import { Button as Button$1, DatePicker as DatePicker$1, TimePicker as TimePicker$1, Drawer as Drawer$1, Input as Input$1, Modal, Select as Select$2, Rate, Col, Row, Checkbox, Switch as Switch$1, Spin, notification, Form, Card, Avatar, Upload as Upload$1, Skeleton, Menu, Dropdown, Table, Image as Image$1, Radio } from 'antd';
export { Affix, Alert, Anchor, AutoComplete, Avatar, Badge, Breadcrumb, Calendar, Card, Carousel, Cascader, Checkbox, Col, Collapse, ConfigProvider, DatePicker, Descriptions, Divider, Dropdown, Empty, Form, Image, InputNumber, Layout, List, Mentions, Menu, Modal, Pagination, Popconfirm, Popover, Progress, Radio, Rate, Result, Row, Skeleton, Slider, Space, Spin, Statistic, Steps, Table, Tabs, Tag, TimePicker, Timeline, Tooltip, Transfer, Tree, TreeSelect, Typography, message, notification } from 'antd';
import * as React from 'react';
import React__default, { useState, useEffect, useMemo, useRef, useCallback, useContext, createContext, memo } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import require$$0$1 from 'vm';
import require$$1$1 from 'http';
import require$$2 from 'https';
import require$$0$4 from 'url';
import require$$3 from 'stream';
import require$$4 from 'assert';
import require$$0$3 from 'tty';
import require$$1 from 'util';
import require$$0$2 from 'os';
import require$$8 from 'zlib';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

// Not able to import elements repo to customer-pages, so using the below hack
// https://github.com/styled-components/styled-components/issues/3437
var defaultStyled = typeof styled === 'function' ? styled : styled["default"];

var Button = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'primary' : _b, _c = _a.htmlType, htmlType = _c === void 0 ? 'button' : _c, children = _a.children, className = _a.className, disabled = _a.disabled, _d = _a.style, style = _d === void 0 ? {} : _d, _e = _a.$color, $color = _e === void 0 ? '#d84339' : _e, $disabledHover = _a.$disabledHover, props = __rest(_a, ["type", "htmlType", "children", "className", "disabled", "style", "$color", "$disabledHover"]);
    return (React__default.createElement(CustomAntButton, __assign({ size: "large", type: type, htmlType: htmlType, disabled: disabled, className: className, style: __assign({ minWidth: 150 }, style), "$color": $color, "$disabledHover": $disabledHover }, props), children));
};
var CustomAntButton = defaultStyled(Button$1)(templateObject_1$12 || (templateObject_1$12 = __makeTemplateObject(["\n  &.ant-btn {\n    border-radius: 10px;\n  }\n\n  &.ant-btn-lg {\n    height: 3.125rem;\n  }\n\n  &.ant-btn-primary:not([disabled]) {\n    color: #fff;\n    background: ", ";\n    border-color: ", ";\n    text-shadow: 0 -1px 0 rgb(0 0 0 / 12%);\n    box-shadow: 0 2px 0 rgb(0 0 0 / 5%);\n  }\n\n  &.ant-btn-primary span {\n    color: #fff;\n    font-weight: 600;\n  }\n\n  ", "\n\n  &.ant-btn-default,\n  &.ant-btn-ghost {\n    border-color: ", ";\n    color: ", ";\n  }\n\n  &[disabled] {\n    border-color: #d9d9d9 !important;\n    background: #f5f5f5 !important;\n    &:hover {\n      span {\n        color: var(--white) !important;\n      }\n    }\n  }\n"], ["\n  &.ant-btn {\n    border-radius: 10px;\n  }\n\n  &.ant-btn-lg {\n    height: 3.125rem;\n  }\n\n  &.ant-btn-primary:not([disabled]) {\n    color: #fff;\n    background: ", ";\n    border-color: ", ";\n    text-shadow: 0 -1px 0 rgb(0 0 0 / 12%);\n    box-shadow: 0 2px 0 rgb(0 0 0 / 5%);\n  }\n\n  &.ant-btn-primary span {\n    color: #fff;\n    font-weight: 600;\n  }\n\n  ", "\n\n  &.ant-btn-default,\n  &.ant-btn-ghost {\n    border-color: ", ";\n    color: ", ";\n  }\n\n  &[disabled] {\n    border-color: #d9d9d9 !important;\n    background: #f5f5f5 !important;\n    &:hover {\n      span {\n        color: var(--white) !important;\n      }\n    }\n  }\n"])), function (_a) {
    var $color = _a.$color;
    return $color;
}, function (_a) {
    var $color = _a.$color;
    return $color;
}, function (_a) {
    var $disabledHover = _a.$disabledHover, $color = _a.$color;
    if (!$disabledHover) {
        return "&.ant-btn-primary:hover {\n                background: #fff;\n                span {\n                  color: ".concat($color, ";\n                }\n              }\n              &.ant-btn-default:hover,\n              &.ant-btn-ghost:hover {\n                color: #fff;\n                background: ").concat($color, ";\n              }");
    }
}, function (_a) {
    var $color = _a.$color;
    return $color;
}, function (_a) {
    var $color = _a.$color;
    return $color;
});
var templateObject_1$12;

function _extends$3() {
  return _extends$3 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3.apply(null, arguments);
}

var locale$3 = {
  locale: 'en_US',
  today: 'Today',
  now: 'Now',
  backToToday: 'Back to today',
  ok: 'OK',
  clear: 'Clear',
  month: 'Month',
  year: 'Year',
  timeSelect: 'select time',
  dateSelect: 'select date',
  weekSelect: 'Choose a week',
  monthSelect: 'Choose a month',
  yearSelect: 'Choose a year',
  decadeSelect: 'Choose a decade',
  yearFormat: 'YYYY',
  dateFormat: 'M/D/YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'M/D/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'Previous month (PageUp)',
  nextMonth: 'Next month (PageDown)',
  previousYear: 'Last year (Control + left)',
  nextYear: 'Next year (Control + right)',
  previousDecade: 'Last decade',
  nextDecade: 'Next decade',
  previousCentury: 'Last century',
  nextCentury: 'Next century'
};

var locale$2 = {
  placeholder: 'Select time',
  rangePlaceholder: ['Start time', 'End time']
};
var TimePickerLocale = locale$2;

var locale = {
  lang: _extends$3({
    placeholder: 'Select date',
    yearPlaceholder: 'Select year',
    quarterPlaceholder: 'Select quarter',
    monthPlaceholder: 'Select month',
    weekPlaceholder: 'Select week',
    rangePlaceholder: ['Start date', 'End date'],
    rangeYearPlaceholder: ['Start year', 'End year'],
    rangeQuarterPlaceholder: ['Start quarter', 'End quarter'],
    rangeMonthPlaceholder: ['Start month', 'End month'],
    rangeWeekPlaceholder: ['Start week', 'End week']
  }, locale$3),
  timePickerLocale: _extends$3({}, TimePickerLocale)
}; // All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json

var locale$1 = locale;

var SvgAlertCircle = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.001 18.333a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667ZM10 6.666v3.333M10 13.334h.008", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgAnalize = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M9.257 7.818h-.666c-.092 0-.167.136-.167.303v3.637c0 .167.075.303.167.303h.666c.092 0 .167-.136.167-.303V8.12c0-.167-.075-.303-.167-.303ZM6.833 9.637h-.666c-.092 0-.167.135-.167.303v1.818c0 .167.075.303.167.303h.666c.092 0 .167-.136.167-.303V9.94c0-.168-.075-.303-.167-.303ZM11.681 6h-.667c-.092 0-.166.136-.166.303v5.455c0 .167.074.303.166.303h.667c.092 0 .167-.136.167-.303V6.303c0-.167-.075-.303-.167-.303Z", fill: "#30384C" }),
    React.createElement("path", { d: "M9.333 16.167a7.333 7.333 0 1 0 0-14.667 7.333 7.333 0 0 0 0 14.667ZM18.5 18l-3.988-3.988", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgArchive2 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.5 6.668v10.833h-15V6.668M19.167 2.5H.834v4.167h18.333V2.5ZM8.334 10h3.333", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgArchive = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.5 6.666v10.833h-15V6.666", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M19.165 2.5H.832v4.167h18.333V2.5ZM10 9.166v5M12.5 11.666l-2.5 2.5-2.5-2.5", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgArrowDown = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10 4.166v11.667M15.835 10 10 15.833 4.168 10", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgArrowLeft = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15.835 10H4.168M10.001 15.833 4.168 9.999l5.833-5.833", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgArrowRight = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4.166 10h11.667M10 4.168l5.833 5.833L10 15.835", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgArrowUpRight = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15.194 14.789V5.596H6M5.999 14.788l9.192-9.192", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgArrowUp = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17 9.5 10.5 3 4 9.5M10.5 16V3", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgAssign = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13.332 17.5v-1.667A3.333 3.333 0 0 0 9.999 12.5H4.165a3.333 3.333 0 0 0-3.333 3.333V17.5M7.083 9.167a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667ZM16.668 6.666v5M19.168 9.166h-5", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgAttach = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m18 9.5-7.564 7.135A5.097 5.097 0 0 1 6.94 18a5.097 5.097 0 0 1-3.494-1.365C2.521 15.761 2 14.575 2 13.34c0-1.236.52-2.422 1.447-3.296l7.565-7.134a3.398 3.398 0 0 1 2.33-.91c.873 0 1.71.327 2.329.91a3.02 3.02 0 0 1 .965 2.197 3.02 3.02 0 0 1-.965 2.197l-7.573 7.134a1.7 1.7 0 0 1-1.165.455 1.7 1.7 0 0 1-1.164-.455 1.51 1.51 0 0 1-.483-1.098c0-.412.174-.807.483-1.099l6.988-6.583", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgBellCheck = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10 1.667a5 5 0 0 0-5 5c0 5.833-2.5 7.5-2.5 7.5h15s-.804-.536-1.5-2.064", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M11 5.5 13.333 8 18 3M11.442 17.5a1.666 1.666 0 0 1-2.883 0", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgBell = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15 6.666a5 5 0 0 0-10 0c0 5.833-2.5 7.5-2.5 7.5h15s-2.5-1.667-2.5-7.5ZM11.442 17.5a1.666 1.666 0 0 1-2.883 0", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgBookOpen = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.666 2.5h5a3.333 3.333 0 0 1 3.333 3.333V17.5A2.5 2.5 0 0 0 7.5 15H1.666V2.5ZM18.333 2.5h-5A3.333 3.333 0 0 0 10 5.833V17.5a2.5 2.5 0 0 1 2.5-2.5h5.833V2.5Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgBriefcase = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.668 5.834H3.335c-.92 0-1.667.746-1.667 1.667v8.333c0 .92.746 1.667 1.667 1.667h13.333c.92 0 1.667-.747 1.667-1.667V7.501c0-.92-.747-1.667-1.667-1.667Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M13.335 17.5V4.167A1.667 1.667 0 0 0 11.668 2.5H8.335a1.667 1.667 0 0 0-1.667 1.667V17.5", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgCalendarArrow = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4.166 10.328h11.667M10 4.496l5.833 5.833", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgCalendar = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15.833 3.334H4.167c-.92 0-1.667.746-1.667 1.667v11.666c0 .92.746 1.667 1.667 1.667h11.666c.92 0 1.667-.746 1.667-1.667V5.001c0-.92-.746-1.667-1.667-1.667ZM13.332 1.666v3.333M6.668 1.666v3.333M2.5 8.334h15", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgCamera = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M19.167 15.833A1.667 1.667 0 0 1 17.5 17.5h-15a1.667 1.667 0 0 1-1.667-1.667V6.667A1.667 1.667 0 0 1 2.5 5h3.333L7.5 2.5h5L14.167 5H17.5a1.667 1.667 0 0 1 1.667 1.667v9.166Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M10 14.167A3.333 3.333 0 1 0 10 7.5a3.333 3.333 0 0 0 0 6.667Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgCancel = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10 18.335a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667ZM4.652 4.652l10.695 10.695", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgChangeOrder = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6.604 2v9.206M11.206 6.604l-4.603 4.603L2 6.604M14.23 18.834V9.628M9.626 14.23l4.603-4.603 4.603 4.603", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgCheckCircle = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M18.333 9.232v.766a8.333 8.333 0 1 1-4.942-7.616", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M18.333 3.332 10 11.674l-2.5-2.5", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgChevronDown$1 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m5 7.5 5 5 5-5", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgChevronLeft = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m12.5 15-5-5 5-5", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgChevronRight = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m7.5 15 5-5-5-5", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgChevronUp = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m15 12.5-5-5-5 5", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgClick = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#click_svg__a)", stroke: "#30384C" },
        React.createElement("path", { d: "m18.5 18.5-4-4m0 0 3-3L9 9l2.5 8.5 3-3Z", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M6.53 11.03c-1.398-1.398-1.523-3.537-.28-4.78 1.243-1.243 3.382-1.118 4.78.28", strokeLinecap: "round" }),
        React.createElement("path", { d: "M8.616 14.703a6.457 6.457 0 1 1 5.955-5.955" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "click_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))); };

var SvgClock$1 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.001 18.333a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M10 5v5l3.333-2.333", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgClose = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15 5 5 15M5 5l10 10", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgCodepen = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m10 1.668 8.333 5.417v5.833l-8.334 5.417-8.333-5.417V7.085l8.333-5.417ZM10 18.335v-5.417", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m18.333 7.082-8.334 5.833-8.333-5.833", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m1.666 12.915 8.333-5.833 8.334 5.833M10 1.668v5.417", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgCollapse = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M9.167 14.165 5 10l4.167-4.167M14.999 14.165 10.832 10l4.167-4.167", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgColumns = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10 2.5h5.833A1.666 1.666 0 0 1 17.5 4.167v11.666a1.666 1.666 0 0 1-1.667 1.667H10m0-15H4.167A1.667 1.667 0 0 0 2.5 4.167v11.666A1.666 1.666 0 0 0 4.167 17.5H10m0-15v15", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgCommentQuote = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#comment-quote_svg__a)" },
        React.createElement("path", { d: "M9 .5h2A8.5 8.5 0 0 1 19.5 9v9a1.5 1.5 0 0 1-1.5 1.5H9A8.5 8.5 0 0 1 .5 11V9A8.5 8.5 0 0 1 9 .5Z", stroke: "#30384C" }),
        React.createElement("path", { d: "M10.872 13.733c1.688-.027 2.61-1.253 2.61-3.256V7.629h-2.61v2.544h1.226v.449c0 1.08-.422 1.753-1.226 1.753v1.358Zm-4.403 0c1.7-.027 2.623-1.253 2.623-3.256V7.629H6.47v2.544h1.239v.449c0 1.08-.435 1.753-1.24 1.753v1.358Z", fill: "#30384C" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "comment-quote_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))); };

var SvgComment$2 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#comment_svg__a)", stroke: "#30384C", strokeLinejoin: "round" },
        React.createElement("path", { d: "M18.182 1H1.818a.824.824 0 0 0-.578.236.802.802 0 0 0-.24.571v12.108c0 .214.086.42.24.57a.824.824 0 0 0 .578.237h1.637v3.47a.8.8 0 0 0 .146.462.817.817 0 0 0 .878.32.82.82 0 0 0 .416-.257L8.364 14.5h9.818c.217 0 .425.137.578-.014a.802.802 0 0 0 .24-.571V1.807a.802.802 0 0 0-.24-.57.824.824 0 0 0-.578-.237Z" }),
        React.createElement("path", { d: "M4.5 6h11M4.5 10H11", strokeMiterlimit: 10, strokeLinecap: "round" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "comment_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))); };

var SvgCopy = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.667 7.5h-7.5c-.92 0-1.667.746-1.667 1.667v7.5c0 .92.746 1.666 1.667 1.666h7.5c.92 0 1.666-.746 1.666-1.666v-7.5c0-.92-.746-1.667-1.666-1.667Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M4.168 12.5h-.833a1.666 1.666 0 0 1-1.667-1.667v-7.5a1.667 1.667 0 0 1 1.667-1.667h7.5A1.666 1.666 0 0 1 12.5 3.333v.833", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgCornerUpLeft = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M7.5 11.665 3.333 7.5 7.5 3.332", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M16.667 16.667v-5.834A3.333 3.333 0 0 0 13.333 7.5h-10", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgCornerUpRight = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m12.5 11.667 4.167-4.166L12.5 3.334", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M3.332 16.667v-5.834A3.333 3.333 0 0 1 6.665 7.5h10", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgCrown$1 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m17.759 1.721-.014.058v.06l-.04 15.73a.125.125 0 0 1-.115.068h-.006l-15.17-.143h-.016a.125.125 0 0 1-.114-.067L2.282 2.073V2.02l-.012-.052a.125.125 0 0 1 .045-.125.125.125 0 0 1 .085-.027l3.613 3.537.383.375.348-.409 3.074-3.619.031-.036.023-.041a.125.125 0 0 1 .218 0l.021.037.027.034 2.976 3.625.35.427.39-.392 3.77-3.786a.125.125 0 0 1 .135.154Z", stroke: "#30384C" }),
    React.createElement("path", { d: "M10 8v5l3.333-2.333", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgDate = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15.833 3.334H4.167c-.92 0-1.667.746-1.667 1.667v11.666c0 .92.746 1.667 1.667 1.667h11.666c.92 0 1.667-.746 1.667-1.667V5.001c0-.92-.746-1.667-1.667-1.667ZM13.334 1.666v3.333M6.666 1.666v3.333M2.5 8.334h15", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgDelete = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2.5 5h15M6.668 5V3.332a1.667 1.667 0 0 1 1.667-1.667h3.333a1.667 1.667 0 0 1 1.667 1.667v1.666m2.5 0v11.667a1.667 1.667 0 0 1-1.667 1.667H5.835a1.667 1.667 0 0 1-1.667-1.667V4.999h11.667ZM8.332 9.166v5M11.668 9.166v5", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgDesktop = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.668 2.5H3.335c-.92 0-1.667.746-1.667 1.667V12.5c0 .92.746 1.667 1.667 1.667h13.333c.92 0 1.667-.746 1.667-1.667V4.167c0-.92-.747-1.667-1.667-1.667ZM6.668 17.5h6.667M10 14.166v3.333", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgDiceFour = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#dice-four_svg__a)", stroke: "#30384C" },
        React.createElement("path", { d: "M14.875 1h-9.75A4.13 4.13 0 0 0 1 5.125v9.75A4.13 4.13 0 0 0 5.125 19h9.75A4.13 4.13 0 0 0 19 14.875v-9.75A4.13 4.13 0 0 0 14.875 1Z" }),
        React.createElement("path", { d: "M13 7h.01M13 13h.01M7 7h.01M7 13h.01", strokeLinecap: "round", strokeLinejoin: "round" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "dice-four_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))); };

var SvgDislike = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m14.167 10.835-3.334 7.5a2.5 2.5 0 0 1-2.5-2.5v-3.333H3.617a1.668 1.668 0 0 1-1.667-1.917l1.15-7.5a1.667 1.667 0 0 1 1.667-1.417h9.4m0 9.167V1.668m0 9.167h2.225a1.924 1.924 0 0 0 1.941-1.667V3.335a1.925 1.925 0 0 0-1.941-1.667h-2.225", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgDollarSign = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10 .834v18.333M14.167 4.166h-6.25a2.917 2.917 0 1 0 0 5.833h4.166a2.917 2.917 0 1 1 0 5.834H5", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgDoneAll = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m18.333 8-9.166 9.167L5 13", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m14.333 8-9.166 9.167L1 13", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgDone$1 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.665 5 7.5 14.167 3.332 10", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgDownload = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.5 12.5v3.333a1.666 1.666 0 0 1-1.667 1.667H4.167A1.667 1.667 0 0 1 2.5 15.833V12.5", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m5.832 8.334 4.167 4.167 4.166-4.167M10 12.5v-10", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgDuplicate = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.667 7.5h-7.5c-.92 0-1.667.746-1.667 1.667v7.5c0 .92.746 1.666 1.667 1.666h7.5c.92 0 1.666-.746 1.666-1.666v-7.5c0-.92-.746-1.667-1.666-1.667ZM13 11v4M11 13h4", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M4.168 12.5h-.833a1.667 1.667 0 0 1-1.667-1.667v-7.5a1.667 1.667 0 0 1 1.667-1.667h7.5A1.666 1.666 0 0 1 12.5 3.333v.833", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round", strokeDasharray: "3 3" }))); };

var SvgEdit = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M14.347 2.627a2.14 2.14 0 0 1 3.026 3.026L7.161 15.865 3 17l1.135-4.16L14.347 2.626Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgExternalFeedbackLink = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M8.57 2.855H2.597c-.643 0-1.168.547-1.168 1.215v10.428c0 .668.525 1.215 1.168 1.215h10.323l3.038 2.613c.339.467 1.051.218 1.051-.365v-2.248h.394c.643 0 1.169-.547 1.169-1.215v-3.071", stroke: "#30384C", strokeMiterlimit: 10 }),
    React.createElement("path", { d: "M12.736 1.43h5v5M8.572 10.596 17.74 1.43", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgExternalLink = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15 10.833v5a1.666 1.666 0 0 1-1.667 1.667H4.167A1.667 1.667 0 0 1 2.5 15.833V6.667A1.667 1.667 0 0 1 4.167 5h5M12.5 2.5h5v5M8.332 11.667 17.499 2.5", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgEyeOff = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#eye-off_svg__a)", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" },
        React.createElement("path", { d: "M14.949 14.95a8.391 8.391 0 0 1-4.95 1.717c-5.834 0-9.167-6.666-9.167-6.666a15.375 15.375 0 0 1 4.217-4.95m3.2-1.517a7.6 7.6 0 0 1 1.75-.2c5.833 0 9.166 6.667 9.166 6.667a15.423 15.423 0 0 1-1.8 2.658m-5.6-.892a2.498 2.498 0 0 1-4.328-1.748 2.5 2.5 0 0 1 .795-1.785M.832.834l18.333 18.333" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "eye-off_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))); };

var SvgEye = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M.832 10s3.333-6.667 9.167-6.667c5.833 0 9.166 6.667 9.166 6.667S15.832 16.666 10 16.666C4.165 16.666.832 10 .832 10Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgFieldLine = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m6.61 10.354 4.244-4.243M7.32 16.718l9.899-9.9", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgFileDownload = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.832 1.668H4.999a1.667 1.667 0 0 0-1.667 1.667v13.333a1.667 1.667 0 0 0 1.667 1.667h10a1.667 1.667 0 0 0 1.666-1.667V7.501l-5.833-5.833Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M10.832 1.668v5.833h5.833M10 10.5v4M12 12.5l-2 2-2-2", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgFileDraft = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.832 1.668H4.999a1.667 1.667 0 0 0-1.667 1.667v13.333a1.667 1.667 0 0 0 1.667 1.667h10a1.667 1.667 0 0 0 1.666-1.667V7.501l-5.833-5.833Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M10.832 1.668v5.833h5.833", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgFilter$1 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M18.335 2.5H1.668l6.667 7.883v5.45l3.333 1.667v-7.117L18.335 2.5Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgFinish = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6.102 21.824c3.892-2.375 9.646-4.876 13.426-4.98M18.604 2.248l1.754 4.167", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m16.199 9.079 4.267 9.928c3.663 3.663 10.216-8.33 18.665-2.181 0 0-4.047-5.673-8.67-6.53 0-1.655 5.556-3.274 5.556-3.274C27.568.873 19.862 12.742 16.2 9.08c-.78-.78.28-2.516 1.455-4.127 1.019-1.397 1.48-2.79.312-3.538-2.928-1.874-11.112 1.45-16.08 4.48M.87 2.053 10.064 36.8", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgFire = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#fire_svg__a)", fill: "#30384C" },
        React.createElement("path", { d: "M5.4 19.126a.5.5 0 1 0 .643-.766l-.642.766Zm.693-10.9.434.248a.5.5 0 0 0-.644-.702l.21.454Zm.437 2.596.332-.374v-.001l-.332.375Zm3.338-.925.499.035-.499-.035ZM12.53.422l.312.39a.5.5 0 0 0-.482-.86l.17.47Zm2.067 6.654-.338.368.338-.368ZM6.043 18.36c-1.738-1.458-2.625-2.876-2.625-4.305h-1c0 1.872 1.163 3.545 2.983 5.07l.642-.765Zm-2.625-4.305c0-1.126.322-2.295.855-3.277.536-.988 1.26-1.742 2.03-2.098l-.42-.908C4.86 8.246 3.997 9.19 3.394 10.3c-.606 1.117-.976 2.448-.976 3.755h1Zm2.24-6.076c-.352.618-.447 1.237-.322 1.81.123.566.45 1.043.864 1.408l.661-.75c-.29-.256-.48-.555-.548-.87-.067-.307-.03-.676.214-1.103l-.868-.495Zm.54 3.217c.266.235.647.387 1.026.471.389.087.832.114 1.26.057.426-.057.87-.203 1.226-.494.37-.301.617-.736.657-1.298l-.998-.07c-.02.284-.133.465-.29.593-.17.14-.421.237-.727.277-.303.041-.628.022-.912-.041-.294-.066-.49-.166-.578-.243l-.663.748Zm4.169-1.264c.033-.466-.049-.834-.212-1.163-.152-.304-.373-.564-.555-.791-.364-.454-.784-1.012-1.016-2.225l-.982.188c.272 1.428.794 2.133 1.218 2.662.212.265.348.427.44.612.08.161.13.35.11.646l.997.071ZM8.584 5.753c-.213-1.118.21-2.103 1.008-2.94.807-.847 1.968-1.507 3.109-1.921l-.34-.94c-1.239.449-2.549 1.18-3.493 2.17-.95.998-1.557 2.295-1.266 3.819l.982-.188ZM12.22.031c-.527.42-.912.906-1.107 1.474-.196.571-.182 1.178.011 1.806.377 1.227 1.454 2.59 3.136 4.133l.676-.736c-1.66-1.523-2.562-2.733-2.856-3.69-.142-.463-.137-.85-.02-1.19.117-.342.364-.68.783-1.015L12.22.03Zm2.04 7.414c2.22 2.035 3.576 4.047 3.576 6.31h1c0-2.695-1.62-4.958-3.9-7.048l-.676.738Zm3.576 6.31c0 .788-.37 1.99-1.016 3.09-.65 1.108-1.506 1.986-2.387 2.267l.305.953c1.228-.393 2.247-1.526 2.944-2.713.702-1.194 1.154-2.572 1.154-3.597h-1ZM13.583 12.084l.488.111a.5.5 0 0 0-.736-.545l.248.434Zm-6.35 3.1.477-.152a.5.5 0 0 0-.938-.04l.461.192Zm.566 4.348a.5.5 0 0 0 .685-.729l-.685.729Zm5.72-.052c.634-.789.965-1.512 1.089-2.207.124-.693.035-1.316-.102-1.886-.284-1.185-.7-2.03-.435-3.192l-.975-.222c-.335 1.463.207 2.684.438 3.647.121.505.18.976.09 1.477-.09.5-.334 1.071-.885 1.757l.78.627Zm-.184-7.83c-.771.441-1.29.954-1.657 1.516-.361.557-.558 1.141-.71 1.698l.964.265c.143-.522.307-.99.585-1.418.274-.421.673-.826 1.315-1.193l-.497-.868Zm-2.367 3.214c-.122.446-.39.877-.737 1.195-.348.32-.741.496-1.108.5l.012 1c.675-.008 1.294-.324 1.772-.763.48-.44.851-1.033 1.025-1.667l-.964-.265ZM9.123 16.56a1.024 1.024 0 0 1-.832-.365c-.23-.258-.418-.65-.581-1.162l-.953.304c.178.558.418 1.11.789 1.525.39.436.913.706 1.59.698l-.013-1Zm-2.351-1.568c-.48 1.147-.483 2.075-.201 2.847.274.75.797 1.288 1.228 1.694l.685-.729c-.414-.39-.785-.792-.974-1.308-.18-.495-.215-1.16.185-2.118l-.923-.386Z" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "fire_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))); };

var SvgFolder = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M18.333 15.833a1.666 1.666 0 0 1-1.667 1.667H3.333a1.667 1.667 0 0 1-1.667-1.667V4.167A1.667 1.667 0 0 1 3.333 2.5h4.166L9.166 5h7.5a1.667 1.667 0 0 1 1.667 1.667v9.166Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgFoodMenu = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("mask", { id: "food-menu_svg__a", fill: "#fff" },
        React.createElement("path", { d: "M14.273 7H9v1h5.273c.4 0 .727-.045.727-.1v-.8c0-.055-.326-.1-.727-.1Z" })),
    React.createElement("path", { d: "M9 7V5H7v2h2Zm0 1H7v2h2V8Zm5.273-3H9v4h5.273V5ZM7 7v1h4V7H7Zm2 3h5.273V6H9v4Zm5.273 0c.262 0 .54-.014.786-.048.109-.015.298-.045.501-.11.088-.03.304-.104.539-.26.144-.097.901-.626.901-1.682h-4a1.983 1.983 0 0 1 .871-1.641 1.834 1.834 0 0 1 .606-.263.77.77 0 0 1 .028-.005l.01-.002a.535.535 0 0 1-.076.007 2.908 2.908 0 0 1-.166.004v4ZM17 7.9v-.8h-4v.8h4Zm0-.8c0-1.056-.757-1.585-.901-1.681a2.169 2.169 0 0 0-.539-.26 2.923 2.923 0 0 0-.5-.111A5.946 5.946 0 0 0 14.272 5v4a2.908 2.908 0 0 1 .241.01h-.009a1.383 1.383 0 0 1-.18-.046 1.834 1.834 0 0 1-.454-.223A1.983 1.983 0 0 1 13 7.1h4Z", fill: "#30384C", mask: "url(#food-menu_svg__a)" }),
    React.createElement("mask", { id: "food-menu_svg__b", fill: "#fff" },
        React.createElement("path", { d: "M14.273 11H9v1h5.273c.4 0 .727-.045.727-.1v-.8c0-.055-.326-.1-.727-.1Z" })),
    React.createElement("path", { d: "M9 11V9H7v2h2Zm0 1H7v2h2v-2Zm5.273-3H9v4h5.273V9ZM7 11v1h4v-1H7Zm2 3h5.273v-4H9v4Zm5.273 0c.262 0 .54-.014.786-.048.109-.015.298-.045.501-.11.088-.03.304-.104.539-.26.144-.097.901-.626.901-1.682h-4a1.983 1.983 0 0 1 .871-1.641 1.836 1.836 0 0 1 .606-.263.77.77 0 0 1 .028-.005l.01-.002a.535.535 0 0 1-.076.007 2.908 2.908 0 0 1-.166.004v4ZM17 11.9v-.8h-4v.8h4Zm0-.8c0-1.056-.757-1.585-.901-1.681a2.169 2.169 0 0 0-.539-.26 2.923 2.923 0 0 0-.5-.111A5.946 5.946 0 0 0 14.272 9v4a2.889 2.889 0 0 1 .241.01h-.009a1.388 1.388 0 0 1-.18-.046 1.836 1.836 0 0 1-.454-.223A1.983 1.983 0 0 1 13 11.1h4Z", fill: "#30384C", mask: "url(#food-menu_svg__b)" }),
    React.createElement("path", { stroke: "#30384C", d: "M2.5 2v16M5.5 2.5H17A1.5 1.5 0 0 1 18.5 4v12a1.5 1.5 0 0 1-1.5 1.5H5.5v-15Z" }))); };

var SvgGlobal = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM2 10h16", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M10 2a12.24 12.24 0 0 1 3.2 8 12.24 12.24 0 0 1-3.2 8 12.24 12.24 0 0 1-3.2-8A12.24 12.24 0 0 1 10 2v0Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgHelp$1 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.001 18.333a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M7.574 7.5a2.5 2.5 0 0 1 4.859.834c0 1.667-2.5 2.5-2.5 2.5M10 14.166h.008", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgHome$1 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2.5 7.5 10 1.665l7.5 5.833v9.167a1.666 1.666 0 0 1-1.667 1.667H4.167A1.667 1.667 0 0 1 2.5 16.666V7.499Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M7.5 18.333V10h5v8.333", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgHourglass$1 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#hourglass_svg__a)" },
        React.createElement("path", { d: "M8.687 10.355a.5.5 0 0 0 0-.707L5.845 6.806a1.172 1.172 0 0 1-.345-.83V3.335c0-.64.526-1.167 1.167-1.167h6.666c.64 0 1.167.526 1.167 1.167v2.65a1.172 1.172 0 0 1-.345.83l-2.841 2.832a.5.5 0 0 0-.001.707l2.85 2.859c.213.214.337.51.337.822v2.633c0 .64-.526 1.167-1.167 1.167H6.667c-.64 0-1.167-.527-1.167-1.167v-2.633c0-.309.122-.608.34-.833l2.847-2.847Z", stroke: "#30384C", strokeLinejoin: "round" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "hourglass_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))); };

var SvgIcons = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.537 3.442a1.585 1.585 0 0 0-.512-.327 1.643 1.643 0 0 0-1.209 0 1.586 1.586 0 0 0-.512.327l-.304.29-.304-.29A1.617 1.617 0 0 0 12.579 3c-.419 0-.82.16-1.117.442A1.476 1.476 0 0 0 11 4.509c0 .4.166.784.463 1.067l.304.29L14 8l2.233-2.134.304-.29c.147-.14.263-.307.343-.49a1.452 1.452 0 0 0-.343-1.644v0Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("circle", { cx: 5.5, cy: 13.5, r: 3, stroke: "#30384C" }),
    React.createElement("path", { stroke: "#30384C", d: "M11.5 11.5h5v5h-5zM2.469 8.25 5.5 3l3.031 5.25H2.47Z" }))); };

var SvgInfo = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.001 18.334a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667ZM10 6.667V10M10 13.333h.008", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgInteractiveMouseClick = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#interactive-mouse-click_svg__a)", stroke: "#30384C" },
        React.createElement("path", { d: "m18.5 18.5-4-4m0 0 3-3L9 9l2.5 8.5 3-3Z", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M6.53 11.03c-1.398-1.398-1.523-3.537-.28-4.78 1.243-1.243 3.382-1.118 4.78.28" }),
        React.createElement("path", { d: "M8.616 14.703a6.457 6.457 0 1 1 5.955-5.955" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "interactive-mouse-click_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))); };

var SvgInternalChat = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.5 9.583a6.983 6.983 0 0 1-.75 3.167 7.084 7.084 0 0 1-6.333 3.917 6.983 6.983 0 0 1-3.167-.75L2.5 17.5l1.583-4.75a6.983 6.983 0 0 1-.75-3.167A7.083 7.083 0 0 1 7.25 3.25a6.983 6.983 0 0 1 3.167-.75h.416A7.067 7.067 0 0 1 17.5 9.167v.416Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgKey = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m17.5 1.668-1.667 1.667m0 0 2.5 2.5-2.917 2.916-2.5-2.5m2.917-2.916L12.916 6.25M9.49 9.676a4.583 4.583 0 1 1-6.482 6.482 4.584 4.584 0 0 1 6.481-6.48v-.002Zm0 0 3.425-3.425", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgLayers = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.001 1.666 1.668 5.833l8.333 4.166 8.334-4.166L10 1.666ZM1.668 14.166l8.333 4.167 8.334-4.167", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m1.668 10 8.333 4.167L18.335 10", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgLayout = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15.833 2.5H4.167c-.92 0-1.667.746-1.667 1.667v11.666c0 .92.746 1.667 1.667 1.667h11.666c.92 0 1.667-.746 1.667-1.667V4.167c0-.92-.746-1.667-1.667-1.667ZM2.5 7.5h15M7.5 17.5v-10", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgLike = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M5.835 18.335h-2.5a1.667 1.667 0 0 1-1.667-1.667v-5.833a1.667 1.667 0 0 1 1.667-1.667h2.5m5.833-1.667V4.168a2.5 2.5 0 0 0-2.5-2.5l-3.333 7.5v9.167h9.4a1.667 1.667 0 0 0 1.666-1.417l1.15-7.5a1.665 1.665 0 0 0-1.666-1.917h-4.717Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgLink = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m9.312 6.607 1.353-1.352a3.19 3.19 0 0 1 4.51 4.509l-1.354 1.352m-2.705 2.706-1.353 1.352a3.189 3.189 0 0 1-4.509-4.508l1.353-1.353M8.41 12.018l3.607-3.608", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgList = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6.667 5H17.5M6.667 10H17.5M6.667 15H17.5M2.5 5h.008M2.5 10h.008M2.5 15h.008", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgMagnet = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11.667 8V4.167c0-.92.747-1.667 1.666-1.667h2.5c.92 0 1.667.748 1.667 1.667V8m-5.833 0v2.833c0 .92-.748 1.667-1.667 1.667-.92 0-1.667-.748-1.667-1.667V8m3.334 0H17.5m0 0v2.833c0 4.136-3.364 7.5-7.5 7.5s-7.5-3.364-7.5-7.5V8m5.833 0V4.167c0-.92-.747-1.667-1.666-1.667h-2.5c-.92 0-1.667.748-1.667 1.667V8m5.833 0H2.5", stroke: "#30384C" }))); };

var SvgMail = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3.333 3.332h13.333c.917 0 1.667.75 1.667 1.667v10c0 .916-.75 1.666-1.667 1.666H3.333c-.917 0-1.667-.75-1.667-1.666v-10c0-.917.75-1.667 1.667-1.667Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m18.333 5-8.334 5.833L1.666 5", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgMapPin$1 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.253 8.539c0 5.64-7.251 10.475-7.251 10.475S2.75 14.179 2.75 8.539a7.252 7.252 0 0 1 14.503 0Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M10 10.957a2.417 2.417 0 1 0 0-4.834 2.417 2.417 0 0 0 0 4.834Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgMenu = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2.5 10h15M2.5 5h15M2.5 15h15", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgMessageSquare = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.5 12.5a1.666 1.666 0 0 1-1.667 1.667h-10L2.5 17.5V4.167A1.667 1.667 0 0 1 4.167 2.5h11.666A1.666 1.666 0 0 1 17.5 4.167V12.5Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgMinus = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4.168 10h11.667", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgMore = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10 10.833a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667ZM10 5a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.667ZM10.001 16.667a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgMove = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6.833 10.833a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667ZM6.833 5a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.667ZM6.833 16.667a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667ZM12.833 10.833a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667ZM12.833 5a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.667ZM12.833 16.667a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgNavigation = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m2.5 9.166 15.833-7.5-7.5 15.833-1.666-6.666L2.5 9.166Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgOrder = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17 4H3L1 15.5h14L17 4Zm0 0 2 11.5h-1.5M5 10h8", stroke: "#30384C" }))); };

var SvgPaperclip = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m17.867 9.208-7.659 7.658a5.003 5.003 0 1 1-7.075-7.075l7.659-7.658a3.335 3.335 0 0 1 4.716 4.717l-7.666 7.658a1.668 1.668 0 0 1-2.359-2.358l7.075-7.067", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgPhone = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M18.331 14.1v2.5a1.667 1.667 0 0 1-1.816 1.666 16.492 16.492 0 0 1-7.192-2.558 16.251 16.251 0 0 1-5-5 16.492 16.492 0 0 1-2.558-7.225 1.667 1.667 0 0 1 1.658-1.817h2.5A1.667 1.667 0 0 1 7.59 3.1c.105.8.3 1.586.583 2.342A1.667 1.667 0 0 1 7.798 7.2L6.74 8.258a13.333 13.333 0 0 0 5 5l1.058-1.059a1.667 1.667 0 0 1 1.758-.375c.756.283 1.542.478 2.342.584a1.667 1.667 0 0 1 1.433 1.691Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgPicInCyrcle = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m2.799 12.7 3.535-3.491c.494-.465 1.054-.709 1.625-.709.57 0 1.13.244 1.625.709L15 14.5M13.252 6.334h.008M12.5 11.876l1.083-1.123c.494-.493 1.055-.753 1.625-.753.57 0 1.131.26 1.625.753l.816 1.123", stroke: "#30384C", strokeWidth: 0.9, strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("circle", { cx: 10, cy: 10, r: 8.55, stroke: "#30384C", strokeWidth: 0.9 }))); };

var SvgPic = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#pic_svg__a)", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" },
        React.createElement("path", { d: "M16.136 2.727H4.318c-1.632 0-2.955 1.308-2.955 2.922v7.792c0 1.614 1.323 2.922 2.955 2.922h11.818c1.632 0 2.955-1.308 2.955-2.922V5.649c0-1.614-1.323-2.922-2.955-2.922Z" }),
        React.createElement("path", { d: "m1.363 12.272 3.802-3.893c.433-.428.925-.652 1.426-.652.5 0 .992.224 1.425.652l3.802 3.893" }),
        React.createElement("path", { d: "m10.908 11.407 2.046-1.734c.466-.38.995-.581 1.534-.581.538 0 1.067.2 1.534.58l3.068 2.602M12.5 6.666h.008" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "pic_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))); };

var SvgPin = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4 12c.48-.53 2-1.23 2-2V2h8v8c0 .77 1.52 1.47 2 2H4ZM10 13v6", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgPlay = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4.168 2.5 15.835 10 4.168 17.5v-15Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgPlus = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10 4.166v11.667M4.168 10h11.667", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgProgrammingLanguage1 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6 14.5 1.5 10 6 6M14.5 6l4.5 4.5-4.5 4M11.562 4.371 8.439 16.63", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgQr = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6.667 2.5h-2.5A1.667 1.667 0 0 0 2.5 4.167v2.5m15 0v-2.5A1.667 1.667 0 0 0 15.833 2.5h-2.5m0 15h2.5a1.666 1.666 0 0 0 1.667-1.667v-2.5m-15 0v2.5A1.666 1.666 0 0 0 4.167 17.5h2.5", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M10.08 10.168c0 .564-.166 1.062-.5 1.493l.42.453-.832.74-.46-.493c-.334.16-.692.24-1.074.24-.684 0-1.264-.233-1.74-.7-.47-.471-.707-1.049-.707-1.733 0-.685.236-1.26.707-1.727a2.379 2.379 0 0 1 1.74-.707c.685 0 1.262.236 1.733.707.476.467.714 1.042.714 1.727Zm-2.446 1.266c.05 0 .113-.004.193-.013l-.626-.673.84-.734.713.76c.094-.186.14-.388.14-.606 0-.37-.12-.671-.36-.907-.24-.24-.54-.36-.9-.36s-.66.12-.9.36c-.24.236-.36.538-.36.907s.12.673.36.913c.24.236.54.353.9.353ZM13.1 12.501l-.813-1.507h-.427v1.507h-1.193V7.834h1.867c.475 0 .873.154 1.193.46.324.303.487.687.487 1.154 0 .28-.072.537-.214.773a1.576 1.576 0 0 1-.58.553l.96 1.727H13.1Zm-1.24-3.567v1.047h.66a.455.455 0 0 0 .36-.14.528.528 0 0 0 .14-.38.528.528 0 0 0-.14-.38.476.476 0 0 0-.36-.147h-.66Z", fill: "#30384C" }))); };

var SvgQr2 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#qr2_svg__a)", stroke: "#30384C" },
        React.createElement("path", { d: "M16 12v2m-4 5h4v-5m0 0h3m-6-2v3", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M2 1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1ZM2 13h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1ZM14 1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1Z" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "qr2_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))); };

var SvgQuestion = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.001 18.334a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M8.87 11.13c0-.41.089-.793.266-1.148.177-.355.392-.658.644-.91s.504-.49.756-.714a4.07 4.07 0 0 0 .644-.756c.177-.28.266-.574.266-.882 0-.467-.163-.821-.49-1.064-.317-.252-.733-.378-1.246-.378-1.027 0-1.685.453-1.974 1.358L6.63 6.02c.233-.653.63-1.148 1.19-1.484.56-.345 1.195-.518 1.904-.518.83 0 1.54.233 2.128.7.597.467.896 1.115.896 1.946 0 .392-.089.76-.266 1.106a3.545 3.545 0 0 1-.644.896c-.252.252-.504.5-.756.742-.252.233-.467.5-.644.798-.177.29-.266.597-.266.924H8.87Zm.644 3.024a.877.877 0 0 1-.644-.266.877.877 0 0 1-.266-.644c0-.252.089-.467.266-.644a.877.877 0 0 1 .644-.266c.261 0 .476.089.644.266a.877.877 0 0 1 .266.644.877.877 0 0 1-.266.644.848.848 0 0 1-.644.266Z", fill: "#30384C" }))); };

var SvgRelatedApps = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4.545 2.5h1.91A2.045 2.045 0 0 1 8.5 4.545v1.91A2.045 2.045 0 0 1 6.455 8.5h-1.91A2.045 2.045 0 0 1 2.5 6.455v-1.91A2.045 2.045 0 0 1 4.545 2.5ZM13.546 2.5h1.909A2.046 2.046 0 0 1 17.5 4.545v1.91A2.045 2.045 0 0 1 15.454 8.5h-1.909A2.046 2.046 0 0 1 11.5 6.455v-1.91A2.045 2.045 0 0 1 13.546 2.5ZM4.545 11.5h1.91A2.045 2.045 0 0 1 8.5 13.546v1.909A2.046 2.046 0 0 1 6.455 17.5h-1.91A2.045 2.045 0 0 1 2.5 15.454v-1.909A2.046 2.046 0 0 1 4.545 11.5ZM13.546 11.5h1.909a2.046 2.046 0 0 1 2.045 2.046v1.909a2.046 2.046 0 0 1-2.046 2.045h-1.909a2.046 2.046 0 0 1-2.045-2.046v-1.909a2.046 2.046 0 0 1 2.046-2.045Z", stroke: "#30384C" }))); };

var SvgReply = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M7.833 7.5v.433l.43.061c2.801.4 4.775 1.594 6.152 3.168.907 1.036 1.565 2.25 2.025 3.532-2.045-1.902-4.693-2.778-8.107-2.778h-.5v2.71L3.207 9.999l4.626-4.626V7.5Z", stroke: "#30384C" }))); };

var SvgReset = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M18.999 3.819v4.909h-4.91M1 16.91V12h4.91", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M3.054 7.91a7.364 7.364 0 0 1 12.15-2.75L19 8.729M1 12l3.796 3.567a7.365 7.365 0 0 0 12.15-2.75", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgRobot = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6.857 13.714a1.714 1.714 0 1 0 0-3.429 1.714 1.714 0 0 0 0 3.429ZM13.142 13.714a1.714 1.714 0 1 0 0-3.429 1.714 1.714 0 0 0 0 3.429Z", stroke: "#30384C", strokeMiterlimit: 10 }),
    React.createElement("path", { d: "M8 16.57h4", stroke: "#30384C", strokeMiterlimit: 10, strokeLinecap: "round" }),
    React.createElement("path", { d: "M2.858 18.857h14.285v-4h.572a.571.571 0 0 0 .571-.572v-2.857a.571.571 0 0 0-.571-.571h-.572V8.57a2.286 2.286 0 0 0-2.285-2.286H5.143a2.286 2.286 0 0 0-2.285 2.286v2.286h-.572a.571.571 0 0 0-.571.571v2.857a.571.571 0 0 0 .571.572h.572v4Z", stroke: "#30384C", strokeMiterlimit: 10, strokeLinejoin: "round" }),
    React.createElement("path", { d: "M10 6.287V1.145", stroke: "#30384C", strokeMiterlimit: 10, strokeLinecap: "round" }))); };

var SvgRotateCw = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M19.166 3.332v5h-5", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M17.076 12.498a7.5 7.5 0 1 1-1.767-7.8l3.858 3.634", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgSad = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.001 18.333a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M13.334 13.334s-1.25-1.667-3.333-1.667c-2.084 0-3.334 1.667-3.334 1.667M7.5 7.5h.008M12.5 7.5h.008", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgScissors = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M5 7.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM5 17.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM16.668 3.334l-9.9 9.9M12.059 12.066l4.608 4.6M6.768 6.768 10 10", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgSend = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m18.335 1.666-9.167 9.167M18.335 1.666 12.5 18.333l-3.333-7.5-7.5-3.334 16.667-5.833Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgSettings2 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M16.165 12.5a1.373 1.373 0 0 0 .275 1.517l.05.05a1.666 1.666 0 0 1-.54 2.72 1.666 1.666 0 0 1-1.818-.361l-.05-.05a1.375 1.375 0 0 0-1.517-.275 1.375 1.375 0 0 0-.833 1.258v.142a1.667 1.667 0 0 1-3.333 0v-.075a1.375 1.375 0 0 0-.9-1.259 1.375 1.375 0 0 0-1.517.275l-.05.05a1.667 1.667 0 1 1-2.358-2.358l.05-.05a1.375 1.375 0 0 0 .275-1.517 1.374 1.374 0 0 0-1.259-.833H2.5a1.667 1.667 0 1 1 0-3.333h.075a1.375 1.375 0 0 0 1.258-.9 1.375 1.375 0 0 0-.275-1.517l-.05-.05a1.667 1.667 0 1 1 2.358-2.358l.05.05a1.375 1.375 0 0 0 1.517.275h.067a1.375 1.375 0 0 0 .833-1.259v-.141a1.667 1.667 0 0 1 3.333 0v.075a1.374 1.374 0 0 0 .834 1.258 1.375 1.375 0 0 0 1.516-.275l.05-.05a1.667 1.667 0 1 1 2.359 2.358l-.05.05a1.375 1.375 0 0 0-.275 1.517v.067a1.375 1.375 0 0 0 1.258.833h.142a1.667 1.667 0 0 1 0 3.333h-.075a1.375 1.375 0 0 0-1.259.834v0Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgSettings$1 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M21 12.429V9.543L18.886 9.2a8.176 8.176 0 0 0-1.043-2.507l1.25-1.736L17.036 2.9 15.3 4.15a8.031 8.031 0 0 0-2.507-1.043L12.457 1H9.55l-.343 2.114c-.9.207-1.743.565-2.507 1.043L4.957 2.9 2.9 4.957l1.25 1.736A8.031 8.031 0 0 0 3.107 9.2L1 9.543v2.907l2.114.343c.207.9.565 1.743 1.043 2.507l-1.25 1.736 2.057 2.057 1.736-1.25c.757.478 1.6.836 2.507 1.043L9.543 21h2.907l.343-2.114a8.176 8.176 0 0 0 2.507-1.043l1.736 1.25 2.057-2.057-1.25-1.736c.478-.757.836-1.6 1.043-2.507L21 12.429Z", stroke: "#30384C", strokeMiterlimit: 10, strokeLinejoin: "round" }),
    React.createElement("path", { d: "M11 13.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z", stroke: "#30384C", strokeMiterlimit: 10 }))); };

var SvgShare = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3.332 10v6.667a1.667 1.667 0 0 0 1.667 1.666h10a1.667 1.667 0 0 0 1.666-1.666V10M13.335 5 10 1.665 6.668 4.999M10 1.666v10.833", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgShoppingCart = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M7.501 18.333a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667ZM16.665 18.333a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667ZM.832.834h3.333L6.4 11.992a1.667 1.667 0 0 0 1.666 1.342h8.1a1.666 1.666 0 0 0 1.667-1.342l1.333-6.991H5", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgSmartphone = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M14.168 1.666H5.835c-.92 0-1.667.746-1.667 1.667v13.333c0 .92.746 1.667 1.667 1.667h8.333c.92 0 1.667-.746 1.667-1.667V3.333c0-.92-.747-1.667-1.667-1.667ZM10 15h.008", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgSmile = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.001 18.333a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M6.666 11.666s1.25 1.667 3.333 1.667c2.084 0 3.334-1.667 3.334-1.667M7.5 7.5h.008M12.5 7.5h.008", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgSms = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#sms_svg__a)" },
        React.createElement("path", { d: "M3.631 3.642a8.994 8.994 0 0 1 6.996-2.62C15.323 1.342 19 5.393 19 10.245v4.768A3.993 3.993 0 0 1 15.011 19h-4.235c-5.23 0-9.424-3.594-9.754-8.36A9.019 9.019 0 0 1 3.63 3.642Z", stroke: "#30384C" }),
        React.createElement("path", { d: "M6.251 12c-.412 0-.756-.086-1.03-.257a1.277 1.277 0 0 1-.554-.705l.928-.54c.126.324.354.486.683.486.246 0 .37-.066.37-.197 0-.037-.01-.07-.028-.099a.22.22 0 0 0-.103-.076 1.072 1.072 0 0 0-.135-.05 2.044 2.044 0 0 0-.196-.06 6.652 6.652 0 0 1-.212-.06c-.756-.229-1.134-.639-1.134-1.229 0-.35.125-.64.375-.869.253-.23.584-.344.993-.344.322 0 .61.076.863.23.257.153.445.373.564.66l-.9.53c-.106-.269-.28-.404-.522-.404a.343.343 0 0 0-.217.06.171.171 0 0 0-.07.143c0 .08.041.142.124.185.087.044.252.1.494.17.181.054.33.107.445.158.116.048.237.117.364.208.127.087.22.202.282.344.065.139.098.302.098.492 0 .39-.134.692-.402.907-.264.211-.624.317-1.08.317ZM11.994 8.087v3.826h-1.086v-1.864l-.846 1.432h-.098l-.847-1.432v1.864H8.032V8.087h1.085l.896 1.558.895-1.558h1.086ZM13.851 12c-.412 0-.756-.086-1.03-.257a1.277 1.277 0 0 1-.554-.705l.928-.54c.127.324.354.486.684.486.246 0 .369-.066.369-.197a.183.183 0 0 0-.027-.099.22.22 0 0 0-.104-.076 1.074 1.074 0 0 0-.135-.05 2.043 2.043 0 0 0-.196-.06 6.684 6.684 0 0 1-.211-.06c-.756-.229-1.135-.639-1.135-1.229 0-.35.125-.64.375-.869.253-.23.584-.344.993-.344.322 0 .61.076.863.23.257.153.445.373.565.66l-.901.53c-.105-.269-.279-.404-.522-.404a.343.343 0 0 0-.216.06.171.171 0 0 0-.071.143c0 .08.042.142.125.185.087.044.251.1.494.17.18.054.329.107.445.158.115.048.237.117.363.208.127.087.221.202.283.344.065.139.097.302.097.492 0 .39-.134.692-.401.907-.265.211-.625.317-1.08.317Z", fill: "#30384C" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "sms_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))); };

var SvgStar$1 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m10 1.668 2.575 5.217 5.758.841-4.166 4.059.983 5.733L10 14.81l-5.15 2.708.983-5.733-4.167-4.059 5.759-.841L10 1.668Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgSurvey$2 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11.287 7.237c0 .84-.659 1.522-1.47 1.522-.813 0-1.471-.682-1.471-1.522s.658-1.522 1.47-1.522c.813 0 1.47.681 1.47 1.522ZM12.562 9.086c0 .256.2.464.447.464a.456.456 0 0 0 .448-.464c0-.256-.2-.463-.448-.463a.456.456 0 0 0-.447.463ZM6.428 14.376c0 .475.372.86.83.86.46 0 .832-.386.832-.86 0-.475-.372-.86-.831-.86-.459 0-.831.385-.831.86Z", fill: "#30384C" }),
    React.createElement("path", { d: "M7.793 2.066c1.112-1.421 3.301-1.421 4.413 0l1.433 1.83c.328.419.773.735 1.282.91l2.223.767c1.726.594 2.403 2.63 1.364 4.102l-1.338 1.897a2.675 2.675 0 0 0-.49 1.475l-.058 2.303c-.045 1.788-1.816 3.046-3.57 2.535l-2.26-.657a2.839 2.839 0 0 0-1.585 0l-2.259.657c-1.754.51-3.525-.747-3.57-2.535l-.058-2.303a2.674 2.674 0 0 0-.49-1.475L1.492 9.675C.453 8.202 1.13 6.167 2.856 5.573l2.223-.766c.509-.176.954-.492 1.282-.912l1.433-1.83Z", stroke: "#30384C" }))); };

var SvgTakeaway = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4.357 17.732V6.027h11.287v11.705M7.313 5.546v-1.13c0-1.183.967-2.15 2.15-2.15h1.074c1.182 0 2.15.967 2.15 2.15v1.13", stroke: "#30384C", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgTask = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3.577 9.071a2.965 2.965 0 0 0 1.96-.87l5.656-5.657 5.657 5.657-5.657 5.657a2.965 2.965 0 0 0-.87 1.959L3.577 9.07ZM6.242 13.15 2 17.393", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgTicket = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 22 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.625 3.135V4.85M16.625 14.572v2.288M16.625 5.994V7.71M16.625 8.854v1.715M16.625 11.713v1.715M21.195 15.143A1.142 1.142 0 0 1 20.053 14a1.144 1.144 0 0 1 1.142-1.143V11.14a1.142 1.142 0 0 1-1.142-1.143 1.144 1.144 0 0 1 1.142-1.144V7.138a1.142 1.142 0 0 1-1.142-1.144 1.144 1.144 0 0 1 1.142-1.144V3.135H1.2V4.85a1.142 1.142 0 0 1 .808 1.953 1.142 1.142 0 0 1-.808.335v1.715a1.142 1.142 0 0 1 .808 1.952 1.142 1.142 0 0 1-.808.335v1.716a1.142 1.142 0 0 1 .808 1.952 1.142 1.142 0 0 1-.808.335v1.716h19.996v-1.716Z", stroke: "#30384C", strokeLinejoin: "round" }))); };

var SvgTruck = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13.332 2.5H.832v10.833h12.5V2.5Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M13.332 6.668h3.333l2.5 2.5v4.167h-5.833V6.668ZM4.583 17.5a2.083 2.083 0 1 0 0-4.166 2.083 2.083 0 0 0 0 4.167Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M15.415 17.499a2.083 2.083 0 1 0 0-4.167 2.083 2.083 0 0 0 0 4.167Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgTypeTxtL = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#type-txt-l_svg__a)", stroke: "#30384C" },
        React.createElement("path", { d: "M6 8V6h8v2M8 14h4M10 6v8", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M14.875 1h-9.75A4.13 4.13 0 0 0 1 5.125v9.75A4.13 4.13 0 0 0 5.125 19h9.75A4.13 4.13 0 0 0 19 14.875v-9.75A4.13 4.13 0 0 0 14.875 1Z" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "type-txt-l_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))); };

var SvgTypeTxt = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3.333 5.832v-2.5h13.334v2.5M7.5 16.668h5M10 3.332v13.333", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgType = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.5 13.333V6.666a1.667 1.667 0 0 0-.833-1.441L10.833 1.89a1.666 1.666 0 0 0-1.666 0L3.333 5.225A1.667 1.667 0 0 0 2.5 6.666v6.667a1.667 1.667 0 0 0 .833 1.442l5.834 3.333a1.666 1.666 0 0 0 1.666 0l5.834-3.333a1.667 1.667 0 0 0 .833-1.442Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M6.25 3.508 10 5.674l3.75-2.166M6.25 16.492v-4.325L2.5 10M17.5 10l-3.75 2.167v4.325M2.725 5.8 10 10.01l7.275-4.21M10 18.4V10", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgUncollapse = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m15 18.334-5-5-5 5M5 1.666l5 5 5-5", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgUpdate = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1 4.089v4.909h4.91M18.999 17.18v-4.91h-4.91", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M16.946 8.18a7.364 7.364 0 0 0-12.15-2.75L1 8.998m18 3.272-3.796 3.568a7.364 7.364 0 0 1-12.15-2.75", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgUpload = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.5 12.5v3.333a1.666 1.666 0 0 1-1.667 1.667H4.167A1.667 1.667 0 0 1 2.5 15.833V12.5M14.167 6.667 10.001 2.5 5.834 6.667M10 2.5v10", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgUrl = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11.927 7h1.913a3.189 3.189 0 0 1 0 6.377h-1.913m-3.826 0H6.188a3.189 3.189 0 0 1 0-6.377h1.913M7.465 10.188h5.101", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgUserCheck = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13.332 17.5v-1.667A3.333 3.333 0 0 0 9.999 12.5H4.165a3.333 3.333 0 0 0-3.333 3.333V17.5M7.083 9.167a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667ZM14.168 9.167l1.667 1.666L19.168 7.5", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgUser$1 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.665 17.5v-1.667a3.333 3.333 0 0 0-3.333-3.333H6.665a3.333 3.333 0 0 0-3.333 3.333V17.5M10.001 9.167a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgUsers = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M14.165 17.5v-1.667a3.333 3.333 0 0 0-3.333-3.333H4.165a3.333 3.333 0 0 0-3.333 3.333V17.5M7.501 9.167a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667ZM19.168 17.5v-1.668a3.334 3.334 0 0 0-2.5-3.225M13.332 2.607a3.333 3.333 0 0 1 0 6.459", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgZap = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m10.833 1.666-8.333 10H10l-.833 6.667 8.333-10H10l.833-6.667Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var MenuBox = function (props) { return (React.createElement("svg", { width: "17", height: "16", viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M13.0996 3.19922H4.29961C3.08458 3.19922 2.09961 4.17337 2.09961 5.37505V11.1772C2.09961 12.3789 3.08458 13.3531 4.29961 13.3531H13.0996C14.3146 13.3531 15.2996 12.3789 15.2996 11.1772V5.37505C15.2996 4.17337 14.3146 3.19922 13.0996 3.19922Z", stroke: "#D84339", "stroke-width": "1.5", "stroke-linecap": "round", "stroke-linejoin": "round" }),
    React.createElement("path", { d: "M2.09961 10.3084L4.93038 7.40934C5.25313 7.09127 5.61924 6.92383 5.99192 6.92383C6.3646 6.92383 6.73071 7.09127 7.05346 7.40934L9.88423 10.3084", stroke: "#D84339", "stroke-width": "1.5", "stroke-linecap": "round", "stroke-linejoin": "round" }),
    React.createElement("path", { d: "M9.20898 9.66114L10.7321 8.36996C11.0794 8.08665 11.4733 7.9375 11.8744 7.9375C12.2754 7.9375 12.6694 8.08665 13.0167 8.36996L15.3013 10.3067", stroke: "#D84339", "stroke-width": "1.5", "stroke-linecap": "round", "stroke-linejoin": "round" }),
    React.createElement("path", { d: "M10.3945 6.13281H10.4012", stroke: "#D84339", "stroke-width": "1.5", "stroke-linecap": "round", "stroke-linejoin": "round" }))); };

var PointScale = function (props) { return (React.createElement("svg", { width: "17", height: "16", viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M5.83398 4H14.5007", stroke: "#D84339", "stroke-width": "1.5", "stroke-linecap": "round", "stroke-linejoin": "round" }),
    React.createElement("path", { d: "M5.83398 8H14.5007", stroke: "#D84339", "stroke-width": "1.5", "stroke-linecap": "round", "stroke-linejoin": "round" }),
    React.createElement("path", { d: "M5.83398 12H14.5007", stroke: "#D84339", "stroke-width": "1.5", "stroke-linecap": "round", "stroke-linejoin": "round" }),
    React.createElement("path", { d: "M2.5 4H2.50667", stroke: "#D84339", "stroke-width": "1.5", "stroke-linecap": "round", "stroke-linejoin": "round" }),
    React.createElement("path", { d: "M2.5 8H2.50667", stroke: "#D84339", "stroke-width": "1.5", "stroke-linecap": "round", "stroke-linejoin": "round" }),
    React.createElement("path", { d: "M2.5 12H2.50667", stroke: "#D84339", "stroke-width": "1.5", "stroke-linecap": "round", "stroke-linejoin": "round" }))); };

var SvgMultipleChoice = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" }, props),
    React.createElement("path", { d: "M10 4L14 4", stroke: "#D84339", "stroke-width": "1.5", "stroke-linecap": "round", "stroke-linejoin": "round" }),
    React.createElement("path", { d: "M10 12L14 12", stroke: "#D84339", "stroke-width": "1.5", "stroke-linecap": "round", "stroke-linejoin": "round" }),
    React.createElement("path", { d: "M2 3C2 2.44772 2.44772 2 3 2H5C5.55228 2 6 2.44772 6 3V5C6 5.55228 5.55228 6 5 6H3C2.44772 6 2 5.55228 2 5V3Z", stroke: "#D84339", "stroke-width": "1.5" }),
    React.createElement("path", { d: "M2 11C2 10.4477 2.44772 10 3 10H5C5.55228 10 6 10.4477 6 11V13C6 13.5523 5.55228 14 5 14H3C2.44772 14 2 13.5523 2 13V11Z", stroke: "#D84339", "stroke-width": "1.5" }))); };

var TieredRatingIcon = function (props) { return (React.createElement("svg", __assign({ width: "17", height: "16", viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M0.599218 14.8202C0.664192 14.9355 0.757635 15.0313 0.870165 15.0979C0.982695 15.1645 1.11035 15.1997 1.24032 15.1997M0.599218 14.8202L16.4009 14.0616C16.4659 14.177 16.5 14.3078 16.5 14.4409C16.5 14.5741 16.4658 14.7049 16.4008 14.8202C16.3358 14.9355 16.2424 15.0313 16.1298 15.0979C16.0173 15.1645 15.8896 15.1997 15.7597 15.1997H1.24032M0.599218 14.8202L1.24032 14.459M0.599218 14.8202L1.24032 14.459M1.24032 15.1997L1.24081 14.4719V14.4718L1.24082 14.4587L1.24082 14.4497M1.24032 15.1997V14.4727V14.4727V14.459M1.24082 14.4497L1.24032 14.4497V14.459M1.24082 14.4497C1.24582 14.4497 1.24973 14.4511 1.25201 14.4524L1.24082 14.4497ZM14.6523 12.4863L15.7474 14.4295C15.7474 14.4295 15.7474 14.4296 15.7474 14.4296C15.7487 14.4319 15.75 14.4358 15.75 14.4408C15.75 14.4444 15.7493 14.4475 15.7484 14.4497H1.25157C1.2507 14.4475 1.25 14.4444 1.25 14.4408C1.25 14.4358 1.25133 14.4318 1.25262 14.4295C1.25262 14.4295 1.25263 14.4295 1.25264 14.4295L2.34773 12.4863H14.6523Z", stroke: "white", "stroke-width": "1.5" }),
    React.createElement("path", { d: "M6.34267 5.39979L8.50082 1.57009L10.659 5.39979H6.34267Z", stroke: "white", "stroke-width": "1.5" }),
    React.createElement("mask", { id: "path-3-inside-1_5993_84951", fill: "white" },
        React.createElement("path", { d: "M14.1326 10.5502C14.0946 10.5727 14.0515 10.5846 14.0076 10.5846H2.99224C2.94835 10.5846 2.90523 10.5727 2.86721 10.5502C2.8292 10.5278 2.79763 10.4954 2.77569 10.4565C2.75374 10.4175 2.74219 10.3733 2.74219 10.3284C2.74219 10.2834 2.75374 10.2392 2.77569 10.2003L4.33641 7.43083C4.35834 7.39186 4.3899 7.35951 4.42792 7.33702C4.46593 7.31453 4.50907 7.3027 4.55297 7.30273H12.4469C12.4908 7.3027 12.534 7.31453 12.572 7.33702C12.61 7.35951 12.6416 7.39186 12.6635 7.43083L14.2241 10.2003C14.2461 10.2392 14.2576 10.2834 14.2576 10.3284C14.2576 10.3733 14.2461 10.4175 14.2241 10.4565C14.2022 10.4954 14.1706 10.5278 14.1326 10.5502Z" })),
    React.createElement("path", { d: "M14.0076 10.5846V12.0846H14.0076L14.0076 10.5846ZM14.2241 10.4565L15.5309 11.1929L15.5309 11.1929L14.2241 10.4565ZM14.2241 10.2003L12.9173 10.9367L12.9173 10.9367L14.2241 10.2003ZM12.6635 7.43083L11.3562 8.16633L11.3567 8.16723L12.6635 7.43083ZM12.572 7.33702L11.8083 8.62806L12.572 7.33702ZM12.4469 7.30273V8.80273L12.448 8.80273L12.4469 7.30273ZM4.55297 7.30273L4.5519 8.80273H4.55297V7.30273ZM4.42792 7.33702L5.1916 8.62806L5.1916 8.62806L4.42792 7.33702ZM4.33641 7.43083L5.64319 8.16727L5.64373 8.16631L4.33641 7.43083ZM2.77569 10.2003L1.46891 9.46385L1.4689 9.46387L2.77569 10.2003ZM2.77569 10.4565L1.46889 11.1929L1.46889 11.1929L2.77569 10.4565ZM2.86721 10.5502L2.10352 11.8413H2.10352L2.86721 10.5502ZM2.99224 10.5846L2.9922 12.0846H2.99224V10.5846ZM14.0076 12.0846C14.3219 12.0846 14.6285 11.9997 14.8963 11.8413L13.3689 9.25921C13.5606 9.14579 13.781 9.08458 14.0075 9.08457L14.0076 12.0846ZM14.8963 11.8413C15.1637 11.6831 15.3814 11.4582 15.5309 11.1929L12.9173 9.72007C13.0229 9.53263 13.1775 9.37245 13.3689 9.25921L14.8963 11.8413ZM15.5309 11.1929C15.6803 10.9277 15.7576 10.6297 15.7576 10.3284H12.7576C12.7576 10.117 12.8118 9.90733 12.9173 9.72007L15.5309 11.1929ZM15.7576 10.3284C15.7576 10.027 15.6803 9.72898 15.5309 9.46388L12.9173 10.9367C12.8118 10.7495 12.7576 10.5398 12.7576 10.3284H15.7576ZM15.5309 9.46388L13.9703 6.69443L11.3567 8.16723L12.9173 10.9367L15.5309 9.46388ZM13.9708 6.69534C13.8213 6.42959 13.6035 6.20438 13.3357 6.04598L11.8083 8.62806C11.6165 8.51463 11.4618 8.35413 11.3562 8.16632L13.9708 6.69534ZM13.3357 6.04598C13.0676 5.88741 12.7606 5.80251 12.4459 5.80273L12.448 8.80273C12.2211 8.8029 12.0003 8.74165 11.8083 8.62806L13.3357 6.04598ZM12.4469 5.80273H4.55297V8.80273H12.4469V5.80273ZM4.55404 5.80273C4.23933 5.80251 3.93229 5.88741 3.66423 6.04598L5.1916 8.62806C4.99958 8.74165 4.77881 8.8029 4.5519 8.80273L4.55404 5.80273ZM3.66423 6.04598C3.39645 6.20437 3.17862 6.42958 3.0291 6.69535L5.64373 8.16631C5.53806 8.35414 5.38334 8.51464 5.1916 8.62806L3.66423 6.04598ZM3.02964 6.6944L1.46891 9.46385L4.08247 10.9367L5.64319 8.16727L3.02964 6.6944ZM1.4689 9.46387C1.3195 9.72898 1.24219 10.027 1.24219 10.3284H4.24219C4.24219 10.5398 4.18798 10.7495 4.08248 10.9367L1.4689 9.46387ZM1.24219 10.3284C1.24219 10.6297 1.31949 10.9277 1.46889 11.1929L4.08248 9.72007C4.18799 9.9073 4.24219 10.117 4.24219 10.3284H1.24219ZM1.46889 11.1929C1.61841 11.4582 1.83605 11.6831 2.10352 11.8413L3.63091 9.25921C3.82235 9.37246 3.97686 9.53263 4.08248 9.72007L1.46889 11.1929ZM2.10352 11.8413C2.37128 11.9997 2.6779 12.0846 2.9922 12.0846L2.99228 9.08457C3.21879 9.08458 3.43917 9.14579 3.63091 9.25921L2.10352 11.8413ZM2.99224 12.0846H14.0076V9.08457H2.99224V12.0846Z", fill: "white", mask: "url(#path-3-inside-1_5993_84951)" }))); };

var VoucherIcon = function (props) { return (React.createElement("svg", __assign({ width: "16", height: "14", viewBox: "0 0 16 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M14.7684 9.09163L14.7773 9.09422L14.7862 9.09659C14.9047 9.12806 15.0198 9.20322 15.1076 9.32178C15.1953 9.4404 15.248 9.59291 15.25 9.75587L15.25 9.84398C15.249 10.6029 14.9656 11.3215 14.4754 11.8444C13.9868 12.3655 13.3351 12.6489 12.6664 12.65C12.6662 12.65 12.6659 12.65 12.6657 12.65L2 12.65C1.68467 12.65 1.37165 12.5168 1.13294 12.2622C0.892694 12.0059 0.75 11.6486 0.75 11.2666L0.750001 9.75588C0.752026 9.59292 0.804653 9.44041 0.892429 9.32178C0.980158 9.20322 1.09527 9.12806 1.21379 9.09659L1.22272 9.09422L1.23159 9.09163C1.68116 8.96033 2.06819 8.67796 2.33924 8.29903C2.6098 7.9208 2.75256 7.46435 2.75256 6.99997C2.75256 6.53559 2.6098 6.07915 2.33924 5.70092C2.06819 5.32199 1.68116 5.03962 1.23159 4.90832L1.22272 4.90573L1.21379 4.90336C1.09527 4.87189 0.98016 4.79673 0.892429 4.67817C0.804653 4.55954 0.752026 4.40703 0.750001 4.24407L0.750001 2.73331C0.750001 2.35137 0.892694 1.99403 1.13294 1.73777C1.37165 1.48315 1.68467 1.34997 2 1.34997L12.6661 1.34998C13.335 1.35095 13.9867 1.63436 14.4754 2.15558C14.9656 2.67844 15.249 3.39705 15.25 4.15597L15.25 4.24408C15.248 4.40704 15.1953 4.55955 15.1076 4.67817C15.0198 4.79673 14.9047 4.87189 14.7862 4.90336L14.7773 4.90573L14.7684 4.90832C14.3188 5.03962 13.9318 5.32199 13.6608 5.70092C13.3902 6.07915 13.2474 6.53559 13.2474 6.99998C13.2474 7.46436 13.3902 7.9208 13.6608 8.29903C13.9318 8.67796 14.3188 8.96033 14.7684 9.09163Z", stroke: "#D84339", "stroke-width": "1.5" }))); };

var ICONS_OUTLINE = /*#__PURE__*/Object.freeze({
    __proto__: null,
    AlertCircle: SvgAlertCircle,
    Analize: SvgAnalize,
    Archive: SvgArchive,
    Archive2: SvgArchive2,
    ArrowDown: SvgArrowDown,
    ArrowLeft: SvgArrowLeft,
    ArrowRight: SvgArrowRight,
    ArrowUp: SvgArrowUp,
    ArrowUpRight: SvgArrowUpRight,
    Assign: SvgAssign,
    Attach: SvgAttach,
    Bell: SvgBell,
    BellCheck: SvgBellCheck,
    BookOpen: SvgBookOpen,
    Briefcase: SvgBriefcase,
    Calendar: SvgCalendar,
    CalendarArrow: SvgCalendarArrow,
    Camera: SvgCamera,
    Cancel: SvgCancel,
    ChangeOrder: SvgChangeOrder,
    CheckCircle: SvgCheckCircle,
    ChevronDown: SvgChevronDown$1,
    ChevronLeft: SvgChevronLeft,
    ChevronRight: SvgChevronRight,
    ChevronUp: SvgChevronUp,
    Click: SvgClick,
    Clock: SvgClock$1,
    Close: SvgClose,
    Codepen: SvgCodepen,
    Collapse: SvgCollapse,
    Columns: SvgColumns,
    Comment: SvgComment$2,
    CommentQuote: SvgCommentQuote,
    Copy: SvgCopy,
    CornerUpLeft: SvgCornerUpLeft,
    CornerUpRight: SvgCornerUpRight,
    Crown: SvgCrown$1,
    Date: SvgDate,
    Delete: SvgDelete,
    Desktop: SvgDesktop,
    DiceFour: SvgDiceFour,
    Dislike: SvgDislike,
    DollarSign: SvgDollarSign,
    Done: SvgDone$1,
    DoneAll: SvgDoneAll,
    Download: SvgDownload,
    Duplicate: SvgDuplicate,
    Edit: SvgEdit,
    ExternalFeedbackLink: SvgExternalFeedbackLink,
    ExternalLink: SvgExternalLink,
    Eye: SvgEye,
    EyeOff: SvgEyeOff,
    FieldLine: SvgFieldLine,
    FileDownload: SvgFileDownload,
    FileDraft: SvgFileDraft,
    Filter: SvgFilter$1,
    Finish: SvgFinish,
    Fire: SvgFire,
    Folder: SvgFolder,
    FoodMenu: SvgFoodMenu,
    Gallery: MenuBox,
    Global: SvgGlobal,
    Help: SvgHelp$1,
    Home: SvgHome$1,
    Hourglass: SvgHourglass$1,
    Icons: SvgIcons,
    Info: SvgInfo,
    InteractiveMouseClick: SvgInteractiveMouseClick,
    InternalChat: SvgInternalChat,
    Key: SvgKey,
    Layers: SvgLayers,
    Layout: SvgLayout,
    Like: SvgLike,
    Link: SvgLink,
    List: SvgList,
    Magnet: SvgMagnet,
    Mail: SvgMail,
    MapPin: SvgMapPin$1,
    Menu: SvgMenu,
    MessageSquare: SvgMessageSquare,
    Minus: SvgMinus,
    More: SvgMore,
    Move: SvgMove,
    MultipleChoice: SvgMultipleChoice,
    Navigation: SvgNavigation,
    Order: SvgOrder,
    Paperclip: SvgPaperclip,
    Phone: SvgPhone,
    Pic: SvgPic,
    PicInCyrcle: SvgPicInCyrcle,
    Pin: SvgPin,
    Play: SvgPlay,
    Plus: SvgPlus,
    PointScale: PointScale,
    ProgrammingLanguage1: SvgProgrammingLanguage1,
    Qr: SvgQr,
    Qr2: SvgQr2,
    Question: SvgQuestion,
    RelatedApps: SvgRelatedApps,
    Reply: SvgReply,
    Reset: SvgReset,
    Robot: SvgRobot,
    RotateCw: SvgRotateCw,
    Sad: SvgSad,
    Scissors: SvgScissors,
    Send: SvgSend,
    Settings: SvgSettings$1,
    Settings2: SvgSettings2,
    Share: SvgShare,
    ShoppingCart: SvgShoppingCart,
    Smartphone: SvgSmartphone,
    Smile: SvgSmile,
    Sms: SvgSms,
    Star: SvgStar$1,
    Survey: SvgSurvey$2,
    Takeaway: SvgTakeaway,
    Task: SvgTask,
    Ticket: SvgTicket,
    TieredRating: TieredRatingIcon,
    Truck: SvgTruck,
    Type: SvgType,
    TypeTxt: SvgTypeTxt,
    TypeTxtL: SvgTypeTxtL,
    Uncollapse: SvgUncollapse,
    Update: SvgUpdate,
    Upload: SvgUpload,
    Url: SvgUrl,
    User: SvgUser$1,
    UserCheck: SvgUserCheck,
    Users: SvgUsers,
    VoucherIcon: VoucherIcon,
    Zap: SvgZap
});

var SvgAppeasementForm = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 38 38", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M23.8 4.223h3.377v32.933H1.844V4.223h3.378M7.756 28.71h13.511M7.756 32.09h6.755M32.244 32.089l2.111 4.729 2.111-4.73V6.334A1.267 1.267 0 0 0 35.2 5.066h-1.69a1.267 1.267 0 0 0-1.266 1.267V32.09ZM36.466 9.29h-4.222", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M17.045 3.377a2.534 2.534 0 0 0-5.067 0H9.445a1.689 1.689 0 0 0-1.69 1.689v1.689h13.512V5.066a1.689 1.689 0 0 0-1.689-1.689h-2.533ZM14.756 15.637v1.118M14.756 19v-.166M14.01 11.405 8.137 20.58c-.373.585.065 1.335.76 1.335H20.63a.874.874 0 0 0 .744-1.345L15.5 11.405a.886.886 0 0 0-1.488 0Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgAssignmentRules = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#assignment-rules_svg__a)", stroke: "#30384C", strokeLinejoin: "round" },
        React.createElement("path", { d: "M17.87 27.233a3.583 3.583 0 0 0 3.405-3.404v-7.66c0-2.808-5.157-4.255-8.11-4.255-2.953 0-8.06 1.447-8.06 4.255v7.66a3.583 3.583 0 0 0 3.405 3.404", strokeLinecap: "round" }),
        React.createElement("path", { d: "M13.617 9.362a3.26 3.26 0 0 0 3.404-3.404V4.256a3.404 3.404 0 0 0-6.809 0v1.702a3.26 3.26 0 0 0 3.405 3.404Z" }),
        React.createElement("path", { d: "M17.871 39.15V17.873M8.512 17.873V39.15M13.617 26.383v12.766", strokeLinecap: "round" }),
        React.createElement("path", { d: "M35.744 15.32a3.404 3.404 0 1 0 0-6.808 3.404 3.404 0 0 0 0 6.808ZM35.744 25.531a3.404 3.404 0 1 0 0-6.809 3.404 3.404 0 0 0 0 6.81ZM35.744 35.744a3.404 3.404 0 1 0 0-6.809 3.404 3.404 0 0 0 0 6.81ZM32.34 22.127h-8.51" }),
        React.createElement("path", { d: "M32.34 32.34h-3.405a.85.85 0 0 1-.851-.852V12.765a.851.851 0 0 1 .851-.85h3.404" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "assignment-rules_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h40v40H0z" }))))); };

var SvgAutoResponse = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M7.705 13.359a3.754 3.754 0 0 1 3.749-3.75h17.093a3.753 3.753 0 0 1 3.75 3.75v16.143a3.753 3.753 0 0 1-3.75 3.75h-5.711l-.243.152-7.29 4.556v-4.708h-3.848a3.754 3.754 0 0 1-3.75-3.75V13.36Zm19.56-7.767s-.36.096-.616.096c-.255 0-.617-.096-.617-.096a1.849 1.849 0 1 1 1.234 0Z", stroke: "#30384C" }),
    React.createElement("path", { d: "m21.5 22 2.5-2.5-2.5-2.5", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M16 25v-3.5a2 2 0 0 1 2-2h6", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M35.195 16.207h.95a2.852 2.852 0 0 1 2.85 2.85v3.798a2.852 2.852 0 0 1-2.85 2.85h-.95M4.805 25.704h-.95a2.852 2.852 0 0 1-2.85-2.849v-3.799a2.852 2.852 0 0 1 2.85-2.849h.95", stroke: "#30384C" }))); };

var SvgBusinessInfo = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#business-info_svg__a)", stroke: "#30384C", strokeMiterlimit: 10, strokeLinejoin: "round" },
        React.createElement("path", { d: "M14.95 24.543h5.105c-.468.425-.85 1.047-.85 1.702a2.55 2.55 0 0 0 2.553 2.553 2.55 2.55 0 0 0 2.553-2.553c0-.655-.392-1.277-.851-1.702h5.106v11.915a2.55 2.55 0 0 1-2.553 2.553H3.885a2.55 2.55 0 0 1-2.553-2.553v-22.98a2.55 2.55 0 0 1 2.553-2.552H14.95v5.106c.477-.502 1.047-.85 1.702-.85a2.55 2.55 0 0 1 2.553 2.552 2.55 2.55 0 0 1-2.553 2.553 2.17 2.17 0 0 1-1.702-.85v5.106ZM20.059 10.346l3.608-3.608c-.043.621.136 1.336.604 1.804a2.553 2.553 0 0 0 3.609 0 2.553 2.553 0 0 0 0-3.609c-.468-.468-1.217-.68-1.804-.604L29.693.721l7.82 7.821a2.553 2.553 0 0 1 0 3.608l-7.82 7.822-9.634-9.626Z" }),
        React.createElement("path", { d: "M14.947 39.011v-5.957c-.324.45-1.047.85-1.702.85a2.55 2.55 0 0 1-2.554-2.553 2.55 2.55 0 0 1 2.554-2.553c.655 0 1.37.383 1.702.851v-5.106M1.332 24.542h5.106c-.493-.383-.85-1.046-.85-1.702a2.55 2.55 0 0 1 2.553-2.553 2.55 2.55 0 0 1 2.553 2.553c0 .656-.358 1.294-.851 1.702h5.106" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "business-info_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h40v40H0z" }))))); };

var SvgChats = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m23 20.5-3 3-3-3H8.5v-17h23v17H23Z", stroke: "#30384C", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M8.5 12H1v17.5h8.5l3 3 3.5-3m0 0h8.5v-9h7v-4h8l-.5 17h-8.5l-3 3-3.5-3h-8v-4Z", stroke: "#30384C", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M12.5 7h15M12.5 11.5H25M15 16.5h12.5", stroke: "#30384C", strokeLinecap: "round" }),
    React.createElement("circle", { cx: 27.5, cy: 11.5, r: 0.5, fill: "#30384C" }),
    React.createElement("circle", { cx: 12.5, cy: 16.5, r: 0.5, fill: "#30384C" }))); };

var SvgComment$1 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M9 17h22M9 12h22M9 22h13", stroke: "#30384C", strokeMiterlimit: 10, strokeLinejoin: "round" }),
    React.createElement("path", { d: "M36.364 3H3.636c-.434 0-.85.17-1.157.473C2.172 3.776 2 4.186 2 4.614V28.83c0 .429.172.84.48 1.142.306.303.722.473 1.156.473H6.91v6.942c0 .33.103.652.294.922.191.271.462.478.776.592a1.657 1.657 0 0 0 1.81-.465l6.938-7.991h19.637c.434 0 .85-.17 1.157-.473.307-.303.479-.713.479-1.142V4.614c0-.428-.172-.838-.48-1.141A1.648 1.648 0 0 0 36.365 3Z", stroke: "#30384C", strokeLinejoin: "round" }))); };

var SvgDelivery = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M25.832 14.666h6.617c.55 0 1.066.275 1.375.725l2.841 5.108h.834c.933 0 1.666.617 1.666 1.842v5.658c0 .917-.75 1.667-1.666 1.667h-1.667", stroke: "#30384C", strokeMiterlimit: 10 }),
    React.createElement("path", { d: "M14.167 8h11.666v21.667H12.5M5.835 29.666H1.668M35.836 29.675A3.332 3.332 0 0 1 32.494 33a3.332 3.332 0 0 1-3.342-3.325 3.332 3.332 0 0 1 3.342-3.325 3.327 3.327 0 0 1 3.342 3.325Z", stroke: "#30384C", strokeMiterlimit: 10 }),
    React.createElement("path", { d: "M12.515 29.675A3.332 3.332 0 0 1 9.174 33a3.332 3.332 0 0 1-3.342-3.325 3.332 3.332 0 0 1 3.342-3.325 3.327 3.327 0 0 1 3.341 3.325ZM25.832 29.666h3.333M27.5 21.333h5.833L35 20.5h1.667M0 20.5h14.167M2.5 12.166h19.167M7.5 16.334H20M5.835 16.334H4.168", stroke: "#30384C", strokeMiterlimit: 10 }),
    React.createElement("path", { d: "M12.499 8h-1.667", stroke: "#30384C", strokeWidth: 2, strokeMiterlimit: 10 }))); };

var SvgDirectMessage = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 42 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.998 19.543h18.75M10.998 14.762h18.75M10.998 24.326h10", stroke: "#30384C", strokeMiterlimit: 10, strokeLinejoin: "round" }),
    React.createElement("path", { d: "M21 4C9.95 4 1 10.696 1 18.946c0 3.264 1.413 6.265 3.787 8.728-.337 2.535-1 5.201-2.037 7.688-.388.92.462 1.89 1.475 1.65 4.325-1.004 7.55-2.475 9.912-4.041 2.15.586 4.45.92 6.863.92 11.05 0 20-6.695 20-14.945S32.05 4 21 4Z", stroke: "#30384C", strokeMiterlimit: 10 }))); };

var SvgEmailSend = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M9.168 17.333v-5c0-.917.75-1.667 1.667-1.667H37.5c.917 0 1.667.75 1.667 1.667v17.5c0 .916-.75 1.666-1.667 1.666H10.835c-.917 0-1.667-.75-1.667-1.666v-3.334", stroke: "#30384C", strokeMiterlimit: 10 }),
    React.createElement("path", { d: "m36.668 13.166-8.967 8.967a5.01 5.01 0 0 1-7.075 0l-8.958-8.967M11.668 28.999l6.667-6.667M36.667 28.999 30 22.332M3.332 17.332h8.333M0 20.666h9.167M4.168 24h8.333", stroke: "#30384C", strokeMiterlimit: 10 }))); };

var SvgFeedbackComment = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 38 38", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#feedback-comment_svg__a)", stroke: "#30384C" },
        React.createElement("path", { d: "M7.277 20.212c1.852 0 3.234-1.551 3.234-3.464V15.59c0-1.913-1.382-3.464-3.234-3.464-1.851 0-3.234 1.551-3.234 3.464v1.157c0 1.913 1.383 3.464 3.234 3.464Z", strokeMiterlimit: 10 }),
        React.createElement("path", { d: "M16.17.809h18.595a2.426 2.426 0 0 1 2.426 2.425v12.128a3.234 3.234 0 0 1-3.234 3.234h-11.32l-3.395 4.527a.809.809 0 0 1-1.455-.485v-4.042H16.17a2.425 2.425 0 0 1-2.426-2.426V3.234A2.426 2.426 0 0 1 16.17.81Z", strokeLinejoin: "round" }),
        React.createElement("path", { d: "m25.468 4.469 1.645 3.417 3.61.383L28.13 11l.586 3.417-3.248-1.493-3.248 1.492.586-3.416-2.593-2.732 3.61-.383 1.645-3.417ZM7.277 33.58l-2.729-.556c-.768-.108-1.29-.28-2.007-1.364l-.69-1.522C1.244 28.799.809 28.225.809 27.137c0-2.28 1.165-4.498 3.734-4.498h4.66c1.494.06 2.41.322 3.226 1.305.816.984 1.58 1.912 1.58 1.912", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "m4.639 26.912.731 1.826c.291.73.645 1.016 1.325 1.268l1.882.669", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M15.8 32.34h-2.854c-.155-1.92 1.516-3.235 1.516-3.235h2.565c.563 0 .93.633.678 1.17l-.549 1.171a1.51 1.51 0 0 1-1.356.893Z", strokeLinejoin: "round" }),
        React.createElement("path", { d: "m16.648 29.107 1.063-2.176a.743.743 0 0 0-.653-1.076h-5.66a.728.728 0 0 0-.652.412l-3.648 7.425a.742.742 0 0 0 .653 1.074h5.66a.728.728 0 0 0 .652-.41l.989-2.015M4.043 32.926v4.266", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M12.127 34.766v2.425", strokeWidth: 2, strokeLinejoin: "round" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "feedback-comment_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h38v38H0z" }))))); };

var SvgFeedbackInbox = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.91 9.492h16.516M17.91 13.623h9.29M9.65 43.557h3.097c2.044 0 1.25 2.064 4.13 2.064h11.829c1.001 0 2.168-1.011 2.168-2.012l1.445-8.671c.32-1.941-1.167-3.768-3.128-3.768h-3.024", stroke: "#30384C", strokeMiterlimit: 10 }),
    React.createElement("path", { d: "M19.973 38.398c2.601-1.26 4.13-2.756 4.13-5.564v-1.662c0-.867 1.031-2.054 1.031-4.129 0-2.106-.815-3.22-1.713-4.377-.898-1.176-3.448-.96-3.448.176v1.105c0 3.685-5.13 7.225-6.194 7.225H9.65", stroke: "#30384C", strokeMiterlimit: 10 }),
    React.createElement("path", { d: "M9.65 29.105H3.458v16.516h6.194V29.105ZM16.877 22.914h-6.193a2.07 2.07 0 0 1-2.065-2.065V3.301a2.07 2.07 0 0 1 2.065-2.065H41.65c1.136 0 2.065.919 2.065 2.065v17.548a2.07 2.07 0 0 1-2.065 2.065h-3.096v5.161c0 .991-1.26 1.414-1.858.62l-5.368-5.781h-4.13", stroke: "#30384C", strokeMiterlimit: 10 }))); };

var SvgForms$1 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11.838 18.828h16.405M3.637 28.854V3.563c0-.638.501-1.14 1.139-1.14h30.53c.639 0 1.14.502 1.14 1.14v30.53c0 .639-.501 1.14-1.14 1.14H17.992", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M31.89 10.627H8.194a.457.457 0 0 1-.456-.456V6.98c0-.25.205-.456.456-.456H31.89c.25 0 .455.205.455.456v3.19c0 .25-.205.456-.455.456ZM31.205 31.132H21.18c-.638 0-1.139-.5-1.139-1.139v-1.822c0-.639.501-1.14 1.14-1.14h10.024c.638 0 1.14.502 1.14 1.14v1.822c0 .615-.524 1.14-1.14 1.14ZM31.89 22.93H8.194a.457.457 0 0 1-.456-.455v-7.29c0-.251.205-.457.456-.457H31.89c.25 0 .455.206.455.456v7.291c0 .25-.205.456-.455.456ZM11.998 27.031h3.942v3.92l-7.861 7.837-3.919-3.919 7.838-7.838ZM6.371 32.727l3.873 3.873", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgGoogleBoostFeedbackSurvey = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M28.5 18.5h10v17H30l-3 3-3-3h-8.5V29", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M34.5 23H27M32 27h-9M20 31h14", stroke: "#30384C", strokeLinecap: "round" }),
    React.createElement("path", { d: "M13.504 26.5h-.567A13.215 13.215 0 0 1 .506 13.88 12.99 12.99 0 0 1 6.289 2.681a13 13 0 0 1 12.565-1.026 1.498 1.498 0 0 1 .775.866 1.483 1.483 0 0 1-.101 1.169l-1.74 3.21a1.443 1.443 0 0 1-1.835.642l-.013-.006a6.575 6.575 0 0 0-7.158 1.578l-.005.005a6.45 6.45 0 0 0-1.698 4.886l.001.011a6.382 6.382 0 0 0 2.426 4.388 6.602 6.602 0 0 0 5.032 1.455h.003a5.75 5.75 0 0 0 3.888-2.32l.577-.795H14.11a1.457 1.457 0 0 1-1.457-1.444v-3.615a1.456 1.456 0 0 1 1.457-1.456h10.931a1.47 1.47 0 0 1 1.459 1.446v2.52A12.992 12.992 0 0 1 13.504 26.5Z", stroke: "#30384C" }))); };

var SvgGoogleBoostOnePage = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13.504 26.5h-.567A13.215 13.215 0 0 1 .506 13.88 12.99 12.99 0 0 1 6.289 2.681a13 13 0 0 1 12.565-1.026 1.498 1.498 0 0 1 .775.866 1.483 1.483 0 0 1-.101 1.169l-1.74 3.21a1.443 1.443 0 0 1-1.835.642l-.013-.006a6.575 6.575 0 0 0-7.158 1.578l-.005.005a6.45 6.45 0 0 0-1.698 4.886l.001.011a6.382 6.382 0 0 0 2.426 4.388 6.602 6.602 0 0 0 5.032 1.455h.003a5.75 5.75 0 0 0 3.888-2.32l.577-.795H14.11a1.457 1.457 0 0 1-1.457-1.444v-3.615a1.456 1.456 0 0 1 1.457-1.456h10.931a1.47 1.47 0 0 1 1.459 1.446v2.52A12.992 12.992 0 0 1 13.504 26.5Z", stroke: "#30384C" }),
    React.createElement("path", { d: "M29 17h7.556C37.906 17 39 18.045 39 19.333v16.334C39 36.955 37.906 38 36.556 38H19.444C18.094 38 17 36.955 17 35.667V29M39 24H24M24 38V24", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgKnifeAndFork = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M34.168 8.332v5M36.668 8.332v5M39.168 8.332v7.5c0 1.775-1.608 2.292-2.5 2.5l.833 11.667c0 .716-.208 1.666-2.083 1.666-1.875 0-2.083-.95-2.083-1.666l.833-11.667c-.892-.208-2.5-.725-2.5-2.5v-7.5M1.776 12.614c-.317 1.9-.942 8.217-.942 8.217l1.667 1.666v7.5c0 .867.633 1.667 1.666 1.667 1.034 0 1.667-.7 1.667-1.567V9.581s0-1.042-1.25-1.042-2.475 2.083-2.808 4.075ZM18.75 29.997c5.754 0 10.417-4.663 10.417-10.416S24.504 9.164 18.751 9.164 8.334 13.828 8.334 19.581s4.664 10.416 10.417 10.416Z", stroke: "#30384C", strokeMiterlimit: 10, strokeLinejoin: "round" }),
    React.createElement("path", { d: "M11.668 19.583a7.088 7.088 0 0 1 7.083-7.083", stroke: "#30384C", strokeMiterlimit: 10, strokeLinejoin: "round" }))); };

var SvgManageConnection = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#manage-connection_svg__a)", stroke: "#30384C", strokeMiterlimit: 10 },
        React.createElement("path", { d: "M20 27.272a7.273 7.273 0 1 0 0-14.545 7.273 7.273 0 0 0 0 14.545ZM20 6.363a2.727 2.727 0 1 0 0-5.455 2.727 2.727 0 0 0 0 5.455ZM20 39.091a2.727 2.727 0 1 0 0-5.454 2.727 2.727 0 0 0 0 5.454ZM37.273 6.364a2.724 2.724 0 0 1-2.727 2.727 2.724 2.724 0 0 1-2.728-2.727 2.724 2.724 0 0 1 2.728-2.727 2.724 2.724 0 0 1 2.727 2.727ZM39.091 20a2.724 2.724 0 0 1-2.727 2.728 2.724 2.724 0 0 1-2.727-2.727 2.724 2.724 0 0 1 2.727-2.728 2.724 2.724 0 0 1 2.727 2.728ZM6.363 20a2.724 2.724 0 0 1-2.728 2.728 2.724 2.724 0 0 1-2.727-2.727 2.724 2.724 0 0 1 2.727-2.728 2.724 2.724 0 0 1 2.728 2.728ZM8.181 6.364a2.724 2.724 0 0 1-2.727 2.727 2.724 2.724 0 0 1-2.727-2.727 2.724 2.724 0 0 1 2.727-2.727A2.724 2.724 0 0 1 8.18 6.364ZM37.273 33.637a2.724 2.724 0 0 1-2.727 2.728 2.724 2.724 0 0 1-2.728-2.728 2.724 2.724 0 0 1 2.728-2.727 2.724 2.724 0 0 1 2.727 2.727ZM8.181 33.637a2.724 2.724 0 0 1-2.727 2.728 2.724 2.724 0 0 1-2.727-2.728 2.724 2.724 0 0 1 2.727-2.727 2.724 2.724 0 0 1 2.727 2.727ZM20 6.363v4.546M20 29.092v4.545M7.273 8.182l5.455 5.454M32.728 8.182l-5.455 5.454M7.273 31.818l5.455-5.455M32.728 31.818l-5.455-5.455M6.363 20h4.546M29.09 20h4.545" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "manage-connection_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h40v40H0z" }))))); };

var SvgManageUsers = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#manage-users_svg__a)", stroke: "#30384C", strokeMiterlimit: 10 },
        React.createElement("path", { d: "M19.999 20c2.956 0 5.217-2.087 5.217-5.217v-2.608c0-3.131-2.26-5.218-5.217-5.218s-5.218 2.087-5.218 5.218v2.608C14.781 17.913 17.042 20 20 20ZM30.436 33.044v-4.348c0-3.913-6.956-6.087-10.435-6.087-3.478 0-10.435 2.174-10.435 6.087v4.348" }),
        React.createElement("path", { d: "M20 39.13c10.565 0 19.13-8.565 19.13-19.13C39.13 9.434 30.565.87 20 .87 9.434.87.87 9.433.87 20 .87 30.565 9.433 39.13 20 39.13Z" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "manage-users_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h40v40H0z" }))))); };

var SvgMessage = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 42 42", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M19.182 12.305h13.636M19.182 8.826h13.636M19.182 15.783h7.273M9.571 11.904l-7.909 2.348", stroke: "#30384C", strokeMiterlimit: 10, strokeLinejoin: "round" }),
    React.createElement("path", { d: "m10.09 7.191-7.172 2.13c-1.437.427-2.246 1.888-1.791 3.27l8.627 26.575c.446 1.374 1.973 2.148 3.41 1.713l13.018-3.87c1.436-.426 2.245-1.887 1.79-3.27l-2.836-8.721", stroke: "#30384C", strokeMiterlimit: 10 }),
    React.createElement("path", { d: "m17.572 36.844 2.6-.774M8.945 36.67l18.228-5.418", stroke: "#30384C", strokeMiterlimit: 10, strokeLinejoin: "round" }),
    React.createElement("path", { d: "M26.454 1c-8.037 0-14.546 4.87-14.546 10.87 0 2.374 1.027 4.556 2.755 6.348-.246 1.843-.728 3.782-1.482 5.591-.282.67.336 1.374 1.073 1.2 3.145-.73 5.49-1.8 7.209-2.94 1.564.427 3.236.67 4.99.67C34.49 22.74 41 17.87 41 11.87 41 5.87 34.49 1 26.454 1Z", stroke: "#30384C", strokeMiterlimit: 10 }))); };

var SvgMoneyArrowDown = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 38 38", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.5 8.709v-.792a1.583 1.583 0 0 0-1.583-1.583h-1.584a1.584 1.584 0 0 0-1.583 1.583v.443a1.584 1.584 0 0 0 1.083 1.502l2.584.862a1.583 1.583 0 0 1 1.083 1.501v.442a1.583 1.583 0 0 1-1.583 1.584h-1.584a1.584 1.584 0 0 1-1.583-1.584v-.791M15.125 14.25v2.375M15.125 6.334V3.959", stroke: "#30384C", strokeMiterlimit: 10 }),
    React.createElement("path", { d: "M13.543 19.791v3.167h-4.75l10.292 14.25 10.291-14.25h-3.958V7.916M25.418 6.333V4.75M25.418 3.167V1.584M29.375 13.459v-9.5M8.793 17.417V9.5M8.793 7.917V6.334M8.793 4.75V3.165M8.793 1.583V0M21.457 13.459v7.917", stroke: "#30384C", strokeLinejoin: "round" }))); };

var SvgMoneyChart = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 38 38", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12.666 27.663c0 .788.726 1.575 1.601 1.575h1.566c.874 0 1.583-.787 1.583-1.575v-.238c0-.61-.428-1.152-1.074-1.345l-2.59-.771c-.646-.197-1.088-.735-1.088-1.345v-.238c0-.788.709-1.576 1.583-1.576h1.584c.875 0 1.583.788 1.583 1.576v.787M15.043 22.15v-2.363M15.043 29.238v2.363", stroke: "#30384C", strokeMiterlimit: 10 }),
    React.createElement("path", { d: "M15.042 33.177c4.372 0 7.916-3.35 7.916-7.482s-3.544-7.482-7.916-7.482c-4.373 0-7.917 3.35-7.917 7.482s3.544 7.482 7.917 7.482Z", stroke: "#30384C", strokeMiterlimit: 10 }),
    React.createElement("path", { d: "m20.7 30.928 5.425 5.397", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M3.168 15.85a2.369 2.369 0 0 0 2.375-2.362 2.369 2.369 0 0 0-2.375-2.363 2.369 2.369 0 0 0-2.375 2.363 2.369 2.369 0 0 0 2.375 2.362ZM13.457 7.973a2.369 2.369 0 0 0 2.375-2.362 2.369 2.369 0 0 0-2.375-2.363 2.369 2.369 0 0 0-2.375 2.363 2.369 2.369 0 0 0 2.375 2.362ZM25.332 14.274a2.369 2.369 0 0 0 2.375-2.362 2.369 2.369 0 0 0-2.375-2.363 2.369 2.369 0 0 0-2.375 2.363 2.369 2.369 0 0 0 2.375 2.362ZM34.832 6.4a2.369 2.369 0 0 0 2.375-2.363 2.369 2.369 0 0 0-2.375-2.363 2.369 2.369 0 0 0-2.375 2.363 2.369 2.369 0 0 0 2.375 2.362ZM5.047 12.048l6.531-4.997M15.557 6.725l7.68 4.075M27.154 10.4l5.856-4.853", stroke: "#30384C", strokeMiterlimit: 10 }),
    React.createElement("path", { d: "M3.168 19v10.238M7.125 16.637v2.362M11.082 11.912v3.938M15.043 11.912v3.15M19 14.275v1.575M22.957 16.637v2.362M26.918 17.426v11.813M30.875 13.486v15.752M34.832 10.336v18.902", stroke: "#30384C", strokeMiterlimit: 10, strokeLinecap: "round" }))); };

var SvgNotificationCenter = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#notification-center_svg__a)" },
        React.createElement("mask", { id: "notification-center_svg__b", style: {
                maskType: 'luminance'
            }, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 40, height: 40 },
            React.createElement("path", { d: "M40 0H0v40h40V0Z", fill: "#fff" })),
        React.createElement("g", { mask: "url(#notification-center_svg__b)", stroke: "#30384C", strokeMiterlimit: 10 },
            React.createElement("path", { d: "M11.892 11.903c-.66-.084-1.214-.084-1.539-.084-1.455-.01-7.212-.02-7.212 7.108 0 2.408.104 4.7.104 7.119 0 3.716-1.989 4.187-2.722 4.292v2.198c3.015 0 8.72-.02 9.82-.031 1.11 0 6.804.031 9.82.031v-2.198c-.733-.105-2.723-.576-2.723-4.292 0-.586.01-1.173.021-1.748M7.674 33.918s0 1.842 2.67 1.842c2.606 0 2.669-1.842 2.669-1.842M10.344 11.316V8.93" }),
            React.createElement("path", { d: "M39.465 4.523H14.53v17.493h24.936V4.523Z" }),
            React.createElement("path", { d: "m14.53 4.523 12.3 10.835L39.476 4.523" }))),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "notification-center_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h40v40H0z" }))))); };

var SvgOpenBook = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("mask", { id: "open-book_svg__a", fill: "#fff" },
        React.createElement("path", { d: "M39.219 7.579H35.78V5.002a.781.781 0 0 0-.78-.781h-9.786a5.957 5.957 0 0 0-4.24 1.755A6.025 6.025 0 0 0 20 7.255a6.027 6.027 0 0 0-.975-1.279 5.957 5.957 0 0 0-4.24-1.756h-6L8.75 4.22l-.036.002H5a.781.781 0 0 0-.781.781V7.58H.78A.781.781 0 0 0 0 8.36v26.641c0 .431.35.781.781.781H39.22c.431 0 .781-.35.781-.781V8.361a.781.781 0 0 0-.781-.782ZM1.562 34.219V9.142H4.22v20.86a.781.781 0 0 0 .781.782h9.785c1.207 0 2.326.428 3.152 1.206a4.055 4.055 0 0 1 1.21 2.23H1.563Zm17.657-3.158a5.998 5.998 0 0 0-.21-.209c-1.117-1.053-2.617-1.633-4.224-1.632H5.78V5.783H7.97v5.45a.781.781 0 0 0 1.562 0v-5.45h5.254c1.184 0 2.298.46 3.135 1.298a4.405 4.405 0 0 1 1.299 3.135v20.845Zm1.562-20.845c0-1.184.461-2.298 1.299-3.135a4.404 4.404 0 0 1 3.135-1.298h9.004V29.22h-9.004c-1.607 0-3.107.58-4.224 1.632a5.913 5.913 0 0 0-.21.21V10.215ZM38.438 34.22H20.852a4.055 4.055 0 0 1 1.21-2.23c.826-.78 1.945-1.208 3.152-1.208H35a.781.781 0 0 0 .781-.78V9.142h2.657V34.22Z" })),
    React.createElement("path", { d: "M35.781 7.579h-2v2h2v-2Zm-.78-3.358-.001 2v-2Zm-9.786 0v-2 2Zm-4.24 1.755-1.414-1.414 1.414 1.414ZM20 7.255l-1.738.99L20 11.294l1.738-3.049L20 7.255Zm-.975-1.279 1.414-1.414-1.414 1.414Zm-4.24-1.756v2-2Zm-6 0-.091 1.998.046.003h.046v-2Zm-.07 0v2h.046l.045-.002-.092-1.997ZM5 4.22v2-2ZM4.219 7.58v2h2v-2h-2Zm-2.657 26.64h-2v2h2v-2Zm0-25.078v-2h-2v2h2Zm2.657 0h2v-2h-2v2Zm.229 21.413 1.414-1.414-1.414 1.414Zm.552.229v2-2Zm9.785 0v-2 2Zm3.152 1.206 1.372-1.455-1.372 1.455Zm1.21 2.23v2h2.401l-.434-2.361-1.967.362Zm.072-3.158-1.445 1.383 3.445 3.6V31.06h-2Zm-.21-.209 1.373-1.453-.001-.002-1.372 1.455Zm-4.224-1.632v2-2Zm-9.004 0h-2v2h2v-2Zm0-23.437v-2h-2v2h2Zm2.188 0h2v-2h-2v2Zm1.562 0v-2h-2v2h2Zm5.254 0v-2 2ZM17.92 7.08l1.414-1.414L17.92 7.08Zm4.16 0-1.414-1.414L22.08 7.08Zm3.135-1.298v-2 2Zm9.004 0h2v-2h-2v2Zm0 23.437v2h2v-2h-2Zm-9.004 0v-2 2Zm-4.224 1.632-1.372-1.455 1.372 1.455Zm-.21.21h-2v4.981l3.445-3.599-1.445-1.383Zm.072 3.158-1.967-.362-.435 2.362h2.402v-2Zm1.21-2.23-1.372-1.456 1.372 1.455Zm3.152-1.208v-2 2Zm9.785 0v2-2Zm.552-.228L34.14 29.14l1.413 1.414Zm.23-21.413v-2h-2v2h2Zm2.656 0h2v-2h-2v2Zm.78-3.562h-3.437v4h3.438v-4Zm-1.437 2V5.002h-4V7.58h4Zm0-2.577a2.781 2.781 0 0 0-2.78-2.781v4a1.219 1.219 0 0 1-1.22-1.219h4Zm-2.78-2.781h-9.786v4H35v-4Zm-9.786 0v4-4Zm0 0a7.957 7.957 0 0 0-5.654 2.34l2.828 2.83a3.957 3.957 0 0 1 2.826-1.17v-4ZM19.56 4.561a8.025 8.025 0 0 0-1.299 1.703l3.476 1.98c.176-.31.393-.597.651-.855l-2.828-2.828Zm2.177 1.702a8.028 8.028 0 0 0-1.299-1.702L17.611 7.39c.257.258.475.545.651.855l3.476-1.98Zm-1.299-1.702a7.956 7.956 0 0 0-5.654-2.342v4c1.071 0 2.068.413 2.826 1.17l2.828-2.828ZM14.785 2.22h-6v4h6v-4Zm-5.907.003.03.001c.001 0 .002 0 0 0h-.011a2.264 2.264 0 0 0-.147-.005v4l-.076-.002-.035-.002h-.002a1.319 1.319 0 0 0 .057.003l.184-3.995Zm-.128-.004c-.071 0-.129.003-.146.005h-.011c-.003 0-.002 0 0 0l.03-.001.183 3.995.048-.002h.009-.002a1.543 1.543 0 0 1-.11.003v-4Zm-.036.002H5v4h3.715v-4ZM5 2.22a2.781 2.781 0 0 0-2.781 2.781h4c0 .673-.546 1.219-1.22 1.219v-4ZM2.219 5.002V7.58h4V5.002h-4Zm2 .577H.78v4H4.22v-4Zm-3.438 0A2.781 2.781 0 0 0-2 8.36h4C2 9.033 1.454 9.58.781 9.58v-4ZM-2 8.36v26.641h4V8.361h-4Zm0 26.641a2.781 2.781 0 0 0 2.781 2.781v-4c.673 0 1.219.546 1.219 1.219h-4Zm2.781 2.781H39.22v-4H.78v4Zm38.438 0A2.781 2.781 0 0 0 42 35.001h-4c0-.673.546-1.219 1.219-1.219v4ZM42 35.001V8.361h-4V35h4Zm0-26.64a2.781 2.781 0 0 0-2.781-2.782v4A1.219 1.219 0 0 1 38 8.36h4ZM3.562 34.22V9.14h-4V34.22h4Zm-2-23.079H4.22v-4H1.562v4Zm.657-2v20.86h4V9.142h-4Zm0 20.86c0 .738.293 1.446.815 1.968l2.827-2.83c.23.23.358.54.358.863h-4Zm.814 1.967A2.781 2.781 0 0 0 5 32.783v-4c.323 0 .633.128.862.357l-2.829 2.828ZM5 32.783h9.785v-4H5v4Zm9.785 0c.732 0 1.35.257 1.78.661l2.744-2.91c-1.222-1.152-2.843-1.752-4.524-1.752v4Zm1.78.661c.323.305.533.694.615 1.137l3.934-.723a6.055 6.055 0 0 0-1.805-3.324l-2.745 2.91Zm2.582-1.224H1.563v4h17.584v-4Zm1.517-2.542a7.81 7.81 0 0 0-.282-.28l-2.747 2.908c.048.046.095.092.139.138l2.89-2.766Zm-.283-.28c-1.507-1.421-3.506-2.178-5.596-2.178v4c1.123 0 2.125.402 2.851 1.087l2.745-2.91Zm-5.596-2.178H5.78v4h9.004v-4Zm-7.004 2V5.783h-4V29.22h4Zm-2-21.437H7.97v-4H5.78v4Zm.188-2v5.45h4v-5.45h-4Zm0 5.45a2.781 2.781 0 0 0 2.781 2.782v-4c.673 0 1.219.545 1.219 1.218h-4Zm2.781 2.782a2.781 2.781 0 0 0 2.781-2.782h-4c0-.673.546-1.218 1.219-1.218v4Zm2.781-2.782v-5.45h-4v5.45h4Zm-2-3.45h5.254v-4H9.53v4Zm5.254 0c.654 0 1.259.25 1.721.712l2.828-2.828a6.405 6.405 0 0 0-4.55-1.884l.001 4Zm1.72.712c.463.463.714 1.067.714 1.721h4a6.405 6.405 0 0 0-1.885-4.55l-2.828 2.83Zm.714 1.721v20.845h4V10.216h-4Zm5.562 0c0-.654.25-1.258.713-1.72l-2.828-2.83a6.405 6.405 0 0 0-1.885 4.55h4Zm.713-1.72a2.404 2.404 0 0 1 1.72-.713v-4a6.404 6.404 0 0 0-4.548 1.884l2.828 2.828Zm1.72-.713h.001v-4 4Zm0 0h9.005v-4h-9.004v4Zm7.005-2V29.22h4V5.783h-4Zm2 21.437h-9.004v4h9.004v-4Zm-9.004 0v4-4Zm0 0c-2.09 0-4.09.757-5.596 2.177l2.745 2.91c.726-.685 1.727-1.087 2.85-1.087v-4Zm-5.596 2.178a7.782 7.782 0 0 0-.283.28l2.89 2.766c.045-.047.09-.092.138-.137l-2.745-2.91Zm3.162 1.663V10.216h-4v20.845h4Zm15.657 1.159H20.852v4h17.584v-4ZM22.82 34.582c.082-.444.292-.833.616-1.138l-2.745-2.91a6.055 6.055 0 0 0-1.805 3.324l3.934.724Zm.616-1.138c.429-.404 1.046-.662 1.779-.662v-4c-1.681 0-3.302.6-4.524 1.752l2.745 2.91Zm1.779-.662v-4 4Zm0 0H35v-4h-9.785v4Zm9.785 0v-4 4Zm0 0c.738 0 1.445-.292 1.967-.814l-2.829-2.828a1.22 1.22 0 0 1 .862-.357v4Zm1.966-.813c.522-.522.815-1.23.815-1.967h-4c0-.324.129-.634.358-.862l2.827 2.829Zm.815-1.967V9.142h-4v20.86h4Zm-2-18.86h2.657v-4H35.78v4Zm.657-2V34.22h4V9.14h-4Z", fill: "#30384C", mask: "url(#open-book_svg__a)" }),
    React.createElement("path", { d: "M8.961 14.473c.003.009.005.018.006.028a.216.216 0 0 1-.428-.028.219.219 0 0 1 .422 0Z", stroke: "#30384C", strokeWidth: 2 }))); };

var SvgPages = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 38 38", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M35.42 16.141 20.65 9.367l-9.13 19.904 14.77 6.774 9.13-19.904Z", stroke: "#30384C", strokeMiterlimit: 10 }),
    React.createElement("path", { d: "m30.731 17.876-8.348-3.83-2.355 5.136 8.348 3.83 2.355-5.136ZM17.898 22.104l9.637 4.423M16.725 24.676l9.628 4.415M15.543 27.24l3.851 1.768M18.026 10.467l-1.964-7.192L1.875 7.142l5.213 19.13 4.416-1.204", stroke: "#30384C", strokeMiterlimit: 10 }),
    React.createElement("path", { d: "m7.147 14.336 8.019-2.188-1.346-4.934L5.8 9.4l1.347 4.935ZM14.107 15.738l-6.732 1.836M12.797 18.748l-4.754 1.294M19.027 6.05l1.866-4.107L32.86 7.405l-2.129 4.679", stroke: "#30384C", strokeMiterlimit: 10 }))); };

var SvgPhoneChatContact = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 38 38", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M35.468 15.19a1.688 1.688 0 0 0 1.688-1.688V2.532A1.688 1.688 0 0 0 35.468.844H18.59a1.688 1.688 0 0 0-1.688 1.688v10.97a1.688 1.688 0 0 0 1.688 1.688h2.532v5.063a.844.844 0 0 0 1.536.481l4.37-5.544h8.44ZM21.123 5.906h11.814M21.123 9.283h8.439", stroke: "#30384C", strokeMiterlimit: 10 }),
    React.createElement("path", { d: "M10.413 26.792c7.764 7.756 15.19 9.401 17.908 9.545a19.99 19.99 0 0 0 2.978-6.566 24.852 24.852 0 0 0-7.156-4.768l-3.02 2.98c-1.022-.27-3.815-1.427-7.157-4.769-3.342-3.341-4.472-6.143-4.742-7.181l2.987-2.98a24.97 24.97 0 0 0-4.776-7.147A19.865 19.865 0 0 0 .869 8.894c.152 2.734 1.79 10.143 9.544 17.898Z", stroke: "#30384C", strokeMiterlimit: 10 }))); };

var SvgPuzzle = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#puzzle_svg__a)" },
        React.createElement("path", { d: "m19.251 38.52 7.217-7.218c-.153 1.243.272 2.69 1.209 3.609a5.106 5.106 0 0 0 7.217 0 5.106 5.106 0 0 0 0-7.217c-.937-.937-2.332-1.311-3.609-1.209l7.217-7.217-7.217-7.217c2.077.051 3.932-.664 4.698-3.08.596-1.89.272-4.052-1.157-5.414a5.102 5.102 0 0 0-7.15.069 4.298 4.298 0 0 0-1.208 3.608L19.251 0l-7.217 7.217c1.277-.12 2.69.272 3.609 1.209a5.106 5.106 0 0 1 0 7.217 5.106 5.106 0 0 1-7.217 0c-.937-.937-1.362-2.366-1.209-3.609L0 19.251 19.251 38.52Z", stroke: "#30384C", strokeMiterlimit: 10, strokeLinejoin: "round" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "puzzle_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h40v40H0z" }))))); };

var SvgReview$1 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#review_svg__a)", stroke: "#30384C", strokeMiterlimit: 10 },
        React.createElement("path", { d: "m27.484 5.222 1.668-3.214 2.725 5.254L38 7.808l-4.438 4.131 1.059 5.254-5.468-2.363-1.541.666M12.515 5.222l-1.668-3.214-2.725 5.254L2 7.808l4.438 4.131-1.058 5.254 5.467-2.363 1.542.666", strokeLinejoin: "round" }),
        React.createElement("path", { d: "m23.398 16.251 2.18.942-1.058-5.254 4.438-4.13-6.123-.547-2.725-5.254-2.725 5.254-6.123.546L15.7 11.94l-1.059 5.254 2.18-.942", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M21.754 19.66h1.644c.518 0 1.33.329 1.644.822h1.644c.77 0 1.644.72 1.644 1.644h1.645c.77 0 1.644.72 1.644 1.644v8.221c0 1.664-1.645 3.003-1.645 4.11v.822M25.041 20.482v4.11M28.33 22.125v3.288" }),
        React.createElement("path", { d: "M31.62 40.21v-3.288H16v3.288" }),
        React.createElement("path", { d: "M21.753 24.59v-9.864c.008-.908-.736-1.636-1.644-1.644a1.622 1.622 0 0 0-1.645 1.617v12.56c0 .224-.28.328-.429.16-.59-.67-1.896-2.16-2.858-2.828-.612-.425-1.45-.458-2.127-.139-.954.45-1.151 1.715-.445 2.498 2.124 2.357 2.876 5.515 5.038 7.506.865.865.822 1.181.822 1.644v.855" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "review_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h40v40H0z" }))))); };

var SvgShareVoucher = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M29.334 2.11h6a2 2 0 0 1 2 2v6M9.334 38.11h-6a2 2 0 0 1-2-2v-6M1.334 10.11v-6a2 2 0 0 1 2-2h6M37.334 30.11v6a2 2 0 0 1-2 2h-6", stroke: "#30384C", strokeLinecap: "round" }),
    React.createElement("path", { d: "M13.734 7.508h-5.6c-.84 0-1.4.56-1.4 1.4v5.6c0 .84.56 1.4 1.4 1.4h5.6c.84 0 1.4-.56 1.4-1.4v-5.6c0-.84-.56-1.4-1.4-1.4ZM13.734 24.309h-5.6c-.84 0-1.4.56-1.4 1.4v5.6c0 .84.56 1.4 1.4 1.4h5.6c.84 0 1.4-.56 1.4-1.4v-5.6c0-.84-.56-1.4-1.4-1.4ZM30.535 7.508h-5.6c-.84 0-1.4.56-1.4 1.4v5.6c0 .84.56 1.4 1.4 1.4h5.6c.84 0 1.4-.56 1.4-1.4v-5.6c0-.84-.56-1.4-1.4-1.4Z", stroke: "#30384C" }),
    React.createElement("path", { d: "M23.334 27.445h-2v2c0 1.107.893 2 2 2s2-.893 2-2c0-1.106-.893-2-2-2ZM30 22.11c1.107 0 2 .893 2 2v6.666c0 1.107-.893 2-2 2s-2-.893-2-2v-6.667c0-1.106.893-2 2-2Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgSocialPlatforms = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 42 42", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M23.608 3.609c0 1.478-1.13 2.608-2.609 2.608-1.478 0-2.608-1.13-2.608-2.608C18.39 2.13 19.52 1 20.999 1c1.479 0 2.609 1.13 2.609 2.609ZM21 41a2.609 2.609 0 1 0 0-5.217 2.609 2.609 0 0 0 0 5.218ZM36.651 8.825c0 1.479-1.13 2.61-2.609 2.61-1.478 0-2.608-1.131-2.608-2.61 0-1.478 1.13-2.608 2.608-2.608 1.478 0 2.609 1.13 2.609 2.608ZM40.999 21c0 1.478-1.13 2.608-2.61 2.608-1.477 0-2.608-1.13-2.608-2.609 0-1.478 1.13-2.608 2.609-2.608 1.478 0 2.609 1.13 2.609 2.608ZM36.651 33.173c0 1.478-1.13 2.609-2.609 2.609-1.478 0-2.608-1.13-2.608-2.609 0-1.478 1.13-2.609 2.608-2.609 1.478 0 2.609 1.13 2.609 2.61ZM21 6.217v3.478M21 32.305v3.478M32.304 10.565l-2.609 2.608M32.304 31.435l-2.609-2.609M32.305 21h3.478M5.348 8.825c0 1.479 1.13 2.61 2.608 2.61 1.479 0 2.609-1.131 2.609-2.61 0-1.478-1.13-2.608-2.609-2.608-1.478 0-2.608 1.13-2.608 2.608ZM1 21c0 1.478 1.13 2.608 2.609 2.608 1.478 0 2.608-1.13 2.608-2.609 0-1.478-1.13-2.608-2.608-2.608C2.13 18.39 1 19.52 1 20.999ZM5.348 33.173c0 1.478 1.13 2.609 2.608 2.609 1.479 0 2.609-1.13 2.609-2.609 0-1.478-1.13-2.609-2.609-2.609-1.478 0-2.608 1.13-2.608 2.61ZM9.695 10.565l2.609 2.608M9.695 31.435l2.609-2.609M9.695 21H6.217M21 32.304c6.243 0 11.304-5.061 11.304-11.304 0-6.244-5.061-11.305-11.304-11.305-6.244 0-11.305 5.061-11.305 11.305 0 6.243 5.061 11.304 11.305 11.304Z", stroke: "#30384C", strokeMiterlimit: 10 }),
    React.createElement("path", { d: "M20.13 23.608c1.565-1.044 2.609-2.522 2.609-4.348v-.87c0-.26.434-1.39.434-2.608 0-3.392-3.043-3.478-3.043-2.609v.87c0 1.913-2.87 4.348-3.74 4.348h-2.347v7.826h2.609c1.217 0 .956.87 2.608.87h6.435c.609 0 1.305-.697 1.305-1.305l.87-5.13c.173-1.131-.697-2.262-1.827-2.262h-1.565", stroke: "#30384C", strokeMiterlimit: 10 }))); };

var SvgStars = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m12.886 11.786 3.186 6.99 7.312.644a.567.567 0 0 1 .348.966l-5.372 5.32 1.347 6.915a.568.568 0 0 1-.847.618l-6.524-3.279-6.524 3.254a.567.567 0 0 1-.805-.619l1.338-6.905-5.363-5.33a.567.567 0 0 1 .348-.965l7.303-.644 3.186-6.99a.568.568 0 0 1 1.067.025Z", stroke: "#30384C", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m18.707 16.26 2.635-5.796a.474.474 0 0 1 .847 0l2.635 5.795 6.058.543a.466.466 0 0 1 .288.796l-4.448 4.406 1.119 5.753a.474.474 0 0 1-.67.508l-5.405-2.72", stroke: "#30384C", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m26.578 13.915 2.644-5.795a.466.466 0 0 1 .847 0l2.643 5.795 6.05.534a.474.474 0 0 1 .288.847l-4.44 4.406 1.11 5.753a.466.466 0 0 1-.67.508l-5.405-2.72", stroke: "#30384C", strokeLinejoin: "round" }))); };

var SvgSurvey$1 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M22.574 14.472c0 1.681-1.317 3.044-2.941 3.044-1.625 0-2.942-1.363-2.942-3.044s1.317-3.044 2.942-3.044c1.624 0 2.94 1.363 2.94 3.044ZM25.124 18.173c0 .511.4.926.895.926.494 0 .895-.415.895-.926 0-.512-.4-.927-.895-.927s-.895.415-.895.927ZM12.858 28.751c0 .95.744 1.72 1.662 1.72.918 0 1.662-.77 1.662-1.72s-.744-1.72-1.662-1.72c-.918 0-1.662.77-1.662 1.72Z", fill: "#30384C" }),
    React.createElement("path", { d: "m23.574 5.494 2.578 3.369a5.5 5.5 0 0 0 2.54 1.845l4 1.41c2.795.986 3.89 4.358 2.208 6.798l-2.407 3.493a5.5 5.5 0 0 0-.97 2.985l-.105 4.24c-.073 2.964-2.942 5.048-5.783 4.202l-4.065-1.21a5.499 5.499 0 0 0-3.14 0l-4.065 1.21c-2.84.846-5.709-1.238-5.782-4.201l-.105-4.24a5.5 5.5 0 0 0-.97-2.986L5.1 18.916c-1.682-2.44-.587-5.812 2.209-6.798l4-1.41a5.5 5.5 0 0 0 2.54-1.845l2.577-3.369c1.801-2.354 5.347-2.354 7.148 0Z", stroke: "#30384C" }))); };

var SvgTarget = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#target_svg__a)", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" },
        React.createElement("path", { d: "M17.476 24.512c-.084.071-.175.13-.274.175-1.232.574-3.198-1.036-4.392-3.597-1.194-2.56-1.164-5.102.067-5.676.052-.024.104-.044.158-.06M16.877 22.012h15.449M34.472 24.587l-2.146-2.575 2.146-2.575h4.291l-1.716 2.575 1.716 2.575h-4.291ZM15.525 20.078 30.931 9.352M34.174 10.203l-3.242-.85.25-3.342 3.494-2.493.099 3.093 2.892 1.1-3.493 2.492ZM14.705 17.64l7.197-10.056M25.244 7.351l-3.343.232-.83-3.247L23.582.857l1.082 2.9 3.092.116-2.513 3.478Z" }),
        React.createElement("path", { d: "M22.198 22.013c1.088 4.692.302 8.726-2.26 9.922-3.368 1.57-8.527-2.367-11.524-8.793-2.996-6.427-2.696-12.91.67-14.48 1.902-.887 4.375-.019 6.706 2.063M20.275 16.766a24.179 24.179 0 0 1 .977 2.195M17.967 13.08c.31.402.614.826.909 1.27" }),
        React.createElement("path", { d: "M26.19 22.014c1.919 7.674.537 14.472-3.863 16.523-5.55 2.589-13.804-3.36-18.434-13.287C-.735 15.323.012 5.177 5.563 2.588c3.577-1.667 8.274.207 12.4 4.407M23.377 14.61a35.428 35.428 0 0 1 1.757 3.992M20.342 9.758a32.207 32.207 0 0 1 1.496 2.16" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "target_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h39.621v40H0z" }))))); };

var SvgTasks = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#tasks_svg__a)", fill: "#30384C" },
        React.createElement("path", { d: "M35.104 5.718v.008l-.05-.008h.05Zm0 0 .003-.046.003-.036c.001-.04 0-.08-.002-.12-.001-.045-.003-.09-.001-.135m-.003.337-.068-.003-.424-.072.002-.009.004-.015a.504.504 0 0 1 .036-.1.49.49 0 0 1 .095-.134l.358-.004m0 0c0-.048-.001-.095-.003-.143a.502.502 0 0 0-.335.128l.338.015Zm-.513-1.679v.702c-.028.232-.01.498.001.668l.006.095c.003.067.005.137.006.208-.002.058 0 .113.001.15v.002c.002.046.003.07.002.089l-.001.014c-.001.011-.004.035-.004.063l-.011-1.99Zm0 0A3.206 3.206 0 0 0 31.392.5", stroke: "#30384C" }),
        React.createElement("path", { d: "M15.794 7.15a.742.742 0 0 0-.69-.486H9.182a.74.74 0 0 0-.74.74v5.923c0 .41.33.74.74.74h5.922a.74.74 0 0 0 .74-.74V9.192l2.005-2.005-1.047-1.046-1.007 1.007-.001.001Zm-1.43 5.437H9.922V8.145h4.442v.434l-1.48 1.48-.958-.956-1.046 1.046 1.48 1.481a.74.74 0 0 0 1.047 0l.957-.957v1.915-.001ZM16.801 16.505l-1.007 1.008a.742.742 0 0 0-.69-.485H9.182a.74.74 0 0 0-.74.74v5.922c0 .41.33.74.74.74h5.922a.74.74 0 0 0 .74-.74v-4.135l2.005-2.005-1.047-1.046Zm-2.437 6.446H9.922V18.51h4.442v.434l-1.48 1.48-.958-.956-1.046 1.047 1.48 1.48a.74.74 0 0 0 1.047 0l.957-.957v1.915ZM15.104 26.652H9.182a.74.74 0 0 0-.74.74v5.923c0 .41.33.74.74.74h5.922a.74.74 0 0 0 .74-.74v-5.922a.74.74 0 0 0-.74-.74Zm-.74 5.923H9.922v-4.442h4.442v4.442ZM18.807 11.105h7.403v1.481h-7.403v-1.48ZM18.807 8.145h4.442v1.48h-4.442v-1.48ZM18.807 21.469h7.403v1.48h-7.403v-1.48ZM18.807 18.508h4.442v1.48h-4.442v-1.48ZM18.807 31.094h7.403v1.48h-7.403v-1.48ZM18.807 28.133h4.442v1.48h-4.442v-1.48ZM24.729 28.133h1.48v1.48h-1.48v-1.48Z" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "tasks_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h40v40H0z" }))))); };

var SvgTickets = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.6 31.2v-1.067A2.134 2.134 0 0 0 15.466 28h-3.733A2.134 2.134 0 0 0 9.6 30.133V31.2M13.6 25.6a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M3.398 16.005h2.574M20.553 16.005h3.43M7.686 16.005h2.573M11.975 16.005h2.573M16.264 16.005h2.573M21.411 9.15a1.713 1.713 0 0 1-1.716 1.713A1.716 1.716 0 0 1 17.98 9.15h-2.573a1.713 1.713 0 0 1-1.716 1.714 1.716 1.716 0 0 1-1.715-1.714H9.403a1.713 1.713 0 0 1-1.716 1.714A1.716 1.716 0 0 1 5.972 9.15H3.398v29.994h2.574a1.713 1.713 0 0 1 1.715-1.714 1.716 1.716 0 0 1 1.716 1.714h2.573a1.713 1.713 0 0 1 1.715-1.714 1.716 1.716 0 0 1 1.716 1.714h2.573a1.713 1.713 0 0 1 1.715-1.714 1.716 1.716 0 0 1 1.716 1.714h2.573V9.15h-2.573Z", stroke: "#30384C", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m26.968 34.911 1.794.527 8.47-28.773-2.466-.727a1.714 1.714 0 0 1-2.74.884 1.713 1.713 0 0 1-.552-1.848l-2.466-.726a1.714 1.714 0 0 1-2.74.884 1.713 1.713 0 0 1-.552-1.848l-2.466-.726a1.714 1.714 0 0 1-2.111 1.108 1.715 1.715 0 0 1-1.179-2.073L17.494.867 15.93 6.15", stroke: "#30384C", strokeLinejoin: "round" }))); };

var SvgUpdatePersonalInformation = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 39 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M19.13 20.29c2.656 0 4.688-1.875 4.688-4.688v-2.344c0-2.812-2.032-4.688-4.689-4.688-2.656 0-4.688 1.876-4.688 4.688v2.345c0 2.812 2.032 4.688 4.688 4.688ZM19.13 22.635c-3.125 0-9.376 1.953-9.376 5.47v3.906", stroke: "#30384C", strokeMiterlimit: 10 }),
    React.createElement("path", { d: "M19.131 37.479c9.494 0 17.19-7.696 17.19-17.19 0-9.493-7.696-17.19-17.19-17.19-9.494 0-17.19 7.697-17.19 17.19 0 9.494 7.696 17.19 17.19 17.19Z", stroke: "#30384C", strokeMiterlimit: 10 }),
    React.createElement("path", { d: "M25.797 31.883a4.348 4.348 0 1 0 0-8.696 4.348 4.348 0 0 0 0 8.696Z", stroke: "#30384C", strokeMiterlimit: 10 }),
    React.createElement("path", { d: "M25.797 26.957v3.188m0-4.058v-1.16", stroke: "#30384C" }))); };

var SvgUpdateStaffInformation = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M20 37.667c9.758 0 17.667-7.91 17.667-17.666 0-9.757-7.91-17.667-17.666-17.667-9.757 0-17.667 7.91-17.667 17.667 0 9.757 7.91 17.666 17.667 17.666Z", stroke: "#30384C" }),
    React.createElement("path", { d: "M19.999 23a7.667 7.667 0 1 0 0-15.334 7.667 7.667 0 0 0 0 15.333Z", stroke: "#30384C" }),
    React.createElement("path", { d: "M7.121 32.093a13.666 13.666 0 0 1 18.826-7.731c.672.325.735.338 1.35.773", stroke: "#30384C" }),
    React.createElement("mask", { id: "update-staff-information_svg__a", style: {
            maskType: 'alpha'
        }, maskUnits: "userSpaceOnUse", x: 22, y: 21, width: 12, height: 12 },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M31.313 22.198a3.261 3.261 0 0 0-4.552 4.103l-3.436 3.737a1.29 1.29 0 0 0 .076 1.823l.157.144a1.29 1.29 0 0 0 1.824-.076l3.436-3.737a3.26 3.26 0 0 0 3.527-5.13l-1.431 1.557a.672.672 0 1 1-.99-.91l1.389-1.51Z", fill: "#fff" })),
    React.createElement("g", { mask: "url(#update-staff-information_svg__a)" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M31.313 22.198a3.261 3.261 0 0 0-4.552 4.103l-3.436 3.737a1.29 1.29 0 0 0 .076 1.823l.157.144a1.29 1.29 0 0 0 1.824-.076l3.436-3.737a3.26 3.26 0 0 0 3.527-5.13l-1.431 1.557a.672.672 0 1 1-.99-.91l1.389-1.51Z", fill: "#fff" }),
        React.createElement("path", { d: "m31.314 22.198.95.873 1.13-1.229-1.474-.784-.606 1.14ZM26.762 26.3l.95.874.552-.6-.305-.757-1.197.483Zm-3.436 3.737-.95-.873.95.873Zm.077 1.823.873-.95-.873.95Zm.157.145-.874.95.874-.95Zm1.823-.077-.95-.873.95.873Zm3.436-3.737.382-1.232-.78-.241-.552.6.95.873Zm3.528-5.13 1.013-.8-.938-1.188-1.025 1.115.95.873Zm-.427-2.003a4.551 4.551 0 0 0-5.484.94l1.9 1.746a1.97 1.97 0 0 1 2.372-.407l1.212-2.279Zm-5.484.94a4.55 4.55 0 0 0-.87 4.785l2.393-.966a1.97 1.97 0 0 1 .376-2.073l-1.9-1.747Zm-.623 3.429-3.437 3.737 1.9 1.746 3.436-3.736-1.9-1.747Zm-3.437 3.737a2.58 2.58 0 0 0 .153 3.646l1.747-1.9-1.9-1.746Zm.153 3.646.157.145 1.747-1.9-.157-.145-1.747 1.9Zm.157.145a2.58 2.58 0 0 0 3.647-.153l-1.9-1.747-1.747 1.9Zm3.647-.153 3.436-3.737-1.9-1.747-3.436 3.737 1.9 1.747Zm2.105-3.378a4.55 4.55 0 0 0 4.696-1.267l-1.9-1.747a1.97 1.97 0 0 1-2.034.549l-.762 2.465Zm4.696-1.267a4.55 4.55 0 0 0 .226-5.895l-2.026 1.598a1.97 1.97 0 0 1-.1 2.55l1.9 1.747Zm-1.737-5.97-1.432 1.557 1.9 1.747 1.432-1.557-1.9-1.746Zm-1.432 1.557a.618.618 0 0 1 .873-.036l-1.746 1.9c.798.733 2.04.681 2.773-.117l-1.9-1.747Zm.873-.036a.618.618 0 0 1 .037.873l-1.9-1.747a1.962 1.962 0 0 0 .117 2.773l1.746-1.9Zm.037.873 1.389-1.51-1.9-1.747-1.389 1.51 1.9 1.747Z", fill: "#30384C" })))); };

var SvgUserSurveyCheck = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 38 38", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M23.75 30.5v3.958h-9.5V25.75h7.125", stroke: "#30384C", strokeMiterlimit: 10 }),
    React.createElement("path", { d: "M16.625 29.708 19 32.083l5.542-6.333M37.207 25.75h-9.5v8.708h9.5V25.75ZM10.293 30.5v3.958h-9.5V25.75h7.125", stroke: "#30384C", strokeMiterlimit: 10 }),
    React.createElement("path", { d: "m3.168 29.708 2.375 2.375 5.542-6.333M9.5 10.709a3.213 3.213 0 0 1-3.167-3.397V6.188a3.167 3.167 0 1 1 6.334 0v1.124A3.212 3.212 0 0 1 9.5 10.71ZM3.168 22.584s.522-4.402.792-6.333c.269-1.932 1.425-3.167 3.166-3.167H8.71l5.541 6.333h4.75s.357 3.167-2.375 3.167h-4.75l-3.958-4.75", stroke: "#30384C", strokeMiterlimit: 10 }),
    React.createElement("path", { d: "m15.043 17.041 3.167-4.75H28.5l-4.75 7.917h-3.166M8.707 22.584h26.917", stroke: "#30384C", strokeLinejoin: "round" }))); };

var SvgVouchers = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 42 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16 22.54C16 17.253 20.5 13 26 13s10 4.278 10 9.567c0 1.089-.194 1.892-.5 2.463-.306.57-.75.985-1.333 1.27-1.195.596-2.945.7-5.195.7H23.028c-2.222 0-3.972-.104-5.195-.7a2.915 2.915 0 0 1-1.333-1.27c-.333-.597-.5-1.4-.5-2.49Z", stroke: "#30384C" }),
    React.createElement("path", { d: "M26.016 16.47v2.513M24.016 16.47s-.89.55-1.335 1.047c-.445.498-.89 1.466-.89 1.466M28.016 16.47s.89.55 1.334 1.047c.445.498.89 1.466.89 1.466M8.533 18.563v3.14M8.533 13.07v3.139M8.533 24.32v3.14", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M39.967 8.36H11.228c-.25 0-.5.157-.528.418-.194.968-1.112 1.675-2.168 1.675S6.531 9.72 6.336 8.752a.553.553 0 0 0-.528-.419H2.084C1.5 8.333 1 8.804 1 9.353v21.482c0 .575.472 1.02 1.084 1.02h3.724c.25 0 .5-.157.528-.419.195-.968 1.112-1.674 2.168-1.674 1.057 0 1.974.732 2.168 1.674a.553.553 0 0 0 .528.419h28.712c.584 0 1.084-.47 1.084-1.02V9.38c.055-.576-.445-1.02-1.029-1.02Z", stroke: "#30384C" }))); };

var ICONS_DETAILED = /*#__PURE__*/Object.freeze({
    __proto__: null,
    AppeasementForm: SvgAppeasementForm,
    AssignmentRules: SvgAssignmentRules,
    AutoResponse: SvgAutoResponse,
    BusinessInfo: SvgBusinessInfo,
    Chats: SvgChats,
    Comment: SvgComment$1,
    Delivery: SvgDelivery,
    DirectMessage: SvgDirectMessage,
    EmailSend: SvgEmailSend,
    FeedbackComment: SvgFeedbackComment,
    FeedbackInbox: SvgFeedbackInbox,
    Forms: SvgForms$1,
    GoogleBoostFeedbackSurvey: SvgGoogleBoostFeedbackSurvey,
    GoogleBoostOnePage: SvgGoogleBoostOnePage,
    KnifeAndFork: SvgKnifeAndFork,
    ManageConnection: SvgManageConnection,
    ManageUsers: SvgManageUsers,
    Message: SvgMessage,
    MoneyArrowDown: SvgMoneyArrowDown,
    MoneyChart: SvgMoneyChart,
    NotificationCenter: SvgNotificationCenter,
    OpenBook: SvgOpenBook,
    Pages: SvgPages,
    PhoneChatContact: SvgPhoneChatContact,
    Puzzle: SvgPuzzle,
    Review: SvgReview$1,
    ShareVoucher: SvgShareVoucher,
    SocialPlatforms: SvgSocialPlatforms,
    Stars: SvgStars,
    Survey: SvgSurvey$1,
    Target: SvgTarget,
    Tasks: SvgTasks,
    Tickets: SvgTickets,
    UpdatePersonalInformation: SvgUpdatePersonalInformation,
    UpdateStaffInformation: SvgUpdateStaffInformation,
    UserSurveyCheck: SvgUserSurveyCheck,
    Vouchers: SvgVouchers
});

var Svg1St = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#1st_svg__a)" },
        React.createElement("path", { d: "M19.584 11c-.396-.77-1.077-1.747-.69-2.642l.316-.895a2.807 2.807 0 0 0-.835-3.068 2.85 2.85 0 0 0-.982-.546l-1.068-.34c-.895-.216-1.292-1.264-1.672-1.988A2.834 2.834 0 0 0 13.004.136a2.856 2.856 0 0 0-2.152.167c-.755.368-1.73 1.045-2.605.694L7.206.67a2.86 2.86 0 0 0-2.16.184 2.829 2.829 0 0 0-1.401 1.643l-.41 1.276c-.21.83-1.109 1.217-1.808 1.563A2.827 2.827 0 0 0 .031 6.983 2.805 2.805 0 0 0 .21 9.129l.554 1.065c.459.754.059 1.697-.189 2.45a2.791 2.791 0 0 0 .87 3.007c.285.238.614.418.97.53.746.22 1.668.455 2.019 1.227l.554 1.07a2.792 2.792 0 0 0 1.654 1.388 2.855 2.855 0 0 0 2.164-.179l1.154-.596c.797-.48 1.844-.003 2.637.242a2.862 2.862 0 0 0 2.16-.184 2.831 2.831 0 0 0 1.401-1.643c.253-.785.462-1.89 1.316-2.252l.893-.461a2.83 2.83 0 0 0 1.395-1.647A2.808 2.808 0 0 0 19.584 11Z", fill: "#FFC700" }),
        React.createElement("path", { d: "M9.71 6h1.79v8H9.419V8.149L8 8.503l-.5-1.726L9.71 6Z", fill: "#fff" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "1st_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))); };

var Svg2St = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#2st_svg__a)" },
        React.createElement("path", { d: "M19.584 11c-.396-.77-1.077-1.747-.69-2.642l.316-.895a2.807 2.807 0 0 0-.835-3.068 2.85 2.85 0 0 0-.982-.546l-1.068-.34c-.895-.216-1.292-1.264-1.672-1.988A2.834 2.834 0 0 0 13.004.136a2.856 2.856 0 0 0-2.152.167c-.755.368-1.73 1.045-2.605.694L7.206.67a2.86 2.86 0 0 0-2.16.184 2.829 2.829 0 0 0-1.401 1.643l-.41 1.276c-.21.83-1.109 1.217-1.808 1.563A2.827 2.827 0 0 0 .031 6.983 2.805 2.805 0 0 0 .21 9.129l.554 1.065c.459.754.059 1.697-.189 2.45a2.791 2.791 0 0 0 .87 3.007c.285.238.614.418.97.53.746.22 1.668.455 2.019 1.227l.554 1.07a2.792 2.792 0 0 0 1.654 1.388 2.855 2.855 0 0 0 2.164-.179l1.154-.596c.797-.48 1.844-.003 2.637.242a2.862 2.862 0 0 0 2.16-.184 2.831 2.831 0 0 0 1.401-1.643c.253-.785.462-1.89 1.316-2.252l.893-.461a2.83 2.83 0 0 0 1.395-1.647A2.808 2.808 0 0 0 19.584 11Z", fill: "#A0A0A0" }),
        React.createElement("path", { d: "M7.02 14v-1.454l2.595-2.742c.261-.283.452-.51.571-.682a.948.948 0 0 0 .179-.526.615.615 0 0 0-.19-.47c-.12-.12-.287-.18-.504-.18-.462 0-.813.273-1.051.818L6.896 7.8c.254-.589.627-1.036 1.12-1.342A3.034 3.034 0 0 1 9.648 6c.746 0 1.384.224 1.913.671.537.44.806 1.045.806 1.813 0 .455-.108.876-.325 1.264-.208.38-.518.784-.928 1.209l-1.063 1.107h2.45V14H7.02Z", fill: "#fff" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "2st_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))); };

var Svg3St = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#3st_svg__a)" },
        React.createElement("path", { d: "M19.584 11c-.396-.77-1.077-1.747-.69-2.642l.316-.895a2.807 2.807 0 0 0-.835-3.068 2.85 2.85 0 0 0-.982-.546l-1.068-.34c-.895-.216-1.292-1.264-1.672-1.988A2.834 2.834 0 0 0 13.004.136a2.856 2.856 0 0 0-2.152.167c-.755.368-1.73 1.045-2.605.694L7.206.67a2.86 2.86 0 0 0-2.16.184 2.829 2.829 0 0 0-1.401 1.643l-.41 1.276c-.21.83-1.109 1.217-1.808 1.563A2.827 2.827 0 0 0 .031 6.983 2.805 2.805 0 0 0 .21 9.129l.554 1.065c.459.754.059 1.697-.189 2.45a2.791 2.791 0 0 0 .87 3.007c.285.238.614.418.97.53.746.22 1.668.455 2.019 1.227l.554 1.07a2.792 2.792 0 0 0 1.654 1.388 2.855 2.855 0 0 0 2.164-.179l1.154-.596c.797-.48 1.844-.003 2.637.242a2.862 2.862 0 0 0 2.16-.184 2.831 2.831 0 0 0 1.401-1.643c.253-.785.462-1.89 1.316-2.252l.893-.461a2.83 2.83 0 0 0 1.395-1.647A2.808 2.808 0 0 0 19.584 11Z", fill: "#F4A460" }),
        React.createElement("path", { d: "M10.925 9.189c.5.156.902.425 1.208.805.306.38.459.84.459 1.377 0 .842-.276 1.492-.828 1.947-.552.455-1.235.682-2.048.682-.649 0-1.227-.15-1.734-.448-.5-.298-.862-.738-1.086-1.32l1.746-.996c.164.545.522.817 1.074.817.284 0 .5-.067.649-.201a.671.671 0 0 0 .235-.537.64.64 0 0 0-.235-.526c-.15-.134-.365-.202-.649-.202h-.425l-.772-1.14 1.253-1.534h-2.63V6h5.091v1.578l-1.309 1.61Z", fill: "#fff" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "3st_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))); };

var SvgArrowDropUpDown = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#arrow-drop-up-down_svg__a)", fill: "#30384C" },
        React.createElement("path", { d: "M5.413 5.85 9.02 2.09a1.347 1.347 0 0 1 1.963 0l3.607 3.76c.878.915.251 2.483-.988 2.483H6.388c-1.24 0-1.852-1.568-.975-2.483ZM14.587 14.15l-3.607 3.76a1.348 1.348 0 0 1-1.964 0L5.41 14.15c-.877-.915-.25-2.483.99-2.483h7.213c1.24 0 1.852 1.568.975 2.483Z" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "arrow-drop-up-down_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))); };

var SvgBrush = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#brush_svg__a)", fill: "#000" },
        React.createElement("path", { d: "M19.458 1.355a1.857 1.857 0 0 0-2.623 0L6.891 11.3a4.691 4.691 0 0 1 1.66 1.137c.419.438.743.942.963 1.486l9.944-9.945c.724-.723.724-1.9 0-2.623ZM7.703 13.248a8.456 8.456 0 0 0-.137-.137c-.991-.948-2.355-1.223-3.647-.736a3.534 3.534 0 0 0-2.294 2.995c-.01 1.492-.752 2.717-1.49 3.272a.284.284 0 0 0-.12.34c.021.062.089.206.284.206h5.145a3.534 3.534 0 0 0 2.994-2.294c.487-1.292.212-2.655-.735-3.646Z" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "brush_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))); };

var SvgCalculator = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15.795 0H4.207a1.76 1.76 0 0 0-1.758 1.758v16.484c0 .97.789 1.758 1.758 1.758h11.588a1.76 1.76 0 0 0 1.757-1.758V1.758A1.76 1.76 0 0 0 15.795 0ZM4.835 3.451a.47.47 0 0 1 .47-.469h9.55a.47.47 0 0 1 .468.47v1.786a.47.47 0 0 1-.469.469h-9.55a.47.47 0 0 1-.468-.469V3.451ZM10.55 9.86H9.453a.586.586 0 0 1-.586-.586v-.796c0-.324.262-.586.586-.586h1.096c.323 0 .586.262.586.586v.796a.586.586 0 0 1-.586.586Zm.586 2.392v.796a.586.586 0 0 1-.586.586H9.453a.586.586 0 0 1-.586-.585v-.797c0-.323.262-.586.586-.586h1.096c.323 0 .586.263.586.586Zm-4.189 4.57a.586.586 0 0 1-.585.587H5.265a.586.586 0 0 1-.586-.586v-.796c0-.324.262-.586.586-.586H6.36c.323 0 .585.262.585.586v.796Zm0-3.774a.586.586 0 0 1-.585.586H5.265a.586.586 0 0 1-.586-.585v-.797c0-.323.262-.586.586-.586H6.36c.323 0 .585.263.585.586v.796Zm0-3.774a.586.586 0 0 1-.585.586H5.265a.586.586 0 0 1-.586-.586v-.796c0-.324.262-.586.586-.586H6.36c.323 0 .585.262.585.586v.796Zm8.377 7.549a.586.586 0 0 1-.586.586H9.453a.586.586 0 0 1-.586-.586v-.796c0-.324.262-.586.586-.586h5.284c.324 0 .586.262.586.586v.796Zm0-3.774a.586.586 0 0 1-.586.585h-1.096a.586.586 0 0 1-.586-.585v-.797c0-.323.263-.586.586-.586h1.096c.324 0 .586.263.586.586v.796Zm0-3.775a.586.586 0 0 1-.586.586h-1.096a.586.586 0 0 1-.586-.586v-.796c0-.324.263-.586.586-.586h1.096c.324 0 .586.262.586.586v.796Z", fill: "#30384C" }))); };

var SvgChat = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11.665 15 15 18.333V15h-3.334ZM5.832 5a4.167 4.167 0 0 0 0 8.333h8.333a4.167 4.167 0 1 0 0-8.333H5.832Z", fill: "#30384C" }))); };

var SvgClipboard = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#clipboard_svg__a)" },
        React.createElement("path", { d: "M15.769 1.539h-1.902V.781a.781.781 0 0 0-.78-.781H6.94a.781.781 0 0 0-.781.781v.758H4.258a1.955 1.955 0 0 0-1.953 1.953v14.555c0 1.077.876 1.953 1.953 1.953h11.51a1.955 1.955 0 0 0 1.954-1.953V3.492a1.955 1.955 0 0 0-1.953-1.953Zm-3.464.024v1.515H7.72V1.563h4.584Zm3.854 16.484c0 .215-.175.39-.39.39H4.258a.391.391 0 0 1-.39-.39V3.492c0-.215.174-.39.39-.39h1.9v.757c0 .432.35.782.782.782h6.146c.431 0 .781-.35.781-.782v-.757h1.902c.215 0 .39.175.39.39v14.555Zm-2.52-8.925c.305.305.305.8 0 1.105l-4.106 4.105a.781.781 0 0 1-1.105 0l-2.04-2.04a.781.781 0 0 1 1.105-1.105l1.487 1.488 3.553-3.553a.781.781 0 0 1 1.105 0Z", fill: "#30384C" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clipboard_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))); };

var SvgClock = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z", fill: "#30384C" }),
    React.createElement("path", { d: "M9.328 5.334v6l4 2", stroke: "#fff", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgComment = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#comment_svg__a)", strokeLinejoin: "round" },
        React.createElement("path", { d: "M18.182 1H1.818a.824.824 0 0 0-.578.236.802.802 0 0 0-.24.571v12.108c0 .214.086.42.24.57a.824.824 0 0 0 .578.237h1.637v3.47a.8.8 0 0 0 .146.462.817.817 0 0 0 .878.32.82.82 0 0 0 .416-.257L8.364 14.5h9.818c.217 0 .425.137.578-.014a.802.802 0 0 0 .24-.571V1.807a.802.802 0 0 0-.24-.57.824.824 0 0 0-.578-.237Z", fill: "#30384C", stroke: "#30384C" }),
        React.createElement("path", { d: "M4.5 6h11M4.5 10H11", stroke: "#fff", strokeMiterlimit: 10, strokeLinecap: "round" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "comment_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))); };

var SvgCrown = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#crown_svg__a)" },
        React.createElement("path", { d: "M16.576 13.98H3.544a.21.21 0 0 0-.214.204l-.004.605c0 .11.09.204.213.204H16.57c.114 0 .213-.095.214-.204l.003-.605c0-.11-.09-.204-.212-.204Zm3.226-8.1-6.007 2.324a.218.218 0 0 1-.25-.073l-3.26-4.407c-.084-.116-.26-.116-.351 0L6.628 8.138a.21.21 0 0 1-.251.073L.402 5.881c-.175-.066-.35.101-.276.269l3.118 6.883a.21.21 0 0 0 .197.124h13.246a.23.23 0 0 0 .198-.124l3.19-6.883c.076-.168-.098-.343-.273-.27Z", fill: "#30384C" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "crown_svg__a" },
            React.createElement("path", { fill: "#fff", transform: "matrix(1.00134 0 -.00516 .99866 .104 0)", d: "M0 0h19.973v20.027H0z" }))))); };

var SvgDone = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#done_svg__a)", strokeLinecap: "round", strokeLinejoin: "round" },
        React.createElement("path", { d: "M10.001 18.334a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667Z", fill: "#30384C", stroke: "#30384C" }),
        React.createElement("path", { d: "m16 7-6.875 6L6 10.273", stroke: "#fff" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "done_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))); };

var SvgFail = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#fail_svg__a)", strokeLinecap: "round", strokeLinejoin: "round" },
        React.createElement("path", { d: "M10.001 18.334a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667Z", fill: "#30384C", stroke: "#30384C" }),
        React.createElement("path", { d: "m13 7-6 6M7 7l6 6", stroke: "#fff" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "fail_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))); };

var SvgFilter2 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11.456 19a.713.713 0 0 1-.437-.15L8.11 16.6a.769.769 0 0 1-.291-.6v-4.215l-5.104-5.92a2.965 2.965 0 0 1-.682-1.499 3.007 3.007 0 0 1 .217-1.64c.224-.514.588-.95 1.046-1.256.46-.307.994-.47 1.54-.47h10.331c.546 0 1.081.164 1.54.47.458.307.821.743 1.045 1.257.224.514.299 1.083.216 1.64a2.966 2.966 0 0 1-.682 1.499l-5.102 5.919v6.465c0 .199-.076.39-.213.53a.716.716 0 0 1-.514.22Z", fill: "#30384C" }))); };

var SvgFilter = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M18.335 2.5H1.668l6.667 7.883v5.45l3.333 1.667v-7.117L18.335 2.5Z", fill: "#30384C" }))); };

var SvgHandsClapping = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#hands-clapping_svg__a)" },
        React.createElement("path", { d: "M15.295 6.072a2.582 2.582 0 0 0-3.526-.943 2.557 2.557 0 0 0-.524.395L10.075 3.5a2.582 2.582 0 0 0-3.527-.944c-.268.151-.506.35-.702.589a2.825 2.825 0 0 0-.774-.355 2.583 2.583 0 0 0-3.245 2.323 2.58 2.58 0 0 0 .34 1.459l.04.073c-.212.056-.415.14-.605.25a2.58 2.58 0 0 0-.944 3.523l3.39 5.87a7.425 7.425 0 0 0 10.142 2.718A7.42 7.42 0 0 0 16.909 8.87l-1.614-2.798Zm-2.074 11.257a5.498 5.498 0 0 1-7.496-2.008l-3.388-5.87a.637.637 0 0 1-.065-.484.67.67 0 0 1 .299-.395.654.654 0 0 1 .887.234l1.775 3.072.323.556a.968.968 0 1 0 1.67-.967l-3.389-5.87a.677.677 0 0 1-.064-.485.653.653 0 0 1 .306-.395.605.605 0 0 1 .485-.064.67.67 0 0 1 .395.298l.645 1.121 2.744 4.75a.969.969 0 0 0 1.678-.968l-.645-1.12-2.098-3.63a.645.645 0 0 1 1.113-.645l3.873 6.701a.969.969 0 0 0 1.678-.967l-.645-1.113-.807-1.395a.677.677 0 0 1-.064-.484.652.652 0 0 1 .794-.46.645.645 0 0 1 .392.299l1.613 2.798a5.489 5.489 0 0 1-2.009 7.491ZM11.123 2.258V.968a.967.967 0 0 1 1.937 0v1.29a.967.967 0 0 1-1.937 0Zm3.357.379.646-1.113a.969.969 0 0 1 1.678.968l-.646 1.113a.967.967 0 0 1-1.607.105.968.968 0 0 1-.071-1.073Zm4.801 3.04-1.113.645a.97.97 0 0 1-.969-1.677L18.313 4a.97.97 0 0 1 .968 1.677Z", fill: "#30384C" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "hands-clapping_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))); };

var SvgHourglass = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#hourglass_svg__a)" },
        React.createElement("path", { d: "M2.5 2.5V0h15v2.5a10.166 10.166 0 0 1-3.702 7.5 10.166 10.166 0 0 1 3.702 7.5A2.5 2.5 0 0 1 15 20H5a2.5 2.5 0 0 1-2.5-2.5A10.185 10.185 0 0 1 6.188 10 10.184 10.184 0 0 1 2.5 2.5Zm2.575.962c.468 2.972 2.994 5.02 4.458 5.975l.457.299.456-.3c1.47-.963 4.005-3.02 4.477-5.971l.155-.965H4.923l.152.962Z", fill: "#30384C" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "hourglass_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))); };

var SvgMapPin = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.002 19.015s7.251-4.835 7.251-10.475a7.252 7.252 0 1 0-14.503 0c0 5.64 7.252 10.475 7.252 10.475ZM12.416 8.54a2.417 2.417 0 1 1-4.834 0 2.417 2.417 0 0 1 4.834 0Z", fill: "#30384C" }))); };

var SvgMilitaryRank = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.025 4.05 1.05.45v5.114l9.029 3.623 8.924-3.625V.449l-8.977 3.602Z", fill: "#30384C" }),
    React.createElement("path", { d: "M10.025 12.39 1.05 8.79v5.114l9.029 3.623 8.924-3.626V8.79l-8.977 3.601Z", fill: "#30384C" }))); };

var SvgSave = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17 19H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2Z", fill: "#30384C" }),
    React.createElement("path", { d: "M15 19v-8H5v8M5 1v5h8", stroke: "#fff", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgSearch = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M9.167 15.833a6.667 6.667 0 1 0 0-13.333 6.667 6.667 0 0 0 0 13.333ZM17.5 17.5l-3.625-3.625", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgStar = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m10 3 2.163 4.608L17 8.35l-3.5 3.585.826 5.064L10 14.608 5.674 17l.826-5.064L3 8.35l4.837-.743L10 3Z", fill: "#30384C" }))); };

var SvgStore = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m15.3 7.5.5 2.5H4.2l.5-2.5h10.6Zm1.367-4.166H3.333v1.667h13.334V3.334Zm0 2.5H3.333L2.5 10.001v1.666h.833v5h8.334v-5H15v5h1.667v-5h.833v-1.666l-.833-4.167ZM5 15.001v-3.334h5v3.334H5Z", fill: "#30384C" }))); };

var SvgStorefront = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#storefront_svg__a)" },
        React.createElement("path", { d: "m18.25 7.408-.874-3.641A1.637 1.637 0 0 0 15.784 2.5H4.21c-.75 0-1.408.525-1.583 1.267L1.75 7.408c-.2.85-.017 1.717.516 2.4.067.092.159.159.234.242v5.783c0 .917.75 1.667 1.666 1.667h11.667c.917 0 1.667-.75 1.667-1.667V10.05c.075-.075.166-.15.233-.233a2.803 2.803 0 0 0 .517-2.409Zm-2.49-3.25.874 3.642c.083.35.008.7-.208.975a.978.978 0 0 1-.784.392c-.508 0-.95-.409-1.008-.95l-.483-4.05 1.608-.009Zm-4.926.009h1.633l.45 3.766a1.12 1.12 0 0 1-.275.892c-.183.217-.45.342-.791.342-.559 0-1.017-.492-1.017-1.092V4.167ZM7.076 7.933l.458-3.766h1.633v3.908c0 .6-.458 1.092-1.075 1.092-.283 0-.541-.125-.741-.342a1.184 1.184 0 0 1-.275-.892ZM3.367 7.8l.842-3.633h1.642l-.484 4.05c-.066.541-.5.95-1.008.95a.96.96 0 0 1-.775-.392 1.102 1.102 0 0 1-.217-.975Zm.8 8.033v-5.025c.067.009.125.025.192.025.725 0 1.383-.3 1.867-.791.5.5 1.166.791 1.925.791.725 0 1.375-.3 1.858-.775a2.731 2.731 0 0 0 1.908.775c.7 0 1.367-.291 1.867-.791a2.608 2.608 0 0 0 1.867.791c.066 0 .125-.016.191-.025v5.025H4.167Z", fill: "#30384C" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "storefront_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))); };

var ICONS_FILL = /*#__PURE__*/Object.freeze({
    __proto__: null,
    ArrowDropUpDown: SvgArrowDropUpDown,
    Brush: SvgBrush,
    Calculator: SvgCalculator,
    Chat: SvgChat,
    Clipboard: SvgClipboard,
    Clock: SvgClock,
    Comment: SvgComment,
    Crown: SvgCrown,
    Done: SvgDone,
    Fail: SvgFail,
    Filter: SvgFilter,
    Filter2: SvgFilter2,
    HandsClapping: SvgHandsClapping,
    Hourglass: SvgHourglass,
    MapPin: SvgMapPin,
    MilitaryRank: SvgMilitaryRank,
    Save: SvgSave,
    Search: SvgSearch,
    Star: SvgStar,
    Store: SvgStore,
    Storefront: SvgStorefront,
    Svg1St: Svg1St,
    Svg2St: Svg2St,
    Svg3St: Svg3St
});

var SvgChevronDown = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m5 7.5 5 5 5-5", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgCustomer = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M14.165 17.5v-1.667a3.333 3.333 0 0 0-3.333-3.333H4.165a3.333 3.333 0 0 0-3.333 3.333V17.5M7.501 9.167a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667ZM19.168 17.501v-1.667a3.334 3.334 0 0 0-2.5-3.225M13.332 2.61a3.333 3.333 0 0 1 0 6.458", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgEmail = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3.333 3.332h13.333c.917 0 1.667.75 1.667 1.667v10c0 .916-.75 1.666-1.667 1.666H3.333c-.917 0-1.667-.75-1.667-1.666v-10c0-.917.75-1.667 1.667-1.667Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m18.333 5-8.334 5.833L1.666 5", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m2 16 5.333-7L10 11l2.667-2L18 16", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgFeedback = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#feedback_svg__a)", stroke: "#30384C", strokeMiterlimit: 10 },
        React.createElement("path", { d: "M9.58 10.032h1.29c.852 0 .52.86 1.72.86h4.93c.417 0 .903-.42.903-.838l.602-3.613c.134-.809-.486-1.57-1.303-1.57h-1.26" }),
        React.createElement("path", { d: "M13.881 7.882c1.084-.525 1.72-1.148 1.72-2.318V4.87c0-.36.43-.855.43-1.72 0-.877-.34-1.342-.713-1.824-.374-.49-1.437-.4-1.437.073v.46c0 1.536-2.138 3.011-2.58 3.011H9.58" }),
        React.createElement("path", { d: "M11.58 5H9v5h2.58" }),
        React.createElement("path", { d: "M5 8H1.86a.863.863 0 0 0-.86.86v6.827c0 .473.387.86.86.86H9.462l2.237 2.409a.43.43 0 0 0 .774-.258v-2.151h.29c.474 0 .86-.387.86-.86V14M4 13h6", strokeLinecap: "round" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "feedback_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))); };

var SvgForms = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#forms_svg__a)", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" },
        React.createElement("path", { d: "M6 5h8M6 9h8M12 13h2M1.818 13V1.782c0-.32.251-.57.57-.57h15.265c.32 0 .57.25.57.57v15.265c0 .319-.25.57-.57.57H10" }),
        React.createElement("path", { d: "M5.999 13.516h1.97v1.96l-3.93 3.918-1.959-1.96L6 13.517Z" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "forms_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))); };

var SvgGrowth = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M8 17.11v-6.333h4v8M3.5 19.11v-4.333H8v4M16 18.666V7h-4v6.666", stroke: "#30384C", strokeMiterlimit: 10, strokeLinejoin: "round" }),
    React.createElement("path", { d: "M1 19h17", stroke: "#30384C", strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M15 2.5c-2.333.5-7.5 3-13 9.5", stroke: "#30384C", strokeLinecap: "round" }),
    React.createElement("path", { d: "m14.207 4.34.896-1.923-1.922-.896", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgHelp = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.001 18.335a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M7.574 7.499a2.5 2.5 0 0 1 4.859.833c0 1.667-2.5 2.5-2.5 2.5M10 14.168h.008", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgHome = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#home_svg__a)" },
        React.createElement("path", { d: "m18.517 8.83-.002-.002-7.343-7.343A1.646 1.646 0 0 0 10 1c-.443 0-.859.172-1.172.485l-7.34 7.34-.007.007a1.659 1.659 0 0 0 1.154 2.825h.293v5.404c0 1.069.87 1.939 1.94 1.939H7.74a.527.527 0 0 0 .528-.527v-4.237c0-.488.397-.885.885-.885h1.694c.488 0 .885.397.885.885v4.237c0 .29.236.527.528.527h2.873c1.07 0 1.94-.87 1.94-1.94v-5.403h.27c.443 0 .86-.172 1.173-.485a1.66 1.66 0 0 0 0-2.343Z", stroke: "#30384C" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "home_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))); };

var SvgInbox = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M18.335 11.668h-5l-1.667 2.5H8.335l-1.667-2.5h-5M7 5l3 3 3-3M10 8V1", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m4.543 5.926-2.875 5.741v5a1.667 1.667 0 0 0 1.667 1.667h13.333a1.667 1.667 0 0 0 1.667-1.667v-5L15.46 5.926", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgLogout = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M7.5 17.5H4.167A1.667 1.667 0 0 1 2.5 15.833V4.167A1.667 1.667 0 0 1 4.167 2.5H7.5M13.334 14.165 17.501 10l-4.167-4.167M17.5 10h-10", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgMicrosite = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10 18.335a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667ZM1.666 10h16.667", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M10 1.668a12.75 12.75 0 0 1 3.333 8.333 12.75 12.75 0 0 1-3.334 8.334A12.75 12.75 0 0 1 6.666 10a12.75 12.75 0 0 1 3.333-8.333v0Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgOffers = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m17.714 11.981.012.004c.215.055.409.184.55.37.142.185.221.416.224.657v.099a3.468 3.468 0 0 1-.96 2.401 3.188 3.188 0 0 1-2.29.988h-12a1.71 1.71 0 0 1-1.231-.53 1.878 1.878 0 0 1-.519-1.303v-1.655c.003-.24.082-.472.224-.658a1.01 1.01 0 0 1 .55-.37l.012-.003a1.998 1.998 0 0 0 1.062-.741c.264-.358.405-.794.405-1.24 0-.446-.141-.882-.405-1.24a1.999 1.999 0 0 0-1.062-.741l-.012-.003a1.011 1.011 0 0 1-.55-.37 1.108 1.108 0 0 1-.224-.659V5.333c0-.492.189-.96.519-1.303A1.71 1.71 0 0 1 3.25 3.5h12c.855.001 1.68.354 2.29.987.612.635.959 1.498.96 2.402v.098a1.108 1.108 0 0 1-.224.659 1.011 1.011 0 0 1-.55.37l-.012.003a1.999 1.999 0 0 0-1.062.741 2.093 2.093 0 0 0-.405 1.24c0 .446.141.882.405 1.24s.636.62 1.062.741Z", stroke: "#30384C" }),
    React.createElement("path", { d: "M7 4v2M7 14v2M7 8v4", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgReview = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#review_svg__a)", stroke: "#30384C", strokeMiterlimit: 10 },
        React.createElement("path", { d: "m13.708 11-.718-3.46L16 4.82l-4.152-.36L10 1 8.152 4.46 4 4.82l3.01 2.72L6.292 11", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M10.877 12.29h.822c.259 0 .665.164.822.41h.822c.386 0 .822.36.822.822h.822c.386 0 .822.36.822.822v4.11" }),
        React.createElement("path", { d: "M10.878 13V9.822A.822.822 0 0 0 10.056 9a.811.811 0 0 0-.823.809v6.28c0 .112-.14.164-.214.08-.295-.335-.949-1.08-1.43-1.415-.305-.212-.725-.229-1.063-.069-.477.225-.576.858-.223 1.25 1.062 1.177 1.438 2.757 2.52 3.752" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "review_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))); };

var SvgSales = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2 18v-7h3.2v7M8.4 18V2h3.2v16M14.8 18V6H18v12", stroke: "#30384C", strokeMiterlimit: 10, strokeLinejoin: "round" }))); };

var SvgSettings = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#settings_svg__a)", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" },
        React.createElement("path", { d: "M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" }),
        React.createElement("path", { d: "M16.165 12.499a1.374 1.374 0 0 0 .275 1.516l.05.05a1.667 1.667 0 1 1-2.358 2.359l-.05-.05a1.375 1.375 0 0 0-1.517-.275 1.375 1.375 0 0 0-.833 1.258v.142a1.667 1.667 0 0 1-3.333 0v-.075a1.375 1.375 0 0 0-.9-1.259 1.374 1.374 0 0 0-1.517.275l-.05.05a1.666 1.666 0 0 1-2.72-1.817c.084-.202.207-.386.362-.541l.05-.05a1.375 1.375 0 0 0 .275-1.517 1.375 1.375 0 0 0-1.259-.833H2.5a1.667 1.667 0 0 1 0-3.333h.075a1.375 1.375 0 0 0 1.258-.9 1.375 1.375 0 0 0-.275-1.517l-.05-.05a1.667 1.667 0 1 1 2.358-2.358l.05.05a1.375 1.375 0 0 0 1.517.275h.067a1.375 1.375 0 0 0 .833-1.259V2.5a1.667 1.667 0 0 1 3.333 0v.075a1.374 1.374 0 0 0 .834 1.258 1.375 1.375 0 0 0 1.516-.275l.05-.05a1.667 1.667 0 1 1 2.359 2.358l-.05.05a1.375 1.375 0 0 0-.275 1.517v.067a1.375 1.375 0 0 0 1.258.833h.142a1.667 1.667 0 0 1 0 3.333h-.075a1.374 1.374 0 0 0-1.259.834v0Z" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "settings_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))); };

var SvgSurvey = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11.287 7.237c0 .84-.659 1.522-1.47 1.522-.813 0-1.471-.682-1.471-1.522s.658-1.522 1.47-1.522c.813 0 1.47.681 1.47 1.522ZM12.562 9.086c0 .256.2.464.447.464a.456.456 0 0 0 .448-.464c0-.256-.2-.463-.448-.463a.456.456 0 0 0-.447.463ZM6.428 14.376c0 .475.372.86.83.86.46 0 .832-.386.832-.86 0-.475-.372-.86-.831-.86-.459 0-.831.385-.831.86Z", fill: "#30384C" }),
    React.createElement("path", { d: "M7.793 2.066c1.112-1.421 3.301-1.421 4.413 0l1.433 1.83c.328.419.773.735 1.282.91l2.223.767c1.726.594 2.403 2.63 1.364 4.102l-1.338 1.897a2.675 2.675 0 0 0-.49 1.475l-.058 2.303c-.045 1.788-1.816 3.046-3.57 2.535l-2.26-.657a2.839 2.839 0 0 0-1.585 0l-2.259.657c-1.754.51-3.525-.747-3.57-2.535l-.058-2.303a2.674 2.674 0 0 0-.49-1.475L1.492 9.675C.453 8.202 1.13 6.167 2.856 5.573l2.223-.766c.509-.176.954-.492 1.282-.912l1.433-1.83Z", stroke: "#30384C", strokeWidth: 1.5 }))); };

var SvgUser = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.001 18.335a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M15 16v-1c0-.53-.263-1.04-.732-1.414-.47-.375-1.105-.586-1.768-.586h-5c-.663 0-1.299.21-1.768.586C5.263 13.96 5 14.47 5 15v1M10 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z", stroke: "#30384C", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var ICONS_SIDEBAR = /*#__PURE__*/Object.freeze({
    __proto__: null,
    ChevronDown: SvgChevronDown,
    Customer: SvgCustomer,
    Email: SvgEmail,
    Feedback: SvgFeedback,
    Forms: SvgForms,
    Growth: SvgGrowth,
    Help: SvgHelp,
    Home: SvgHome,
    Inbox: SvgInbox,
    Logout: SvgLogout,
    Microsite: SvgMicrosite,
    Offers: SvgOffers,
    Review: SvgReview,
    Sales: SvgSales,
    Settings: SvgSettings,
    Survey: SvgSurvey,
    User: SvgUser
});

var SvgIcon$4 = function (props) { return (React.createElement("svg", __assign({ width: "3em", height: "3em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("rect", { width: "48", height: "48", fill: "url(#pattern0_7677_38530)" }),
    React.createElement("defs", null,
        React.createElement("pattern", { id: "pattern0_7677_38530", patternContentUnits: "objectBoundingBox", width: "1", height: "1" },
            React.createElement("use", { xlinkHref: "#image0_7677_38530", transform: "scale(0.00833333)" })),
        React.createElement("image", { id: "image0_7677_38530", width: "120", height: "120", xlinkHref: "data:image/png;base64,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" })))); };

var SvgIcon$3 = function (props) { return (React.createElement("svg", __assign({ width: "3em", height: "3em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("rect", { width: "48", height: "48", fill: "url(#pattern0_7677_38465)" }),
    React.createElement("defs", null,
        React.createElement("pattern", { id: "pattern0_7677_38465", patternContentUnits: "objectBoundingBox", width: "1", height: "1" },
            React.createElement("use", { xlinkHref: "#image0_7677_38465", transform: "scale(0.00833333)" })),
        React.createElement("image", { id: "image0_7677_38465", width: "120", height: "120", xlinkHref: "data:image/png;base64,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" })))); };

var SvgIcon$2 = function (props) { return (React.createElement("svg", __assign({ width: "3em", height: "3em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("rect", { width: "48", height: "48", fill: "url(#pattern0_7677_38466)" }),
    React.createElement("defs", null,
        React.createElement("pattern", { id: "pattern0_7677_38466", patternContentUnits: "objectBoundingBox", width: "1", height: "1" },
            React.createElement("use", { xlinkHref: "#image0_7677_38466", transform: "scale(0.00833333)" })),
        React.createElement("image", { id: "image0_7677_38466", width: "120", height: "120", xlinkHref: "data:image/png;base64,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" })))); };

var SvgIcon$1 = function (props) { return (React.createElement("svg", __assign({ width: "3em", height: "3em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("rect", { width: "48", height: "48", fill: "url(#pattern0_7677_38467)" }),
    React.createElement("defs", null,
        React.createElement("pattern", { id: "pattern0_7677_38467", patternContentUnits: "objectBoundingBox", width: "1", height: "1" },
            React.createElement("use", { xlinkHref: "#image0_7677_38467", transform: "scale(0.00833333)" })),
        React.createElement("image", { id: "image0_7677_38467", width: "120", height: "120", xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAYAAAA5ZDbSAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAB3RJTUUH5gMIFi4Ik6pe3AAAAAZiS0dEAP8A/wD/oL2nkwAAPGlJREFUeNrtvXe8JVd1Jvqtvavq5Js7d6tbrVZohVYAARIooIAQDOEZsJ+NAeN5hnF4wAx+DAYGC2yDwdgee3h+9mA8tnkWM2BAgIUQRkgIrAwSklDuVid1urf7phOr9t5r/qhdVbvqnHPvlZCEsHV+v/qdcM89Fb79rbxWEZ5//Kt8cPw0Rc9fin/VAD//eP7x/ONn+vFvQkS/4x3fBMA4e92dBGLc/cS5DAD//TOveh7g5/LjQ1f9GWbNGF1QvtXbEuz1x/35mhZyQgizrky9SQM5QmRGPRHVJEyJCB4AYoYyED1lvBazWBCsF7pcOmZYHPRMdHQ+bDQPRmuiB9TJUY3a/Fv/5ePPA/xsPD7+yT/C73R/G5+v/EZ5m9w5OSGPrQtkeKIv9SlC6K2+jI4LpFrjST1JgstCGkmSBQQEALJnS2AwAIaBYS2M0WTYUFdpMRtp73Co/X2sxeOR8R4Klf/wnBk5sFdvOvoNdXn7XHk3fu19f/o8wE/X45uffCNOKd2P3eHWyohsHj8uF06re60X+V50huep431frfd8UxMBx/z0BCAJkAAExa8JANlTZbanzYABYJJnAyiOt4hhIgEdUTuMvENaeY9HynugpSq3z6rGffu7Eztf/aZrW1df/Ua8+ap/fB7gJ/v4xFUfwn9pXoWrG2/xt9V2r6vK7otH5cKltaDzIq+kNnmBmRABCyoREFAMqk+AdMG1ACcbABDnfYgUYI4/05yBrBhQBggNEAK6B9ahmIt63hOtsHxXU9VubOvKLTt7W/d+pPnb4dsrn8e7fvdPngd4qccH/uCP8bHmf8I3R187crzce2rda72q6rdfUSv3tsuyrosyCZREDGpgQfUcgAUAyQ7AHJ+hSM6UMi+RGTAUA2vspgFoss8AIpMyGpEFu8swPWbdEe12t/RoS9X+uRWVrzscTf7oVvWS2U1iP//ih/7heYCLj52fPAmHeN3YKjHz0jFv4bWVoHdJpdzbKqssUBGIgbXg+gT4IgbXZ8BjQBrL4BLglQBZB0QNoAogygAFAHn2lDXAEWB6gOkApgXoJqA7gOoBSsUAKwK0sAA7QPcY6BmgY2A64E4n2NcNg+/OqrGvPR6t/+6ZpV3Ta96763mA//6jb8Nbzv473HjvZY313qHzJry5NzfKrUv9ilorq5CoCKAsLWPt5iMD1fcAvw74q4BgE+DZTa4HxDhADYBqAMoAJEDCYbABEALcBtAEzBygpwG9Hwj3AWofEB4Awlkg6sXgKgIiAkLEbC4AHXbk9EK39r1j0dg/LESNG1908W1z19/wSrzyd7/5bw/g637/SjBTebO3Z8eY33z7eGn+NaWqWi+qIFQoBrZMlrkWVJ8BvwSUVwOlbUDpNCA4FZCbATEFUB0gPz4tLgbsaIlAnjXEYCzwXQv4QSB6FAjvB7oPAp19QLgQgxsREIkY4B4DXQ10GNxhDlvezHy3fv0xNfY3P2ptvkMQt37+o9f92wD42x+7DP8sLqPX62s2b/QO/uJIsPjLtVpvu6yBUBVAiYCyfS4R4GsgkEBlNVA5Fai+EAh2xEylUQCexcwUwCLnFGmJaK3Vx8SFRUGO5d0GzDQQPgR0fwi07gE6u4BuGwhFzOgeW6A5ZnSLudUqPT7bqf3Pg2bd5/7Fu/zhHeZOvvx3/vlfL8Df/+jLoCH9KTl9yepg5t2jldaFXt3UqCYRs5YyYAMNlAKgejxQPx+ong8E2yyo0gJqHACX2pZ68BKbsc+UiXfuAvow0P0BsPg9oHkP0J4FQorB7gHomnhrGkQt6i62q3cdiqb+7EC05huXBd9t0zQDf/LsXHr5bOzk//vAG3HtwR/jTds/s+GE0v7fWF858nsjI+0XeCMUUEMCNQKqIga5pIFqAIxuByZ/Hhh/K1B9eaxX4QFQACLn4nNB5BZfmxWAuNym7T5V/LOiAZROAmovAqqnAJ4EMAugFV9Raf1vD5AevLLsHlfn1sVV0x5/SJ2066bgnNm/u2QPPn/jzp99Bn/6I+/AN6Ir8fHSh14w5c28b7K68KpSw9RRk0DViuMyAQHH+raxDRi7DKhfAHjrrT51xG/i8xDl30P0fydhX05cF8Tzkix2FgcPWigEkAR4EejcB8x9C5i7HWgvAJFMxTU6DLQ0okXRnevUbjoQrf3Yj3D2LWXq6l/44Bd/RgH+Pcb3+MWY4algm9h1xcbg0Ica9c65sk6xrq0SYvcHsTiurQImLgXGXgn4m2KQeJgIFtlrEsuI5qXEdFECFMDlBGQ4bB6wEIhiYWgWgdYdwMw/AfP3A90I6MkM5LaBaTIvNsv3H+5NfXKn2fLl8/iW9htL1+KG37nkGYHBe6bw3cNr8SOcVd8h7nvLVGnu/2k0esdTXWSiuCJicVz2gfFzgcnXAdUdAHyAwwGAYjAzk9AjLQcuPTmAU8auAGC2i4E8oHEBUDoZqH0LmL4OoCPxIpQECAEhDY2K9hn+4oE/8nu9Tf9iLvirz0ZvPrblZ4nB1330EhimiVPEI/9hbXnm3dWGWo2GzMAtW11bWwWsugIYvwLwJgFWA0SxcA5T9DN40HsqAMw05EyLQGEAiGZp0Z0uBpP9JkmANdD8EXDkK8DsvbE71SUrrg3Q0ugsyIXD3YnP7DZb/pjABy/+8K3PbSPrE3/wXnz2osdwmNZObRcP/fba8sx7qqNmEnUJ1KxYLjNQNsDYycC6XwbGXg7ICsC9IWxxXpMZcJGxvP7sM6Z04dkMeV/8zMYw2Xk98H9UvM9gHVDZHq+/aF98jkLEC5AIvtClsumeXdKdsTk9cvcnLmktnnPRlfjSTQ89NwH+q4v24Mc4feo0euD96yozv1EZMSNIrOSKAEoGKHvA5HnA2rcC1ZMASizUIjBmaeOHeMAiMEMWx3IWsl76b6wLi6L4etCm4nCoqFpLexSI9gNmwYIcCxePjF/WnR0l3Vv9iNl611l07+Kf3tR+7gH8jY++HDO0emI7PfTedeWZ3yyPcB11y9qqAEoMVMrA6suAVT8HBJNxqJC0BYsHAMSDmVwEIgGbjcNyM+Q39RAWDwJIL7MQ9PCFk7Cco/gClY4DSmuB6BCgjmVqhAgesSyZ7mmB6o3s5BN+8PaLNzT/9qYnniMAf4Fx2ylfxDEerW3HQ7+1vjzznsoIN1AXlrkUg1utAqtfDUy9EvDKAEUxGDSEtcRDDBu9POAp8NoBvQAILwfwUgwt/tYSgLPJJIC/BihvBNQhQM24aa4YZN07Taqev4+Ou+uDF+pO5TW/j1u/dd1PF+Afnv4F3OW/1H8J3/729aXp99caejLWt0ngwgDVBrDm1cD4xVY8WXCFe/GLzOB+hg4U38Xv6wEMHgbScmJ2me9zgfHp91T27ALMCvDGYzarGSA84ngFgAfjl3Tv9IpajB6g0+66rPe16C++O//TA/jd73wj3rf7NfSfx7905abSkd+v16KNVHes5RID1Tqw+lXA2PnW24liYGHBpaX05zDWWtDZsrSP0XplYnQlALO2ksAFcQk2Fz9jnYHMGjARIBtAaQOgpoFoOrbyLZN9NqVA9U73dO/AbcHFP/7FS080X/rOA88+wJ/61Ifwf0d/iVesO3jOFm//J8drndNFAm6ic8ulWOeOvcRKIxUDI6wIpmLAgJfRn0sZTpwtmqFWs1nCmh5mIbsMXW5hDBDZiSpgR1yzAkQ9trLDA0A06yQ2AJ91zYuikypq4ceXh9/bfcKlb8BXbnrw2QP4jz/+Hryu/fd4pLxj/Tax5/dWVRcvlw1hI1QydoVKHjD1UmDiZXEiPgGX2IpmHsJgPdiA6iu94BW6N/pJbmoZPTxITBeNsMJvuAxmEwNsVFyU4E8B4ROAWrTRu7g6MDDRKhmFG+8022+73Nx4dNNFb8S1Nz/w7AD80Zcu4D5zRnAKPfiba0qzv1qqIcj8XMSBjLEzgYmLAC9wwDWOeC4yjocwlQvsXM46Xo65PGQBmAJTBwCbqAReTk8PEtH2+HMiWwFyJAa6ty+uKLGiWoDgqWiT0Bp30LnfP50fCP/y5rlnAeCvMz5z028hnMKlm+ShjzZqaorSxAEBgQFGjgcmLwGCRsGg4jywiUhO9ehSQA8zwrTDcr28CF8Rw80AI8oMYPgwgFWe3cb+3ehMfLOJWQwdG15EQHdfXN1pmewZIz0VnmgMdr2l/o/3v+PSNbj5hpuf2VDlDb/7YgA47iR++C/X1hav9EYFUn+3zEB9HFh7JVA7zoJqU2dphWPs+6XOvnDCi1SMGw/KEA2KNRcTCqIQslwqHcxLxKSHvR4UhHGyU0lsOinNZS5UcNpnbQ1FI4AoBI7cCBz9URzSbMf5ZLOocWSxdvtjfMK/r+rmj19xxqM4+n/SM8Pgb1x1MR7xzgjOVHe9Y3Uw99Zynf3YYrZZoXIJmHgRUD8BEHb1uvoWBRajaE3rAaFJU/BllzOceIV+rRpiCauV6e+cdT0k9GmsKDaO8cbO/6cMV/Gi9EaBcAaI5mPL2p621GoNRyq6V55xy9um/zz83HefePoB/sJHXoXXtP8ZQPMF6+T0h0dr4XrhVmL4AEa2AWNn2WJzRwyLJODAebBRCELQSvXngIDGsuLXrMCAKkax9JCIl1p6EbG2otYJqOSMLJPXz0bHIFMprv7sHgB0mJb1SsOSI73RU+GPXta+/7GzLrsY/+vm3U9vunCbfgRf9C6unUMPvH0k6GyXpaQuWcTLpDwOjGyPRS+HmW/HFB+oKL5PpBrlRTINS/UVRbFwxOwA0U1FDbREXRYPKgAwBbFMQz4v1HaxKUjv5L1TYM+OqM6JfQKq64DGiUDvXltkSBAlgUbQ2zSm5n7tm7Xz7jxBP3L0ac8Hn+0/hvkunT/uL7w2KIGywnPEJSv1bYA/ZrNCBLDIg8ywwAoneGPBJsRpQdKZjnYBXJHeLXzGywHMQ94P0KkDQS18P/2Ync3qXXchuX+D8z4tMBCximvuj8W1L4DAwCsTxsPFS1ap6Vec4R34/NMqov/2vRfg7u7xI2eU9r5/otx8qV8TRElJq89AfTUwdjogZSaWqRB0IEevur4t64Kvq5cPVqRWt15CfPMygYllUoKDdO5Q1yrxbR3dm1jNfdEsVzdb8czastq6TuTHf+seiZ81x46I0mUT6coteOF33nzRcc2rb977kwP8pU/8PLYf/Q7qJbpkQzDz7lpNj3hppwEBpVJcIFeezGeG0mcnGU4DdO2wUCWtMBSYPNMKgVrpxgPcntzvcj76lehVUzCgchGsASAX/27sJspAOA+ETcAQyDbJmUhPGm0eufDAffee8cbX4QvfefgnE9EjzT14eOryxgvUba+r+NEG4YusalACqEzF4Lp6F2Qxta+FFcVA9lo4301UnHBErCm8H1h643zGS5XJLlWTtRIxzYO/n7hDOfHsPLtiOXGREneJYcF0XKlUZxtAeEB1A9A+CoQ9wCMIn1Dx1cSoWnj919dd8K3J9p4jPxGDv/x7r8YLF28EiM+ZFLPvrVeiCa9CSLv6SgEwshUoj1r9WWAuFWLOVKjKyAU4CtY0u58hbykTrzxluOTf9DIFAAW2UiHWnFjA7LpDXEgTKguiy2b3/wZ8nv6OD/QWgKjpNMUxVMSTYU/feUHw8KMnnHsBvnLL3qfG4PHeAXyl9hb/ZeqGV1a97lbhE0iKOLYsAASjQDASJ7UZscNOTgEcWwuXRcZKskYVJ6zThe8jTYQnBhgbA9YKbAyIBCA9kOfFr+F8f1kGO10LA+fQcGb45GIhBqwisIoAZpDwQJ4PIipYxEUjvGhwGafSyLWiiwaYtcaFACqrgNZRQCpbay1Q9cI140HvNV/mV9y4rbS/85RF9LrocWjJa6toXeF7LMhtrpZeXJVBAjBh/MzJhkwMJ6/JukYmEdvJgnADVuQUvwkwA7oXImo2MX9kHgtHO5BSYHxdA7WpMfj1GoTvDXGVlgvcDRLP1GclaxUhWmxj8dAcZg/Nw2iDsVV1jK4ZR1CvQfpeISqWgEVZEV9OdBdENlPefUqqORPx7zeAoA705kAeQXgEzwdqYfPlq/jwCVuih+9/ygCfzHM4hs5LqqJ9qvABSAIlvbdeJd65sa4NWzGUVEEKxGAbjoGmAtiJjiXKu5qU+ba6F6J5ZBYP3H4At313BgcPdCGlwImn1HDe5Wtx/JkbUBpvQHhewT/mJYClgk4tsjn7m4kUusfmsevug7jt2wfx+KMtKM1Yv7GMF71sFU590XrU147DC4IBrlLCZJ3ZJIb7fWOmLJSpEzHNmVgXHhCMAXIRkBrwCOQRKrK7uaqbF63/LXX/X438Kt75of/x5AD+8lVX4IuQpVO7P7ik5Js6eQKUGFckYtEspBXPIjvYJFieyGSBzOASIu+jpoA77LXgGqXRnpnHrdfvxXXXHMTsTAQp4908sbeDPXs6eMNbge3nb4TfqMeqA+T4rFQAcdmgdO6ZtUbUbOLhO57AVz+3G7t3dtIYzMEnenh8ZxtXLkY4/5VAfWoMInduJg01pmAmfzTFoAcy8GGc/zHZ//oNQAYAdUEyBtiXpjwSzl761c9edjWBZ580g2tqHgCOr1HrXOmxIJssYCKQ9AGv5hgT0q7gJKhhstcJU4114qWri604J850twCYGarTxYN3TeOGa4+gvRhhakLA8+Jr0wsZ+3e1cf1X9mNqQxXrTvJApSA/i6NP5w4DlQpfjy+8CXs4sucYvv21/XhiTwejI4TAj78bKaC5oHDjdYexdn0Np5/vg8qVWCcbzlptXHaiEPxw/+bqaXbiA8nnwgP8KiB6tluGQB5QFt0zRvXRkwHcNgxHMTDu/Ac/h/XdRzGqZ07zSW2mZKBJcgFlCRBBHD9N0l6Jk87Oc+oTOp8n/5O+1s7/xr/DKsT89AJu++4hLM71MDkmMDZC6TY+Gr9//KFF3HvbDFS3C9b2d7T9XRNlv8lRYQvts/2eiez/2P1rBdXu4r7bprHnkSZGGwJjDYFxu+/xUcLkmMDcTA93fO8IWrNtGztWzrk75wjlWMdOKjH9fuF6mULOmAB4VXBSUy0IJAk+qbUNdfSsix64B1/+yJUrB7gazeI7q94a1MzCuZ5QE7l0H1GsfwnOQdoL64KdA9zZ3EBAcmHhLBATAVGEPQ/NY89jTTTqwEiDMFInjNptpE4YbQj4wuDBu49h/sgiSPecBWN/T9vNDNi0sn9TfRvpHuaOLOLBu2fhC073Hx8D0mOoVwm7Hl7Egd0LYB1l++dkRIQDnNEDrk3iFjlgsnII41wvWQKkD7ZSFJIgpa5X0H7x/9rxutGamnsyAM9hW/OuKR/hDil0PGVKAEwEFjJmLxeyIX0rr8heZ9NR4UI4GRijEHVD7H6sCd3TGKkJ1CqEWgWolgnVCqFWBmoVQr1GOHa4i5mDrdiS11G8GZfFkcNSh60pe3X++zoEdIjpJ9o4dqgb7y/Zf4XiY7D7b9QI3ZbCvp1NmEgNYKW74KJCFkn3s9c4C5ILKUYSgPCRYAEBSGngQZ0y2d2zqh4dw5+855XL6+Crf/dVmGzfhQUxvsaD3koSdtUkVq7Mem8SPy4xsgxnFrJrmZLjB6f2F2XRq0T3SQkQo90KceRgB4Efp5jLAaHkx39mq1OVZlTKhGZH4eihLthokHASG0nXHw+LVpHjXuWtaDYGxw53oUKNekWgFAClgOD79pAFwRhGGBEWWxoHD3QQ9iJ4gfUakOnyzHp2XCdGIbI1xA9O3SWr04UPRoJFLFE9RFsqam7zuXr3YzvLG5dncNW0sePqIwi4e6JH4XpX9zIRWHpWPDuRFxSiMGnw3bJSF1ls+kUQm3iVQ6HbjtBeiFAKgMCPZ61IGRvhUsTJK99DbPQwo7kQwuSkhXFSd8UoUvFiaue78bEYo9Cc74GMye1fivgY4v0TgiA+hsW5EL2eq1udRIIpxptdFVX43AxSZ1ldNQvPHkSGiU/RlE/q9F+q/YVocGt5Bld0E//tnf/BP7/59e2SVD1N3zkMZmZQehFF5tsm/l5SkpO4BchWXBrdInuhhfu32PpW2sAYA88B1q3oiYEmSMkQxNCKHctTZ761U4oaE5bznw/KCROBiaG1ScGUgtJjgHN6yWJjwzBJBil5GC6kj13LmfN/Z5flTiDEcZfYmJhgCSdtgFCS9sioEy9rXRMEYrG7LMAl08am7oO+hD5eEBNbcOMftwo+1SMyu7BGZBPlkhNxL2Qu+eBGBjmfF5YE6RE8jyCIUrvO9WaSXD4RICUhKItYC7jszCXyKS82uRi9zAMuBCEoSQhJ6cIqOlqpVydihgvBA9wdp4fZJOfphDbZ8Y37igFcKZSwOFZ3aZSX4sqZilRbT/SPlOumuTzANTUH7XlVj8PNqWhOr4OwSRTlxPutf0sJm+HoYYe1yYmmOhIZi+EwjoFqXaJW87A4zfGiWiLoKD1CbcSLL7Ayw31dHva+v2pDCIGRiQCeRysqVSxXPZRKwjEUB/x0wmpTWIhubNoUqz6ytCKzAiNmcba6YhJJDjeSwHi9d3RuWR1cjzvfxiVHa9LjyxGT4+B7n1HATvrL5A8wTXC7n7nfd1a9NqjWJUangoyMhTkr7vkHJYnRVYFdYKrgqhT0X5Klca3WnF1gk/aCMb62hKDiwWjuG/OCwsSlyTUBSlUxQMwa53WxZNZkQ1DT/LDD2uQ9CuLakYpsS5Mkh6vJhOsbqrm8kVVTXQgTrRUcTTrNbxZkylJnxQIy94Dcg8yBmRhdOvucnQ55ZkBr+CXC2q01QFDmJhaumzYMpRhjq8uY3FB1FpKzn3TT/X9zQTdO+s4e28TGMkZXBYgUQ2vOrr1zDEoD0hNYd0IV0kf8v2m6UDuLXBUWve4/rqL+RbYjtouCWccEcxccAcS6JlmtqYcr8IMDDUjdnQKbavZD5KivZGcOi90CMhfk9L12woBuKM4Ukt/xCRMbnHBGHaNTJXR7MZDauT5aA5FiKA2ccNYoJtcEQKjiOmPDBT231Oa6LMgWYqgwMeVj645xRApQdl+JANAG0IrR7RpMrq9iy/ZG/GEfWE7yADz478UJPi7LndXEKYM5V+NgCCA2EsDE+EoAnogAAzFCrEUCLrvpMBOvpJy+SRlbYG7qpnCe8TlWJ8AmI30N0FNYu7GC086bgtJAt8eIIkYUAWEEhCGj3TKYWF/D6Reugu8h1r+5eieVZ3LRaMm5MTrPJmXgCWDHRaswsaGOVtsgjBihsvuPGO0uw5DEmRetxsTqUrzA0n1xPsnvilnjzvQoGGWuRHMWQXK92X5eTFoBkEKH44OMlT6A/RAg4hFkXUSFohXnQIorDTzY5E8+04VUWJ8xYb+vNHw2eMEr1mDrOavQajGaiwatlkGrpbGwoBE0Kjjv547D+s1loBsWGIl8fpULorqvusLN2VoDrBth3eYyznvDcfCrJSzMK7TbBu2OQXPRoN1mnHL+Gpz58lUQURTL68TP1onIdwMdA+yOXPFdoeTWXkO2i4GteolFNIE5Hlxv9bAQJhr5T6f+Nb724Zcvk01iQBpVRWyj2Z0klnS2U2YDSi9gsSLDsZaJ8xaKQWr9ZSOQRHYBEqu7E2JyrILLf2Urbl9dxa67jqDXiSADDxu2jeCsK9bipLNrEJ1OnN6B4zvlSmd5mQKAgguVHKQyEJ0udlwwDi84CT/4+n7MHWjCKIZf83H25Wtw3r9bh0aggMXIcfc4K39NVE9fxa0TYUuzbqbfzUtB5lQtJj8SG7vpTwsyun7hwtXS455eNl1IrEuczV/N3FVwpnfBFmSZP2guXuQsgJCzDNJgB9IKjqw22O54sYupkSou/aXNOO3CtViYCVGueli9uYLREQNqNuNhY+nUOc4X8S05I2tAHpgLgY9OCJ8ZZ5w3hg0nj+PQrjairsbY2hLWHxegFHWBxY7tMXLP1wGXiz6/WzhCeV+9WAQAV0wnP8+OaE5YDALrsq+aQkAtA3CsU5O7k+TdEy40bTESIZGdoHuwwyoh3XryJECRTItjZwCoMsB8G+WKwpbjSsDWuk0Id4FjdnB3uouCj913UsuAXGR7cpHbEUS4iKlqCVPnVOPjVBHQbMaqwWVeOtqwkGtOEaH+aqEkJz6gZiyVmm4hAiOzpN1SMGZJrCgXTRsmotmC6yrzWG0wpLOCaFBpDBfYCec1FabTuQVuZFnMMquqZIt+uwd0elmkzLjJBOSH37mf99cBDS7CS3/DrQlzjjVU8Sba2f4T0WvcnUtHf6I/wZBKOc6rNVelwTkGLhbkJSqzv1p3mJzqB1gBDFKp6GfKe0GO6GBnL30sdtnUV/rkBHVNJp3jRjWBrOzDZIV8ZLLwXzF2yYVTY8p0Pw2pnsypBxpUtdMvfbTbblpcRNIRywUQ+0quqV+tFSSjW1ed2l3GWBFNxZGazCCtyesDeaCINiR7JgU4O4BYHeTDacSF3hyiTA8n8eikcpAcfdzHnGT/xmZLJLJJs+zIcnakAueD00WQlyrJGpZF7DO6yDk+k0X5U59VFOLNyIdm3YpPY/oXPlOhUI9SUFMr2k06pLZQoayLZE/JmhHcXdpN0gQY8tqcGc35jJsbqkwDH+7BUZ4Zrnhyw2K55rTCCaci0NbU5hghnP3J7HcGjY5eqvuQh4CcE6dUaBITeTELkS1e4zabWdGdZNqY+heQK5J5QNLDCSRxkk1K8aB81tPAMGTrYO00rWV5aQZzA2hHtGAY2o1b5Gq42YCNBrO0ypptCpHz7Shpmyg7N8Qo6EbDWTGkcFZzWqhH+ZtaMeVvrpETyQVmuwkNGmRUFXSvy9bcKGFRKFZ3mecU2Bl7njzA4GPTDy4XF5plrzGO9WxscIkzcA2DDaX62DCMlt78r//w00z/uIyIPkyAAC8YFoaNyiYOGMAYTncQO912lRkGkcn0kFsl4WSJUtGGAaC7Ij6nVwvZppxfLYY0KhTcNFqC2X3M4ryASw2vBEiRj0Al4DMycE1hESfgFnRrVm7MBUnFuWqONIKVxmU4zkFz/NoY0sovzTVpBZGsWQN4QemoZtHJ7IVs9bg2RL5DLtEXRcOF8ukod9aGccRcTpRL5+KLAaKzYD66MzyYhnSkOGqBB32vYD1D5AFI/9/pSHCPrQ9A4TC/6GWgICmyz1O9aHSaXIAT+ItJBgdcQMfzMo4dKa3Aiu74PrTwD2n4x4yOVuUzWfGJMVMaXYHRYNI24MF5fZxaq4617LKbkEWvEsBFgYWJoUYOqKkVzZmLQe565RV0E1LevE8XH/cHJopgFPUmF/xdFs4CxgBQC/lxUMHYyeLOcTUHF7KPlE+IsWwbkodbwQoY3AkmAK2PafIPMyfiADCaC3F7ssx2A+LGYbG7ggsXxTWMclUVIkte5Bg/yKUpAFFcXDlDadA26HvIR5EGXq5iRE44iRjOztsUpEdqkGGAIUpZmwvr9Foi1b+ZB8MOc5NwtiJ/2gj/iXZQWR7gsDSOXmmspUWwVzugmkL2i60eyJnxad5TOzFqkb+Ipghy0Yq0lmduUpHIWIEhopYLoA8d+eBOiReONe+kM3Oi1hHXcMKqLAerlsQdAgYsMvc9542zVCS76VhrXLmJOcNp6jqxizQFT7DBbDeYWl5EK7+OhbHt0Vjr8V1aUz4nbVcOO7o576MZEGuwIdtaKQcH/HlIo1hShNdn8FDmTw8UtQVrlQYEP/pULi+hg4utLFywpinfMQhHZSSWvyuuCz5uH9AJaw2DTAKyBhsTA1osjmG2QMd5ck3BrlZlfUcQA9i3NIN7fg2//L7PRJrkwxpey2i29dgOmx2gjWbro+VLTzgpKHeD7wPFo9NyioIxhaLf6YptR8ybgq89SDoY67al0qEo0t3fLKgTiMzwS6zinBVdKKxLf0MMMAwLxqPR9lq5Od/EauaUWJwwV+fT6NoIbYR8dN+W10UqaCwvopVfw/d/fQKaSg9rDg7EuXB2sOP8ajKwvpozWyo9SOUUoYl8c7QZpiNFIV7t6LR0VRWAHgh2QUQWJ+Wx6A+SFNVC8bfTiwDHHy/Er3kJ0WwcC9ug0MGQqTY3sJFda3LS2gnYDI1gpqvlfW+++df14V5peYDf+OFvoNXYhG551SFN3uNacV8dt9GJ0WXjpE71AjsHzbleJed+vTzA4c8ZG25jtOuSyHz7pbtQUj0ph+g8DLn4lF8ELpPd8YPGWViulcxc+A3qz4+7UStDThFe3qBip04sJhLnYhCpWLYSVSuGgr9HByN77p3YhkXtr6w3qReMYnbitKOa/B9rI9jYH0tATS3rggvFRucs6jQqk64KHgxu8aLnfN+iESYd0cf5EiAu+rwyY6opbDxoc2u0TEGMJ0kQMfhmLkWQzYA4s1vdYXUsHHczA9f0FVsWe+dYA9oQNLyHO42NR7rlCbz7T7+1MoCj8ihOeuTvu5Ffv0OzN6t1XFmYb9ZjJOI7I7ApdNMVRgmlcWsq5LuQuyBGGehQQ/c0jHLmWhhTyN6IvEgvlqr21TdxYZzCkFLVXPBBZNZxagtk6sBEBrqnoHsKrDnT81xcCM5Ih1yVZyzl2KqzTAU6z7p/05qhjdeOROWON1x13VyvNLryKTtf+M4j+D9ecQ6UV+VSb+YyD2qt8OKeVCEJwvanCkEgkVT/x5azsMXylLYfxABQ2vchbEiPnK7+/M2rolDj8P4mWnNdBAIQUtgO+kJyIglukKuPh83hWCob4d5ZTTohSvT74Em2xwC6q9E62sGuxxbQ6zJGRgKQEIUxDYW4derbmv7+6VQ0Z9WjWnHc6RoxVMRQkYEKAR0aKO3va1U3/OXOl67Z+9qP3frkOvyndQ0GcleVqneVdXeHUUwmEdMJc3Xc5mFEXCFAhkDEEKQtXnY1yzgwEtcAJS0YMj91h0w6uEVIgXt+3MID98/j5S8ZwUmnNFAdr8Ir+WkWMUsyDEobUn+walh/xMA0YcENc+deWSMnavUwd7iNW++cw813NvH6123AcdukYww6LTmMXEMZp0NLVRrThzFgnTdgE1XIOq9/Ewx6KP14Tow9uFTd2dA5Wdfcshv/dePjanp8Qy2IFq4Q0pSEtIx12StgWRx/lvXtkJOXj9lK7kXsu3toRktRCRAKH9ffMIP77l8EKYV6YOALgETM5nSEUm7oGA2bp9KfiBh0V1rm/uiSfc9MMIqhOiGa0y3sengO1990DN+8eRFrNo3gytcfh3pFAJGb5kx+QxWqN4uN8BqsNQxbdZe4poqhI06fVcTQof0spF4rWPOZ14prb1w9803ceffOJwcwALzpggY6ldVNXzUv9UxvPUmRSlhKOu6ESMdtkAUtJWX6IgOP+jr7CvcntFmZiY0jKNXLuOfuWTz4WAtHpkPoTogAGp4AiITdChUehOG3FeZCL05fKRT1VaWwIZjIQLVCtKab2PvYHG65bRbf+t487nukiw3Hj+Atv34Kjt9UATph1pOV+tr5VlEeAC60zrtErp6NGCoR0SFDhQa6xwh1ZW+nsu6T7zr2/kPv+JudT57BAPCmS07B/Mi2drVzeJOv2y8jASKZZ7D7DIo7AhOECQwizl18SgHlPKPI0XsGEEJg40njKNdK2PXIHPbu72D3/hBPHOii1wrhsYKXNqEnEkIscRfSYR1khe9bUFkxdE8hWuyhOdPE3kfncOvts7jh1gXc/WAHs/MKJ5wyjl9656k47eQGaLEbFwkaJ0LljmpgYw0pVdC5xjHaKQ4oWTGsFazeddgbMkzI6PrjX15obP4H9krR5249+tQAfsMVZ+OkB7+uF0fWhZ7qXOIhHCMZs5BEYUtbPe3fU8baqkuHueQG7tPBpZQP5isDTwKbT5nA2FQNR55oYnauh+lZjZ17e9i9r4NjM12EzS5MNwR6Cqw0WGlruA8o0y0AmUS1WDFMZGC6ClG7h+58GwvTLRzeO4+HH5zDbXfO4cY7FvCjR7uYW1SQnsCZL1qDn/+/TsMpJ9ZBsy0g1I6E0IVhLKYw3iHrpEj9W9tvFQcArceSgKtiYFXI0KFBZIKZtjfxqVd9+u777rnoTHzh5seXrPxe8vFP//mF6AUTY6uO3vUnVZ57u1cheGUBryTg280LBHxfQPoC0ov7e6VledKsDSHjjTwQyXg0EEk4Mj8bD0HZNBlUAuh6FT9+aB43fG0XHrtvGr2eBiP+/UZNYM2Eh/WrfKxZ5WNq3MfoSIBq3UOp7CEoeRC+TCVMFrLm2B2LNKKeQrejsLAYYW4+wszREIemIxycUZiZV2h34+pjjxij4xWcc+FxuPhVx2HtiADmW0BPFdwuVWiV0Zkr5Ew+SF0gtoELzdDKQEUGWjGinkEUGqieQdg1UF0D0zFoY/TrMyPb3+mr5sFXf+reJfFbdtpst7oGmx+/dm5ubNvXSt3WlUKFa01EMJKhJUNIhhAMLRgkOJ3rTcgzViTjdYXTK0smHiyS1uy4VpGMqxjbIaRhnL59BGs3nok7v38Ad9y4B0cPLEIpxmLLYKEZ4tF9IQKPUC0RGlWB0brEiN3qVYFKieB5sc5mZvRCRquj0WzF29yiwVxTo9lhdEMDZZJ5HAxfAuWKxNbtq3D+K7bg1B2TqOgQmG3FXRWp4WScUC33jY4iVmCbcUt9XO6PUhkdi+bYRYpZzCrelPHmw6Dx1df94S0Hv/SRVwFYGuAV3b7jmqsuB4CJiSM/+Isaz/2CKBO8koiZHAgElsVekDBYwPMEpIytbHcEQizSPctmOzmGPIfBNJjNngQaZahqBXv3d3DPrU/g4R8cwvTBRYQ9bbOTZNmQhYwJ8RgIz+7bLd5UJs7GJBoknbNKsO4eUKkH2HD8OHacvxE7zl2L8QqBFltxrbZ25o1g0PRYt1/ZBjS0o3Pt/o1mKG0cQGPWRqFB1Itfq56B7hp0TP2GY2Onvx3E+4b5vivWwcnjf960Cx/dtKtzqL6xW1LNyyTpGkReFydd58LqYDguEjnNymRdG8pNpTOF5cb9t7vRDPQURKQwPlHGCaevwgk71mL1xhGUAgmtNaAUBHM8oCUASn48nU5Kyt8M3K4h3yeUg/gu8yU//j/fA6o1D6s3NLD9hRtwwatPwgWvPAHbTx5FNeyBZheBbq+/0RzFUcFR3lI2OmVsnFPPIlXaydillrMNaugofs+hgVJysVVe98lbzvvUd8eaj+NLN9y/LHYrvgHPt9+1BfPVjSOTCw//ed0cfZssE2RJQDp62AsIfiBTFksJSCkgJFkWE0hwPHtD2KiWy+Yca2VmXZONUiWvhQTKAVArw5RLaIXA9OEO9u08hv275jBzYAELx1rotkNEPROHVd32EOujC0F2xoePaiPA6GQNk+tHsPGEcWzcMorJyQoqQoPaHaDVBcLQsrXQWYlBU3SMM9zN2L5iLvSBmzQEbJRBFDFUpKEjq397BrpnoMNY9zZp7Nr5xgm/Wlvce+SSvzi8ItxWfFOO2fHtOOuH1y3s3HbyXwed9vnlqHOikfGNJmPda6xPHBdfEbENRiRtUnFFJOmkb5FAZEBsB4QJGX/OxoLslKCSycYVE8UXsBUB7R6EL9Eol9BYU8aW446Dungz2h2Nubke5mbbaM710G2GiHoaSsVFbEIKBCUP5aqPar2E+ngJI6NljNR9lAIBjxWo2wPmZ4FeGPdADQLUHfvLhTudWb2b1TNTmt9NghkJ4EYbKGtgacUWaIZR8caRQY9LhzrB5Gf+3SfuPPKlD14GYGUAP6k7n13zwQux2Di+vHHf9e+vqZn3+yUuiZKADGKdLK0e9nwBPxCQMtbJwjI5ZbGdTpONR0qGihQY7Org9G5mMvN1k2hWwmxpZWzZjwdsJXOYiMAscuVhlNRxs53jFSmgZzvMI6d5nN0biBQBNv0Ap7lxm7AHYCy4qTtkQ4/aGlaJ1azCmMW6p21Aw8CEBlEXuiPH/qq9avsHZHd+/vI/vG/FmK2Ywfx3AHAzrr9/uludKv1D91DtIhEuXkySYQRiK5pia1oQQ9s7qZAFhphjqWvbjwwIzNaFIhsQYac/iRzmuiIaTsoxTVzYuSE6AiIC2s5gLREvhMRXz5XnuJVrQH6qnFsLnWMvDwHXFCJWSV8X58BNa5qTaJUysd9rrWYTxno3ifvrkBFy5b7alPc3av/e+Zd/fC/4VAK9lZ9egBNb54rTHiS8bd1j//K+6p9153qnVMPeWggJEgwtDEgAKo0niLQDkbwkw8Qp4AnQQpBtZrC3nk36mFJRzc4NoZ3QJhuH4U6e2Q056qFFWf2vuXADDpPciJoLDHZHDDouUtrlQYU5NFwIRbrhyHgGiFYGOjIWcAMTGXBo0FPenK41Pn3OZcHd2LOXcC3x4CTvTwqw457iGwcxsn7r9fPd8H+EPf0fS9KUWRgYEtBkrBFjnH8TYDJgCEhLHmFBYTYwnIQ4bUtqwuhED6cMRj4wAsom2xWzSH2vnfYTKqxat9sgVwRoCi2cg/QwHF3LznAcdgrkskI5bQBtDLTJAhtpcMPRu1CMXig0l6pfnNogvgS9N2vRECvXrAJP9sEA5kAX/8cXdOqryv89kpVvRz2kBxZnPkzqqKvkM7syE72T1faSfZ/3D+MbcSRjf6N4mqxRdhqsM1U2N2dZ9RccuKN80xnRhY0HjO91n3U2hTaeGmufdQTWEVhrsDYpkbU1oLjgCiXWcurvJpt1hXRkmasYUY+hqHxbMFb78zf/dm0OB61OAwhdfoYYnBnFfPTzXxTXfC7YvfHMiY/3julNots504cBk4Cxt9Vxm++T8lGJrIUpju7ELpOxNdZCIGVz3BNMmc9MJhvVQIUsFEmnXFbkW1SHdkhTP2NzbO1nqnt/wr7+bObUv2WHyUkSXyvOaql0rHtj5jqiWTF0z6Cnyzt5ZPTjL/wo7v/h6Y+K9E4/QHwj0GcEYLcRWgCvf0sowkp0+53fr3+it6D/iMJwgydMKkq1U4/DTg8RMyCZAGnVCSfZqDgAwDb1mAAd948lYtuZPE8o9Aon8Wad7xqkQmvJwDHDLshuAb17L+BsjFFf471TJJc2zRvXFYoHnMbMNamkMwlrIwZHMbjd0JsVjfJ/PXFH9G184YgojDpiMJ5+EU2/4gjpBDMGgugon3iWvgbVyp91Q39O9xgmYnC6Ik0qolV6cgZa62xFW51knIthtHH0mDtvzRb3aZWN79fO6N203qU4bU4j1yrJgybyuSOO8lPhWeuMoVwcpJepG7e0NY1QKQOlnfN3dK9RMbgmigMa3Z7XUaX6X6/eWv7cqtEjEbS1U82TgfUnZXBy2z4fQAhafelM98jRzZ+ZfVSMd3qL76pA1bKcr7GLr9D8DYBFLLLTPicrnlPpq53QdNoCzCk5KZ38RllKMm0zHWR4FWZguBMDEvFL+d4kdsYoZI13ieRnp/uSHEvZpBmiZLEqxy2KXaKEvTarFRp0uzLUQfX/r28Y+eOtv7l7HldDutMjn8rjSd/inf82C0zBt1eQAZwLc8+Xtqxe2L/wQS9cfEelrEueDYKQJyCS8KVvX8s4GZFscSEfbBgzTlLE0cx8hUg2s5ltdCxzc+I89IA7rQzpKKVca4wLpDPCEYVpNmlZtukr3DTs+ruOWE7YnEgvC6qxzFWhQbcttAkqX6iurn/grA8f3I3Pkxd31YOhwRZgLkjTZ4jByfQkBbYVpYQ7Ic7asfvID82Wj7cOcLndbb6lCl0GBIQxIBYwqXGSdKcLu/JFGqk0giGYIJnAgiASFhNns5utn5vGO5xyH6YB90sqjK4ulnIVuxUTacM5T4pzxhTb7yXuTxZrThoFMvYmhlXi3yYeh7FZo25XaBOUr6mtrnzozHMP7sHVFN9AKA/uU3rIJ/sPV73e4QXnuioJPYh1vzG3cPSeNXf22lzXXX26ZO2nJTy52yRQf1VqodO+//6fmXjlYmVkYfJQbr4GBtdhcbEZjslRJXnrmJ3pBnn1nQdV5yognUiVYrC27LU+bwyuDE1Q+cfGmsrvnPnh6V24i/ycvFD5aMyTYe9TEtGOmM7+XwKQEEmQCtth7rn+uNUL+1vvkb3Fd5YDNeaVbK44iO+/J7wkTh2XyQoZZ5+EUwmSpCLTye8i/nly7k5LbhoyEdFET+rEuDAMOhvGzkOmC+b7dIuhyNRILIQjTaJ/wxjcTs/rmFL1c43V5Y+d9eFDe1PmWoEBVeig/pVnQQcPBdmPr709JIExmMd2bRqZ3rn4DtXqvqskw/WlEkEEBC8QFuRYF5OXFdTHYCfJiKygLzW+CGlhn3sfByqC7RRKrhRgTuPcnO8OBdKYcn6sMztlN1mnh9Yc1zLrzLd1g0Bhh9GLvKOmUv9sfV3jT88+Zc8RdEjmkuBxcUh+RMuvPAsieoCoTtQg2V+Lr1AXYmLLQtdr1H44N1vZF3XNNlZ6tXDJ5eQX2B37kI4Jyo+D4KLYTAdyUh4oV2SbwiQkHnBbBNikAOen+pnCLIxcr24SfUtEssriywlb02cbqVIho9tmdFXpMdmo/eGWU73/9+QXH5jDtMPcrNWYXY/3qYD7EzF4IJO9OBXsHCZBAl1vBPf9sPzi9tHOBzzdeXm5ZMq+FdnCj9mbiGvyRMrm+OZPWYoxEddZu4xrWdsKzqQ2OxeO7resk1GMDOoLXiAd2Zt1T6ad9uD8pBtbNMc6C8GyE45MmKtCg05XKC3Kt/qj1T885Qx143j5mELoFKQlwCoLrQbTv//J8Hl6Ac70cXyVjRXXBGDTOv2j7/LW+SO9X+N2521lL1wTlAie1clJNSbJWD+TFdFJN4ULMqX+siOmk9c5nVw8URocCOKiv1ucLuQAbNmdtJmwUzDHid616T9jY81hl9FV3izKlS/WJiv/7azz1ANydsazsCbgsjWq3APkp8rcZwLgfMmzTH0NsiATToZ+6PZ1lbnd6pXduc67PO6+sBSYShDETE5A7mt0E4VGNwdwFJicNbmh0EXh6GOnSTCLSOanucKK6GxkVAZyBqzJBtRoY3MaJs5NKBOL5FCEEUr3B6PlT09tlF896WVH5/GIlmDi1M+l+IYq6d3kf0LD6mkFeCiTs5kkwq2ehQfGeJnvuX30xIXDvbdwt/cLHoXHlwOmgWxOrer4vQsw3JYZx8LOetDivHOCLA2adZboehRmkDnDVjkRwRboJFrlimWjkIplHRr0QkJo/CdQKn15ZFX5b3ec27lXthYIUTp6NassMDlf9yfWu88IwEPZHHdjilyfCBFhhNVjezZVZvb2Xtxrdt/O3d4VgVRTJZ9J+gTpk+NGWVAl5fWwBTe96bhTzUmU1HLSkmfJTugqZ6QZB1B3qpDrChnOiWQVMaIQ3NP+AoLSTaWG/9mRjZWbT33h/iYeTwdJ5wvAk2bDp5G1zxjAS4psAbe9MIYkAOOMkn702tGxY0f0xe256M2kei/zhVoV+Ex+kBlg5PjI5LhQCcCJj4yCTu4rABgQ6eCkYARcmCAUgwnOkiDZMBQn9RfFN6qMtJzVsnxHZbR09eiUvH77m+dm6I6uQIcSS46tZRfzVg8uMXlOAzxUZMPq5czIzTYfjBGYnQ+tnjqwHxfqVud1HKoLJUcbS74hL0DaDkOpv+x0OToszseraVk/mNPxgQXjyimzQS6IkTSGMaKQEUbEGv5h+P6tslr+6ur18jsnnzRzED1FCHMzkE3qbOu8IfV0g/qsADwU5MTkEo4RlgDuweDFgXnomsmJowfU2boTXhl11KXChCf4Qld9D+R5BOFZ90nCaX4rZJ5cvUuD5mthQNKe03KrTCwj07E6qcIAR1r2jPB3y0pwk1/2vjEyVb7z9Eua09g7R+hCotCwCrai2AzsYP7ZBHioyEYKcpYrYEeEj4Jxdsns+aeJ8uxhtbnTNC9pzetLEfXOllDrJfGoJ5k8yZAecta2C3LOch5Sc8dpgzdntzgq9AopBWhNrFk0NeQh9kv3VRveDbUG/qUxFew8/k3zbfphW+Bo/rabOWC5zz97Rpn7rAG8LKNFVlmbM8RskAQVGPiSD+4baxw+IrfOHzNn6W70Qmh1KmuzhVivETBlKUzWWySRWdk0PFzpWs1pK4kdNKOMgGHRg5DTJGgPS/mQLAV3NsbFPavXYOfGjXOzMBGhA1GwgJcC9hln7E8V4GUYnQQ8yXG0MtAlDDbB4MwKZr8+Wtv9GE21F9Qmo9R2GHNSGGILlN5otFkDNqOCTUBkhAALIhbomywOZiY2IMMstIFQEDQvpJiG9Pb7Ph4nTzwmPO/BSsPbs3ELT69+7fwi7ukAhyGgBrA10bHPAWB/agAvCbLjSFmrGwVWx48AwGYYnOsZPDgpj9wlvCOHUKWwN9KL5BQbs5aVHm/1SqNKYYSMbgBcArNvf02BqMdCNqXEQq0UzgtPzJIQh0q+nmGvPD8+Re0N5+gIZ89q3BEK7INAL3e7Fs6VMLFTyoRn3jp+TgO8YmOMHKub+o43Y7cA4IFRhokTHskcKw8ceqQjIU18o7Ykq8hCgKVnDAXKQKpsjggD6ICgIByPtTjOhXMFcGawfv1pgfqcA3gIqzkXFaOcczUYaDe3QIUL7t7oiQcumOLNoPpn9Lh3qjIDqxufM8A+5wAeAvTSYpxyS2DQt57kztOMTv4zHvB6AKjPJWDT4+HnKtLDAaehn7gC/qmc0CCz6GcM0EEATwGYITz3H0PY/UxJpKF1yM91UN3H/wZomX6VBaNsvwAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMi0wMy0wOFQyMjo0NTo1NiswMDowMA57ROoAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjItMDMtMDhUMjI6NDU6NTYrMDA6MDB/JvxWAAAAAElFTkSuQmCC" })))); };

var SvgIcon = function (props) { return (React.createElement("svg", __assign({ width: "3em", height: "3em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("rect", { width: "48", height: "48", fill: "url(#pattern0_7677_38468)" }),
    React.createElement("defs", null,
        React.createElement("pattern", { id: "pattern0_7677_38468", patternContentUnits: "objectBoundingBox", width: "1", height: "1" },
            React.createElement("use", { xlinkHref: "#image0_7677_38468", transform: "scale(0.00833333)" })),
        React.createElement("image", { id: "image0_7677_38468", width: "120", height: "120", xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAYAAAA5ZDbSAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAB3RJTUUH5gMJACkMe5G0pQAAAAZiS0dEAP8A/wD/oL2nkwAAQP5JREFUeNrtvWe4ZUd5Jvp+VSvtdPLp3OqgbkmthAQoIISEEsnG4jqNbYxtbI/DjO+Ye7nGCY8FDjhgz507XI9nsD02GLCNCQYEBiwEAgQICZCQhHKr1a1O5/SJO621quqbH7VC7XX2CRKSELb289Sz815r11tffutbhOdu/ypvbO+m6Lmp+FcN8HO3527P3b6rb/8mVPTP/eQ/AQAu3PZVAhhff/yFDCb8z3e/5jmAn823N//G2zFvRukl9du8PdFhf9RfbBgpJwSZrRHFk4bkCBGPeiJtSJiQiD0AxCBlWMTKeB1mWhKsl/omnDOQxzydnlpMWu1j/an03viMtCG6/Eu/+/bnAH4mbm/7w9/Hr8e/jvdGPxftEwcnJ+T81tBL9ntSnyWF3ut76rRAqs2e1JMkOBLSSBIsICBAoOzfEgCGAcPAsBHGaDJsqK80zafKP5Fo7zBrcTA13n2J8u5fUCNHH1PbT31SX9t9vvgG/v1v/LfnAH6qbv/8B9+Ps+r34NH+3lpLtPeMe0vntLzuxb6Xnud5ao8fqG2ebxoiYIJHgEeAJEACENljAkDZX2UuMIbJnhsAmgFlAMVAyjCpgE6pm6Teca28g2nq3dtJa1+ZV81vHulPPPw9r/54570f+gG89i0feA7gJ3r7gxvejN/s/Q7+rvZj/v76wa11r3/JqLd8TcPvXeyFaqcXmgkZsEBIQECAJwCfACkccDOA8wGrnAdiCAPAsB2cg+wOAyQGSAAdg3UsFtLEe7wTR7e3VePmro5ufTDe+9hbe7+avD58D375t//0OYDXuv36W9+Oty2/Ef88/uqR3d5jZzf9zqsafu9ljSg+ICPdFJEoQQ0yUD0HYAFAsgMw238o8n9KZZTIDBiywJpsaACasnsAaSnRSDOw+wwTM+ue6Hb74YPttP7pblr7xIl08s4vqEvnTxNH+LW/9Z7nAK7eHvqjs3BcbxqblrMvHveWv68W9K+O6sler8YCNQGEwoIakAXTFxZcnwGPAWkyCQ4BLwRkExANgGqAiAAKAPKyv6wBTgETA6YHmA6g24DuASoGlLIAKwK0yAB2gI4ZiA3QMzA9cK8fHO7Hwefm0tGPPKq2f+48/6GZrb/y6HMAv+uG1+F1F78bN99xTWubf+xF4/7ia0ei7jV+TW2RNUjUBRDJTGKz4aME1fcAvwn400CwE/CyIbcBYhygFkANABEACZBwJNgASADuAmgDZgHQM4A+AiSHAXUYSI4CyTyQxhZcRUBKQAIrzRWgk543s9Svf34uGXvPYtq8+ZIXfmXhk7e9DK/47U/92wP447/7cjCLaLf32Plj/vLrx8OlV4d1tU3UQaiRBTaiTHIzUH0G/BCINgHhPiA8BwjOBuQuQEwB1ATIt3+Lqwk7WiORlzliMBnw/QzwY0D6IJDcDfS/BfQOA8mSBTclIBUW4JiBvgZ6DO4xx21vdilufPJUOvZXd3V33SbIdH74rZ/8twHwp3/vWnyar6XX0Id37fCO/ehosPzjjUZ8QDZAqAsgJCDK7kMCfA0EEqhtAmpnA/UXAsH5VlJpFICXYWYqYJHzF2mNbG1mj4kri4Icz7sLmBkguQ/ofw3ofAPoPQL0u0AirETHnAHNVqI7zJ1OeHC+1/i7Y2bLu7/oXXP/+eYOvu7X/+VfL8C3vPVyaEh/Ws5cvTmY/eWRWucKv2ka1JCwUkslsIEGwgCo7wGalwH1y4BgXwaqzAA1DoBrjbVuvMYw2T2V6p37gD4B9O8Alj8PtL8BdOeBhCzYMYC+saNtkHaov9yt3X48mf6vR9NNH782vKVLMwz86TMz9fKZOMh//40fwI2P3osfPu+d2/eFR/7D9trJ3xkZ6b7AG6GAWhJoEFAXFuRQA/UAGD0ATP4wMP4TQP0qa1fhAVAAUmfyuaJyq4/NBkBcb+jsmMr+rGgB4RlA42KgfhbgSQDzADp2RmUWf3uA9OBFMj6tyZ2X1rk7fp/a/8jn+JL5v7nuIN732Ye/+yX4HTf8LG5MXom31X7rBdPeqTdN1pdfFbZ0Ew0J1DN1HBEQsLW3rX3A2LVA8yWAty2zp476zWMeosHnECs/k0vfgLquqOc1pdhZHDxsoRBAEuBloPdNYOFTwMJXgO4SkMpCXaPHQEcjXab+Qq/52aPJlt+/ky68NaK+/ne/+f7vUoDfyvg8LsEsTwb76ODLd4TH39xq9i6STbK2tk6w4Q+sOm5MAxPXAGOvAPydFiReTQWL8jGJdVTzWmq6qgEq4HIOMhxpHrIQiKwyNMtA5zZg9mPA4t1APwViWYLcNTBt5uV2dPeJeOqPHta7P3gp3dr9IXEjbvqtq58WGLynC99DvAV38gXN8+Tdr5sOF36l1Yr3UFOUqrgmrDqOfGD8ImDyeqB+PgAf4GQIoBgumXnqkdYDl54YwIXEbgBgzhYDeUDrJUB4JtD4FDDzCYBO2kUoCRACQhoaFd3z/OWjf+z345238hX/4y/5tXO7v5sk+BNvvRqGaeIs8cAvbIlmf7neUpvQkiW4UWZrG9PA9MuB8ZcD3iTAaogqFs5pipUSPOw5VQBmWuWfVoHCEBDN2qq7WAym/E2SAGugfSdw8kPA/F02nOpTpq4N0NHoLXlLJ/oT73xUn/YnBD720t/+8rPbyfrD33sj/vIlD+IEbZ46QPf/P1tqs2+oj5pJNCXQyNRyxEBkgLEzga0/DoxdBcgawPEq0uI8JjNkkrG+/VzhTOnKvVnlefW1LIfJzuOh31H2mMFWoHbArr/0sP2PQtgFSARf6DAyvQsD1RtbNCNf/4OrO8vPv/JV+MBn73t2Avw/rzyEe+icqbPpW7+2tTb7H2qjZsSCm6tkA0QeMPkiYMtPAPUzAMo91CowZm3nh3jIIjCrLI71PGS99nusK4ui+njYUDYdKuqZpz0KpEcAs5SBbJWLR8aPdO/8UMebHjSn334B3bX8Xz7bffYB/PG3XoUZbJo4gPveuK126j9GI9wspLYugJCBWgRsuhaY/n4gmLSpQtIZWDwEIB4uyVUgcrDZOFJuVvlNvYoUDwNIr7MQ9OoLJ5dyTu0EhacB4RYgPQ6oudKMEMEjlqHpnxOoeORhPv2O1790e/uvP/v4swTgf2B8+az3Y45HGwfovl/aVpt7Q23EtNAUmeSSBbdeBzZ9DzD1CsCLAEotGLSK1BKv4tjo9QEvgNcO6BVAeD2A15LQ6m+tATibUgP4m4FoB6COA2rWLXNZkHV8jlSxf1icdvtvXqF7wat/F1/+1Ce+swB/7dx/wO3+i/1L+Suv3xbO/lqjpSat5OaJCwPUW8Dm7wHGX5qppwxc4U5+VTJ4pYQOVd/Vz+shErwaSOup2XU+zxWJLz6nynsXYFaAN26lWc0CyUknKgA8GD/U8bm1dDm9h865/WXxR9I/+9zidw7gX/75H8SbHn01/er4B165Mzz5u81GsoOa0olxGag3gU2vAsYuy6Kd1AKLDFxay36uJrUZ6JxJ6QqJ1htToxsBmHWmCVwQ15Dm6musS5BZAyYFZAsItwNqBkhnrJefSbLPJgxUfK6n46NfDl56z49es9984DP3PvMAv/3tb8b/mf45Xrb12PN3e0f+aLzRO1c0s1Aot7lRaG3u2KWZNlIWGJGpYKomDHgd+7mW48TlolnVazZreNOreciuhK63MIao7NwUsKOuWQGiab3s5CiQzjuFDcBn3fDS9IyaWrrnuuTzj55+zQ/gQ5/91jMH8J+87Q24vvsuPBCdv22fOPQ70/Xl62RLZBkqaUOh0AOmXgxMXG4L8Tm4xJlq5lUkWA93oFZQL3iD4Y1+gkOtY4eHqemqE1b5DVeC2ViAjbKkBH8KSB4H1HKWvQMIhMCk0zJNdnzVHPjydebmUzuv/EHceMu9zwzAb33xEr5pzgvOom/9x83h/E+HDQRlnAubyBh7HjBxJeAFDrjGUc9VieNVJJUr0rmed7ye5PIqC8BUJHUIsLlJ4PXs9DAVnZ3/gMpWgByxQMeHLaMkU9UCBE+lO4XWuI0u+sK5fG/y57csPAMAv5/xztt+CckYrtnpHX9rq6mmqJ4XDggIDDCyB5i8GghaFYeKB4HNVXJhR9cCejUnTDtSrtdX4RuScDPEiTJDJHw1gNWgdJvsfaNL9c3GSjG0dbyIgP5hwJhCkj1jpKeS/cbgkdc1//Hun7tmM2656ZanN1V50w2Xg4HTzjT3/PmWxuIrvVEJNJ0sVXMc2PJKoHFaBmpWOisYjjb2K4J94aQXqZo3HlYhGpZrrhYURCVluVY5mNfISa/2eFgSxqlO5bnpKjW3YHBm9zpzFI0A0gQ4eTNw6k6b0uzaerJZ1ji53PjKQ3z6z9R1+54rzn0QnR/dOGxPqNhw59tOR7u2GGyeP/VjY0HnSq+WF+czrlQQAqMXAuFmALH9v8IpFnCeF87uActszEFmDM8p83rFhFUqSbzWWuZVnq+WAq0WI3IWCK9efnTB5DXKksx2wY9dAPRnAXXEzmlIEKnAaNJ7/pbe0Z/+qnzhb3/43kva1z0dKvrWPz4fFz56H9rSf+Ekzb+5VVfbRcMpHvgARvbZk5RUOlDEgMgTDlzaYpiKXdUVh0tvPP1IegPq12zAgapmsfQqGS+1tgPGOlO1TkJlwMkyg/bZaKuuKbTsz/5RQCcFrVcalpzqHVIld17eufuh5133Uvz9LY8+tRLcUMv4ZuPMxghmXxt58QER5bxkYZdJNAGMHLArkZMytmOqSGn+HKV0uiqZViv1VaVXOMI3RLKpKrVr8LJ4mASaitTSKq9XuF1sKgKaP3ckmR3pHlD7BNS3Aq39QHxXRjIkiFCgFcQ7x9XCv//nxou+erp+4NRTrqLPjw7iC+m2S7aLzvVhRJJy0rkE4HlA83TAH82qQgSwcECGA6xwkjfZawRbFiRd2mgXwA3Z3WHqmZ6Eih6mcs0qVSsMlhpz8IqR2V13IbnvwXleEAyEncv2ESCZtfzvwMCLCOPJ8tXTauZl53tH3/eUqui/fNNLcUd7z8jZ9WO/NhV0rggaRBQJS7fxYeu6Ywcs0FSNcYc9dhwV1pVYV6+frCi8br2G+uZ1EhPrlASHZbRWDa3y2Db7DWNKr3lFNit7P1fjJlfdnD1WlvprDNA/ae8120BE6cikunYrXviZ1155Wvu9tzz27QP8gT/8YZxz6l8w4uPq7f7sGxoNPeIVOw3IMh/HzgJq007I4mSl3DiXhtja1VKVtMFUYH5PGwRqo4OHhD0Dv8uD2a/crhaADctgDQG5+r7JhoiAZBFI2oAhkLGeuEn1pNHmgSuOfvOu837wevzDZ+7/9lT0SPsQ7pu8rvUC9eXra366XfiiZA1KALUpIJpaSbMxjkoVmcrOQrwBm5yrcDdkyrWi+5yGecfOMXgtmuxanKy11HRFVRMGbXYeDg2oZ+feVct5iJSHS4wMTCeUKmy2AYQH1LcD3VNAEgMeQfiEmq8mRtXSaz669SWfmuweOvltSfAHf+d78MLlmwHi50+K+Tc2a+mEVyNQHhqFATCyF4hGM/vJgxJM1eTGMIkekoYkl/DGxQpnKBCbIfXjDeSo18xFr0UAcFQwO+q0SFY4kmkq7+UFCsOZxDrD6MHn7uvF7/hAvASkbWdTHEOlPJnE+qsvCe5/8PSLXoIP3frYk5Pg8fgoPtR4nX+5uukVda+/V/gEksLmlgWAYBQIRmxRm2EDdnJi1ty5YlFKJWVOFTtSl3u8rtAIsnOmFHS/h7Tbh1Ya0vfgN+rwohrI90FUlfC1JNjZtTC0D40Tl+bulUph4r49fpJCCIIMA8ioDun5ljKWSyiqTnjV4TJOmF2JoQccsGxRC2FNX+cUIFXGtRaoe8nm8SB+9Qf5ZTfvC4/0nrSK3poehJa8pY7Oy32PBXnO/lvpWVYGCcAk9p7z4ajh/DFRqZ5ztZ170MIBghhgAiuDtNvH0vF5HH5gBocfWUa/q1Freti1fxSnnbUJjU0T8OoRSMhKkmQjibth6pkKkJkNdJygP7eIEw/P4tD981ic78MPBDZvq+O0MyYxunUCQaMO4XkV1c3ZAkbpHVc97CKrRYPhE5tBpqbfAoImEC+APILwCJ4PNJL2VdN84vTd6f13P2mAz+QFzKF3aV10zxY+AEmgfO+tV7MHN1low5kaylmQApndZQsmVcDObSzRYKgJgDVD9Xs48fBJfP4Tj+OOr8xjYS6FMQwhCJOTM7j0inlc9srTMLlnE7x6DSRcai2vASxVbGtVmi0AOo7RPj6HO24+jC/+y0k8/lgPKmGQJDQaEgfOncEVL9+GvedvRTA6AiHFEFuMzJOmQdvrxsZMTpeBXE1zqdaFBwRjgFwGpAY8AnmEmuzvquv2ldt+Sd39P0Z+Gj//5v/1xGzwB294Oe72zwx3pAd/cdzvvMivCZKhgAiFTW40poBozNrdIk08JD50QyDCoGc9jD/FBiaOMXNwFh9730Hc+tlTiHsaoU8IfIIgYHlJ45EHukjjFKftqSFqBBCeKHcIrkhYrEeDHTwHo1J0ZxfxpU88io++7whmjvbhSUIYWOvU6xsceqSP44e72LLVw8R0CCEJVFBodbngBzJXpnzNmFJiczChs0Xg2OLcCYsXAaWztxicGk8liK+969OfapmF/vs+d/CJSXBDLQLAngZ1LpIeC8qKBUwEkj7gNRxnQmYrP7OrbMrHuaSaLIiXri3OVj1xlugAmDV6i2186aZj+NqXFhD5QKMhEHgEIoIxjDhltDuMr3zuFLbtbuDFr44Q5f4BDVPDa3nRVLGdBqbfx0PfmMFnPnYcSU9hclwiDAEpCAwgTRm9PuHQwQ5u+thRbN7ewMROAZJeKaFF7p0r9hilambXg3akO88P5K8LD/DrgIiz3TIE8oBI9M8b1afOBLAqoVoM5dH93vdjW/9BjOrZc3xSuyhvaJI3M5EhIAKbP83LXnmQzs59ERM6r+ffKR7nn0vtayrB0YNL+Pptcwh8g/FRwliLMDZCGB8Bxkeyx6MEoxRuu2UGs0eWwCq1v6Oz3zXZ73FGXx0YSXk8k2Yj+55W6C50ccfnT2J5LsbEqMBoizDWEhgfIYy3COMjAmMjwGiT8MDdS7jvzjlwEmf/R5VJjPw/QjnesVNKLD5fmS9TqRkTAK8OzjnVgkCS4JPa0lKnLrjy3m/gg2955cYBrqfz+Mz0TwQNs3SRJ9TEQLmPyNpfgnOS2cS6YA8A7gw3EZBPbDEBKVSc4OFvLWJpLsZoS6DZEGjVCa0G0MzGSIPQagi0mgInD3fx6H0LdoK1Ks/JaEBnwwwZWmXvqcpIcOKxJRx6cAn1GtBsElqNweO3GkCrLjDSFIDR+NZdC+i148E6MKeDC9joIXOTq2IHzHxRmMp8yRCQPjjTopAEKXWzhu4lf3/+9aMNtfBEAF7AvvbtUz6S86XQwjY0AZgILKSVXq5UQ1asvKr0OkOnzvPUAd0g7qY4+lgXkhj1GqEeAVFECAM7otCOegS0agRog8cPtpHGsfXmtSONJpNYUx3KkV49AC7rBCeOdNBvp2jUBeoRoRbZY4YBIcrOoV6DHRHh1Ik+lhcT+9+1K5XugksrVSS9UnqNsyDZ4YextiZM+MixgACkNPCgzprsH5pupnP40ze8Yn0b/N7ffhUmu7djSYxv9qD3kkS2anJHSpZ7b/I4jkXp+ucesuuZkhMH50uqCJGcTJYkJIlCeyFB4Ns8SuATfM9uwSUqD6l9QhQyfA9YXkiRKkbkhiT5rj9eLVvl1JqdczVgLC0mIHAGKhD49vgi+5tEgDH2vTAE4p5Cr5cD5VaX4HjPTujEqGS2VomDi3Aps+nCByPHwmpUD+numlrYdZF+9KGHox3rS3DddHH+e08i4P5+j5Jtru1lIrD0MvXsZF5QycIUyfdM/eiqFJuVKijL+nCW3fKknVQpuLAMcMggnmeHLwGjDZicHDI7HmrVm11R8dHOZw0gGMwMKexve3leR5THJwFIaYcnAWL7nYJzZZxCgqnmm10TVXndDDNnJa+ahZedTImJT+mUT+rcH2v8mWhxZ30Jruk2/tvP/4J/WfujBySpZlG+cySYmW3KkDPpNU72yjgo5JQVlCuuyG5RNtF5w7Js0XuRQH3EK/doCVrJvHFyJUIC9REPMhSlBOWxtUNFLUI09/UV+WfrvDRHfEhJgyyiIVG1fZ9Qb3mIWjIj5GW/Z7hSPnY9Zx58n10pd1kg5cJkY6yA5TKZJQglaY+M2n9t58NBIJb76wIcmi529r/lS+g9gpg4A9f+eGbgCzsiS5feCAcoKnUZ3JIqlUkQOEmBIvlBqDV9bNpWx5FvLQ6yYVbJKApB2LyjjqjmWfvFPJhRqqYqK0mVwboxQwQ+Np1WR1iXMEaBVwuxCgXAGJ8OMTLhl6DkhQh3D7PJDurysnJTMpAEccHlQenPzF2Z5bXMmZpUe/f7J6OmaffXVdENtYARM1/3ONlVqOZiHkR27mpQjZhqGWyYeuKViXU3+DcaUAZBSNh97iiCuoRSDG24JD84/18bRpoy6iMBdp0/BunxkAS+c8y8clOobXeiHTWpFTaf3sD0zjrShEtta5zj2xIttGYwCLvPHkVzxAOUHowoXCcTbjjpgGYqpUajB01LNrfMynZQJYegmGlXyckOEhhvpqfWt8FNu/NtXHK6uRCWAcG0eVpe4RSwU/6qnGBR4HZfcz5ffF8DSmP3OSPYedYYej1GkgAqtVk8bayQKgUkCSOOGae/YAI7z2oCqeM9V+19tdrjeq1VvyBVGJ0OcO5LNgNSoB8bpKqMuLSxOKYpo9c1mNhaw1mXToKQnZyboCiyVTyEMpsVHkwlw1Vkt0zpaLnq2tGKnBVqJCebyCTbWqq9vg1uqD6ESbcITiedzW8ZyFQWunNKDqPCjhSVmiiV3yMuVVZBm3U9XgBxgtHRCJe+ejvmjnXRnu+CIBAYghR2guOY0V42mNg1gktesxP1GoB26oj5GtkrrurZSn5aMaSSOO+qTTj28DIevPUYBGlwTUBmFilVQHtZgwIPF716B7buCoHlXinmhTdPTuoRgyraOB42Kjls49ggY/segw2YtRWwSkmcWDckq83NZAOpykADUvenwKZe/hA55is/mP0TlKu7wq6awSJ+MemipJnmSRI4hDzj9KTqxNh3bhPX/sx+fPEfDmLxSBteT0NkABsIbDkwiRf/6F7s3BMBSx0rVqD1eXarcqNRhiXdPkZbNVz1U6dDBh4e+cpxxIspvOw/Kk0IR2t4wfWn4cJrpiB6PYt63i+EMYSXhUHby5XqU77ImCtlxgzkQoJ5gONgCCA2EsDE+EYAnkgBAzFCrEUOLrsTYexKIhaAyfo/5sCZ7PFAGTDPR2uHC507CDwY/1BWUTEpBLo4+4IWJraegwe+OocTDy0i6SoENQ87zh7HmZdOYXKKQEtdINWD5DdyvWVywHYktdrqkJ0HGsByH1OjdbzsZ/bjwQumcPCOGSzP9iA9gYkdDZzxomns2h/B7/WAXmKNsuuyDzhSGCTAM69wGAspH2BmciG51g5boaoWrQBIoZPxYQ7pCoD9BCDiEZS7iCrkFcduFsUG4RSxqZRodmit+XeKGI6dUIrLMCpfvf0EwjC2baph02u2oh9vh04Z0gdqkYFMY2C+bxfEqqVergC6Gm12CCsz1cDCMpr1EBdcPoIzLx5D0mOQAKI6ECIFltpAL3U853xB5/ZTDCYxBrxlR6INVcqH5Xuc2W3OfASrognMlLWtJ4AghElH/u+z/wIf+c/vwfe99eY1qkkMSKPqsIXA7CC5J10elNlY9ZxXjgYYGc6JEg9Orsl+mdwWSKIsmwmnM3uSAqcUPL+LZuDZ9xIDdDNPK18w7haXFdwtXocAUAmhXBuqASx1QJ0e6p5EXWbEgkUNJCqr31ZsebH4RcniWMG4dTJsRdWtkoSBCzKXZrEgJLDrcggyunnF0nulx7Fet1xIrEOuVFc5+yOF95yxHojl4ElzdZK5VMGuZ1AkO3IMRDmxVIkfY7YTOowiXbAmyHHiMKQhKdYh3nEFLEe6U237ROfUJFSIde6CqoLLlZjfPW8XaNBKEoBDpi/NNTuHJrAVOwLryFdtIawzsgbAVqXYq5NUEg0Dad3sKJynArji3fBqE0yDdilX5Xm3OHZAdhMl1QVRqHOUHrrr1a/4U+uAvMImu6BV2JzMlQVMpXNJ0vktqiyGIXum8pr4EM5YoTWd96x88QphB7MkVhkzD2uraM7AdY259e4Z0llBNIwawxXphPOYKt3pXIIbZVLMMsvpZhMrVsHGOClHqqQjiSqTTKsQALjC3KFK6FSRvIEDcaVYkS/QSlbKLTAUWo4HzZpr0uCcA1cJebnJHO6M04YYHQpgkCpUP9PANhp2VAc7R1khxa40raA+OZ6zKbVz6XjJkraaE/nIOOzJ6qKklc/J8aiHreIB80Ar09KrcboYg+HQCnDNShBXUK5ppVmraEZXWxQ+mTGZiqZqS01mkNbkrQB5qIo2JGNTAFyegDUHg5uoCj3OjpQWW0S5fG7YieFoiOTkxzeZpy0d1celLueS3jO4dGk46Lz2vrOVz2llEqQ4P+PQgLn0lAfyzc6icR2pwrumVcDmAdBLB3cwvVv6QhWHnGSsZMMI7q+dqtQEGPK6XDrNgxU3N1VZJD7ck6NByXDVk5sWq25Oc/9wnsLLg+kBiRDO8eRgRm3V4sSQ3Ye8CsgD6pQqm8TEoJqFKBevqSY1qKy0MQ1xyGjlHA1oijIdzHk1qcCDBnMpBoYhO8ca52gto7UlmFtAN6UlY/P8RVp0MLliwEaDWWbGmrMSIg9uRzE05JI2FdtoMnVpnOJ/Hv4YrmwEz710UbGhJZ96QLLhZNNomFNVsb2utA60EhYVsroreWYw1idR4UVjSHWJKlkv14dhsMO45AyAwntmAhsGGyrssWEYLb3FX/zaO5j+cR0VfYIAAV4yLAwbVcbiBjCGiwPYoDtbZYZBZEo7lE2Y64WTcNOVuW0UK6WHqGJX3dCHKnG1WGWjQiVMozUke4Vk8aCCKxwvU6ZcXYYkHD50Dq6pOnjG4X9TVt9lkBHO8cRgetJhcxQZrKIuweCsymYMwxjSyg8X2rQBJ2veAF4QntI90TMGzcItzx0ux4cgY7IUpCxUCWVZLZUaJN0EaaLhhxJ+3YOMfJCXkeeLWReD/SwElRMFRyJW250wsGVlFceqWvRYNVQapsbN4HvVIor7nCv/K29qzgTWBqwZJjZIewnSnoaUEkHdhxd49sKKzKVdNLooLoDLkNoKGRxwAQ2hAcydDDcAcM/3oYV/XMOfMzqdHqxkZdtKmIrsCowGk7YJj9y7NozeUorbvzaPg4f62LbZx56dASY3R6i3Qnh1CRlIkCdBkkEFJ6eaPHAcNXI8WKKBbSZlP2iBNfKSWHmZHTdco8FdEQNhypDrHnJl4bjFexZZVVLDpAacKKh+it5yivnZGI8d7uPQ4ynGx3y8+NIxTGxuOXuczEDeOZf2weojDbB9DMuuIXmiE2wE4GAC0HpOk3+CGWeaTN8bzTDG+eEM5Jy+w6xBRoKFARFh5pTCjbe0cfhYgladsHlSYvc2H7u2Bti21cfEVIDGiI+gFsCLJETggzyRAZ7v+KdB+oYL7IDq5ZXbSVd1n6s+Jg86eoVDgCGLQVTWSUkmZKPB2thydKqh4hRxJ0V3OcXCqQTHTiQ4fDTFoaMJjs5qLHYYIw2B7dvrmJjO/ZC8qKAHiAqlM5UDzQMldUX+jBH+492gBqC3NsBJOI44HOvodOYx7YDq1pwNAyKzAyxMxs/K+z5ZllonZXR6GvUaIITBiVMaJ04luOPeHkYaEpsmJLZMe9i8ycP0pI/R8QDNlo+o4cOLJLxAgnwvA50yKc8xHhICuUzKAbDFGpKLQU0w0Pm9qkmo0E6cXa2UtYJRGjpRSPsKcVehu5RiYT7BzEyK4zMpTswozCwYLLY1ktSAyO6vatUFkpRx/JQuctFcSK4p8v3s2N4C3IG94gxNweNsMN8PpgAcXhtg5TexNHYgHescfERrKhk5xq6gAeJBhYZjbbA9Yc9j1CKCLwXqm7ZDRKNQiycRL89hqZtifknh/kMxfF+gURMYawlMjkpMTXiYmvAwNu6hNeKj0fIQ1jwEkQ8ZSgifQJ6AcIn4RJljzY7TvVobfxpeJnSS94WznCUDrP00YMVQiYbqawtmO0V7OcXCvMLsnB0zcxrzSxqdHiNRdn6kAMKA0BwdgdeYgEmXkS7Po9MDNBNIZCVBwyCTg6zBxlhAq+QY5gxotiwXCh7p1Lb1BPH6AMd+Az/+pnemN7/htPs1vI7RqmH52AyZS7P13CCyjVCUdbIjZ1OVJCD0GZ4XYfsLvxfjp1+CzsxhLB1/CJ2TDyM59RjipVkkvT7aHYXFJcbBIwCRQOBbsnmzLjDakhgbkZgc9zA2JjEy4qHR9BDVJPyA4Gd7koQkEAmr2QWVbEyyvR+rYVLuvLg0ZM69U21gFEMpgzQ1SGKDftdgaUlhYVFhfkFhfkFjfslgua3R7TGS1EDbrD88wfA8QqshEdRHEI5tRX3zPjS2noVwYgeWH7sTs1/9BxjTQ6MmQGTDTjgS7GqL8ryc1h4Zw0gboY0vHzy8+/r0jEfevb4NVn4DX/jFCWgK79ccHGWt9hud2eFCiqk4iE1YGZBRzoYyCc8DQp/QTwmbt2zH3vMuhErORj9+KdpLC1icOYrlk4fQPvkI+jOPob9wDEl7AWm/C5Uk6HQVFpeBw8esvZfSghmFhEZNoBYJhKHdaeAHBN8jy6OWBC8bUpKl2QzLZ3AmGcUOF4ZWVurSlC3nK2XEiX3c6xt0Y0aSGKisuC/I8rZ9D6jXBaQXwI9qCBpjCMe3or5pL5pb9mFk8x60JragVm8gCCIcrUnMfeMjqEcxpqaz3QqqJC66iY1ScqnQoEbnYDM0wtm+lt987S2/qD82fdX6AP/gf/44/vlNz0MqG8frycxBrXi/rPC47WAYCQiZxcVZJx2GBkGjVhdotTx0jvfQmT0C1hq+5yEKQ4yPjeG0XXuQqkvR7bTRXVrA8vxJtOeOonPqCHpzx9CfP4akM4+kswTd70Alfag0Qa/HaLdpcFO9q5azVChhyCWDh5QdBnMfeZjixO+UA2mJ7rWQ4AUBvCCCDGvw6yMIGqMIRzYhnNiGxsRONCa3ozWxGY3WOMJaBE8Iq261BkkJ3Z6BjrsYaUpMTniDSY2MEGjB5IEcRKGWnQWp4B/Swcihuyb2YVn7G9s+GgejWBw989To8oP3aCOuM5pJK4bUXByIHSm2PVYsW5HYEqdGGh6mJgIcO9rFwpH7kfSWEdQaYG0g2YPneWhEIUZaDdCWLWA+C1prJGmCXq+DztIiusvzaM+dQG9pFr3FGfSXZ5B2lpC0F6B6i9BJDzrpw6g+dBqDtS4SAYOFkaLYlq2HQZoQgQZUu5AepB9B+CGkX4MXRPDqIwgaY/DrowhHJlEb24yoOYZaawr11gTqrRGEjQbCIILn2bKnVhpaJ1CpglbKLp80xqlD90LFPYxtb2G0JQfbKZnc9g5nIbtkUG0IGt79vdaOkxyfwi+/7VMbAziNRnHGA+/qd5rbbtP9pXmt0wmRrRyRDaMZQhOMYBhBto8TGRBpsNGoRR62bglwz7cIi0cfxvLJI5jafTaYFQwbaK1zawgpJYQQiEIfzUYNYnrKOlFM0NpAK4U4jRH3+0j6PfQ6y+i1l5HEXSS9DpLeEuLOIlTcg05jqKQHrRKwSsBGwWhlw5iMvCbI7uUV0gd5AUj6FsQggvQjeGEdYWMUQa2FoNZAENUQ1ZsI602EYQ1hGCEIAwghIUlkUq+htUGqUiiVQisLqlLabq0Bg4RE59QxzD92D4QgbNkcolYjQCXgrM9WoYbde71yaM3QxuumsnbbD9zwiYUP3nDdxjeA/+CbP4obf+0iAPhmrX/isK/SicLRyg+QOVlUOFq5U2P3IonAw7ZtAeoND/3FY5g5eBcmdp1t1TlM0dzOsLA9oGCgs7hasgVdCoHA8yDDACOyCSGsI1UyG+zQykBpDa01lFIwWsMYDWNMcc+508Im2/YirKRKCSGlPZ6U9jVPwJMepBA2PCtknmGYs9+1Eqq0to1itLKL0eiB4zM7LBginDp0DzqzhxFGEju2RfCkAacll5udem/hSOmqrwAYxTAsjyfRxDc++SsT+IEbPv3EdvjP6AYM5CN1qt8e6f75RjEZxYWBz1eSEJSRKRlkyMZ5pEFaYesmD1OTAR471MHJ+7+CPRe9Cn6tblUQCKQNDOnMyxVZqtl6seQUqNkYkBGQUkAQQQhpwRYCQghQaHf/594y5YAMdOAZjJer3Al2a6/FYmAYNva/cgaq4YGFowswy88UZsyJZSGE7Tty7xeg4w6mttawbVsAMla7wLBNZRrXscq8aD1of3MMYoT3LIixb63FOxOrvfFTf/xZXHXopl4ajt+kjGwXqkFZ9VCsqMKzKwNxNsbuEGgRdu2qwfMF5h/9BmYe+Tqk52efyybI2FXPxljpYDt5OpdANjAwmZOSTWAmrVZirdQqpaC0VYlKK6RaIdVp9lo6+BmtobUqPpe/lyoNlSo78s+p8lwKcLO6LGf/1eSLwQHeHcwG0gswd/hezD5yB6THOG1nDRPjAlCZ+dA6+/9lMsPuU8/m27m3WFCcBGOf+RHz3lO3zDSeXJedxydaUF79S6moPeClyy/QPiAUQygDIQlCGhgtYYRNL5qsvEfEIK3gQWH/3hB33+NjcXEeD3/h/RjdsgejW/cWIYHR2lKpiyQhAYJBxkp3USWUWbYHAiy46DVOwoA4OyZZSWZQxr+jnJK2MrlBpedcSrXNVpk86W9KM2Dc4nu22IpFaBgmt/HagszZNhPh+RDCQ7+9gEO33Yh06SQazQD799VR8w24kwJar9jps9JrzpoSKIZJGSnXHlf+yGdvO7UTF//V6hiu2enuh64+C4sj+7r13omdvu5eTgJE0m6xFLnH6dyDCCLPLMF2xImaHk6c1JibS9Gfexyzhx5EkiQgIeGHNfhRHdIPQELYREX2vUKpZpvfcrW7gl2VlyZpsLTIGN4l2JaHaeDNMiuXBUo8aONzu8u57dVWNRepxEzyGHbbbN63K+73sHTiGI7efwcevPnvcPJbn4GgFLt2NXDpxU1ElIKTNPt9e17aMYFaASrlYujEDpMw+v74B5dau97DXpi++0unnpwE95rbcODeDyYzW/Z/IlVLPypVd7dRBJ0ylGSQZAjJIM1Z5ohhMmfLgGFSjWbTx7nnNPDY4T7SRKF79Ku4+0N3Qtan0Jg+HZO7DmB6zzmY2H46Rqa2IGqOwPMCCCEKijRAMFmdlWH52EIQmARY2AtYkCm3UzKJwimqUniYyxpxaXczG2xctqKVWJMV4O1juz+XpICU0v6WUjBpgjTuo7Mwh/mTRzD3+CNYOHIQ88ceQWfmUajOSQTUQxACIvJw9tlNjNYZ3Ekdb9k1d5nUKh5U0YphlEGKYDYW9Y++5k9u7nzwjVcDuH9Drd+G3j72qy9EHEyMTZ+6/U/rvPB6r0bwIgEvFPCz4QUCvi8gfQHpkR3CZpK8yEeHAtz4qQU89EDbhgUMJIlGP7bcdpZNBM0taExtx9i2vZjcsQ/j2/ZgdHo7GqPjCGtN+FEN0gsgpAWeuGQFE6jco565566TRTSMPMcOqS3bA43SUePii3nsb5AmCeJeD/3OEjoLs1icOY65Y4cwd/QgFo4fxvLJo+gtHYOJ5yA5QeAToogQBFbDJTFjx2l1fN/3TmLcT6F7CbQ2heRaD9lApQZaMdLYIE0MVGyQ9A1U38D0DLoY/ejsyIGf91X72Pe8/S486U53ANCvb8augzcuLIzt+0jY77xSqGSLSQlGMnQmwUIwtGBQZotJl5Ot4xTNlofnP6+Fo4/3wVqjXiO0Gh6YgVQx4qSDOHkIvccewNLBz+JR1CHCFoLGGOpjm9Ac34LW9A6MbNqBkeltaE1sslmixgjCsAYvCCF93+akBdk4N7PHAyTOgeoil/aWMzuaplBZvB132+gtzaO9OIfl+VkszR6z6dXZx9E+dQy9xTkknWXotAOBLjxh4AeEsYAQtghh4MHLFroxjG6PEdUknve8FsYaDLOsCoZM1d4abVVzLsEqZbCyQxlvMQla/3T9H9x67ANveRWAtQHe0P67D9sgemLi5B1/1uCFfycighcKK8mBQJBJsRfkEizgeQJSEoQA/NCDqUf47K1tfO2OBTTqQD3MtmNSyU6we38ZynZURZJqpCmglIDSEgwP5HmQUQNBbRRhfQJRYwxRo4WgOVZIehBG8PzQOjhSFiGUDX+sB61VCpX0Ecd9JL0+4l4b/eVFxJ1l9DuLSLoLSHqLSOMedJqAWEOQhic1fJ/hewTfF/D8LA/uUZHOtD09rM+gNdCLGcsdxlkHRnDt1aNo6BiqnxbVIKMZShsHUCu1aWKQxvaxig1036BnmjfNjZ37ehAf/r7f/9K62G2opf9rbvg0Hngd5h6a2P+3Qdy5KlDpJi0ZlFqpVTK7XJ0oEx6ayuQgJRp+kOLCC5o4fjzGsce78CVDSIIn7JUB7IYqZIyRfG+4tBNgsgDfKBidQOkOVP8k0g4QHyfM59QVl6CeSTGK2Ni98EnmHMEU5IU88ZL3/fCkvfq8F5E9T5nF4UJACNv1rvi8QMVEZJsUNaCMLVRMTEZ4wQtaaAgN1VXWrub13CLs5DLHnFWzctA5NdBaLvejqfd89YU3HD77gb8C8BQBDACPje9Gr7b5ln668AkvPfWTJHlATVv1bDJvOm9KalkQGgzRTTE56uOSi8fwqU+m6PZSmznKJrTYXJiZR5nxtlZSRcUgk7XYecEF44HdPLTTzJuqhfycKO7Y6nKQW24uB1Ze4omGbDfWxm5p6vUYQkpccukEtk1L6KWudZaYMo+8lGLrNZeg6hQwuXpOgb5o3dILJ2+86qbX4eo/O7Eh3DYM8Pz4AVzwtU8sPbzvzL8Iet3LorS332SSm4NrQx1LBrdxqcumMKB2jL07a7j4RRP4/Odm0e0ZEAn4WbUGQxJPQ1tdDWNaZVyxVXepVLh4w35yKGi0cQKQ28NDKaDfM0gV4fmXTODAGTWg24FKdVamZMdrtiVInUlsmoVFRtnBqUHM4fFeMPnO7/3Dr578wG9eC2BjAG/4uknv/9xDuOaHrsD8xHknG8uHRz3Ve5Eg9vLCOlWWepHDJafht7HqeGprHbEWePxIDwBbW01YvW0RbWwI4XRcFCWta8VrWd+r6qBVJBZPANy8h0e/z+j2gTPPGcOLXzyOKO1DdZNCFRvj2N9CYhlKASYx0KmBSQw4NVAJ6Vi0/jae2v2Xj146Fr/6bV/aKGyrpypXnPy7gOvPvAVTJ27v1yaiv+2j/iWdqQ+TnZxJ81jNPtcZMyIP3JW2VNowjXHJxWM485xx9PpAr8+20YlZX1o3elur//vTcSu672gg7jO6PYPd+0Zw2Ysn0DQJVDvObG3OzsjnyZTzpTgDt0xJ6oQRc/TNxoT3l+2vzS5et/8u4r/AUw9wvhfsFefdQ5e8df9D1Gr+174Kj5tUF6pEKwOTGihlSgchz5/mzlJqkCz30TR9XHH5uAW5x+j12HbT0U4vk++SW2Fzle0l3ekxduwZxZVXTWPCT5EudaFSU2mAV4ZFKps7nRo7h9k8cmIQK39B1Ube8fyXj339h/6P+whynT3tTxpg9xt3fxqtzfVPclT/qyTx+pwyWBkrwanJVqMN2JWy9kXp3KFgpKlBvNTDCBK85CUTOPPccfQToNszhSQb88T+yHfqZpzWTr2+Qa/P2LVvBFdeNYWpMIVa6iFVZaFCG4YyBsqwY3ez5IZjd6EYSSK0CWrvn94i/xGX38+F/RJPJ8AAcAfoizdTrzFVe2cqap9OYzhSbEHOA/XCvmQrU2ehgUoNksUeRhHjyismcP7zJ5FqQqdjY1+tMdAA7dkqtVrbFl3drkGsCGecPYGrrp7GlrqCWuwiTXXGKc+SGE7oo/KRZio6zSRXGaQxkFLty/5o8//7yN+pRbzLIW8/gYsCb/ijN7xmMDly0Tlz9NWbuwujO0cPJX3zQmnSLSJ3tpzYs3RQaMgkMThRqPkC2/e0EDRCHD8Wo9fVpeOG1XeIfqeAZUdyk5TR6TLI93DhxdO47LJxjCCGWuhZcHNGpClLfzqLcU2W1ChUc26PY0ZPRQ/rxvhvXvaHe794+dg9BDV4Hm/58NMMMACceY6hyd3No0ePR/Omn75IQI/QANuNBmKOHGh24g8LskYAxradDYxuqmN+QWFxPgFz3ml2MKdM9J0DN2diKmUbsnX7jNHJGi69YjMuPLuBsNdButRHqsrCfxHnZtmqwj/JJNakBpwyOLV7l3qJP0+NxtvOOJf+sXH/PQbxyqjw6QS4xIoBz2tzMF57eG7WYxXrizzSUUnfqexEqAal2YYuZganClIpTG2KsHXPCBQLzJyMEce6DMF4MGx6pkBd4SUnNrdsSGLPGeN4yUs3Ye9WD2Kpg7TTt9GDw6uyVJ7SVGnH9hplwTWpgU4MerHX02Hrv0/vqb1j166jPSwNP6+NArzhRAf9FMB/PeSNLmjLT830jp86/Z2Lj4rxXrz0n2pQjTKTZbJ8UmXzNywTU6Lc52S6MXylsWmkgauvmMDOXQ3cefspnDzWgYw1olDA92lo3Pq0qGIebLmZKtsfUxnC1OYGzrtwAmecXkdN96FOdZHGKnOmbH1YFyQ562iaHNi0jDhMakuAOjHo92Wi/Pq761tG/+SfP8pLZ/7k0GsEPaGbfCIfHqamARDuBG35xfne3Ne23N3vctPE6QWSjDcw+c7+Xx7Ysee0cs4yPCZO4WmNTZsj7Ng7iqgVod3WWF5SSFMzqOYrjti3A3YVUJu0YCSp9fDjBGiO1XDOhVO49LIp7N4s4bU7SBZ7SFMHXCcU0nn0oDMgVe4tZ+CmBiox6PeE1n7t/fWpxg0fvmnf0V9//TfEEGg5F7Ynkg94YpPw16uADACnge/4wp7NneMLb5Fp+yfqkY68UEB4BOnbe+EJCN/WjIUU2e4Du/VEFFkmW2YLfA9+qwZu1jHXIzz0QBsP3b+AuZkuyBh4nt3tYCs49vtwk/5DMmKreeXVhrllRcvuUR6ZjLB3/xjOOLOF6RGC7HaRLvehEgVtjLNfN29BXEpv7ljl8W2eDDJZ1ajfF8r40YcbU403Pe+qE4/iEAknmf4sApiA7T95sfnI75zc0jm29Jsyaf90PVJ1GQjIgCB9CzD5GaieJQWIDGCZUYFy9WtJAwK+78FvRuBGHUupwKHDPTz68DJOHu2i10nARmelOhdsKnq1rHZFu4FChWaoLI2otN0jFdZ9TG9tYNfeFvbsrmM0YohuD7rdQ5IoC15BvrO/owcYkBmoGcCsjaXcZCBbcGVi/Oj9zenab13wlq0H+W/ukkWnlRWXZHti4D7pwGMdkAk/AX3H7+7e3D6+/AaZLP9CLVBjXpjVigMqJNlKcQ6wrQ8LF2Rhc9lCAJ4geL4HrxFBNCLE5GN22eDE8T6OPd7F/Gwf3U6KNLYTz4ZB4FKq3fYdPNgqkshScP1QotYMMDYRYeu2OrZsr2FqVKIGBe72odp9qNT+vkGZnWNXNTuSaxy7azIJ1hm3SiUGvb7X00H9Xc3p2u+/4C2/+hj/zf/1lIL7bUWW64Jch7nvyK6xuUcXf1Z3e2+IZLotCAkiIHhBrq6thFIOtMjBzgsAJaFPZPuNhCB4noQX+fDqIRCF6JOHfkLo9jSWlhWWl1N0llN02in6PWVz4H0bkwpJ8D2rMYJIot4I0Gx4aI4GGBvz0WxI1EIgYgWKE+iuLc5rldN43csqlNJqtQAKyeUc5ALcMgmU9Bn9xD9louZfNLa0/ssLzn30JBZJrAXudxLg4SADhOtgjnxyqnbwm/J6027/akj988OIyQtEpq4zSc6ZmlJAeLBkdgfkvMiOLPzKY2MpCNKTkL6EF/igwAcHHlhKO3I6DKhs54xsIxmx1RjC9hohrUGpApIUKkmhE2UlbwBUdq7hnHO43U3ZZRGhkOA8hZtlrOIeI9bhg16z/v9u3xf87a6fP7aM9xY2Fyt5oE8e3KckN5QBvcp1UQD4QM8fo7u+FlzSm+//hqe7V9ciE/kZvUf4VnpzdU2eKKQZmV0VeUkyl2RBQ4rwIlsQolTt0jIgIfLyZdnAjLNeXEbl+4FMsbE6p8HmbOmiP5gpnxcZKp1RZvOQyNi8vFZOZU0xdGLQ7QulRPQlr9V821lnq5snG7MpeoM996rS+2SBfaoBXg3kXGED55xhvn5je+/Syd7Pcr/3+pqXbA5CgpfZ5JyNSTJzxHLplQ7/Or/MjoAFmpxL3xDB3dhPFTd6hVfNlYZ0zAOOFwa6C3EJsOOUDdhfbZ2osgzI2SZytipZ+XMIa++vTdTfceGl3j3eqcdk1gpk7RZuzyKA15ZkAuFHoO96x4768rHkFcli7z/56F0U+qYWBFSETjKzzVZlryTYF5IsBrNlJdhOXpRo0Ha4zXKydkucC5Bxw6Wccem0rTIlyCWwprjcq1XJWTEhha0QJYw4EUmM8JvBSO0dE1u9fzrwxsUFvLtXBRdPRUj0tAD8hCQZIARg7Bjhr32msX95pv86jvs/4lOyNwqYhkpz4VXb5y7AeS9xyi4x4/KjC4Cd6zfRsF5nQNmWkavSywPXRzIZ0NbumgG1bJRDVE8N4piQmOBxDqIPtCaj/3X+Zek3/cVZIM7o3ACwekNFPBXgPuX1mQ1IMzLCFrCJ9f0P7KrPHulfpNr9n+ak/4pQplOBD5K+jZnLMCoDNVfXuR0WeYiDbEtoeYU2ykjrtGozFhdsHuxSmAPp3Od9MtgNhQaYGdaJShNwX/tL8KPPhE3/r+rTjVued+2hZdxNw0Kgp0VqnzaAN+hdl9JcA+P5U+a+D8qx+Vn90t5S8mMija/wpZoOfCY/KB0wcmJkckKoHGASZbOVwibTWrXGsl0S5/3EwZUOQnm3gHJLSdkMxSn9pYwkJaTam1ci/Eo4Er2nOe5/8txf68x6Ny4IzLuX1RyWcnnqJfdpA3hDcXJVdUdgbCPzwG2bp44/zleaXvd6k6orPKQ7Q8+QF8CqbWfjm8gv+FJIdCm5ZVmR1s1Ns7vD0A2HnP4YGEhioMhMpQkjSYkVBScg/VupFn140xb5mbMvnD2GhZTQL5Lma4H7lEvtMwLwOnZ5uET7MLiyxvf+/fjE3FF1ge4nr0xjda3U8b5A6rrngTyPILwsfJKDLZOISiblQA2ZVmm9wtWm6lz0ADVuCjIDNrexqQInWvaNCB6VoX+zF/kfb0zVbr/w8nQGR48RegMt57EeuN+1AD8BlT1IIdoCg6un+KE/b4SLs73T4q65rLOkriEVP19Cb5NkRqVk8iVDehjwtl2QsUop2p1azmKl3EMGr9ybqxSgjWBtaFnBO2688K5607up0cQX6uO1g6e/Pu56/3KS0IEY6PayRg/5p1tynzGAn6DariZJGJNgCA+HHxhvzp4Spy/OmfN1P7kIRp0DY3aT0VsEmUgKU+wNErJ0uNaqF7tes2Ee6ImhjYBmEbOQJ0mIQyzkfSIIbmuNiTunN+GhXXsXF0AxMA+BdNUM1DNiZ581AD8JiXbBNhgFY88ZPH9Hu/nQI2Kyu5TsJK0OwKgz0pT2sNI7jTGbiM0YwQQCRgiwIGJrofNmWlkpjpnYgLRhYRhCMYkFKWkG0jvi+ThIUj7I0ru31vQf23Uaz25+cbqMkzPAUQjEK/ZQPOMO1LMS4A2EU2s7ZABQA2McBtf9/4wH/kAe/6LxjzwuQl93RxIlp4n1FqPMRDsOR7VGi1g1iTkCs5/pbQVQbEi2hUfLrTBZFJLmIOTxwFMzStSWJqa93u4XmRTPu1zj0+8jLEKgO3ChmTVj2GcDuN8xgJ9komQ42HmKOYJBDZaElLfp5wBIfaiuRyo1IuvdQCBhpEfsN8ggihkmtj2hGICC7cjbh4AegIw3AuKzAVT35uHZd3MvwlNt0U4rJtpe7ZbQycbAz8QAYngAe9Um0BrI1KxY5RzWAhTrSe93GthnnQSvor6fiBr/dv8bP4n3npWgDpwTP1uRXh1wehoX7jCt8ayyqU8G4CkAs/TsP9fVpPvp0kirgvzdAGx++99LVPWQ6lKxdwAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMi0wMy0wOVQwMDo0MTowMCswMDowMAP6P7kAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjItMDMtMDlUMDA6NDE6MDArMDA6MDByp4cFAAAAAElFTkSuQmCC" })))); };

var ICONS_EMOJIS = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Neutral: SvgIcon$2,
    SlightlyNegative: SvgIcon$3,
    SlightlyPositive: SvgIcon$1,
    VeryNegative: SvgIcon$4,
    VeryPositive: SvgIcon
});

var SvgFacebook$1 = function (props) { return (React.createElement("svg", __assign({ width: "10", height: "18", viewBox: "0 0 10 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.0007 0.666504H7.50065C6.39558 0.666504 5.33577 1.10549 4.55437 1.88689C3.77297 2.66829 3.33398 3.7281 3.33398 4.83317V7.33317H0.833984V10.6665H3.33398V17.3332H6.66732V10.6665H9.16732L10.0007 7.33317H6.66732V4.83317C6.66732 4.61216 6.75512 4.4002 6.9114 4.24392C7.06768 4.08764 7.27964 3.99984 7.50065 3.99984H10.0007V0.666504Z", fill: "#3C5A9A" }))); };

var SvgGoogle$1 = function (props) { return (React.createElement("svg", __assign({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M19.9895 10.1873C19.9895 9.36792 19.9214 8.76998 19.7742 8.1499H10.1992V11.8482H15.8195C15.7062 12.7673 15.0943 14.1514 13.7346 15.0815L13.7155 15.2053L16.7429 17.4972L16.9527 17.5176C18.879 15.7791 19.9895 13.2213 19.9895 10.1873Z", fill: "#4285F4" }),
    React.createElement("path", { d: "M10.2002 19.9312C12.9537 19.9312 15.2653 19.0453 16.9537 17.5173L13.7356 15.0812C12.8744 15.6681 11.7186 16.0777 10.2002 16.0777C7.5034 16.0777 5.2145 14.3393 4.39856 11.9365L4.27897 11.9464L1.13101 14.3271L1.08984 14.439C2.76686 17.6944 6.21158 19.9312 10.2002 19.9312Z", fill: "#34A853" }),
    React.createElement("path", { d: "M4.3965 11.9368C4.18121 11.3167 4.05661 10.6523 4.05661 9.96583C4.05661 9.27927 4.18121 8.61492 4.38517 7.99484L4.37947 7.86278L1.19206 5.44385L1.08778 5.49232C0.3966 6.84324 0 8.36026 0 9.96583C0 11.5714 0.3966 13.0884 1.08778 14.4393L4.3965 11.9368Z", fill: "#FBBC05" }),
    React.createElement("path", { d: "M10.2002 3.85336C12.1152 3.85336 13.4069 4.66168 14.1435 5.33717L17.0216 2.59107C15.254 0.985496 12.9537 0 10.2002 0C6.21158 0 2.76686 2.23672 1.08984 5.49214L4.38724 7.99466C5.2145 5.59183 7.5034 3.85336 10.2002 3.85336Z", fill: "#EB4335" }))); };

var SvgDoorDash = function (props) { return (React.createElement("svg", __assign({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M19.2267 6.68017C18.3388 5.02713 16.6114 4 14.7227 4H0.484299C0.209863 4 0 4.22469 0 4.49752C0 4.62591 0.0484301 4.7543 0.14529 4.83454L3.2448 7.93198C3.51924 8.20481 3.89053 8.3653 4.27797 8.3653H14.3191C15.0294 8.3653 15.6267 8.92701 15.6267 9.63316C15.6267 10.3393 15.0617 10.9331 14.3514 10.9331H7.42591C7.15148 10.9331 6.94161 11.1578 6.94161 11.4306C6.94161 11.559 6.99004 11.6874 7.0869 11.7677L10.1703 14.8651C10.4447 15.1379 10.816 15.2984 11.2034 15.2984H14.3352C18.4195 15.2984 21.5029 10.9652 19.2267 6.68017Z", fill: "#FF3008" }))); };

var SvgGrubhub = function (props) { return (React.createElement("svg", __assign({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.8757 6.01369C16.8415 5.96236 16.8072 5.91103 16.8072 5.8426C16.6276 3.79812 16.3368 2.44654 16.3368 2.44654C16.294 2.21557 16.0888 2.04448 15.8578 2.01027L14.2241 1.81352C14.207 1.81352 14.1985 1.81352 14.1814 1.81352C13.9932 1.81352 13.8392 1.96749 13.8392 2.15569V2.72027C13.8392 2.72883 13.8307 2.73738 13.8221 2.73738C13.8136 2.73738 13.8136 2.73738 13.805 2.72883C12.83 1.84773 11.7266 0.992301 10.512 0.248075C10.2811 0.0940975 10.0074 0 9.708 0C9.40863 0 9.13493 0.0855432 8.90399 0.248075C3.26736 3.73824 0.171066 9.38409 0.0513198 9.69204C0.0171066 9.76048 0 9.84602 0 9.93157C0 10.1882 0.179619 10.4106 0.419112 10.4705L2.03569 10.7784C2.24952 10.8383 2.41203 11.0265 2.43769 11.2489C2.4548 11.5312 2.75416 17.9299 3.13906 19.5808C3.19893 19.8204 3.42132 20 3.67792 20H3.68647C4.63589 19.9743 5.49977 19.9572 6.43208 19.9487H6.44064C6.4663 19.9487 6.49196 19.9487 6.50906 19.9487C6.6117 19.9487 6.68868 19.8631 6.68868 19.769C6.68868 19.769 6.68868 19.769 6.68868 19.7605C6.65447 19.2044 6.56894 17.9299 6.50051 16.5868C6.50051 16.5526 6.49196 16.5098 6.49196 16.4756C6.4834 16.3559 6.42353 16.2532 6.32944 16.2019C5.84191 15.911 5.50833 15.3892 5.48267 14.7904C5.39713 12.5492 5.35437 9.95723 5.47411 7.92985C5.48267 7.75877 5.61952 7.6219 5.79059 7.6219C5.9702 7.6219 6.11561 7.75877 6.12416 7.93841C6.12416 7.94696 6.12416 7.95552 6.12416 7.96407C6.04718 9.31565 6.03863 10.9153 6.06429 12.4893C6.06429 12.7032 6.24391 12.8743 6.45774 12.8657C6.67158 12.8657 6.84264 12.6861 6.83409 12.4722C6.80843 10.8896 6.80843 9.28144 6.89396 7.9213C6.90251 7.75021 7.03937 7.61334 7.21043 7.61334C7.39005 7.61334 7.53546 7.75021 7.54401 7.92985C7.54401 7.93841 7.54401 7.94696 7.54401 7.95552C7.46703 9.29855 7.45848 10.8897 7.48414 12.4551C7.48414 12.6689 7.66376 12.84 7.87759 12.8315C8.09142 12.8315 8.26249 12.6518 8.25394 12.438C8.22828 10.8554 8.23683 9.25577 8.31381 7.91275C8.32236 7.74166 8.45922 7.60479 8.63028 7.60479C8.8099 7.60479 8.95531 7.74166 8.96386 7.9213C8.96386 7.92985 8.96386 7.93841 8.96386 7.94696C8.84411 9.91446 8.88688 12.4123 8.96386 14.6022V14.6193C8.96386 14.6279 8.96386 14.645 8.96386 14.6536C8.96386 14.6621 8.96386 14.6707 8.96386 14.6792C8.96386 15.278 8.66449 15.8084 8.20262 16.1249C8.11708 16.1848 8.06576 16.2703 8.05721 16.3815C8.05721 16.3815 8.01444 16.7151 8.1684 18.349C8.23683 19.059 8.28815 19.5552 8.31381 19.7776C8.32236 19.8631 8.39934 19.9316 8.48487 19.9316C8.53619 19.9316 8.58751 19.9316 8.63883 19.9316C8.94675 19.9316 9.27178 19.9316 9.60536 19.9316H9.66523H9.7251C10.1442 19.9316 10.5548 19.9316 10.9397 19.9316L11.8549 19.9401C11.9404 19.9401 12.0174 19.8717 12.0259 19.7861C12.2398 17.8358 12.2911 16.7408 12.2911 16.7408C12.2911 16.6382 12.2141 16.5697 12.12 16.5526L10.9995 16.3986C10.8199 16.3644 10.7173 16.2618 10.6831 16.1249C10.6574 16.0479 10.666 15.9538 10.666 15.9538C11.1621 9.45252 13.3004 7.26262 13.3004 7.26262C13.3603 7.19418 13.403 7.16852 13.403 7.16852C13.4629 7.12575 13.5313 7.10009 13.6083 7.10009C13.7537 7.10009 13.882 7.19418 13.9248 7.3225C13.9248 7.3225 13.9419 7.36527 13.9504 7.47648C14.1386 9.52096 14.0445 13.0026 13.9333 15.7143C13.8392 18.0154 13.7195 19.8289 13.7195 19.8289C13.7195 19.9059 13.7794 19.9658 13.8563 19.9658C14.4636 19.9743 15.0624 19.9914 15.6953 20H15.7039C15.9605 20 16.1828 19.8204 16.2427 19.5808C16.6276 17.9213 16.9355 11.5312 16.9441 11.2489C16.9698 11.018 17.1323 10.8383 17.3461 10.7784L18.9627 10.4705C19.2022 10.4106 19.3818 10.1882 19.3818 9.93157C19.3818 9.84602 19.3647 9.76903 19.3305 9.69204C19.2877 9.53807 18.4409 7.97263 16.8757 6.01369Z", fill: "#FF8000" }))); };

var SvgUberEats = function (props) { return (React.createElement("svg", __assign({ width: "20", height: "15", viewBox: "0 0 20 15", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M9.39176 12.2537C9.39176 11.4133 8.71949 10.7531 7.87115 10.7531C7.03481 10.7531 6.35054 11.4133 6.35054 12.2537C6.35054 13.094 7.03481 13.7543 7.87115 13.7543C8.71949 13.7543 9.39176 13.094 9.39176 12.2537ZM10.6323 9.7967V14.7147H9.36775V14.2705C8.92757 14.6346 8.37135 14.8387 7.76711 14.8387C6.27051 14.8387 5.10204 13.6903 5.10204 12.2537C5.10204 10.8211 6.27451 9.66865 7.76711 9.66865C8.37135 9.66865 8.92757 9.87273 9.36775 10.2369V9.7967H10.6323ZM14.8339 13.5982H13.8816C13.5934 13.5982 13.4054 13.4742 13.4054 13.2101V10.9091H14.8299V9.7967H13.4054V8.39614H12.1289V9.7967H11.1685V10.9131H12.1289V13.5262C12.1289 14.1865 12.605 14.7107 13.4614 14.7107H14.8299V13.5982H14.8339ZM17.7151 14.8387C19.1757 14.8387 20 14.1544 20 13.2101C20 12.5378 19.5118 12.0376 18.4914 11.8215L17.411 11.6054C16.7867 11.4934 16.5866 11.3773 16.5866 11.1492C16.5866 10.8531 16.8868 10.6731 17.443 10.6731C18.0472 10.6731 18.4874 10.8331 18.6154 11.3773H19.88C19.8119 10.3529 19.0556 9.66865 17.527 9.66865C16.2065 9.66865 15.2781 10.2049 15.2781 11.2413C15.2781 11.9576 15.7903 12.4258 16.8908 12.6538L18.0952 12.926C18.5714 13.018 18.6995 13.142 18.6995 13.3341C18.6995 13.6422 18.3393 13.8343 17.7591 13.8343C17.0308 13.8343 16.6106 13.6743 16.4506 13.13H15.1741C15.3621 14.1544 16.1385 14.8387 17.7151 14.8387ZM0 8.052H4.76591V9.18846H1.28852V10.8171H4.67387V11.9216H1.28852V13.5702H4.76591V14.7067H0V8.052Z", fill: "#06C167" }),
    React.createElement("path", { d: "M19.8679 2.66106V1.76871H19.5278C18.9876 1.76871 18.5874 2.01681 18.3473 2.40496V1.80472H17.379V6.65066H18.3553V3.89756C18.3553 3.14526 18.8195 2.66106 19.4598 2.66106H19.8679ZM12.8411 3.78151C13.0172 3.04122 13.6254 2.54502 14.3497 2.54502C15.074 2.54502 15.6863 3.03721 15.8503 3.78151H12.8411ZM14.3697 1.71268C12.9292 1.71268 11.8327 2.86114 11.8327 4.22969C11.8327 5.67427 12.9732 6.7587 14.4578 6.7587C15.3581 6.7587 16.0944 6.37055 16.5866 5.72229L15.8783 5.21008C15.5102 5.69428 15.026 5.92237 14.4538 5.92237C13.6214 5.92237 12.9532 5.33413 12.8171 4.54582H16.8347V4.23369C16.8387 2.78511 15.7943 1.71268 14.3697 1.71268ZM8.78351 5.92237C7.83513 5.92237 7.07883 5.17007 7.07883 4.2417C7.07883 3.30132 7.84314 2.56102 8.78351 2.56102C9.71188 2.56102 10.4762 3.30132 10.4762 4.2417C10.4802 5.17007 9.71589 5.92237 8.78351 5.92237ZM6.12245 6.65466H7.09084V6.04642C7.53501 6.4946 8.16727 6.76671 8.85154 6.76671C10.3041 6.76671 11.4446 5.63425 11.4446 4.23769C11.4446 2.83313 10.3041 1.70068 8.85154 1.70068C8.16326 1.70068 7.54302 1.97679 7.09884 2.42097V0H6.12245V6.65466ZM2.68507 5.87435C3.62545 5.87435 4.34974 5.16206 4.34974 4.10564V0H5.36615V6.65066H4.35774V6.03441C3.90156 6.4986 3.27331 6.76671 2.56503 6.76671C1.11244 6.76671 0 5.73029 0 4.16166V0H1.02041V4.10564C1.02041 5.18207 1.73669 5.87435 2.68507 5.87435Z", fill: "#142328" }))); };

var SvgDeliveroo = function (props) { return (React.createElement("svg", __assign({ width: "22", height: "24", viewBox: "0 0 22 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15.4673 0.767578L14.4369 10.9793L12.6801 2.36977L7.13948 3.58461L8.87937 12.1942L0.90625 13.9548L2.3252 20.8213L16.3626 23.9377L19.5721 16.4549L21.0924 1.3838L15.4673 0.767578ZM11.0247 15.5922C10.7375 15.8739 10.3659 15.8387 9.94358 15.6978C9.53817 15.557 9.36925 15.064 9.50439 14.4302C9.62263 13.9724 10.1463 13.902 10.4335 13.902C10.5348 13.902 10.6362 13.9196 10.7375 13.9724C10.9233 14.0604 11.2443 14.2541 11.3119 14.5358C11.4132 14.9584 11.3119 15.3105 11.0247 15.5922ZM15.0957 16.05C14.8761 16.4373 14.3356 16.4901 13.7781 16.2084C13.4065 16.0148 13.4065 15.557 13.4572 15.2577C13.4741 15.0992 13.5416 14.9408 13.643 14.8175C13.7781 14.6415 13.9977 14.4126 14.2342 14.4126C14.6565 14.395 14.9944 14.5886 15.1971 14.9408C15.3998 15.2929 15.2984 15.6802 15.0957 16.05Z", fill: "#36B7B1" }))); };

var SvgFoodpanda = function (props) { return (React.createElement("svg", __assign({ width: "30", height: "30", viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15.7601 22.4307C17.3497 22.4307 18.6745 21.2978 18.6745 19.9033H12.8457C12.8457 21.2978 14.0821 22.4307 15.7601 22.4307Z", fill: "#D60765" }),
    React.createElement("path", { d: "M25.5637 10.4035C26.2702 9.88055 26.6235 9.00902 26.6235 8.05034C26.6235 6.30729 25.2105 5 23.4442 5C22.2961 5 21.3246 5.52292 20.7947 6.39444C19.2051 5.61007 17.4388 5.26146 15.6725 5.26146C13.8179 5.26146 12.0516 5.69722 10.5502 6.39444C10.0203 5.52292 9.04888 5 7.90079 5C6.13449 5 4.72145 6.39444 4.72145 8.05034C4.72145 9.00902 5.16304 9.7934 5.78124 10.4035C4.45652 12.3208 3.75 14.4996 3.75 16.9399C3.75 23.3892 9.04888 28.7055 15.6725 28.7055C22.2078 28.7055 27.595 23.4764 27.595 16.9399C27.595 14.4996 26.8885 12.2337 25.5637 10.4035ZM15.7608 27.7468C9.75539 27.7468 4.80977 22.8663 4.80977 16.9399C4.80977 14.6739 5.5163 12.5823 6.66439 10.8392C7.72416 9.27048 9.22551 7.96319 10.9918 7.17882C12.4048 6.4816 14.0828 6.13298 15.7608 6.13298C17.4388 6.13298 19.1168 6.4816 20.5298 7.17882C22.2961 8.05034 23.7091 9.27048 24.8572 10.8392C26.0053 12.5823 26.7118 14.6739 26.7118 16.9399C26.7118 22.8663 21.7662 27.7468 15.7608 27.7468Z", fill: "#D60765" }),
    React.createElement("path", { d: "M15.7607 19.2059C15.9373 19.2931 17.7919 18.5959 17.7919 17.7243C17.7919 17.2014 16.2906 17.1143 15.7607 17.1143C15.2308 17.1143 13.7295 17.2014 13.7295 17.7243C13.6412 18.5959 15.5841 19.2931 15.7607 19.2059Z", fill: "#D60765" }),
    React.createElement("path", { d: "M22.6498 11.885C21.59 11.1878 19.2938 10.8391 18.4107 11.9721C18.4107 11.9721 17.2626 13.1923 18.4107 14.4124C19.5587 15.6325 20.3536 16.8527 20.6185 17.8114C20.8835 18.8572 21.3251 19.2058 22.1199 19.2058C22.9147 19.2058 24.5044 17.9857 24.7693 15.9811C24.946 13.9766 23.7095 12.495 22.6498 11.885ZM20.2653 14.4124C19.912 14.4124 19.6471 14.1509 19.6471 13.8023C19.6471 13.4537 19.912 13.1923 20.2653 13.1923C20.6185 13.1923 20.8835 13.4537 20.8835 13.8023C20.8835 14.1509 20.6185 14.4124 20.2653 14.4124Z", fill: "#D60765" }),
    React.createElement("path", { d: "M13.0241 11.9721C12.1409 10.8391 9.84473 11.1878 8.78495 11.885C7.72518 12.5822 6.48878 13.9766 6.66541 15.9811C6.84204 17.9857 8.4317 19.2058 9.31485 19.2058C10.1097 19.2058 10.5513 18.77 10.8162 17.8114C11.0811 16.7655 11.9643 15.6325 13.0241 14.4124C14.1722 13.1051 13.0241 11.9721 13.0241 11.9721ZM11.3461 14.4124C10.9928 14.4124 10.7279 14.1509 10.7279 13.8023C10.7279 13.4537 10.9928 13.1923 11.3461 13.1923C11.6993 13.1923 11.9643 13.4537 11.9643 13.8023C11.9643 14.1509 11.6993 14.4124 11.3461 14.4124Z", fill: "#D60765" }))); };

var SvgGrab = function (props) { return (React.createElement("svg", __assign({ width: "50", height: "20", viewBox: "0 0 50 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M39.9956 5.98492V0.000976562H41.2145V5.1449C40.877 5.31479 40.4175 5.6357 39.9956 5.98492ZM37.8766 7.78765C38.2516 7.33461 38.636 6.88156 39.0955 6.49459V0.000976562H37.8766V7.78765ZM23.756 12.5446C23.756 14.1397 24.3842 15.6593 25.5375 16.8202C26.6814 17.9717 28.191 18.6135 29.7849 18.6135C30.46 18.6135 31.1538 18.4719 31.6414 18.2265V16.9995C31.0695 17.2449 30.3756 17.3865 29.7849 17.3865C27.1783 17.3865 24.9843 15.1779 24.9843 12.554V11.4497C24.9843 8.82587 27.1877 6.61729 29.7849 6.61729C31.0788 6.61729 32.2884 7.11752 33.1885 8.02361C34.0886 8.92969 34.5855 10.1472 34.5855 11.4497V18.6229H35.8044V11.2138C35.7294 9.64701 35.0637 8.18406 33.9386 7.08921C32.8041 5.99435 31.332 5.3903 29.7849 5.3903C28.2003 5.3903 26.6908 6.02267 25.5375 7.18359C24.3936 8.33508 23.756 9.85466 23.756 11.4592V12.5446ZM42.0021 9.59982C42.5553 9.04295 43.2679 8.73149 43.9711 8.73149C45.4807 8.73149 46.6527 9.92072 46.6527 11.4309V12.5352C46.6527 14.0547 45.4713 15.2345 43.9711 15.2345C43.2398 15.2345 42.5365 14.8287 41.9833 14.1019C41.4958 13.4601 41.177 12.5824 41.1301 11.799L40.1456 13.026C40.3425 13.9509 40.8207 14.8476 41.5052 15.4705C42.2084 16.1123 43.0897 16.471 43.9711 16.471C46.1276 16.471 47.881 14.706 47.881 12.5446V11.4403C47.881 10.4115 47.4684 9.42993 46.7183 8.6843C45.9682 7.92922 44.9931 7.51394 43.9711 7.51394C43.3241 7.51394 42.3021 7.7499 41.0832 8.85419C40.7551 9.18453 39.9862 9.95848 39.5174 10.5059C38.7298 11.3742 37.5953 12.6673 36.6202 13.9792V15.8952C37.6984 14.4983 38.3173 13.715 39.3393 12.5352C40.2394 11.4592 41.3645 10.1661 42.0021 9.59982ZM13.1984 7.28741V5.8339C12.092 5.23928 10.8919 4.97501 9.29793 4.97501C7.66647 4.97501 6.1194 5.57906 4.94738 6.66448C3.76598 7.75933 3.11902 9.19397 3.11902 10.723V11.1194C3.11902 14.2907 5.64122 16.8674 8.75411 16.8674C11.2763 16.8674 12.3171 16.0368 12.5796 15.7725V12.0821H8.45407V13.3091H11.4357V15.159H11.4263C11.0419 15.31 10.2449 15.631 8.75411 15.631C7.57271 15.631 6.45695 15.1685 5.63184 14.319C4.79736 13.4696 4.3473 12.337 4.3473 11.11V10.7135C4.3473 8.26901 6.61634 6.19256 9.30731 6.19256C11.1544 6.202 12.2608 6.51347 13.1984 7.28741ZM22.0871 8.73149C22.5465 8.73149 22.9403 8.80699 23.2591 8.95801C23.4091 8.58047 23.5685 8.25957 23.7935 7.88203C23.4654 7.64607 22.6684 7.49506 22.0871 7.49506C19.8649 7.49506 18.1866 9.18453 18.1866 11.4309V18.604H19.4055V11.4309C19.4055 9.84522 20.5025 8.73149 22.0871 8.73149ZM1 10.723V11.1194C1 13.2525 1.80635 15.2345 3.25966 16.7164C4.71297 18.1888 6.66322 19.0005 8.74474 19.0005C10.4231 19.0005 11.9045 18.6229 13.1609 17.8678C14.1923 17.2449 14.6517 16.622 14.6892 16.5654V9.95848H8.45407V11.1855H13.4703V16.1973C12.8796 16.7919 11.4826 17.7829 8.75411 17.7829C6.97264 17.7829 5.32243 17.0939 4.10352 15.848C2.89399 14.6116 2.22828 12.9316 2.22828 11.1288V10.7324C2.22828 9.02408 2.98775 7.32517 4.31917 6.06986C5.67872 4.78624 7.45082 4.07836 9.30731 4.07836C11.0419 4.07836 12.2421 4.34264 13.2078 4.93725V3.54981C12.1952 3.11565 10.9856 2.92688 9.29793 2.92688C4.79736 2.92688 1 6.49459 1 10.723ZM33.676 18.604V11.4309C33.676 9.22228 31.9602 7.49506 29.7662 7.49506C28.7442 7.49506 27.769 7.91035 27.0189 8.66542C26.2688 9.42049 25.8563 10.4021 25.8563 11.4214V12.5257C25.8563 14.6588 27.6471 16.4521 29.7568 16.4521C30.3381 16.4521 31.1257 16.3105 31.6133 15.9047V14.6305C31.1351 15.0175 30.4506 15.244 29.7568 15.244C28.2566 15.244 27.0752 14.0547 27.0752 12.5446V11.4403C27.0752 9.92072 28.2566 8.74093 29.7568 8.74093C31.2664 8.74093 32.4384 9.93016 32.4384 11.4403V18.6135H33.676V18.604ZM22.0871 6.59841C22.9122 6.59841 23.6341 6.77774 24.2811 7.14584C24.5811 6.75886 24.8905 6.45684 25.1249 6.22088C24.4405 5.69233 23.2778 5.37142 22.0964 5.37142C20.3993 5.37142 18.8617 5.98492 17.7646 7.10808C16.677 8.21238 16.0769 9.75083 16.0769 11.4403V18.6135H17.2958V11.4403C17.2865 8.58991 19.2555 6.59841 22.0871 6.59841ZM48.2185 7.16471C47.0746 6.01323 45.5651 5.37142 43.9711 5.37142C42.8085 5.37142 41.6458 5.80559 40.9988 6.23975C39.6674 7.12696 38.5798 8.09912 36.6108 10.6569V12.4974C38.2798 10.3077 39.855 8.58991 41.0551 7.63663C41.8427 7.00426 42.9585 6.60785 43.9711 6.60785C46.5777 6.60785 48.7717 8.82587 48.7717 11.4403V12.5446C48.7717 13.8377 48.2654 15.0552 47.3465 15.9707C46.437 16.8768 45.2369 17.3771 43.9711 17.3771C41.8333 17.3771 39.9487 15.8952 39.4424 13.8848L38.5798 14.9325C39.208 17.0467 41.477 18.604 43.9711 18.604C45.5651 18.604 47.0652 17.9622 48.2185 16.8108C49.3624 15.6498 50 14.1397 50 12.5352V11.4309C50 9.83578 49.3624 8.3162 48.2185 7.16471Z", fill: "#019C49" }))); };

var SvgYelp$1 = function (props) { return (React.createElement("svg", __assign({ width: "20", height: "21", viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#clip0_9742_47111)" },
        React.createElement("path", { d: "M7.33333 13.1191L8.27169 12.906C8.29128 12.9016 8.32445 12.8942 8.36364 12.8816C8.62283 12.8134 8.84491 12.6491 8.98312 12.4234C9.12132 12.1976 9.16485 11.928 9.10453 11.6714L9.10076 11.6551C9.06974 11.5322 9.01554 11.416 8.94097 11.3126C8.8359 11.1817 8.70585 11.0722 8.55809 10.9901C8.38413 10.8928 8.20209 10.8102 8.01392 10.743L6.98512 10.3739C6.40779 10.1631 5.83045 9.95815 5.24709 9.75768C4.86949 9.626 4.54917 9.50986 4.27105 9.42479C4.21812 9.41042 4.16559 9.39463 4.11353 9.37745C3.77738 9.27684 3.54072 9.23468 3.34099 9.2332C3.20749 9.22832 3.07452 9.25205 2.95132 9.30274C2.82261 9.35743 2.70705 9.43808 2.61216 9.53945C2.56508 9.59191 2.5208 9.64672 2.47951 9.70368C2.39921 9.82476 2.33298 9.95428 2.28204 10.0898C2.0909 10.6439 1.99562 11.2255 2.00015 11.8105C2.00392 12.3386 2.01824 13.017 2.31445 13.4771C2.38605 13.5955 2.48177 13.6976 2.59558 13.7767C2.80661 13.9195 3.01916 13.9387 3.2415 13.9542C3.57313 13.9772 3.89345 13.898 4.21377 13.8248L7.33107 13.1183L7.33333 13.1191ZM17.8022 8.23011C17.5461 7.70241 17.2016 7.22057 16.7832 6.80462C16.7291 6.75172 16.6712 6.70277 16.6099 6.65815C16.5532 6.61643 16.4943 6.57767 16.4335 6.54201C16.3709 6.50834 16.3065 6.47797 16.2406 6.45102C16.1104 6.40081 15.971 6.37812 15.8313 6.38445C15.6979 6.39184 15.5675 6.42883 15.4492 6.49023C15.2705 6.57752 15.0768 6.71807 14.8191 6.95257C14.7837 6.98734 14.7392 7.02655 14.6985 7.06353C14.4867 7.25956 14.25 7.50146 13.9689 7.78256C13.534 8.21383 13.1067 8.64732 12.6808 9.08451L11.9196 9.85976C11.7806 10.0012 11.654 10.1538 11.5412 10.3162C11.4447 10.4536 11.3763 10.6081 11.34 10.7711C11.3196 10.8964 11.3227 11.0242 11.349 11.1484L11.3528 11.1647C11.413 11.421 11.5721 11.6445 11.7968 11.788C12.0214 11.9315 12.294 11.9838 12.5572 11.934C12.5889 11.9296 12.6203 11.9237 12.6514 11.9163L16.7078 10.996C17.0282 10.9235 17.3523 10.8569 17.6394 10.6927C17.8324 10.584 18.0155 10.4752 18.1414 10.2563C18.2084 10.1357 18.249 10.0026 18.2605 9.86568C18.323 9.32271 18.0344 8.7065 17.8022 8.23011ZM10.5403 9.90415C10.8343 9.54167 10.8343 9.00166 10.8599 8.55929C10.9488 7.0835 11.0415 5.60772 11.1162 4.13119C11.144 3.57194 11.2051 3.02009 11.1712 2.45641C11.1433 1.99185 11.1403 1.45775 10.8411 1.07605C10.3135 0.402879 9.18743 0.45836 8.41941 0.563404C8.18249 0.595524 7.94731 0.638974 7.7147 0.693599C7.48106 0.74834 7.24892 0.808259 7.02281 0.880014C6.28569 1.11673 5.24935 1.5517 5.07449 2.38539C4.97501 2.85661 5.21016 3.33818 5.39105 3.76871C5.61188 4.28949 5.91261 4.75923 6.18696 5.24968C6.91277 6.54497 7.65139 7.83287 8.38776 9.1215C8.60859 9.50617 8.84752 9.99292 9.27336 10.1926C9.302 10.2045 9.33064 10.2148 9.36003 10.2245C9.55072 10.2955 9.75949 10.3088 9.95771 10.2637L9.99314 10.2563C10.177 10.2067 10.3429 10.1083 10.4732 9.97294C10.4974 9.95075 10.5192 9.92856 10.5411 9.90415H10.5403ZM10.1883 13.8551C10.0736 13.6967 9.9108 13.578 9.72317 13.516C9.53553 13.4539 9.33271 13.4517 9.14372 13.5097C9.09925 13.524 9.05593 13.5416 9.01408 13.5622C8.94932 13.5946 8.88753 13.6325 8.82942 13.6754C8.6635 13.8037 8.51529 13.9526 8.38851 14.1185C8.3561 14.1592 8.32595 14.2132 8.28676 14.2487L7.63406 15.129C7.26474 15.6231 6.8992 16.118 6.53818 16.6203C6.30152 16.945 6.09802 17.2195 5.93597 17.4614C5.90583 17.5072 5.87417 17.5575 5.84553 17.599C5.65183 17.8919 5.54254 18.1064 5.48601 18.2973C5.44379 18.4241 5.43041 18.5584 5.44682 18.6908C5.46491 18.8284 5.51239 18.9608 5.5855 19.0799C5.6247 19.1391 5.6669 19.1968 5.71212 19.2523C5.8098 19.3626 5.91978 19.4619 6.03998 19.5482C6.4907 19.8559 6.98362 20.0771 7.50216 20.248C7.93403 20.3885 8.38248 20.4729 8.83621 20.498C8.91384 20.5017 8.99147 20.5002 9.06835 20.4936C9.13963 20.487 9.21056 20.4772 9.28089 20.464C9.35125 20.4479 9.42069 20.4282 9.48891 20.4048C9.62154 20.356 9.74223 20.2804 9.84315 20.1829C9.93887 20.0889 10.0127 19.9758 10.0587 19.8507C10.1341 19.6658 10.1838 19.432 10.217 19.0844C10.2192 19.0348 10.2268 18.9756 10.2321 18.9216C10.2577 18.6331 10.2697 18.2928 10.2878 17.8949C10.3202 17.2816 10.3451 16.6713 10.3647 16.0596L10.4069 14.9707C10.4167 14.7206 10.4084 14.4425 10.3376 14.1932C10.3064 14.0734 10.2561 13.9593 10.1883 13.8551ZM17.5543 15.5587C17.4186 15.4115 17.2256 15.2658 16.9211 15.0853C16.8774 15.0609 16.8254 15.0291 16.7779 15.001C16.5247 14.8508 16.2194 14.694 15.8629 14.5039C15.315 14.208 14.7671 13.921 14.2131 13.6354L13.2356 13.1265C13.1851 13.1117 13.1338 13.0762 13.0856 13.0532C12.8976 12.959 12.698 12.8891 12.4917 12.8454C12.4206 12.8319 12.3485 12.8245 12.2761 12.8232C12.2292 12.8229 12.1824 12.8257 12.1359 12.8313C11.9402 12.861 11.7591 12.9505 11.6183 13.0872C11.4775 13.2239 11.3844 13.4008 11.3521 13.5925C11.3377 13.7146 11.3423 13.8381 11.3664 13.9579C11.4139 14.2139 11.5299 14.4661 11.6505 14.6873L12.1721 15.6483C12.463 16.1897 12.757 16.7283 13.0584 17.2653C13.2529 17.6152 13.4149 17.9148 13.5664 18.1634C13.5951 18.21 13.6275 18.2603 13.6523 18.3039C13.837 18.6021 13.9847 18.7899 14.1347 18.9253C14.2346 19.0196 14.3545 19.0911 14.4859 19.1346C14.6172 19.1781 14.7568 19.1925 14.8944 19.1768C14.9662 19.1683 15.0374 19.1559 15.1077 19.1398C15.2519 19.102 15.3913 19.0481 15.523 18.9793C15.9198 18.7611 16.2854 18.4924 16.6106 18.1804C17.001 17.8031 17.3462 17.3918 17.6145 16.9214C17.6522 16.8548 17.6839 16.786 17.711 16.7142C17.7363 16.6485 17.7582 16.5816 17.7766 16.5138C17.7924 16.4442 17.8045 16.3747 17.8128 16.3044C17.8263 16.1663 17.8101 16.0269 17.7653 15.8953C17.721 15.769 17.649 15.6539 17.5543 15.558V15.5587Z", fill: "red" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_9742_47111" },
            React.createElement("rect", { width: "20", height: "20", fill: "white", transform: "translate(0 0.5)" }))))); };

var SvgOpenTable = function (props) { return (React.createElement("svg", __assign({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M1 10C1 9.03947 1.77417 8.25 2.71892 8.25C3.6768 8.25 4.43785 9.03947 4.43785 10C4.43785 10.9605 3.66367 11.75 2.71892 11.75C1.77417 11.75 1 10.9737 1 10ZM13.1112 11.75C12.1533 11.75 11.3923 10.9605 11.3923 10C11.3923 9.03947 12.1664 8.25 13.1112 8.25C14.0691 8.25 14.8301 9.03947 14.8301 10C14.8301 10.9737 14.0559 11.75 13.1112 11.75ZM13.1112 3C9.30594 3 6.22238 6.13158 6.22238 10C6.22238 13.8684 9.30594 17 13.1112 17C16.9164 17 20 13.8684 20 10C20 6.14474 16.9164 3 13.1112 3Z", fill: "#DA3743" }))); };

var SvgTripAdvisor$1 = function (props) { return (React.createElement("svg", __assign({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { "clip-path": "url(#clip0_2854_8976)" },
        React.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM17.3834 6.73632L16.1767 8.04918C16.9164 8.72293 17.38 9.69499 17.3789 10.7754C17.3789 12.8123 15.7253 14.4637 13.6884 14.4637C12.7208 14.4637 11.8404 14.0917 11.1823 13.4816L10.0002 14.7676L8.81805 13.4805C8.15994 14.0905 7.2784 14.4637 6.31079 14.4637C4.27392 14.4637 2.6225 12.8123 2.6225 10.7754C2.6225 9.69611 3.08619 8.72403 3.82585 8.04918L2.61914 6.73632H5.30182C6.63926 5.82237 8.25264 5.28827 10.0001 5.28827C11.7499 5.28827 13.3678 5.82122 14.7074 6.73632H17.3834ZM3.81581 10.7754C3.81581 12.1542 4.9331 13.2715 6.31189 13.2715C7.69065 13.2715 8.80796 12.1542 8.80796 10.7754C8.80796 9.39666 7.69065 8.27934 6.31189 8.27934C4.93313 8.27934 3.81581 9.39666 3.81581 10.7754ZM7.23032 7.04805C8.80687 7.6503 10.0013 9.06034 10.0013 10.7028C10.0013 9.06037 11.1957 7.65142 12.7711 7.04805C11.9186 6.69161 10.9823 6.49385 10.0001 6.49385C9.01803 6.49385 8.08283 6.69161 7.23032 7.04805ZM11.1935 10.7754C11.1935 12.1542 12.3108 13.2715 13.6896 13.2715C15.0683 13.2715 16.1856 12.1542 16.1856 10.7754C16.1856 9.39666 15.0683 8.27934 13.6896 8.27934C12.3108 8.27934 11.1935 9.39666 11.1935 10.7754ZM12.3812 10.7743C12.3812 10.0514 12.9666 9.46592 13.6896 9.46592C14.4125 9.46592 14.9979 10.0525 14.9979 10.7743C14.9979 11.4972 14.4125 12.0827 13.6896 12.0827C12.9666 12.0827 12.3812 11.4972 12.3812 10.7743ZM6.31189 12.0838C7.03478 12.0838 7.62026 11.4983 7.62026 10.7754C7.62026 10.0525 7.03478 9.46592 6.31189 9.46704C5.589 9.46704 5.00351 10.0525 5.00351 10.7754C5.00351 11.4983 5.589 12.0838 6.31189 12.0838Z", fill: "#D84339" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_2854_8976" },
            React.createElement("rect", { width: "20", height: "20", fill: "white" }))))); };

var ICONS_PARTNERS = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Deliveroo: SvgDeliveroo,
    DoorDash: SvgDoorDash,
    Facebook: SvgFacebook$1,
    Foodpanda: SvgFoodpanda,
    Google: SvgGoogle$1,
    Grab: SvgGrab,
    Grubub: SvgGrubhub,
    OpenTable: SvgOpenTable,
    TripAdvisor: SvgTripAdvisor$1,
    UberEats: SvgUberEats,
    Yelp: SvgYelp$1
});

var SvgInstagram = function (props) { return (React.createElement("svg", __assign({ width: "20", height: "21", viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M14.1666 2.16675H5.83329C3.53211 2.16675 1.66663 4.03223 1.66663 6.33342V14.6667C1.66663 16.9679 3.53211 18.8334 5.83329 18.8334H14.1666C16.4678 18.8334 18.3333 16.9679 18.3333 14.6667V6.33342C18.3333 4.03223 16.4678 2.16675 14.1666 2.16675Z", stroke: "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M13.3334 9.97501C13.4362 10.6685 13.3178 11.3769 12.9948 11.9992C12.6719 12.6215 12.161 13.1262 11.5347 13.4414C10.9085 13.7566 10.1987 13.8663 9.50653 13.7549C8.81431 13.6436 8.17484 13.3167 7.67907 12.821C7.1833 12.3252 6.85648 11.6857 6.7451 10.9935C6.63371 10.3013 6.74343 9.59159 7.05865 8.96532C7.37386 8.33905 7.87853 7.82812 8.50086 7.50521C9.12319 7.18229 9.8315 7.06383 10.525 7.16667C11.2325 7.27158 11.8874 7.60123 12.3931 8.10693C12.8988 8.61263 13.2285 9.26757 13.3334 9.97501Z", stroke: "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M14.5834 5.91675H14.5917", stroke: "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgLinkedin = function (props) { return (React.createElement("svg", __assign({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13.3334 6.66675C14.6595 6.66675 15.9312 7.19353 16.8689 8.13121C17.8066 9.0689 18.3334 10.3407 18.3334 11.6667V17.5001H15V11.6667C15 11.2247 14.8244 10.8008 14.5119 10.4882C14.1993 10.1757 13.7754 10.0001 13.3334 10.0001C12.8913 10.0001 12.4674 10.1757 12.1549 10.4882C11.8423 10.8008 11.6667 11.2247 11.6667 11.6667V17.5001H8.33337V11.6667C8.33337 10.3407 8.86016 9.0689 9.79784 8.13121C10.7355 7.19353 12.0073 6.66675 13.3334 6.66675V6.66675Z", stroke: "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M4.99996 7.5H1.66663V17.5H4.99996V7.5Z", stroke: "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M3.33329 5.00008C4.25377 5.00008 4.99996 4.25389 4.99996 3.33341C4.99996 2.41294 4.25377 1.66675 3.33329 1.66675C2.41282 1.66675 1.66663 2.41294 1.66663 3.33341C1.66663 4.25389 2.41282 5.00008 3.33329 5.00008Z", stroke: "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgFacebook = function (props) { return (React.createElement("svg", __assign({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15 1.66675H12.5C11.395 1.66675 10.3352 2.10573 9.55376 2.88714C8.77236 3.66854 8.33337 4.72835 8.33337 5.83341V8.33342H5.83337V11.6667H8.33337V18.3334H11.6667V11.6667H14.1667L15 8.33342H11.6667V5.83341C11.6667 5.6124 11.7545 5.40044 11.9108 5.24416C12.0671 5.08788 12.279 5.00008 12.5 5.00008H15V1.66675Z", stroke: "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))); };

var SvgMessenger = function (props) { return (React.createElement("svg", __assign({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.68348 20V16.4381C1.43554 14.7404 0 12.1549 0 9.25926C0 4.14549 4.47714 0 10 0C15.5232 0 20 4.14549 20 9.25926C20 14.3727 15.5232 18.5185 10 18.5185C8.96964 18.5185 7.97518 18.3741 7.03964 18.1065L3.68348 20ZM3.53906 12.3897L8.93201 6.72317L11.5204 9.34873L16.374 6.72317L11.0115 12.3897L8.4471 9.71733L3.53906 12.3897Z", fill: "white" }))); };

var SvgTiktok = function (props) { return (React.createElement("svg", __assign({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M8.89913 7.97499C6.4458 7.85666 4.73996 8.73124 3.78246 10.5996C2.34663 13.4012 3.53371 17.9862 8.32455 17.9862C13.1158 17.9862 13.2541 13.3567 13.2541 12.8712V7.44833C14.2791 8.09708 15.1429 8.48791 15.8462 8.62041C16.5495 8.75249 16.9962 8.81124 17.1875 8.79624V6.09791C16.537 6.01958 15.9745 5.86999 15.5 5.64958C14.7879 5.31874 13.3766 4.40083 13.3766 3.05541C13.3775 3.06208 13.3775 2.71499 13.3766 2.01416H10.4108C10.402 8.60416 10.402 12.2233 10.4108 12.8717C10.4241 13.8442 9.66955 15.205 8.13996 15.205C6.60996 15.205 5.8558 13.8454 5.8558 12.9687C5.8558 12.4321 6.03996 11.6542 6.80205 11.0779C7.25413 10.7362 7.88121 10.6 8.89913 10.6V7.97499V7.97499Z", stroke: "white", strokeWidth: "2", strokeLinejoin: "round" }))); };

var SvgYelp = function (props) { return (React.createElement("svg", __assign({ width: "20", height: "21", viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#clip0_9742_47111)" },
        React.createElement("path", { d: "M7.33333 13.1191L8.27169 12.906C8.29128 12.9016 8.32445 12.8942 8.36364 12.8816C8.62283 12.8134 8.84491 12.6491 8.98312 12.4234C9.12132 12.1976 9.16485 11.928 9.10453 11.6714L9.10076 11.6551C9.06974 11.5322 9.01554 11.416 8.94097 11.3126C8.8359 11.1817 8.70585 11.0722 8.55809 10.9901C8.38413 10.8928 8.20209 10.8102 8.01392 10.743L6.98512 10.3739C6.40779 10.1631 5.83045 9.95815 5.24709 9.75768C4.86949 9.626 4.54917 9.50986 4.27105 9.42479C4.21812 9.41042 4.16559 9.39463 4.11353 9.37745C3.77738 9.27684 3.54072 9.23468 3.34099 9.2332C3.20749 9.22832 3.07452 9.25205 2.95132 9.30274C2.82261 9.35743 2.70705 9.43808 2.61216 9.53945C2.56508 9.59191 2.5208 9.64672 2.47951 9.70368C2.39921 9.82476 2.33298 9.95428 2.28204 10.0898C2.0909 10.6439 1.99562 11.2255 2.00015 11.8105C2.00392 12.3386 2.01824 13.017 2.31445 13.4771C2.38605 13.5955 2.48177 13.6976 2.59558 13.7767C2.80661 13.9195 3.01916 13.9387 3.2415 13.9542C3.57313 13.9772 3.89345 13.898 4.21377 13.8248L7.33107 13.1183L7.33333 13.1191ZM17.8022 8.23011C17.5461 7.70241 17.2016 7.22057 16.7832 6.80462C16.7291 6.75172 16.6712 6.70277 16.6099 6.65815C16.5532 6.61643 16.4943 6.57767 16.4335 6.54201C16.3709 6.50834 16.3065 6.47797 16.2406 6.45102C16.1104 6.40081 15.971 6.37812 15.8313 6.38445C15.6979 6.39184 15.5675 6.42883 15.4492 6.49023C15.2705 6.57752 15.0768 6.71807 14.8191 6.95257C14.7837 6.98734 14.7392 7.02655 14.6985 7.06353C14.4867 7.25956 14.25 7.50146 13.9689 7.78256C13.534 8.21383 13.1067 8.64732 12.6808 9.08451L11.9196 9.85976C11.7806 10.0012 11.654 10.1538 11.5412 10.3162C11.4447 10.4536 11.3763 10.6081 11.34 10.7711C11.3196 10.8964 11.3227 11.0242 11.349 11.1484L11.3528 11.1647C11.413 11.421 11.5721 11.6445 11.7968 11.788C12.0214 11.9315 12.294 11.9838 12.5572 11.934C12.5889 11.9296 12.6203 11.9237 12.6514 11.9163L16.7078 10.996C17.0282 10.9235 17.3523 10.8569 17.6394 10.6927C17.8324 10.584 18.0155 10.4752 18.1414 10.2563C18.2084 10.1357 18.249 10.0026 18.2605 9.86568C18.323 9.32271 18.0344 8.7065 17.8022 8.23011ZM10.5403 9.90415C10.8343 9.54167 10.8343 9.00166 10.8599 8.55929C10.9488 7.0835 11.0415 5.60772 11.1162 4.13119C11.144 3.57194 11.2051 3.02009 11.1712 2.45641C11.1433 1.99185 11.1403 1.45775 10.8411 1.07605C10.3135 0.402879 9.18743 0.45836 8.41941 0.563404C8.18249 0.595524 7.94731 0.638974 7.7147 0.693599C7.48106 0.74834 7.24892 0.808259 7.02281 0.880014C6.28569 1.11673 5.24935 1.5517 5.07449 2.38539C4.97501 2.85661 5.21016 3.33818 5.39105 3.76871C5.61188 4.28949 5.91261 4.75923 6.18696 5.24968C6.91277 6.54497 7.65139 7.83287 8.38776 9.1215C8.60859 9.50617 8.84752 9.99292 9.27336 10.1926C9.302 10.2045 9.33064 10.2148 9.36003 10.2245C9.55072 10.2955 9.75949 10.3088 9.95771 10.2637L9.99314 10.2563C10.177 10.2067 10.3429 10.1083 10.4732 9.97294C10.4974 9.95075 10.5192 9.92856 10.5411 9.90415H10.5403ZM10.1883 13.8551C10.0736 13.6967 9.9108 13.578 9.72317 13.516C9.53553 13.4539 9.33271 13.4517 9.14372 13.5097C9.09925 13.524 9.05593 13.5416 9.01408 13.5622C8.94932 13.5946 8.88753 13.6325 8.82942 13.6754C8.6635 13.8037 8.51529 13.9526 8.38851 14.1185C8.3561 14.1592 8.32595 14.2132 8.28676 14.2487L7.63406 15.129C7.26474 15.6231 6.8992 16.118 6.53818 16.6203C6.30152 16.945 6.09802 17.2195 5.93597 17.4614C5.90583 17.5072 5.87417 17.5575 5.84553 17.599C5.65183 17.8919 5.54254 18.1064 5.48601 18.2973C5.44379 18.4241 5.43041 18.5584 5.44682 18.6908C5.46491 18.8284 5.51239 18.9608 5.5855 19.0799C5.6247 19.1391 5.6669 19.1968 5.71212 19.2523C5.8098 19.3626 5.91978 19.4619 6.03998 19.5482C6.4907 19.8559 6.98362 20.0771 7.50216 20.248C7.93403 20.3885 8.38248 20.4729 8.83621 20.498C8.91384 20.5017 8.99147 20.5002 9.06835 20.4936C9.13963 20.487 9.21056 20.4772 9.28089 20.464C9.35125 20.4479 9.42069 20.4282 9.48891 20.4048C9.62154 20.356 9.74223 20.2804 9.84315 20.1829C9.93887 20.0889 10.0127 19.9758 10.0587 19.8507C10.1341 19.6658 10.1838 19.432 10.217 19.0844C10.2192 19.0348 10.2268 18.9756 10.2321 18.9216C10.2577 18.6331 10.2697 18.2928 10.2878 17.8949C10.3202 17.2816 10.3451 16.6713 10.3647 16.0596L10.4069 14.9707C10.4167 14.7206 10.4084 14.4425 10.3376 14.1932C10.3064 14.0734 10.2561 13.9593 10.1883 13.8551ZM17.5543 15.5587C17.4186 15.4115 17.2256 15.2658 16.9211 15.0853C16.8774 15.0609 16.8254 15.0291 16.7779 15.001C16.5247 14.8508 16.2194 14.694 15.8629 14.5039C15.315 14.208 14.7671 13.921 14.2131 13.6354L13.2356 13.1265C13.1851 13.1117 13.1338 13.0762 13.0856 13.0532C12.8976 12.959 12.698 12.8891 12.4917 12.8454C12.4206 12.8319 12.3485 12.8245 12.2761 12.8232C12.2292 12.8229 12.1824 12.8257 12.1359 12.8313C11.9402 12.861 11.7591 12.9505 11.6183 13.0872C11.4775 13.2239 11.3844 13.4008 11.3521 13.5925C11.3377 13.7146 11.3423 13.8381 11.3664 13.9579C11.4139 14.2139 11.5299 14.4661 11.6505 14.6873L12.1721 15.6483C12.463 16.1897 12.757 16.7283 13.0584 17.2653C13.2529 17.6152 13.4149 17.9148 13.5664 18.1634C13.5951 18.21 13.6275 18.2603 13.6523 18.3039C13.837 18.6021 13.9847 18.7899 14.1347 18.9253C14.2346 19.0196 14.3545 19.0911 14.4859 19.1346C14.6172 19.1781 14.7568 19.1925 14.8944 19.1768C14.9662 19.1683 15.0374 19.1559 15.1077 19.1398C15.2519 19.102 15.3913 19.0481 15.523 18.9793C15.9198 18.7611 16.2854 18.4924 16.6106 18.1804C17.001 17.8031 17.3462 17.3918 17.6145 16.9214C17.6522 16.8548 17.6839 16.786 17.711 16.7142C17.7363 16.6485 17.7582 16.5816 17.7766 16.5138C17.7924 16.4442 17.8045 16.3747 17.8128 16.3044C17.8263 16.1663 17.8101 16.0269 17.7653 15.8953C17.721 15.769 17.649 15.6539 17.5543 15.558V15.5587Z", fill: "white" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_9742_47111" },
            React.createElement("rect", { width: "20", height: "20", fill: "white", transform: "translate(0 0.5)" }))))); };

var SvgSpotify = function (props) { return (React.createElement("svg", __assign({ width: "21", height: "21", viewBox: "0 0 21 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.2538 0.276978C4.73115 0.276978 0.253906 4.7541 0.253906 10.2768C0.253906 15.7997 4.73115 20.2765 10.2538 20.2765C15.7771 20.2765 20.2539 15.7997 20.2539 10.2768C20.2539 4.75446 15.7771 0.277455 10.2537 0.277455L10.2538 0.276978ZM14.8398 14.6996C14.6606 14.9933 14.2761 15.0865 13.9824 14.9062C11.6345 13.472 8.6788 13.1472 5.19793 13.9425C4.8625 14.0189 4.52815 13.8088 4.45173 13.4732C4.37494 13.1377 4.58427 12.8033 4.92054 12.7269C8.72979 11.8566 11.9973 12.2313 14.6332 13.8422C14.9269 14.0225 15.0201 14.4058 14.8398 14.6996ZM16.0637 11.9768C15.838 12.3436 15.358 12.4594 14.9914 12.2337C12.3034 10.5815 8.20605 10.1031 5.02669 11.0681C4.61436 11.1927 4.17887 10.9603 4.05372 10.5487C3.92953 10.1364 4.16203 9.70171 4.57364 9.57633C8.20533 8.47439 12.7202 9.00816 15.807 10.905C16.1736 11.1307 16.2894 11.6106 16.0637 11.9768ZM16.1688 9.14143C12.9459 7.22713 7.62845 7.05112 4.55131 7.98504C4.05719 8.1349 3.53464 7.85595 3.3849 7.36183C3.23515 6.86746 3.51386 6.34527 4.00835 6.19505C7.54068 5.12273 13.4128 5.32991 17.1234 7.53271C17.5688 7.79649 17.7145 8.3705 17.4506 8.81436C17.1879 9.25881 16.6123 9.40533 16.1693 9.14143H16.1688Z", fill: "white" }))); };

var SvgTwitter = function (props) { return (React.createElement("svg", __assign({ width: "20", height: "17", viewBox: "0 0 20 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6.2898 16.2602C13.8373 16.2602 17.9648 10.005 17.9648 4.58081C17.9648 4.40317 17.9612 4.22634 17.9532 4.05024C18.7563 3.46891 19.4494 2.74912 20 1.92463C19.2648 2.25163 18.4736 2.47171 17.6436 2.57093C18.4908 2.06276 19.1411 1.25882 19.448 0.300528C18.6425 0.778534 17.7613 1.1155 16.8424 1.29691C16.0936 0.499024 15.0276 0 13.8472 0C11.5812 0 9.74362 1.83829 9.74362 4.10427C9.74362 4.42642 9.77967 4.73967 9.85008 5.04024C6.43972 4.86858 3.41565 3.23516 1.39179 0.751463C1.02727 1.3779 0.835542 2.08986 0.836179 2.81463C0.836179 4.23878 1.56057 5.49598 2.66219 6.2315C2.01057 6.2116 1.37325 6.03552 0.803821 5.71809C0.803211 5.73532 0.803211 5.75211 0.803211 5.77053C0.803211 7.75846 2.2176 9.41825 4.09516 9.79435C3.74253 9.89042 3.37865 9.93899 3.01317 9.93878C2.74923 9.93878 2.49199 9.9128 2.24199 9.8648C2.76439 11.4958 4.27919 12.6826 6.07516 12.7158C4.67073 13.817 2.90159 14.4729 0.97878 14.4729C0.651687 14.4732 0.32486 14.4542 0 14.416C1.81602 15.5804 3.97236 16.2599 6.29 16.2599", fill: "white" }))); };

var SvgWhatsapp = function (props) { return (React.createElement("svg", __assign({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#clip0_850_4099)" },
        React.createElement("path", { d: "M10.1036 17.934C8.44204 17.934 6.89142 17.4332 5.59604 16.5809L2.44642 17.5872L3.46739 14.5437C2.48502 13.1952 1.90725 11.5338 1.90725 9.74231C1.90725 5.22514 5.58164 1.55076 10.0988 1.55076C14.616 1.55076 18.2904 5.22514 18.2904 9.74231C18.2904 14.2593 14.616 17.9339 10.0988 17.9339H10.1036V17.934ZM10.1036 0C4.72417 0 0.361254 4.36332 0.361254 9.74245C0.361254 11.582 0.87174 13.3061 1.75775 14.7749L0 20L5.39381 18.2712C6.83549 19.0684 8.45616 19.486 10.1036 19.4848C15.4828 19.4848 19.8459 15.1217 19.8459 9.74245C19.8457 4.36332 15.4828 0 10.1036 0Z", fill: "#FEFEFE" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.91211 9.74234C1.91211 5.22516 5.58649 1.55078 10.1037 1.55078V1.55092H10.1084C14.6256 1.55092 18.3 5.2253 18.3 9.74247C18.3 14.2595 14.6256 17.934 10.1084 17.934C8.44214 17.934 6.89628 17.4381 5.6009 16.5809L2.45141 17.5872L3.47238 14.5437C2.49001 13.1952 1.91211 11.5338 1.91211 9.74234ZM7.29618 5.30712C7.53688 5.31691 7.65729 5.33131 7.81618 5.71173C7.8675 5.8356 7.938 6.00664 8.01527 6.19408C8.23532 6.72791 8.5102 7.39476 8.55296 7.48389C8.61072 7.60431 8.66862 7.76808 8.58666 7.92696C8.51497 8.07932 8.45163 8.15251 8.34621 8.27435C8.3383 8.28348 8.33017 8.29289 8.32177 8.30262C8.27023 8.36242 8.2196 8.41601 8.16909 8.46947C8.10157 8.54093 8.03429 8.61214 7.96541 8.69758C7.96348 8.69985 7.96155 8.70211 7.95961 8.70438C7.85049 8.83242 7.7319 8.97156 7.86918 9.20807C8.00876 9.44401 8.4903 10.2289 9.19827 10.8597C10.0385 11.6069 10.7324 11.8875 11.0453 12.014C11.0732 12.0253 11.0981 12.0354 11.1198 12.0444C11.3171 12.1264 11.5532 12.1071 11.6977 11.9529C11.8543 11.7841 12.0425 11.52 12.2384 11.2452C12.2715 11.1988 12.3048 11.152 12.3382 11.1054C12.5019 10.8742 12.7089 10.8453 12.9257 10.9271C13.1472 11.0041 14.3175 11.582 14.5582 11.7025C14.6074 11.7271 14.6531 11.7491 14.6953 11.7694C14.8597 11.8484 14.9697 11.9013 15.0157 11.9818C15.0736 12.0829 15.0736 12.5597 14.8761 13.1184C14.6786 13.6769 13.8936 14.1394 13.2676 14.2742C12.8391 14.3657 12.2803 14.438 10.3974 13.6578C8.16718 12.7343 6.67225 10.5673 6.36818 10.1266C6.34397 10.0915 6.32731 10.0673 6.31843 10.0556C6.31504 10.051 6.31102 10.0455 6.3064 10.0391C6.1534 9.82997 5.3457 8.72567 5.3457 7.58501C5.3457 6.44287 5.90987 5.86952 6.16253 5.61275C6.16982 5.60535 6.17685 5.5982 6.1836 5.59131C6.38108 5.38908 6.70849 5.29761 7.02163 5.29761C7.11322 5.29806 7.20478 5.30123 7.29618 5.30712Z", fill: "white" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_850_4099" },
            React.createElement("rect", { width: "20", height: "20", fill: "white" }))))); };

var SvgPinterest = function (props) { return (React.createElement("svg", __assign({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#clip0_722_3519)" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.9674 19.7112C15.3452 19.7112 19.7063 15.3501 19.7063 9.97229C19.7063 4.59451 15.3452 0.233398 9.9674 0.233398C4.58963 0.233398 0.228516 4.59451 0.228516 9.97229C0.228516 14.0427 2.72695 17.5307 6.27361 18.986C5.9736 16.662 6.51299 14.7455 7.03747 12.8819C7.23002 12.1977 7.42055 11.5207 7.56681 10.8333C6.62237 9.31665 7.68348 6.25554 9.67792 7.0111C10.8539 7.4554 10.4155 8.76862 9.9774 10.0813C9.50062 11.5097 9.02406 12.9376 10.6279 13.2444C13.839 13.8611 15.1501 7.93332 13.1613 6.00554C10.2779 3.22776 4.78348 5.94443 5.46126 9.92221C5.54459 10.4167 6.3557 11.1944 6.3557 11.1944C6.3557 11.1944 6.31681 11.6667 6.1057 12.5389C4.26126 12.15 3.48903 10.7667 3.56126 8.92221C3.67237 5.89999 6.4057 3.78887 9.15014 3.49443C12.6168 3.12221 15.8724 4.70554 16.3279 7.81665C16.8335 11.3278 14.7613 15.1278 11.0501 14.8555C10.2967 14.8014 9.87073 14.5196 9.37263 14.1901C9.20598 14.0798 9.03125 13.9642 8.83348 13.85C8.41528 15.941 7.90911 17.9492 6.46109 19.0607C7.54909 19.4808 8.73139 19.7112 9.9674 19.7112Z", fill: "white" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_722_3519" },
            React.createElement("rect", { width: "20", height: "20", fill: "white" }))))); };

var SvgSnapchat = function (props) { return (React.createElement("svg", __assign({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M9.81007 1C9.38184 1 8.47321 1.06607 7.48677 1.50251C6.49989 1.93895 5.43344 2.77096 4.76958 4.26023C4.26831 5.38262 4.41613 7.01621 4.49786 8.32205C4.50438 8.41855 4.50656 8.50201 4.51134 8.59373C4.47047 8.61199 4.50612 8.62068 4.37526 8.62068C4.17832 8.62068 3.9153 8.55635 3.5875 8.40333C3.45707 8.34248 3.31752 8.32161 3.1797 8.32161C2.93007 8.32367 2.68581 8.39435 2.47367 8.52592C2.26108 8.65459 2.05718 8.85499 1.99805 9.16406C1.9624 9.35445 2.00283 9.63962 2.18804 9.87044C2.37324 10.1013 2.66018 10.2899 3.11188 10.4681C3.21057 10.5073 3.31056 10.5447 3.41099 10.5768C3.61489 10.6412 3.85443 10.7111 4.03572 10.8076C4.21745 10.9046 4.3244 11.0185 4.36179 11.1067C4.40265 11.2015 4.41439 11.3493 4.28049 11.6227C4.27531 11.6315 4.27081 11.6406 4.26701 11.6501C4.26527 11.6566 4.25832 11.6618 4.2531 11.677C4.19875 11.7996 3.00841 14.3939 0.530771 14.8017C0.377457 14.8256 0.238457 14.9055 0.140591 15.0259C0.0427252 15.1463 -0.00707096 15.2987 0.0008109 15.4537C0.0060279 15.5472 0.0364603 15.6471 0.0686318 15.7254C0.189492 16.0088 0.447299 16.2179 0.87031 16.4044C1.26072 16.5778 1.86893 16.7304 2.67713 16.8665C2.69756 16.9225 2.72495 17.0273 2.75886 17.1786C2.75886 17.1821 2.75712 17.189 2.75886 17.1925C2.7893 17.3333 2.81799 17.4881 2.86755 17.6541C2.91668 17.8237 3.04232 17.9906 3.19361 18.0754C3.34447 18.1601 3.4875 18.1706 3.57402 18.1706C3.75401 18.1706 3.90356 18.1332 4.06311 18.1023C4.32614 18.0514 4.64394 17.9936 5.05478 17.9936C5.28215 17.9936 5.51996 18.0093 5.76125 18.0484C6.17426 18.1162 6.57988 18.3844 7.06549 18.7274C7.76849 19.2251 8.61277 19.8276 9.87789 19.8276C9.89963 19.8276 9.92354 19.8159 9.94571 19.8141C9.96745 19.8159 9.99136 19.8141 10.0135 19.8141C10.0492 19.8159 10.0866 19.8276 10.1222 19.8276C11.3873 19.8276 12.2299 19.2251 12.9346 18.7274C13.4185 18.384 13.8259 18.1162 14.2389 18.048C14.4725 18.0111 14.7088 17.9931 14.9453 17.9941C15.3427 17.9941 15.657 18.0449 15.9509 18.1027C16.1379 18.1397 16.28 18.1566 16.4261 18.1566H16.4535C16.5874 18.1566 16.7422 18.1197 16.8743 18.021C16.997 17.9291 17.0874 17.8006 17.1326 17.6541C17.1821 17.4876 17.2091 17.3281 17.2412 17.179C17.2626 17.0732 17.2899 16.9687 17.323 16.866C18.1316 16.7304 18.7394 16.5778 19.1298 16.4044C19.5528 16.2175 19.8106 16.0071 19.9315 15.7254C19.9671 15.6437 19.9941 15.5472 19.9993 15.4537C20.0066 15.2989 19.9566 15.1468 19.8588 15.0265C19.7611 14.9062 19.6224 14.8262 19.4693 14.8017C18.2194 14.596 17.3025 13.844 16.6843 13.1172C16.0696 12.3939 15.764 11.7027 15.747 11.6636V11.6501C15.7431 11.6406 15.7384 11.6315 15.7331 11.6227C15.5975 11.3493 15.5975 11.2032 15.6383 11.1067C15.6757 11.0185 15.7827 10.9046 15.9644 10.8076C16.1461 10.7111 16.3839 10.6412 16.5891 10.5768C16.6913 10.5447 16.793 10.5055 16.8882 10.4681C17.2839 10.3117 17.5556 10.1491 17.7438 9.95173C17.9325 9.75481 18.019 9.51051 18.016 9.29968C18.0073 8.85499 17.676 8.55939 17.2956 8.41724L17.2821 8.40333C17.2786 8.4016 17.2721 8.40507 17.2686 8.40333C17.1132 8.34051 16.9472 8.30819 16.7795 8.30814C16.6201 8.30305 16.4618 8.33567 16.3174 8.40333C16.0218 8.54244 15.774 8.61069 15.584 8.62068H15.5701C15.5583 8.62068 15.567 8.62242 15.557 8.62068C15.5005 8.61373 15.5179 8.6033 15.4888 8.5933C15.494 8.51896 15.4975 8.45246 15.5022 8.37595V8.32161C15.5857 7.01621 15.7318 5.38436 15.2305 4.26023C14.5667 2.77096 13.502 1.92547 12.5133 1.48903C11.7807 1.16879 10.9901 1.00234 10.1905 1H10.1357H9.81007Z", fill: "white" }),
    React.createElement("path", { d: "M9.81007 1C9.38184 1 8.47321 1.06607 7.48677 1.50251C6.49989 1.93895 5.43344 2.77096 4.76958 4.26023C4.26831 5.38262 4.41613 7.01621 4.49786 8.32205C4.50438 8.41855 4.50656 8.50201 4.51134 8.59373C4.47047 8.61199 4.50612 8.62068 4.37526 8.62068C4.17832 8.62068 3.9153 8.55635 3.5875 8.40333C3.45707 8.34248 3.31752 8.32161 3.1797 8.32161C2.93007 8.32367 2.68581 8.39435 2.47367 8.52592C2.26108 8.65459 2.05718 8.85499 1.99805 9.16406C1.9624 9.35445 2.00283 9.63962 2.18804 9.87044C2.37324 10.1013 2.66018 10.2899 3.11188 10.4681C3.21057 10.5073 3.31056 10.5447 3.41099 10.5768C3.61489 10.6412 3.85443 10.7111 4.03572 10.8076C4.21745 10.9046 4.3244 11.0185 4.36179 11.1067C4.40265 11.2015 4.41439 11.3493 4.28049 11.6227C4.27531 11.6315 4.27081 11.6406 4.26701 11.6501C4.26527 11.6566 4.25832 11.6618 4.2531 11.677C4.19875 11.7996 3.00841 14.3939 0.530771 14.8017C0.377457 14.8256 0.238457 14.9055 0.140591 15.0259C0.0427252 15.1463 -0.00707096 15.2987 0.0008109 15.4537C0.0060279 15.5472 0.0364603 15.6471 0.0686318 15.7254C0.189492 16.0088 0.447299 16.2179 0.87031 16.4044C1.26072 16.5778 1.86893 16.7304 2.67713 16.8665C2.69756 16.9225 2.72495 17.0273 2.75886 17.1786C2.75886 17.1821 2.75712 17.189 2.75886 17.1925C2.7893 17.3333 2.81799 17.4881 2.86755 17.6541C2.91668 17.8237 3.04232 17.9906 3.19361 18.0754C3.34447 18.1601 3.4875 18.1706 3.57402 18.1706C3.75401 18.1706 3.90356 18.1332 4.06311 18.1023C4.32614 18.0514 4.64394 17.9936 5.05478 17.9936C5.28215 17.9936 5.51996 18.0093 5.76125 18.0484C6.17426 18.1162 6.57988 18.3844 7.06549 18.7274C7.76849 19.2251 8.61277 19.8276 9.87789 19.8276C9.89963 19.8276 9.92354 19.8159 9.94571 19.8141C9.96745 19.8159 9.99136 19.8141 10.0135 19.8141C10.0492 19.8159 10.0866 19.8276 10.1222 19.8276C11.3873 19.8276 12.2299 19.2251 12.9346 18.7274C13.4185 18.384 13.8259 18.1162 14.2389 18.048C14.4725 18.0111 14.7088 17.9931 14.9453 17.9941C15.3427 17.9941 15.657 18.0449 15.9509 18.1027C16.1379 18.1397 16.28 18.1566 16.4261 18.1566H16.4535C16.5874 18.1566 16.7422 18.1197 16.8743 18.021C16.997 17.9291 17.0874 17.8006 17.1326 17.6541C17.1821 17.4876 17.2091 17.3281 17.2412 17.179C17.2626 17.0732 17.2899 16.9687 17.323 16.866C18.1316 16.7304 18.7394 16.5778 19.1298 16.4044C19.5528 16.2175 19.8106 16.0071 19.9315 15.7254C19.9671 15.6437 19.9941 15.5472 19.9993 15.4537C20.0066 15.2989 19.9566 15.1468 19.8588 15.0265C19.7611 14.9062 19.6224 14.8262 19.4693 14.8017C18.2194 14.596 17.3025 13.844 16.6843 13.1172C16.0696 12.3939 15.764 11.7027 15.747 11.6636V11.6501C15.7431 11.6406 15.7384 11.6315 15.7331 11.6227C15.5975 11.3493 15.5975 11.2032 15.6383 11.1067C15.6757 11.0185 15.7827 10.9046 15.9644 10.8076C16.1461 10.7111 16.3839 10.6412 16.5891 10.5768C16.6913 10.5447 16.793 10.5055 16.8882 10.4681C17.2839 10.3117 17.5556 10.1491 17.7438 9.95173C17.9325 9.75481 18.019 9.51051 18.016 9.29968C18.0073 8.85499 17.676 8.55939 17.2956 8.41724L17.2821 8.40333C17.2786 8.4016 17.2721 8.40507 17.2686 8.40333C17.1132 8.34051 16.9472 8.30819 16.7795 8.30814C16.6201 8.30305 16.4618 8.33567 16.3174 8.40333C16.0218 8.54244 15.774 8.61069 15.584 8.62068H15.5701C15.5583 8.62068 15.567 8.62242 15.557 8.62068C15.5005 8.61373 15.5179 8.6033 15.4888 8.5933C15.494 8.51896 15.4975 8.45246 15.5022 8.37595V8.32161C15.5857 7.01621 15.7318 5.38436 15.2305 4.26023C14.5667 2.77096 13.502 1.92547 12.5133 1.48903C11.7807 1.16879 10.9901 1.00234 10.1905 1H10.1357H9.81007ZM9.81007 1.8694H10.1905C10.5383 1.8694 11.3282 1.92373 12.1599 2.29018C12.9924 2.65707 13.8685 3.32476 14.4423 4.61321C14.7684 5.3435 14.7162 6.96318 14.6327 8.26727V8.32161C14.621 8.50332 14.6006 8.68024 14.5923 8.85194C14.5907 8.91277 14.6019 8.97326 14.6253 9.02944C14.6487 9.08562 14.6837 9.13624 14.728 9.17797C14.7958 9.24752 15.0814 9.47139 15.5566 9.49008H15.5835C15.9357 9.4766 16.3039 9.36967 16.6843 9.19101C16.7153 9.18209 16.7473 9.17769 16.7795 9.17797C16.8339 9.17797 16.9052 9.19101 16.9426 9.20492C16.9461 9.20666 16.9526 9.20318 16.9561 9.20492C16.9649 9.20993 16.9741 9.21443 16.9834 9.21839C17.0852 9.25404 17.1326 9.2949 17.146 9.31359C17.1495 9.31707 17.1447 9.32533 17.146 9.32707C17.1413 9.33576 17.136 9.33576 17.1191 9.35445C17.056 9.42053 16.883 9.5392 16.5622 9.66657C16.4861 9.69653 16.4089 9.72378 16.3309 9.74829C16.1257 9.81262 15.8335 9.90087 15.557 10.0469C15.2801 10.193 14.9875 10.4086 14.8366 10.7672C14.6754 11.1454 14.7432 11.5618 14.9319 11.9626C14.9336 11.9692 14.9301 11.9709 14.9319 11.9757C14.9384 11.9948 14.9453 12.0048 14.9453 12.0031C14.9845 12.093 15.314 12.8607 16.0187 13.6875C16.6522 14.4313 17.6151 15.2003 18.8989 15.535C18.8446 15.5706 18.8816 15.5689 18.7763 15.6167C18.4642 15.7541 17.9273 15.9019 17.0513 16.0375C16.8035 16.0749 16.6182 16.3096 16.5483 16.4722C16.4787 16.6356 16.443 16.7969 16.3991 17.0025C16.3787 17.0973 16.3531 17.1838 16.3309 17.2738C16.2718 17.269 16.2222 17.269 16.1135 17.2468C15.7291 17.1675 15.3378 17.1264 14.9453 17.1242C14.6671 17.1242 14.3884 17.1447 14.1028 17.1925C13.4354 17.3046 12.9159 17.678 12.432 18.021C11.7256 18.5187 11.1243 18.9582 10.1222 18.9582C10.0818 18.9582 10.0409 18.96 10.0001 18.9582C9.98198 18.9565 9.96379 18.9565 9.94571 18.9582C9.92832 18.96 9.89789 18.9582 9.87789 18.9582C8.87579 18.9582 8.27106 18.5187 7.56807 18.021C7.08245 17.6776 6.56466 17.3029 5.89732 17.1925C5.61885 17.1464 5.33703 17.1236 5.05478 17.1242C4.66216 17.1267 4.27074 17.1677 3.88617 17.2468C3.78096 17.2673 3.74183 17.279 3.68271 17.2872C3.6588 17.1925 3.62315 17.1025 3.60097 17.0021C3.56011 16.8152 3.53315 16.6509 3.46533 16.4861C3.42739 16.3907 3.37212 16.3032 3.3023 16.2279C3.22057 16.141 3.10014 16.0714 2.96276 16.0514C2.08804 15.9153 1.53591 15.7541 1.22376 15.6167C1.11507 15.5689 1.15551 15.5724 1.10116 15.535C3.80965 14.8351 4.98869 12.1561 5.05478 12.0031L5.06825 11.9761C5.06999 11.9709 5.06651 11.9692 5.06825 11.9622C5.25694 11.5618 5.32476 11.1458 5.16346 10.7668C5.01043 10.4086 4.72002 10.193 4.44352 10.0469C4.16658 9.90087 3.88791 9.81262 3.68271 9.74829C3.58271 9.71612 3.48881 9.68743 3.43794 9.66657C3.07275 9.52225 2.9132 9.38488 2.86755 9.32707C2.86755 9.33576 2.85712 9.29838 2.92189 9.25925C2.99319 9.21665 3.11884 9.19101 3.18014 9.19101C3.21405 9.19101 3.21231 9.19275 3.20709 9.19101C3.61489 9.3814 4.00181 9.49008 4.3757 9.49008C4.89175 9.49008 5.20085 9.26577 5.28563 9.17753C5.32752 9.13465 5.36001 9.08351 5.38104 9.02738C5.40208 8.97125 5.41119 8.91135 5.40779 8.85151C5.39779 8.66155 5.3791 8.46767 5.36736 8.26771C5.28563 6.96188 5.23129 5.3435 5.55735 4.61321C6.13122 3.3265 6.99593 2.65707 7.82631 2.29018C8.45301 2.01945 9.12741 1.87639 9.81007 1.8694Z", fill: "white" }))); };

var SvgYoutube = function (props) { return (React.createElement("svg", __assign({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.4431 16.9817L6.33986 16.9057C5.01133 16.8793 3.67949 16.9321 2.37701 16.6579C0.395628 16.2483 0.25526 14.2399 0.10838 12.5553C-0.0940059 10.1868 -0.0156563 7.77543 0.366272 5.42677C0.581883 4.10893 1.4304 3.32257 2.7426 3.237C7.17225 2.92645 11.6314 2.96325 16.0512 3.10813C16.518 3.12141 16.988 3.19401 17.4482 3.27664C19.7203 3.67966 19.7757 5.95561 19.923 7.87154C20.0698 9.80724 20.0078 11.7529 19.7271 13.6754C19.5019 15.2672 19.0709 16.6021 17.2524 16.7309C14.9738 16.8994 12.7476 17.0351 10.4626 16.9919C10.4627 16.9817 10.4496 16.9817 10.4431 16.9817ZM8.03079 12.9517C9.74786 11.954 11.4322 10.973 13.1394 9.98204C11.4191 8.98438 9.73804 8.00335 8.03079 7.01238V12.9517Z", fill: "white" }))); };

var SvgGoogle = function (props) { return (React.createElement("svg", __assign({ width: "20", height: "21", viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#clip0)" },
        React.createElement("path", { d: "M5.76888 7.46751C6.73998 6.19001 8.27521 5.36352 10.0001 5.36352C11.419 5.36352 12.7531 5.9161 13.7566 6.9195L14.1709 7.3338L17.4854 4.01927L17.0711 3.60497C15.1824 1.71622 12.6712 0.676025 10.0001 0.676025C7.32896 0.676025 4.81775 1.71622 2.92896 3.60493C2.75751 3.77642 2.59326 3.95313 2.43591 4.1345L5.76888 7.46751Z", fill: "white" }),
        React.createElement("path", { d: "M16.5415 18.2402C16.7229 18.0829 16.8996 17.9186 17.0711 17.7472C18.9598 15.8584 20 13.3472 20 10.6761C20 10.0677 19.9449 9.45813 19.8363 8.86446L19.7483 8.38403H9.41406V13.0715H14.7442C14.3756 13.8049 13.8483 14.4301 13.213 14.9117L16.5415 18.2402Z", fill: "white" }),
        React.createElement("path", { d: "M12.172 15.528C11.5044 15.8258 10.7678 15.9886 10.0001 15.9886C8.27521 15.9886 6.73998 15.1621 5.76888 13.8846L2.43591 17.2176C2.59326 17.399 2.75751 17.5757 2.92896 17.7472C4.81775 19.6359 7.32896 20.6761 10.0001 20.6761C12.028 20.6761 13.9635 20.076 15.6047 18.9607L12.172 15.528Z", fill: "white" }),
        React.createElement("path", { d: "M5.1509 12.8451C4.85328 12.1824 4.6875 11.4482 4.6875 10.6759C4.6875 9.90367 4.85328 9.16945 5.1509 8.50676L1.71543 5.07129C0.600117 6.7125 0 8.64797 0 10.6759C0 12.7039 0.600117 14.6394 1.71543 16.2806L5.1509 12.8451Z", fill: "white" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0" },
            React.createElement("rect", { width: "20", height: "20", fill: "white", transform: "translate(0 0.676025)" }))))); };

var SvgLine = function (props) { return (React.createElement("svg", __assign({ width: "20", height: "21", viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M19.9535 8.41021L19.9537 8.41015L19.9475 8.35889C19.9474 8.35801 19.9473 8.35734 19.9472 8.35646C19.9471 8.35572 19.9471 8.35504 19.9469 8.3543L19.9237 8.16154C19.9191 8.12282 19.9137 8.07871 19.9077 8.0284L19.9028 7.98833L19.8929 7.98955C19.6489 6.60209 18.9788 5.28538 17.9408 4.1611C16.9077 3.04222 15.5655 2.1588 14.0594 1.60633C12.7689 1.13299 11.3997 0.892944 9.98981 0.892944C8.08645 0.892944 6.23792 1.34059 4.64414 2.18746C1.57077 3.82043 -0.241805 6.82197 0.026096 9.8343C0.164768 11.3931 0.775435 12.8768 1.79214 14.1254C2.74908 15.3005 4.04359 16.2488 5.53566 16.8678C6.45308 17.2483 7.36018 17.4276 8.32063 17.6175L8.43306 17.6398C8.69752 17.6921 8.76861 17.764 8.78696 17.7925C8.82089 17.8453 8.80315 17.9496 8.78952 18.007C8.77698 18.0599 8.76403 18.1127 8.75108 18.1656C8.64795 18.5861 8.54132 19.021 8.62509 19.5005C8.7214 20.0517 9.06558 20.3678 9.56942 20.3679C9.56948 20.3679 9.56948 20.3679 9.56955 20.3679C10.1115 20.3679 10.7283 20.0043 11.1364 19.7638L11.1909 19.7318C12.1646 19.16 13.0819 18.515 13.7722 18.0169C15.2828 16.9271 16.995 15.6917 18.2787 14.0935C19.5713 12.4839 20.1802 10.4155 19.9535 8.41021ZM6.22828 11.4598H4.50284C4.24209 11.4598 4.03071 11.2484 4.03071 10.9876V7.366C4.03071 7.10524 4.24209 6.89386 4.50284 6.89386C4.76359 6.89386 4.97497 7.10524 4.97497 7.366V10.5155H6.22821C6.48896 10.5155 6.70034 10.7269 6.70034 10.9876C6.70041 11.2484 6.48903 11.4598 6.22828 11.4598ZM8.02824 10.9748C8.02824 11.2356 7.81686 11.447 7.55611 11.447C7.29536 11.447 7.08398 11.2356 7.08398 10.9748V7.35318C7.08398 7.09243 7.29536 6.88105 7.55611 6.88105C7.81686 6.88105 8.02824 7.09243 8.02824 7.35318V10.9748ZM12.2959 10.9748C12.2959 11.1794 12.1642 11.3607 11.9696 11.4239C11.9216 11.4395 11.8724 11.447 11.8238 11.447C11.6755 11.447 11.5323 11.377 11.4417 11.2522L9.74154 8.91067V10.9749C9.74154 11.2356 9.53016 11.447 9.26941 11.447C9.00866 11.447 8.79728 11.2356 8.79728 10.9749V7.45685C8.79728 7.25228 8.929 7.07098 9.12359 7.00778C9.31824 6.94465 9.53131 7.01385 9.6515 7.17944L11.3516 9.521V7.35318C11.3516 7.09243 11.563 6.88105 11.8238 6.88105C12.0845 6.88105 12.2959 7.09243 12.2959 7.35318V10.9748ZM15.7362 11.3726H13.3995C13.1387 11.3726 12.9273 11.1613 12.9273 10.9005V9.08975V7.27885C12.9273 7.0181 13.1387 6.80672 13.3995 6.80672H15.6637C15.9244 6.80672 16.1358 7.0181 16.1358 7.27885C16.1358 7.53961 15.9244 7.75098 15.6637 7.75098H13.8716V8.61761H15.3259C15.5867 8.61761 15.798 8.82899 15.798 9.08975C15.798 9.3505 15.5867 9.56188 15.3259 9.56188H13.8716V10.4284H15.7362C15.9969 10.4284 16.2083 10.6398 16.2083 10.9005C16.2083 11.1613 15.9969 11.3726 15.7362 11.3726Z", fill: "white" }))); };

var SvgAppStore = function (props) { return (React.createElement("svg", __assign({ width: "21", height: "20", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.3311 2.55282L10.8877 1.59078C11.2313 0.98951 11.9975 0.786796 12.5988 1.13038C13.2 1.47396 13.4027 2.24015 13.0592 2.84143L7.69582 12.1251H11.5749C12.8324 12.1251 13.5367 13.6025 12.9904 14.6263H1.61783C0.923793 14.6263 0.367188 14.0697 0.367188 13.3757C0.367188 12.6817 0.923793 12.1251 1.61783 12.1251H4.80629L8.88806 5.05067L7.61336 2.83799C7.26978 2.23672 7.4725 1.4774 8.07377 1.12694C8.67504 0.78336 9.43436 0.986074 9.78481 1.58735L10.3311 2.55282ZM5.5072 15.9148L4.30466 18.0003C3.96107 18.6016 3.19488 18.8043 2.59361 18.4607C1.99234 18.1171 1.78962 17.351 2.13321 16.7497L3.02652 15.2036C4.03666 14.8909 4.85782 15.1314 5.5072 15.9148ZM15.8628 12.1319H19.1165C19.8106 12.1319 20.3672 12.6885 20.3672 13.3826C20.3672 14.0766 19.8106 14.6332 19.1165 14.6332H17.3093L18.529 16.7497C18.8726 17.351 18.6699 18.1103 18.0686 18.4607C17.4673 18.8043 16.708 18.6016 16.3576 18.0003C14.3029 14.4374 12.7602 11.7712 11.7364 9.99483C10.6884 8.18759 11.4374 6.37346 12.1762 5.75845C12.9973 7.16714 14.2239 9.29393 15.8628 12.1319Z", fill: "white" }))); };

var SvgGooglePlay = function (props) { return (React.createElement("svg", __assign({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.36173 0.313332C1.10786 0.617912 0.979482 1.00772 1.00267 1.40355V18.5989C0.980794 18.9945 1.10902 19.3839 1.36173 19.6891L1.42048 19.7479L11.0496 10.1122V9.88371L1.42048 0.254578L1.36173 0.313332Z", fill: "white" }),
    React.createElement("path", { d: "M14.2607 13.3241L11.0488 10.1122V9.8837L14.2607 6.67834L14.3325 6.71751L18.1385 8.87836C19.2287 9.49201 19.2287 10.5039 18.1385 11.1241L14.3325 13.2849L14.2607 13.3241Z", fill: "white" }),
    React.createElement("path", { d: "M14.3329 13.2849L11.0688 10.0208L1.36133 19.6891C1.58508 19.873 1.86366 19.9773 2.15322 19.9856C2.44277 19.9939 2.72685 19.9056 2.96074 19.7348L14.3133 13.2849", fill: "white" }),
    React.createElement("path", { d: "M14.3329 6.7175L2.96074 0.261084C2.72936 0.0831907 2.44339 -0.00885362 2.15168 0.000671586C1.85997 0.0101968 1.58062 0.120701 1.36133 0.31331L11.0492 10.0012L14.3329 6.7175Z", fill: "white" }),
    React.createElement("path", { opacity: "0.1", d: "M14.2612 13.2131L2.9608 19.6238C2.73538 19.7918 2.46178 19.8825 2.18067 19.8825C1.89957 19.8825 1.62596 19.7918 1.40055 19.6238L1.3418 19.6825L1.40055 19.7413C1.62596 19.9093 1.89957 20 2.18067 20C2.46178 20 2.73538 19.9093 2.9608 19.7413L14.3134 13.2914L14.2612 13.2131Z", fill: "white" }),
    React.createElement("path", { opacity: "0.07", d: "M1.36153 19.5847C1.1084 19.2771 0.980229 18.8856 1.00248 18.4879V18.5989C0.980599 18.9945 1.10882 19.3839 1.36153 19.6891L1.42029 19.6304L1.36153 19.5847Z", fill: "white" }),
    React.createElement("path", { opacity: "0.07", d: "M18.1395 11.0066L14.2617 13.2131L14.3335 13.2849L18.1395 11.098C18.3627 10.9998 18.5559 10.8441 18.6993 10.6468C18.8426 10.4495 18.9311 10.2177 18.9555 9.9751C18.911 10.1994 18.8138 10.4099 18.6719 10.5892C18.53 10.7686 18.3475 10.9116 18.1395 11.0066Z", fill: "white" }),
    React.createElement("path", { opacity: "0.3", d: "M2.96042 0.378603L18.1385 8.98933C18.3446 9.08195 18.5258 9.22185 18.6676 9.39766C18.8094 9.57348 18.9077 9.78026 18.9546 10.0012C18.9315 9.75815 18.8436 9.52576 18.7 9.32826C18.5565 9.13075 18.3626 8.97538 18.1385 8.87835L2.96042 0.261095C1.88979 -0.352559 1.00195 0.156643 1.00195 1.40353V1.51451C1.00195 0.274151 1.88979 -0.241579 2.96042 0.378603Z", fill: "white" }))); };

var SvgTripAdvisor = function (props) { return (React.createElement("svg", __assign({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#clip0_2854_8976)" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM17.3834 6.73632L16.1767 8.04918C16.9164 8.72293 17.38 9.69499 17.3789 10.7754C17.3789 12.8123 15.7253 14.4637 13.6884 14.4637C12.7208 14.4637 11.8404 14.0917 11.1823 13.4816L10.0002 14.7676L8.81805 13.4805C8.15994 14.0905 7.2784 14.4637 6.31079 14.4637C4.27392 14.4637 2.6225 12.8123 2.6225 10.7754C2.6225 9.69611 3.08619 8.72403 3.82585 8.04918L2.61914 6.73632H5.30182C6.63926 5.82237 8.25264 5.28827 10.0001 5.28827C11.7499 5.28827 13.3678 5.82122 14.7074 6.73632H17.3834ZM3.81581 10.7754C3.81581 12.1542 4.9331 13.2715 6.31189 13.2715C7.69065 13.2715 8.80796 12.1542 8.80796 10.7754C8.80796 9.39666 7.69065 8.27934 6.31189 8.27934C4.93313 8.27934 3.81581 9.39666 3.81581 10.7754ZM7.23032 7.04805C8.80687 7.6503 10.0013 9.06034 10.0013 10.7028C10.0013 9.06037 11.1957 7.65142 12.7711 7.04805C11.9186 6.69161 10.9823 6.49385 10.0001 6.49385C9.01803 6.49385 8.08283 6.69161 7.23032 7.04805ZM11.1935 10.7754C11.1935 12.1542 12.3108 13.2715 13.6896 13.2715C15.0683 13.2715 16.1856 12.1542 16.1856 10.7754C16.1856 9.39666 15.0683 8.27934 13.6896 8.27934C12.3108 8.27934 11.1935 9.39666 11.1935 10.7754ZM12.3812 10.7743C12.3812 10.0514 12.9666 9.46592 13.6896 9.46592C14.4125 9.46592 14.9979 10.0525 14.9979 10.7743C14.9979 11.4972 14.4125 12.0827 13.6896 12.0827C12.9666 12.0827 12.3812 11.4972 12.3812 10.7743ZM6.31189 12.0838C7.03478 12.0838 7.62026 11.4983 7.62026 10.7754C7.62026 10.0525 7.03478 9.46592 6.31189 9.46704C5.589 9.46704 5.00351 10.0525 5.00351 10.7754C5.00351 11.4983 5.589 12.0838 6.31189 12.0838Z", fill: "#D84339" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_2854_8976" },
            React.createElement("rect", { width: "20", height: "20", fill: "white" }))))); };

var ICONS_SOCIAL_MEDIA = /*#__PURE__*/Object.freeze({
    __proto__: null,
    AppStore: SvgAppStore,
    Facebook: SvgFacebook,
    Google: SvgGoogle,
    GooglePlay: SvgGooglePlay,
    Instagram: SvgInstagram,
    Line: SvgLine,
    LinkedIn: SvgLinkedin,
    Messenger: SvgMessenger,
    Pinterest: SvgPinterest,
    Snapchat: SvgSnapchat,
    Spotify: SvgSpotify,
    TikTok: SvgTiktok,
    TripAdvisor: SvgTripAdvisor,
    Twitter: SvgTwitter,
    Whatsapp: SvgWhatsapp,
    Yelp: SvgYelp,
    Youtube: SvgYoutube
});

var StyledIcon$2 = defaultStyled.span(templateObject_1$11 || (templateObject_1$11 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  svg {\n    width: ", ";\n    height: ", ";\n  }\n\n  svg path {\n    stroke: ", ";\n    stroke-width: ", ";\n  }\n"], ["\n  width: ", ";\n  height: ", ";\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  svg {\n    width: ", ";\n    height: ", ";\n  }\n\n  svg path {\n    stroke: ", ";\n    stroke-width: ", ";\n  }\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? 16 : _b;
    return "".concat(size / 16, "rem");
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? 16 : _b;
    return "".concat(size / 16, "rem");
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? 16 : _b;
    return "".concat(size / 16, "rem");
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? 16 : _b;
    return "".concat(size / 16, "rem");
}, function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#30384C' : _b;
    return color;
}, function (_a) {
    var _b = _a.strokeWidth, strokeWidth = _b === void 0 ? 1 : _b;
    return strokeWidth;
});
var Icon = function (_a) {
    var name = _a.name, type = _a.type, color = _a.color, size = _a.size, strokeWidth = _a.strokeWidth, className = _a.className;
    var renderIconType = function (type) {
        switch (type) {
            case 'outline':
                return (React__default.createElement(StyledIcon$2, { color: color, size: size, strokeWidth: strokeWidth, className: className }, React__default.createElement(ICONS_OUTLINE[name])));
            case 'fill':
                return (React__default.createElement(StyledIcon$2, { color: color, size: size, strokeWidth: strokeWidth, className: className }, React__default.createElement(ICONS_FILL[name])));
            case 'detailed':
                return (React__default.createElement(StyledIcon$2, { color: color, size: size, strokeWidth: strokeWidth, className: className }, React__default.createElement(ICONS_DETAILED[name])));
            case 'sidebar':
                return (React__default.createElement(StyledIcon$2, { color: color, size: size, strokeWidth: strokeWidth, className: className }, React__default.createElement(ICONS_SIDEBAR[name])));
            case 'emojis':
                return (React__default.createElement(StyledIcon$2, { color: color, size: size, strokeWidth: strokeWidth, className: className }, React__default.createElement(ICONS_EMOJIS[name])));
            case 'partners':
                return React__default.createElement(ICONS_PARTNERS[name], { className: className });
            case 'social-media':
                return React__default.createElement(ICONS_SOCIAL_MEDIA[name], { className: className });
            default:
                return React__default.createElement(ICONS_OUTLINE[name], { className: className });
        }
    };
    return React__default.createElement(React__default.Fragment, null, renderIconType(type || 'outline'));
};
var templateObject_1$11;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var classnames = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

(function (module) {
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames () {
			var classes = '';

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (arg) {
					classes = appendClass(classes, parseValue(arg));
				}
			}

			return classes;
		}

		function parseValue (arg) {
			if (typeof arg === 'string' || typeof arg === 'number') {
				return arg;
			}

			if (typeof arg !== 'object') {
				return '';
			}

			if (Array.isArray(arg)) {
				return classNames.apply(null, arg);
			}

			if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
				return arg.toString();
			}

			var classes = '';

			for (var key in arg) {
				if (hasOwn.call(arg, key) && arg[key]) {
					classes = appendClass(classes, key);
				}
			}

			return classes;
		}

		function appendClass (value, newClass) {
			if (!newClass) {
				return value;
			}
		
			if (value) {
				return value + ' ' + newClass;
			}
		
			return value + newClass;
		}

		if (module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else {
			window.classNames = classNames;
		}
	}()); 
} (classnames));

var classnamesExports = classnames.exports;
var classNames = /*@__PURE__*/getDefaultExportFromCjs(classnamesExports);

var RangePicker = DatePicker$1.RangePicker;
var DatePickerPanelContainer$1 = defaultStyled.div(templateObject_1$10 || (templateObject_1$10 = __makeTemplateObject(["\n  .ant-picker-content th,\n  .ant-picker-content td {\n    &::before {\n      display: none;\n    }\n    > div {\n      &:hover {\n        background-color: #eaeaea;\n        color: #d84339;\n        border-radius: 6px;\n      }\n      padding-top: 2px;\n      &.today {\n        border-radius: 6px;\n        border: 1px solid #d84339;\n      }\n      &.disabled {\n        color: #bbbbbb;\n        background-color: #eaeaea;\n      }\n      &.overlapped {\n        color: #089171;\n        background-color: #eaeaea;\n      }\n      &.selected {\n        border-radius: 6px;\n        color: white;\n        background-color: #d84339;\n      }\n    }\n  }\n"], ["\n  .ant-picker-content th,\n  .ant-picker-content td {\n    &::before {\n      display: none;\n    }\n    > div {\n      &:hover {\n        background-color: #eaeaea;\n        color: #d84339;\n        border-radius: 6px;\n      }\n      padding-top: 2px;\n      &.today {\n        border-radius: 6px;\n        border: 1px solid #d84339;\n      }\n      &.disabled {\n        color: #bbbbbb;\n        background-color: #eaeaea;\n      }\n      &.overlapped {\n        color: #089171;\n        background-color: #eaeaea;\n      }\n      &.selected {\n        border-radius: 6px;\n        color: white;\n        background-color: #d84339;\n      }\n    }\n  }\n"])));
var DatePickerWrapper = defaultStyled(DatePicker$1)(templateObject_2$H || (templateObject_2$H = __makeTemplateObject(["\n  padding: 0.719rem 1.438rem 0.719rem;\n\n  .ant-picker-large .ant-picker-input > input {\n    font-size: 0.875rem;\n  }\n  border-radius: 23.5px;\n\n  &.ant-picker-disabled {\n    input {\n      color: var(--grey);\n    }\n  }\n\n  ", "\n"], ["\n  padding: 0.719rem 1.438rem 0.719rem;\n\n  .ant-picker-large .ant-picker-input > input {\n    font-size: 0.875rem;\n  }\n  border-radius: 23.5px;\n\n  &.ant-picker-disabled {\n    input {\n      color: var(--grey);\n    }\n  }\n\n  ", "\n"])), function (_a) {
    var size = _a.size;
    if (size === 'default') {
        return "height:2.5rem;";
    }
});
defaultStyled(TimePicker$1)(templateObject_3$r || (templateObject_3$r = __makeTemplateObject(["\n  .ant-picker-large .ant-picker-input > input {\n    font-size: 0.875rem;\n  }\n  border-radius: 23.5px;\n"], ["\n  .ant-picker-large .ant-picker-input > input {\n    font-size: 0.875rem;\n  }\n  border-radius: 23.5px;\n"])));
defaultStyled.div(templateObject_4$g || (templateObject_4$g = __makeTemplateObject(["\n  position: relative;\n  ", "\n"], ["\n  position: relative;\n  ", "\n"])), function (_a) {
    var $normalWidth = _a.$normalWidth;
    return !$normalWidth && 'width: 130%;';
});
defaultStyled(RangePicker)(templateObject_5$d || (templateObject_5$d = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  .ant-picker-large .ant-picker-input > input {\n    font-size: 0.875rem;\n  }\n  .ant-picker-separator {\n    color: var(--grey-dark) !important;\n  }\n"], ["\n  width: 100%;\n  height: 100%;\n  .ant-picker-large .ant-picker-input > input {\n    font-size: 0.875rem;\n  }\n  .ant-picker-separator {\n    color: var(--grey-dark) !important;\n  }\n"])));
defaultStyled.label(templateObject_6$a || (templateObject_6$a = __makeTemplateObject(["\n  font-size: 0.75rem;\n"], ["\n  font-size: 0.75rem;\n"])));
var Legend = defaultStyled.span(templateObject_7$6 || (templateObject_7$6 = __makeTemplateObject(["\n  padding: 0.25rem 0.75rem;\n  &.today {\n    border-radius: 6px;\n    background-color: #d84339;\n    color: white;\n  }\n  &.disabled {\n    color: #bbbbbb;\n    background-color: #eaeaea;\n  }\n  &.overlapped {\n    color: #089171;\n    background-color: #eaeaea;\n  }\n"], ["\n  padding: 0.25rem 0.75rem;\n  &.today {\n    border-radius: 6px;\n    background-color: #d84339;\n    color: white;\n  }\n  &.disabled {\n    color: #bbbbbb;\n    background-color: #eaeaea;\n  }\n  &.overlapped {\n    color: #089171;\n    background-color: #eaeaea;\n  }\n"])));
function DatePicker(_a) {
    var disabledDate = _a.disabledDate, overlappedFootnote = _a.overlappedFootnote, disabledFootnote = _a.disabledFootnote, props = __rest(_a, ["disabledDate", "overlappedFootnote", "disabledFootnote"]);
    return (React__default.createElement(DatePickerWrapper, __assign({ format: props.format || 'DD/MM/YYYY', disabledDate: disabledDate, suffixIcon: React__default.createElement(Icon, { name: 'Date', type: 'outline' }), size: "large", showToday: true, panelRender: function (node) { return React__default.createElement(DatePickerPanelContainer$1, null, node); }, renderExtraFooter: function () {
            if (!overlappedFootnote && !disabledFootnote) {
                return null;
            }
            return (React__default.createElement("div", { className: "py-2" },
                overlappedFootnote && (React__default.createElement("p", { className: "m-0 text-xs" },
                    React__default.createElement(Legend, { className: "overlapped" }, "1"),
                    " ",
                    overlappedFootnote)),
                React__default.createElement("p", { className: "m-0 text-xs mt-2" },
                    React__default.createElement(Legend, { className: "disabled" }, "5"),
                    " Unavailable dates")));
        } }, props)));
}
var templateObject_1$10, templateObject_2$H, templateObject_3$r, templateObject_4$g, templateObject_5$d, templateObject_6$a, templateObject_7$6;

var DatePickerPanelContainer = defaultStyled.div(templateObject_1$$ || (templateObject_1$$ = __makeTemplateObject(["\n  .ant-picker-time-panel {\n    .ant-picker-content {\n      padding: 0.25rem;\n      gap: 0.25rem;\n    }\n  }\n  .ant-picker-time-panel-column {\n    border: 1px solid #eaeaea;\n    border-radius: 10px;\n\n    .ant-picker-time-panel-cell {\n      padding-left: 0;\n      .ant-picker-time-panel-cell-inner {\n        text-align: center;\n        padding-left: 0px;\n      }\n    }\n    & > li.ant-picker-time-panel-cell-selected .ant-picker-time-panel-cell-inner {\n      background: #d84339;\n      color: #ffffff;\n      border-radius: 10px;\n    }\n  }\n\n  .ant-picker-footer {\n    .ant-picker-ok {\n      .ant-btn {\n        padding: 0rem 1.5rem;\n        border-radius: 10px;\n        margin: 0.25rem;\n      }\n    }\n  }\n"], ["\n  .ant-picker-time-panel {\n    .ant-picker-content {\n      padding: 0.25rem;\n      gap: 0.25rem;\n    }\n  }\n  .ant-picker-time-panel-column {\n    border: 1px solid #eaeaea;\n    border-radius: 10px;\n\n    .ant-picker-time-panel-cell {\n      padding-left: 0;\n      .ant-picker-time-panel-cell-inner {\n        text-align: center;\n        padding-left: 0px;\n      }\n    }\n    & > li.ant-picker-time-panel-cell-selected .ant-picker-time-panel-cell-inner {\n      background: #d84339;\n      color: #ffffff;\n      border-radius: 10px;\n    }\n  }\n\n  .ant-picker-footer {\n    .ant-picker-ok {\n      .ant-btn {\n        padding: 0rem 1.5rem;\n        border-radius: 10px;\n        margin: 0.25rem;\n      }\n    }\n  }\n"])));
var StyledDatePicker$1 = defaultStyled(DatePicker)(templateObject_2$G || (templateObject_2$G = __makeTemplateObject(["\n  .ant-picker-input {\n    input {\n      font-family: var(--font-family-regular);\n      font-size: 14px;\n      line-height: 25px;\n    }\n  }\n"], ["\n  .ant-picker-input {\n    input {\n      font-family: var(--font-family-regular);\n      font-size: 14px;\n      line-height: 25px;\n    }\n  }\n"])));
var MomosDatePicker = function (props) {
    return (React__default.createElement(StyledDatePicker$1, __assign({ suffixIcon: React__default.createElement(Icon, { name: 'Date', type: 'outline' }), size: "large", panelRender: function (node) { return React__default.createElement(DatePickerPanelContainer, null, node); }, locale: __assign(__assign({}, locale$1), { lang: __assign(__assign({}, locale$1.lang), { ok: 'Save' }) }) }, props)));
};
var templateObject_1$$, templateObject_2$G;

var FONT_WEIGHTS = {
    extrabold: 800,
    bold: 700,
    semibold: 600,
    medium: 500,
    regular: 400,
    light: 300,
    extralight: 200,
    thin: 100
};
var FONT_VARIANTS = {
    extrabold: 'var(--font-family-extrabold)',
    bold: 'var(--font-family-bold)',
    semibold: 'var(--font-family-semibold)',
    medium: 'var(--font-family-medium)',
    regular: 'var(--font-family-regular)',
    light: 'var(--font-family-light)',
    extralight: 'var(--font-family-extralight)',
    thin: 'var(--font-family-thin)'
};
var BaseText = defaultStyled.span(templateObject_1$_ || (templateObject_1$_ = __makeTemplateObject(["\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n\n  * {\n    font-size: inherit;\n    line-height: inherit;\n  }\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n\n  * {\n    font-size: inherit;\n    line-height: inherit;\n  }\n"])), function (_a) {
    var _b = _a.fontWeight, fontWeight = _b === void 0 ? 'medium' : _b;
    return FONT_VARIANTS[fontWeight];
}, function (_a) {
    var _b = _a.fontWeight, fontWeight = _b === void 0 ? 'medium' : _b;
    return FONT_WEIGHTS[fontWeight];
}, function (_a) {
    var fontSize = _a.fontSize;
    return "".concat(fontSize, "rem");
}, function (_a) {
    var lineHeight = _a.lineHeight;
    return "".concat(lineHeight, "rem");
}, function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#30384C' : _b;
    return color;
});
var Text$1 = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React__default.createElement(BaseText, __assign({}, props), children);
};
var createTextComponent = function (fontSize, lineHeight, headingLevel) {
    return function (_a) {
        var bold = _a.bold, semibold = _a.semibold, regular = _a.regular, color = _a.color, fontWeight = _a.fontWeight, props = __rest(_a, ["bold", "semibold", "regular", "color", "fontWeight"]);
        var Component = headingLevel ? baseHeadings[headingLevel] : BaseText;
        return (React__default.createElement(Component, __assign({ fontSize: fontSize, lineHeight: lineHeight, fontWeight: fontWeight ? fontWeight : bold ? 'bold' : semibold ? 'semibold' : regular ? 'regular' : 'medium', color: color }, props)));
    };
};
var baseHeadings = {
    h1: BaseText.withComponent('h1'),
    h2: BaseText.withComponent('h2'),
    h3: BaseText.withComponent('h3'),
    h4: BaseText.withComponent('h4'),
    h5: BaseText.withComponent('h5')
};
Text$1.H1 = createTextComponent(2.25, 2.5, 'h1');
Text$1.H2 = createTextComponent(1.5, 1.813, 'h2');
Text$1.H3 = createTextComponent(1.25, 1.5, 'h3');
Text$1.H4 = createTextComponent(1.063, 1.25, 'h4');
Text$1.H5 = createTextComponent(1, 1.188, 'h5');
Text$1.B1 = createTextComponent(0.875, 1.063);
Text$1.B2 = createTextComponent(0.75, 0.875);
Text$1.B3 = createTextComponent(0.688, 0.688);
Text$1.B4 = createTextComponent(0.625, 0.75);
Text$1.H3Span = createTextComponent(1.375, 1.5);
var templateObject_1$_;

var TitleWrap = defaultStyled.div(templateObject_1$Z || (templateObject_1$Z = __makeTemplateObject(["\n  margin-bottom: 40px;\n"], ["\n  margin-bottom: 40px;\n"])));
var StyledAntDrawer = defaultStyled(Drawer$1)(templateObject_2$F || (templateObject_2$F = __makeTemplateObject(["\n  .ant-drawer-header {\n    padding: 25px;\n    padding-bottom: 15px;\n    position: relative;\n    border-bottom: none;\n\n    .ant-drawer-header-title {\n      .ant-drawer-close {\n        position: absolute;\n        right: 0;\n      }\n    }\n  }\n\n  .ant-drawer-body {\n    padding-top: 0px;\n    padding-left: 60px;\n    padding-right: 60px;\n  }\n"], ["\n  .ant-drawer-header {\n    padding: 25px;\n    padding-bottom: 15px;\n    position: relative;\n    border-bottom: none;\n\n    .ant-drawer-header-title {\n      .ant-drawer-close {\n        position: absolute;\n        right: 0;\n      }\n    }\n  }\n\n  .ant-drawer-body {\n    padding-top: 0px;\n    padding-left: 60px;\n    padding-right: 60px;\n  }\n"])));
var Drawer = function (_a) {
    var title = _a.title, children = _a.children, _b = _a.width, width = _b === void 0 ? 300 : _b, rest = __rest(_a, ["title", "children", "width"]);
    var getTitle = function () {
        return typeof title === 'string' ? (React__default.createElement(TitleWrap, null,
            React__default.createElement(Text$1.H2, { semibold: true }, title))) : (title);
    };
    return (React__default.createElement(StyledAntDrawer, __assign({ width: width }, rest),
        getTitle(),
        children));
};
var templateObject_1$Z, templateObject_2$F;

var _global = {exports: {}};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$6 = _global.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global$6; // eslint-disable-line no-undef

var _globalExports = _global.exports;

var _core = {exports: {}};

var core$3 = _core.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core$3; // eslint-disable-line no-undef

var _coreExports = _core.exports;

var _aFunction = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

// optional / simple context binding
var aFunction = _aFunction;
var _ctx = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var _objectDp = {};

var _isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var isObject$e = _isObject;
var _anObject = function (it) {
  if (!isObject$e(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var _fails = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

var _descriptors;
var hasRequired_descriptors;

function require_descriptors () {
	if (hasRequired_descriptors) return _descriptors;
	hasRequired_descriptors = 1;
	// Thank's IE8 for his funny defineProperty
	_descriptors = !_fails(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});
	return _descriptors;
}

var _domCreate;
var hasRequired_domCreate;

function require_domCreate () {
	if (hasRequired_domCreate) return _domCreate;
	hasRequired_domCreate = 1;
	var isObject = _isObject;
	var document = _globalExports.document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	_domCreate = function (it) {
	  return is ? document.createElement(it) : {};
	};
	return _domCreate;
}

var _ie8DomDefine;
var hasRequired_ie8DomDefine;

function require_ie8DomDefine () {
	if (hasRequired_ie8DomDefine) return _ie8DomDefine;
	hasRequired_ie8DomDefine = 1;
	_ie8DomDefine = !require_descriptors() && !_fails(function () {
	  return Object.defineProperty(require_domCreate()('div'), 'a', { get: function () { return 7; } }).a != 7;
	});
	return _ie8DomDefine;
}

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject$d = _isObject;
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var _toPrimitive$1 = function (it, S) {
  if (!isObject$d(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject$d(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject$d(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject$d(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var hasRequired_objectDp;

function require_objectDp () {
	if (hasRequired_objectDp) return _objectDp;
	hasRequired_objectDp = 1;
	var anObject = _anObject;
	var IE8_DOM_DEFINE = require_ie8DomDefine();
	var toPrimitive = _toPrimitive$1;
	var dP = Object.defineProperty;

	_objectDp.f = require_descriptors() ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};
	return _objectDp;
}

var _propertyDesc = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var dP$1 = require_objectDp();
var createDesc$2 = _propertyDesc;
var _hide = require_descriptors() ? function (object, key, value) {
  return dP$1.f(object, key, createDesc$2(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var hasOwnProperty$f = {}.hasOwnProperty;
var _has$1 = function (it, key) {
  return hasOwnProperty$f.call(it, key);
};

var global$5 = _globalExports;
var core$2 = _coreExports;
var ctx = _ctx;
var hide$2 = _hide;
var has$9 = _has$1;
var PROTOTYPE$1 = 'prototype';

var $export$6 = function (type, name, source) {
  var IS_FORCED = type & $export$6.F;
  var IS_GLOBAL = type & $export$6.G;
  var IS_STATIC = type & $export$6.S;
  var IS_PROTO = type & $export$6.P;
  var IS_BIND = type & $export$6.B;
  var IS_WRAP = type & $export$6.W;
  var exports = IS_GLOBAL ? core$2 : core$2[name] || (core$2[name] = {});
  var expProto = exports[PROTOTYPE$1];
  var target = IS_GLOBAL ? global$5 : IS_STATIC ? global$5[name] : (global$5[name] || {})[PROTOTYPE$1];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has$9(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global$5)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE$1] = C[PROTOTYPE$1];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export$6.R && expProto && !expProto[key]) hide$2(expProto, key, out);
    }
  }
};
// type bitmap
$export$6.F = 1;   // forced
$export$6.G = 2;   // global
$export$6.S = 4;   // static
$export$6.P = 8;   // proto
$export$6.B = 16;  // bind
$export$6.W = 32;  // wrap
$export$6.U = 64;  // safe
$export$6.R = 128; // real proto method for `library`
var _export = $export$6;

var $export$5 = _export;
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export$5($export$5.S + $export$5.F * !require_descriptors(), 'Object', { defineProperty: require_objectDp().f });

var $Object$1 = _coreExports.Object;
var defineProperty$5 = function defineProperty(it, key, desc) {
  return $Object$1.defineProperty(it, key, desc);
};

var defineProperty$4 = { "default": defineProperty$5, __esModule: true };

var _defineProperty$4 = defineProperty$4;

var _defineProperty2$1 = _interopRequireDefault$N(_defineProperty$4);

function _interopRequireDefault$N(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default$6 = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2$1.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var toString$f = {}.toString;

var _cof = function (it) {
  return toString$f.call(it).slice(8, -1);
};

var _iobject;
var hasRequired_iobject;

function require_iobject () {
	if (hasRequired_iobject) return _iobject;
	hasRequired_iobject = 1;
	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = _cof;
	// eslint-disable-next-line no-prototype-builtins
	_iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};
	return _iobject;
}

// 7.2.1 RequireObjectCoercible(argument)
var _defined = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require_iobject();
var defined$2 = _defined;
var _toIobject = function (it) {
  return IObject(defined$2(it));
};

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
var _toInteger = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

// 7.1.15 ToLength
var toInteger$8 = _toInteger;
var min$1 = Math.min;
var _toLength = function (it) {
  return it > 0 ? min$1(toInteger$8(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

var toInteger$7 = _toInteger;
var max = Math.max;
var min = Math.min;
var _toAbsoluteIndex = function (index, length) {
  index = toInteger$7(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

// false -> Array#indexOf
// true  -> Array#includes
var toIObject$5 = _toIobject;
var toLength = _toLength;
var toAbsoluteIndex = _toAbsoluteIndex;
var _arrayIncludes = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject$5($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var _shared$2 = {exports: {}};

var _library;
var hasRequired_library;

function require_library () {
	if (hasRequired_library) return _library;
	hasRequired_library = 1;
	_library = true;
	return _library;
}

var core$1 = _coreExports;
var global$4 = _globalExports;
var SHARED = '__core-js_shared__';
var store$1 = global$4[SHARED] || (global$4[SHARED] = {});

(_shared$2.exports = function (key, value) {
  return store$1[key] || (store$1[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core$1.version,
  mode: require_library() ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

var _sharedExports = _shared$2.exports;

var id$1 = 0;
var px = Math.random();
var _uid = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id$1 + px).toString(36));
};

var _sharedKey;
var hasRequired_sharedKey;

function require_sharedKey () {
	if (hasRequired_sharedKey) return _sharedKey;
	hasRequired_sharedKey = 1;
	var shared = _sharedExports('keys');
	var uid = _uid;
	_sharedKey = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};
	return _sharedKey;
}

var has$8 = _has$1;
var toIObject$4 = _toIobject;
var arrayIndexOf = _arrayIncludes(false);
var IE_PROTO$1 = require_sharedKey()('IE_PROTO');

var _objectKeysInternal = function (object, names) {
  var O = toIObject$4(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO$1) has$8(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has$8(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

var _enumBugKeys;
var hasRequired_enumBugKeys;

function require_enumBugKeys () {
	if (hasRequired_enumBugKeys) return _enumBugKeys;
	hasRequired_enumBugKeys = 1;
	// IE 8- don't enum bug keys
	_enumBugKeys = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');
	return _enumBugKeys;
}

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys$1 = _objectKeysInternal;
var enumBugKeys = require_enumBugKeys();

var _objectKeys = Object.keys || function keys(O) {
  return $keys$1(O, enumBugKeys);
};

var _objectGops = {};

_objectGops.f = Object.getOwnPropertySymbols;

var _objectPie = {};

var hasRequired_objectPie;

function require_objectPie () {
	if (hasRequired_objectPie) return _objectPie;
	hasRequired_objectPie = 1;
	_objectPie.f = {}.propertyIsEnumerable;
	return _objectPie;
}

// 7.1.13 ToObject(argument)
var defined$1 = _defined;
var _toObject = function (it) {
  return Object(defined$1(it));
};

var _objectAssign;
var hasRequired_objectAssign;

function require_objectAssign () {
	if (hasRequired_objectAssign) return _objectAssign;
	hasRequired_objectAssign = 1;
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = require_descriptors();
	var getKeys = _objectKeys;
	var gOPS = _objectGops;
	var pIE = require_objectPie();
	var toObject = _toObject;
	var IObject = require_iobject();
	var $assign = Object.assign;

	// should work with symbols and should have deterministic property order (V8 bug)
	_objectAssign = !$assign || _fails(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;
	return _objectAssign;
}

// 19.1.3.1 Object.assign(target, source)
var $export$4 = _export;

$export$4($export$4.S + $export$4.F, 'Object', { assign: require_objectAssign() });

var assign$1 = _coreExports.Object.assign;

var assign = { "default": assign$1, __esModule: true };

var _assign = assign;

var _assign2 = _interopRequireDefault$M(_assign);

function _interopRequireDefault$M(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default$5 = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _default$4 = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var _defineProperty$3 = defineProperty$4;

var _defineProperty2 = _interopRequireDefault$L(_defineProperty$3);

function _interopRequireDefault$L(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default$3 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _typeof$4 = {};

var toInteger$6 = _toInteger;
var defined = _defined;
// true  -> String#at
// false -> String#codePointAt
var _stringAt = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger$6(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

var _redefine = _hide;

var _iterators = {};

var _objectDps;
var hasRequired_objectDps;

function require_objectDps () {
	if (hasRequired_objectDps) return _objectDps;
	hasRequired_objectDps = 1;
	var dP = require_objectDp();
	var anObject = _anObject;
	var getKeys = _objectKeys;

	_objectDps = require_descriptors() ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};
	return _objectDps;
}

var _html;
var hasRequired_html;

function require_html () {
	if (hasRequired_html) return _html;
	hasRequired_html = 1;
	var document = _globalExports.document;
	_html = document && document.documentElement;
	return _html;
}

var _objectCreate;
var hasRequired_objectCreate;

function require_objectCreate () {
	if (hasRequired_objectCreate) return _objectCreate;
	hasRequired_objectCreate = 1;
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = _anObject;
	var dPs = require_objectDps();
	var enumBugKeys = require_enumBugKeys();
	var IE_PROTO = require_sharedKey()('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';

	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = require_domCreate()('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  require_html().appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};

	_objectCreate = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};
	return _objectCreate;
}

var _wks = {exports: {}};

var store = _sharedExports('wks');
var uid$1 = _uid;
var Symbol$8 = _globalExports.Symbol;
var USE_SYMBOL = typeof Symbol$8 == 'function';

var $exports = _wks.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol$8[name] || (USE_SYMBOL ? Symbol$8 : uid$1)('Symbol.' + name));
};

$exports.store = store;

var _wksExports = _wks.exports;

var def = require_objectDp().f;
var has$7 = _has$1;
var TAG = _wksExports('toStringTag');

var _setToStringTag = function (it, tag, stat) {
  if (it && !has$7(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

var create$2 = require_objectCreate();
var descriptor = _propertyDesc;
var setToStringTag$2 = _setToStringTag;
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
_hide(IteratorPrototype, _wksExports('iterator'), function () { return this; });

var _iterCreate = function (Constructor, NAME, next) {
  Constructor.prototype = create$2(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag$2(Constructor, NAME + ' Iterator');
};

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has$6 = _has$1;
var toObject$1 = _toObject;
var IE_PROTO = require_sharedKey()('IE_PROTO');
var ObjectProto$1 = Object.prototype;

var _objectGpo = Object.getPrototypeOf || function (O) {
  O = toObject$1(O);
  if (has$6(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto$1 : null;
};

var LIBRARY$1 = require_library();
var $export$3 = _export;
var redefine$1 = _redefine;
var hide$1 = _hide;
var Iterators$2 = _iterators;
var $iterCreate = _iterCreate;
var setToStringTag$1 = _setToStringTag;
var getPrototypeOf = _objectGpo;
var ITERATOR = _wksExports('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

var _iterDefine = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag$1(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY$1 && typeof IteratorPrototype[ITERATOR] != 'function') hide$1(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY$1 || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide$1(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators$2[NAME] = $default;
  Iterators$2[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine$1(proto, key, methods[key]);
    } else $export$3($export$3.P + $export$3.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

var $at = _stringAt(true);

// 21.1.3.27 String.prototype[@@iterator]()
_iterDefine(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

var _iterStep = function (done, value) {
  return { value: value, done: !!done };
};

var step = _iterStep;
var Iterators$1 = _iterators;
var toIObject$3 = _toIobject;

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
_iterDefine(Array, 'Array', function (iterated, kind) {
  this._t = toIObject$3(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators$1.Arguments = Iterators$1.Array;

var global$3 = _globalExports;
var hide = _hide;
var Iterators = _iterators;
var TO_STRING_TAG = _wksExports('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i$1 = 0; i$1 < DOMIterables.length; i$1++) {
  var NAME = DOMIterables[i$1];
  var Collection = global$3[NAME];
  var proto$1 = Collection && Collection.prototype;
  if (proto$1 && !proto$1[TO_STRING_TAG]) hide(proto$1, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

var _wksExt = {};

_wksExt.f = _wksExports;

var iterator$1 = _wksExt.f('iterator');

var iterator = { "default": iterator$1, __esModule: true };

var _meta = {exports: {}};

var META$1 = _uid('meta');
var isObject$c = _isObject;
var has$5 = _has$1;
var setDesc = require_objectDp().f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !_fails(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META$1, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject$c(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has$5(it, META$1)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META$1].i;
};
var getWeak = function (it, create) {
  if (!has$5(it, META$1)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META$1].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta$1.NEED && isExtensible(it) && !has$5(it, META$1)) setMeta(it);
  return it;
};
var meta$1 = _meta.exports = {
  KEY: META$1,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

var _metaExports = _meta.exports;

var global$2 = _globalExports;
var core = _coreExports;
var LIBRARY = require_library();
var wksExt$1 = _wksExt;
var defineProperty$3 = require_objectDp().f;
var _wksDefine = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global$2.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty$3($Symbol, name, { value: wksExt$1.f(name) });
};

// all enumerable object keys, includes symbols
var getKeys = _objectKeys;
var gOPS = _objectGops;
var pIE$1 = require_objectPie();
var _enumKeys = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE$1.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};

// 7.2.2 IsArray(argument)
var cof = _cof;
var _isArray = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

var _objectGopnExt = {};

var _objectGopn = {};

var hasRequired_objectGopn;

function require_objectGopn () {
	if (hasRequired_objectGopn) return _objectGopn;
	hasRequired_objectGopn = 1;
	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = _objectKeysInternal;
	var hiddenKeys = require_enumBugKeys().concat('length', 'prototype');

	_objectGopn.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};
	return _objectGopn;
}

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject$2 = _toIobject;
var gOPN$1 = require_objectGopn().f;
var toString$e = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN$1(it);
  } catch (e) {
    return windowNames.slice();
  }
};

_objectGopnExt.f = function getOwnPropertyNames(it) {
  return windowNames && toString$e.call(it) == '[object Window]' ? getWindowNames(it) : gOPN$1(toIObject$2(it));
};

var _objectGopd = {};

var pIE = require_objectPie();
var createDesc$1 = _propertyDesc;
var toIObject$1 = _toIobject;
var toPrimitive$1 = _toPrimitive$1;
var has$4 = _has$1;
var IE8_DOM_DEFINE = require_ie8DomDefine();
var gOPD$1 = Object.getOwnPropertyDescriptor;

_objectGopd.f = require_descriptors() ? gOPD$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIObject$1(O);
  P = toPrimitive$1(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD$1(O, P);
  } catch (e) { /* empty */ }
  if (has$4(O, P)) return createDesc$1(!pIE.f.call(O, P), O[P]);
};

// ECMAScript 6 symbols shim
var global$1 = _globalExports;
var has$3 = _has$1;
var DESCRIPTORS = require_descriptors();
var $export$2 = _export;
var redefine = _redefine;
var META = _metaExports.KEY;
var $fails = _fails;
var shared$1 = _sharedExports;
var setToStringTag = _setToStringTag;
var uid = _uid;
var wks = _wksExports;
var wksExt = _wksExt;
var wksDefine = _wksDefine;
var enumKeys = _enumKeys;
var isArray$i = _isArray;
var anObject = _anObject;
var isObject$b = _isObject;
var toObject = _toObject;
var toIObject = _toIobject;
var toPrimitive = _toPrimitive$1;
var createDesc = _propertyDesc;
var _create$1 = require_objectCreate();
var gOPNExt = _objectGopnExt;
var $GOPD = _objectGopd;
var $GOPS = _objectGops;
var $DP = require_objectDp();
var $keys = _objectKeys;
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global$1.Symbol;
var $JSON = global$1.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared$1('symbol-registry');
var AllSymbols = shared$1('symbols');
var OPSymbols = shared$1('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global$1.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create$1(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create$1($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol$6 = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has$3(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has$3(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has$3(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create$1(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create$1(it) : $defineProperties(_create$1(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has$3(AllSymbols, key) && !has$3(OPSymbols, key)) return false;
  return E || !has$3(this, key) || !has$3(AllSymbols, key) || has$3(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has$3(AllSymbols, key) && !has$3(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has$3(AllSymbols, key) && !(has$3(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has$3(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has$3(AllSymbols, key = names[i++]) && (IS_OP ? has$3(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has$3(this, HIDDEN) && has$3(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  require_objectGopn().f = gOPNExt.f = $getOwnPropertyNames;
  require_objectPie().f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !require_library()) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export$2($export$2.G + $export$2.W + $export$2.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export$2($export$2.S + $export$2.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has$3(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol$6(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export$2($export$2.S + $export$2.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export$2($export$2.S + $export$2.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export$2($export$2.S + $export$2.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject$b(replacer) && it === undefined || isSymbol$6(it)) return; // IE8 returns string on undefined
    if (!isArray$i(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol$6(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || _hide($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global$1.JSON, 'JSON', true);

_wksDefine('asyncIterator');

_wksDefine('observable');

var symbol$1 = _coreExports.Symbol;

var symbol = { "default": symbol$1, __esModule: true };

_typeof$4.__esModule = true;

var _iterator = iterator;

var _iterator2 = _interopRequireDefault$K(_iterator);

var _symbol = symbol;

var _symbol2 = _interopRequireDefault$K(_symbol);

var _typeof$3 = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault$K(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_typeof$4.default = typeof _symbol2.default === "function" && _typeof$3(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof$3(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof$3(obj);
};

var _typeof2$1 = _typeof$4;

var _typeof3$1 = _interopRequireDefault$J(_typeof2$1);

function _interopRequireDefault$J(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default$2 = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3$1.default)(call)) === "object" || typeof call === "function") ? call : self;
};

var _setProto;
var hasRequired_setProto;

function require_setProto () {
	if (hasRequired_setProto) return _setProto;
	hasRequired_setProto = 1;
	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = _isObject;
	var anObject = _anObject;
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	_setProto = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = _ctx(Function.call, _objectGopd.f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};
	return _setProto;
}

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export$1 = _export;
$export$1($export$1.S, 'Object', { setPrototypeOf: require_setProto().set });

var setPrototypeOf$1 = _coreExports.Object.setPrototypeOf;

var setPrototypeOf = { "default": setPrototypeOf$1, __esModule: true };

var $export = _export;
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: require_objectCreate() });

var $Object = _coreExports.Object;
var create$1 = function create(P, D) {
  return $Object.create(P, D);
};

var create = { "default": create$1, __esModule: true };

var _setPrototypeOf = setPrototypeOf;

var _setPrototypeOf2 = _interopRequireDefault$I(_setPrototypeOf);

var _create = create;

var _create2 = _interopRequireDefault$I(_create);

var _typeof2 = _typeof$4;

var _typeof3 = _interopRequireDefault$I(_typeof2);

function _interopRequireDefault$I(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default$1 = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

var Item = function Item(_props) {
    return null;
};
function PickerMixin (ComposedComponent) {
    var _a;
    return _a = function (_React$Component) {
        _default$1(_a, _React$Component);

        function _a() {
            _default$4(this, _a);

            var _this = _default$2(this, (_a.__proto__ || Object.getPrototypeOf(_a)).apply(this, arguments));

            _this.select = function (value, itemHeight, scrollTo) {
                var children = React.Children.toArray(_this.props.children);
                for (var i = 0, len = children.length; i < len; i++) {
                    if (children[i].props.value === value) {
                        _this.selectByIndex(i, itemHeight, scrollTo);
                        return;
                    }
                }
                _this.selectByIndex(0, itemHeight, scrollTo);
            };
            _this.doScrollingComplete = function (top, itemHeight, fireValueChange) {
                var children = React.Children.toArray(_this.props.children);
                var index = _this.computeChildIndex(top, itemHeight, children.length);
                var child = children[index];
                if (child) {
                    fireValueChange(child.props.value);
                } else if (console.warn) {
                    console.warn('child not found', children, index);
                }
            };
            return _this;
        }

        _default$3(_a, [{
            key: 'selectByIndex',
            value: function selectByIndex(index, itemHeight, zscrollTo) {
                if (index < 0 || index >= React.Children.count(this.props.children) || !itemHeight) {
                    return;
                }
                zscrollTo(index * itemHeight);
            }
        }, {
            key: 'computeChildIndex',
            value: function computeChildIndex(top, itemHeight, childrenLength) {
                var index = Math.round(top / itemHeight);
                return Math.min(index, childrenLength - 1);
            }
        }, {
            key: 'render',
            value: function render() {
                return React.createElement(ComposedComponent, _default$5({}, this.props, { doScrollingComplete: this.doScrollingComplete, computeChildIndex: this.computeChildIndex, select: this.select }));
            }
        }]);

        return _a;
    }(React.Component), _a.Item = Item, _a;
}

var Picker = function (_React$Component) {
    _default$1(Picker, _React$Component);

    function Picker(props) {
        _default$4(this, Picker);

        var _this = _default$2(this, (Picker.__proto__ || Object.getPrototypeOf(Picker)).call(this, props));

        _this.scrollHanders = function () {
            var scrollY = -1;
            var lastY = 0;
            var startY = 0;
            var scrollDisabled = false;
            var isMoving = false;
            var setTransform = function setTransform(nodeStyle, value) {
                nodeStyle.transform = value;
                nodeStyle.webkitTransform = value;
            };
            var setTransition = function setTransition(nodeStyle, value) {
                nodeStyle.transition = value;
                nodeStyle.webkitTransition = value;
            };
            var scrollTo = function scrollTo(_x, y) {
                var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : .3;

                if (scrollY !== y) {
                    scrollY = y;
                    if (time && !_this.props.noAnimate) {
                        setTransition(_this.contentRef.style, 'cubic-bezier(0,0,0.2,1.15) ' + time + 's');
                    }
                    setTransform(_this.contentRef.style, 'translate3d(0,' + -y + 'px,0)');
                    setTimeout(function () {
                        _this.scrollingComplete();
                        if (_this.contentRef) {
                            setTransition(_this.contentRef.style, '');
                        }
                    }, +time * 1000);
                }
            };
            var Velocity = function () {
                var minInterval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 30;
                var maxInterval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

                var _time = 0;
                var _y = 0;
                var _velocity = 0;
                var recorder = {
                    record: function record(y) {
                        var now = +new Date();
                        _velocity = (y - _y) / (now - _time);
                        if (now - _time >= minInterval) {
                            _velocity = now - _time <= maxInterval ? _velocity : 0;
                            _y = y;
                            _time = now;
                        }
                    },
                    getVelocity: function getVelocity(y) {
                        if (y !== _y) {
                            recorder.record(y);
                        }
                        return _velocity;
                    }
                };
                return recorder;
            }();
            var onFinish = function onFinish() {
                isMoving = false;
                var targetY = scrollY;
                var height = (_this.props.children.length - 1) * _this.itemHeight;
                var time = .3;
                var velocity = Velocity.getVelocity(targetY) * 4;
                if (velocity) {
                    targetY = velocity * 40 + targetY;
                    time = Math.abs(velocity) * .1;
                }
                if (targetY % _this.itemHeight !== 0) {
                    targetY = Math.round(targetY / _this.itemHeight) * _this.itemHeight;
                }
                if (targetY < 0) {
                    targetY = 0;
                } else if (targetY > height) {
                    targetY = height;
                }
                scrollTo(0, targetY, time < .3 ? .3 : time);
                _this.onScrollChange();
            };
            var onStart = function onStart(y) {
                if (scrollDisabled) {
                    return;
                }
                isMoving = true;
                startY = y;
                lastY = scrollY;
            };
            var onMove = function onMove(y) {
                if (scrollDisabled || !isMoving) {
                    return;
                }
                scrollY = lastY - y + startY;
                Velocity.record(scrollY);
                _this.onScrollChange();
                setTransform(_this.contentRef.style, 'translate3d(0,' + -scrollY + 'px,0)');
            };
            return {
                touchstart: function touchstart(evt) {
                    return onStart(evt.touches[0].pageY);
                },
                mousedown: function mousedown(evt) {
                    return onStart(evt.pageY);
                },
                touchmove: function touchmove(evt) {
                    evt.preventDefault();
                    onMove(evt.touches[0].pageY);
                },
                mousemove: function mousemove(evt) {
                    evt.preventDefault();
                    onMove(evt.pageY);
                },
                touchend: function touchend() {
                    return onFinish();
                },
                touchcancel: function touchcancel() {
                    return onFinish();
                },
                mouseup: function mouseup() {
                    return onFinish();
                },
                getValue: function getValue() {
                    return scrollY;
                },
                scrollTo: scrollTo,
                setDisabled: function setDisabled() {
                    var disabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                    scrollDisabled = disabled;
                }
            };
        }();
        _this.scrollTo = function (top) {
            _this.scrollHanders.scrollTo(0, top);
            _this.setScrollEffect();
        };
        _this.scrollToWithoutAnimation = function (top) {
            _this.scrollHanders.scrollTo(0, top, 0);
            _this.setScrollEffect();
        };
        _this.fireValueChange = function (selectedValue) {
            if (selectedValue !== _this.state.selectedValue) {
                if (!('selectedValue' in _this.props)) {
                    _this.setState({
                        selectedValue: selectedValue
                    });
                }
                if (_this.props.onValueChange) {
                    _this.props.onValueChange(selectedValue);
                }
            }
        };
        _this.onScrollChange = function () {
            var top = _this.scrollHanders.getValue();
            if (top >= 0) {
                _this.setScrollEffect();
                var children = React.Children.toArray(_this.props.children);
                var index = _this.props.computeChildIndex(top, _this.itemHeight, children.length);
                if (_this.scrollValue !== index) {
                    _this.scrollValue = index;
                    var child = children[index];
                    if (child && _this.props.onScrollChange) {
                        _this.props.onScrollChange(child.props.value);
                    } else if (!child && console.warn) {
                        console.warn('child not found', children, index);
                    }
                }
            }
        };
        _this.scrollingComplete = function () {
            var top = _this.scrollHanders.getValue();
            if (top >= 0) {
                _this.props.doScrollingComplete(top, _this.itemHeight, _this.fireValueChange);
            }
        };
        // react渲染会有性能问题，故在这里使用传统方法
        _this.setScrollEffect = function () {
            var _this$props$rotate = _this.props.rotate,
                rotate = _this$props$rotate === undefined ? 25 : _this$props$rotate;
            var selectedValue = _this.state.selectedValue;

            var angle = rotate / 180 * Math.PI;
            var min = 0.1;
            var children = React.Children.toArray(_this.props.children) || [];
            var max = children.length;
            var offset = _this.scrollHanders.getValue() / _this.itemHeight;
            offset = Math.max(offset, min);
            offset = Math.min(offset, max);
            _this.items.forEach(function (item, index) {
                if (!item) {
                    return;
                }
                var offsetIndex = Math.min(Math.max((offset || selectedValue) - index, -(90 / rotate)), 90 / rotate);
                item.style.transform = 'translateY(' + _this.itemHeight * (offsetIndex - Math.sin(offsetIndex * angle) / angle) + 'px) rotateX(' + -offsetIndex * rotate + 'deg)';
            });
        };
        _this.clickToScroll = function (value) {
            _this.props.select(value, _this.itemHeight, _this.scrollTo);
        };
        var selectedValueState = void 0;
        var _this$props = _this.props,
            selectedValue = _this$props.selectedValue,
            defaultSelectedValue = _this$props.defaultSelectedValue;

        if (selectedValue !== undefined) {
            selectedValueState = selectedValue;
        } else if (defaultSelectedValue !== undefined) {
            selectedValueState = defaultSelectedValue;
        } else {
            var children = React.Children.toArray(_this.props.children);
            selectedValueState = children && children[0] && children[0].props.value;
        }
        _this.state = {
            selectedValue: selectedValueState
        };
        _this.items = [];
        return _this;
    }

    _default$3(Picker, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var contentRef = this.contentRef,
                indicatorRef = this.indicatorRef,
                maskRef = this.maskRef,
                rootRef = this.rootRef;

            var rootHeight = rootRef.getBoundingClientRect().height;
            // https://github.com/react-component/m-picker/issues/18
            var itemHeight = this.itemHeight = indicatorRef.getBoundingClientRect().height;
            var num = Math.floor(rootHeight / itemHeight);
            if (num % 2 === 0) {
                num--;
            }
            num--;
            num /= 2;
            contentRef.style.padding = itemHeight * num + 'px 0';
            indicatorRef.style.top = itemHeight * num + 'px';
            maskRef.style.backgroundSize = '100% ' + itemHeight * num + 'px';
            this.scrollHanders.setDisabled(this.props.disabled);
            this.props.select(this.state.selectedValue, this.itemHeight, this.scrollTo);
            var passiveSupported = this.passiveSupported();
            var willPreventDefault = passiveSupported ? { passive: false } : false;
            var willNotPreventDefault = passiveSupported ? { passive: true } : false;
            Object.keys(this.scrollHanders).forEach(function (key) {
                if (key.indexOf('touch') === 0 || key.indexOf('mouse') === 0) {
                    var pd = key.indexOf('move') >= 0 ? willPreventDefault : willNotPreventDefault;
                    rootRef.addEventListener(key, _this2.scrollHanders[key], pd);
                }
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var _this3 = this;

            Object.keys(this.scrollHanders).forEach(function (key) {
                if (key.indexOf('touch') === 0 || key.indexOf('mouse') === 0) {
                    _this3.rootRef.removeEventListener(key, _this3.scrollHanders[key]);
                }
            });
        }
    }, {
        key: 'passiveSupported',
        value: function passiveSupported() {
            var passiveSupported = false;
            try {
                var options = Object.defineProperty({}, 'passive', {
                    get: function get() {
                        passiveSupported = true;
                    }
                });
                window.addEventListener('test', null, options);
            } catch (err) {}
            return passiveSupported;
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this4 = this;

            if ('selectedValue' in nextProps) {
                if (this.state.selectedValue !== nextProps.selectedValue) {
                    this.setState({
                        selectedValue: nextProps.selectedValue
                    }, function () {
                        _this4.props.select(nextProps.selectedValue, _this4.itemHeight, nextProps.noAnimate ? _this4.scrollToWithoutAnimation : _this4.scrollTo);
                    });
                }
            }
            this.scrollHanders.setDisabled(nextProps.disabled);
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return this.state.selectedValue !== nextState.selectedValue || this.props.children !== nextProps.children;
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.props.select(this.state.selectedValue, this.itemHeight, this.scrollToWithoutAnimation);
        }
    }, {
        key: 'getValue',
        value: function getValue() {
            if ('selectedValue' in this.props) {
                return this.props.selectedValue;
            }
            var children = React.Children.toArray(this.props.children);
            return children && children[0] && children[0].props.value;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this,
                _pickerCls;

            var props = this.props;
            var prefixCls = props.prefixCls,
                itemStyle = props.itemStyle,
                indicatorStyle = props.indicatorStyle,
                _props$indicatorClass = props.indicatorClassName,
                indicatorClassName = _props$indicatorClass === undefined ? '' : _props$indicatorClass,
                children = props.children;
            var selectedValue = this.state.selectedValue;

            var itemClassName = prefixCls + '-item';
            var selectedItemClassName = itemClassName + ' ' + prefixCls + '-item-selected';
            var map = function map(item, index) {
                var _item$props = item.props,
                    _item$props$className = _item$props.className,
                    className = _item$props$className === undefined ? '' : _item$props$className,
                    style = _item$props.style,
                    value = _item$props.value;

                return React.createElement(
                    'div',
                    { style: _default$5({}, itemStyle, style), className: (selectedValue === value ? selectedItemClassName : itemClassName) + ' ' + className, key: value, ref: function ref(_ref) {
                            return _this5.items[index] = _ref;
                        }, onClick: function onClick() {
                            return _this5.clickToScroll(value);
                        } },
                    item.children || item.props.children
                );
            };
            // compatibility for preact
            var items = React.Children ? React.Children.map(children, map) : [].concat(children).map(map);
            var pickerCls = (_pickerCls = {}, _default$6(_pickerCls, props.className, !!props.className), _default$6(_pickerCls, prefixCls, true), _pickerCls);
            return React.createElement(
                'div',
                { className: classNames(pickerCls), ref: function ref(el) {
                        return _this5.rootRef = el;
                    }, style: this.props.style },
                React.createElement('div', { className: prefixCls + '-mask', ref: function ref(el) {
                        return _this5.maskRef = el;
                    } }),
                React.createElement('div', { className: prefixCls + '-indicator ' + indicatorClassName, ref: function ref(el) {
                        return _this5.indicatorRef = el;
                    }, style: indicatorStyle }),
                React.createElement(
                    'div',
                    { className: prefixCls + '-content', ref: function ref(el) {
                            return _this5.contentRef = el;
                        } },
                    items
                )
            );
        }
    }]);

    return Picker;
}(React.Component);

Picker.defaultProps = {
    prefixCls: 'rmc-picker'
};
var Picker$1 = PickerMixin(Picker);

/** Used for built-in method references. */

var objectProto$h = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype$4(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$h;

  return value === proto;
}

var _isPrototype = isPrototype$4;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

function overArg$2(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg$2;

var overArg$1 = _overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys$1 = overArg$1(Object.keys, Object);

var _nativeKeys = nativeKeys$1;

var isPrototype$3 = _isPrototype,
    nativeKeys = _nativeKeys;

/** Used for built-in method references. */
var objectProto$g = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$e = objectProto$g.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys$3(object) {
  if (!isPrototype$3(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$e.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys$3;

/** Detect free variable `global` from Node.js. */

var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal$1;

var freeGlobal = _freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$9 = freeGlobal || freeSelf || Function('return this')();

var _root = root$9;

var root$8 = _root;

/** Built-in value references. */
var Symbol$7 = root$8.Symbol;

var _Symbol = Symbol$7;

var Symbol$6 = _Symbol;

/** Used for built-in method references. */
var objectProto$f = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$d = objectProto$f.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$f.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$6 ? Symbol$6.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$d.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

var _getRawTag = getRawTag$1;

/** Used for built-in method references. */

var objectProto$e = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$e.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString$1;

var Symbol$5 = _Symbol,
    getRawTag = _getRawTag,
    objectToString = _objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$5 ? Symbol$5.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$8(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

var _baseGetTag = baseGetTag$8;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$a(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$a;

var baseGetTag$7 = _baseGetTag,
    isObject$9 = isObject_1;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$3(value) {
  if (!isObject$9(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag$7(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction$3;

var root$7 = _root;

/** Used to detect overreaching core-js shims. */
var coreJsData$1 = root$7['__core-js_shared__'];

var _coreJsData = coreJsData$1;

var coreJsData = _coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$1(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked$1;

/** Used for built-in method references. */

var funcProto$2 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$2.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource$2;

var isFunction$2 = isFunction_1,
    isMasked = _isMasked,
    isObject$8 = isObject_1,
    toSource$1 = _toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
    objectProto$d = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$d.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString$1.call(hasOwnProperty$c).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$1(value) {
  if (!isObject$8(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$2(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}

var _baseIsNative = baseIsNative$1;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue$1(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue$1;

var baseIsNative = _baseIsNative,
    getValue = _getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$7(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

var _getNative = getNative$7;

var getNative$6 = _getNative,
    root$6 = _root;

/* Built-in method references that are verified to be native. */
var DataView$1 = getNative$6(root$6, 'DataView');

var _DataView = DataView$1;

var getNative$5 = _getNative,
    root$5 = _root;

/* Built-in method references that are verified to be native. */
var Map$4 = getNative$5(root$5, 'Map');

var _Map = Map$4;

var getNative$4 = _getNative,
    root$4 = _root;

/* Built-in method references that are verified to be native. */
var Promise$2 = getNative$4(root$4, 'Promise');

var _Promise = Promise$2;

var getNative$3 = _getNative,
    root$3 = _root;

/* Built-in method references that are verified to be native. */
var Set$2 = getNative$3(root$3, 'Set');

var _Set = Set$2;

var getNative$2 = _getNative,
    root$2 = _root;

/* Built-in method references that are verified to be native. */
var WeakMap$2 = getNative$2(root$2, 'WeakMap');

var _WeakMap = WeakMap$2;

var DataView = _DataView,
    Map$3 = _Map,
    Promise$1 = _Promise,
    Set$1 = _Set,
    WeakMap$1 = _WeakMap,
    baseGetTag$6 = _baseGetTag,
    toSource = _toSource;

/** `Object#toString` result references. */
var mapTag$7 = '[object Map]',
    objectTag$4 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$7 = '[object Set]',
    weakMapTag$2 = '[object WeakMap]';

var dataViewTag$4 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map$3),
    promiseCtorString = toSource(Promise$1),
    setCtorString = toSource(Set$1),
    weakMapCtorString = toSource(WeakMap$1);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$6 = baseGetTag$6;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag$6(new DataView(new ArrayBuffer(1))) != dataViewTag$4) ||
    (Map$3 && getTag$6(new Map$3) != mapTag$7) ||
    (Promise$1 && getTag$6(Promise$1.resolve()) != promiseTag) ||
    (Set$1 && getTag$6(new Set$1) != setTag$7) ||
    (WeakMap$1 && getTag$6(new WeakMap$1) != weakMapTag$2)) {
  getTag$6 = function(value) {
    var result = baseGetTag$6(value),
        Ctor = result == objectTag$4 ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$4;
        case mapCtorString: return mapTag$7;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$7;
        case weakMapCtorString: return weakMapTag$2;
      }
    }
    return result;
  };
}

var _getTag = getTag$6;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$b(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$b;

var baseGetTag$5 = _baseGetTag,
    isObjectLike$a = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$3 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments$1(value) {
  return isObjectLike$a(value) && baseGetTag$5(value) == argsTag$3;
}

var _baseIsArguments = baseIsArguments$1;

var baseIsArguments = _baseIsArguments,
    isObjectLike$9 = isObjectLike_1;

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$c.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$c.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments$4 = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike$9(value) && hasOwnProperty$b.call(value, 'callee') &&
    !propertyIsEnumerable$1.call(value, 'callee');
};

var isArguments_1 = isArguments$4;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray$g = Array.isArray;

var isArray_1 = isArray$g;

var isArray$h = /*@__PURE__*/getDefaultExportFromCjs(isArray_1);

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$1 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$3(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}

var isLength_1 = isLength$3;

var isFunction$1 = isFunction_1,
    isLength$2 = isLength_1;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$9(value) {
  return value != null && isLength$2(value.length) && !isFunction$1(value);
}

var isArrayLike_1 = isArrayLike$9;

var isBuffer$5 = {exports: {}};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

isBuffer$5.exports;

(function (module, exports) {
	var root = _root,
	    stubFalse = stubFalse_1;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;

	module.exports = isBuffer; 
} (isBuffer$5, isBuffer$5.exports));

var isBufferExports = isBuffer$5.exports;

var baseGetTag$4 = _baseGetTag,
    isLength$1 = isLength_1,
    isObjectLike$8 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]',
    arrayTag$2 = '[object Array]',
    boolTag$3 = '[object Boolean]',
    dateTag$3 = '[object Date]',
    errorTag$2 = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag$6 = '[object Map]',
    numberTag$3 = '[object Number]',
    objectTag$3 = '[object Object]',
    regexpTag$4 = '[object RegExp]',
    setTag$6 = '[object Set]',
    stringTag$4 = '[object String]',
    weakMapTag$1 = '[object WeakMap]';

var arrayBufferTag$3 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] =
typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] =
typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] =
typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] =
typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] =
typedArrayTags[arrayBufferTag$3] = typedArrayTags[boolTag$3] =
typedArrayTags[dataViewTag$3] = typedArrayTags[dateTag$3] =
typedArrayTags[errorTag$2] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag$6] = typedArrayTags[numberTag$3] =
typedArrayTags[objectTag$3] = typedArrayTags[regexpTag$4] =
typedArrayTags[setTag$6] = typedArrayTags[stringTag$4] =
typedArrayTags[weakMapTag$1] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray$1(value) {
  return isObjectLike$8(value) &&
    isLength$1(value.length) && !!typedArrayTags[baseGetTag$4(value)];
}

var _baseIsTypedArray = baseIsTypedArray$1;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

function baseUnary$5(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary$5;

var _nodeUtil = {exports: {}};

_nodeUtil.exports;

(function (module, exports) {
	var freeGlobal = _freeGlobal;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;

	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;

	    if (types) {
	      return types;
	    }

	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());

	module.exports = nodeUtil; 
} (_nodeUtil, _nodeUtil.exports));

var _nodeUtilExports = _nodeUtil.exports;

var baseIsTypedArray = _baseIsTypedArray,
    baseUnary$4 = _baseUnary,
    nodeUtil$3 = _nodeUtilExports;

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil$3 && nodeUtil$3.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray$3 = nodeIsTypedArray ? baseUnary$4(nodeIsTypedArray) : baseIsTypedArray;

var isTypedArray_1 = isTypedArray$3;

var baseKeys$2 = _baseKeys,
    getTag$5 = _getTag,
    isArguments$3 = isArguments_1,
    isArray$f = isArray_1,
    isArrayLike$8 = isArrayLike_1,
    isBuffer$4 = isBufferExports,
    isPrototype$2 = _isPrototype,
    isTypedArray$2 = isTypedArray_1;

/** `Object#toString` result references. */
var mapTag$5 = '[object Map]',
    setTag$5 = '[object Set]';

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$b.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike$8(value) &&
      (isArray$f(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer$4(value) || isTypedArray$2(value) || isArguments$3(value))) {
    return !value.length;
  }
  var tag = getTag$5(value);
  if (tag == mapTag$5 || tag == setTag$5) {
    return !value.size;
  }
  if (isPrototype$2(value)) {
    return !baseKeys$2(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty$a.call(value, key)) {
      return false;
    }
  }
  return true;
}

var isEmpty_1 = isEmpty;

var isEmpty$1 = /*@__PURE__*/getDefaultExportFromCjs(isEmpty_1);

var StyledAntdInput$1 = defaultStyled(Input$1)(templateObject_1$Y || (templateObject_1$Y = __makeTemplateObject(["\n  border-radius: 550px !important;\n  height: 3.125rem;\n  font-family: var(--font-family-regular);\n  font-style: normal;\n  font-weight: 500;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n"], ["\n  border-radius: 550px !important;\n  height: 3.125rem;\n  font-family: var(--font-family-regular);\n  font-style: normal;\n  font-weight: 500;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n"])));
var InputStyled = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React__default.createElement(StyledAntdInput$1, __assign({}, props), children);
};
var TimePickerModal = function (_a) {
    var defaultValue = _a.defaultValue, value = _a.value, onChange = _a.onChange, title = _a.title, _b = _a.minStep, minStep = _b === void 0 ? 30 : _b; _a.suffix; var label = _a.label, className = _a.className, _c = _a.placeholder, placeholder = _c === void 0 ? 'hh:mm' : _c;
    var currentValue = value && moment.isMoment(value) ? value.format('hh:mm A') : '';
    var _d = useState(10), selectedHour = _d[0], setSelectedHour = _d[1];
    var _e = useState(0), selectedMinute = _e[0], setSelectedMinute = _e[1];
    var _f = useState('am'), selectedAbbreviation = _f[0], setSelectedAbbreviation = _f[1];
    var _g = useState(false), timepickerVisible = _g[0], setTimepickerVisible = _g[1];
    useEffect(function () {
        if (value && moment.isMoment(value)) {
            var formatted_hour = Number(value.format('hh'));
            var formatted_minute = Number(value.format('mm'));
            var formatted_suffix = value.format('a');
            setSelectedHour(formatted_hour);
            setSelectedMinute(formatted_minute);
            setSelectedAbbreviation(formatted_suffix);
        }
    }, [value, timepickerVisible]);
    var getHours = useMemo(function () {
        var items = [];
        for (var i = 1; i <= 12; i++) {
            items.push(React__default.createElement(Picker$1.Item, { value: i, key: i }, i > 9 ? i : "0".concat(i)));
        }
        return items;
    }, []);
    var getMinutes = useMemo(function () {
        var items = [];
        var interval = 0;
        for (var i = 0; i < 60 / minStep; i++) {
            items.push(React__default.createElement(Picker$1.Item, { value: interval, key: i }, interval > 9 ? interval : "0".concat(interval)));
            interval += minStep;
        }
        return items;
    }, [minStep]);
    var onChangeHour = function (value) {
        setSelectedHour(value);
    };
    var onChangeMinutes = function (value) {
        setSelectedMinute(value);
    };
    var onChangeAbbreviation = function (value) {
        setSelectedAbbreviation(value);
    };
    var handleSubmit = function () {
        setTimepickerVisible(false);
        var time24Format = moment("".concat(selectedHour, ":").concat(selectedMinute, " ").concat(selectedAbbreviation), 'hh:mm a').format('HH:mm');
        onChange && onChange(moment(time24Format, 'HH:mm'));
    };
    return (React__default.createElement(React__default.Fragment, null,
        !isEmpty$1(label) && React__default.createElement(Text$1.B1, { className: "mb-2" }, label),
        React__default.createElement(TimePickerModalInput, { className: className },
            React__default.createElement(InputStyled, { placeholder: placeholder, defaultValue: defaultValue || '', value: currentValue, onClick: function () {
                    setTimepickerVisible(true);
                }, readOnly: true, className: "timepicker-modal-input", suffix: React__default.createElement(Icon, { name: 'Clock', type: 'outline' }) })),
        React__default.createElement(Modal, { title: title, visible: timepickerVisible, onCancel: function () { return setTimepickerVisible(false); }, centered: true, footer: null, className: "momos-modal" },
            React__default.createElement(TimePickerWrap, null,
                React__default.createElement(Picker$1, { selectedValue: selectedHour, onValueChange: onChangeHour }, getHours),
                React__default.createElement(Picker$1, { selectedValue: selectedMinute, onValueChange: onChangeMinutes }, getMinutes),
                React__default.createElement(Picker$1, { selectedValue: selectedAbbreviation, onValueChange: onChangeAbbreviation },
                    React__default.createElement(Picker$1.Item, { value: 'am' }, "AM"),
                    React__default.createElement(Picker$1.Item, { value: 'pm' }, "PM"))),
            React__default.createElement(TimePickerFooter, { className: "timepicker-footer" },
                React__default.createElement(Button$1, { shape: "round", type: "default", className: "mr-10", onClick: function () { return setTimepickerVisible(false); } }, "Cancel"),
                React__default.createElement(Button$1, { shape: "round", onClick: handleSubmit }, "Set")))));
};
var TimePickerWrap = defaultStyled.div(templateObject_2$E || (templateObject_2$E = __makeTemplateObject(["\n  display: flex;\n  padding: 0.625rem 0px;\n\n  .rmc-picker-item {\n    font-size: 1rem;\n    font-family: var(--font-family-medium);\n    color: #000000;\n  }\n"], ["\n  display: flex;\n  padding: 0.625rem 0px;\n\n  .rmc-picker-item {\n    font-size: 1rem;\n    font-family: var(--font-family-medium);\n    color: #000000;\n  }\n"])));
var TimePickerFooter = defaultStyled.div(templateObject_3$q || (templateObject_3$q = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n"])));
var TimePickerModalInput = defaultStyled.div(templateObject_4$f || (templateObject_4$f = __makeTemplateObject(["\n  .timepicker-modal-input {\n    padding-top: 0px;\n    padding-bottom: 0px;\n    border-radius: 500px;\n\n    input.ant-input {\n      height: 3rem;\n      font-size: 0.875rem;\n      line-height: 1.25rem;\n    }\n  }\n"], ["\n  .timepicker-modal-input {\n    padding-top: 0px;\n    padding-bottom: 0px;\n    border-radius: 500px;\n\n    input.ant-input {\n      height: 3rem;\n      font-size: 0.875rem;\n      line-height: 1.25rem;\n    }\n  }\n"])));
var templateObject_1$Y, templateObject_2$E, templateObject_3$q, templateObject_4$f;

var Wrapper = defaultStyled.div(templateObject_1$X || (templateObject_1$X = __makeTemplateObject(["\n  min-width: 105px;\n  height: 40px;\n  width: 100%;\n  ", "\n  .ant-select {\n    height: 100%;\n    width: 100%;\n\n    .ant-select-selector {\n      height: 100%;\n      border-radius: 30px;\n      .ant-select-selection-item {\n        line-height: 40px;\n      }\n    }\n  }\n"], ["\n  min-width: 105px;\n  height: 40px;\n  width: 100%;\n  ", "\n  .ant-select {\n    height: 100%;\n    width: 100%;\n\n    .ant-select-selector {\n      height: 100%;\n      border-radius: 30px;\n      .ant-select-selection-item {\n        line-height: 40px;\n      }\n    }\n  }\n"])), function (_a) {
    var disabled = _a.disabled;
    return disabled
        ? "\n          pointer-events: none;\n          opacity: 0.5;\n        "
        : '';
});
var OptionArea$1 = defaultStyled.div(templateObject_2$D || (templateObject_2$D = __makeTemplateObject(["\n  .ant-select-item {\n    padding: 5px 10px;\n  }\n"], ["\n  .ant-select-item {\n    padding: 5px 10px;\n  }\n"])));
var generateOptions = function (_a) {
    var hourStep = _a.hourStep, minStep = _a.minStep, disabledHours = _a.disabledHours, use12Hours = _a.use12Hours, validate = _a.validate;
    try {
        var opts = [];
        var disabledHoursList = disabledHours ? disabledHours() : [];
        for (var hour = 0; hour < 24; hour += hourStep) {
            for (var min = 0; min < 60; min += minStep) {
                if (disabledHoursList === null || disabledHoursList === void 0 ? void 0 : disabledHoursList.includes(hour))
                    continue;
                var originalHour = hour < 10 ? "0".concat(hour) : hour;
                var originalMin = min < 10 ? "0".concat(min) : min;
                var value = "".concat(originalHour, ":").concat(originalMin);
                var formatedHour = use12Hours && hour > 12 ? hour - 12 : hour;
                var formatedHourString = formatedHour < 10 ? "0".concat(formatedHour) : formatedHour;
                var postfix = use12Hours ? (hour > 11 ? ' PM' : ' AM') : '';
                var label = "".concat(formatedHourString, ":").concat(originalMin).concat(postfix);
                // Match moment 12h format and label 00:00 AM as 12:00 AM to match moment time
                if (use12Hours) {
                    var labelHour = label.split(':')[0];
                    if (labelHour === '00') {
                        label = "".concat(12, ":").concat(originalMin).concat(postfix);
                    }
                }
                if (typeof validate === 'function') {
                    if (validate(value)) {
                        opts.push({
                            value: value,
                            label: label
                        });
                    }
                }
                else {
                    opts.push({
                        value: value,
                        label: label
                    });
                }
            }
        }
        return opts;
    }
    catch (err) {
        return [];
    }
};
function TimePicker(_a) {
    var _b = _a.hourStep, hourStep = _b === void 0 ? 1 : _b, _c = _a.minStep, minStep = _c === void 0 ? 15 : _c, disabledHours = _a.disabledHours, _d = _a.use12Hours, use12Hours = _d === void 0 ? false : _d, disabled = _a.disabled, _e = _a.useMoment, useMoment = _e === void 0 ? true : _e, onChange = _a.onChange, value = _a.value, validate = _a.validate, props = __rest(_a, ["hourStep", "minStep", "disabledHours", "use12Hours", "disabled", "useMoment", "onChange", "value", "validate"]);
    var options = generateOptions({ hourStep: hourStep, minStep: minStep, disabledHours: disabledHours, use12Hours: use12Hours, validate: validate });
    // use moment 12h format if use12Hours props is true
    var currentValue = moment.isMoment(value) ? value.format(use12Hours ? 'hh:mm A' : 'HH:mm') : value;
    var onChangeTime = function (value) {
        if (useMoment) {
            onChange && onChange(moment(value, 'HH:mm'));
            return;
        }
        onChange && onChange(value);
    };
    return (React__default.createElement(Wrapper, { disabled: disabled, className: "timepicker-wrapper" },
        React__default.createElement(Select$2, __assign({ options: options, value: currentValue, onChange: onChangeTime }, props, { dropdownRender: function (menu) { return React__default.createElement(OptionArea$1, null, menu); } }))));
}
var templateObject_1$X, templateObject_2$D;

var EMOJI_RATING = {
    1: React__default.createElement(SvgIcon$4, { width: '2.5rem', height: '2.5rem' }),
    2: React__default.createElement(SvgIcon$3, { width: '2.5rem', height: '2.5rem' }),
    3: React__default.createElement(SvgIcon$2, { width: '2.5rem', height: '2.5rem' }),
    4: React__default.createElement(SvgIcon$1, { width: '2.5rem', height: '2.5rem' }),
    5: React__default.createElement(SvgIcon, { width: '2.5rem', height: '2.5rem' })
};
var EmojiRating = function (_a) {
    var defaultValue = _a.defaultValue, _b = _a.count, count = _b === void 0 ? 5 : _b, disabled = _a.disabled, props = __rest(_a, ["defaultValue", "count", "disabled"]);
    var _c = useState(defaultValue || 0), rating = _c[0], setRating = _c[1];
    var _d = useState(null), hoverValue = _d[0], setHoverValue = _d[1];
    useEffect(function () {
        if (defaultValue) {
            setRating(defaultValue);
        }
    }, [defaultValue]);
    var handleHoverChange = function (hoverValue) {
        setHoverValue(hoverValue);
    };
    var handleRateChange = function (newValue) {
        setRating(newValue);
        props.onChange && props.onChange(newValue);
    };
    var renderEmoji = function () {
        var emojiCount = count === 3 ? [1, 3, 5] : [1, 2, 3, 4, 5];
        var renderEmojiItem = function (i) {
            var isActive = i <= (hoverValue || rating);
            var className = isActive ? 'emoji active' : 'emoji';
            return (React__default.createElement("span", { key: i, className: className, onMouseEnter: function () { return handleHoverChange(i); }, onMouseLeave: function () { return handleHoverChange(null); }, onClick: function () {
                    if (!disabled) {
                        handleRateChange(i);
                    }
                } }, EMOJI_RATING[i]));
        };
        return emojiCount.map(function (i) { return renderEmojiItem(i); });
    };
    return (React__default.createElement(StyledSpan$1, null,
        React__default.createElement("span", { className: "emoji-container" }, renderEmoji())));
};
var StyledSpan$1 = defaultStyled.span(templateObject_1$W || (templateObject_1$W = __makeTemplateObject(["\n  margin-bottom: 10px;\n\n  .emoji-container {\n    display: flex;\n    gap: 0.75rem;\n  }\n\n  .emoji {\n    filter: saturate(0);\n    transition: all 0.2s;\n  }\n\n  .emoji.active {\n    filter: saturate(1);\n  }\n\n  .emoji:hover {\n    cursor: pointer;\n    filter: saturate(1);\n  }\n"], ["\n  margin-bottom: 10px;\n\n  .emoji-container {\n    display: flex;\n    gap: 0.75rem;\n  }\n\n  .emoji {\n    filter: saturate(0);\n    transition: all 0.2s;\n  }\n\n  .emoji.active {\n    filter: saturate(1);\n  }\n\n  .emoji:hover {\n    cursor: pointer;\n    filter: saturate(1);\n  }\n"])));
var templateObject_1$W;

/*
 * ThumbsRating
 * value = 0 => no thumbs are selected
 * value = 1 => thumb up is selected
 * value = -1 => thumb down is selected
 */
var ThumbsRating = function (_a) {
    var defaultValue = _a.defaultValue, captions = _a.captions, disabled = _a.disabled, props = __rest(_a, ["defaultValue", "captions", "disabled"]);
    var _b = useState(defaultValue || 0), rating = _b[0], setRating = _b[1];
    useEffect(function () {
        if (defaultValue) {
            setRating(defaultValue);
        }
    }, [defaultValue]);
    var handleThumbClick = function (value) {
        if (!disabled) {
            if (rating === value) {
                // If the same thumb is clicked again, reset the rating
                setRating(null);
            }
            else {
                // Otherwise, set the rating to the clicked thumb
                setRating(value);
                props.onChange && props.onChange(value);
            }
        }
    };
    return (React__default.createElement(StyledSpan, null,
        React__default.createElement("div", { className: "sentiment" },
            React__default.createElement("div", { className: "tag-actions" },
                React__default.createElement("div", { className: "main-container-box" },
                    React__default.createElement("div", { className: "tag-icon dislike ".concat(rating === -1 ? 'active' : ''), onClick: function () { return handleThumbClick(-1); } },
                        React__default.createElement(Icon, { name: 'Dislike', type: 'outline' })),
                    React__default.createElement("div", { className: "tag-icon like ".concat(rating === 1 ? 'active' : ''), onClick: function () { return handleThumbClick(1); } },
                        React__default.createElement(Icon, { name: 'Like', type: 'outline' }))),
                React__default.createElement("div", { className: "main-container-box" },
                    React__default.createElement(Text$1.B4, { className: "caption-text" }, (captions === null || captions === void 0 ? void 0 : captions.length) && captions[0] ? captions[0] : ''),
                    React__default.createElement(Text$1.B4, { className: "caption-text" }, (captions === null || captions === void 0 ? void 0 : captions.length) && captions[1] ? captions[1] : ''))))));
};
var StyledSpan = defaultStyled.span(templateObject_1$V || (templateObject_1$V = __makeTemplateObject(["\n  .sentiment {\n    .tag-actions {\n      display: flex;\n      flex-direction: column;\n      gap: 5px;\n      align-items: center;\n      justify-content: center;\n\n      .main-container-box {\n        display: flex;\n        flex-direction: row;\n        gap: 30px;\n        width: 110px;\n      }\n      .tag-icon {\n        width: 2.5rem;\n        height: 2.5rem;\n        padding: 0.625rem;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border: 1px solid var(--grey);\n\n        &.active {\n          border: 1px solid var(--white);\n        }\n\n        &.like.active {\n          background: #019c49 !important;\n        }\n\n        &.dislike.active {\n          background: var(--indian-red);\n        }\n        span {\n          width: 1.5rem;\n          height: 1.5rem;\n\n          svg {\n            width: 1.5rem;\n            height: 1.5rem;\n          }\n        }\n\n        svg > path {\n          stroke: var(--grey);\n        }\n        &.active {\n          background: var(--indian-red) !important;\n\n          svg > path {\n            stroke: white;\n          }\n        }\n      }\n    }\n    .caption-text {\n      flex-wrap: wrap;\n      justify-content: center;\n      display: flex;\n      width: 40px;\n      color: var(--Gray-Dark-Gray, #a0a0a0);\n      text-align: center;\n      font-family: var(--font-family-base);\n      font-style: normal;\n      font-weight: 600;\n      line-height: 120%;\n    }\n  }\n"], ["\n  .sentiment {\n    .tag-actions {\n      display: flex;\n      flex-direction: column;\n      gap: 5px;\n      align-items: center;\n      justify-content: center;\n\n      .main-container-box {\n        display: flex;\n        flex-direction: row;\n        gap: 30px;\n        width: 110px;\n      }\n      .tag-icon {\n        width: 2.5rem;\n        height: 2.5rem;\n        padding: 0.625rem;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border: 1px solid var(--grey);\n\n        &.active {\n          border: 1px solid var(--white);\n        }\n\n        &.like.active {\n          background: #019c49 !important;\n        }\n\n        &.dislike.active {\n          background: var(--indian-red);\n        }\n        span {\n          width: 1.5rem;\n          height: 1.5rem;\n\n          svg {\n            width: 1.5rem;\n            height: 1.5rem;\n          }\n        }\n\n        svg > path {\n          stroke: var(--grey);\n        }\n        &.active {\n          background: var(--indian-red) !important;\n\n          svg > path {\n            stroke: white;\n          }\n        }\n      }\n    }\n    .caption-text {\n      flex-wrap: wrap;\n      justify-content: center;\n      display: flex;\n      width: 40px;\n      color: var(--Gray-Dark-Gray, #a0a0a0);\n      text-align: center;\n      font-family: var(--font-family-base);\n      font-style: normal;\n      font-weight: 600;\n      line-height: 120%;\n    }\n  }\n"])));
var templateObject_1$V;

var NpsItem = function (_a) {
    var label = _a.label, active = _a.active, onClick = _a.onClick;
    return (React__default.createElement("span", { onClick: onClick, className: "nps-rating ".concat(active ? 'selected' : '') },
        React__default.createElement(Text$1.B1, null, label)));
};
var NPSRating = function (_a) {
    var defaultValue = _a.defaultValue, _b = _a.count, count = _b === void 0 ? 5 : _b, props = __rest(_a, ["defaultValue", "count"]);
    var _c = useState(defaultValue || undefined), rating = _c[0], setRating = _c[1];
    useEffect(function () {
        if (defaultValue) {
            setRating(defaultValue);
        }
    }, [defaultValue]);
    var handleRateChange = function (newValue) {
        setRating(newValue);
        props.onChange && props.onChange(newValue);
    };
    var generateNps = function () {
        if (count > 5) {
            var firstRow = Array.from({ length: 5 }, function (_, i) { return i + 1; });
            var secondRow = Array.from({ length: count - 5 }, function (_, i) { return i + 6; });
            return [firstRow, secondRow];
        }
        return [Array.from({ length: count }, function (_, i) { return i + 1; })];
    };
    return (React__default.createElement(NpsRatingContainer, null, generateNps().map(function (item, i) {
        return (React__default.createElement("div", { key: i, className: classNames('nps-container', { 'nps-no-margin': i === 0 }) }, item.map(function (item) { return (React__default.createElement(NpsItem, { label: item, active: rating === item, onClick: function () { return handleRateChange(item); } })); })));
    })));
};
var NpsRatingContainer = defaultStyled.div(templateObject_1$U || (templateObject_1$U = __makeTemplateObject(["\n  display: flex;\n  gap: 0.625rem;\n  justify-content: center;\n  flex-wrap: wrap;\n\n  .nps-container {\n    display: flex;\n    gap: 0.625rem;\n\n    &.nps-margin {\n      margin-bottom: 10px;\n    }\n  }\n\n  .nps-rating {\n    position: relative;\n    display: flex;\n    width: 3.5rem;\n    height: 3.125rem;\n    padding: 0.5rem 1.25rem;\n    text-align: center;\n    align-items: center;\n    justify-content: space-evenly;\n    border-radius: 30px;\n    border: 1px solid var(--gray-light-gray, #eaeaea);\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n\n    &.selected > span {\n      color: white;\n    }\n  }\n\n  .nps-rating.selected {\n    background-color: var(--indian-red);\n    border: 1px solid var(--indian-red);\n  }\n\n  .nps-rating:not(.selected):hover {\n    background-color: lightgray;\n  }\n\n  .selected-rating {\n    margin-top: 0.5rem;\n    font-weight: bold;\n  }\n"], ["\n  display: flex;\n  gap: 0.625rem;\n  justify-content: center;\n  flex-wrap: wrap;\n\n  .nps-container {\n    display: flex;\n    gap: 0.625rem;\n\n    &.nps-margin {\n      margin-bottom: 10px;\n    }\n  }\n\n  .nps-rating {\n    position: relative;\n    display: flex;\n    width: 3.5rem;\n    height: 3.125rem;\n    padding: 0.5rem 1.25rem;\n    text-align: center;\n    align-items: center;\n    justify-content: space-evenly;\n    border-radius: 30px;\n    border: 1px solid var(--gray-light-gray, #eaeaea);\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n\n    &.selected > span {\n      color: white;\n    }\n  }\n\n  .nps-rating.selected {\n    background-color: var(--indian-red);\n    border: 1px solid var(--indian-red);\n  }\n\n  .nps-rating:not(.selected):hover {\n    background-color: lightgray;\n  }\n\n  .selected-rating {\n    margin-top: 0.5rem;\n    font-weight: bold;\n  }\n"])));
var templateObject_1$U;

var RateStyled = defaultStyled(Rate)(templateObject_1$T || (templateObject_1$T = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-around;\n  flex-wrap: wrap;\n  span {\n    font-size: 2.5rem;\n    line-height: 2.5rem;\n  }\n  .ant-rate-star {\n    svg {\n      color: #d6d6d6;\n    }\n  }\n  .ant-rate-star.ant-rate-star-full {\n    svg {\n      color: #fadb14;\n    }\n  }\n"], ["\n  display: flex;\n  justify-content: space-around;\n  flex-wrap: wrap;\n  span {\n    font-size: 2.5rem;\n    line-height: 2.5rem;\n  }\n  .ant-rate-star {\n    svg {\n      color: #d6d6d6;\n    }\n  }\n  .ant-rate-star.ant-rate-star-full {\n    svg {\n      color: #fadb14;\n    }\n  }\n"])));
// ant-rate-star-full
var BoostRateStyled = defaultStyled(Rate)(templateObject_2$C || (templateObject_2$C = __makeTemplateObject(["\n  span {\n    font-size: 0.875rem;\n    line-height: 1.25rem;\n  }\n"], ["\n  span {\n    font-size: 0.875rem;\n    line-height: 1.25rem;\n  }\n"])));
var RatingWrapper = defaultStyled.div(templateObject_3$p || (templateObject_3$p = __makeTemplateObject(["\n  padding: ", ";\n  gap: 0.625rem;\n  .main-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1.25rem;\n\n    .caption-text {\n      color: var(--Gray-Dark-Gray, #a0a0a0);\n      text-align: center;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 120%;\n      width: ", ";\n      justify-content: center;\n      align-items: center;\n      display: flex;\n    }\n  }\n"], ["\n  padding: ", ";\n  gap: 0.625rem;\n  .main-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1.25rem;\n\n    .caption-text {\n      color: var(--Gray-Dark-Gray, #a0a0a0);\n      text-align: center;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 120%;\n      width: ", ";\n      justify-content: center;\n      align-items: center;\n      display: flex;\n    }\n  }\n"])), function (props) {
    return props.$count === 3 ? '0.625rem 3.125rem' : props.$count === 10 ? '0.625rem 0.625rem' : '0px';
}, function (props) { return (props.$count === 3 ? '3.125rem;' : 'unset'); });
var renderRatingType = function (_a) {
    var props = __rest(_a, []);
    if (props.type === 'emoji') {
        return React__default.createElement(EmojiRating, __assign({}, props));
    }
    else if (props.type === 'thumbs') {
        return React__default.createElement(ThumbsRating, __assign({}, props));
    }
    else if (props.type === 'nps') {
        return React__default.createElement(NPSRating, __assign({}, props));
    }
    else if (props.type === 'boost') {
        return React__default.createElement(BoostRateStyled, __assign({}, props));
    }
    else
        return React__default.createElement(RateStyled, __assign({}, props));
};
var Rating = function (_a) {
    var props = __rest(_a, []);
    var captions = props.captions;
    return (React__default.createElement(RatingWrapper, { "$type": props === null || props === void 0 ? void 0 : props.type, "$count": props === null || props === void 0 ? void 0 : props.count },
        renderRatingType(props),
        captions && (captions === null || captions === void 0 ? void 0 : captions.length) && (captions === null || captions === void 0 ? void 0 : captions.length) === 2 && props.type !== 'thumbs' ? (React__default.createElement("div", { className: "main-container" },
            React__default.createElement(Text$1.B4, { className: "caption-text" }, captions[0]),
            React__default.createElement(Text$1.B4, { className: "caption-text" }, captions[1]))) : (React__default.createElement(React__default.Fragment, null))));
};
var templateObject_1$T, templateObject_2$C, templateObject_3$p;

var hexToRgbA = function (hex, alpha) {
    if (alpha === void 0) { alpha = 1; }
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('');
        if (c.length == 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        return "rgba(".concat([(c >> 16) & 255, (c >> 8) & 255, c & 255].join(','), ",").concat(alpha, ")");
    }
    return null;
};
var stringToHslColor = function (str, s, l) {
    if (s === void 0) { s = 50; }
    if (l === void 0) { l = 50; }
    var hash = 0;
    for (var i = 0; i < (str === null || str === void 0 ? void 0 : str.length); i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    var h = hash % 360;
    return 'hsl(' + h + ', ' + s + '%, ' + l + '%)';
};
var isTransparent = function (color) {
    // Check if the color is "transparent", RGBA with alpha 0, or hexadecimal RGBA with alpha 0
    return ((color === null || color === void 0 ? void 0 : color.toLowerCase()) === 'transparent' ||
        /^rgba?\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*,\s*0\s*\)$/i.test(color) ||
        /^#[0-9A-F]{6}00$/i.test(color));
};
var invertColor = function (hexColor) {
    // Remove '#' if present
    hexColor = hexColor === null || hexColor === void 0 ? void 0 : hexColor.replace('#', '');
    // Convert hex to RGB
    var r = parseInt(hexColor === null || hexColor === void 0 ? void 0 : hexColor.substring(0, 2), 16);
    var g = parseInt(hexColor === null || hexColor === void 0 ? void 0 : hexColor.substring(2, 4), 16);
    var b = parseInt(hexColor === null || hexColor === void 0 ? void 0 : hexColor.substring(4, 6), 16);
    // Invert RGB values
    r = 255 - r;
    g = 255 - g;
    b = 255 - b;
    // Convert RGB back to hex
    var invertedHex = '#' + r.toString(16).padStart(2, '0') + g.toString(16).padStart(2, '0') + b.toString(16).padStart(2, '0');
    return invertedHex;
};

var IconCard = function (_a) {
    var iconName = _a.iconName, iconUrl = _a.iconUrl, isYourWebsiteCategory = _a.isYourWebsiteCategory, isBrandLogo = _a.isBrandLogo, onClick = _a.onClick, theme = _a.theme, brandLogoBg = _a.brandLogoBg, maxHeight = _a.maxHeight, iconComponent = _a.iconComponent;
    return (React__default.createElement(IconCardWrap, { onClick: onClick, "$theme": theme, "$brandBg": brandLogoBg, "$height": maxHeight },
        React__default.createElement("div", { className: classNames('logo-wrap', { 'brand-logo': isBrandLogo }) }, iconComponent ? (iconComponent) : (React__default.createElement(React__default.Fragment, null, iconUrl ? (React__default.createElement("img", { src: iconUrl, width: 70, height: 70, alt: "" })) : (React__default.createElement(Text$1.H5, null, isYourWebsiteCategory ? 'Our Website' : iconName)))))));
};
var IconCardWrap = defaultStyled.div(templateObject_1$S || (templateObject_1$S = __makeTemplateObject(["\n  position: relative;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  cursor: pointer;\n  border: 1px solid #eaeaea;\n  height: ", ";\n  border-radius: 10px;\n  transition: all 300ms ease 0s;\n\n  .logo-wrap {\n    img {\n      object-fit: contain;\n    }\n    h5 {\n      margin-bottom: 0px;\n    }\n  }\n\n  .brand-logo {\n    background: ", ";\n    padding: 10px;\n    border-radius: 2px;\n  }\n\n  .promo-banner {\n    background: var(--sea-green-light);\n    position: absolute;\n    bottom: -2px;\n    left: -1px;\n    right: -1px;\n    text-align: center;\n    padding: 5px 0px;\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px;\n    color: var(--white);\n  }\n\n  :hover {\n    background: ", ";\n    border-color: ", ";\n  }\n\n  &.active-item {\n    background: ", ";\n  }\n\n  .menu-img {\n    object-fit: contain;\n  }\n"], ["\n  position: relative;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  cursor: pointer;\n  border: 1px solid #eaeaea;\n  height: ", ";\n  border-radius: 10px;\n  transition: all 300ms ease 0s;\n\n  .logo-wrap {\n    img {\n      object-fit: contain;\n    }\n    h5 {\n      margin-bottom: 0px;\n    }\n  }\n\n  .brand-logo {\n    background: ", ";\n    padding: 10px;\n    border-radius: 2px;\n  }\n\n  .promo-banner {\n    background: var(--sea-green-light);\n    position: absolute;\n    bottom: -2px;\n    left: -1px;\n    right: -1px;\n    text-align: center;\n    padding: 5px 0px;\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px;\n    color: var(--white);\n  }\n\n  :hover {\n    background: ", ";\n    border-color: ", ";\n  }\n\n  &.active-item {\n    background: ", ";\n  }\n\n  .menu-img {\n    object-fit: contain;\n  }\n"])), function (props) { return props.$height || '180px'; }, function (props) { return props.$brandBg || 'transparent'; }, function (_a) {
    var $theme = _a.$theme;
    return hexToRgbA($theme === null || $theme === void 0 ? void 0 : $theme.highlightColor, 0.5) || 'var(--orange)';
}, function (_a) {
    var $theme = _a.$theme;
    return hexToRgbA($theme === null || $theme === void 0 ? void 0 : $theme.highlightColor, 0.5) || 'var(--orange)';
}, function (_a) {
    var $theme = _a.$theme;
    return hexToRgbA($theme === null || $theme === void 0 ? void 0 : $theme.highlightColor, 0.5) || 'var(--orange)';
});
var templateObject_1$S;

var ProfileImage = function (_a) {
    var src = _a.src, name = _a.name, size = _a.size;
    return (React__default.createElement(StyledDiv$1, { "$size": size },
        React__default.createElement("div", { className: "profile-image-container" }, src ? (React__default.createElement("img", { src: src, alt: name, className: "profile-image" })) : (React__default.createElement("div", { className: "no-image" },
            React__default.createElement(Icon, { name: 'User', type: 'outline', size: 70 })))),
        React__default.createElement("div", { className: "profile-name" },
            React__default.createElement(Text$1.B1, { semibold: true }, name))));
};
var StyledDiv$1 = defaultStyled.div(templateObject_1$R || (templateObject_1$R = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  cursor: pointer;\n  width: ", ";\n  :hover {\n    outline: 1px solid #d84339;\n  }\n\n  .profile-image-container {\n    width: ", ";\n    height: ", ";\n  }\n\n  .profile-image {\n    border-radius: 50%;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  .no-image {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    width: 100%;\n    height: 100%;\n    background-color: #eaeaea;\n  }\n\n  .profile-name {\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  cursor: pointer;\n  width: ", ";\n  :hover {\n    outline: 1px solid #d84339;\n  }\n\n  .profile-image-container {\n    width: ", ";\n    height: ", ";\n  }\n\n  .profile-image {\n    border-radius: 50%;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  .no-image {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    width: 100%;\n    height: 100%;\n    background-color: #eaeaea;\n  }\n\n  .profile-name {\n  }\n"])), function (_a) {
    var $size = _a.$size;
    return $size || '140px';
}, function (_a) {
    var $size = _a.$size;
    return $size || '140px';
}, function (_a) {
    var $size = _a.$size;
    return $size || '140px';
});
var templateObject_1$R;

var LogoIcon$b = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#clip0_234_7829)" },
        React.createElement("g", null,
            React.createElement("path", { d: "M15.3019 20.319H4.29935C2.66879 20.319 1.33203 18.9822 1.33203 17.337V6.54004H18.2692V17.337C18.2692 18.9822 16.9472 20.319 15.3019 20.319Z", fill: "#FFA700" }),
            React.createElement("g", null,
                React.createElement("path", { d: "M6.09112 11.4313C6.07643 11.3725 6.06174 11.3432 6.03236 11.2697C6.01767 11.3138 6.00298 11.3285 6.00298 11.3432C5.94422 11.7251 5.90015 12.107 5.84139 12.4743C5.8267 12.533 5.84139 12.5771 5.8267 12.6359C5.8267 12.6652 5.79732 12.6946 5.78263 12.724C5.76794 12.6946 5.73856 12.6799 5.73856 12.6505C5.70919 12.4596 5.6945 12.2833 5.67981 12.0923C5.63574 11.5782 5.60636 11.0787 5.56229 10.5646C5.5476 10.3296 5.48884 10.0798 5.44477 9.84481C5.43008 9.80074 5.37132 9.75668 5.32725 9.74199C4.66622 9.56571 4.06394 9.31599 3.52042 8.90467C3.13849 8.61088 2.87408 8.24364 2.72718 7.78826C2.60966 7.42102 2.59497 7.03908 2.62435 6.65715C2.63904 6.51026 2.72718 6.36336 2.77125 6.21646C3.00628 5.51136 3.28539 4.83563 3.63794 4.18929C4.00518 3.51356 4.46056 2.8819 4.98939 2.30901C5.57698 1.67735 6.23801 1.14852 7.00188 0.7519C7.53071 0.472796 8.07422 0.28183 8.66181 0.149623C9.17595 0.0321056 9.69009 -0.0119634 10.2189 0.00272628C10.7037 0.017416 11.1737 0.0761747 11.6291 0.193692C12.1873 0.325899 12.7015 0.531555 13.2156 0.795969C13.7885 1.10445 14.3173 1.48638 14.7874 1.92707C15.5807 2.66156 16.1976 3.54294 16.6677 4.51246C16.7558 4.68873 16.7852 4.8797 16.7558 5.07067C16.6824 5.58481 16.6236 6.08425 16.5502 6.59839C16.5355 6.65715 16.5208 6.71591 16.5061 6.77467C16.3886 7.05377 16.5649 7.27412 16.6383 7.49446C16.7411 7.80295 16.888 8.08205 16.9762 8.39054C17.0643 8.66964 16.9909 8.91936 16.7999 9.1544C16.3151 9.7273 15.8304 10.3149 15.3603 10.9025C14.9343 11.446 14.5377 12.0189 14.2292 12.6359C14.097 12.915 14.0089 13.2088 13.9795 13.5172C13.9501 13.767 13.8913 14.002 13.8326 14.237C13.7444 14.5602 13.671 14.8834 13.5535 15.2065C13.4066 15.6032 13.2303 15.9851 13.054 16.3523C12.7896 16.8812 12.4664 17.3659 12.1139 17.836C11.5557 18.5705 10.8946 19.2021 10.1602 19.7457C10.1308 19.7603 10.0867 19.7603 10.0573 19.7603C10.072 19.731 10.072 19.6722 10.1014 19.6575C10.8065 19.0552 11.3206 18.3208 11.732 17.4981C11.9817 16.9987 12.1873 16.4846 12.3489 15.9557C12.4371 15.6472 12.5105 15.3241 12.5986 15.0156C12.7896 14.2811 12.8337 13.5319 12.819 12.7681C12.819 12.6212 12.8631 12.4596 12.9071 12.3127C12.9512 12.1511 12.9512 12.1364 12.8043 12.0776C12.5252 11.9601 12.2461 11.8573 11.967 11.7545C11.6585 11.6516 11.35 11.5488 11.0415 11.4754C10.6302 11.3725 10.2042 11.2844 9.79292 11.1963C9.08781 11.0494 8.36802 11.0494 7.64822 11.0641C7.23691 11.0787 6.84029 11.1375 6.42898 11.1816C6.3996 11.1816 6.37022 11.1963 6.34084 11.1963C6.1205 11.2697 6.1205 11.2697 6.09112 11.4313ZM13.3184 7.99391C13.3184 7.97922 13.3038 7.96453 13.3038 7.94984C13.3331 7.92047 13.3625 7.89109 13.3919 7.86171C13.6563 7.61198 13.862 7.3035 14.0089 6.98033C14.1851 6.59839 14.3467 6.20177 14.523 5.80515C14.7727 5.21756 15.0665 4.64467 15.61 4.24804C15.6835 4.20398 15.6541 4.15991 15.61 4.10115C14.949 3.48418 14.2586 2.91128 13.48 2.44121C12.628 1.91238 11.7173 1.53045 10.7184 1.38356C10.0573 1.29542 9.3963 1.29542 8.74995 1.41294C7.98609 1.54514 7.26629 1.79487 6.57588 2.13273C6.01767 2.39714 5.50353 2.72032 5.04815 3.14632C4.4018 3.7486 3.94642 4.4537 3.78484 5.33508C3.72608 5.65825 3.71139 5.98143 3.78484 6.28991C3.8436 6.53963 3.96111 6.75998 4.15208 6.93626C4.43118 7.20067 4.75436 7.37695 5.07753 7.53853C5.41539 7.70012 5.75325 7.84702 5.98829 8.1555C6.23801 8.47867 6.3996 8.83123 6.29677 9.27192C6.23801 9.49226 6.23801 9.71261 6.20863 9.93295C6.19395 10.0211 6.22332 10.0358 6.31146 10.0211C6.91374 9.96233 7.51602 9.99171 8.11829 10.0945C8.79402 10.1974 9.44037 10.3883 10.0573 10.6234C11.0415 11.0053 11.967 11.5047 12.8484 12.063C12.9365 12.1217 12.9512 12.0923 12.9806 12.0189C13.054 11.7398 13.1275 11.4607 13.2009 11.1816C13.3772 10.5058 13.5975 9.83012 13.8766 9.18378C13.9648 8.99281 14.0823 8.81654 14.1998 8.64026C14.2439 8.5815 14.3173 8.53743 14.3908 8.59619C14.4495 8.64026 14.4642 8.71371 14.4349 8.78716C14.3026 9.1544 14.1851 9.50695 14.0529 9.87419C13.8766 10.3883 13.7004 10.9025 13.6416 11.446C13.6122 11.6516 13.6269 11.8573 13.7444 12.0336C13.8473 12.1952 13.9354 12.1952 14.0529 12.0483C14.1998 11.8426 14.3467 11.6223 14.4789 11.3872C15.0224 10.4618 15.5953 9.56571 16.2417 8.69902C16.3739 8.53743 16.3886 8.36116 16.2858 8.18488C16.1682 7.97922 16.0213 7.77357 15.8891 7.56791C15.8598 7.50915 15.801 7.50915 15.7569 7.55322C15.6247 7.67074 15.4778 7.78826 15.3456 7.90578C15.3162 7.93515 15.2722 7.96453 15.2281 7.97922C15.2134 7.96453 15.1987 7.96453 15.184 7.94984C15.2428 7.80295 15.2869 7.64136 15.375 7.50915C15.6394 7.08315 15.9332 6.67184 16.1976 6.24584C16.3739 5.95205 16.5061 5.64356 16.6677 5.34977C16.6824 5.32039 16.6824 5.27632 16.6677 5.26163C16.6677 5.24694 16.6089 5.24694 16.5796 5.26163C16.4033 5.3057 16.227 5.33508 16.0507 5.37915C15.8598 5.42322 15.6982 5.54074 15.566 5.67294C15.2134 6.0255 14.9637 6.43681 14.6846 6.84812C14.4055 7.24474 14.097 7.61198 13.6563 7.84702C13.5388 7.90578 13.436 7.94984 13.3184 7.99391ZM5.00408 8.90467C5.04815 8.90467 5.09222 8.90467 5.15098 8.90467C5.25381 8.90467 5.28318 8.8606 5.20974 8.77247C5.15098 8.68433 5.07753 8.59619 4.98939 8.53743C4.68091 8.31709 4.37242 8.08205 4.06394 7.89109C3.8436 7.75888 3.60856 7.65605 3.35884 7.55322C3.22663 7.49446 3.13849 7.55322 3.1238 7.70012C3.10911 7.86171 3.10911 8.0086 3.19725 8.1555C3.31477 8.36116 3.47635 8.53743 3.66732 8.66964C3.71139 8.69902 3.77015 8.7284 3.82891 8.74309C4.21084 8.78716 4.60746 8.84592 5.00408 8.90467Z", fill: "black" }),
                React.createElement("path", { d: "M13.3187 7.99402C13.4216 7.94995 13.5391 7.90588 13.6419 7.86182C14.0826 7.64147 14.3911 7.27423 14.6702 6.86292C14.9493 6.4663 15.199 6.04029 15.5516 5.68774C15.6985 5.54084 15.8454 5.43802 16.0363 5.39395C16.2126 5.34988 16.3889 5.3205 16.5651 5.27643C16.5945 5.27643 16.6386 5.27643 16.6533 5.27643C16.668 5.30581 16.668 5.34988 16.6533 5.36457C16.5064 5.65836 16.3595 5.96685 16.1832 6.26064C15.9188 6.68664 15.625 7.09795 15.3606 7.52395C15.2725 7.65616 15.2284 7.81775 15.1696 7.96464C15.1843 7.97933 15.199 7.97933 15.2137 7.99402C15.2578 7.96464 15.2871 7.94995 15.3312 7.92057C15.4634 7.80306 15.6103 7.68554 15.7425 7.56802C15.7866 7.52395 15.8307 7.52395 15.8747 7.58271C16.0069 7.78837 16.1391 7.99402 16.2714 8.19968C16.3742 8.37595 16.3448 8.53754 16.2273 8.71382C15.5809 9.56582 15.008 10.4766 14.4645 11.402C14.3323 11.6224 14.1854 11.8427 14.0385 12.0631C13.9357 12.21 13.8329 12.21 13.73 12.0484C13.6125 11.8721 13.5978 11.6664 13.6272 11.4608C13.686 10.9173 13.8622 10.4031 14.0385 9.88899C14.1707 9.52175 14.2882 9.1692 14.4205 8.80196C14.4498 8.72851 14.4351 8.65506 14.3764 8.61099C14.3029 8.56692 14.2295 8.5963 14.1854 8.65506C14.0679 8.83133 13.9504 9.00761 13.8622 9.19858C13.5685 9.84492 13.3628 10.5206 13.1865 11.1964C13.1131 11.4755 13.0396 11.7546 12.9662 12.0337C12.9515 12.1071 12.9221 12.1365 12.834 12.0778C11.9526 11.5049 11.0271 11.0201 10.0429 10.6382C9.41127 10.3884 8.76492 10.2122 8.10389 10.1093C7.50161 10.0212 6.89934 9.97713 6.29706 10.0359C6.22361 10.0506 6.19423 10.0212 6.19423 9.94775C6.22361 9.72741 6.2383 9.49237 6.28237 9.28671C6.3852 8.84602 6.22361 8.50816 5.97389 8.1703C5.73885 7.86182 5.40099 7.71492 5.06312 7.55333C4.72526 7.39175 4.40209 7.20078 4.13767 6.95105C3.94671 6.77478 3.82919 6.55443 3.77043 6.30471C3.69698 5.98154 3.71167 5.65836 3.77043 5.34988C3.94671 4.4685 4.3874 3.76339 5.03375 3.16112C5.48913 2.73512 6.00326 2.41194 6.56147 2.14753C7.25189 1.82435 7.97168 1.55994 8.73555 1.42773C9.39658 1.31022 10.0429 1.29553 10.704 1.39835C11.7029 1.54525 12.6136 1.92718 13.4656 2.45601C14.2295 2.92608 14.9346 3.49898 15.5956 4.11595C15.6397 4.16001 15.6691 4.20408 15.5956 4.26284C15.0668 4.65946 14.773 5.23236 14.5086 5.81995C14.347 6.21657 14.1707 6.5985 13.9945 6.99512C13.8476 7.3183 13.6419 7.62678 13.3775 7.87651C13.3481 7.90588 13.3187 7.93526 13.2893 7.96464C13.304 7.96464 13.3187 7.97933 13.3187 7.99402ZM6.63492 3.1905C6.62023 3.1905 6.60554 3.1905 6.60554 3.20519C6.60554 3.23456 6.59085 3.27863 6.60554 3.30801C6.64961 3.64588 6.6643 3.99843 6.73775 4.33629C6.92871 5.23236 7.13437 6.12843 7.32534 7.0245C7.34003 7.11264 7.38409 7.14202 7.47223 7.12733C7.88354 7.09795 8.29486 7.06857 8.70617 7.05388C9.35251 7.03919 9.99886 7.06857 10.6452 7.15671C11.2034 7.23016 11.7322 7.34768 12.2611 7.53864C12.3933 7.5974 12.5402 7.64147 12.6724 7.70023C12.6724 7.68554 12.6871 7.68554 12.6871 7.67085C12.643 7.62678 12.6136 7.58271 12.5696 7.55333C12.2904 7.36237 12.0113 7.15671 11.7176 6.98043C11.556 6.87761 11.5266 6.90699 11.5853 6.64257C11.6441 6.36347 11.7176 6.06967 11.791 5.79057C11.9085 5.27643 12.0407 4.7476 12.1582 4.23346C12.2023 4.07188 12.2317 3.8956 12.2611 3.73401C12.2464 3.73401 12.2464 3.73401 12.2317 3.71932C12.217 3.73401 12.2023 3.76339 12.1876 3.77808C12.0554 4.14532 11.8644 4.4685 11.6588 4.77698C11.3062 5.30581 10.9096 5.81995 10.6599 6.42223C10.6305 6.51036 10.5718 6.49567 10.4983 6.48099C10.322 6.43692 10.1458 6.39285 9.98417 6.36347C9.44065 6.24595 8.88244 6.24595 8.32423 6.33409C8.2361 6.34878 8.19203 6.33409 8.16265 6.26064C7.92761 5.77588 7.69258 5.29112 7.45754 4.82105C7.28127 4.45381 7.10499 4.08657 6.92871 3.71932C6.8112 3.54305 6.72306 3.36677 6.63492 3.1905ZM14.9346 7.65616C14.9346 7.64147 14.9199 7.62678 14.9199 7.61209C14.6702 7.65616 14.4205 7.67085 14.1854 7.7443C13.8329 7.83244 13.6566 8.09685 13.5685 8.43471C13.5538 8.47878 13.5391 8.53754 13.6125 8.53754C13.7741 8.53754 13.9357 8.56692 14.0973 8.55223C14.2001 8.53754 14.3176 8.49347 14.3764 8.42002C14.4939 8.30251 14.582 8.1703 14.6849 8.0234C14.773 7.90588 14.8465 7.77368 14.9346 7.65616Z", fill: "white" }),
                React.createElement("path", { d: "M5.00475 8.90432C4.60813 8.84556 4.21151 8.78681 3.82957 8.71336C3.77082 8.69867 3.71206 8.66929 3.66799 8.63991C3.47702 8.5077 3.31544 8.33143 3.19792 8.12577C3.10978 7.97887 3.10978 7.83198 3.12447 7.67039C3.13916 7.52349 3.2273 7.46473 3.3595 7.52349C3.59454 7.62632 3.84426 7.72915 4.06461 7.86136C4.38778 8.06701 4.69627 8.28736 4.99006 8.5077C5.0782 8.56646 5.15165 8.6546 5.2104 8.74274C5.26916 8.83087 5.25447 8.86025 5.15165 8.87494C5.09289 8.90432 5.04882 8.90432 5.00475 8.90432Z", fill: "white" }),
                React.createElement("path", { d: "M6.63493 3.19043C6.72307 3.36671 6.81121 3.54298 6.89935 3.71926C7.07562 4.0865 7.2519 4.45374 7.42817 4.82098C7.66321 5.30574 7.89824 5.77581 8.13328 6.26057C8.17735 6.33402 8.22142 6.34871 8.29486 6.33402C8.85307 6.24588 9.39659 6.26057 9.9548 6.3634C10.1311 6.39278 10.3074 6.43685 10.4689 6.48092C10.5424 6.49561 10.6011 6.49561 10.6305 6.42216C10.8802 5.81988 11.2769 5.30574 11.6294 4.77692C11.8351 4.45374 12.0407 4.13057 12.1583 3.77802C12.1729 3.74864 12.1876 3.73395 12.2023 3.71926C12.217 3.71926 12.217 3.71926 12.2317 3.73395C12.2023 3.89553 12.1729 4.07181 12.1289 4.2334C12.0114 4.74754 11.8791 5.27636 11.7616 5.7905C11.6882 6.06961 11.6294 6.34871 11.556 6.64251C11.4972 6.90692 11.5266 6.87754 11.6882 6.98037C11.982 7.15664 12.2611 7.3623 12.5402 7.55327C12.5843 7.58264 12.6136 7.62671 12.6577 7.67078C12.6577 7.68547 12.643 7.68547 12.643 7.70016C12.5108 7.6414 12.3639 7.58264 12.2317 7.53858C11.7029 7.34761 11.1594 7.23009 10.6158 7.15664C9.96949 7.06851 9.32314 7.03913 8.6768 7.05382C8.26549 7.06851 7.85417 7.09789 7.44286 7.12726C7.34004 7.14195 7.31066 7.11257 7.29597 7.02444C7.105 6.12837 6.88465 5.2323 6.70838 4.33622C6.63493 3.99836 6.62024 3.64581 6.57617 3.30795C6.57617 3.27857 6.57617 3.24919 6.57617 3.20512C6.60555 3.19043 6.62024 3.19043 6.63493 3.19043Z", fill: "black" }),
                React.createElement("path", { d: "M14.9348 7.65589C14.8466 7.7734 14.7732 7.90561 14.6851 8.02313C14.5822 8.15534 14.4941 8.30223 14.3766 8.41975C14.3031 8.4932 14.1856 8.53727 14.0975 8.55196C13.9359 8.56665 13.7743 8.55196 13.6127 8.53727C13.5393 8.53727 13.5539 8.47851 13.5686 8.43444C13.6568 8.09658 13.833 7.83216 14.1856 7.74402C14.4206 7.68527 14.6704 7.65589 14.9201 7.61182C14.9201 7.62651 14.9201 7.6412 14.9348 7.65589Z", fill: "black" })))),
    React.createElement("defs", null,
        React.createElement("clipPath", null,
            React.createElement("rect", { width: 20, height: 20, fill: "white" }))))); };

var LogoIcon$a = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#clip0_234_8973)" },
        React.createElement("path", { d: "M19.9895 10.1871C19.9895 9.36767 19.9215 8.76973 19.7743 8.14966H10.1993V11.848H15.8196C15.7063 12.7671 15.0944 14.1512 13.7346 15.0813L13.7156 15.2051L16.743 17.4969L16.9527 17.5174C18.879 15.7789 19.9895 13.221 19.9895 10.1871Z", fill: "#4285F4" }),
        React.createElement("path", { d: "M10.2002 19.9312C12.9537 19.9312 15.2653 19.0453 16.9537 17.5173L13.7356 15.0812C12.8744 15.6681 11.7186 16.0777 10.2002 16.0777C7.5034 16.0777 5.2145 14.3393 4.39856 11.9365L4.27897 11.9464L1.13101 14.3271L1.08984 14.439C2.76686 17.6944 6.21158 19.9312 10.2002 19.9312Z", fill: "#34A853" }),
        React.createElement("path", { d: "M4.3965 11.9368C4.18121 11.3167 4.05661 10.6523 4.05661 9.96583C4.05661 9.27927 4.18121 8.61492 4.38517 7.99484L4.37947 7.86278L1.19206 5.44385L1.08778 5.49232C0.3966 6.84324 0 8.36026 0 9.96583C0 11.5714 0.3966 13.0884 1.08778 14.4393L4.3965 11.9368Z", fill: "#FBBC05" }),
        React.createElement("path", { d: "M10.2002 3.85336C12.1152 3.85336 13.4069 4.66168 14.1435 5.33717L17.0216 2.59107C15.254 0.985496 12.9537 0 10.2002 0C6.21158 0 2.76686 2.23672 1.08984 5.49214L4.38724 7.99466C5.2145 5.59183 7.5034 3.85336 10.2002 3.85336Z", fill: "#EB4335" })),
    React.createElement("defs", null,
        React.createElement("clipPath", null,
            React.createElement("rect", { width: 20, height: 20, fill: "white" }))))); };

var LogoIcon$9 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M14.9987 1.6665H12.4987C11.3936 1.6665 10.3338 2.10549 9.55242 2.88689C8.77102 3.66829 8.33203 4.7281 8.33203 5.83317V8.33317H5.83203V11.6665H8.33203V18.3332H11.6654V11.6665H14.1654L14.9987 8.33317H11.6654V5.83317C11.6654 5.61216 11.7532 5.4002 11.9094 5.24392C12.0657 5.08764 12.2777 4.99984 12.4987 4.99984H14.9987V1.6665Z", fill: "#4267B2" }))); };

var LogoIcon$8 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#clip0_234_9052)" },
        React.createElement("path", { d: "M6.6672 10C6.6672 8.15912 8.15912 6.6664 10 6.6664C11.8409 6.6664 13.3336 8.15912 13.3336 10C13.3336 11.8409 11.8409 13.3336 10 13.3336C8.15912 13.3336 6.6672 11.8409 6.6672 10ZM4.86512 10C4.86512 12.836 7.164 15.1349 10 15.1349C12.836 15.1349 15.1349 12.836 15.1349 10C15.1349 7.164 12.836 4.86512 10 4.86512C7.164 4.86512 4.86512 7.164 4.86512 10ZM14.1382 4.66152C14.1381 4.89886 14.2084 5.13089 14.3401 5.32829C14.4719 5.52568 14.6593 5.67956 14.8785 5.77047C15.0977 5.86138 15.339 5.88525 15.5718 5.83904C15.8046 5.79283 16.0185 5.67862 16.1863 5.51087C16.3542 5.34311 16.4686 5.12934 16.515 4.89658C16.5614 4.66382 16.5377 4.42253 16.447 4.20322C16.3563 3.98392 16.2025 3.79644 16.0052 3.6645C15.808 3.53257 15.576 3.4621 15.3386 3.462H15.3382C15.02 3.46215 14.715 3.58856 14.49 3.81347C14.265 4.03837 14.1384 4.34339 14.1382 4.66152M5.96 18.1398C4.98504 18.0954 4.45512 17.933 4.10296 17.7958C3.63608 17.614 3.30296 17.3975 2.95272 17.0478C2.60248 16.698 2.38568 16.3652 2.20472 15.8983C2.06744 15.5463 1.90504 15.0162 1.86072 14.0413C1.81224 12.9872 1.80256 12.6706 1.80256 10.0001C1.80256 7.3296 1.81304 7.01384 1.86072 5.95888C1.90512 4.98392 2.06872 4.45488 2.20472 4.10184C2.38648 3.63496 2.60296 3.30184 2.95272 2.9516C3.30248 2.60136 3.63528 2.38456 4.10296 2.2036C4.45496 2.06632 4.98504 1.90392 5.96 1.8596C7.01408 1.81112 7.33072 1.80144 10 1.80144C12.6693 1.80144 12.9862 1.81192 14.0412 1.8596C15.0162 1.904 15.5452 2.0676 15.8982 2.2036C16.3651 2.38456 16.6982 2.60184 17.0485 2.9516C17.3987 3.30136 17.6147 3.63496 17.7965 4.10184C17.9338 4.45384 18.0962 4.98392 18.1405 5.95888C18.189 7.01384 18.1986 7.3296 18.1986 10.0001C18.1986 12.6706 18.189 12.9863 18.1405 14.0413C18.0961 15.0162 17.9329 15.5462 17.7965 15.8983C17.6147 16.3652 17.3982 16.6983 17.0485 17.0478C16.6987 17.3972 16.3651 17.614 15.8982 17.7958C15.5462 17.933 15.0162 18.0954 14.0412 18.1398C12.9871 18.1882 12.6705 18.1979 10 18.1979C7.32952 18.1979 7.01376 18.1882 5.96 18.1398M5.8772 0.06056C4.81264 0.10904 4.0852 0.27784 3.44992 0.52504C2.792 0.78032 2.23504 1.1228 1.67848 1.67848C1.12192 2.23416 0.78032 2.792 0.52504 3.44992C0.27784 4.0856 0.10904 4.81264 0.06056 5.8772C0.01128 6.94344 0 7.28432 0 10C0 12.7157 0.01128 13.0566 0.06056 14.1228C0.10904 15.1874 0.27784 15.9144 0.52504 16.5501C0.78032 17.2076 1.122 17.7661 1.67848 18.3215C2.23496 18.877 2.792 19.219 3.44992 19.475C4.0864 19.7222 4.81264 19.891 5.8772 19.9394C6.944 19.9879 7.28432 20 10 20C12.7157 20 13.0566 19.9887 14.1228 19.9394C15.1874 19.891 15.9144 19.7222 16.5501 19.475C17.2076 19.219 17.765 18.8772 18.3215 18.3215C18.8781 17.7658 19.219 17.2076 19.475 16.5501C19.7222 15.9144 19.8918 15.1874 19.9394 14.1228C19.9879 13.0558 19.9992 12.7157 19.9992 10C19.9992 7.28432 19.9879 6.94344 19.9394 5.8772C19.891 4.81256 19.7222 4.0852 19.475 3.44992C19.219 2.7924 18.8772 2.23504 18.3215 1.67848C17.7658 1.12192 17.2076 0.78032 16.5509 0.52504C15.9144 0.27784 15.1874 0.10824 14.1236 0.06056C13.0574 0.01208 12.7165 0 10.0008 0C7.28512 0 6.944 0.01128 5.8772 0.06056Z", fill: "url(#paint0_radial_234_9052)" }),
        React.createElement("path", { d: "M6.6672 10C6.6672 8.15912 8.15912 6.6664 10 6.6664C11.8409 6.6664 13.3336 8.15912 13.3336 10C13.3336 11.8409 11.8409 13.3336 10 13.3336C8.15912 13.3336 6.6672 11.8409 6.6672 10ZM4.86512 10C4.86512 12.836 7.164 15.1349 10 15.1349C12.836 15.1349 15.1349 12.836 15.1349 10C15.1349 7.164 12.836 4.86512 10 4.86512C7.164 4.86512 4.86512 7.164 4.86512 10ZM14.1382 4.66152C14.1381 4.89886 14.2084 5.13089 14.3401 5.32829C14.4719 5.52568 14.6593 5.67956 14.8785 5.77047C15.0977 5.86138 15.339 5.88525 15.5718 5.83904C15.8046 5.79283 16.0185 5.67862 16.1863 5.51087C16.3542 5.34311 16.4686 5.12934 16.515 4.89658C16.5614 4.66382 16.5377 4.42253 16.447 4.20322C16.3563 3.98392 16.2025 3.79644 16.0052 3.6645C15.808 3.53257 15.576 3.4621 15.3386 3.462H15.3382C15.02 3.46215 14.715 3.58856 14.49 3.81347C14.265 4.03837 14.1384 4.34339 14.1382 4.66152M5.96 18.1398C4.98504 18.0954 4.45512 17.933 4.10296 17.7958C3.63608 17.614 3.30296 17.3975 2.95272 17.0478C2.60248 16.698 2.38568 16.3652 2.20472 15.8983C2.06744 15.5463 1.90504 15.0162 1.86072 14.0413C1.81224 12.9872 1.80256 12.6706 1.80256 10.0001C1.80256 7.3296 1.81304 7.01384 1.86072 5.95888C1.90512 4.98392 2.06872 4.45488 2.20472 4.10184C2.38648 3.63496 2.60296 3.30184 2.95272 2.9516C3.30248 2.60136 3.63528 2.38456 4.10296 2.2036C4.45496 2.06632 4.98504 1.90392 5.96 1.8596C7.01408 1.81112 7.33072 1.80144 10 1.80144C12.6693 1.80144 12.9862 1.81192 14.0412 1.8596C15.0162 1.904 15.5452 2.0676 15.8982 2.2036C16.3651 2.38456 16.6982 2.60184 17.0485 2.9516C17.3987 3.30136 17.6147 3.63496 17.7965 4.10184C17.9338 4.45384 18.0962 4.98392 18.1405 5.95888C18.189 7.01384 18.1986 7.3296 18.1986 10.0001C18.1986 12.6706 18.189 12.9863 18.1405 14.0413C18.0961 15.0162 17.9329 15.5462 17.7965 15.8983C17.6147 16.3652 17.3982 16.6983 17.0485 17.0478C16.6987 17.3972 16.3651 17.614 15.8982 17.7958C15.5462 17.933 15.0162 18.0954 14.0412 18.1398C12.9871 18.1882 12.6705 18.1979 10 18.1979C7.32952 18.1979 7.01376 18.1882 5.96 18.1398M5.8772 0.06056C4.81264 0.10904 4.0852 0.27784 3.44992 0.52504C2.792 0.78032 2.23504 1.1228 1.67848 1.67848C1.12192 2.23416 0.78032 2.792 0.52504 3.44992C0.27784 4.0856 0.10904 4.81264 0.06056 5.8772C0.01128 6.94344 0 7.28432 0 10C0 12.7157 0.01128 13.0566 0.06056 14.1228C0.10904 15.1874 0.27784 15.9144 0.52504 16.5501C0.78032 17.2076 1.122 17.7661 1.67848 18.3215C2.23496 18.877 2.792 19.219 3.44992 19.475C4.0864 19.7222 4.81264 19.891 5.8772 19.9394C6.944 19.9879 7.28432 20 10 20C12.7157 20 13.0566 19.9887 14.1228 19.9394C15.1874 19.891 15.9144 19.7222 16.5501 19.475C17.2076 19.219 17.765 18.8772 18.3215 18.3215C18.8781 17.7658 19.219 17.2076 19.475 16.5501C19.7222 15.9144 19.8918 15.1874 19.9394 14.1228C19.9879 13.0558 19.9992 12.7157 19.9992 10C19.9992 7.28432 19.9879 6.94344 19.9394 5.8772C19.891 4.81256 19.7222 4.0852 19.475 3.44992C19.219 2.7924 18.8772 2.23504 18.3215 1.67848C17.7658 1.12192 17.2076 0.78032 16.5509 0.52504C15.9144 0.27784 15.1874 0.10824 14.1236 0.06056C13.0574 0.01208 12.7165 0 10.0008 0C7.28512 0 6.944 0.01128 5.8772 0.06056Z", fill: "url(#paint1_radial_234_9052)" })),
    React.createElement("defs", null,
        React.createElement("radialGradient", { cx: 0, cy: 0, r: 1, gradientUnits: "userSpaceOnUse", gradientTransform: "translate(2.65712 20.0945) scale(26.1083 26.1083)" },
            React.createElement("stop", { offset: 0.09, stopColor: "#FA8F21" }),
            React.createElement("stop", { offset: 0.78, stopColor: "#D82D7E" })),
        React.createElement("radialGradient", { cx: 0, cy: 0, r: 1, gradientUnits: "userSpaceOnUse", gradientTransform: "translate(12.1291 20.9905) scale(20.577)" },
            React.createElement("stop", { offset: 0.64, stopColor: "#8C3AAA", stopOpacity: 0 }),
            React.createElement("stop", { offset: 1, stopColor: "#8C3AAA" })),
        React.createElement("clipPath", null,
            React.createElement("rect", { width: 20, height: 20, fill: "white" }))))); };

var LogoIcon$7 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6.2898 18.2602C13.8373 18.2602 17.9648 12.005 17.9648 6.58081C17.9648 6.40317 17.9612 6.22634 17.9532 6.05024C18.7563 5.46891 19.4494 4.74912 20 3.92463C19.2648 4.25163 18.4736 4.47171 17.6436 4.57093C18.4908 4.06276 19.1411 3.25882 19.448 2.30053C18.6425 2.77853 17.7613 3.1155 16.8424 3.29691C16.0936 2.49902 15.0276 2 13.8472 2C11.5812 2 9.74362 3.83829 9.74362 6.10427C9.74362 6.42642 9.77967 6.73967 9.85008 7.04024C6.43972 6.86858 3.41565 5.23516 1.39179 2.75146C1.02727 3.3779 0.835542 4.08986 0.836179 4.81463C0.836179 6.23878 1.56057 7.49598 2.66219 8.2315C2.01057 8.2116 1.37325 8.03552 0.803821 7.71809C0.803211 7.73532 0.803211 7.75211 0.803211 7.77053C0.803211 9.75846 2.2176 11.4183 4.09516 11.7943C3.74253 11.8904 3.37865 11.939 3.01317 11.9388C2.74923 11.9388 2.49199 11.9128 2.24199 11.8648C2.76439 13.4958 4.27919 14.6826 6.07516 14.7158C4.67073 15.817 2.90159 16.4729 0.97878 16.4729C0.651687 16.4732 0.32486 16.4542 0 16.416C1.81602 17.5804 3.97236 18.2599 6.29 18.2599", fill: "#1DA1F2" }))); };

var LogoIcon$6 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 323 251", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M233.592 9.32029C310.544 22.2541 350.657 152.248 299.848 201.694C249.04 251.14 117.264 257.338 40.1928 230.904C-36.8783 204.469 13.6252 142.873 64.4338 93.4271C115.242 43.981 108.6 -11.6881 233.592 9.32029Z", fill: "#FCF2F1" }),
    React.createElement("g", null,
        React.createElement("path", { d: "M244.229 180.026L77.4336 179.907L77.5704 70.5256L244.366 70.6446L244.229 180.026Z", fill: "white" }),
        React.createElement("path", { d: "M160.968 90.0171C199.227 90.018 244.366 70.6446 244.366 70.6446C244.366 70.6446 224.831 102.656 224.806 125.335C224.781 148.004 244.229 180.026 244.229 180.026C244.229 180.026 195.357 179.981 160.831 179.966C126.333 179.951 77.4336 179.907 77.4336 179.907C77.4336 179.907 96.9688 147.895 96.9935 125.216C97.0182 102.547 77.5704 70.5256 77.5704 70.5256C77.5704 70.5256 122.666 90.0163 160.968 90.0171Z", fill: "#FCFCFC" }),
        React.createElement("path", { d: "M77.4154 180.536L244.128 180.732C244.527 180.692 244.835 180.351 244.893 180.003L245.02 70.68C245.027 70.431 244.981 70.2804 244.784 70.1759C244.64 69.973 244.489 70.0191 244.293 69.9145L77.5278 69.8167C77.1283 69.8566 76.8209 70.1978 76.7623 70.5451L76.6353 179.868C76.629 180.117 76.675 180.268 76.8716 180.373C76.9699 180.425 76.9699 180.425 77.0682 180.477C77.1665 180.529 77.2648 180.582 77.4154 180.536ZM243.56 71.2916L243.419 179.219L78.0493 179.106L78.1907 71.1785L243.56 71.2916Z", fill: "#30384C" }),
        React.createElement("path", { d: "M160.461 148.357C160.363 148.304 160.363 148.304 160.264 148.252L76.9918 71.0446C76.7492 70.7894 76.7095 70.3898 76.9187 69.9963C77.1739 69.7535 77.5734 69.7136 77.9666 69.9226L160.8 146.771L243.834 70.0481C244.089 69.8053 244.587 69.8176 244.83 70.0728C245.072 70.3279 245.06 70.8259 244.804 71.0688L161.312 148.178C161.005 148.52 160.756 148.513 160.461 148.357Z", fill: "#30384C" }),
        React.createElement("path", { d: "M77.0604 180.474C76.9621 180.422 76.9621 180.422 76.8638 180.369C76.6212 180.114 76.6338 179.616 76.889 179.373L132.4 121.452C132.655 121.209 133.153 121.222 133.395 121.477C133.638 121.732 133.625 122.23 133.37 122.473L77.8594 180.394C77.6565 180.539 77.3553 180.631 77.0604 180.474Z", fill: "#30384C" }),
        React.createElement("path", { d: "M243.831 180.576C243.732 180.524 243.732 180.524 243.634 180.471L188.217 122.491C187.975 122.236 187.987 121.738 188.243 121.495C188.498 121.252 188.996 121.265 189.238 121.52L244.655 179.5C244.897 179.755 244.885 180.253 244.63 180.496C244.374 180.739 244.125 180.733 243.831 180.576Z", fill: "#30384C" })),
    React.createElement("g", null,
        React.createElement("path", { d: "M264.588 176.133C264.588 176.133 264.532 180.685 263.909 181.295C263.287 181.906 240.452 186.657 241.018 185.2C241.584 183.742 250.689 164.624 252.339 164.702C253.988 164.779 260.81 168.45 261.429 169.064C262.049 169.677 262.369 171.438 262.369 171.438C262.369 171.438 265.911 168.731 267.702 168.897C269.492 169.064 280.385 168.156 279.591 169.222C278.797 170.288 264.588 176.133 264.588 176.133Z", fill: "white" }),
        React.createElement("path", { d: "M241.758 185.708C241.726 185.599 241.734 185.483 241.783 185.38C241.832 185.278 241.917 185.197 242.023 185.153L242.837 184.811C242.762 184.814 242.687 184.799 242.62 184.766C242.552 184.734 242.494 184.685 242.451 184.625C242.379 184.53 242.347 184.411 242.363 184.293C242.379 184.175 242.441 184.068 242.535 183.995C249.292 178.672 259.326 170.616 260.835 169.067C259.658 168.109 253.678 165.238 252.164 165.232C250.432 165.821 241.747 184.245 241.42 185.625C241.407 185.741 241.35 185.848 241.259 185.924C241.168 185.999 241.052 186.038 240.933 186.032C240.815 186.025 240.703 185.974 240.622 185.889C240.54 185.804 240.494 185.692 240.494 185.575C240.494 185.019 243.484 178.633 245.424 174.745C250.632 164.318 251.637 164.318 252.121 164.318C253.529 164.318 261.891 167.831 261.891 169.061C261.891 169.297 261.891 169.7 251.713 177.872C258 173.737 265.446 168.972 266.893 168.614C268.864 168.125 279.281 167.873 280.275 168.634C280.341 168.684 280.396 168.749 280.434 168.823C280.472 168.897 280.492 168.978 280.494 169.061C280.494 169.514 280.494 169.744 261.299 177.966C255.556 180.429 249.757 182.881 246.133 184.414C253.619 183.078 262.679 181.373 263.588 180.94C263.87 180.588 264.047 178.969 264.05 177.625C264.05 177.503 264.099 177.387 264.186 177.301C264.273 177.215 264.391 177.167 264.514 177.167C264.638 177.167 264.756 177.215 264.843 177.301C264.93 177.387 264.979 177.503 264.979 177.625C264.979 178.386 264.925 180.926 264.222 181.618C263.594 182.24 250.196 184.647 242.262 186.027C242.235 186.03 242.208 186.03 242.181 186.027C242.085 186.023 241.994 185.99 241.918 185.933C241.843 185.876 241.787 185.797 241.758 185.708V185.708ZM267.124 169.508C265.154 169.991 249.281 180.546 243.194 184.667C256.356 179.127 274.726 171.28 278.881 169.217C276.294 168.967 269.098 169.022 267.124 169.522V169.508Z", fill: "black" })),
    React.createElement("g", null,
        React.createElement("path", { d: "M176.804 84.9502C176.804 84.9502 173.218 83.4745 165.239 77.6353C157.26 71.7962 155.43 70.4849 155.72 69.8909C156.011 69.2969 164.751 64.6683 165.469 64.9067C166.186 65.1451 170.265 68.6063 170.265 68.6063C170.265 68.6063 172.896 62.6191 173.492 62.4629C174.087 62.3067 184.763 61.2297 185.176 62.1587C185.588 63.0878 177.58 84.1774 176.804 84.9502Z", fill: "white" }),
        React.createElement("path", { d: "M176.929 85.2835C176.821 85.3201 176.703 85.3301 176.589 85.3123C175.215 85.1376 168.381 80.322 165.506 78.2584C162.25 75.9195 155.987 71.2703 155.552 70.4482C154.656 68.6806 165.196 64.6378 165.315 64.6008C165.821 64.4179 166.292 64.2473 171.459 73.8272C172.342 75.4714 173.211 77.1157 173.968 78.5544L170.099 69.1246C170.074 69.0578 170.074 68.9859 170.099 68.9191C170.292 68.3415 171.988 63.2381 172.801 62.4325C173.8 61.4356 183.746 61.0492 185.12 61.5137C185.214 61.5489 185.296 61.6029 185.359 61.6709C185.423 61.739 185.466 61.8191 185.484 61.9042C186.111 64.0356 177.893 84.4121 177.131 85.1684C177.075 85.2196 177.006 85.259 176.929 85.2835V85.2835ZM165.457 65.2811C162.716 66.2965 156.157 69.3733 156.304 70.1769C157.09 71.6156 174.4 83.9106 176.587 84.6114C177.827 82.6445 185.115 63.8527 184.703 62.1159C182.994 61.7049 174.119 62.2763 173.399 62.8764C172.887 63.3861 171.608 66.8596 170.897 69.0013L174.978 78.949L173.038 64.5433C173.028 64.4971 173.029 64.4497 173.041 64.4039C173.054 64.3582 173.077 64.315 173.11 64.2773C173.143 64.2395 173.185 64.2079 173.234 64.1844C173.282 64.161 173.335 64.1461 173.391 64.1409C173.446 64.1357 173.502 64.1401 173.556 64.1539C173.609 64.1678 173.658 64.1907 173.701 64.2214C173.743 64.252 173.777 64.2897 173.801 64.332C173.825 64.3743 173.839 64.4203 173.841 64.4672L176.36 83.2467C176.37 83.3276 176.345 83.4087 176.29 83.4756C176.235 83.5424 176.154 83.5906 176.061 83.6114C175.967 83.6322 175.868 83.6243 175.781 83.5891C175.694 83.5539 175.625 83.4937 175.586 83.4194C172.262 76.8752 166.677 66.3622 165.45 65.2811H165.457Z", fill: "black" })),
    React.createElement("g", null,
        React.createElement("path", { d: "M44.9665 168.763C46.0825 167.658 99.8094 156.241 99.1464 158.081C98.4834 159.922 82.3154 182.555 81.7587 182.555C81.202 182.555 74.7439 178.014 74.7439 178.014C74.7439 178.014 66.7068 185.866 65.5933 185.312C64.4799 184.759 61.1521 172.505 61.1521 172.505C61.1521 172.505 43.8429 169.865 44.9665 168.763Z", fill: "white" }),
        React.createElement("path", { d: "M65.6456 185.836C66.1011 185.836 67.541 185.183 73.6701 179.548C73.7513 179.473 73.7992 179.369 73.8032 179.26C73.8073 179.15 73.7671 179.043 73.6916 178.963C73.6542 178.923 73.6093 178.891 73.5593 178.868C73.5094 178.846 73.4555 178.833 73.4006 178.831C73.2898 178.827 73.1819 178.867 73.1007 178.942C70.355 181.466 67.2399 184.116 66.0631 184.832C66.4706 182.668 68.7759 175.39 69.6363 174.677C70.2766 174.792 72.8173 176.87 74.6823 178.398C79.2931 182.172 81.2492 183.633 82.0438 182.849C82.6208 182.275 87.0746 176.397 91.2577 170.602C99.6845 158.926 99.5428 158.064 99.4897 157.739C99.4788 157.658 99.4482 157.581 99.4006 157.515C99.353 157.449 99.2898 157.395 99.2164 157.358C98.1788 156.857 72.8983 161.819 71.8177 162.031C54.2048 165.5 45.0365 167.664 44.5683 168.463C44.5036 168.569 44.4838 168.696 44.5131 168.817C44.5425 168.937 44.6187 169.041 44.7252 169.107C46.3499 170.181 58.4385 172.079 60.797 172.443L64.0665 183.227C64.1001 183.332 64.1745 183.42 64.2735 183.471C64.3724 183.522 64.4878 183.532 64.5941 183.499C64.7005 183.465 64.7892 183.392 64.8407 183.294C64.8922 183.196 64.9023 183.082 64.8687 182.976L61.5233 171.942C61.5002 171.867 61.4564 171.8 61.3969 171.749C61.3374 171.697 61.2646 171.664 61.1867 171.651C55.9965 170.862 48.1997 169.5 45.7931 168.671C47.9998 167.877 56.4671 165.886 72.0126 162.825C84.7439 160.321 96.3214 158.27 98.5837 158.114C98.1308 159.216 95.8178 162.873 90.4378 170.311C86.2421 176.117 82.1071 181.556 81.4921 182.218H81.477C80.6849 182.218 77.2762 179.428 75.2239 177.747C71.1597 174.424 69.9653 173.57 69.3048 173.898C67.8928 174.596 65.1724 184.416 65.1724 185.301C65.1671 185.403 65.1937 185.504 65.2484 185.591C65.3032 185.678 65.3835 185.746 65.4786 185.786C65.5298 185.815 65.5869 185.832 65.6456 185.836V185.836Z", fill: "black" }),
        React.createElement("path", { d: "M69.4832 174.694C69.5552 174.694 69.6259 174.675 69.6882 174.639L99.2328 158.089C99.2972 158.053 99.3508 158 99.3881 157.937C99.4255 157.874 99.4452 157.802 99.4453 157.728C99.4446 157.659 99.4272 157.592 99.3946 157.531C99.3621 157.47 99.3152 157.417 99.2581 157.378C98.9772 157.187 98.752 157.045 79.7295 164.39C70.4246 167.979 61.0589 171.653 60.9678 171.696C60.8658 171.737 60.7842 171.816 60.7408 171.916C60.6975 172.016 60.6958 172.129 60.7361 172.23C60.7765 172.332 60.8556 172.413 60.9563 172.457C61.057 172.501 61.1712 172.504 61.274 172.465C72.4085 168.089 87.9793 162.049 95.1535 159.441L69.2757 173.937C69.1948 173.982 69.1312 174.052 69.095 174.137C69.0589 174.221 69.0521 174.315 69.0759 174.404C69.0997 174.493 69.1526 174.571 69.2264 174.627C69.3001 174.682 69.3905 174.712 69.4832 174.711V174.694Z", fill: "black" })))); };

var VoucherHandIcon = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 81 81", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", null,
        React.createElement("path", { d: "M41.494 62.5116C56.3931 62.5116 68.4711 50.4224 68.4711 35.5097C68.4711 20.597 56.3931 8.50781 41.494 8.50781C26.5949 8.50781 14.5168 20.597 14.5168 35.5097C14.5168 50.4224 26.5949 62.5116 41.494 62.5116Z", fill: "white" }),
        React.createElement("path", { d: "M57.9 14.0879C61.8657 19.2852 63.8121 25.7465 63.3778 32.2717C62.9435 38.7969 60.158 44.9427 55.5386 49.5675C50.9191 54.1924 44.7798 56.9821 38.2606 57.4185C31.7415 57.855 25.2857 55.9084 20.092 51.9405C22.4261 54.9995 25.3866 57.5237 28.775 59.3438C32.1634 61.1639 35.9015 62.2379 39.7385 62.4937C43.5755 62.7496 47.4229 62.1814 51.0226 60.8272C54.6223 59.4731 57.8911 57.3643 60.61 54.6422C63.3288 51.9202 65.4348 48.6478 66.7868 45.0444C68.1387 41.4411 68.7054 37.5901 68.4487 33.7496C68.1921 29.9091 67.1181 26.1679 65.2988 22.7769C63.4794 19.3858 60.9568 16.4233 57.9 14.0879V14.0879Z", fill: "#EAEAEA" }),
        React.createElement("path", { d: "M41.4943 63.2617C36.0114 63.2617 30.6516 61.6346 26.0924 58.586C21.5332 55.5375 17.9794 51.2044 15.8803 46.1346C13.7812 41.0647 13.2309 35.4858 14.2991 30.103C15.3673 24.7202 18.0061 19.7752 21.8817 15.8933C25.7573 12.0113 30.6958 9.36658 36.0729 8.29351C41.45 7.22044 47.0243 7.76716 52.091 9.86457C57.1577 11.962 61.4893 15.5159 64.5384 20.0771C67.5874 24.6382 69.2169 30.0018 69.2208 35.4898C69.2182 42.851 66.2968 49.9104 61.0982 55.1175C55.8997 60.3246 48.8489 63.2537 41.4943 63.2617V63.2617ZM41.4943 9.25793C36.3061 9.25794 31.2345 10.7981 26.9209 13.6835C22.6073 16.569 19.2457 20.6702 17.2611 25.4682C15.2766 30.2663 14.7584 35.5457 15.772 40.6386C16.7856 45.7315 19.2856 50.4091 22.9556 54.0797C26.6256 57.7502 31.3008 60.2489 36.3898 61.2596C41.4788 62.2703 46.753 61.7475 51.5451 59.7575C56.3373 57.7675 60.4321 54.3996 63.3117 50.0799C66.1912 45.7602 67.7261 40.6827 67.7221 35.4898C67.7089 28.5332 64.9407 21.8657 60.0244 16.9486C55.108 12.0315 48.4445 9.26586 41.4943 9.25793V9.25793Z", fill: "#30384C" }),
        React.createElement("path", { d: "M25.0778 52.3301C24.9375 52.4707 24.8586 52.6614 24.8586 52.8601C24.8586 53.0589 24.9375 53.2495 25.0778 53.3902C25.2137 53.5242 25.3966 53.5996 25.5874 53.6002C25.714 53.6008 25.8387 53.5696 25.9503 53.5096C26.0618 53.4497 26.1566 53.3627 26.226 53.2567C26.2954 53.1507 26.3372 53.029 26.3476 52.9027C26.358 52.7764 26.3367 52.6495 26.2856 52.5335C26.2346 52.4175 26.1553 52.3162 26.0551 52.2387C25.9549 52.1612 25.8369 52.11 25.7119 52.0898C25.5869 52.0696 25.4589 52.081 25.3394 52.123C25.2199 52.1649 25.1128 52.2361 25.0278 52.3301H25.0778Z", fill: "#30384C" }),
        React.createElement("path", { d: "M22.4407 20.4886C22.3193 20.6453 22.2648 20.8437 22.2891 21.0405C22.3135 21.2373 22.4147 21.4164 22.5706 21.5387C22.7014 21.6424 22.8633 21.6988 23.0302 21.6987C23.144 21.6983 23.2562 21.672 23.3584 21.6218C23.4605 21.5715 23.5499 21.4986 23.6197 21.4087C23.7319 21.2585 23.782 21.0708 23.7597 20.8846C23.7373 20.6984 23.6443 20.528 23.4998 20.4086C23.3479 20.2807 23.1519 20.2175 22.954 20.2324C22.756 20.2474 22.5717 20.3393 22.4407 20.4886V20.4886Z", fill: "#30384C" }),
        React.createElement("path", { d: "M27.6959 15.5785C27.5424 15.6892 27.4372 15.8546 27.4019 16.0407C27.3666 16.2267 27.4039 16.4192 27.5061 16.5786C27.5757 16.6782 27.6685 16.7593 27.7764 16.8151C27.8843 16.8708 28.0041 16.8995 28.1255 16.8986C28.2763 16.9054 28.4246 16.8594 28.5452 16.7686C28.6348 16.7167 28.7127 16.6469 28.774 16.5634C28.8353 16.48 28.8787 16.3847 28.9013 16.2836C28.924 16.1826 28.9256 16.0779 28.9058 15.9762C28.8861 15.8745 28.8455 15.778 28.7867 15.6928C28.7279 15.6076 28.652 15.5355 28.564 15.481C28.4759 15.4266 28.3775 15.391 28.2751 15.3765C28.1726 15.362 28.0682 15.3689 27.9685 15.3968C27.8689 15.4247 27.776 15.4729 27.6959 15.5385V15.5785Z", fill: "#30384C" }),
        React.createElement("path", { d: "M34.1804 12.3881C34.0064 12.4389 33.8566 12.551 33.7589 12.7039C33.6611 12.8567 33.622 13.0398 33.6489 13.2192C33.6757 13.3987 33.7666 13.5623 33.9048 13.6798C34.0429 13.7973 34.219 13.8607 34.4002 13.8582C34.4765 13.8679 34.5537 13.8679 34.63 13.8582C34.7292 13.8268 34.8209 13.7755 34.8997 13.7076C34.9785 13.6397 35.0427 13.5565 35.0885 13.463C35.1342 13.3695 35.1606 13.2677 35.1659 13.1637C35.1713 13.0598 35.1555 12.9558 35.1196 12.8581C35.0558 12.6722 34.9217 12.5188 34.746 12.4309C34.5704 12.343 34.3673 12.3276 34.1804 12.3881V12.3881Z", fill: "#30384C" }),
        React.createElement("path", { d: "M31.7622 56.0812C31.5849 56.0058 31.3854 56.0017 31.2052 56.0696C31.0249 56.1376 30.8777 56.2724 30.7942 56.4462C30.7106 56.6199 30.6971 56.8191 30.7564 57.0026C30.8157 57.186 30.9434 57.3395 31.1128 57.4313V57.4313C31.2173 57.4765 31.3288 57.5036 31.4425 57.5113C31.6134 57.5121 31.7795 57.4544 31.9132 57.3478C32.0469 57.2411 32.1401 57.092 32.1774 56.925C32.2147 56.758 32.1939 56.5833 32.1184 56.4298C32.0429 56.2764 31.9172 56.1533 31.7622 56.0812V56.0812Z", fill: "#30384C" }),
        React.createElement("path", { d: "M38.2469 58.0309C38.1483 58.0169 38.048 58.0226 37.9517 58.0478C37.8554 58.073 37.7651 58.1172 37.686 58.1777C37.607 58.2382 37.5408 58.3139 37.4912 58.4003C37.4417 58.4867 37.4099 58.5821 37.3976 58.681C37.3835 58.777 37.3887 58.8748 37.4129 58.9688C37.4371 59.0627 37.4797 59.1509 37.5383 59.2282C37.5969 59.3055 37.6703 59.3703 37.7542 59.4189C37.8382 59.4674 37.9309 59.4988 38.0271 59.511V59.511H38.137C38.3184 59.5124 38.4941 59.4469 38.6304 59.327C38.7667 59.2072 38.8543 59.0413 38.8763 58.861C38.8968 58.6684 38.8431 58.4753 38.7261 58.321C38.6091 58.1667 38.4377 58.063 38.2469 58.0309V58.0309Z", fill: "#30384C" }),
        React.createElement("path", { d: "M18.0642 34.6784C18.2564 34.6739 18.44 34.5974 18.5787 34.4641C18.7174 34.3309 18.8012 34.1504 18.8136 33.9584C18.8204 33.8609 18.8075 33.763 18.7758 33.6705C18.744 33.5781 18.694 33.493 18.6288 33.4202C18.5636 33.3475 18.4844 33.2886 18.396 33.247C18.3076 33.2055 18.2118 33.1821 18.1142 33.1783C18.0163 33.1702 17.9177 33.1816 17.8242 33.212C17.7307 33.2424 17.6442 33.2912 17.5698 33.3554C17.4954 33.4197 17.4345 33.4981 17.3907 33.5862C17.347 33.6743 17.3212 33.7702 17.3149 33.8684C17.3039 34.0658 17.3713 34.2595 17.5022 34.4074C17.6332 34.5553 17.8172 34.6456 18.0143 34.6584C18.0205 34.6654 18.0282 34.6709 18.0369 34.6744C18.0456 34.6778 18.0549 34.6792 18.0642 34.6784V34.6784Z", fill: "#30384C" }),
        React.createElement("path", { d: "M18.5143 40.1589C18.3332 40.2013 18.1739 40.3088 18.0667 40.461C17.9595 40.6132 17.9119 40.7995 17.9328 40.9845C17.9538 41.1696 18.0418 41.3405 18.1803 41.4648C18.3188 41.5891 18.4981 41.6582 18.6842 41.659C18.7406 41.6646 18.7975 41.6646 18.854 41.659C18.9508 41.6367 19.0422 41.5953 19.1229 41.5373C19.2036 41.4793 19.272 41.4059 19.3241 41.3212C19.3761 41.2365 19.4109 41.1423 19.4262 41.0441C19.4416 40.9458 19.4373 40.8455 19.4135 40.7489C19.3703 40.5525 19.252 40.3808 19.084 40.2706C18.916 40.1603 18.7115 40.1202 18.5143 40.1589V40.1589Z", fill: "#30384C" }),
        React.createElement("path", { d: "M20.8518 46.7603C20.6887 46.8619 20.5708 47.0223 20.5224 47.2084C20.4741 47.3945 20.499 47.5921 20.592 47.7603C20.6588 47.8702 20.7527 47.961 20.8647 48.024C20.9767 48.0871 21.103 48.1203 21.2315 48.1204C21.3633 48.1203 21.4933 48.0894 21.6112 48.0304C21.7723 47.9271 21.8893 47.7674 21.9392 47.5825C21.989 47.3976 21.9683 47.2007 21.8809 47.0303C21.8313 46.9446 21.7653 46.8696 21.6866 46.8097C21.608 46.7497 21.5182 46.7059 21.4225 46.6808C21.3269 46.6557 21.2272 46.6498 21.1292 46.6634C21.0313 46.6771 20.937 46.71 20.8518 46.7603V46.7603Z", fill: "#30384C" }),
        React.createElement("path", { d: "M19.8429 26.3784C19.751 26.3429 19.6531 26.3259 19.5547 26.3284C19.4563 26.3308 19.3593 26.3526 19.2693 26.3925C19.1793 26.4324 19.0981 26.4897 19.0302 26.5611C18.9623 26.6324 18.9091 26.7165 18.8737 26.8084C18.8383 26.9004 18.8213 26.9984 18.8237 27.0969C18.8261 27.1954 18.8479 27.2924 18.8878 27.3825C18.9277 27.4726 18.9849 27.5539 19.0562 27.6219C19.1275 27.6898 19.2115 27.743 19.3033 27.7785C19.39 27.8095 19.4811 27.8264 19.5731 27.8285C19.723 27.828 19.8694 27.7831 19.9939 27.6994C20.1184 27.6158 20.2153 27.4972 20.2725 27.3585C20.3095 27.266 20.3278 27.167 20.3261 27.0674C20.3245 26.9678 20.3031 26.8695 20.2631 26.7782C20.2231 26.687 20.1653 26.6046 20.0932 26.536C20.021 26.4673 19.936 26.4138 19.8429 26.3784V26.3784Z", fill: "#30384C" }),
        React.createElement("path", { d: "M62.2663 46.491C62.181 46.4418 62.0869 46.4098 61.9893 46.397C61.8916 46.3842 61.7924 46.3907 61.6973 46.4163C61.6022 46.4418 61.5131 46.4858 61.435 46.5458C61.3569 46.6059 61.2914 46.6807 61.2422 46.7661C61.193 46.8514 61.1611 46.9457 61.1482 47.0434C61.1354 47.1411 61.1419 47.2404 61.1675 47.3356C61.193 47.4307 61.237 47.52 61.2969 47.5981C61.3569 47.6763 61.4317 47.7419 61.5169 47.7911C61.6311 47.8519 61.7575 47.8861 61.8866 47.8911C62.0522 47.8924 62.2135 47.8388 62.3454 47.7387C62.4773 47.6385 62.5723 47.4975 62.6157 47.3376C62.6591 47.1777 62.6483 47.0079 62.5851 46.8547C62.5219 46.7016 62.4098 46.5737 62.2663 46.491V46.491Z", fill: "#30384C" }),
        React.createElement("path", { d: "M57.051 52.1123C56.926 52.2488 56.8567 52.4272 56.8567 52.6124C56.8567 52.7975 56.926 52.9759 57.051 53.1124C57.1195 53.1909 57.2039 53.2539 57.2987 53.297C57.3935 53.3401 57.4964 53.3624 57.6005 53.3624C57.7905 53.3578 57.972 53.283 58.1101 53.1524C58.248 53.0105 58.3252 52.8204 58.3252 52.6224C58.3252 52.4244 58.248 52.2343 58.1101 52.0924C57.967 51.9545 57.775 51.8792 57.5764 51.8829C57.3778 51.8867 57.1888 51.9692 57.051 52.1123V52.1123Z", fill: "#30384C" }),
        React.createElement("path", { d: "M41.3041 11.258C41.1053 11.258 40.9147 11.337 40.7742 11.4777C40.6336 11.6183 40.5547 11.8091 40.5547 12.008C40.5547 12.207 40.6336 12.3977 40.7742 12.5384C40.9147 12.6791 41.1053 12.7581 41.3041 12.7581C41.4028 12.7594 41.5009 12.741 41.5924 12.7037C41.6839 12.6665 41.7671 12.6113 41.8369 12.5414C41.9068 12.4715 41.9619 12.3883 41.9991 12.2967C42.0363 12.205 42.0548 12.1069 42.0534 12.008C42.0484 11.8107 41.9678 11.6229 41.8283 11.4833C41.6889 11.3437 41.5012 11.2631 41.3041 11.258V11.258Z", fill: "#30384C" }),
        React.createElement("path", { d: "M63.9846 26.489C63.896 26.3235 63.7493 26.1967 63.5729 26.133C63.3964 26.0693 63.2027 26.0732 63.0289 26.144C62.8552 26.2148 62.7138 26.3475 62.632 26.5164C62.5501 26.6854 62.5337 26.8786 62.5858 27.059C62.6456 27.1951 62.7434 27.3109 62.8675 27.3925C62.9916 27.4742 63.1367 27.5181 63.2852 27.519C63.3815 27.5183 63.4767 27.4978 63.5649 27.459C63.7487 27.3855 63.8959 27.2423 63.9745 27.0606C64.0531 26.8788 64.0568 26.6734 63.9846 26.489V26.489Z", fill: "#30384C" }),
        React.createElement("path", { d: "M65.6431 33.5806V33.4906C65.6229 33.2942 65.5271 33.1134 65.376 32.9865C65.225 32.8596 65.0305 32.7965 64.8338 32.8105C64.7357 32.8168 64.6399 32.8426 64.5519 32.8865C64.4639 32.9303 64.3855 32.9912 64.3213 33.0657C64.2571 33.1402 64.2084 33.2267 64.1781 33.3203C64.1477 33.4139 64.1362 33.5125 64.1444 33.6106C64.1444 33.6106 64.1444 33.6106 64.1444 33.6106C64.1572 33.7998 64.2421 33.9769 64.3815 34.1053C64.5209 34.2337 64.7043 34.3036 64.8938 34.3006H64.9537C65.1517 34.2828 65.3348 34.1879 65.4637 34.0365C65.5926 33.885 65.657 33.689 65.6431 33.4906V33.5806Z", fill: "#30384C" }),
        React.createElement("path", { d: "M64.5847 39.8901C64.3901 39.8481 64.1868 39.8844 64.0186 39.991C63.8504 40.0976 63.7308 40.2661 63.6855 40.4601C63.6436 40.6549 63.6798 40.8584 63.7863 41.0267C63.8928 41.1951 64.0611 41.3148 64.255 41.3602H64.4149C64.5984 41.3597 64.7755 41.2917 64.9123 41.1693C65.0492 41.0468 65.1363 40.8783 65.1573 40.6957C65.1782 40.5132 65.1315 40.3293 65.026 40.1789C64.9204 40.0286 64.7634 39.9222 64.5847 39.8801V39.8901Z", fill: "#30384C" }),
        React.createElement("path", { d: "M59.2599 20.1191C59.1407 20.2169 59.0546 20.349 59.0132 20.4975C58.9718 20.646 58.9771 20.8037 59.0284 20.9491C59.0797 21.0945 59.1746 21.2205 59.3 21.31C59.4255 21.3995 59.5754 21.4481 59.7295 21.4492C59.9053 21.4569 60.0773 21.3959 60.2091 21.2792C60.3505 21.157 60.4398 20.9852 60.4583 20.7991C60.4769 20.613 60.4235 20.4269 60.309 20.2791C60.2507 20.1995 60.1773 20.1323 60.093 20.0812C60.0086 20.03 59.9151 19.9961 59.8176 19.9812C59.7202 19.9663 59.6207 19.9709 59.525 19.9945C59.4293 20.0182 59.3392 20.0605 59.2599 20.1191V20.1191Z", fill: "#30384C" }),
        React.createElement("path", { d: "M45.0209 57.9922C44.9229 58.0068 44.8288 58.0407 44.7441 58.092C44.6593 58.1432 44.5855 58.2108 44.5269 58.2908C44.4684 58.3708 44.4263 58.4616 44.403 58.5579C44.3798 58.6543 44.3758 58.7543 44.3914 58.8522C44.4218 59.0272 44.5123 59.1859 44.6474 59.301C44.7824 59.4161 44.9535 59.4802 45.1308 59.4823H45.2507C45.4382 59.4425 45.6034 59.3324 45.7122 59.1745C45.8211 59.0166 45.8653 58.8229 45.8359 58.6333C45.8065 58.4438 45.7056 58.2727 45.554 58.1553C45.4024 58.0379 45.2116 57.9831 45.0209 58.0022V57.9922Z", fill: "#30384C" }),
        React.createElement("path", { d: "M48.4884 12.2773C48.3924 12.2401 48.2898 12.223 48.187 12.2272C48.0842 12.2314 47.9833 12.2567 47.8907 12.3016C47.7981 12.3465 47.7157 12.41 47.6486 12.4882C47.5816 12.5664 47.5314 12.6576 47.5012 12.756C47.4709 12.8545 47.4612 12.9581 47.4727 13.0605C47.4842 13.1629 47.5167 13.2618 47.5681 13.351C47.6194 13.4403 47.6886 13.518 47.7713 13.5793C47.8541 13.6406 47.9485 13.6843 48.0488 13.7074H48.2686C48.4291 13.7065 48.5851 13.6547 48.7144 13.5595C48.8436 13.4643 48.9394 13.3305 48.988 13.1774C49.0377 12.9918 49.0134 12.7941 48.9202 12.6261C48.827 12.4582 48.6721 12.3331 48.4884 12.2773V12.2773Z", fill: "#30384C" }),
        React.createElement("path", { d: "M53.9434 15.5785C53.8422 15.739 53.8065 15.9324 53.8437 16.1185C53.8809 16.3046 53.9881 16.4693 54.1432 16.5786C54.2695 16.6563 54.4146 16.6978 54.5629 16.6986C54.6844 16.7003 54.8046 16.672 54.9126 16.6162C55.0207 16.5604 55.1133 16.4788 55.1823 16.3786C55.2788 16.2167 55.3118 16.0248 55.2749 15.84C55.238 15.6552 55.1338 15.4907 54.9825 15.3785C54.9015 15.3222 54.8102 15.2826 54.7137 15.2622C54.6172 15.2417 54.5177 15.2408 54.4209 15.2594C54.324 15.278 54.2319 15.3159 54.1499 15.3707C54.0679 15.4255 53.9977 15.4961 53.9434 15.5785V15.5785Z", fill: "#30384C" }),
        React.createElement("path", { d: "M41.4941 55.5106C52.5304 55.5106 61.4771 46.5557 61.4771 35.5092C61.4771 24.4627 52.5304 15.5078 41.4941 15.5078C30.4577 15.5078 21.511 24.4627 21.511 35.5092C21.511 46.5557 30.4577 55.5106 41.4941 55.5106Z", fill: "white" }),
        React.createElement("path", { d: "M45.4907 19.4886C49.8159 19.4791 54.026 20.8837 57.4805 23.4888C55.7627 21.1963 53.5728 19.3001 51.059 17.9284C48.5453 16.5567 45.7664 15.7417 42.9106 15.5386C40.0548 15.3355 37.1887 15.7489 34.5065 16.751C31.8242 17.753 29.3884 19.3202 27.3639 21.3466C25.3394 23.3729 23.7736 25.8109 22.7725 28.4957C21.7714 31.1804 21.3583 34.0491 21.5613 36.9076C21.7642 39.766 22.5785 42.5474 23.9489 45.0634C25.3193 47.5795 27.2138 49.7714 29.5042 51.4908C27.2776 48.5192 25.9216 44.9857 25.5883 41.2862C25.2551 37.5867 25.9576 33.8674 27.6173 30.5451C29.2769 27.2227 31.8281 24.4286 34.9849 22.4758C38.1418 20.5229 41.7796 19.4886 45.4907 19.4886V19.4886Z", fill: "#EAEAEA" }),
        React.createElement("path", { d: "M41.4946 56.2607C37.395 56.2607 33.3874 55.0442 29.9784 52.7648C26.5694 50.4855 23.9121 47.2458 22.3423 43.4551C20.7725 39.6644 20.3608 35.4931 21.1591 31.4682C21.9575 27.4434 23.9301 23.7458 26.8275 20.8428C29.725 17.9399 33.4173 15.962 37.4377 15.159C41.4581 14.356 45.6261 14.7641 49.4148 16.3317C53.2035 17.8993 56.4428 20.5559 58.7233 23.9658C61.0038 27.3758 62.2231 31.3859 62.2271 35.4893C62.2271 40.9947 60.0434 46.275 56.1559 50.1698C52.2684 54.0646 46.9951 56.2554 41.4946 56.2607V56.2607ZM41.4946 16.2579C37.6897 16.2579 33.9703 17.3875 30.8069 19.5038C27.6435 21.62 25.1783 24.6278 23.7231 28.1467C22.2679 31.6656 21.8882 35.5374 22.632 39.2724C23.3757 43.0073 25.2096 46.4375 27.9014 49.1291C30.5933 51.8206 34.0223 53.6526 37.7546 54.3931C41.4869 55.1337 45.3548 54.7496 48.8689 53.2894C52.3831 51.8293 55.3856 49.3587 57.4966 46.1902C59.6076 43.0217 60.7323 39.2977 60.7283 35.4893C60.7178 30.3886 58.6873 25.5001 55.082 21.8953C51.4767 18.2904 46.5907 16.2632 41.4946 16.2579V16.2579Z", fill: "#30384C" }),
        React.createElement("path", { d: "M54.9727 42.8299C54.8453 42.833 54.7192 42.803 54.6068 42.743C54.4943 42.6829 54.3993 42.5947 54.3309 42.487C54.2626 42.3794 54.2232 42.2558 54.2166 42.1284C54.21 42.001 54.2364 41.8741 54.2933 41.7599C55.2371 39.8152 55.7276 37.6814 55.7276 35.5194C55.7276 33.3574 55.2371 31.2237 54.2933 29.279C54.249 29.1912 54.2227 29.0954 54.2159 28.9973C54.2091 28.8992 54.2218 28.8007 54.2535 28.7076C54.2851 28.6145 54.3349 28.5286 54.4001 28.455C54.4653 28.3814 54.5444 28.3216 54.633 28.2789C54.8107 28.1923 55.0154 28.1794 55.2025 28.2431C55.3896 28.3067 55.5441 28.4419 55.6321 28.619C56.6772 30.7671 57.2202 33.1251 57.2202 35.5144C57.2202 37.9037 56.6772 40.2617 55.6321 42.4099C55.5724 42.5346 55.479 42.64 55.3624 42.7143C55.2458 42.7885 55.1108 42.8286 54.9727 42.8299V42.8299Z", fill: "#30384C" }),
        React.createElement("path", { d: "M28.0162 42.8292C27.8749 42.8305 27.7362 42.7917 27.616 42.7174C27.4957 42.643 27.399 42.5362 27.3368 42.4092C26.2946 40.2602 25.7532 37.9025 25.7532 35.5137C25.7532 33.1249 26.2946 30.7673 27.3368 28.6183C27.3741 28.5209 27.4313 28.4324 27.5047 28.3584C27.5781 28.2844 27.6661 28.2265 27.7631 28.1884C27.8601 28.1504 27.9639 28.133 28.068 28.1374C28.1721 28.1418 28.2741 28.1678 28.3676 28.2139C28.4611 28.26 28.5439 28.325 28.6108 28.405C28.6777 28.4849 28.7273 28.5779 28.7563 28.6781C28.7853 28.7782 28.7931 28.8833 28.7792 28.9867C28.7653 29.09 28.73 29.1893 28.6757 29.2783C27.7354 31.224 27.2469 33.3574 27.2469 35.5187C27.2469 37.6801 27.7354 39.8135 28.6757 41.7592C28.7623 41.937 28.7751 42.1419 28.7115 42.3292C28.6479 42.5165 28.5129 42.6711 28.336 42.7592C28.2355 42.805 28.1265 42.8288 28.0162 42.8292V42.8292Z", fill: "#30384C" }),
        React.createElement("path", { d: "M41.4945 47.7615C38.0873 47.7615 35.0799 46.1514 33.831 43.6512C33.7422 43.4721 33.7281 43.2651 33.7918 43.0757C33.8555 42.8863 33.9918 42.73 34.1707 42.6411C34.3495 42.5522 34.5563 42.5382 34.7456 42.6019C34.9348 42.6657 35.091 42.8021 35.1798 42.9811C36.179 44.9813 38.6968 46.2614 41.4945 46.2614C45.2113 46.2614 48.2288 44.0212 48.2288 41.261C48.2288 38.0908 45.7608 36.2607 41.4745 36.2607C36.3188 36.2607 33.2415 33.8305 33.2415 29.7602C33.2415 26.18 36.9283 23.2598 41.4745 23.2598C44.8816 23.2598 47.889 24.8799 49.128 27.38C49.1726 27.4673 49.1994 27.5625 49.2069 27.6601C49.2145 27.7578 49.2026 27.856 49.1719 27.949C49.1412 28.0421 49.0924 28.1281 49.0283 28.2021C48.9641 28.2761 48.886 28.3366 48.7983 28.3801C48.6218 28.4675 48.4181 28.4819 48.2311 28.4201C48.0441 28.3584 47.889 28.2254 47.7991 28.0501C46.8 26.05 44.2821 24.7599 41.4845 24.7599C37.7676 24.7599 34.7502 27.01 34.7502 29.7602C34.7502 32.9404 37.1981 34.7606 41.4845 34.7606C46.6501 34.7606 49.7375 37.1907 49.7375 41.261C49.7375 44.8513 46.0406 47.7615 41.4945 47.7615Z", fill: "#30384C" }),
        React.createElement("path", { d: "M41.4948 51.2605C41.396 51.2618 41.298 51.2433 41.2064 51.2061C41.1149 51.1689 41.0318 51.1137 40.9619 51.0438C40.8921 50.9739 40.8369 50.8906 40.7997 50.799C40.7626 50.7074 40.7441 50.6093 40.7454 50.5104V20.4883C40.7454 20.2894 40.8244 20.0986 40.9649 19.958C41.1055 19.8173 41.2961 19.7383 41.4948 19.7383C41.6935 19.7383 41.8841 19.8173 42.0247 19.958C42.1652 20.0986 42.2442 20.2894 42.2442 20.4883V50.4904C42.2468 50.5906 42.2294 50.6903 42.193 50.7836C42.1565 50.8769 42.1017 50.962 42.0319 51.0338C41.962 51.1055 41.8785 51.1626 41.7863 51.2015C41.694 51.2405 41.5949 51.2605 41.4948 51.2605Z", fill: "#30384C" })),
    React.createElement("g", null,
        React.createElement("path", { d: "M68.8505 57.4912C68.7304 58.2986 68.3977 59.0594 67.8868 59.6956C67.3758 60.3318 66.705 60.8205 65.943 61.1115L53.4036 65.9218C52.8112 66.1401 52.1801 66.2336 51.5499 66.1965C50.9197 66.1593 50.3039 65.9924 49.7412 65.7061C49.1784 65.4197 48.6808 65.0202 48.2794 64.5324C47.8781 64.0447 47.5816 63.4793 47.4087 62.8716V62.8716C47.1566 61.9555 47.2673 60.9774 47.7178 60.141C48.1682 59.3045 48.9236 58.6742 49.8266 58.3813L52.3046 57.5912C59.2986 56.1111 63.4051 53.5009 66.0029 53.4609C68.351 53.4909 69.3201 55.5611 68.8505 57.4912Z", fill: "white" }),
        React.createElement("path", { d: "M67.3124 53.7812C66.8988 54.4234 66.3323 54.9527 65.6638 55.3214L53.9037 61.7918C52.854 62.3637 51.6224 62.5018 50.4722 62.1766C49.322 61.8514 48.3446 61.0888 47.7489 60.0517C47.4947 60.4775 47.3292 60.9504 47.2622 61.442C47.1953 61.9335 47.2283 62.4335 47.3593 62.9119C47.5322 63.5196 47.8286 64.085 48.23 64.5727C48.6314 65.0605 49.129 65.46 49.6917 65.7463C50.2545 66.0327 50.8703 66.1996 51.5005 66.2368C52.1307 66.2739 52.7618 66.1804 53.3542 65.9621L65.8936 61.1518C66.6702 60.8648 67.3549 60.3732 67.8755 59.729C68.3961 59.0847 68.7331 58.3117 68.8511 57.4915C69.0701 56.7907 69.0361 56.035 68.7548 55.3567C68.4735 54.6785 67.9629 54.1208 67.3124 53.7812V53.7812Z", fill: "#EAEAEA" }),
        React.createElement("path", { d: "M51.7746 67.011C50.6121 67.0111 49.4812 66.6312 48.5542 65.9289C47.6272 65.2267 46.9547 64.2406 46.639 63.1207C46.323 62.0175 46.4502 60.8343 46.9933 59.8236C47.5365 58.8128 48.4527 58.0545 49.5465 57.7103L52.0244 56.9203C55.0156 56.246 57.9489 55.3364 60.797 54.2001C62.4244 53.4481 64.1616 52.962 65.9426 52.76C66.508 52.7273 67.0733 52.8269 67.5935 53.0508C68.1138 53.2747 68.5749 53.6168 68.9401 54.0501C69.3203 54.5644 69.5806 55.1575 69.7016 55.7857C69.8226 56.4139 69.8014 57.0614 69.6395 57.6803C69.4926 58.6112 69.103 59.4869 68.5101 60.2191C67.9172 60.9512 67.1419 61.514 66.2624 61.8506L53.723 66.6609C53.1006 66.8967 52.4401 67.0153 51.7746 67.011V67.011ZM66.0026 54.2501C64.3991 54.4685 62.8368 54.9235 61.3665 55.6002C58.4701 56.7554 55.4866 57.6784 52.4441 58.3604L50.0461 59.1304C49.3249 59.3592 48.7207 59.8593 48.361 60.5254C48.0012 61.1915 47.914 61.9715 48.1177 62.7007C48.2619 63.2138 48.5113 63.6912 48.8499 64.1026C49.1885 64.514 49.6089 64.8503 50.0845 65.0902C50.56 65.3301 51.0803 65.4682 51.6121 65.4959C52.1439 65.5236 52.6756 65.4401 53.1735 65.2508L65.6729 60.4905C66.3058 60.2475 66.8641 59.8425 67.2919 59.3161C67.7196 58.7896 68.002 58.1601 68.1108 57.4903C68.1155 57.4706 68.1155 57.45 68.1108 57.4303C68.2278 57.0307 68.2526 56.6098 68.1834 56.1992C68.1141 55.7886 67.9527 55.3992 67.7111 55.0601C67.5106 54.7995 67.2512 54.5902 66.9542 54.4494C66.6572 54.3086 66.3311 54.2403 66.0026 54.2501V54.2501Z", fill: "#30384C" }),
        React.createElement("path", { d: "M71.589 57.4907C69.6606 55.8805 64.3151 60.8009 50.4169 63.4311C52.2454 62.741 52.8948 61.7209 52.9647 60.6909C53.2745 56.0806 49.2879 56.3006 49.2879 56.3006C28.7952 56.4906 44.382 51.6502 16.5156 51.4902V69.4915C16.5156 69.4915 47.1996 79.9222 70.4699 62.031C70.4699 62.031 74.1068 59.5708 71.589 57.4907Z", fill: "white" }),
        React.createElement("path", { d: "M71.589 57.4899C71.0195 57.0198 70.1502 57.1198 68.8613 57.5499C68.4797 58.1168 68.011 58.6197 67.4725 59.04C48.8582 74.491 24.5089 70.9508 16.5156 69.2107V69.4907C16.5156 69.4907 47.1996 79.9214 70.4699 62.0302C70.4699 62.0302 74.1068 59.57 71.589 57.4899Z", fill: "#EAEAEA" }),
        React.createElement("path", { d: "M37.2477 73.2218C30.1448 73.2518 23.0758 72.241 16.2654 70.2216C16.117 70.1714 15.988 70.0759 15.8966 69.9486C15.8052 69.8212 15.756 69.6684 15.7559 69.5116V51.4903C15.7555 51.3909 15.7758 51.2924 15.8153 51.2012C15.8549 51.11 15.9129 51.0279 15.9857 50.9603C16.0549 50.8901 16.1373 50.8346 16.2283 50.7968C16.3192 50.759 16.4168 50.7398 16.5152 50.7402C31.6124 50.8202 34.1902 52.3003 36.4983 53.6104C38.3567 54.6905 39.9753 55.6106 49.2974 55.5106C50.4844 55.5032 51.6276 55.9587 52.4847 56.7807C52.9637 57.3195 53.3185 57.9571 53.524 58.6484C53.7295 59.3396 53.7806 60.0677 53.6737 60.7809C53.64 61.2349 53.5142 61.6773 53.304 62.081C57.5718 61.0713 61.744 59.6927 65.7735 57.9607C69.0008 56.6307 70.7692 55.9006 72.0282 56.9607C72.395 57.2282 72.6913 57.581 72.8914 57.9887C73.0916 58.3964 73.1897 58.8467 73.1772 59.3008C73.0873 61.151 71.049 62.5711 70.8192 62.7211C60.0483 70.9816 47.5489 73.2218 37.2477 73.2218ZM17.2646 68.9415C21.3411 70.1716 48.9577 77.6321 69.9799 61.441C70.4495 61.121 71.6785 60.0909 71.7184 59.1608C71.7184 59.0108 71.7184 58.5808 71.109 58.0408C70.4995 57.5007 68.8009 58.3008 66.393 59.3008C61.3066 61.4907 55.9961 63.1171 50.5564 64.1512C50.37 64.1922 50.1749 64.1606 50.0111 64.0626C49.8472 63.9646 49.7269 63.8078 49.6746 63.624C49.6223 63.4403 49.6421 63.2435 49.7298 63.0739C49.8176 62.9042 49.9667 62.7745 50.1467 62.7111C51.4656 62.211 52.145 61.511 52.215 60.6209C52.2956 60.1286 52.2696 59.6246 52.1385 59.1432C52.0075 58.6617 51.7746 58.2141 51.4556 57.8307C50.8701 57.3077 50.1123 57.0192 49.3274 57.0207C39.5657 57.1407 37.7872 56.1206 35.7289 54.9305C33.6707 53.7405 31.3027 52.3804 17.2646 52.2703V68.9415Z", fill: "#30384C" }),
        React.createElement("path", { d: "M43.4924 64.9912C40.5704 64.9663 37.6533 64.7492 34.7598 64.3412C34.6556 64.3369 34.5534 64.3109 34.4598 64.2648C34.3662 64.2188 34.2832 64.1537 34.2162 64.0737C34.1492 63.9937 34.0996 63.9006 34.0706 63.8003C34.0416 63.7 34.0338 63.5948 34.0478 63.4913C34.0617 63.3878 34.0971 63.2884 34.1517 63.1994C34.2062 63.1105 34.2787 63.0339 34.3646 62.9745C34.4504 62.9152 34.5477 62.8745 34.6501 62.8549C34.7526 62.8354 34.858 62.8375 34.9596 62.8611C43.5024 63.9911 47.9486 63.3911 50.2467 62.7011C50.4313 62.6584 50.6252 62.6873 50.7893 62.782C50.9535 62.8766 51.0758 63.03 51.1315 63.2113C51.1872 63.3925 51.1723 63.5882 51.0897 63.7589C51.0071 63.9295 50.8629 64.0626 50.6863 64.1312C48.3431 64.7677 45.9194 65.0574 43.4924 64.9912V64.9912Z", fill: "#30384C" }),
        React.createElement("path", { d: "M16.5245 51.5117H8.53125V69.513H16.5245V51.5117Z", fill: "#EAEAEA" }),
        React.createElement("path", { d: "M8.52148 51.5117H13.5173V65.5127C13.5173 65.7779 13.412 66.0323 13.2246 66.2198C13.0372 66.4074 12.7831 66.5128 12.5181 66.5128H8.52148V51.5117Z", fill: "white" }),
        React.createElement("path", { d: "M16.5151 70.2616H8.52183C8.32308 70.2616 8.13248 70.1826 7.99194 70.0419C7.85141 69.9012 7.77246 69.7105 7.77246 69.5115V51.4903C7.77505 51.2922 7.85483 51.1029 7.99481 50.9628C8.13478 50.8227 8.32389 50.7428 8.52183 50.7402H16.5151C16.7138 50.7402 16.9044 50.8193 17.0449 50.9599C17.1855 51.1006 17.2644 51.2914 17.2644 51.4903V69.4915C17.2685 69.5921 17.2521 69.6924 17.2161 69.7863C17.1802 69.8803 17.1254 69.9659 17.0553 70.038C16.9852 70.11 16.9011 70.1671 16.8082 70.2055C16.7153 70.2439 16.6156 70.263 16.5151 70.2616V70.2616ZM9.27119 68.7615H15.7657V52.2603H9.27119V68.7615Z", fill: "#30384C" }),
        React.createElement("path", { d: "M12.5285 66.5119C13.0803 66.5119 13.5276 66.0641 13.5276 65.5118C13.5276 64.9595 13.0803 64.5117 12.5285 64.5117C11.9766 64.5117 11.5293 64.9595 11.5293 65.5118C11.5293 66.0641 11.9766 66.5119 12.5285 66.5119Z", fill: "#30384C" })))); };

var VoucherHandIconV2 = function (props) { return (React.createElement("svg", __assign({ width: "64", height: "65", viewBox: "0 0 64 65", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M18.3013 10.7206C24.4342 6.78766 34.2749 16.5793 41.7683 14.3298C49.2617 12.0803 54.2765 13.7537 58.9466 22.7385C62.7523 30.0601 56.4637 29.9537 62.2713 46.0124C68.0789 62.0711 58.1711 63.1031 48.5951 63.1031C36.9402 63.5929 31.2341 64.0126 23.3772 64.0126C15.5203 64.0126 11.8096 64.4096 7.3488 55.8276C3.61011 48.6349 -5.03865 41.5348 3.94915 32.9596C12.9369 24.3843 10.5498 15.6916 18.3013 10.7206Z", fill: "#FEE8E6" }),
    React.createElement("g", { "clip-path": "url(#clip0_7639_35486)" },
        React.createElement("mask", { id: "mask0_7639_35486", maskUnits: "userSpaceOnUse", x: "9", y: "2", width: "47", height: "47" },
            React.createElement("path", { d: "M9 2.99973H56V48.9997H9V2.99973Z", fill: "white" })),
        React.createElement("g", { mask: "url(#mask0_7639_35486)" },
            React.createElement("path", { d: "M36.3615 37.5478L45.4414 32.8761C48.7075 31.1956 52.7477 32.2527 54.5928 35.3801L54.6195 35.4252L35.382 47.2593C34.4255 47.8477 33.3189 47.7365 32.341 47.1828L21.7691 41.1969H18.2769", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "22.926", "stroke-linecap": "round", "stroke-linejoin": "round" }),
            React.createElement("path", { d: "M18.9656 29.2657H27.5028C28.2344 29.2657 28.913 29.4984 29.4656 29.8919L35.1474 33.1024C38.9863 35.2715 35.6357 40.9514 31.7968 38.7823L26.5621 35.8243H24.244", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "22.926", "stroke-linecap": "round", "stroke-linejoin": "round" }),
            React.createElement("path", { d: "M10.3804 26.4648H18.2769V45.2308H10.3804V26.4648Z", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "22.926", "stroke-linecap": "round", "stroke-linejoin": "round" }),
            React.createElement("path", { d: "M51.1332 15.2437C51.1332 21.2229 46.1808 26.0699 40.0717 26.0699C33.9626 26.0699 29.0102 21.2229 29.0102 15.2437C29.0102 9.26449 33.9626 4.41751 40.0717 4.41751C46.1808 4.41751 51.1332 9.26449 51.1332 15.2437Z", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "10", "stroke-linecap": "round", "stroke-linejoin": "round" }),
            React.createElement("path", { d: "M40.0717 10.9132V8.74801", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "10", "stroke-linecap": "round", "stroke-linejoin": "round" }),
            React.createElement("path", { d: "M40.0717 19.5742V21.7395", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "10", "stroke-linecap": "round", "stroke-linejoin": "round" }),
            React.createElement("path", { d: "M42.284 10.9132H39.3343C38.1124 10.9132 37.1219 11.8826 37.1219 13.0785C37.1219 14.2743 38.1124 15.2437 39.3343 15.2437H40.8092C42.0309 15.2437 43.0214 16.2131 43.0214 17.4089C43.0214 18.6048 42.0309 19.5742 40.8092 19.5742H37.8594", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "10", "stroke-linecap": "round", "stroke-linejoin": "round" }))),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_7639_35486" },
            React.createElement("rect", { width: "47", height: "46", fill: "white", transform: "translate(9 3)" }))))); };

var CrossIcon = function (props) { return (React.createElement("svg", __assign({ width: "20", height: "21", viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15 5.51562L5 15.5156", stroke: "#D84339", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }),
    React.createElement("path", { d: "M5 5.51562L15 15.5156", stroke: "#D84339", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }))); };

var VoucherAmountOffIcon = function (props) { return (React.createElement("svg", __assign({ width: "65", height: "59", viewBox: "0 0 65 59", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M18.5873 9.86885C24.816 6.24317 34.8105 15.2698 42.4209 13.196C50.0314 11.1223 55.1245 12.665 59.8677 20.9478C63.7328 27.6974 57.3459 27.5993 63.2443 42.4035C69.1427 57.2076 59.08 58.1589 49.3544 58.1589C37.5174 58.6105 31.7222 58.9974 23.7425 58.9974C15.7628 58.9974 11.9941 59.3634 7.46363 51.4519C3.66652 44.8211 -5.11738 38.2757 4.01085 30.3704C13.1391 22.465 10.7147 14.4515 18.5873 9.86885Z", fill: "#FEE8E6" }),
    React.createElement("g", { "clip-path": "url(#clip0_7875_15812)" },
        React.createElement("mask", { id: "mask0_7875_15812", style: { maskType: 'luminance' }, maskUnits: "userSpaceOnUse", x: "8", y: "2", width: "48", height: "49" },
            React.createElement("path", { d: "M8 2.99976H56V50.9998H8V2.99976Z", fill: "white" })),
        React.createElement("g", { mask: "url(#mask0_7875_15812)" },
            React.createElement("path", { d: "M35.9439 39.0499L45.217 34.1751C48.5526 32.4215 52.6788 33.5246 54.5631 36.7879L54.5904 36.8351L34.9436 49.1836C33.9667 49.7976 32.8367 49.6816 31.838 49.1038L21.041 42.8577H17.4746", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "22.926", "stroke-linecap": "round", "stroke-linejoin": "round" }),
            React.createElement("path", { d: "M18.1777 30.4077H26.8966C27.6437 30.4077 28.3368 30.6505 28.9011 31.0611L34.7038 34.4112C38.6243 36.6746 35.2025 42.6015 31.2819 40.338L25.9358 37.2515H23.5684", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "22.926", "stroke-linecap": "round", "stroke-linejoin": "round" }),
            React.createElement("path", { d: "M9.41016 27.4851H17.4746V47.0669H9.41016V27.4851Z", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "22.926", "stroke-linecap": "round", "stroke-linejoin": "round" }),
            React.createElement("path", { d: "M51.0293 15.7761C51.0293 22.0153 45.9715 27.073 39.7324 27.073C33.4933 27.073 28.4355 22.0153 28.4355 15.7761C28.4355 9.53697 33.4933 4.47925 39.7324 4.47925C45.9715 4.47925 51.0293 9.53697 51.0293 15.7761Z", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "10", "stroke-linecap": "round", "stroke-linejoin": "round" }),
            React.createElement("path", { d: "M39.7324 11.2574V8.99807", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "10", "stroke-linecap": "round", "stroke-linejoin": "round" }),
            React.createElement("path", { d: "M39.7324 20.2949V22.5543", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "10", "stroke-linecap": "round", "stroke-linejoin": "round" }),
            React.createElement("path", { d: "M41.9926 11.2574H38.9801C37.7323 11.2574 36.7207 12.2689 36.7207 13.5168C36.7207 14.7646 37.7323 15.7761 38.9801 15.7761H40.4864C41.7341 15.7761 42.7457 16.7877 42.7457 18.0355C42.7457 19.2834 41.7341 20.2949 40.4864 20.2949H37.4739", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "10", "stroke-linecap": "round", "stroke-linejoin": "round" }))),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_7875_15812" },
            React.createElement("rect", { width: "48", height: "48", fill: "white", transform: "translate(8 3)" }))))); };

var VoucherFreeItemIcon = function (props) { return (React.createElement("svg", __assign({ width: "65", height: "59", viewBox: "0 0 65 59", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M18.5873 9.86885C24.816 6.24317 34.8105 15.2698 42.4209 13.196C50.0314 11.1223 55.1245 12.665 59.8677 20.9478C63.7328 27.6974 57.3459 27.5993 63.2443 42.4035C69.1427 57.2076 59.08 58.1589 49.3544 58.1589C37.5174 58.6105 31.7222 58.9974 23.7425 58.9974C15.7628 58.9974 11.9941 59.3634 7.46363 51.4519C3.66652 44.8211 -5.11738 38.2757 4.01085 30.3704C13.1391 22.465 10.7147 14.4515 18.5873 9.86885Z", fill: "#FEE8E6" }),
    React.createElement("g", { "clip-path": "url(#clip0_7875_15732)" },
        React.createElement("mask", { id: "mask0_7875_15732", style: { maskType: 'luminance' }, maskUnits: "userSpaceOnUse", x: "8", y: "2", width: "49", height: "49" },
            React.createElement("path", { d: "M8.45508 2.39966H56.4551V50.3997H8.45508V2.39966Z", fill: "white" })),
        React.createElement("g", { mask: "url(#mask0_7875_15732)" },
            React.createElement("path", { d: "M36.399 38.4498L45.6721 33.575C49.0077 31.8214 53.1338 32.9245 55.0182 36.1878L55.0455 36.235L35.3987 48.5835C34.4218 49.1975 33.2918 49.0815 32.293 48.5037L21.4961 42.2576H17.9297", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "22.926", "stroke-linecap": "round", "stroke-linejoin": "round" }),
            React.createElement("path", { d: "M18.6328 29.8076H27.3517C28.0988 29.8076 28.7918 30.0504 29.3562 30.461L35.1589 33.8111C39.0794 36.0745 35.6575 42.0014 31.737 39.7379L26.3909 36.6514H24.0234", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "22.926", "stroke-linecap": "round", "stroke-linejoin": "round" }),
            React.createElement("path", { d: "M9.86523 26.8849H17.9297V46.4668H9.86523V26.8849Z", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "22.926", "stroke-linecap": "round", "stroke-linejoin": "round" }),
            React.createElement("path", { d: "M41.8325 5.00625C42.9995 5.03765 43.7034 6.51412 44.831 6.81628C45.7848 7.07184 46.944 6.08484 47.7856 6.60141C48.7806 7.21209 48.652 8.84269 49.4775 9.66825C50.1757 10.3664 51.6731 10.0913 52.1436 10.9594C52.6999 11.9858 51.7732 13.3335 52.0754 14.4613C52.3309 15.415 53.7653 15.9255 53.7387 16.9125C53.7073 18.0796 52.2309 18.7835 51.9287 19.9111C51.6732 20.8649 52.6602 22.0241 52.1436 22.8657C51.5329 23.8607 49.9023 23.7321 49.0767 24.5575C48.3786 25.2558 48.6537 26.7532 47.7856 27.2237C46.7592 27.78 45.4115 26.8533 44.2837 27.1554C43.33 27.411 42.8195 28.8454 41.8325 28.8189C40.6654 28.7874 39.9616 27.311 38.8339 27.0088C37.8801 26.7533 36.721 27.7403 35.8793 27.2237C34.8844 26.613 35.013 24.9824 34.1875 24.1568C33.4892 23.4587 31.9918 23.7338 31.5214 22.8657C30.965 21.8393 31.8917 20.4916 31.5896 19.3638C31.3341 18.4101 29.8996 17.8996 29.9261 16.9125C29.9576 15.7455 31.434 15.0416 31.7363 13.914C31.9917 12.9602 31.0048 11.801 31.5214 10.9594C32.132 9.96441 33.7626 10.093 34.5881 9.26756C35.2864 8.56931 35.0111 7.07194 35.8793 6.60141C36.9057 6.04509 38.2534 6.97181 39.3812 6.66965C40.3349 6.41409 40.8454 4.97972 41.8325 5.00625Z", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "22.926", "stroke-linecap": "round", "stroke-linejoin": "round" }),
            React.createElement("path", { d: "M34.9395 19.0379V16.897M36.3615 14.0258H34.9395V16.897M34.9395 16.897H36.1315M38.9913 19.0379V16.5545M38.9913 16.5545V14.0259C40.8091 13.9927 41.0492 14.4068 41.0492 15.2842C41.0492 16.1615 40.8314 16.4516 40.351 16.5545M38.9913 16.5545C39.5529 16.6296 39.946 16.6413 40.351 16.5545M40.351 16.5545L41.4261 18.9649M45.4864 14.0257H43.9584V16.3351M45.4154 18.7881H43.9584V16.3351M49.328 14.0257H47.8357V16.3351M49.328 18.7881H47.8357V16.3351M43.9584 16.3351H45.0597M47.8357 16.3351H49.0263", stroke: "#D84339", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }))),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_7875_15732" },
            React.createElement("rect", { width: "48", height: "48", fill: "white", transform: "translate(8 3)" }))))); };

var VoucherBogoIcon = function (props) { return (React.createElement("svg", __assign({ width: "65", height: "59", viewBox: "0 0 65 59", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M18.5873 9.86885C24.816 6.24317 34.8105 15.2698 42.4209 13.196C50.0314 11.1223 55.1245 12.665 59.8677 20.9478C63.7328 27.6974 57.3459 27.5993 63.2443 42.4035C69.1427 57.2076 59.08 58.1589 49.3544 58.1589C37.5174 58.6105 31.7222 58.9974 23.7425 58.9974C15.7628 58.9974 11.9941 59.3634 7.46363 51.4519C3.66652 44.8211 -5.11738 38.2757 4.01085 30.3704C13.1391 22.465 10.7147 14.4515 18.5873 9.86885Z", fill: "#FEE8E6" }),
    React.createElement("g", { "clip-path": "url(#clip0_7875_15772)" },
        React.createElement("mask", { id: "mask0_7875_15772", style: { maskType: 'luminance' }, maskUnits: "userSpaceOnUse", x: "8", y: "2", width: "49", height: "49" },
            React.createElement("path", { d: "M8.45508 2.39966H56.4551V50.3997H8.45508V2.39966Z", fill: "white" })),
        React.createElement("g", { mask: "url(#mask0_7875_15772)" },
            React.createElement("path", { d: "M36.399 38.4498L45.6721 33.575C49.0077 31.8214 53.1338 32.9245 55.0182 36.1878L55.0455 36.235L35.3987 48.5835C34.4218 49.1975 33.2918 49.0815 32.293 48.5037L21.4961 42.2576H17.9297", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "22.926", "stroke-linecap": "round", "stroke-linejoin": "round" }),
            React.createElement("path", { d: "M18.6328 29.8076H27.3517C28.0988 29.8076 28.7918 30.0504 29.3562 30.461L35.1589 33.8111C39.0794 36.0745 35.6575 42.0014 31.737 39.7379L26.3909 36.6514H24.0234", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "22.926", "stroke-linecap": "round", "stroke-linejoin": "round" }),
            React.createElement("path", { d: "M9.86523 26.8849H17.9297V46.4668H9.86523V26.8849Z", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "22.926", "stroke-linecap": "round", "stroke-linejoin": "round" }),
            React.createElement("path", { d: "M41.8325 5.00613C42.9995 5.03753 43.7034 6.514 44.831 6.81616C45.7848 7.07172 46.944 6.08472 47.7856 6.60128C48.7806 7.21197 48.652 8.84256 49.4775 9.66813C50.1757 10.3663 51.6731 10.0911 52.1436 10.9593C52.6999 11.9857 51.7732 13.3334 52.0754 14.4612C52.3309 15.4149 53.7653 15.9254 53.7387 16.9124C53.7073 18.0795 52.2309 18.7833 51.9287 19.911C51.6732 20.8648 52.6602 22.024 52.1436 22.8656C51.5329 23.8606 49.9023 23.7319 49.0767 24.5574C48.3786 25.2557 48.6537 26.753 47.7856 27.2236C46.7592 27.7799 45.4115 26.8532 44.2837 27.1553C43.33 27.4109 42.8195 28.8453 41.8325 28.8187C40.6654 28.7873 39.9616 27.3109 38.8339 27.0087C37.8801 26.7531 36.721 27.7401 35.8793 27.2236C34.8844 26.6129 35.013 24.9823 34.1875 24.1567C33.4892 23.4586 31.9918 23.7337 31.5214 22.8656C30.965 21.8391 31.8917 20.4915 31.5896 19.3637C31.3341 18.4099 29.8996 17.8995 29.9261 16.9124C29.9576 15.7454 31.434 15.0415 31.7363 13.9139C31.9917 12.9601 31.0048 11.8008 31.5214 10.9593C32.132 9.96428 33.7626 10.0929 34.5881 9.26744C35.2864 8.56919 35.0111 7.07181 35.8793 6.60128C36.9057 6.04497 38.2534 6.97169 39.3812 6.66953C40.3349 6.41397 40.8454 4.9796 41.8325 5.00613Z", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "22.926", "stroke-linecap": "round", "stroke-linejoin": "round" }),
            React.createElement("path", { d: "M46.4531 12.4867L46.4531 21.1117", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "22.926", "stroke-linecap": "round", "stroke-linejoin": "round" }),
            React.createElement("path", { d: "M38.5684 15.8872L38.5684 19.4353", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "22.926", "stroke-linecap": "round", "stroke-linejoin": "round" }),
            React.createElement("path", { d: "M40.343 17.7142L36.7949 17.7142", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "22.926", "stroke-linecap": "round", "stroke-linejoin": "round" }),
            React.createElement("path", { d: "M46.4239 12.511L43.7012 15.4799", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "22.926", "stroke-linecap": "round", "stroke-linejoin": "round" }))),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_7875_15772" },
            React.createElement("rect", { width: "48", height: "48", fill: "white", transform: "translate(8 3)" }))))); };

var VoucherPercentageOffIcon = function (props) { return (React.createElement("svg", __assign({ width: "65", height: "59", viewBox: "0 0 65 59", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M18.5873 9.86885C24.816 6.24317 34.8105 15.2698 42.4209 13.196C50.0314 11.1223 55.1245 12.665 59.8677 20.9478C63.7328 27.6974 57.3459 27.5993 63.2443 42.4035C69.1427 57.2076 59.08 58.1589 49.3544 58.1589C37.5174 58.6105 31.7222 58.9974 23.7425 58.9974C15.7628 58.9974 11.9941 59.3634 7.46363 51.4519C3.66652 44.8211 -5.11738 38.2757 4.01085 30.3704C13.1391 22.465 10.7147 14.4515 18.5873 9.86885Z", fill: "#FEE8E6" }),
    React.createElement("g", { "clip-path": "url(#clip0_7787_17040)" },
        React.createElement("mask", { id: "mask0_7787_17040", style: { maskType: 'luminance' }, maskUnits: "userSpaceOnUse", x: "8", y: "2", width: "48", height: "49" },
            React.createElement("path", { d: "M8 2.99976H56V50.9998H8V2.99976Z", fill: "white" })),
        React.createElement("g", { mask: "url(#mask0_7787_17040)" },
            React.createElement("path", { d: "M35.9439 39.0499L45.217 34.1751C48.5526 32.4215 52.6788 33.5246 54.5631 36.7879L54.5904 36.8351L34.9436 49.1836C33.9667 49.7976 32.8367 49.6816 31.838 49.1038L21.041 42.8577H17.4746", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "22.926", "stroke-linecap": "round", "stroke-linejoin": "round" }),
            React.createElement("path", { d: "M18.1777 30.4077H26.8966C27.6437 30.4077 28.3368 30.6505 28.9011 31.0611L34.7038 34.4112C38.6243 36.6746 35.2025 42.6015 31.2819 40.338L25.9358 37.2515H23.5684", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "22.926", "stroke-linecap": "round", "stroke-linejoin": "round" }),
            React.createElement("path", { d: "M9.41016 27.4851H17.4746V47.0669H9.41016V27.4851Z", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "22.926", "stroke-linecap": "round", "stroke-linejoin": "round" }),
            React.createElement("path", { d: "M41.3774 4.40639C42.5444 4.4378 43.2483 5.91427 44.3759 6.21642C45.3297 6.47199 46.4889 5.48499 47.3305 6.00155C48.3255 6.61224 48.1969 8.24283 49.0224 9.06839C49.7206 9.76655 51.218 9.4914 51.6885 10.3595C52.2448 11.386 51.3181 12.7336 51.6204 13.8615C51.8758 14.8152 53.3102 15.3256 53.2837 16.3126C53.2523 17.4797 51.7758 18.1836 51.4736 19.3112C51.2181 20.2651 52.2051 21.4243 51.6885 22.2659C51.0778 23.2608 49.4472 23.1322 48.6217 23.9577C47.9235 24.6559 48.1987 26.1533 47.3305 26.6238C46.3042 27.1802 44.9564 26.2534 43.8286 26.5556C42.8749 26.8112 42.3644 28.2455 41.3774 28.219C40.2103 28.1876 39.5065 26.7111 38.3788 26.409C37.425 26.1534 36.2659 27.1404 35.4242 26.6238C34.4293 26.0132 34.5579 24.3826 33.7324 23.557C33.0341 22.8588 31.5368 23.134 31.0663 22.2659C30.5099 21.2394 31.4366 19.8917 31.1345 18.7639C30.879 17.8102 29.4445 17.2997 29.4711 16.3126C29.5025 15.1456 30.9789 14.4418 31.2812 13.3141C31.5367 12.3603 30.5498 11.2011 31.0663 10.3595C31.6769 9.36455 33.3075 9.49318 34.1331 8.66771C34.8313 7.96946 34.5561 6.47208 35.4242 6.00155C36.4507 5.44524 37.7983 6.37196 38.9261 6.0698C39.8799 5.81424 40.3903 4.37986 41.3774 4.40639Z", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "22.926", "stroke-linecap": "round", "stroke-linejoin": "round" }),
            React.createElement("path", { d: "M43.5332 12.5776L39.2207 20.047", stroke: "#D84339", "stroke-width": "2", "stroke-miterlimit": "22.926", "stroke-linecap": "round", "stroke-linejoin": "round" }),
            React.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M38.6916 11.5785C39.3643 11.9668 39.5947 12.8269 39.2063 13.4995C38.8181 14.1721 37.958 14.4026 37.2854 14.0143C36.6128 13.6258 36.3824 12.7659 36.7707 12.0932C37.159 11.4207 38.019 11.1902 38.6916 11.5785Z", fill: "" }),
            React.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M45.7444 18.0944C46.417 18.4827 46.6474 19.3428 46.2591 20.0154C45.8708 20.688 45.0107 20.9184 44.3381 20.5301C43.6655 20.1417 43.4351 19.2817 43.8235 18.6092C44.2117 17.9365 45.0717 17.7061 45.7444 18.0944Z", fill: "" }))),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_7787_17040" },
            React.createElement("rect", { width: "48", height: "48", fill: "white", transform: "translate(8 3)" }))))); };

var LOGO_ORIGINAL_COLOR = /*#__PURE__*/Object.freeze({
    __proto__: null,
    CrossIcon: CrossIcon,
    Facebook: LogoIcon$9,
    Google: LogoIcon$a,
    Instagram: LogoIcon$8,
    SendMail: LogoIcon$6,
    TableAgent: LogoIcon$b,
    Twitter: LogoIcon$7,
    VoucherAmountOffIcon: VoucherAmountOffIcon,
    VoucherBogoIcon: VoucherBogoIcon,
    VoucherFreeItemIcon: VoucherFreeItemIcon,
    VoucherHandIcon: VoucherHandIcon,
    VoucherHandIconV2: VoucherHandIconV2,
    VoucherPercentageOffIcon: VoucherPercentageOffIcon
});

var LogoIcon$5 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 65 59", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M18.5873 9.86885C24.816 6.24317 34.8105 15.2698 42.4209 13.196C50.0314 11.1223 55.1245 12.665 59.8677 20.9478C63.7328 27.6974 57.3459 27.5993 63.2443 42.4035C69.1427 57.2076 59.08 58.1589 49.3544 58.1589C37.5174 58.6105 31.7222 58.9974 23.7425 58.9974C15.7628 58.9974 11.9941 59.3634 7.46363 51.4519C3.66652 44.8211 -5.11738 38.2757 4.01085 30.3704C13.1391 22.465 10.7147 14.4515 18.5873 9.86885Z", fill: "#FCF2F1" }),
    React.createElement("g", null,
        React.createElement("line", { x1: 14.8, y1: 5.79999, x2: 14.8, y2: 44.2, stroke: "#D84339", strokeWidth: 2 }),
        React.createElement("line", { x1: 45, y1: 18.8, x2: 30.6, y2: 18.8, stroke: "#D84339", strokeWidth: 2 }),
        React.createElement("line", { x1: 45, y1: 28.4, x2: 30.6, y2: 28.4, stroke: "#D84339", strokeWidth: 2 }),
        React.createElement("path", { d: "M22 6.79999H52.6C53.1523 6.79999 53.6 7.2477 53.6 7.79999V42.2C53.6 42.7523 53.1523 43.2 52.6 43.2H22V6.79999Z", stroke: "#D84339", strokeWidth: 2 })))); };

var LogoIcon$4 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 65 59", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M18.5873 9.86885C24.816 6.24317 34.8105 15.2698 42.4209 13.196C50.0314 11.1223 55.1245 12.665 59.8677 20.9478C63.7328 27.6974 57.3459 27.5993 63.2443 42.4035C69.1427 57.2076 59.08 58.1589 49.3544 58.1589C37.5174 58.6105 31.7222 58.9974 23.7425 58.9974C15.7628 58.9974 11.9941 59.3634 7.46363 51.4519C3.66652 44.8211 -5.11738 38.2757 4.01085 30.3704C13.1391 22.465 10.7147 14.4515 18.5873 9.86885Z", fill: "#FCF2F1" }),
    React.createElement("g", null,
        React.createElement("g", null,
            React.createElement("path", { d: "M19.4578 43.5601V15.4688H46.5446V43.5601", stroke: "#D84339", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }),
            React.createElement("path", { d: "M26.55 14.3133V11.5992C26.55 8.76157 28.8717 6.43985 31.7094 6.43985H34.2891C37.1268 6.43985 39.4485 8.76157 39.4485 11.5992V14.3133", stroke: "#D84339", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }))))); };

var LogoIcon$3 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 65 59", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M18.5873 9.86885C24.816 6.24317 34.8105 15.2698 42.4209 13.196C50.0314 11.1223 55.1245 12.665 59.8677 20.9478C63.7328 27.6974 57.3459 27.5993 63.2443 42.4035C69.1427 57.2076 59.08 58.1589 49.3544 58.1589C37.5174 58.6105 31.7222 58.9974 23.7425 58.9974C15.7628 58.9974 11.9941 59.3634 7.46363 51.4519C3.66652 44.8211 -5.11738 38.2757 4.01085 30.3704C13.1391 22.465 10.7147 14.4515 18.5873 9.86885Z", fill: "#FCF2F1" }),
    React.createElement("g", null,
        React.createElement("path", { d: "M40.9969 7H10.9969V33H40.9969V7Z", stroke: "#D84339", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M40.9969 17.0008H48.9969L54.9969 23.0008V33.0008H40.9969V17.0008Z", stroke: "#D84339", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M20 43C22.7614 43 25 40.7614 25 38C25 35.2386 22.7614 33 20 33C17.2386 33 15 35.2386 15 38C15 40.7614 17.2386 43 20 43Z", stroke: "#D84339", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M45.9969 42.9992C48.7583 42.9992 50.9969 40.7606 50.9969 37.9992C50.9969 35.2378 48.7583 32.9992 45.9969 32.9992C43.2355 32.9992 40.9969 35.2378 40.9969 37.9992C40.9969 40.7606 43.2355 42.9992 45.9969 42.9992Z", stroke: "#D84339", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })))); };

var LogoIcon$2 = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 65 65", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", null,
        React.createElement("path", { d: "M18.5873 15.8688C24.816 12.2432 34.8105 21.2698 42.4209 19.196C50.0314 17.1223 55.1245 18.665 59.8677 26.9478C63.7328 33.6974 57.3459 33.5993 63.2443 48.4035C69.1427 63.2076 59.08 64.1589 49.3544 64.1589C37.5174 64.6105 31.7222 64.9974 23.7425 64.9974C15.7628 64.9974 11.9941 65.3634 7.46363 57.4519C3.66652 50.8211 -5.11738 44.2757 4.01085 36.3704C13.1391 28.465 10.7147 20.4515 18.5873 15.8688Z", fill: "#F0F5FE" }),
        React.createElement("g", { clipPath: "url(#clip0_234_9688)" },
            React.createElement("path", { d: "M57.9739 25.4677C57.9739 23.4192 57.8038 21.9244 57.4356 20.3742H33.4982V29.62H47.5489C47.2658 31.9177 45.736 35.378 42.3366 37.7032L42.2889 38.0127L49.8575 43.7423L50.3819 43.7935C55.1976 39.4473 57.9739 33.0526 57.9739 25.4677Z", fill: "#4285F4" }),
            React.createElement("path", { d: "M33.5006 49.8283C40.3842 49.8283 46.1631 47.6136 50.3842 43.7935L42.3389 37.7033C40.186 39.1704 37.2965 40.1947 33.5006 40.1947C26.7585 40.1947 21.0362 35.8487 18.9964 29.8416L18.6974 29.8664L10.8275 35.8181L10.7246 36.0977C14.9171 44.2363 23.529 49.8283 33.5006 49.8283Z", fill: "#34A853" }),
            React.createElement("path", { d: "M18.9912 29.8418C18.453 28.2916 18.1415 26.6305 18.1415 24.9143C18.1415 23.1979 18.453 21.537 18.9629 19.9868L18.9487 19.6566L10.9802 13.6093L10.7194 13.7305C8.9915 17.1078 8 20.9003 8 24.9143C8 28.9282 8.9915 32.7206 10.7194 36.0979L18.9912 29.8418Z", fill: "#FBBC05" }),
            React.createElement("path", { d: "M33.5006 9.6334C38.288 9.6334 41.5173 11.6542 43.3588 13.3429L50.5541 6.47767C46.135 2.46374 40.3843 0 33.5006 0C23.529 0 14.9171 5.59179 10.7246 13.7303L18.9681 19.9866C21.0362 13.9796 26.7585 9.6334 33.5006 9.6334Z", fill: "#EB4335" }))),
    React.createElement("defs", null,
        React.createElement("clipPath", null,
            React.createElement("rect", { width: 50, height: 50, fill: "white", transform: "translate(8)" }))))); };

var LogoIcon$1 = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "66", height: "65", viewBox: "0 0 66 65", fill: "none" }, props),
    React.createElement("g", { "clip-path": "url(#clip0_9772_2398)" },
        React.createElement("path", { d: "M19.0873 15.8688C25.316 12.2432 35.3105 21.2698 42.9209 19.196C50.5314 17.1223 55.6245 18.665 60.3677 26.9478C64.2328 33.6974 57.8459 33.5993 63.7443 48.4035C69.6427 63.2076 59.58 64.1589 49.8544 64.1589C38.0174 64.6105 32.2222 64.9974 24.2425 64.9974C16.2628 64.9974 12.4941 65.3634 7.96363 57.4519C4.16652 50.8211 -4.61738 44.2757 4.51085 36.3704C13.6391 28.465 11.2147 20.4515 19.0873 15.8688Z", fill: "#FEE8E6" }),
        React.createElement("path", { d: "M27.4412 30.4563L29.3961 30.0125C29.4369 30.0032 29.506 29.9878 29.5877 29.9616C30.1276 29.8195 30.5903 29.4772 30.8782 29.0069C31.1662 28.5366 31.2569 27.9749 31.1312 27.4403L31.1233 27.4064C31.0587 27.1502 30.9458 26.9082 30.7904 26.6929C30.5715 26.4202 30.3006 26.1919 29.9928 26.0209C29.6304 25.8182 29.2511 25.646 28.8591 25.5062L26.7157 24.7372C25.513 24.2979 24.3102 23.871 23.0949 23.4534C22.3082 23.1791 21.6408 22.9371 21.0614 22.7599C20.9512 22.7299 20.8417 22.697 20.7333 22.6613C20.033 22.4517 19.5399 22.3638 19.1238 22.3607C18.8457 22.3506 18.5687 22.4 18.312 22.5056C18.0438 22.6195 17.8031 22.7876 17.6054 22.9988C17.5073 23.108 17.4151 23.2222 17.329 23.3409C17.1618 23.5931 17.0238 23.863 16.9177 24.1454C16.5195 25.2997 16.321 26.5114 16.3304 27.73C16.3383 28.8304 16.3681 30.2436 16.9852 31.2022C17.1343 31.4488 17.3338 31.6615 17.5709 31.8264C18.0105 32.1238 18.4533 32.1639 18.9165 32.1962C19.6074 32.244 20.2748 32.0791 20.9421 31.9265L27.4365 30.4548L27.4412 30.4563ZM49.2514 20.271C48.7177 19.1716 48.0002 18.1678 47.1284 17.3012C47.0158 17.191 46.8951 17.089 46.7673 16.996C46.6492 16.9091 46.5266 16.8284 46.3999 16.7541C46.2694 16.6839 46.1352 16.6207 45.9979 16.5645C45.7268 16.4599 45.4363 16.4127 45.1453 16.4258C44.8673 16.4412 44.5957 16.5183 44.3492 16.6462C43.977 16.8281 43.5735 17.1209 43.0365 17.6094C42.9627 17.6819 42.87 17.7635 42.7853 17.8406C42.344 18.249 41.851 18.7529 41.2653 19.3386C40.3593 20.2371 39.469 21.1402 38.5818 22.051L36.9959 23.6661C36.7063 23.9606 36.4426 24.2787 36.2076 24.617C36.0065 24.9031 35.8641 25.2251 35.7884 25.5647C35.7459 25.8257 35.7523 26.092 35.8073 26.3507L35.8151 26.3846C35.9404 26.9187 36.272 27.3842 36.74 27.6832C37.208 27.9821 37.776 28.0912 38.3243 27.9874C38.3903 27.9783 38.4558 27.9659 38.5206 27.9504L46.9714 26.0333C47.6388 25.8822 48.314 25.7435 48.9122 25.4014C49.3142 25.1748 49.6957 24.9483 49.958 24.4921C50.0976 24.2409 50.1821 23.9637 50.206 23.6784C50.3364 22.5472 49.735 21.2634 49.2514 20.271ZM34.1224 23.7585C34.7348 23.0034 34.7348 21.8784 34.7882 20.9568C34.9735 17.8822 35.1666 14.8076 35.3221 11.7315C35.3802 10.5664 35.5073 9.41676 35.4367 8.24241C35.3786 7.27458 35.3723 6.16189 34.7489 5.36666C33.6498 3.96423 31.3039 4.07982 29.7039 4.29866C29.2103 4.36557 28.7203 4.45609 28.2357 4.5699C27.7489 4.68394 27.2653 4.80877 26.7943 4.95826C25.2586 5.45142 23.0996 6.35761 22.7353 8.09447C22.528 9.07617 23.0179 10.0794 23.3948 10.9764C23.8548 12.0613 24.4813 13.04 25.0529 14.0617C26.565 16.7603 28.1038 19.4434 29.6379 22.128C30.098 22.9294 30.5957 23.9435 31.4829 24.3596C31.5426 24.3842 31.6022 24.4058 31.6635 24.4258C32.0607 24.5738 32.4957 24.6015 32.9086 24.5075L32.9825 24.4921C33.3656 24.3889 33.711 24.1839 33.9827 23.9019C34.0329 23.8556 34.0785 23.8094 34.124 23.7585H34.1224ZM33.3891 31.9897C33.1501 31.6597 32.8109 31.4124 32.42 31.2832C32.0291 31.1539 31.6065 31.1493 31.2128 31.27C31.1202 31.3 31.0299 31.3365 30.9427 31.3794C30.8078 31.447 30.6791 31.5259 30.558 31.6152C30.2124 31.8826 29.9036 32.1929 29.6395 32.5384C29.572 32.6231 29.5091 32.7356 29.4275 32.8096L28.0677 34.6436C27.2983 35.673 26.5367 36.7041 25.7846 37.7505C25.2916 38.427 24.8676 38.9988 24.53 39.5027C24.4672 39.5983 24.4013 39.7031 24.3416 39.7894C23.9381 40.3997 23.7104 40.8466 23.5926 41.2442C23.5046 41.5084 23.4768 41.7882 23.511 42.0641C23.5486 42.3508 23.6476 42.6266 23.7999 42.8747C23.8815 42.998 23.9695 43.1182 24.0637 43.2338C24.2672 43.4637 24.4963 43.6705 24.7467 43.8503C25.6857 44.4914 26.7126 44.9522 27.7929 45.3082C28.6926 45.601 29.6269 45.7767 30.5722 45.8291C30.7339 45.8368 30.8956 45.8337 31.0558 45.8199C31.2043 45.8062 31.3521 45.7856 31.4986 45.7582C31.6452 45.7247 31.7899 45.6836 31.932 45.6349C32.2083 45.5333 32.4597 45.3758 32.67 45.1726C32.8694 44.9769 33.0233 44.7411 33.1191 44.4806C33.2761 44.0953 33.3797 43.6083 33.4488 42.884C33.4535 42.7807 33.4692 42.6574 33.4802 42.5449C33.5336 41.9439 33.5587 41.235 33.5964 40.4059C33.6639 39.1283 33.7157 37.8568 33.7566 36.5823L33.8445 34.3138C33.8649 33.7929 33.8476 33.2134 33.7 32.694C33.6351 32.4446 33.5302 32.2068 33.3891 31.9897ZM48.7348 35.539C48.4521 35.2323 48.0502 34.9287 47.4158 34.5526C47.3247 34.5018 47.2164 34.4355 47.1175 34.3769C46.5899 34.0641 45.9539 33.7374 45.2112 33.3413C44.0697 32.7248 42.9281 32.1269 41.774 31.532L39.7375 30.4717C39.6323 30.4409 39.5255 30.3669 39.425 30.3191C39.0334 30.1228 38.6175 29.9772 38.1877 29.8861C38.0396 29.858 37.8894 29.8426 37.7386 29.8398C37.641 29.8393 37.5434 29.845 37.4465 29.8568C37.0388 29.9186 36.6614 30.1052 36.3682 30.39C36.0749 30.6747 35.8808 31.0432 35.8135 31.4426C35.7837 31.6969 35.7931 31.9543 35.8434 32.2039C35.9423 32.7372 36.1841 33.2627 36.4353 33.7235L37.5219 35.7254C38.128 36.8535 38.7404 37.9755 39.3685 39.0943C39.7736 39.8233 40.1112 40.4475 40.4268 40.9653C40.4865 41.0624 40.554 41.1672 40.6058 41.2581C40.9905 41.8792 41.2983 42.2706 41.6107 42.5527C41.8189 42.7491 42.0687 42.898 42.3423 42.9886C42.616 43.0792 42.9066 43.1093 43.1935 43.0766C43.3429 43.0588 43.4913 43.033 43.6379 42.9996C43.9383 42.9207 44.2285 42.8085 44.5031 42.6652C45.3296 42.2105 46.0914 41.6508 46.7689 41.0007C47.5822 40.2148 48.3014 39.3579 48.8604 38.3777C48.9389 38.239 49.0048 38.0957 49.0614 37.9462C49.114 37.8093 49.1596 37.6699 49.198 37.5286C49.231 37.3837 49.2561 37.2388 49.2734 37.0924C49.3015 36.8047 49.2678 36.5143 49.1744 36.2402C49.0822 35.9771 48.9321 35.7371 48.7348 35.5374V35.539Z", fill: "#F43939" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_9772_2398" },
            React.createElement("rect", { width: "65", height: "65", fill: "white", transform: "translate(0.5)" }))))); };

var LogoIcon = function (props) { return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 65 59", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#clip0_4812_130187)" },
        React.createElement("mask", { id: "mask0_4812_130187", style: { maskType: "luminance" }, width: "49", height: "48", x: "0", y: "0", maskUnits: "userSpaceOnUse" },
            React.createElement("path", { fill: "#fff", d: "M.75 0h48v48h-48V0z" })),
        React.createElement("g", { stroke: "#D84339", strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: "10", strokeWidth: "2", mask: "url(#mask0_4812_130187)" },
            React.createElement("path", { d: "M14.531 15.563h32.813l-2.421 14.524a2.812 2.812 0 01-2.774 2.35H16.406L13.594 7.125a2.812 2.812 0 00-2.813-2.813H2.156M38.906 38.063h-22.5a2.812 2.812 0 010-5.626" }),
            React.createElement("path", { d: "M24.844 40.875a2.813 2.813 0 11-5.625 0 2.813 2.813 0 015.625 0zM41.719 40.875a2.813 2.813 0 11-5.625 0 2.813 2.813 0 015.625 0zM22.031 15.563V9.936h8.438M30.469 15.563V7.124h11.25v8.438M22.031 21.188v5.625M30.469 21.188v5.625M38.906 21.188v5.625" }))),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_4812_130187" },
            React.createElement("path", { fill: "#fff", d: "M0 0H48V48H0z", transform: "translate(.75)" }))))); };

var LOGO_BUBBLE_ORIGINAL = /*#__PURE__*/Object.freeze({
    __proto__: null,
    FoodMenu: LogoIcon$5,
    Google: LogoIcon$2,
    ShoppingCart: LogoIcon,
    Takeaway: LogoIcon$4,
    Truck: LogoIcon$3,
    Yelp: LogoIcon$1
});

var StyledLogo = defaultStyled.span(templateObject_1$Q || (templateObject_1$Q = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  svg {\n    width: ", ";\n    height: ", ";\n  }\n"], ["\n  width: ", ";\n  height: ", ";\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  svg {\n    width: ", ";\n    height: ", ";\n  }\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? 16 : _b;
    return "".concat(size, "px");
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? 16 : _b;
    return "".concat(size, "px");
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? 16 : _b;
    return "".concat(size, "px");
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? 16 : _b;
    return "".concat(size, "px");
});
var Logo = function (_a) {
    var name = _a.name, type = _a.type, color = _a.color, size = _a.size, strokeWidth = _a.strokeWidth;
    var renderLogoType = function (type) {
        switch (type) {
            case 'original-color':
                return React__default.createElement(LOGO_ORIGINAL_COLOR[name]);
            case 'bubble-original-color':
                return React__default.createElement(LOGO_BUBBLE_ORIGINAL[name]);
            default:
                return React__default.createElement(LOGO_ORIGINAL_COLOR[name]);
        }
    };
    return (React__default.createElement(StyledLogo, { color: color, size: size, strokeWidth: strokeWidth }, renderLogoType(type || 'original-color')));
};
var templateObject_1$Q;

var selectAll = 'selectAll';
var SelectContainer = defaultStyled.div(templateObject_1$P || (templateObject_1$P = __makeTemplateObject(["\n  color: var(--grey-dark);\n  width: 100%;\n  position: relative;\n\n  > label {\n    font-weight: 300;\n    color: var(--grey-dark);\n  }\n\n  &.highlight {\n    .ant-select-selector {\n      background: var(--sea-green-light);\n      border-color: var(--sea-green-light) !important;\n\n      .ant-select-selection-item {\n        color: var(--white);\n      }\n    }\n    .ant-select-arrow {\n      svg > path {\n        stroke: var(--white) !important;\n      }\n    }\n  }\n\n  .ant-select-single .ant-select-selector .ant-select-selection-item::after {\n    display: none;\n  }\n  .ant-select-focused {\n    .ant-select-selection-item .ant-avatar {\n      display: none;\n    }\n  }\n"], ["\n  color: var(--grey-dark);\n  width: 100%;\n  position: relative;\n\n  > label {\n    font-weight: 300;\n    color: var(--grey-dark);\n  }\n\n  &.highlight {\n    .ant-select-selector {\n      background: var(--sea-green-light);\n      border-color: var(--sea-green-light) !important;\n\n      .ant-select-selection-item {\n        color: var(--white);\n      }\n    }\n    .ant-select-arrow {\n      svg > path {\n        stroke: var(--white) !important;\n      }\n    }\n  }\n\n  .ant-select-single .ant-select-selector .ant-select-selection-item::after {\n    display: none;\n  }\n  .ant-select-focused {\n    .ant-select-selection-item .ant-avatar {\n      display: none;\n    }\n  }\n"])));
var SelectWrapper = defaultStyled(Select$2)(templateObject_2$B || (templateObject_2$B = __makeTemplateObject(["\n  width: 100%;\n  .ant-select-selector {\n    border-radius: 30px !important;\n    min-height: ", ";\n    display: flex;\n    align-items: center;\n    box-shadow: none;\n  }\n\n  .ant-select-selector input {\n    height: 3rem !important;\n    padding: 0 0.25rem;\n  }\n  .ant-select-selection-placeholder {\n    line-height: 3rem;\n    padding: 0 0.625rem;\n  }\n\n  .ant-select-selection-item {\n    padding-left: 0.625rem;\n    margin: 0;\n    border: none;\n    background-color: transparent;\n  }\n\n  .ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector {\n    background: #eaeaea;\n  }\n\n  &.ant-select-disabled {\n    .ant-select-selection-item {\n      color: var(--grey);\n    }\n  }\n\n  .ant-select-arrow {\n    top: 48% !important;\n  }\n"], ["\n  width: 100%;\n  .ant-select-selector {\n    border-radius: 30px !important;\n    min-height: ", ";\n    display: flex;\n    align-items: center;\n    box-shadow: none;\n  }\n\n  .ant-select-selector input {\n    height: 3rem !important;\n    padding: 0 0.25rem;\n  }\n  .ant-select-selection-placeholder {\n    line-height: 3rem;\n    padding: 0 0.625rem;\n  }\n\n  .ant-select-selection-item {\n    padding-left: 0.625rem;\n    margin: 0;\n    border: none;\n    background-color: transparent;\n  }\n\n  .ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector {\n    background: #eaeaea;\n  }\n\n  &.ant-select-disabled {\n    .ant-select-selection-item {\n      color: var(--grey);\n    }\n  }\n\n  .ant-select-arrow {\n    top: 48% !important;\n  }\n"])), function (props) { return props.height || '3.125rem'; });
var OptionArea = defaultStyled.div(templateObject_3$o || (templateObject_3$o = __makeTemplateObject(["\n  .ant-select-item {\n    color: var(--grey-dark);\n    padding: 0.625rem 1.25rem 0.625rem 1.25rem;\n  }\n\n  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n    background: none;\n    color: ", " !important;\n    font-weight: normal;\n  }\n\n  .ant-select-item-option-disabled {\n    background: #eaeaea;\n  }\n  .ant-select-item-option-state {\n    margin-left: 0.5rem;\n  }\n\n  //scroll animation\n  .ant-select-item.ant-select-item-option {\n    &:hover {\n      .ant-select-item-option-content.auto-scroll {\n        animation: moveSlideshow 5s linear infinite;\n      }\n    }\n\n    .ant-select-item-option-content {\n      display: inline-block;\n      overflow: unset;\n      flex: none;\n    }\n\n    @keyframes moveSlideshow {\n      100% {\n        transform: translateX(-100%);\n      }\n    }\n  }\n"], ["\n  .ant-select-item {\n    color: var(--grey-dark);\n    padding: 0.625rem 1.25rem 0.625rem 1.25rem;\n  }\n\n  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n    background: none;\n    color: ", " !important;\n    font-weight: normal;\n  }\n\n  .ant-select-item-option-disabled {\n    background: #eaeaea;\n  }\n  .ant-select-item-option-state {\n    margin-left: 0.5rem;\n  }\n\n  //scroll animation\n  .ant-select-item.ant-select-item-option {\n    &:hover {\n      .ant-select-item-option-content.auto-scroll {\n        animation: moveSlideshow 5s linear infinite;\n      }\n    }\n\n    .ant-select-item-option-content {\n      display: inline-block;\n      overflow: unset;\n      flex: none;\n    }\n\n    @keyframes moveSlideshow {\n      100% {\n        transform: translateX(-100%);\n      }\n    }\n  }\n"])), function (_a) {
    var activeColor = _a.activeColor;
    return activeColor !== null && activeColor !== void 0 ? activeColor : 'var(--orange)';
});
var LabelHeading = defaultStyled.label(templateObject_4$e || (templateObject_4$e = __makeTemplateObject(["\n  font-size: 0.75rem;\n  line-height: 1.25rem;\n  font-weight: 500;\n"], ["\n  font-size: 0.75rem;\n  line-height: 1.25rem;\n  font-weight: 500;\n"])));
var addScrollAnimation = function (event) {
    var _a;
    try {
        var contentEl = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.querySelector('.ant-select-item-option-content');
        if (contentEl) {
            var wrapperContentEl = contentEl === null || contentEl === void 0 ? void 0 : contentEl.parentElement;
            var styles = window.getComputedStyle(wrapperContentEl);
            var width = wrapperContentEl.clientWidth - parseFloat(styles.paddingLeft) - parseFloat(styles.paddingRight);
            if (contentEl.offsetWidth > width) {
                contentEl.classList.add('auto-scroll');
            }
        }
    }
    catch (err) {
        console.log(err);
    }
};
var Select$1 = function (_a) {
    var _b;
    var label = _a.label, options = _a.options, SelectAllOpt = _a.SelectAllOpt, children = _a.children, className = _a.className, wrapperClassName = _a.wrapperClassName, sortFunc = _a.sortFunc, suffixIcon = _a.suffixIcon, activeColor = _a.activeColor, DropdownComponent = _a.DropdownComponent, highlight = _a.highlight, props = __rest(_a, ["label", "options", "SelectAllOpt", "children", "className", "wrapperClassName", "sortFunc", "suffixIcon", "activeColor", "DropdownComponent", "highlight"]);
    var ref = useRef(null);
    var sortedOptions = (_b = (sortFunc ? sortFunc(options) : options)) !== null && _b !== void 0 ? _b : [];
    var DropdownComponentUsed = DropdownComponent !== null && DropdownComponent !== void 0 ? DropdownComponent : OptionArea;
    return (React__default.createElement(SelectContainer, { className: classNames('momos-select', wrapperClassName, { highlight: highlight }), ref: ref },
        !!label && React__default.createElement(LabelHeading, null, label),
        React__default.createElement(SelectWrapper, __assign({ className: classNames(className), showArrow: true, dropdownRender: function (menu) { return React__default.createElement(DropdownComponentUsed, { activeColor: activeColor }, menu); }, suffixIcon: suffixIcon ? suffixIcon : React__default.createElement(Icon, { name: "ChevronDown" }), dropdownStyle: { borderRadius: 10 } }, props), children
            ? children
            : (SelectAllOpt ? __spreadArray([SelectAllOpt], sortedOptions, true) : sortedOptions).map(function (option, idx) { return (React__default.createElement(Select$2.Option, { key: option.id || idx, value: option.id || ('value' in option && option.value) || idx, disabled: 'disabled' in option && option.disabled, style: (props.fontOption && { fontFamily: 'value' in option && option.value }) || undefined, onMouseEnter: addScrollAnimation }, option.prefix
                ? "".concat(option.prefix, ": ").concat(option.label || ('name' in option && option.name) || option.id)
                : option.label || ('name' in option && option.name) || option.id)); }))));
};
var templateObject_1$P, templateObject_2$B, templateObject_3$o, templateObject_4$e;

var Select = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var onClick = _a.onClick, size = _a.size, props = __rest(_a, ["onClick", "size"]);
    var _h = useState([]), selectedValues = _h[0], setSelectedValues = _h[1];
    var _j = useState(props.value || []), value = _j[0], setValue = _j[1];
    var handleSelect = function (value) {
        if (selectedValues.includes(value)) {
            setSelectedValues(__spreadArray([], selectedValues, true).filter(function (o) { return o !== value; }));
        }
        else {
            setSelectedValues(__spreadArray(__spreadArray([], selectedValues, true), [value], false));
        }
        props.onChange && props.onChange(selectedValues);
    };
    var handleSingleSelect = function (value) {
        if (value) {
            setValue(value);
            props.onChange && props.onChange(value);
        }
    };
    useEffect(function () {
        setValue(props.value);
    }, [props.value]);
    switch (props.type) {
        case 'multiselect-tags':
            return (React__default.createElement(MultiSelectTagWrap, { className: props.className }, (_b = props === null || props === void 0 ? void 0 : props.options) === null || _b === void 0 ? void 0 : _b.map(function (option, index) {
                var isSelected = selectedValues.includes(option[props.fieldKey]);
                return (React__default.createElement(SelectTag$1, { className: isSelected ? 'active' : '', "$selected": isSelected, key: index, onClick: function () { return handleSelect(option[props.fieldKey]); } },
                    option.iconName ? (React__default.createElement(Icon, { name: option.iconName, strokeWidth: 2 })) : (React__default.createElement(Icon, { name: isSelected ? 'Done' : 'Plus', strokeWidth: 2 })),
                    option.text));
            })));
        case 'icon-text':
            return (React__default.createElement(StyledDiv, null,
                React__default.createElement(Row, { className: "select-options-wrap", gutter: [20, 20] }, (_c = props.options) === null || _c === void 0 ? void 0 : _c.map(function (option, index) { return (React__default.createElement(Col, { span: 24, key: index },
                    React__default.createElement(IconTextItem, { iconName: option.iconName, text: option.text, key: index, onClick: function () { return onClick && onClick(option); }, size: size }))); }))));
        case 'logo-text':
            return (React__default.createElement(StyledDiv, { className: props.className },
                React__default.createElement(Row, { className: "select-options-wrap", gutter: [20, 20] }, (_d = props.options) === null || _d === void 0 ? void 0 : _d.map(function (option, index) { return (React__default.createElement(Col, { span: 24, key: index },
                    React__default.createElement(LogoTextItem, { iconName: option.iconName, text: option.text, key: index, onClick: function () { return onClick && onClick(option); }, size: size, customIcon: option.customIcon, customIconData: option.customIconData }))); }))));
        case 'icon':
            return (React__default.createElement(Row, { gutter: [20, 20], className: props.className }, (_e = props.options) === null || _e === void 0 ? void 0 : _e.map(function (option, index) { return (React__default.createElement(Col, { span: 12, key: index, "data-testid": option.iconName },
                React__default.createElement(IconCard, { iconName: option.iconName, iconUrl: option.iconUrl, onClick: function () { return onClick && onClick(option); }, maxHeight: "150px", theme: { highlightColor: '#ea4435' } }))); })));
        case 'tags':
            return (React__default.createElement(MultiSelectTagWrap, { className: props.className }, (_f = props === null || props === void 0 ? void 0 : props.options) === null || _f === void 0 ? void 0 : _f.map(function (option, index) {
                var isSelected = value === option[props.fieldKey];
                return (React__default.createElement(SelectTag$1, { className: isSelected ? 'active' : '', "$selected": isSelected, key: index, onClick: function () { return handleSingleSelect(option[props.fieldKey]); } },
                    option.iconName ? (React__default.createElement(Icon, { name: option.iconName, strokeWidth: 2 })) : (React__default.createElement(Icon, { name: isSelected ? 'Done' : 'Plus', strokeWidth: 2 })),
                    option.text));
            })));
        case 'profile':
            return (React__default.createElement(Row, { gutter: [20, 20] }, (_g = props.options) === null || _g === void 0 ? void 0 : _g.map(function (option, index) { return (React__default.createElement(Col, { span: 12, onClick: function () { return onClick && onClick(option); } },
                React__default.createElement(ProfileImage, { src: option.src, name: option.name, key: index }))); })));
        case 'dropdown':
            return (React__default.createElement(Select$1, { className: props.className, placeholder: props.placeholder, options: props.options, value: value, onChange: props.onChange, showSearch: props.showSearch, allowClear: props.allowClear, filterOption: props.filterOption, getPopupContainer: function (triggerNode) { return triggerNode === null || triggerNode === void 0 ? void 0 : triggerNode.parentNode; } }, props.children));
        default:
            return (React__default.createElement(Col, { span: 24 },
                React__default.createElement(IconCard, { iconName: 'Other', onClick: function () { return console.log('icon clicked'); }, maxHeight: "150px", theme: { highlightColor: '#ea4435' } })));
    }
};
var IconTextItem = function (_a) {
    var iconName = _a.iconName, text = _a.text, size = _a.size, onClick = _a.onClick;
    return (React__default.createElement("div", { className: "select-option", onClick: onClick },
        React__default.createElement(Icon, { name: iconName, type: 'outline', size: size }),
        React__default.createElement("div", { className: "select-option-txt" }, text)));
};
var LogoTextItem = function (_a) {
    var iconName = _a.iconName, text = _a.text, size = _a.size, onClick = _a.onClick, customIcon = _a.customIcon, customIconData = _a.customIconData;
    return (React__default.createElement("div", { className: "select-option", onClick: onClick },
        customIcon ? (React__default.createElement("img", { src: customIconData === null || customIconData === void 0 ? void 0 : customIconData.mediaUrl, width: size, height: size, style: { objectFit: 'contain' } })) : (React__default.createElement(React__default.Fragment, null, iconName && React__default.createElement(Logo, { name: iconName, type: 'bubble-original-color', size: size }))),
        React__default.createElement("div", { className: "select-option-txt" }, text)));
};
var StyledDiv = defaultStyled.div(templateObject_1$O || (templateObject_1$O = __makeTemplateObject(["\n  .select-options-wrap {\n    margin-bottom: 2.5rem;\n\n    .select-option {\n      border: 1px solid #eaeaea;\n      box-sizing: border-box;\n      border-radius: 10px;\n      padding: 1.25rem;\n      display: flex;\n      align-items: center;\n      cursor: pointer;\n      transition: all 300ms ease 0s;\n\n      .select-option-txt {\n        font-weight: 600;\n        font-size: 1rem;\n        line-height: 1.25rem;\n        font-family: var(--font-family-medium);\n        margin-left: 0.938rem;\n      }\n\n      .span {\n        svg {\n          margin-right: 1.875rem;\n        }\n\n        svg path {\n          stroke: #d84339;\n        }\n      }\n\n      :hover {\n        background: #d84339;\n\n        svg path {\n          stroke: white;\n        }\n\n        .select-option-txt {\n          color: white;\n        }\n      }\n    }\n  }\n"], ["\n  .select-options-wrap {\n    margin-bottom: 2.5rem;\n\n    .select-option {\n      border: 1px solid #eaeaea;\n      box-sizing: border-box;\n      border-radius: 10px;\n      padding: 1.25rem;\n      display: flex;\n      align-items: center;\n      cursor: pointer;\n      transition: all 300ms ease 0s;\n\n      .select-option-txt {\n        font-weight: 600;\n        font-size: 1rem;\n        line-height: 1.25rem;\n        font-family: var(--font-family-medium);\n        margin-left: 0.938rem;\n      }\n\n      .span {\n        svg {\n          margin-right: 1.875rem;\n        }\n\n        svg path {\n          stroke: #d84339;\n        }\n      }\n\n      :hover {\n        background: #d84339;\n\n        svg path {\n          stroke: white;\n        }\n\n        .select-option-txt {\n          color: white;\n        }\n      }\n    }\n  }\n"])));
var MultiSelectTagWrap = defaultStyled.div(templateObject_2$A || (templateObject_2$A = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n"])));
var SelectTag$1 = defaultStyled.div(templateObject_3$n || (templateObject_3$n = __makeTemplateObject(["\n  font-size: 0.75rem;\n  font-weight: 600;\n  line-height: 1.05rem;\n  border: 1px solid var(--indian-red);\n  border-radius: 30px;\n  padding: 0.5rem 0.625rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  background: ", ";\n  user-select: none;\n  color: ", ";\n  transition: all 0.3s;\n  font-family: var(--font-family-semibold);\n  justify-content: center;\n\n  svg {\n    margin-right: 0.313rem;\n    path {\n      stroke: ", ";\n    }\n  }\n"], ["\n  font-size: 0.75rem;\n  font-weight: 600;\n  line-height: 1.05rem;\n  border: 1px solid var(--indian-red);\n  border-radius: 30px;\n  padding: 0.5rem 0.625rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  background: ", ";\n  user-select: none;\n  color: ", ";\n  transition: all 0.3s;\n  font-family: var(--font-family-semibold);\n  justify-content: center;\n\n  svg {\n    margin-right: 0.313rem;\n    path {\n      stroke: ", ";\n    }\n  }\n"])), function (_a) {
    var $selected = _a.$selected;
    return ($selected ? 'var(--indian-red)' : 'var(--white)');
}, function (_a) {
    var $selected = _a.$selected;
    return ($selected ? 'var(--white)' : 'var(--slate-gray-dark)');
}, function (_a) {
    var $selected = _a.$selected;
    return ($selected ? 'var(--white)' : 'var(--indian-red)');
});
var templateObject_1$O, templateObject_2$A, templateObject_3$n;

var MultiSelect = function (props) {
    var _a, _b;
    var _c = useState((props === null || props === void 0 ? void 0 : props.value) || []), selectedValues = _c[0], setSelectedValues = _c[1];
    useEffect(function () {
        var _a;
        if ((_a = props === null || props === void 0 ? void 0 : props.value) === null || _a === void 0 ? void 0 : _a.length) {
            setSelectedValues(props.value);
        }
    }, [props === null || props === void 0 ? void 0 : props.value]);
    var renderPrefixType = function (index, isSelected) {
        switch (props.prefixType) {
            case 'numbers':
                return (React__default.createElement(UniquePrefix, { "$selected": isSelected },
                    React__default.createElement(Text$1.B1, null, index + 1)));
            case 'letters':
                return (React__default.createElement(UniquePrefix, { "$selected": isSelected },
                    React__default.createElement(Text$1.B1, null, String.fromCharCode(65 + index))));
            default:
                return React__default.createElement("div", null); // render empty div for no
        }
    };
    var handleSelect = function (value) {
        if (props.mode === 'single') {
            setSelectedValues(value);
            if (props === null || props === void 0 ? void 0 : props.onChange) {
                props === null || props === void 0 ? void 0 : props.onChange(value);
            }
        }
        else {
            if (isArray$h(selectedValues)) {
                if (selectedValues.includes(value)) {
                    var updatedSelectedValues = __spreadArray([], selectedValues, true).filter(function (o) { return o !== value; });
                    setSelectedValues(updatedSelectedValues);
                    if (props === null || props === void 0 ? void 0 : props.onChange) {
                        props === null || props === void 0 ? void 0 : props.onChange(updatedSelectedValues);
                    }
                }
                else {
                    var updatedSelectedValues = __spreadArray(__spreadArray([], selectedValues, true), [value], false);
                    setSelectedValues(updatedSelectedValues);
                    if (props === null || props === void 0 ? void 0 : props.onChange) {
                        props === null || props === void 0 ? void 0 : props.onChange(updatedSelectedValues);
                    }
                }
            }
        }
    };
    if (props.type === 'list') {
        return (React__default.createElement(MultiSelectListWrap, { className: props.className }, (_a = props === null || props === void 0 ? void 0 : props.options) === null || _a === void 0 ? void 0 : _a.map(function (option, index) {
            var isSelected = props.mode === 'single'
                ? option[props.fieldKey] === selectedValues
                : selectedValues.includes(option[props.fieldKey]);
            return (React__default.createElement(MultiSelectListItem, { className: isSelected ? 'active' : '', "$selected": isSelected, key: index, onClick: function () { return handleSelect(option[props.fieldKey]); } },
                renderPrefixType(index, isSelected),
                React__default.createElement(SelectText, null,
                    React__default.createElement(Text$1.B1, { semibold: isSelected }, option.text)),
                React__default.createElement(Checkbox, { checked: isSelected })));
        })));
    }
    return (React__default.createElement(SelectTagWrap, { className: props.className }, (_b = props === null || props === void 0 ? void 0 : props.options) === null || _b === void 0 ? void 0 : _b.map(function (option, index) {
        var isSelected = selectedValues.includes(option[props.fieldKey]);
        return (React__default.createElement(SelectTag, { className: isSelected ? 'active' : '', "$selected": isSelected, key: index, onClick: function () { return handleSelect(option[props.fieldKey]); } },
            option.iconName ? (React__default.createElement(Icon, { name: option.iconName, strokeWidth: 2 })) : (React__default.createElement(Icon, { name: isSelected ? 'Done' : 'Plus', strokeWidth: 2 })),
            option.text));
    })));
};
var SelectTagWrap = defaultStyled.div(templateObject_1$N || (templateObject_1$N = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.625rem;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.625rem;\n"])));
var SelectTag = defaultStyled.div(templateObject_2$z || (templateObject_2$z = __makeTemplateObject(["\n  font-size: 0.75rem;\n  font-weight: 600;\n  line-height: 1rem;\n  border: 1px solid var(--indian-red);\n  border-radius: 30px;\n  padding: 0.5rem 0.625rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  background: ", ";\n  user-select: none;\n  color: ", ";\n  transition: all 0.3s;\n  font-family: var(--font-family-semibold);\n\n  svg {\n    margin-right: 0.313rem;\n    path {\n      stroke: ", ";\n    }\n  }\n"], ["\n  font-size: 0.75rem;\n  font-weight: 600;\n  line-height: 1rem;\n  border: 1px solid var(--indian-red);\n  border-radius: 30px;\n  padding: 0.5rem 0.625rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  background: ", ";\n  user-select: none;\n  color: ", ";\n  transition: all 0.3s;\n  font-family: var(--font-family-semibold);\n\n  svg {\n    margin-right: 0.313rem;\n    path {\n      stroke: ", ";\n    }\n  }\n"])), function (_a) {
    var $selected = _a.$selected;
    return ($selected ? 'var(--indian-red)' : 'var(--white)');
}, function (_a) {
    var $selected = _a.$selected;
    return ($selected ? 'var(--white)' : 'var(--slate-gray-dark)');
}, function (_a) {
    var $selected = _a.$selected;
    return ($selected ? 'var(--white)' : 'var(--indian-red)');
});
var MultiSelectListWrap = defaultStyled.div(templateObject_3$m || (templateObject_3$m = __makeTemplateObject([""], [""])));
var MultiSelectListItem = defaultStyled.div(templateObject_4$d || (templateObject_4$d = __makeTemplateObject(["\n  border: 1px solid ", ";\n  border-radius: 30px;\n  padding: 0.625rem;\n  cursor: pointer;\n  margin-bottom: 1.25rem;\n  transition: all 20ms ease-in 0s;\n  display: flex;\n  align-items: center;\n\n  :hover {\n    border-color: var(--indian-red);\n  }\n"], ["\n  border: 1px solid ", ";\n  border-radius: 30px;\n  padding: 0.625rem;\n  cursor: pointer;\n  margin-bottom: 1.25rem;\n  transition: all 20ms ease-in 0s;\n  display: flex;\n  align-items: center;\n\n  :hover {\n    border-color: var(--indian-red);\n  }\n"])), function (_a) {
    var $selected = _a.$selected;
    return ($selected ? 'var(--indian-red)' : 'var(--disable-grey)');
});
var UniquePrefix = defaultStyled.div(templateObject_5$c || (templateObject_5$c = __makeTemplateObject(["\n  width: 1.875rem;\n  height: 1.875rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 20ms ease-in 0s;\n  background: ", ";\n  border-radius: 50%;\n  margin-right: 0.938rem;\n  span {\n    color: ", ";\n  }\n"], ["\n  width: 1.875rem;\n  height: 1.875rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 20ms ease-in 0s;\n  background: ", ";\n  border-radius: 50%;\n  margin-right: 0.938rem;\n  span {\n    color: ", ";\n  }\n"])), function (_a) {
    var $selected = _a.$selected;
    return ($selected ? 'var(--indian-red)' : 'var(--disable-grey)');
}, function (_a) {
    var $selected = _a.$selected;
    return ($selected ? 'var(--white)' : 'var(--indian-red)');
});
var SelectText = defaultStyled.div(templateObject_6$9 || (templateObject_6$9 = __makeTemplateObject(["\n  flex: 1;\n"], ["\n  flex: 1;\n"])));
var templateObject_1$N, templateObject_2$z, templateObject_3$m, templateObject_4$d, templateObject_5$c, templateObject_6$9;

var lib$1=function(e){var t={};function r(n){if(t[n])return t[n].exports;var a=t[n]={i:n,l:!1,exports:{}};return e[n].call(a.exports,a,a.exports,r),a.l=!0,a.exports}return r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n});},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0});},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var a in e)r.d(n,a,function(t){return e[t]}.bind(null,a));return n},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=9)}([function(e,t){e.exports=React__default;},function(e,t,r){var n;
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/!function(){var r={}.hasOwnProperty;function a(){for(var e=[],t=0;t<arguments.length;t++){var n=arguments[t];if(n){var o=typeof n;if("string"===o||"number"===o)e.push(n);else if(Array.isArray(n)&&n.length){var i=a.apply(null,n);i&&e.push(i);}else if("object"===o)for(var u in n)r.call(n,u)&&n[u]&&e.push(u);}}return e.join(" ")}e.exports?(a.default=a,e.exports=a):void 0===(n=function(){return a}.apply(t,[]))||(e.exports=n);}();},function(e,t,r){(function(t){var r=/^\s+|\s+$/g,n=/^[-+]0x[0-9a-f]+$/i,a=/^0b[01]+$/i,o=/^0o[0-7]+$/i,i=parseInt,u="object"==typeof t&&t&&t.Object===Object&&t,c="object"==typeof self&&self&&self.Object===Object&&self,s=u||c||Function("return this")(),l=Object.prototype.toString,f=s.Symbol,d=f?f.prototype:void 0,p=d?d.toString:void 0;function h(e){if("string"==typeof e)return e;if(y(e))return p?p.call(e):"";var t=e+"";return "0"==t&&1/e==-1/0?"-0":t}function m(e){var t=typeof e;return !!e&&("object"==t||"function"==t)}function y(e){return "symbol"==typeof e||function(e){return !!e&&"object"==typeof e}(e)&&"[object Symbol]"==l.call(e)}function b(e){return e?(e=function(e){if("number"==typeof e)return e;if(y(e))return NaN;if(m(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=m(t)?t+"":t;}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(r,"");var u=a.test(e);return u||o.test(e)?i(e.slice(2),u?2:8):n.test(e)?NaN:+e}(e))===1/0||e===-1/0?17976931348623157e292*(e<0?-1:1):e==e?e:0:0===e?e:0}e.exports=function(e,t,r){var n,a,o,i;return e=null==(n=e)?"":h(n),a=function(e){var t=b(e),r=t%1;return t==t?r?t-r:t:0}(r),o=0,i=e.length,a==a&&(void 0!==i&&(a=a<=i?a:i),void 0!==o&&(a=a>=o?a:o)),r=a,t=h(t),e.slice(r,r+t.length)==t};}).call(this,r(3));},function(e,t){var r;r=function(){return this}();try{r=r||new Function("return this")();}catch(e){"object"==typeof window&&(r=window);}e.exports=r;},function(e,t,r){(function(t){var r=/^\[object .+?Constructor\]$/,n="object"==typeof t&&t&&t.Object===Object&&t,a="object"==typeof self&&self&&self.Object===Object&&self,o=n||a||Function("return this")();var i,u=Array.prototype,c=Function.prototype,s=Object.prototype,l=o["__core-js_shared__"],f=(i=/[^.]+$/.exec(l&&l.keys&&l.keys.IE_PROTO||""))?"Symbol(src)_1."+i:"",d=c.toString,p=s.hasOwnProperty,h=s.toString,m=RegExp("^"+d.call(p).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),y=u.splice,b=x(o,"Map"),g=x(Object,"create");function v(e){var t=-1,r=e?e.length:0;for(this.clear();++t<r;){var n=e[t];this.set(n[0],n[1]);}}function C(e){var t=-1,r=e?e.length:0;for(this.clear();++t<r;){var n=e[t];this.set(n[0],n[1]);}}function _(e){var t=-1,r=e?e.length:0;for(this.clear();++t<r;){var n=e[t];this.set(n[0],n[1]);}}function w(e,t){for(var r,n,a=e.length;a--;)if((r=e[a][0])===(n=t)||r!=r&&n!=n)return a;return -1}function S(e){return !(!O(e)||(t=e,f&&f in t))&&(function(e){var t=O(e)?h.call(e):"";return "[object Function]"==t||"[object GeneratorFunction]"==t}(e)||function(e){var t=!1;if(null!=e&&"function"!=typeof e.toString)try{t=!!(e+"");}catch(e){}return t}(e)?m:r).test(function(e){if(null!=e){try{return d.call(e)}catch(e){}try{return e+""}catch(e){}}return ""}(e));var t;}function j(e,t){var r,n,a=e.__data__;return ("string"==(n=typeof(r=t))||"number"==n||"symbol"==n||"boolean"==n?"__proto__"!==r:null===r)?a["string"==typeof t?"string":"hash"]:a.map}function x(e,t){var r=function(e,t){return null==e?void 0:e[t]}(e,t);return S(r)?r:void 0}function N(e,t){if("function"!=typeof e||t&&"function"!=typeof t)throw new TypeError("Expected a function");var r=function(){var n=arguments,a=t?t.apply(this,n):n[0],o=r.cache;if(o.has(a))return o.get(a);var i=e.apply(this,n);return r.cache=o.set(a,i),i};return r.cache=new(N.Cache||_),r}function O(e){var t=typeof e;return !!e&&("object"==t||"function"==t)}v.prototype.clear=function(){this.__data__=g?g(null):{};},v.prototype.delete=function(e){return this.has(e)&&delete this.__data__[e]},v.prototype.get=function(e){var t=this.__data__;if(g){var r=t[e];return "__lodash_hash_undefined__"===r?void 0:r}return p.call(t,e)?t[e]:void 0},v.prototype.has=function(e){var t=this.__data__;return g?void 0!==t[e]:p.call(t,e)},v.prototype.set=function(e,t){return this.__data__[e]=g&&void 0===t?"__lodash_hash_undefined__":t,this},C.prototype.clear=function(){this.__data__=[];},C.prototype.delete=function(e){var t=this.__data__,r=w(t,e);return !(r<0)&&(r==t.length-1?t.pop():y.call(t,r,1),!0)},C.prototype.get=function(e){var t=this.__data__,r=w(t,e);return r<0?void 0:t[r][1]},C.prototype.has=function(e){return w(this.__data__,e)>-1},C.prototype.set=function(e,t){var r=this.__data__,n=w(r,e);return n<0?r.push([e,t]):r[n][1]=t,this},_.prototype.clear=function(){this.__data__={hash:new v,map:new(b||C),string:new v};},_.prototype.delete=function(e){return j(this,e).delete(e)},_.prototype.get=function(e){return j(this,e).get(e)},_.prototype.has=function(e){return j(this,e).has(e)},_.prototype.set=function(e,t){return j(this,e).set(e,t),this},N.Cache=_,e.exports=N;}).call(this,r(3));},function(e,t,r){(function(t){var r=/^\s+|\s+$/g,n=/^[-+]0x[0-9a-f]+$/i,a=/^0b[01]+$/i,o=/^0o[0-7]+$/i,i=parseInt,u="object"==typeof t&&t&&t.Object===Object&&t,c="object"==typeof self&&self&&self.Object===Object&&self,s=u||c||Function("return this")(),l=Object.prototype.toString,f=Math.max,d=Math.min,p=function(){return s.Date.now()};function h(e){var t=typeof e;return !!e&&("object"==t||"function"==t)}function m(e){if("number"==typeof e)return e;if(function(e){return "symbol"==typeof e||function(e){return !!e&&"object"==typeof e}(e)&&"[object Symbol]"==l.call(e)}(e))return NaN;if(h(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=h(t)?t+"":t;}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(r,"");var u=a.test(e);return u||o.test(e)?i(e.slice(2),u?2:8):n.test(e)?NaN:+e}e.exports=function(e,t,r){var n,a,o,i,u,c,s=0,l=!1,y=!1,b=!0;if("function"!=typeof e)throw new TypeError("Expected a function");function g(t){var r=n,o=a;return n=a=void 0,s=t,i=e.apply(o,r)}function v(e){return s=e,u=setTimeout(_,t),l?g(e):i}function C(e){var r=e-c;return void 0===c||r>=t||r<0||y&&e-s>=o}function _(){var e=p();if(C(e))return w(e);u=setTimeout(_,function(e){var r=t-(e-c);return y?d(r,o-(e-s)):r}(e));}function w(e){return u=void 0,b&&n?g(e):(n=a=void 0,i)}function S(){var e=p(),r=C(e);if(n=arguments,a=this,c=e,r){if(void 0===u)return v(c);if(y)return u=setTimeout(_,t),g(c)}return void 0===u&&(u=setTimeout(_,t)),i}return t=m(t)||0,h(r)&&(l=!!r.leading,o=(y="maxWait"in r)?f(m(r.maxWait)||0,t):o,b="trailing"in r?!!r.trailing:b),S.cancel=function(){void 0!==u&&clearTimeout(u),s=0,n=c=a=u=void 0;},S.flush=function(){return void 0===u?i:w(p())},S};}).call(this,r(3));},function(e,t,r){(function(e,r){var n="[object Arguments]",a="[object Map]",o="[object Object]",i="[object Set]",u=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,c=/^\w*$/,s=/^\./,l=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,f=/\\(\\)?/g,d=/^\[object .+?Constructor\]$/,p=/^(?:0|[1-9]\d*)$/,h={};h["[object Float32Array]"]=h["[object Float64Array]"]=h["[object Int8Array]"]=h["[object Int16Array]"]=h["[object Int32Array]"]=h["[object Uint8Array]"]=h["[object Uint8ClampedArray]"]=h["[object Uint16Array]"]=h["[object Uint32Array]"]=!0,h[n]=h["[object Array]"]=h["[object ArrayBuffer]"]=h["[object Boolean]"]=h["[object DataView]"]=h["[object Date]"]=h["[object Error]"]=h["[object Function]"]=h[a]=h["[object Number]"]=h[o]=h["[object RegExp]"]=h[i]=h["[object String]"]=h["[object WeakMap]"]=!1;var m="object"==typeof e&&e&&e.Object===Object&&e,y="object"==typeof self&&self&&self.Object===Object&&self,b=m||y||Function("return this")(),g=t&&!t.nodeType&&t,v=g&&"object"==typeof r&&r&&!r.nodeType&&r,C=v&&v.exports===g&&m.process,_=function(){try{return C&&C.binding("util")}catch(e){}}(),w=_&&_.isTypedArray;function S(e,t,r,n){var a=-1,o=e?e.length:0;for(n&&o&&(r=e[++a]);++a<o;)r=t(r,e[a],a,e);return r}function j(e,t){for(var r=-1,n=e?e.length:0;++r<n;)if(t(e[r],r,e))return !0;return !1}function x(e,t,r,n,a){return a(e,(function(e,a,o){r=n?(n=!1,e):t(r,e,a,o);})),r}function N(e){var t=!1;if(null!=e&&"function"!=typeof e.toString)try{t=!!(e+"");}catch(e){}return t}function O(e){var t=-1,r=Array(e.size);return e.forEach((function(e,n){r[++t]=[n,e];})),r}function k(e){var t=-1,r=Array(e.size);return e.forEach((function(e){r[++t]=e;})),r}var E,T,I,A=Array.prototype,D=Function.prototype,P=Object.prototype,F=b["__core-js_shared__"],M=(E=/[^.]+$/.exec(F&&F.keys&&F.keys.IE_PROTO||""))?"Symbol(src)_1."+E:"",R=D.toString,L=P.hasOwnProperty,z=P.toString,B=RegExp("^"+R.call(L).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),G=b.Symbol,$=b.Uint8Array,V=P.propertyIsEnumerable,K=A.splice,U=(T=Object.keys,I=Object,function(e){return T(I(e))}),q=Ne(b,"DataView"),H=Ne(b,"Map"),W=Ne(b,"Promise"),J=Ne(b,"Set"),Z=Ne(b,"WeakMap"),Q=Ne(Object,"create"),Y=Pe(q),X=Pe(H),ee=Pe(W),te=Pe(J),re=Pe(Z),ne=G?G.prototype:void 0,ae=ne?ne.valueOf:void 0,oe=ne?ne.toString:void 0;function ie(e){var t=-1,r=e?e.length:0;for(this.clear();++t<r;){var n=e[t];this.set(n[0],n[1]);}}function ue(e){var t=-1,r=e?e.length:0;for(this.clear();++t<r;){var n=e[t];this.set(n[0],n[1]);}}function ce(e){var t=-1,r=e?e.length:0;for(this.clear();++t<r;){var n=e[t];this.set(n[0],n[1]);}}function se(e){var t=-1,r=e?e.length:0;for(this.__data__=new ce;++t<r;)this.add(e[t]);}function le(e){this.__data__=new ue(e);}function fe(e,t){var r=Le(e)||Re(e)?function(e,t){for(var r=-1,n=Array(e);++r<e;)n[r]=t(r);return n}(e.length,String):[],n=r.length,a=!!n;for(var o in e)!t&&!L.call(e,o)||a&&("length"==o||ke(o,n))||r.push(o);return r}function de(e,t){for(var r=e.length;r--;)if(Me(e[r][0],t))return r;return -1}ie.prototype.clear=function(){this.__data__=Q?Q(null):{};},ie.prototype.delete=function(e){return this.has(e)&&delete this.__data__[e]},ie.prototype.get=function(e){var t=this.__data__;if(Q){var r=t[e];return "__lodash_hash_undefined__"===r?void 0:r}return L.call(t,e)?t[e]:void 0},ie.prototype.has=function(e){var t=this.__data__;return Q?void 0!==t[e]:L.call(t,e)},ie.prototype.set=function(e,t){return this.__data__[e]=Q&&void 0===t?"__lodash_hash_undefined__":t,this},ue.prototype.clear=function(){this.__data__=[];},ue.prototype.delete=function(e){var t=this.__data__,r=de(t,e);return !(r<0)&&(r==t.length-1?t.pop():K.call(t,r,1),!0)},ue.prototype.get=function(e){var t=this.__data__,r=de(t,e);return r<0?void 0:t[r][1]},ue.prototype.has=function(e){return de(this.__data__,e)>-1},ue.prototype.set=function(e,t){var r=this.__data__,n=de(r,e);return n<0?r.push([e,t]):r[n][1]=t,this},ce.prototype.clear=function(){this.__data__={hash:new ie,map:new(H||ue),string:new ie};},ce.prototype.delete=function(e){return xe(this,e).delete(e)},ce.prototype.get=function(e){return xe(this,e).get(e)},ce.prototype.has=function(e){return xe(this,e).has(e)},ce.prototype.set=function(e,t){return xe(this,e).set(e,t),this},se.prototype.add=se.prototype.push=function(e){return this.__data__.set(e,"__lodash_hash_undefined__"),this},se.prototype.has=function(e){return this.__data__.has(e)},le.prototype.clear=function(){this.__data__=new ue;},le.prototype.delete=function(e){return this.__data__.delete(e)},le.prototype.get=function(e){return this.__data__.get(e)},le.prototype.has=function(e){return this.__data__.has(e)},le.prototype.set=function(e,t){var r=this.__data__;if(r instanceof ue){var n=r.__data__;if(!H||n.length<199)return n.push([e,t]),this;r=this.__data__=new ce(n);}return r.set(e,t),this};var pe,me=(pe=function(e,t){return e&&ye(e,t,qe)},function(e,t){if(null==e)return e;if(!ze(e))return pe(e,t);for(var r=e.length,n=-1,a=Object(e);(++n<r)&&!1!==t(a[n],n,a););return e}),ye=function(e){return function(t,r,n){for(var a=-1,o=Object(t),i=n(t),u=i.length;u--;){var c=i[e?u:++a];if(!1===r(o[c],c,o))break}return t}}();function be(e,t){for(var r=0,n=(t=Ee(t,e)?[t]:Se(t)).length;null!=e&&r<n;)e=e[De(t[r++])];return r&&r==n?e:void 0}function ge(e,t){return null!=e&&t in Object(e)}function ve(e,t,r,u,c){return e===t||(null==e||null==t||!$e(e)&&!Ve(t)?e!=e&&t!=t:function(e,t,r,u,c,s){var l=Le(e),f=Le(t),d="[object Array]",p="[object Array]";l||(d=(d=Oe(e))==n?o:d);f||(p=(p=Oe(t))==n?o:p);var h=d==o&&!N(e),m=p==o&&!N(t),y=d==p;if(y&&!h)return s||(s=new le),l||Ue(e)?je(e,t,r,u,c,s):function(e,t,r,n,o,u,c){switch(r){case"[object DataView]":if(e.byteLength!=t.byteLength||e.byteOffset!=t.byteOffset)return !1;e=e.buffer,t=t.buffer;case"[object ArrayBuffer]":return !(e.byteLength!=t.byteLength||!n(new $(e),new $(t)));case"[object Boolean]":case"[object Date]":case"[object Number]":return Me(+e,+t);case"[object Error]":return e.name==t.name&&e.message==t.message;case"[object RegExp]":case"[object String]":return e==t+"";case a:var s=O;case i:var l=2&u;if(s||(s=k),e.size!=t.size&&!l)return !1;var f=c.get(e);if(f)return f==t;u|=1,c.set(e,t);var d=je(s(e),s(t),n,o,u,c);return c.delete(e),d;case"[object Symbol]":if(ae)return ae.call(e)==ae.call(t)}return !1}(e,t,d,r,u,c,s);if(!(2&c)){var b=h&&L.call(e,"__wrapped__"),g=m&&L.call(t,"__wrapped__");if(b||g){var v=b?e.value():e,C=g?t.value():t;return s||(s=new le),r(v,C,u,c,s)}}if(!y)return !1;return s||(s=new le),function(e,t,r,n,a,o){var i=2&a,u=qe(e),c=u.length,s=qe(t).length;if(c!=s&&!i)return !1;var l=c;for(;l--;){var f=u[l];if(!(i?f in t:L.call(t,f)))return !1}var d=o.get(e);if(d&&o.get(t))return d==t;var p=!0;o.set(e,t),o.set(t,e);var h=i;for(;++l<c;){f=u[l];var m=e[f],y=t[f];if(n)var b=i?n(y,m,f,t,e,o):n(m,y,f,e,t,o);if(!(void 0===b?m===y||r(m,y,n,a,o):b)){p=!1;break}h||(h="constructor"==f);}if(p&&!h){var g=e.constructor,v=t.constructor;g==v||!("constructor"in e)||!("constructor"in t)||"function"==typeof g&&g instanceof g&&"function"==typeof v&&v instanceof v||(p=!1);}return o.delete(e),o.delete(t),p}(e,t,r,u,c,s)}(e,t,ve,r,u,c))}function Ce(e){return !(!$e(e)||function(e){return !!M&&M in e}(e))&&(Be(e)||N(e)?B:d).test(Pe(e))}function _e(e){return "function"==typeof e?e:null==e?He:"object"==typeof e?Le(e)?function(e,t){if(Ee(e)&&Te(t))return Ie(De(e),t);return function(r){var n=function(e,t,r){var n=null==e?void 0:be(e,t);return void 0===n?r:n}(r,e);return void 0===n&&n===t?function(e,t){return null!=e&&function(e,t,r){t=Ee(t,e)?[t]:Se(t);var n,a=-1,o=t.length;for(;++a<o;){var i=De(t[a]);if(!(n=null!=e&&r(e,i)))break;e=e[i];}if(n)return n;return !!(o=e?e.length:0)&&Ge(o)&&ke(i,o)&&(Le(e)||Re(e))}(e,t,ge)}(r,e):ve(t,n,void 0,3)}}(e[0],e[1]):function(e){var t=function(e){var t=qe(e),r=t.length;for(;r--;){var n=t[r],a=e[n];t[r]=[n,a,Te(a)];}return t}(e);if(1==t.length&&t[0][2])return Ie(t[0][0],t[0][1]);return function(r){return r===e||function(e,t,r,n){var a=r.length,o=a,i=!n;if(null==e)return !o;for(e=Object(e);a--;){var u=r[a];if(i&&u[2]?u[1]!==e[u[0]]:!(u[0]in e))return !1}for(;++a<o;){var c=(u=r[a])[0],s=e[c],l=u[1];if(i&&u[2]){if(void 0===s&&!(c in e))return !1}else {var f=new le;if(n)var d=n(s,l,c,e,t,f);if(!(void 0===d?ve(l,s,n,3,f):d))return !1}}return !0}(r,e,t)}}(e):Ee(t=e)?(r=De(t),function(e){return null==e?void 0:e[r]}):function(e){return function(t){return be(t,e)}}(t);var t,r;}function we(e){if(r=(t=e)&&t.constructor,n="function"==typeof r&&r.prototype||P,t!==n)return U(e);var t,r,n,a=[];for(var o in Object(e))L.call(e,o)&&"constructor"!=o&&a.push(o);return a}function Se(e){return Le(e)?e:Ae(e)}function je(e,t,r,n,a,o){var i=2&a,u=e.length,c=t.length;if(u!=c&&!(i&&c>u))return !1;var s=o.get(e);if(s&&o.get(t))return s==t;var l=-1,f=!0,d=1&a?new se:void 0;for(o.set(e,t),o.set(t,e);++l<u;){var p=e[l],h=t[l];if(n)var m=i?n(h,p,l,t,e,o):n(p,h,l,e,t,o);if(void 0!==m){if(m)continue;f=!1;break}if(d){if(!j(t,(function(e,t){if(!d.has(t)&&(p===e||r(p,e,n,a,o)))return d.add(t)}))){f=!1;break}}else if(p!==h&&!r(p,h,n,a,o)){f=!1;break}}return o.delete(e),o.delete(t),f}function xe(e,t){var r,n,a=e.__data__;return ("string"==(n=typeof(r=t))||"number"==n||"symbol"==n||"boolean"==n?"__proto__"!==r:null===r)?a["string"==typeof t?"string":"hash"]:a.map}function Ne(e,t){var r=function(e,t){return null==e?void 0:e[t]}(e,t);return Ce(r)?r:void 0}var Oe=function(e){return z.call(e)};function ke(e,t){return !!(t=null==t?9007199254740991:t)&&("number"==typeof e||p.test(e))&&e>-1&&e%1==0&&e<t}function Ee(e,t){if(Le(e))return !1;var r=typeof e;return !("number"!=r&&"symbol"!=r&&"boolean"!=r&&null!=e&&!Ke(e))||(c.test(e)||!u.test(e)||null!=t&&e in Object(t))}function Te(e){return e==e&&!$e(e)}function Ie(e,t){return function(r){return null!=r&&(r[e]===t&&(void 0!==t||e in Object(r)))}}(q&&"[object DataView]"!=Oe(new q(new ArrayBuffer(1)))||H&&Oe(new H)!=a||W&&"[object Promise]"!=Oe(W.resolve())||J&&Oe(new J)!=i||Z&&"[object WeakMap]"!=Oe(new Z))&&(Oe=function(e){var t=z.call(e),r=t==o?e.constructor:void 0,n=r?Pe(r):void 0;if(n)switch(n){case Y:return "[object DataView]";case X:return a;case ee:return "[object Promise]";case te:return i;case re:return "[object WeakMap]"}return t});var Ae=Fe((function(e){var t;e=null==(t=e)?"":function(e){if("string"==typeof e)return e;if(Ke(e))return oe?oe.call(e):"";var t=e+"";return "0"==t&&1/e==-1/0?"-0":t}(t);var r=[];return s.test(e)&&r.push(""),e.replace(l,(function(e,t,n,a){r.push(n?a.replace(f,"$1"):t||e);})),r}));function De(e){if("string"==typeof e||Ke(e))return e;var t=e+"";return "0"==t&&1/e==-1/0?"-0":t}function Pe(e){if(null!=e){try{return R.call(e)}catch(e){}try{return e+""}catch(e){}}return ""}function Fe(e,t){if("function"!=typeof e||t&&"function"!=typeof t)throw new TypeError("Expected a function");var r=function(){var n=arguments,a=t?t.apply(this,n):n[0],o=r.cache;if(o.has(a))return o.get(a);var i=e.apply(this,n);return r.cache=o.set(a,i),i};return r.cache=new(Fe.Cache||ce),r}function Me(e,t){return e===t||e!=e&&t!=t}function Re(e){return function(e){return Ve(e)&&ze(e)}(e)&&L.call(e,"callee")&&(!V.call(e,"callee")||z.call(e)==n)}Fe.Cache=ce;var Le=Array.isArray;function ze(e){return null!=e&&Ge(e.length)&&!Be(e)}function Be(e){var t=$e(e)?z.call(e):"";return "[object Function]"==t||"[object GeneratorFunction]"==t}function Ge(e){return "number"==typeof e&&e>-1&&e%1==0&&e<=9007199254740991}function $e(e){var t=typeof e;return !!e&&("object"==t||"function"==t)}function Ve(e){return !!e&&"object"==typeof e}function Ke(e){return "symbol"==typeof e||Ve(e)&&"[object Symbol]"==z.call(e)}var Ue=w?function(e){return function(t){return e(t)}}(w):function(e){return Ve(e)&&Ge(e.length)&&!!h[z.call(e)]};function qe(e){return ze(e)?fe(e):we(e)}function He(e){return e}r.exports=function(e,t,r){var n=Le(e)?S:x,a=arguments.length<3;return n(e,_e(t),r,a,me)};}).call(this,r(3),r(7)(e));},function(e,t){e.exports=function(e){return e.webpackPolyfill||(e.deprecate=function(){},e.paths=[],e.children||(e.children=[]),Object.defineProperty(e,"loaded",{enumerable:!0,get:function(){return e.l}}),Object.defineProperty(e,"id",{enumerable:!0,get:function(){return e.i}}),e.webpackPolyfill=1),e};},function(e,t){String.prototype.padEnd||(String.prototype.padEnd=function(e,t){return e>>=0,t=String(void 0!==t?t:" "),this.length>e?String(this):((e-=this.length)>t.length&&(t+=t.repeat(e/t.length)),String(this)+t.slice(0,e))});},function(e,t,r){function n(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function a(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}function o(e){return function(e){if(Array.isArray(e)){for(var t=0,r=new Array(e.length);t<e.length;t++)r[t]=e[t];return r}}(e)||a(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function i(e){if(Array.isArray(e))return e}function u(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}function c(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function s(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n);}}function l(e){return (l="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function f(e){return (f="function"==typeof Symbol&&"symbol"===l(Symbol.iterator)?function(e){return l(e)}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":l(e)})(e)}function d(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function p(e){return (p=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function h(e,t){return (h=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}r.r(t);var m=r(0),y=r.n(m),b=r(5),g=r.n(b),v=r(4),C=r.n(v),_=r(6),w=r.n(_),S=r(2),j=r.n(S),x=r(1),N=r.n(x);r(8);function O(e,t){return i(e)||function(e,t){var r=[],n=!0,a=!1,o=void 0;try{for(var i,u=e[Symbol.iterator]();!(n=(i=u.next()).done)&&(r.push(i.value),!t||r.length!==t);n=!0);}catch(e){a=!0,o=e;}finally{try{n||null==u.return||u.return();}finally{if(a)throw o}}return r}(e,t)||u()}var k=[["Afghanistan",["asia"],"af","93"],["Albania",["europe"],"al","355"],["Algeria",["africa","north-africa"],"dz","213"],["Andorra",["europe"],"ad","376"],["Angola",["africa"],"ao","244"],["Antigua and Barbuda",["america","carribean"],"ag","1268"],["Argentina",["america","south-america"],"ar","54","(..) ........",0,["11","221","223","261","264","2652","280","2905","291","2920","2966","299","341","342","343","351","376","379","381","3833","385","387","388"]],["Armenia",["asia","ex-ussr"],"am","374",".. ......"],["Aruba",["america","carribean"],"aw","297"],["Australia",["oceania"],"au","61","(..) .... ....",0,["2","3","4","7","8","02","03","04","07","08"]],["Austria",["europe","eu-union"],"at","43"],["Azerbaijan",["asia","ex-ussr"],"az","994","(..) ... .. .."],["Bahamas",["america","carribean"],"bs","1242"],["Bahrain",["middle-east"],"bh","973"],["Bangladesh",["asia"],"bd","880"],["Barbados",["america","carribean"],"bb","1246"],["Belarus",["europe","ex-ussr"],"by","375","(..) ... .. .."],["Belgium",["europe","eu-union"],"be","32","... .. .. .."],["Belize",["america","central-america"],"bz","501"],["Benin",["africa"],"bj","229"],["Bhutan",["asia"],"bt","975"],["Bolivia",["america","south-america"],"bo","591"],["Bosnia and Herzegovina",["europe","ex-yugos"],"ba","387"],["Botswana",["africa"],"bw","267"],["Brazil",["america","south-america"],"br","55","(..) ........."],["British Indian Ocean Territory",["asia"],"io","246"],["Brunei",["asia"],"bn","673"],["Bulgaria",["europe","eu-union"],"bg","359"],["Burkina Faso",["africa"],"bf","226"],["Burundi",["africa"],"bi","257"],["Cambodia",["asia"],"kh","855"],["Cameroon",["africa"],"cm","237"],["Canada",["america","north-america"],"ca","1","(...) ...-....",1,["204","226","236","249","250","289","306","343","365","387","403","416","418","431","437","438","450","506","514","519","548","579","581","587","604","613","639","647","672","705","709","742","778","780","782","807","819","825","867","873","902","905"]],["Cape Verde",["africa"],"cv","238"],["Caribbean Netherlands",["america","carribean"],"bq","599","",1],["Central African Republic",["africa"],"cf","236"],["Chad",["africa"],"td","235"],["Chile",["america","south-america"],"cl","56"],["China",["asia"],"cn","86","..-........."],["Colombia",["america","south-america"],"co","57","... ... ...."],["Comoros",["africa"],"km","269"],["Congo",["africa"],"cd","243"],["Congo",["africa"],"cg","242"],["Costa Rica",["america","central-america"],"cr","506","....-...."],["Côte d’Ivoire",["africa"],"ci","225",".. .. .. .."],["Croatia",["europe","eu-union","ex-yugos"],"hr","385"],["Cuba",["america","carribean"],"cu","53"],["Curaçao",["america","carribean"],"cw","599","",0],["Cyprus",["europe","eu-union"],"cy","357",".. ......"],["Czech Republic",["europe","eu-union"],"cz","420","... ... ..."],["Denmark",["europe","eu-union","baltic"],"dk","45",".. .. .. .."],["Djibouti",["africa"],"dj","253"],["Dominica",["america","carribean"],"dm","1767"],["Dominican Republic",["america","carribean"],"do","1","",2,["809","829","849"]],["Ecuador",["america","south-america"],"ec","593"],["Egypt",["africa","north-africa"],"eg","20"],["El Salvador",["america","central-america"],"sv","503","....-...."],["Equatorial Guinea",["africa"],"gq","240"],["Eritrea",["africa"],"er","291"],["Estonia",["europe","eu-union","ex-ussr","baltic"],"ee","372",".... ......"],["Ethiopia",["africa"],"et","251"],["Fiji",["oceania"],"fj","679"],["Finland",["europe","eu-union","baltic"],"fi","358",".. ... .. .."],["France",["europe","eu-union"],"fr","33",". .. .. .. .."],["French Guiana",["america","south-america"],"gf","594"],["French Polynesia",["oceania"],"pf","689"],["Gabon",["africa"],"ga","241"],["Gambia",["africa"],"gm","220"],["Georgia",["asia","ex-ussr"],"ge","995"],["Germany",["europe","eu-union","baltic"],"de","49",".... ........"],["Ghana",["africa"],"gh","233"],["Greece",["europe","eu-union"],"gr","30"],["Grenada",["america","carribean"],"gd","1473"],["Guadeloupe",["america","carribean"],"gp","590","",0],["Guam",["oceania"],"gu","1671"],["Guatemala",["america","central-america"],"gt","502","....-...."],["Guinea",["africa"],"gn","224"],["Guinea-Bissau",["africa"],"gw","245"],["Guyana",["america","south-america"],"gy","592"],["Haiti",["america","carribean"],"ht","509","....-...."],["Honduras",["america","central-america"],"hn","504"],["Hong Kong",["asia"],"hk","852",".... ...."],["Hungary",["europe","eu-union"],"hu","36"],["Iceland",["europe"],"is","354","... ...."],["India",["asia"],"in","91",".....-....."],["Indonesia",["asia"],"id","62"],["Iran",["middle-east"],"ir","98","... ... ...."],["Iraq",["middle-east"],"iq","964"],["Ireland",["europe","eu-union"],"ie","353",".. ......."],["Israel",["middle-east"],"il","972","... ... ...."],["Italy",["europe","eu-union"],"it","39","... .......",0],["Jamaica",["america","carribean"],"jm","1876"],["Japan",["asia"],"jp","81",".. .... ...."],["Jordan",["middle-east"],"jo","962"],["Kazakhstan",["asia","ex-ussr"],"kz","7","... ...-..-..",1,["310","311","312","313","315","318","321","324","325","326","327","336","7172","73622"]],["Kenya",["africa"],"ke","254"],["Kiribati",["oceania"],"ki","686"],["Kosovo",["europe","ex-yugos"],"xk","383"],["Kuwait",["middle-east"],"kw","965"],["Kyrgyzstan",["asia","ex-ussr"],"kg","996","... ... ..."],["Laos",["asia"],"la","856"],["Latvia",["europe","eu-union","ex-ussr","baltic"],"lv","371",".. ... ..."],["Lebanon",["middle-east"],"lb","961"],["Lesotho",["africa"],"ls","266"],["Liberia",["africa"],"lr","231"],["Libya",["africa","north-africa"],"ly","218"],["Liechtenstein",["europe"],"li","423"],["Lithuania",["europe","eu-union","ex-ussr","baltic"],"lt","370"],["Luxembourg",["europe","eu-union"],"lu","352"],["Macau",["asia"],"mo","853"],["Macedonia",["europe","ex-yugos"],"mk","389"],["Madagascar",["africa"],"mg","261"],["Malawi",["africa"],"mw","265"],["Malaysia",["asia"],"my","60","..-....-...."],["Maldives",["asia"],"mv","960"],["Mali",["africa"],"ml","223"],["Malta",["europe","eu-union"],"mt","356"],["Marshall Islands",["oceania"],"mh","692"],["Martinique",["america","carribean"],"mq","596"],["Mauritania",["africa"],"mr","222"],["Mauritius",["africa"],"mu","230"],["Mexico",["america","central-america"],"mx","52","... ... ....",0,["55","81","33","656","664","998","774","229"]],["Micronesia",["oceania"],"fm","691"],["Moldova",["europe"],"md","373","(..) ..-..-.."],["Monaco",["europe"],"mc","377"],["Mongolia",["asia"],"mn","976"],["Montenegro",["europe","ex-yugos"],"me","382"],["Morocco",["africa","north-africa"],"ma","212"],["Mozambique",["africa"],"mz","258"],["Myanmar",["asia"],"mm","95"],["Namibia",["africa"],"na","264"],["Nauru",["africa"],"nr","674"],["Nepal",["asia"],"np","977"],["Netherlands",["europe","eu-union"],"nl","31",".. ........"],["New Caledonia",["oceania"],"nc","687"],["New Zealand",["oceania"],"nz","64","...-...-...."],["Nicaragua",["america","central-america"],"ni","505"],["Niger",["africa"],"ne","227"],["Nigeria",["africa"],"ng","234"],["North Korea",["asia"],"kp","850"],["Norway",["europe","baltic"],"no","47","... .. ..."],["Oman",["middle-east"],"om","968"],["Pakistan",["asia"],"pk","92","...-......."],["Palau",["oceania"],"pw","680"],["Palestine",["middle-east"],"ps","970"],["Panama",["america","central-america"],"pa","507"],["Papua New Guinea",["oceania"],"pg","675"],["Paraguay",["america","south-america"],"py","595"],["Peru",["america","south-america"],"pe","51"],["Philippines",["asia"],"ph","63",".... ......."],["Poland",["europe","eu-union","baltic"],"pl","48","...-...-..."],["Portugal",["europe","eu-union"],"pt","351"],["Puerto Rico",["america","carribean"],"pr","1","",3,["787","939"]],["Qatar",["middle-east"],"qa","974"],["Réunion",["africa"],"re","262"],["Romania",["europe","eu-union"],"ro","40"],["Russia",["europe","asia","ex-ussr","baltic"],"ru","7","(...) ...-..-..",0],["Rwanda",["africa"],"rw","250"],["Saint Kitts and Nevis",["america","carribean"],"kn","1869"],["Saint Lucia",["america","carribean"],"lc","1758"],["Saint Vincent and the Grenadines",["america","carribean"],"vc","1784"],["Samoa",["oceania"],"ws","685"],["San Marino",["europe"],"sm","378"],["São Tomé and Príncipe",["africa"],"st","239"],["Saudi Arabia",["middle-east"],"sa","966"],["Senegal",["africa"],"sn","221"],["Serbia",["europe","ex-yugos"],"rs","381"],["Seychelles",["africa"],"sc","248"],["Sierra Leone",["africa"],"sl","232"],["Singapore",["asia"],"sg","65","....-...."],["Slovakia",["europe","eu-union"],"sk","421"],["Slovenia",["europe","eu-union","ex-yugos"],"si","386"],["Solomon Islands",["oceania"],"sb","677"],["Somalia",["africa"],"so","252"],["South Africa",["africa"],"za","27"],["South Korea",["asia"],"kr","82","... .... ...."],["South Sudan",["africa","north-africa"],"ss","211"],["Spain",["europe","eu-union"],"es","34","... ... ..."],["Sri Lanka",["asia"],"lk","94"],["Sudan",["africa"],"sd","249"],["Suriname",["america","south-america"],"sr","597"],["Swaziland",["africa"],"sz","268"],["Sweden",["europe","eu-union","baltic"],"se","46","(...) ...-..."],["Switzerland",["europe"],"ch","41",".. ... .. .."],["Syria",["middle-east"],"sy","963"],["Taiwan",["asia"],"tw","886"],["Tajikistan",["asia","ex-ussr"],"tj","992"],["Tanzania",["africa"],"tz","255"],["Thailand",["asia"],"th","66"],["Timor-Leste",["asia"],"tl","670"],["Togo",["africa"],"tg","228"],["Tonga",["oceania"],"to","676"],["Trinidad and Tobago",["america","carribean"],"tt","1868"],["Tunisia",["africa","north-africa"],"tn","216"],["Turkey",["europe"],"tr","90","... ... .. .."],["Turkmenistan",["asia","ex-ussr"],"tm","993"],["Tuvalu",["asia"],"tv","688"],["Uganda",["africa"],"ug","256"],["Ukraine",["europe","ex-ussr"],"ua","380","(..) ... .. .."],["United Arab Emirates",["middle-east"],"ae","971"],["United Kingdom",["europe","eu-union"],"gb","44",".... ......"],["United States",["america","north-america"],"us","1","(...) ...-....",0,["907","205","251","256","334","479","501","870","480","520","602","623","928","209","213","310","323","408","415","510","530","559","562","619","626","650","661","707","714","760","805","818","831","858","909","916","925","949","951","303","719","970","203","860","202","302","239","305","321","352","386","407","561","727","772","813","850","863","904","941","954","229","404","478","706","770","912","808","319","515","563","641","712","208","217","309","312","618","630","708","773","815","847","219","260","317","574","765","812","316","620","785","913","270","502","606","859","225","318","337","504","985","413","508","617","781","978","301","410","207","231","248","269","313","517","586","616","734","810","906","989","218","320","507","612","651","763","952","314","417","573","636","660","816","228","601","662","406","252","336","704","828","910","919","701","308","402","603","201","609","732","856","908","973","505","575","702","775","212","315","516","518","585","607","631","716","718","845","914","216","330","419","440","513","614","740","937","405","580","918","503","541","215","412","570","610","717","724","814","401","803","843","864","605","423","615","731","865","901","931","210","214","254","281","325","361","409","432","512","713","806","817","830","903","915","936","940","956","972","979","435","801","276","434","540","703","757","804","802","206","253","360","425","509","262","414","608","715","920","304","307"]],["Uruguay",["america","south-america"],"uy","598"],["Uzbekistan",["asia","ex-ussr"],"uz","998",".. ... .. .."],["Vanuatu",["oceania"],"vu","678"],["Vatican City",["europe"],"va","39",".. .... ....",1],["Venezuela",["america","south-america"],"ve","58"],["Vietnam",["asia"],"vn","84"],["Yemen",["middle-east"],"ye","967"],["Zambia",["africa"],"zm","260"],["Zimbabwe",["africa"],"zw","263"]],E=[["American Samoa",["oceania"],"as","1684"],["Anguilla",["america","carribean"],"ai","1264"],["Bermuda",["america","north-america"],"bm","1441"],["British Virgin Islands",["america","carribean"],"vg","1284"],["Cayman Islands",["america","carribean"],"ky","1345"],["Cook Islands",["oceania"],"ck","682"],["Falkland Islands",["america","south-america"],"fk","500"],["Faroe Islands",["europe"],"fo","298"],["Gibraltar",["europe"],"gi","350"],["Greenland",["america"],"gl","299"],["Jersey",["europe","eu-union"],"je","44",".... ......"],["Montserrat",["america","carribean"],"ms","1664"],["Niue",["asia"],"nu","683"],["Norfolk Island",["oceania"],"nf","672"],["Northern Mariana Islands",["oceania"],"mp","1670"],["Saint Barthélemy",["america","carribean"],"bl","590","",1],["Saint Helena",["africa"],"sh","290"],["Saint Martin",["america","carribean"],"mf","590","",2],["Saint Pierre and Miquelon",["america","north-america"],"pm","508"],["Sint Maarten",["america","carribean"],"sx","1721"],["Tokelau",["oceania"],"tk","690"],["Turks and Caicos Islands",["america","carribean"],"tc","1649"],["U.S. Virgin Islands",["america","carribean"],"vi","1340"],["Wallis and Futuna",["oceania"],"wf","681"]];function T(e,t,r,n,a){return !r||a?e+"".padEnd(t.length,".")+" "+n:e+"".padEnd(t.length,".")+" "+r}function I(e,t,r,a,i){var u,c,s=[];return c=!0===t,[(u=[]).concat.apply(u,o(e.map((function(e){var o={name:e[0],regions:e[1],iso2:e[2],countryCode:e[3],dialCode:e[3],format:T(r,e[3],e[4],a,i),priority:e[5]||0},u=[];return e[6]&&e[6].map((function(t){var r=function(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{},a=Object.keys(r);"function"==typeof Object.getOwnPropertySymbols&&(a=a.concat(Object.getOwnPropertySymbols(r).filter((function(e){return Object.getOwnPropertyDescriptor(r,e).enumerable})))),a.forEach((function(t){n(e,t,r[t]);}));}return e}({},o);r.dialCode=e[3]+t,r.isAreaCode=!0,r.areaCodeLength=t.length,u.push(r);})),u.length>0?(o.mainCode=!0,c||"Array"===t.constructor.name&&t.includes(e[2])?(o.hasAreaCodes=!0,[o].concat(u)):(s=s.concat(u),[o])):[o]})))),s]}function A(e,t,r,n){if(null!==r){var a=Object.keys(r),o=Object.values(r);a.forEach((function(r,a){if(n)return e.push([r,o[a]]);var i=e.findIndex((function(e){return e[0]===r}));if(-1===i){var u=[r];u[t]=o[a],e.push(u);}else e[i][t]=o[a];}));}}function D(e,t){return 0===t.length?e:e.map((function(e){var r=t.findIndex((function(t){return t[0]===e[2]}));if(-1===r)return e;var n=t[r];return n[1]&&(e[4]=n[1]),n[3]&&(e[5]=n[3]),n[2]&&(e[6]=n[2]),e}))}var P=function e(t,r,n,a,i,u,s,l,f,d,p,h,m,y){c(this,e),this.filterRegions=function(e,t){if("string"==typeof e){var r=e;return t.filter((function(e){return e.regions.some((function(e){return e===r}))}))}return t.filter((function(t){return e.map((function(e){return t.regions.some((function(t){return t===e}))})).some((function(e){return e}))}))},this.sortTerritories=function(e,t){var r=[].concat(o(e),o(t));return r.sort((function(e,t){return e.name<t.name?-1:e.name>t.name?1:0})),r},this.getFilteredCountryList=function(e,t,r){return 0===e.length?t:r?e.map((function(e){var r=t.find((function(t){return t.iso2===e}));if(r)return r})).filter((function(e){return e})):t.filter((function(t){return e.some((function(e){return e===t.iso2}))}))},this.localizeCountries=function(e,t,r){for(var n=0;n<e.length;n++)void 0!==t[e[n].iso2]?e[n].localName=t[e[n].iso2]:void 0!==t[e[n].name]&&(e[n].localName=t[e[n].name]);return r||e.sort((function(e,t){return e.localName<t.localName?-1:e.localName>t.localName?1:0})),e},this.getCustomAreas=function(e,t){for(var r=[],n=0;n<t.length;n++){var a=JSON.parse(JSON.stringify(e));a.dialCode+=t[n],r.push(a);}return r},this.excludeCountries=function(e,t){return 0===t.length?e:e.filter((function(e){return !t.includes(e.iso2)}))};var b=function(e,t,r){var n=[];return A(n,1,e,!0),A(n,3,t),A(n,2,r),n}(l,f,d),g=D(JSON.parse(JSON.stringify(k)),b),v=D(JSON.parse(JSON.stringify(E)),b),C=O(I(g,t,h,m,y),2),_=C[0],w=C[1];if(r){var S=O(I(v,t,h,m,y),2),j=S[0];S[1];_=this.sortTerritories(j,_);}n&&(_=this.filterRegions(n,_)),this.onlyCountries=this.localizeCountries(this.excludeCountries(this.getFilteredCountryList(a,_,s.includes("onlyCountries")),u),p,s.includes("onlyCountries")),this.preferredCountries=0===i.length?[]:this.localizeCountries(this.getFilteredCountryList(i,_,s.includes("preferredCountries")),p,s.includes("preferredCountries")),this.hiddenAreaCodes=this.excludeCountries(this.getFilteredCountryList(a,w),u);},F=function(e){function t(e){var r;c(this,t),(r=function(e,t){return !t||"object"!==f(t)&&"function"!=typeof t?d(e):t}(this,p(t).call(this,e))).getProbableCandidate=C()((function(e){return e&&0!==e.length?r.state.onlyCountries.filter((function(t){return j()(t.name.toLowerCase(),e.toLowerCase())}),d(d(r)))[0]:null})),r.guessSelectedCountry=C()((function(e,t,n,a){var o;if(!1===r.props.enableAreaCodes&&(a.some((function(t){if(j()(e,t.dialCode))return n.some((function(e){if(t.iso2===e.iso2&&e.mainCode)return o=e,!0})),!0})),o))return o;var i=n.find((function(e){return e.iso2==t}));if(""===e.trim())return i;var u=n.reduce((function(t,r){if(j()(e,r.dialCode)){if(r.dialCode.length>t.dialCode.length)return r;if(r.dialCode.length===t.dialCode.length&&r.priority<t.priority)return r}return t}),{dialCode:"",priority:10001},d(d(r)));return u.name?u:i})),r.updateCountry=function(e){var t,n=r.state.onlyCountries;(t=e.indexOf(0)>="0"&&e.indexOf(0)<="9"?n.find((function(t){return t.dialCode==+e})):n.find((function(t){return t.iso2==e})))&&t.dialCode&&r.setState({selectedCountry:t,formattedNumber:r.props.disableCountryCode?"":r.formatNumber(t.dialCode,t)});},r.scrollTo=function(e,t){if(e){var n=r.dropdownRef;if(n&&document.body){var a=n.offsetHeight,o=n.getBoundingClientRect().top+document.body.scrollTop,i=o+a,u=e,c=u.getBoundingClientRect(),s=u.offsetHeight,l=c.top+document.body.scrollTop,f=l+s,d=l-o+n.scrollTop,p=a/2-s/2;if(r.props.enableSearch?l<o+32:l<o)t&&(d-=p),n.scrollTop=d;else if(f>i){t&&(d+=p);var h=a-s;n.scrollTop=d-h;}}}},r.scrollToTop=function(){var e=r.dropdownRef;e&&document.body&&(e.scrollTop=0);},r.formatNumber=function(e,t){if(!t)return e;var n,o=t.format,c=r.props,s=c.disableCountryCode,l=c.enableAreaCodeStretch,f=c.enableLongNumbers,d=c.autoFormat;if(s?((n=o.split(" ")).shift(),n=n.join(" ")):l&&t.isAreaCode?((n=o.split(" "))[1]=n[1].replace(/\.+/,"".padEnd(t.areaCodeLength,".")),n=n.join(" ")):n=o,!e||0===e.length)return s?"":r.props.prefix;if(e&&e.length<2||!n||!d)return s?e:r.props.prefix+e;var p,h=w()(n,(function(e,t){if(0===e.remainingText.length)return e;if("."!==t)return {formattedText:e.formattedText+t,remainingText:e.remainingText};var r,n=i(r=e.remainingText)||a(r)||u(),o=n[0],c=n.slice(1);return {formattedText:e.formattedText+o,remainingText:c}}),{formattedText:"",remainingText:e.split("")});return (p=f?h.formattedText+h.remainingText.join(""):h.formattedText).includes("(")&&!p.includes(")")&&(p+=")"),p},r.cursorToEnd=function(){var e=r.numberInputRef;if(document.activeElement===e){e.focus();var t=e.value.length;")"===e.value.charAt(t-1)&&(t-=1),e.setSelectionRange(t,t);}},r.getElement=function(e){return r["flag_no_".concat(e)]},r.getCountryData=function(){return r.state.selectedCountry?{name:r.state.selectedCountry.name||"",dialCode:r.state.selectedCountry.dialCode||"",countryCode:r.state.selectedCountry.iso2||"",format:r.state.selectedCountry.format||""}:{}},r.handleFlagDropdownClick=function(e){if(e.preventDefault(),r.state.showDropdown||!r.props.disabled){var t=r.state,n=t.preferredCountries,a=t.onlyCountries,o=t.selectedCountry,i=r.concatPreferredCountries(n,a).findIndex((function(e){return e.dialCode===o.dialCode&&e.iso2===o.iso2}));r.setState({showDropdown:!r.state.showDropdown,highlightCountryIndex:i},(function(){r.state.showDropdown&&r.scrollTo(r.getElement(r.state.highlightCountryIndex));}));}},r.handleInput=function(e){var t=e.target.value,n=r.props,a=n.prefix,o=n.onChange,i=r.props.disableCountryCode?"":a,u=r.state.selectedCountry,c=r.state.freezeSelection;if(!r.props.countryCodeEditable){var s=a+(u.hasAreaCodes?r.state.onlyCountries.find((function(e){return e.iso2===u.iso2&&e.mainCode})).dialCode:u.dialCode);if(t.slice(0,s.length)!==s)return}if(t===a)return o&&o("",r.getCountryData(),e,""),r.setState({formattedNumber:""});if(t.replace(/\D/g,"").length>15){if(!1===r.props.enableLongNumbers)return;if("number"==typeof r.props.enableLongNumbers&&t.replace(/\D/g,"").length>r.props.enableLongNumbers)return}if(t!==r.state.formattedNumber){e.preventDefault?e.preventDefault():e.returnValue=!1;var l=r.props.country,f=r.state,d=f.onlyCountries,p=f.selectedCountry,h=f.hiddenAreaCodes;if(o&&e.persist(),t.length>0){var m=t.replace(/\D/g,"");(!r.state.freezeSelection||p&&p.dialCode.length>m.length)&&(u=r.props.disableCountryGuess?p:r.guessSelectedCountry(m.substring(0,6),l,d,h)||p,c=!1),i=r.formatNumber(m,u),u=u.dialCode?u:p;}var y=e.target.selectionStart,b=e.target.selectionStart,g=r.state.formattedNumber,v=i.length-g.length;r.setState({formattedNumber:i,freezeSelection:c,selectedCountry:u},(function(){v>0&&(b-=v),")"==i.charAt(i.length-1)?r.numberInputRef.setSelectionRange(i.length-1,i.length-1):b>0&&g.length>=i.length?r.numberInputRef.setSelectionRange(b,b):y<g.length&&r.numberInputRef.setSelectionRange(y,y),o&&o(i.replace(/[^0-9]+/g,""),r.getCountryData(),e,i);}));}},r.handleInputClick=function(e){r.setState({showDropdown:!1}),r.props.onClick&&r.props.onClick(e,r.getCountryData());},r.handleDoubleClick=function(e){var t=e.target.value.length;e.target.setSelectionRange(0,t);},r.handleFlagItemClick=function(e,t){var n=r.state.selectedCountry,a=r.state.onlyCountries.find((function(t){return t==e}));if(a){var o=r.state.formattedNumber.replace(" ","").replace("(","").replace(")","").replace("-",""),i=o.length>1?o.replace(n.dialCode,a.dialCode):a.dialCode,u=r.formatNumber(i.replace(/\D/g,""),a);r.setState({showDropdown:!1,selectedCountry:a,freezeSelection:!0,formattedNumber:u,searchValue:""},(function(){r.cursorToEnd(),r.props.onChange&&r.props.onChange(u.replace(/[^0-9]+/g,""),r.getCountryData(),t,u);}));}},r.handleInputFocus=function(e){r.numberInputRef&&r.numberInputRef.value===r.props.prefix&&r.state.selectedCountry&&!r.props.disableCountryCode&&r.setState({formattedNumber:r.props.prefix+r.state.selectedCountry.dialCode},(function(){r.props.jumpCursorToEnd&&setTimeout(r.cursorToEnd,0);})),r.setState({placeholder:""}),r.props.onFocus&&r.props.onFocus(e,r.getCountryData()),r.props.jumpCursorToEnd&&setTimeout(r.cursorToEnd,0);},r.handleInputBlur=function(e){e.target.value||r.setState({placeholder:r.props.placeholder}),r.props.onBlur&&r.props.onBlur(e,r.getCountryData());},r.handleInputCopy=function(e){if(r.props.copyNumbersOnly){var t=window.getSelection().toString().replace(/[^0-9]+/g,"");e.clipboardData.setData("text/plain",t),e.preventDefault();}},r.getHighlightCountryIndex=function(e){var t=r.state.highlightCountryIndex+e;return t<0||t>=r.state.onlyCountries.length+r.state.preferredCountries.length?t-e:r.props.enableSearch&&t>r.getSearchFilteredCountries().length?0:t},r.searchCountry=function(){var e=r.getProbableCandidate(r.state.queryString)||r.state.onlyCountries[0],t=r.state.onlyCountries.findIndex((function(t){return t==e}))+r.state.preferredCountries.length;r.scrollTo(r.getElement(t),!0),r.setState({queryString:"",highlightCountryIndex:t});},r.handleKeydown=function(e){var t=r.props.keys,n=e.target.className;if(n.includes("selected-flag")&&e.which===t.ENTER&&!r.state.showDropdown)return r.handleFlagDropdownClick(e);if(n.includes("form-control")&&(e.which===t.ENTER||e.which===t.ESC))return e.target.blur();if(r.state.showDropdown&&!r.props.disabled&&(!n.includes("search-box")||e.which===t.UP||e.which===t.DOWN||e.which===t.ENTER||e.which===t.ESC&&""===e.target.value)){e.preventDefault?e.preventDefault():e.returnValue=!1;var a=function(e){r.setState({highlightCountryIndex:r.getHighlightCountryIndex(e)},(function(){r.scrollTo(r.getElement(r.state.highlightCountryIndex),!0);}));};switch(e.which){case t.DOWN:a(1);break;case t.UP:a(-1);break;case t.ENTER:r.props.enableSearch?r.handleFlagItemClick(r.getSearchFilteredCountries()[r.state.highlightCountryIndex]||r.getSearchFilteredCountries()[0],e):r.handleFlagItemClick([].concat(o(r.state.preferredCountries),o(r.state.onlyCountries))[r.state.highlightCountryIndex],e);break;case t.ESC:case t.TAB:r.setState({showDropdown:!1},r.cursorToEnd);break;default:(e.which>=t.A&&e.which<=t.Z||e.which===t.SPACE)&&r.setState({queryString:r.state.queryString+String.fromCharCode(e.which)},r.state.debouncedQueryStingSearcher);}}},r.handleInputKeyDown=function(e){var t=r.props,n=t.keys,a=t.onEnterKeyPress,o=t.onKeyDown;e.which===n.ENTER&&a&&a(e),o&&o(e);},r.handleClickOutside=function(e){r.dropdownRef&&!r.dropdownContainerRef.contains(e.target)&&r.state.showDropdown&&r.setState({showDropdown:!1});},r.handleSearchChange=function(e){var t=e.currentTarget.value,n=r.state,a=n.preferredCountries,o=n.selectedCountry,i=0;if(""===t&&o){var u=r.state.onlyCountries;i=r.concatPreferredCountries(a,u).findIndex((function(e){return e==o})),setTimeout((function(){return r.scrollTo(r.getElement(i))}),100);}r.setState({searchValue:t,highlightCountryIndex:i});},r.concatPreferredCountries=function(e,t){return e.length>0?o(new Set(e.concat(t))):t},r.getDropdownCountryName=function(e){return e.localName||e.name},r.getSearchFilteredCountries=function(){var e=r.state,t=e.preferredCountries,n=e.onlyCountries,a=e.searchValue,i=r.props.enableSearch,u=r.concatPreferredCountries(t,n),c=a.trim().toLowerCase().replace("+","");if(i&&c){if(/^\d+$/.test(c))return u.filter((function(e){var t=e.dialCode;return ["".concat(t)].some((function(e){return e.toLowerCase().includes(c)}))}));var s=u.filter((function(e){var t=e.iso2;return ["".concat(t)].some((function(e){return e.toLowerCase().includes(c)}))})),l=u.filter((function(e){var t=e.name,r=e.localName;e.iso2;return ["".concat(t),"".concat(r||"")].some((function(e){return e.toLowerCase().includes(c)}))}));return r.scrollToTop(),o(new Set([].concat(s,l)))}return u},r.getCountryDropdownList=function(){var e=r.state,t=e.preferredCountries,a=e.highlightCountryIndex,o=e.showDropdown,i=e.searchValue,u=r.props,c=u.disableDropdown,s=u.prefix,l=r.props,f=l.enableSearch,d=l.searchNotFound,p=l.disableSearchIcon,h=l.searchClass,m=l.searchStyle,b=l.searchPlaceholder,g=l.autocompleteSearch,v=r.getSearchFilteredCountries().map((function(e,t){var n=a===t,o=N()({country:!0,preferred:"us"===e.iso2||"gb"===e.iso2,active:"us"===e.iso2,highlight:n}),i="flag ".concat(e.iso2);return y.a.createElement("li",Object.assign({ref:function(e){return r["flag_no_".concat(t)]=e},key:"flag_no_".concat(t),"data-flag-key":"flag_no_".concat(t),className:o,"data-dial-code":"1",tabIndex:c?"-1":"0","data-country-code":e.iso2,onClick:function(t){return r.handleFlagItemClick(e,t)},role:"option"},n?{"aria-selected":!0}:{}),y.a.createElement("div",{className:i}),y.a.createElement("span",{className:"country-name"},r.getDropdownCountryName(e)),y.a.createElement("span",{className:"dial-code"},e.format?r.formatNumber(e.dialCode,e):s+e.dialCode))})),C=y.a.createElement("li",{key:"dashes",className:"divider"});t.length>0&&(!f||f&&!i.trim())&&v.splice(t.length,0,C);var _=N()(n({"country-list":!0,hide:!o},r.props.dropdownClass,!0));return y.a.createElement("ul",{ref:function(e){return !f&&e&&e.focus(),r.dropdownRef=e},className:_,style:r.props.dropdownStyle,role:"listbox",tabIndex:"0"},f&&y.a.createElement("li",{className:N()(n({search:!0},h,h))},!p&&y.a.createElement("span",{className:N()(n({"search-emoji":!0},"".concat(h,"-emoji"),h)),role:"img","aria-label":"Magnifying glass"},"🔎"),y.a.createElement("input",{className:N()(n({"search-box":!0},"".concat(h,"-box"),h)),style:m,type:"search",placeholder:b,autoFocus:!0,autoComplete:g?"on":"off",value:i,onChange:r.handleSearchChange})),v.length>0?v:y.a.createElement("li",{className:"no-entries-message"},y.a.createElement("span",null,d)))};var s,l=new P(e.enableAreaCodes,e.enableTerritories,e.regions,e.onlyCountries,e.preferredCountries,e.excludeCountries,e.preserveOrder,e.masks,e.priority,e.areaCodes,e.localization,e.prefix,e.defaultMask,e.alwaysDefaultMask),h=l.onlyCountries,m=l.preferredCountries,b=l.hiddenAreaCodes,v=e.value?e.value.replace(/\D/g,""):"";s=e.disableInitialCountryGuess?0:v.length>1?r.guessSelectedCountry(v.substring(0,6),e.country,h,b)||0:e.country&&h.find((function(t){return t.iso2==e.country}))||0;var _,S=v.length<2&&s&&!j()(v,s.dialCode)?s.dialCode:"";_=""===v&&0===s?"":r.formatNumber((e.disableCountryCode?"":S)+v,s.name?s:void 0);var x=h.findIndex((function(e){return e==s}));return r.state={showDropdown:e.showDropdown,formattedNumber:_,onlyCountries:h,preferredCountries:m,hiddenAreaCodes:b,selectedCountry:s,highlightCountryIndex:x,queryString:"",freezeSelection:!1,debouncedQueryStingSearcher:g()(r.searchCountry,250),searchValue:""},r}var r,l;return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&h(e,t);}(t,e),r=t,(l=[{key:"componentDidMount",value:function(){document.addEventListener&&this.props.enableClickOutside&&document.addEventListener("mousedown",this.handleClickOutside),this.props.onMount&&this.props.onMount(this.state.formattedNumber.replace(/[^0-9]+/g,""),this.getCountryData(),this.state.formattedNumber);}},{key:"componentWillUnmount",value:function(){document.removeEventListener&&this.props.enableClickOutside&&document.removeEventListener("mousedown",this.handleClickOutside);}},{key:"componentDidUpdate",value:function(e,t,r){e.country!==this.props.country?this.updateCountry(this.props.country):e.value!==this.props.value&&this.updateFormattedNumber(this.props.value);}},{key:"updateFormattedNumber",value:function(e){if(null===e)return this.setState({selectedCountry:0,formattedNumber:""});var t=this.state,r=t.onlyCountries,n=t.selectedCountry,a=t.hiddenAreaCodes,o=this.props,i=o.country,u=o.prefix;if(""===e)return this.setState({selectedCountry:n,formattedNumber:""});var c,s,l=e.replace(/\D/g,"");if(n&&j()(e,u+n.dialCode))s=this.formatNumber(l,n),this.setState({formattedNumber:s});else {var f=(c=this.props.disableCountryGuess?n:this.guessSelectedCountry(l.substring(0,6),i,r,a)||n)&&j()(l,u+c.dialCode)?c.dialCode:"";s=this.formatNumber((this.props.disableCountryCode?"":f)+l,c||void 0),this.setState({selectedCountry:c,formattedNumber:s});}}},{key:"render",value:function(){var e,t,r,a=this,o=this.state,i=o.onlyCountries,u=o.selectedCountry,c=o.showDropdown,s=o.formattedNumber,l=o.hiddenAreaCodes,f=this.props,d=f.disableDropdown,p=f.renderStringAsFlag,h=f.isValid,m=f.defaultErrorMessage,b=f.specialLabel;if("boolean"==typeof h)t=h;else {var g=h(s.replace(/\D/g,""),u,i,l);"boolean"==typeof g?!1===(t=g)&&(r=m):(t=!1,r=g);}var v=N()((n(e={},this.props.containerClass,!0),n(e,"react-tel-input",!0),e)),C=N()({arrow:!0,up:c}),_=N()(n({"form-control":!0,"invalid-number":!t,open:c},this.props.inputClass,!0)),w=N()({"selected-flag":!0,open:c}),S=N()(n({"flag-dropdown":!0,"invalid-number":!t,open:c},this.props.buttonClass,!0)),j="flag ".concat(u&&u.iso2);return y.a.createElement("div",{className:"".concat(v," ").concat(this.props.className),style:this.props.style||this.props.containerStyle,onKeyDown:this.handleKeydown},b&&y.a.createElement("div",{className:"special-label"},b),r&&y.a.createElement("div",{className:"invalid-number-message"},r),y.a.createElement("input",Object.assign({className:_,style:this.props.inputStyle,onChange:this.handleInput,onClick:this.handleInputClick,onDoubleClick:this.handleDoubleClick,onFocus:this.handleInputFocus,onBlur:this.handleInputBlur,onCopy:this.handleInputCopy,value:s,onKeyDown:this.handleInputKeyDown,placeholder:this.props.placeholder,disabled:this.props.disabled,type:"tel"},this.props.inputProps,{ref:function(e){a.numberInputRef=e,"function"==typeof a.props.inputProps.ref?a.props.inputProps.ref(e):"object"==typeof a.props.inputProps.ref&&(a.props.inputProps.ref.current=e);}})),y.a.createElement("div",{className:S,style:this.props.buttonStyle,ref:function(e){return a.dropdownContainerRef=e}},p?y.a.createElement("div",{className:w},p):y.a.createElement("div",{onClick:d?void 0:this.handleFlagDropdownClick,className:w,title:u?"".concat(u.localName||u.name,": + ").concat(u.dialCode):"",tabIndex:d?"-1":"0",role:"button","aria-haspopup":"listbox","aria-expanded":!!c||void 0},y.a.createElement("div",{className:j},!d&&y.a.createElement("div",{className:C}))),c&&this.getCountryDropdownList()))}}])&&s(r.prototype,l),t}(y.a.Component);F.defaultProps={country:"",value:"",onlyCountries:[],preferredCountries:[],excludeCountries:[],placeholder:"1 (702) 123-4567",searchPlaceholder:"search",searchNotFound:"No entries to show",flagsImagePath:"./flags.png",disabled:!1,containerStyle:{},inputStyle:{},buttonStyle:{},dropdownStyle:{},searchStyle:{},containerClass:"",inputClass:"",buttonClass:"",dropdownClass:"",searchClass:"",className:"",autoFormat:!0,enableAreaCodes:!1,enableTerritories:!1,disableCountryCode:!1,disableDropdown:!1,enableLongNumbers:!1,countryCodeEditable:!0,enableSearch:!1,disableSearchIcon:!1,disableInitialCountryGuess:!1,disableCountryGuess:!1,regions:"",inputProps:{},localization:{},masks:null,priority:null,areaCodes:null,preserveOrder:[],defaultMask:"... ... ... ... ..",alwaysDefaultMask:!1,prefix:"+",copyNumbersOnly:!0,renderStringAsFlag:"",autocompleteSearch:!1,jumpCursorToEnd:!0,enableAreaCodeStretch:!1,enableClickOutside:!0,showDropdown:!1,isValid:!0,defaultErrorMessage:"",specialLabel:"Phone",onEnterKeyPress:null,keys:{UP:38,DOWN:40,RIGHT:39,LEFT:37,ENTER:13,ESC:27,PLUS:43,A:65,Z:90,SPACE:32,TAB:9}};t.default=F;}]);

var PhoneInput = /*@__PURE__*/getDefaultExportFromCjs(lib$1);

var StyledPhoneInput = defaultStyled(PhoneInput)(templateObject_1$M || (templateObject_1$M = __makeTemplateObject(["\n  .momos-input {\n    border-radius: 550px;\n    height: 3.125rem;\n    width: 100%;\n    font-size: 0.875rem;\n    line-height: 1.25rem;\n  }\n  .flag-dropdown,\n  .flag-dropdown.open,\n  .flag-dropdown.open .selected-flag,\n  .selected-flag {\n    border-radius: 550px 0px 0px 550px;\n  }\n\n  .react-tel-input {\n    .form-control {\n      padding-left: 3rem;\n    }\n    .selected-flag {\n      width: 2.375rem;\n    }\n  }\n"], ["\n  .momos-input {\n    border-radius: 550px;\n    height: 3.125rem;\n    width: 100%;\n    font-size: 0.875rem;\n    line-height: 1.25rem;\n  }\n  .flag-dropdown,\n  .flag-dropdown.open,\n  .flag-dropdown.open .selected-flag,\n  .selected-flag {\n    border-radius: 550px 0px 0px 550px;\n  }\n\n  .react-tel-input {\n    .form-control {\n      padding-left: 3rem;\n    }\n    .selected-flag {\n      width: 2.375rem;\n    }\n  }\n"])));
// interface IMomosPhoneInputProps {
//   country: string;
//   inputClass?: string;
//   onChange: (phone: string) => void;
//   disableDropdown?: boolean;
//   countryCodeEditable?: boolean;
//   placeholder?: string;
//   value: string;
// }
var MomosPhoneInput = function (_a) {
    var country = _a.country, inputClass = _a.inputClass, onChange = _a.onChange, disableDropdown = _a.disableDropdown, countryCodeEditable = _a.countryCodeEditable, placeholder = _a.placeholder, value = _a.value, onFocus = _a.onFocus;
    return (React__default.createElement(StyledPhoneInput, { containerClass: inputClass, inputClass: 'momos-input', country: country, value: value, onChange: onChange, disableDropdown: disableDropdown, countryCodeEditable: countryCodeEditable, placeholder: placeholder, onFocus: onFocus }));
};
var templateObject_1$M;

var StyledAntdInput = defaultStyled(Input$1)(templateObject_1$L || (templateObject_1$L = __makeTemplateObject(["\n  border-radius: 550px !important;\n  height: 3.125rem;\n  font-family: var(--font-family-regular);\n  font-style: normal;\n  font-weight: 500;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  border: 1px solid var(--disable-grey);\n\n  .ant-input {\n    font-size: 0.875rem;\n    line-height: 1.25rem;\n  }\n"], ["\n  border-radius: 550px !important;\n  height: 3.125rem;\n  font-family: var(--font-family-regular);\n  font-style: normal;\n  font-weight: 500;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  border: 1px solid var(--disable-grey);\n\n  .ant-input {\n    font-size: 0.875rem;\n    line-height: 1.25rem;\n  }\n"])));
var Input = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React__default.createElement(StyledAntdInput, __assign({}, props), children);
};
var StyledTextArea = defaultStyled(Input$1.TextArea)(templateObject_2$y || (templateObject_2$y = __makeTemplateObject(["\n  font-weight: 500;\n  background: var(--white);\n  border: 1px solid var(--disable-grey);\n  padding: 0.875rem 1.25rem 1.875rem 1.25rem;\n  border-radius: 10px;\n  font-family: var(--font-family-regular);\n  font-size: 0.875rem;\n  line-height: 1.25rem !important;\n  font-style: normal;\n  resize: auto;\n\n  &:hover,\n  &:focus {\n    outline: none !important;\n    border-color: #d84339;\n    box-shadow: 0px 4px 15px rgba(216, 67, 57, 0.07);\n  }\n"], ["\n  font-weight: 500;\n  background: var(--white);\n  border: 1px solid var(--disable-grey);\n  padding: 0.875rem 1.25rem 1.875rem 1.25rem;\n  border-radius: 10px;\n  font-family: var(--font-family-regular);\n  font-size: 0.875rem;\n  line-height: 1.25rem !important;\n  font-style: normal;\n  resize: auto;\n\n  &:hover,\n  &:focus {\n    outline: none !important;\n    border-color: #d84339;\n    box-shadow: 0px 4px 15px rgba(216, 67, 57, 0.07);\n  }\n"])));
var StyledDatePicker = defaultStyled(DatePicker)(templateObject_3$l || (templateObject_3$l = __makeTemplateObject(["\n  .ant-picker-input {\n    input {\n      font-family: var(--font-family-regular);\n      font-size: 0.875rem;\n      line-height: 1.25rem !important;\n    }\n  }\n"], ["\n  .ant-picker-input {\n    input {\n      font-family: var(--font-family-regular);\n      font-size: 0.875rem;\n      line-height: 1.25rem !important;\n    }\n  }\n"])));
var TextArea$1 = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React__default.createElement(StyledTextArea, __assign({}, props), children);
};
var Date$1 = function (_a) {
    var props = __rest(_a, []);
    return React__default.createElement(StyledDatePicker, __assign({}, props));
};
Input.Time = function (_a) {
    var type = _a.type, props = __rest(_a, ["type"]);
    if (type === 'modal') {
        return React__default.createElement(TimePickerModal, __assign({}, props));
    }
    return React__default.createElement(TimePicker, __assign({}, props));
};
Input.Rating = function (_a) {
    var props = __rest(_a, []);
    return React__default.createElement(Rating, __assign({}, props));
};
Input.Select = function (_a) {
    var props = __rest(_a, []);
    return React__default.createElement(Select, __assign({}, props));
};
Input.MultiSelect = function (_a) {
    var props = __rest(_a, []);
    return React__default.createElement(MultiSelect, __assign({}, props));
};
Input.TextArea = TextArea$1;
Input.Date = Date$1;
Input.Phone = MomosPhoneInput;
var templateObject_1$L, templateObject_2$y, templateObject_3$l;

var MomosModalWrap = defaultStyled.div(templateObject_1$K || (templateObject_1$K = __makeTemplateObject([""], [""])));
var ModalTitle = defaultStyled.div(templateObject_2$x || (templateObject_2$x = __makeTemplateObject(["\n  text-align: center;\n  margin-bottom: 30px;\n"], ["\n  text-align: center;\n  margin-bottom: 30px;\n"])));
var ModalContent = defaultStyled.div(templateObject_3$k || (templateObject_3$k = __makeTemplateObject(["\n  margin-bottom: 20px;\n"], ["\n  margin-bottom: 20px;\n"])));
var MomosModal = function (_a) {
    var open = _a.open, title = _a.title, onCancel = _a.onCancel, children = _a.children, props = __rest(_a, ["open", "title", "onCancel", "children"]);
    return (React__default.createElement(Modal, __assign({ className: "ant-momos-modal", visible: open, closable: true, onCancel: onCancel, footer: null }, props),
        React__default.createElement(MomosModalWrap, null,
            React__default.createElement(ModalTitle, null,
                React__default.createElement(Text$1.H2, null, title)),
            React__default.createElement(ModalContent, null, children))));
};
var templateObject_1$K, templateObject_2$x, templateObject_3$k;

var Switch = defaultStyled(Switch$1)(templateObject_1$J || (templateObject_1$J = __makeTemplateObject(["\n  color: red;\n  height: 12px;\n  min-width: 32px;\n  &.ant-switch {\n    background-color: var(--grey-light);\n\n    .ant-switch-handle {\n      top: -4px;\n      left: 0%;\n      width: 20px;\n      height: 20px;\n\n      &:before {\n        border-radius: 50%;\n        background-color: var(--orange);\n      }\n    }\n\n    .ant-switch-loading-icon {\n      color: var(--grey-dark);\n      top: 3px;\n    }\n\n    &.ant-switch-checked {\n      .ant-switch-handle {\n        left: calc(100% - 18px - 2px);\n        &:before {\n          background-color: var(--sea-green-light);\n        }\n      }\n    }\n  }\n"], ["\n  color: red;\n  height: 12px;\n  min-width: 32px;\n  &.ant-switch {\n    background-color: var(--grey-light);\n\n    .ant-switch-handle {\n      top: -4px;\n      left: 0%;\n      width: 20px;\n      height: 20px;\n\n      &:before {\n        border-radius: 50%;\n        background-color: var(--orange);\n      }\n    }\n\n    .ant-switch-loading-icon {\n      color: var(--grey-dark);\n      top: 3px;\n    }\n\n    &.ant-switch-checked {\n      .ant-switch-handle {\n        left: calc(100% - 18px - 2px);\n        &:before {\n          background-color: var(--sea-green-light);\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$J;

var LocationModal = function (_a) {
    var _b;
    var title = _a.title, open = _a.open, onCancel = _a.onCancel, locations = _a.locations, onSave = _a.onSave;
    var _c = useState({}), selectedLocations = _c[0], setSelectedLocations = _c[1];
    var _d = useState(false), allSelected = _d[0], setAllSelected = _d[1];
    var _e = useState(''), locationSearch = _e[0], setLocationSearch = _e[1];
    useEffect(function () {
        var _a;
        var initialSelected = {};
        locations.forEach(function (location) {
            initialSelected[location.id] = location.selected || false;
        });
        setSelectedLocations(initialSelected);
        setAllSelected(((_a = locations.find(function (o) { return o.id === 'all'; })) === null || _a === void 0 ? void 0 : _a.selected) || false);
    }, [locations]);
    var handleSearch = function (event) {
        var _a;
        var searchQuery = (_a = event.target.value) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        setLocationSearch(searchQuery);
    };
    var handleSelect = function (id, isSelected) {
        var _a;
        if (id === 'all') {
            var isAllSelected_1 = !allSelected;
            setAllSelected(isAllSelected_1);
            var updatedSelected_1 = {};
            Object.keys(selectedLocations).forEach(function (locationId) {
                updatedSelected_1[locationId] = isAllSelected_1;
            });
            setSelectedLocations(updatedSelected_1);
        }
        else {
            setSelectedLocations(__assign(__assign({}, selectedLocations), (_a = {}, _a[id] = isSelected ? false : true, _a.all = false, _a)));
            setAllSelected(false);
        }
    };
    var handleSave = function () {
        if (typeof onSave === 'function') {
            if (allSelected) {
                onSave([]);
            }
            else {
                var locationSelected = Object.entries(selectedLocations)
                    .filter(function (_a) {
                    _a[0]; var isSelected = _a[1];
                    return isSelected;
                })
                    .map(function (_a) {
                    var locationId = _a[0];
                    return locationId;
                });
                onSave(locationSelected.length ? locationSelected : null);
            }
        }
    };
    // Filtering locations based on search query
    var filteredLocations = locationSearch
        ? locations.filter(function (location) { return location.name.toLowerCase().includes(locationSearch); })
        : locations;
    return (React__default.createElement(MomosModal, { open: open, title: title, onCancel: onCancel },
        React__default.createElement(LocationModalContent, null,
            React__default.createElement(Input, { onChange: handleSearch, className: "momos-search mb-20", placeholder: "Search...", prefix: React__default.createElement(Icon, { name: "Search", type: "fill" }), allowClear: true }),
            React__default.createElement(ScrollableContent, null,
                React__default.createElement(LocationListItem, { onClick: function () { return handleSelect('all'); } },
                    React__default.createElement(LocationListItemText, null,
                        React__default.createElement(Text$1.B1, null, "All")),
                    React__default.createElement(Switch, { checked: allSelected })), (_b = filteredLocations === null || filteredLocations === void 0 ? void 0 : filteredLocations.filter(function (o) { return o.id !== 'all'; })) === null || _b === void 0 ? void 0 :
                _b.map(function (location, key) { return (React__default.createElement(LocationListItem, { key: key, onClick: function () { return handleSelect(location.id, selectedLocations[location.id]); } },
                    React__default.createElement(LocationListItemText, null,
                        React__default.createElement(Text$1.B1, null, location.name)),
                    React__default.createElement(Switch, { checked: selectedLocations[location.id] }))); }))),
        React__default.createElement(LocationModalAction, null,
            React__default.createElement(Button, { block: true, type: "default", onClick: onCancel }, "Cancel"),
            React__default.createElement(Button, { block: true, onClick: handleSave }, "Save"))));
};
var LocationModalContent = defaultStyled.div(templateObject_1$I || (templateObject_1$I = __makeTemplateObject(["\n  div:last-child {\n    border-bottom: none;\n  }\n\n  .momos-search {\n    border-radius: 10px;\n\n    input.ant-input {\n      height: 38px;\n    }\n  }\n"], ["\n  div:last-child {\n    border-bottom: none;\n  }\n\n  .momos-search {\n    border-radius: 10px;\n\n    input.ant-input {\n      height: 38px;\n    }\n  }\n"])));
var ScrollableContent = defaultStyled.div(templateObject_2$w || (templateObject_2$w = __makeTemplateObject(["\n  height: 300px;\n  overflow-y: scroll;\n"], ["\n  height: 300px;\n  overflow-y: scroll;\n"])));
var LocationListItem = defaultStyled.div(templateObject_3$j || (templateObject_3$j = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid var(--disable-grey);\n  padding: 16px 5px;\n\n  :hover {\n    cursor: pointer;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid var(--disable-grey);\n  padding: 16px 5px;\n\n  :hover {\n    cursor: pointer;\n  }\n"])));
var LocationListItemText = defaultStyled.div(templateObject_4$c || (templateObject_4$c = __makeTemplateObject(["\n  flex: 1;\n"], ["\n  flex: 1;\n"])));
var LocationModalAction = defaultStyled.div(templateObject_5$b || (templateObject_5$b = __makeTemplateObject(["\n  display: flex;\n  gap: 10px;\n"], ["\n  display: flex;\n  gap: 10px;\n"])));
var templateObject_1$I, templateObject_2$w, templateObject_3$j, templateObject_4$c, templateObject_5$b;

var MobileView = function (_a) {
    var backgroundColor = _a.backgroundColor, outerBgColor = _a.outerBgColor, loading = _a.loading, children = _a.children;
    return (React__default.createElement(MobileViewWrap, { "$backgroundColor": backgroundColor, "$outerBgColor": outerBgColor }, loading ? (React__default.createElement(FormLoader, null,
        React__default.createElement(Spin, null))) : (React__default.createElement("div", { className: "mobile-container" }, children))));
};
var MobileViewWrap = defaultStyled.div(templateObject_1$H || (templateObject_1$H = __makeTemplateObject(["\n  background: ", ";\n  height: 100vh;\n  overflow: hidden;\n\n  .mobile-container {\n    width: 360px;\n    min-height: 669px;\n    height: 669px;\n    background: ", ";\n    margin: 30px auto;\n    overflow-y: auto;\n    border-radius: 10px;\n\n    ::-webkit-scrollbar {\n      width: 4px;\n      height: 8px;\n      background-color: transparent;\n    }\n\n    ::-webkit-scrollbar-thumb {\n      background: var(--grey-light);\n    }\n\n    @media (max-width: 768px) {\n      border-radius: unset;\n    }\n  }\n"], ["\n  background: ", ";\n  height: 100vh;\n  overflow: hidden;\n\n  .mobile-container {\n    width: 360px;\n    min-height: 669px;\n    height: 669px;\n    background: ", ";\n    margin: 30px auto;\n    overflow-y: auto;\n    border-radius: 10px;\n\n    ::-webkit-scrollbar {\n      width: 4px;\n      height: 8px;\n      background-color: transparent;\n    }\n\n    ::-webkit-scrollbar-thumb {\n      background: var(--grey-light);\n    }\n\n    @media (max-width: 768px) {\n      border-radius: unset;\n    }\n  }\n"])), function (props) { return props.$outerBgColor; }, function (props) { return props.$backgroundColor; });
var FormLoader = defaultStyled.div(templateObject_2$v || (templateObject_2$v = __makeTemplateObject(["\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var templateObject_1$H, templateObject_2$v;

var lodash = {exports: {}};

/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
lodash.exports;

(function (module, exports) {
(function() {

	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined$1;

	  /** Used as the semantic version number. */
	  var VERSION = '4.17.21';

	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;

	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function',
	      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';

	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;

	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';

	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;

	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;

	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;

	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';

	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;

	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;

	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;

	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];

	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';

	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';

	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;

	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);

	  /** Used to match leading whitespace. */
	  var reTrimStart = /^\s+/;

	  /** Used to match a single whitespace character. */
	  var reWhitespace = /\s/;

	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;

	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

	  /**
	   * Used to validate the `validate` option in `_.template` variable.
	   *
	   * Forbids characters which could potentially change the meaning of the function argument definition:
	   * - "()," (modification of function parameters)
	   * - "=" (default value)
	   * - "[]{}" (destructuring of function parameters)
	   * - "/" (beginning of a comment)
	   * - whitespace
	   */
	  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;

	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;

	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;

	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;

	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;

	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;

	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;

	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';

	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');

	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');

	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');

	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];

	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;

	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;

	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;

	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };

	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };

	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };

	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };

	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;

	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();

	  /** Detect free variable `exports`. */
	  var freeExports = exports && !exports.nodeType && exports;

	  /** Detect free variable `module`. */
	  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;

	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;

	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;

	      if (types) {
	        return types;
	      }

	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());

	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

	  /*--------------------------------------------------------------------------*/

	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }

	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;

	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }

	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;

	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }

	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;

	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }

	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;

	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }

	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];

	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }

	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }

	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;

	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }

	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);

	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }

	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;

	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }

	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;

	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }

	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }

	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;

	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }

	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');

	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }

	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }

	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }

	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);

	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }

	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }

	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;

	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }

	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }

	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }

	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined$1 : object[key];
	    };
	  }

	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined$1 : object[key];
	    };
	  }

	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }

	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;

	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }

	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;

	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined$1) {
	        result = result === undefined$1 ? current : (result + current);
	      }
	    }
	    return result;
	  }

	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);

	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }

	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }

	  /**
	   * The base implementation of `_.trim`.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} Returns the trimmed string.
	   */
	  function baseTrim(string) {
	    return string
	      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	      : string;
	  }

	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }

	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }

	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }

	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;

	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }

	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;

	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }

	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;

	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }

	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);

	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);

	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }

	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined$1 : object[key];
	  }

	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }

	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }

	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];

	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }

	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);

	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }

	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }

	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];

	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }

	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);

	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }

	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);

	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }

	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;

	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }

	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }

	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }

	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }

	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedEndIndex(string) {
	    var index = string.length;

	    while (index-- && reWhitespace.test(string.charAt(index))) {}
	    return index;
	  }

	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }

	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }

	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }

	  /*--------------------------------------------------------------------------*/

	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;

	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;

	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];

	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;

	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;

	    /** Used to generate unique IDs. */
	    var idCounter = 0;

	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());

	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;

	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);

	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;

	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );

	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined$1,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined$1,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined$1,
	        symIterator = Symbol ? Symbol.iterator : undefined$1,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined$1;

	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());

	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined$1,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;

	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');

	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;

	    /** Used to lookup unminified function names. */
	    var realNames = {};

	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);

	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined$1,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1,
	        symbolToString = symbolProto ? symbolProto.toString : undefined$1;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }

	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined$1;
	        return result;
	      };
	    }());

	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }

	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined$1;
	    }

	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {

	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,

	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,

	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,

	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',

	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {

	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };

	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;

	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }

	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }

	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }

	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);

	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];

	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;

	        var iterIndex = -1,
	            value = array[index];

	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);

	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }

	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;

	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }

	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }

	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }

	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined$1 : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined$1;
	    }

	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined$1) : hasOwnProperty.call(data, key);
	    }

	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined$1) ? HASH_UNDEFINED : value;
	      return this;
	    }

	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;

	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }

	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }

	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);

	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }

	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);

	      return index < 0 ? undefined$1 : data[index][1];
	    }

	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }

	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);

	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }

	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;

	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }

	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }

	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }

	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }

	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }

	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;

	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }

	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;

	    /*------------------------------------------------------------------------*/

	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;

	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }

	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }

	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }

	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }

	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }

	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);

	      this.size = data.size;
	      return result;
	    }

	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }

	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }

	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }

	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;

	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }

	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined$1;
	    }

	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }

	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }

	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined$1 && !eq(object[key], value)) ||
	          (value === undefined$1 && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }

	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined$1 && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }

	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }

	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }

	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }

	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }

	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }

	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;

	      while (++index < length) {
	        result[index] = skip ? undefined$1 : get(object, paths[index]);
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined$1) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined$1) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }

	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;

	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined$1) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;

	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);

	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }

	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);

	      var props = isArr ? undefined$1 : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }

	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];

	        if ((value === undefined$1 && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }

	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined$1, args); }, wait);
	    }

	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;

	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);

	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);

	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);

	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }

	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;

	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);

	        if (current != null && (computed === undefined$1
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;

	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined$1 || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }

	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;

	      predicate || (predicate = isFlattenable);
	      result || (result = []);

	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();

	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);

	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }

	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }

	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }

	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);

	      var index = 0,
	          length = path.length;

	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined$1;
	    }

	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }

	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined$1 ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }

	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }

	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }

	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }

	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }

	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];

	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined$1;
	      }
	      array = arrays[0];

	      var index = -1,
	          seen = caches[0];

	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;

	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }

	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined$1 : apply(func, object, args);
	    }

	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }

	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }

	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }

	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }

	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);

	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;

	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;

	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;

	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }

	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }

	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;

	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];

	        if (noCustomizer && data[2]) {
	          if (objValue === undefined$1 && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined$1
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }

	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }

	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }

	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }

	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }

	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }

	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];

	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }

	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];

	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }

	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined$1 && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }

	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined$1;

	          if (newValue === undefined$1) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }

	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);

	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined$1;

	      var isCommon = newValue === undefined$1;

	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }

	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined$1;
	    }

	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      if (iteratees.length) {
	        iteratees = arrayMap(iteratees, function(iteratee) {
	          if (isArray(iteratee)) {
	            return function(value) {
	              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	            }
	          }
	          return iteratee;
	        });
	      } else {
	        iteratees = [identity];
	      }

	      var index = -1;
	      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });

	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }

	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }

	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};

	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);

	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }

	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }

	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;

	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;

	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }

	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;

	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }

	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }

	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);

	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);

	      return result;
	    }

	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }

	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }

	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }

	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);

	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;

	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;

	        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	          return object;
	        }

	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
	          if (newValue === undefined$1) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }

	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };

	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };

	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }

	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;

	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;

	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;

	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }

	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;

	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];

	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }

	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      var low = 0,
	          high = array == null ? 0 : array.length;
	      if (high === 0) {
	        return 0;
	      }

	      value = iteratee(value);
	      var valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined$1;

	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined$1,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);

	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }

	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];

	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;

	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }

	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }

	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;

	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;

	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }

	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }

	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;

	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}

	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }

	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }

	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);

	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;

	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }

	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};

	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined$1;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }

	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }

	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }

	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }

	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;

	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined$1 ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }

	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };

	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

	      buffer.copy(result);
	      return result;
	    }

	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }

	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }

	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }

	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }

	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }

	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined$1,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);

	        var othIsDefined = other !== undefined$1,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);

	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }

	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;

	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }

	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;

	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }

	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;

	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }

	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;

	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }

	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});

	      var index = -1,
	          length = props.length;

	      while (++index < length) {
	        var key = props[index];

	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined$1;

	        if (newValue === undefined$1) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }

	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }

	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }

	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};

	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }

	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined$1,
	            guard = length > 2 ? sources[2] : undefined$1;

	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined$1;

	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined$1 : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }

	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);

	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }

	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;

	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }

	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);

	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }

	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);

	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined$1;

	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);

	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);

	        return chr[methodName]() + trailing;
	      };
	    }

	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }

	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);

	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }

	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);

	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);

	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);

	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined$1,
	            args, holders, undefined$1, undefined$1, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }

	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined$1;
	      };
	    }

	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;

	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];

	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined$1;

	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];

	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;

	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }

	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined$1 : createCtor(func);

	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;

	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;

	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }

	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }

	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined$1 && other === undefined$1) {
	          return defaultValue;
	        }
	        if (value !== undefined$1) {
	          result = value;
	        }
	        if (other !== undefined$1) {
	          if (result === undefined$1) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }

	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }

	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined$1 ? ' ' : baseToString(chars);

	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }

	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);

	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }

	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined$1;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined$1) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined$1 ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }

	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }

	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined$1,
	          newHoldersRight = isCurry ? undefined$1 : holders,
	          newPartials = isCurry ? partials : undefined$1,
	          newPartialsRight = isCurry ? undefined$1 : partials;

	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];

	      var result = wrapFunc.apply(undefined$1, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }

	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));

	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }

	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };

	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }

	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined$1;
	      }
	      ary = ary === undefined$1 ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined$1 ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;

	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;

	        partials = holders = undefined$1;
	      }
	      var data = isBindKey ? undefined$1 : getData(func);

	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];

	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined$1
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);

	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined$1, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }

	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined$1 ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }

	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }

	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined$1 : value;
	    }

	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;

	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Check that cyclic values are equal.
	      var arrStacked = stack.get(array);
	      var othStacked = stack.get(other);
	      if (arrStacked && othStacked) {
	        return arrStacked == other && othStacked == array;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined$1;

	      stack.set(array, other);
	      stack.set(other, array);

	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];

	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined$1) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }

	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;

	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;

	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);

	        case errorTag:
	          return object.name == other.name && object.message == other.message;

	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');

	        case mapTag:
	          var convert = mapToArray;

	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);

	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;

	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;

	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }

	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;

	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Check that cyclic values are equal.
	      var objStacked = stack.get(object);
	      var othStacked = stack.get(other);
	      if (objStacked && othStacked) {
	        return objStacked == other && othStacked == object;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);

	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];

	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined$1
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;

	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }

	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined$1, flatten), func + '');
	    }

	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }

	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }

	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };

	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }

	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }

	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }

	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }

	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;

	      while (length--) {
	        var key = result[length],
	            value = object[key];

	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }

	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined$1;
	    }

	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];

	      try {
	        value[symToStringTag] = undefined$1;
	        var unmasked = true;
	      } catch (e) {}

	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }

	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };

	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };

	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;

	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined$1,
	            ctorString = Ctor ? toSource(Ctor) : '';

	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }

	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;

	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;

	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }

	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }

	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);

	      var index = -1,
	          length = path.length,
	          result = false;

	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }

	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);

	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }

	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }

	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);

	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);

	        case dataViewTag:
	          return cloneDataView(object, isDeep);

	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);

	        case mapTag:
	          return new Ctor;

	        case numberTag:
	        case stringTag:
	          return new Ctor(object);

	        case regexpTag:
	          return cloneRegExp(object);

	        case setTag:
	          return new Ctor;

	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }

	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }

	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }

	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;

	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }

	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }

	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }

	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }

	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];

	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }

	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }

	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;

	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

	      return value === proto;
	    }

	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }

	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined$1 || (key in Object(object)));
	      };
	    }

	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });

	      var cache = result.cache;
	      return result;
	    }

	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;

	      return data;
	    }

	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }

	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }

	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined$1 ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);

	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }

	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }

	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);

	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined$1;
	      }
	      return array;
	    }

	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }

	      if (key == '__proto__') {
	        return;
	      }

	      return object[key];
	    }

	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);

	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };

	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);

	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }

	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;

	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);

	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined$1, arguments);
	      };
	    }

	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;

	      size = size === undefined$1 ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];

	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }

	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });

	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }

	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }

	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }

	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined$1)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));

	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }

	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];

	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }

	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;

	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }

	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });

	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined$1;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });

	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined$1;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined$1, comparator)
	        : [];
	    });

	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined$1) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }

	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined$1) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }

	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }

	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }

	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }

	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }

	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined$1) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }

	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }

	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }

	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined$1 ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }

	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};

	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }

	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined$1;
	    }

	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }

	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }

	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });

	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);

	      if (iteratee === last(mapped)) {
	        iteratee = undefined$1;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });

	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);

	      comparator = typeof comparator == 'function' ? comparator : undefined$1;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined$1, comparator)
	        : [];
	    });

	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }

	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined$1;
	    }

	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined$1) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }

	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined$1;
	    }

	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);

	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }

	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }

	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined$1, comparator)
	        : array;
	    }

	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);

	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));

	      return result;
	    });

	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;

	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }

	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }

	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined$1 ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }

	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }

	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }

	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }

	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }

	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }

	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }

	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }

	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }

	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }

	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined$1) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }

	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined$1) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }

	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }

	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }

	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });

	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined$1;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });

	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined$1;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
	    });

	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }

	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }

	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined$1;
	      return (array && array.length) ? baseUniq(array, undefined$1, comparator) : [];
	    }

	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }

	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined$1, group);
	      });
	    }

	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });

	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });

	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined$1;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });

	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined$1;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
	    });

	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);

	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }

	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }

	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined$1;

	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined$1;
	      return unzipWith(arrays, iteratee);
	    });

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }

	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }

	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }

	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };

	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined$1
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined$1);
	        }
	        return array;
	      });
	    });

	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }

	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }

	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined$1) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined$1 : this.__values__[this.__index__++];

	      return { 'done': done, 'value': value };
	    }

	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }

	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;

	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined$1;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }

	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined$1
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }

	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });

	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined$1;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }

	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     *
	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	     * // => objects for ['fred', 'barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }

	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);

	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);

	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }

	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }

	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined$1 ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }

	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }

	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }

	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });

	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }

	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];

	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });

	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });

	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }

	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined$1 : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }

	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });

	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;

	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }

	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;

	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }

	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }

	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }

	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined$1)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }

	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }

	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }

	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined$1;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }

	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 30 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });

	    /*------------------------------------------------------------------------*/

	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };

	    /*------------------------------------------------------------------------*/

	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }

	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined$1 : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n);
	    }

	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined$1;
	        }
	        return result;
	      };
	    }

	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });

	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });

	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined$1 : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }

	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined$1 : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }

	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;

	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }

	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;

	        lastArgs = lastThis = undefined$1;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }

	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }

	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;

	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }

	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;

	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined$1 || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }

	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }

	      function trailingEdge(time) {
	        timerId = undefined$1;

	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined$1;
	        return result;
	      }

	      function cancel() {
	        if (timerId !== undefined$1) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined$1;
	      }

	      function flush() {
	        return timerId === undefined$1 ? result : trailingEdge(now());
	      }

	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);

	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;

	        if (isInvoking) {
	          if (timerId === undefined$1) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined$1) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }

	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });

	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });

	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }

	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;

	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }

	    // Expose `MapCache`.
	    memoize.Cache = MapCache;

	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }

	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }

	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);

	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });

	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
	    });

	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
	    });

	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
	    });

	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined$1 ? start : toInteger(start);
	      return baseRest(func, start);
	    }

	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);

	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }

	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;

	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }

	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }

	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }

	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }

	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined$1;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }

	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }

	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined$1;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }

	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }

	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }

	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);

	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });

	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };

	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;

	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }

	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }

	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }

	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;

	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }

	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }

	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }

	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined$1;
	      var result = customizer ? customizer(value, other) : undefined$1;
	      return result === undefined$1 ? baseIsEqual(value, other, undefined$1, customizer) : !!result;
	    }

	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }

	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }

	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }

	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }

	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }

	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }

	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }

	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }

	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined$1;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }

	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }

	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }

	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }

	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }

	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }

	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }

	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }

	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }

	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }

	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined$1;
	    }

	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }

	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }

	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);

	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });

	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

	      return func(value);
	    }

	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }

	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;

	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }

	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }

	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = baseTrim(value);
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }

	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }

	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }

	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });

	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });

	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });

	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });

	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);

	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }

	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);

	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined$1;

	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }

	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;

	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];

	          if (value === undefined$1 ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }

	      return object;
	    });

	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined$1, customDefaultsMerge);
	      return apply(mergeWith, undefined$1, args);
	    });

	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }

	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }

	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }

	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }

	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }

	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }

	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }

	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }

	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined$1 : baseGet(object, path);
	      return result === undefined$1 ? defaultValue : result;
	    }

	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }

	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }

	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }

	      result[value] = key;
	    }, constant(identity));

	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }

	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);

	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);

	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }

	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }

	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);

	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }

	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);

	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }

	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });

	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });

	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });

	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }

	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });

	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }

	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);

	      var index = -1,
	          length = path.length;

	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined$1;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined$1 : object[toKey(path[index])];
	        if (value === undefined$1) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }

	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }

	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined$1;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }

	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);

	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);

	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }

	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }

	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }

	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined$1;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }

	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }

	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined$1) {
	        upper = lower;
	        lower = undefined$1;
	      }
	      if (upper !== undefined$1) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined$1) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }

	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined$1) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }

	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined$1;
	      }
	      if (floating === undefined$1) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined$1;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined$1;
	        }
	      }
	      if (lower === undefined$1 && upper === undefined$1) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined$1) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });

	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }

	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }

	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);

	      var length = string.length;
	      position = position === undefined$1
	        ? length
	        : baseClamp(toInteger(position), 0, length);

	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }

	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }

	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }

	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });

	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });

	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');

	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);

	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }

	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);

	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }

	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);

	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }

	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }

	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined$1)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }

	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);

	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }

	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });

	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined$1;
	      }
	      limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }

	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });

	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);

	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }

	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;

	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined$1;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);

	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);

	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";

	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');

	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
	      // and escape the comment, thus injecting code that gets evaled.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/\s/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';

	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);

	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;

	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });

	      source += "';\n";

	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Throw an error if a forbidden character was found in `variable`, to prevent
	      // potential command injection attacks.
	      else if (reForbiddenIdentifierChars.test(variable)) {
	        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
	      }

	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');

	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';

	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined$1, importsValues);
	      });

	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }

	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }

	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }

	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined$1)) {
	        return baseTrim(string);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;

	      return castSlice(strSymbols, start, end).join('');
	    }

	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined$1)) {
	        return string.slice(0, trimmedEndIndex(string) + 1);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

	      return castSlice(strSymbols, 0, end).join('');
	    }

	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined$1)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));

	      return castSlice(strSymbols, start).join('');
	    }

	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;

	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);

	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);

	      if (separator === undefined$1) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;

	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined$1 ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }

	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }

	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });

	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');

	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined$1 : pattern;

	      if (pattern === undefined$1) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined$1, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });

	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });

	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();

	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });

	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }

	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }

	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }

	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }

	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();

	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);

	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }

	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }

	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }

	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }

	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });

	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });

	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);

	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);

	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);

	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });

	      return object;
	    }

	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }

	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }

	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }

	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);

	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);

	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     *
	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	     */
	    var overSome = createOver(arraySome);

	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }

	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined$1 : baseGet(object, path);
	      };
	    }

	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();

	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);

	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }

	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }

	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }

	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }

	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }

	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);

	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;

	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }

	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }

	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);

	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');

	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);

	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');

	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined$1;
	    }

	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined$1;
	    }

	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }

	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }

	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined$1;
	    }

	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined$1;
	    }

	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);

	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');

	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);

	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }

	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }

	    /*------------------------------------------------------------------------*/

	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;

	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;

	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);

	    /*------------------------------------------------------------------------*/

	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;

	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;

	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });

	    /*------------------------------------------------------------------------*/

	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;

	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });

	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined$1 ? 1 : nativeMax(toInteger(n), 0);

	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();

	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };

	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });

	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });

	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');

	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });

	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');

	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });

	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };

	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };

	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };

	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });

	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };

	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);

	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined$1) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };

	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };

	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };

	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);

	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);

	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };

	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;

	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined$1 });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });

	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });

	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });

	    realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined$1
	    }];

	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;

	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;

	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });

	  /*--------------------------------------------------------------------------*/

	  // Export lodash.
	  var _ = runInContext();

	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(commonjsGlobal)); 
} (lodash, lodash.exports));

var lodashExports = lodash.exports;
var _ = /*@__PURE__*/getDefaultExportFromCjs(lodashExports);

var RATING = {
    STAR_1_3: '1_3',
    STAR_1_5: '1_5',
    STAR_1_10: '1_10',
    EMOJI: 'emoji',
    THUMBS: 'thumbs',
    NPS_1_5: 'NPS_1_5',
    NPS_1_10: 'NPS_1_10'
};
var PAGE_KEYS = {
    WELCOME_PAGE: 'welcome_page',
    TYPE_OF_ORDER: 'type_of_order',
    CHOOSE_LOCATION: 'choose_location',
    DELIVERY_PLATFORM: 'delivery_platform',
    RATINGS: 'ratings',
    EXPERIENCE_DETAILS: 'experience_details',
    EXPERIENCE_POSITIVE: 'experience_positive',
    EXPERIENCE_NEGATIVE: 'experience_negative',
    STAFF_LIST: 'staff_list',
    STAFF_RATING: 'staff_rating',
    PERSONAL_INFORMATION: 'personal_information',
    BOOST_PAGE: 'boost_page',
    BOOST_PAGE_V2: 'boost_page_v2',
    THANK_YOU: 'thank_you'
};
var ORDER_TYPE = {
    DINE_IN: 'DINE_IN',
    TAKE_AWAY: 'TAKE_AWAY',
    DELIVERY: 'DELIVERY'
};
var THIRD_PARTY_LINK_TYPE = {
    SOCIAL_MEDIA: 'SOCIAL_MEDIA',
    RESERVATION: 'RESERVATION',
    FOOD_DELIVERY: 'FOOD_DELIVERY'
};

var _a$1, _b, _c;
var MOMOS_WEBSITE_URL = 'https://momos.com/';
var REGIONS = {
    US: 'US',
    SG: 'SG'
};
var GOOGLE_MAP_ADDRESS_BUILD_ORDER = [
    'address1',
    'address2',
    'route',
    'city',
    'state',
    'pinCode',
    'countryCode',
];
var EXTRACT_DETAILED_QUESTION_TYPE = [
    'ratingtype',
    'tiered_rating',
    'sub_tiered_rating',
    'item_tiered_rating',
    'item_sub_tiered_rating',
];
var REWARD_TYPES = {
    DISCOUNT_AMOUNT: 'DISCOUNT_AMOUNT',
    PERCENTAGE_OFF: 'PERCENTAGE_OFF',
    FREE_ITEM: 'FREE_ITEM'
};
var DEFAULT_OFFER_IMAGES = {
    DISCOUNT_AMOUNT: 'https://stg-sg-notification-email-static-objects-bucket.s3.ap-southeast-1.amazonaws.com/images/dollar-off.png',
    PERCENTAGE_OFF: 'https://stg-sg-notification-email-static-objects-bucket.s3.ap-southeast-1.amazonaws.com/images/percentage-off.png',
    FREE_ITEM: 'https://stg-sg-notification-email-static-objects-bucket.s3.ap-southeast-1.amazonaws.com/images/free-item.png',
    DEFAULT: 'https://dar7o8g1w12g1.cloudfront.net/email/voucher_banner.png'
};
var PARTNER = {
    GRAB: 'GRAB',
    FOODPANDA: 'FOODPANDA',
    GMB: 'GMB',
    FACEBOOK: 'FACEBOOK',
    DELIVEROO: 'DELIVEROO',
    GOOGLE: 'GOOGLE',
    DOORDASH: 'DOORDASH',
    UBER_EATS: 'UBER_EATS',
    GRUBHUB: 'GRUBHUB',
    YELP: 'YELP',
    OPEN_TABLE: 'OPEN_TABLE',
    TRIP_ADVISOR: 'TRIP_ADVISOR'
};
var SOCIAL_MEDIA_PLATFORM = {
    GMB: PARTNER.GMB,
    FACEBOOK: PARTNER.FACEBOOK,
    INSTAGRAM: 'INSTAGRAM',
    MESSENGER: 'MESSENGER',
    YELP: 'YELP',
    WHATSAPP: 'WHATSAPP',
    TWITTER: 'TWITTER',
    SNAPCHAT: 'SNAPCHAT',
    PINTEREST: 'PINTEREST',
    YOUTUBE: 'YOUTUBE',
    LINE: 'LINE',
    SPOTIFY: 'SPOTIFY',
    TRIP_ADVISOR: PARTNER.TRIP_ADVISOR
};
var SOCIAL_MEDIA_NAME = (_a$1 = {},
    _a$1[SOCIAL_MEDIA_PLATFORM.TRIP_ADVISOR] = 'Trip Advisor',
    _a$1);
var SOCIAL_MEDIA_PARTNER_NAME_MAPPER = (_b = {},
    _b[PARTNER.GMB] = 'Google',
    _b[PARTNER.GOOGLE] = 'Google',
    _b[PARTNER.FACEBOOK] = 'Facebook',
    _b[PARTNER.YELP] = 'Yelp',
    _b[PARTNER.OPEN_TABLE] = 'OpenTable',
    _b[PARTNER.DOORDASH] = 'DoorDash',
    _b[PARTNER.GRUBHUB] = 'Grubhub',
    _b[PARTNER.UBER_EATS] = 'UberEats',
    _b[PARTNER.TRIP_ADVISOR] = 'TripAdvisor',
    _b);
(_c = {
        Facebook: 'FACEBOOK',
        Google: 'GOOGLE',
        Instagram: 'INSTAGRAM',
        Messenger: 'MESSENGER',
        LinkedIn: 'LINKEDIN',
        TikTok: 'TIKTOK',
        Yelp: 'YELP',
        DoorDash: 'DOORDASH',
        Youtube: 'YOUTUBE',
        Whatsapp: 'WHATSAPP',
        Snapchat: 'SNAPCHAT',
        Twitter: 'TWITTER',
        Pinterest: 'PINTEREST',
        Line: 'LINE',
        Spotify: 'SPOTIFY',
        'Google Play Store': 'GOOGLE_PLAY_STORE',
        'App Store': 'APP_STORE'
    },
    _c[SOCIAL_MEDIA_NAME[SOCIAL_MEDIA_PLATFORM.TRIP_ADVISOR]] = PARTNER.TRIP_ADVISOR,
    _c);
var FontsList = [
    { value: 'Arial', label: 'Arial' },
    { value: 'Gilroy-Regular', label: 'Gilroy' },
    { value: 'Montserrat-Regular', label: 'Montserrat' },
    { value: 'Druk-Bold-Regular', label: 'Druk Bold Regular' },
    { value: 'Baby-School-Italic', label: 'Baby School Italic' },
    { value: 'Barlow-Bold', label: 'Barlow Bold' },
];
var breakpoints = {
    mobileS: '320px',
    mobileM: '375px',
    mobileL: '425px',
    tablet: '768px',
    laptop: '1024px',
    laptopL: '1440px',
    desktop: '2560px'
};
var DEFAULT_TS_TEXT = "<p>By checking this box, you agree to the following <a href=\"about:blank\" rel=\"noopener noreferrer\" target=\"_blank\">Terms and Conditions</a></p>";
var DATE_FORMAT = 'MMMM Do YYYY';
var DATETIME_FORMAT = 'MMMM D, YYYY h:mm a';
var PRIVATE_USER = 'PRIVATE_USER';
var SURVEY_TEMPLATES = {
    STD_FEEDBACK_SURVEY: 'STD_FEEDBACK_SURVEY',
    BOOST_SURVEY: 'BOOST_SURVEY',
    FEW_CLICK_FEEDBACK_SURVEY: 'FEW_CLICK_FEEDBACK_SURVEY',
    STD_FEEDBACK_SURVEY_V2: 'STD_FEEDBACK_SURVEY_V2'
};
var STATIC_SURVEY_PAGES = [
    PAGE_KEYS.EXPERIENCE_NEGATIVE,
    PAGE_KEYS.EXPERIENCE_POSITIVE,
    PAGE_KEYS.BOOST_PAGE,
    PAGE_KEYS.BOOST_PAGE_V2,
    PAGE_KEYS.STAFF_LIST,
    PAGE_KEYS.STAFF_RATING,
    PAGE_KEYS.TYPE_OF_ORDER,
    PAGE_KEYS.CHOOSE_LOCATION,
    PAGE_KEYS.DELIVERY_PLATFORM,
    PAGE_KEYS.RATINGS,
];
var STATIC_PAGE_KEYS_WITH_CUSTOM_QUESTIONS = [
    PAGE_KEYS.RATINGS,
    PAGE_KEYS.EXPERIENCE_DETAILS,
    PAGE_KEYS.PERSONAL_INFORMATION,
    PAGE_KEYS.THANK_YOU,
];
var QUESTION_TYPE_KEYS = {
    TIERED_RATING: 'tiered_rating',
    SUB_TIERED_RATING: 'sub_tiered_rating',
    RATING: 'ratingtype',
    DROPDOWN: 'dropdown',
    SINGLE_CHOICE: 'single-choice',
    PICTURE_SELECTION: 'picture-selection',
    ITEM_TIERED_RATING: 'item_tiered_rating',
    SUB_ITEM_TIERED_RATING: 'sub_item_tiered_rating',
    CHOOSE_VOUCHER: 'choose_voucher',
    DYNAMIC_TEXT: 'dynamic_text'
};
var SKIP_ABLE_QUESTION_TYPE = [
    QUESTION_TYPE_KEYS.TIERED_RATING,
    QUESTION_TYPE_KEYS.DROPDOWN,
    QUESTION_TYPE_KEYS.SUB_TIERED_RATING,
    QUESTION_TYPE_KEYS.RATING,
    QUESTION_TYPE_KEYS.SINGLE_CHOICE,
    QUESTION_TYPE_KEYS.PICTURE_SELECTION,
    QUESTION_TYPE_KEYS.ITEM_TIERED_RATING,
    QUESTION_TYPE_KEYS.SUB_ITEM_TIERED_RATING,
    QUESTION_TYPE_KEYS.CHOOSE_VOUCHER,
];
var CURRENCIES = {
    US: '$',
    SG: 'SGD',
    AU: 'AUD',
    HK: 'HKD',
    MY: 'MYR',
    TH: 'THB',
    PH: 'PHP',
    VN: 'VND'
};
var OFFER_LANGUAGES = {
    'en-US': 'American English',
    'en-GB': 'British English',
    'ms-MY': 'Malay',
    'id-ID': 'Indonesian',
    'fil-PH': 'Filipino',
    'th-TH': 'Thai',
    'es-ES': 'Spanish',
    'ar-SA': 'Arabic',
    'zh-CN': 'Simplified Chinese',
    'zh-TW': 'Traditional Chinese',
    'vi-VN': 'Vietnamese'
};
var FLAG_LANGUAGES = {
    'en-US': 'fi fi-us',
    'en-GB': 'fi fi-gb',
    'ms-MY': 'fi fi-my',
    'id-ID': 'fi fi-id',
    'fil-PH': 'fi fi-ph',
    'th-TH': 'fi fi-th',
    'es-ES': 'fi fi-es',
    'ar-SA': 'fi fi-sa',
    'zh-CN': 'fi fi-cn',
    'zh-TW': 'fi fi-tw',
    'vi-VN': 'fi fi-vn'
};
var PHONE_COUNTRY_CODE_MAPPING = {
    US: 'us',
    SG: 'sg',
    UAE: 'ae',
    KWT: 'kw'
};
var BOOST_PAGE_V2_CONFIG = {
    google: {
        icon: ['Google'],
        platformName: 'Google',
        buttonKey: ['button_text'],
        variationPlaformKey: 'GOOGLE',
        redirectionUrlKey: {
            button_text: {
                fieldKey: 'selectedLocationReviewLink',
                icon: 'Google',
                color: '#0E68E9',
                variationPlaformKey: 'GOOGLE'
            }
        }
    },
    yelp: {
        icon: ['Yelp'],
        platformName: 'Google',
        buttonKey: ['button_text'],
        variationPlaformKey: 'YELP',
        redirectionUrlKey: {
            button_text: {
                fieldKey: 'selectedLocationReviewYelpLink',
                icon: 'Yelp',
                color: '#D73E33',
                variationPlaformKey: 'YELP'
            }
        }
    },
    all: {
        platformName: 'Platform',
        icon: ['Google', 'Yelp'],
        buttonKey: ['button_text_google', 'button_text_yelp'],
        redirectionUrlKey: {
            button_text_google: {
                fieldKey: 'selectedLocationReviewLink',
                icon: 'Google',
                color: '#0E68E9',
                variationPlaformKey: 'GOOGLE'
            },
            button_text_yelp: {
                fieldKey: 'selectedLocationReviewYelpLink',
                icon: 'Yelp',
                color: '#D73E33',
                variationPlaformKey: 'YELP'
            }
        }
    }
};
var BOOST_PAGE_KEYS = [PAGE_KEYS.BOOST_PAGE, PAGE_KEYS.BOOST_PAGE_V2];

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function arrayMap$5(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap$5;

var baseGetTag$3 = _baseGetTag,
    isObjectLike$7 = isObjectLike_1;

/** `Object#toString` result references. */
var symbolTag$3 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$5(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$7(value) && baseGetTag$3(value) == symbolTag$3);
}

var isSymbol_1 = isSymbol$5;

var Symbol$4 = _Symbol,
    arrayMap$4 = _arrayMap,
    isArray$e = isArray_1,
    isSymbol$4 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$2 = Symbol$4 ? Symbol$4.prototype : undefined,
    symbolToString = symbolProto$2 ? symbolProto$2.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$4(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$e(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap$4(value, baseToString$4) + '';
  }
  if (isSymbol$4(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$2) ? '-0' : result;
}

var _baseToString = baseToString$4;

/** Used to match a single whitespace character. */

var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex$1(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

var _trimmedEndIndex = trimmedEndIndex$1;

var trimmedEndIndex = _trimmedEndIndex;

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim$2(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

var _baseTrim = baseTrim$2;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */

function baseSlice$2(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

var _baseSlice = baseSlice$2;

var baseSlice$1 = _baseSlice;

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice$3(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice$1(array, start, end);
}

var _castSlice = castSlice$3;

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function baseFindIndex$2(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

var _baseFindIndex = baseFindIndex$2;

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */

function baseIsNaN$1(value) {
  return value !== value;
}

var _baseIsNaN = baseIsNaN$1;

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function strictIndexOf$1(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

var _strictIndexOf = strictIndexOf$1;

var baseFindIndex$1 = _baseFindIndex,
    baseIsNaN = _baseIsNaN,
    strictIndexOf = _strictIndexOf;

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf$3(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex$1(array, baseIsNaN, fromIndex);
}

var _baseIndexOf = baseIndexOf$3;

var baseIndexOf$2 = _baseIndexOf;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex$1(strSymbols, chrSymbols) {
  var index = strSymbols.length;

  while (index-- && baseIndexOf$2(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

var _charsEndIndex = charsEndIndex$1;

var baseIndexOf$1 = _baseIndexOf;

/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex$1(strSymbols, chrSymbols) {
  var index = -1,
      length = strSymbols.length;

  while (++index < length && baseIndexOf$1(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

var _charsStartIndex = charsStartIndex$1;

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */

function asciiToArray$1(string) {
  return string.split('');
}

var _asciiToArray = asciiToArray$1;

/** Used to compose unicode character classes. */

var rsAstralRange$3 = '\\ud800-\\udfff',
    rsComboMarksRange$4 = '\\u0300-\\u036f',
    reComboHalfMarksRange$4 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$4 = '\\u20d0-\\u20ff',
    rsComboRange$4 = rsComboMarksRange$4 + reComboHalfMarksRange$4 + rsComboSymbolsRange$4,
    rsVarRange$3 = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ$3 = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ$3 + rsAstralRange$3  + rsComboRange$4 + rsVarRange$3 + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode$4(string) {
  return reHasUnicode.test(string);
}

var _hasUnicode = hasUnicode$4;

/** Used to compose unicode character classes. */

var rsAstralRange$2 = '\\ud800-\\udfff',
    rsComboMarksRange$3 = '\\u0300-\\u036f',
    reComboHalfMarksRange$3 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$3 = '\\u20d0-\\u20ff',
    rsComboRange$3 = rsComboMarksRange$3 + reComboHalfMarksRange$3 + rsComboSymbolsRange$3,
    rsVarRange$2 = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral$1 = '[' + rsAstralRange$2 + ']',
    rsCombo$3 = '[' + rsComboRange$3 + ']',
    rsFitz$2 = '\\ud83c[\\udffb-\\udfff]',
    rsModifier$2 = '(?:' + rsCombo$3 + '|' + rsFitz$2 + ')',
    rsNonAstral$2 = '[^' + rsAstralRange$2 + ']',
    rsRegional$2 = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair$2 = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ$2 = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod$2 = rsModifier$2 + '?',
    rsOptVar$2 = '[' + rsVarRange$2 + ']?',
    rsOptJoin$2 = '(?:' + rsZWJ$2 + '(?:' + [rsNonAstral$2, rsRegional$2, rsSurrPair$2].join('|') + ')' + rsOptVar$2 + reOptMod$2 + ')*',
    rsSeq$2 = rsOptVar$2 + reOptMod$2 + rsOptJoin$2,
    rsSymbol$1 = '(?:' + [rsNonAstral$2 + rsCombo$3 + '?', rsCombo$3, rsRegional$2, rsSurrPair$2, rsAstral$1].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode$1 = RegExp(rsFitz$2 + '(?=' + rsFitz$2 + ')|' + rsSymbol$1 + rsSeq$2, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray$1(string) {
  return string.match(reUnicode$1) || [];
}

var _unicodeToArray = unicodeToArray$1;

var asciiToArray = _asciiToArray,
    hasUnicode$3 = _hasUnicode,
    unicodeToArray = _unicodeToArray;

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray$3(string) {
  return hasUnicode$3(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

var _stringToArray = stringToArray$3;

var baseToString$3 = _baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$d(value) {
  return value == null ? '' : baseToString$3(value);
}

var toString_1 = toString$d;

var baseToString$2 = _baseToString,
    baseTrim$1 = _baseTrim,
    castSlice$2 = _castSlice,
    charsEndIndex = _charsEndIndex,
    charsStartIndex = _charsStartIndex,
    stringToArray$2 = _stringToArray,
    toString$c = toString_1;

/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */
function trim$1(string, chars, guard) {
  string = toString$c(string);
  if (string && (guard || chars === undefined)) {
    return baseTrim$1(string);
  }
  if (!string || !(chars = baseToString$2(chars))) {
    return string;
  }
  var strSymbols = stringToArray$2(string),
      chrSymbols = stringToArray$2(chars),
      start = charsStartIndex(strSymbols, chrSymbols),
      end = charsEndIndex(strSymbols, chrSymbols) + 1;

  return castSlice$2(strSymbols, start, end).join('');
}

var trim_1 = trim$1;

var trim$2 = /*@__PURE__*/getDefaultExportFromCjs(trim_1);

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear$1;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq$4(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq$4;

var eq$3 = eq_1;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$4(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$3(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf$4;

var assocIndexOf$3 = _assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$1(key) {
  var data = this.__data__,
      index = assocIndexOf$3(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete$1;

var assocIndexOf$2 = _assocIndexOf;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$1(key) {
  var data = this.__data__,
      index = assocIndexOf$2(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet$1;

var assocIndexOf$1 = _assocIndexOf;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas$1;

var assocIndexOf = _assocIndexOf;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$1(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet$1;

var listCacheClear = _listCacheClear,
    listCacheDelete = _listCacheDelete,
    listCacheGet = _listCacheGet,
    listCacheHas = _listCacheHas,
    listCacheSet = _listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$4(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype['delete'] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;

var _ListCache = ListCache$4;

var ListCache$3 = _ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear$1() {
  this.__data__ = new ListCache$3;
  this.size = 0;
}

var _stackClear = stackClear$1;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function stackDelete$1(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete$1;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function stackGet$1(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet$1;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function stackHas$1(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas$1;

var getNative$1 = _getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate$4 = getNative$1(Object, 'create');

var _nativeCreate = nativeCreate$4;

var nativeCreate$3 = _nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}

var _hashClear = hashClear$1;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete$1;

var nativeCreate$2 = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$a.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? undefined : result;
  }
  return hasOwnProperty$9.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet$1;

var nativeCreate$1 = _nativeCreate;

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$9.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? (data[key] !== undefined) : hasOwnProperty$8.call(data, key);
}

var _hashHas = hashHas$1;

var nativeCreate = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet$1;

var hashClear = _hashClear,
    hashDelete = _hashDelete,
    hashGet = _hashGet,
    hashHas = _hashHas,
    hashSet = _hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$1.prototype.clear = hashClear;
Hash$1.prototype['delete'] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;

var _Hash = Hash$1;

var Hash = _Hash,
    ListCache$2 = _ListCache,
    Map$2 = _Map;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map$2 || ListCache$2),
    'string': new Hash
  };
}

var _mapCacheClear = mapCacheClear$1;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

function isKeyable$1(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable$1;

var isKeyable = _isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData$4;

var getMapData$3 = _getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete$1;

var getMapData$2 = _getMapData;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}

var _mapCacheGet = mapCacheGet$1;

var getMapData$1 = _getMapData;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}

var _mapCacheHas = mapCacheHas$1;

var getMapData = _getMapData;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet$1;

var mapCacheClear = _mapCacheClear,
    mapCacheDelete = _mapCacheDelete,
    mapCacheGet = _mapCacheGet,
    mapCacheHas = _mapCacheHas,
    mapCacheSet = _mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$3(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype['delete'] = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;

var _MapCache = MapCache$3;

var ListCache$1 = _ListCache,
    Map$1 = _Map,
    MapCache$2 = _MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$1 || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$2(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet$1;

var ListCache = _ListCache,
    stackClear = _stackClear,
    stackDelete = _stackDelete,
    stackGet = _stackGet,
    stackHas = _stackHas,
    stackSet = _stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack$3(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack$3.prototype.clear = stackClear;
Stack$3.prototype['delete'] = stackDelete;
Stack$3.prototype.get = stackGet;
Stack$3.prototype.has = stackHas;
Stack$3.prototype.set = stackSet;

var _Stack = Stack$3;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */

function arrayEach$2(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var _arrayEach = arrayEach$2;

var getNative = _getNative;

var defineProperty$2 = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty$2 = defineProperty$2;

var defineProperty$1 = _defineProperty$2;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue$2(object, key, value) {
  if (key == '__proto__' && defineProperty$1) {
    defineProperty$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue$2;

var baseAssignValue$1 = _baseAssignValue,
    eq$2 = eq_1;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$8.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue$2(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$7.call(object, key) && eq$2(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue$1(object, key, value);
  }
}

var _assignValue = assignValue$2;

var assignValue$1 = _assignValue,
    baseAssignValue = _baseAssignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject$5(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue$1(object, key, newValue);
    }
  }
  return object;
}

var _copyObject = copyObject$5;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */

function baseTimes$1(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes$1;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$3(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex$3;

var baseTimes = _baseTimes,
    isArguments$2 = isArguments_1,
    isArray$d = isArray_1,
    isBuffer$3 = isBufferExports,
    isIndex$2 = _isIndex,
    isTypedArray$1 = isTypedArray_1;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys$2(value, inherited) {
  var isArr = isArray$d(value),
      isArg = !isArr && isArguments$2(value),
      isBuff = !isArr && !isArg && isBuffer$3(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$6.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex$2(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys$2;

var arrayLikeKeys$1 = _arrayLikeKeys,
    baseKeys$1 = _baseKeys,
    isArrayLike$7 = isArrayLike_1;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$7(object) {
  return isArrayLike$7(object) ? arrayLikeKeys$1(object) : baseKeys$1(object);
}

var keys_1 = keys$7;

var keys$8 = /*@__PURE__*/getDefaultExportFromCjs(keys_1);

var copyObject$4 = _copyObject,
    keys$6 = keys_1;

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign$1(object, source) {
  return object && copyObject$4(source, keys$6(source), object);
}

var _baseAssign = baseAssign$1;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function nativeKeysIn$1(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn = nativeKeysIn$1;

var isObject$7 = isObject_1,
    isPrototype$1 = _isPrototype,
    nativeKeysIn = _nativeKeysIn;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn$1(object) {
  if (!isObject$7(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype$1(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$5.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn = baseKeysIn$1;

var arrayLikeKeys = _arrayLikeKeys,
    baseKeysIn = _baseKeysIn,
    isArrayLike$6 = isArrayLike_1;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn$3(object) {
  return isArrayLike$6(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

var keysIn_1 = keysIn$3;

var copyObject$3 = _copyObject,
    keysIn$2 = keysIn_1;

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn$1(object, source) {
  return object && copyObject$3(source, keysIn$2(source), object);
}

var _baseAssignIn = baseAssignIn$1;

var _cloneBuffer = {exports: {}};

_cloneBuffer.exports;

(function (module, exports) {
	var root = _root;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

	  buffer.copy(result);
	  return result;
	}

	module.exports = cloneBuffer; 
} (_cloneBuffer, _cloneBuffer.exports));

var _cloneBufferExports = _cloneBuffer.exports;

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */

function copyArray$1(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

var _copyArray = copyArray$1;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function arrayFilter$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter$1;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */

function stubArray$2() {
  return [];
}

var stubArray_1 = stubArray$2;

var arrayFilter = _arrayFilter,
    stubArray$1 = stubArray_1;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$5.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols$3 = !nativeGetSymbols$1 ? stubArray$1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols$1(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

var _getSymbols = getSymbols$3;

var copyObject$2 = _copyObject,
    getSymbols$2 = _getSymbols;

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols$1(source, object) {
  return copyObject$2(source, getSymbols$2(source), object);
}

var _copySymbols = copySymbols$1;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

function arrayPush$3(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush$3;

var overArg = _overArg;

/** Built-in value references. */
var getPrototype$3 = overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype$3;

var arrayPush$2 = _arrayPush,
    getPrototype$2 = _getPrototype,
    getSymbols$1 = _getSymbols,
    stubArray = stubArray_1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn$2 = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush$2(result, getSymbols$1(object));
    object = getPrototype$2(object);
  }
  return result;
};

var _getSymbolsIn = getSymbolsIn$2;

var copyObject$1 = _copyObject,
    getSymbolsIn$1 = _getSymbolsIn;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn$1(source, object) {
  return copyObject$1(source, getSymbolsIn$1(source), object);
}

var _copySymbolsIn = copySymbolsIn$1;

var arrayPush$1 = _arrayPush,
    isArray$c = isArray_1;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys$2(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$c(object) ? result : arrayPush$1(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys$2;

var baseGetAllKeys$1 = _baseGetAllKeys,
    getSymbols = _getSymbols,
    keys$5 = keys_1;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys$2(object) {
  return baseGetAllKeys$1(object, keys$5, getSymbols);
}

var _getAllKeys = getAllKeys$2;

var baseGetAllKeys = _baseGetAllKeys,
    getSymbolsIn = _getSymbolsIn,
    keysIn$1 = keysIn_1;

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn$2(object) {
  return baseGetAllKeys(object, keysIn$1, getSymbolsIn);
}

var _getAllKeysIn = getAllKeysIn$2;

/** Used for built-in method references. */

var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$4.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray$1(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$4.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

var _initCloneArray = initCloneArray$1;

var root$1 = _root;

/** Built-in value references. */
var Uint8Array$3 = root$1.Uint8Array;

var _Uint8Array = Uint8Array$3;

var Uint8Array$2 = _Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer$3(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$2(result).set(new Uint8Array$2(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer$3;

var cloneArrayBuffer$2 = _cloneArrayBuffer;

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView$1(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$2(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView = cloneDataView$1;

/** Used to match `RegExp` flags from their coerced string values. */

var reFlags$1 = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp$1(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags$1.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp = cloneRegExp$1;

var Symbol$3 = _Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$3 ? Symbol$3.prototype : undefined,
    symbolValueOf$1 = symbolProto$1 ? symbolProto$1.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol$1(symbol) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(symbol)) : {};
}

var _cloneSymbol = cloneSymbol$1;

var cloneArrayBuffer$1 = _cloneArrayBuffer;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray$1(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$1(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray$1;

var cloneArrayBuffer = _cloneArrayBuffer,
    cloneDataView = _cloneDataView,
    cloneRegExp = _cloneRegExp,
    cloneSymbol = _cloneSymbol,
    cloneTypedArray = _cloneTypedArray;

/** `Object#toString` result references. */
var boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    mapTag$4 = '[object Map]',
    numberTag$2 = '[object Number]',
    regexpTag$3 = '[object RegExp]',
    setTag$4 = '[object Set]',
    stringTag$3 = '[object String]',
    symbolTag$2 = '[object Symbol]';

var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$2 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag$1(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$2:
      return cloneArrayBuffer(object);

    case boolTag$2:
    case dateTag$2:
      return new Ctor(+object);

    case dataViewTag$2:
      return cloneDataView(object, isDeep);

    case float32Tag$1: case float64Tag$1:
    case int8Tag$1: case int16Tag$1: case int32Tag$1:
    case uint8Tag$1: case uint8ClampedTag$1: case uint16Tag$1: case uint32Tag$1:
      return cloneTypedArray(object, isDeep);

    case mapTag$4:
      return new Ctor;

    case numberTag$2:
    case stringTag$3:
      return new Ctor(object);

    case regexpTag$3:
      return cloneRegExp(object);

    case setTag$4:
      return new Ctor;

    case symbolTag$2:
      return cloneSymbol(object);
  }
}

var _initCloneByTag = initCloneByTag$1;

var isObject$6 = isObject_1;

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate$1 = (function() {
  function object() {}
  return function(proto) {
    if (!isObject$6(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

var _baseCreate = baseCreate$1;

var baseCreate = _baseCreate,
    getPrototype$1 = _getPrototype,
    isPrototype = _isPrototype;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject$1(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype$1(object))
    : {};
}

var _initCloneObject = initCloneObject$1;

var getTag$4 = _getTag,
    isObjectLike$6 = isObjectLike_1;

/** `Object#toString` result references. */
var mapTag$3 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap$1(value) {
  return isObjectLike$6(value) && getTag$4(value) == mapTag$3;
}

var _baseIsMap = baseIsMap$1;

var baseIsMap = _baseIsMap,
    baseUnary$3 = _baseUnary,
    nodeUtil$2 = _nodeUtilExports;

/* Node.js helper references. */
var nodeIsMap = nodeUtil$2 && nodeUtil$2.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap$1 = nodeIsMap ? baseUnary$3(nodeIsMap) : baseIsMap;

var isMap_1 = isMap$1;

var getTag$3 = _getTag,
    isObjectLike$5 = isObjectLike_1;

/** `Object#toString` result references. */
var setTag$3 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet$1(value) {
  return isObjectLike$5(value) && getTag$3(value) == setTag$3;
}

var _baseIsSet = baseIsSet$1;

var baseIsSet = _baseIsSet,
    baseUnary$2 = _baseUnary,
    nodeUtil$1 = _nodeUtilExports;

/* Node.js helper references. */
var nodeIsSet = nodeUtil$1 && nodeUtil$1.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet$1 = nodeIsSet ? baseUnary$2(nodeIsSet) : baseIsSet;

var isSet_1 = isSet$1;

var Stack$2 = _Stack,
    arrayEach$1 = _arrayEach,
    assignValue = _assignValue,
    baseAssign = _baseAssign,
    baseAssignIn = _baseAssignIn,
    cloneBuffer = _cloneBufferExports,
    copyArray = _copyArray,
    copySymbols = _copySymbols,
    copySymbolsIn = _copySymbolsIn,
    getAllKeys$1 = _getAllKeys,
    getAllKeysIn$1 = _getAllKeysIn,
    getTag$2 = _getTag,
    initCloneArray = _initCloneArray,
    initCloneByTag = _initCloneByTag,
    initCloneObject = _initCloneObject,
    isArray$b = isArray_1,
    isBuffer$2 = isBufferExports,
    isMap = isMap_1,
    isObject$5 = isObject_1,
    isSet = isSet_1,
    keys$4 = keys_1,
    keysIn = keysIn_1;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$2 = 1,
    CLONE_FLAT_FLAG$1 = 2,
    CLONE_SYMBOLS_FLAG$2 = 4;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag$2 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$2 = '[object String]',
    symbolTag$1 = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag$1] = cloneableTags[arrayTag$1] =
cloneableTags[arrayBufferTag$1] = cloneableTags[dataViewTag$1] =
cloneableTags[boolTag$1] = cloneableTags[dateTag$1] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag$2] =
cloneableTags[numberTag$1] = cloneableTags[objectTag$2] =
cloneableTags[regexpTag$2] = cloneableTags[setTag$2] =
cloneableTags[stringTag$2] = cloneableTags[symbolTag$1] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag$1] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone$2(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG$2,
      isFlat = bitmask & CLONE_FLAT_FLAG$1,
      isFull = bitmask & CLONE_SYMBOLS_FLAG$2;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject$5(value)) {
    return value;
  }
  var isArr = isArray$b(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag$2(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer$2(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$2 || tag == argsTag$1 || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack$2);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone$2(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone$2(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn$1 : getAllKeys$1)
    : (isFlat ? keysIn : keys$4);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach$1(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone$2(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

var _baseClone = baseClone$2;

var isArray$a = isArray_1,
    isSymbol$3 = isSymbol_1;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey$3(value, object) {
  if (isArray$a(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol$3(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey$3;

var MapCache$1 = _MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$1(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$1.Cache || MapCache$1);
  return memoized;
}

// Expose `MapCache`.
memoize$1.Cache = MapCache$1;

var memoize_1 = memoize$1;

var memoize = memoize_1;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped$1(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped$1;

var memoizeCapped = _memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$1 = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath$1;

var isArray$9 = isArray_1,
    isKey$2 = _isKey,
    stringToPath = _stringToPath,
    toString$b = toString_1;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath$4(value, object) {
  if (isArray$9(value)) {
    return value;
  }
  return isKey$2(value, object) ? [value] : stringToPath(toString$b(value));
}

var _castPath = castPath$4;

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */

function last$1(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

var last_1 = last$1;

var isSymbol$2 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey$5(value) {
  if (typeof value == 'string' || isSymbol$2(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

var _toKey = toKey$5;

var castPath$3 = _castPath,
    toKey$4 = _toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet$4(object, path) {
  path = castPath$3(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey$4(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet$4;

var baseGet$3 = _baseGet,
    baseSlice = _baseSlice;

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent$1(object, path) {
  return path.length < 2 ? object : baseGet$3(object, baseSlice(path, 0, -1));
}

var _parent = parent$1;

var castPath$2 = _castPath,
    last = last_1,
    parent = _parent,
    toKey$3 = _toKey;

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset$1(object, path) {
  path = castPath$2(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey$3(last(path))];
}

var _baseUnset = baseUnset$1;

var baseGetTag$2 = _baseGetTag,
    getPrototype = _getPrototype,
    isObjectLike$4 = isObjectLike_1;

/** `Object#toString` result references. */
var objectTag$1 = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto$3 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$3.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject$2(value) {
  if (!isObjectLike$4(value) || baseGetTag$2(value) != objectTag$1) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$3.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

var isPlainObject_1 = isPlainObject$2;

var isPlainObject$1 = isPlainObject_1;

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone$1(value) {
  return isPlainObject$1(value) ? undefined : value;
}

var _customOmitClone = customOmitClone$1;

var Symbol$2 = _Symbol,
    isArguments$1 = isArguments_1,
    isArray$8 = isArray_1;

/** Built-in value references. */
var spreadableSymbol = Symbol$2 ? Symbol$2.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable$1(value) {
  return isArray$8(value) || isArguments$1(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

var _isFlattenable = isFlattenable$1;

var arrayPush = _arrayPush,
    isFlattenable = _isFlattenable;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten$2(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten$2(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

var _baseFlatten = baseFlatten$2;

var baseFlatten$1 = _baseFlatten;

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten$1(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten$1(array, 1) : [];
}

var flatten_1 = flatten$1;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */

function apply$1(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

var _apply = apply$1;

var apply = _apply;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$2 = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest$2(func, start, transform) {
  start = nativeMax$2(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax$2(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

var _overRest = overRest$2;

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */

function constant$1(value) {
  return function() {
    return value;
  };
}

var constant_1 = constant$1;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */

function identity$5(value) {
  return value;
}

var identity_1 = identity$5;

var constant = constant_1,
    defineProperty = _defineProperty$2,
    identity$4 = identity_1;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString$1 = !defineProperty ? identity$4 : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

var _baseSetToString = baseSetToString$1;

/** Used to detect hot functions by number of calls within a span of milliseconds. */

var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut$1(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut$1;

var baseSetToString = _baseSetToString,
    shortOut = _shortOut;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString$2 = shortOut(baseSetToString);

var _setToString = setToString$2;

var flatten = flatten_1,
    overRest$1 = _overRest,
    setToString$1 = _setToString;

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest$1(func) {
  return setToString$1(overRest$1(func, undefined, flatten), func + '');
}

var _flatRest = flatRest$1;

var arrayMap$3 = _arrayMap,
    baseClone$1 = _baseClone,
    baseUnset = _baseUnset,
    castPath$1 = _castPath,
    copyObject = _copyObject,
    customOmitClone = _customOmitClone,
    flatRest = _flatRest,
    getAllKeysIn = _getAllKeysIn;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG$1 = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap$3(paths, function(path) {
    path = castPath$1(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone$1(result, CLONE_DEEP_FLAG$1 | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG$1, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

var omit_1 = omit;

var omit$1 = /*@__PURE__*/getDefaultExportFromCjs(omit_1);

function bytesToSize(bytes) {
    var _a;
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0)
        return '0 Byte';
    var i = parseInt((_a = Math.floor(Math.log(bytes) / Math.log(1024))) === null || _a === void 0 ? void 0 : _a.toString());
    return Math.round(bytes / Math.pow(1024, i)) + ' ' + sizes[i];
}
/**
 * Calculates the haversine distance between point A, and B.
 * @param {number[]} latlngA [lat, lng] point A
 * @param {number[]} latlngB [lat, lng] point B
 * @param {boolean} isMiles If we are using miles, else km.
 */
var haversineDistance = function (_a, _b, isMiles) {
    var lat1 = _a[0], lon1 = _a[1];
    var lat2 = _b[0], lon2 = _b[1];
    if (isMiles === void 0) { isMiles = false; }
    var toRadian = function (angle) { return (Math.PI / 180) * angle; };
    var distance = function (a, b) { return (Math.PI / 180) * (a - b); };
    var RADIUS_OF_EARTH_IN_KM = 6371;
    var dLat = distance(lat2, lat1);
    var dLon = distance(lon2, lon1);
    lat1 = toRadian(lat1);
    lat2 = toRadian(lat2);
    // Haversine Formula
    var a = Math.pow(Math.sin(dLat / 2), 2) + Math.pow(Math.sin(dLon / 2), 2) * Math.cos(lat1) * Math.cos(lat2);
    var c = 2 * Math.asin(Math.sqrt(a));
    var finalDistance = RADIUS_OF_EARTH_IN_KM * c;
    if (isMiles) {
        finalDistance /= 1.60934;
    }
    return finalDistance;
};
var validateEmail = function (email) {
    return String(email)
        .toLowerCase()
        .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
};
var normalizeAddress = function (addressComponent) { return (!isEmpty$1(addressComponent) ? addressComponent + ', ' : ''); };
var buildGoogleMapAddress = function (addressObj) {
    if ((addressObj === null || addressObj === void 0 ? void 0 : addressObj.state) === (addressObj === null || addressObj === void 0 ? void 0 : addressObj.city)) {
        addressObj = omit$1(addressObj, 'state');
    }
    return trim$2(GOOGLE_MAP_ADDRESS_BUILD_ORDER.map(function (orderKey) { return normalizeAddress(addressObj === null || addressObj === void 0 ? void 0 : addressObj[orderKey]); }).join('')).replace(/,\s*$/, '');
};

var showNotification = function (message, title, type, duration, placement, btn) {
    if (title === void 0) { title = 'Momos'; }
    if (type === void 0) { type = 'info'; }
    if (duration === void 0) { duration = 10; }
    if (placement === void 0) { placement = 'topRight'; }
    notification[type]({
        message: title,
        description: message,
        duration: duration,
        placement: placement,
        btn: btn
    });
};

var _a;
var SOCIAL_MEDIA_ICONS = (_a = {
        Facebook: React__default.createElement(Icon, { type: "social-media", name: "Facebook" }),
        Google: React__default.createElement(Icon, { type: "social-media", name: "Google" }),
        Instagram: React__default.createElement(Icon, { type: "social-media", name: "Instagram" }),
        Messenger: React__default.createElement(Icon, { type: "social-media", name: "Messenger" }),
        LinkedIn: React__default.createElement(Icon, { type: "social-media", name: "LinkedIn" }),
        TikTok: React__default.createElement(Icon, { type: "social-media", name: "TikTok" }),
        Yelp: React__default.createElement(Icon, { type: "social-media", name: "Yelp" }),
        DoorDash: React__default.createElement(Icon, { type: "social-media", name: "Facebook" }),
        Whatsapp: React__default.createElement(Icon, { type: "social-media", name: "Whatsapp" }),
        Twitter: React__default.createElement(Icon, { type: "social-media", name: "Twitter" }),
        Youtube: React__default.createElement(Icon, { type: "social-media", name: "Youtube" }),
        Snapchat: React__default.createElement(Icon, { type: "social-media", name: "Snapchat" }),
        Pinterest: React__default.createElement(Icon, { type: "social-media", name: "Pinterest" }),
        Line: React__default.createElement(Icon, { type: "social-media", name: "Line" }),
        Spotify: React__default.createElement(Icon, { type: "social-media", name: "Spotify" }),
        'Google Play Store': React__default.createElement(Icon, { type: "social-media", name: "GooglePlay" }),
        'App Store': React__default.createElement(Icon, { type: "social-media", name: "AppStore" })
    },
    _a[SOCIAL_MEDIA_NAME[SOCIAL_MEDIA_PLATFORM.TRIP_ADVISOR]] = React__default.createElement(Icon, { type: "social-media", name: "TripAdvisor" }),
    _a);

var Agreement = function (_a) {
    var slug = _a.slug, fontColor = _a.fontColor, customTc = _a.customTc, _b = _a.required, required = _b === void 0 ? true : _b, basePath = _a.basePath;
    var _c = useState("".concat(basePath, "/").concat(slug, "/tnc")), url = _c[0], setUrl = _c[1];
    useEffect(function () {
        var _a;
        setUrl("".concat(basePath, "/").concat(slug, "/tnc?referrer=").concat((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href));
    }, [slug]);
    return (React__default.createElement(AgreementWrapper, { "$fontColor": fontColor },
        React__default.createElement(Form.Item, { valuePropName: "checked", name: "terms", rules: [
                function () { return ({
                    validator: function (_, value) {
                        if (!value && required)
                            return Promise.reject(new Error('Please accept the terms & conditions'));
                        return Promise.resolve();
                    }
                }); },
            ] },
            React__default.createElement("div", { className: "each-agreement-box" },
                React__default.createElement(Checkbox, null, customTc ? (React__default.createElement("div", { className: "forms-tc-html", dangerouslySetInnerHTML: { __html: customTc } })) : (React__default.createElement("div", { className: "forms-tc-html" },
                    React__default.createElement("p", { className: "agreement-text mb-0 " },
                        "By checking this box, you agree to the following",
                        ' ',
                        React__default.createElement("a", { href: url !== null && url !== void 0 ? url : "".concat(basePath, "/").concat(slug, "/tnc"), target: "_blank", rel: "noopener noreferrer" }, "Terms and Conditions")))))))));
};
var AgreementWrapper = defaultStyled.div(templateObject_1$G || (templateObject_1$G = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0px;\n  gap: 10px;\n  margin-top: 10px;\n\n  .each-agreement-box {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: 0px;\n    gap: 10px;\n\n    .agreement-text {\n      font-style: normal;\n      font-weight: 500;\n      font-size: 14px;\n      line-height: 120%;\n      color: ", ";\n      margin-bottom: 0px;\n      text-align: left;\n    }\n  }\n  .ant-checkbox-checked .ant-checkbox-inner {\n    background-color: #30384c;\n    border-color: #30384c;\n  }\n  .ant-checkbox-checked::after {\n    border: 1px solid #30384c;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0px;\n  gap: 10px;\n  margin-top: 10px;\n\n  .each-agreement-box {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: 0px;\n    gap: 10px;\n\n    .agreement-text {\n      font-style: normal;\n      font-weight: 500;\n      font-size: 14px;\n      line-height: 120%;\n      color: ", ";\n      margin-bottom: 0px;\n      text-align: left;\n    }\n  }\n  .ant-checkbox-checked .ant-checkbox-inner {\n    background-color: #30384c;\n    border-color: #30384c;\n  }\n  .ant-checkbox-checked::after {\n    border: 1px solid #30384c;\n  }\n"])), function (props) { return props.$fontColor || '#30384c'; });
var templateObject_1$G;

var SvgImg = function (props) { return (React.createElement("svg", { width: "101", height: "18", viewBox: "0 0 101 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("g", { "clip-path": "url(#clip0_18520_94926)" },
        React.createElement("path", { d: "M40.9104 2.98877C42.1624 2.98877 43.1624 3.40505 43.9104 4.2376C44.6584 5.07016 45.0324 6.18432 45.0344 7.58007V14.4466H42.2204V7.78209C42.2204 7.11278 42.0604 6.59243 41.7404 6.22105C41.3944 5.83742 40.8964 5.63336 40.3864 5.66397C39.8164 5.63336 39.2644 5.87211 38.8884 6.31083C38.5324 6.74139 38.3544 7.36581 38.3544 8.18204V14.4466H35.5344V7.78209C35.5344 7.11278 35.3744 6.59243 35.0544 6.22105C34.7084 5.83742 34.2104 5.63336 33.7004 5.66397C33.1284 5.63948 32.5784 5.88027 32.2024 6.32104C31.8324 6.75976 31.6484 7.3801 31.6464 8.18204V14.4466H28.8284V3.30098H31.6464V4.48247C32.3024 3.48667 33.3144 2.98877 34.6824 2.98877C36.0504 2.98877 37.0404 3.52136 37.6544 4.58858C38.3684 3.52136 39.4544 2.98877 40.9104 2.98877Z", fill: "#30384C" }),
        React.createElement("path", { d: "M56.7493 13.0651C54.4853 15.3792 50.8093 15.3832 48.5413 13.0733C46.2733 10.7634 46.2693 7.01278 48.5333 4.69876C50.7973 2.38474 54.4733 2.38066 56.7413 4.6906C59.0093 7.00053 59.0133 10.7511 56.7493 13.0651ZM50.5213 11.0817C51.7073 12.2407 53.5753 12.2407 54.7613 11.0817C55.8973 9.83694 55.8973 7.91063 54.7613 6.66588C53.5753 5.50683 51.7073 5.50683 50.5213 6.66588C49.4153 7.92084 49.4153 9.82674 50.5213 11.0817Z", fill: "#30384C" }),
        React.createElement("path", { d: "M72.502 2.98877C73.7561 2.98877 74.7561 3.40505 75.5021 4.2376C76.2481 5.07016 76.6221 6.18432 76.6281 7.58007V14.4466H73.8101V7.78209C73.8101 7.11278 73.6481 6.59243 73.3281 6.22105C72.9821 5.83742 72.4841 5.63336 71.9741 5.66397C71.4041 5.63336 70.852 5.87211 70.478 6.31083C70.12 6.74139 69.9401 7.36581 69.9421 8.18204V14.4466H67.128V7.78209C67.128 7.11278 66.968 6.59243 66.648 6.22105C66.3 5.83742 65.802 5.63336 65.292 5.66397C64.722 5.63948 64.17 5.88027 63.796 6.32104C63.424 6.75976 63.2381 7.3801 63.2381 8.18204V14.4466H60.42V3.30098H63.2381V4.48247C63.8941 3.48667 64.906 2.98877 66.276 2.98877C67.646 2.98877 68.6361 3.52136 69.2481 4.58858C69.9601 3.52136 71.044 2.98877 72.502 2.98877Z", fill: "#30384C" }),
        React.createElement("path", { d: "M88.3418 13.0652C86.0778 15.3792 82.4038 15.3833 80.1338 13.0733C77.8638 10.7634 77.8618 7.01485 80.1258 4.69879C82.3898 2.38273 86.0638 2.38069 88.3338 4.69063C90.6038 7.00261 90.6058 10.7512 88.3418 13.0652ZM82.1158 11.0817C83.2998 12.2408 85.1698 12.2408 86.3538 11.0817C87.4898 9.83697 87.4898 7.91067 86.3538 6.66591C85.1698 5.50686 83.2998 5.50686 82.1158 6.66591C81.0098 7.92087 81.0098 9.82677 82.1158 11.0817Z", fill: "#30384C" }),
        React.createElement("path", { d: "M94.3743 6.46585C94.3743 6.9413 95.0363 7.34942 96.3623 7.69019C96.7923 7.78406 97.2143 7.9065 97.6283 8.0575C98.0323 8.21666 98.4183 8.42072 98.7763 8.66967C99.1603 8.92883 99.4743 9.28593 99.6823 9.70629C99.9083 10.1695 100.02 10.6817 100.01 11.2C100.01 12.3448 99.5883 13.2283 98.7423 13.8527C97.8963 14.4772 96.8523 14.7792 95.6103 14.7588C93.3683 14.7588 91.8403 13.8752 91.0223 12.106L93.4783 10.7103C93.8123 11.6754 94.5243 12.157 95.6183 12.1591C96.6243 12.1591 97.1283 11.8387 97.1263 11.2C97.1263 10.7245 96.4643 10.3164 95.1383 9.97564C94.6423 9.84301 94.2203 9.70833 93.8703 9.56753C93.4743 9.40836 93.0923 9.21043 92.7343 8.97576C92.3423 8.73293 92.0203 8.38807 91.8063 7.97383C91.5863 7.52899 91.4763 7.03313 91.4883 6.53523C91.4883 5.43535 91.8823 4.57219 92.6683 3.94981C93.5223 3.29274 94.5723 2.95401 95.6403 2.99074C96.4863 2.98054 97.3223 3.19072 98.0663 3.60291C98.7903 4.01103 99.3883 4.61708 99.7923 5.35373L97.3923 6.69031C97.1043 5.97203 96.4043 5.51698 95.6443 5.55371C95.3243 5.54146 95.0063 5.63125 94.7383 5.81082C94.5143 5.94958 94.3763 6.19853 94.3743 6.46585Z", fill: "#30384C" }),
        React.createElement("path", { d: "M11.5478 2.28271C16.7238 2.28475 20.9198 6.56588 20.9218 11.8469C20.9218 12.7774 20.7918 13.5018 20.5398 14.0018C20.3638 14.3568 20.0798 14.6445 19.7298 14.818C18.6538 15.3914 16.7298 15.471 14.7878 15.471C14.2958 15.471 13.7878 15.471 13.2618 15.4608C12.7358 15.4506 12.1338 15.4485 11.5478 15.4485C10.9618 15.4485 10.3878 15.4485 9.83177 15.4608C9.27577 15.473 8.79776 15.471 8.30577 15.471C6.37376 15.471 4.43977 15.3914 3.36377 14.818C3.01777 14.6425 2.73577 14.3548 2.56377 14.0018C2.31177 13.5018 2.18377 12.7774 2.18377 11.8449C2.18177 6.56384 6.37777 2.28271 11.5538 2.28067C11.5558 2.28067 11.5558 2.28067 11.5578 2.28067L11.5478 2.28271ZM11.5578 0.0727592C5.18577 0.0666375 0.0157656 5.33337 0.00976562 11.8347C0.00976562 11.8387 0.00976562 11.8428 0.00976562 11.8469C0.00976562 17.1993 3.51177 17.6728 8.30577 17.6728C9.33377 17.6728 10.4218 17.6503 11.5478 17.6503C12.6738 17.6503 13.7598 17.6728 14.7878 17.6728C19.5878 17.6728 23.0838 17.1993 23.0838 11.8469C23.0838 5.34562 17.9198 0.0768404 11.5478 0.0747998L11.5578 0.0727592Z", fill: "#D84339" }),
        React.createElement("path", { d: "M11.5465 8.16778C11.1485 8.16778 10.8245 7.83721 10.8245 7.43113V4.48862C10.8445 4.08254 11.1845 3.77034 11.5825 3.79074C11.9505 3.81115 12.2465 4.11111 12.2665 4.48862V7.43113C12.2665 7.83721 11.9445 8.16574 11.5465 8.16778Z", fill: "#D84339" }),
        React.createElement("path", { d: "M16.0315 8.1677C15.7635 8.1677 15.5175 8.0167 15.3935 7.77387C15.3935 7.75959 14.5935 6.25364 13.3775 5.62922C13.0215 5.44761 12.8795 5.0048 13.0575 4.64158C13.2355 4.27836 13.6695 4.13348 14.0255 4.31509C15.6635 5.15376 16.6255 7.01069 16.6715 7.09027C16.8555 7.45146 16.7195 7.8963 16.3655 8.08404C16.2635 8.13913 16.1475 8.1677 16.0315 8.1677Z", fill: "#D84339" }),
        React.createElement("path", { d: "M7.05252 8.1677C6.93652 8.1677 6.82052 8.13913 6.71852 8.08404C6.36452 7.8963 6.22852 7.45146 6.41252 7.09027C6.45452 7.01069 7.41252 5.15376 9.05853 4.31509C9.41453 4.13348 9.84853 4.27836 10.0265 4.64158C10.2045 5.0048 10.0625 5.44761 9.70653 5.62922C8.50652 6.24139 7.70652 7.75754 7.69052 7.77387C7.56652 8.0167 7.32052 8.1677 7.05252 8.1677Z", fill: "#D84339" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_18520_94926" },
            React.createElement("rect", { width: "100", height: "17.6", fill: "white", transform: "translate(0.00976562 0.0727539)" }))))); };

var OfferCardIcon = function () { return (React.createElement("svg", { width: "64", height: "64", viewBox: "0 0 64 64", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M18.3013 10.705C24.4342 6.77205 34.2749 16.5636 41.7683 14.3141C49.2617 12.0647 54.2765 13.7381 58.9466 22.7229C62.7523 30.0444 56.4637 29.938 62.2713 45.9968C68.0789 62.0555 58.1711 63.0875 48.5951 63.0875C36.9402 63.5773 31.2341 63.997 23.3772 63.997C15.5203 63.997 11.8096 64.394 7.3488 55.812C3.61011 48.6193 -5.03865 41.5192 3.94915 32.9439C12.9369 24.3687 10.5498 15.676 18.3013 10.705Z", fill: "#EAEAEA" }),
    React.createElement("g", { clipPath: "url(#clip0_2276_74774)" },
        React.createElement("mask", { id: "mask0_2276_74774", style: { maskType: 'luminance' }, maskUnits: "userSpaceOnUse", x: "9", y: "2", width: "47", height: "47" },
            React.createElement("path", { d: "M9 2.98408H56V48.9841H9V2.98408Z", fill: "white" })),
        React.createElement("g", { mask: "url(#mask0_2276_74774)" },
            React.createElement("path", { d: "M36.3619 37.5321L45.4418 32.8604C48.7079 31.1799 52.7481 32.237 54.5932 35.3644L54.6199 35.4096L35.3824 47.2436C34.4259 47.832 33.3194 47.7209 32.3415 47.1672L21.7695 41.1812H18.2773", stroke: "#30384C", strokeWidth: "2", strokeMiterlimit: "22.926", strokeLinecap: "round", strokeLinejoin: "round" }),
            React.createElement("path", { d: "M18.9658 29.2501H27.503C28.2346 29.2501 28.9132 29.4828 29.4658 29.8762L35.1476 33.0867C38.9865 35.2558 35.6359 40.9358 31.797 38.7666L26.5623 35.8086H24.2441", stroke: "#30384C", strokeWidth: "2", strokeMiterlimit: "22.926", strokeLinecap: "round", strokeLinejoin: "round" }),
            React.createElement("path", { d: "M10.3809 26.4492H18.2773V45.2151H10.3809V26.4492Z", stroke: "#30384C", strokeWidth: "2", strokeMiterlimit: "22.926", strokeLinecap: "round", strokeLinejoin: "round" }),
            React.createElement("path", { d: "M51.1328 15.228C51.1328 21.2072 46.1804 26.0542 40.0713 26.0542C33.9622 26.0542 29.0098 21.2072 29.0098 15.228C29.0098 9.24884 33.9622 4.40186 40.0713 4.40186C46.1804 4.40186 51.1328 9.24884 51.1328 15.228Z", stroke: "#30384C", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round" }),
            React.createElement("path", { d: "M40.0713 10.8976V8.73235", stroke: "#30384C", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round" }),
            React.createElement("path", { d: "M40.0713 19.5585V21.7238", stroke: "#30384C", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round" }),
            React.createElement("path", { d: "M42.2832 10.8976H39.3334C38.1116 10.8976 37.1211 11.867 37.1211 13.0628C37.1211 14.2586 38.1116 15.228 39.3334 15.228H40.8083C42.03 15.228 43.0206 16.1975 43.0206 17.3933C43.0206 18.5891 42.03 19.5585 40.8083 19.5585H37.8586", stroke: "#30384C", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round" }))),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_2276_74774" },
            React.createElement("rect", { width: "47", height: "46", fill: "white", transform: "translate(9 2.98438)" }))))); };

var PoweredByMomos = function (_a) {
    var color = _a.color, _b = _a.className, className = _b === void 0 ? '' : _b;
    var navigateToMomos = function () {
        window.open(MOMOS_WEBSITE_URL, '_blank');
    };
    return (React__default.createElement(PoweredByMomosWrap, { "$color": color, onClick: navigateToMomos, className: "powered-by-momos ".concat(className) },
        "Powered by ",
        React__default.createElement(SvgImg, null)));
};
var PoweredByMomosWrap = defaultStyled.div(templateObject_1$F || (templateObject_1$F = __makeTemplateObject(["\n  font-family: var(--font-family-medium);\n  font-style: normal;\n  font-weight: 600;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: ", ";\n  margin-top: 1.875rem;\n\n  svg {\n    margin-left: 0.625rem;\n\n    ", "\n  }\n"], ["\n  font-family: var(--font-family-medium);\n  font-style: normal;\n  font-weight: 600;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: ", ";\n  margin-top: 1.875rem;\n\n  svg {\n    margin-left: 0.625rem;\n\n    ", "\n  }\n"])), function (props) { return props.$color || 'inherit'; }, function (_a) {
    var $color = _a.$color;
    return $color &&
        "\n    path {\n      fill: ".concat($color, ";\n    }\n  ");
});
var templateObject_1$F;

var castSlice$1 = _castSlice,
    hasUnicode$2 = _hasUnicode,
    stringToArray$1 = _stringToArray,
    toString$a = toString_1;

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst$1(methodName) {
  return function(string) {
    string = toString$a(string);

    var strSymbols = hasUnicode$2(string)
      ? stringToArray$1(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice$1(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

var _createCaseFirst = createCaseFirst$1;

var createCaseFirst = _createCaseFirst;

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst$1 = createCaseFirst('toUpperCase');

var upperFirst_1 = upperFirst$1;

var toString$9 = toString_1,
    upperFirst = upperFirst_1;

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString$9(string).toLowerCase());
}

var capitalize_1 = capitalize;

var capitalize$1 = /*@__PURE__*/getDefaultExportFromCjs(capitalize_1);

var ThankYouModal = function (_a) {
    var visible = _a.visible, _b = _a.thirdPartyLinks, thirdPartyLinks = _b === void 0 ? [] : _b, fontType = _a.fontType, titleFontType = _a.titleFontType, closeModal = _a.closeModal, data = _a.data;
    return (React__default.createElement(Modal, { title: "", maskClosable: true, visible: visible, onCancel: closeModal, centered: true, footer: null, className: "momos-modal" },
        React__default.createElement(ThankYouModalContent, { thirdPartyLinks: thirdPartyLinks, fontType: fontType, titleFontType: titleFontType, closeModal: closeModal, data: data })));
};
var ThankYouModalContent = function (_a) {
    var _b;
    var _c = _a.thirdPartyLinks, thirdPartyLinks = _c === void 0 ? [] : _c, fontType = _a.fontType, titleFontType = _a.titleFontType, closeModal = _a.closeModal, data = _a.data;
    var _d = data || {}, _e = _d.pageTitle, pageTitle = _e === void 0 ? 'Thank you for reaching out to us.' : _e, _f = _d.caption, caption = _f === void 0 ? 'If needed, a representative will reach out to you shortly.' : _f, _g = _d.socialLinkCaption, socialLinkCaption = _g === void 0 ? 'Please contact us if you have any questions' : _g, showPageTitle = _d.showPageTitle, showCaption = _d.showCaption, showSocialCaption = _d.showSocialCaption, showSocialLinks = _d.showSocialLinks, _h = _d.buttonTitle, buttonTitle = _h === void 0 ? 'OK' : _h;
    var socialMediaLinks = (_b = thirdPartyLinks === null || thirdPartyLinks === void 0 ? void 0 : thirdPartyLinks.filter) === null || _b === void 0 ? void 0 : _b.call(thirdPartyLinks, function (type) { return type === null || type === void 0 ? void 0 : type.link; });
    return (React__default.createElement(ThankYouWrap, { "$titleFontType": titleFontType, "$fontType": fontType },
        React__default.createElement("div", { className: "thankyou-page-content" },
            React__default.createElement("div", { className: "body-content" },
                showPageTitle !== false && (React__default.createElement("h2", { className: "main-heading", dangerouslySetInnerHTML: { __html: pageTitle } })),
                showCaption !== false && React__default.createElement("p", { className: "main-caption", dangerouslySetInnerHTML: { __html: caption } }),
                React__default.createElement(HighlightButton$1, { type: "default", ghost: true, "$fontType": fontType, onClick: closeModal }, buttonTitle),
                showSocialCaption !== false && (React__default.createElement("p", { className: "main-social-caption", dangerouslySetInnerHTML: { __html: socialLinkCaption } })),
                showSocialLinks !== false && (React__default.createElement("div", { className: "social-media-links", style: { fontFamily: fontType } }, socialMediaLinks === null || socialMediaLinks === void 0 ? void 0 : socialMediaLinks.map(function (type, key) { return (React__default.createElement(IconWithText$1, { key: key, href: type.link, target: "_blank", "$fill": type.category === capitalize$1(PARTNER.GOOGLE) ||
                        type.category === capitalize$1(SOCIAL_MEDIA_PLATFORM.MESSENGER) ||
                        type.category === capitalize$1(SOCIAL_MEDIA_PLATFORM.WHATSAPP) ||
                        type.category === capitalize$1(SOCIAL_MEDIA_PLATFORM.TWITTER) ||
                        type.category === capitalize$1(SOCIAL_MEDIA_PLATFORM.SNAPCHAT) ||
                        type.category === capitalize$1(SOCIAL_MEDIA_PLATFORM.YOUTUBE) ||
                        type.category === capitalize$1(SOCIAL_MEDIA_PLATFORM.YELP) ||
                        type.category === capitalize$1(SOCIAL_MEDIA_PLATFORM.PINTEREST) ||
                        type.category === capitalize$1(SOCIAL_MEDIA_PLATFORM.LINE) ||
                        type.category === capitalize$1(SOCIAL_MEDIA_PLATFORM.SPOTIFY) ||
                        type.category === SOCIAL_MEDIA_NAME[SOCIAL_MEDIA_PLATFORM.TRIP_ADVISOR] },
                    SOCIAL_MEDIA_ICONS[type.category],
                    React__default.createElement("p", { className: "body-text", style: { fontFamily: fontType } }, type.category))); })))))));
};
var ThankYouWrap = defaultStyled.div(templateObject_1$E || (templateObject_1$E = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  padding: 0px;\n\n  .social-media-links {\n    margin-bottom: 0px;\n    margin-top: 1rem;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .thankyou-page-content {\n    flex: 1;\n\n    .main-heading {\n      color: var(--grey-dark);\n      font-family: ", " !important;\n      text-align: center;\n      font-size: 1.5rem;\n      font-weight: 600;\n      line-height: 1.813rem;\n    }\n\n    .body-content {\n      font-size: 0.875rem;\n      line-height: 1.25rem;\n      font-family: ", " !important;\n      font-weight: 600;\n      text-align: center;\n    }\n  }\n\n  @media (max-width: ", ") {\n    margin-top: 0px;\n    flex-direction: column;\n\n    .thankyou-page-content {\n      padding-right: 0px;\n      margin-bottom: 1.875rem;\n\n      .body-content {\n        font-size: 0.875rem;\n      }\n    }\n  }\n\n  .main-social-caption {\n    margin-top: 1rem;\n  }\n  .main-caption {\n    margin-top: 1rem;\n    margin-bottom: 0rem;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  padding: 0px;\n\n  .social-media-links {\n    margin-bottom: 0px;\n    margin-top: 1rem;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .thankyou-page-content {\n    flex: 1;\n\n    .main-heading {\n      color: var(--grey-dark);\n      font-family: ", " !important;\n      text-align: center;\n      font-size: 1.5rem;\n      font-weight: 600;\n      line-height: 1.813rem;\n    }\n\n    .body-content {\n      font-size: 0.875rem;\n      line-height: 1.25rem;\n      font-family: ", " !important;\n      font-weight: 600;\n      text-align: center;\n    }\n  }\n\n  @media (max-width: ", ") {\n    margin-top: 0px;\n    flex-direction: column;\n\n    .thankyou-page-content {\n      padding-right: 0px;\n      margin-bottom: 1.875rem;\n\n      .body-content {\n        font-size: 0.875rem;\n      }\n    }\n  }\n\n  .main-social-caption {\n    margin-top: 1rem;\n  }\n  .main-caption {\n    margin-top: 1rem;\n    margin-bottom: 0rem;\n  }\n"])), function (props) { return props.$titleFontType || 'var(--font-family-bold)'; }, function (props) { return props.$fontType || 'var(--font-family-medium)'; }, breakpoints.laptop);
var IconWithText$1 = defaultStyled.a(templateObject_2$u || (templateObject_2$u = __makeTemplateObject(["\n  text-align: center;\n  color: var(--white);\n  cursor: pointer;\n  padding-left: 0.625rem;\n  padding-right: 0.625rem;\n  transition: transform 0s cubic-bezier(0.23, 1, 0.32, 1) 0s;\n\n  ", "\n\n  ", "\n  \n    :hover {\n    transform: scale(1.075);\n  }\n"], ["\n  text-align: center;\n  color: var(--white);\n  cursor: pointer;\n  padding-left: 0.625rem;\n  padding-right: 0.625rem;\n  transition: transform 0s cubic-bezier(0.23, 1, 0.32, 1) 0s;\n\n  ", "\n\n  ", "\n  \n    :hover {\n    transform: scale(1.075);\n  }\n"])), function (_a) {
    var $fill = _a.$fill;
    return $fill &&
        "\n      & > svg path {\n        fill: var(--grey-dark);\n      }\n    ";
}, function (_a) {
    var $fill = _a.$fill;
    return !$fill &&
        "\n      & > svg path {\n        stroke: var(--grey-dark);\n      }\n    ";
});
var HighlightButton$1 = defaultStyled(Button)(templateObject_3$i || (templateObject_3$i = __makeTemplateObject(["\n  border-color: var(--grey-dark) !important;\n  border-radius: 40px;\n  min-width: 220px !important;\n  margin-top: 1rem;\n\n  span {\n    font-family: ", " !important;\n    font-size: 1rem !important;\n    color: var(--grey-dark) !important;\n  }\n\n  & > svg path {\n    stroke: var(--grey-dark);\n  }\n\n  :hover {\n    background: var(--grey-dark) !important;\n    border-color: var(--white) !important;\n\n    span {\n      font-family: ", " !important;\n      font-size: 1rem !important;\n      color: var(--white) !important;\n    }\n\n    & > svg path {\n      stroke: var(--white);\n    }\n  }\n"], ["\n  border-color: var(--grey-dark) !important;\n  border-radius: 40px;\n  min-width: 220px !important;\n  margin-top: 1rem;\n\n  span {\n    font-family: ", " !important;\n    font-size: 1rem !important;\n    color: var(--grey-dark) !important;\n  }\n\n  & > svg path {\n    stroke: var(--grey-dark);\n  }\n\n  :hover {\n    background: var(--grey-dark) !important;\n    border-color: var(--white) !important;\n\n    span {\n      font-family: ", " !important;\n      font-size: 1rem !important;\n      color: var(--white) !important;\n    }\n\n    & > svg path {\n      stroke: var(--white);\n    }\n  }\n"])), function (props) { return props.$fontType; }, function (props) { return props.$fontType; });
var templateObject_1$E, templateObject_2$u, templateObject_3$i;

var baseTrim = _baseTrim,
    isObject$4 = isObject_1,
    isSymbol$1 = isSymbol_1;

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$2(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol$1(value)) {
    return NAN;
  }
  if (isObject$4(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$4(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var toNumber_1 = toNumber$2;

var toNumber$1 = toNumber_1;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite$1(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber$1(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

var toFinite_1 = toFinite$1;

var toFinite = toFinite_1;

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger$5(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

var toInteger_1 = toInteger$5;

var root = _root,
    toInteger$4 = toInteger_1,
    toNumber = toNumber_1,
    toString$8 = toString_1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsFinite = root.isFinite,
    nativeMin = Math.min;

/**
 * Creates a function like `_.round`.
 *
 * @private
 * @param {string} methodName The name of the `Math` method to use when rounding.
 * @returns {Function} Returns the new round function.
 */
function createRound$1(methodName) {
  var func = Math[methodName];
  return function(number, precision) {
    number = toNumber(number);
    precision = precision == null ? 0 : nativeMin(toInteger$4(precision), 292);
    if (precision && nativeIsFinite(number)) {
      // Shift with exponential notation to avoid floating-point issues.
      // See [MDN](https://mdn.io/round#Examples) for more details.
      var pair = (toString$8(number) + 'e').split('e'),
          value = func(pair[0] + 'e' + (+pair[1] + precision));

      pair = (toString$8(value) + 'e').split('e');
      return +(pair[0] + 'e' + (+pair[1] - precision));
    }
    return func(number);
  };
}

var _createRound = createRound$1;

var createRound = _createRound;

/**
 * Computes `number` rounded to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round.
 * @param {number} [precision=0] The precision to round to.
 * @returns {number} Returns the rounded number.
 * @example
 *
 * _.round(4.006);
 * // => 4
 *
 * _.round(4.006, 2);
 * // => 4.01
 *
 * _.round(4060, -2);
 * // => 4100
 */
var round = createRound('round');

var round_1 = round;

var round$1 = /*@__PURE__*/getDefaultExportFromCjs(round_1);

var GeolocationOption = {
    enableHighAccuracy: false,
    timeout: 5000,
    maximumAge: 0
};
var useLocation = function (_a) {
    var _b = _a.isLocationVisible, isLocationVisible = _b === void 0 ? true : _b;
    console.log("Init gea location options, location visible: ".concat(isLocationVisible));
    var _c = useState({}), position = _c[0], setPosition = _c[1];
    var _d = useState(null), error = _d[0], setError = _d[1];
    var onChange = function (_a) {
        var coords = _a.coords;
        setPosition({
            latitude: round$1(coords.latitude, 2),
            longitude: round$1(coords.longitude, 2)
        });
    };
    var onError = function (error) {
        console.log("Error while retriving user's location", error);
        setError(error.message);
    };
    useEffect(function () {
        if (navigator && navigator.geolocation && isLocationVisible) {
            navigator.geolocation.getCurrentPosition(onChange, onError, GeolocationOption);
        }
    }, []);
    return { latLong: position, error: error };
};

var jsonRulesEngine = {};

var engine = {};

var fact = {};

var cjs = {};

Object.defineProperty(cjs, '__esModule', { value: true });

/**
 * based on string passed, get the integer hash value
 * through bitwise operation (based on spinoff of dbj2
 * with enhancements for reduced collisions)
 */
function hash(string) {
    var index = string.length;
    var hashA = 5381;
    var hashB = 52711;
    var charCode;
    while (index--) {
        charCode = string.charCodeAt(index);
        hashA = (hashA * 33) ^ charCode;
        hashB = (hashB * 33) ^ charCode;
    }
    return (hashA >>> 0) * 4096 + (hashB >>> 0);
}

var SEPARATOR = '|';
var XML_ELEMENT_REGEXP = /\[object ([HTML|SVG](.*)Element)\]/;
var CLASSES = {
    '[object Arguments]': 0,
    '[object Array]': 1,
    '[object ArrayBuffer]': 2,
    '[object AsyncFunction]': 3,
    '[object AsyncGeneratorFunction]': 4,
    '[object BigInt]': 5,
    '[object BigInt64Array]': 6,
    '[object BigUint64Array]': 7,
    '[object Boolean]': 8,
    '[object DataView]': 9,
    '[object Date]': 10,
    '[object DocumentFragment]': 11,
    '[object Error]': 12,
    '[object Event]': 13,
    '[object Float32Array]': 14,
    '[object Float64Array]': 15,
    '[object Function]': 16,
    '[object Generator]': 17,
    '[object GeneratorFunction]': 18,
    '[object Int8Array]': 19,
    '[object Int16Array]': 20,
    '[object Map]': 21,
    '[object Number]': 22,
    '[object Object]': 23,
    '[object Promise]': 24,
    '[object RegExp]': 25,
    '[object Set]': 26,
    '[object SharedArrayBuffer]': 27,
    '[object String]': 28,
    '[object Uint8Array]': 29,
    '[object Uint8ClampedArray]': 30,
    '[object Uint16Array]': 31,
    '[object Uint32Array]': 32,
    '[object WeakMap]': 33,
    '[object WeakRef]': 34,
    '[object WeakSet]': 35,
    CUSTOM: 36,
    ELEMENT: 37,
};
var ARRAY_LIKE_CLASSES = {
    '[object Arguments]': 1,
    '[object Array]': 2,
};
var NON_ENUMERABLE_CLASSES = {
    '[object Generator]': 1,
    '[object Promise]': 2,
    '[object WeakMap]': 3,
    '[object WeakRef]': 4,
    '[object WeakSet]': 5,
};
var PRIMITIVE_WRAPPER_CLASSES = {
    '[object AsyncFunction]': 1,
    '[object AsyncGeneratorFunction]': 2,
    '[object Boolean]': 3,
    '[object Function]': 4,
    '[object GeneratorFunction]': 5,
    '[object Number]': 6,
    '[object String]': 7,
};
var TYPED_ARRAY_CLASSES = {
    '[object BigInt64Array]': 1,
    '[object BigUint64Array]': 2,
    '[object Float32Array]': 3,
    '[object Float64Array]': 4,
    '[object Int8Array]': 5,
    '[object Int16Array]': 6,
    '[object Uint8Array]': 7,
    '[object Uint8ClampedArray]': 8,
    '[object Uint16Array]': 9,
    '[object Uint32Array]': 10,
};
var RECURSIVE_CLASSES = {
    '[object Arguments]': 1,
    '[object Array]': 2,
    '[object ArrayBuffer]': 3,
    '[object BigInt64Array]': 4,
    '[object BigUint64Array]': 5,
    '[object DataView]': 6,
    '[object Float32Array]': 7,
    '[object Float64Array]': 8,
    '[object Int8Array]': 9,
    '[object Int16Array]': 10,
    '[object Map]': 11,
    '[object Object]': 12,
    '[object Set]': 13,
    '[object SharedArrayBuffer]': 14,
    '[object Uint8Array]': 15,
    '[object Uint8ClampedArray]': 16,
    '[object Uint16Array]': 17,
    '[object Uint32Array]': 18,
    CUSTOM: 19,
};
var HASHABLE_TYPES = {
    bigint: 'i',
    boolean: 'b',
    empty: 'e',
    function: 'g',
    number: 'n',
    object: 'o',
    string: 's',
    symbol: 's',
};

function sortByKey(first, second) {
    return first[0] > second[0];
}
function sortBySelf(first, second) {
    return first > second;
}
function sort(array, fn) {
    var subIndex;
    var value;
    for (var index = 0; index < array.length; ++index) {
        value = array[index];
        for (subIndex = index - 1; ~subIndex && fn(array[subIndex], value); --subIndex) {
            array[subIndex + 1] = array[subIndex];
        }
        array[subIndex + 1] = value;
    }
    return array;
}

function namespaceComplexValue(classType, value) {
    return (HASHABLE_TYPES.object + SEPARATOR + CLASSES[classType] + SEPARATOR + value);
}

var NON_ENUMERABLE_CLASS_CACHE = new WeakMap();
var refId = 0;
function getUnsupportedHash(value, classType) {
    var cached = NON_ENUMERABLE_CLASS_CACHE.get(value);
    if (cached) {
        return cached;
    }
    var toCache = namespaceComplexValue(classType, 'NOT_ENUMERABLE' + SEPARATOR + refId++);
    NON_ENUMERABLE_CLASS_CACHE.set(value, toCache);
    return toCache;
}

var toString$7 = Object.prototype.toString;
function stringifyComplexType(value, classType, state) {
    if (RECURSIVE_CLASSES[classType]) {
        return stringifyRecursiveAsJson(classType, value, state);
    }
    if (classType === '[object Date]') {
        return namespaceComplexValue(classType, value.getTime());
    }
    if (classType === '[object RegExp]') {
        return namespaceComplexValue(classType, value.toString());
    }
    if (classType === '[object Event]') {
        return namespaceComplexValue(classType, [
            value.bubbles,
            value.cancelBubble,
            value.cancelable,
            value.composed,
            value.currentTarget,
            value.defaultPrevented,
            value.eventPhase,
            value.isTrusted,
            value.returnValue,
            value.target,
            value.type,
        ].join());
    }
    if (classType === '[object Error]') {
        return namespaceComplexValue(classType, value.message + SEPARATOR + value.stack);
    }
    if (classType === '[object DocumentFragment]') {
        return namespaceComplexValue(classType, stringifyDocumentFragment(value));
    }
    var element = classType.match(XML_ELEMENT_REGEXP);
    if (element) {
        return namespaceComplexValue('ELEMENT', element[1] + SEPARATOR + value.outerHTML);
    }
    if (NON_ENUMERABLE_CLASSES[classType]) {
        return getUnsupportedHash(value, classType);
    }
    if (PRIMITIVE_WRAPPER_CLASSES[classType]) {
        return namespaceComplexValue(classType, value.toString());
    }
    // This would only be hit with custom `toStringTag` values
    return stringifyRecursiveAsJson('CUSTOM', value, state);
}
function stringifyRecursiveAsJson(classType, value, state) {
    var cached = state.cache.get(value);
    if (cached) {
        return namespaceComplexValue(classType, 'RECURSIVE~' + cached);
    }
    state.cache.set(value, ++state.id);
    if (classType === '[object Object]') {
        return value[Symbol.iterator]
            ? getUnsupportedHash(value, classType)
            : namespaceComplexValue(classType, stringifyObject(value, state));
    }
    if (ARRAY_LIKE_CLASSES[classType]) {
        return namespaceComplexValue(classType, stringifyArray(value, state));
    }
    if (classType === '[object Map]') {
        return namespaceComplexValue(classType, stringifyMap(value, state));
    }
    if (classType === '[object Set]') {
        return namespaceComplexValue(classType, stringifySet(value, state));
    }
    if (TYPED_ARRAY_CLASSES[classType]) {
        return namespaceComplexValue(classType, value.join());
    }
    if (classType === '[object ArrayBuffer]') {
        return namespaceComplexValue(classType, stringifyArrayBuffer(value));
    }
    if (classType === '[object DataView]') {
        return namespaceComplexValue(classType, stringifyArrayBuffer(value.buffer));
    }
    if (NON_ENUMERABLE_CLASSES[classType]) {
        return getUnsupportedHash(value, classType);
    }
    return namespaceComplexValue('CUSTOM', stringifyObject(value, state));
}
function stringifyArray(value, state) {
    var index = value.length;
    var result = new Array(index);
    while (--index >= 0) {
        result[index] = stringify(value[index], state);
    }
    return result.join();
}
function stringifyArrayBufferModern(buffer) {
    return Buffer.from(buffer).toString('utf8');
}
function stringifyArrayBufferFallback(buffer) {
    return String.fromCharCode.apply(null, new Uint16Array(buffer));
}
function stringifyArrayBufferNone() {
    return 'UNSUPPORTED';
}
function stringifyDocumentFragment(fragment) {
    var children = fragment.children;
    var index = children.length;
    var innerHTML = new Array(index);
    while (--index >= 0) {
        innerHTML[index] = children[index].outerHTML;
    }
    return innerHTML.join();
}
var stringifyArrayBuffer = typeof Buffer !== 'undefined' && typeof Buffer.from === 'function'
    ? stringifyArrayBufferModern
    : typeof Uint16Array === 'function'
        ? stringifyArrayBufferFallback
        : stringifyArrayBufferNone;
function stringifyMap(map, state) {
    var result = new Array(map.size);
    var index = 0;
    map.forEach(function (value, key) {
        result[index++] = [stringify(key, state), stringify(value, state)];
    });
    sort(result, sortByKey);
    while (--index >= 0) {
        result[index] = '[' + result[index][0] + ',' + result[index][1] + ']';
    }
    return '[' + result.join() + ']';
}
function stringifyObject(value, state) {
    var properties = sort(Object.getOwnPropertyNames(value), sortBySelf);
    var length = properties.length;
    var result = new Array(length);
    var index = length;
    while (--index >= 0) {
        result[index] =
            properties[index] + ':' + stringify(value[properties[index]], state);
    }
    return '{' + result.join() + '}';
}
function stringifySet(set, state) {
    var result = new Array(set.size);
    var index = 0;
    set.forEach(function (value) {
        result[index++] = stringify(value, state);
    });
    return '[' + sort(result, sortBySelf).join() + ']';
}
function stringify(value, state) {
    var type = typeof value;
    if (value == null || type === 'undefined') {
        return HASHABLE_TYPES.empty + value;
    }
    if (type === 'object') {
        return stringifyComplexType(value, toString$7.call(value), state || { cache: new WeakMap(), id: 1 });
    }
    if (type === 'function' || type === 'symbol') {
        return HASHABLE_TYPES[type] + value.toString();
    }
    if (type === 'boolean') {
        return HASHABLE_TYPES.boolean + +value;
    }
    return HASHABLE_TYPES[type] + value;
}

function hashIt(value) {
    return hash(stringify(value, undefined));
}

cjs.default = hashIt;

Object.defineProperty(fact, "__esModule", {
  value: true
});

var _createClass$s = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _hashIt = cjs;

var _hashIt2 = _interopRequireDefault$H(_hashIt);

function _interopRequireDefault$H(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$A(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Fact = function () {
  /**
   * Returns a new fact instance
   * @param  {string} id - fact unique identifer
   * @param  {object} options
   * @param  {boolean} options.cache - whether to cache the fact's value for future rules
   * @param  {primitive|function} valueOrMethod - constant primitive, or method to call when computing the fact's value
   * @return {Fact}
   */
  function Fact(id, valueOrMethod, options) {
    _classCallCheck$A(this, Fact);

    this.id = id;
    var defaultOptions = { cache: true };
    if (typeof options === 'undefined') {
      options = defaultOptions;
    }
    if (typeof valueOrMethod !== 'function') {
      this.value = valueOrMethod;
      this.type = this.constructor.CONSTANT;
    } else {
      this.calculationMethod = valueOrMethod;
      this.type = this.constructor.DYNAMIC;
    }

    if (!this.id) throw new Error('factId required');

    this.priority = parseInt(options.priority || 1, 10);
    this.options = Object.assign({}, defaultOptions, options);
    this.cacheKeyMethod = this.defaultCacheKeys;
    return this;
  }

  _createClass$s(Fact, [{
    key: 'isConstant',
    value: function isConstant() {
      return this.type === this.constructor.CONSTANT;
    }
  }, {
    key: 'isDynamic',
    value: function isDynamic() {
      return this.type === this.constructor.DYNAMIC;
    }

    /**
     * Return the fact value, based on provided parameters
     * @param  {object} params
     * @param  {Almanac} almanac
     * @return {any} calculation method results
     */

  }, {
    key: 'calculate',
    value: function calculate(params, almanac) {
      // if constant fact w/set value, return immediately
      if (Object.prototype.hasOwnProperty.call(this, 'value')) {
        return this.value;
      }
      return this.calculationMethod(params, almanac);
    }

    /**
     * Return a cache key (MD5 string) based on parameters
     * @param  {object} obj - properties to generate a hash key from
     * @return {string} MD5 string based on the hash'd object
     */

  }, {
    key: 'defaultCacheKeys',


    /**
     * Default properties to use when caching a fact
     * Assumes every fact is a pure function, whose computed value will only
     * change when input params are modified
     * @param  {string} id - fact unique identifer
     * @param  {object} params - parameters passed to fact calcution method
     * @return {object} id + params
     */
    value: function defaultCacheKeys(id, params) {
      return { params: params, id: id };
    }

    /**
     * Generates the fact's cache key(MD5 string)
     * Returns nothing if the fact's caching has been disabled
     * @param  {object} params - parameters that would be passed to the computation method
     * @return {string} cache key
     */

  }, {
    key: 'getCacheKey',
    value: function getCacheKey(params) {
      if (this.options.cache === true) {
        var cacheProperties = this.cacheKeyMethod(this.id, params);
        var _hash = Fact.hashFromObject(cacheProperties);
        return _hash;
      }
    }
  }], [{
    key: 'hashFromObject',
    value: function hashFromObject(obj) {
      return (0, _hashIt2.default)(obj);
    }
  }]);

  return Fact;
}();

Fact.CONSTANT = 'CONSTANT';
Fact.DYNAMIC = 'DYNAMIC';

fact.default = Fact;

var rule = {};

var condition = {};

var debug$1 = {};

Object.defineProperty(debug$1, "__esModule", {
  value: true
});
debug$1.default = debug;
function debug(message) {
  try {
    if (typeof process !== 'undefined' && process.env && process.env.DEBUG && process.env.DEBUG.match(/json-rules-engine/) || typeof window !== 'undefined' && window.localStorage && window.localStorage.debug && window.localStorage.debug.match(/json-rules-engine/)) {
      console.log(message);
    }
  } catch (ex) {
    // Do nothing
  }
}

Object.defineProperty(condition, "__esModule", {
  value: true
});

var _slicedToArray$1 = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass$r = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _debug$3 = debug$1;

var _debug2$3 = _interopRequireDefault$G(_debug$3);

function _interopRequireDefault$G(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$z(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Condition = function () {
  function Condition(properties) {
    _classCallCheck$z(this, Condition);

    if (!properties) throw new Error('Condition: constructor options required');
    var booleanOperator = Condition.booleanOperator(properties);
    Object.assign(this, properties);
    if (booleanOperator) {
      var subConditions = properties[booleanOperator];
      var subConditionsIsArray = Array.isArray(subConditions);
      if (booleanOperator !== 'not' && !subConditionsIsArray) {
        throw new Error('"' + booleanOperator + '" must be an array');
      }
      if (booleanOperator === 'not' && subConditionsIsArray) {
        throw new Error('"' + booleanOperator + '" cannot be an array');
      }
      this.operator = booleanOperator;
      // boolean conditions always have a priority; default 1
      this.priority = parseInt(properties.priority, 10) || 1;
      if (subConditionsIsArray) {
        this[booleanOperator] = subConditions.map(function (c) {
          return new Condition(c);
        });
      } else {
        this[booleanOperator] = new Condition(subConditions);
      }
    } else if (!Object.prototype.hasOwnProperty.call(properties, 'condition')) {
      if (!Object.prototype.hasOwnProperty.call(properties, 'fact')) {
        throw new Error('Condition: constructor "fact" property required');
      }
      if (!Object.prototype.hasOwnProperty.call(properties, 'operator')) {
        throw new Error('Condition: constructor "operator" property required');
      }
      if (!Object.prototype.hasOwnProperty.call(properties, 'value')) {
        throw new Error('Condition: constructor "value" property required');
      }

      // a non-boolean condition does not have a priority by default. this allows
      // priority to be dictated by the fact definition
      if (Object.prototype.hasOwnProperty.call(properties, 'priority')) {
        properties.priority = parseInt(properties.priority, 10);
      }
    }
  }

  /**
   * Converts the condition into a json-friendly structure
   * @param   {Boolean} stringify - whether to return as a json string
   * @returns {string,object} json string or json-friendly object
   */


  _createClass$r(Condition, [{
    key: 'toJSON',
    value: function toJSON() {
      var stringify = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      var props = {};
      if (this.priority) {
        props.priority = this.priority;
      }
      if (this.name) {
        props.name = this.name;
      }
      var oper = Condition.booleanOperator(this);
      if (oper) {
        if (Array.isArray(this[oper])) {
          props[oper] = this[oper].map(function (c) {
            return c.toJSON(false);
          });
        } else {
          props[oper] = this[oper].toJSON(false);
        }
      } else if (this.isConditionReference()) {
        props.condition = this.condition;
      } else {
        props.operator = this.operator;
        props.value = this.value;
        props.fact = this.fact;
        if (this.factResult !== undefined) {
          props.factResult = this.factResult;
        }
        if (this.result !== undefined) {
          props.result = this.result;
        }
        if (this.params) {
          props.params = this.params;
        }
        if (this.path) {
          props.path = this.path;
        }
      }
      if (stringify) {
        return JSON.stringify(props);
      }
      return props;
    }

    /**
     * Takes the fact result and compares it to the condition 'value', using the operator
     *   LHS                      OPER       RHS
     * <fact + params + path>  <operator>  <value>
     *
     * @param   {Almanac} almanac
     * @param   {Map} operatorMap - map of available operators, keyed by operator name
     * @returns {Boolean} - evaluation result
     */

  }, {
    key: 'evaluate',
    value: function evaluate(almanac, operatorMap) {
      var _this = this;

      if (!almanac) return Promise.reject(new Error('almanac required'));
      if (!operatorMap) return Promise.reject(new Error('operatorMap required'));
      if (this.isBooleanOperator()) {
        return Promise.reject(new Error('Cannot evaluate() a boolean condition'));
      }

      var op = operatorMap.get(this.operator);
      if (!op) {
        return Promise.reject(new Error('Unknown operator: ' + this.operator));
      }

      return Promise.all([almanac.getValue(this.value), almanac.factValue(this.fact, this.params, this.path)]).then(function (_ref) {
        var _ref2 = _slicedToArray$1(_ref, 2),
            rightHandSideValue = _ref2[0],
            leftHandSideValue = _ref2[1];

        var result = op.evaluate(leftHandSideValue, rightHandSideValue);
        (0, _debug2$3.default)('condition::evaluate <' + JSON.stringify(leftHandSideValue) + ' ' + _this.operator + ' ' + JSON.stringify(rightHandSideValue) + '?> (' + result + ')');
        return {
          result: result,
          leftHandSideValue: leftHandSideValue,
          rightHandSideValue: rightHandSideValue,
          operator: _this.operator
        };
      });
    }

    /**
     * Returns the boolean operator for the condition
     * If the condition is not a boolean condition, the result will be 'undefined'
     * @return {string 'all', 'any', or 'not'}
     */

  }, {
    key: 'booleanOperator',


    /**
     * Returns the condition's boolean operator
     * Instance version of Condition.isBooleanOperator
     * @returns {string,undefined} - 'any', 'all', 'not' or undefined (if not a boolean condition)
     */
    value: function booleanOperator() {
      return Condition.booleanOperator(this);
    }

    /**
     * Whether the operator is boolean ('all', 'any', 'not')
     * @returns {Boolean}
     */

  }, {
    key: 'isBooleanOperator',
    value: function isBooleanOperator() {
      return Condition.booleanOperator(this) !== undefined;
    }

    /**
     * Whether the condition represents a reference to a condition
     * @returns {Boolean}
     */

  }, {
    key: 'isConditionReference',
    value: function isConditionReference() {
      return Object.prototype.hasOwnProperty.call(this, 'condition');
    }
  }], [{
    key: 'booleanOperator',
    value: function booleanOperator(condition) {
      if (Object.prototype.hasOwnProperty.call(condition, 'any')) {
        return 'any';
      } else if (Object.prototype.hasOwnProperty.call(condition, 'all')) {
        return 'all';
      } else if (Object.prototype.hasOwnProperty.call(condition, 'not')) {
        return 'not';
      }
    }
  }]);

  return Condition;
}();

condition.default = Condition;

var ruleResult = {};

var clone = {exports: {}};

(function (module) {
	var clone = (function() {

	function _instanceof(obj, type) {
	  return type != null && obj instanceof type;
	}

	var nativeMap;
	try {
	  nativeMap = Map;
	} catch(_) {
	  // maybe a reference error because no `Map`. Give it a dummy value that no
	  // value will ever be an instanceof.
	  nativeMap = function() {};
	}

	var nativeSet;
	try {
	  nativeSet = Set;
	} catch(_) {
	  nativeSet = function() {};
	}

	var nativePromise;
	try {
	  nativePromise = Promise;
	} catch(_) {
	  nativePromise = function() {};
	}

	/**
	 * Clones (copies) an Object using deep copying.
	 *
	 * This function supports circular references by default, but if you are certain
	 * there are no circular references in your object, you can save some CPU time
	 * by calling clone(obj, false).
	 *
	 * Caution: if `circular` is false and `parent` contains circular references,
	 * your program may enter an infinite loop and crash.
	 *
	 * @param `parent` - the object to be cloned
	 * @param `circular` - set to true if the object to be cloned may contain
	 *    circular references. (optional - true by default)
	 * @param `depth` - set to a number if the object is only to be cloned to
	 *    a particular depth. (optional - defaults to Infinity)
	 * @param `prototype` - sets the prototype to be used when cloning an object.
	 *    (optional - defaults to parent prototype).
	 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
	 *    should be cloned as well. Non-enumerable properties on the prototype
	 *    chain will be ignored. (optional - false by default)
	*/
	function clone(parent, circular, depth, prototype, includeNonEnumerable) {
	  if (typeof circular === 'object') {
	    depth = circular.depth;
	    prototype = circular.prototype;
	    includeNonEnumerable = circular.includeNonEnumerable;
	    circular = circular.circular;
	  }
	  // maintain two arrays for circular references, where corresponding parents
	  // and children have the same index
	  var allParents = [];
	  var allChildren = [];

	  var useBuffer = typeof Buffer != 'undefined';

	  if (typeof circular == 'undefined')
	    circular = true;

	  if (typeof depth == 'undefined')
	    depth = Infinity;

	  // recurse this function so we don't reset allParents and allChildren
	  function _clone(parent, depth) {
	    // cloning null always returns null
	    if (parent === null)
	      return null;

	    if (depth === 0)
	      return parent;

	    var child;
	    var proto;
	    if (typeof parent != 'object') {
	      return parent;
	    }

	    if (_instanceof(parent, nativeMap)) {
	      child = new nativeMap();
	    } else if (_instanceof(parent, nativeSet)) {
	      child = new nativeSet();
	    } else if (_instanceof(parent, nativePromise)) {
	      child = new nativePromise(function (resolve, reject) {
	        parent.then(function(value) {
	          resolve(_clone(value, depth - 1));
	        }, function(err) {
	          reject(_clone(err, depth - 1));
	        });
	      });
	    } else if (clone.__isArray(parent)) {
	      child = [];
	    } else if (clone.__isRegExp(parent)) {
	      child = new RegExp(parent.source, __getRegExpFlags(parent));
	      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
	    } else if (clone.__isDate(parent)) {
	      child = new Date(parent.getTime());
	    } else if (useBuffer && Buffer.isBuffer(parent)) {
	      if (Buffer.allocUnsafe) {
	        // Node.js >= 4.5.0
	        child = Buffer.allocUnsafe(parent.length);
	      } else {
	        // Older Node.js versions
	        child = new Buffer(parent.length);
	      }
	      parent.copy(child);
	      return child;
	    } else if (_instanceof(parent, Error)) {
	      child = Object.create(parent);
	    } else {
	      if (typeof prototype == 'undefined') {
	        proto = Object.getPrototypeOf(parent);
	        child = Object.create(proto);
	      }
	      else {
	        child = Object.create(prototype);
	        proto = prototype;
	      }
	    }

	    if (circular) {
	      var index = allParents.indexOf(parent);

	      if (index != -1) {
	        return allChildren[index];
	      }
	      allParents.push(parent);
	      allChildren.push(child);
	    }

	    if (_instanceof(parent, nativeMap)) {
	      parent.forEach(function(value, key) {
	        var keyChild = _clone(key, depth - 1);
	        var valueChild = _clone(value, depth - 1);
	        child.set(keyChild, valueChild);
	      });
	    }
	    if (_instanceof(parent, nativeSet)) {
	      parent.forEach(function(value) {
	        var entryChild = _clone(value, depth - 1);
	        child.add(entryChild);
	      });
	    }

	    for (var i in parent) {
	      var attrs;
	      if (proto) {
	        attrs = Object.getOwnPropertyDescriptor(proto, i);
	      }

	      if (attrs && attrs.set == null) {
	        continue;
	      }
	      child[i] = _clone(parent[i], depth - 1);
	    }

	    if (Object.getOwnPropertySymbols) {
	      var symbols = Object.getOwnPropertySymbols(parent);
	      for (var i = 0; i < symbols.length; i++) {
	        // Don't need to worry about cloning a symbol because it is a primitive,
	        // like a number or string.
	        var symbol = symbols[i];
	        var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
	        if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
	          continue;
	        }
	        child[symbol] = _clone(parent[symbol], depth - 1);
	        if (!descriptor.enumerable) {
	          Object.defineProperty(child, symbol, {
	            enumerable: false
	          });
	        }
	      }
	    }

	    if (includeNonEnumerable) {
	      var allPropertyNames = Object.getOwnPropertyNames(parent);
	      for (var i = 0; i < allPropertyNames.length; i++) {
	        var propertyName = allPropertyNames[i];
	        var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
	        if (descriptor && descriptor.enumerable) {
	          continue;
	        }
	        child[propertyName] = _clone(parent[propertyName], depth - 1);
	        Object.defineProperty(child, propertyName, {
	          enumerable: false
	        });
	      }
	    }

	    return child;
	  }

	  return _clone(parent, depth);
	}

	/**
	 * Simple flat clone using prototype, accepts only objects, usefull for property
	 * override on FLAT configuration object (no nested props).
	 *
	 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
	 * works.
	 */
	clone.clonePrototype = function clonePrototype(parent) {
	  if (parent === null)
	    return null;

	  var c = function () {};
	  c.prototype = parent;
	  return new c();
	};

	// private utility functions

	function __objToStr(o) {
	  return Object.prototype.toString.call(o);
	}
	clone.__objToStr = __objToStr;

	function __isDate(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Date]';
	}
	clone.__isDate = __isDate;

	function __isArray(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Array]';
	}
	clone.__isArray = __isArray;

	function __isRegExp(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
	}
	clone.__isRegExp = __isRegExp;

	function __getRegExpFlags(re) {
	  var flags = '';
	  if (re.global) flags += 'g';
	  if (re.ignoreCase) flags += 'i';
	  if (re.multiline) flags += 'm';
	  return flags;
	}
	clone.__getRegExpFlags = __getRegExpFlags;

	return clone;
	})();

	if (module.exports) {
	  module.exports = clone;
	} 
} (clone));

var cloneExports = clone.exports;

/**
 * lodash 4.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$3(value) {
  return !!value && typeof value == 'object';
}

var lodash_isobjectlike = isObjectLike$3;

Object.defineProperty(ruleResult, "__esModule", {
  value: true
});

var _createClass$q = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clone$1 = cloneExports;

var _clone2$1 = _interopRequireDefault$F(_clone$1);

var _lodash$1 = lodash_isobjectlike;

var _lodash2$1 = _interopRequireDefault$F(_lodash$1);

function _interopRequireDefault$F(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$y(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RuleResult = function () {
  function RuleResult(conditions, event, priority, name) {
    _classCallCheck$y(this, RuleResult);

    this.conditions = (0, _clone2$1.default)(conditions);
    this.event = (0, _clone2$1.default)(event);
    this.priority = (0, _clone2$1.default)(priority);
    this.name = (0, _clone2$1.default)(name);
    this.result = null;
  }

  _createClass$q(RuleResult, [{
    key: 'setResult',
    value: function setResult(result) {
      this.result = result;
    }
  }, {
    key: 'resolveEventParams',
    value: function resolveEventParams(almanac) {
      var _this = this;

      if ((0, _lodash2$1.default)(this.event.params)) {
        var updates = [];

        var _loop = function _loop(key) {
          if (Object.prototype.hasOwnProperty.call(_this.event.params, key)) {
            updates.push(almanac.getValue(_this.event.params[key]).then(function (val) {
              return _this.event.params[key] = val;
            }));
          }
        };

        for (var key in this.event.params) {
          _loop(key);
        }
        return Promise.all(updates);
      }
      return Promise.resolve();
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      var stringify = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      var props = {
        conditions: this.conditions.toJSON(false),
        event: this.event,
        priority: this.priority,
        name: this.name,
        result: this.result
      };
      if (stringify) {
        return JSON.stringify(props);
      }
      return props;
    }
  }]);

  return RuleResult;
}();

ruleResult.default = RuleResult;

var eventemitter2 = {exports: {}};

/*!
 * EventEmitter2
 * https://github.com/hij1nx/EventEmitter2
 *
 * Copyright (c) 2013 hij1nx
 * Licensed under the MIT license.
 */

(function (module, exports) {
!function(undefined$1) {
	  var hasOwnProperty= Object.hasOwnProperty;
	  var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
	    return Object.prototype.toString.call(obj) === "[object Array]";
	  };
	  var defaultMaxListeners = 10;
	  var nextTickSupported= typeof process=='object' && typeof process.nextTick=='function';
	  var symbolsSupported= typeof Symbol==='function';
	  var reflectSupported= typeof Reflect === 'object';
	  var setImmediateSupported= typeof setImmediate === 'function';
	  var _setImmediate= setImmediateSupported ? setImmediate : setTimeout;
	  var ownKeys= symbolsSupported? (reflectSupported && typeof Reflect.ownKeys==='function'? Reflect.ownKeys : function(obj){
	    var arr= Object.getOwnPropertyNames(obj);
	    arr.push.apply(arr, Object.getOwnPropertySymbols(obj));
	    return arr;
	  }) : Object.keys;

	  function init() {
	    this._events = {};
	    if (this._conf) {
	      configure.call(this, this._conf);
	    }
	  }

	  function configure(conf) {
	    if (conf) {
	      this._conf = conf;

	      conf.delimiter && (this.delimiter = conf.delimiter);

	      if(conf.maxListeners!==undefined$1){
	          this._maxListeners= conf.maxListeners;
	      }

	      conf.wildcard && (this.wildcard = conf.wildcard);
	      conf.newListener && (this._newListener = conf.newListener);
	      conf.removeListener && (this._removeListener = conf.removeListener);
	      conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
	      conf.ignoreErrors && (this.ignoreErrors = conf.ignoreErrors);

	      if (this.wildcard) {
	        this.listenerTree = {};
	      }
	    }
	  }

	  function logPossibleMemoryLeak(count, eventName) {
	    var errorMsg = '(node) warning: possible EventEmitter memory ' +
	        'leak detected. ' + count + ' listeners added. ' +
	        'Use emitter.setMaxListeners() to increase limit.';

	    if(this.verboseMemoryLeak){
	      errorMsg += ' Event name: ' + eventName + '.';
	    }

	    if(typeof process !== 'undefined' && process.emitWarning){
	      var e = new Error(errorMsg);
	      e.name = 'MaxListenersExceededWarning';
	      e.emitter = this;
	      e.count = count;
	      process.emitWarning(e);
	    } else {
	      console.error(errorMsg);

	      if (console.trace){
	        console.trace();
	      }
	    }
	  }

	  var toArray = function (a, b, c) {
	    var n = arguments.length;
	    switch (n) {
	      case 0:
	        return [];
	      case 1:
	        return [a];
	      case 2:
	        return [a, b];
	      case 3:
	        return [a, b, c];
	      default:
	        var arr = new Array(n);
	        while (n--) {
	          arr[n] = arguments[n];
	        }
	        return arr;
	    }
	  };

	  function toObject(keys, values) {
	    var obj = {};
	    var key;
	    var len = keys.length;
	    var valuesCount = values ? values.length : 0;
	    for (var i = 0; i < len; i++) {
	      key = keys[i];
	      obj[key] = i < valuesCount ? values[i] : undefined$1;
	    }
	    return obj;
	  }

	  function TargetObserver(emitter, target, options) {
	    this._emitter = emitter;
	    this._target = target;
	    this._listeners = {};
	    this._listenersCount = 0;

	    var on, off;

	    if (options.on || options.off) {
	      on = options.on;
	      off = options.off;
	    }

	    if (target.addEventListener) {
	      on = target.addEventListener;
	      off = target.removeEventListener;
	    } else if (target.addListener) {
	      on = target.addListener;
	      off = target.removeListener;
	    } else if (target.on) {
	      on = target.on;
	      off = target.off;
	    }

	    if (!on && !off) {
	      throw Error('target does not implement any known event API');
	    }

	    if (typeof on !== 'function') {
	      throw TypeError('on method must be a function');
	    }

	    if (typeof off !== 'function') {
	      throw TypeError('off method must be a function');
	    }

	    this._on = on;
	    this._off = off;

	    var _observers= emitter._observers;
	    if(_observers){
	      _observers.push(this);
	    }else {
	      emitter._observers= [this];
	    }
	  }

	  Object.assign(TargetObserver.prototype, {
	    subscribe: function(event, localEvent, reducer){
	      var observer= this;
	      var target= this._target;
	      var emitter= this._emitter;
	      var listeners= this._listeners;
	      var handler= function(){
	        var args= toArray.apply(null, arguments);
	        var eventObj= {
	          data: args,
	          name: localEvent,
	          original: event
	        };
	        if(reducer){
	          var result= reducer.call(target, eventObj);
	          if(result!==false){
	            emitter.emit.apply(emitter, [eventObj.name].concat(args));
	          }
	          return;
	        }
	        emitter.emit.apply(emitter, [localEvent].concat(args));
	      };


	      if(listeners[event]){
	        throw Error('Event \'' + event + '\' is already listening');
	      }

	      this._listenersCount++;

	      if(emitter._newListener && emitter._removeListener && !observer._onNewListener){

	        this._onNewListener = function (_event) {
	          if (_event === localEvent && listeners[event] === null) {
	            listeners[event] = handler;
	            observer._on.call(target, event, handler);
	          }
	        };

	        emitter.on('newListener', this._onNewListener);

	        this._onRemoveListener= function(_event){
	          if(_event === localEvent && !emitter.hasListeners(_event) && listeners[event]){
	            listeners[event]= null;
	            observer._off.call(target, event, handler);
	          }
	        };

	        listeners[event]= null;

	        emitter.on('removeListener', this._onRemoveListener);
	      }else {
	        listeners[event]= handler;
	        observer._on.call(target, event, handler);
	      }
	    },

	    unsubscribe: function(event){
	      var observer= this;
	      var listeners= this._listeners;
	      var emitter= this._emitter;
	      var handler;
	      var events;
	      var off= this._off;
	      var target= this._target;
	      var i;

	      if(event && typeof event!=='string'){
	        throw TypeError('event must be a string');
	      }

	      function clearRefs(){
	        if(observer._onNewListener){
	          emitter.off('newListener', observer._onNewListener);
	          emitter.off('removeListener', observer._onRemoveListener);
	          observer._onNewListener= null;
	          observer._onRemoveListener= null;
	        }
	        var index= findTargetIndex.call(emitter, observer);
	        emitter._observers.splice(index, 1);
	      }

	      if(event){
	        handler= listeners[event];
	        if(!handler) return;
	        off.call(target, event, handler);
	        delete listeners[event];
	        if(!--this._listenersCount){
	          clearRefs();
	        }
	      }else {
	        events= ownKeys(listeners);
	        i= events.length;
	        while(i-->0){
	          event= events[i];
	          off.call(target, event, listeners[event]);
	        }
	        this._listeners= {};
	        this._listenersCount= 0;
	        clearRefs();
	      }
	    }
	  });

	  function resolveOptions(options, schema, reducers, allowUnknown) {
	    var computedOptions = Object.assign({}, schema);

	    if (!options) return computedOptions;

	    if (typeof options !== 'object') {
	      throw TypeError('options must be an object')
	    }

	    var keys = Object.keys(options);
	    var length = keys.length;
	    var option, value;
	    var reducer;

	    function reject(reason) {
	      throw Error('Invalid "' + option + '" option value' + (reason ? '. Reason: ' + reason : ''))
	    }

	    for (var i = 0; i < length; i++) {
	      option = keys[i];
	      if (!allowUnknown && !hasOwnProperty.call(schema, option)) {
	        throw Error('Unknown "' + option + '" option');
	      }
	      value = options[option];
	      if (value !== undefined$1) {
	        reducer = reducers[option];
	        computedOptions[option] = reducer ? reducer(value, reject) : value;
	      }
	    }
	    return computedOptions;
	  }

	  function constructorReducer(value, reject) {
	    if (typeof value !== 'function' || !value.hasOwnProperty('prototype')) {
	      reject('value must be a constructor');
	    }
	    return value;
	  }

	  function makeTypeReducer(types) {
	    var message= 'value must be type of ' + types.join('|');
	    var len= types.length;
	    var firstType= types[0];
	    var secondType= types[1];

	    if (len === 1) {
	      return function (v, reject) {
	        if (typeof v === firstType) {
	          return v;
	        }
	        reject(message);
	      }
	    }

	    if (len === 2) {
	      return function (v, reject) {
	        var kind= typeof v;
	        if (kind === firstType || kind === secondType) return v;
	        reject(message);
	      }
	    }

	    return function (v, reject) {
	      var kind = typeof v;
	      var i = len;
	      while (i-- > 0) {
	        if (kind === types[i]) return v;
	      }
	      reject(message);
	    }
	  }

	  var functionReducer= makeTypeReducer(['function']);

	  var objectFunctionReducer= makeTypeReducer(['object', 'function']);

	  function makeCancelablePromise(Promise, executor, options) {
	    var isCancelable;
	    var callbacks;
	    var timer= 0;
	    var subscriptionClosed;

	    var promise = new Promise(function (resolve, reject, onCancel) {
	      options= resolveOptions(options, {
	        timeout: 0,
	        overload: false
	      }, {
	        timeout: function(value, reject){
	          value*= 1;
	          if (typeof value !== 'number' || value < 0 || !Number.isFinite(value)) {
	            reject('timeout must be a positive number');
	          }
	          return value;
	        }
	      });

	      isCancelable = !options.overload && typeof Promise.prototype.cancel === 'function' && typeof onCancel === 'function';

	      function cleanup() {
	        if (callbacks) {
	          callbacks = null;
	        }
	        if (timer) {
	          clearTimeout(timer);
	          timer = 0;
	        }
	      }

	      var _resolve= function(value){
	        cleanup();
	        resolve(value);
	      };

	      var _reject= function(err){
	        cleanup();
	        reject(err);
	      };

	      if (isCancelable) {
	        executor(_resolve, _reject, onCancel);
	      } else {
	        callbacks = [function(reason){
	          _reject(reason || Error('canceled'));
	        }];
	        executor(_resolve, _reject, function (cb) {
	          if (subscriptionClosed) {
	            throw Error('Unable to subscribe on cancel event asynchronously')
	          }
	          if (typeof cb !== 'function') {
	            throw TypeError('onCancel callback must be a function');
	          }
	          callbacks.push(cb);
	        });
	        subscriptionClosed= true;
	      }

	      if (options.timeout > 0) {
	        timer= setTimeout(function(){
	          var reason= Error('timeout');
	          reason.code = 'ETIMEDOUT';
	          timer= 0;
	          promise.cancel(reason);
	          reject(reason);
	        }, options.timeout);
	      }
	    });

	    if (!isCancelable) {
	      promise.cancel = function (reason) {
	        if (!callbacks) {
	          return;
	        }
	        var length = callbacks.length;
	        for (var i = 1; i < length; i++) {
	          callbacks[i](reason);
	        }
	        // internal callback to reject the promise
	        callbacks[0](reason);
	        callbacks = null;
	      };
	    }

	    return promise;
	  }

	  function findTargetIndex(observer) {
	    var observers = this._observers;
	    if(!observers){
	      return -1;
	    }
	    var len = observers.length;
	    for (var i = 0; i < len; i++) {
	      if (observers[i]._target === observer) return i;
	    }
	    return -1;
	  }

	  // Attention, function return type now is array, always !
	  // It has zero elements if no any matches found and one or more
	  // elements (leafs) if there are matches
	  //
	  function searchListenerTree(handlers, type, tree, i, typeLength) {
	    if (!tree) {
	      return null;
	    }

	    if (i === 0) {
	      var kind = typeof type;
	      if (kind === 'string') {
	        var ns, n, l = 0, j = 0, delimiter = this.delimiter, dl = delimiter.length;
	        if ((n = type.indexOf(delimiter)) !== -1) {
	          ns = new Array(5);
	          do {
	            ns[l++] = type.slice(j, n);
	            j = n + dl;
	          } while ((n = type.indexOf(delimiter, j)) !== -1);

	          ns[l++] = type.slice(j);
	          type = ns;
	          typeLength = l;
	        } else {
	          type = [type];
	          typeLength = 1;
	        }
	      } else if (kind === 'object') {
	        typeLength = type.length;
	      } else {
	        type = [type];
	        typeLength = 1;
	      }
	    }

	    var listeners= null, branch, xTree, xxTree, isolatedBranch, endReached, currentType = type[i],
	        nextType = type[i + 1], branches, _listeners;

	    if (i === typeLength) {
	      //
	      // If at the end of the event(s) list and the tree has listeners
	      // invoke those listeners.
	      //

	      if(tree._listeners) {
	        if (typeof tree._listeners === 'function') {
	          handlers && handlers.push(tree._listeners);
	          listeners = [tree];
	        } else {
	          handlers && handlers.push.apply(handlers, tree._listeners);
	          listeners = [tree];
	        }
	      }
	    } else {

	      if (currentType === '*') {
	        //
	        // If the event emitted is '*' at this part
	        // or there is a concrete match at this patch
	        //
	        branches = ownKeys(tree);
	        n = branches.length;
	        while (n-- > 0) {
	          branch = branches[n];
	          if (branch !== '_listeners') {
	            _listeners = searchListenerTree(handlers, type, tree[branch], i + 1, typeLength);
	            if (_listeners) {
	              if (listeners) {
	                listeners.push.apply(listeners, _listeners);
	              } else {
	                listeners = _listeners;
	              }
	            }
	          }
	        }
	        return listeners;
	      } else if (currentType === '**') {
	        endReached = (i + 1 === typeLength || (i + 2 === typeLength && nextType === '*'));
	        if (endReached && tree._listeners) {
	          // The next element has a _listeners, add it to the handlers.
	          listeners = searchListenerTree(handlers, type, tree, typeLength, typeLength);
	        }

	        branches = ownKeys(tree);
	        n = branches.length;
	        while (n-- > 0) {
	          branch = branches[n];
	          if (branch !== '_listeners') {
	            if (branch === '*' || branch === '**') {
	              if (tree[branch]._listeners && !endReached) {
	                _listeners = searchListenerTree(handlers, type, tree[branch], typeLength, typeLength);
	                if (_listeners) {
	                  if (listeners) {
	                    listeners.push.apply(listeners, _listeners);
	                  } else {
	                    listeners = _listeners;
	                  }
	                }
	              }
	              _listeners = searchListenerTree(handlers, type, tree[branch], i, typeLength);
	            } else if (branch === nextType) {
	              _listeners = searchListenerTree(handlers, type, tree[branch], i + 2, typeLength);
	            } else {
	              // No match on this one, shift into the tree but not in the type array.
	              _listeners = searchListenerTree(handlers, type, tree[branch], i, typeLength);
	            }
	            if (_listeners) {
	              if (listeners) {
	                listeners.push.apply(listeners, _listeners);
	              } else {
	                listeners = _listeners;
	              }
	            }
	          }
	        }
	        return listeners;
	      } else if (tree[currentType]) {
	        listeners = searchListenerTree(handlers, type, tree[currentType], i + 1, typeLength);
	      }
	    }

	      xTree = tree['*'];
	    if (xTree) {
	      //
	      // If the listener tree will allow any match for this part,
	      // then recursively explore all branches of the tree
	      //
	      searchListenerTree(handlers, type, xTree, i + 1, typeLength);
	    }

	    xxTree = tree['**'];
	    if (xxTree) {
	      if (i < typeLength) {
	        if (xxTree._listeners) {
	          // If we have a listener on a '**', it will catch all, so add its handler.
	          searchListenerTree(handlers, type, xxTree, typeLength, typeLength);
	        }

	        // Build arrays of matching next branches and others.
	        branches= ownKeys(xxTree);
	        n= branches.length;
	        while(n-->0){
	          branch= branches[n];
	          if (branch !== '_listeners') {
	            if (branch === nextType) {
	              // We know the next element will match, so jump twice.
	              searchListenerTree(handlers, type, xxTree[branch], i + 2, typeLength);
	            } else if (branch === currentType) {
	              // Current node matches, move into the tree.
	              searchListenerTree(handlers, type, xxTree[branch], i + 1, typeLength);
	            } else {
	              isolatedBranch = {};
	              isolatedBranch[branch] = xxTree[branch];
	              searchListenerTree(handlers, type, {'**': isolatedBranch}, i + 1, typeLength);
	            }
	          }
	        }
	      } else if (xxTree._listeners) {
	        // We have reached the end and still on a '**'
	        searchListenerTree(handlers, type, xxTree, typeLength, typeLength);
	      } else if (xxTree['*'] && xxTree['*']._listeners) {
	        searchListenerTree(handlers, type, xxTree['*'], typeLength, typeLength);
	      }
	    }

	    return listeners;
	  }

	  function growListenerTree(type, listener, prepend) {
	    var len = 0, j = 0, i, delimiter = this.delimiter, dl= delimiter.length, ns;

	    if(typeof type==='string') {
	      if ((i = type.indexOf(delimiter)) !== -1) {
	        ns = new Array(5);
	        do {
	          ns[len++] = type.slice(j, i);
	          j = i + dl;
	        } while ((i = type.indexOf(delimiter, j)) !== -1);

	        ns[len++] = type.slice(j);
	      }else {
	        ns= [type];
	        len= 1;
	      }
	    }else {
	      ns= type;
	      len= type.length;
	    }

	    //
	    // Looks for two consecutive '**', if so, don't add the event at all.
	    //
	    if (len > 1) {
	      for (i = 0; i + 1 < len; i++) {
	        if (ns[i] === '**' && ns[i + 1] === '**') {
	          return;
	        }
	      }
	    }



	    var tree = this.listenerTree, name;

	    for (i = 0; i < len; i++) {
	      name = ns[i];

	      tree = tree[name] || (tree[name] = {});

	      if (i === len - 1) {
	        if (!tree._listeners) {
	          tree._listeners = listener;
	        } else {
	          if (typeof tree._listeners === 'function') {
	            tree._listeners = [tree._listeners];
	          }

	          if (prepend) {
	            tree._listeners.unshift(listener);
	          } else {
	            tree._listeners.push(listener);
	          }

	          if (
	              !tree._listeners.warned &&
	              this._maxListeners > 0 &&
	              tree._listeners.length > this._maxListeners
	          ) {
	            tree._listeners.warned = true;
	            logPossibleMemoryLeak.call(this, tree._listeners.length, name);
	          }
	        }
	        return true;
	      }
	    }

	    return true;
	  }

	  function collectTreeEvents(tree, events, root, asArray){
	     var branches= ownKeys(tree);
	     var i= branches.length;
	     var branch, branchName, path;
	     var hasListeners= tree['_listeners'];
	     var isArrayPath;

	     while(i-->0){
	         branchName= branches[i];

	         branch= tree[branchName];

	         if(branchName==='_listeners'){
	             path= root;
	         }else {
	             path = root ? root.concat(branchName) : [branchName];
	         }

	         isArrayPath= asArray || typeof branchName==='symbol';

	         hasListeners && events.push(isArrayPath? path : path.join(this.delimiter));

	         if(typeof branch==='object'){
	             collectTreeEvents.call(this, branch, events, path, isArrayPath);
	         }
	     }

	     return events;
	  }

	  function recursivelyGarbageCollect(root) {
	    var keys = ownKeys(root);
	    var i= keys.length;
	    var obj, key, flag;
	    while(i-->0){
	      key = keys[i];
	      obj = root[key];

	      if(obj){
	          flag= true;
	          if(key !== '_listeners' && !recursivelyGarbageCollect(obj)){
	             delete root[key];
	          }
	      }
	    }

	    return flag;
	  }

	  function Listener(emitter, event, listener){
	    this.emitter= emitter;
	    this.event= event;
	    this.listener= listener;
	  }

	  Listener.prototype.off= function(){
	    this.emitter.off(this.event, this.listener);
	    return this;
	  };

	  function setupListener(event, listener, options){
	      if (options === true) {
	        promisify = true;
	      } else if (options === false) {
	        async = true;
	      } else {
	        if (!options || typeof options !== 'object') {
	          throw TypeError('options should be an object or true');
	        }
	        var async = options.async;
	        var promisify = options.promisify;
	        var nextTick = options.nextTick;
	        var objectify = options.objectify;
	      }

	      if (async || nextTick || promisify) {
	        var _listener = listener;
	        var _origin = listener._origin || listener;

	        if (nextTick && !nextTickSupported) {
	          throw Error('process.nextTick is not supported');
	        }

	        if (promisify === undefined$1) {
	          promisify = listener.constructor.name === 'AsyncFunction';
	        }

	        listener = function () {
	          var args = arguments;
	          var context = this;
	          var event = this.event;

	          return promisify ? (nextTick ? Promise.resolve() : new Promise(function (resolve) {
	            _setImmediate(resolve);
	          }).then(function () {
	            context.event = event;
	            return _listener.apply(context, args)
	          })) : (nextTick ? process.nextTick : _setImmediate)(function () {
	            context.event = event;
	            _listener.apply(context, args);
	          });
	        };

	        listener._async = true;
	        listener._origin = _origin;
	      }

	    return [listener, objectify? new Listener(this, event, listener): this];
	  }

	  function EventEmitter(conf) {
	    this._events = {};
	    this._newListener = false;
	    this._removeListener = false;
	    this.verboseMemoryLeak = false;
	    configure.call(this, conf);
	  }

	  EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property

	  EventEmitter.prototype.listenTo= function(target, events, options){
	    if(typeof target!=='object'){
	      throw TypeError('target musts be an object');
	    }

	    var emitter= this;

	    options = resolveOptions(options, {
	      on: undefined$1,
	      off: undefined$1,
	      reducers: undefined$1
	    }, {
	      on: functionReducer,
	      off: functionReducer,
	      reducers: objectFunctionReducer
	    });

	    function listen(events){
	      if(typeof events!=='object'){
	        throw TypeError('events must be an object');
	      }

	      var reducers= options.reducers;
	      var index= findTargetIndex.call(emitter, target);
	      var observer;

	      if(index===-1){
	        observer= new TargetObserver(emitter, target, options);
	      }else {
	        observer= emitter._observers[index];
	      }

	      var keys= ownKeys(events);
	      var len= keys.length;
	      var event;
	      var isSingleReducer= typeof reducers==='function';

	      for(var i=0; i<len; i++){
	        event= keys[i];
	        observer.subscribe(
	            event,
	            events[event] || event,
	            isSingleReducer ? reducers : reducers && reducers[event]
	        );
	      }
	    }

	    isArray(events)?
	        listen(toObject(events)) :
	        (typeof events==='string'? listen(toObject(events.split(/\s+/))): listen(events));

	    return this;
	  };

	  EventEmitter.prototype.stopListeningTo = function (target, event) {
	    var observers = this._observers;

	    if(!observers){
	      return false;
	    }

	    var i = observers.length;
	    var observer;
	    var matched= false;

	    if(target && typeof target!=='object'){
	      throw TypeError('target should be an object');
	    }

	    while (i-- > 0) {
	      observer = observers[i];
	      if (!target || observer._target === target) {
	        observer.unsubscribe(event);
	        matched= true;
	      }
	    }

	    return matched;
	  };

	  // By default EventEmitters will print a warning if more than
	  // 10 listeners are added to it. This is a useful default which
	  // helps finding memory leaks.
	  //
	  // Obviously not all Emitters should be limited to 10. This function allows
	  // that to be increased. Set to zero for unlimited.

	  EventEmitter.prototype.delimiter = '.';

	  EventEmitter.prototype.setMaxListeners = function(n) {
	    if (n !== undefined$1) {
	      this._maxListeners = n;
	      if (!this._conf) this._conf = {};
	      this._conf.maxListeners = n;
	    }
	  };

	  EventEmitter.prototype.getMaxListeners = function() {
	    return this._maxListeners;
	  };

	  EventEmitter.prototype.event = '';

	  EventEmitter.prototype.once = function(event, fn, options) {
	    return this._once(event, fn, false, options);
	  };

	  EventEmitter.prototype.prependOnceListener = function(event, fn, options) {
	    return this._once(event, fn, true, options);
	  };

	  EventEmitter.prototype._once = function(event, fn, prepend, options) {
	    return this._many(event, 1, fn, prepend, options);
	  };

	  EventEmitter.prototype.many = function(event, ttl, fn, options) {
	    return this._many(event, ttl, fn, false, options);
	  };

	  EventEmitter.prototype.prependMany = function(event, ttl, fn, options) {
	    return this._many(event, ttl, fn, true, options);
	  };

	  EventEmitter.prototype._many = function(event, ttl, fn, prepend, options) {
	    var self = this;

	    if (typeof fn !== 'function') {
	      throw new Error('many only accepts instances of Function');
	    }

	    function listener() {
	      if (--ttl === 0) {
	        self.off(event, listener);
	      }
	      return fn.apply(this, arguments);
	    }

	    listener._origin = fn;

	    return this._on(event, listener, prepend, options);
	  };

	  EventEmitter.prototype.emit = function() {
	    if (!this._events && !this._all) {
	      return false;
	    }

	    this._events || init.call(this);

	    var type = arguments[0], ns, wildcard= this.wildcard;
	    var args,l,i,j, containsSymbol;

	    if (type === 'newListener' && !this._newListener) {
	      if (!this._events.newListener) {
	        return false;
	      }
	    }

	    if (wildcard) {
	      ns= type;
	      if(type!=='newListener' && type!=='removeListener'){
	        if (typeof type === 'object') {
	          l = type.length;
	          if (symbolsSupported) {
	            for (i = 0; i < l; i++) {
	              if (typeof type[i] === 'symbol') {
	                containsSymbol = true;
	                break;
	              }
	            }
	          }
	          if (!containsSymbol) {
	            type = type.join(this.delimiter);
	          }
	        }
	      }
	    }

	    var al = arguments.length;
	    var handler;

	    if (this._all && this._all.length) {
	      handler = this._all.slice();

	      for (i = 0, l = handler.length; i < l; i++) {
	        this.event = type;
	        switch (al) {
	        case 1:
	          handler[i].call(this, type);
	          break;
	        case 2:
	          handler[i].call(this, type, arguments[1]);
	          break;
	        case 3:
	          handler[i].call(this, type, arguments[1], arguments[2]);
	          break;
	        default:
	          handler[i].apply(this, arguments);
	        }
	      }
	    }

	    if (wildcard) {
	      handler = [];
	      searchListenerTree.call(this, handler, ns, this.listenerTree, 0, l);
	    } else {
	      handler = this._events[type];
	      if (typeof handler === 'function') {
	        this.event = type;
	        switch (al) {
	        case 1:
	          handler.call(this);
	          break;
	        case 2:
	          handler.call(this, arguments[1]);
	          break;
	        case 3:
	          handler.call(this, arguments[1], arguments[2]);
	          break;
	        default:
	          args = new Array(al - 1);
	          for (j = 1; j < al; j++) args[j - 1] = arguments[j];
	          handler.apply(this, args);
	        }
	        return true;
	      } else if (handler) {
	        // need to make copy of handlers because list can change in the middle
	        // of emit call
	        handler = handler.slice();
	      }
	    }

	    if (handler && handler.length) {
	      if (al > 3) {
	        args = new Array(al - 1);
	        for (j = 1; j < al; j++) args[j - 1] = arguments[j];
	      }
	      for (i = 0, l = handler.length; i < l; i++) {
	        this.event = type;
	        switch (al) {
	        case 1:
	          handler[i].call(this);
	          break;
	        case 2:
	          handler[i].call(this, arguments[1]);
	          break;
	        case 3:
	          handler[i].call(this, arguments[1], arguments[2]);
	          break;
	        default:
	          handler[i].apply(this, args);
	        }
	      }
	      return true;
	    } else if (!this.ignoreErrors && !this._all && type === 'error') {
	      if (arguments[1] instanceof Error) {
	        throw arguments[1]; // Unhandled 'error' event
	      } else {
	        throw new Error("Uncaught, unspecified 'error' event.");
	      }
	    }

	    return !!this._all;
	  };

	  EventEmitter.prototype.emitAsync = function() {
	    if (!this._events && !this._all) {
	      return false;
	    }

	    this._events || init.call(this);

	    var type = arguments[0], wildcard= this.wildcard, ns, containsSymbol;
	    var args,l,i,j;

	    if (type === 'newListener' && !this._newListener) {
	        if (!this._events.newListener) { return Promise.resolve([false]); }
	    }

	    if (wildcard) {
	      ns= type;
	      if(type!=='newListener' && type!=='removeListener'){
	        if (typeof type === 'object') {
	          l = type.length;
	          if (symbolsSupported) {
	            for (i = 0; i < l; i++) {
	              if (typeof type[i] === 'symbol') {
	                containsSymbol = true;
	                break;
	              }
	            }
	          }
	          if (!containsSymbol) {
	            type = type.join(this.delimiter);
	          }
	        }
	      }
	    }

	    var promises= [];

	    var al = arguments.length;
	    var handler;

	    if (this._all) {
	      for (i = 0, l = this._all.length; i < l; i++) {
	        this.event = type;
	        switch (al) {
	        case 1:
	          promises.push(this._all[i].call(this, type));
	          break;
	        case 2:
	          promises.push(this._all[i].call(this, type, arguments[1]));
	          break;
	        case 3:
	          promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
	          break;
	        default:
	          promises.push(this._all[i].apply(this, arguments));
	        }
	      }
	    }

	    if (wildcard) {
	      handler = [];
	      searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
	    } else {
	      handler = this._events[type];
	    }

	    if (typeof handler === 'function') {
	      this.event = type;
	      switch (al) {
	      case 1:
	        promises.push(handler.call(this));
	        break;
	      case 2:
	        promises.push(handler.call(this, arguments[1]));
	        break;
	      case 3:
	        promises.push(handler.call(this, arguments[1], arguments[2]));
	        break;
	      default:
	        args = new Array(al - 1);
	        for (j = 1; j < al; j++) args[j - 1] = arguments[j];
	        promises.push(handler.apply(this, args));
	      }
	    } else if (handler && handler.length) {
	      handler = handler.slice();
	      if (al > 3) {
	        args = new Array(al - 1);
	        for (j = 1; j < al; j++) args[j - 1] = arguments[j];
	      }
	      for (i = 0, l = handler.length; i < l; i++) {
	        this.event = type;
	        switch (al) {
	        case 1:
	          promises.push(handler[i].call(this));
	          break;
	        case 2:
	          promises.push(handler[i].call(this, arguments[1]));
	          break;
	        case 3:
	          promises.push(handler[i].call(this, arguments[1], arguments[2]));
	          break;
	        default:
	          promises.push(handler[i].apply(this, args));
	        }
	      }
	    } else if (!this.ignoreErrors && !this._all && type === 'error') {
	      if (arguments[1] instanceof Error) {
	        return Promise.reject(arguments[1]); // Unhandled 'error' event
	      } else {
	        return Promise.reject("Uncaught, unspecified 'error' event.");
	      }
	    }

	    return Promise.all(promises);
	  };

	  EventEmitter.prototype.on = function(type, listener, options) {
	    return this._on(type, listener, false, options);
	  };

	  EventEmitter.prototype.prependListener = function(type, listener, options) {
	    return this._on(type, listener, true, options);
	  };

	  EventEmitter.prototype.onAny = function(fn) {
	    return this._onAny(fn, false);
	  };

	  EventEmitter.prototype.prependAny = function(fn) {
	    return this._onAny(fn, true);
	  };

	  EventEmitter.prototype.addListener = EventEmitter.prototype.on;

	  EventEmitter.prototype._onAny = function(fn, prepend){
	    if (typeof fn !== 'function') {
	      throw new Error('onAny only accepts instances of Function');
	    }

	    if (!this._all) {
	      this._all = [];
	    }

	    // Add the function to the event listener collection.
	    if(prepend){
	      this._all.unshift(fn);
	    }else {
	      this._all.push(fn);
	    }

	    return this;
	  };

	  EventEmitter.prototype._on = function(type, listener, prepend, options) {
	    if (typeof type === 'function') {
	      this._onAny(type, listener);
	      return this;
	    }

	    if (typeof listener !== 'function') {
	      throw new Error('on only accepts instances of Function');
	    }
	    this._events || init.call(this);

	    var returnValue= this, temp;

	    if (options !== undefined$1) {
	      temp = setupListener.call(this, type, listener, options);
	      listener = temp[0];
	      returnValue = temp[1];
	    }

	    // To avoid recursion in the case that type == "newListeners"! Before
	    // adding it to the listeners, first emit "newListeners".
	    if (this._newListener) {
	      this.emit('newListener', type, listener);
	    }

	    if (this.wildcard) {
	      growListenerTree.call(this, type, listener, prepend);
	      return returnValue;
	    }

	    if (!this._events[type]) {
	      // Optimize the case of one listener. Don't need the extra array object.
	      this._events[type] = listener;
	    } else {
	      if (typeof this._events[type] === 'function') {
	        // Change to array.
	        this._events[type] = [this._events[type]];
	      }

	      // If we've already got an array, just add
	      if(prepend){
	        this._events[type].unshift(listener);
	      }else {
	        this._events[type].push(listener);
	      }

	      // Check for listener leak
	      if (
	        !this._events[type].warned &&
	        this._maxListeners > 0 &&
	        this._events[type].length > this._maxListeners
	      ) {
	        this._events[type].warned = true;
	        logPossibleMemoryLeak.call(this, this._events[type].length, type);
	      }
	    }

	    return returnValue;
	  };

	  EventEmitter.prototype.off = function(type, listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('removeListener only takes instances of Function');
	    }

	    var handlers,leafs=[];

	    if(this.wildcard) {
	      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
	      leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
	      if(!leafs) return this;
	    } else {
	      // does not use listeners(), so no side effect of creating _events[type]
	      if (!this._events[type]) return this;
	      handlers = this._events[type];
	      leafs.push({_listeners:handlers});
	    }

	    for (var iLeaf=0; iLeaf<leafs.length; iLeaf++) {
	      var leaf = leafs[iLeaf];
	      handlers = leaf._listeners;
	      if (isArray(handlers)) {

	        var position = -1;

	        for (var i = 0, length = handlers.length; i < length; i++) {
	          if (handlers[i] === listener ||
	            (handlers[i].listener && handlers[i].listener === listener) ||
	            (handlers[i]._origin && handlers[i]._origin === listener)) {
	            position = i;
	            break;
	          }
	        }

	        if (position < 0) {
	          continue;
	        }

	        if(this.wildcard) {
	          leaf._listeners.splice(position, 1);
	        }
	        else {
	          this._events[type].splice(position, 1);
	        }

	        if (handlers.length === 0) {
	          if(this.wildcard) {
	            delete leaf._listeners;
	          }
	          else {
	            delete this._events[type];
	          }
	        }
	        if (this._removeListener)
	          this.emit("removeListener", type, listener);

	        return this;
	      }
	      else if (handlers === listener ||
	        (handlers.listener && handlers.listener === listener) ||
	        (handlers._origin && handlers._origin === listener)) {
	        if(this.wildcard) {
	          delete leaf._listeners;
	        }
	        else {
	          delete this._events[type];
	        }
	        if (this._removeListener)
	          this.emit("removeListener", type, listener);
	      }
	    }

	    this.listenerTree && recursivelyGarbageCollect(this.listenerTree);

	    return this;
	  };

	  EventEmitter.prototype.offAny = function(fn) {
	    var i = 0, l = 0, fns;
	    if (fn && this._all && this._all.length > 0) {
	      fns = this._all;
	      for(i = 0, l = fns.length; i < l; i++) {
	        if(fn === fns[i]) {
	          fns.splice(i, 1);
	          if (this._removeListener)
	            this.emit("removeListenerAny", fn);
	          return this;
	        }
	      }
	    } else {
	      fns = this._all;
	      if (this._removeListener) {
	        for(i = 0, l = fns.length; i < l; i++)
	          this.emit("removeListenerAny", fns[i]);
	      }
	      this._all = [];
	    }
	    return this;
	  };

	  EventEmitter.prototype.removeListener = EventEmitter.prototype.off;

	  EventEmitter.prototype.removeAllListeners = function (type) {
	    if (type === undefined$1) {
	      !this._events || init.call(this);
	      return this;
	    }

	    if (this.wildcard) {
	      var leafs = searchListenerTree.call(this, null, type, this.listenerTree, 0), leaf, i;
	      if (!leafs) return this;
	      for (i = 0; i < leafs.length; i++) {
	        leaf = leafs[i];
	        leaf._listeners = null;
	      }
	      this.listenerTree && recursivelyGarbageCollect(this.listenerTree);
	    } else if (this._events) {
	      this._events[type] = null;
	    }
	    return this;
	  };

	  EventEmitter.prototype.listeners = function (type) {
	    var _events = this._events;
	    var keys, listeners, allListeners;
	    var i;
	    var listenerTree;

	    if (type === undefined$1) {
	      if (this.wildcard) {
	        throw Error('event name required for wildcard emitter');
	      }

	      if (!_events) {
	        return [];
	      }

	      keys = ownKeys(_events);
	      i = keys.length;
	      allListeners = [];
	      while (i-- > 0) {
	        listeners = _events[keys[i]];
	        if (typeof listeners === 'function') {
	          allListeners.push(listeners);
	        } else {
	          allListeners.push.apply(allListeners, listeners);
	        }
	      }
	      return allListeners;
	    } else {
	      if (this.wildcard) {
	        listenerTree= this.listenerTree;
	        if(!listenerTree) return [];
	        var handlers = [];
	        var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
	        searchListenerTree.call(this, handlers, ns, listenerTree, 0);
	        return handlers;
	      }

	      if (!_events) {
	        return [];
	      }

	      listeners = _events[type];

	      if (!listeners) {
	        return [];
	      }
	      return typeof listeners === 'function' ? [listeners] : listeners;
	    }
	  };

	  EventEmitter.prototype.eventNames = function(nsAsArray){
	    var _events= this._events;
	    return this.wildcard? collectTreeEvents.call(this, this.listenerTree, [], null, nsAsArray) : (_events? ownKeys(_events) : []);
	  };

	  EventEmitter.prototype.listenerCount = function(type) {
	    return this.listeners(type).length;
	  };

	  EventEmitter.prototype.hasListeners = function (type) {
	    if (this.wildcard) {
	      var handlers = [];
	      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
	      searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
	      return handlers.length > 0;
	    }

	    var _events = this._events;
	    var _all = this._all;

	    return !!(_all && _all.length || _events && (type === undefined$1 ? ownKeys(_events).length : _events[type]));
	  };

	  EventEmitter.prototype.listenersAny = function() {

	    if(this._all) {
	      return this._all;
	    }
	    else {
	      return [];
	    }

	  };

	  EventEmitter.prototype.waitFor = function (event, options) {
	    var self = this;
	    var type = typeof options;
	    if (type === 'number') {
	      options = {timeout: options};
	    } else if (type === 'function') {
	      options = {filter: options};
	    }

	    options= resolveOptions(options, {
	      timeout: 0,
	      filter: undefined$1,
	      handleError: false,
	      Promise: Promise,
	      overload: false
	    }, {
	      filter: functionReducer,
	      Promise: constructorReducer
	    });

	    return makeCancelablePromise(options.Promise, function (resolve, reject, onCancel) {
	      function listener() {
	        var filter= options.filter;
	        if (filter && !filter.apply(self, arguments)) {
	          return;
	        }
	        self.off(event, listener);
	        if (options.handleError) {
	          var err = arguments[0];
	          err ? reject(err) : resolve(toArray.apply(null, arguments).slice(1));
	        } else {
	          resolve(toArray.apply(null, arguments));
	        }
	      }

	      onCancel(function(){
	        self.off(event, listener);
	      });

	      self._on(event, listener, false);
	    }, {
	      timeout: options.timeout,
	      overload: options.overload
	    })
	  };

	  function once(emitter, name, options) {
	    options= resolveOptions(options, {
	      Promise: Promise,
	      timeout: 0,
	      overload: false
	    }, {
	      Promise: constructorReducer
	    });

	    var _Promise= options.Promise;

	    return makeCancelablePromise(_Promise, function(resolve, reject, onCancel){
	      var handler;
	      if (typeof emitter.addEventListener === 'function') {
	        handler=  function () {
	          resolve(toArray.apply(null, arguments));
	        };

	        onCancel(function(){
	          emitter.removeEventListener(name, handler);
	        });

	        emitter.addEventListener(
	            name,
	            handler,
	            {once: true}
	        );
	        return;
	      }

	      var eventListener = function(){
	        errorListener && emitter.removeListener('error', errorListener);
	        resolve(toArray.apply(null, arguments));
	      };

	      var errorListener;

	      if (name !== 'error') {
	        errorListener = function (err){
	          emitter.removeListener(name, eventListener);
	          reject(err);
	        };

	        emitter.once('error', errorListener);
	      }

	      onCancel(function(){
	        errorListener && emitter.removeListener('error', errorListener);
	        emitter.removeListener(name, eventListener);
	      });

	      emitter.once(name, eventListener);
	    }, {
	      timeout: options.timeout,
	      overload: options.overload
	    });
	  }

	  var prototype= EventEmitter.prototype;

	  Object.defineProperties(EventEmitter, {
	    defaultMaxListeners: {
	      get: function () {
	        return prototype._maxListeners;
	      },
	      set: function (n) {
	        if (typeof n !== 'number' || n < 0 || Number.isNaN(n)) {
	          throw TypeError('n must be a non-negative number')
	        }
	        prototype._maxListeners = n;
	      },
	      enumerable: true
	    },
	    once: {
	      value: once,
	      writable: true,
	      configurable: true
	    }
	  });

	  Object.defineProperties(prototype, {
	      _maxListeners: {
	          value: defaultMaxListeners,
	          writable: true,
	          configurable: true
	      },
	      _observers: {value: null, writable: true, configurable: true}
	  });

	  if (typeof undefined$1 === 'function' && undefined$1.amd) {
	     // AMD. Register as an anonymous module.
	    undefined$1(function() {
	      return EventEmitter;
	    });
	  } else {
	    // CommonJS
	    module.exports = EventEmitter;
	  }
	}(); 
} (eventemitter2));

var eventemitter2Exports = eventemitter2.exports;

Object.defineProperty(rule, "__esModule", {
  value: true
});

var _createClass$p = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _condition$1 = condition;

var _condition2$1 = _interopRequireDefault$E(_condition$1);

var _ruleResult = ruleResult;

var _ruleResult2 = _interopRequireDefault$E(_ruleResult);

var _debug$2 = debug$1;

var _debug2$2 = _interopRequireDefault$E(_debug$2);

var _clone = cloneExports;

var _clone2 = _interopRequireDefault$E(_clone);

var _eventemitter$1 = eventemitter2Exports;

var _eventemitter2$1 = _interopRequireDefault$E(_eventemitter$1);

function _interopRequireDefault$E(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$x(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$q(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$q(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rule = function (_EventEmitter) {
  _inherits$q(Rule, _EventEmitter);

  /**
   * returns a new Rule instance
   * @param {object,string} options, or json string that can be parsed into options
   * @param {integer} options.priority (>1) - higher runs sooner.
   * @param {Object} options.event - event to fire when rule evaluates as successful
   * @param {string} options.event.type - name of event to emit
   * @param {string} options.event.params - parameters to pass to the event listener
   * @param {Object} options.conditions - conditions to evaluate when processing this rule
   * @param {any} options.name - identifier for a particular rule, particularly valuable in RuleResult output
   * @return {Rule} instance
   */
  function Rule(options) {
    _classCallCheck$x(this, Rule);

    var _this = _possibleConstructorReturn$q(this, (Rule.__proto__ || Object.getPrototypeOf(Rule)).call(this));

    if (typeof options === 'string') {
      options = JSON.parse(options);
    }
    if (options && options.conditions) {
      _this.setConditions(options.conditions);
    }
    if (options && options.onSuccess) {
      _this.on('success', options.onSuccess);
    }
    if (options && options.onFailure) {
      _this.on('failure', options.onFailure);
    }
    if (options && (options.name || options.name === 0)) {
      _this.setName(options.name);
    }

    var priority = options && options.priority || 1;
    _this.setPriority(priority);

    var event = options && options.event || { type: 'unknown' };
    _this.setEvent(event);
    return _this;
  }

  /**
   * Sets the priority of the rule
   * @param {integer} priority (>=1) - increasing the priority causes the rule to be run prior to other rules
   */


  _createClass$p(Rule, [{
    key: 'setPriority',
    value: function setPriority(priority) {
      priority = parseInt(priority, 10);
      if (priority <= 0) throw new Error('Priority must be greater than zero');
      this.priority = priority;
      return this;
    }

    /**
     * Sets the name of the rule
     * @param {any} name - any truthy input and zero is allowed
     */

  }, {
    key: 'setName',
    value: function setName(name) {
      if (!name && name !== 0) {
        throw new Error('Rule "name" must be defined');
      }
      this.name = name;
      return this;
    }

    /**
     * Sets the conditions to run when evaluating the rule.
     * @param {object} conditions - conditions, root element must be a boolean operator
     */

  }, {
    key: 'setConditions',
    value: function setConditions(conditions) {
      if (!Object.prototype.hasOwnProperty.call(conditions, 'all') && !Object.prototype.hasOwnProperty.call(conditions, 'any') && !Object.prototype.hasOwnProperty.call(conditions, 'not') && !Object.prototype.hasOwnProperty.call(conditions, 'condition')) {
        throw new Error('"conditions" root must contain a single instance of "all", "any", "not", or "condition"');
      }
      this.conditions = new _condition2$1.default(conditions);
      return this;
    }

    /**
     * Sets the event to emit when the conditions evaluate truthy
     * @param {object} event - event to emit
     * @param {string} event.type - event name to emit on
     * @param {string} event.params - parameters to emit as the argument of the event emission
     */

  }, {
    key: 'setEvent',
    value: function setEvent(event) {
      if (!event) throw new Error('Rule: setEvent() requires event object');
      if (!Object.prototype.hasOwnProperty.call(event, 'type')) {
        throw new Error('Rule: setEvent() requires event object with "type" property');
      }
      this.ruleEvent = {
        type: event.type
      };
      if (event.params) this.ruleEvent.params = event.params;
      return this;
    }

    /**
     * returns the event object
     * @returns {Object} event
     */

  }, {
    key: 'getEvent',
    value: function getEvent() {
      return this.ruleEvent;
    }

    /**
     * returns the priority
     * @returns {Number} priority
     */

  }, {
    key: 'getPriority',
    value: function getPriority() {
      return this.priority;
    }

    /**
     * returns the event object
     * @returns {Object} event
     */

  }, {
    key: 'getConditions',
    value: function getConditions() {
      return this.conditions;
    }

    /**
     * returns the engine object
     * @returns {Object} engine
     */

  }, {
    key: 'getEngine',
    value: function getEngine() {
      return this.engine;
    }

    /**
     * Sets the engine to run the rules under
     * @param {object} engine
     * @returns {Rule}
     */

  }, {
    key: 'setEngine',
    value: function setEngine(engine) {
      this.engine = engine;
      return this;
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      var stringify = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      var props = {
        conditions: this.conditions.toJSON(false),
        priority: this.priority,
        event: this.ruleEvent,
        name: this.name
      };
      if (stringify) {
        return JSON.stringify(props);
      }
      return props;
    }

    /**
     * Priorizes an array of conditions based on "priority"
     *   When no explicit priority is provided on the condition itself, the condition's priority is determine by its fact
     * @param  {Condition[]} conditions
     * @return {Condition[][]} prioritized two-dimensional array of conditions
     *    Each outer array element represents a single priority(integer).  Inner array is
     *    all conditions with that priority.
     */

  }, {
    key: 'prioritizeConditions',
    value: function prioritizeConditions(conditions) {
      var _this2 = this;

      var factSets = conditions.reduce(function (sets, condition) {
        // if a priority has been set on this specific condition, honor that first
        // otherwise, use the fact's priority
        var priority = condition.priority;
        if (!priority) {
          var fact = _this2.engine.getFact(condition.fact);
          priority = fact && fact.priority || 1;
        }
        if (!sets[priority]) sets[priority] = [];
        sets[priority].push(condition);
        return sets;
      }, {});
      return Object.keys(factSets).sort(function (a, b) {
        return Number(a) > Number(b) ? -1 : 1; // order highest priority -> lowest
      }).map(function (priority) {
        return factSets[priority];
      });
    }

    /**
     * Evaluates the rule, starting with the root boolean operator and recursing down
     * All evaluation is done within the context of an almanac
     * @return {Promise(RuleResult)} rule evaluation result
     */

  }, {
    key: 'evaluate',
    value: function evaluate(almanac) {
      var _this3 = this;

      var ruleResult = new _ruleResult2.default(this.conditions, this.ruleEvent, this.priority, this.name);

      /**
       * Evaluates the rule conditions
       * @param  {Condition} condition - condition to evaluate
       * @return {Promise(true|false)} - resolves with the result of the condition evaluation
       */
      var evaluateCondition = function evaluateCondition(condition) {
        if (condition.isConditionReference()) {
          return realize(condition);
        } else if (condition.isBooleanOperator()) {
          var subConditions = condition[condition.operator];
          var comparisonPromise = void 0;
          if (condition.operator === 'all') {
            comparisonPromise = all(subConditions);
          } else if (condition.operator === 'any') {
            comparisonPromise = any(subConditions);
          } else {
            comparisonPromise = not(subConditions);
          }
          // for booleans, rule passing is determined by the all/any/not result
          return comparisonPromise.then(function (comparisonValue) {
            var passes = comparisonValue === true;
            condition.result = passes;
            return passes;
          });
        } else {
          return condition.evaluate(almanac, _this3.engine.operators).then(function (evaluationResult) {
            var passes = evaluationResult.result;
            condition.factResult = evaluationResult.leftHandSideValue;
            condition.result = passes;
            return passes;
          });
        }
      };

      /**
       * Evalutes an array of conditions, using an 'every' or 'some' array operation
       * @param  {Condition[]} conditions
       * @param  {string(every|some)} array method to call for determining result
       * @return {Promise(boolean)} whether conditions evaluated truthy or falsey based on condition evaluation + method
       */
      var evaluateConditions = function evaluateConditions(conditions, method) {
        if (!Array.isArray(conditions)) conditions = [conditions];

        return Promise.all(conditions.map(function (condition) {
          return evaluateCondition(condition);
        })).then(function (conditionResults) {
          (0, _debug2$2.default)('rule::evaluateConditions results', conditionResults);
          return method.call(conditionResults, function (result) {
            return result === true;
          });
        });
      };

      /**
       * Evaluates a set of conditions based on an 'all', 'any', or 'not' operator.
       *   First, orders the top level conditions based on priority
       *   Iterates over each priority set, evaluating each condition
       *   If any condition results in the rule to be guaranteed truthy or falsey,
       *   it will short-circuit and not bother evaluating any additional rules
       * @param  {Condition[]} conditions - conditions to be evaluated
       * @param  {string('all'|'any'|'not')} operator
       * @return {Promise(boolean)} rule evaluation result
       */
      var prioritizeAndRun = function prioritizeAndRun(conditions, operator) {
        if (conditions.length === 0) {
          return Promise.resolve(true);
        }
        if (conditions.length === 1) {
          // no prioritizing is necessary, just evaluate the single condition
          // 'all' and 'any' will give the same results with a single condition so no method is necessary
          // this also covers the 'not' case which should only ever have a single condition
          return evaluateCondition(conditions[0]);
        }
        var method = Array.prototype.some;
        if (operator === 'all') {
          method = Array.prototype.every;
        }
        var orderedSets = _this3.prioritizeConditions(conditions);
        var cursor = Promise.resolve();
        // use for() loop over Array.forEach to support IE8 without polyfill

        var _loop = function _loop(i) {
          var set = orderedSets[i];
          var stop = false;
          cursor = cursor.then(function (setResult) {
            // after the first set succeeds, don't fire off the remaining promises
            if (operator === 'any' && setResult === true || stop) {
              (0, _debug2$2.default)('prioritizeAndRun::detected truthy result; skipping remaining conditions');
              stop = true;
              return true;
            }

            // after the first set fails, don't fire off the remaining promises
            if (operator === 'all' && setResult === false || stop) {
              (0, _debug2$2.default)('prioritizeAndRun::detected falsey result; skipping remaining conditions');
              stop = true;
              return false;
            }
            // all conditions passed; proceed with running next set in parallel
            return evaluateConditions(set, method);
          });
        };

        for (var i = 0; i < orderedSets.length; i++) {
          _loop(i);
        }
        return cursor;
      };

      /**
       * Runs an 'any' boolean operator on an array of conditions
       * @param  {Condition[]} conditions to be evaluated
       * @return {Promise(boolean)} condition evaluation result
       */
      var any = function any(conditions) {
        return prioritizeAndRun(conditions, 'any');
      };

      /**
       * Runs an 'all' boolean operator on an array of conditions
       * @param  {Condition[]} conditions to be evaluated
       * @return {Promise(boolean)} condition evaluation result
       */
      var all = function all(conditions) {
        return prioritizeAndRun(conditions, 'all');
      };

      /**
       * Runs a 'not' boolean operator on a single condition
       * @param  {Condition} condition to be evaluated
       * @return {Promise(boolean)} condition evaluation result
       */
      var not = function not(condition) {
        return prioritizeAndRun([condition], 'not').then(function (result) {
          return !result;
        });
      };

      /**
       * Dereferences the condition reference and then evaluates it.
       * @param {Condition} conditionReference
       * @returns {Promise(boolean)} condition evaluation result
       */
      var realize = function realize(conditionReference) {
        var condition = _this3.engine.conditions.get(conditionReference.condition);
        if (!condition) {
          if (_this3.engine.allowUndefinedConditions) {
            // undefined conditions always fail
            conditionReference.result = false;
            return Promise.resolve(false);
          } else {
            throw new Error('No condition ' + conditionReference.condition + ' exists');
          }
        } else {
          // project the referenced condition onto reference object and evaluate it.
          delete conditionReference.condition;
          Object.assign(conditionReference, (0, _clone2.default)(condition));
          return evaluateCondition(conditionReference);
        }
      };

      /**
       * Emits based on rule evaluation result, and decorates ruleResult with 'result' property
       * @param {RuleResult} ruleResult
       */
      var processResult = function processResult(result) {
        ruleResult.setResult(result);
        var processEvent = Promise.resolve();
        if (_this3.engine.replaceFactsInEventParams) {
          processEvent = ruleResult.resolveEventParams(almanac);
        }
        var event = result ? 'success' : 'failure';
        return processEvent.then(function () {
          return _this3.emitAsync(event, ruleResult.event, almanac, ruleResult);
        }).then(function () {
          return ruleResult;
        });
      };

      if (ruleResult.conditions.any) {
        return any(ruleResult.conditions.any).then(function (result) {
          return processResult(result);
        });
      } else if (ruleResult.conditions.all) {
        return all(ruleResult.conditions.all).then(function (result) {
          return processResult(result);
        });
      } else if (ruleResult.conditions.not) {
        return not(ruleResult.conditions.not).then(function (result) {
          return processResult(result);
        });
      } else {
        return realize(ruleResult.conditions).then(function (result) {
          return processResult(result);
        });
      }
    }
  }]);

  return Rule;
}(_eventemitter2$1.default);

rule.default = Rule;

var operator = {};

Object.defineProperty(operator, "__esModule", {
  value: true
});

var _createClass$o = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$w(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Operator = function () {
  /**
   * Constructor
   * @param {string}   name - operator identifier
   * @param {function(factValue, jsonValue)} callback - operator evaluation method
   * @param {function}  [factValueValidator] - optional validator for asserting the data type of the fact
   * @returns {Operator} - instance
   */
  function Operator(name, cb, factValueValidator) {
    _classCallCheck$w(this, Operator);

    this.name = String(name);
    if (!name) throw new Error('Missing operator name');
    if (typeof cb !== 'function') throw new Error('Missing operator callback');
    this.cb = cb;
    this.factValueValidator = factValueValidator;
    if (!this.factValueValidator) this.factValueValidator = function () {
      return true;
    };
  }

  /**
   * Takes the fact result and compares it to the condition 'value', using the callback
   * @param   {mixed} factValue - fact result
   * @param   {mixed} jsonValue - "value" property of the condition
   * @returns {Boolean} - whether the values pass the operator test
   */


  _createClass$o(Operator, [{
    key: 'evaluate',
    value: function evaluate(factValue, jsonValue) {
      return this.factValueValidator(factValue) && this.cb(factValue, jsonValue);
    }
  }]);

  return Operator;
}();

operator.default = Operator;

var almanac = {};

var errors = {};

Object.defineProperty(errors, "__esModule", {
  value: true
});

function _classCallCheck$v(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$p(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$p(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

errors.UndefinedFactError = function (_Error) {
  _inherits$p(UndefinedFactError, _Error);

  function UndefinedFactError() {
    var _ref;

    _classCallCheck$v(this, UndefinedFactError);

    for (var _len = arguments.length, props = Array(_len), _key = 0; _key < _len; _key++) {
      props[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn$p(this, (_ref = UndefinedFactError.__proto__ || Object.getPrototypeOf(UndefinedFactError)).call.apply(_ref, [this].concat(props)));

    _this.code = 'UNDEFINED_FACT';
    return _this;
  }

  return UndefinedFactError;
}(Error);

var indexNodeCjs = {};

Object.defineProperty(indexNodeCjs, '__esModule', { value: true });

var vm = require$$0$1;

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var vm__default = /*#__PURE__*/_interopDefaultLegacy(vm);

const {
  hasOwnProperty: hasOwnProp
} = Object.prototype;
/**
 * @typedef {null|boolean|number|string|PlainObject|GenericArray} JSONObject
 */

/**
 * @typedef {any} AnyItem
 */

/**
 * @typedef {any} AnyResult
 */

/**
 * Copies array and then pushes item into it.
 * @param {GenericArray} arr Array to copy and into which to push
 * @param {AnyItem} item Array item to add (to end)
 * @returns {GenericArray} Copy of the original array
 */

function push(arr, item) {
  arr = arr.slice();
  arr.push(item);
  return arr;
}
/**
 * Copies array and then unshifts item into it.
 * @param {AnyItem} item Array item to add (to beginning)
 * @param {GenericArray} arr Array to copy and into which to unshift
 * @returns {GenericArray} Copy of the original array
 */


function unshift(item, arr) {
  arr = arr.slice();
  arr.unshift(item);
  return arr;
}
/**
 * Caught when JSONPath is used without `new` but rethrown if with `new`
 * @extends Error
 */


class NewError extends Error {
  /**
   * @param {AnyResult} value The evaluated scalar value
   */
  constructor(value) {
    super('JSONPath should not be called with "new" (it prevents return ' + 'of (unwrapped) scalar values)');
    this.avoidNew = true;
    this.value = value;
    this.name = 'NewError';
  }

}
/**
* @typedef {PlainObject} ReturnObject
* @property {string} path
* @property {JSONObject} value
* @property {PlainObject|GenericArray} parent
* @property {string} parentProperty
*/

/**
* @callback JSONPathCallback
* @param {string|PlainObject} preferredOutput
* @param {"value"|"property"} type
* @param {ReturnObject} fullRetObj
* @returns {void}
*/

/**
* @callback OtherTypeCallback
* @param {JSONObject} val
* @param {string} path
* @param {PlainObject|GenericArray} parent
* @param {string} parentPropName
* @returns {boolean}
*/

/* eslint-disable max-len -- Can make multiline type after https://github.com/syavorsky/comment-parser/issues/109 */

/**
 * @typedef {PlainObject} JSONPathOptions
 * @property {JSON} json
 * @property {string|string[]} path
 * @property {"value"|"path"|"pointer"|"parent"|"parentProperty"|"all"} [resultType="value"]
 * @property {boolean} [flatten=false]
 * @property {boolean} [wrap=true]
 * @property {PlainObject} [sandbox={}]
 * @property {boolean} [preventEval=false]
 * @property {PlainObject|GenericArray|null} [parent=null]
 * @property {string|null} [parentProperty=null]
 * @property {JSONPathCallback} [callback]
 * @property {OtherTypeCallback} [otherTypeCallback] Defaults to
 *   function which throws on encountering `@other`
 * @property {boolean} [autostart=true]
 */

/* eslint-enable max-len -- Can make multiline type after https://github.com/syavorsky/comment-parser/issues/109 */

/**
 * @param {string|JSONPathOptions} opts If a string, will be treated as `expr`
 * @param {string} [expr] JSON path to evaluate
 * @param {JSON} [obj] JSON object to evaluate against
 * @param {JSONPathCallback} [callback] Passed 3 arguments: 1) desired payload
 *     per `resultType`, 2) `"value"|"property"`, 3) Full returned object with
 *     all payloads
 * @param {OtherTypeCallback} [otherTypeCallback] If `@other()` is at the end
 *   of one's query, this will be invoked with the value of the item, its
 *   path, its parent, and its parent's property name, and it should return
 *   a boolean indicating whether the supplied value belongs to the "other"
 *   type or not (or it may handle transformations and return `false`).
 * @returns {JSONPath}
 * @class
 */


function JSONPath(opts, expr, obj, callback, otherTypeCallback) {
  // eslint-disable-next-line no-restricted-syntax
  if (!(this instanceof JSONPath)) {
    try {
      return new JSONPath(opts, expr, obj, callback, otherTypeCallback);
    } catch (e) {
      if (!e.avoidNew) {
        throw e;
      }

      return e.value;
    }
  }

  if (typeof opts === 'string') {
    otherTypeCallback = callback;
    callback = obj;
    obj = expr;
    expr = opts;
    opts = null;
  }

  const optObj = opts && typeof opts === 'object';
  opts = opts || {};
  this.json = opts.json || obj;
  this.path = opts.path || expr;
  this.resultType = opts.resultType || 'value';
  this.flatten = opts.flatten || false;
  this.wrap = hasOwnProp.call(opts, 'wrap') ? opts.wrap : true;
  this.sandbox = opts.sandbox || {};
  this.preventEval = opts.preventEval || false;
  this.parent = opts.parent || null;
  this.parentProperty = opts.parentProperty || null;
  this.callback = opts.callback || callback || null;

  this.otherTypeCallback = opts.otherTypeCallback || otherTypeCallback || function () {
    throw new TypeError('You must supply an otherTypeCallback callback option ' + 'with the @other() operator.');
  };

  if (opts.autostart !== false) {
    const args = {
      path: optObj ? opts.path : expr
    };

    if (!optObj) {
      args.json = obj;
    } else if ('json' in opts) {
      args.json = opts.json;
    }

    const ret = this.evaluate(args);

    if (!ret || typeof ret !== 'object') {
      throw new NewError(ret);
    }

    return ret;
  }
} // PUBLIC METHODS


JSONPath.prototype.evaluate = function (expr, json, callback, otherTypeCallback) {
  let currParent = this.parent,
      currParentProperty = this.parentProperty;
  let {
    flatten,
    wrap
  } = this;
  this.currResultType = this.resultType;
  this.currPreventEval = this.preventEval;
  this.currSandbox = this.sandbox;
  callback = callback || this.callback;
  this.currOtherTypeCallback = otherTypeCallback || this.otherTypeCallback;
  json = json || this.json;
  expr = expr || this.path;

  if (expr && typeof expr === 'object' && !Array.isArray(expr)) {
    if (!expr.path && expr.path !== '') {
      throw new TypeError('You must supply a "path" property when providing an object ' + 'argument to JSONPath.evaluate().');
    }

    if (!hasOwnProp.call(expr, 'json')) {
      throw new TypeError('You must supply a "json" property when providing an object ' + 'argument to JSONPath.evaluate().');
    }

    ({
      json
    } = expr);
    flatten = hasOwnProp.call(expr, 'flatten') ? expr.flatten : flatten;
    this.currResultType = hasOwnProp.call(expr, 'resultType') ? expr.resultType : this.currResultType;
    this.currSandbox = hasOwnProp.call(expr, 'sandbox') ? expr.sandbox : this.currSandbox;
    wrap = hasOwnProp.call(expr, 'wrap') ? expr.wrap : wrap;
    this.currPreventEval = hasOwnProp.call(expr, 'preventEval') ? expr.preventEval : this.currPreventEval;
    callback = hasOwnProp.call(expr, 'callback') ? expr.callback : callback;
    this.currOtherTypeCallback = hasOwnProp.call(expr, 'otherTypeCallback') ? expr.otherTypeCallback : this.currOtherTypeCallback;
    currParent = hasOwnProp.call(expr, 'parent') ? expr.parent : currParent;
    currParentProperty = hasOwnProp.call(expr, 'parentProperty') ? expr.parentProperty : currParentProperty;
    expr = expr.path;
  }

  currParent = currParent || null;
  currParentProperty = currParentProperty || null;

  if (Array.isArray(expr)) {
    expr = JSONPath.toPathString(expr);
  }

  if (!expr && expr !== '' || !json) {
    return undefined;
  }

  const exprList = JSONPath.toPathArray(expr);

  if (exprList[0] === '$' && exprList.length > 1) {
    exprList.shift();
  }

  this._hasParentSelector = null;

  const result = this._trace(exprList, json, ['$'], currParent, currParentProperty, callback).filter(function (ea) {
    return ea && !ea.isParentSelector;
  });

  if (!result.length) {
    return wrap ? [] : undefined;
  }

  if (!wrap && result.length === 1 && !result[0].hasArrExpr) {
    return this._getPreferredOutput(result[0]);
  }

  return result.reduce((rslt, ea) => {
    const valOrPath = this._getPreferredOutput(ea);

    if (flatten && Array.isArray(valOrPath)) {
      rslt = rslt.concat(valOrPath);
    } else {
      rslt.push(valOrPath);
    }

    return rslt;
  }, []);
}; // PRIVATE METHODS


JSONPath.prototype._getPreferredOutput = function (ea) {
  const resultType = this.currResultType;

  switch (resultType) {
    case 'all':
      {
        const path = Array.isArray(ea.path) ? ea.path : JSONPath.toPathArray(ea.path);
        ea.pointer = JSONPath.toPointer(path);
        ea.path = typeof ea.path === 'string' ? ea.path : JSONPath.toPathString(ea.path);
        return ea;
      }

    case 'value':
    case 'parent':
    case 'parentProperty':
      return ea[resultType];

    case 'path':
      return JSONPath.toPathString(ea[resultType]);

    case 'pointer':
      return JSONPath.toPointer(ea.path);

    default:
      throw new TypeError('Unknown result type');
  }
};

JSONPath.prototype._handleCallback = function (fullRetObj, callback, type) {
  if (callback) {
    const preferredOutput = this._getPreferredOutput(fullRetObj);

    fullRetObj.path = typeof fullRetObj.path === 'string' ? fullRetObj.path : JSONPath.toPathString(fullRetObj.path); // eslint-disable-next-line n/callback-return

    callback(preferredOutput, type, fullRetObj);
  }
};
/**
 *
 * @param {string} expr
 * @param {JSONObject} val
 * @param {string} path
 * @param {PlainObject|GenericArray} parent
 * @param {string} parentPropName
 * @param {JSONPathCallback} callback
 * @param {boolean} hasArrExpr
 * @param {boolean} literalPriority
 * @returns {ReturnObject|ReturnObject[]}
 */


JSONPath.prototype._trace = function (expr, val, path, parent, parentPropName, callback, hasArrExpr, literalPriority) {
  // No expr to follow? return path and value as the result of
  //  this trace branch
  let retObj;

  if (!expr.length) {
    retObj = {
      path,
      value: val,
      parent,
      parentProperty: parentPropName,
      hasArrExpr
    };

    this._handleCallback(retObj, callback, 'value');

    return retObj;
  }

  const loc = expr[0],
        x = expr.slice(1); // We need to gather the return value of recursive trace calls in order to
  // do the parent sel computation.

  const ret = [];
  /**
   *
   * @param {ReturnObject|ReturnObject[]} elems
   * @returns {void}
   */

  function addRet(elems) {
    if (Array.isArray(elems)) {
      // This was causing excessive stack size in Node (with or
      //  without Babel) against our performance test:
      //  `ret.push(...elems);`
      elems.forEach(t => {
        ret.push(t);
      });
    } else {
      ret.push(elems);
    }
  }

  if ((typeof loc !== 'string' || literalPriority) && val && hasOwnProp.call(val, loc)) {
    // simple case--directly follow property
    addRet(this._trace(x, val[loc], push(path, loc), val, loc, callback, hasArrExpr)); // eslint-disable-next-line unicorn/prefer-switch -- Part of larger `if`
  } else if (loc === '*') {
    // all child properties
    this._walk(val, m => {
      addRet(this._trace(x, val[m], push(path, m), val, m, callback, true, true));
    });
  } else if (loc === '..') {
    // all descendent parent properties
    // Check remaining expression with val's immediate children
    addRet(this._trace(x, val, path, parent, parentPropName, callback, hasArrExpr));

    this._walk(val, m => {
      // We don't join m and x here because we only want parents,
      //   not scalar values
      if (typeof val[m] === 'object') {
        // Keep going with recursive descent on val's
        //   object children
        addRet(this._trace(expr.slice(), val[m], push(path, m), val, m, callback, true));
      }
    }); // The parent sel computation is handled in the frame above using the
    // ancestor object of val

  } else if (loc === '^') {
    // This is not a final endpoint, so we do not invoke the callback here
    this._hasParentSelector = true;
    return {
      path: path.slice(0, -1),
      expr: x,
      isParentSelector: true
    };
  } else if (loc === '~') {
    // property name
    retObj = {
      path: push(path, loc),
      value: parentPropName,
      parent,
      parentProperty: null
    };

    this._handleCallback(retObj, callback, 'property');

    return retObj;
  } else if (loc === '$') {
    // root only
    addRet(this._trace(x, val, path, null, null, callback, hasArrExpr));
  } else if (/^(-?\d*):(-?\d*):?(\d*)$/u.test(loc)) {
    // [start:end:step]  Python slice syntax
    addRet(this._slice(loc, x, val, path, parent, parentPropName, callback));
  } else if (loc.indexOf('?(') === 0) {
    // [?(expr)] (filtering)
    if (this.currPreventEval) {
      throw new Error('Eval [?(expr)] prevented in JSONPath expression.');
    }

    const safeLoc = loc.replace(/^\?\((.*?)\)$/u, '$1');

    this._walk(val, m => {
      if (this._eval(safeLoc, val[m], m, path, parent, parentPropName)) {
        addRet(this._trace(x, val[m], push(path, m), val, m, callback, true));
      }
    });
  } else if (loc[0] === '(') {
    // [(expr)] (dynamic property/index)
    if (this.currPreventEval) {
      throw new Error('Eval [(expr)] prevented in JSONPath expression.');
    } // As this will resolve to a property name (but we don't know it
    //  yet), property and parent information is relative to the
    //  parent of the property to which this expression will resolve


    addRet(this._trace(unshift(this._eval(loc, val, path[path.length - 1], path.slice(0, -1), parent, parentPropName), x), val, path, parent, parentPropName, callback, hasArrExpr));
  } else if (loc[0] === '@') {
    // value type: @boolean(), etc.
    let addType = false;
    const valueType = loc.slice(1, -2);

    switch (valueType) {
      case 'scalar':
        if (!val || !['object', 'function'].includes(typeof val)) {
          addType = true;
        }

        break;

      case 'boolean':
      case 'string':
      case 'undefined':
      case 'function':
        // eslint-disable-next-line valid-typeof
        if (typeof val === valueType) {
          addType = true;
        }

        break;

      case 'integer':
        if (Number.isFinite(val) && !(val % 1)) {
          addType = true;
        }

        break;

      case 'number':
        if (Number.isFinite(val)) {
          addType = true;
        }

        break;

      case 'nonFinite':
        if (typeof val === 'number' && !Number.isFinite(val)) {
          addType = true;
        }

        break;

      case 'object':
        // eslint-disable-next-line valid-typeof
        if (val && typeof val === valueType) {
          addType = true;
        }

        break;

      case 'array':
        if (Array.isArray(val)) {
          addType = true;
        }

        break;

      case 'other':
        addType = this.currOtherTypeCallback(val, path, parent, parentPropName);
        break;

      case 'null':
        if (val === null) {
          addType = true;
        }

        break;

      /* c8 ignore next 2 */

      default:
        throw new TypeError('Unknown value type ' + valueType);
    }

    if (addType) {
      retObj = {
        path,
        value: val,
        parent,
        parentProperty: parentPropName
      };

      this._handleCallback(retObj, callback, 'value');

      return retObj;
    } // `-escaped property

  } else if (loc[0] === '`' && val && hasOwnProp.call(val, loc.slice(1))) {
    const locProp = loc.slice(1);
    addRet(this._trace(x, val[locProp], push(path, locProp), val, locProp, callback, hasArrExpr, true));
  } else if (loc.includes(',')) {
    // [name1,name2,...]
    const parts = loc.split(',');

    for (const part of parts) {
      addRet(this._trace(unshift(part, x), val, path, parent, parentPropName, callback, true));
    } // simple case--directly follow property

  } else if (!literalPriority && val && hasOwnProp.call(val, loc)) {
    addRet(this._trace(x, val[loc], push(path, loc), val, loc, callback, hasArrExpr, true));
  } // We check the resulting values for parent selections. For parent
  // selections we discard the value object and continue the trace with the
  // current val object


  if (this._hasParentSelector) {
    for (let t = 0; t < ret.length; t++) {
      const rett = ret[t];

      if (rett && rett.isParentSelector) {
        const tmp = this._trace(rett.expr, val, rett.path, parent, parentPropName, callback, hasArrExpr);

        if (Array.isArray(tmp)) {
          ret[t] = tmp[0];
          const tl = tmp.length;

          for (let tt = 1; tt < tl; tt++) {
            t++;
            ret.splice(t, 0, tmp[tt]);
          }
        } else {
          ret[t] = tmp;
        }
      }
    }
  }

  return ret;
};

JSONPath.prototype._walk = function (val, f) {
  if (Array.isArray(val)) {
    const n = val.length;

    for (let i = 0; i < n; i++) {
      f(i);
    }
  } else if (val && typeof val === 'object') {
    Object.keys(val).forEach(m => {
      f(m);
    });
  }
};

JSONPath.prototype._slice = function (loc, expr, val, path, parent, parentPropName, callback) {
  if (!Array.isArray(val)) {
    return undefined;
  }

  const len = val.length,
        parts = loc.split(':'),
        step = parts[2] && Number.parseInt(parts[2]) || 1;
  let start = parts[0] && Number.parseInt(parts[0]) || 0,
      end = parts[1] && Number.parseInt(parts[1]) || len;
  start = start < 0 ? Math.max(0, start + len) : Math.min(len, start);
  end = end < 0 ? Math.max(0, end + len) : Math.min(len, end);
  const ret = [];

  for (let i = start; i < end; i += step) {
    const tmp = this._trace(unshift(i, expr), val, path, parent, parentPropName, callback, true); // Should only be possible to be an array here since first part of
    //   ``unshift(i, expr)` passed in above would not be empty, nor `~`,
    //     nor begin with `@` (as could return objects)
    // This was causing excessive stack size in Node (with or
    //  without Babel) against our performance test: `ret.push(...tmp);`


    tmp.forEach(t => {
      ret.push(t);
    });
  }

  return ret;
};

JSONPath.prototype._eval = function (code, _v, _vname, path, parent, parentPropName) {
  this.currSandbox._$_parentProperty = parentPropName;
  this.currSandbox._$_parent = parent;
  this.currSandbox._$_property = _vname;
  this.currSandbox._$_root = this.json;
  this.currSandbox._$_v = _v;
  const containsPath = code.includes('@path');

  if (containsPath) {
    this.currSandbox._$_path = JSONPath.toPathString(path.concat([_vname]));
  }

  const scriptCacheKey = 'script:' + code;

  if (!JSONPath.cache[scriptCacheKey]) {
    let script = code.replace(/@parentProperty/gu, '_$_parentProperty').replace(/@parent/gu, '_$_parent').replace(/@property/gu, '_$_property').replace(/@root/gu, '_$_root').replace(/@([.\s)[])/gu, '_$_v$1');

    if (containsPath) {
      script = script.replace(/@path/gu, '_$_path');
    }

    JSONPath.cache[scriptCacheKey] = new this.vm.Script(script);
  }

  try {
    return JSONPath.cache[scriptCacheKey].runInNewContext(this.currSandbox);
  } catch (e) {
    throw new Error('jsonPath: ' + e.message + ': ' + code);
  }
}; // PUBLIC CLASS PROPERTIES AND METHODS
// Could store the cache object itself


JSONPath.cache = {};
/**
 * @param {string[]} pathArr Array to convert
 * @returns {string} The path string
 */

JSONPath.toPathString = function (pathArr) {
  const x = pathArr,
        n = x.length;
  let p = '$';

  for (let i = 1; i < n; i++) {
    if (!/^(~|\^|@.*?\(\))$/u.test(x[i])) {
      p += /^[0-9*]+$/u.test(x[i]) ? '[' + x[i] + ']' : "['" + x[i] + "']";
    }
  }

  return p;
};
/**
 * @param {string} pointer JSON Path
 * @returns {string} JSON Pointer
 */


JSONPath.toPointer = function (pointer) {
  const x = pointer,
        n = x.length;
  let p = '';

  for (let i = 1; i < n; i++) {
    if (!/^(~|\^|@.*?\(\))$/u.test(x[i])) {
      p += '/' + x[i].toString().replace(/~/gu, '~0').replace(/\//gu, '~1');
    }
  }

  return p;
};
/**
 * @param {string} expr Expression to convert
 * @returns {string[]}
 */


JSONPath.toPathArray = function (expr) {
  const {
    cache
  } = JSONPath;

  if (cache[expr]) {
    return cache[expr].concat();
  }

  const subx = [];
  const normalized = expr // Properties
  .replace(/@(?:null|boolean|number|string|integer|undefined|nonFinite|scalar|array|object|function|other)\(\)/gu, ';$&;') // Parenthetical evaluations (filtering and otherwise), directly
  //   within brackets or single quotes
  .replace(/[['](\??\(.*?\))[\]']/gu, function ($0, $1) {
    return '[#' + (subx.push($1) - 1) + ']';
  }) // Escape periods and tildes within properties
  .replace(/\[['"]([^'\]]*)['"]\]/gu, function ($0, prop) {
    return "['" + prop.replace(/\./gu, '%@%').replace(/~/gu, '%%@@%%') + "']";
  }) // Properties operator
  .replace(/~/gu, ';~;') // Split by property boundaries
  .replace(/['"]?\.['"]?(?![^[]*\])|\[['"]?/gu, ';') // Reinsert periods within properties
  .replace(/%@%/gu, '.') // Reinsert tildes within properties
  .replace(/%%@@%%/gu, '~') // Parent
  .replace(/(?:;)?(\^+)(?:;)?/gu, function ($0, ups) {
    return ';' + ups.split('').join(';') + ';';
  }) // Descendents
  .replace(/;;;|;;/gu, ';..;') // Remove trailing
  .replace(/;$|'?\]|'$/gu, '');
  const exprList = normalized.split(';').map(function (exp) {
    const match = exp.match(/#(\d+)/u);
    return !match || !match[1] ? exp : subx[match[1]];
  });
  cache[expr] = exprList;
  return cache[expr].concat();
};

JSONPath.prototype.vm = vm__default["default"];

indexNodeCjs.JSONPath = JSONPath;

Object.defineProperty(almanac, "__esModule", {
  value: true
});

var _typeof$2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass$n = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _fact$2 = fact;

var _fact2$2 = _interopRequireDefault$D(_fact$2);

var _errors = errors;

var _debug$1 = debug$1;

var _debug2$1 = _interopRequireDefault$D(_debug$1);

var _jsonpathPlus = indexNodeCjs;

var _lodash = lodash_isobjectlike;

var _lodash2 = _interopRequireDefault$D(_lodash);

function _interopRequireDefault$D(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$u(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function defaultPathResolver(value, path) {
  return (0, _jsonpathPlus.JSONPath)({ path: path, json: value, wrap: false });
}

/**
 * Fact results lookup
 * Triggers fact computations and saves the results
 * A new almanac is used for every engine run()
 */

var Almanac = function () {
  function Almanac() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck$u(this, Almanac);

    this.factMap = new Map();
    this.factResultsCache = new Map(); // { cacheKey:  Promise<factValu> }
    this.allowUndefinedFacts = Boolean(options.allowUndefinedFacts);
    this.pathResolver = options.pathResolver || defaultPathResolver;
    this.events = { success: [], failure: [] };
    this.ruleResults = [];
  }

  /**
   * Adds a success event
   * @param {Object} event
   */


  _createClass$n(Almanac, [{
    key: 'addEvent',
    value: function addEvent(event, outcome) {
      if (!outcome) throw new Error('outcome required: "success" | "failure"]');
      this.events[outcome].push(event);
    }

    /**
     * retrieve successful events
     */

  }, {
    key: 'getEvents',
    value: function getEvents() {
      var outcome = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (outcome) return this.events[outcome];
      return this.events.success.concat(this.events.failure);
    }

    /**
     * Adds a rule result
     * @param {Object} event
     */

  }, {
    key: 'addResult',
    value: function addResult(ruleResult) {
      this.ruleResults.push(ruleResult);
    }

    /**
     * retrieve successful events
     */

  }, {
    key: 'getResults',
    value: function getResults() {
      return this.ruleResults;
    }

    /**
     * Retrieve fact by id, raising an exception if it DNE
     * @param  {String} factId
     * @return {Fact}
     */

  }, {
    key: '_getFact',
    value: function _getFact(factId) {
      return this.factMap.get(factId);
    }

    /**
     * Registers fact with the almanac
     * @param {[type]} fact [description]
     */

  }, {
    key: '_addConstantFact',
    value: function _addConstantFact(fact) {
      this.factMap.set(fact.id, fact);
      this._setFactValue(fact, {}, fact.value);
    }

    /**
     * Sets the computed value of a fact
     * @param {Fact} fact
     * @param {Object} params - values for differentiating this fact value from others, used for cache key
     * @param {Mixed} value - computed value
     */

  }, {
    key: '_setFactValue',
    value: function _setFactValue(fact, params, value) {
      var cacheKey = fact.getCacheKey(params);
      var factValue = Promise.resolve(value);
      if (cacheKey) {
        this.factResultsCache.set(cacheKey, factValue);
      }
      return factValue;
    }

    /**
     * Add a fact definition to the engine.  Facts are called by rules as they are evaluated.
     * @param {object|Fact} id - fact identifier or instance of Fact
     * @param {function} definitionFunc - function to be called when computing the fact value for a given rule
     * @param {Object} options - options to initialize the fact with. used when "id" is not a Fact instance
     */

  }, {
    key: 'addFact',
    value: function addFact(id, valueOrMethod, options) {
      var factId = id;
      var fact = void 0;
      if (id instanceof _fact2$2.default) {
        factId = id.id;
        fact = id;
      } else {
        fact = new _fact2$2.default(id, valueOrMethod, options);
      }
      (0, _debug2$1.default)('almanac::addFact id:' + factId);
      this.factMap.set(factId, fact);
      if (fact.isConstant()) {
        this._setFactValue(fact, {}, fact.value);
      }
      return this;
    }

    /**
     * Adds a constant fact during runtime.  Can be used mid-run() to add additional information
     * @deprecated use addFact
     * @param {String} fact - fact identifier
     * @param {Mixed} value - constant value of the fact
     */

  }, {
    key: 'addRuntimeFact',
    value: function addRuntimeFact(factId, value) {
      (0, _debug2$1.default)('almanac::addRuntimeFact id:' + factId);
      var fact = new _fact2$2.default(factId, value);
      return this._addConstantFact(fact);
    }

    /**
     * Returns the value of a fact, based on the given parameters.  Utilizes the 'almanac' maintained
     * by the engine, which cache's fact computations based on parameters provided
     * @param  {string} factId - fact identifier
     * @param  {Object} params - parameters to feed into the fact.  By default, these will also be used to compute the cache key
     * @param  {String} path - object
     * @return {Promise} a promise which will resolve with the fact computation.
     */

  }, {
    key: 'factValue',
    value: function factValue(factId) {
      var _this = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      var factValuePromise = void 0;
      var fact = this._getFact(factId);
      if (fact === undefined) {
        if (this.allowUndefinedFacts) {
          return Promise.resolve(undefined);
        } else {
          return Promise.reject(new _errors.UndefinedFactError('Undefined fact: ' + factId));
        }
      }
      if (fact.isConstant()) {
        factValuePromise = Promise.resolve(fact.calculate(params, this));
      } else {
        var cacheKey = fact.getCacheKey(params);
        var cacheVal = cacheKey && this.factResultsCache.get(cacheKey);
        if (cacheVal) {
          factValuePromise = Promise.resolve(cacheVal);
          (0, _debug2$1.default)('almanac::factValue cache hit for fact:' + factId);
        } else {
          (0, _debug2$1.default)('almanac::factValue cache miss for fact:' + factId + '; calculating');
          factValuePromise = this._setFactValue(fact, params, fact.calculate(params, this));
        }
      }
      if (path) {
        (0, _debug2$1.default)('condition::evaluate extracting object property ' + path);
        return factValuePromise.then(function (factValue) {
          if ((0, _lodash2.default)(factValue)) {
            var pathValue = _this.pathResolver(factValue, path);
            (0, _debug2$1.default)('condition::evaluate extracting object property ' + path + ', received: ' + JSON.stringify(pathValue));
            return pathValue;
          } else {
            (0, _debug2$1.default)('condition::evaluate could not compute object path(' + path + ') of non-object: ' + factValue + ' <' + (typeof factValue === 'undefined' ? 'undefined' : _typeof$2(factValue)) + '>; continuing with ' + factValue);
            return factValue;
          }
        });
      }

      return factValuePromise;
    }

    /**
     * Interprets value as either a primitive, or if a fact, retrieves the fact value
     */

  }, {
    key: 'getValue',
    value: function getValue(value) {
      if ((0, _lodash2.default)(value) && Object.prototype.hasOwnProperty.call(value, 'fact')) {
        // value = { fact: 'xyz' }
        return this.factValue(value.fact, value.params, value.path);
      }
      return Promise.resolve(value);
    }
  }]);

  return Almanac;
}();

almanac.default = Almanac;

var engineDefaultOperators = {};

Object.defineProperty(engineDefaultOperators, "__esModule", {
  value: true
});

var _operator$2 = operator;

var _operator2$2 = _interopRequireDefault$C(_operator$2);

function _interopRequireDefault$C(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Operators = [];
Operators.push(new _operator2$2.default('equal', function (a, b) {
  return a === b;
}));
Operators.push(new _operator2$2.default('notEqual', function (a, b) {
  return a !== b;
}));
Operators.push(new _operator2$2.default('in', function (a, b) {
  return b.indexOf(a) > -1;
}));
Operators.push(new _operator2$2.default('notIn', function (a, b) {
  return b.indexOf(a) === -1;
}));

Operators.push(new _operator2$2.default('contains', function (a, b) {
  return a.indexOf(b) > -1;
}, Array.isArray));
Operators.push(new _operator2$2.default('doesNotContain', function (a, b) {
  return a.indexOf(b) === -1;
}, Array.isArray));

function numberValidator(factValue) {
  return Number.parseFloat(factValue).toString() !== 'NaN';
}
Operators.push(new _operator2$2.default('lessThan', function (a, b) {
  return a < b;
}, numberValidator));
Operators.push(new _operator2$2.default('lessThanInclusive', function (a, b) {
  return a <= b;
}, numberValidator));
Operators.push(new _operator2$2.default('greaterThan', function (a, b) {
  return a > b;
}, numberValidator));
Operators.push(new _operator2$2.default('greaterThanInclusive', function (a, b) {
  return a >= b;
}, numberValidator));

engineDefaultOperators.default = Operators;

Object.defineProperty(engine, "__esModule", {
  value: true
});
engine.FINISHED = engine.RUNNING = engine.READY = undefined;

var _typeof$1 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass$m = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _fact$1 = fact;

var _fact2$1 = _interopRequireDefault$B(_fact$1);

var _rule$1 = rule;

var _rule2$1 = _interopRequireDefault$B(_rule$1);

var _operator$1 = operator;

var _operator2$1 = _interopRequireDefault$B(_operator$1);

var _almanac$1 = almanac;

var _almanac2$1 = _interopRequireDefault$B(_almanac$1);

var _eventemitter = eventemitter2Exports;

var _eventemitter2 = _interopRequireDefault$B(_eventemitter);

var _engineDefaultOperators = engineDefaultOperators;

var _engineDefaultOperators2 = _interopRequireDefault$B(_engineDefaultOperators);

var _debug = debug$1;

var _debug2 = _interopRequireDefault$B(_debug);

var _condition = condition;

var _condition2 = _interopRequireDefault$B(_condition);

function _interopRequireDefault$B(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$t(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$o(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$o(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var READY = engine.READY = 'READY';
var RUNNING = engine.RUNNING = 'RUNNING';
var FINISHED = engine.FINISHED = 'FINISHED';

var Engine = function (_EventEmitter) {
  _inherits$o(Engine, _EventEmitter);

  /**
   * Returns a new Engine instance
   * @param  {Rule[]} rules - array of rules to initialize with
   */
  function Engine() {
    var rules = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck$t(this, Engine);

    var _this = _possibleConstructorReturn$o(this, (Engine.__proto__ || Object.getPrototypeOf(Engine)).call(this));

    _this.rules = [];
    _this.allowUndefinedFacts = options.allowUndefinedFacts || false;
    _this.allowUndefinedConditions = options.allowUndefinedConditions || false;
    _this.replaceFactsInEventParams = options.replaceFactsInEventParams || false;
    _this.pathResolver = options.pathResolver;
    _this.operators = new Map();
    _this.facts = new Map();
    _this.conditions = new Map();
    _this.status = READY;
    rules.map(function (r) {
      return _this.addRule(r);
    });
    _engineDefaultOperators2.default.map(function (o) {
      return _this.addOperator(o);
    });
    return _this;
  }

  /**
   * Add a rule definition to the engine
   * @param {object|Rule} properties - rule definition.  can be JSON representation, or instance of Rule
   * @param {integer} properties.priority (>1) - higher runs sooner.
   * @param {Object} properties.event - event to fire when rule evaluates as successful
   * @param {string} properties.event.type - name of event to emit
   * @param {string} properties.event.params - parameters to pass to the event listener
   * @param {Object} properties.conditions - conditions to evaluate when processing this rule
   */


  _createClass$m(Engine, [{
    key: 'addRule',
    value: function addRule(properties) {
      if (!properties) throw new Error('Engine: addRule() requires options');

      var rule = void 0;
      if (properties instanceof _rule2$1.default) {
        rule = properties;
      } else {
        if (!Object.prototype.hasOwnProperty.call(properties, 'event')) throw new Error('Engine: addRule() argument requires "event" property');
        if (!Object.prototype.hasOwnProperty.call(properties, 'conditions')) throw new Error('Engine: addRule() argument requires "conditions" property');
        rule = new _rule2$1.default(properties);
      }
      rule.setEngine(this);
      this.rules.push(rule);
      this.prioritizedRules = null;
      return this;
    }

    /**
     * update a rule in the engine
     * @param {object|Rule} rule - rule definition. Must be a instance of Rule
     */

  }, {
    key: 'updateRule',
    value: function updateRule(rule) {
      var ruleIndex = this.rules.findIndex(function (ruleInEngine) {
        return ruleInEngine.name === rule.name;
      });
      if (ruleIndex > -1) {
        this.rules.splice(ruleIndex, 1);
        this.addRule(rule);
        this.prioritizedRules = null;
      } else {
        throw new Error('Engine: updateRule() rule not found');
      }
    }

    /**
     * Remove a rule from the engine
     * @param {object|Rule|string} rule - rule definition. Must be a instance of Rule
     */

  }, {
    key: 'removeRule',
    value: function removeRule(rule) {
      var ruleRemoved = false;
      if (!(rule instanceof _rule2$1.default)) {
        var filteredRules = this.rules.filter(function (ruleInEngine) {
          return ruleInEngine.name !== rule;
        });
        ruleRemoved = filteredRules.length !== this.rules.length;
        this.rules = filteredRules;
      } else {
        var index = this.rules.indexOf(rule);
        if (index > -1) {
          ruleRemoved = Boolean(this.rules.splice(index, 1).length);
        }
      }
      if (ruleRemoved) {
        this.prioritizedRules = null;
      }
      return ruleRemoved;
    }

    /**
     * sets a condition that can be referenced by the given name.
     * If a condition with the given name has already been set this will replace it.
     * @param {string} name - the name of the condition to be referenced by rules.
     * @param {object} conditions - the conditions to use when the condition is referenced.
     */

  }, {
    key: 'setCondition',
    value: function setCondition(name, conditions) {
      if (!name) throw new Error('Engine: setCondition() requires name');
      if (!conditions) throw new Error('Engine: setCondition() requires conditions');
      if (!Object.prototype.hasOwnProperty.call(conditions, 'all') && !Object.prototype.hasOwnProperty.call(conditions, 'any') && !Object.prototype.hasOwnProperty.call(conditions, 'not') && !Object.prototype.hasOwnProperty.call(conditions, 'condition')) {
        throw new Error('"conditions" root must contain a single instance of "all", "any", "not", or "condition"');
      }
      this.conditions.set(name, new _condition2.default(conditions));
      return this;
    }

    /**
     * Removes a condition that has previously been added to this engine
     * @param {string} name - the name of the condition to remove.
     * @returns true if the condition existed, otherwise false
     */

  }, {
    key: 'removeCondition',
    value: function removeCondition(name) {
      return this.conditions.delete(name);
    }

    /**
     * Add a custom operator definition
     * @param {string}   operatorOrName - operator identifier within the condition; i.e. instead of 'equals', 'greaterThan', etc
     * @param {function(factValue, jsonValue)} callback - the method to execute when the operator is encountered.
     */

  }, {
    key: 'addOperator',
    value: function addOperator(operatorOrName, cb) {
      var operator = void 0;
      if (operatorOrName instanceof _operator2$1.default) {
        operator = operatorOrName;
      } else {
        operator = new _operator2$1.default(operatorOrName, cb);
      }
      (0, _debug2.default)('engine::addOperator name:' + operator.name);
      this.operators.set(operator.name, operator);
    }

    /**
     * Remove a custom operator definition
     * @param {string}   operatorOrName - operator identifier within the condition; i.e. instead of 'equals', 'greaterThan', etc
     * @param {function(factValue, jsonValue)} callback - the method to execute when the operator is encountered.
     */

  }, {
    key: 'removeOperator',
    value: function removeOperator(operatorOrName) {
      var operatorName = void 0;
      if (operatorOrName instanceof _operator2$1.default) {
        operatorName = operatorOrName.name;
      } else {
        operatorName = operatorOrName;
      }

      return this.operators.delete(operatorName);
    }

    /**
     * Add a fact definition to the engine.  Facts are called by rules as they are evaluated.
     * @param {object|Fact} id - fact identifier or instance of Fact
     * @param {function} definitionFunc - function to be called when computing the fact value for a given rule
     * @param {Object} options - options to initialize the fact with. used when "id" is not a Fact instance
     */

  }, {
    key: 'addFact',
    value: function addFact(id, valueOrMethod, options) {
      var factId = id;
      var fact = void 0;
      if (id instanceof _fact2$1.default) {
        factId = id.id;
        fact = id;
      } else {
        fact = new _fact2$1.default(id, valueOrMethod, options);
      }
      (0, _debug2.default)('engine::addFact id:' + factId);
      this.facts.set(factId, fact);
      return this;
    }

    /**
     * Remove a fact definition to the engine.  Facts are called by rules as they are evaluated.
     * @param {object|Fact} id - fact identifier or instance of Fact
     */

  }, {
    key: 'removeFact',
    value: function removeFact(factOrId) {
      var factId = void 0;
      if (!(factOrId instanceof _fact2$1.default)) {
        factId = factOrId;
      } else {
        factId = factOrId.id;
      }

      return this.facts.delete(factId);
    }

    /**
     * Iterates over the engine rules, organizing them by highest -> lowest priority
     * @return {Rule[][]} two dimensional array of Rules.
     *    Each outer array element represents a single priority(integer).  Inner array is
     *    all rules with that priority.
     */

  }, {
    key: 'prioritizeRules',
    value: function prioritizeRules() {
      if (!this.prioritizedRules) {
        var ruleSets = this.rules.reduce(function (sets, rule) {
          var priority = rule.priority;
          if (!sets[priority]) sets[priority] = [];
          sets[priority].push(rule);
          return sets;
        }, {});
        this.prioritizedRules = Object.keys(ruleSets).sort(function (a, b) {
          return Number(a) > Number(b) ? -1 : 1; // order highest priority -> lowest
        }).map(function (priority) {
          return ruleSets[priority];
        });
      }
      return this.prioritizedRules;
    }

    /**
     * Stops the rules engine from running the next priority set of Rules.  All remaining rules will be resolved as undefined,
     * and no further events emitted.  Since rules of the same priority are evaluated in parallel(not series), other rules of
     * the same priority may still emit events, even though the engine is in a "finished" state.
     * @return {Engine}
     */

  }, {
    key: 'stop',
    value: function stop() {
      this.status = FINISHED;
      return this;
    }

    /**
     * Returns a fact by fact-id
     * @param  {string} factId - fact identifier
     * @return {Fact} fact instance, or undefined if no such fact exists
     */

  }, {
    key: 'getFact',
    value: function getFact(factId) {
      return this.facts.get(factId);
    }

    /**
     * Runs an array of rules
     * @param  {Rule[]} array of rules to be evaluated
     * @return {Promise} resolves when all rules in the array have been evaluated
     */

  }, {
    key: 'evaluateRules',
    value: function evaluateRules(ruleArray, almanac) {
      var _this2 = this;

      return Promise.all(ruleArray.map(function (rule) {
        if (_this2.status !== RUNNING) {
          (0, _debug2.default)('engine::run status:' + _this2.status + '; skipping remaining rules');
          return Promise.resolve();
        }
        return rule.evaluate(almanac).then(function (ruleResult) {
          (0, _debug2.default)('engine::run ruleResult:' + ruleResult.result);
          almanac.addResult(ruleResult);
          if (ruleResult.result) {
            almanac.addEvent(ruleResult.event, 'success');
            return _this2.emitAsync('success', ruleResult.event, almanac, ruleResult).then(function () {
              return _this2.emitAsync(ruleResult.event.type, ruleResult.event.params, almanac, ruleResult);
            });
          } else {
            almanac.addEvent(ruleResult.event, 'failure');
            return _this2.emitAsync('failure', ruleResult.event, almanac, ruleResult);
          }
        });
      }));
    }

    /**
     * Runs the rules engine
     * @param  {Object} runtimeFacts - fact values known at runtime
     * @param  {Object} runOptions - run options
     * @return {Promise} resolves when the engine has completed running
     */

  }, {
    key: 'run',
    value: function run() {
      var _this3 = this;

      var runtimeFacts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var runOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      (0, _debug2.default)('engine::run started');
      this.status = RUNNING;

      var almanac = runOptions.almanac || new _almanac2$1.default({
        allowUndefinedFacts: this.allowUndefinedFacts,
        pathResolver: this.pathResolver
      });

      this.facts.forEach(function (fact) {
        almanac.addFact(fact);
      });
      for (var factId in runtimeFacts) {
        var fact = void 0;
        if (runtimeFacts[factId] instanceof _fact2$1.default) {
          fact = runtimeFacts[factId];
        } else {
          fact = new _fact2$1.default(factId, runtimeFacts[factId]);
        }

        almanac.addFact(fact);
        (0, _debug2.default)('engine::run initialized runtime fact:' + fact.id + ' with ' + fact.value + '<' + _typeof$1(fact.value) + '>');
      }
      var orderedSets = this.prioritizeRules();
      var cursor = Promise.resolve();
      // for each rule set, evaluate in parallel,
      // before proceeding to the next priority set.
      return new Promise(function (resolve, reject) {
        orderedSets.map(function (set) {
          cursor = cursor.then(function () {
            return _this3.evaluateRules(set, almanac);
          }).catch(reject);
          return cursor;
        });
        cursor.then(function () {
          _this3.status = FINISHED;
          (0, _debug2.default)('engine::run completed');
          var ruleResults = almanac.getResults();

          var _ruleResults$reduce = ruleResults.reduce(function (hash, ruleResult) {
            var group = ruleResult.result ? 'results' : 'failureResults';
            hash[group].push(ruleResult);
            return hash;
          }, { results: [], failureResults: [] }),
              results = _ruleResults$reduce.results,
              failureResults = _ruleResults$reduce.failureResults;

          resolve({
            almanac: almanac,
            results: results,
            failureResults: failureResults,
            events: almanac.getEvents('success'),
            failureEvents: almanac.getEvents('failure')
          });
        }).catch(reject);
      });
    }
  }]);

  return Engine;
}(_eventemitter2.default);

engine.default = Engine;

Object.defineProperty(jsonRulesEngine, "__esModule", {
  value: true
});
jsonRulesEngine.Almanac = jsonRulesEngine.Engine = jsonRulesEngine.Operator = jsonRulesEngine.Rule = jsonRulesEngine.Fact = undefined;

jsonRulesEngine.default = function (rules, options) {
  return new _engine2.default(rules, options);
};

var _engine = engine;

var _engine2 = _interopRequireDefault$A(_engine);

var _fact = fact;

var _fact2 = _interopRequireDefault$A(_fact);

var _rule = rule;

var _rule2 = _interopRequireDefault$A(_rule);

var _operator = operator;

var _operator2 = _interopRequireDefault$A(_operator);

var _almanac = almanac;

var _almanac2 = _interopRequireDefault$A(_almanac);

function _interopRequireDefault$A(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

jsonRulesEngine.Fact = _fact2.default;
jsonRulesEngine.Rule = _rule2.default;
jsonRulesEngine.Operator = _operator2.default;
jsonRulesEngine.Engine = _engine2.default;
jsonRulesEngine.Almanac = _almanac2.default;

var dist = jsonRulesEngine;

var se,pe="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},he={exports:{}},de=Math.floor,ge=Math.max,ve=Math.min,_calculateRatio=function(se,pe){return pe?2*se/pe:1},_arrayCmp=function(se,pe){var he,de,ge,ye,_e,be;for(_e=[se.length,pe.length],he=ye=0,be=ve(de=_e[0],ge=_e[1]);0<=be?ye<be:ye>be;he=0<=be?++ye:--ye){if(se[he]<pe[he])return -1;if(se[he]>pe[he])return 1}return de-ge},_has=function(se,pe){return Object.prototype.hasOwnProperty.call(se,pe)},ye=function(){function SequenceMatcher(se,pe,he,de){this.isjunk=se,null==pe&&(pe=""),null==he&&(he=""),this.autojunk=null==de||de,this.a=this.b=null,this.setSeqs(pe,he);}return SequenceMatcher.prototype.setSeqs=function(se,pe){return this.setSeq1(se),this.setSeq2(pe)},SequenceMatcher.prototype.setSeq1=function(se){if(se!==this.a)return this.a=se,this.matchingBlocks=this.opcodes=null},SequenceMatcher.prototype.setSeq2=function(se){if(se!==this.b)return this.b=se,this.matchingBlocks=this.opcodes=null,this.fullbcount=null,this._chainB()},SequenceMatcher.prototype._chainB=function(){var se,pe,he,ge,ve,ye,_e,be,me,xe,we,je,ke,Ee;for(se=this.b,this.b2j=pe={},ge=xe=0,je=se.length;xe<je;ge=++xe)he=se[ge],(_has(pe,he)?pe[he]:pe[he]=[]).push(ge);if(ye={},ve=this.isjunk)for(we=0,ke=(Ee=Object.keys(pe)).length;we<ke;we++)ve(he=Ee[we])&&(ye[he]=!0,delete pe[he]);if(me={},_e=se.length,this.autojunk&&_e>=200)for(he in be=de(_e/100)+1,pe)pe[he].length>be&&(me[he]=!0,delete pe[he]);return this.isbjunk=function(se){return _has(ye,se)},this.isbpopular=function(se){return _has(me,se)}},SequenceMatcher.prototype.findLongestMatch=function(se,pe,he,de){var ge,ve,ye,_e,be,me,xe,we,je,ke,Ee,Ae,Se,Oe,Re,Ce,Ie,ze,$e,Me,Ne;for(ge=(Ce=[this.a,this.b,this.b2j,this.isbjunk])[0],ve=Ce[1],ye=Ce[2],we=Ce[3],_e=(Ie=[se,he,0])[0],be=Ie[1],me=Ie[2],ke={},xe=Se=se;se<=pe?Se<pe:Se>pe;xe=se<=pe?++Se:--Se){for(Ae={},Oe=0,Re=(ze=_has(ye,ge[xe])?ye[ge[xe]]:[]).length;Oe<Re;Oe++)if(!((je=ze[Oe])<he)){if(je>=de)break;(Ee=Ae[je]=(ke[je-1]||0)+1)>me&&(_e=($e=[xe-Ee+1,je-Ee+1,Ee])[0],be=$e[1],me=$e[2]);}ke=Ae;}for(;_e>se&&be>he&&!we(ve[be-1])&&ge[_e-1]===ve[be-1];)_e=(Me=[_e-1,be-1,me+1])[0],be=Me[1],me=Me[2];for(;_e+me<pe&&be+me<de&&!we(ve[be+me])&&ge[_e+me]===ve[be+me];)me++;for(;_e>se&&be>he&&we(ve[be-1])&&ge[_e-1]===ve[be-1];)_e=(Ne=[_e-1,be-1,me+1])[0],be=Ne[1],me=Ne[2];for(;_e+me<pe&&be+me<de&&we(ve[be+me])&&ge[_e+me]===ve[be+me];)me++;return [_e,be,me]},SequenceMatcher.prototype.getMatchingBlocks=function(){var se,pe,he,de,ge,ve,ye,_e,be,me,xe,we,je,ke,Ee,Ae,Se,Oe,Re,Ce,Ie,ze,$e,Me,Ne,Pe;if(this.matchingBlocks)return this.matchingBlocks;for(Oe=[[0,ke=(ze=[this.a.length,this.b.length])[0],0,Ee=ze[1]]],Ae=[];Oe.length;)pe=($e=Oe.pop())[0],se=$e[1],de=$e[2],he=$e[3],ge=(Me=Re=this.findLongestMatch(pe,se,de,he))[0],_e=Me[1],(xe=Me[2])&&(Ae.push(Re),pe<ge&&de<_e&&Oe.push([pe,ge,de,_e]),ge+xe<se&&_e+xe<he&&Oe.push([ge+xe,se,_e+xe,he]));for(Ae.sort(_arrayCmp),ve=be=we=0,Se=[],Ce=0,Ie=Ae.length;Ce<Ie;Ce++)ye=(Ne=Ae[Ce])[0],me=Ne[1],je=Ne[2],ve+we===ye&&be+we===me?we+=je:(we&&Se.push([ve,be,we]),ve=(Pe=[ye,me,je])[0],be=Pe[1],we=Pe[2]);return we&&Se.push([ve,be,we]),Se.push([ke,Ee,0]),this.matchingBlocks=Se},SequenceMatcher.prototype.getOpcodes=function(){var se,pe,he,de,ge,ve,ye,_e,be,me,xe,we;if(this.opcodes)return this.opcodes;for(de=ge=0,this.opcodes=pe=[],_e=0,be=(me=this.getMatchingBlocks()).length;_e<be;_e++)se=(xe=me[_e])[0],he=xe[1],ve=xe[2],ye="",de<se&&ge<he?ye="replace":de<se?ye="delete":ge<he&&(ye="insert"),ye&&pe.push([ye,de,se,ge,he]),de=(we=[se+ve,he+ve])[0],ge=we[1],ve&&pe.push(["equal",se,de,he,ge]);return pe},SequenceMatcher.prototype.getGroupedOpcodes=function(se){var pe,he,de,ye,_e,be,me,xe,we,je,ke,Ee,Ae,Se,Oe;for(null==se&&(se=3),(pe=this.getOpcodes()).length||(pe=[["equal",0,1,0,1]]),"equal"===pe[0][0]&&(we=(Ee=pe[0])[0],ye=Ee[1],_e=Ee[2],be=Ee[3],me=Ee[4],pe[0]=[we,ge(ye,_e-se),_e,ge(be,me-se),me]),"equal"===pe[pe.length-1][0]&&(we=(Ae=pe[pe.length-1])[0],ye=Ae[1],_e=Ae[2],be=Ae[3],me=Ae[4],pe[pe.length-1]=[we,ye,ve(_e,ye+se),be,ve(me,be+se)]),xe=se+se,de=[],he=[],je=0,ke=pe.length;je<ke;je++)we=(Se=pe[je])[0],ye=Se[1],_e=Se[2],be=Se[3],me=Se[4],"equal"===we&&_e-ye>xe&&(he.push([we,ye,ve(_e,ye+se),be,ve(me,be+se)]),de.push(he),he=[],ye=(Oe=[ge(ye,_e-se),ge(be,me-se)])[0],be=Oe[1]),he.push([we,ye,_e,be,me]);return !he.length||1===he.length&&"equal"===he[0][0]||de.push(he),de},SequenceMatcher.prototype.ratio=function(){var se,pe,he,de;for(se=0,pe=0,he=(de=this.getMatchingBlocks()).length;pe<he;pe++)se+=de[pe][2];return _calculateRatio(se,this.a.length+this.b.length)},SequenceMatcher.prototype.quickRatio=function(){var se,pe,he,de,ge,ve,ye,_e,be,me,xe;if(!this.fullbcount)for(this.fullbcount=he={},ve=0,_e=(me=this.b).length;ve<_e;ve++)he[pe=me[ve]]=(he[pe]||0)+1;for(he=this.fullbcount,se={},de=0,ye=0,be=(xe=this.a).length;ye<be;ye++)pe=xe[ye],ge=_has(se,pe)?se[pe]:he[pe]||0,se[pe]=ge-1,ge>0&&de++;return _calculateRatio(de,this.a.length+this.b.length)},SequenceMatcher.prototype.realQuickRatio=function(){var se,pe,he;return he=[this.a.length,this.b.length],_calculateRatio(ve(se=he[0],pe=he[1]),se+pe)},SequenceMatcher}(),_e={exports:{}};se=_e,function(){var pe,he,de,ge,ve,ye,_e,be,me,xe,we,je,ke,Ee,Ae;de=Math.floor,xe=Math.min,he=function(se,pe){return se<pe?-1:se>pe?1:0},me=function(se,pe,ge,ve,ye){var _e;if(null==ge&&(ge=0),null==ye&&(ye=he),ge<0)throw new Error("lo must be non-negative");for(null==ve&&(ve=se.length);ge<ve;)ye(pe,se[_e=de((ge+ve)/2)])<0?ve=_e:ge=_e+1;return [].splice.apply(se,[ge,ge-ge].concat(pe)),pe},ye=function(se,pe,de){return null==de&&(de=he),se.push(pe),Ee(se,0,se.length-1,de)},ve=function(se,pe){var de,ge;return null==pe&&(pe=he),de=se.pop(),se.length?(ge=se[0],se[0]=de,Ae(se,0,pe)):ge=de,ge},be=function(se,pe,de){var ge;return null==de&&(de=he),ge=se[0],se[0]=pe,Ae(se,0,de),ge},_e=function(se,pe,de){var ge;return null==de&&(de=he),se.length&&de(se[0],pe)<0&&(pe=(ge=[se[0],pe])[0],se[0]=ge[1],Ae(se,0,de)),pe},ge=function(se,pe){var ge,ve,ye,_e,be,me;for(null==pe&&(pe=he),be=[],ve=0,ye=(_e=function(){me=[];for(var pe=0,he=de(se.length/2);0<=he?pe<he:pe>he;0<=he?pe++:pe--)me.push(pe);return me}.apply(this).reverse()).length;ve<ye;ve++)ge=_e[ve],be.push(Ae(se,ge,pe));return be},ke=function(se,pe,de){var ge;if(null==de&&(de=he),-1!==(ge=se.indexOf(pe)))return Ee(se,0,ge,de),Ae(se,ge,de)},we=function(se,pe,de){var ve,ye,be,me,xe;if(null==de&&(de=he),!(ye=se.slice(0,pe)).length)return ye;for(ge(ye,de),be=0,me=(xe=se.slice(pe)).length;be<me;be++)ve=xe[be],_e(ye,ve,de);return ye.sort(de).reverse()},je=function(se,pe,de){var ye,_e,be,we,je,ke,Ee,Ae,Se;if(null==de&&(de=he),10*pe<=se.length){if(!(be=se.slice(0,pe).sort(de)).length)return be;for(_e=be[be.length-1],we=0,ke=(Ee=se.slice(pe)).length;we<ke;we++)de(ye=Ee[we],_e)<0&&(me(be,ye,0,null,de),be.pop(),_e=be[be.length-1]);return be}for(ge(se,de),Se=[],je=0,Ae=xe(pe,se.length);0<=Ae?je<Ae:je>Ae;0<=Ae?++je:--je)Se.push(ve(se,de));return Se},Ee=function(se,pe,de,ge){var ve,ye,_e;for(null==ge&&(ge=he),ve=se[de];de>pe&&ge(ve,ye=se[_e=de-1>>1])<0;)se[de]=ye,de=_e;return se[de]=ve},Ae=function(se,pe,de){var ge,ve,ye,_e,be;for(null==de&&(de=he),ve=se.length,be=pe,ye=se[pe],ge=2*pe+1;ge<ve;)(_e=ge+1)<ve&&!(de(se[ge],se[_e])<0)&&(ge=_e),se[pe]=se[ge],ge=2*(pe=ge)+1;return se[pe]=ye,Ee(se,be,pe,de)},pe=function(){function Heap(se){this.cmp=null!=se?se:he,this.nodes=[];}return Heap.push=ye,Heap.pop=ve,Heap.replace=be,Heap.pushpop=_e,Heap.heapify=ge,Heap.updateItem=ke,Heap.nlargest=we,Heap.nsmallest=je,Heap.prototype.push=function(se){return ye(this.nodes,se,this.cmp)},Heap.prototype.pop=function(){return ve(this.nodes,this.cmp)},Heap.prototype.peek=function(){return this.nodes[0]},Heap.prototype.contains=function(se){return -1!==this.nodes.indexOf(se)},Heap.prototype.replace=function(se){return be(this.nodes,se,this.cmp)},Heap.prototype.pushpop=function(se){return _e(this.nodes,se,this.cmp)},Heap.prototype.heapify=function(){return ge(this.nodes,this.cmp)},Heap.prototype.updateItem=function(se){return ke(this.nodes,se,this.cmp)},Heap.prototype.clear=function(){return this.nodes=[]},Heap.prototype.empty=function(){return 0===this.nodes.length},Heap.prototype.size=function(){return this.nodes.length},Heap.prototype.clone=function(){var se;return (se=new Heap).nodes=this.nodes.slice(0),se},Heap.prototype.toArray=function(){return this.nodes.slice(0)},Heap.prototype.insert=Heap.prototype.push,Heap.prototype.top=Heap.prototype.peek,Heap.prototype.front=Heap.prototype.peek,Heap.prototype.has=Heap.prototype.contains,Heap.prototype.copy=Heap.prototype.clone,Heap}(),se.exports=pe;}.call(pe);var be,me,xe,we=_e.exports,je={exports:{}};
/**
 * @license
 * Lodash (Custom Build) lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 * Build: `lodash include="intersection,difference,uniq,intersectionWith,differenceWith,uniqWith,toArray,partialRight,keys,isArray,forEach,orderBy" -p -o ./lib/lodash.custom.min.js`
 */
!function(se,he){(function(){function t(se,pe,he){switch(he.length){case 0:return se.call(pe);case 1:return se.call(pe,he[0]);case 2:return se.call(pe,he[0],he[1]);case 3:return se.call(pe,he[0],he[1],he[2])}return se.apply(pe,he)}function e(se,pe){for(var he=-1,de=null==se?0:se.length;++he<de&&!1!==pe(se[he],he,se););return se}function n(se,pe){var he;if(he=!(null==se||!se.length)){if(pe==pe)e:{he=-1;for(var de=se.length;++he<de;)if(se[he]===pe)break e;he=-1;}else e:{he=f;de=se.length;for(var ge=-1;++ge<de;)if(he(se[ge],ge,se)){he=ge;break e}he=-1;}he=-1<he;}return he}function u(se,pe,he){for(var de=-1,ge=null==se?0:se.length;++de<ge;)if(he(pe,se[de]))return !0;return !1}function o(se,pe){for(var he=-1,de=null==se?0:se.length,ge=Array(de);++he<de;)ge[he]=pe(se[he],he,se);return ge}function i(se,pe){for(var he=-1,de=pe.length,ge=se.length;++he<de;)se[ge+he]=pe[he];return se}function c(se,pe){for(var he=-1,de=null==se?0:se.length;++he<de;)if(pe(se[he],he,se))return !0;return !1}function f(se){return se!=se}function s(se){return function(pe){return se(pe)}}function b(se,pe){return se.has(pe)}function p(se){var pe=-1,he=Array(se.size);return se.forEach((function(se,de){he[++pe]=[de,se];})),he}function y(se){var pe=Object;return function(he){return se(pe(he))}}function _(se,pe){for(var he=-1,de=se.length,ge=0,ve=[];++he<de;){var ye=se[he];ye!==pe&&"__lodash_placeholder__"!==ye||(se[he]="__lodash_placeholder__",ve[ge++]=he);}return ve}function g(se){var pe=-1,he=Array(se.size);return se.forEach((function(se){he[++pe]=se;})),he}function v(){}function d(se){this.__wrapped__=se,this.__actions__=[],this.__dir__=1,this.__filtered__=!1,this.__iteratees__=[],this.__takeCount__=4294967295,this.__views__=[];}function j(se){var pe=-1,he=null==se?0:se.length;for(this.clear();++pe<he;){var de=se[pe];this.set(de[0],de[1]);}}function w(se){var pe=-1,he=null==se?0:se.length;for(this.clear();++pe<he;){var de=se[pe];this.set(de[0],de[1]);}}function A(se){var pe=-1,he=null==se?0:se.length;for(this.clear();++pe<he;){var de=se[pe];this.set(de[0],de[1]);}}function m(se){var pe=-1,he=null==se?0:se.length;for(this.__data__=new A;++pe<he;)this.add(se[pe]);}function O(se){this.size=(this.__data__=new w(se)).size;}function S(se,pe){var he=tn(se),de=!he&&en(se),ge=!he&&!de&&rn(se),ve=!he&&!de&&!ge&&an(se);if(he=he||de||ge||ve){de=se.length;for(var ye=String,_e=-1,be=Array(de);++_e<de;)be[_e]=ye(_e);de=be;}else de=[];var me;ye=de.length;for(me in se)!pe&&!Ke.call(se,me)||he&&("length"==me||ge&&("offset"==me||"parent"==me)||ve&&("buffer"==me||"byteLength"==me||"byteOffset"==me)||xt(me,ye))||de.push(me);return de}function k(se,pe,he){var ge=se[pe];Ke.call(se,pe)&&Ct(ge,he)&&(he!==de||pe in se)||F(se,pe,he);}function x(se,pe){for(var he=se.length;he--;)if(Ct(se[he][0],pe))return he;return -1}function F(se,pe,he){"__proto__"==pe&&hr?hr(se,pe,{configurable:!0,enumerable:!0,value:he,writable:!0}):se[pe]=he;}function I(se,pe,he,ge,ve,ye){var _e,be=1&pe,me=2&pe,xe=4&pe;if(he&&(_e=ve?he(se,ge,ve,ye):he(se)),_e!==de)return _e;if(!qt(se))return se;if(ge=tn(se)){if(_e=function Ot(se){var pe=se.length,he=new se.constructor(pe);return pe&&"string"==typeof se[0]&&Ke.call(se,"index")&&(he.index=se.index,he.input=se.input),he}(se),!be)return ot(se,_e)}else {var we=Ur(se),je="[object Function]"==we||"[object GeneratorFunction]"==we;if(rn(se))return function et(se,pe){if(pe)return se.slice();var he=se.length;he=ar?ar(he):new se.constructor(he);return se.copy(he),he}(se,be);if("[object Object]"==we||"[object Arguments]"==we||je&&!ve){if(_e=me||je||"function"!=typeof se.constructor||Et(se)?{}:Fr(ir(se)),!be)return me?function ft(se,pe){return it(se,Hr(se),pe)}(se,function E(se,pe){return se&&it(pe,re(pe),se)}(_e,se)):function ct(se,pe){return it(se,Lr(se),pe)}(se,function z(se,pe){return se&&it(pe,ee(pe),se)}(_e,se))}else {if(!Ne[we])return ve?se:{};_e=function St(se,pe,he){var de=se.constructor;switch(pe){case"[object ArrayBuffer]":return rt(se);case"[object Boolean]":case"[object Date]":return new de(+se);case"[object DataView]":return pe=he?rt(se.buffer):se.buffer,new se.constructor(pe,se.byteOffset,se.byteLength);case"[object Float32Array]":case"[object Float64Array]":case"[object Int8Array]":case"[object Int16Array]":case"[object Int32Array]":case"[object Uint8Array]":case"[object Uint8ClampedArray]":case"[object Uint16Array]":case"[object Uint32Array]":return pe=he?rt(se.buffer):se.buffer,new se.constructor(pe,se.byteOffset,se.length);case"[object Map]":return new de;case"[object Number]":case"[object String]":return new de(se);case"[object RegExp]":return (pe=new se.constructor(se.source,Ae.exec(se))).lastIndex=se.lastIndex,pe;case"[object Set]":return new de;case"[object Symbol]":return Nr?Object(Nr.call(se)):{}}}(se,we,be);}}if(ye||(ye=new O),ve=ye.get(se))return ve;if(ye.set(se,_e),on(se))return se.forEach((function(de){_e.add(I(de,pe,he,de,se,ye));})),_e;if(nn(se))return se.forEach((function(de,ge){_e.set(ge,I(de,pe,he,ge,se,ye));})),_e;me=xe?me?vt:gt:me?re:ee;var ke=ge?de:me(se);return e(ke||se,(function(de,ge){ke&&(de=se[ge=de]),k(_e,ge,I(de,pe,he,ge,se,ye));})),_e}function M(se,pe,he,de){var ge=-1,ve=n,ye=!0,_e=se.length,be=[],me=pe.length;if(!_e)return be;he&&(pe=o(pe,s(he))),de?(ve=u,ye=!1):200<=pe.length&&(ve=b,ye=!1,pe=new m(pe));e:for(;++ge<_e;){var xe=se[ge],we=null==he?xe:he(xe);xe=de||0!==xe?xe:0;if(ye&&we==we){for(var je=me;je--;)if(pe[je]===we)continue e;be.push(xe);}else ve(pe,we,de)||be.push(xe);}return be}function $(se,pe,he,de,ge){var ve=-1,ye=se.length;for(he||(he=kt),ge||(ge=[]);++ve<ye;){var _e=se[ve];0<pe&&he(_e)?1<pe?$(_e,pe-1,he,de,ge):i(ge,_e):de||(ge[ge.length]=_e);}return ge}function U(se,pe){for(var he=0,ge=(pe=tt(pe,se)).length;null!=se&&he<ge;)se=se[Ut(pe[he++])];return he&&he==ge?se:de}function B(se,pe,he){return pe=pe(se),tn(se)?pe:i(pe,he(se))}function D(se){if(null==se)se=se===de?"[object Undefined]":"[object Null]";else if(pr&&pr in Object(se)){var pe=Ke.call(se,pr),he=se[pr];try{se[pr]=de;var ge=!0;}catch(se){}var ve=er.call(se);ge&&(pe?se[pr]=he:delete se[pr]),se=ve;}else se=er.call(se);return se}function R(se,pe,he){for(var ge=he?u:n,ve=se[0].length,ye=se.length,_e=ye,be=Array(ye),me=1/0,xe=[];_e--;){var we=se[_e];_e&&pe&&(we=o(we,s(pe))),me=_r(we.length,me),be[_e]=!he&&(pe||120<=ve&&120<=we.length)?new m(_e&&we):de;}we=se[0];var je=-1,ke=be[0];e:for(;++je<ve&&xe.length<me;){var Ee=we[je],Ae=pe?pe(Ee):Ee;Ee=he||0!==Ee?Ee:0;if(ke?!b(ke,Ae):!ge(xe,Ae,he)){for(_e=ye;--_e;){var Se=be[_e];if(Se?!b(Se,Ae):!ge(se[_e],Ae,he))continue e}ke&&ke.push(Ae),xe.push(Ee);}}return xe}function L(se){return Gt(se)&&"[object Arguments]"==D(se)}function P(se,pe,he,ge,ve){if(se===pe)pe=!0;else if(null==se||null==pe||!Gt(se)&&!Gt(pe))pe=se!=se&&pe!=pe;else e:{var ye,_e,be=tn(se),me=tn(pe),xe="[object Object]"==(ye="[object Arguments]"==(ye=be?"[object Array]":Ur(se))?"[object Object]":ye);me="[object Object]"==(_e="[object Arguments]"==(_e=me?"[object Array]":Ur(pe))?"[object Object]":_e);if((_e=ye==_e)&&rn(se)){if(!rn(pe)){pe=!1;break e}be=!0,xe=!1;}if(_e&&!xe)ve||(ve=new O),pe=be||an(se)?yt(se,pe,he,ge,P,ve):_t(se,pe,ye,he,ge,P,ve);else {if(!(1&he)&&(be=xe&&Ke.call(se,"__wrapped__"),ye=me&&Ke.call(pe,"__wrapped__"),be||ye)){se=be?se.value():se,pe=ye?pe.value():pe,ve||(ve=new O),pe=P(se,pe,he,ge,ve);break e}if(_e)t:if(ve||(ve=new O),be=1&he,ye=gt(se),me=ye.length,_e=gt(pe).length,me==_e||be){for(xe=me;xe--;){var we=ye[xe];if(!(be?we in pe:Ke.call(pe,we))){pe=!1;break t}}if((_e=ve.get(se))&&ve.get(pe))pe=_e==pe;else {_e=!0,ve.set(se,pe),ve.set(pe,se);for(var je=be;++xe<me;){var ke=se[we=ye[xe]],Ee=pe[we];if(ge)var Ae=be?ge(Ee,ke,we,pe,se,ve):ge(ke,Ee,we,se,pe,ve);if(Ae===de?ke!==Ee&&!P(ke,Ee,he,ge,ve):!Ae){_e=!1;break}je||(je="constructor"==we);}_e&&!je&&((he=se.constructor)!=(ge=pe.constructor)&&"constructor"in se&&"constructor"in pe&&!("function"==typeof he&&he instanceof he&&"function"==typeof ge&&ge instanceof ge)&&(_e=!1)),ve.delete(se),ve.delete(pe),pe=_e;}}else pe=!1;else pe=!1;}}return pe}function W(se){return "function"==typeof se?se:null==se?oe:"object"==typeof se?tn(se)?function K(se,pe){return zt(se)&&pe==pe&&!qt(pe)?Ft(Ut(se),pe):function(he){var ge=Zt(he,se);return ge===de&&ge===pe?te(he,se):P(pe,ge,3)}}(se[0],se[1]):function G(se){var pe=function At(se){for(var pe=ee(se),he=pe.length;he--;){var de=pe[he],ge=se[de];pe[he]=[de,ge,ge==ge&&!qt(ge)];}return pe}(se);return 1==pe.length&&pe[0][2]?Ft(pe[0][0],pe[0][1]):function(he){return he===se||function N(se,pe){var he=pe.length,ge=he;if(null==se)return !ge;for(se=Object(se);he--;)if((ve=pe[he])[2]?ve[1]!==se[ve[0]]:!(ve[0]in se))return !1;for(;++he<ge;){var ve,ye=(ve=pe[he])[0],_e=se[ye],be=ve[1];if(ve[2]){if(_e===de&&!(ye in se))return !1}else if(!P(be,_e,3,void 0,ve=new O))return !1}return !0}(he,pe)}}(se):fe(se)}function H(se,pe,he){var ge=-1;return pe=o(pe.length?pe:[oe],s(jt())),function l(se,pe){var he=se.length;for(se.sort(pe);he--;)se[he]=se[he].c;return se}(se=function q(se,pe){var he=-1,de=Nt(se)?Array(se.length):[];return Dr(se,(function(se,ge,ve){de[++he]=pe(se,ge,ve);})),de}(se,(function(se){return {a:o(pe,(function(pe){return pe(se)})),b:++ge,c:se}})),(function(se,pe){var ge;e:{ge=-1;for(var ve=se.a,ye=pe.a,_e=ve.length,be=he.length;++ge<_e;){var me;t:{me=ve[ge];var xe=ye[ge];if(me!==xe){var we=me!==de,je=null===me,ke=me==me,Ee=Ht(me),Ae=xe!==de,Se=null===xe,Oe=xe==xe,Re=Ht(xe);if(!Se&&!Re&&!Ee&&me>xe||Ee&&Ae&&Oe&&!Se&&!Re||je&&Ae&&Oe||!we&&Oe||!ke){me=1;break t}if(!je&&!Ee&&!Re&&me<xe||Re&&we&&ke&&!je&&!Ee||Se&&we&&ke||!Ae&&ke||!Oe){me=-1;break t}}me=0;}if(me){ge=ge>=be?me:me*("desc"==he[ge]?-1:1);break e}}ge=se.b-pe.b;}return ge}))}function Q(se){return Gr(It(se,oe),se+"")}function X(se){if("string"==typeof se)return se;if(tn(se))return o(se,X)+"";if(Ht(se))return Pr?Pr.call(se):"";var pe=se+"";return "0"==pe&&1/se==-ge?"-0":pe}function Y(se,pe,he){var de=-1,ge=n,ve=se.length,ye=!0,_e=[],be=_e;if(he)ye=!1,ge=u;else if(200<=ve){if(ge=pe?null:Xr(se))return g(ge);ye=!1,ge=b,be=new m;}else be=pe?[]:_e;e:for(;++de<ve;){var me=se[de],xe=pe?pe(me):me;me=he||0!==me?me:0;if(ye&&xe==xe){for(var we=be.length;we--;)if(be[we]===xe)continue e;pe&&be.push(xe),_e.push(me);}else ge(be,xe,he)||(be!==_e&&be.push(xe),_e.push(me));}return _e}function Z(se){return Tt(se)?se:[]}function tt(se,pe){return tn(se)?se:zt(se,pe)?[se]:Qr(Yt(se))}function rt(se){var pe=new se.constructor(se.byteLength);return new or(pe).set(new or(se)),pe}function nt(se,pe,he,de){var ge=-1,ve=se.length,ye=he.length,_e=-1,be=pe.length,me=yr(ve-ye,0),xe=Array(be+me);for(de=!de;++_e<be;)xe[_e]=pe[_e];for(;++ge<ye;)(de||ge<ve)&&(xe[he[ge]]=se[ge]);for(;me--;)xe[_e++]=se[ge++];return xe}function ut(se,pe,he,de){var ge=-1,ve=se.length,ye=-1,_e=he.length,be=-1,me=pe.length,xe=yr(ve-_e,0),we=Array(xe+me);for(de=!de;++ge<xe;)we[ge]=se[ge];for(xe=ge;++be<me;)we[xe+be]=pe[be];for(;++ye<_e;)(de||ge<ve)&&(we[xe+he[ye]]=se[ge++]);return we}function ot(se,pe){var he=-1,de=se.length;for(pe||(pe=Array(de));++he<de;)pe[he]=se[he];return pe}function it(se,pe,he){var ge=!he;he||(he={});for(var ve=-1,ye=pe.length;++ve<ye;){var _e=pe[ve],be=de;be===de&&(be=se[_e]),ge?F(he,_e,be):k(he,_e,be);}return he}function lt(se){return function(){switch((pe=arguments).length){case 0:return new se;case 1:return new se(pe[0]);case 2:return new se(pe[0],pe[1]);case 3:return new se(pe[0],pe[1],pe[2]);case 4:return new se(pe[0],pe[1],pe[2],pe[3]);case 5:return new se(pe[0],pe[1],pe[2],pe[3],pe[4]);case 6:return new se(pe[0],pe[1],pe[2],pe[3],pe[4],pe[5]);case 7:return new se(pe[0],pe[1],pe[2],pe[3],pe[4],pe[5],pe[6])}var pe,he=Fr(se.prototype);return qt(pe=se.apply(he,pe))?pe:he}}function st(se,pe,he){var ge=lt(se);return function u(){for(var ve=arguments.length,ye=Array(ve),_e=ve,be=dt(u);_e--;)ye[_e]=arguments[_e];return (ve-=(_e=3>ve&&ye[0]!==be&&ye[ve-1]!==be?[]:_(ye,be)).length)<he?pt(se,pe,ht,u.placeholder,de,ye,_e,de,de,he-ve):t(this&&this!==Xe&&this instanceof u?ge:se,this,ye)}}function ht(se,pe,he,ge,ve,ye,_e,be,me,xe){var we=128&pe,je=1&pe,ke=2&pe,Ee=24&pe,Ae=512&pe,Se=ke?de:lt(se);return function l(){for(var Oe=arguments.length,Re=Array(Oe),Ce=Oe;Ce--;)Re[Ce]=arguments[Ce];if(Ee){var Ie,ze=dt(l);Ce=Re.length;for(Ie=0;Ce--;)Re[Ce]===ze&&++Ie;}if(ge&&(Re=nt(Re,ge,ve,Ee)),ye&&(Re=ut(Re,ye,_e,Ee)),Oe-=Ie,Ee&&Oe<xe)return ze=_(Re,ze),pt(se,pe,ht,l.placeholder,he,Re,ze,be,me,xe-Oe);if(ze=je?he:this,Ce=ke?ze[se]:se,Oe=Re.length,be){Ie=Re.length;for(var $e=_r(be.length,Ie),Me=ot(Re);$e--;){var Ne=be[$e];Re[$e]=xt(Ne,Ie)?Me[Ne]:de;}}else Ae&&1<Oe&&Re.reverse();return we&&me<Oe&&(Re.length=me),this&&this!==Xe&&this instanceof l&&(Ce=Se||lt(Ce)),Ce.apply(ze,Re)}}function bt(se,pe,he,de){var ge=1&pe,ve=lt(se);return function o(){for(var pe=-1,ye=arguments.length,_e=-1,be=de.length,me=Array(be+ye),xe=this&&this!==Xe&&this instanceof o?ve:se;++_e<be;)me[_e]=de[_e];for(;ye--;)me[_e++]=arguments[++pe];return t(xe,ge?he:this,me)}}function pt(se,pe,he,ge,ve,ye,_e,be,me,xe){var we=8&pe,je=we?_e:de;4&(pe=(pe|(we?32:64))&~(we?64:32))||(pe&=-4),ve=[se,pe,ve,we?ye:de,je,ye=we?de:ye,_e=we?de:_e,be,me,xe],he=he.apply(de,ve);e:for(be=se.name+"",me=Sr[be],xe=Ke.call(Sr,be)?me.length:0;xe--;)if(we=me[xe],je=we.func,null==je||je==se){be=we.name;break e}return "function"==typeof(me=v[be])&&be in d.prototype?se===me?be=!0:be=!!(be=Br(me))&&se===be[0]:be=!1,be&&Wr(he,ve),he.placeholder=ge,Mt(he,se,pe)}function yt(se,pe,he,ge,ve,ye){var _e=1&he,be=se.length;if(be!=(me=pe.length)&&!(_e&&me>be))return !1;if((me=ye.get(se))&&ye.get(pe))return me==pe;var me=-1,xe=!0,we=2&he?new m:de;for(ye.set(se,pe),ye.set(pe,se);++me<be;){var je=se[me],ke=pe[me];if(ge)var Ee=_e?ge(ke,je,me,pe,se,ye):ge(je,ke,me,se,pe,ye);if(Ee!==de){if(Ee)continue;xe=!1;break}if(we){if(!c(pe,(function(se,pe){if(!b(we,pe)&&(je===se||ve(je,se,he,ge,ye)))return we.push(pe)}))){xe=!1;break}}else if(je!==ke&&!ve(je,ke,he,ge,ye)){xe=!1;break}}return ye.delete(se),ye.delete(pe),xe}function _t(se,pe,he,de,ge,ve,ye){switch(he){case"[object DataView]":if(se.byteLength!=pe.byteLength||se.byteOffset!=pe.byteOffset)break;se=se.buffer,pe=pe.buffer;case"[object ArrayBuffer]":if(se.byteLength!=pe.byteLength||!ve(new or(se),new or(pe)))break;return !0;case"[object Boolean]":case"[object Date]":case"[object Number]":return Ct(+se,+pe);case"[object Error]":return se.name==pe.name&&se.message==pe.message;case"[object RegExp]":case"[object String]":return se==pe+"";case"[object Map]":var _e=p;case"[object Set]":if(_e||(_e=g),se.size!=pe.size&&!(1&de))break;return (he=ye.get(se))?he==pe:(de|=2,ye.set(se,pe),pe=yt(_e(se),_e(pe),de,ge,ve,ye),ye.delete(se),pe);case"[object Symbol]":if(Nr)return Nr.call(se)==Nr.call(pe)}return !1}function gt(se){return B(se,ee,Lr)}function vt(se){return B(se,re,Hr)}function dt(se){return (Ke.call(v,"placeholder")?v:se).placeholder}function jt(){var se=(se=v.iteratee||ie)===ie?W:se;return arguments.length?se(arguments[0],arguments[1]):se}function wt(se,pe){var he=se.__data__,de=typeof pe;return ("string"==de||"number"==de||"symbol"==de||"boolean"==de?"__proto__"!==pe:null===pe)?he["string"==typeof pe?"string":"hash"]:he.map}function mt(se,pe){var he=null==se?de:se[pe];return !qt(he)||Je&&Je in he||!(Vt(he)?tr:Re).test(Bt(he))?de:he}function kt(se){return tn(se)||en(se)||!!(lr&&se&&se[lr])}function xt(se,pe){var he=typeof se;return !!(pe=null==pe?9007199254740991:pe)&&("number"==he||"symbol"!=he&&Ie.test(se))&&-1<se&&0==se%1&&se<pe}function zt(se,pe){if(tn(se))return !1;var he=typeof se;return !("number"!=he&&"symbol"!=he&&"boolean"!=he&&null!=se&&!Ht(se))||be.test(se)||!_e.test(se)||null!=pe&&se in Object(pe)}function Et(se){var pe=se&&se.constructor;return se===("function"==typeof pe&&pe.prototype||Ve)}function Ft(se,pe){return function(he){return null!=he&&he[se]===pe&&(pe!==de||se in Object(he))}}function It(se,pe){var he=yr((he=void 0)===de?se.length-1:he,0);return function(){for(var de=arguments,ge=-1,ve=yr(de.length-he,0),ye=Array(ve);++ge<ve;)ye[ge]=de[he+ge];for(ge=-1,ve=Array(he+1);++ge<he;)ve[ge]=de[ge];return ve[he]=pe(ye),t(se,this,ve)}}function Mt(se,pe,he){var de=pe+"";pe=Gr;var ge,ve=Dt;return he=ve(ge=(ge=de.match(je))?ge[1].split(ke):[],he),(ve=he.length)&&(he[ge=ve-1]=(1<ve?"& ":"")+he[ge],he=he.join(2<ve?", ":" "),de=de.replace(we,"{\n/* [wrapped with "+he+"] */\n")),pe(se,de)}function $t(se){var pe=0,he=0;return function(){var ge=br(),ve=16-(ge-he);if(he=ge,0<ve){if(800<=++pe)return arguments[0]}else pe=0;return se.apply(de,arguments)}}function Ut(se){if("string"==typeof se||Ht(se))return se;var pe=se+"";return "0"==pe&&1/se==-ge?"-0":pe}function Bt(se){if(null!=se){try{return Ze.call(se)}catch(se){}return se+""}return ""}function Dt(se,pe){return e(ye,(function(he){var de="_."+he[0];pe&he[1]&&!n(se,de)&&se.push(de);})),se.sort()}function Rt(se){var pe=null==se?0:se.length;return pe?se[pe-1]:de}function Lt(se,pe){return (tn(se)?e:Dr)(se,jt(pe,3))}function Pt(se,pe){function r(){var he=arguments,de=pe?pe.apply(this,he):he[0],ge=r.cache;return ge.has(de)?ge.get(de):(he=se.apply(this,he),r.cache=ge.set(de,he)||ge,he)}if("function"!=typeof se||null!=pe&&"function"!=typeof pe)throw new TypeError("Expected a function");return r.cache=new(Pt.Cache||A),r}function Ct(se,pe){return se===pe||se!=se&&pe!=pe}function Nt(se){return null!=se&&Wt(se.length)&&!Vt(se)}function Tt(se){return Gt(se)&&Nt(se)}function Vt(se){return !!qt(se)&&("[object Function]"==(se=D(se))||"[object GeneratorFunction]"==se||"[object AsyncFunction]"==se||"[object Proxy]"==se)}function Wt(se){return "number"==typeof se&&-1<se&&0==se%1&&9007199254740991>=se}function qt(se){var pe=typeof se;return null!=se&&("object"==pe||"function"==pe)}function Gt(se){return null!=se&&"object"==typeof se}function Kt(se){return "string"==typeof se||!tn(se)&&Gt(se)&&"[object String]"==D(se)}function Ht(se){return "symbol"==typeof se||Gt(se)&&"[object Symbol]"==D(se)}function Jt(se){return se?(se=Xt(se))===ge||se===-ge?17976931348623157e292*(0>se?-1:1):se==se?se:0:0===se?se:0}function Qt(se){var pe=(se=Jt(se))%1;return se==se?pe?se-pe:se:0}function Xt(se){if("number"==typeof se)return se;if(Ht(se))return ve;if(qt(se)&&(se=qt(se="function"==typeof se.valueOf?se.valueOf():se)?se+"":se),"string"!=typeof se)return 0===se?se:+se;se=se.replace(xe,"");var pe=Oe.test(se);return pe||Ce.test(se)?Fe(se.slice(2),pe?2:8):Se.test(se)?ve:+se}function Yt(se){return null==se?"":X(se)}function Zt(se,pe,he){return (se=null==se?de:U(se,pe))===de?he:se}function te(se,pe){var he;if(he=null!=se){for(var de,ge=-1,ve=(de=tt(pe,he=se)).length,ye=!1;++ge<ve;){var _e=Ut(de[ge]);if(!(ye=null!=he&&null!=he&&_e in Object(he)))break;he=he[_e];}ye||++ge!=ve?he=ye:he=!!(ve=null==he?0:he.length)&&Wt(ve)&&xt(_e,ve)&&(tn(he)||en(he));}return he}function ee(se){if(Nt(se))se=S(se);else if(Et(se)){var pe,he=[];for(pe in Object(se))Ke.call(se,pe)&&"constructor"!=pe&&he.push(pe);se=he;}else se=vr(se);return se}function re(se){if(Nt(se))se=S(se,!0);else if(qt(se)){var pe,he=Et(se),de=[];for(pe in se)("constructor"!=pe||!he&&Ke.call(se,pe))&&de.push(pe);se=de;}else {if(pe=[],null!=se)for(he in Object(se))pe.push(he);se=pe;}return se}function ne(se){return null==se?[]:function h(se,pe){return o(pe,(function(pe){return se[pe]}))}(se,ee(se))}function ue(se){return function(){return se}}function oe(se){return se}function ie(se){return W("function"==typeof se?se:I(se,1))}function ce(){}function fe(se){return zt(se)?function a(se){return function(pe){return null==pe?de:pe[se]}}(Ut(se)):function J(se){return function(pe){return U(pe,se)}}(se)}function ae(){return []}function le(){return !1}var de,ge=1/0,ve=NaN,ye=[["ary",128],["bind",1],["bindKey",2],["curry",8],["curryRight",16],["flip",512],["partial",32],["partialRight",64],["rearg",256]],_e=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,be=/^\w*$/,me=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,xe=/^\s+|\s+$/g,we=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,je=/\{\n\/\* \[wrapped with (.+)\] \*/,ke=/,? & /,Ee=/\\(\\)?/g,Ae=/\w*$/,Se=/^[-+]0x[0-9a-f]+$/i,Oe=/^0b[01]+$/i,Re=/^\[object .+?Constructor\]$/,Ce=/^0o[0-7]+$/i,Ie=/^(?:0|[1-9]\d*)$/,ze=RegExp("\\ud83c[\\udffb-\\udfff](?=\\ud83c[\\udffb-\\udfff])|(?:[^\\ud800-\\udfff][\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]?|[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff]|[\\ud800-\\udfff])[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?(?:\\u200d(?:[^\\ud800-\\udfff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?)*","g"),$e=RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]"),Me={};Me["[object Float32Array]"]=Me["[object Float64Array]"]=Me["[object Int8Array]"]=Me["[object Int16Array]"]=Me["[object Int32Array]"]=Me["[object Uint8Array]"]=Me["[object Uint8ClampedArray]"]=Me["[object Uint16Array]"]=Me["[object Uint32Array]"]=!0,Me["[object Arguments]"]=Me["[object Array]"]=Me["[object ArrayBuffer]"]=Me["[object Boolean]"]=Me["[object DataView]"]=Me["[object Date]"]=Me["[object Error]"]=Me["[object Function]"]=Me["[object Map]"]=Me["[object Number]"]=Me["[object Object]"]=Me["[object RegExp]"]=Me["[object Set]"]=Me["[object String]"]=Me["[object WeakMap]"]=!1;var Ne={};Ne["[object Arguments]"]=Ne["[object Array]"]=Ne["[object ArrayBuffer]"]=Ne["[object DataView]"]=Ne["[object Boolean]"]=Ne["[object Date]"]=Ne["[object Float32Array]"]=Ne["[object Float64Array]"]=Ne["[object Int8Array]"]=Ne["[object Int16Array]"]=Ne["[object Int32Array]"]=Ne["[object Map]"]=Ne["[object Number]"]=Ne["[object Object]"]=Ne["[object RegExp]"]=Ne["[object Set]"]=Ne["[object String]"]=Ne["[object Symbol]"]=Ne["[object Uint8Array]"]=Ne["[object Uint8ClampedArray]"]=Ne["[object Uint16Array]"]=Ne["[object Uint32Array]"]=!0,Ne["[object Error]"]=Ne["[object Function]"]=Ne["[object WeakMap]"]=!1;var Pe,Fe=parseInt,qe="object"==typeof pe&&pe&&pe.Object===Object&&pe,Te="object"==typeof self&&self&&self.Object===Object&&self,Xe=qe||Te||Function("return this")(),Be=he&&!he.nodeType&&he,Le=Be&&se&&!se.nodeType&&se,He=Le&&Le.exports===Be,Ue=He&&qe.process;e:{try{Pe=Ue&&Ue.binding&&Ue.binding("util");break e}catch(t){}Pe=void 0;}var De=Pe&&Pe.isMap,We=Pe&&Pe.isSet,Ge=Pe&&Pe.isTypedArray,Qe=Array.prototype,Ve=Object.prototype,Ye=Xe["__core-js_shared__"],Ze=Function.prototype.toString,Ke=Ve.hasOwnProperty,Je=function(){var se=/[^.]+$/.exec(Ye&&Ye.keys&&Ye.keys.IE_PROTO||"");return se?"Symbol(src)_1."+se:""}(),er=Ve.toString,tr=RegExp("^"+Ze.call(Ke).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),rr=He?Xe.Buffer:de,nr=Xe.Symbol,or=Xe.Uint8Array,ar=rr?rr.f:de,ir=y(Object.getPrototypeOf),cr=Object.create,ur=Ve.propertyIsEnumerable,sr=Qe.splice,lr=nr?nr.isConcatSpreadable:de,fr=nr?nr.iterator:de,pr=nr?nr.toStringTag:de,hr=function(){try{var se=mt(Object,"defineProperty");return se({},"",{}),se}catch(se){}}(),dr=Object.getOwnPropertySymbols,gr=rr?rr.isBuffer:de,vr=y(Object.keys),yr=Math.max,_r=Math.min,br=Date.now,mr=mt(Xe,"DataView"),xr=mt(Xe,"Map"),wr=mt(Xe,"Promise"),jr=mt(Xe,"Set"),kr=mt(Xe,"WeakMap"),Er=mt(Object,"create"),Ar=kr&&new kr,Sr={},Or=Bt(mr),Cr=Bt(xr),Ir=Bt(wr),zr=Bt(jr),$r=Bt(kr),Mr=nr?nr.prototype:de,Nr=Mr?Mr.valueOf:de,Pr=Mr?Mr.toString:de,Fr=function(){function t(){}return function(se){return qt(se)?cr?cr(se):(t.prototype=se,se=new t,t.prototype=de,se):{}}}();d.prototype=Fr(function(){}.prototype),d.prototype.constructor=d,j.prototype.clear=function(){this.__data__=Er?Er(null):{},this.size=0;},j.prototype.delete=function(se){return se=this.has(se)&&delete this.__data__[se],this.size-=se?1:0,se},j.prototype.get=function(se){var pe=this.__data__;return Er?"__lodash_hash_undefined__"===(se=pe[se])?de:se:Ke.call(pe,se)?pe[se]:de},j.prototype.has=function(se){var pe=this.__data__;return Er?pe[se]!==de:Ke.call(pe,se)},j.prototype.set=function(se,pe){var he=this.__data__;return this.size+=this.has(se)?0:1,he[se]=Er&&pe===de?"__lodash_hash_undefined__":pe,this},w.prototype.clear=function(){this.__data__=[],this.size=0;},w.prototype.delete=function(se){var pe=this.__data__;return !(0>(se=x(pe,se))||(se==pe.length-1?pe.pop():sr.call(pe,se,1),--this.size,0))},w.prototype.get=function(se){var pe=this.__data__;return 0>(se=x(pe,se))?de:pe[se][1]},w.prototype.has=function(se){return -1<x(this.__data__,se)},w.prototype.set=function(se,pe){var he=this.__data__,de=x(he,se);return 0>de?(++this.size,he.push([se,pe])):he[de][1]=pe,this},A.prototype.clear=function(){this.size=0,this.__data__={hash:new j,map:new(xr||w),string:new j};},A.prototype.delete=function(se){return se=wt(this,se).delete(se),this.size-=se?1:0,se},A.prototype.get=function(se){return wt(this,se).get(se)},A.prototype.has=function(se){return wt(this,se).has(se)},A.prototype.set=function(se,pe){var he=wt(this,se),de=he.size;return he.set(se,pe),this.size+=he.size==de?0:1,this},m.prototype.add=m.prototype.push=function(se){return this.__data__.set(se,"__lodash_hash_undefined__"),this},m.prototype.has=function(se){return this.__data__.has(se)},O.prototype.clear=function(){this.__data__=new w,this.size=0;},O.prototype.delete=function(se){var pe=this.__data__;return se=pe.delete(se),this.size=pe.size,se},O.prototype.get=function(se){return this.__data__.get(se)},O.prototype.has=function(se){return this.__data__.has(se)},O.prototype.set=function(se,pe){var he=this.__data__;if(he instanceof w){var de=he.__data__;if(!xr||199>de.length)return de.push([se,pe]),this.size=++he.size,this;he=this.__data__=new A(de);}return he.set(se,pe),this.size=he.size,this};var Dr=function(se,pe){if(null==se)return se;if(!Nt(se))return function(se,pe){return se&&Rr(se,pe,ee)}(se,pe);for(var he=se.length,de=-1,ge=Object(se);++de<he&&!1!==pe(ge[de],de,ge););return se},Rr=function(se,pe,he){for(var de=-1,ge=Object(se),ve=(he=he(se)).length;ve--;){var ye=he[++de];if(!1===pe(ge[ye],ye,ge))break}return se},qr=Ar?function(se,pe){return Ar.set(se,pe),se}:oe,Tr=hr?function(se,pe){return hr(se,"toString",{configurable:!0,enumerable:!1,value:ue(pe),writable:!0})}:oe,Xr=jr&&1/g(new jr([,-0]))[1]==ge?function(se){return new jr(se)}:ce,Br=Ar?function(se){return Ar.get(se)}:ce,Lr=dr?function(se){return null==se?[]:(se=Object(se),function r(se,pe){for(var he=-1,de=null==se?0:se.length,ge=0,ve=[];++he<de;){var ye=se[he];pe(ye,he,se)&&(ve[ge++]=ye);}return ve}(dr(se),(function(pe){return ur.call(se,pe)})))}:ae,Hr=dr?function(se){for(var pe=[];se;)i(pe,Lr(se)),se=ir(se);return pe}:ae,Ur=D;(mr&&"[object DataView]"!=Ur(new mr(new ArrayBuffer(1)))||xr&&"[object Map]"!=Ur(new xr)||wr&&"[object Promise]"!=Ur(wr.resolve())||jr&&"[object Set]"!=Ur(new jr)||kr&&"[object WeakMap]"!=Ur(new kr))&&(Ur=function(se){var pe=D(se);if(se=(se="[object Object]"==pe?se.constructor:de)?Bt(se):"")switch(se){case Or:return "[object DataView]";case Cr:return "[object Map]";case Ir:return "[object Promise]";case zr:return "[object Set]";case $r:return "[object WeakMap]"}return pe});var Wr=$t(qr),Gr=$t(Tr),Qr=function(se){var pe=(se=Pt(se,(function(se){return 500===pe.size&&pe.clear(),se}))).cache;return se}((function(se){var pe=[];return 46===se.charCodeAt(0)&&pe.push(""),se.replace(me,(function(se,he,de,ge){pe.push(de?ge.replace(Ee,"$1"):he||se);})),pe})),Vr=Q((function(se,pe){return Tt(se)?M(se,$(pe,1,Tt,!0)):[]})),Yr=Q((function(se,pe){var he=Rt(pe);return Tt(he)&&(he=de),Tt(se)?M(se,$(pe,1,Tt,!0),de,he):[]})),Zr=Q((function(se){var pe=o(se,Z);return pe.length&&pe[0]===se[0]?R(pe):[]})),Kr=Q((function(se){var pe=Rt(se),he=o(se,Z);return (pe="function"==typeof pe?pe:de)&&he.pop(),he.length&&he[0]===se[0]?R(he,de,pe):[]}));Pt.Cache=A;var Jr=Q((function(se,pe){var he,ge,ve=_(pe,dt(Jr)),ye=se,_e=de,be=pe,me=ve,xe=64;if(!(ve=2&xe)&&"function"!=typeof ye)throw new TypeError("Expected a function");var we=be?be.length:0;if(we||(xe&=-97,be=me=de),he=he===de?he:yr(Qt(he),0),ge=ge===de?ge:Qt(ge),we-=me?me.length:0,64&xe){var je=be,ke=me;be=me=de;}var Ee=ve?de:Br(ye);return he=[ye,xe,_e,be,me,je,ke,void 0,he,ge],Ee&&(_e=(be=he[1])|(ye=Ee[1]),ge=128==ye&&8==be||128==ye&&256==be&&he[7].length<=Ee[8]||384==ye&&Ee[7].length<=Ee[8]&&8==be,131>_e||ge)&&(1&ye&&(he[2]=Ee[2],_e|=1&be?0:4),(be=Ee[3])&&(ge=he[3],he[3]=ge?nt(ge,be,Ee[4]):be,he[4]=ge?_(he[3],"__lodash_placeholder__"):Ee[4]),(be=Ee[5])&&(ge=he[5],he[5]=ge?ut(ge,be,Ee[6]):be,he[6]=ge?_(he[5],"__lodash_placeholder__"):Ee[6]),(be=Ee[7])&&(he[7]=be),128&ye&&(he[8]=null==he[8]?Ee[8]:_r(he[8],Ee[8])),null==he[9]&&(he[9]=Ee[9]),he[0]=Ee[0],he[1]=_e),ye=he[0],xe=he[1],_e=he[2],be=he[3],me=he[4],!(ge=he[9]=he[9]===de?ve?0:ye.length:yr(he[9]-we,0))&&24&xe&&(xe&=-25),Mt((Ee?qr:Wr)(xe&&1!=xe?8==xe||16==xe?st(ye,xe,ge):32!=xe&&33!=xe||me.length?ht.apply(de,he):bt(ye,xe,_e,be):function at(se,pe,he){var de=1&pe,ge=lt(se);return function n(){return (this&&this!==Xe&&this instanceof n?ge:se).apply(de?he:this,arguments)}}(ye,xe,_e),he),ye,xe)})),en=L(function(){return arguments}())?L:function(se){return Gt(se)&&Ke.call(se,"callee")&&!ur.call(se,"callee")},tn=Array.isArray,rn=gr||le,nn=De?s(De):function C(se){return Gt(se)&&"[object Map]"==Ur(se)},on=We?s(We):function T(se){return Gt(se)&&"[object Set]"==Ur(se)},an=Ge?s(Ge):function V(se){return Gt(se)&&Wt(se.length)&&!!Me[D(se)]};v.constant=ue,v.difference=Vr,v.differenceWith=Yr,v.intersection=Zr,v.intersectionWith=Kr,v.iteratee=ie,v.keys=ee,v.keysIn=re,v.memoize=Pt,v.orderBy=function(se,pe,he,ge){return null==se?[]:(tn(pe)||(pe=null==pe?[]:[pe]),tn(he=ge?de:he)||(he=null==he?[]:[he]),H(se,pe,he))},v.partialRight=Jr,v.property=fe,v.toArray=function(se){if(!se)return [];if(Nt(se))return Kt(se)?$e.test(se)?se.match(ze)||[]:se.split(""):ot(se);if(fr&&se[fr]){se=se[fr]();for(var pe,he=[];!(pe=se.next()).done;)he.push(pe.value);return he}return ("[object Map]"==(pe=Ur(se))?p:"[object Set]"==pe?g:ne)(se)},v.uniq=function(se){return se&&se.length?Y(se):[]},v.uniqWith=function(se,pe){return pe="function"==typeof pe?pe:de,se&&se.length?Y(se,de,pe):[]},v.values=ne,v.eq=Ct,v.forEach=Lt,v.get=Zt,v.hasIn=te,v.identity=oe,v.isArguments=en,v.isArray=tn,v.isArrayLike=Nt,v.isArrayLikeObject=Tt,v.isBuffer=rn,v.isFunction=Vt,v.isLength=Wt,v.isMap=nn,v.isObject=qt,v.isObjectLike=Gt,v.isSet=on,v.isString=Kt,v.isSymbol=Ht,v.isTypedArray=an,v.last=Rt,v.stubArray=ae,v.stubFalse=le,v.noop=ce,v.toFinite=Jt,v.toInteger=Qt,v.toNumber=Xt,v.toString=Yt,v.each=Lt,v.VERSION="4.17.5",Jr.placeholder=v,Le?((Le.exports=v)._=v,Be._=v):Xe._=v;}).call(pe);}(je,je.exports),
/*! https://mths.be/codepointat v0.2.0 by @mathias */
String.prototype.codePointAt||(be=function(){try{var se={},pe=Object.defineProperty,he=pe(se,se,se)&&pe;}catch(se){}return he}(),me=function(se){if(null==this)throw TypeError();var pe=String(this),he=pe.length,de=se?Number(se):0;if(de!=de&&(de=0),!(de<0||de>=he)){var ge,ve=pe.charCodeAt(de);return ve>=55296&&ve<=56319&&he>de+1&&(ge=pe.charCodeAt(de+1))>=56320&&ge<=57343?1024*(ve-55296)+ge-56320+65536:ve}},be?be(String.prototype,"codePointAt",{value:me,configurable:!0,writable:!0}):String.prototype.codePointAt=me)
/*! http://mths.be/fromcodepoint v0.2.1 by @mathias */,String.fromCodePoint||function(){var se=function(){try{var se={},pe=Object.defineProperty,he=pe(se,se,se)&&pe;}catch(se){}return he}(),pe=String.fromCharCode,he=Math.floor,fromCodePoint=function(se){var de,ge,ve=16384,ye=[],_e=-1,be=arguments.length;if(!be)return "";for(var me="";++_e<be;){var xe=Number(arguments[_e]);if(!isFinite(xe)||xe<0||xe>1114111||he(xe)!=xe)throw RangeError("Invalid code point: "+xe);xe<=65535?ye.push(xe):(de=55296+((xe-=65536)>>10),ge=xe%1024+56320,ye.push(de,ge)),(_e+1==be||ye.length>ve)&&(me+=pe.apply(null,ye),ye.length=0);}return me};se?se(String,"fromCodePoint",{value:fromCodePoint,configurable:!0,writable:!0}):String.fromCodePoint=fromCodePoint;}();try{xe="undefined"!=typeof Intl&&void 0!==Intl.Collator?Intl.Collator("generic",{sensitivity:"base"}):null;}catch(se){void 0!==typeof console&&console.warn("Collator could not be initialized and wouldn't be used");}var ke,Ee=function leven(se,pe,he,de){var ge=[],ve=[],ye=he&&xe&&he.useCollator,_e=1;if(he&&he.subcost&&"number"==typeof he.subcost&&(_e=he.subcost),se===pe)return 0;var be,me,we,je,ke=de(se),Ee=de(pe),Ae=ke.length,Se=Ee.length;if(0===Ae)return Se;if(0===Se)return Ae;for(var Oe=0,Re=0;Oe<Ae;)ve[Oe]=ke[Oe].codePointAt(0),ge[Oe]=++Oe;if(ye)for(;Re<Se;)for(be=Ee[Re].codePointAt(0),we=Re++,me=Re,Oe=0;Oe<Ae;Oe++)je=0===xe.compare(String.fromCodePoint(be),String.fromCodePoint(ve[Oe]))?we:we+_e,we=ge[Oe],me=ge[Oe]=we>me?je>me?me+1:je:je>we?we+1:je;else for(;Re<Se;)for(be=Ee[Re].codePointAt(0),we=Re++,me=Re,Oe=0;Oe<Ae;Oe++)je=be===ve[Oe]?we:we+_e,we=ge[Oe],me=ge[Oe]=we>me?je>me?me+1:je:je>we?we+1:je;return me};try{ke="undefined"!=typeof Intl&&void 0!==Intl.Collator?Intl.Collator("generic",{sensitivity:"base"}):null;}catch(se){void 0!==typeof console&&console.warn("Collator could not be initialized and wouldn't be used");}var Ae,Se=function leven(se,pe,he,de){var ge=[],ve=[],ye=he&&ke&&he.useCollator,_e=1;if(he&&he.subcost&&"number"==typeof he.subcost&&(_e=he.subcost),se===pe)return 0;var be=se.length,me=pe.length;if(0===be)return me;if(0===me)return be;if(he&&he.wildcards&&"string"==typeof he.wildcards&&he.wildcards.length>0){var xe,we,je,Ee,Ae,Se;if(!1===he.full_process&&!0!==he.processed){we=(xe=he.wildcards[0]).charCodeAt(0);var Oe="["+function escapeRegExp(se){return se.replace(/[.*+?^${}()|[\]\\]/g,"\\$&")}(he.wildcards)+"]";if((se=se.replace(new RegExp(Oe,"g"),xe))===(pe=pe.replace(new RegExp(Oe,"g"),xe)))return 0}else we=(xe=he.wildcards[0].toLowerCase()).charCodeAt(0);for(var Re=0,Ce=0;Re<be;)ve[Re]=se.charCodeAt(Re),ge[Re]=++Re;if(ye)for(;Ce<me;)for(je=pe.charCodeAt(Ce),Ae=Ce++,Ee=Ce,Re=0;Re<be;Re++)Se=0===ke.compare(String.fromCharCode(je),String.fromCharCode(ve[Re]))||je===we||ve[Re]===we?Ae:Ae+_e,Ae=ge[Re],Ee=ge[Re]=Ae>Ee?Se>Ee?Ee+1:Se:Se>Ae?Ae+1:Se;else for(;Ce<me;)for(je=pe.charCodeAt(Ce),Ae=Ce++,Ee=Ce,Re=0;Re<be;Re++)Se=je===ve[Re]||je===we||ve[Re]===we?Ae:Ae+_e,Ae=ge[Re],Ee=ge[Re]=Ae>Ee?Se>Ee?Ee+1:Se:Se>Ae?Ae+1:Se;return Ee}return de(se,pe,he)};try{Ae="undefined"!=typeof Intl&&void 0!==Intl.Collator?Intl.Collator("generic",{sensitivity:"base"}):null;}catch(se){void 0!==typeof console&&console.warn("Collator could not be initialized and wouldn't be used");}var Oe=function leven(se,pe,he){var de=[],ge=[],ve=he&&Ae&&he.useCollator,ye=1;if(he&&he.subcost&&"number"==typeof he.subcost&&(ye=he.subcost),se===pe)return 0;var _e,be,me,xe,we=se.length,je=pe.length;if(0===we)return je;if(0===je)return we;for(var ke=0,Ee=0;ke<we;)ge[ke]=se.charCodeAt(ke),de[ke]=++ke;if(ve)for(;Ee<je;)for(_e=pe.charCodeAt(Ee),me=Ee++,be=Ee,ke=0;ke<we;ke++)xe=0===Ae.compare(String.fromCharCode(_e),String.fromCharCode(ge[ke]))?me:me+ye,me=de[ke],be=de[ke]=me>be?xe>be?be+1:xe:xe>me?me+1:xe;else for(;Ee<je;)for(_e=pe.charCodeAt(Ee),me=Ee++,be=Ee,ke=0;ke<we;ke++)xe=_e===ge[ke]?me:me+ye,me=de[ke],be=de[ke]=me>be?xe>be?be+1:xe:xe>me?me+1:xe;return be};!function(se,pe){if(!se.setImmediate){var he,de=1,ge={},ve=!1,ye=se.document,_e=Object.getPrototypeOf&&Object.getPrototypeOf(se);_e=_e&&_e.setTimeout?_e:se,"[object process]"==={}.toString.call(se.process)?function installNextTickImplementation(){he=function(se){process.nextTick((function(){runIfPresent(se);}));};}():!function canUsePostMessage(){if(se.postMessage&&!se.importScripts){var pe=!0,he=se.onmessage;return se.onmessage=function(){pe=!1;},se.postMessage("","*"),se.onmessage=he,pe}}()?se.MessageChannel?function installMessageChannelImplementation(){var se=new MessageChannel;se.port1.onmessage=function(se){runIfPresent(se.data);},he=function(pe){se.port2.postMessage(pe);};}():ye&&"onreadystatechange"in ye.createElement("script")?function installReadyStateChangeImplementation(){var se=ye.documentElement;he=function(pe){var he=ye.createElement("script");he.onreadystatechange=function(){runIfPresent(pe),he.onreadystatechange=null,se.removeChild(he),he=null;},se.appendChild(he);};}():function installSetTimeoutImplementation(){he=function(se){setTimeout(runIfPresent,0,se);};}():function installPostMessageImplementation(){var pe="setImmediate$"+Math.random()+"$",onGlobalMessage=function(he){he.source===se&&"string"==typeof he.data&&0===he.data.indexOf(pe)&&runIfPresent(+he.data.slice(pe.length));};se.addEventListener?se.addEventListener("message",onGlobalMessage,!1):se.attachEvent("onmessage",onGlobalMessage),he=function(he){se.postMessage(pe+he,"*");};}(),_e.setImmediate=function setImmediate(se){"function"!=typeof se&&(se=new Function(""+se));for(var pe=new Array(arguments.length-1),ve=0;ve<pe.length;ve++)pe[ve]=arguments[ve+1];var ye={callback:se,args:pe};return ge[de]=ye,he(de),de++},_e.clearImmediate=clearImmediate;}function clearImmediate(se){delete ge[se];}function runIfPresent(se){if(ve)setTimeout(runIfPresent,0,se);else {var pe=ge[se];if(pe){ve=!0;try{!function run(se){var pe=se.callback,he=se.args;switch(he.length){case 0:pe();break;case 1:pe(he[0]);break;case 2:pe(he[0],he[1]);break;case 3:pe(he[0],he[1],he[2]);break;default:pe.apply(void 0,he);}}(pe);}finally{clearImmediate(se),ve=!1;}}}}}("undefined"==typeof self?pe:self);
/*!
 * XRegExp 3.1.1-next
 * <xregexp.com>
 * Steven Levithan (c) 2007-2016 MIT License
 */
var Re={astral:!1,natives:!1},Ce={exec:RegExp.prototype.exec,test:RegExp.prototype.test,match:String.prototype.match,replace:String.prototype.replace,split:String.prototype.split},Ie={},ze={},$e={},Me=[],Ne={default:/\\(?:0(?:[0-3][0-7]{0,2}|[4-7][0-7]?)?|[1-9]\d*|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|\(\?(?:[:=!]|<[=!])|[?*+]\?|{\d+(?:,\d*)?}\??|[\s\S]/,class:/\\(?:[0-3][0-7]{0,2}|[4-7][0-7]?|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|[\s\S]/},Pe=/\$(?:{([\w$]+)}|(\d\d?|[\s\S]))/g,Fe=void 0===Ce.exec.call(/()??/,"")[1],qe=void 0!==/x/.flags,Te={}.toString;function hasNativeFlag(se){var pe=!0;try{new RegExp("",se);}catch(se){pe=!1;}return pe&&"y"===se?new RegExp("aa|.","y").test("b"):pe}var Xe=hasNativeFlag("u"),Be=hasNativeFlag("y"),Le={g:!0,i:!0,m:!0,u:Xe,y:Be};function augment(se,pe,he,de,ge){var ve;if(se.xregexp={captureNames:pe},ge)return se;if(se.__proto__)se.__proto__=XRegExp$1.prototype;else for(ve in XRegExp$1.prototype)se[ve]=XRegExp$1.prototype[ve];return se.xregexp.source=he,se.xregexp.flags=de?de.split("").sort().join(""):de,se}function clipDuplicates(se){return Ce.replace.call(se,/([\s\S])(?=[\s\S]*\1)/g,"")}function copyRegex(se,pe){if(!XRegExp$1.isRegExp(se))throw new TypeError("Type RegExp expected");var he=se.xregexp||{},de=function getNativeFlags(se){return qe?se.flags:Ce.exec.call(/\/([a-z]*)$/i,RegExp.prototype.toString.call(se))[1]}(se),ge="",ve="",ye=null,_e=null;return (pe=pe||{}).removeG&&(ve+="g"),pe.removeY&&(ve+="y"),ve&&(de=Ce.replace.call(de,new RegExp("["+ve+"]+","g"),"")),pe.addG&&(ge+="g"),pe.addY&&(ge+="y"),ge&&(de=clipDuplicates(de+ge)),pe.isInternalOnly||(void 0!==he.source&&(ye=he.source),null!=he.flags&&(_e=ge?clipDuplicates(he.flags+ge):he.flags)),se=augment(new RegExp(pe.source||se.source,de),function hasNamedCapture(se){return !(!se.xregexp||!se.xregexp.captureNames)}(se)?he.captureNames.slice(0):null,ye,_e,pe.isInternalOnly)}function dec(se){return parseInt(se,16)}function hex(se){return parseInt(se,10).toString(16)}function indexOf(se,pe){var he,de=se.length;for(he=0;he<de;++he)if(se[he]===pe)return he;return -1}function isQuantifierNext(se,pe,he){return Ce.test.call(he.indexOf("x")>-1?/^(?:\s|#[^#\n]*|\(\?#[^)]*\))*(?:[?*+]|{\d+(?:,\d*)?})/:/^(?:\(\?#[^)]*\))*(?:[?*+]|{\d+(?:,\d*)?})/,se.slice(pe))}function pad4(se){for(;se.length<4;)se="0"+se;return se}function registerFlag(se){if(!/^[\w$]$/.test(se))throw new Error("Flag must be a single character A-Za-z0-9_$");Le[se]=!0;}function runTokens(se,pe,he,de,ge){for(var ve,ye,_e=Me.length,be=se.charAt(he),me=null;_e--;)if(!((ye=Me[_e]).leadChar&&ye.leadChar!==be||ye.scope!==de&&"all"!==ye.scope||ye.flag&&-1===pe.indexOf(ye.flag))&&(ve=XRegExp$1.exec(se,ye.regex,he,"sticky"))){me={matchLength:ve[0].length,output:ye.handler.call(ge,ve,de,pe),reparse:ye.reparse};break}return me}function XRegExp$1(se,pe){if(XRegExp$1.isRegExp(se)){if(void 0!==pe)throw new TypeError("Cannot supply flags when copying a RegExp");return copyRegex(se)}if(se=void 0===se?"":String(se),pe=void 0===pe?"":String(pe),XRegExp$1.isInstalled("astral")&&-1===pe.indexOf("A")&&(pe+="A"),$e[se]||($e[se]={}),!$e[se][pe]){for(var he,de={hasNamedCapture:!1,captureNames:[]},ge="default",ve="",ye=0,_e=function prepareFlags(se,pe){var he;if(clipDuplicates(pe)!==pe)throw new SyntaxError("Invalid duplicate regex flag "+pe);for(se=Ce.replace.call(se,/^\(\?([\w$]+)\)/,(function(se,he){if(Ce.test.call(/[gy]/,he))throw new SyntaxError("Cannot use flag g or y in mode modifier "+se);return pe=clipDuplicates(pe+he),""})),he=0;he<pe.length;++he)if(!Le[pe.charAt(he)])throw new SyntaxError("Unknown regex flag "+pe.charAt(he));return {pattern:se,flags:pe}}(se,pe),be=_e.pattern,me=_e.flags;ye<be.length;){do{(he=runTokens(be,me,ye,ge,de))&&he.reparse&&(be=be.slice(0,ye)+he.output+be.slice(ye+he.matchLength));}while(he&&he.reparse);if(he)ve+=he.output,ye+=he.matchLength||1;else {var xe=XRegExp$1.exec(be,Ne[ge],ye,"sticky")[0];ve+=xe,ye+=xe.length,"["===xe&&"default"===ge?ge="class":"]"===xe&&"class"===ge&&(ge="default");}}$e[se][pe]={pattern:Ce.replace.call(ve,/(?:\(\?:\))+/g,"(?:)"),flags:Ce.replace.call(me,/[^gimuy]+/g,""),captures:de.hasNamedCapture?de.captureNames:null};}var we=$e[se][pe];return augment(new RegExp(we.pattern,we.flags),we.captures,se,pe)}XRegExp$1.prototype=new RegExp,XRegExp$1.version="3.1.1-next",XRegExp$1._clipDuplicates=clipDuplicates,XRegExp$1._hasNativeFlag=hasNativeFlag,XRegExp$1._dec=dec,XRegExp$1._hex=hex,XRegExp$1._pad4=pad4,XRegExp$1.addToken=function(se,pe,he){var de,ge=(he=he||{}).optionalFlags;if(he.flag&&registerFlag(he.flag),ge)for(ge=Ce.split.call(ge,""),de=0;de<ge.length;++de)registerFlag(ge[de]);Me.push({regex:copyRegex(se,{addG:!0,addY:Be,isInternalOnly:!0}),handler:pe,scope:he.scope||"default",flag:he.flag,reparse:he.reparse,leadChar:he.leadChar}),XRegExp$1.cache.flush("patterns");},XRegExp$1.cache=function(se,pe){return ze[se]||(ze[se]={}),ze[se][pe]||(ze[se][pe]=XRegExp$1(se,pe))},XRegExp$1.cache.flush=function(se){"patterns"===se?$e={}:ze={};},XRegExp$1.exec=function(se,pe,he,de){var ge,ve,ye,_e="g",be=!1;return (ge=Be&&!!(de||pe.sticky&&!1!==de))?_e+="y":de&&(be=!0,_e+="FakeY"),pe.xregexp=pe.xregexp||{},he=he||0,(ye=pe.xregexp[_e]||(pe.xregexp[_e]=copyRegex(pe,{addG:!0,addY:ge,source:be?pe.source+"|()":void 0,removeY:!1===de,isInternalOnly:!0}))).lastIndex=he,ve=Ie.exec.call(ye,se),be&&ve&&""===ve.pop()&&(ve=null),pe.global&&(pe.lastIndex=ve?ye.lastIndex:0),ve},XRegExp$1.isInstalled=function(se){return !!Re[se]},XRegExp$1.isRegExp=function(se){return "[object RegExp]"===Te.call(se)},XRegExp$1.replace=function(se,pe,he,de){var ge,ve=XRegExp$1.isRegExp(pe),ye=pe.global&&"one"!==de||"all"===de,_e=(ye?"g":"")+(pe.sticky?"y":"")||"noGY",be=pe;return ve?(pe.xregexp=pe.xregexp||{},be=pe.xregexp[_e]||(pe.xregexp[_e]=copyRegex(pe,{addG:!!ye,removeG:"one"===de,isInternalOnly:!0}))):ye&&(be=new RegExp(XRegExp$1.escape(String(pe)),"g")),ge=Ie.replace.call(function toObject(se){if(null==se)throw new TypeError("Cannot convert null or undefined to object");return se}(se),be,he),ve&&pe.global&&(pe.lastIndex=0),ge},Ie.exec=function(se){var pe,he,de,ge=this.lastIndex,ve=Ce.exec.apply(this,arguments);if(ve){if(!Fe&&ve.length>1&&indexOf(ve,"")>-1&&(he=copyRegex(this,{removeG:!0,isInternalOnly:!0}),Ce.replace.call(String(se).slice(ve.index),he,(function(){var se,pe=arguments.length;for(se=1;se<pe-2;++se)void 0===arguments[se]&&(ve[se]=void 0);}))),this.xregexp&&this.xregexp.captureNames)for(de=1;de<ve.length;++de)(pe=this.xregexp.captureNames[de-1])&&(ve[pe]=ve[de]);this.global&&!ve[0].length&&this.lastIndex>ve.index&&(this.lastIndex=ve.index);}return this.global||(this.lastIndex=ge),ve},Ie.replace=function(se,pe){var he,de,ge,ve=XRegExp$1.isRegExp(se);return ve?(se.xregexp&&(de=se.xregexp.captureNames),he=se.lastIndex):se+="",ge=function isType(se,pe){return Te.call(se)==="[object "+pe+"]"}(pe,"Function")?Ce.replace.call(String(this),se,(function(){var he,ge=arguments;if(de)for(ge[0]=new String(ge[0]),he=0;he<de.length;++he)de[he]&&(ge[0][de[he]]=ge[he+1]);return ve&&se.global&&(se.lastIndex=ge[ge.length-2]+ge[0].length),pe.apply(void 0,ge)})):Ce.replace.call(null==this?this:String(this),se,(function(){var se=arguments;return Ce.replace.call(String(pe),Pe,(function(pe,he,ge){var ve;if(he){if((ve=+he)<=se.length-3)return se[ve]||"";if((ve=de?indexOf(de,he):-1)<0)throw new SyntaxError("Backreference to undefined group "+pe);return se[ve+1]||""}if("$"===ge)return "$";if("&"===ge||0==+ge)return se[0];if("`"===ge)return se[se.length-1].slice(0,se[se.length-2]);if("'"===ge)return se[se.length-1].slice(se[se.length-2]+se[0].length);if(ge=+ge,!isNaN(ge)){if(ge>se.length-3)throw new SyntaxError("Backreference to undefined group "+pe);return se[ge]||""}throw new SyntaxError("Invalid token "+pe)}))})),ve&&(se.global?se.lastIndex=0:se.lastIndex=he),ge},Ie.split=function(se,pe){if(!XRegExp$1.isRegExp(se))return Ce.split.apply(this,arguments);var he,de=String(this),ge=[],ve=se.lastIndex,ye=0;return pe=(void 0===pe?-1:pe)>>>0,XRegExp$1.forEach(de,se,(function(se){se.index+se[0].length>ye&&(ge.push(de.slice(ye,se.index)),se.length>1&&se.index<de.length&&Array.prototype.push.apply(ge,se.slice(1)),he=se[0].length,ye=se.index+he);})),ye===de.length?Ce.test.call(se,"")&&!he||ge.push(""):ge.push(de.slice(ye)),se.lastIndex=ve,ge.length>pe?ge.slice(0,pe):ge},XRegExp$1.addToken(/\\([ABCE-RTUVXYZaeg-mopqyz]|c(?![A-Za-z])|u(?![\dA-Fa-f]{4}|{[\dA-Fa-f]+})|x(?![\dA-Fa-f]{2}))/,(function(se,pe){if("B"===se[1]&&"default"===pe)return se[0];throw new SyntaxError("Invalid escape "+se[0])}),{scope:"all",leadChar:"\\"}),XRegExp$1.addToken(/\\u{([\dA-Fa-f]+)}/,(function(se,pe,he){var de=dec(se[1]);if(de>1114111)throw new SyntaxError("Invalid Unicode code point "+se[0]);if(de<=65535)return "\\u"+pad4(hex(de));if(Xe&&he.indexOf("u")>-1)return se[0];throw new SyntaxError("Cannot use Unicode code point above \\u{FFFF} without flag u")}),{scope:"all",leadChar:"\\"}),XRegExp$1.addToken(/\[(\^?)\]/,(function(se){return se[1]?"[\\s\\S]":"\\b\\B"}),{leadChar:"["}),XRegExp$1.addToken(/\(\?#[^)]*\)/,(function(se,pe,he){return isQuantifierNext(se.input,se.index+se[0].length,he)?"":"(?:)"}),{leadChar:"("}),XRegExp$1.addToken(/\s+|#[^\n]*\n?/,(function(se,pe,he){return isQuantifierNext(se.input,se.index+se[0].length,he)?"":"(?:)"}),{flag:"x"}),XRegExp$1.addToken(/\./,(function(){return "[\\s\\S]"}),{flag:"s",leadChar:"."}),XRegExp$1.addToken(/\\k<([\w$]+)>/,(function(se){var pe=isNaN(se[1])?indexOf(this.captureNames,se[1])+1:+se[1],he=se.index+se[0].length;if(!pe||pe>this.captureNames.length)throw new SyntaxError("Backreference to undefined group "+se[0]);return "\\"+pe+(he===se.input.length||isNaN(se.input.charAt(he))?"":"(?:)")}),{leadChar:"\\"}),XRegExp$1.addToken(/\\(\d+)/,(function(se,pe){if(!("default"===pe&&/^[1-9]/.test(se[1])&&+se[1]<=this.captureNames.length)&&"0"!==se[1])throw new SyntaxError("Cannot use octal escape or backreference to undefined group "+se[0]);return se[0]}),{scope:"all",leadChar:"\\"}),XRegExp$1.addToken(/\(\?P?<([\w$]+)>/,(function(se){if(!isNaN(se[1]))throw new SyntaxError("Cannot use integer as capture name "+se[0]);if("length"===se[1]||"__proto__"===se[1])throw new SyntaxError("Cannot use reserved word as capture name "+se[0]);if(indexOf(this.captureNames,se[1])>-1)throw new SyntaxError("Cannot use same name for multiple groups "+se[0]);return this.captureNames.push(se[1]),this.hasNamedCapture=!0,"("}),{leadChar:"("}),XRegExp$1.addToken(/\((?!\?)/,(function(se,pe,he){return he.indexOf("n")>-1?"(?:":(this.captureNames.push(null),"(")}),{optionalFlags:"n",leadChar:"("});var He=XRegExp$1;
/*!
 * XRegExp Unicode Base 3.1.1-next
 * <xregexp.com>
 * Steven Levithan (c) 2008-2016 MIT License
 */!function(se){var pe={},he=se._dec,de=se._hex,ge=se._pad4;function normalize(se){return se.replace(/[- _]+/g,"").toLowerCase()}function charCode(se){var pe=/^\\[xu](.+)/.exec(se);return pe?he(pe[1]):se.charCodeAt("\\"===se.charAt(0)?1:0)}function cacheInvertedBmp(he){return pe[he]["b!"]||(pe[he]["b!"]=function invertBmp(pe){var he="",ve=-1;return se.forEach(pe,/(\\x..|\\u....|\\?[\s\S])(?:-(\\x..|\\u....|\\?[\s\S]))?/,(function(se){var pe=charCode(se[1]);pe>ve+1&&(he+="\\u"+ge(de(ve+1)),pe>ve+2&&(he+="-\\u"+ge(de(pe-1)))),ve=charCode(se[2]||se[1]);})),ve<65535&&(he+="\\u"+ge(de(ve+1)),ve<65534&&(he+="-\\uFFFF")),he}(pe[he].bmp))}se.addToken(/\\([pP])(?:{(\^?)([^}]*)}|([A-Za-z]))/,(function(se,he,de){var ge="P"===se[1]||!!se[2],ve=normalize(se[4]||se[3]),ye=pe[ve];if("P"===se[1]&&se[2])throw new SyntaxError("Invalid double negation "+se[0]);if(!pe.hasOwnProperty(ve))throw new SyntaxError("Unknown Unicode token "+se[0]);if(ye.inverseOf){if(ve=normalize(ye.inverseOf),!pe.hasOwnProperty(ve))throw new ReferenceError("Unicode token missing data "+se[0]+" -> "+ye.inverseOf);ye=pe[ve],ge=!ge;}if(!ye.bmp)throw new SyntaxError("Astral mode required for Unicode token "+se[0]);return "class"===he?ge?cacheInvertedBmp(ve):ye.bmp:(ge?"[^":"[")+ye.bmp+"]"}),{scope:"all",optionalFlags:"A",leadChar:"\\"}),se.addUnicodeData=function(he){for(var de,ge=0;ge<he.length;++ge){if(!(de=he[ge]).name)throw new Error("Unicode token requires name");if(!(de.inverseOf||de.bmp||de.astral))throw new Error("Unicode token has no character data "+de.name);pe[normalize(de.name)]=de,de.alias&&(pe[normalize(de.alias)]=de);}se.cache.flush("patterns");},se._getUnicodeProperty=function(se){var he=normalize(se);return pe[he]};}(He),function(se){if(!se.addUnicodeData)throw new ReferenceError("Unicode Base must be loaded before Unicode Categories");se.addUnicodeData([{name:"L",alias:"Letter",bmp:"A-Za-zªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈא-תׯ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࡠ-ࡪࢠ-ࢴࢶ-ࢽऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೞೠೡೱೲഅ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛱ-ᛸᜀ-ᜌᜎ-ᜑᜠ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡸᢀ-ᢄᢇ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭋᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᲀ-ᲈᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎↃↄⰀ-Ⱞⰰ-ⱞⱠ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⸯ々〆〱-〵〻〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆺㇰ-ㇿ㐀-䶵一-鿯ꀀ-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛥꜗ-ꜟꜢ-ꞈꞋ-ꞿꟂ-Ᶎꟷ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭧꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ"},{name:"N",alias:"Number",bmp:"0-9²³¹¼-¾٠-٩۰-۹߀-߉०-९০-৯৴-৹੦-੯૦-૯୦-୯୲-୷௦-௲౦-౯౸-౾೦-೯൘-൞൦-൸෦-෯๐-๙໐-໙༠-༳၀-၉႐-႙፩-፼ᛮ-ᛰ០-៩៰-៹᠐-᠙᥆-᥏᧐-᧚᪀-᪉᪐-᪙᭐-᭙᮰-᮹᱀-᱉᱐-᱙⁰⁴-⁹₀-₉⅐-ↂↅ-↉①-⒛⓪-⓿❶-➓⳽〇〡-〩〸-〺㆒-㆕㈠-㈩㉈-㉏㉑-㉟㊀-㊉㊱-㊿꘠-꘩ꛦ-ꛯ꠰-꠵꣐-꣙꤀-꤉꧐-꧙꧰-꧹꩐-꩙꯰-꯹０-９"}]);}(He);var Ue=He,De={exports:{}};!function(se){se.exports=function(pe,he,de,ge){return (se={}).dedupe=function dedupe(se,ve){var ye,_e=pe(ve);if(!he(se)&&"object"!=typeof se)throw new Error("contains_dupes must be an array or object");if(0===Object.keys(se).length)return void 0!==typeof console&&console.warn("contains_dupes is empty"),[];_e.limit&&(void 0!==typeof console&&console.warn("options.limit will be ignored in dedupe"),_e.limit=0),_e.cutoff&&"number"==typeof _e.cutoff||(void 0!==typeof console&&console.warn("Using default cutoff of 70"),_e.cutoff=70),_e.scorer||(_e.scorer=de,void 0!==typeof console&&console.log("Using default scorer 'ratio' for dedupe")),ye=_e.processor&&"function"==typeof _e.processor?_e.processor:function(se){return se};var be={};for(var me in se){var xe=ye(se[me]);if("string"!=typeof xe&&xe instanceof String==!1)throw new Error("Each processed item in dedupe must be a string.");var we=ge(xe,se,_e);_e.returnObjects?(1===we.length||(we=we.sort((function(se,pe){var he=ye(se.choice),de=ye(pe.choice),ge=he.length,ve=de.length;return ge===ve?he<de?-1:1:ve-ge}))),_e.keepmap?be[ye(we[0].choice)]={item:we[0].choice,key:we[0].key,matches:we}:be[ye(we[0].choice)]={item:we[0].choice,key:we[0].key}):(1===we.length||(we=we.sort((function(se,pe){var he=ye(se[0]),de=ye(pe[0]),ge=he.length,ve=de.length;return ge===ve?he<de?-1:1:ve-ge}))),_e.keepmap?be[ye(we[0][0])]=[we[0][0],we[0][2],we]:be[ye(we[0][0])]=[we[0][0],we[0][2]]);}var je=[];for(var ke in be)je.push(be[ke]);return je},se};}(De),function(){var se=ye,pe=we,de=je.exports.intersection,ge=je.exports.intersectionWith,ve=je.exports.difference,_e=je.exports.differenceWith,be=je.exports.uniq,me=je.exports.uniqWith,xe=je.exports.partialRight,ke=je.exports.forEach,Ae=je.exports.keys,Re=je.exports.isArray,Ce=je.exports.toArray,Ie=je.exports.orderBy,ze=Ee,$e=Se,Me=Oe,Ne=function(se,pe,he){var de={},ge=Ue,ve=Se,ye=Oe;function escapeRegExp(se){return se.replace(/[.*+?^${}()|[\]\\]/g,"\\$&")}function validate(se){return ("string"==typeof se||se instanceof String)&&se.length>0}de.validate=validate,de.process_and_sort=function process_and_sort(se){return validate(se)?se.match(/\S+/g).sort().join(" ").trim():""},de.tokenize=function unique_tokens(de,ge){if(ge&&ge.wildcards&&pe&&he){var _e=he(ve,ge,ye);return pe(de.match(/\S+/g),(function(se,pe){return 0===_e(se,pe)}))}return se(de.match(/\S+/g))};var _e=ge("[^\\pN|\\pL]","g");return de.full_process=function full_process(se,pe){if(!(se instanceof String)&&"string"!=typeof se)return "";var he;if(pe&&"object"==typeof pe&&pe.wildcards&&"string"==typeof pe.wildcards&&pe.wildcards.length>0){var de=pe.wildcards.toLowerCase();if(se=se.toLowerCase(),pe.force_ascii){var ve="[^\0 -|"+escapeRegExp(de)+"]";se=se.replace(new RegExp(ve,"g"),"");var ye="["+escapeRegExp(de)+"]",be=de[0];se=se.replace(new RegExp(ye,"g"),be);var me="[^A-Za-z0-9"+escapeRegExp(de)+"]";he=(se=(se=se.replace(new RegExp(me,"g")," ")).replace(/_/g," ")).trim();}else {var xe="[^\\pN|\\pL|"+escapeRegExp(de)+"]",we=ge(xe,"g");se=ge.replace(se,we," ","all"),ye="["+escapeRegExp(de)+"]",be=de[0],he=(se=se.replace(new RegExp(ye,"g"),be)).trim();}}else pe&&(pe.force_ascii||!0===pe)&&(he=(se=se.replace(/[^\x00-\x7F]/g,"")).replace(/\W|_/g," ").toLowerCase().trim()),he=ge.replace(se,_e," ","all").toLowerCase().trim();return pe&&pe.collapseWhitespace&&(he=he.replace(/\s+/g," ")),he},de.clone_and_set_option_defaults=function(se){if(se&&se.isAClone)return se;var pe={isAClone:!0};if(se){var he,de=Object.keys(se);for(he=0;he<de.length;he++)pe[de[he]]=se[de[he]];}return void 0!==pe.full_process&&!1===pe.full_process||(pe.full_process=!0),void 0!==pe.force_ascii&&!0===pe.force_ascii||(pe.force_ascii=!1),void 0!==pe.normalize&&!1===pe.normalize||(pe.normalize=!0),void 0!==pe.astral&&!0===pe.astral&&(pe.full_process=!1),void 0!==pe.collapseWhitespace&&!1===pe.collapseWhitespace||(pe.collapseWhitespace=!0),pe},de.isCustomFunc=function(se){return "function"!=typeof se||"token_set_ratio"!==se.name&&"partial_token_set_ratio"!==se.name&&"token_sort_ratio"!==se.name&&"partial_token_sort_ratio"!==se.name&&"QRatio"!==se.name&&"WRatio"!==se.name&&"distance"!==se.name&&"partial_ratio"!==se.name},de}(be,me,xe),Pe=Ne.validate,Fe=Ne.process_and_sort,qe=Ne.tokenize,Te=Ne.full_process,Xe=Ne.clone_and_set_option_defaults,Be=Ne.isCustomFunc,Le=De.exports(Xe,Re,QRatio,extract).dedupe;function QRatio(se,pe,he){var de=Xe(he);return se=de.full_process?Te(se,de):se,pe=de.full_process?Te(pe,de):pe,Pe(se)&&Pe(pe)?_ratio(se,pe,de):0}function token_set_ratio(se,pe,he){var de=Xe(he);return se=de.full_process?Te(se,de):se,pe=de.full_process?Te(pe,de):pe,Pe(se)&&Pe(pe)?_token_set(se,pe,de):0}function partial_token_set_ratio(se,pe,he){var de=Xe(he);return se=de.full_process?Te(se,de):se,pe=de.full_process?Te(pe,de):pe,Pe(se)&&Pe(pe)?(de.partial=!0,_token_set(se,pe,de)):0}function token_sort_ratio(se,pe,he){var de=Xe(he);return se=de.full_process?Te(se,de):se,pe=de.full_process?Te(pe,de):pe,Pe(se)&&Pe(pe)?(de.proc_sorted||(se=Fe(se),pe=Fe(pe)),_ratio(se,pe,de)):0}function partial_token_sort_ratio(se,pe,he){var de=Xe(he);return se=de.full_process?Te(se,de):se,pe=de.full_process?Te(pe,de):pe,Pe(se)&&Pe(pe)?(de.partial=!0,de.proc_sorted||(se=Fe(se),pe=Fe(pe)),_partial_ratio(se,pe,de)):0}function extract(se,he,de){var ge,ve=Xe(de);if(Re(he))ge=he.length;else {if(!(he instanceof Object))throw new Error("Invalid choices");ge=Ae(he).length;}if(!he||0===ge)return void 0!==typeof console&&console.warn("No choices"),[];if(ve.processor&&"function"!=typeof ve.processor)throw new Error("Invalid Processor");if(ve.processor||(ve.processor=function(se){return se}),ve.scorer&&"function"!=typeof ve.scorer)throw new Error("Invalid Scorer");ve.scorer||(ve.scorer=QRatio);var ye=Be(ve.scorer);ve.cutoff&&"number"==typeof ve.cutoff||(ve.cutoff=-1);var pre_processor=function(se,pe){return se};ve.full_process&&(pre_processor=Te,ye||(ve.processed=!0));var _e=!1;ye||(se=pre_processor(se,ve),ve.full_process=!1,ve.astral&&ve.normalize&&(ve.normalize=!1,String.prototype.normalize?(_e=!0,se=se.normalize()):void 0!==typeof console&&console.warn("Normalization not supported in your environment")),0===se.length&&void 0!==typeof console&&console.warn("Processed query is empty string"));var be,me,xe,we,je=[],Ee=!1,Se=!1,Oe=!1;if("token_sort_ratio"===ve.scorer.name||"partial_token_sort_ratio"===ve.scorer.name){var Ce=Fe(se);Se=!0;}else if("token_set_ratio"===ve.scorer.name||"partial_token_set_ratio"===ve.scorer.name){var Ie=qe(se,ve);Oe=!0;}return ve.returnObjects?(xe=function(se,pe){return se.score-pe.score},we=function(se,pe){return pe.score-se.score}):(xe=function(se,pe){return se[1]-pe[1]},we=function(se,pe){return pe[1]-se[1]}),ke(he,(function(pe,he){ve.tokens=void 0,ve.proc_sorted=!1,Se?(ve.proc_sorted=!0,pe&&pe.proc_sorted?me=pe.proc_sorted:(me=pre_processor(ve.processor(pe),ve),me=Fe(_e?me.normalize():me)),be=ve.scorer(Ce,me,ve)):Oe?(me="x",pe&&pe.tokens?(ve.tokens=[Ie,pe.tokens],ve.trySimple&&(me=pre_processor(ve.processor(pe),ve))):(me=pre_processor(ve.processor(pe),ve),ve.tokens=[Ie,qe(_e?me.normalize():me,ve)]),be=ve.scorer(se,me,ve)):ye?(me=ve.processor(pe),be=ve.scorer(se,me,ve)):("string"==typeof(me=pre_processor(ve.processor(pe),ve))&&0!==me.length||(Ee=!0),_e&&"string"==typeof me&&(me=me.normalize()),be=ve.scorer(se,me,ve)),be>ve.cutoff&&(ve.returnObjects?je.push({choice:pe,score:be,key:he}):je.push([pe,be,he]));})),Ee&&void 0!==typeof console&&console.log("One or more choices were empty. (post-processing if applied)"),ve.limit&&"number"==typeof ve.limit&&ve.limit>0&&ve.limit<ge&&!ve.unsorted?je=pe.nlargest(je,ve.limit,xe):ve.unsorted||(je=je.sort(we)),je}function extractAsync(se,he,de,ge){var ve,ye,_e=Xe(de);"object"==typeof de.abortController&&(ve=de.abortController),"object"==typeof de.cancelToken&&(ye=de.cancelToken);var be=256;"number"==typeof _e.asyncLoopOffset&&(be=_e.asyncLoopOffset<1?1:_e.asyncLoopOffset);var me,xe=!1;if(he&&he.length&&Re(he))me=he.length,xe=!0;else {if(!(he instanceof Object))return void ge(new Error("Invalid choices"));me=Object.keys(he).length;}if(!he||0===me)return void 0!==typeof console&&console.warn("No choices"),void ge(null,[]);if(_e.processor&&"function"!=typeof _e.processor)ge(new Error("Invalid Processor"));else if(_e.processor||(_e.processor=function(se){return se}),_e.scorer&&"function"!=typeof _e.scorer)ge(new Error("Invalid Scorer"));else {_e.scorer||(_e.scorer=QRatio);var we=Be(_e.scorer);_e.cutoff&&"number"==typeof _e.cutoff||(_e.cutoff=-1);var pre_processor=function(se,pe){return se};_e.full_process&&(pre_processor=Te,we||(_e.processed=!0));var je=!1;we||(se=pre_processor(se,_e),_e.full_process=!1,_e.astral&&_e.normalize&&(_e.normalize=!1,String.prototype.normalize?(je=!0,se=se.normalize()):void 0!==typeof console&&console.warn("Normalization not supported in your environment")),0===se.length&&void 0!==typeof console&&console.warn("Processed query is empty string"));var ke,Ee,Ae,Se,Oe,Ce=[],Ie=!1,ze=!1,$e=!1;if("token_sort_ratio"===_e.scorer.name||"partial_token_sort_ratio"===_e.scorer.name){var Me=Fe(se);ze=!0;}else if("token_set_ratio"===_e.scorer.name||"partial_token_set_ratio"===_e.scorer.name){var Ne=qe(se,_e);$e=!0;}_e.returnObjects?(Se=function(se,pe){return se.score-pe.score},Oe=function(se,pe){return pe.score-se.score}):(Se=function(se,pe){return se[1]-pe[1]},Oe=function(se,pe){return pe[1]-se[1]});var Pe=Object.keys(he);xe?searchLoop(0):searchLoop(Pe[0],0);}function searchLoop(de,Re){(xe||he.hasOwnProperty(de))&&(_e.tokens=void 0,_e.proc_sorted=!1,ze?(_e.proc_sorted=!0,he[de]&&he[de].proc_sorted?Ee=he[de].proc_sorted:(Ee=pre_processor(_e.processor(he[de]),_e),Ee=Fe(je?Ee.normalize():Ee)),Ae=_e.scorer(Me,Ee,_e)):$e?(Ee="x",he[de]&&he[de].tokens?(_e.tokens=[Ne,he[de].tokens],_e.trySimple&&(Ee=pre_processor(_e.processor(he[de]),_e))):(Ee=pre_processor(_e.processor(he[de]),_e),_e.tokens=[Ne,qe(je?Ee.normalize():Ee,_e)]),Ae=_e.scorer(se,Ee,_e)):we?(Ee=_e.processor(he[de]),Ae=_e.scorer(se,Ee,_e)):("string"==typeof(Ee=pre_processor(_e.processor(he[de]),_e))&&0!==Ee.length||(Ie=!0),je&&"string"==typeof Ee&&(Ee=Ee.normalize()),Ae=_e.scorer(se,Ee,_e)),ke=xe?parseInt(de):de,Ae>_e.cutoff&&(_e.returnObjects?Ce.push({choice:he[de],score:Ae,key:ke}):Ce.push([he[de],Ae,ke]))),ve&&!0===ve.signal.aborted?ge(new Error("aborted")):ye&&!0===ye.canceled?ge(new Error("canceled")):xe&&de<he.length-1?de%be==0?setImmediate((function(){searchLoop(de+1);})):searchLoop(de+1):Re<Pe.length-1?Re%be==0?setImmediate((function(){searchLoop(Pe[Re+1],Re+1);})):searchLoop(Pe[Re+1],Re+1):(Ie&&void 0!==typeof console&&console.log("One or more choices were empty. (post-processing if applied)"),_e.limit&&"number"==typeof _e.limit&&_e.limit>0&&_e.limit<me&&!_e.unsorted?Ce=pe.nlargest(Ce,_e.limit,Se):_e.unsorted||(Ce=Ce.sort(Oe)),ge(null,Ce));}}var He="%*SuperUniqueWildcardKey*%",We=!1;function _getCharacterCounts(se,pe){var he=se;if(pe.astral){pe.normalize&&(String.prototype.normalize?he=se.normalize():We||(void 0!==typeof console&&console.warn("Normalization not supported in your environment"),We=!0));var de=Ce(he);}else de=he.split("");var ge={};if(pe.wildcards)for(var ve=0;ve<de.length;ve++){var ye=de[ve];pe.wildcards.indexOf(ye)>-1?ge[He]?ge[He]+=1:ge[He]=1:ge[ye]?ge[ye]+=1:ge[ye]=1;}else for(ve=0;ve<de.length;ve++){ge[ye=de[ve]]?ge[ye]+=1:ge[ye]=1;}return ge}function _token_similarity_sort(se,pe,he){for(var ge=pe,ve=se.reduce((function(se,pe){return se[pe]=_getCharacterCounts(pe,he),se}),{}),ye=ge.reduce((function(se,pe){return se[pe]=_getCharacterCounts(pe,he),se}),{}),_e=[],be=0;ge.length&&be<se.length;){var me=Ie(ge,(function(pe){return he=ve[se[be]],ge=ye[pe],_e=Object.keys(he),me=Object.keys(ge),xe=de(_e,me).map((function(se){return he[se]*ge[se]})).reduce((function(se,pe){return se+pe}),0),we=_e.map((function(se){return Math.pow(he[se],2)})).reduce((function(se,pe){return se+pe}),0),je=me.map((function(se){return Math.pow(ge[se],2)})).reduce((function(se,pe){return se+pe}),0),xe/(Math.sqrt(we)*Math.sqrt(je));var he,ge,_e,me,xe,we,je;}),"desc")[0];_e.push(me),be++,ge=ge.filter((function(se){return se!==me}));}return _e.concat(ge)}function _order_token_lists(se,pe,he,de){var ge=pe,ve=de;if(pe.length>de.length)ge=de,ve=pe;else if(pe.length===de.length){if(se.length>he.length)ge=de,ve=pe;else [se,he].sort()[0]===he&&(ge=de,ve=pe);}return [ge,ve]}function _token_similarity_sort_ratio(se,pe,he){if(he.tokens)de=he.tokens[0],ge=he.tokens[1];else var de=qe(se,he),ge=qe(pe,he);var ve=_order_token_lists(se,de.sort(),pe,ge.sort()),ye=ve[0];const _e=_token_similarity_sort(ye,ve[1],he);return he.partial?_partial_ratio(ye.join(" "),_e.join(" "),he):_ratio(ye.join(" "),_e.join(" "),he)}function _token_set(se,pe,he){if(he.tokens)ye=he.tokens[0],be=he.tokens[1];else var ye=qe(se,he),be=qe(pe,he);if(he.wildcards)var me=xe($e,he,Me),wildCompare=function(se,pe){return 0===me(se,pe)},we=ge(ye,be,wildCompare),je=_e(ye,be,wildCompare),ke=_e(be,ye,wildCompare);else we=de(ye,be),je=ve(ye,be),ke=ve(be,ye);var Ee=we.sort().join(" "),Ae=je.sort(),Se=ke.sort();if(he.sortBySimilarity)var Oe=_order_token_lists(se,Ae,pe,Se),Re=Oe[0],Ce=Oe[1],Ie=Re.join(" "),ze=_token_similarity_sort(Re,Ce,he).join(" ");else Ie=Ae.join(" "),ze=Se.join(" ");var Ne=Ee+" "+Ie,Pe=Ee+" "+ze;Ee=Ee.trim(),Ne=Ne.trim(),Pe=Pe.trim();var Fe=_ratio;if(he.partial&&(Fe=_partial_ratio,Ee.length>0))return 100;var Te=[Fe(Ee,Ne,he),Fe(Ee,Pe,he),Fe(Ne,Pe,he)];return he.trySimple&&Te.push(Fe(se,pe,he)),Math.max.apply(null,Te)}var Ge,Qe,Ve,Ye,Ze=!1;function _ratio(pe,he,de){if(!Pe(pe))return 0;if(!Pe(he))return 0;if(de.ratio_alg&&"difflib"===de.ratio_alg){var ge=new se(null,pe,he).ratio();return Math.round(100*ge)}var ve,ye;return void 0===de.subcost&&(de.subcost=2),de.astral?(de.normalize&&(String.prototype.normalize?(pe=pe.normalize(),he=he.normalize()):Ze||(void 0!==typeof console&&console.warn("Normalization not supported in your environment"),Ze=!0)),ve=ze(pe,he,de,Ce),ye=Ce(pe).length+Ce(he).length):de.wildcards?(ve=$e(pe,he,de,Me),ye=pe.length+he.length):(ve=Me(pe,he,de),ye=pe.length+he.length),Math.round((ye-ve)/ye*100)}function _partial_ratio(pe,he,de){if(!Pe(pe))return 0;if(!Pe(he))return 0;if(pe.length<=he.length)var ge=pe,ve=he;else ge=he,ve=pe;for(var ye=new se(null,ge,ve).getMatchingBlocks(),_e=[],be=0;be<ye.length;be++){var me=ye[be][1]-ye[be][0]>0?ye[be][1]-ye[be][0]:0,xe=me+ge.length,we=_ratio(ge,ve.substring(me,xe),de);if(we>99.5)return 100;_e.push(we);}return Math.max.apply(null,_e)}Object.keys||(Object.keys=(Ge=Object.prototype.hasOwnProperty,Qe=!{toString:null}.propertyIsEnumerable("toString"),Ye=(Ve=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"]).length,function(se){if("object"!=typeof se&&("function"!=typeof se||null===se))throw new TypeError("Object.keys called on non-object");var pe,he,de=[];for(pe in se)Ge.call(se,pe)&&de.push(pe);if(Qe)for(he=0;he<Ye;he++)Ge.call(se,Ve[he])&&de.push(Ve[he]);return de}));var Ke=void 0;"undefined"!=typeof Promise&&(Ke=function(se,pe,he){return new Promise((function(de,ge){extractAsync(se,pe,he,(function(se,pe){se?ge(se):de(pe);}));}))});var Je={distance:function distance(se,pe,he){var de=Xe(he);return se=de.full_process?Te(se,de):se,pe=de.full_process?Te(pe,de):pe,void 0===de.subcost&&(de.subcost=1),de.astral?ze(se,pe,de,Ce):$e(se,pe,de,Me)},ratio:QRatio,partial_ratio:function partial_ratio(se,pe,he){var de=Xe(he);return se=de.full_process?Te(se,de):se,pe=de.full_process?Te(pe,de):pe,Pe(se)&&Pe(pe)?_partial_ratio(se,pe,de):0},token_set_ratio:token_set_ratio,token_sort_ratio:token_sort_ratio,partial_token_set_ratio:partial_token_set_ratio,partial_token_sort_ratio:partial_token_sort_ratio,token_similarity_sort_ratio:function token_similarity_sort_ratio(se,pe,he){var de=Xe(he);return se=de.full_process?Te(se,de):se,pe=de.full_process?Te(pe,de):pe,Pe(se)&&Pe(pe)?_token_similarity_sort_ratio(se,pe,de):0},partial_token_similarity_sort_ratio:function partial_token_similarity_sort_ratio(se,pe,he){var de=Xe(he);return se=de.full_process?Te(se,de):se,pe=de.full_process?Te(pe,de):pe,Pe(se)&&Pe(pe)?(de.partial=!0,_token_similarity_sort_ratio(se,pe,de)):0},WRatio:function WRatio(se,pe,he){var de=Xe(he);if(se=de.full_process?Te(se,de):se,pe=de.full_process?Te(pe,de):pe,de.full_process=!1,!Pe(se))return 0;if(!Pe(pe))return 0;var ge=!0,ve=.95,ye=.9,_e=_ratio(se,pe,de),be=Math.max(se.length,pe.length)/Math.min(se.length,pe.length);if(be<1.5&&(ge=!1),be>8&&(ye=.6),ge){var me=_partial_ratio(se,pe,de)*ye,xe=partial_token_sort_ratio(se,pe,de)*ve*ye,we=partial_token_set_ratio(se,pe,de)*ve*ye;return Math.round(Math.max(_e,me,xe,we))}var je=token_sort_ratio(se,pe,de)*ve,ke=token_set_ratio(se,pe,de)*ve;return Math.round(Math.max(_e,je,ke))},full_process:Te,extract:extract,extractAsync:extractAsync,extractAsPromised:Ke,process_and_sort:Fe,unique_tokens:qe,dedupe:Le};he.exports=Je;}();var We=he.exports;We.distance;const Qe=We.ratio;We.partial_ratio;We.token_set_ratio;We.token_sort_ratio;We.partial_token_set_ratio;We.partial_token_sort_ratio;We.token_similarity_sort_ratio;We.partial_token_similarity_sort_ratio;We.WRatio;We.full_process;We.extract;We.extractAsync;We.extractAsPromised;We.process_and_sort;We.unique_tokens;We.dedupe;

var normalizeRating$1 = function (_a) {
    var value = _a.value, type = _a.type;
    if (type === RATING.THUMBS) {
        if (value === -1)
            return '1';
        if (value === 1)
            return '5';
    }
    if (type === RATING.STAR_1_3) {
        if (value === 1)
            return '1';
        if (value === 2)
            return '3';
        if (value === 3)
            return '5';
    }
    if (type === RATING.STAR_1_10) {
        return Math.ceil(value / 2).toString();
    }
    // default for RATING.STAR_1_5, RATING.EMOJI
    return value === null || value === void 0 ? void 0 : value.toString();
};
var isCurrentRatingIsUnderRange$1 = function (selectedRating, ratingRange) {
    var selectedValue = Number(normalizeRating$1(selectedRating));
    if (selectedValue && ratingRange && Array.isArray(ratingRange) && (ratingRange === null || ratingRange === void 0 ? void 0 : ratingRange.length) === 2) {
        if (ratingRange[0] <= selectedValue && ratingRange[1] >= selectedValue) {
            return true;
        }
    }
    return false;
};
var sortOutlets$1 = function (latLong, outlets, isMiles) {
    if (isMiles === void 0) { isMiles = false; }
    if (outlets && outlets.length > 0) {
        if (!lodashExports.isEmpty(latLong)) {
            var outletsData = outlets.map(function (outlet) {
                return __assign(__assign({}, outlet), { distance: !lodashExports.isEmpty(outlet.latLong)
                        ? haversineDistance([latLong.latitude, latLong.longitude], outlet.latLong, isMiles)
                        : null });
            });
            outletsData.sort(function (a, b) {
                if (a.distance === undefined || a.distance === null) {
                    return 1;
                }
                if (b.distance === undefined || b.distance === null) {
                    return -1;
                }
                return a.distance - b.distance;
            });
            return outletsData;
        }
        return outlets;
    }
    return [];
};
var surveyScrollHandler = function () {
    // Find the element with the class 'mobile-container'
    var section = document.querySelector('.mobile-container');
    var htmlDoc = document.querySelector('html');
    var bodyEle = document.querySelector('body');
    // Scroll to the top of the element with smooth behavior
    section === null || section === void 0 ? void 0 : section.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
    htmlDoc === null || htmlDoc === void 0 ? void 0 : htmlDoc.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
    bodyEle === null || bodyEle === void 0 ? void 0 : bodyEle.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
};
var showField$1 = function (page, fieldKey) {
    var field = page.value.find(function (f) { return f.fieldKey == fieldKey; });
    return Boolean(field === null || field === void 0 ? void 0 : field.show);
};
var getFieldQuestionValue$1 = function (question, fieldKey) {
    var _a;
    var field = (_a = question === null || question === void 0 ? void 0 : question.value) === null || _a === void 0 ? void 0 : _a.find(function (f) { return f.fieldKey == fieldKey; });
    return field === null || field === void 0 ? void 0 : field.fieldValue;
};
var showQuestionField$1 = function (question, fieldKey) {
    var field = question.value.find(function (f) { return f.fieldKey == fieldKey; });
    return Boolean(field === null || field === void 0 ? void 0 : field.show);
};
var doesUserServiceTypeMatchQuestion = function (userSelectedServiceType, question) {
    var serviceTypesOfThisQuestion = getFieldQuestionValue$1(question, 'show_question_if_service_type')
        .filter(function (type) { return type.show; })
        .map(function (type) { return type.key; });
    return serviceTypesOfThisQuestion.includes(userSelectedServiceType);
};
var doesUserRatingMatchQuestion = function (question, isPositiveRating, isNegativeRating) {
    var hasPositiveRatingDependency = getFieldQuestionValue$1(question, 'show_question_if_rating') == true;
    var hasNegativeRatingDependency = getFieldQuestionValue$1(question, 'show_question_if_rating') == false;
    return (hasPositiveRatingDependency && isPositiveRating) || (hasNegativeRatingDependency && isNegativeRating);
};
var computeQuestionsMap = function (_a) {
    var _b, _c, _d, _e;
    var currentPage = _a.currentPage;
    var questionValueFactMap = {};
    if ((currentPage === null || currentPage === void 0 ? void 0 : currentPage.isCustomPage) || STATIC_PAGE_KEYS_WITH_CUSTOM_QUESTIONS.includes(currentPage === null || currentPage === void 0 ? void 0 : currentPage.pageKey)) {
        var isExperienceDetailsPage = lodashExports.isEqual(currentPage === null || currentPage === void 0 ? void 0 : currentPage.pageKey, PAGE_KEYS.EXPERIENCE_DETAILS);
        var isPersonalInformationPage = lodashExports.isEqual(currentPage === null || currentPage === void 0 ? void 0 : currentPage.pageKey, PAGE_KEYS.PERSONAL_INFORMATION);
        for (var key in currentPage === null || currentPage === void 0 ? void 0 : currentPage.selectedValue) {
            var selectedValue = isExperienceDetailsPage || isPersonalInformationPage
                ? currentPage === null || currentPage === void 0 ? void 0 : currentPage.selectedValue[key]
                : currentPage === null || currentPage === void 0 ? void 0 : currentPage.selectedValue[key].value; // this will work for custom page and rating page
            if (((_b = currentPage === null || currentPage === void 0 ? void 0 : currentPage.selectedValue[key]) === null || _b === void 0 ? void 0 : _b.questionType) === 'picture-selection') {
                selectedValue = selectedValue.value;
            }
            questionValueFactMap["".concat(key, "_value")] = selectedValue;
        }
    }
    else {
        switch (currentPage === null || currentPage === void 0 ? void 0 : currentPage.pageKey) {
            case PAGE_KEYS.TYPE_OF_ORDER:
                questionValueFactMap['serviceType_value'] = (_c = currentPage === null || currentPage === void 0 ? void 0 : currentPage.selectedValue) === null || _c === void 0 ? void 0 : _c.key;
                break;
            case PAGE_KEYS.CHOOSE_LOCATION:
                questionValueFactMap['location_value'] = (_d = currentPage === null || currentPage === void 0 ? void 0 : currentPage.selectedValue) === null || _d === void 0 ? void 0 : _d.value;
                break;
            case PAGE_KEYS.DELIVERY_PLATFORM:
                questionValueFactMap['deliveryPlatform_value'] = (_e = currentPage === null || currentPage === void 0 ? void 0 : currentPage.selectedValue) === null || _e === void 0 ? void 0 : _e.key;
                break;
        }
    }
    return questionValueFactMap;
};
var generateQuestionsMapUntilCurrentPage = function (_a) {
    var _b, _c;
    var _d = _a.pages, pages = _d === void 0 ? [] : _d, page = _a.page, globalSelectedFactMap = _a.globalSelectedFactMap;
    var questionSelectedFactValueMap = __assign({}, globalSelectedFactMap);
    var pageIterator = 0;
    // Run until the page key matches the current page key
    while (((_b = pages[pageIterator]) === null || _b === void 0 ? void 0 : _b.pageKey) !== (page === null || page === void 0 ? void 0 : page.pageKey) && pageIterator < pages.length) {
        var currentPage = pages[pageIterator];
        questionSelectedFactValueMap = __assign(__assign({}, questionSelectedFactValueMap), computeQuestionsMap({ currentPage: currentPage }));
        pageIterator++;
    }
    // Also process the current page
    if (((_c = pages[pageIterator]) === null || _c === void 0 ? void 0 : _c.pageKey) === (page === null || page === void 0 ? void 0 : page.pageKey)) {
        var currentPage = pages[pageIterator];
        questionSelectedFactValueMap = __assign(__assign({}, questionSelectedFactValueMap), computeQuestionsMap({ currentPage: currentPage }));
    }
    return questionSelectedFactValueMap;
};
var evaluateQuestionConditions = function (engine, factRecord, question) { return __awaiter(void 0, void 0, void 0, function () {
    var resolvedFacts, canShowQuestion;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, engine.run(factRecord)];
            case 1:
                resolvedFacts = _b.sent();
                canShowQuestion = false;
                if (!(question === null || question === void 0 ? void 0 : question.showOptions) || lodashExports.isEmpty((_a = question === null || question === void 0 ? void 0 : question.showOptions) === null || _a === void 0 ? void 0 : _a.conditions)) {
                    canShowQuestion = true;
                }
                resolvedFacts.events.forEach(function (event) {
                    if (lodashExports.isEqual(event.type, 'show')) {
                        canShowQuestion = true;
                    }
                });
                return [2 /*return*/, {
                        questionId: question === null || question === void 0 ? void 0 : question.originQuestionId,
                        canShowQuestion: canShowQuestion
                    }];
        }
    });
}); };
var generateConditionalRulesEngine = function (_a) {
    var pages = _a.pages;
    var globalQuestionRulesRecord = {};
    pages.forEach(function (page) {
        var currentPageQuestions = page === null || page === void 0 ? void 0 : page.questions;
        if (((page === null || page === void 0 ? void 0 : page.isCustomPage) || STATIC_PAGE_KEYS_WITH_CUSTOM_QUESTIONS.includes(page === null || page === void 0 ? void 0 : page.pageKey)) &&
            currentPageQuestions &&
            !lodashExports.isEmpty(currentPageQuestions)) {
            currentPageQuestions.forEach(function (question) {
                var _a;
                var rules = [];
                if (!lodashExports.isEmpty((_a = question === null || question === void 0 ? void 0 : question.showOptions) === null || _a === void 0 ? void 0 : _a.conditions)) {
                    var ruleObj = {};
                    var orConditions = [];
                    console.log('question.showOptions.conditions: ', question.showOptions.conditions);
                    //Add logic here to iterate over question.showOptions.conditions
                    // the next iteration should be OR and not AND
                    for (var _i = 0, _b = question.showOptions.conditions; _i < _b.length; _i++) {
                        var conditionGroup = _b[_i];
                        var andConditions = [];
                        console.log('conditionGroup: ', conditionGroup);
                        for (var _c = 0, _d = conditionGroup.logic; _c < _d.length; _c++) {
                            var logicItem = _d[_c];
                            andConditions.push({
                                fact: logicItem.questionId + '_value',
                                operator: logicItem.operation,
                                value: logicItem.value
                            });
                        }
                        // Each AND group is one block inside 'any'
                        orConditions.push({ all: andConditions });
                    }
                    ruleObj.conditions = { any: orConditions };
                    ruleObj.event = {
                        type: question.showOptions.conditions[0].action,
                        params: {
                            questionId: question.originQuestionId
                        }
                    };
                    rules.push(ruleObj);
                    console.log('rules: ', rules);
                }
                var engine = new dist.Engine();
                // Define the custom operator function
                function similiarItemList(factValue, ruleValue) {
                    var mostSimiliarElement = null;
                    if (!factValue) {
                        return mostSimiliarElement != null;
                    }
                    for (var index = 0; index < factValue.length; index++) {
                        var element = factValue[index];
                        if (Qe(element, ruleValue) > 80) {
                            mostSimiliarElement = element;
                        }
                    }
                    return mostSimiliarElement != null;
                }
                // Define the custom operator function
                function containsCommonElements(factValue, ruleValue) {
                    return lodashExports.isArray(factValue) && factValue.some(function (item) { return ruleValue.includes(item); });
                }
                // Adding  custom operator to the engine
                engine.addOperator('similiarTo', similiarItemList);
                // Adding  custom operator to the engine
                engine.addOperator('commonElement', containsCommonElements);
                // add custom operators
                rules.forEach(function (rule) { return engine.addRule(new dist.Rule(rule)); });
                globalQuestionRulesRecord[question.originQuestionId] = {
                    rulesList: rules,
                    engine: engine
                };
            });
        }
    });
    return globalQuestionRulesRecord;
};
var getInitialQuestionsVisibleStatus = function (_a) {
    var pages = _a.pages;
    var visibleQuestionsMap = {};
    pages.forEach(function (page) {
        if (((page === null || page === void 0 ? void 0 : page.isCustomPage) || STATIC_PAGE_KEYS_WITH_CUSTOM_QUESTIONS.includes(page === null || page === void 0 ? void 0 : page.pageKey)) && page.questions) {
            page === null || page === void 0 ? void 0 : page.questions.forEach(function (question) {
                var _a, _b;
                visibleQuestionsMap[question === null || question === void 0 ? void 0 : question.originQuestionId] =
                    ((_a = question === null || question === void 0 ? void 0 : question.showOptions) === null || _a === void 0 ? void 0 : _a.conditions) && !lodashExports.isEmpty((_b = question === null || question === void 0 ? void 0 : question.showOptions) === null || _b === void 0 ? void 0 : _b.conditions) ? false : true;
            });
        }
    });
    return visibleQuestionsMap;
};
var getInitialSelectedFactMap = function (_a) {
    var pages = _a.pages, itemList = _a.itemList;
    var factMap = {};
    var questions = pages.reduce(function (acc, page) {
        if (((page === null || page === void 0 ? void 0 : page.isCustomPage) || STATIC_PAGE_KEYS_WITH_CUSTOM_QUESTIONS.includes(page === null || page === void 0 ? void 0 : page.pageKey)) && (page === null || page === void 0 ? void 0 : page.questions)) {
            acc.push.apply(acc, page.questions);
        }
        return acc;
    }, []);
    var initializedFactMap = questions.reduce(function (acc, question) {
        acc[question.originQuestionId + '_value'] =
            factMap[(question === null || question === void 0 ? void 0 : question.originQuestionId) + '_value'] !== undefined ? factMap[question === null || question === void 0 ? void 0 : question.originQuestionId] : null;
        return acc;
    }, {});
    initializedFactMap['rating_value'] = null; // TODO: EXPRESS PARAMS
    initializedFactMap['serviceType_value'] = null; // TODO: EXPRESS PARAMS
    initializedFactMap['location_value'] = null; // TODO: EXPRESS PARAMS
    initializedFactMap['deliveryPlatform_value'] = null; // TODO: EXPRESS PARAMS
    initializedFactMap['itemList_value'] = itemList ? itemList : [];
    return initializedFactMap;
};
var getQuestionsVisibleStatus = function (_a) {
    var page = _a.page, factMap = _a.factMap, allQuestionsRulesFromEngine = _a.allQuestionsRulesFromEngine;
    return __awaiter(void 0, void 0, void 0, function () {
        var visibleQuestionsMap, responses, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    visibleQuestionsMap = {};
                    if (!(((page === null || page === void 0 ? void 0 : page.isCustomPage) || STATIC_PAGE_KEYS_WITH_CUSTOM_QUESTIONS.includes(page === null || page === void 0 ? void 0 : page.pageKey)) &&
                        (page === null || page === void 0 ? void 0 : page.questions) &&
                        !lodashExports.isEmpty(page === null || page === void 0 ? void 0 : page.questions))) return [3 /*break*/, 4];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Promise.all(page.questions.map(function (question) { return __awaiter(void 0, void 0, void 0, function () {
                            var _a;
                            return __generator(this, function (_b) {
                                return [2 /*return*/, evaluateQuestionConditions((_a = allQuestionsRulesFromEngine === null || allQuestionsRulesFromEngine === void 0 ? void 0 : allQuestionsRulesFromEngine[question === null || question === void 0 ? void 0 : question.originQuestionId]) === null || _a === void 0 ? void 0 : _a.engine, factMap, question)];
                            });
                        }); }))];
                case 2:
                    responses = _b.sent();
                    responses.forEach(function (response) {
                        visibleQuestionsMap[response === null || response === void 0 ? void 0 : response.questionId] = response.canShowQuestion;
                    });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    console.error(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, visibleQuestionsMap];
            }
        });
    });
};
var getQuestionsVisibleStatusForAllPages = function (_a) {
    var pages = _a.pages, factMap = _a.factMap, allQuestionsRulesFromEngine = _a.allQuestionsRulesFromEngine;
    return __awaiter(void 0, void 0, void 0, function () {
        var visibleQuestionsMap, questions, responses, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    visibleQuestionsMap = {};
                    questions = pages.reduce(function (acc, page) {
                        if (((page === null || page === void 0 ? void 0 : page.isCustomPage) || STATIC_PAGE_KEYS_WITH_CUSTOM_QUESTIONS.includes(page === null || page === void 0 ? void 0 : page.pageKey)) && (page === null || page === void 0 ? void 0 : page.questions)) {
                            acc.push.apply(acc, page.questions);
                        }
                        return acc;
                    }, []);
                    if (!!lodashExports.isEmpty(questions)) return [3 /*break*/, 4];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Promise.all(questions.map(function (question) { return __awaiter(void 0, void 0, void 0, function () {
                            var _a;
                            return __generator(this, function (_b) {
                                return [2 /*return*/, evaluateQuestionConditions((_a = allQuestionsRulesFromEngine === null || allQuestionsRulesFromEngine === void 0 ? void 0 : allQuestionsRulesFromEngine[question === null || question === void 0 ? void 0 : question.originQuestionId]) === null || _a === void 0 ? void 0 : _a.engine, factMap, question)];
                            });
                        }); }))];
                case 2:
                    responses = _b.sent();
                    responses.forEach(function (response) {
                        visibleQuestionsMap[response === null || response === void 0 ? void 0 : response.questionId] = response.canShowQuestion;
                    });
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _b.sent();
                    console.error(error_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, visibleQuestionsMap];
            }
        });
    });
};
var buildGlobalQuestionsDependencyMap = function (pages) {
    var globalQuestionsDependencyMap = {};
    pages.forEach(function (page) {
        if (((page === null || page === void 0 ? void 0 : page.isCustomPage) || STATIC_PAGE_KEYS_WITH_CUSTOM_QUESTIONS.includes(page === null || page === void 0 ? void 0 : page.pageKey)) && (page === null || page === void 0 ? void 0 : page.questions)) {
            page.questions.forEach(function (question) {
                var _a;
                if ((question === null || question === void 0 ? void 0 : question.showOptions) && ((_a = question === null || question === void 0 ? void 0 : question.showOptions) === null || _a === void 0 ? void 0 : _a.conditions)) {
                    question.showOptions.conditions.forEach(function (condition) {
                        condition.logic.forEach(function (logic) {
                            if (!globalQuestionsDependencyMap[logic.questionId]) {
                                globalQuestionsDependencyMap[logic.questionId] = [];
                            }
                            globalQuestionsDependencyMap[logic.questionId].push(question === null || question === void 0 ? void 0 : question.originQuestionId);
                        });
                    });
                }
            });
        }
    });
    return globalQuestionsDependencyMap;
};
var buildItemLevelQuestionsWithConditions = function (pages, itemList) {
    var updatedPages = pages.map(function (page) {
        var _a;
        var liliItemList = itemList ? itemList.concat() : [];
        var itemVisibleSet = new Set();
        (_a = page === null || page === void 0 ? void 0 : page.questions) === null || _a === void 0 ? void 0 : _a.map(function (question) {
            if ((question === null || question === void 0 ? void 0 : question.questionType) == 'item_tiered_rating') {
                question.hideThisItemQuestion = false;
                // if (!isEmpty(liliItemList)) {
                {
                    question.hideThisItemQuestion = false;
                    itemVisibleSet.add(question === null || question === void 0 ? void 0 : question.originQuestionId);
                    question.itemName = liliItemList.shift();
                }
            }
        });
        var updatedQuestionsLatest = ((page === null || page === void 0 ? void 0 : page.questions) || [])
            .map(function (question) {
            if ((question === null || question === void 0 ? void 0 : question.questionType) == 'item_sub_tiered_rating') {
                question.hideThisItemQuestion = true;
                if (itemVisibleSet.has(question === null || question === void 0 ? void 0 : question.parentQuestionId)) {
                    question.hideThisItemQuestion = false;
                }
            }
            return question;
        })
            .filter(function (obj) {
            return obj.hideThisItemQuestion != true;
        });
        return __assign(__assign({}, page), { questions: updatedQuestionsLatest });
    });
    return updatedPages;
};
var getQuestionById = function (id, pages) {
    for (var _i = 0, pages_1 = pages; _i < pages_1.length; _i++) {
        var page = pages_1[_i];
        if (page === null || page === void 0 ? void 0 : page.questions) {
            for (var _a = 0, _b = page === null || page === void 0 ? void 0 : page.questions; _a < _b.length; _a++) {
                var question = _b[_a];
                if ((question === null || question === void 0 ? void 0 : question.originQuestionId) === id) {
                    return question;
                }
            }
        }
    }
    return null;
};
var generateFullConditionLogic = function (questionId, globalQuestionsDependencyMap, pages, index) {
    var buildLogic = function (id, conditions) {
        var _a, _b, _c;
        if (conditions === void 0) { conditions = []; }
        var question = getQuestionById(id, pages);
        if (question && (question === null || question === void 0 ? void 0 : question.showOptions) && !lodashExports.isEmpty((_a = question === null || question === void 0 ? void 0 : question.showOptions) === null || _a === void 0 ? void 0 : _a.conditions)) {
            var i_1 = 0;
            (_c = (_b = question === null || question === void 0 ? void 0 : question.showOptions) === null || _b === void 0 ? void 0 : _b.conditions) === null || _c === void 0 ? void 0 : _c.forEach(function (condition) {
                if (index === i_1) {
                    // add only for those conditions
                    condition.logic.forEach(function (logic) {
                        if (!conditions.some(function (existingLogic) { return lodashExports.isEqual(existingLogic, logic); })) {
                            conditions.push(logic);
                        }
                        buildLogic(logic.questionId, conditions);
                    });
                }
                i_1++;
            });
        }
        return conditions;
    };
    return buildLogic(questionId);
};
var updateQuestionsWithFullConditions = function (pages, globalQuestionsDependencyMap) {
    var updatedPages = pages.map(function (page) {
        var updatedQuestions = ((page === null || page === void 0 ? void 0 : page.questions) || []).map(function (question) {
            var _a, _b, _c, _d;
            if (((page === null || page === void 0 ? void 0 : page.isCustomPage) || STATIC_PAGE_KEYS_WITH_CUSTOM_QUESTIONS.includes(page === null || page === void 0 ? void 0 : page.pageKey)) &&
                (question === null || question === void 0 ? void 0 : question.showOptions) &&
                !lodashExports.isEmpty((_a = question === null || question === void 0 ? void 0 : question.showOptions) === null || _a === void 0 ? void 0 : _a.conditions)) {
                // Convert condition values to proper types before processing
                question.showOptions.conditions = convertConditionValuesToCorrectTypes(question.showOptions.conditions);
                // need to run an array here for each condition
                // need to edit this logic so it generate full condition properly in OR
                for (var index = 0; index < question.showOptions.conditions.length; index++) {
                    generateFullConditionLogic(question === null || question === void 0 ? void 0 : question.originQuestionId, globalQuestionsDependencyMap, pages, index);
                    console.log('fullConditions: ', question.showOptions.conditions[index].logic);
                    // question.showOptions.conditions[index].logic = fullConditions;
                }
            }
            // Handle parentQuestionId
            if (question === null || question === void 0 ? void 0 : question.parentQuestionId) {
                var parentQuestion = getQuestionById(question.parentQuestionId, pages);
                if (parentQuestion && (parentQuestion === null || parentQuestion === void 0 ? void 0 : parentQuestion.showOptions) && !lodashExports.isEmpty((_b = parentQuestion === null || parentQuestion === void 0 ? void 0 : parentQuestion.showOptions) === null || _b === void 0 ? void 0 : _b.conditions)) {
                    // Convert parent condition values to proper types as well
                    var convertedParentConditions = convertConditionValuesToCorrectTypes((_c = parentQuestion === null || parentQuestion === void 0 ? void 0 : parentQuestion.showOptions) === null || _c === void 0 ? void 0 : _c.conditions);
                    var parentConditions = ((_d = convertedParentConditions === null || convertedParentConditions === void 0 ? void 0 : convertedParentConditions[0]) === null || _d === void 0 ? void 0 : _d.logic) || [];
                    var uniqueParentConditions = parentConditions.filter(function (parentCondition) {
                        var _a, _b, _c, _d;
                        return !((_d = (_c = (_b = (_a = question === null || question === void 0 ? void 0 : question.showOptions) === null || _a === void 0 ? void 0 : _a.conditions) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.logic) === null || _d === void 0 ? void 0 : _d.some(function (existingLogic) {
                            return lodashExports.isEqual(existingLogic, parentCondition);
                        }));
                    });
                    if (!lodashExports.isEmpty(uniqueParentConditions)) {
                        if (!question.showOptions) {
                            question.showOptions = { conditions: [{ logic: [], action: 'show' }] };
                        }
                        else if (lodashExports.isEmpty(question.showOptions.conditions)) {
                            question.showOptions.conditions = [{ logic: [], action: 'show' }];
                        }
                        uniqueParentConditions.forEach(function (uniqueParentCondition) {
                            question.showOptions.conditions[0].logic.push(uniqueParentCondition);
                        });
                    }
                }
            }
            return question;
        });
        return __assign(__assign({}, page), { questions: updatedQuestions });
    });
    return updatedPages;
};
/**
 * Helper function to convert condition values from strings to appropriate types
 * based on the question type. This fixes the issue where rating comparisons fail
 * because values are stored as strings (e.g., "-1") but compared as integers (-1).
 *
 * Example: Condition with value "-1" for thumbs/rating questions gets converted to -1
 * so that condition.value === selectedRating works properly.
 *
 * @param conditions Array of condition objects
 * @returns Array of condition objects with properly typed values
 */
var convertConditionValuesToCorrectTypes = function (conditions) {
    return conditions.map(function (condition) {
        var _a;
        return (__assign(__assign({}, condition), { logic: ((_a = condition.logic) === null || _a === void 0 ? void 0 : _a.map(function (logicItem) {
                var convertedLogic = __assign({}, logicItem);
                // Convert value based on question type
                if (convertedLogic.questionType && convertedLogic.value !== undefined) {
                    switch (convertedLogic.questionType) {
                        case 'ratingtype':
                        case 'tiered_rating':
                        case 'sub_tiered_rating':
                        case 'item_tiered_rating':
                        case 'item_sub_tiered_rating':
                            // Convert string values to integers for rating questions
                            var numValue = Number(convertedLogic.value);
                            if (!isNaN(numValue)) {
                                convertedLogic.value = numValue;
                            }
                            break;
                    }
                }
                return convertedLogic;
            })) || [] }));
    });
};
var reformatQuestionsWithFullConditions = function (pages, itemList) {
    var pagesWithItemLevelQuestions = buildItemLevelQuestionsWithConditions(pages, itemList);
    var globalQuestionsDependencyMap = buildGlobalQuestionsDependencyMap(pagesWithItemLevelQuestions);
    var updatedPages = updateQuestionsWithFullConditions(pagesWithItemLevelQuestions, globalQuestionsDependencyMap);
    return updatedPages;
};
var cleanUpSurveyDetailsForSubmission = function (page, globalQuestionsVisibleMap) {
    var _a;
    var selectedValue = page.selectedValue;
    var originQuestionIdsToBeDeleted = Object.keys(globalQuestionsVisibleMap).filter(function (key) { return !globalQuestionsVisibleMap[key]; }) || [];
    if (typeof selectedValue === 'object' && selectedValue !== null) {
        // Clean up origin question id types
        for (var key in selectedValue) {
            var value = selectedValue[key];
            if (selectedValue[key] && (originQuestionIdsToBeDeleted === null || originQuestionIdsToBeDeleted === void 0 ? void 0 : originQuestionIdsToBeDeleted.includes(key))) {
                if (value === null || value === void 0 ? void 0 : value.generatedQuestionId) {
                    selectedValue = lodashExports.omit(selectedValue, [value === null || value === void 0 ? void 0 : value.generatedQuestionId]);
                }
                selectedValue = lodashExports.omit(selectedValue, [key]);
            }
            // Clean up origin question id types
            if (selectedValue[key] &&
                typeof selectedValue[key] === 'object' &&
                ((_a = selectedValue[key]) === null || _a === void 0 ? void 0 : _a.questionIdType) === 'origin-question-id') {
                selectedValue = lodashExports.omit(selectedValue, [key]);
            }
        }
    }
    // Final clean up of all falsy question ids and origin questionIds
    selectedValue = lodashExports.omit(selectedValue, originQuestionIdsToBeDeleted);
    return {
        pageKey: page.pageKey,
        isCustomPage: page.isCustomPage,
        value: selectedValue,
        isCustomQuestionAllowed: page.isCustomQuestionAllowed,
        metaData: page.metaData
    };
};
var computeCanGoToNextPage = function (customVisibleQuestions) {
    if (!customVisibleQuestions || lodashExports.isEmpty(customVisibleQuestions)) {
        return { canGoToNextPage: true, lastQuestion: null };
    }
    var lastQuestion = lodashExports.last(customVisibleQuestions);
    if (!SKIP_ABLE_QUESTION_TYPE.includes(lastQuestion.questionType)) {
        return { canGoToNextPage: false, lastQuestion: lastQuestion };
    }
    var isRequired = lastQuestion.value.some(function (field) { return (field === null || field === void 0 ? void 0 : field.fieldKey) === 'required' && (field === null || field === void 0 ? void 0 : field.showRequired); });
    if (isRequired) {
        return { canGoToNextPage: true, lastQuestion: lastQuestion };
    }
    return { canGoToNextPage: false, lastQuestion: lastQuestion };
};
var groupChildQuestionsWithParent = function (questions) {
    var reorderedQuestions = [];
    var childrenMap = {};
    // Create a map of parent question ids to their children
    questions.forEach(function (question) {
        if (question.parentQuestionId) {
            if (!childrenMap[question.parentQuestionId]) {
                childrenMap[question.parentQuestionId] = [];
            }
            childrenMap[question.parentQuestionId].push(question);
        }
    });
    // Loop through the questions to build the reordered list
    questions.forEach(function (question) {
        if (!question.parentQuestionId) {
            // Push the parent question
            reorderedQuestions.push(question);
            // If this parent has children, push them too
            if (childrenMap[question.originQuestionId]) {
                childrenMap[question.originQuestionId].forEach(function (childQuestion) {
                    reorderedQuestions.push(childQuestion);
                });
            }
        }
    });
    // Add any remaining questions that do not have a parent (unrelated questions)
    questions.forEach(function (question) {
        if (!reorderedQuestions.includes(question)) {
            reorderedQuestions.push(question);
        }
    });
    return reorderedQuestions;
};

var INQUIRYFORM_QUESTION_TYPE = {
    NAME: 'NAME',
    EMAIL: 'EMAIL',
    INQUIRY_TYPE: 'TYPE',
    MAINTEXT: 'MAINTEXT',
    TEXTBOX: 'TEXTBOX',
    TEXTBOX_LONG: 'TEXTBOX_LONG',
    NUMBER: 'NUMBER',
    PHONE_NUMBER: 'PHONE_NUMBER',
    DATE: 'DATE',
    TIME: 'TIME',
    CHECKBOX: 'CHECKBOX',
    OUTLET_SELECT: 'OUTLET_SELECT',
    SINGLE_SELECT: 'SINGLE_SELECT',
    FILE_UPLOAD: 'FILE_UPLOAD',
    TEXT: 'TEXT'
};
var ADAPTIVE_TYPES = [
    INQUIRYFORM_QUESTION_TYPE.NAME,
    INQUIRYFORM_QUESTION_TYPE.EMAIL,
    INQUIRYFORM_QUESTION_TYPE.DATE,
    INQUIRYFORM_QUESTION_TYPE.TIME,
    INQUIRYFORM_QUESTION_TYPE.TEXTBOX,
    INQUIRYFORM_QUESTION_TYPE.NUMBER,
    INQUIRYFORM_QUESTION_TYPE.SINGLE_SELECT,
];
var FormViewer = function (_a) {
    var inquiryTypes = _a.inquiryTypes, theme = _a.theme, questionTypes = _a.questionTypes, reviewDetails = _a.reviewDetails, inquiryFormId = _a.inquiryFormId, generalInfo = _a.generalInfo, showBrandName = _a.showBrandName, region = _a.region, slug = _a.slug, logo = _a.logo, heroBanner = _a.heroBanner, outlets = _a.outlets, brandName = _a.brandName, _b = _a.thirdPartyLinks, thirdPartyLinks = _b === void 0 ? [] : _b, basePath = _a.basePath, onSubmit = _a.onSubmit, uploadFileRequest = _a.uploadFileRequest, _c = _a.editorMode, editorMode = _c === void 0 ? false : _c, _d = _a.mobile, mobile = _d === void 0 ? false : _d;
    var form = Form.useForm()[0];
    var findLocationQuestionVisible = function (_a) {
        var questionTypes = _a.questionTypes, outlets = _a.outlets;
        try {
            return (!lodashExports.isEmpty(lodashExports.find(questionTypes, function (obj) { return lodashExports.isEqual(obj === null || obj === void 0 ? void 0 : obj.questionType, INQUIRYFORM_QUESTION_TYPE.OUTLET_SELECT); })) &&
                (outlets === null || outlets === void 0 ? void 0 : outlets.length) > 0);
        }
        catch (error) {
            return false;
        }
    };
    var latLong = (editorMode
        ? {}
        : useLocation({ isLocationVisible: findLocationQuestionVisible({ questionTypes: questionTypes, outlets: outlets }) })).latLong;
    var fontColor = theme.fontColor, backgroundColor = theme.backgroundColor, fontType = theme.fontType, titleFontType = theme.titleFontType, headerBgColor = theme.headerBgColor, headerTextColor = theme.headerTextColor;
    var _e = useState(false), expiredProfileUrl = _e[0], setExpiredProfileUrl = _e[1];
    var _f = useState(false), thankYouModalVisible = _f[0], setThankYouModalVisible = _f[1];
    var _g = useState(function () {
        return inquiryTypes.length ? inquiryTypes[0].name : undefined;
    }), inquiryTypeSelected = _g[0], setInquiryTypeSelected = _g[1];
    var _h = useState([]), questionsResponses = _h[0], setQuestionsResponses = _h[1];
    var _j = useState([]), questionsBasedOnCommonType = _j[0], setQuestionsBasedOnCommonType = _j[1];
    var _k = useState([]), questionsBasedOnInquiryType = _k[0], setQuestionsBasedOnInquiryType = _k[1];
    var _l = useState(false), loadingInquiryForm = _l[0], setLoadingInquiryForm = _l[1];
    var reviewDetailsDisplayName = lodashExports.get(reviewDetails, 'reviewerDetails.displayName') === PRIVATE_USER
        ? 'Private User'
        : lodashExports.get(reviewDetails, 'reviewerDetails.displayName');
    var reviewDetailsProfilePhotoUrl = lodashExports.get(reviewDetails, 'reviewerDetails.profilePhotoUrl');
    var locations = useMemo(function () {
        if (latLong) {
            return sortOutlets$1(latLong, outlets, region === REGIONS.US);
        }
        return outlets;
    }, [outlets, latLong]);
    useEffect(function () {
        var inquiryTypeQuestionIndex = questionsBasedOnCommonType.findIndex(function (questionData) {
            return lodashExports.isEqual(questionData === null || questionData === void 0 ? void 0 : questionData.questionType, INQUIRYFORM_QUESTION_TYPE.INQUIRY_TYPE);
        });
        var questionsResponses = !lodashExports.isEmpty(questionsBasedOnCommonType) && !lodashExports.isEqual(inquiryTypeQuestionIndex, -1)
            ? __spreadArray(__spreadArray(__spreadArray([], ((questionsBasedOnCommonType === null || questionsBasedOnCommonType === void 0 ? void 0 : questionsBasedOnCommonType.slice(0, inquiryTypeQuestionIndex + 1)) || []), true), (questionsBasedOnInquiryType || []), true), ((questionsBasedOnCommonType === null || questionsBasedOnCommonType === void 0 ? void 0 : questionsBasedOnCommonType.slice(inquiryTypeQuestionIndex + 1)) || []), true) : questionsBasedOnCommonType;
        setQuestionsResponses(questionsResponses);
    }, [questionsBasedOnCommonType, questionsBasedOnInquiryType]);
    /**
     * Makes adaptive lauout as per the form field type
     */
    var adaptiveLayoutBuilder = useMemo(function () {
        var buildLayoutResponse = [];
        var layoutIndex = 0;
        questionsResponses.forEach(function (questionData, index) {
            if (ADAPTIVE_TYPES.includes(questionData.questionType)) {
                var NEXT_FIELD = questionsResponses[index + 1];
                var IS_NEXT_SHORT = NEXT_FIELD && ADAPTIVE_TYPES.includes(NEXT_FIELD.questionType);
                if (index === 0 && IS_NEXT_SHORT) {
                    buildLayoutResponse.push(__assign(__assign({}, questionData), { col: 12 }));
                    layoutIndex += 1;
                }
                else if (index === 0 && !IS_NEXT_SHORT) {
                    buildLayoutResponse.push(__assign(__assign({}, questionData), { col: 24 }));
                    layoutIndex += 2;
                }
                else if (index > 0 && layoutIndex % 2 !== 0) {
                    buildLayoutResponse.push(__assign(__assign({}, questionData), { col: 12 }));
                    layoutIndex += 1;
                }
                else if (index > 0 && layoutIndex % 2 === 0 && IS_NEXT_SHORT) {
                    buildLayoutResponse.push(__assign(__assign({}, questionData), { col: 12 }));
                    layoutIndex += 1;
                }
                else {
                    buildLayoutResponse.push(__assign(__assign({}, questionData), { col: 24 }));
                    layoutIndex += 2;
                }
            }
            else {
                buildLayoutResponse.push(__assign(__assign({}, questionData), { col: 24 }));
                layoutIndex += 2;
            }
        });
        return buildLayoutResponse;
    }, [questionsResponses]);
    useEffect(function () {
        var commonQuestionsFiltered = questionTypes.filter(function (question) { var _a; return lodashExports.isEqual((_a = question === null || question === void 0 ? void 0 : question.types) === null || _a === void 0 ? void 0 : _a.length, 0); });
        var inquiryQuestionsFiltered = questionTypes.filter(function (question) { var _a, _b; return ((_b = (_a = question === null || question === void 0 ? void 0 : question.types) === null || _a === void 0 ? void 0 : _a.filter(function (type) { return lodashExports.isEqual(type === null || type === void 0 ? void 0 : type.name, inquiryTypeSelected); })) === null || _b === void 0 ? void 0 : _b.length) > 0; });
        setQuestionsBasedOnCommonType(commonQuestionsFiltered);
        setQuestionsBasedOnInquiryType(inquiryQuestionsFiltered);
    }, [questionTypes, inquiryTypeSelected]);
    useEffect(function () {
        var _a;
        // set name by default if review have reviewer name
        if (questionsResponses === null || questionsResponses === void 0 ? void 0 : questionsResponses.length) {
            if (!lodashExports.isEmpty(reviewDetails) && reviewDetailsDisplayName) {
                var nameQuestionResponse = questionsResponses.find(function (o) { return o.questionType === INQUIRYFORM_QUESTION_TYPE.NAME; });
                if (nameQuestionResponse) {
                    nameQuestionResponse['responseText'] = reviewDetailsDisplayName;
                    form.setFieldsValue((_a = {}, _a[nameQuestionResponse.id] = reviewDetailsDisplayName, _a));
                    setQuestionsResponses(questionsResponses);
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [questionsResponses, reviewDetails]);
    var onChangeQuestion = function (value, index, fieldKey, isInquiryType) {
        if (isInquiryType === void 0) { isInquiryType = false; }
        if (isInquiryType) {
            setInquiryTypeSelected(value);
        }
        var questionsData = questionsResponses;
        questionsData[index][fieldKey] = value;
        setQuestionsResponses(questionsData);
    };
    var resetFields = function () {
        var questionsData = questionsResponses === null || questionsResponses === void 0 ? void 0 : questionsResponses.map(function (q) { return (__assign(__assign({}, q), { responseText: '' })); });
        setQuestionsResponses(questionsData);
        form.resetFields();
    };
    var handleSubmit = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var isQuestionLoading;
        return __generator(this, function (_a) {
            isQuestionLoading = questionsResponses.filter(function (eachQuestion) { return eachQuestion.showLoading; });
            if (isQuestionLoading === null || isQuestionLoading === void 0 ? void 0 : isQuestionLoading.length) {
                showNotification('Wait until upload completes to submit.', 'Inquiry Form', 'error');
                return [2 /*return*/];
            }
            setLoadingInquiryForm(true);
            if (typeof onSubmit === 'function' && !editorMode) {
                onSubmit({ questionsResponses: questionsResponses, inquiryTypeSelected: inquiryTypeSelected, values: values }, function (success) {
                    if (success) {
                        setLoadingInquiryForm(false);
                        resetFields();
                        setThankYouModalVisible(true);
                    }
                });
            }
            return [2 /*return*/];
        });
    }); };
    var beforeUpload = function (file) {
        var isLt100MB = file.size / 1024 / 1024 < 100;
        if (!isLt100MB) {
            showNotification('File must smaller than 100 MB!', 'Inquiry Form', 'error');
        }
        return isLt100MB;
    };
    var uploadFile = function (questionIndex, options) { return __awaiter(void 0, void 0, void 0, function () {
        var questionsData, file, fmData;
        return __generator(this, function (_a) {
            questionsData = __spreadArray([], questionsResponses, true);
            questionsData[questionIndex]['showLoading'] = true;
            setQuestionsResponses(questionsData);
            file = options.file;
            fmData = new FormData();
            fmData.append('file', file);
            fmData.append('inquiryFormId', inquiryFormId);
            if (typeof uploadFileRequest === 'function' && !editorMode) {
                uploadFileRequest(fmData, function (result, success) {
                    if (success) {
                        var newQuestionsData = __spreadArray([], questionsResponses, true);
                        var questionFileList = newQuestionsData[questionIndex]['fileList'] || [];
                        newQuestionsData[questionIndex]['fileList'] = __spreadArray(__spreadArray([], questionFileList, true), [
                            __assign(__assign({}, result === null || result === void 0 ? void 0 : result.data), { name: file.name, size: file.size }),
                        ], false);
                        newQuestionsData[questionIndex]['showLoading'] = false;
                        setQuestionsResponses(newQuestionsData);
                    }
                    else {
                        var newQuestionsData = __spreadArray([], questionsResponses, true);
                        newQuestionsData[questionIndex]['showLoading'] = false;
                        setQuestionsResponses(newQuestionsData);
                    }
                });
            }
            return [2 /*return*/];
        });
    }); };
    var handleRemove = function (questionIndex, index, id) {
        form.resetFields([id]);
        var newQuestionsData = __spreadArray([], questionsResponses, true);
        var questionFileList = newQuestionsData[questionIndex]['fileList'] || [];
        questionFileList.splice(index, 1);
        newQuestionsData[questionIndex]['fileList'] = __spreadArray([], questionFileList, true);
        setQuestionsResponses(newQuestionsData);
    };
    var starIcons = useMemo(function () {
        var _a;
        return (reviewDetails === null || reviewDetails === void 0 ? void 0 : reviewDetails.rating)
            ? (_a = new Array(Number(reviewDetails === null || reviewDetails === void 0 ? void 0 : reviewDetails.rating)).fill(0)) === null || _a === void 0 ? void 0 : _a.map(function (n, idx) {
                return React__default.createElement(Icon, { key: n + idx, name: "Star", type: "fill", size: 14 });
            })
            : null;
    }, [reviewDetails === null || reviewDetails === void 0 ? void 0 : reviewDetails.rating]);
    return (React__default.createElement(Spin, { spinning: loadingInquiryForm },
        React__default.createElement(DesktopViewWrap, { "$fontColor": fontColor, "$fontType": fontType, "$titleFontType": titleFontType, "$headerBgColor": headerBgColor, "$headerTextColor": headerTextColor, "$backgroundColor": backgroundColor },
            (generalInfo === null || generalInfo === void 0 ? void 0 : generalInfo.showHeroBanner) && (React__default.createElement(HeroImage, { src: heroBanner === null || heroBanner === void 0 ? void 0 : heroBanner.mediaUrl, "$mobile": mobile, "$editorMode": editorMode })),
            (generalInfo.showLogo ||
                showBrandName ||
                (generalInfo === null || generalInfo === void 0 ? void 0 : generalInfo.showTitle) ||
                ((generalInfo === null || generalInfo === void 0 ? void 0 : generalInfo.showIntroMessage) && lodashExports.isEmpty(reviewDetails))) && (React__default.createElement("div", { className: "hero-container" },
                logo && (generalInfo === null || generalInfo === void 0 ? void 0 : generalInfo.showLogo) && (React__default.createElement("img", { src: logo === null || logo === void 0 ? void 0 : logo.mediaUrl, className: "form-desk-logo", alt: "".concat(brandName) })),
                showBrandName && (React__default.createElement("h2", { className: "form-title", style: { fontFamily: titleFontType || fontType } }, brandName)),
                React__default.createElement("div", { className: "header-titles" },
                    React__default.createElement(Row, { gutter: [16, 16], className: "header-titles-row" },
                        React__default.createElement(Col, { lg: 24, xs: 24 },
                            (generalInfo === null || generalInfo === void 0 ? void 0 : generalInfo.showTitle) && (React__default.createElement("div", { className: "contact-title", style: { fontFamily: titleFontType }, dangerouslySetInnerHTML: { __html: generalInfo === null || generalInfo === void 0 ? void 0 : generalInfo.title } })),
                            lodashExports.isEmpty(reviewDetails) && (generalInfo === null || generalInfo === void 0 ? void 0 : generalInfo.showIntroMessage) ? (React__default.createElement("p", { className: "intro-message", dangerouslySetInnerHTML: { __html: generalInfo === null || generalInfo === void 0 ? void 0 : generalInfo.introMessage } })) : null))))),
            React__default.createElement("div", { className: "form-body-wrap" },
                React__default.createElement("div", { className: "links-wrap", style: { color: fontColor } },
                    (reviewDetails === null || reviewDetails === void 0 ? void 0 : reviewDetails.momosReviewId) && (React__default.createElement(AppeasementFormCardWrap, null,
                        React__default.createElement(AppeasementFormCard, null,
                            React__default.createElement(AppeasementFormCardHeader, null,
                                React__default.createElement("div", { className: "user-avatar-wrap mr-15" },
                                    reviewDetailsProfilePhotoUrl && !expiredProfileUrl ? (React__default.createElement(Avatar, { size: 50, src: reviewDetailsProfilePhotoUrl, onError: function () {
                                            setExpiredProfileUrl(true);
                                            return true;
                                        } })) : (React__default.createElement(Avatar, { size: 50, style: {
                                            backgroundColor: stringToHslColor(reviewDetailsDisplayName),
                                            verticalAlign: 'middle'
                                        } }, reviewDetailsDisplayName === null || reviewDetailsDisplayName === void 0 ? void 0 : reviewDetailsDisplayName.charAt(0))),
                                    React__default.createElement("div", { className: "platform-icon" },
                                        React__default.createElement(Icon, { name: (SOCIAL_MEDIA_PARTNER_NAME_MAPPER[reviewDetails === null || reviewDetails === void 0 ? void 0 : reviewDetails.platform] || 'Google'), type: "partners" }))),
                                React__default.createElement("div", { className: "appeasement-meta" },
                                    React__default.createElement("div", { className: "d-flex align-items-center mb-5" },
                                        React__default.createElement("div", { className: "appeasement-meta-user" }, reviewDetailsDisplayName),
                                        React__default.createElement("div", { className: "appeasement-rating ml-5" }, starIcons)),
                                    React__default.createElement("div", { className: "appeasement-meta-date" },
                                        React__default.createElement(Icon, { name: "Clock", type: "fill" }),
                                        " Created ",
                                        moment(reviewDetails === null || reviewDetails === void 0 ? void 0 : reviewDetails.createdAt).calendar()))),
                            (reviewDetails === null || reviewDetails === void 0 ? void 0 : reviewDetails.message) && (React__default.createElement(AppeasementFormCardContent, null,
                                React__default.createElement(Icon, { name: "CommentQuote", type: "outline", className: "mr-15" }),
                                "\u201C", reviewDetails === null || reviewDetails === void 0 ? void 0 :
                                reviewDetails.message,
                                "\u201D"))),
                        (generalInfo === null || generalInfo === void 0 ? void 0 : generalInfo.showIntroMessage) && (React__default.createElement("p", { className: "appeasement-intro-message", dangerouslySetInnerHTML: { __html: generalInfo === null || generalInfo === void 0 ? void 0 : generalInfo.introMessage } })))),
                    React__default.createElement(Form, { id: "momos-form", layout: "vertical", form: form, onFinish: handleSubmit },
                        React__default.createElement(Row, { gutter: [16, 0], id: "dynamic-field-wrapper" }, adaptiveLayoutBuilder === null || adaptiveLayoutBuilder === void 0 ? void 0 : adaptiveLayoutBuilder.map(function (_a, key) {
                            var id = _a.id, questionType = _a.questionType, value = _a.questionText, responseText = _a.responseText, isRequired = _a.isRequired, _b = _a.options, options = _b === void 0 ? [] : _b, _c = _a.fileList, fileList = _c === void 0 ? [] : _c, _d = _a.showLoading, showLoading = _d === void 0 ? false : _d, col = _a.col;
                            return (React__default.createElement(Col, { lg: mobile ? 24 : col, xs: 24, key: key },
                                questionType == INQUIRYFORM_QUESTION_TYPE.NAME && (React__default.createElement(Form.Item, { label: value, name: id, rules: [{ required: isRequired, message: 'Please enter your name!' }] },
                                    React__default.createElement(Input, { placeholder: "Enter name", value: responseText, onChange: function (e) { return onChangeQuestion(e.target.value, key, 'responseText'); } }))),
                                questionType == INQUIRYFORM_QUESTION_TYPE.EMAIL && (React__default.createElement(Form.Item, { label: value, name: id, rules: [{ required: isRequired, message: 'Please enter your email!' }] },
                                    React__default.createElement(Input, { placeholder: "Enter email", type: "email", value: responseText, onChange: function (e) { return onChangeQuestion(e.target.value, key, 'responseText'); } }))),
                                questionType == INQUIRYFORM_QUESTION_TYPE.INQUIRY_TYPE && (inquiryTypes === null || inquiryTypes === void 0 ? void 0 : inquiryTypes.length) > 1 && (React__default.createElement(Form.Item, { label: value },
                                    React__default.createElement(Input.Select, { options: inquiryTypes === null || inquiryTypes === void 0 ? void 0 : inquiryTypes.map(function (_a) {
                                            var name = _a.name;
                                            return ({ value: name });
                                        }), value: inquiryTypeSelected, onChange: function (value) { return onChangeQuestion(value, key, 'responseText', true); }, type: "dropdown" }))),
                                questionType == INQUIRYFORM_QUESTION_TYPE.MAINTEXT && (React__default.createElement(Form.Item, { label: value, name: id, rules: [{ required: isRequired, message: 'Required!' }] },
                                    React__default.createElement(Input.TextArea, { placeholder: "Enter here", value: responseText, onChange: function (e) { return onChangeQuestion(e.target.value, key, 'responseText'); } }))),
                                questionType == INQUIRYFORM_QUESTION_TYPE.TEXTBOX && (React__default.createElement(Form.Item, { label: value, name: id, rules: [{ required: isRequired, message: 'Required!' }] },
                                    React__default.createElement(Input, { placeholder: "Enter here", value: responseText, onChange: function (e) { return onChangeQuestion(e.target.value, key, 'responseText'); } }))),
                                questionType == INQUIRYFORM_QUESTION_TYPE.TEXTBOX_LONG && (React__default.createElement(Form.Item, { label: value, name: id, rules: [{ required: isRequired, message: 'Required!' }] },
                                    React__default.createElement(Input.TextArea, { placeholder: "Enter here", value: responseText, onChange: function (e) { return onChangeQuestion(e.target.value, key, 'responseText'); } }))),
                                questionType == INQUIRYFORM_QUESTION_TYPE.NUMBER && (React__default.createElement(Form.Item, { label: value, name: id, rules: [{ required: isRequired, message: 'Required!' }] },
                                    React__default.createElement(Input, { type: "number", placeholder: "Enter value", value: responseText, onChange: function (e) { return onChangeQuestion(e.target.value, key, 'responseText'); } }))),
                                questionType == INQUIRYFORM_QUESTION_TYPE.PHONE_NUMBER && (React__default.createElement(Form.Item, { label: value, name: id, rules: [{ required: isRequired, message: 'Required!' }] },
                                    React__default.createElement(Input.Phone, { inputClass: 'momos-input', country: PHONE_COUNTRY_CODE_MAPPING[lodashExports.upperCase(region)] || lodashExports.lowerCase(region) || 'sg', value: responseText, onChange: function (phone) { return onChangeQuestion(phone, key, 'responseText'); }, countryCodeEditable: false }))),
                                questionType == INQUIRYFORM_QUESTION_TYPE.DATE && (React__default.createElement(Form.Item, { label: value, name: id, rules: [{ required: isRequired, message: 'Required!' }] },
                                    React__default.createElement(Input.Date, { className: "ant-form-date-picker w-100", onChange: function (val) {
                                            return onChangeQuestion(val ? moment(val).format('YYYY-MM-DD') : '', key, 'responseText');
                                        }, format: DATE_FORMAT }))),
                                questionType == INQUIRYFORM_QUESTION_TYPE.TIME && (React__default.createElement(Form.Item, { label: value, name: id, rules: [{ required: isRequired, message: 'Required!' }] },
                                    React__default.createElement(Input.Time, { type: 'modal', className: "mb-10", onChange: function (time) {
                                            var _a;
                                            onChangeQuestion(time.format('HH:mm'), key, 'responseText');
                                            form.setFieldsValue((_a = {}, _a[id] = time, _a));
                                        } }))),
                                questionType == INQUIRYFORM_QUESTION_TYPE.CHECKBOX && (React__default.createElement("div", { className: "checkbox-question" },
                                    React__default.createElement(Form.Item, { name: id, valuePropName: "checked", rules: [
                                            {
                                                required: isRequired,
                                                transform: function (value) { return value || undefined; },
                                                type: 'boolean',
                                                message: 'Required!'
                                            },
                                        ] },
                                        React__default.createElement(Checkbox, { onChange: function (e) { return onChangeQuestion(String(e.target.checked), key, 'responseText'); } },
                                            React__default.createElement("label", null, (isRequired ? '* ' : '') + value))))),
                                questionType == INQUIRYFORM_QUESTION_TYPE.OUTLET_SELECT && (outlets === null || outlets === void 0 ? void 0 : outlets.length) > 0 && (React__default.createElement(Form.Item, { label: value, name: id, rules: [{ required: isRequired, message: 'Required!' }] },
                                    React__default.createElement(Input.Select, { onChange: function (value) { return onChangeQuestion(value, key, 'responseText'); }, placeholder: 'Search by address, city, or zip code', filterOption: function (input, option) {
                                            var _a;
                                            return (((_a = option.children) === null || _a === void 0 ? void 0 : _a.map(function (el) { return el.props.children; }).join('').toLowerCase().indexOf(input.toLowerCase())) >= 0);
                                        }, type: "dropdown", showSearch: true, allowClear: true, className: "custom-outlet-selection" }, locations === null || locations === void 0 ? void 0 : locations.map(function (_a) {
                                        var id = _a.id, name = _a.name, location = _a.location;
                                        return (React__default.createElement(Select$2.Option, { value: id, key: id },
                                            React__default.createElement("div", null, name),
                                            !lodashExports.isEmpty(location) ? (React__default.createElement("div", { className: "body-text-2", style: { color: 'inherit' } }, buildGoogleMapAddress(location[0]))) : null));
                                    })))),
                                questionType == INQUIRYFORM_QUESTION_TYPE.SINGLE_SELECT && (options === null || options === void 0 ? void 0 : options.length) > 0 && (React__default.createElement(Form.Item, { label: value, name: id, rules: [{ required: isRequired, message: 'Required!' }] },
                                    React__default.createElement(Input.Select, { options: options === null || options === void 0 ? void 0 : options.map(function (option) { return ({ label: option, value: option }); }), onChange: function (value) { return onChangeQuestion(value, key, 'responseText'); }, placeholder: "Select one", type: "dropdown" }))),
                                questionType == INQUIRYFORM_QUESTION_TYPE.FILE_UPLOAD && (React__default.createElement(React__default.Fragment, null,
                                    React__default.createElement(Form.Item, { label: value, name: id, rules: [{ required: isRequired, message: 'Required!' }] },
                                        React__default.createElement(Upload$1, { beforeUpload: beforeUpload, customRequest: function (options) { return uploadFile(key, options); }, showUploadList: false, multiple: true, fileList: fileList, accept: "image/*,video/*,audio/*,.xlsx,.xls,.doc,.docx,.ppt,.pptx,.txt,.pdf" },
                                            React__default.createElement(ActionArea, null,
                                                React__default.createElement(IconWrap, { className: "upload-icon", "$fontColor": fontColor, "$backgroundColor": backgroundColor },
                                                    React__default.createElement(Icon, { name: "ArrowUp", type: "outline", color: theme.fontColor })),
                                                React__default.createElement("div", { className: "file-upload-label" }, "Click here to upload files")))),
                                    showLoading ? (React__default.createElement(Skeleton, { active: true })) : (React__default.createElement(React__default.Fragment, null, (fileList === null || fileList === void 0 ? void 0 : fileList.length) ? (React__default.createElement(Row, { gutter: [16, 16], className: "mb-20" }, fileList === null || fileList === void 0 ? void 0 : fileList.map(function (file, index) { return (React__default.createElement(Col, { key: index, lg: 12 },
                                        React__default.createElement("div", { className: "upload-media-list" },
                                            React__default.createElement("div", { className: "media-info mr-10" },
                                                React__default.createElement("div", { className: "media-name" }, file.name),
                                                file.size && React__default.createElement("div", { className: "media-size" }, bytesToSize(file.size))),
                                            React__default.createElement("div", { className: "close-icon-wrap", onClick: function () { return handleRemove(key, index, id); } },
                                                React__default.createElement(Icon, { type: "outline", name: "Close" }))))); }))) : null)))),
                                questionType == INQUIRYFORM_QUESTION_TYPE.TEXT && (React__default.createElement("p", { className: "question-type-text ql-editor", dangerouslySetInnerHTML: { __html: value } }))));
                        })),
                        (generalInfo === null || generalInfo === void 0 ? void 0 : generalInfo.showTermsConditions) && (React__default.createElement(Row, null,
                            React__default.createElement(Col, { lg: 24, xs: 24 },
                                React__default.createElement(Agreement, { slug: slug, fontColor: fontColor, customTc: (generalInfo === null || generalInfo === void 0 ? void 0 : generalInfo.termsConditions) === DEFAULT_TS_TEXT ? '' : generalInfo === null || generalInfo === void 0 ? void 0 : generalInfo.termsConditions, required: generalInfo === null || generalInfo === void 0 ? void 0 : generalInfo.requiredTermsConditions, basePath: basePath })))),
                        (generalInfo === null || generalInfo === void 0 ? void 0 : generalInfo.showOptin) && (React__default.createElement(Row, null,
                            React__default.createElement(Col, { lg: 24, xs: 24 },
                                React__default.createElement("div", { className: "each-agreement-box" },
                                    React__default.createElement(Form.Item, { name: 'optin', valuePropName: "checked" },
                                        React__default.createElement(Checkbox, null, generalInfo.optin ? (React__default.createElement("div", { className: "forms-tc-html", dangerouslySetInnerHTML: { __html: generalInfo.optin } })) : (React__default.createElement("div", { className: "forms-tc-html" },
                                            "I'd like to receive information about offers, discounts and other marketing communications from ",
                                            brandName)))))))),
                        React__default.createElement(Row, null,
                            React__default.createElement(Col, { lg: 24, xs: 24 },
                                React__default.createElement(HighlightButton, { htmlType: "submit", type: "default", ghost: true, block: true, "$fontColor": fontColor, "$backgroundColor": backgroundColor, "$fontType": fontType, "data-testId": "form-submit" }, generalInfo.buttonTitle || 'Submit'))))),
                React__default.createElement("div", { className: "social-media-links", style: { color: fontColor, fontFamily: fontType } }, thirdPartyLinks === null || thirdPartyLinks === void 0 ? void 0 : thirdPartyLinks.map(function (type, key) {
                    return type.link && (React__default.createElement(IconWithText, { "$fontColor": fontColor, key: key, href: type.link, target: "_blank", "$fill": type.category === lodashExports.capitalize(PARTNER.GOOGLE) ||
                            type.category === lodashExports.capitalize(SOCIAL_MEDIA_PLATFORM.MESSENGER) ||
                            type.category === lodashExports.capitalize(SOCIAL_MEDIA_PLATFORM.WHATSAPP) ||
                            type.category === lodashExports.capitalize(SOCIAL_MEDIA_PLATFORM.TWITTER) ||
                            type.category === lodashExports.capitalize(SOCIAL_MEDIA_PLATFORM.SNAPCHAT) ||
                            type.category === lodashExports.capitalize(SOCIAL_MEDIA_PLATFORM.YOUTUBE) ||
                            type.category === lodashExports.capitalize(SOCIAL_MEDIA_PLATFORM.YELP) ||
                            type.category === lodashExports.capitalize(SOCIAL_MEDIA_PLATFORM.PINTEREST) ||
                            type.category === lodashExports.capitalize(SOCIAL_MEDIA_PLATFORM.LINE) ||
                            type.category === lodashExports.capitalize(SOCIAL_MEDIA_PLATFORM.SPOTIFY) ||
                            type.category === SOCIAL_MEDIA_NAME[SOCIAL_MEDIA_PLATFORM.TRIP_ADVISOR], "data-type": type.category === SOCIAL_MEDIA_NAME[SOCIAL_MEDIA_PLATFORM.TRIP_ADVISOR], onClick: function () {
                            //ga.event(TRACKING.HOME.PARTNER[SOCIAL_MEDIA_KEY_MAPPED[type?.category]]);
                        } },
                        SOCIAL_MEDIA_ICONS[type.category],
                        React__default.createElement("p", { className: "body-text", style: { color: fontColor, fontFamily: fontType } }, type.category)));
                })),
                generalInfo.showPoweredBy && React__default.createElement(PoweredByMomos, { color: fontColor, className: "form-poweredby" }),
                React__default.createElement("style", null, "\n            body {\n              background-color: transparent;\n            }\n          "))),
        React__default.createElement(ThankYouModal, { visible: thankYouModalVisible, thirdPartyLinks: thirdPartyLinks, fontType: fontType, titleFontType: titleFontType, closeModal: function () { return setThankYouModalVisible(false); }, data: generalInfo === null || generalInfo === void 0 ? void 0 : generalInfo.thankyou })));
};
var DesktopViewWrap = defaultStyled.div(templateObject_1$D || (templateObject_1$D = __makeTemplateObject(["\n  letter-spacing: ", ";\n  display: flex;\n  flex-direction: column;\n\n  .hero-container {\n    text-align: center;\n    border-bottom: 1px solid ", ";\n    padding: 1.875rem 0.625rem 0.625rem 0.625rem;\n    background: ", ";\n\n    .form-desk-logo {\n      display: block;\n      margin: 0 auto;\n      width: 15rem;\n      height: 6rem;\n      object-fit: contain;\n      margin-bottom: 0.625rem;\n    }\n\n    .form-title {\n      color: ", ";\n      margin-bottom: 1.25rem;\n    }\n  }\n\n  .form-body-wrap {\n    background-color: ", ";\n  }\n\n  .header-titles {\n    padding: 0px 5.75rem;\n    width: 80%;\n    margin: 0 auto;\n\n    @media (max-width: ", ") {\n      padding: 1.25rem 1.875rem;\n      width: 90%;\n    }\n\n    .header-titles-row {\n      flex-direction: column;\n    }\n\n    .contact-title,\n    .contact-title > * {\n      color: ", ";\n      font-family: ", ";\n      font-style: normal;\n      font-size: 2.25rem;\n      line-height: 2.5rem;\n      overflow-wrap: break-word;\n\n      p {\n        margin-bottom: 0px;\n      }\n    }\n\n    .intro-message {\n      padding-top: 1.25rem;\n    }\n\n    .intro-message,\n    .intro-message > * {\n      font-family: ", ";\n      font-size: 1rem;\n      line-height: 1.25rem;\n      color: ", ";\n      text-align: center;\n      align-self: center;\n      overflow-wrap: break-word;\n\n      p {\n        margin-bottom: 0px;\n      }\n    }\n  }\n\n  .ql-editor p,\n  .ql-editor span {\n    color: ", ";\n    font-family: ", ";\n  }\n\n  .links-wrap {\n    padding: 3.125rem 6.25rem;\n\n    width: 80%;\n    margin: 0 auto;\n\n    .appeasement-intro-message {\n      font-family: ", ";\n      font-size: 1rem;\n      line-height: 1.25rem;\n      color: ", ";\n      text-align: center;\n      align-self: center;\n      padding-top: 1.25rem;\n\n      p {\n        margin-bottom: 0px;\n      }\n    }\n\n    .appeasement-intro-message * {\n      font-family: ", ";\n      font-size: 1rem;\n      line-height: 1.25rem;\n      color: ", ";\n    }\n\n    label {\n      color: ", ";\n      font-family: ", ";\n      font-size: 0.875rem;\n    }\n\n    .custom-outlet-selection {\n      .ant-select-selection-item {\n        > div:last-child {\n          display: none;\n        }\n\n        &:after {\n          content: none;\n        }\n      }\n    }\n\n    .ant-upload {\n      transition: transform 0s cubic-bezier(0.23, 1, 0.32, 1) 0s;\n\n      .file-upload-label {\n        color: ", ";\n        font-family: ", ";\n      }\n\n      :hover {\n        .file-upload-label {\n          color: ", ";\n        }\n\n        .upload-icon {\n          background-color: ", " !important;\n          border-color: ", " !important;\n\n          svg path {\n            stroke: ", " !important;\n          }\n        }\n      }\n    }\n\n    .react-tel-input {\n      input {\n        font-family: ", ";\n      }\n\n      .form-control {\n        width: 100%;\n        height: 3.125rem;\n      }\n\n      .flag-dropdown {\n        border-radius: 550px 0 0 550px;\n      }\n\n      .selected-flag {\n        border-radius: 550px 0 0 550px;\n      }\n    }\n\n    .ant-form-date-picker {\n      height: 3.125rem;\n\n      input {\n        font-family: ", " !important;\n        font-size: 0.875rem !important;\n      }\n    }\n\n    .media-info {\n      color: ", ";\n      flex: 1;\n    }\n\n    .close-icon-wrap {\n      cursor: pointer;\n      svg path {\n        stroke: ", ";\n      }\n    }\n\n    .upload-media-list {\n      display: flex;\n    }\n\n    .ant-select-selection-placeholder {\n      font-family: ", ";\n    }\n\n    .ant-form-item-explain-error {\n      color: ", ";\n      font-family: ", ";\n    }\n\n    .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {\n      color: ", ";\n    }\n\n    .ant-input {\n      font-family: ", ";\n      font-size: 0.875rem;\n    }\n\n    .ant-picker-input > input {\n      font-family: ", ";\n      font-size: 0.875rem;\n    }\n\n    .checkbox-question {\n      display: flex;\n      align-items: center;\n    }\n\n    input[type='checkbox'] {\n      accent-color: ", ";\n      width: 0.938rem;\n      height: 0.938rem;\n      margin-right: 0.625rem;\n      cursor: pointer;\n    }\n\n    .ant-checkbox-checked .ant-checkbox-inner {\n      background-color: ", ";\n      border-color: ", ";\n    }\n\n    .ant-checkbox-checked .ant-checkbox-inner:after {\n      border-color: ", " !important;\n    }\n\n    .ant-select-selection-item {\n      font-family: ", ";\n    }\n\n    @media (max-width: ", ") {\n      padding: 1.25rem 1.875rem;\n      margin: 0;\n      width: 100%;\n    }\n\n    .submit-button,\n    .submit-button span {\n      background-color: ", ";\n      color: ", ";\n      font-family: ", ";\n    }\n  }\n\n  .forms-tc-html {\n    p,\n    span {\n      font-style: normal;\n      font-weight: 500;\n      font-size: 0.875rem;\n      line-height: 120%;\n      color: ", ";\n      font-family: ", ";\n      margin-bottom: 0px;\n    }\n  }\n\n  .ant-select .ant-select-item.ant-select-item-option {\n    font-family: ", ";\n  }\n\n  .social-media-links {\n    margin-bottom: 0.625rem;\n    margin-top: 1.25rem;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .form-poweredby {\n    margin-bottom: 5.625rem;\n  }\n"], ["\n  letter-spacing: ", ";\n  display: flex;\n  flex-direction: column;\n\n  .hero-container {\n    text-align: center;\n    border-bottom: 1px solid ", ";\n    padding: 1.875rem 0.625rem 0.625rem 0.625rem;\n    background: ", ";\n\n    .form-desk-logo {\n      display: block;\n      margin: 0 auto;\n      width: 15rem;\n      height: 6rem;\n      object-fit: contain;\n      margin-bottom: 0.625rem;\n    }\n\n    .form-title {\n      color: ", ";\n      margin-bottom: 1.25rem;\n    }\n  }\n\n  .form-body-wrap {\n    background-color: ", ";\n  }\n\n  .header-titles {\n    padding: 0px 5.75rem;\n    width: 80%;\n    margin: 0 auto;\n\n    @media (max-width: ", ") {\n      padding: 1.25rem 1.875rem;\n      width: 90%;\n    }\n\n    .header-titles-row {\n      flex-direction: column;\n    }\n\n    .contact-title,\n    .contact-title > * {\n      color: ", ";\n      font-family: ", ";\n      font-style: normal;\n      font-size: 2.25rem;\n      line-height: 2.5rem;\n      overflow-wrap: break-word;\n\n      p {\n        margin-bottom: 0px;\n      }\n    }\n\n    .intro-message {\n      padding-top: 1.25rem;\n    }\n\n    .intro-message,\n    .intro-message > * {\n      font-family: ", ";\n      font-size: 1rem;\n      line-height: 1.25rem;\n      color: ", ";\n      text-align: center;\n      align-self: center;\n      overflow-wrap: break-word;\n\n      p {\n        margin-bottom: 0px;\n      }\n    }\n  }\n\n  .ql-editor p,\n  .ql-editor span {\n    color: ", ";\n    font-family: ", ";\n  }\n\n  .links-wrap {\n    padding: 3.125rem 6.25rem;\n\n    width: 80%;\n    margin: 0 auto;\n\n    .appeasement-intro-message {\n      font-family: ", ";\n      font-size: 1rem;\n      line-height: 1.25rem;\n      color: ", ";\n      text-align: center;\n      align-self: center;\n      padding-top: 1.25rem;\n\n      p {\n        margin-bottom: 0px;\n      }\n    }\n\n    .appeasement-intro-message * {\n      font-family: ", ";\n      font-size: 1rem;\n      line-height: 1.25rem;\n      color: ", ";\n    }\n\n    label {\n      color: ", ";\n      font-family: ", ";\n      font-size: 0.875rem;\n    }\n\n    .custom-outlet-selection {\n      .ant-select-selection-item {\n        > div:last-child {\n          display: none;\n        }\n\n        &:after {\n          content: none;\n        }\n      }\n    }\n\n    .ant-upload {\n      transition: transform 0s cubic-bezier(0.23, 1, 0.32, 1) 0s;\n\n      .file-upload-label {\n        color: ", ";\n        font-family: ", ";\n      }\n\n      :hover {\n        .file-upload-label {\n          color: ", ";\n        }\n\n        .upload-icon {\n          background-color: ", " !important;\n          border-color: ", " !important;\n\n          svg path {\n            stroke: ", " !important;\n          }\n        }\n      }\n    }\n\n    .react-tel-input {\n      input {\n        font-family: ", ";\n      }\n\n      .form-control {\n        width: 100%;\n        height: 3.125rem;\n      }\n\n      .flag-dropdown {\n        border-radius: 550px 0 0 550px;\n      }\n\n      .selected-flag {\n        border-radius: 550px 0 0 550px;\n      }\n    }\n\n    .ant-form-date-picker {\n      height: 3.125rem;\n\n      input {\n        font-family: ", " !important;\n        font-size: 0.875rem !important;\n      }\n    }\n\n    .media-info {\n      color: ", ";\n      flex: 1;\n    }\n\n    .close-icon-wrap {\n      cursor: pointer;\n      svg path {\n        stroke: ", ";\n      }\n    }\n\n    .upload-media-list {\n      display: flex;\n    }\n\n    .ant-select-selection-placeholder {\n      font-family: ", ";\n    }\n\n    .ant-form-item-explain-error {\n      color: ", ";\n      font-family: ", ";\n    }\n\n    .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {\n      color: ", ";\n    }\n\n    .ant-input {\n      font-family: ", ";\n      font-size: 0.875rem;\n    }\n\n    .ant-picker-input > input {\n      font-family: ", ";\n      font-size: 0.875rem;\n    }\n\n    .checkbox-question {\n      display: flex;\n      align-items: center;\n    }\n\n    input[type='checkbox'] {\n      accent-color: ", ";\n      width: 0.938rem;\n      height: 0.938rem;\n      margin-right: 0.625rem;\n      cursor: pointer;\n    }\n\n    .ant-checkbox-checked .ant-checkbox-inner {\n      background-color: ", ";\n      border-color: ", ";\n    }\n\n    .ant-checkbox-checked .ant-checkbox-inner:after {\n      border-color: ", " !important;\n    }\n\n    .ant-select-selection-item {\n      font-family: ", ";\n    }\n\n    @media (max-width: ", ") {\n      padding: 1.25rem 1.875rem;\n      margin: 0;\n      width: 100%;\n    }\n\n    .submit-button,\n    .submit-button span {\n      background-color: ", ";\n      color: ", ";\n      font-family: ", ";\n    }\n  }\n\n  .forms-tc-html {\n    p,\n    span {\n      font-style: normal;\n      font-weight: 500;\n      font-size: 0.875rem;\n      line-height: 120%;\n      color: ", ";\n      font-family: ", ";\n      margin-bottom: 0px;\n    }\n  }\n\n  .ant-select .ant-select-item.ant-select-item-option {\n    font-family: ", ";\n  }\n\n  .social-media-links {\n    margin-bottom: 0.625rem;\n    margin-top: 1.25rem;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .form-poweredby {\n    margin-bottom: 5.625rem;\n  }\n"])), function (props) { return (props.$fontType === FontsList[3].value ? '0.6px' : 'normal'); }, function (props) { return props.$fontColor; }, function (props) { return props.$headerBgColor; }, function (props) { return props.$headerTextColor || props.$fontColor; }, function (props) { return props.$backgroundColor; }, breakpoints.tablet, function (props) { return props.$headerTextColor; }, function (props) { return props.$titleFontType; }, function (props) { return props.$titleFontType; }, function (props) { return props.$headerTextColor; }, function (props) { return props.$fontColor; }, function (props) { return props.$fontType; }, function (props) { return props.$titleFontType; }, function (props) { return props.$fontColor; }, function (props) { return props.$titleFontType; }, function (props) { return props.$fontColor; }, function (props) { return props.$fontColor; }, function (props) { return props.$fontType; }, function (props) { return props.$fontColor; }, function (props) { return props.$fontType; }, function (props) { return props.$fontColor; }, function (props) { return props.$fontColor; }, function (props) { return props.$backgroundColor; }, function (props) { return props.$backgroundColor; }, function (props) { return props.$fontType; }, function (props) { return props.$fontType; }, function (props) { return props.$fontColor; }, function (props) { return props.$fontColor; }, function (props) { return props.$fontType; }, function (props) { return props.$fontColor; }, function (props) { return props.$fontType; }, function (props) { return props.$fontColor; }, function (props) { return props.$fontType; }, function (props) { return props.$fontType; }, function (props) { return props.$fontColor; }, function (props) { return props.$backgroundColor; }, function (props) { return props.$fontColor; }, function (props) { return props.$fontColor; }, function (props) { return props.$fontType; }, breakpoints.tablet, function (props) { return props.$backgroundColor; }, function (props) { return props.$fontColor; }, function (props) { return props.$fontType; }, function (props) { return props.$fontColor || '#30384c'; }, function (props) { return props.$fontType; }, function (props) { return props.$fontType; });
var HeroImage = defaultStyled.img(templateObject_2$t || (templateObject_2$t = __makeTemplateObject(["\n  width: 100%;\n  height: ", ";\n  object-fit: cover;\n\n  @media (max-width: ", ") {\n    height: 10.625rem;\n  }\n"], ["\n  width: 100%;\n  height: ", ";\n  object-fit: cover;\n\n  @media (max-width: ", ") {\n    height: 10.625rem;\n  }\n"])), function (props) { return (props.$editorMode && props.$mobile ? '10.625rem' : '18.75rem'); }, breakpoints.tablet);
var IconWithText = defaultStyled.a(templateObject_3$h || (templateObject_3$h = __makeTemplateObject(["\n  text-align: center;\n  color: var(--white);\n  cursor: pointer;\n  padding-left: 0.625rem;\n  padding-right: 0.625rem;\n  transition: transform 0s cubic-bezier(0.23, 1, 0.32, 1) 0s;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  ", "\n\n  ", "\n\n  :hover {\n    transform: scale(1.075);\n  }\n"], ["\n  text-align: center;\n  color: var(--white);\n  cursor: pointer;\n  padding-left: 0.625rem;\n  padding-right: 0.625rem;\n  transition: transform 0s cubic-bezier(0.23, 1, 0.32, 1) 0s;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  ", "\n\n  ", "\n\n  :hover {\n    transform: scale(1.075);\n  }\n"])), function (_a) {
    var $fill = _a.$fill, $fontColor = _a.$fontColor;
    return $fill &&
        "\n    & > svg path {\n      fill: ".concat($fontColor, ";\n    }\n  ");
}, function (_a) {
    var $fill = _a.$fill, $fontColor = _a.$fontColor;
    return !$fill &&
        "\n    & > svg path {\n      stroke: ".concat($fontColor, ";\n    }\n  ");
});
var HighlightButton = defaultStyled(Button)(templateObject_4$b || (templateObject_4$b = __makeTemplateObject(["\n  border-color: ", " !important;\n  border-radius: 40px;\n\n  span {\n    font-family: ", " !important;\n    font-size: 1rem !important;\n    color: ", " !important;\n  }\n\n  & > svg path {\n    stroke: ", ";\n  }\n\n  :hover {\n    background: ", " !important;\n    border-color: ", " !important;\n\n    span {\n      font-family: ", " !important;\n      font-size: 1rem !important;\n      color: ", " !important;\n    }\n\n    & > svg path {\n      stroke: ", ";\n    }\n  }\n"], ["\n  border-color: ", " !important;\n  border-radius: 40px;\n\n  span {\n    font-family: ", " !important;\n    font-size: 1rem !important;\n    color: ", " !important;\n  }\n\n  & > svg path {\n    stroke: ", ";\n  }\n\n  :hover {\n    background: ", " !important;\n    border-color: ", " !important;\n\n    span {\n      font-family: ", " !important;\n      font-size: 1rem !important;\n      color: ", " !important;\n    }\n\n    & > svg path {\n      stroke: ", ";\n    }\n  }\n"])), function (props) { return props.$fontColor; }, function (props) { return props.$fontType; }, function (props) { return props.$fontColor; }, function (props) { return props.$fontColor; }, function (props) { return props.$fontColor; }, function (props) { return props.$backgroundColor; }, function (props) { return props.$fontType; }, function (props) {
    return isTransparent(props.$backgroundColor) ? invertColor(props.$fontColor) : props.$backgroundColor;
}, function (props) { return props.$backgroundColor; });
var ActionArea = defaultStyled.div(templateObject_5$a || (templateObject_5$a = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  &:hover {\n    color: var(--orange);\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  &:hover {\n    color: var(--orange);\n  }\n"])));
var IconWrap = defaultStyled.div(templateObject_6$8 || (templateObject_6$8 = __makeTemplateObject(["\n  height: 1.875rem;\n  width: 1.875rem;\n  border-radius: 50%;\n  background-color: ", " !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 0.625rem;\n  border: 1px solid ", ";\n"], ["\n  height: 1.875rem;\n  width: 1.875rem;\n  border-radius: 50%;\n  background-color: ", " !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 0.625rem;\n  border: 1px solid ", ";\n"])), function (props) { return props.$backgroundColor; }, function (props) { return props.$fontColor; });
var AppeasementFormCardWrap = defaultStyled.div(templateObject_7$5 || (templateObject_7$5 = __makeTemplateObject(["\n  margin-bottom: 1.875rem;\n"], ["\n  margin-bottom: 1.875rem;\n"])));
var AppeasementFormCard = defaultStyled(Card)(templateObject_8$4 || (templateObject_8$4 = __makeTemplateObject(["\n  border: 1px solid var(--grey-light);\n  border-radius: 10px;\n"], ["\n  border: 1px solid var(--grey-light);\n  border-radius: 10px;\n"])));
var AppeasementFormCardHeader = defaultStyled.div(templateObject_9$2 || (templateObject_9$2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid var(--grey-light);\n  padding-bottom: 0.938rem;\n  margin-bottom: 0.938rem;\n\n  .user-avatar-wrap {\n    position: relative;\n\n    .platform-icon {\n      transform: scale(0.75);\n      position: absolute;\n      bottom: -8px;\n      right: 0px;\n      background: var(--white);\n      width: 1.875rem;\n      height: 1.875rem;\n      border-radius: 50%;\n      padding: 0.313rem;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      box-shadow: 0px 2px 4px rgb(0 0 0 / 30%);\n    }\n  }\n\n  .appeasement-meta {\n    .appeasement-meta-user {\n      font-family: var(--font-family-bold);\n      font-style: normal;\n      font-size: 1rem;\n      line-height: 1.25rem;\n      color: var(--grey-dark);\n    }\n    .appeasement-rating {\n      display: flex;\n      align-items: center;\n\n      span svg path {\n        fill: rgb(255, 199, 0);\n        stroke: rgb(255, 199, 0);\n      }\n    }\n    .appeasement-meta-date {\n      display: flex;\n      align-items: center;\n      color: var(--grey);\n      font-family: var(--font-family-medium);\n      font-style: normal;\n      font-weight: 500;\n      font-size: 0.75rem;\n      line-height: 0.875rem;\n\n      svg {\n        margin-right: 0.313rem;\n\n        path:first-child {\n          stroke: var(--grey);\n          fill: var(--grey);\n        }\n\n        path:last-child {\n          stroke: var(--white);\n        }\n      }\n    }\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid var(--grey-light);\n  padding-bottom: 0.938rem;\n  margin-bottom: 0.938rem;\n\n  .user-avatar-wrap {\n    position: relative;\n\n    .platform-icon {\n      transform: scale(0.75);\n      position: absolute;\n      bottom: -8px;\n      right: 0px;\n      background: var(--white);\n      width: 1.875rem;\n      height: 1.875rem;\n      border-radius: 50%;\n      padding: 0.313rem;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      box-shadow: 0px 2px 4px rgb(0 0 0 / 30%);\n    }\n  }\n\n  .appeasement-meta {\n    .appeasement-meta-user {\n      font-family: var(--font-family-bold);\n      font-style: normal;\n      font-size: 1rem;\n      line-height: 1.25rem;\n      color: var(--grey-dark);\n    }\n    .appeasement-rating {\n      display: flex;\n      align-items: center;\n\n      span svg path {\n        fill: rgb(255, 199, 0);\n        stroke: rgb(255, 199, 0);\n      }\n    }\n    .appeasement-meta-date {\n      display: flex;\n      align-items: center;\n      color: var(--grey);\n      font-family: var(--font-family-medium);\n      font-style: normal;\n      font-weight: 500;\n      font-size: 0.75rem;\n      line-height: 0.875rem;\n\n      svg {\n        margin-right: 0.313rem;\n\n        path:first-child {\n          stroke: var(--grey);\n          fill: var(--grey);\n        }\n\n        path:last-child {\n          stroke: var(--white);\n        }\n      }\n    }\n  }\n"])));
var AppeasementFormCardContent = defaultStyled.div(templateObject_10$2 || (templateObject_10$2 = __makeTemplateObject(["\n  font-family: var(--font-family-medium);\n  font-style: italic;\n  font-weight: 500;\n  font-size: 0.875rem;\n  line-height: 1.063rem;\n  color: var(--grey-dark);\n\n  display: flex;\n  align-items: center;\n"], ["\n  font-family: var(--font-family-medium);\n  font-style: italic;\n  font-weight: 500;\n  font-size: 0.875rem;\n  line-height: 1.063rem;\n  color: var(--grey-dark);\n\n  display: flex;\n  align-items: center;\n"])));
var templateObject_1$D, templateObject_2$t, templateObject_3$h, templateObject_4$b, templateObject_5$a, templateObject_6$8, templateObject_7$5, templateObject_8$4, templateObject_9$2, templateObject_10$2;

var getOfferImage = function (rewardType) {
    switch (rewardType) {
        case REWARD_TYPES.DISCOUNT_AMOUNT: {
            return DEFAULT_OFFER_IMAGES.DISCOUNT_AMOUNT;
        }
        case REWARD_TYPES.PERCENTAGE_OFF: {
            return DEFAULT_OFFER_IMAGES.PERCENTAGE_OFF;
        }
        case REWARD_TYPES.FREE_ITEM: {
            return DEFAULT_OFFER_IMAGES.FREE_ITEM;
        }
        default: {
            return DEFAULT_OFFER_IMAGES.DEFAULT;
        }
    }
};

var baseGet$2 = _baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$1(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet$2(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get$1;

var get$2 = /*@__PURE__*/getDefaultExportFromCjs(get_1);

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

var _setCacheAdd = setCacheAdd$1;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */

function setCacheHas$1(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas$1;

var MapCache = _MapCache,
    setCacheAdd = _setCacheAdd,
    setCacheHas = _setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache$1(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache$1.prototype.add = SetCache$1.prototype.push = setCacheAdd;
SetCache$1.prototype.has = setCacheHas;

var _SetCache = SetCache$1;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */

function arraySome$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

var _arraySome = arraySome$1;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function cacheHas$1(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas$1;

var SetCache = _SetCache,
    arraySome = _arraySome,
    cacheHas = _cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG$3) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays$2;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */

function mapToArray$1(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray$1;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */

function setToArray$1(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray$1;

var Symbol$1 = _Symbol,
    Uint8Array$1 = _Uint8Array,
    eq$1 = eq_1,
    equalArrays$1 = _equalArrays,
    mapToArray = _mapToArray,
    setToArray = _setToArray;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag$1 = '[object Map]',
    numberTag = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$1 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array$1(object), new Uint8Array$1(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq$1(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag$1:
    case stringTag$1:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag$1:
      var convert = mapToArray;

    case setTag$1:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

var _equalByTag = equalByTag$1;

var getAllKeys = _getAllKeys;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$2.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects$1;

var Stack$1 = _Stack,
    equalArrays = _equalArrays,
    equalByTag = _equalByTag,
    equalObjects = _equalObjects,
    getTag$1 = _getTag,
    isArray$7 = isArray_1,
    isBuffer$1 = isBufferExports,
    isTypedArray = isTypedArray_1;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$7(object),
      othIsArr = isArray$7(other),
      objTag = objIsArr ? arrayTag : getTag$1(object),
      othTag = othIsArr ? arrayTag : getTag$1(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer$1(object)) {
    if (!isBuffer$1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$1);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$1.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$1.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack$1);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$1);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep$1;

var baseIsEqualDeep = _baseIsEqualDeep,
    isObjectLike$2 = isObjectLike_1;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual$3(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike$2(value) && !isObjectLike$2(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$3, stack);
}

var _baseIsEqual = baseIsEqual$3;

var Stack = _Stack,
    baseIsEqual$2 = _baseIsEqual;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch$1(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual$2(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

var _baseIsMatch = baseIsMatch$1;

var isObject$3 = isObject_1;

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable$2(value) {
  return value === value && !isObject$3(value);
}

var _isStrictComparable = isStrictComparable$2;

var isStrictComparable$1 = _isStrictComparable,
    keys$3 = keys_1;

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData$1(object) {
  var result = keys$3(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable$1(value)];
  }
  return result;
}

var _getMatchData = getMatchData$1;

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */

function matchesStrictComparable$2(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

var _matchesStrictComparable = matchesStrictComparable$2;

var baseIsMatch = _baseIsMatch,
    getMatchData = _getMatchData,
    matchesStrictComparable$1 = _matchesStrictComparable;

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches$1(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

var _baseMatches = baseMatches$1;

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */

function baseHasIn$1(object, key) {
  return object != null && key in Object(object);
}

var _baseHasIn = baseHasIn$1;

var castPath = _castPath,
    isArguments = isArguments_1,
    isArray$6 = isArray_1,
    isIndex$1 = _isIndex,
    isLength = isLength_1,
    toKey$2 = _toKey;

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath$2(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey$2(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex$1(key, length) &&
    (isArray$6(object) || isArguments(object));
}

var _hasPath = hasPath$2;

var baseHasIn = _baseHasIn,
    hasPath$1 = _hasPath;

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn$1(object, path) {
  return object != null && hasPath$1(object, path, baseHasIn);
}

var hasIn_1 = hasIn$1;

var baseIsEqual$1 = _baseIsEqual,
    get = get_1,
    hasIn = hasIn_1,
    isKey$1 = _isKey,
    isStrictComparable = _isStrictComparable,
    matchesStrictComparable = _matchesStrictComparable,
    toKey$1 = _toKey;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty$1(path, srcValue) {
  if (isKey$1(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$1(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

var _baseMatchesProperty = baseMatchesProperty$1;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */

function baseProperty$2(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

var _baseProperty = baseProperty$2;

var baseGet$1 = _baseGet;

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep$1(path) {
  return function(object) {
    return baseGet$1(object, path);
  };
}

var _basePropertyDeep = basePropertyDeep$1;

var baseProperty$1 = _baseProperty,
    basePropertyDeep = _basePropertyDeep,
    isKey = _isKey,
    toKey = _toKey;

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property$1(path) {
  return isKey(path) ? baseProperty$1(toKey(path)) : basePropertyDeep(path);
}

var property_1 = property$1;

var baseMatches = _baseMatches,
    baseMatchesProperty = _baseMatchesProperty,
    identity$3 = identity_1,
    isArray$5 = isArray_1,
    property = property_1;

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee$4(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity$3;
  }
  if (typeof value == 'object') {
    return isArray$5(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

var _baseIteratee = baseIteratee$4;

var baseIteratee$3 = _baseIteratee,
    isArrayLike$5 = isArrayLike_1,
    keys$2 = keys_1;

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind$1(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike$5(collection)) {
      var iteratee = baseIteratee$3(predicate);
      collection = keys$2(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

var _createFind = createFind$1;

var baseFindIndex = _baseFindIndex,
    baseIteratee$2 = _baseIteratee,
    toInteger$3 = toInteger_1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex$1(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger$3(fromIndex);
  if (index < 0) {
    index = nativeMax$1(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee$2(predicate), index);
}

var findIndex_1 = findIndex$1;

var createFind = _createFind,
    findIndex = findIndex_1;

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

var find_1 = find;

var find$1 = /*@__PURE__*/getDefaultExportFromCjs(find_1);

var OfferCardContainer$1 = defaultStyled.div(templateObject_1$C || (templateObject_1$C = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  background: var(--snow);\n  padding: 16px;\n  border-radius: 10px;\n  position: relative;\n  min-height: 82px;\n  gap: 1rem;\n  * {\n    font-family: var(--font-family-base);\n  }\n  &,\n  & div {\n    color: var(--grey-dark);\n  }\n  .voucher-image {\n    width: 80px;\n    img {\n      width: 100%;\n    }\n  }\n  .discount-info {\n    flex-grow: 1;\n    p {\n      margin-bottom: 0;\n    }\n    .title {\n      font-size: 16px;\n      line-height: 22px;\n    }\n    .subtitle {\n      font-size: 12px;\n      line-height: 13px;\n      padding-top: 5px;\n    }\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  background: var(--snow);\n  padding: 16px;\n  border-radius: 10px;\n  position: relative;\n  min-height: 82px;\n  gap: 1rem;\n  * {\n    font-family: var(--font-family-base);\n  }\n  &,\n  & div {\n    color: var(--grey-dark);\n  }\n  .voucher-image {\n    width: 80px;\n    img {\n      width: 100%;\n    }\n  }\n  .discount-info {\n    flex-grow: 1;\n    p {\n      margin-bottom: 0;\n    }\n    .title {\n      font-size: 16px;\n      line-height: 22px;\n    }\n    .subtitle {\n      font-size: 12px;\n      line-height: 13px;\n      padding-top: 5px;\n    }\n  }\n"])));
var generateTitle$1 = function (_a) {
    var title = _a.title, platform = _a.platform, brandName = _a.brandName;
    var onlineText = "".concat(platform ? 'when you order online' : 'on order', " ").concat(brandName ? " at ".concat(brandName) : '');
    return "".concat(title || onlineText);
};
var OfferCard$1 = function (_a) {
    var voucher = _a.voucher, className = _a.className, _b = _a.locale, locale = _b === void 0 ? 'en-US' : _b;
    if (!voucher)
        return null;
    var title = get$2(voucher, 'voucherData.title');
    var brandName = get$2(voucher, 'voucherData.brandName');
    var platform = get$2(voucher, 'platform');
    var translations = get$2(voucher, 'translations');
    var translation = find$1(translations, { locale: locale });
    var t_voucherImageUrl = get$2(translation, 'offerCard.voucherImage.0.mediaUrl');
    var t_title = get$2(translation, 'offerCard.title');
    var t_subTittle = get$2(translation, 'offerCard.subTittle');
    var t_subTitle = get$2(translation, 'offerCard.subTitle');
    var voucherImageUrl = get$2(voucher, 'voucherData.voucherImage.0.mediaUrl') || getOfferImage(voucher.rewardType) || t_voucherImageUrl;
    var titleText = generateTitle$1({ title: title || t_title, platform: platform, brandName: brandName });
    return (React__default.createElement(OfferCardContainer$1, { className: className },
        React__default.createElement("div", { className: "voucher-image" },
            React__default.createElement("img", { src: voucherImageUrl, alt: "" })),
        React__default.createElement("div", { className: "discount-info" },
            React__default.createElement("div", { className: "title", dangerouslySetInnerHTML: { __html: titleText } }),
            React__default.createElement("div", { className: "subtitle", dangerouslySetInnerHTML: { __html: get$2(voucher, 'voucherData.subTittle') || t_subTittle || t_subTitle } }))));
};
var templateObject_1$C;

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */

function createBaseFor$1(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

var _createBaseFor = createBaseFor$1;

var createBaseFor = _createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor$1 = createBaseFor();

var _baseFor = baseFor$1;

var baseFor = _baseFor,
    keys$1 = keys_1;

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn$1(object, iteratee) {
  return object && baseFor(object, iteratee, keys$1);
}

var _baseForOwn = baseForOwn$1;

var isArrayLike$4 = isArrayLike_1;

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach$1(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike$4(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

var _createBaseEach = createBaseEach$1;

var baseForOwn = _baseForOwn,
    createBaseEach = _createBaseEach;

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach$2 = createBaseEach(baseForOwn);

var _baseEach = baseEach$2;

var baseEach$1 = _baseEach,
    isArrayLike$3 = isArrayLike_1;

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap$2(collection, iteratee) {
  var index = -1,
      result = isArrayLike$3(collection) ? Array(collection.length) : [];

  baseEach$1(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

var _baseMap = baseMap$2;

var arrayMap$2 = _arrayMap,
    baseIteratee$1 = _baseIteratee,
    baseMap$1 = _baseMap,
    isArray$4 = isArray_1;

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray$4(collection) ? arrayMap$2 : baseMap$1;
  return func(collection, baseIteratee$1(iteratee));
}

var map_1 = map;

var map$1 = /*@__PURE__*/getDefaultExportFromCjs(map_1);

var Link = defaultStyled.a(templateObject_1$B || (templateObject_1$B = __makeTemplateObject(["\n  color:var(--grey-dark);\n  font-weight:600;\n  width: 200px;\n  display: flex;\n  justify-content: flex-end;\n  gap:0.5rem;\n  direction: ltr !important;\n"], ["\n  color:var(--grey-dark);\n  font-weight:600;\n  width: 200px;\n  display: flex;\n  justify-content: flex-end;\n  gap:0.5rem;\n  direction: ltr !important;\n"])));
var Container$c = defaultStyled.div(templateObject_2$s || (templateObject_2$s = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n  font-size: 14px;\n  padding-bottom: 1.5rem;\n  margin-top: 1rem;\n  padding: 0 1rem;\n  direction: ltr !important;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  font-size: 14px;\n  padding-bottom: 1.5rem;\n  margin-top: 1rem;\n  padding: 0 1rem;\n  direction: ltr !important;\n"])));
var LanguageItem = defaultStyled.div(templateObject_3$g || (templateObject_3$g = __makeTemplateObject(["\n  display:flex;\n  align-items: center;\n  gap: 0.5rem;\n "], ["\n  display:flex;\n  align-items: center;\n  gap: 0.5rem;\n "])));
var LanguageSelect = function (_a) {
    var translations = _a.translations, language = _a.language, onChangeLanguage = _a.onChangeLanguage;
    var options = useMemo(function () {
        return map$1(translations, function (tran) { return (React__default.createElement(Menu.Item, { key: tran.locale, onClick: function () { return onChangeLanguage(tran.locale); } },
            React__default.createElement(LanguageItem, null,
                React__default.createElement("span", { className: FLAG_LANGUAGES[tran === null || tran === void 0 ? void 0 : tran.locale] }),
                OFFER_LANGUAGES[tran === null || tran === void 0 ? void 0 : tran.locale]))); });
    }, [translations]);
    var menu = React__default.createElement(Menu, null, options);
    return (React__default.createElement(Container$c, null,
        React__default.createElement(Dropdown, { overlay: menu, trigger: ['click'], placement: "topRight" },
            React__default.createElement(Link, { className: "align-center" },
                language ? (React__default.createElement(LanguageItem, null,
                    React__default.createElement("span", { className: FLAG_LANGUAGES[language] }),
                    OFFER_LANGUAGES[language])) : ('Select Language'),
                React__default.createElement(SvgChevronDown$1, null)))));
};
var templateObject_1$B, templateObject_2$s, templateObject_3$g;

var Container$b = defaultStyled.div(templateObject_1$A || (templateObject_1$A = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  .brand-logo {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    img {\n      object-fit: cover;\n      width: 105px;\n    }\n  }\n  .brand-name {\n    display: inline-block;\n    margin-top: 1rem;\n    font-size: 18px;\n    color: var(--grey-dark);\n    font-weight: 500;\n    line-height: 20px;\n    font-family: inherit;\n    * {\n      font-family: inherit;\n      font-size: 18px;\n    }\n  }\n"], ["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  .brand-logo {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    img {\n      object-fit: cover;\n      width: 105px;\n    }\n  }\n  .brand-name {\n    display: inline-block;\n    margin-top: 1rem;\n    font-size: 18px;\n    color: var(--grey-dark);\n    font-weight: 500;\n    line-height: 20px;\n    font-family: inherit;\n    * {\n      font-family: inherit;\n      font-size: 18px;\n    }\n  }\n"])));
function OfferLogo(_a) {
    var showLogo = _a.showLogo, showBrandName = _a.showBrandName, brandName = _a.brandName, logo = _a.logo, props = __rest(_a, ["showLogo", "showBrandName", "brandName", "logo"]);
    return (React__default.createElement(Container$b, __assign({}, props),
        showLogo && logo && (React__default.createElement("div", { className: "brand-logo" },
            React__default.createElement("img", { src: logo }))),
        showBrandName && brandName && React__default.createElement("div", { className: "brand-name", dangerouslySetInnerHTML: { __html: brandName } })));
}
var templateObject_1$A;

var OfferCardContainer = defaultStyled.div(templateObject_1$z || (templateObject_1$z = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n  padding: 1.1rem 1.25rem;\n  direction: ltr !important;\n\n  .rtl,\n  .rtl *{\n    direction: rtl;\n    text-align: right;\n  }\n\n  ", "\n  border-radius: 10px;\n  position: relative;\n  min-height: 82px;\n  gap: 0.5rem;\n  border:1px solid var(--grey-light);\n\n  * {\n    font-family: inherit;\n    color: inherit;\n  }\n\n  &,\n  & div {\n    color: var(--grey-dark);\n  }\n  .voucher-image {\n    width: 80px;\n    img {\n      width: 100%;\n    }\n  }\n  .discount-info {\n    text-align: left;\n    flex-grow: 1;\n    padding-top: 0.5rem;\n\n    p {\n      margin-bottom: 0;\n    }\n    .title {\n      font-size: 16px;\n      line-height: 22px;\n    }\n    .subtitle {\n      font-size: 12px;\n      line-height: 13px;\n      padding-top: 5px;\n    }\n  }\n\n  .min-spend {\n    position: absolute;\n    top: 7px;\n    right: 12px;\n    border: 1px solid var(--grey-light);\n    border-radius: 15px;\n    padding: 0.1rem 0.75rem;\n    font-weight: 500;\n    font-size: 11px;\n  }\n"], ["\n  display: flex;\n  align-items: flex-start;\n  padding: 1.1rem 1.25rem;\n  direction: ltr !important;\n\n  .rtl,\n  .rtl *{\n    direction: rtl;\n    text-align: right;\n  }\n\n  ", "\n  border-radius: 10px;\n  position: relative;\n  min-height: 82px;\n  gap: 0.5rem;\n  border:1px solid var(--grey-light);\n\n  * {\n    font-family: inherit;\n    color: inherit;\n  }\n\n  &,\n  & div {\n    color: var(--grey-dark);\n  }\n  .voucher-image {\n    width: 80px;\n    img {\n      width: 100%;\n    }\n  }\n  .discount-info {\n    text-align: left;\n    flex-grow: 1;\n    padding-top: 0.5rem;\n\n    p {\n      margin-bottom: 0;\n    }\n    .title {\n      font-size: 16px;\n      line-height: 22px;\n    }\n    .subtitle {\n      font-size: 12px;\n      line-height: 13px;\n      padding-top: 5px;\n    }\n  }\n\n  .min-spend {\n    position: absolute;\n    top: 7px;\n    right: 12px;\n    border: 1px solid var(--grey-light);\n    border-radius: 15px;\n    padding: 0.1rem 0.75rem;\n    font-weight: 500;\n    font-size: 11px;\n  }\n"])), function (_a) {
    var minOrderValue = _a.minOrderValue;
    return minOrderValue ? 'padding-top: 1.8rem;' : '';
});
var generateTitle = function (_a) {
    var title = _a.title, platform = _a.platform, brandName = _a.brandName;
    var onlineText = "".concat(platform ? 'when you order online' : 'on order', " ").concat(brandName ? " at ".concat(brandName) : '');
    return "".concat(title || onlineText);
};
var OfferCard = function (_a) {
    var voucher = _a.voucher, className = _a.className, _b = _a.locale, locale = _b === void 0 ? 'en-US' : _b, t = _a.t;
    var translations = get$2(voucher, 'translations');
    var translation = find$1(translations, { locale: locale });
    var voucherImageUrl = get$2(translation, 'offerCard.voucherImage.0.mediaUrl');
    var title = get$2(translation, 'offerCard.title');
    var subTittle = get$2(translation, 'offerCard.subTittle');
    var subTitle = get$2(translation, 'offerCard.subTitle');
    var minOrderValue = get$2(voucher, 'voucherData.minOrderValue');
    var voucherCurrency = get$2(voucher, 'voucherData.currency', '$');
    var brandName = get$2(voucher, 'voucherData.brandName');
    var platform = get$2(voucher, 'voucherData.platform');
    var titleText = generateTitle({ title: title, platform: platform, brandName: brandName });
    var rtl = locale === 'ar-SA';
    return (React__default.createElement(OfferCardContainer, { className: className, minOrderValue: minOrderValue },
        minOrderValue && (React__default.createElement("div", { className: "min-spend ".concat(rtl ? 'rtl' : '') },
            t('offer.offerCard.minSpend'),
            " ",
            voucherCurrency,
            minOrderValue)),
        React__default.createElement("div", { className: "voucher-image" }, voucherImageUrl ? React__default.createElement("img", { src: voucherImageUrl }) : React__default.createElement(OfferCardIcon, null)),
        React__default.createElement("div", { className: "discount-info" },
            titleText && (React__default.createElement("div", { className: "title ".concat(rtl ? 'rtl' : ''), dangerouslySetInnerHTML: { __html: titleText } })),
            (subTittle || subTitle) && (React__default.createElement("div", { className: "subtitle ".concat(rtl ? 'rtl' : ''), dangerouslySetInnerHTML: { __html: subTittle || subTitle } })))));
};
var templateObject_1$z;

var Container$a = defaultStyled.div(templateObject_1$y || (templateObject_1$y = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n\n  font-family: ", ";\n  color: ", ";\n  flex-grow: 1;\n\n  .ant-form-item {\n    .ant-form-item-label,\n    label,\n    input {\n      font-family: inherit;\n    }\n  }\n"], ["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n\n  font-family: ", ";\n  color: ", ";\n  flex-grow: 1;\n\n  .ant-form-item {\n    .ant-form-item-label,\n    label,\n    input {\n      font-family: inherit;\n    }\n  }\n"])), function (_a) {
    var $fontFamily = _a.$fontFamily;
    return $fontFamily;
}, function (_a) {
    var $color = _a.$color;
    return $color;
});
var Title$7 = defaultStyled.div(templateObject_2$r || (templateObject_2$r = __makeTemplateObject(["\n  margin: 1.5rem 0;\n  margin-top: 2rem;\n  font-size: 24px;\n  line-height: 28.8px;\n  text-align: center !important;\n  word-break: break-word;\n  font-weight: 600;\n\n  p,\n  * {\n    word-break: break-word;\n    font-size: 24px;\n    line-height: 28.8px;\n    font-family: inherit;\n    font-weight: 600;\n    color: inherit;\n    text-align: center !important;\n  }\n"], ["\n  margin: 1.5rem 0;\n  margin-top: 2rem;\n  font-size: 24px;\n  line-height: 28.8px;\n  text-align: center !important;\n  word-break: break-word;\n  font-weight: 600;\n\n  p,\n  * {\n    word-break: break-word;\n    font-size: 24px;\n    line-height: 28.8px;\n    font-family: inherit;\n    font-weight: 600;\n    color: inherit;\n    text-align: center !important;\n  }\n"])));
function IssuancePage(_a) {
    var voucher = _a.voucher, configuration = _a.configuration, brand = _a.brand, form = _a.form, t = _a.t, translation = _a.translation, language = _a.language, tnc = _a.tnc, optin = _a.optin;
    var _b = configuration || {}, _c = _b.brandFont, brandFont = _c === void 0 ? 'var(--font-family-regular)' : _c, _d = _b.themeColor, themeColor = _d === void 0 ? 'var(--indian-red)' : _d, _e = _b.showBrandName, showBrandName = _e === void 0 ? true : _e, brandName = _b.brandName, _f = _b.showOfferCard, showOfferCard = _f === void 0 ? true : _f, _g = _b.showLogo, showLogo = _g === void 0 ? true : _g;
    var _h = brand || {}, name = _h.name, logoUrl = _h.logoUrl;
    var shouldCollectPhoneNumber = (voucher || {}).shouldCollectPhoneNumber;
    return (React__default.createElement(Container$a, { "$fontFamily": brandFont, "$color": themeColor, "data-testid": "issuance-page" },
        React__default.createElement(OfferLogo, { showBrandName: showBrandName, showLogo: showLogo, logo: logoUrl, brandName: brandName || name }),
        showOfferCard && React__default.createElement(OfferCard, { voucher: voucher, className: "mt-20", t: t, locale: language }),
        React__default.createElement(Title$7, { dangerouslySetInnerHTML: { __html: (translation === null || translation === void 0 ? void 0 : translation.issuanceMetaInfoMarkup) || t('offer.pages.welcome.title') } }),
        React__default.createElement(Form.Item, { name: "name", label: t('offer.pages.welcome.form.name'), rules: [
                {
                    required: true,
                    message: t('offer.pages.welcome.form.requiredMsg')
                },
            ] },
            React__default.createElement(Input, { placeholder: t('offer.pages.welcome.form.namePlacehoder') })),
        React__default.createElement(Form.Item, { name: "email", label: t('offer.pages.welcome.form.email'), rules: [
                {
                    required: true,
                    message: t('offer.pages.welcome.form.requiredMsg')
                },
            ] },
            React__default.createElement(Input, { placeholder: t('offer.pages.welcome.form.emailPlacehoder') })),
        shouldCollectPhoneNumber && (React__default.createElement(Form.Item, { name: "phoneNumber", label: t('offer.pages.welcome.form.phoneNumber'), rules: [
                {
                    required: shouldCollectPhoneNumber === 'MANDATORY',
                    message: t('offer.pages.welcome.form.requiredMsg')
                },
            ], requiredMark: shouldCollectPhoneNumber === 'MANDATORY' },
            React__default.createElement(Input, { placeholder: t('offer.pages.welcome.form.phoneNumberPlacehoder') }))),
        React__default.createElement(Form.Item, { name: "tnc", valuePropName: "checked", className: "tnc mb-1", initialValue: true },
            React__default.createElement(Checkbox, null, tnc || React__default.createElement("span", null, t('offer.pages.welcome.form.tnc')))),
        React__default.createElement(Form.Item, { name: "optin", valuePropName: "checked", className: "tnc" },
            React__default.createElement(Checkbox, null, optin || React__default.createElement("span", null, t('offer.pages.welcome.form.optin')))),
        React__default.createElement(Form.Item, { shouldUpdate: function (prevValues, curValues) { return prevValues.tnc !== curValues.tnc; } }, function (_a) {
            var getFieldValue = _a.getFieldValue;
            var tnc = getFieldValue('tnc');
            return (React__default.createElement(Form.Item, null,
                React__default.createElement(Button, { onClick: form.submit, disabled: !tnc, className: "w-full text-center", "$color": themeColor, "$disabledHover": true }, t('offer.pages.welcome.buttonText'))));
        })));
}
var templateObject_1$y, templateObject_2$r;

var Container$9 = defaultStyled(Form)(templateObject_1$x || (templateObject_1$x = __makeTemplateObject(["\n  max-width: 650px;\n  margin: auto;\n  height: 100%;\n  position: relative;\n  padding-bottom: 2rem;\n\n  &.rtl {\n    direction: rtl;\n    text-align: right;\n    * {\n      direction: rtl;\n      text-align: right;\n    }\n  }\n  .text-center {\n    text-align: center !important;\n  }\n\n  font-family: ", ";\n  color: ", ";\n"], ["\n  max-width: 650px;\n  margin: auto;\n  height: 100%;\n  position: relative;\n  padding-bottom: 2rem;\n\n  &.rtl {\n    direction: rtl;\n    text-align: right;\n    * {\n      direction: rtl;\n      text-align: right;\n    }\n  }\n  .text-center {\n    text-align: center !important;\n  }\n\n  font-family: ", ";\n  color: ", ";\n"])), function (_a) {
    var $fontFamily = _a.$fontFamily;
    return $fontFamily;
}, function (_a) {
    var $color = _a.$color;
    return $color;
});
function OfferIssuance(_a) {
    var voucher = _a.voucher, brand = _a.brand, onFinish = _a.onFinish, t = _a.t, language = _a.language, onChangeLanguage = _a.onChangeLanguage, tnc = _a.tnc, optin = _a.optin;
    var form = Form.useForm()[0];
    var pageConfiguration = ((voucher === null || voucher === void 0 ? void 0 : voucher.pageConfig) || {}).issuance;
    var _b = pageConfiguration || {}, _c = _b.brandFont, brandFont = _c === void 0 ? 'var(--font-family-regular)' : _c, _d = _b.themeColor, themeColor = _d === void 0 ? 'var(--indian-red)' : _d;
    var translations = useMemo(function () { return voucher === null || voucher === void 0 ? void 0 : voucher.translations; }, [voucher]);
    var translation = useMemo(function () { return find$1(translations, { locale: language }); }, [translations, language]);
    return (React__default.createElement(Container$9, { form: form, layout: "vertical", onFinish: onFinish, className: language === 'ar-SA' ? 'rtl' : '', "$fontFamily": brandFont, "$color": themeColor },
        React__default.createElement(IssuancePage, { voucher: voucher, brand: brand, configuration: pageConfiguration, form: form, t: t, translation: translation, language: language, tnc: tnc, optin: optin }),
        React__default.createElement(LanguageSelect, { translations: translations, language: language, onChangeLanguage: onChangeLanguage })));
}
var templateObject_1$x;

var barcodes = {};

var CODE39$1 = {};

var Barcode$1 = {};

Object.defineProperty(Barcode$1, "__esModule", {
	value: true
});

function _classCallCheck$s(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Barcode = function Barcode(data, options) {
	_classCallCheck$s(this, Barcode);

	this.data = data;
	this.text = options.text || data;
	this.options = options;
};

Barcode$1.default = Barcode;

Object.defineProperty(CODE39$1, "__esModule", {
	value: true
});
CODE39$1.CODE39 = undefined;

var _createClass$l = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2$b = Barcode$1;

var _Barcode3$b = _interopRequireDefault$z(_Barcode2$b);

function _interopRequireDefault$z(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$r(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$n(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$n(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/Code_39#Encoding

var CODE39 = function (_Barcode) {
	_inherits$n(CODE39, _Barcode);

	function CODE39(data, options) {
		_classCallCheck$r(this, CODE39);

		data = data.toUpperCase();

		// Calculate mod43 checksum if enabled
		if (options.mod43) {
			data += getCharacter(mod43checksum(data));
		}

		return _possibleConstructorReturn$n(this, (CODE39.__proto__ || Object.getPrototypeOf(CODE39)).call(this, data, options));
	}

	_createClass$l(CODE39, [{
		key: "encode",
		value: function encode() {
			// First character is always a *
			var result = getEncoding("*");

			// Take every character and add the binary representation to the result
			for (var i = 0; i < this.data.length; i++) {
				result += getEncoding(this.data[i]) + "0";
			}

			// Last character is always a *
			result += getEncoding("*");

			return {
				data: result,
				text: this.text
			};
		}
	}, {
		key: "valid",
		value: function valid() {
			return this.data.search(/^[0-9A-Z\-\.\ \$\/\+\%]+$/) !== -1;
		}
	}]);

	return CODE39;
}(_Barcode3$b.default);

// All characters. The position in the array is the (checksum) value


var characters = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "-", ".", " ", "$", "/", "+", "%", "*"];

// The decimal representation of the characters, is converted to the
// corresponding binary with the getEncoding function
var encodings = [20957, 29783, 23639, 30485, 20951, 29813, 23669, 20855, 29789, 23645, 29975, 23831, 30533, 22295, 30149, 24005, 21623, 29981, 23837, 22301, 30023, 23879, 30545, 22343, 30161, 24017, 21959, 30065, 23921, 22385, 29015, 18263, 29141, 17879, 29045, 18293, 17783, 29021, 18269, 17477, 17489, 17681, 20753, 35770];

// Get the binary representation of a character by converting the encodings
// from decimal to binary
function getEncoding(character) {
	return getBinary(characterValue(character));
}

function getBinary(characterValue) {
	return encodings[characterValue].toString(2);
}

function getCharacter(characterValue) {
	return characters[characterValue];
}

function characterValue(character) {
	return characters.indexOf(character);
}

function mod43checksum(data) {
	var checksum = 0;
	for (var i = 0; i < data.length; i++) {
		checksum += characterValue(data[i]);
	}

	checksum = checksum % 43;
	return checksum;
}

CODE39$1.CODE39 = CODE39;

var CODE128$2 = {};

var CODE128_AUTO = {};

var CODE128$1 = {};

var constants$2 = {};

Object.defineProperty(constants$2, "__esModule", {
	value: true
});

var _SET_BY_CODE;

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// constants for internal usage
var SET_A = constants$2.SET_A = 0;
var SET_B = constants$2.SET_B = 1;
var SET_C = constants$2.SET_C = 2;

// Special characters
constants$2.SHIFT = 98;
var START_A = constants$2.START_A = 103;
var START_B = constants$2.START_B = 104;
var START_C = constants$2.START_C = 105;
constants$2.MODULO = 103;
constants$2.STOP = 106;
constants$2.FNC1 = 207;

// Get set by start code
constants$2.SET_BY_CODE = (_SET_BY_CODE = {}, _defineProperty$1(_SET_BY_CODE, START_A, SET_A), _defineProperty$1(_SET_BY_CODE, START_B, SET_B), _defineProperty$1(_SET_BY_CODE, START_C, SET_C), _SET_BY_CODE);

// Get next set by code
constants$2.SWAP = {
	101: SET_A,
	100: SET_B,
	99: SET_C
};

constants$2.A_START_CHAR = String.fromCharCode(208); // START_A + 105
constants$2.B_START_CHAR = String.fromCharCode(209); // START_B + 105
constants$2.C_START_CHAR = String.fromCharCode(210); // START_C + 105

// 128A (Code Set A)
// ASCII characters 00 to 95 (0–9, A–Z and control codes), special characters, and FNC 1–4
constants$2.A_CHARS = "[\x00-\x5F\xC8-\xCF]";

// 128B (Code Set B)
// ASCII characters 32 to 127 (0–9, A–Z, a–z), special characters, and FNC 1–4
constants$2.B_CHARS = "[\x20-\x7F\xC8-\xCF]";

// 128C (Code Set C)
// 00–99 (encodes two digits with a single code point) and FNC1
constants$2.C_CHARS = "(\xCF*[0-9]{2}\xCF*)";

// CODE128 includes 107 symbols:
// 103 data symbols, 3 start symbols (A, B and C), and 1 stop symbol (the last one)
// Each symbol consist of three black bars (1) and three white spaces (0).
constants$2.BARS = [11011001100, 11001101100, 11001100110, 10010011000, 10010001100, 10001001100, 10011001000, 10011000100, 10001100100, 11001001000, 11001000100, 11000100100, 10110011100, 10011011100, 10011001110, 10111001100, 10011101100, 10011100110, 11001110010, 11001011100, 11001001110, 11011100100, 11001110100, 11101101110, 11101001100, 11100101100, 11100100110, 11101100100, 11100110100, 11100110010, 11011011000, 11011000110, 11000110110, 10100011000, 10001011000, 10001000110, 10110001000, 10001101000, 10001100010, 11010001000, 11000101000, 11000100010, 10110111000, 10110001110, 10001101110, 10111011000, 10111000110, 10001110110, 11101110110, 11010001110, 11000101110, 11011101000, 11011100010, 11011101110, 11101011000, 11101000110, 11100010110, 11101101000, 11101100010, 11100011010, 11101111010, 11001000010, 11110001010, 10100110000, 10100001100, 10010110000, 10010000110, 10000101100, 10000100110, 10110010000, 10110000100, 10011010000, 10011000010, 10000110100, 10000110010, 11000010010, 11001010000, 11110111010, 11000010100, 10001111010, 10100111100, 10010111100, 10010011110, 10111100100, 10011110100, 10011110010, 11110100100, 11110010100, 11110010010, 11011011110, 11011110110, 11110110110, 10101111000, 10100011110, 10001011110, 10111101000, 10111100010, 11110101000, 11110100010, 10111011110, 10111101110, 11101011110, 11110101110, 11010000100, 11010010000, 11010011100, 1100011101011];

Object.defineProperty(CODE128$1, "__esModule", {
	value: true
});

var _createClass$k = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2$a = Barcode$1;

var _Barcode3$a = _interopRequireDefault$y(_Barcode2$a);

var _constants$a = constants$2;

function _interopRequireDefault$y(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$q(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$m(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$m(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// This is the master class,
// it does require the start code to be included in the string
var CODE128 = function (_Barcode) {
	_inherits$m(CODE128, _Barcode);

	function CODE128(data, options) {
		_classCallCheck$q(this, CODE128);

		// Get array of ascii codes from data
		var _this = _possibleConstructorReturn$m(this, (CODE128.__proto__ || Object.getPrototypeOf(CODE128)).call(this, data.substring(1), options));

		_this.bytes = data.split('').map(function (char) {
			return char.charCodeAt(0);
		});
		return _this;
	}

	_createClass$k(CODE128, [{
		key: 'valid',
		value: function valid() {
			// ASCII value ranges 0-127, 200-211
			return (/^[\x00-\x7F\xC8-\xD3]+$/.test(this.data)
			);
		}

		// The public encoding function

	}, {
		key: 'encode',
		value: function encode() {
			var bytes = this.bytes;
			// Remove the start code from the bytes and set its index
			var startIndex = bytes.shift() - 105;
			// Get start set by index
			var startSet = _constants$a.SET_BY_CODE[startIndex];

			if (startSet === undefined) {
				throw new RangeError('The encoding does not start with a start character.');
			}

			if (this.shouldEncodeAsEan128() === true) {
				bytes.unshift(_constants$a.FNC1);
			}

			// Start encode with the right type
			var encodingResult = CODE128.next(bytes, 1, startSet);

			return {
				text: this.text === this.data ? this.text.replace(/[^\x20-\x7E]/g, '') : this.text,
				data:
				// Add the start bits
				CODE128.getBar(startIndex) +
				// Add the encoded bits
				encodingResult.result +
				// Add the checksum
				CODE128.getBar((encodingResult.checksum + startIndex) % _constants$a.MODULO) +
				// Add the end bits
				CODE128.getBar(_constants$a.STOP)
			};
		}

		// GS1-128/EAN-128

	}, {
		key: 'shouldEncodeAsEan128',
		value: function shouldEncodeAsEan128() {
			var isEAN128 = this.options.ean128 || false;
			if (typeof isEAN128 === 'string') {
				isEAN128 = isEAN128.toLowerCase() === 'true';
			}
			return isEAN128;
		}

		// Get a bar symbol by index

	}], [{
		key: 'getBar',
		value: function getBar(index) {
			return _constants$a.BARS[index] ? _constants$a.BARS[index].toString() : '';
		}

		// Correct an index by a set and shift it from the bytes array

	}, {
		key: 'correctIndex',
		value: function correctIndex(bytes, set) {
			if (set === _constants$a.SET_A) {
				var charCode = bytes.shift();
				return charCode < 32 ? charCode + 64 : charCode - 32;
			} else if (set === _constants$a.SET_B) {
				return bytes.shift() - 32;
			} else {
				return (bytes.shift() - 48) * 10 + bytes.shift() - 48;
			}
		}
	}, {
		key: 'next',
		value: function next(bytes, pos, set) {
			if (!bytes.length) {
				return { result: '', checksum: 0 };
			}

			var nextCode = void 0,
			    index = void 0;

			// Special characters
			if (bytes[0] >= 200) {
				index = bytes.shift() - 105;
				var nextSet = _constants$a.SWAP[index];

				// Swap to other set
				if (nextSet !== undefined) {
					nextCode = CODE128.next(bytes, pos + 1, nextSet);
				}
				// Continue on current set but encode a special character
				else {
						// Shift
						if ((set === _constants$a.SET_A || set === _constants$a.SET_B) && index === _constants$a.SHIFT) {
							// Convert the next character so that is encoded correctly
							bytes[0] = set === _constants$a.SET_A ? bytes[0] > 95 ? bytes[0] - 96 : bytes[0] : bytes[0] < 32 ? bytes[0] + 96 : bytes[0];
						}
						nextCode = CODE128.next(bytes, pos + 1, set);
					}
			}
			// Continue encoding
			else {
					index = CODE128.correctIndex(bytes, set);
					nextCode = CODE128.next(bytes, pos + 1, set);
				}

			// Get the correct binary encoding and calculate the weight
			var enc = CODE128.getBar(index);
			var weight = index * pos;

			return {
				result: enc + nextCode.result,
				checksum: weight + nextCode.checksum
			};
		}
	}]);

	return CODE128;
}(_Barcode3$a.default);

CODE128$1.default = CODE128;

var auto = {};

Object.defineProperty(auto, "__esModule", {
	value: true
});

var _constants$9 = constants$2;

// Match Set functions
var matchSetALength = function matchSetALength(string) {
	return string.match(new RegExp('^' + _constants$9.A_CHARS + '*'))[0].length;
};
var matchSetBLength = function matchSetBLength(string) {
	return string.match(new RegExp('^' + _constants$9.B_CHARS + '*'))[0].length;
};
var matchSetC = function matchSetC(string) {
	return string.match(new RegExp('^' + _constants$9.C_CHARS + '*'))[0];
};

// CODE128A or CODE128B
function autoSelectFromAB(string, isA) {
	var ranges = isA ? _constants$9.A_CHARS : _constants$9.B_CHARS;
	var untilC = string.match(new RegExp('^(' + ranges + '+?)(([0-9]{2}){2,})([^0-9]|$)'));

	if (untilC) {
		return untilC[1] + String.fromCharCode(204) + autoSelectFromC(string.substring(untilC[1].length));
	}

	var chars = string.match(new RegExp('^' + ranges + '+'))[0];

	if (chars.length === string.length) {
		return string;
	}

	return chars + String.fromCharCode(isA ? 205 : 206) + autoSelectFromAB(string.substring(chars.length), !isA);
}

// CODE128C
function autoSelectFromC(string) {
	var cMatch = matchSetC(string);
	var length = cMatch.length;

	if (length === string.length) {
		return string;
	}

	string = string.substring(length);

	// Select A/B depending on the longest match
	var isA = matchSetALength(string) >= matchSetBLength(string);
	return cMatch + String.fromCharCode(isA ? 206 : 205) + autoSelectFromAB(string, isA);
}

// Detect Code Set (A, B or C) and format the string

auto.default = function (string) {
	var newString = void 0;
	var cLength = matchSetC(string).length;

	// Select 128C if the string start with enough digits
	if (cLength >= 2) {
		newString = _constants$9.C_START_CHAR + autoSelectFromC(string);
	} else {
		// Select A/B depending on the longest match
		var isA = matchSetALength(string) > matchSetBLength(string);
		newString = (isA ? _constants$9.A_START_CHAR : _constants$9.B_START_CHAR) + autoSelectFromAB(string, isA);
	}

	return newString.replace(/[\xCD\xCE]([^])[\xCD\xCE]/, // Any sequence between 205 and 206 characters
	function (match, char) {
		return String.fromCharCode(203) + char;
	});
};

Object.defineProperty(CODE128_AUTO, "__esModule", {
	value: true
});

var _CODE2$4 = CODE128$1;

var _CODE3$3 = _interopRequireDefault$x(_CODE2$4);

var _auto = auto;

var _auto2 = _interopRequireDefault$x(_auto);

function _interopRequireDefault$x(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$p(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$l(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$l(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CODE128AUTO = function (_CODE) {
	_inherits$l(CODE128AUTO, _CODE);

	function CODE128AUTO(data, options) {
		_classCallCheck$p(this, CODE128AUTO);

		// ASCII value ranges 0-127, 200-211
		if (/^[\x00-\x7F\xC8-\xD3]+$/.test(data)) {
			var _this = _possibleConstructorReturn$l(this, (CODE128AUTO.__proto__ || Object.getPrototypeOf(CODE128AUTO)).call(this, (0, _auto2.default)(data), options));
		} else {
			var _this = _possibleConstructorReturn$l(this, (CODE128AUTO.__proto__ || Object.getPrototypeOf(CODE128AUTO)).call(this, data, options));
		}
		return _possibleConstructorReturn$l(_this);
	}

	return CODE128AUTO;
}(_CODE3$3.default);

CODE128_AUTO.default = CODE128AUTO;

var CODE128A$1 = {};

Object.defineProperty(CODE128A$1, "__esModule", {
	value: true
});

var _createClass$j = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CODE2$3 = CODE128$1;

var _CODE3$2 = _interopRequireDefault$w(_CODE2$3);

var _constants$8 = constants$2;

function _interopRequireDefault$w(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$o(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$k(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$k(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CODE128A = function (_CODE) {
	_inherits$k(CODE128A, _CODE);

	function CODE128A(string, options) {
		_classCallCheck$o(this, CODE128A);

		return _possibleConstructorReturn$k(this, (CODE128A.__proto__ || Object.getPrototypeOf(CODE128A)).call(this, _constants$8.A_START_CHAR + string, options));
	}

	_createClass$j(CODE128A, [{
		key: 'valid',
		value: function valid() {
			return new RegExp('^' + _constants$8.A_CHARS + '+$').test(this.data);
		}
	}]);

	return CODE128A;
}(_CODE3$2.default);

CODE128A$1.default = CODE128A;

var CODE128B$1 = {};

Object.defineProperty(CODE128B$1, "__esModule", {
	value: true
});

var _createClass$i = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CODE2$2 = CODE128$1;

var _CODE3$1 = _interopRequireDefault$v(_CODE2$2);

var _constants$7 = constants$2;

function _interopRequireDefault$v(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$n(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$j(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$j(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CODE128B = function (_CODE) {
	_inherits$j(CODE128B, _CODE);

	function CODE128B(string, options) {
		_classCallCheck$n(this, CODE128B);

		return _possibleConstructorReturn$j(this, (CODE128B.__proto__ || Object.getPrototypeOf(CODE128B)).call(this, _constants$7.B_START_CHAR + string, options));
	}

	_createClass$i(CODE128B, [{
		key: 'valid',
		value: function valid() {
			return new RegExp('^' + _constants$7.B_CHARS + '+$').test(this.data);
		}
	}]);

	return CODE128B;
}(_CODE3$1.default);

CODE128B$1.default = CODE128B;

var CODE128C$1 = {};

Object.defineProperty(CODE128C$1, "__esModule", {
	value: true
});

var _createClass$h = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CODE2$1 = CODE128$1;

var _CODE3 = _interopRequireDefault$u(_CODE2$1);

var _constants$6 = constants$2;

function _interopRequireDefault$u(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$m(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$i(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$i(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CODE128C = function (_CODE) {
	_inherits$i(CODE128C, _CODE);

	function CODE128C(string, options) {
		_classCallCheck$m(this, CODE128C);

		return _possibleConstructorReturn$i(this, (CODE128C.__proto__ || Object.getPrototypeOf(CODE128C)).call(this, _constants$6.C_START_CHAR + string, options));
	}

	_createClass$h(CODE128C, [{
		key: 'valid',
		value: function valid() {
			return new RegExp('^' + _constants$6.C_CHARS + '+$').test(this.data);
		}
	}]);

	return CODE128C;
}(_CODE3.default);

CODE128C$1.default = CODE128C;

Object.defineProperty(CODE128$2, "__esModule", {
  value: true
});
CODE128$2.CODE128C = CODE128$2.CODE128B = CODE128$2.CODE128A = CODE128$2.CODE128 = undefined;

var _CODE128_AUTO = CODE128_AUTO;

var _CODE128_AUTO2 = _interopRequireDefault$t(_CODE128_AUTO);

var _CODE128A = CODE128A$1;

var _CODE128A2 = _interopRequireDefault$t(_CODE128A);

var _CODE128B = CODE128B$1;

var _CODE128B2 = _interopRequireDefault$t(_CODE128B);

var _CODE128C = CODE128C$1;

var _CODE128C2 = _interopRequireDefault$t(_CODE128C);

function _interopRequireDefault$t(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

CODE128$2.CODE128 = _CODE128_AUTO2.default;
CODE128$2.CODE128A = _CODE128A2.default;
CODE128$2.CODE128B = _CODE128B2.default;
CODE128$2.CODE128C = _CODE128C2.default;

var EAN_UPC = {};

var EAN13$1 = {};

var constants$1 = {};

Object.defineProperty(constants$1, "__esModule", {
	value: true
});
// Standard start end and middle bits
constants$1.SIDE_BIN = '101';
constants$1.MIDDLE_BIN = '01010';

constants$1.BINARIES = {
	'L': [// The L (left) type of encoding
	'0001101', '0011001', '0010011', '0111101', '0100011', '0110001', '0101111', '0111011', '0110111', '0001011'],
	'G': [// The G type of encoding
	'0100111', '0110011', '0011011', '0100001', '0011101', '0111001', '0000101', '0010001', '0001001', '0010111'],
	'R': [// The R (right) type of encoding
	'1110010', '1100110', '1101100', '1000010', '1011100', '1001110', '1010000', '1000100', '1001000', '1110100'],
	'O': [// The O (odd) encoding for UPC-E
	'0001101', '0011001', '0010011', '0111101', '0100011', '0110001', '0101111', '0111011', '0110111', '0001011'],
	'E': [// The E (even) encoding for UPC-E
	'0100111', '0110011', '0011011', '0100001', '0011101', '0111001', '0000101', '0010001', '0001001', '0010111']
};

// Define the EAN-2 structure
constants$1.EAN2_STRUCTURE = ['LL', 'LG', 'GL', 'GG'];

// Define the EAN-5 structure
constants$1.EAN5_STRUCTURE = ['GGLLL', 'GLGLL', 'GLLGL', 'GLLLG', 'LGGLL', 'LLGGL', 'LLLGG', 'LGLGL', 'LGLLG', 'LLGLG'];

// Define the EAN-13 structure
constants$1.EAN13_STRUCTURE = ['LLLLLL', 'LLGLGG', 'LLGGLG', 'LLGGGL', 'LGLLGG', 'LGGLLG', 'LGGGLL', 'LGLGLG', 'LGLGGL', 'LGGLGL'];

var EAN$1 = {};

var encoder = {};

Object.defineProperty(encoder, "__esModule", {
	value: true
});

var _constants$5 = constants$1;

// Encode data string
var encode$2 = function encode(data, structure, separator) {
	var encoded = data.split('').map(function (val, idx) {
		return _constants$5.BINARIES[structure[idx]];
	}).map(function (val, idx) {
		return val ? val[data[idx]] : '';
	});

	if (separator) {
		var last = data.length - 1;
		encoded = encoded.map(function (val, idx) {
			return idx < last ? val + separator : val;
		});
	}

	return encoded.join('');
};

encoder.default = encode$2;

Object.defineProperty(EAN$1, "__esModule", {
	value: true
});

var _createClass$g = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants$4 = constants$1;

var _encoder$4 = encoder;

var _encoder2$4 = _interopRequireDefault$s(_encoder$4);

var _Barcode2$9 = Barcode$1;

var _Barcode3$9 = _interopRequireDefault$s(_Barcode2$9);

function _interopRequireDefault$s(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$l(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$h(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$h(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Base class for EAN8 & EAN13
var EAN = function (_Barcode) {
	_inherits$h(EAN, _Barcode);

	function EAN(data, options) {
		_classCallCheck$l(this, EAN);

		// Make sure the font is not bigger than the space between the guard bars
		var _this = _possibleConstructorReturn$h(this, (EAN.__proto__ || Object.getPrototypeOf(EAN)).call(this, data, options));

		_this.fontSize = !options.flat && options.fontSize > options.width * 10 ? options.width * 10 : options.fontSize;

		// Make the guard bars go down half the way of the text
		_this.guardHeight = options.height + _this.fontSize / 2 + options.textMargin;
		return _this;
	}

	_createClass$g(EAN, [{
		key: 'encode',
		value: function encode() {
			return this.options.flat ? this.encodeFlat() : this.encodeGuarded();
		}
	}, {
		key: 'leftText',
		value: function leftText(from, to) {
			return this.text.substr(from, to);
		}
	}, {
		key: 'leftEncode',
		value: function leftEncode(data, structure) {
			return (0, _encoder2$4.default)(data, structure);
		}
	}, {
		key: 'rightText',
		value: function rightText(from, to) {
			return this.text.substr(from, to);
		}
	}, {
		key: 'rightEncode',
		value: function rightEncode(data, structure) {
			return (0, _encoder2$4.default)(data, structure);
		}
	}, {
		key: 'encodeGuarded',
		value: function encodeGuarded() {
			var textOptions = { fontSize: this.fontSize };
			var guardOptions = { height: this.guardHeight };

			return [{ data: _constants$4.SIDE_BIN, options: guardOptions }, { data: this.leftEncode(), text: this.leftText(), options: textOptions }, { data: _constants$4.MIDDLE_BIN, options: guardOptions }, { data: this.rightEncode(), text: this.rightText(), options: textOptions }, { data: _constants$4.SIDE_BIN, options: guardOptions }];
		}
	}, {
		key: 'encodeFlat',
		value: function encodeFlat() {
			var data = [_constants$4.SIDE_BIN, this.leftEncode(), _constants$4.MIDDLE_BIN, this.rightEncode(), _constants$4.SIDE_BIN];

			return {
				data: data.join(''),
				text: this.text
			};
		}
	}]);

	return EAN;
}(_Barcode3$9.default);

EAN$1.default = EAN;

Object.defineProperty(EAN13$1, "__esModule", {
	value: true
});

var _createClass$f = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get$1 = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _constants$3 = constants$1;

var _EAN2$2 = EAN$1;

var _EAN3$2 = _interopRequireDefault$r(_EAN2$2);

function _interopRequireDefault$r(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$k(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$g(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$g(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/International_Article_Number_(EAN)#Binary_encoding_of_data_digits_into_EAN-13_barcode

// Calculate the checksum digit
// https://en.wikipedia.org/wiki/International_Article_Number_(EAN)#Calculation_of_checksum_digit
var checksum$4 = function checksum(number) {
	var res = number.substr(0, 12).split('').map(function (n) {
		return +n;
	}).reduce(function (sum, a, idx) {
		return idx % 2 ? sum + a * 3 : sum + a;
	}, 0);

	return (10 - res % 10) % 10;
};

var EAN13 = function (_EAN) {
	_inherits$g(EAN13, _EAN);

	function EAN13(data, options) {
		_classCallCheck$k(this, EAN13);

		// Add checksum if it does not exist
		if (data.search(/^[0-9]{12}$/) !== -1) {
			data += checksum$4(data);
		}

		// Adds a last character to the end of the barcode
		var _this = _possibleConstructorReturn$g(this, (EAN13.__proto__ || Object.getPrototypeOf(EAN13)).call(this, data, options));

		_this.lastChar = options.lastChar;
		return _this;
	}

	_createClass$f(EAN13, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^[0-9]{13}$/) !== -1 && +this.data[12] === checksum$4(this.data);
		}
	}, {
		key: 'leftText',
		value: function leftText() {
			return _get$1(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'leftText', this).call(this, 1, 6);
		}
	}, {
		key: 'leftEncode',
		value: function leftEncode() {
			var data = this.data.substr(1, 6);
			var structure = _constants$3.EAN13_STRUCTURE[this.data[0]];
			return _get$1(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'leftEncode', this).call(this, data, structure);
		}
	}, {
		key: 'rightText',
		value: function rightText() {
			return _get$1(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'rightText', this).call(this, 7, 6);
		}
	}, {
		key: 'rightEncode',
		value: function rightEncode() {
			var data = this.data.substr(7, 6);
			return _get$1(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'rightEncode', this).call(this, data, 'RRRRRR');
		}

		// The "standard" way of printing EAN13 barcodes with guard bars

	}, {
		key: 'encodeGuarded',
		value: function encodeGuarded() {
			var data = _get$1(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'encodeGuarded', this).call(this);

			// Extend data with left digit & last character
			if (this.options.displayValue) {
				data.unshift({
					data: '000000000000',
					text: this.text.substr(0, 1),
					options: { textAlign: 'left', fontSize: this.fontSize }
				});

				if (this.options.lastChar) {
					data.push({
						data: '00'
					});
					data.push({
						data: '00000',
						text: this.options.lastChar,
						options: { fontSize: this.fontSize }
					});
				}
			}

			return data;
		}
	}]);

	return EAN13;
}(_EAN3$2.default);

EAN13$1.default = EAN13;

var EAN8$1 = {};

Object.defineProperty(EAN8$1, "__esModule", {
	value: true
});

var _createClass$e = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _EAN2$1 = EAN$1;

var _EAN3$1 = _interopRequireDefault$q(_EAN2$1);

function _interopRequireDefault$q(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$j(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$f(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$f(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// http://www.barcodeisland.com/ean8.phtml

// Calculate the checksum digit
var checksum$3 = function checksum(number) {
	var res = number.substr(0, 7).split('').map(function (n) {
		return +n;
	}).reduce(function (sum, a, idx) {
		return idx % 2 ? sum + a : sum + a * 3;
	}, 0);

	return (10 - res % 10) % 10;
};

var EAN8 = function (_EAN) {
	_inherits$f(EAN8, _EAN);

	function EAN8(data, options) {
		_classCallCheck$j(this, EAN8);

		// Add checksum if it does not exist
		if (data.search(/^[0-9]{7}$/) !== -1) {
			data += checksum$3(data);
		}

		return _possibleConstructorReturn$f(this, (EAN8.__proto__ || Object.getPrototypeOf(EAN8)).call(this, data, options));
	}

	_createClass$e(EAN8, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^[0-9]{8}$/) !== -1 && +this.data[7] === checksum$3(this.data);
		}
	}, {
		key: 'leftText',
		value: function leftText() {
			return _get(EAN8.prototype.__proto__ || Object.getPrototypeOf(EAN8.prototype), 'leftText', this).call(this, 0, 4);
		}
	}, {
		key: 'leftEncode',
		value: function leftEncode() {
			var data = this.data.substr(0, 4);
			return _get(EAN8.prototype.__proto__ || Object.getPrototypeOf(EAN8.prototype), 'leftEncode', this).call(this, data, 'LLLL');
		}
	}, {
		key: 'rightText',
		value: function rightText() {
			return _get(EAN8.prototype.__proto__ || Object.getPrototypeOf(EAN8.prototype), 'rightText', this).call(this, 4, 4);
		}
	}, {
		key: 'rightEncode',
		value: function rightEncode() {
			var data = this.data.substr(4, 4);
			return _get(EAN8.prototype.__proto__ || Object.getPrototypeOf(EAN8.prototype), 'rightEncode', this).call(this, data, 'RRRR');
		}
	}]);

	return EAN8;
}(_EAN3$1.default);

EAN8$1.default = EAN8;

var EAN5$1 = {};

Object.defineProperty(EAN5$1, "__esModule", {
	value: true
});

var _createClass$d = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants$2 = constants$1;

var _encoder$3 = encoder;

var _encoder2$3 = _interopRequireDefault$p(_encoder$3);

var _Barcode2$8 = Barcode$1;

var _Barcode3$8 = _interopRequireDefault$p(_Barcode2$8);

function _interopRequireDefault$p(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$i(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$e(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$e(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/EAN_5#Encoding

var checksum$2 = function checksum(data) {
	var result = data.split('').map(function (n) {
		return +n;
	}).reduce(function (sum, a, idx) {
		return idx % 2 ? sum + a * 9 : sum + a * 3;
	}, 0);
	return result % 10;
};

var EAN5 = function (_Barcode) {
	_inherits$e(EAN5, _Barcode);

	function EAN5(data, options) {
		_classCallCheck$i(this, EAN5);

		return _possibleConstructorReturn$e(this, (EAN5.__proto__ || Object.getPrototypeOf(EAN5)).call(this, data, options));
	}

	_createClass$d(EAN5, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^[0-9]{5}$/) !== -1;
		}
	}, {
		key: 'encode',
		value: function encode() {
			var structure = _constants$2.EAN5_STRUCTURE[checksum$2(this.data)];
			return {
				data: '1011' + (0, _encoder2$3.default)(this.data, structure, '01'),
				text: this.text
			};
		}
	}]);

	return EAN5;
}(_Barcode3$8.default);

EAN5$1.default = EAN5;

var EAN2$1 = {};

Object.defineProperty(EAN2$1, "__esModule", {
	value: true
});

var _createClass$c = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants$1 = constants$1;

var _encoder$2 = encoder;

var _encoder2$2 = _interopRequireDefault$o(_encoder$2);

var _Barcode2$7 = Barcode$1;

var _Barcode3$7 = _interopRequireDefault$o(_Barcode2$7);

function _interopRequireDefault$o(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$h(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$d(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$d(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/EAN_2#Encoding

var EAN2 = function (_Barcode) {
	_inherits$d(EAN2, _Barcode);

	function EAN2(data, options) {
		_classCallCheck$h(this, EAN2);

		return _possibleConstructorReturn$d(this, (EAN2.__proto__ || Object.getPrototypeOf(EAN2)).call(this, data, options));
	}

	_createClass$c(EAN2, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^[0-9]{2}$/) !== -1;
		}
	}, {
		key: 'encode',
		value: function encode() {
			// Choose the structure based on the number mod 4
			var structure = _constants$1.EAN2_STRUCTURE[parseInt(this.data) % 4];
			return {
				// Start bits + Encode the two digits with 01 in between
				data: '1011' + (0, _encoder2$2.default)(this.data, structure, '01'),
				text: this.text
			};
		}
	}]);

	return EAN2;
}(_Barcode3$7.default);

EAN2$1.default = EAN2;

var UPC$1 = {};

Object.defineProperty(UPC$1, "__esModule", {
	value: true
});

var _createClass$b = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

UPC$1.checksum = checksum$1;

var _encoder$1 = encoder;

var _encoder2$1 = _interopRequireDefault$n(_encoder$1);

var _Barcode2$6 = Barcode$1;

var _Barcode3$6 = _interopRequireDefault$n(_Barcode2$6);

function _interopRequireDefault$n(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$g(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$c(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$c(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/Universal_Product_Code#Encoding

var UPC = function (_Barcode) {
	_inherits$c(UPC, _Barcode);

	function UPC(data, options) {
		_classCallCheck$g(this, UPC);

		// Add checksum if it does not exist
		if (data.search(/^[0-9]{11}$/) !== -1) {
			data += checksum$1(data);
		}

		var _this = _possibleConstructorReturn$c(this, (UPC.__proto__ || Object.getPrototypeOf(UPC)).call(this, data, options));

		_this.displayValue = options.displayValue;

		// Make sure the font is not bigger than the space between the guard bars
		if (options.fontSize > options.width * 10) {
			_this.fontSize = options.width * 10;
		} else {
			_this.fontSize = options.fontSize;
		}

		// Make the guard bars go down half the way of the text
		_this.guardHeight = options.height + _this.fontSize / 2 + options.textMargin;
		return _this;
	}

	_createClass$b(UPC, [{
		key: "valid",
		value: function valid() {
			return this.data.search(/^[0-9]{12}$/) !== -1 && this.data[11] == checksum$1(this.data);
		}
	}, {
		key: "encode",
		value: function encode() {
			if (this.options.flat) {
				return this.flatEncoding();
			} else {
				return this.guardedEncoding();
			}
		}
	}, {
		key: "flatEncoding",
		value: function flatEncoding() {
			var result = "";

			result += "101";
			result += (0, _encoder2$1.default)(this.data.substr(0, 6), "LLLLLL");
			result += "01010";
			result += (0, _encoder2$1.default)(this.data.substr(6, 6), "RRRRRR");
			result += "101";

			return {
				data: result,
				text: this.text
			};
		}
	}, {
		key: "guardedEncoding",
		value: function guardedEncoding() {
			var result = [];

			// Add the first digit
			if (this.displayValue) {
				result.push({
					data: "00000000",
					text: this.text.substr(0, 1),
					options: { textAlign: "left", fontSize: this.fontSize }
				});
			}

			// Add the guard bars
			result.push({
				data: "101" + (0, _encoder2$1.default)(this.data[0], "L"),
				options: { height: this.guardHeight }
			});

			// Add the left side
			result.push({
				data: (0, _encoder2$1.default)(this.data.substr(1, 5), "LLLLL"),
				text: this.text.substr(1, 5),
				options: { fontSize: this.fontSize }
			});

			// Add the middle bits
			result.push({
				data: "01010",
				options: { height: this.guardHeight }
			});

			// Add the right side
			result.push({
				data: (0, _encoder2$1.default)(this.data.substr(6, 5), "RRRRR"),
				text: this.text.substr(6, 5),
				options: { fontSize: this.fontSize }
			});

			// Add the end bits
			result.push({
				data: (0, _encoder2$1.default)(this.data[11], "R") + "101",
				options: { height: this.guardHeight }
			});

			// Add the last digit
			if (this.displayValue) {
				result.push({
					data: "00000000",
					text: this.text.substr(11, 1),
					options: { textAlign: "right", fontSize: this.fontSize }
				});
			}

			return result;
		}
	}]);

	return UPC;
}(_Barcode3$6.default);

// Calulate the checksum digit
// https://en.wikipedia.org/wiki/International_Article_Number_(EAN)#Calculation_of_checksum_digit


function checksum$1(number) {
	var result = 0;

	var i;
	for (i = 1; i < 11; i += 2) {
		result += parseInt(number[i]);
	}
	for (i = 0; i < 11; i += 2) {
		result += parseInt(number[i]) * 3;
	}

	return (10 - result % 10) % 10;
}

UPC$1.default = UPC;

var UPCE$1 = {};

Object.defineProperty(UPCE$1, "__esModule", {
	value: true
});

var _createClass$a = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _encoder = encoder;

var _encoder2 = _interopRequireDefault$m(_encoder);

var _Barcode2$5 = Barcode$1;

var _Barcode3$5 = _interopRequireDefault$m(_Barcode2$5);

var _UPC$1 = UPC$1;

function _interopRequireDefault$m(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$f(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$b(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$b(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/Universal_Product_Code#Encoding
//
// UPC-E documentation:
// https://en.wikipedia.org/wiki/Universal_Product_Code#UPC-E

var EXPANSIONS = ["XX00000XXX", "XX10000XXX", "XX20000XXX", "XXX00000XX", "XXXX00000X", "XXXXX00005", "XXXXX00006", "XXXXX00007", "XXXXX00008", "XXXXX00009"];

var PARITIES = [["EEEOOO", "OOOEEE"], ["EEOEOO", "OOEOEE"], ["EEOOEO", "OOEEOE"], ["EEOOOE", "OOEEEO"], ["EOEEOO", "OEOOEE"], ["EOOEEO", "OEEOOE"], ["EOOOEE", "OEEEOO"], ["EOEOEO", "OEOEOE"], ["EOEOOE", "OEOEEO"], ["EOOEOE", "OEEOEO"]];

var UPCE = function (_Barcode) {
	_inherits$b(UPCE, _Barcode);

	function UPCE(data, options) {
		_classCallCheck$f(this, UPCE);

		var _this = _possibleConstructorReturn$b(this, (UPCE.__proto__ || Object.getPrototypeOf(UPCE)).call(this, data, options));
		// Code may be 6 or 8 digits;
		// A 7 digit code is ambiguous as to whether the extra digit
		// is a UPC-A check or number system digit.


		_this.isValid = false;
		if (data.search(/^[0-9]{6}$/) !== -1) {
			_this.middleDigits = data;
			_this.upcA = expandToUPCA(data, "0");
			_this.text = options.text || '' + _this.upcA[0] + data + _this.upcA[_this.upcA.length - 1];
			_this.isValid = true;
		} else if (data.search(/^[01][0-9]{7}$/) !== -1) {
			_this.middleDigits = data.substring(1, data.length - 1);
			_this.upcA = expandToUPCA(_this.middleDigits, data[0]);

			if (_this.upcA[_this.upcA.length - 1] === data[data.length - 1]) {
				_this.isValid = true;
			} else {
				// checksum mismatch
				return _possibleConstructorReturn$b(_this);
			}
		} else {
			return _possibleConstructorReturn$b(_this);
		}

		_this.displayValue = options.displayValue;

		// Make sure the font is not bigger than the space between the guard bars
		if (options.fontSize > options.width * 10) {
			_this.fontSize = options.width * 10;
		} else {
			_this.fontSize = options.fontSize;
		}

		// Make the guard bars go down half the way of the text
		_this.guardHeight = options.height + _this.fontSize / 2 + options.textMargin;
		return _this;
	}

	_createClass$a(UPCE, [{
		key: 'valid',
		value: function valid() {
			return this.isValid;
		}
	}, {
		key: 'encode',
		value: function encode() {
			if (this.options.flat) {
				return this.flatEncoding();
			} else {
				return this.guardedEncoding();
			}
		}
	}, {
		key: 'flatEncoding',
		value: function flatEncoding() {
			var result = "";

			result += "101";
			result += this.encodeMiddleDigits();
			result += "010101";

			return {
				data: result,
				text: this.text
			};
		}
	}, {
		key: 'guardedEncoding',
		value: function guardedEncoding() {
			var result = [];

			// Add the UPC-A number system digit beneath the quiet zone
			if (this.displayValue) {
				result.push({
					data: "00000000",
					text: this.text[0],
					options: { textAlign: "left", fontSize: this.fontSize }
				});
			}

			// Add the guard bars
			result.push({
				data: "101",
				options: { height: this.guardHeight }
			});

			// Add the 6 UPC-E digits
			result.push({
				data: this.encodeMiddleDigits(),
				text: this.text.substring(1, 7),
				options: { fontSize: this.fontSize }
			});

			// Add the end bits
			result.push({
				data: "010101",
				options: { height: this.guardHeight }
			});

			// Add the UPC-A check digit beneath the quiet zone
			if (this.displayValue) {
				result.push({
					data: "00000000",
					text: this.text[7],
					options: { textAlign: "right", fontSize: this.fontSize }
				});
			}

			return result;
		}
	}, {
		key: 'encodeMiddleDigits',
		value: function encodeMiddleDigits() {
			var numberSystem = this.upcA[0];
			var checkDigit = this.upcA[this.upcA.length - 1];
			var parity = PARITIES[parseInt(checkDigit)][parseInt(numberSystem)];
			return (0, _encoder2.default)(this.middleDigits, parity);
		}
	}]);

	return UPCE;
}(_Barcode3$5.default);

function expandToUPCA(middleDigits, numberSystem) {
	var lastUpcE = parseInt(middleDigits[middleDigits.length - 1]);
	var expansion = EXPANSIONS[lastUpcE];

	var result = "";
	var digitIndex = 0;
	for (var i = 0; i < expansion.length; i++) {
		var c = expansion[i];
		if (c === 'X') {
			result += middleDigits[digitIndex++];
		} else {
			result += c;
		}
	}

	result = '' + numberSystem + result;
	return '' + result + (0, _UPC$1.checksum)(result);
}

UPCE$1.default = UPCE;

Object.defineProperty(EAN_UPC, "__esModule", {
  value: true
});
EAN_UPC.UPCE = EAN_UPC.UPC = EAN_UPC.EAN2 = EAN_UPC.EAN5 = EAN_UPC.EAN8 = EAN_UPC.EAN13 = undefined;

var _EAN = EAN13$1;

var _EAN2 = _interopRequireDefault$l(_EAN);

var _EAN3 = EAN8$1;

var _EAN4 = _interopRequireDefault$l(_EAN3);

var _EAN5 = EAN5$1;

var _EAN6 = _interopRequireDefault$l(_EAN5);

var _EAN7 = EAN2$1;

var _EAN8 = _interopRequireDefault$l(_EAN7);

var _UPC = UPC$1;

var _UPC2 = _interopRequireDefault$l(_UPC);

var _UPCE = UPCE$1;

var _UPCE2 = _interopRequireDefault$l(_UPCE);

function _interopRequireDefault$l(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

EAN_UPC.EAN13 = _EAN2.default;
EAN_UPC.EAN8 = _EAN4.default;
EAN_UPC.EAN5 = _EAN6.default;
EAN_UPC.EAN2 = _EAN8.default;
EAN_UPC.UPC = _UPC2.default;
EAN_UPC.UPCE = _UPCE2.default;

var ITF$2 = {};

var ITF$1 = {};

var constants = {};

Object.defineProperty(constants, "__esModule", {
	value: true
});
constants.START_BIN = '1010';
constants.END_BIN = '11101';

constants.BINARIES = ['00110', '10001', '01001', '11000', '00101', '10100', '01100', '00011', '10010', '01010'];

Object.defineProperty(ITF$1, "__esModule", {
	value: true
});

var _createClass$9 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = constants;

var _Barcode2$4 = Barcode$1;

var _Barcode3$4 = _interopRequireDefault$k(_Barcode2$4);

function _interopRequireDefault$k(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$e(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$a(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$a(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ITF = function (_Barcode) {
	_inherits$a(ITF, _Barcode);

	function ITF() {
		_classCallCheck$e(this, ITF);

		return _possibleConstructorReturn$a(this, (ITF.__proto__ || Object.getPrototypeOf(ITF)).apply(this, arguments));
	}

	_createClass$9(ITF, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^([0-9]{2})+$/) !== -1;
		}
	}, {
		key: 'encode',
		value: function encode() {
			var _this2 = this;

			// Calculate all the digit pairs
			var encoded = this.data.match(/.{2}/g).map(function (pair) {
				return _this2.encodePair(pair);
			}).join('');

			return {
				data: _constants.START_BIN + encoded + _constants.END_BIN,
				text: this.text
			};
		}

		// Calculate the data of a number pair

	}, {
		key: 'encodePair',
		value: function encodePair(pair) {
			var second = _constants.BINARIES[pair[1]];

			return _constants.BINARIES[pair[0]].split('').map(function (first, idx) {
				return (first === '1' ? '111' : '1') + (second[idx] === '1' ? '000' : '0');
			}).join('');
		}
	}]);

	return ITF;
}(_Barcode3$4.default);

ITF$1.default = ITF;

var ITF14$1 = {};

Object.defineProperty(ITF14$1, "__esModule", {
	value: true
});

var _createClass$8 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ITF2$1 = ITF$1;

var _ITF3$1 = _interopRequireDefault$j(_ITF2$1);

function _interopRequireDefault$j(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$d(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$9(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$9(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Calculate the checksum digit
var checksum = function checksum(data) {
	var res = data.substr(0, 13).split('').map(function (num) {
		return parseInt(num, 10);
	}).reduce(function (sum, n, idx) {
		return sum + n * (3 - idx % 2 * 2);
	}, 0);

	return Math.ceil(res / 10) * 10 - res;
};

var ITF14 = function (_ITF) {
	_inherits$9(ITF14, _ITF);

	function ITF14(data, options) {
		_classCallCheck$d(this, ITF14);

		// Add checksum if it does not exist
		if (data.search(/^[0-9]{13}$/) !== -1) {
			data += checksum(data);
		}
		return _possibleConstructorReturn$9(this, (ITF14.__proto__ || Object.getPrototypeOf(ITF14)).call(this, data, options));
	}

	_createClass$8(ITF14, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^[0-9]{14}$/) !== -1 && +this.data[13] === checksum(this.data);
		}
	}]);

	return ITF14;
}(_ITF3$1.default);

ITF14$1.default = ITF14;

Object.defineProperty(ITF$2, "__esModule", {
  value: true
});
ITF$2.ITF14 = ITF$2.ITF = undefined;

var _ITF$1 = ITF$1;

var _ITF2 = _interopRequireDefault$i(_ITF$1);

var _ITF3 = ITF14$1;

var _ITF4 = _interopRequireDefault$i(_ITF3);

function _interopRequireDefault$i(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

ITF$2.ITF = _ITF2.default;
ITF$2.ITF14 = _ITF4.default;

var MSI$2 = {};

var MSI$1 = {};

Object.defineProperty(MSI$1, "__esModule", {
	value: true
});

var _createClass$7 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2$3 = Barcode$1;

var _Barcode3$3 = _interopRequireDefault$h(_Barcode2$3);

function _interopRequireDefault$h(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$c(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$8(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$8(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation
// https://en.wikipedia.org/wiki/MSI_Barcode#Character_set_and_binary_lookup

var MSI = function (_Barcode) {
	_inherits$8(MSI, _Barcode);

	function MSI(data, options) {
		_classCallCheck$c(this, MSI);

		return _possibleConstructorReturn$8(this, (MSI.__proto__ || Object.getPrototypeOf(MSI)).call(this, data, options));
	}

	_createClass$7(MSI, [{
		key: "encode",
		value: function encode() {
			// Start bits
			var ret = "110";

			for (var i = 0; i < this.data.length; i++) {
				// Convert the character to binary (always 4 binary digits)
				var digit = parseInt(this.data[i]);
				var bin = digit.toString(2);
				bin = addZeroes(bin, 4 - bin.length);

				// Add 100 for every zero and 110 for every 1
				for (var b = 0; b < bin.length; b++) {
					ret += bin[b] == "0" ? "100" : "110";
				}
			}

			// End bits
			ret += "1001";

			return {
				data: ret,
				text: this.text
			};
		}
	}, {
		key: "valid",
		value: function valid() {
			return this.data.search(/^[0-9]+$/) !== -1;
		}
	}]);

	return MSI;
}(_Barcode3$3.default);

function addZeroes(number, n) {
	for (var i = 0; i < n; i++) {
		number = "0" + number;
	}
	return number;
}

MSI$1.default = MSI;

var MSI10$1 = {};

var checksums = {};

Object.defineProperty(checksums, "__esModule", {
	value: true
});
checksums.mod10 = mod10;
checksums.mod11 = mod11;
function mod10(number) {
	var sum = 0;
	for (var i = 0; i < number.length; i++) {
		var n = parseInt(number[i]);
		if ((i + number.length) % 2 === 0) {
			sum += n;
		} else {
			sum += n * 2 % 10 + Math.floor(n * 2 / 10);
		}
	}
	return (10 - sum % 10) % 10;
}

function mod11(number) {
	var sum = 0;
	var weights = [2, 3, 4, 5, 6, 7];
	for (var i = 0; i < number.length; i++) {
		var n = parseInt(number[number.length - 1 - i]);
		sum += weights[i % weights.length] * n;
	}
	return (11 - sum % 11) % 11;
}

Object.defineProperty(MSI10$1, "__esModule", {
	value: true
});

var _MSI2$4 = MSI$1;

var _MSI3$4 = _interopRequireDefault$g(_MSI2$4);

var _checksums$3 = checksums;

function _interopRequireDefault$g(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$b(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$7(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$7(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MSI10 = function (_MSI) {
	_inherits$7(MSI10, _MSI);

	function MSI10(data, options) {
		_classCallCheck$b(this, MSI10);

		return _possibleConstructorReturn$7(this, (MSI10.__proto__ || Object.getPrototypeOf(MSI10)).call(this, data + (0, _checksums$3.mod10)(data), options));
	}

	return MSI10;
}(_MSI3$4.default);

MSI10$1.default = MSI10;

var MSI11$1 = {};

Object.defineProperty(MSI11$1, "__esModule", {
	value: true
});

var _MSI2$3 = MSI$1;

var _MSI3$3 = _interopRequireDefault$f(_MSI2$3);

var _checksums$2 = checksums;

function _interopRequireDefault$f(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$a(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$6(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$6(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MSI11 = function (_MSI) {
	_inherits$6(MSI11, _MSI);

	function MSI11(data, options) {
		_classCallCheck$a(this, MSI11);

		return _possibleConstructorReturn$6(this, (MSI11.__proto__ || Object.getPrototypeOf(MSI11)).call(this, data + (0, _checksums$2.mod11)(data), options));
	}

	return MSI11;
}(_MSI3$3.default);

MSI11$1.default = MSI11;

var MSI1010$1 = {};

Object.defineProperty(MSI1010$1, "__esModule", {
	value: true
});

var _MSI2$2 = MSI$1;

var _MSI3$2 = _interopRequireDefault$e(_MSI2$2);

var _checksums$1 = checksums;

function _interopRequireDefault$e(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$9(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$5(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$5(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MSI1010 = function (_MSI) {
	_inherits$5(MSI1010, _MSI);

	function MSI1010(data, options) {
		_classCallCheck$9(this, MSI1010);

		data += (0, _checksums$1.mod10)(data);
		data += (0, _checksums$1.mod10)(data);
		return _possibleConstructorReturn$5(this, (MSI1010.__proto__ || Object.getPrototypeOf(MSI1010)).call(this, data, options));
	}

	return MSI1010;
}(_MSI3$2.default);

MSI1010$1.default = MSI1010;

var MSI1110$1 = {};

Object.defineProperty(MSI1110$1, "__esModule", {
	value: true
});

var _MSI2$1 = MSI$1;

var _MSI3$1 = _interopRequireDefault$d(_MSI2$1);

var _checksums = checksums;

function _interopRequireDefault$d(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$8(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$4(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$4(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MSI1110 = function (_MSI) {
	_inherits$4(MSI1110, _MSI);

	function MSI1110(data, options) {
		_classCallCheck$8(this, MSI1110);

		data += (0, _checksums.mod11)(data);
		data += (0, _checksums.mod10)(data);
		return _possibleConstructorReturn$4(this, (MSI1110.__proto__ || Object.getPrototypeOf(MSI1110)).call(this, data, options));
	}

	return MSI1110;
}(_MSI3$1.default);

MSI1110$1.default = MSI1110;

Object.defineProperty(MSI$2, "__esModule", {
  value: true
});
MSI$2.MSI1110 = MSI$2.MSI1010 = MSI$2.MSI11 = MSI$2.MSI10 = MSI$2.MSI = undefined;

var _MSI$1 = MSI$1;

var _MSI2 = _interopRequireDefault$c(_MSI$1);

var _MSI3 = MSI10$1;

var _MSI4 = _interopRequireDefault$c(_MSI3);

var _MSI5 = MSI11$1;

var _MSI6 = _interopRequireDefault$c(_MSI5);

var _MSI7 = MSI1010$1;

var _MSI8 = _interopRequireDefault$c(_MSI7);

var _MSI9 = MSI1110$1;

var _MSI10 = _interopRequireDefault$c(_MSI9);

function _interopRequireDefault$c(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

MSI$2.MSI = _MSI2.default;
MSI$2.MSI10 = _MSI4.default;
MSI$2.MSI11 = _MSI6.default;
MSI$2.MSI1010 = _MSI8.default;
MSI$2.MSI1110 = _MSI10.default;

var pharmacode$1 = {};

Object.defineProperty(pharmacode$1, "__esModule", {
	value: true
});
pharmacode$1.pharmacode = undefined;

var _createClass$6 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2$2 = Barcode$1;

var _Barcode3$2 = _interopRequireDefault$b(_Barcode2$2);

function _interopRequireDefault$b(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$7(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$3(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$3(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation
// http://www.gomaro.ch/ftproot/Laetus_PHARMA-CODE.pdf

var pharmacode = function (_Barcode) {
	_inherits$3(pharmacode, _Barcode);

	function pharmacode(data, options) {
		_classCallCheck$7(this, pharmacode);

		var _this = _possibleConstructorReturn$3(this, (pharmacode.__proto__ || Object.getPrototypeOf(pharmacode)).call(this, data, options));

		_this.number = parseInt(data, 10);
		return _this;
	}

	_createClass$6(pharmacode, [{
		key: "encode",
		value: function encode() {
			var z = this.number;
			var result = "";

			// http://i.imgur.com/RMm4UDJ.png
			// (source: http://www.gomaro.ch/ftproot/Laetus_PHARMA-CODE.pdf, page: 34)
			while (!isNaN(z) && z != 0) {
				if (z % 2 === 0) {
					// Even
					result = "11100" + result;
					z = (z - 2) / 2;
				} else {
					// Odd
					result = "100" + result;
					z = (z - 1) / 2;
				}
			}

			// Remove the two last zeroes
			result = result.slice(0, -2);

			return {
				data: result,
				text: this.text
			};
		}
	}, {
		key: "valid",
		value: function valid() {
			return this.number >= 3 && this.number <= 131070;
		}
	}]);

	return pharmacode;
}(_Barcode3$2.default);

pharmacode$1.pharmacode = pharmacode;

var codabar$1 = {};

Object.defineProperty(codabar$1, "__esModule", {
	value: true
});
codabar$1.codabar = undefined;

var _createClass$5 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2$1 = Barcode$1;

var _Barcode3$1 = _interopRequireDefault$a(_Barcode2$1);

function _interopRequireDefault$a(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$6(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$2(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding specification:
// http://www.barcodeisland.com/codabar.phtml

var codabar = function (_Barcode) {
	_inherits$2(codabar, _Barcode);

	function codabar(data, options) {
		_classCallCheck$6(this, codabar);

		if (data.search(/^[0-9\-\$\:\.\+\/]+$/) === 0) {
			data = "A" + data + "A";
		}

		var _this = _possibleConstructorReturn$2(this, (codabar.__proto__ || Object.getPrototypeOf(codabar)).call(this, data.toUpperCase(), options));

		_this.text = _this.options.text || _this.text.replace(/[A-D]/g, '');
		return _this;
	}

	_createClass$5(codabar, [{
		key: "valid",
		value: function valid() {
			return this.data.search(/^[A-D][0-9\-\$\:\.\+\/]+[A-D]$/) !== -1;
		}
	}, {
		key: "encode",
		value: function encode() {
			var result = [];
			var encodings = this.getEncodings();
			for (var i = 0; i < this.data.length; i++) {
				result.push(encodings[this.data.charAt(i)]);
				// for all characters except the last, append a narrow-space ("0")
				if (i !== this.data.length - 1) {
					result.push("0");
				}
			}
			return {
				text: this.text,
				data: result.join('')
			};
		}
	}, {
		key: "getEncodings",
		value: function getEncodings() {
			return {
				"0": "101010011",
				"1": "101011001",
				"2": "101001011",
				"3": "110010101",
				"4": "101101001",
				"5": "110101001",
				"6": "100101011",
				"7": "100101101",
				"8": "100110101",
				"9": "110100101",
				"-": "101001101",
				"$": "101100101",
				":": "1101011011",
				"/": "1101101011",
				".": "1101101101",
				"+": "1011011011",
				"A": "1011001001",
				"B": "1001001011",
				"C": "1010010011",
				"D": "1010011001"
			};
		}
	}]);

	return codabar;
}(_Barcode3$1.default);

codabar$1.codabar = codabar;

var GenericBarcode$1 = {};

Object.defineProperty(GenericBarcode$1, "__esModule", {
	value: true
});
GenericBarcode$1.GenericBarcode = undefined;

var _createClass$4 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2 = Barcode$1;

var _Barcode3 = _interopRequireDefault$9(_Barcode2);

function _interopRequireDefault$9(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$5(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$1(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GenericBarcode = function (_Barcode) {
	_inherits$1(GenericBarcode, _Barcode);

	function GenericBarcode(data, options) {
		_classCallCheck$5(this, GenericBarcode);

		return _possibleConstructorReturn$1(this, (GenericBarcode.__proto__ || Object.getPrototypeOf(GenericBarcode)).call(this, data, options)); // Sets this.data and this.text
	}

	// Return the corresponding binary numbers for the data provided


	_createClass$4(GenericBarcode, [{
		key: "encode",
		value: function encode() {
			return {
				data: "10101010101010101010101010101010101010101",
				text: this.text
			};
		}

		// Resturn true/false if the string provided is valid for this encoder

	}, {
		key: "valid",
		value: function valid() {
			return true;
		}
	}]);

	return GenericBarcode;
}(_Barcode3.default);

GenericBarcode$1.GenericBarcode = GenericBarcode;

Object.defineProperty(barcodes, "__esModule", {
	value: true
});

var _CODE = CODE39$1;

var _CODE2 = CODE128$2;

var _EAN_UPC = EAN_UPC;

var _ITF = ITF$2;

var _MSI = MSI$2;

var _pharmacode = pharmacode$1;

var _codabar = codabar$1;

var _GenericBarcode = GenericBarcode$1;

barcodes.default = {
	CODE39: _CODE.CODE39,
	CODE128: _CODE2.CODE128, CODE128A: _CODE2.CODE128A, CODE128B: _CODE2.CODE128B, CODE128C: _CODE2.CODE128C,
	EAN13: _EAN_UPC.EAN13, EAN8: _EAN_UPC.EAN8, EAN5: _EAN_UPC.EAN5, EAN2: _EAN_UPC.EAN2, UPC: _EAN_UPC.UPC, UPCE: _EAN_UPC.UPCE,
	ITF14: _ITF.ITF14,
	ITF: _ITF.ITF,
	MSI: _MSI.MSI, MSI10: _MSI.MSI10, MSI11: _MSI.MSI11, MSI1010: _MSI.MSI1010, MSI1110: _MSI.MSI1110,
	pharmacode: _pharmacode.pharmacode,
	codabar: _codabar.codabar,
	GenericBarcode: _GenericBarcode.GenericBarcode
};

var merge$1 = {};

Object.defineProperty(merge$1, "__esModule", {
  value: true
});

var _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

merge$1.default = function (old, replaceObj) {
  return _extends$2({}, old, replaceObj);
};

var linearizeEncodings$1 = {};

Object.defineProperty(linearizeEncodings$1, "__esModule", {
	value: true
});
linearizeEncodings$1.default = linearizeEncodings;

// Encodings can be nestled like [[1-1, 1-2], 2, [3-1, 3-2]
// Convert to [1-1, 1-2, 2, 3-1, 3-2]

function linearizeEncodings(encodings) {
	var linearEncodings = [];
	function nextLevel(encoded) {
		if (Array.isArray(encoded)) {
			for (var i = 0; i < encoded.length; i++) {
				nextLevel(encoded[i]);
			}
		} else {
			encoded.text = encoded.text || "";
			encoded.data = encoded.data || "";
			linearEncodings.push(encoded);
		}
	}
	nextLevel(encodings);

	return linearEncodings;
}

var fixOptions$1 = {};

Object.defineProperty(fixOptions$1, "__esModule", {
	value: true
});
fixOptions$1.default = fixOptions;


function fixOptions(options) {
	// Fix the margins
	options.marginTop = options.marginTop || options.margin;
	options.marginBottom = options.marginBottom || options.margin;
	options.marginRight = options.marginRight || options.margin;
	options.marginLeft = options.marginLeft || options.margin;

	return options;
}

var getRenderProperties$1 = {};

var getOptionsFromElement$1 = {};

var optionsFromStrings$1 = {};

Object.defineProperty(optionsFromStrings$1, "__esModule", {
	value: true
});
optionsFromStrings$1.default = optionsFromStrings;

// Convert string to integers/booleans where it should be

function optionsFromStrings(options) {
	var intOptions = ["width", "height", "textMargin", "fontSize", "margin", "marginTop", "marginBottom", "marginLeft", "marginRight"];

	for (var intOption in intOptions) {
		if (intOptions.hasOwnProperty(intOption)) {
			intOption = intOptions[intOption];
			if (typeof options[intOption] === "string") {
				options[intOption] = parseInt(options[intOption], 10);
			}
		}
	}

	if (typeof options["displayValue"] === "string") {
		options["displayValue"] = options["displayValue"] != "false";
	}

	return options;
}

var defaults$5 = {};

Object.defineProperty(defaults$5, "__esModule", {
	value: true
});
var defaults$4 = {
	width: 2,
	height: 100,
	format: "auto",
	displayValue: true,
	fontOptions: "",
	font: "monospace",
	text: undefined,
	textAlign: "center",
	textPosition: "bottom",
	textMargin: 2,
	fontSize: 20,
	background: "#ffffff",
	lineColor: "#000000",
	margin: 10,
	marginTop: undefined,
	marginBottom: undefined,
	marginLeft: undefined,
	marginRight: undefined,
	valid: function valid() {}
};

defaults$5.default = defaults$4;

Object.defineProperty(getOptionsFromElement$1, "__esModule", {
	value: true
});

var _optionsFromStrings$1 = optionsFromStrings$1;

var _optionsFromStrings2$1 = _interopRequireDefault$8(_optionsFromStrings$1);

var _defaults$1 = defaults$5;

var _defaults2$1 = _interopRequireDefault$8(_defaults$1);

function _interopRequireDefault$8(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getOptionsFromElement(element) {
	var options = {};
	for (var property in _defaults2$1.default) {
		if (_defaults2$1.default.hasOwnProperty(property)) {
			// jsbarcode-*
			if (element.hasAttribute("jsbarcode-" + property.toLowerCase())) {
				options[property] = element.getAttribute("jsbarcode-" + property.toLowerCase());
			}

			// data-*
			if (element.hasAttribute("data-" + property.toLowerCase())) {
				options[property] = element.getAttribute("data-" + property.toLowerCase());
			}
		}
	}

	options["value"] = element.getAttribute("jsbarcode-value") || element.getAttribute("data-value");

	// Since all atributes are string they need to be converted to integers
	options = (0, _optionsFromStrings2$1.default)(options);

	return options;
}

getOptionsFromElement$1.default = getOptionsFromElement;

var renderers = {};

var canvas = {};

var shared = {};

Object.defineProperty(shared, "__esModule", {
	value: true
});
shared.getTotalWidthOfEncodings = shared.calculateEncodingAttributes = shared.getBarcodePadding = shared.getEncodingHeight = shared.getMaximumHeightOfEncodings = undefined;

var _merge$3 = merge$1;

var _merge2$3 = _interopRequireDefault$7(_merge$3);

function _interopRequireDefault$7(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getEncodingHeight(encoding, options) {
	return options.height + (options.displayValue && encoding.text.length > 0 ? options.fontSize + options.textMargin : 0) + options.marginTop + options.marginBottom;
}

function getBarcodePadding(textWidth, barcodeWidth, options) {
	if (options.displayValue && barcodeWidth < textWidth) {
		if (options.textAlign == "center") {
			return Math.floor((textWidth - barcodeWidth) / 2);
		} else if (options.textAlign == "left") {
			return 0;
		} else if (options.textAlign == "right") {
			return Math.floor(textWidth - barcodeWidth);
		}
	}
	return 0;
}

function calculateEncodingAttributes(encodings, barcodeOptions, context) {
	for (var i = 0; i < encodings.length; i++) {
		var encoding = encodings[i];
		var options = (0, _merge2$3.default)(barcodeOptions, encoding.options);

		// Calculate the width of the encoding
		var textWidth;
		if (options.displayValue) {
			textWidth = messureText(encoding.text, options, context);
		} else {
			textWidth = 0;
		}

		var barcodeWidth = encoding.data.length * options.width;
		encoding.width = Math.ceil(Math.max(textWidth, barcodeWidth));

		encoding.height = getEncodingHeight(encoding, options);

		encoding.barcodePadding = getBarcodePadding(textWidth, barcodeWidth, options);
	}
}

function getTotalWidthOfEncodings(encodings) {
	var totalWidth = 0;
	for (var i = 0; i < encodings.length; i++) {
		totalWidth += encodings[i].width;
	}
	return totalWidth;
}

function getMaximumHeightOfEncodings(encodings) {
	var maxHeight = 0;
	for (var i = 0; i < encodings.length; i++) {
		if (encodings[i].height > maxHeight) {
			maxHeight = encodings[i].height;
		}
	}
	return maxHeight;
}

function messureText(string, options, context) {
	var ctx;

	if (context) {
		ctx = context;
	} else if (typeof document !== "undefined") {
		ctx = document.createElement("canvas").getContext("2d");
	} else {
		// If the text cannot be messured we will return 0.
		// This will make some barcode with big text render incorrectly
		return 0;
	}
	ctx.font = options.fontOptions + " " + options.fontSize + "px " + options.font;

	// Calculate the width of the encoding
	var measureTextResult = ctx.measureText(string);
	if (!measureTextResult) {
		// Some implementations don't implement measureText and return undefined.
		// If the text cannot be measured we will return 0.
		// This will make some barcode with big text render incorrectly
		return 0;
	}
	var size = measureTextResult.width;
	return size;
}

shared.getMaximumHeightOfEncodings = getMaximumHeightOfEncodings;
shared.getEncodingHeight = getEncodingHeight;
shared.getBarcodePadding = getBarcodePadding;
shared.calculateEncodingAttributes = calculateEncodingAttributes;
shared.getTotalWidthOfEncodings = getTotalWidthOfEncodings;

Object.defineProperty(canvas, "__esModule", {
	value: true
});

var _createClass$3 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _merge$2 = merge$1;

var _merge2$2 = _interopRequireDefault$6(_merge$2);

var _shared$1 = shared;

function _interopRequireDefault$6(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$4(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CanvasRenderer = function () {
	function CanvasRenderer(canvas, encodings, options) {
		_classCallCheck$4(this, CanvasRenderer);

		this.canvas = canvas;
		this.encodings = encodings;
		this.options = options;
	}

	_createClass$3(CanvasRenderer, [{
		key: "render",
		value: function render() {
			// Abort if the browser does not support HTML5 canvas
			if (!this.canvas.getContext) {
				throw new Error('The browser does not support canvas.');
			}

			this.prepareCanvas();
			for (var i = 0; i < this.encodings.length; i++) {
				var encodingOptions = (0, _merge2$2.default)(this.options, this.encodings[i].options);

				this.drawCanvasBarcode(encodingOptions, this.encodings[i]);
				this.drawCanvasText(encodingOptions, this.encodings[i]);

				this.moveCanvasDrawing(this.encodings[i]);
			}

			this.restoreCanvas();
		}
	}, {
		key: "prepareCanvas",
		value: function prepareCanvas() {
			// Get the canvas context
			var ctx = this.canvas.getContext("2d");

			ctx.save();

			(0, _shared$1.calculateEncodingAttributes)(this.encodings, this.options, ctx);
			var totalWidth = (0, _shared$1.getTotalWidthOfEncodings)(this.encodings);
			var maxHeight = (0, _shared$1.getMaximumHeightOfEncodings)(this.encodings);

			this.canvas.width = totalWidth + this.options.marginLeft + this.options.marginRight;

			this.canvas.height = maxHeight;

			// Paint the canvas
			ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
			if (this.options.background) {
				ctx.fillStyle = this.options.background;
				ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
			}

			ctx.translate(this.options.marginLeft, 0);
		}
	}, {
		key: "drawCanvasBarcode",
		value: function drawCanvasBarcode(options, encoding) {
			// Get the canvas context
			var ctx = this.canvas.getContext("2d");

			var binary = encoding.data;

			// Creates the barcode out of the encoded binary
			var yFrom;
			if (options.textPosition == "top") {
				yFrom = options.marginTop + options.fontSize + options.textMargin;
			} else {
				yFrom = options.marginTop;
			}

			ctx.fillStyle = options.lineColor;

			for (var b = 0; b < binary.length; b++) {
				var x = b * options.width + encoding.barcodePadding;

				if (binary[b] === "1") {
					ctx.fillRect(x, yFrom, options.width, options.height);
				} else if (binary[b]) {
					ctx.fillRect(x, yFrom, options.width, options.height * binary[b]);
				}
			}
		}
	}, {
		key: "drawCanvasText",
		value: function drawCanvasText(options, encoding) {
			// Get the canvas context
			var ctx = this.canvas.getContext("2d");

			var font = options.fontOptions + " " + options.fontSize + "px " + options.font;

			// Draw the text if displayValue is set
			if (options.displayValue) {
				var x, y;

				if (options.textPosition == "top") {
					y = options.marginTop + options.fontSize - options.textMargin;
				} else {
					y = options.height + options.textMargin + options.marginTop + options.fontSize;
				}

				ctx.font = font;

				// Draw the text in the correct X depending on the textAlign option
				if (options.textAlign == "left" || encoding.barcodePadding > 0) {
					x = 0;
					ctx.textAlign = 'left';
				} else if (options.textAlign == "right") {
					x = encoding.width - 1;
					ctx.textAlign = 'right';
				}
				// In all other cases, center the text
				else {
						x = encoding.width / 2;
						ctx.textAlign = 'center';
					}

				ctx.fillText(encoding.text, x, y);
			}
		}
	}, {
		key: "moveCanvasDrawing",
		value: function moveCanvasDrawing(encoding) {
			var ctx = this.canvas.getContext("2d");

			ctx.translate(encoding.width, 0);
		}
	}, {
		key: "restoreCanvas",
		value: function restoreCanvas() {
			// Get the canvas context
			var ctx = this.canvas.getContext("2d");

			ctx.restore();
		}
	}]);

	return CanvasRenderer;
}();

canvas.default = CanvasRenderer;

var svg = {};

Object.defineProperty(svg, "__esModule", {
	value: true
});

var _createClass$2 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _merge$1 = merge$1;

var _merge2$1 = _interopRequireDefault$5(_merge$1);

var _shared = shared;

function _interopRequireDefault$5(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var svgns = "http://www.w3.org/2000/svg";

var SVGRenderer = function () {
	function SVGRenderer(svg, encodings, options) {
		_classCallCheck$3(this, SVGRenderer);

		this.svg = svg;
		this.encodings = encodings;
		this.options = options;
		this.document = options.xmlDocument || document;
	}

	_createClass$2(SVGRenderer, [{
		key: "render",
		value: function render() {
			var currentX = this.options.marginLeft;

			this.prepareSVG();
			for (var i = 0; i < this.encodings.length; i++) {
				var encoding = this.encodings[i];
				var encodingOptions = (0, _merge2$1.default)(this.options, encoding.options);

				var group = this.createGroup(currentX, encodingOptions.marginTop, this.svg);

				this.setGroupOptions(group, encodingOptions);

				this.drawSvgBarcode(group, encodingOptions, encoding);
				this.drawSVGText(group, encodingOptions, encoding);

				currentX += encoding.width;
			}
		}
	}, {
		key: "prepareSVG",
		value: function prepareSVG() {
			// Clear the SVG
			while (this.svg.firstChild) {
				this.svg.removeChild(this.svg.firstChild);
			}

			(0, _shared.calculateEncodingAttributes)(this.encodings, this.options);
			var totalWidth = (0, _shared.getTotalWidthOfEncodings)(this.encodings);
			var maxHeight = (0, _shared.getMaximumHeightOfEncodings)(this.encodings);

			var width = totalWidth + this.options.marginLeft + this.options.marginRight;
			this.setSvgAttributes(width, maxHeight);

			if (this.options.background) {
				this.drawRect(0, 0, width, maxHeight, this.svg).setAttribute("style", "fill:" + this.options.background + ";");
			}
		}
	}, {
		key: "drawSvgBarcode",
		value: function drawSvgBarcode(parent, options, encoding) {
			var binary = encoding.data;

			// Creates the barcode out of the encoded binary
			var yFrom;
			if (options.textPosition == "top") {
				yFrom = options.fontSize + options.textMargin;
			} else {
				yFrom = 0;
			}

			var barWidth = 0;
			var x = 0;
			for (var b = 0; b < binary.length; b++) {
				x = b * options.width + encoding.barcodePadding;

				if (binary[b] === "1") {
					barWidth++;
				} else if (barWidth > 0) {
					this.drawRect(x - options.width * barWidth, yFrom, options.width * barWidth, options.height, parent);
					barWidth = 0;
				}
			}

			// Last draw is needed since the barcode ends with 1
			if (barWidth > 0) {
				this.drawRect(x - options.width * (barWidth - 1), yFrom, options.width * barWidth, options.height, parent);
			}
		}
	}, {
		key: "drawSVGText",
		value: function drawSVGText(parent, options, encoding) {
			var textElem = this.document.createElementNS(svgns, 'text');

			// Draw the text if displayValue is set
			if (options.displayValue) {
				var x, y;

				textElem.setAttribute("style", "font:" + options.fontOptions + " " + options.fontSize + "px " + options.font);

				if (options.textPosition == "top") {
					y = options.fontSize - options.textMargin;
				} else {
					y = options.height + options.textMargin + options.fontSize;
				}

				// Draw the text in the correct X depending on the textAlign option
				if (options.textAlign == "left" || encoding.barcodePadding > 0) {
					x = 0;
					textElem.setAttribute("text-anchor", "start");
				} else if (options.textAlign == "right") {
					x = encoding.width - 1;
					textElem.setAttribute("text-anchor", "end");
				}
				// In all other cases, center the text
				else {
						x = encoding.width / 2;
						textElem.setAttribute("text-anchor", "middle");
					}

				textElem.setAttribute("x", x);
				textElem.setAttribute("y", y);

				textElem.appendChild(this.document.createTextNode(encoding.text));

				parent.appendChild(textElem);
			}
		}
	}, {
		key: "setSvgAttributes",
		value: function setSvgAttributes(width, height) {
			var svg = this.svg;
			svg.setAttribute("width", width + "px");
			svg.setAttribute("height", height + "px");
			svg.setAttribute("x", "0px");
			svg.setAttribute("y", "0px");
			svg.setAttribute("viewBox", "0 0 " + width + " " + height);

			svg.setAttribute("xmlns", svgns);
			svg.setAttribute("version", "1.1");

			svg.setAttribute("style", "transform: translate(0,0)");
		}
	}, {
		key: "createGroup",
		value: function createGroup(x, y, parent) {
			var group = this.document.createElementNS(svgns, 'g');
			group.setAttribute("transform", "translate(" + x + ", " + y + ")");

			parent.appendChild(group);

			return group;
		}
	}, {
		key: "setGroupOptions",
		value: function setGroupOptions(group, options) {
			group.setAttribute("style", "fill:" + options.lineColor + ";");
		}
	}, {
		key: "drawRect",
		value: function drawRect(x, y, width, height, parent) {
			var rect = this.document.createElementNS(svgns, 'rect');

			rect.setAttribute("x", x);
			rect.setAttribute("y", y);
			rect.setAttribute("width", width);
			rect.setAttribute("height", height);

			parent.appendChild(rect);

			return rect;
		}
	}]);

	return SVGRenderer;
}();

svg.default = SVGRenderer;

var object = {};

Object.defineProperty(object, "__esModule", {
	value: true
});

var _createClass$1 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ObjectRenderer = function () {
	function ObjectRenderer(object, encodings, options) {
		_classCallCheck$2(this, ObjectRenderer);

		this.object = object;
		this.encodings = encodings;
		this.options = options;
	}

	_createClass$1(ObjectRenderer, [{
		key: "render",
		value: function render() {
			this.object.encodings = this.encodings;
		}
	}]);

	return ObjectRenderer;
}();

object.default = ObjectRenderer;

Object.defineProperty(renderers, "__esModule", {
  value: true
});

var _canvas = canvas;

var _canvas2 = _interopRequireDefault$4(_canvas);

var _svg = svg;

var _svg2 = _interopRequireDefault$4(_svg);

var _object = object;

var _object2 = _interopRequireDefault$4(_object);

function _interopRequireDefault$4(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

renderers.default = { CanvasRenderer: _canvas2.default, SVGRenderer: _svg2.default, ObjectRenderer: _object2.default };

var exceptions = {};

Object.defineProperty(exceptions, "__esModule", {
	value: true
});

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InvalidInputException = function (_Error) {
	_inherits(InvalidInputException, _Error);

	function InvalidInputException(symbology, input) {
		_classCallCheck$1(this, InvalidInputException);

		var _this = _possibleConstructorReturn(this, (InvalidInputException.__proto__ || Object.getPrototypeOf(InvalidInputException)).call(this));

		_this.name = "InvalidInputException";

		_this.symbology = symbology;
		_this.input = input;

		_this.message = '"' + _this.input + '" is not a valid input for ' + _this.symbology;
		return _this;
	}

	return InvalidInputException;
}(Error);

var InvalidElementException = function (_Error2) {
	_inherits(InvalidElementException, _Error2);

	function InvalidElementException() {
		_classCallCheck$1(this, InvalidElementException);

		var _this2 = _possibleConstructorReturn(this, (InvalidElementException.__proto__ || Object.getPrototypeOf(InvalidElementException)).call(this));

		_this2.name = "InvalidElementException";
		_this2.message = "Not supported type to render on";
		return _this2;
	}

	return InvalidElementException;
}(Error);

var NoElementException = function (_Error3) {
	_inherits(NoElementException, _Error3);

	function NoElementException() {
		_classCallCheck$1(this, NoElementException);

		var _this3 = _possibleConstructorReturn(this, (NoElementException.__proto__ || Object.getPrototypeOf(NoElementException)).call(this));

		_this3.name = "NoElementException";
		_this3.message = "No element to render on.";
		return _this3;
	}

	return NoElementException;
}(Error);

exceptions.InvalidInputException = InvalidInputException;
exceptions.InvalidElementException = InvalidElementException;
exceptions.NoElementException = NoElementException;

Object.defineProperty(getRenderProperties$1, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* global HTMLImageElement */
/* global HTMLCanvasElement */
/* global SVGElement */

var _getOptionsFromElement = getOptionsFromElement$1;

var _getOptionsFromElement2 = _interopRequireDefault$3(_getOptionsFromElement);

var _renderers = renderers;

var _renderers2 = _interopRequireDefault$3(_renderers);

var _exceptions$1 = exceptions;

function _interopRequireDefault$3(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Takes an element and returns an object with information about how
// it should be rendered
// This could also return an array with these objects
// {
//   element: The element that the renderer should draw on
//   renderer: The name of the renderer
//   afterRender (optional): If something has to done after the renderer
//     completed, calls afterRender (function)
//   options (optional): Options that can be defined in the element
// }

function getRenderProperties(element) {
	// If the element is a string, query select call again
	if (typeof element === "string") {
		return querySelectedRenderProperties(element);
	}
	// If element is array. Recursivly call with every object in the array
	else if (Array.isArray(element)) {
			var returnArray = [];
			for (var i = 0; i < element.length; i++) {
				returnArray.push(getRenderProperties(element[i]));
			}
			return returnArray;
		}
		// If element, render on canvas and set the uri as src
		else if (typeof HTMLCanvasElement !== 'undefined' && element instanceof HTMLImageElement) {
				return newCanvasRenderProperties(element);
			}
			// If SVG
			else if (element && element.nodeName && element.nodeName.toLowerCase() === 'svg' || typeof SVGElement !== 'undefined' && element instanceof SVGElement) {
					return {
						element: element,
						options: (0, _getOptionsFromElement2.default)(element),
						renderer: _renderers2.default.SVGRenderer
					};
				}
				// If canvas (in browser)
				else if (typeof HTMLCanvasElement !== 'undefined' && element instanceof HTMLCanvasElement) {
						return {
							element: element,
							options: (0, _getOptionsFromElement2.default)(element),
							renderer: _renderers2.default.CanvasRenderer
						};
					}
					// If canvas (in node)
					else if (element && element.getContext) {
							return {
								element: element,
								renderer: _renderers2.default.CanvasRenderer
							};
						} else if (element && (typeof element === "undefined" ? "undefined" : _typeof(element)) === 'object' && !element.nodeName) {
							return {
								element: element,
								renderer: _renderers2.default.ObjectRenderer
							};
						} else {
							throw new _exceptions$1.InvalidElementException();
						}
}

function querySelectedRenderProperties(string) {
	var selector = document.querySelectorAll(string);
	if (selector.length === 0) {
		return undefined;
	} else {
		var returnArray = [];
		for (var i = 0; i < selector.length; i++) {
			returnArray.push(getRenderProperties(selector[i]));
		}
		return returnArray;
	}
}

function newCanvasRenderProperties(imgElement) {
	var canvas = document.createElement('canvas');
	return {
		element: canvas,
		options: (0, _getOptionsFromElement2.default)(imgElement),
		renderer: _renderers2.default.CanvasRenderer,
		afterRender: function afterRender() {
			imgElement.setAttribute("src", canvas.toDataURL());
		}
	};
}

getRenderProperties$1.default = getRenderProperties;

var ErrorHandler$1 = {};

Object.defineProperty(ErrorHandler$1, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*eslint no-console: 0 */

var ErrorHandler = function () {
	function ErrorHandler(api) {
		_classCallCheck(this, ErrorHandler);

		this.api = api;
	}

	_createClass(ErrorHandler, [{
		key: "handleCatch",
		value: function handleCatch(e) {
			// If babel supported extending of Error in a correct way instanceof would be used here
			if (e.name === "InvalidInputException") {
				if (this.api._options.valid !== this.api._defaults.valid) {
					this.api._options.valid(false);
				} else {
					throw e.message;
				}
			} else {
				throw e;
			}

			this.api.render = function () {};
		}
	}, {
		key: "wrapBarcodeCall",
		value: function wrapBarcodeCall(func) {
			try {
				var result = func.apply(undefined, arguments);
				this.api._options.valid(true);
				return result;
			} catch (e) {
				this.handleCatch(e);

				return this.api;
			}
		}
	}]);

	return ErrorHandler;
}();

ErrorHandler$1.default = ErrorHandler;

var _barcodes = barcodes;

var _barcodes2 = _interopRequireDefault$2(_barcodes);

var _merge = merge$1;

var _merge2 = _interopRequireDefault$2(_merge);

var _linearizeEncodings = linearizeEncodings$1;

var _linearizeEncodings2 = _interopRequireDefault$2(_linearizeEncodings);

var _fixOptions = fixOptions$1;

var _fixOptions2 = _interopRequireDefault$2(_fixOptions);

var _getRenderProperties = getRenderProperties$1;

var _getRenderProperties2 = _interopRequireDefault$2(_getRenderProperties);

var _optionsFromStrings = optionsFromStrings$1;

var _optionsFromStrings2 = _interopRequireDefault$2(_optionsFromStrings);

var _ErrorHandler = ErrorHandler$1;

var _ErrorHandler2 = _interopRequireDefault$2(_ErrorHandler);

var _exceptions = exceptions;

var _defaults = defaults$5;

var _defaults2 = _interopRequireDefault$2(_defaults);

function _interopRequireDefault$2(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The protype of the object returned from the JsBarcode() call


// Help functions
var API = function API() {};

// The first call of the library API
// Will return an object with all barcodes calls and the data that is used
// by the renderers


// Default values


// Exceptions
// Import all the barcodes
var JsBarcode = function JsBarcode(element, text, options) {
	var api = new API();

	if (typeof element === "undefined") {
		throw Error("No element to render on was provided.");
	}

	// Variables that will be pased through the API calls
	api._renderProperties = (0, _getRenderProperties2.default)(element);
	api._encodings = [];
	api._options = _defaults2.default;
	api._errorHandler = new _ErrorHandler2.default(api);

	// If text is set, use the simple syntax (render the barcode directly)
	if (typeof text !== "undefined") {
		options = options || {};

		if (!options.format) {
			options.format = autoSelectBarcode();
		}

		api.options(options)[options.format](text, options).render();
	}

	return api;
};

// To make tests work TODO: remove
JsBarcode.getModule = function (name) {
	return _barcodes2.default[name];
};

// Register all barcodes
for (var name$1 in _barcodes2.default) {
	if (_barcodes2.default.hasOwnProperty(name$1)) {
		// Security check if the propery is a prototype property
		registerBarcode(_barcodes2.default, name$1);
	}
}
function registerBarcode(barcodes, name) {
	API.prototype[name] = API.prototype[name.toUpperCase()] = API.prototype[name.toLowerCase()] = function (text, options) {
		var api = this;
		return api._errorHandler.wrapBarcodeCall(function () {
			// Ensure text is options.text
			options.text = typeof options.text === 'undefined' ? undefined : '' + options.text;

			var newOptions = (0, _merge2.default)(api._options, options);
			newOptions = (0, _optionsFromStrings2.default)(newOptions);
			var Encoder = barcodes[name];
			var encoded = encode$1(text, Encoder, newOptions);
			api._encodings.push(encoded);

			return api;
		});
	};
}

// encode() handles the Encoder call and builds the binary string to be rendered
function encode$1(text, Encoder, options) {
	// Ensure that text is a string
	text = "" + text;

	var encoder = new Encoder(text, options);

	// If the input is not valid for the encoder, throw error.
	// If the valid callback option is set, call it instead of throwing error
	if (!encoder.valid()) {
		throw new _exceptions.InvalidInputException(encoder.constructor.name, text);
	}

	// Make a request for the binary data (and other infromation) that should be rendered
	var encoded = encoder.encode();

	// Encodings can be nestled like [[1-1, 1-2], 2, [3-1, 3-2]
	// Convert to [1-1, 1-2, 2, 3-1, 3-2]
	encoded = (0, _linearizeEncodings2.default)(encoded);

	// Merge
	for (var i = 0; i < encoded.length; i++) {
		encoded[i].options = (0, _merge2.default)(options, encoded[i].options);
	}

	return encoded;
}

function autoSelectBarcode() {
	// If CODE128 exists. Use it
	if (_barcodes2.default["CODE128"]) {
		return "CODE128";
	}

	// Else, take the first (probably only) barcode
	return Object.keys(_barcodes2.default)[0];
}

// Sets global encoder options
// Added to the api by the JsBarcode function
API.prototype.options = function (options) {
	this._options = (0, _merge2.default)(this._options, options);
	return this;
};

// Will create a blank space (usually in between barcodes)
API.prototype.blank = function (size) {
	var zeroes = new Array(size + 1).join("0");
	this._encodings.push({ data: zeroes });
	return this;
};

// Initialize JsBarcode on all HTML elements defined.
API.prototype.init = function () {
	// Should do nothing if no elements where found
	if (!this._renderProperties) {
		return;
	}

	// Make sure renderProperies is an array
	if (!Array.isArray(this._renderProperties)) {
		this._renderProperties = [this._renderProperties];
	}

	var renderProperty;
	for (var i in this._renderProperties) {
		renderProperty = this._renderProperties[i];
		var options = (0, _merge2.default)(this._options, renderProperty.options);

		if (options.format == "auto") {
			options.format = autoSelectBarcode();
		}

		this._errorHandler.wrapBarcodeCall(function () {
			var text = options.value;
			var Encoder = _barcodes2.default[options.format.toUpperCase()];
			var encoded = encode$1(text, Encoder, options);

			render(renderProperty, encoded, options);
		});
	}
};

// The render API call. Calls the real render function.
API.prototype.render = function () {
	if (!this._renderProperties) {
		throw new _exceptions.NoElementException();
	}

	if (Array.isArray(this._renderProperties)) {
		for (var i = 0; i < this._renderProperties.length; i++) {
			render(this._renderProperties[i], this._encodings, this._options);
		}
	} else {
		render(this._renderProperties, this._encodings, this._options);
	}

	return this;
};

API.prototype._defaults = _defaults2.default;

// Prepares the encodings and calls the renderer
function render(renderProperties, encodings, options) {
	encodings = (0, _linearizeEncodings2.default)(encodings);

	for (var i = 0; i < encodings.length; i++) {
		encodings[i].options = (0, _merge2.default)(options, encodings[i].options);
		(0, _fixOptions2.default)(encodings[i].options);
	}

	(0, _fixOptions2.default)(options);

	var Renderer = renderProperties.renderer;
	var renderer = new Renderer(renderProperties.element, encodings, options);
	renderer.render();

	if (renderProperties.afterRender) {
		renderProperties.afterRender();
	}
}

// Export to browser
if (typeof window !== "undefined") {
	window.JsBarcode = JsBarcode;
}

// Export to jQuery
/*global jQuery */
if (typeof jQuery !== 'undefined') {
	jQuery.fn.JsBarcode = function (content, options) {
		var elementArray = [];
		jQuery(this).each(function () {
			elementArray.push(this);
		});
		return JsBarcode(elementArray, content, options);
	};
}

// Export to commonJS
var JsBarcode_1 = JsBarcode;

var p = /*@__PURE__*/getDefaultExportFromCjs(JsBarcode_1);

var jsxRuntime = {exports: {}};

var reactJsxRuntime_production_min = {};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}

/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_production_min;

function requireReactJsxRuntime_production_min () {
	if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
	hasRequiredReactJsxRuntime_production_min = 1;
requireObjectAssign();var f=React__default,g=60103;reactJsxRuntime_production_min.Fragment=60107;if("function"===typeof Symbol&&Symbol.for){var h=Symbol.for;g=h("react.element");reactJsxRuntime_production_min.Fragment=h("react.fragment");}var m=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,n=Object.prototype.hasOwnProperty,p={key:!0,ref:!0,__self:!0,__source:!0};
	function q(c,a,k){var b,d={},e=null,l=null;void 0!==k&&(e=""+k);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(l=a.ref);for(b in a)n.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return {$$typeof:g,type:c,key:e,ref:l,props:d,_owner:m.current}}reactJsxRuntime_production_min.jsx=q;reactJsxRuntime_production_min.jsxs=q;
	return reactJsxRuntime_production_min;
}

var reactJsxRuntime_development = {};

/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_development;

function requireReactJsxRuntime_development () {
	if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
	hasRequiredReactJsxRuntime_development = 1;
	(function (exports) {

		if (process.env.NODE_ENV !== "production") {
		  (function() {

		var React = React__default;
		var _assign = requireObjectAssign();

		// ATTENTION
		// When adding new symbols to this file,
		// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
		// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
		// nor polyfill, then a plain number is used for performance.
		var REACT_ELEMENT_TYPE = 0xeac7;
		var REACT_PORTAL_TYPE = 0xeaca;
		exports.Fragment = 0xeacb;
		var REACT_STRICT_MODE_TYPE = 0xeacc;
		var REACT_PROFILER_TYPE = 0xead2;
		var REACT_PROVIDER_TYPE = 0xeacd;
		var REACT_CONTEXT_TYPE = 0xeace;
		var REACT_FORWARD_REF_TYPE = 0xead0;
		var REACT_SUSPENSE_TYPE = 0xead1;
		var REACT_SUSPENSE_LIST_TYPE = 0xead8;
		var REACT_MEMO_TYPE = 0xead3;
		var REACT_LAZY_TYPE = 0xead4;
		var REACT_BLOCK_TYPE = 0xead9;
		var REACT_SERVER_BLOCK_TYPE = 0xeada;
		var REACT_FUNDAMENTAL_TYPE = 0xead5;
		var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
		var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

		if (typeof Symbol === 'function' && Symbol.for) {
		  var symbolFor = Symbol.for;
		  REACT_ELEMENT_TYPE = symbolFor('react.element');
		  REACT_PORTAL_TYPE = symbolFor('react.portal');
		  exports.Fragment = symbolFor('react.fragment');
		  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
		  REACT_PROFILER_TYPE = symbolFor('react.profiler');
		  REACT_PROVIDER_TYPE = symbolFor('react.provider');
		  REACT_CONTEXT_TYPE = symbolFor('react.context');
		  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
		  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
		  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
		  REACT_MEMO_TYPE = symbolFor('react.memo');
		  REACT_LAZY_TYPE = symbolFor('react.lazy');
		  REACT_BLOCK_TYPE = symbolFor('react.block');
		  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
		  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
		  symbolFor('react.scope');
		  symbolFor('react.opaque.id');
		  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
		  symbolFor('react.offscreen');
		  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
		}

		var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
		var FAUX_ITERATOR_SYMBOL = '@@iterator';
		function getIteratorFn(maybeIterable) {
		  if (maybeIterable === null || typeof maybeIterable !== 'object') {
		    return null;
		  }

		  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

		  if (typeof maybeIterator === 'function') {
		    return maybeIterator;
		  }

		  return null;
		}

		var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

		function error(format) {
		  {
		    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
		      args[_key2 - 1] = arguments[_key2];
		    }

		    printWarning('error', format, args);
		  }
		}

		function printWarning(level, format, args) {
		  // When changing this logic, you might want to also
		  // update consoleWithStackDev.www.js as well.
		  {
		    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
		    var stack = ReactDebugCurrentFrame.getStackAddendum();

		    if (stack !== '') {
		      format += '%s';
		      args = args.concat([stack]);
		    }

		    var argsWithFormat = args.map(function (item) {
		      return '' + item;
		    }); // Careful: RN currently depends on this prefix

		    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
		    // breaks IE9: https://github.com/facebook/react/issues/13610
		    // eslint-disable-next-line react-internal/no-production-logging

		    Function.prototype.apply.call(console[level], console, argsWithFormat);
		  }
		}

		// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

		var enableScopeAPI = false; // Experimental Create Event Handle API.

		function isValidElementType(type) {
		  if (typeof type === 'string' || typeof type === 'function') {
		    return true;
		  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


		  if (type === exports.Fragment || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
		    return true;
		  }

		  if (typeof type === 'object' && type !== null) {
		    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
		      return true;
		    }
		  }

		  return false;
		}

		function getWrappedName(outerType, innerType, wrapperName) {
		  var functionName = innerType.displayName || innerType.name || '';
		  return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
		}

		function getContextName(type) {
		  return type.displayName || 'Context';
		}

		function getComponentName(type) {
		  if (type == null) {
		    // Host root, text node or just invalid type.
		    return null;
		  }

		  {
		    if (typeof type.tag === 'number') {
		      error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
		    }
		  }

		  if (typeof type === 'function') {
		    return type.displayName || type.name || null;
		  }

		  if (typeof type === 'string') {
		    return type;
		  }

		  switch (type) {
		    case exports.Fragment:
		      return 'Fragment';

		    case REACT_PORTAL_TYPE:
		      return 'Portal';

		    case REACT_PROFILER_TYPE:
		      return 'Profiler';

		    case REACT_STRICT_MODE_TYPE:
		      return 'StrictMode';

		    case REACT_SUSPENSE_TYPE:
		      return 'Suspense';

		    case REACT_SUSPENSE_LIST_TYPE:
		      return 'SuspenseList';
		  }

		  if (typeof type === 'object') {
		    switch (type.$$typeof) {
		      case REACT_CONTEXT_TYPE:
		        var context = type;
		        return getContextName(context) + '.Consumer';

		      case REACT_PROVIDER_TYPE:
		        var provider = type;
		        return getContextName(provider._context) + '.Provider';

		      case REACT_FORWARD_REF_TYPE:
		        return getWrappedName(type, type.render, 'ForwardRef');

		      case REACT_MEMO_TYPE:
		        return getComponentName(type.type);

		      case REACT_BLOCK_TYPE:
		        return getComponentName(type._render);

		      case REACT_LAZY_TYPE:
		        {
		          var lazyComponent = type;
		          var payload = lazyComponent._payload;
		          var init = lazyComponent._init;

		          try {
		            return getComponentName(init(payload));
		          } catch (x) {
		            return null;
		          }
		        }
		    }
		  }

		  return null;
		}

		// Helpers to patch console.logs to avoid logging during side-effect free
		// replaying on render function. This currently only patches the object
		// lazily which won't cover if the log function was extracted eagerly.
		// We could also eagerly patch the method.
		var disabledDepth = 0;
		var prevLog;
		var prevInfo;
		var prevWarn;
		var prevError;
		var prevGroup;
		var prevGroupCollapsed;
		var prevGroupEnd;

		function disabledLog() {}

		disabledLog.__reactDisabledLog = true;
		function disableLogs() {
		  {
		    if (disabledDepth === 0) {
		      /* eslint-disable react-internal/no-production-logging */
		      prevLog = console.log;
		      prevInfo = console.info;
		      prevWarn = console.warn;
		      prevError = console.error;
		      prevGroup = console.group;
		      prevGroupCollapsed = console.groupCollapsed;
		      prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

		      var props = {
		        configurable: true,
		        enumerable: true,
		        value: disabledLog,
		        writable: true
		      }; // $FlowFixMe Flow thinks console is immutable.

		      Object.defineProperties(console, {
		        info: props,
		        log: props,
		        warn: props,
		        error: props,
		        group: props,
		        groupCollapsed: props,
		        groupEnd: props
		      });
		      /* eslint-enable react-internal/no-production-logging */
		    }

		    disabledDepth++;
		  }
		}
		function reenableLogs() {
		  {
		    disabledDepth--;

		    if (disabledDepth === 0) {
		      /* eslint-disable react-internal/no-production-logging */
		      var props = {
		        configurable: true,
		        enumerable: true,
		        writable: true
		      }; // $FlowFixMe Flow thinks console is immutable.

		      Object.defineProperties(console, {
		        log: _assign({}, props, {
		          value: prevLog
		        }),
		        info: _assign({}, props, {
		          value: prevInfo
		        }),
		        warn: _assign({}, props, {
		          value: prevWarn
		        }),
		        error: _assign({}, props, {
		          value: prevError
		        }),
		        group: _assign({}, props, {
		          value: prevGroup
		        }),
		        groupCollapsed: _assign({}, props, {
		          value: prevGroupCollapsed
		        }),
		        groupEnd: _assign({}, props, {
		          value: prevGroupEnd
		        })
		      });
		      /* eslint-enable react-internal/no-production-logging */
		    }

		    if (disabledDepth < 0) {
		      error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
		    }
		  }
		}

		var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
		var prefix;
		function describeBuiltInComponentFrame(name, source, ownerFn) {
		  {
		    if (prefix === undefined) {
		      // Extract the VM specific prefix used by each line.
		      try {
		        throw Error();
		      } catch (x) {
		        var match = x.stack.trim().match(/\n( *(at )?)/);
		        prefix = match && match[1] || '';
		      }
		    } // We use the prefix to ensure our stacks line up with native stack frames.


		    return '\n' + prefix + name;
		  }
		}
		var reentry = false;
		var componentFrameCache;

		{
		  var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
		  componentFrameCache = new PossiblyWeakMap();
		}

		function describeNativeComponentFrame(fn, construct) {
		  // If something asked for a stack inside a fake render, it should get ignored.
		  if (!fn || reentry) {
		    return '';
		  }

		  {
		    var frame = componentFrameCache.get(fn);

		    if (frame !== undefined) {
		      return frame;
		    }
		  }

		  var control;
		  reentry = true;
		  var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

		  Error.prepareStackTrace = undefined;
		  var previousDispatcher;

		  {
		    previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
		    // for warnings.

		    ReactCurrentDispatcher.current = null;
		    disableLogs();
		  }

		  try {
		    // This should throw.
		    if (construct) {
		      // Something should be setting the props in the constructor.
		      var Fake = function () {
		        throw Error();
		      }; // $FlowFixMe


		      Object.defineProperty(Fake.prototype, 'props', {
		        set: function () {
		          // We use a throwing setter instead of frozen or non-writable props
		          // because that won't throw in a non-strict mode function.
		          throw Error();
		        }
		      });

		      if (typeof Reflect === 'object' && Reflect.construct) {
		        // We construct a different control for this case to include any extra
		        // frames added by the construct call.
		        try {
		          Reflect.construct(Fake, []);
		        } catch (x) {
		          control = x;
		        }

		        Reflect.construct(fn, [], Fake);
		      } else {
		        try {
		          Fake.call();
		        } catch (x) {
		          control = x;
		        }

		        fn.call(Fake.prototype);
		      }
		    } else {
		      try {
		        throw Error();
		      } catch (x) {
		        control = x;
		      }

		      fn();
		    }
		  } catch (sample) {
		    // This is inlined manually because closure doesn't do it for us.
		    if (sample && control && typeof sample.stack === 'string') {
		      // This extracts the first frame from the sample that isn't also in the control.
		      // Skipping one frame that we assume is the frame that calls the two.
		      var sampleLines = sample.stack.split('\n');
		      var controlLines = control.stack.split('\n');
		      var s = sampleLines.length - 1;
		      var c = controlLines.length - 1;

		      while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
		        // We expect at least one stack frame to be shared.
		        // Typically this will be the root most one. However, stack frames may be
		        // cut off due to maximum stack limits. In this case, one maybe cut off
		        // earlier than the other. We assume that the sample is longer or the same
		        // and there for cut off earlier. So we should find the root most frame in
		        // the sample somewhere in the control.
		        c--;
		      }

		      for (; s >= 1 && c >= 0; s--, c--) {
		        // Next we find the first one that isn't the same which should be the
		        // frame that called our sample function and the control.
		        if (sampleLines[s] !== controlLines[c]) {
		          // In V8, the first line is describing the message but other VMs don't.
		          // If we're about to return the first line, and the control is also on the same
		          // line, that's a pretty good indicator that our sample threw at same line as
		          // the control. I.e. before we entered the sample frame. So we ignore this result.
		          // This can happen if you passed a class to function component, or non-function.
		          if (s !== 1 || c !== 1) {
		            do {
		              s--;
		              c--; // We may still have similar intermediate frames from the construct call.
		              // The next one that isn't the same should be our match though.

		              if (c < 0 || sampleLines[s] !== controlLines[c]) {
		                // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
		                var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');

		                {
		                  if (typeof fn === 'function') {
		                    componentFrameCache.set(fn, _frame);
		                  }
		                } // Return the line we found.


		                return _frame;
		              }
		            } while (s >= 1 && c >= 0);
		          }

		          break;
		        }
		      }
		    }
		  } finally {
		    reentry = false;

		    {
		      ReactCurrentDispatcher.current = previousDispatcher;
		      reenableLogs();
		    }

		    Error.prepareStackTrace = previousPrepareStackTrace;
		  } // Fallback to just using the name if we couldn't make it throw.


		  var name = fn ? fn.displayName || fn.name : '';
		  var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';

		  {
		    if (typeof fn === 'function') {
		      componentFrameCache.set(fn, syntheticFrame);
		    }
		  }

		  return syntheticFrame;
		}
		function describeFunctionComponentFrame(fn, source, ownerFn) {
		  {
		    return describeNativeComponentFrame(fn, false);
		  }
		}

		function shouldConstruct(Component) {
		  var prototype = Component.prototype;
		  return !!(prototype && prototype.isReactComponent);
		}

		function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {

		  if (type == null) {
		    return '';
		  }

		  if (typeof type === 'function') {
		    {
		      return describeNativeComponentFrame(type, shouldConstruct(type));
		    }
		  }

		  if (typeof type === 'string') {
		    return describeBuiltInComponentFrame(type);
		  }

		  switch (type) {
		    case REACT_SUSPENSE_TYPE:
		      return describeBuiltInComponentFrame('Suspense');

		    case REACT_SUSPENSE_LIST_TYPE:
		      return describeBuiltInComponentFrame('SuspenseList');
		  }

		  if (typeof type === 'object') {
		    switch (type.$$typeof) {
		      case REACT_FORWARD_REF_TYPE:
		        return describeFunctionComponentFrame(type.render);

		      case REACT_MEMO_TYPE:
		        // Memo may contain any component type so we recursively resolve it.
		        return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

		      case REACT_BLOCK_TYPE:
		        return describeFunctionComponentFrame(type._render);

		      case REACT_LAZY_TYPE:
		        {
		          var lazyComponent = type;
		          var payload = lazyComponent._payload;
		          var init = lazyComponent._init;

		          try {
		            // Lazy may contain any component type so we recursively resolve it.
		            return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
		          } catch (x) {}
		        }
		    }
		  }

		  return '';
		}

		var loggedTypeFailures = {};
		var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

		function setCurrentlyValidatingElement(element) {
		  {
		    if (element) {
		      var owner = element._owner;
		      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
		      ReactDebugCurrentFrame.setExtraStackFrame(stack);
		    } else {
		      ReactDebugCurrentFrame.setExtraStackFrame(null);
		    }
		  }
		}

		function checkPropTypes(typeSpecs, values, location, componentName, element) {
		  {
		    // $FlowFixMe This is okay but Flow doesn't know it.
		    var has = Function.call.bind(Object.prototype.hasOwnProperty);

		    for (var typeSpecName in typeSpecs) {
		      if (has(typeSpecs, typeSpecName)) {
		        var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
		        // fail the render phase where it didn't fail before. So we log it.
		        // After these have been cleaned up, we'll let them throw.

		        try {
		          // This is intentionally an invariant that gets caught. It's the same
		          // behavior as without this statement except with a better message.
		          if (typeof typeSpecs[typeSpecName] !== 'function') {
		            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
		            err.name = 'Invariant Violation';
		            throw err;
		          }

		          error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
		        } catch (ex) {
		          error$1 = ex;
		        }

		        if (error$1 && !(error$1 instanceof Error)) {
		          setCurrentlyValidatingElement(element);

		          error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);

		          setCurrentlyValidatingElement(null);
		        }

		        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
		          // Only monitor this failure once because there tends to be a lot of the
		          // same error.
		          loggedTypeFailures[error$1.message] = true;
		          setCurrentlyValidatingElement(element);

		          error('Failed %s type: %s', location, error$1.message);

		          setCurrentlyValidatingElement(null);
		        }
		      }
		    }
		  }
		}

		var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
		var hasOwnProperty = Object.prototype.hasOwnProperty;
		var RESERVED_PROPS = {
		  key: true,
		  ref: true,
		  __self: true,
		  __source: true
		};
		var specialPropKeyWarningShown;
		var specialPropRefWarningShown;
		var didWarnAboutStringRefs;

		{
		  didWarnAboutStringRefs = {};
		}

		function hasValidRef(config) {
		  {
		    if (hasOwnProperty.call(config, 'ref')) {
		      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

		      if (getter && getter.isReactWarning) {
		        return false;
		      }
		    }
		  }

		  return config.ref !== undefined;
		}

		function hasValidKey(config) {
		  {
		    if (hasOwnProperty.call(config, 'key')) {
		      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

		      if (getter && getter.isReactWarning) {
		        return false;
		      }
		    }
		  }

		  return config.key !== undefined;
		}

		function warnIfStringRefCannotBeAutoConverted(config, self) {
		  {
		    if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
		      var componentName = getComponentName(ReactCurrentOwner.current.type);

		      if (!didWarnAboutStringRefs[componentName]) {
		        error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentName(ReactCurrentOwner.current.type), config.ref);

		        didWarnAboutStringRefs[componentName] = true;
		      }
		    }
		  }
		}

		function defineKeyPropWarningGetter(props, displayName) {
		  {
		    var warnAboutAccessingKey = function () {
		      if (!specialPropKeyWarningShown) {
		        specialPropKeyWarningShown = true;

		        error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
		      }
		    };

		    warnAboutAccessingKey.isReactWarning = true;
		    Object.defineProperty(props, 'key', {
		      get: warnAboutAccessingKey,
		      configurable: true
		    });
		  }
		}

		function defineRefPropWarningGetter(props, displayName) {
		  {
		    var warnAboutAccessingRef = function () {
		      if (!specialPropRefWarningShown) {
		        specialPropRefWarningShown = true;

		        error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
		      }
		    };

		    warnAboutAccessingRef.isReactWarning = true;
		    Object.defineProperty(props, 'ref', {
		      get: warnAboutAccessingRef,
		      configurable: true
		    });
		  }
		}
		/**
		 * Factory method to create a new React element. This no longer adheres to
		 * the class pattern, so do not use new to call it. Also, instanceof check
		 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
		 * if something is a React Element.
		 *
		 * @param {*} type
		 * @param {*} props
		 * @param {*} key
		 * @param {string|object} ref
		 * @param {*} owner
		 * @param {*} self A *temporary* helper to detect places where `this` is
		 * different from the `owner` when React.createElement is called, so that we
		 * can warn. We want to get rid of owner and replace string `ref`s with arrow
		 * functions, and as long as `this` and owner are the same, there will be no
		 * change in behavior.
		 * @param {*} source An annotation object (added by a transpiler or otherwise)
		 * indicating filename, line number, and/or other information.
		 * @internal
		 */


		var ReactElement = function (type, key, ref, self, source, owner, props) {
		  var element = {
		    // This tag allows us to uniquely identify this as a React Element
		    $$typeof: REACT_ELEMENT_TYPE,
		    // Built-in properties that belong on the element
		    type: type,
		    key: key,
		    ref: ref,
		    props: props,
		    // Record the component responsible for creating this element.
		    _owner: owner
		  };

		  {
		    // The validation flag is currently mutative. We put it on
		    // an external backing store so that we can freeze the whole object.
		    // This can be replaced with a WeakMap once they are implemented in
		    // commonly used development environments.
		    element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
		    // the validation flag non-enumerable (where possible, which should
		    // include every environment we run tests in), so the test framework
		    // ignores it.

		    Object.defineProperty(element._store, 'validated', {
		      configurable: false,
		      enumerable: false,
		      writable: true,
		      value: false
		    }); // self and source are DEV only properties.

		    Object.defineProperty(element, '_self', {
		      configurable: false,
		      enumerable: false,
		      writable: false,
		      value: self
		    }); // Two elements created in two different places should be considered
		    // equal for testing purposes and therefore we hide it from enumeration.

		    Object.defineProperty(element, '_source', {
		      configurable: false,
		      enumerable: false,
		      writable: false,
		      value: source
		    });

		    if (Object.freeze) {
		      Object.freeze(element.props);
		      Object.freeze(element);
		    }
		  }

		  return element;
		};
		/**
		 * https://github.com/reactjs/rfcs/pull/107
		 * @param {*} type
		 * @param {object} props
		 * @param {string} key
		 */

		function jsxDEV(type, config, maybeKey, source, self) {
		  {
		    var propName; // Reserved names are extracted

		    var props = {};
		    var key = null;
		    var ref = null; // Currently, key can be spread in as a prop. This causes a potential
		    // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
		    // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
		    // but as an intermediary step, we will use jsxDEV for everything except
		    // <div {...props} key="Hi" />, because we aren't currently able to tell if
		    // key is explicitly declared to be undefined or not.

		    if (maybeKey !== undefined) {
		      key = '' + maybeKey;
		    }

		    if (hasValidKey(config)) {
		      key = '' + config.key;
		    }

		    if (hasValidRef(config)) {
		      ref = config.ref;
		      warnIfStringRefCannotBeAutoConverted(config, self);
		    } // Remaining properties are added to a new props object


		    for (propName in config) {
		      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
		        props[propName] = config[propName];
		      }
		    } // Resolve default props


		    if (type && type.defaultProps) {
		      var defaultProps = type.defaultProps;

		      for (propName in defaultProps) {
		        if (props[propName] === undefined) {
		          props[propName] = defaultProps[propName];
		        }
		      }
		    }

		    if (key || ref) {
		      var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

		      if (key) {
		        defineKeyPropWarningGetter(props, displayName);
		      }

		      if (ref) {
		        defineRefPropWarningGetter(props, displayName);
		      }
		    }

		    return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
		  }
		}

		var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
		var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

		function setCurrentlyValidatingElement$1(element) {
		  {
		    if (element) {
		      var owner = element._owner;
		      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
		      ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
		    } else {
		      ReactDebugCurrentFrame$1.setExtraStackFrame(null);
		    }
		  }
		}

		var propTypesMisspellWarningShown;

		{
		  propTypesMisspellWarningShown = false;
		}
		/**
		 * Verifies the object is a ReactElement.
		 * See https://reactjs.org/docs/react-api.html#isvalidelement
		 * @param {?object} object
		 * @return {boolean} True if `object` is a ReactElement.
		 * @final
		 */

		function isValidElement(object) {
		  {
		    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
		  }
		}

		function getDeclarationErrorAddendum() {
		  {
		    if (ReactCurrentOwner$1.current) {
		      var name = getComponentName(ReactCurrentOwner$1.current.type);

		      if (name) {
		        return '\n\nCheck the render method of `' + name + '`.';
		      }
		    }

		    return '';
		  }
		}

		function getSourceInfoErrorAddendum(source) {
		  {
		    if (source !== undefined) {
		      var fileName = source.fileName.replace(/^.*[\\\/]/, '');
		      var lineNumber = source.lineNumber;
		      return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
		    }

		    return '';
		  }
		}
		/**
		 * Warn if there's no key explicitly set on dynamic arrays of children or
		 * object keys are not valid. This allows us to keep track of children between
		 * updates.
		 */


		var ownerHasKeyUseWarning = {};

		function getCurrentComponentErrorInfo(parentType) {
		  {
		    var info = getDeclarationErrorAddendum();

		    if (!info) {
		      var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

		      if (parentName) {
		        info = "\n\nCheck the top-level render call using <" + parentName + ">.";
		      }
		    }

		    return info;
		  }
		}
		/**
		 * Warn if the element doesn't have an explicit key assigned to it.
		 * This element is in an array. The array could grow and shrink or be
		 * reordered. All children that haven't already been validated are required to
		 * have a "key" property assigned to it. Error statuses are cached so a warning
		 * will only be shown once.
		 *
		 * @internal
		 * @param {ReactElement} element Element that requires a key.
		 * @param {*} parentType element's parent's type.
		 */


		function validateExplicitKey(element, parentType) {
		  {
		    if (!element._store || element._store.validated || element.key != null) {
		      return;
		    }

		    element._store.validated = true;
		    var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

		    if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
		      return;
		    }

		    ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
		    // property, it may be the creator of the child that's responsible for
		    // assigning it a key.

		    var childOwner = '';

		    if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
		      // Give the component that originally created this child.
		      childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
		    }

		    setCurrentlyValidatingElement$1(element);

		    error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);

		    setCurrentlyValidatingElement$1(null);
		  }
		}
		/**
		 * Ensure that every element either is passed in a static location, in an
		 * array with an explicit keys property defined, or in an object literal
		 * with valid key property.
		 *
		 * @internal
		 * @param {ReactNode} node Statically passed child of any type.
		 * @param {*} parentType node's parent's type.
		 */


		function validateChildKeys(node, parentType) {
		  {
		    if (typeof node !== 'object') {
		      return;
		    }

		    if (Array.isArray(node)) {
		      for (var i = 0; i < node.length; i++) {
		        var child = node[i];

		        if (isValidElement(child)) {
		          validateExplicitKey(child, parentType);
		        }
		      }
		    } else if (isValidElement(node)) {
		      // This element was passed in a valid location.
		      if (node._store) {
		        node._store.validated = true;
		      }
		    } else if (node) {
		      var iteratorFn = getIteratorFn(node);

		      if (typeof iteratorFn === 'function') {
		        // Entry iterators used to provide implicit keys,
		        // but now we print a separate warning for them later.
		        if (iteratorFn !== node.entries) {
		          var iterator = iteratorFn.call(node);
		          var step;

		          while (!(step = iterator.next()).done) {
		            if (isValidElement(step.value)) {
		              validateExplicitKey(step.value, parentType);
		            }
		          }
		        }
		      }
		    }
		  }
		}
		/**
		 * Given an element, validate that its props follow the propTypes definition,
		 * provided by the type.
		 *
		 * @param {ReactElement} element
		 */


		function validatePropTypes(element) {
		  {
		    var type = element.type;

		    if (type === null || type === undefined || typeof type === 'string') {
		      return;
		    }

		    var propTypes;

		    if (typeof type === 'function') {
		      propTypes = type.propTypes;
		    } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
		    // Inner props are checked in the reconciler.
		    type.$$typeof === REACT_MEMO_TYPE)) {
		      propTypes = type.propTypes;
		    } else {
		      return;
		    }

		    if (propTypes) {
		      // Intentionally inside to avoid triggering lazy initializers:
		      var name = getComponentName(type);
		      checkPropTypes(propTypes, element.props, 'prop', name, element);
		    } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
		      propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

		      var _name = getComponentName(type);

		      error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
		    }

		    if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
		      error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
		    }
		  }
		}
		/**
		 * Given a fragment, validate that it can only be provided with fragment props
		 * @param {ReactElement} fragment
		 */


		function validateFragmentProps(fragment) {
		  {
		    var keys = Object.keys(fragment.props);

		    for (var i = 0; i < keys.length; i++) {
		      var key = keys[i];

		      if (key !== 'children' && key !== 'key') {
		        setCurrentlyValidatingElement$1(fragment);

		        error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);

		        setCurrentlyValidatingElement$1(null);
		        break;
		      }
		    }

		    if (fragment.ref !== null) {
		      setCurrentlyValidatingElement$1(fragment);

		      error('Invalid attribute `ref` supplied to `React.Fragment`.');

		      setCurrentlyValidatingElement$1(null);
		    }
		  }
		}

		function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
		  {
		    var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
		    // succeed and there will likely be errors in render.

		    if (!validType) {
		      var info = '';

		      if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
		        info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
		      }

		      var sourceInfo = getSourceInfoErrorAddendum(source);

		      if (sourceInfo) {
		        info += sourceInfo;
		      } else {
		        info += getDeclarationErrorAddendum();
		      }

		      var typeString;

		      if (type === null) {
		        typeString = 'null';
		      } else if (Array.isArray(type)) {
		        typeString = 'array';
		      } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
		        typeString = "<" + (getComponentName(type.type) || 'Unknown') + " />";
		        info = ' Did you accidentally export a JSX literal instead of a component?';
		      } else {
		        typeString = typeof type;
		      }

		      error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
		    }

		    var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
		    // TODO: Drop this when these are no longer allowed as the type argument.

		    if (element == null) {
		      return element;
		    } // Skip key warning if the type isn't valid since our key validation logic
		    // doesn't expect a non-string/function type and can throw confusing errors.
		    // We don't want exception behavior to differ between dev and prod.
		    // (Rendering will throw with a helpful message and as soon as the type is
		    // fixed, the key warnings will appear.)


		    if (validType) {
		      var children = props.children;

		      if (children !== undefined) {
		        if (isStaticChildren) {
		          if (Array.isArray(children)) {
		            for (var i = 0; i < children.length; i++) {
		              validateChildKeys(children[i], type);
		            }

		            if (Object.freeze) {
		              Object.freeze(children);
		            }
		          } else {
		            error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
		          }
		        } else {
		          validateChildKeys(children, type);
		        }
		      }
		    }

		    if (type === exports.Fragment) {
		      validateFragmentProps(element);
		    } else {
		      validatePropTypes(element);
		    }

		    return element;
		  }
		} // These two functions exist to still get child warnings in dev
		// even with the prod transform. This means that jsxDEV is purely
		// opt-in behavior for better messages but that we won't stop
		// giving you warnings if you use production apis.

		function jsxWithValidationStatic(type, props, key) {
		  {
		    return jsxWithValidation(type, props, key, true);
		  }
		}
		function jsxWithValidationDynamic(type, props, key) {
		  {
		    return jsxWithValidation(type, props, key, false);
		  }
		}

		var jsx =  jsxWithValidationDynamic ; // we may want to special case jsxs internally to take advantage of static children.
		// for now we can ship identical prod functions

		var jsxs =  jsxWithValidationStatic ;

		exports.jsx = jsx;
		exports.jsxs = jsxs;
		  })();
		} 
	} (reactJsxRuntime_development));
	return reactJsxRuntime_development;
}

if (process.env.NODE_ENV === 'production') {
  jsxRuntime.exports = requireReactJsxRuntime_production_min();
} else {
  jsxRuntime.exports = requireReactJsxRuntime_development();
}

var jsxRuntimeExports = jsxRuntime.exports;

var f=(e=>(e.SVG="svg",e.IMAGE="image",e.CANVAS="canvas",e))(f||{});function R({style:t,className:a,value:o,options:e,renderer:s="svg"}){let r=useRef(null),n=useCallback(p,[o,r.current,e]);switch(useEffect(()=>{n(r.current,o,e);},[n,o,e,s]),s){case"canvas":return jsxRuntimeExports.jsx("canvas",{ref:r,style:t,className:a});case"image":return jsxRuntimeExports.jsx("img",{ref:r,alt:"barcode",style:t,className:a});default:return jsxRuntimeExports.jsx("svg",{ref:r,style:t,className:a})}}

var lib = {};

var propTypes$2 = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
	reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
	reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;
	return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development.AsyncMode = AsyncMode;
	reactIs_development.ConcurrentMode = ConcurrentMode;
	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}

var hasRequiredReactIs;

function requireReactIs () {
	if (hasRequiredReactIs) return reactIs.exports;
	hasRequiredReactIs = 1;

	if (process.env.NODE_ENV === 'production') {
	  reactIs.exports = requireReactIs_production_min();
	} else {
	  reactIs.exports = requireReactIs_development();
	}
	return reactIs.exports;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}

var has$2;
var hasRequiredHas;

function requireHas () {
	if (hasRequiredHas) return has$2;
	hasRequiredHas = 1;
	has$2 = Function.call.bind(Object.prototype.hasOwnProperty);
	return has$2;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = requireHas();

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;

	var ReactIs = requireReactIs();
	var assign = requireObjectAssign();

	var ReactPropTypesSecret = requireReactPropTypesSecret();
	var has = requireHas();
	var checkPropTypes = requireCheckPropTypes();

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;

	var ReactPropTypesSecret = requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  }	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes$2.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes$2.exports = requireFactoryWithThrowingShims()();
}

var propTypesExports = propTypes$2.exports;

var ErrorCorrectLevel = {
	L : 1,
	M : 0,
	Q : 3,
	H : 2
};

var mode$1 = {
	MODE_NUMBER :		1 << 0,
	MODE_ALPHA_NUM : 	1 << 1,
	MODE_8BIT_BYTE : 	1 << 2,
	MODE_KANJI :		1 << 3
};

var mode = mode$1;

function QR8bitByte(data) {
	this.mode = mode.MODE_8BIT_BYTE;
	this.data = data;
}

QR8bitByte.prototype = {

	getLength : function(buffer) {
		return this.data.length;
	},
	
	write : function(buffer) {
		for (var i = 0; i < this.data.length; i++) {
			// not JIS ...
			buffer.put(this.data.charCodeAt(i), 8);
		}
	}
};

var _8BitByte = QR8bitByte;

// ErrorCorrectLevel
var ECL = ErrorCorrectLevel;

function QRRSBlock(totalCount, dataCount) {
	this.totalCount = totalCount;
	this.dataCount  = dataCount;
}

QRRSBlock.RS_BLOCK_TABLE = [

	// L
	// M
	// Q
	// H

	// 1
	[1, 26, 19],
	[1, 26, 16],
	[1, 26, 13],
	[1, 26, 9],
	
	// 2
	[1, 44, 34],
	[1, 44, 28],
	[1, 44, 22],
	[1, 44, 16],

	// 3
	[1, 70, 55],
	[1, 70, 44],
	[2, 35, 17],
	[2, 35, 13],

	// 4		
	[1, 100, 80],
	[2, 50, 32],
	[2, 50, 24],
	[4, 25, 9],
	
	// 5
	[1, 134, 108],
	[2, 67, 43],
	[2, 33, 15, 2, 34, 16],
	[2, 33, 11, 2, 34, 12],
	
	// 6
	[2, 86, 68],
	[4, 43, 27],
	[4, 43, 19],
	[4, 43, 15],
	
	// 7		
	[2, 98, 78],
	[4, 49, 31],
	[2, 32, 14, 4, 33, 15],
	[4, 39, 13, 1, 40, 14],
	
	// 8
	[2, 121, 97],
	[2, 60, 38, 2, 61, 39],
	[4, 40, 18, 2, 41, 19],
	[4, 40, 14, 2, 41, 15],
	
	// 9
	[2, 146, 116],
	[3, 58, 36, 2, 59, 37],
	[4, 36, 16, 4, 37, 17],
	[4, 36, 12, 4, 37, 13],
	
	// 10		
	[2, 86, 68, 2, 87, 69],
	[4, 69, 43, 1, 70, 44],
	[6, 43, 19, 2, 44, 20],
	[6, 43, 15, 2, 44, 16],

	// 11
	[4, 101, 81],
	[1, 80, 50, 4, 81, 51],
	[4, 50, 22, 4, 51, 23],
	[3, 36, 12, 8, 37, 13],

	// 12
	[2, 116, 92, 2, 117, 93],
	[6, 58, 36, 2, 59, 37],
	[4, 46, 20, 6, 47, 21],
	[7, 42, 14, 4, 43, 15],

	// 13
	[4, 133, 107],
	[8, 59, 37, 1, 60, 38],
	[8, 44, 20, 4, 45, 21],
	[12, 33, 11, 4, 34, 12],

	// 14
	[3, 145, 115, 1, 146, 116],
	[4, 64, 40, 5, 65, 41],
	[11, 36, 16, 5, 37, 17],
	[11, 36, 12, 5, 37, 13],

	// 15
	[5, 109, 87, 1, 110, 88],
	[5, 65, 41, 5, 66, 42],
	[5, 54, 24, 7, 55, 25],
	[11, 36, 12],

	// 16
	[5, 122, 98, 1, 123, 99],
	[7, 73, 45, 3, 74, 46],
	[15, 43, 19, 2, 44, 20],
	[3, 45, 15, 13, 46, 16],

	// 17
	[1, 135, 107, 5, 136, 108],
	[10, 74, 46, 1, 75, 47],
	[1, 50, 22, 15, 51, 23],
	[2, 42, 14, 17, 43, 15],

	// 18
	[5, 150, 120, 1, 151, 121],
	[9, 69, 43, 4, 70, 44],
	[17, 50, 22, 1, 51, 23],
	[2, 42, 14, 19, 43, 15],

	// 19
	[3, 141, 113, 4, 142, 114],
	[3, 70, 44, 11, 71, 45],
	[17, 47, 21, 4, 48, 22],
	[9, 39, 13, 16, 40, 14],

	// 20
	[3, 135, 107, 5, 136, 108],
	[3, 67, 41, 13, 68, 42],
	[15, 54, 24, 5, 55, 25],
	[15, 43, 15, 10, 44, 16],

	// 21
	[4, 144, 116, 4, 145, 117],
	[17, 68, 42],
	[17, 50, 22, 6, 51, 23],
	[19, 46, 16, 6, 47, 17],

	// 22
	[2, 139, 111, 7, 140, 112],
	[17, 74, 46],
	[7, 54, 24, 16, 55, 25],
	[34, 37, 13],

	// 23
	[4, 151, 121, 5, 152, 122],
	[4, 75, 47, 14, 76, 48],
	[11, 54, 24, 14, 55, 25],
	[16, 45, 15, 14, 46, 16],

	// 24
	[6, 147, 117, 4, 148, 118],
	[6, 73, 45, 14, 74, 46],
	[11, 54, 24, 16, 55, 25],
	[30, 46, 16, 2, 47, 17],

	// 25
	[8, 132, 106, 4, 133, 107],
	[8, 75, 47, 13, 76, 48],
	[7, 54, 24, 22, 55, 25],
	[22, 45, 15, 13, 46, 16],

	// 26
	[10, 142, 114, 2, 143, 115],
	[19, 74, 46, 4, 75, 47],
	[28, 50, 22, 6, 51, 23],
	[33, 46, 16, 4, 47, 17],

	// 27
	[8, 152, 122, 4, 153, 123],
	[22, 73, 45, 3, 74, 46],
	[8, 53, 23, 26, 54, 24],
	[12, 45, 15, 28, 46, 16],

	// 28
	[3, 147, 117, 10, 148, 118],
	[3, 73, 45, 23, 74, 46],
	[4, 54, 24, 31, 55, 25],
	[11, 45, 15, 31, 46, 16],

	// 29
	[7, 146, 116, 7, 147, 117],
	[21, 73, 45, 7, 74, 46],
	[1, 53, 23, 37, 54, 24],
	[19, 45, 15, 26, 46, 16],

	// 30
	[5, 145, 115, 10, 146, 116],
	[19, 75, 47, 10, 76, 48],
	[15, 54, 24, 25, 55, 25],
	[23, 45, 15, 25, 46, 16],

	// 31
	[13, 145, 115, 3, 146, 116],
	[2, 74, 46, 29, 75, 47],
	[42, 54, 24, 1, 55, 25],
	[23, 45, 15, 28, 46, 16],

	// 32
	[17, 145, 115],
	[10, 74, 46, 23, 75, 47],
	[10, 54, 24, 35, 55, 25],
	[19, 45, 15, 35, 46, 16],

	// 33
	[17, 145, 115, 1, 146, 116],
	[14, 74, 46, 21, 75, 47],
	[29, 54, 24, 19, 55, 25],
	[11, 45, 15, 46, 46, 16],

	// 34
	[13, 145, 115, 6, 146, 116],
	[14, 74, 46, 23, 75, 47],
	[44, 54, 24, 7, 55, 25],
	[59, 46, 16, 1, 47, 17],

	// 35
	[12, 151, 121, 7, 152, 122],
	[12, 75, 47, 26, 76, 48],
	[39, 54, 24, 14, 55, 25],
	[22, 45, 15, 41, 46, 16],

	// 36
	[6, 151, 121, 14, 152, 122],
	[6, 75, 47, 34, 76, 48],
	[46, 54, 24, 10, 55, 25],
	[2, 45, 15, 64, 46, 16],

	// 37
	[17, 152, 122, 4, 153, 123],
	[29, 74, 46, 14, 75, 47],
	[49, 54, 24, 10, 55, 25],
	[24, 45, 15, 46, 46, 16],

	// 38
	[4, 152, 122, 18, 153, 123],
	[13, 74, 46, 32, 75, 47],
	[48, 54, 24, 14, 55, 25],
	[42, 45, 15, 32, 46, 16],

	// 39
	[20, 147, 117, 4, 148, 118],
	[40, 75, 47, 7, 76, 48],
	[43, 54, 24, 22, 55, 25],
	[10, 45, 15, 67, 46, 16],

	// 40
	[19, 148, 118, 6, 149, 119],
	[18, 75, 47, 31, 76, 48],
	[34, 54, 24, 34, 55, 25],
	[20, 45, 15, 61, 46, 16]
];

QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
	
	var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
	
	if (rsBlock == undefined) {
		throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
	}

	var length = rsBlock.length / 3;
	
	var list = new Array();
	
	for (var i = 0; i < length; i++) {

		var count = rsBlock[i * 3 + 0];
		var totalCount = rsBlock[i * 3 + 1];
		var dataCount  = rsBlock[i * 3 + 2];

		for (var j = 0; j < count; j++) {
			list.push(new QRRSBlock(totalCount, dataCount) );	
		}
	}
	
	return list;
};

QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {

	switch(errorCorrectLevel) {
	case ECL.L :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
	case ECL.M :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
	case ECL.Q :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
	case ECL.H :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
	default :
		return undefined;
	}
};

var RSBlock$1 = QRRSBlock;

function QRBitBuffer() {
	this.buffer = new Array();
	this.length = 0;
}

QRBitBuffer.prototype = {

	get : function(index) {
		var bufIndex = Math.floor(index / 8);
		return ( (this.buffer[bufIndex] >>> (7 - index % 8) ) & 1) == 1;
	},
	
	put : function(num, length) {
		for (var i = 0; i < length; i++) {
			this.putBit( ( (num >>> (length - i - 1) ) & 1) == 1);
		}
	},
	
	getLengthInBits : function() {
		return this.length;
	},
	
	putBit : function(bit) {
	
		var bufIndex = Math.floor(this.length / 8);
		if (this.buffer.length <= bufIndex) {
			this.buffer.push(0);
		}
	
		if (bit) {
			this.buffer[bufIndex] |= (0x80 >>> (this.length % 8) );
		}
	
		this.length++;
	}
};

var BitBuffer$1 = QRBitBuffer;

var QRMath = {

	glog : function(n) {
	
		if (n < 1) {
			throw new Error("glog(" + n + ")");
		}
		
		return QRMath.LOG_TABLE[n];
	},
	
	gexp : function(n) {
	
		while (n < 0) {
			n += 255;
		}
	
		while (n >= 256) {
			n -= 255;
		}
	
		return QRMath.EXP_TABLE[n];
	},
	
	EXP_TABLE : new Array(256),
	
	LOG_TABLE : new Array(256)

};
	
for (var i = 0; i < 8; i++) {
	QRMath.EXP_TABLE[i] = 1 << i;
}
for (var i = 8; i < 256; i++) {
	QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4]
		^ QRMath.EXP_TABLE[i - 5]
		^ QRMath.EXP_TABLE[i - 6]
		^ QRMath.EXP_TABLE[i - 8];
}
for (var i = 0; i < 255; i++) {
	QRMath.LOG_TABLE[QRMath.EXP_TABLE[i] ] = i;
}

var math$2 = QRMath;

var math$1 = math$2;

function QRPolynomial(num, shift) {

	if (num.length == undefined) {
		throw new Error(num.length + "/" + shift);
	}

	var offset = 0;

	while (offset < num.length && num[offset] == 0) {
		offset++;
	}

	this.num = new Array(num.length - offset + shift);
	for (var i = 0; i < num.length - offset; i++) {
		this.num[i] = num[i + offset];
	}
}

QRPolynomial.prototype = {

	get : function(index) {
		return this.num[index];
	},
	
	getLength : function() {
		return this.num.length;
	},
	
	multiply : function(e) {
	
		var num = new Array(this.getLength() + e.getLength() - 1);
	
		for (var i = 0; i < this.getLength(); i++) {
			for (var j = 0; j < e.getLength(); j++) {
				num[i + j] ^= math$1.gexp(math$1.glog(this.get(i) ) + math$1.glog(e.get(j) ) );
			}
		}
	
		return new QRPolynomial(num, 0);
	},
	
	mod : function(e) {
	
		if (this.getLength() - e.getLength() < 0) {
			return this;
		}
	
		var ratio = math$1.glog(this.get(0) ) - math$1.glog(e.get(0) );
	
		var num = new Array(this.getLength() );
		
		for (var i = 0; i < this.getLength(); i++) {
			num[i] = this.get(i);
		}
		
		for (var i = 0; i < e.getLength(); i++) {
			num[i] ^= math$1.gexp(math$1.glog(e.get(i) ) + ratio);
		}
	
		// recursive call
		return new QRPolynomial(num, 0).mod(e);
	}
};

var Polynomial$2 = QRPolynomial;

var Mode = mode$1;
var Polynomial$1 = Polynomial$2;
var math = math$2;

var QRMaskPattern = {
	PATTERN000 : 0,
	PATTERN001 : 1,
	PATTERN010 : 2,
	PATTERN011 : 3,
	PATTERN100 : 4,
	PATTERN101 : 5,
	PATTERN110 : 6,
	PATTERN111 : 7
};

var QRUtil = {

    PATTERN_POSITION_TABLE : [
	    [],
	    [6, 18],
	    [6, 22],
	    [6, 26],
	    [6, 30],
	    [6, 34],
	    [6, 22, 38],
	    [6, 24, 42],
	    [6, 26, 46],
	    [6, 28, 50],
	    [6, 30, 54],		
	    [6, 32, 58],
	    [6, 34, 62],
	    [6, 26, 46, 66],
	    [6, 26, 48, 70],
	    [6, 26, 50, 74],
	    [6, 30, 54, 78],
	    [6, 30, 56, 82],
	    [6, 30, 58, 86],
	    [6, 34, 62, 90],
	    [6, 28, 50, 72, 94],
	    [6, 26, 50, 74, 98],
	    [6, 30, 54, 78, 102],
	    [6, 28, 54, 80, 106],
	    [6, 32, 58, 84, 110],
	    [6, 30, 58, 86, 114],
	    [6, 34, 62, 90, 118],
	    [6, 26, 50, 74, 98, 122],
	    [6, 30, 54, 78, 102, 126],
	    [6, 26, 52, 78, 104, 130],
	    [6, 30, 56, 82, 108, 134],
	    [6, 34, 60, 86, 112, 138],
	    [6, 30, 58, 86, 114, 142],
	    [6, 34, 62, 90, 118, 146],
	    [6, 30, 54, 78, 102, 126, 150],
	    [6, 24, 50, 76, 102, 128, 154],
	    [6, 28, 54, 80, 106, 132, 158],
	    [6, 32, 58, 84, 110, 136, 162],
	    [6, 26, 54, 82, 110, 138, 166],
	    [6, 30, 58, 86, 114, 142, 170]
    ],

    G15 : (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0),
    G18 : (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0),
    G15_MASK : (1 << 14) | (1 << 12) | (1 << 10)	| (1 << 4) | (1 << 1),

    getBCHTypeInfo : function(data) {
	    var d = data << 10;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
		    d ^= (QRUtil.G15 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) ) ); 	
	    }
	    return ( (data << 10) | d) ^ QRUtil.G15_MASK;
    },

    getBCHTypeNumber : function(data) {
	    var d = data << 12;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
		    d ^= (QRUtil.G18 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) ) ); 	
	    }
	    return (data << 12) | d;
    },

    getBCHDigit : function(data) {

	    var digit = 0;

	    while (data != 0) {
		    digit++;
		    data >>>= 1;
	    }

	    return digit;
    },

    getPatternPosition : function(typeNumber) {
	    return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
    },

    getMask : function(maskPattern, i, j) {
	    
	    switch (maskPattern) {
		    
	    case QRMaskPattern.PATTERN000 : return (i + j) % 2 == 0;
	    case QRMaskPattern.PATTERN001 : return i % 2 == 0;
	    case QRMaskPattern.PATTERN010 : return j % 3 == 0;
	    case QRMaskPattern.PATTERN011 : return (i + j) % 3 == 0;
	    case QRMaskPattern.PATTERN100 : return (Math.floor(i / 2) + Math.floor(j / 3) ) % 2 == 0;
	    case QRMaskPattern.PATTERN101 : return (i * j) % 2 + (i * j) % 3 == 0;
	    case QRMaskPattern.PATTERN110 : return ( (i * j) % 2 + (i * j) % 3) % 2 == 0;
	    case QRMaskPattern.PATTERN111 : return ( (i * j) % 3 + (i + j) % 2) % 2 == 0;

	    default :
		    throw new Error("bad maskPattern:" + maskPattern);
	    }
    },

    getErrorCorrectPolynomial : function(errorCorrectLength) {

	    var a = new Polynomial$1([1], 0);

	    for (var i = 0; i < errorCorrectLength; i++) {
		    a = a.multiply(new Polynomial$1([1, math.gexp(i)], 0) );
	    }

	    return a;
    },

    getLengthInBits : function(mode, type) {

	    if (1 <= type && type < 10) {

		    // 1 - 9

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 10;
		    case Mode.MODE_ALPHA_NUM 	: return 9;
		    case Mode.MODE_8BIT_BYTE	: return 8;
		    case Mode.MODE_KANJI  	: return 8;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else if (type < 27) {

		    // 10 - 26

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 12;
		    case Mode.MODE_ALPHA_NUM 	: return 11;
		    case Mode.MODE_8BIT_BYTE	: return 16;
		    case Mode.MODE_KANJI  	: return 10;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else if (type < 41) {

		    // 27 - 40

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 14;
		    case Mode.MODE_ALPHA_NUM	: return 13;
		    case Mode.MODE_8BIT_BYTE	: return 16;
		    case Mode.MODE_KANJI  	: return 12;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else {
		    throw new Error("type:" + type);
	    }
    },

    getLostPoint : function(qrCode) {
	    
	    var moduleCount = qrCode.getModuleCount();
	    
	    var lostPoint = 0;
	    
	    // LEVEL1
	    
	    for (var row = 0; row < moduleCount; row++) {

		    for (var col = 0; col < moduleCount; col++) {

			    var sameCount = 0;
			    var dark = qrCode.isDark(row, col);

				for (var r = -1; r <= 1; r++) {

				    if (row + r < 0 || moduleCount <= row + r) {
					    continue;
				    }

				    for (var c = -1; c <= 1; c++) {

					    if (col + c < 0 || moduleCount <= col + c) {
						    continue;
					    }

					    if (r == 0 && c == 0) {
						    continue;
					    }

					    if (dark == qrCode.isDark(row + r, col + c) ) {
						    sameCount++;
					    }
				    }
			    }

			    if (sameCount > 5) {
				    lostPoint += (3 + sameCount - 5);
			    }
		    }
	    }

	    // LEVEL2

	    for (var row = 0; row < moduleCount - 1; row++) {
		    for (var col = 0; col < moduleCount - 1; col++) {
			    var count = 0;
			    if (qrCode.isDark(row,     col    ) ) count++;
			    if (qrCode.isDark(row + 1, col    ) ) count++;
			    if (qrCode.isDark(row,     col + 1) ) count++;
			    if (qrCode.isDark(row + 1, col + 1) ) count++;
			    if (count == 0 || count == 4) {
				    lostPoint += 3;
			    }
		    }
	    }

	    // LEVEL3

	    for (var row = 0; row < moduleCount; row++) {
		    for (var col = 0; col < moduleCount - 6; col++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row, col + 1)
					    &&  qrCode.isDark(row, col + 2)
					    &&  qrCode.isDark(row, col + 3)
					    &&  qrCode.isDark(row, col + 4)
					    && !qrCode.isDark(row, col + 5)
					    &&  qrCode.isDark(row, col + 6) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount - 6; row++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row + 1, col)
					    &&  qrCode.isDark(row + 2, col)
					    &&  qrCode.isDark(row + 3, col)
					    &&  qrCode.isDark(row + 4, col)
					    && !qrCode.isDark(row + 5, col)
					    &&  qrCode.isDark(row + 6, col) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    // LEVEL4
	    
	    var darkCount = 0;

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount; row++) {
			    if (qrCode.isDark(row, col) ) {
				    darkCount++;
			    }
		    }
	    }
	    
	    var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
	    lostPoint += ratio * 10;

	    return lostPoint;		
    }
};

var util$1 = QRUtil;

var BitByte = _8BitByte;
var RSBlock = RSBlock$1;
var BitBuffer = BitBuffer$1;
var util = util$1;
var Polynomial = Polynomial$2;

function QRCode$1(typeNumber, errorCorrectLevel) {
	this.typeNumber = typeNumber;
	this.errorCorrectLevel = errorCorrectLevel;
	this.modules = null;
	this.moduleCount = 0;
	this.dataCache = null;
	this.dataList = [];
}

// for client side minification
var proto = QRCode$1.prototype;

proto.addData = function(data) {
	var newData = new BitByte(data);
	this.dataList.push(newData);
	this.dataCache = null;
};

proto.isDark = function(row, col) {
	if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
		throw new Error(row + "," + col);
	}
	return this.modules[row][col];
};

proto.getModuleCount = function() {
	return this.moduleCount;
};

proto.make = function() {
	// Calculate automatically typeNumber if provided is < 1
	if (this.typeNumber < 1 ){
		var typeNumber = 1;
		for (typeNumber = 1; typeNumber < 40; typeNumber++) {
			var rsBlocks = RSBlock.getRSBlocks(typeNumber, this.errorCorrectLevel);

			var buffer = new BitBuffer();
			var totalDataCount = 0;
			for (var i = 0; i < rsBlocks.length; i++) {
				totalDataCount += rsBlocks[i].dataCount;
			}

			for (var i = 0; i < this.dataList.length; i++) {
				var data = this.dataList[i];
				buffer.put(data.mode, 4);
				buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
				data.write(buffer);
			}
			if (buffer.getLengthInBits() <= totalDataCount * 8)
				break;
		}
		this.typeNumber = typeNumber;
	}
	this.makeImpl(false, this.getBestMaskPattern() );
};

proto.makeImpl = function(test, maskPattern) {
	
	this.moduleCount = this.typeNumber * 4 + 17;
	this.modules = new Array(this.moduleCount);
	
	for (var row = 0; row < this.moduleCount; row++) {
		
		this.modules[row] = new Array(this.moduleCount);
		
		for (var col = 0; col < this.moduleCount; col++) {
			this.modules[row][col] = null;//(col + row) % 3;
		}
	}

	this.setupPositionProbePattern(0, 0);
	this.setupPositionProbePattern(this.moduleCount - 7, 0);
	this.setupPositionProbePattern(0, this.moduleCount - 7);
	this.setupPositionAdjustPattern();
	this.setupTimingPattern();
	this.setupTypeInfo(test, maskPattern);
	
	if (this.typeNumber >= 7) {
		this.setupTypeNumber(test);
	}

	if (this.dataCache == null) {
		this.dataCache = QRCode$1.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
	}

	this.mapData(this.dataCache, maskPattern);
};

proto.setupPositionProbePattern = function(row, col)  {
	
	for (var r = -1; r <= 7; r++) {
		
		if (row + r <= -1 || this.moduleCount <= row + r) continue;
		
		for (var c = -1; c <= 7; c++) {
			
			if (col + c <= -1 || this.moduleCount <= col + c) continue;
			
			if ( (0 <= r && r <= 6 && (c == 0 || c == 6) )
					|| (0 <= c && c <= 6 && (r == 0 || r == 6) )
					|| (2 <= r && r <= 4 && 2 <= c && c <= 4) ) {
				this.modules[row + r][col + c] = true;
			} else {
				this.modules[row + r][col + c] = false;
			}
		}		
	}		
};

proto.getBestMaskPattern = function() {

	var minLostPoint = 0;
	var pattern = 0;

	for (var i = 0; i < 8; i++) {
		
		this.makeImpl(true, i);

		var lostPoint = util.getLostPoint(this);

		if (i == 0 || minLostPoint >  lostPoint) {
			minLostPoint = lostPoint;
			pattern = i;
		}
	}

	return pattern;
};

proto.createMovieClip = function(target_mc, instance_name, depth) {

	var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
	var cs = 1;

	this.make();

	for (var row = 0; row < this.modules.length; row++) {
		
		var y = row * cs;
		
		for (var col = 0; col < this.modules[row].length; col++) {

			var x = col * cs;
			var dark = this.modules[row][col];
		
			if (dark) {
				qr_mc.beginFill(0, 100);
				qr_mc.moveTo(x, y);
				qr_mc.lineTo(x + cs, y);
				qr_mc.lineTo(x + cs, y + cs);
				qr_mc.lineTo(x, y + cs);
				qr_mc.endFill();
			}
		}
	}
	
	return qr_mc;
};

proto.setupTimingPattern = function() {
	
	for (var r = 8; r < this.moduleCount - 8; r++) {
		if (this.modules[r][6] != null) {
			continue;
		}
		this.modules[r][6] = (r % 2 == 0);
	}

	for (var c = 8; c < this.moduleCount - 8; c++) {
		if (this.modules[6][c] != null) {
			continue;
		}
		this.modules[6][c] = (c % 2 == 0);
	}
};

proto.setupPositionAdjustPattern = function() {

	var pos = util.getPatternPosition(this.typeNumber);
	
	for (var i = 0; i < pos.length; i++) {
	
		for (var j = 0; j < pos.length; j++) {
		
			var row = pos[i];
			var col = pos[j];
			
			if (this.modules[row][col] != null) {
				continue;
			}
			
			for (var r = -2; r <= 2; r++) {
			
				for (var c = -2; c <= 2; c++) {
				
					if (r == -2 || r == 2 || c == -2 || c == 2
							|| (r == 0 && c == 0) ) {
						this.modules[row + r][col + c] = true;
					} else {
						this.modules[row + r][col + c] = false;
					}
				}
			}
		}
	}
};

proto.setupTypeNumber = function(test) {

	var bits = util.getBCHTypeNumber(this.typeNumber);

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
	}

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
	}
};

proto.setupTypeInfo = function(test, maskPattern) {

	var data = (this.errorCorrectLevel << 3) | maskPattern;
	var bits = util.getBCHTypeInfo(data);

	// vertical		
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);

		if (i < 6) {
			this.modules[i][8] = mod;
		} else if (i < 8) {
			this.modules[i + 1][8] = mod;
		} else {
			this.modules[this.moduleCount - 15 + i][8] = mod;
		}
	}

	// horizontal
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);
		
		if (i < 8) {
			this.modules[8][this.moduleCount - i - 1] = mod;
		} else if (i < 9) {
			this.modules[8][15 - i - 1 + 1] = mod;
		} else {
			this.modules[8][15 - i - 1] = mod;
		}
	}

	// fixed module
	this.modules[this.moduleCount - 8][8] = (!test);
};

proto.mapData = function(data, maskPattern) {
	
	var inc = -1;
	var row = this.moduleCount - 1;
	var bitIndex = 7;
	var byteIndex = 0;
	
	for (var col = this.moduleCount - 1; col > 0; col -= 2) {

		if (col == 6) col--;

		while (true) {

			for (var c = 0; c < 2; c++) {
				
				if (this.modules[row][col - c] == null) {
					
					var dark = false;

					if (byteIndex < data.length) {
						dark = ( ( (data[byteIndex] >>> bitIndex) & 1) == 1);
					}

					var mask = util.getMask(maskPattern, row, col - c);

					if (mask) {
						dark = !dark;
					}
					
					this.modules[row][col - c] = dark;
					bitIndex--;

					if (bitIndex == -1) {
						byteIndex++;
						bitIndex = 7;
					}
				}
			}
							
			row += inc;

			if (row < 0 || this.moduleCount <= row) {
				row -= inc;
				inc = -inc;
				break;
			}
		}
	}
};

QRCode$1.PAD0 = 0xEC;
QRCode$1.PAD1 = 0x11;

QRCode$1.createData = function(typeNumber, errorCorrectLevel, dataList) {
	
	var rsBlocks = RSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
	
	var buffer = new BitBuffer();
	
	for (var i = 0; i < dataList.length; i++) {
		var data = dataList[i];
		buffer.put(data.mode, 4);
		buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
		data.write(buffer);
	}

	// calc num max data.
	var totalDataCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalDataCount += rsBlocks[i].dataCount;
	}

	if (buffer.getLengthInBits() > totalDataCount * 8) {
		throw new Error("code length overflow. ("
			+ buffer.getLengthInBits()
			+ ">"
			+  totalDataCount * 8
			+ ")");
	}

	// end code
	if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
		buffer.put(0, 4);
	}

	// padding
	while (buffer.getLengthInBits() % 8 != 0) {
		buffer.putBit(false);
	}

	// padding
	while (true) {
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode$1.PAD0, 8);
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode$1.PAD1, 8);
	}

	return QRCode$1.createBytes(buffer, rsBlocks);
};

QRCode$1.createBytes = function(buffer, rsBlocks) {

	var offset = 0;
	
	var maxDcCount = 0;
	var maxEcCount = 0;
	
	var dcdata = new Array(rsBlocks.length);
	var ecdata = new Array(rsBlocks.length);
	
	for (var r = 0; r < rsBlocks.length; r++) {

		var dcCount = rsBlocks[r].dataCount;
		var ecCount = rsBlocks[r].totalCount - dcCount;

		maxDcCount = Math.max(maxDcCount, dcCount);
		maxEcCount = Math.max(maxEcCount, ecCount);
		
		dcdata[r] = new Array(dcCount);
		
		for (var i = 0; i < dcdata[r].length; i++) {
			dcdata[r][i] = 0xff & buffer.buffer[i + offset];
		}
		offset += dcCount;
		
		var rsPoly = util.getErrorCorrectPolynomial(ecCount);
		var rawPoly = new Polynomial(dcdata[r], rsPoly.getLength() - 1);

		var modPoly = rawPoly.mod(rsPoly);
		ecdata[r] = new Array(rsPoly.getLength() - 1);
		for (var i = 0; i < ecdata[r].length; i++) {
            var modIndex = i + modPoly.getLength() - ecdata[r].length;
			ecdata[r][i] = (modIndex >= 0)? modPoly.get(modIndex) : 0;
		}

	}
	
	var totalCodeCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalCodeCount += rsBlocks[i].totalCount;
	}

	var data = new Array(totalCodeCount);
	var index = 0;

	for (var i = 0; i < maxDcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < dcdata[r].length) {
				data[index++] = dcdata[r][i];
			}
		}
	}

	for (var i = 0; i < maxEcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < ecdata[r].length) {
				data[index++] = ecdata[r][i];
			}
		}
	}

	return data;
};

var QRCode_1 = QRCode$1;

var QRCodeSvg$1 = {};

Object.defineProperty(QRCodeSvg$1, "__esModule", {
  value: true
});

var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes$1 = propTypesExports;

var _propTypes2$1 = _interopRequireDefault$1(_propTypes$1);

var _react$1 = React__default;

var _react2$1 = _interopRequireDefault$1(_react$1);

function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties$2(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes$1 = {
  bgColor: _propTypes2$1.default.oneOfType([_propTypes2$1.default.object, _propTypes2$1.default.string]).isRequired,
  bgD: _propTypes2$1.default.string.isRequired,
  fgColor: _propTypes2$1.default.oneOfType([_propTypes2$1.default.object, _propTypes2$1.default.string]).isRequired,
  fgD: _propTypes2$1.default.string.isRequired,
  size: _propTypes2$1.default.number.isRequired,
  title: _propTypes2$1.default.string,
  viewBoxSize: _propTypes2$1.default.number.isRequired,
  xmlns: _propTypes2$1.default.string
};

var QRCodeSvg = (0, _react$1.forwardRef)(function (_ref, ref) {
  var bgColor = _ref.bgColor,
      bgD = _ref.bgD,
      fgD = _ref.fgD,
      fgColor = _ref.fgColor,
      size = _ref.size,
      title = _ref.title,
      viewBoxSize = _ref.viewBoxSize,
      _ref$xmlns = _ref.xmlns,
      xmlns = _ref$xmlns === undefined ? "http://www.w3.org/2000/svg" : _ref$xmlns,
      props = _objectWithoutProperties$2(_ref, ["bgColor", "bgD", "fgD", "fgColor", "size", "title", "viewBoxSize", "xmlns"]);

  return _react2$1.default.createElement(
    "svg",
    _extends$1({}, props, { height: size, ref: ref, viewBox: "0 0 " + viewBoxSize + " " + viewBoxSize, width: size, xmlns: xmlns }),
    title ? _react2$1.default.createElement(
      "title",
      null,
      title
    ) : null,
    _react2$1.default.createElement("path", { d: bgD, fill: bgColor }),
    _react2$1.default.createElement("path", { d: fgD, fill: fgColor })
  );
});

QRCodeSvg.displayName = "QRCodeSvg";
QRCodeSvg.propTypes = propTypes$1;

QRCodeSvg$1.default = QRCodeSvg;

Object.defineProperty(lib, "__esModule", {
  value: true
});
lib.QRCode = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = propTypesExports;

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ErrorCorrectLevel = ErrorCorrectLevel;

var _ErrorCorrectLevel2 = _interopRequireDefault(_ErrorCorrectLevel);

var _QRCode = QRCode_1;

var _QRCode2 = _interopRequireDefault(_QRCode);

var _react = React__default;

var _react2 = _interopRequireDefault(_react);

var _QRCodeSvg = QRCodeSvg$1;

var _QRCodeSvg2 = _interopRequireDefault(_QRCodeSvg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties$1(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
// A `qr.js` doesn't handle error level of zero (M) so we need to do it right, thus the deep require.


var propTypes = {
  bgColor: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  fgColor: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  level: _propTypes2.default.string,
  size: _propTypes2.default.number,
  value: _propTypes2.default.string.isRequired
};

var QRCode = (0, _react.forwardRef)(function (_ref, ref) {
  var _ref$bgColor = _ref.bgColor,
      bgColor = _ref$bgColor === undefined ? "#FFFFFF" : _ref$bgColor,
      _ref$fgColor = _ref.fgColor,
      fgColor = _ref$fgColor === undefined ? "#000000" : _ref$fgColor,
      _ref$level = _ref.level,
      level = _ref$level === undefined ? "L" : _ref$level,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 256 : _ref$size,
      value = _ref.value,
      props = _objectWithoutProperties$1(_ref, ["bgColor", "fgColor", "level", "size", "value"]);

  // Use type === -1 to automatically pick the best type.
  var qrcode = new _QRCode2.default(-1, _ErrorCorrectLevel2.default[level]);
  qrcode.addData(value);
  qrcode.make();
  var cells = qrcode.modules;
  return _react2.default.createElement(_QRCodeSvg2.default, _extends({}, props, {
    bgColor: bgColor,
    bgD: cells.map(function (row, rowIndex) {
      return row.map(function (cell, cellIndex) {
        return !cell ? "M " + cellIndex + " " + rowIndex + " l 1 0 0 1 -1 0 Z" : "";
      }).join(" ");
    }).join(" "),
    fgColor: fgColor,
    fgD: cells.map(function (row, rowIndex) {
      return row.map(function (cell, cellIndex) {
        return cell ? "M " + cellIndex + " " + rowIndex + " l 1 0 0 1 -1 0 Z" : "";
      }).join(" ");
    }).join(" "),
    ref: ref,
    size: size,
    viewBoxSize: cells.length
  }));
});

lib.QRCode = QRCode;
QRCode.displayName = "QRCode";
QRCode.propTypes = propTypes;

var _default = lib.default = QRCode;

var isClient$1 = function () {
    return typeof window !== 'undefined';
};

var QRCodeModal = function (_a) {
    var visible = _a.visible, onCancel = _a.onCancel, data = _a.data, code = _a.code, title = _a.title, color = _a.color;
    var isSamsungBrowser = useMemo(function () {
        var _a, _b;
        if (!isClient$1())
            return false;
        return (_b = (_a = navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) === null || _a === void 0 ? void 0 : _a.match) === null || _b === void 0 ? void 0 : _b.call(_a, /SamsungBrowser/i);
    }, []);
    return (React__default.createElement(MomosModal, { title: React__default.createElement("div", { className: "mt-4" }, title), open: visible, onCancel: onCancel },
        React__default.createElement(ScanWrap, null, data.scanType === 'barcode' ? React__default.createElement(R, { value: code }) : React__default.createElement(_default, { value: code, width: 160, height: 160 })),
        React__default.createElement(VoucherCode, { "$color": color },
            React__default.createElement("div", { className: "voucher-code-main" }, code)),
        React__default.createElement("div", { className: classNames({ hidden: !isSamsungBrowser }) }, "Note: QR code/barcode scanning may be affected in Dark mode on Samsung Internet Browser. Switch to light mode for a better experience.")));
};
var ScanWrap = defaultStyled.div(templateObject_1$w || (templateObject_1$w = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 30px 5px;\n  background: white;\n  svg {\n    width: 100%;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 30px 5px;\n  background: white;\n  svg {\n    width: 100%;\n  }\n"])));
var VoucherCode = defaultStyled.div(templateObject_2$q || (templateObject_2$q = __makeTemplateObject(["\n  padding: 0.5rem;\n  border-top: 1px solid var(--grey-light);\n  border-bottom: 1px solid var(--grey-light);\n\n  .voucher-code-title {\n    text-align: center !important;\n    color: var(--grey-dark);\n    font-size: 16px;\n    line-height: 24px;\n  }\n\n  .voucher-code-main {\n    text-align: center !important;\n    font-size: 24px;\n    font-weight: 700;\n    color: ", ";\n    letter-spacing: 0.2rem;\n  }\n"], ["\n  padding: 0.5rem;\n  border-top: 1px solid var(--grey-light);\n  border-bottom: 1px solid var(--grey-light);\n\n  .voucher-code-title {\n    text-align: center !important;\n    color: var(--grey-dark);\n    font-size: 16px;\n    line-height: 24px;\n  }\n\n  .voucher-code-main {\n    text-align: center !important;\n    font-size: 24px;\n    font-weight: 700;\n    color: ", ";\n    letter-spacing: 0.2rem;\n  }\n"])), function (_a) {
    var $color = _a.$color;
    return $color;
});
var templateObject_1$w, templateObject_2$q;

var toggleSelection = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' &&
    selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function(range) {
        selection.addRange(range);
      });
    }

    active &&
    active.focus();
  };
};

var deselectCurrent = toggleSelection;

var clipboardToIE11Formatting = {
  "text/plain": "Text",
  "text/html": "Url",
  "default": "Text"
};

var defaultMessage = "Copy to clipboard: #{key}, Enter";

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug,
    message,
    reselectPrevious,
    range,
    selection,
    mark,
    success = false;
  if (!options) {
    options = {};
  }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement("span");
    mark.textContent = text;
    // avoid screen readers from reading out loud the text
    mark.ariaHidden = "true";
    // reset user styles for span element
    mark.style.all = "unset";
    // prevents scrolling to the end of the page
    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)";
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = "pre";
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function(e) {
      e.stopPropagation();
      if (options.format) {
        e.preventDefault();
        if (typeof e.clipboardData === "undefined") { // IE 11
          debug && console.warn("unable to use e.clipboardData");
          debug && console.warn("trying IE specific stuff");
          window.clipboardData.clearData();
          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"];
          window.clipboardData.setData(format, text);
        } else { // all other browsers
          e.clipboardData.clearData();
          e.clipboardData.setData(options.format, text);
        }
      }
      if (options.onCopy) {
        e.preventDefault();
        options.onCopy(e.clipboardData);
      }
    });

    document.body.appendChild(mark);

    range.selectNodeContents(mark);
    selection.addRange(range);

    var successful = document.execCommand("copy");
    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }
    success = true;
  } catch (err) {
    debug && console.error("unable to copy using execCommand: ", err);
    debug && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(options.format || "text", text);
      options.onCopy && options.onCopy(window.clipboardData);
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using clipboardData: ", err);
      debug && console.error("falling back to prompt");
      message = format("message" in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

var copyToClipboard = copy;

var copy$1 = /*@__PURE__*/getDefaultExportFromCjs(copyToClipboard);

var lottie$1 = {exports: {}};

(function (module, exports) {
	(typeof navigator !== "undefined") && (function (global, factory) {
	  module.exports = factory() ;
	})(commonjsGlobal, (function () {
	  var svgNS = 'http://www.w3.org/2000/svg';
	  var locationHref = '';
	  var _useWebWorker = false;
	  var initialDefaultFrame = -999999;

	  var setWebWorker = function setWebWorker(flag) {
	    _useWebWorker = !!flag;
	  };

	  var getWebWorker = function getWebWorker() {
	    return _useWebWorker;
	  };

	  var setLocationHref = function setLocationHref(value) {
	    locationHref = value;
	  };

	  var getLocationHref = function getLocationHref() {
	    return locationHref;
	  };

	  function createTag(type) {
	    // return {appendChild:function(){},setAttribute:function(){},style:{}}
	    return document.createElement(type);
	  }

	  function extendPrototype(sources, destination) {
	    var i;
	    var len = sources.length;
	    var sourcePrototype;

	    for (i = 0; i < len; i += 1) {
	      sourcePrototype = sources[i].prototype;

	      for (var attr in sourcePrototype) {
	        if (Object.prototype.hasOwnProperty.call(sourcePrototype, attr)) destination.prototype[attr] = sourcePrototype[attr];
	      }
	    }
	  }

	  function getDescriptor(object, prop) {
	    return Object.getOwnPropertyDescriptor(object, prop);
	  }

	  function createProxyFunction(prototype) {
	    function ProxyFunction() {}

	    ProxyFunction.prototype = prototype;
	    return ProxyFunction;
	  }

	  // import Howl from '../../3rd_party/howler';
	  var audioControllerFactory = function () {
	    function AudioController(audioFactory) {
	      this.audios = [];
	      this.audioFactory = audioFactory;
	      this._volume = 1;
	      this._isMuted = false;
	    }

	    AudioController.prototype = {
	      addAudio: function addAudio(audio) {
	        this.audios.push(audio);
	      },
	      pause: function pause() {
	        var i;
	        var len = this.audios.length;

	        for (i = 0; i < len; i += 1) {
	          this.audios[i].pause();
	        }
	      },
	      resume: function resume() {
	        var i;
	        var len = this.audios.length;

	        for (i = 0; i < len; i += 1) {
	          this.audios[i].resume();
	        }
	      },
	      setRate: function setRate(rateValue) {
	        var i;
	        var len = this.audios.length;

	        for (i = 0; i < len; i += 1) {
	          this.audios[i].setRate(rateValue);
	        }
	      },
	      createAudio: function createAudio(assetPath) {
	        if (this.audioFactory) {
	          return this.audioFactory(assetPath);
	        }

	        if (window.Howl) {
	          return new window.Howl({
	            src: [assetPath]
	          });
	        }

	        return {
	          isPlaying: false,
	          play: function play() {
	            this.isPlaying = true;
	          },
	          seek: function seek() {
	            this.isPlaying = false;
	          },
	          playing: function playing() {},
	          rate: function rate() {},
	          setVolume: function setVolume() {}
	        };
	      },
	      setAudioFactory: function setAudioFactory(audioFactory) {
	        this.audioFactory = audioFactory;
	      },
	      setVolume: function setVolume(value) {
	        this._volume = value;

	        this._updateVolume();
	      },
	      mute: function mute() {
	        this._isMuted = true;

	        this._updateVolume();
	      },
	      unmute: function unmute() {
	        this._isMuted = false;

	        this._updateVolume();
	      },
	      getVolume: function getVolume() {
	        return this._volume;
	      },
	      _updateVolume: function _updateVolume() {
	        var i;
	        var len = this.audios.length;

	        for (i = 0; i < len; i += 1) {
	          this.audios[i].volume(this._volume * (this._isMuted ? 0 : 1));
	        }
	      }
	    };
	    return function () {
	      return new AudioController();
	    };
	  }();

	  var createTypedArray = function () {
	    function createRegularArray(type, len) {
	      var i = 0;
	      var arr = [];
	      var value;

	      switch (type) {
	        case 'int16':
	        case 'uint8c':
	          value = 1;
	          break;

	        default:
	          value = 1.1;
	          break;
	      }

	      for (i = 0; i < len; i += 1) {
	        arr.push(value);
	      }

	      return arr;
	    }

	    function createTypedArrayFactory(type, len) {
	      if (type === 'float32') {
	        return new Float32Array(len);
	      }

	      if (type === 'int16') {
	        return new Int16Array(len);
	      }

	      if (type === 'uint8c') {
	        return new Uint8ClampedArray(len);
	      }

	      return createRegularArray(type, len);
	    }

	    if (typeof Uint8ClampedArray === 'function' && typeof Float32Array === 'function') {
	      return createTypedArrayFactory;
	    }

	    return createRegularArray;
	  }();

	  function createSizedArray(len) {
	    return Array.apply(null, {
	      length: len
	    });
	  }

	  function _typeof$6(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$6 = function _typeof(obj) { return typeof obj; }; } else { _typeof$6 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$6(obj); }
	  var subframeEnabled = true;
	  var expressionsPlugin = null;
	  var expressionsInterfaces = null;
	  var idPrefix$1 = '';
	  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	  var bmPow = Math.pow;
	  var bmSqrt = Math.sqrt;
	  var bmFloor = Math.floor;
	  var bmMax = Math.max;
	  var bmMin = Math.min;
	  var BMMath = {};

	  (function () {
	    var propertyNames = ['abs', 'acos', 'acosh', 'asin', 'asinh', 'atan', 'atanh', 'atan2', 'ceil', 'cbrt', 'expm1', 'clz32', 'cos', 'cosh', 'exp', 'floor', 'fround', 'hypot', 'imul', 'log', 'log1p', 'log2', 'log10', 'max', 'min', 'pow', 'random', 'round', 'sign', 'sin', 'sinh', 'sqrt', 'tan', 'tanh', 'trunc', 'E', 'LN10', 'LN2', 'LOG10E', 'LOG2E', 'PI', 'SQRT1_2', 'SQRT2'];
	    var i;
	    var len = propertyNames.length;

	    for (i = 0; i < len; i += 1) {
	      BMMath[propertyNames[i]] = Math[propertyNames[i]];
	    }
	  })();

	  BMMath.random = Math.random;

	  BMMath.abs = function (val) {
	    var tOfVal = _typeof$6(val);

	    if (tOfVal === 'object' && val.length) {
	      var absArr = createSizedArray(val.length);
	      var i;
	      var len = val.length;

	      for (i = 0; i < len; i += 1) {
	        absArr[i] = Math.abs(val[i]);
	      }

	      return absArr;
	    }

	    return Math.abs(val);
	  };

	  var defaultCurveSegments = 150;
	  var degToRads = Math.PI / 180;
	  var roundCorner = 0.5519;

	  function styleDiv(element) {
	    element.style.position = 'absolute';
	    element.style.top = 0;
	    element.style.left = 0;
	    element.style.display = 'block';
	    element.style.transformOrigin = '0 0';
	    element.style.webkitTransformOrigin = '0 0';
	    element.style.backfaceVisibility = 'visible';
	    element.style.webkitBackfaceVisibility = 'visible';
	    element.style.transformStyle = 'preserve-3d';
	    element.style.webkitTransformStyle = 'preserve-3d';
	    element.style.mozTransformStyle = 'preserve-3d';
	  }

	  function BMEnterFrameEvent(type, currentTime, totalTime, frameMultiplier) {
	    this.type = type;
	    this.currentTime = currentTime;
	    this.totalTime = totalTime;
	    this.direction = frameMultiplier < 0 ? -1 : 1;
	  }

	  function BMCompleteEvent(type, frameMultiplier) {
	    this.type = type;
	    this.direction = frameMultiplier < 0 ? -1 : 1;
	  }

	  function BMCompleteLoopEvent(type, totalLoops, currentLoop, frameMultiplier) {
	    this.type = type;
	    this.currentLoop = currentLoop;
	    this.totalLoops = totalLoops;
	    this.direction = frameMultiplier < 0 ? -1 : 1;
	  }

	  function BMSegmentStartEvent(type, firstFrame, totalFrames) {
	    this.type = type;
	    this.firstFrame = firstFrame;
	    this.totalFrames = totalFrames;
	  }

	  function BMDestroyEvent(type, target) {
	    this.type = type;
	    this.target = target;
	  }

	  function BMRenderFrameErrorEvent(nativeError, currentTime) {
	    this.type = 'renderFrameError';
	    this.nativeError = nativeError;
	    this.currentTime = currentTime;
	  }

	  function BMConfigErrorEvent(nativeError) {
	    this.type = 'configError';
	    this.nativeError = nativeError;
	  }

	  var createElementID = function () {
	    var _count = 0;
	    return function createID() {
	      _count += 1;
	      return idPrefix$1 + '__lottie_element_' + _count;
	    };
	  }();

	  function HSVtoRGB(h, s, v) {
	    var r;
	    var g;
	    var b;
	    var i;
	    var f;
	    var p;
	    var q;
	    var t;
	    i = Math.floor(h * 6);
	    f = h * 6 - i;
	    p = v * (1 - s);
	    q = v * (1 - f * s);
	    t = v * (1 - (1 - f) * s);

	    switch (i % 6) {
	      case 0:
	        r = v;
	        g = t;
	        b = p;
	        break;

	      case 1:
	        r = q;
	        g = v;
	        b = p;
	        break;

	      case 2:
	        r = p;
	        g = v;
	        b = t;
	        break;

	      case 3:
	        r = p;
	        g = q;
	        b = v;
	        break;

	      case 4:
	        r = t;
	        g = p;
	        b = v;
	        break;

	      case 5:
	        r = v;
	        g = p;
	        b = q;
	        break;
	    }

	    return [r, g, b];
	  }

	  function RGBtoHSV(r, g, b) {
	    var max = Math.max(r, g, b);
	    var min = Math.min(r, g, b);
	    var d = max - min;
	    var h;
	    var s = max === 0 ? 0 : d / max;
	    var v = max / 255;

	    switch (max) {
	      case min:
	        h = 0;
	        break;

	      case r:
	        h = g - b + d * (g < b ? 6 : 0);
	        h /= 6 * d;
	        break;

	      case g:
	        h = b - r + d * 2;
	        h /= 6 * d;
	        break;

	      case b:
	        h = r - g + d * 4;
	        h /= 6 * d;
	        break;
	    }

	    return [h, s, v];
	  }

	  function addSaturationToRGB(color, offset) {
	    var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
	    hsv[1] += offset;

	    if (hsv[1] > 1) {
	      hsv[1] = 1;
	    } else if (hsv[1] <= 0) {
	      hsv[1] = 0;
	    }

	    return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
	  }

	  function addBrightnessToRGB(color, offset) {
	    var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
	    hsv[2] += offset;

	    if (hsv[2] > 1) {
	      hsv[2] = 1;
	    } else if (hsv[2] < 0) {
	      hsv[2] = 0;
	    }

	    return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
	  }

	  function addHueToRGB(color, offset) {
	    var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
	    hsv[0] += offset / 360;

	    if (hsv[0] > 1) {
	      hsv[0] -= 1;
	    } else if (hsv[0] < 0) {
	      hsv[0] += 1;
	    }

	    return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
	  }

	  var rgbToHex = function () {
	    var colorMap = [];
	    var i;
	    var hex;

	    for (i = 0; i < 256; i += 1) {
	      hex = i.toString(16);
	      colorMap[i] = hex.length === 1 ? '0' + hex : hex;
	    }

	    return function (r, g, b) {
	      if (r < 0) {
	        r = 0;
	      }

	      if (g < 0) {
	        g = 0;
	      }

	      if (b < 0) {
	        b = 0;
	      }

	      return '#' + colorMap[r] + colorMap[g] + colorMap[b];
	    };
	  }();

	  var setSubframeEnabled = function setSubframeEnabled(flag) {
	    subframeEnabled = !!flag;
	  };

	  var getSubframeEnabled = function getSubframeEnabled() {
	    return subframeEnabled;
	  };

	  var setExpressionsPlugin = function setExpressionsPlugin(value) {
	    expressionsPlugin = value;
	  };

	  var getExpressionsPlugin = function getExpressionsPlugin() {
	    return expressionsPlugin;
	  };

	  var setExpressionInterfaces = function setExpressionInterfaces(value) {
	    expressionsInterfaces = value;
	  };

	  var getExpressionInterfaces = function getExpressionInterfaces() {
	    return expressionsInterfaces;
	  };

	  var setDefaultCurveSegments = function setDefaultCurveSegments(value) {
	    defaultCurveSegments = value;
	  };

	  var getDefaultCurveSegments = function getDefaultCurveSegments() {
	    return defaultCurveSegments;
	  };

	  var setIdPrefix = function setIdPrefix(value) {
	    idPrefix$1 = value;
	  };

	  function createNS(type) {
	    // return {appendChild:function(){},setAttribute:function(){},style:{}}
	    return document.createElementNS(svgNS, type);
	  }

	  function _typeof$5(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$5 = function _typeof(obj) { return typeof obj; }; } else { _typeof$5 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$5(obj); }

	  var dataManager = function () {
	    var _counterId = 1;
	    var processes = [];
	    var workerFn;
	    var workerInstance;
	    var workerProxy = {
	      onmessage: function onmessage() {},
	      postMessage: function postMessage(path) {
	        workerFn({
	          data: path
	        });
	      }
	    };
	    var _workerSelf = {
	      postMessage: function postMessage(data) {
	        workerProxy.onmessage({
	          data: data
	        });
	      }
	    };

	    function createWorker(fn) {
	      if (window.Worker && window.Blob && getWebWorker()) {
	        var blob = new Blob(['var _workerSelf = self; self.onmessage = ', fn.toString()], {
	          type: 'text/javascript'
	        }); // var blob = new Blob(['self.onmessage = ', fn.toString()], { type: 'text/javascript' });

	        var url = URL.createObjectURL(blob);
	        return new Worker(url);
	      }

	      workerFn = fn;
	      return workerProxy;
	    }

	    function setupWorker() {
	      if (!workerInstance) {
	        workerInstance = createWorker(function workerStart(e) {
	          function dataFunctionManager() {
	            function completeLayers(layers, comps) {
	              var layerData;
	              var i;
	              var len = layers.length;
	              var j;
	              var jLen;
	              var k;
	              var kLen;

	              for (i = 0; i < len; i += 1) {
	                layerData = layers[i];

	                if ('ks' in layerData && !layerData.completed) {
	                  layerData.completed = true;

	                  if (layerData.hasMask) {
	                    var maskProps = layerData.masksProperties;
	                    jLen = maskProps.length;

	                    for (j = 0; j < jLen; j += 1) {
	                      if (maskProps[j].pt.k.i) {
	                        convertPathsToAbsoluteValues(maskProps[j].pt.k);
	                      } else {
	                        kLen = maskProps[j].pt.k.length;

	                        for (k = 0; k < kLen; k += 1) {
	                          if (maskProps[j].pt.k[k].s) {
	                            convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
	                          }

	                          if (maskProps[j].pt.k[k].e) {
	                            convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
	                          }
	                        }
	                      }
	                    }
	                  }

	                  if (layerData.ty === 0) {
	                    layerData.layers = findCompLayers(layerData.refId, comps);
	                    completeLayers(layerData.layers, comps);
	                  } else if (layerData.ty === 4) {
	                    completeShapes(layerData.shapes);
	                  } else if (layerData.ty === 5) {
	                    completeText(layerData);
	                  }
	                }
	              }
	            }

	            function completeChars(chars, assets) {
	              if (chars) {
	                var i = 0;
	                var len = chars.length;

	                for (i = 0; i < len; i += 1) {
	                  if (chars[i].t === 1) {
	                    // var compData = findComp(chars[i].data.refId, assets);
	                    chars[i].data.layers = findCompLayers(chars[i].data.refId, assets); // chars[i].data.ip = 0;
	                    // chars[i].data.op = 99999;
	                    // chars[i].data.st = 0;
	                    // chars[i].data.sr = 1;
	                    // chars[i].w = compData.w;
	                    // chars[i].data.ks = {
	                    //   a: { k: [0, 0, 0], a: 0 },
	                    //   p: { k: [0, -compData.h, 0], a: 0 },
	                    //   r: { k: 0, a: 0 },
	                    //   s: { k: [100, 100], a: 0 },
	                    //   o: { k: 100, a: 0 },
	                    // };

	                    completeLayers(chars[i].data.layers, assets);
	                  }
	                }
	              }
	            }

	            function findComp(id, comps) {
	              var i = 0;
	              var len = comps.length;

	              while (i < len) {
	                if (comps[i].id === id) {
	                  return comps[i];
	                }

	                i += 1;
	              }

	              return null;
	            }

	            function findCompLayers(id, comps) {
	              var comp = findComp(id, comps);

	              if (comp) {
	                if (!comp.layers.__used) {
	                  comp.layers.__used = true;
	                  return comp.layers;
	                }

	                return JSON.parse(JSON.stringify(comp.layers));
	              }

	              return null;
	            }

	            function completeShapes(arr) {
	              var i;
	              var len = arr.length;
	              var j;
	              var jLen;

	              for (i = len - 1; i >= 0; i -= 1) {
	                if (arr[i].ty === 'sh') {
	                  if (arr[i].ks.k.i) {
	                    convertPathsToAbsoluteValues(arr[i].ks.k);
	                  } else {
	                    jLen = arr[i].ks.k.length;

	                    for (j = 0; j < jLen; j += 1) {
	                      if (arr[i].ks.k[j].s) {
	                        convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
	                      }

	                      if (arr[i].ks.k[j].e) {
	                        convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
	                      }
	                    }
	                  }
	                } else if (arr[i].ty === 'gr') {
	                  completeShapes(arr[i].it);
	                }
	              }
	            }

	            function convertPathsToAbsoluteValues(path) {
	              var i;
	              var len = path.i.length;

	              for (i = 0; i < len; i += 1) {
	                path.i[i][0] += path.v[i][0];
	                path.i[i][1] += path.v[i][1];
	                path.o[i][0] += path.v[i][0];
	                path.o[i][1] += path.v[i][1];
	              }
	            }

	            function checkVersion(minimum, animVersionString) {
	              var animVersion = animVersionString ? animVersionString.split('.') : [100, 100, 100];

	              if (minimum[0] > animVersion[0]) {
	                return true;
	              }

	              if (animVersion[0] > minimum[0]) {
	                return false;
	              }

	              if (minimum[1] > animVersion[1]) {
	                return true;
	              }

	              if (animVersion[1] > minimum[1]) {
	                return false;
	              }

	              if (minimum[2] > animVersion[2]) {
	                return true;
	              }

	              if (animVersion[2] > minimum[2]) {
	                return false;
	              }

	              return null;
	            }

	            var checkText = function () {
	              var minimumVersion = [4, 4, 14];

	              function updateTextLayer(textLayer) {
	                var documentData = textLayer.t.d;
	                textLayer.t.d = {
	                  k: [{
	                    s: documentData,
	                    t: 0
	                  }]
	                };
	              }

	              function iterateLayers(layers) {
	                var i;
	                var len = layers.length;

	                for (i = 0; i < len; i += 1) {
	                  if (layers[i].ty === 5) {
	                    updateTextLayer(layers[i]);
	                  }
	                }
	              }

	              return function (animationData) {
	                if (checkVersion(minimumVersion, animationData.v)) {
	                  iterateLayers(animationData.layers);

	                  if (animationData.assets) {
	                    var i;
	                    var len = animationData.assets.length;

	                    for (i = 0; i < len; i += 1) {
	                      if (animationData.assets[i].layers) {
	                        iterateLayers(animationData.assets[i].layers);
	                      }
	                    }
	                  }
	                }
	              };
	            }();

	            var checkChars = function () {
	              var minimumVersion = [4, 7, 99];
	              return function (animationData) {
	                if (animationData.chars && !checkVersion(minimumVersion, animationData.v)) {
	                  var i;
	                  var len = animationData.chars.length;

	                  for (i = 0; i < len; i += 1) {
	                    var charData = animationData.chars[i];

	                    if (charData.data && charData.data.shapes) {
	                      completeShapes(charData.data.shapes);
	                      charData.data.ip = 0;
	                      charData.data.op = 99999;
	                      charData.data.st = 0;
	                      charData.data.sr = 1;
	                      charData.data.ks = {
	                        p: {
	                          k: [0, 0],
	                          a: 0
	                        },
	                        s: {
	                          k: [100, 100],
	                          a: 0
	                        },
	                        a: {
	                          k: [0, 0],
	                          a: 0
	                        },
	                        r: {
	                          k: 0,
	                          a: 0
	                        },
	                        o: {
	                          k: 100,
	                          a: 0
	                        }
	                      };

	                      if (!animationData.chars[i].t) {
	                        charData.data.shapes.push({
	                          ty: 'no'
	                        });
	                        charData.data.shapes[0].it.push({
	                          p: {
	                            k: [0, 0],
	                            a: 0
	                          },
	                          s: {
	                            k: [100, 100],
	                            a: 0
	                          },
	                          a: {
	                            k: [0, 0],
	                            a: 0
	                          },
	                          r: {
	                            k: 0,
	                            a: 0
	                          },
	                          o: {
	                            k: 100,
	                            a: 0
	                          },
	                          sk: {
	                            k: 0,
	                            a: 0
	                          },
	                          sa: {
	                            k: 0,
	                            a: 0
	                          },
	                          ty: 'tr'
	                        });
	                      }
	                    }
	                  }
	                }
	              };
	            }();

	            var checkPathProperties = function () {
	              var minimumVersion = [5, 7, 15];

	              function updateTextLayer(textLayer) {
	                var pathData = textLayer.t.p;

	                if (typeof pathData.a === 'number') {
	                  pathData.a = {
	                    a: 0,
	                    k: pathData.a
	                  };
	                }

	                if (typeof pathData.p === 'number') {
	                  pathData.p = {
	                    a: 0,
	                    k: pathData.p
	                  };
	                }

	                if (typeof pathData.r === 'number') {
	                  pathData.r = {
	                    a: 0,
	                    k: pathData.r
	                  };
	                }
	              }

	              function iterateLayers(layers) {
	                var i;
	                var len = layers.length;

	                for (i = 0; i < len; i += 1) {
	                  if (layers[i].ty === 5) {
	                    updateTextLayer(layers[i]);
	                  }
	                }
	              }

	              return function (animationData) {
	                if (checkVersion(minimumVersion, animationData.v)) {
	                  iterateLayers(animationData.layers);

	                  if (animationData.assets) {
	                    var i;
	                    var len = animationData.assets.length;

	                    for (i = 0; i < len; i += 1) {
	                      if (animationData.assets[i].layers) {
	                        iterateLayers(animationData.assets[i].layers);
	                      }
	                    }
	                  }
	                }
	              };
	            }();

	            var checkColors = function () {
	              var minimumVersion = [4, 1, 9];

	              function iterateShapes(shapes) {
	                var i;
	                var len = shapes.length;
	                var j;
	                var jLen;

	                for (i = 0; i < len; i += 1) {
	                  if (shapes[i].ty === 'gr') {
	                    iterateShapes(shapes[i].it);
	                  } else if (shapes[i].ty === 'fl' || shapes[i].ty === 'st') {
	                    if (shapes[i].c.k && shapes[i].c.k[0].i) {
	                      jLen = shapes[i].c.k.length;

	                      for (j = 0; j < jLen; j += 1) {
	                        if (shapes[i].c.k[j].s) {
	                          shapes[i].c.k[j].s[0] /= 255;
	                          shapes[i].c.k[j].s[1] /= 255;
	                          shapes[i].c.k[j].s[2] /= 255;
	                          shapes[i].c.k[j].s[3] /= 255;
	                        }

	                        if (shapes[i].c.k[j].e) {
	                          shapes[i].c.k[j].e[0] /= 255;
	                          shapes[i].c.k[j].e[1] /= 255;
	                          shapes[i].c.k[j].e[2] /= 255;
	                          shapes[i].c.k[j].e[3] /= 255;
	                        }
	                      }
	                    } else {
	                      shapes[i].c.k[0] /= 255;
	                      shapes[i].c.k[1] /= 255;
	                      shapes[i].c.k[2] /= 255;
	                      shapes[i].c.k[3] /= 255;
	                    }
	                  }
	                }
	              }

	              function iterateLayers(layers) {
	                var i;
	                var len = layers.length;

	                for (i = 0; i < len; i += 1) {
	                  if (layers[i].ty === 4) {
	                    iterateShapes(layers[i].shapes);
	                  }
	                }
	              }

	              return function (animationData) {
	                if (checkVersion(minimumVersion, animationData.v)) {
	                  iterateLayers(animationData.layers);

	                  if (animationData.assets) {
	                    var i;
	                    var len = animationData.assets.length;

	                    for (i = 0; i < len; i += 1) {
	                      if (animationData.assets[i].layers) {
	                        iterateLayers(animationData.assets[i].layers);
	                      }
	                    }
	                  }
	                }
	              };
	            }();

	            var checkShapes = function () {
	              var minimumVersion = [4, 4, 18];

	              function completeClosingShapes(arr) {
	                var i;
	                var len = arr.length;
	                var j;
	                var jLen;

	                for (i = len - 1; i >= 0; i -= 1) {
	                  if (arr[i].ty === 'sh') {
	                    if (arr[i].ks.k.i) {
	                      arr[i].ks.k.c = arr[i].closed;
	                    } else {
	                      jLen = arr[i].ks.k.length;

	                      for (j = 0; j < jLen; j += 1) {
	                        if (arr[i].ks.k[j].s) {
	                          arr[i].ks.k[j].s[0].c = arr[i].closed;
	                        }

	                        if (arr[i].ks.k[j].e) {
	                          arr[i].ks.k[j].e[0].c = arr[i].closed;
	                        }
	                      }
	                    }
	                  } else if (arr[i].ty === 'gr') {
	                    completeClosingShapes(arr[i].it);
	                  }
	                }
	              }

	              function iterateLayers(layers) {
	                var layerData;
	                var i;
	                var len = layers.length;
	                var j;
	                var jLen;
	                var k;
	                var kLen;

	                for (i = 0; i < len; i += 1) {
	                  layerData = layers[i];

	                  if (layerData.hasMask) {
	                    var maskProps = layerData.masksProperties;
	                    jLen = maskProps.length;

	                    for (j = 0; j < jLen; j += 1) {
	                      if (maskProps[j].pt.k.i) {
	                        maskProps[j].pt.k.c = maskProps[j].cl;
	                      } else {
	                        kLen = maskProps[j].pt.k.length;

	                        for (k = 0; k < kLen; k += 1) {
	                          if (maskProps[j].pt.k[k].s) {
	                            maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
	                          }

	                          if (maskProps[j].pt.k[k].e) {
	                            maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
	                          }
	                        }
	                      }
	                    }
	                  }

	                  if (layerData.ty === 4) {
	                    completeClosingShapes(layerData.shapes);
	                  }
	                }
	              }

	              return function (animationData) {
	                if (checkVersion(minimumVersion, animationData.v)) {
	                  iterateLayers(animationData.layers);

	                  if (animationData.assets) {
	                    var i;
	                    var len = animationData.assets.length;

	                    for (i = 0; i < len; i += 1) {
	                      if (animationData.assets[i].layers) {
	                        iterateLayers(animationData.assets[i].layers);
	                      }
	                    }
	                  }
	                }
	              };
	            }();

	            function completeData(animationData) {
	              if (animationData.__complete) {
	                return;
	              }

	              checkColors(animationData);
	              checkText(animationData);
	              checkChars(animationData);
	              checkPathProperties(animationData);
	              checkShapes(animationData);
	              completeLayers(animationData.layers, animationData.assets);
	              completeChars(animationData.chars, animationData.assets);
	              animationData.__complete = true;
	            }

	            function completeText(data) {
	              if (data.t.a.length === 0 && !('m' in data.t.p)) ;
	            }

	            var moduleOb = {};
	            moduleOb.completeData = completeData;
	            moduleOb.checkColors = checkColors;
	            moduleOb.checkChars = checkChars;
	            moduleOb.checkPathProperties = checkPathProperties;
	            moduleOb.checkShapes = checkShapes;
	            moduleOb.completeLayers = completeLayers;
	            return moduleOb;
	          }

	          if (!_workerSelf.dataManager) {
	            _workerSelf.dataManager = dataFunctionManager();
	          }

	          if (!_workerSelf.assetLoader) {
	            _workerSelf.assetLoader = function () {
	              function formatResponse(xhr) {
	                // using typeof doubles the time of execution of this method,
	                // so if available, it's better to use the header to validate the type
	                var contentTypeHeader = xhr.getResponseHeader('content-type');

	                if (contentTypeHeader && xhr.responseType === 'json' && contentTypeHeader.indexOf('json') !== -1) {
	                  return xhr.response;
	                }

	                if (xhr.response && _typeof$5(xhr.response) === 'object') {
	                  return xhr.response;
	                }

	                if (xhr.response && typeof xhr.response === 'string') {
	                  return JSON.parse(xhr.response);
	                }

	                if (xhr.responseText) {
	                  return JSON.parse(xhr.responseText);
	                }

	                return null;
	              }

	              function loadAsset(path, fullPath, callback, errorCallback) {
	                var response;
	                var xhr = new XMLHttpRequest(); // set responseType after calling open or IE will break.

	                try {
	                  // This crashes on Android WebView prior to KitKat
	                  xhr.responseType = 'json';
	                } catch (err) {} // eslint-disable-line no-empty


	                xhr.onreadystatechange = function () {
	                  if (xhr.readyState === 4) {
	                    if (xhr.status === 200) {
	                      response = formatResponse(xhr);
	                      callback(response);
	                    } else {
	                      try {
	                        response = formatResponse(xhr);
	                        callback(response);
	                      } catch (err) {
	                        if (errorCallback) {
	                          errorCallback(err);
	                        }
	                      }
	                    }
	                  }
	                };

	                try {
	                  // Hack to workaround banner validation
	                  xhr.open(['G', 'E', 'T'].join(''), path, true);
	                } catch (error) {
	                  // Hack to workaround banner validation
	                  xhr.open(['G', 'E', 'T'].join(''), fullPath + '/' + path, true);
	                }

	                xhr.send();
	              }

	              return {
	                load: loadAsset
	              };
	            }();
	          }

	          if (e.data.type === 'loadAnimation') {
	            _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function (data) {
	              _workerSelf.dataManager.completeData(data);

	              _workerSelf.postMessage({
	                id: e.data.id,
	                payload: data,
	                status: 'success'
	              });
	            }, function () {
	              _workerSelf.postMessage({
	                id: e.data.id,
	                status: 'error'
	              });
	            });
	          } else if (e.data.type === 'complete') {
	            var animation = e.data.animation;

	            _workerSelf.dataManager.completeData(animation);

	            _workerSelf.postMessage({
	              id: e.data.id,
	              payload: animation,
	              status: 'success'
	            });
	          } else if (e.data.type === 'loadData') {
	            _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function (data) {
	              _workerSelf.postMessage({
	                id: e.data.id,
	                payload: data,
	                status: 'success'
	              });
	            }, function () {
	              _workerSelf.postMessage({
	                id: e.data.id,
	                status: 'error'
	              });
	            });
	          }
	        });

	        workerInstance.onmessage = function (event) {
	          var data = event.data;
	          var id = data.id;
	          var process = processes[id];
	          processes[id] = null;

	          if (data.status === 'success') {
	            process.onComplete(data.payload);
	          } else if (process.onError) {
	            process.onError();
	          }
	        };
	      }
	    }

	    function createProcess(onComplete, onError) {
	      _counterId += 1;
	      var id = 'processId_' + _counterId;
	      processes[id] = {
	        onComplete: onComplete,
	        onError: onError
	      };
	      return id;
	    }

	    function loadAnimation(path, onComplete, onError) {
	      setupWorker();
	      var processId = createProcess(onComplete, onError);
	      workerInstance.postMessage({
	        type: 'loadAnimation',
	        path: path,
	        fullPath: window.location.origin + window.location.pathname,
	        id: processId
	      });
	    }

	    function loadData(path, onComplete, onError) {
	      setupWorker();
	      var processId = createProcess(onComplete, onError);
	      workerInstance.postMessage({
	        type: 'loadData',
	        path: path,
	        fullPath: window.location.origin + window.location.pathname,
	        id: processId
	      });
	    }

	    function completeAnimation(anim, onComplete, onError) {
	      setupWorker();
	      var processId = createProcess(onComplete, onError);
	      workerInstance.postMessage({
	        type: 'complete',
	        animation: anim,
	        id: processId
	      });
	    }

	    return {
	      loadAnimation: loadAnimation,
	      loadData: loadData,
	      completeAnimation: completeAnimation
	    };
	  }();

	  var ImagePreloader = function () {
	    var proxyImage = function () {
	      var canvas = createTag('canvas');
	      canvas.width = 1;
	      canvas.height = 1;
	      var ctx = canvas.getContext('2d');
	      ctx.fillStyle = 'rgba(0,0,0,0)';
	      ctx.fillRect(0, 0, 1, 1);
	      return canvas;
	    }();

	    function imageLoaded() {
	      this.loadedAssets += 1;

	      if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
	        if (this.imagesLoadedCb) {
	          this.imagesLoadedCb(null);
	        }
	      }
	    }

	    function footageLoaded() {
	      this.loadedFootagesCount += 1;

	      if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
	        if (this.imagesLoadedCb) {
	          this.imagesLoadedCb(null);
	        }
	      }
	    }

	    function getAssetsPath(assetData, assetsPath, originalPath) {
	      var path = '';

	      if (assetData.e) {
	        path = assetData.p;
	      } else if (assetsPath) {
	        var imagePath = assetData.p;

	        if (imagePath.indexOf('images/') !== -1) {
	          imagePath = imagePath.split('/')[1];
	        }

	        path = assetsPath + imagePath;
	      } else {
	        path = originalPath;
	        path += assetData.u ? assetData.u : '';
	        path += assetData.p;
	      }

	      return path;
	    }

	    function testImageLoaded(img) {
	      var _count = 0;
	      var intervalId = setInterval(function () {
	        var box = img.getBBox();

	        if (box.width || _count > 500) {
	          this._imageLoaded();

	          clearInterval(intervalId);
	        }

	        _count += 1;
	      }.bind(this), 50);
	    }

	    function createImageData(assetData) {
	      var path = getAssetsPath(assetData, this.assetsPath, this.path);
	      var img = createNS('image');

	      if (isSafari) {
	        this.testImageLoaded(img);
	      } else {
	        img.addEventListener('load', this._imageLoaded, false);
	      }

	      img.addEventListener('error', function () {
	        ob.img = proxyImage;

	        this._imageLoaded();
	      }.bind(this), false);
	      img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', path);

	      if (this._elementHelper.append) {
	        this._elementHelper.append(img);
	      } else {
	        this._elementHelper.appendChild(img);
	      }

	      var ob = {
	        img: img,
	        assetData: assetData
	      };
	      return ob;
	    }

	    function createImgData(assetData) {
	      var path = getAssetsPath(assetData, this.assetsPath, this.path);
	      var img = createTag('img');
	      img.crossOrigin = 'anonymous';
	      img.addEventListener('load', this._imageLoaded, false);
	      img.addEventListener('error', function () {
	        ob.img = proxyImage;

	        this._imageLoaded();
	      }.bind(this), false);
	      img.src = path;
	      var ob = {
	        img: img,
	        assetData: assetData
	      };
	      return ob;
	    }

	    function createFootageData(data) {
	      var ob = {
	        assetData: data
	      };
	      var path = getAssetsPath(data, this.assetsPath, this.path);
	      dataManager.loadData(path, function (footageData) {
	        ob.img = footageData;

	        this._footageLoaded();
	      }.bind(this), function () {
	        ob.img = {};

	        this._footageLoaded();
	      }.bind(this));
	      return ob;
	    }

	    function loadAssets(assets, cb) {
	      this.imagesLoadedCb = cb;
	      var i;
	      var len = assets.length;

	      for (i = 0; i < len; i += 1) {
	        if (!assets[i].layers) {
	          if (!assets[i].t || assets[i].t === 'seq') {
	            this.totalImages += 1;
	            this.images.push(this._createImageData(assets[i]));
	          } else if (assets[i].t === 3) {
	            this.totalFootages += 1;
	            this.images.push(this.createFootageData(assets[i]));
	          }
	        }
	      }
	    }

	    function setPath(path) {
	      this.path = path || '';
	    }

	    function setAssetsPath(path) {
	      this.assetsPath = path || '';
	    }

	    function getAsset(assetData) {
	      var i = 0;
	      var len = this.images.length;

	      while (i < len) {
	        if (this.images[i].assetData === assetData) {
	          return this.images[i].img;
	        }

	        i += 1;
	      }

	      return null;
	    }

	    function destroy() {
	      this.imagesLoadedCb = null;
	      this.images.length = 0;
	    }

	    function loadedImages() {
	      return this.totalImages === this.loadedAssets;
	    }

	    function loadedFootages() {
	      return this.totalFootages === this.loadedFootagesCount;
	    }

	    function setCacheType(type, elementHelper) {
	      if (type === 'svg') {
	        this._elementHelper = elementHelper;
	        this._createImageData = this.createImageData.bind(this);
	      } else {
	        this._createImageData = this.createImgData.bind(this);
	      }
	    }

	    function ImagePreloaderFactory() {
	      this._imageLoaded = imageLoaded.bind(this);
	      this._footageLoaded = footageLoaded.bind(this);
	      this.testImageLoaded = testImageLoaded.bind(this);
	      this.createFootageData = createFootageData.bind(this);
	      this.assetsPath = '';
	      this.path = '';
	      this.totalImages = 0;
	      this.totalFootages = 0;
	      this.loadedAssets = 0;
	      this.loadedFootagesCount = 0;
	      this.imagesLoadedCb = null;
	      this.images = [];
	    }

	    ImagePreloaderFactory.prototype = {
	      loadAssets: loadAssets,
	      setAssetsPath: setAssetsPath,
	      setPath: setPath,
	      loadedImages: loadedImages,
	      loadedFootages: loadedFootages,
	      destroy: destroy,
	      getAsset: getAsset,
	      createImgData: createImgData,
	      createImageData: createImageData,
	      imageLoaded: imageLoaded,
	      footageLoaded: footageLoaded,
	      setCacheType: setCacheType
	    };
	    return ImagePreloaderFactory;
	  }();

	  function BaseEvent() {}

	  BaseEvent.prototype = {
	    triggerEvent: function triggerEvent(eventName, args) {
	      if (this._cbs[eventName]) {
	        var callbacks = this._cbs[eventName];

	        for (var i = 0; i < callbacks.length; i += 1) {
	          callbacks[i](args);
	        }
	      }
	    },
	    addEventListener: function addEventListener(eventName, callback) {
	      if (!this._cbs[eventName]) {
	        this._cbs[eventName] = [];
	      }

	      this._cbs[eventName].push(callback);

	      return function () {
	        this.removeEventListener(eventName, callback);
	      }.bind(this);
	    },
	    removeEventListener: function removeEventListener(eventName, callback) {
	      if (!callback) {
	        this._cbs[eventName] = null;
	      } else if (this._cbs[eventName]) {
	        var i = 0;
	        var len = this._cbs[eventName].length;

	        while (i < len) {
	          if (this._cbs[eventName][i] === callback) {
	            this._cbs[eventName].splice(i, 1);

	            i -= 1;
	            len -= 1;
	          }

	          i += 1;
	        }

	        if (!this._cbs[eventName].length) {
	          this._cbs[eventName] = null;
	        }
	      }
	    }
	  };

	  var markerParser = function () {
	    function parsePayloadLines(payload) {
	      var lines = payload.split('\r\n');
	      var keys = {};
	      var line;
	      var keysCount = 0;

	      for (var i = 0; i < lines.length; i += 1) {
	        line = lines[i].split(':');

	        if (line.length === 2) {
	          keys[line[0]] = line[1].trim();
	          keysCount += 1;
	        }
	      }

	      if (keysCount === 0) {
	        throw new Error();
	      }

	      return keys;
	    }

	    return function (_markers) {
	      var markers = [];

	      for (var i = 0; i < _markers.length; i += 1) {
	        var _marker = _markers[i];
	        var markerData = {
	          time: _marker.tm,
	          duration: _marker.dr
	        };

	        try {
	          markerData.payload = JSON.parse(_markers[i].cm);
	        } catch (_) {
	          try {
	            markerData.payload = parsePayloadLines(_markers[i].cm);
	          } catch (__) {
	            markerData.payload = {
	              name: _markers[i].cm
	            };
	          }
	        }

	        markers.push(markerData);
	      }

	      return markers;
	    };
	  }();

	  var ProjectInterface = function () {
	    function registerComposition(comp) {
	      this.compositions.push(comp);
	    }

	    return function () {
	      function _thisProjectFunction(name) {
	        var i = 0;
	        var len = this.compositions.length;

	        while (i < len) {
	          if (this.compositions[i].data && this.compositions[i].data.nm === name) {
	            if (this.compositions[i].prepareFrame && this.compositions[i].data.xt) {
	              this.compositions[i].prepareFrame(this.currentFrame);
	            }

	            return this.compositions[i].compInterface;
	          }

	          i += 1;
	        }

	        return null;
	      }

	      _thisProjectFunction.compositions = [];
	      _thisProjectFunction.currentFrame = 0;
	      _thisProjectFunction.registerComposition = registerComposition;
	      return _thisProjectFunction;
	    };
	  }();

	  var renderers = {};

	  var registerRenderer = function registerRenderer(key, value) {
	    renderers[key] = value;
	  };

	  function getRenderer(key) {
	    return renderers[key];
	  }

	  function getRegisteredRenderer() {
	    // Returns canvas by default for compatibility
	    if (renderers.canvas) {
	      return 'canvas';
	    } // Returns any renderer that is registered


	    for (var key in renderers) {
	      if (renderers[key]) {
	        return key;
	      }
	    }

	    return '';
	  }

	  function _typeof$4(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$4 = function _typeof(obj) { return typeof obj; }; } else { _typeof$4 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$4(obj); }

	  var AnimationItem = function AnimationItem() {
	    this._cbs = [];
	    this.name = '';
	    this.path = '';
	    this.isLoaded = false;
	    this.currentFrame = 0;
	    this.currentRawFrame = 0;
	    this.firstFrame = 0;
	    this.totalFrames = 0;
	    this.frameRate = 0;
	    this.frameMult = 0;
	    this.playSpeed = 1;
	    this.playDirection = 1;
	    this.playCount = 0;
	    this.animationData = {};
	    this.assets = [];
	    this.isPaused = true;
	    this.autoplay = false;
	    this.loop = true;
	    this.renderer = null;
	    this.animationID = createElementID();
	    this.assetsPath = '';
	    this.timeCompleted = 0;
	    this.segmentPos = 0;
	    this.isSubframeEnabled = getSubframeEnabled();
	    this.segments = [];
	    this._idle = true;
	    this._completedLoop = false;
	    this.projectInterface = ProjectInterface();
	    this.imagePreloader = new ImagePreloader();
	    this.audioController = audioControllerFactory();
	    this.markers = [];
	    this.configAnimation = this.configAnimation.bind(this);
	    this.onSetupError = this.onSetupError.bind(this);
	    this.onSegmentComplete = this.onSegmentComplete.bind(this);
	    this.drawnFrameEvent = new BMEnterFrameEvent('drawnFrame', 0, 0, 0);
	    this.expressionsPlugin = getExpressionsPlugin();
	  };

	  extendPrototype([BaseEvent], AnimationItem);

	  AnimationItem.prototype.setParams = function (params) {
	    if (params.wrapper || params.container) {
	      this.wrapper = params.wrapper || params.container;
	    }

	    var animType = 'svg';

	    if (params.animType) {
	      animType = params.animType;
	    } else if (params.renderer) {
	      animType = params.renderer;
	    }

	    var RendererClass = getRenderer(animType);
	    this.renderer = new RendererClass(this, params.rendererSettings);
	    this.imagePreloader.setCacheType(animType, this.renderer.globalData.defs);
	    this.renderer.setProjectInterface(this.projectInterface);
	    this.animType = animType;

	    if (params.loop === '' || params.loop === null || params.loop === undefined || params.loop === true) {
	      this.loop = true;
	    } else if (params.loop === false) {
	      this.loop = false;
	    } else {
	      this.loop = parseInt(params.loop, 10);
	    }

	    this.autoplay = 'autoplay' in params ? params.autoplay : true;
	    this.name = params.name ? params.name : '';
	    this.autoloadSegments = Object.prototype.hasOwnProperty.call(params, 'autoloadSegments') ? params.autoloadSegments : true;
	    this.assetsPath = params.assetsPath;
	    this.initialSegment = params.initialSegment;

	    if (params.audioFactory) {
	      this.audioController.setAudioFactory(params.audioFactory);
	    }

	    if (params.animationData) {
	      this.setupAnimation(params.animationData);
	    } else if (params.path) {
	      if (params.path.lastIndexOf('\\') !== -1) {
	        this.path = params.path.substr(0, params.path.lastIndexOf('\\') + 1);
	      } else {
	        this.path = params.path.substr(0, params.path.lastIndexOf('/') + 1);
	      }

	      this.fileName = params.path.substr(params.path.lastIndexOf('/') + 1);
	      this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf('.json'));
	      dataManager.loadAnimation(params.path, this.configAnimation, this.onSetupError);
	    }
	  };

	  AnimationItem.prototype.onSetupError = function () {
	    this.trigger('data_failed');
	  };

	  AnimationItem.prototype.setupAnimation = function (data) {
	    dataManager.completeAnimation(data, this.configAnimation);
	  };

	  AnimationItem.prototype.setData = function (wrapper, animationData) {
	    if (animationData) {
	      if (_typeof$4(animationData) !== 'object') {
	        animationData = JSON.parse(animationData);
	      }
	    }

	    var params = {
	      wrapper: wrapper,
	      animationData: animationData
	    };
	    var wrapperAttributes = wrapper.attributes;
	    params.path = wrapperAttributes.getNamedItem('data-animation-path') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-animation-path').value : wrapperAttributes.getNamedItem('data-bm-path') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-bm-path').value : wrapperAttributes.getNamedItem('bm-path') ? wrapperAttributes.getNamedItem('bm-path').value : '';
	    params.animType = wrapperAttributes.getNamedItem('data-anim-type') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-anim-type').value : wrapperAttributes.getNamedItem('data-bm-type') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-bm-type').value : wrapperAttributes.getNamedItem('bm-type') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('bm-type').value : wrapperAttributes.getNamedItem('data-bm-renderer') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-bm-renderer').value : wrapperAttributes.getNamedItem('bm-renderer') ? wrapperAttributes.getNamedItem('bm-renderer').value : getRegisteredRenderer() || 'canvas';
	    var loop = wrapperAttributes.getNamedItem('data-anim-loop') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-anim-loop').value : wrapperAttributes.getNamedItem('data-bm-loop') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-bm-loop').value : wrapperAttributes.getNamedItem('bm-loop') ? wrapperAttributes.getNamedItem('bm-loop').value : '';

	    if (loop === 'false') {
	      params.loop = false;
	    } else if (loop === 'true') {
	      params.loop = true;
	    } else if (loop !== '') {
	      params.loop = parseInt(loop, 10);
	    }

	    var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-anim-autoplay').value : wrapperAttributes.getNamedItem('data-bm-autoplay') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-bm-autoplay').value : wrapperAttributes.getNamedItem('bm-autoplay') ? wrapperAttributes.getNamedItem('bm-autoplay').value : true;
	    params.autoplay = autoplay !== 'false';
	    params.name = wrapperAttributes.getNamedItem('data-name') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-name').value : wrapperAttributes.getNamedItem('data-bm-name') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-bm-name').value : wrapperAttributes.getNamedItem('bm-name') ? wrapperAttributes.getNamedItem('bm-name').value : '';
	    var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-anim-prerender').value : wrapperAttributes.getNamedItem('data-bm-prerender') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-bm-prerender').value : wrapperAttributes.getNamedItem('bm-prerender') ? wrapperAttributes.getNamedItem('bm-prerender').value : '';

	    if (prerender === 'false') {
	      params.prerender = false;
	    }

	    if (!params.path) {
	      this.trigger('destroy');
	    } else {
	      this.setParams(params);
	    }
	  };

	  AnimationItem.prototype.includeLayers = function (data) {
	    if (data.op > this.animationData.op) {
	      this.animationData.op = data.op;
	      this.totalFrames = Math.floor(data.op - this.animationData.ip);
	    }

	    var layers = this.animationData.layers;
	    var i;
	    var len = layers.length;
	    var newLayers = data.layers;
	    var j;
	    var jLen = newLayers.length;

	    for (j = 0; j < jLen; j += 1) {
	      i = 0;

	      while (i < len) {
	        if (layers[i].id === newLayers[j].id) {
	          layers[i] = newLayers[j];
	          break;
	        }

	        i += 1;
	      }
	    }

	    if (data.chars || data.fonts) {
	      this.renderer.globalData.fontManager.addChars(data.chars);
	      this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
	    }

	    if (data.assets) {
	      len = data.assets.length;

	      for (i = 0; i < len; i += 1) {
	        this.animationData.assets.push(data.assets[i]);
	      }
	    }

	    this.animationData.__complete = false;
	    dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
	  };

	  AnimationItem.prototype.onSegmentComplete = function (data) {
	    this.animationData = data;
	    var expressionsPlugin = getExpressionsPlugin();

	    if (expressionsPlugin) {
	      expressionsPlugin.initExpressions(this);
	    }

	    this.loadNextSegment();
	  };

	  AnimationItem.prototype.loadNextSegment = function () {
	    var segments = this.animationData.segments;

	    if (!segments || segments.length === 0 || !this.autoloadSegments) {
	      this.trigger('data_ready');
	      this.timeCompleted = this.totalFrames;
	      return;
	    }

	    var segment = segments.shift();
	    this.timeCompleted = segment.time * this.frameRate;
	    var segmentPath = this.path + this.fileName + '_' + this.segmentPos + '.json';
	    this.segmentPos += 1;
	    dataManager.loadData(segmentPath, this.includeLayers.bind(this), function () {
	      this.trigger('data_failed');
	    }.bind(this));
	  };

	  AnimationItem.prototype.loadSegments = function () {
	    var segments = this.animationData.segments;

	    if (!segments) {
	      this.timeCompleted = this.totalFrames;
	    }

	    this.loadNextSegment();
	  };

	  AnimationItem.prototype.imagesLoaded = function () {
	    this.trigger('loaded_images');
	    this.checkLoaded();
	  };

	  AnimationItem.prototype.preloadImages = function () {
	    this.imagePreloader.setAssetsPath(this.assetsPath);
	    this.imagePreloader.setPath(this.path);
	    this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
	  };

	  AnimationItem.prototype.configAnimation = function (animData) {
	    if (!this.renderer) {
	      return;
	    }

	    try {
	      this.animationData = animData;

	      if (this.initialSegment) {
	        this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]);
	        this.firstFrame = Math.round(this.initialSegment[0]);
	      } else {
	        this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
	        this.firstFrame = Math.round(this.animationData.ip);
	      }

	      this.renderer.configAnimation(animData);

	      if (!animData.assets) {
	        animData.assets = [];
	      }

	      this.assets = this.animationData.assets;
	      this.frameRate = this.animationData.fr;
	      this.frameMult = this.animationData.fr / 1000;
	      this.renderer.searchExtraCompositions(animData.assets);
	      this.markers = markerParser(animData.markers || []);
	      this.trigger('config_ready');
	      this.preloadImages();
	      this.loadSegments();
	      this.updaFrameModifier();
	      this.waitForFontsLoaded();

	      if (this.isPaused) {
	        this.audioController.pause();
	      }
	    } catch (error) {
	      this.triggerConfigError(error);
	    }
	  };

	  AnimationItem.prototype.waitForFontsLoaded = function () {
	    if (!this.renderer) {
	      return;
	    }

	    if (this.renderer.globalData.fontManager.isLoaded) {
	      this.checkLoaded();
	    } else {
	      setTimeout(this.waitForFontsLoaded.bind(this), 20);
	    }
	  };

	  AnimationItem.prototype.checkLoaded = function () {
	    if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== 'canvas') && this.imagePreloader.loadedFootages()) {
	      this.isLoaded = true;
	      var expressionsPlugin = getExpressionsPlugin();

	      if (expressionsPlugin) {
	        expressionsPlugin.initExpressions(this);
	      }

	      this.renderer.initItems();
	      setTimeout(function () {
	        this.trigger('DOMLoaded');
	      }.bind(this), 0);
	      this.gotoFrame();

	      if (this.autoplay) {
	        this.play();
	      }
	    }
	  };

	  AnimationItem.prototype.resize = function (width, height) {
	    // Adding this validation for backwards compatibility in case an event object was being passed down
	    var _width = typeof width === 'number' ? width : undefined;

	    var _height = typeof height === 'number' ? height : undefined;

	    this.renderer.updateContainerSize(_width, _height);
	  };

	  AnimationItem.prototype.setSubframe = function (flag) {
	    this.isSubframeEnabled = !!flag;
	  };

	  AnimationItem.prototype.gotoFrame = function () {
	    this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame; // eslint-disable-line no-bitwise

	    if (this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted) {
	      this.currentFrame = this.timeCompleted;
	    }

	    this.trigger('enterFrame');
	    this.renderFrame();
	    this.trigger('drawnFrame');
	  };

	  AnimationItem.prototype.renderFrame = function () {
	    if (this.isLoaded === false || !this.renderer) {
	      return;
	    }

	    try {
	      if (this.expressionsPlugin) {
	        this.expressionsPlugin.resetFrame();
	      }

	      this.renderer.renderFrame(this.currentFrame + this.firstFrame);
	    } catch (error) {
	      this.triggerRenderFrameError(error);
	    }
	  };

	  AnimationItem.prototype.play = function (name) {
	    if (name && this.name !== name) {
	      return;
	    }

	    if (this.isPaused === true) {
	      this.isPaused = false;
	      this.trigger('_play');
	      this.audioController.resume();

	      if (this._idle) {
	        this._idle = false;
	        this.trigger('_active');
	      }
	    }
	  };

	  AnimationItem.prototype.pause = function (name) {
	    if (name && this.name !== name) {
	      return;
	    }

	    if (this.isPaused === false) {
	      this.isPaused = true;
	      this.trigger('_pause');
	      this._idle = true;
	      this.trigger('_idle');
	      this.audioController.pause();
	    }
	  };

	  AnimationItem.prototype.togglePause = function (name) {
	    if (name && this.name !== name) {
	      return;
	    }

	    if (this.isPaused === true) {
	      this.play();
	    } else {
	      this.pause();
	    }
	  };

	  AnimationItem.prototype.stop = function (name) {
	    if (name && this.name !== name) {
	      return;
	    }

	    this.pause();
	    this.playCount = 0;
	    this._completedLoop = false;
	    this.setCurrentRawFrameValue(0);
	  };

	  AnimationItem.prototype.getMarkerData = function (markerName) {
	    var marker;

	    for (var i = 0; i < this.markers.length; i += 1) {
	      marker = this.markers[i];

	      if (marker.payload && marker.payload.name === markerName) {
	        return marker;
	      }
	    }

	    return null;
	  };

	  AnimationItem.prototype.goToAndStop = function (value, isFrame, name) {
	    if (name && this.name !== name) {
	      return;
	    }

	    var numValue = Number(value);

	    if (isNaN(numValue)) {
	      var marker = this.getMarkerData(value);

	      if (marker) {
	        this.goToAndStop(marker.time, true);
	      }
	    } else if (isFrame) {
	      this.setCurrentRawFrameValue(value);
	    } else {
	      this.setCurrentRawFrameValue(value * this.frameModifier);
	    }

	    this.pause();
	  };

	  AnimationItem.prototype.goToAndPlay = function (value, isFrame, name) {
	    if (name && this.name !== name) {
	      return;
	    }

	    var numValue = Number(value);

	    if (isNaN(numValue)) {
	      var marker = this.getMarkerData(value);

	      if (marker) {
	        if (!marker.duration) {
	          this.goToAndStop(marker.time, true);
	        } else {
	          this.playSegments([marker.time, marker.time + marker.duration], true);
	        }
	      }
	    } else {
	      this.goToAndStop(numValue, isFrame, name);
	    }

	    this.play();
	  };

	  AnimationItem.prototype.advanceTime = function (value) {
	    if (this.isPaused === true || this.isLoaded === false) {
	      return;
	    }

	    var nextValue = this.currentRawFrame + value * this.frameModifier;
	    var _isComplete = false; // Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
	    // If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.

	    if (nextValue >= this.totalFrames - 1 && this.frameModifier > 0) {
	      if (!this.loop || this.playCount === this.loop) {
	        if (!this.checkSegments(nextValue > this.totalFrames ? nextValue % this.totalFrames : 0)) {
	          _isComplete = true;
	          nextValue = this.totalFrames - 1;
	        }
	      } else if (nextValue >= this.totalFrames) {
	        this.playCount += 1;

	        if (!this.checkSegments(nextValue % this.totalFrames)) {
	          this.setCurrentRawFrameValue(nextValue % this.totalFrames);
	          this._completedLoop = true;
	          this.trigger('loopComplete');
	        }
	      } else {
	        this.setCurrentRawFrameValue(nextValue);
	      }
	    } else if (nextValue < 0) {
	      if (!this.checkSegments(nextValue % this.totalFrames)) {
	        if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) {
	          // eslint-disable-line no-plusplus
	          this.setCurrentRawFrameValue(this.totalFrames + nextValue % this.totalFrames);

	          if (!this._completedLoop) {
	            this._completedLoop = true;
	          } else {
	            this.trigger('loopComplete');
	          }
	        } else {
	          _isComplete = true;
	          nextValue = 0;
	        }
	      }
	    } else {
	      this.setCurrentRawFrameValue(nextValue);
	    }

	    if (_isComplete) {
	      this.setCurrentRawFrameValue(nextValue);
	      this.pause();
	      this.trigger('complete');
	    }
	  };

	  AnimationItem.prototype.adjustSegment = function (arr, offset) {
	    this.playCount = 0;

	    if (arr[1] < arr[0]) {
	      if (this.frameModifier > 0) {
	        if (this.playSpeed < 0) {
	          this.setSpeed(-this.playSpeed);
	        } else {
	          this.setDirection(-1);
	        }
	      }

	      this.totalFrames = arr[0] - arr[1];
	      this.timeCompleted = this.totalFrames;
	      this.firstFrame = arr[1];
	      this.setCurrentRawFrameValue(this.totalFrames - 0.001 - offset);
	    } else if (arr[1] > arr[0]) {
	      if (this.frameModifier < 0) {
	        if (this.playSpeed < 0) {
	          this.setSpeed(-this.playSpeed);
	        } else {
	          this.setDirection(1);
	        }
	      }

	      this.totalFrames = arr[1] - arr[0];
	      this.timeCompleted = this.totalFrames;
	      this.firstFrame = arr[0];
	      this.setCurrentRawFrameValue(0.001 + offset);
	    }

	    this.trigger('segmentStart');
	  };

	  AnimationItem.prototype.setSegment = function (init, end) {
	    var pendingFrame = -1;

	    if (this.isPaused) {
	      if (this.currentRawFrame + this.firstFrame < init) {
	        pendingFrame = init;
	      } else if (this.currentRawFrame + this.firstFrame > end) {
	        pendingFrame = end - init;
	      }
	    }

	    this.firstFrame = init;
	    this.totalFrames = end - init;
	    this.timeCompleted = this.totalFrames;

	    if (pendingFrame !== -1) {
	      this.goToAndStop(pendingFrame, true);
	    }
	  };

	  AnimationItem.prototype.playSegments = function (arr, forceFlag) {
	    if (forceFlag) {
	      this.segments.length = 0;
	    }

	    if (_typeof$4(arr[0]) === 'object') {
	      var i;
	      var len = arr.length;

	      for (i = 0; i < len; i += 1) {
	        this.segments.push(arr[i]);
	      }
	    } else {
	      this.segments.push(arr);
	    }

	    if (this.segments.length && forceFlag) {
	      this.adjustSegment(this.segments.shift(), 0);
	    }

	    if (this.isPaused) {
	      this.play();
	    }
	  };

	  AnimationItem.prototype.resetSegments = function (forceFlag) {
	    this.segments.length = 0;
	    this.segments.push([this.animationData.ip, this.animationData.op]);

	    if (forceFlag) {
	      this.checkSegments(0);
	    }
	  };

	  AnimationItem.prototype.checkSegments = function (offset) {
	    if (this.segments.length) {
	      this.adjustSegment(this.segments.shift(), offset);
	      return true;
	    }

	    return false;
	  };

	  AnimationItem.prototype.destroy = function (name) {
	    if (name && this.name !== name || !this.renderer) {
	      return;
	    }

	    this.renderer.destroy();
	    this.imagePreloader.destroy();
	    this.trigger('destroy');
	    this._cbs = null;
	    this.onEnterFrame = null;
	    this.onLoopComplete = null;
	    this.onComplete = null;
	    this.onSegmentStart = null;
	    this.onDestroy = null;
	    this.renderer = null;
	    this.expressionsPlugin = null;
	    this.imagePreloader = null;
	    this.projectInterface = null;
	  };

	  AnimationItem.prototype.setCurrentRawFrameValue = function (value) {
	    this.currentRawFrame = value;
	    this.gotoFrame();
	  };

	  AnimationItem.prototype.setSpeed = function (val) {
	    this.playSpeed = val;
	    this.updaFrameModifier();
	  };

	  AnimationItem.prototype.setDirection = function (val) {
	    this.playDirection = val < 0 ? -1 : 1;
	    this.updaFrameModifier();
	  };

	  AnimationItem.prototype.setLoop = function (isLooping) {
	    this.loop = isLooping;
	  };

	  AnimationItem.prototype.setVolume = function (val, name) {
	    if (name && this.name !== name) {
	      return;
	    }

	    this.audioController.setVolume(val);
	  };

	  AnimationItem.prototype.getVolume = function () {
	    return this.audioController.getVolume();
	  };

	  AnimationItem.prototype.mute = function (name) {
	    if (name && this.name !== name) {
	      return;
	    }

	    this.audioController.mute();
	  };

	  AnimationItem.prototype.unmute = function (name) {
	    if (name && this.name !== name) {
	      return;
	    }

	    this.audioController.unmute();
	  };

	  AnimationItem.prototype.updaFrameModifier = function () {
	    this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
	    this.audioController.setRate(this.playSpeed * this.playDirection);
	  };

	  AnimationItem.prototype.getPath = function () {
	    return this.path;
	  };

	  AnimationItem.prototype.getAssetsPath = function (assetData) {
	    var path = '';

	    if (assetData.e) {
	      path = assetData.p;
	    } else if (this.assetsPath) {
	      var imagePath = assetData.p;

	      if (imagePath.indexOf('images/') !== -1) {
	        imagePath = imagePath.split('/')[1];
	      }

	      path = this.assetsPath + imagePath;
	    } else {
	      path = this.path;
	      path += assetData.u ? assetData.u : '';
	      path += assetData.p;
	    }

	    return path;
	  };

	  AnimationItem.prototype.getAssetData = function (id) {
	    var i = 0;
	    var len = this.assets.length;

	    while (i < len) {
	      if (id === this.assets[i].id) {
	        return this.assets[i];
	      }

	      i += 1;
	    }

	    return null;
	  };

	  AnimationItem.prototype.hide = function () {
	    this.renderer.hide();
	  };

	  AnimationItem.prototype.show = function () {
	    this.renderer.show();
	  };

	  AnimationItem.prototype.getDuration = function (isFrame) {
	    return isFrame ? this.totalFrames : this.totalFrames / this.frameRate;
	  };

	  AnimationItem.prototype.updateDocumentData = function (path, documentData, index) {
	    try {
	      var element = this.renderer.getElementByPath(path);
	      element.updateDocumentData(documentData, index);
	    } catch (error) {// TODO: decide how to handle catch case
	    }
	  };

	  AnimationItem.prototype.trigger = function (name) {
	    if (this._cbs && this._cbs[name]) {
	      switch (name) {
	        case 'enterFrame':
	          this.triggerEvent(name, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameModifier));
	          break;

	        case 'drawnFrame':
	          this.drawnFrameEvent.currentTime = this.currentFrame;
	          this.drawnFrameEvent.totalTime = this.totalFrames;
	          this.drawnFrameEvent.direction = this.frameModifier;
	          this.triggerEvent(name, this.drawnFrameEvent);
	          break;

	        case 'loopComplete':
	          this.triggerEvent(name, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
	          break;

	        case 'complete':
	          this.triggerEvent(name, new BMCompleteEvent(name, this.frameMult));
	          break;

	        case 'segmentStart':
	          this.triggerEvent(name, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
	          break;

	        case 'destroy':
	          this.triggerEvent(name, new BMDestroyEvent(name, this));
	          break;

	        default:
	          this.triggerEvent(name);
	      }
	    }

	    if (name === 'enterFrame' && this.onEnterFrame) {
	      this.onEnterFrame.call(this, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameMult));
	    }

	    if (name === 'loopComplete' && this.onLoopComplete) {
	      this.onLoopComplete.call(this, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
	    }

	    if (name === 'complete' && this.onComplete) {
	      this.onComplete.call(this, new BMCompleteEvent(name, this.frameMult));
	    }

	    if (name === 'segmentStart' && this.onSegmentStart) {
	      this.onSegmentStart.call(this, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
	    }

	    if (name === 'destroy' && this.onDestroy) {
	      this.onDestroy.call(this, new BMDestroyEvent(name, this));
	    }
	  };

	  AnimationItem.prototype.triggerRenderFrameError = function (nativeError) {
	    var error = new BMRenderFrameErrorEvent(nativeError, this.currentFrame);
	    this.triggerEvent('error', error);

	    if (this.onError) {
	      this.onError.call(this, error);
	    }
	  };

	  AnimationItem.prototype.triggerConfigError = function (nativeError) {
	    var error = new BMConfigErrorEvent(nativeError, this.currentFrame);
	    this.triggerEvent('error', error);

	    if (this.onError) {
	      this.onError.call(this, error);
	    }
	  };

	  var animationManager = function () {
	    var moduleOb = {};
	    var registeredAnimations = [];
	    var initTime = 0;
	    var len = 0;
	    var playingAnimationsNum = 0;
	    var _stopped = true;
	    var _isFrozen = false;

	    function removeElement(ev) {
	      var i = 0;
	      var animItem = ev.target;

	      while (i < len) {
	        if (registeredAnimations[i].animation === animItem) {
	          registeredAnimations.splice(i, 1);
	          i -= 1;
	          len -= 1;

	          if (!animItem.isPaused) {
	            subtractPlayingCount();
	          }
	        }

	        i += 1;
	      }
	    }

	    function registerAnimation(element, animationData) {
	      if (!element) {
	        return null;
	      }

	      var i = 0;

	      while (i < len) {
	        if (registeredAnimations[i].elem === element && registeredAnimations[i].elem !== null) {
	          return registeredAnimations[i].animation;
	        }

	        i += 1;
	      }

	      var animItem = new AnimationItem();
	      setupAnimation(animItem, element);
	      animItem.setData(element, animationData);
	      return animItem;
	    }

	    function getRegisteredAnimations() {
	      var i;
	      var lenAnims = registeredAnimations.length;
	      var animations = [];

	      for (i = 0; i < lenAnims; i += 1) {
	        animations.push(registeredAnimations[i].animation);
	      }

	      return animations;
	    }

	    function addPlayingCount() {
	      playingAnimationsNum += 1;
	      activate();
	    }

	    function subtractPlayingCount() {
	      playingAnimationsNum -= 1;
	    }

	    function setupAnimation(animItem, element) {
	      animItem.addEventListener('destroy', removeElement);
	      animItem.addEventListener('_active', addPlayingCount);
	      animItem.addEventListener('_idle', subtractPlayingCount);
	      registeredAnimations.push({
	        elem: element,
	        animation: animItem
	      });
	      len += 1;
	    }

	    function loadAnimation(params) {
	      var animItem = new AnimationItem();
	      setupAnimation(animItem, null);
	      animItem.setParams(params);
	      return animItem;
	    }

	    function setSpeed(val, animation) {
	      var i;

	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.setSpeed(val, animation);
	      }
	    }

	    function setDirection(val, animation) {
	      var i;

	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.setDirection(val, animation);
	      }
	    }

	    function play(animation) {
	      var i;

	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.play(animation);
	      }
	    }

	    function resume(nowTime) {
	      var elapsedTime = nowTime - initTime;
	      var i;

	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.advanceTime(elapsedTime);
	      }

	      initTime = nowTime;

	      if (playingAnimationsNum && !_isFrozen) {
	        window.requestAnimationFrame(resume);
	      } else {
	        _stopped = true;
	      }
	    }

	    function first(nowTime) {
	      initTime = nowTime;
	      window.requestAnimationFrame(resume);
	    }

	    function pause(animation) {
	      var i;

	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.pause(animation);
	      }
	    }

	    function goToAndStop(value, isFrame, animation) {
	      var i;

	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.goToAndStop(value, isFrame, animation);
	      }
	    }

	    function stop(animation) {
	      var i;

	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.stop(animation);
	      }
	    }

	    function togglePause(animation) {
	      var i;

	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.togglePause(animation);
	      }
	    }

	    function destroy(animation) {
	      var i;

	      for (i = len - 1; i >= 0; i -= 1) {
	        registeredAnimations[i].animation.destroy(animation);
	      }
	    }

	    function searchAnimations(animationData, standalone, renderer) {
	      var animElements = [].concat([].slice.call(document.getElementsByClassName('lottie')), [].slice.call(document.getElementsByClassName('bodymovin')));
	      var i;
	      var lenAnims = animElements.length;

	      for (i = 0; i < lenAnims; i += 1) {
	        if (renderer) {
	          animElements[i].setAttribute('data-bm-type', renderer);
	        }

	        registerAnimation(animElements[i], animationData);
	      }

	      if (standalone && lenAnims === 0) {
	        if (!renderer) {
	          renderer = 'svg';
	        }

	        var body = document.getElementsByTagName('body')[0];
	        body.innerText = '';
	        var div = createTag('div');
	        div.style.width = '100%';
	        div.style.height = '100%';
	        div.setAttribute('data-bm-type', renderer);
	        body.appendChild(div);
	        registerAnimation(div, animationData);
	      }
	    }

	    function resize() {
	      var i;

	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.resize();
	      }
	    }

	    function activate() {
	      if (!_isFrozen && playingAnimationsNum) {
	        if (_stopped) {
	          window.requestAnimationFrame(first);
	          _stopped = false;
	        }
	      }
	    }

	    function freeze() {
	      _isFrozen = true;
	    }

	    function unfreeze() {
	      _isFrozen = false;
	      activate();
	    }

	    function setVolume(val, animation) {
	      var i;

	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.setVolume(val, animation);
	      }
	    }

	    function mute(animation) {
	      var i;

	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.mute(animation);
	      }
	    }

	    function unmute(animation) {
	      var i;

	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.unmute(animation);
	      }
	    }

	    moduleOb.registerAnimation = registerAnimation;
	    moduleOb.loadAnimation = loadAnimation;
	    moduleOb.setSpeed = setSpeed;
	    moduleOb.setDirection = setDirection;
	    moduleOb.play = play;
	    moduleOb.pause = pause;
	    moduleOb.stop = stop;
	    moduleOb.togglePause = togglePause;
	    moduleOb.searchAnimations = searchAnimations;
	    moduleOb.resize = resize; // moduleOb.start = start;

	    moduleOb.goToAndStop = goToAndStop;
	    moduleOb.destroy = destroy;
	    moduleOb.freeze = freeze;
	    moduleOb.unfreeze = unfreeze;
	    moduleOb.setVolume = setVolume;
	    moduleOb.mute = mute;
	    moduleOb.unmute = unmute;
	    moduleOb.getRegisteredAnimations = getRegisteredAnimations;
	    return moduleOb;
	  }();

	  /* eslint-disable */
	  var BezierFactory = function () {
	    /**
	       * BezierEasing - use bezier curve for transition easing function
	       * by Gaëtan Renaudeau 2014 - 2015 – MIT License
	       *
	       * Credits: is based on Firefox's nsSMILKeySpline.cpp
	       * Usage:
	       * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
	       * spline.get(x) => returns the easing value | x must be in [0, 1] range
	       *
	       */
	    var ob = {};
	    ob.getBezierEasing = getBezierEasing;
	    var beziers = {};

	    function getBezierEasing(a, b, c, d, nm) {
	      var str = nm || ('bez_' + a + '_' + b + '_' + c + '_' + d).replace(/\./g, 'p');

	      if (beziers[str]) {
	        return beziers[str];
	      }

	      var bezEasing = new BezierEasing([a, b, c, d]);
	      beziers[str] = bezEasing;
	      return bezEasing;
	    } // These values are established by empiricism with tests (tradeoff: performance VS precision)


	    var NEWTON_ITERATIONS = 4;
	    var NEWTON_MIN_SLOPE = 0.001;
	    var SUBDIVISION_PRECISION = 0.0000001;
	    var SUBDIVISION_MAX_ITERATIONS = 10;
	    var kSplineTableSize = 11;
	    var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
	    var float32ArraySupported = typeof Float32Array === 'function';

	    function A(aA1, aA2) {
	      return 1.0 - 3.0 * aA2 + 3.0 * aA1;
	    }

	    function B(aA1, aA2) {
	      return 3.0 * aA2 - 6.0 * aA1;
	    }

	    function C(aA1) {
	      return 3.0 * aA1;
	    } // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.


	    function calcBezier(aT, aA1, aA2) {
	      return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
	    } // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.


	    function getSlope(aT, aA1, aA2) {
	      return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
	    }

	    function binarySubdivide(aX, aA, aB, mX1, mX2) {
	      var currentX,
	          currentT,
	          i = 0;

	      do {
	        currentT = aA + (aB - aA) / 2.0;
	        currentX = calcBezier(currentT, mX1, mX2) - aX;

	        if (currentX > 0.0) {
	          aB = currentT;
	        } else {
	          aA = currentT;
	        }
	      } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);

	      return currentT;
	    }

	    function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
	      for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
	        var currentSlope = getSlope(aGuessT, mX1, mX2);
	        if (currentSlope === 0.0) return aGuessT;
	        var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
	        aGuessT -= currentX / currentSlope;
	      }

	      return aGuessT;
	    }
	    /**
	       * points is an array of [ mX1, mY1, mX2, mY2 ]
	       */


	    function BezierEasing(points) {
	      this._p = points;
	      this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
	      this._precomputed = false;
	      this.get = this.get.bind(this);
	    }

	    BezierEasing.prototype = {
	      get: function get(x) {
	        var mX1 = this._p[0],
	            mY1 = this._p[1],
	            mX2 = this._p[2],
	            mY2 = this._p[3];
	        if (!this._precomputed) this._precompute();
	        if (mX1 === mY1 && mX2 === mY2) return x; // linear
	        // Because JavaScript number are imprecise, we should guarantee the extremes are right.

	        if (x === 0) return 0;
	        if (x === 1) return 1;
	        return calcBezier(this._getTForX(x), mY1, mY2);
	      },
	      // Private part
	      _precompute: function _precompute() {
	        var mX1 = this._p[0],
	            mY1 = this._p[1],
	            mX2 = this._p[2],
	            mY2 = this._p[3];
	        this._precomputed = true;

	        if (mX1 !== mY1 || mX2 !== mY2) {
	          this._calcSampleValues();
	        }
	      },
	      _calcSampleValues: function _calcSampleValues() {
	        var mX1 = this._p[0],
	            mX2 = this._p[2];

	        for (var i = 0; i < kSplineTableSize; ++i) {
	          this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
	        }
	      },

	      /**
	           * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
	           */
	      _getTForX: function _getTForX(aX) {
	        var mX1 = this._p[0],
	            mX2 = this._p[2],
	            mSampleValues = this._mSampleValues;
	        var intervalStart = 0.0;
	        var currentSample = 1;
	        var lastSample = kSplineTableSize - 1;

	        for (; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
	          intervalStart += kSampleStepSize;
	        }

	        --currentSample; // Interpolate to provide an initial guess for t

	        var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]);
	        var guessForT = intervalStart + dist * kSampleStepSize;
	        var initialSlope = getSlope(guessForT, mX1, mX2);

	        if (initialSlope >= NEWTON_MIN_SLOPE) {
	          return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
	        }

	        if (initialSlope === 0.0) {
	          return guessForT;
	        }

	        return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
	      }
	    };
	    return ob;
	  }();

	  var pooling = function () {
	    function _double(arr) {
	      return arr.concat(createSizedArray(arr.length));
	    }

	    return {
	      "double": _double
	    };
	  }();

	  var poolFactory = function () {
	    return function (initialLength, _create, _release) {
	      var _length = 0;
	      var _maxLength = initialLength;
	      var pool = createSizedArray(_maxLength);
	      var ob = {
	        newElement: newElement,
	        release: release
	      };

	      function newElement() {
	        var element;

	        if (_length) {
	          _length -= 1;
	          element = pool[_length];
	        } else {
	          element = _create();
	        }

	        return element;
	      }

	      function release(element) {
	        if (_length === _maxLength) {
	          pool = pooling["double"](pool);
	          _maxLength *= 2;
	        }

	        if (_release) {
	          _release(element);
	        }

	        pool[_length] = element;
	        _length += 1;
	      }

	      return ob;
	    };
	  }();

	  var bezierLengthPool = function () {
	    function create() {
	      return {
	        addedLength: 0,
	        percents: createTypedArray('float32', getDefaultCurveSegments()),
	        lengths: createTypedArray('float32', getDefaultCurveSegments())
	      };
	    }

	    return poolFactory(8, create);
	  }();

	  var segmentsLengthPool = function () {
	    function create() {
	      return {
	        lengths: [],
	        totalLength: 0
	      };
	    }

	    function release(element) {
	      var i;
	      var len = element.lengths.length;

	      for (i = 0; i < len; i += 1) {
	        bezierLengthPool.release(element.lengths[i]);
	      }

	      element.lengths.length = 0;
	    }

	    return poolFactory(8, create, release);
	  }();

	  function bezFunction() {
	    var math = Math;

	    function pointOnLine2D(x1, y1, x2, y2, x3, y3) {
	      var det1 = x1 * y2 + y1 * x3 + x2 * y3 - x3 * y2 - y3 * x1 - x2 * y1;
	      return det1 > -0.001 && det1 < 0.001;
	    }

	    function pointOnLine3D(x1, y1, z1, x2, y2, z2, x3, y3, z3) {
	      if (z1 === 0 && z2 === 0 && z3 === 0) {
	        return pointOnLine2D(x1, y1, x2, y2, x3, y3);
	      }

	      var dist1 = math.sqrt(math.pow(x2 - x1, 2) + math.pow(y2 - y1, 2) + math.pow(z2 - z1, 2));
	      var dist2 = math.sqrt(math.pow(x3 - x1, 2) + math.pow(y3 - y1, 2) + math.pow(z3 - z1, 2));
	      var dist3 = math.sqrt(math.pow(x3 - x2, 2) + math.pow(y3 - y2, 2) + math.pow(z3 - z2, 2));
	      var diffDist;

	      if (dist1 > dist2) {
	        if (dist1 > dist3) {
	          diffDist = dist1 - dist2 - dist3;
	        } else {
	          diffDist = dist3 - dist2 - dist1;
	        }
	      } else if (dist3 > dist2) {
	        diffDist = dist3 - dist2 - dist1;
	      } else {
	        diffDist = dist2 - dist1 - dist3;
	      }

	      return diffDist > -0.0001 && diffDist < 0.0001;
	    }

	    var getBezierLength = function () {
	      return function (pt1, pt2, pt3, pt4) {
	        var curveSegments = getDefaultCurveSegments();
	        var k;
	        var i;
	        var len;
	        var ptCoord;
	        var perc;
	        var addedLength = 0;
	        var ptDistance;
	        var point = [];
	        var lastPoint = [];
	        var lengthData = bezierLengthPool.newElement();
	        len = pt3.length;

	        for (k = 0; k < curveSegments; k += 1) {
	          perc = k / (curveSegments - 1);
	          ptDistance = 0;

	          for (i = 0; i < len; i += 1) {
	            ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * pt3[i] + 3 * (1 - perc) * bmPow(perc, 2) * pt4[i] + bmPow(perc, 3) * pt2[i];
	            point[i] = ptCoord;

	            if (lastPoint[i] !== null) {
	              ptDistance += bmPow(point[i] - lastPoint[i], 2);
	            }

	            lastPoint[i] = point[i];
	          }

	          if (ptDistance) {
	            ptDistance = bmSqrt(ptDistance);
	            addedLength += ptDistance;
	          }

	          lengthData.percents[k] = perc;
	          lengthData.lengths[k] = addedLength;
	        }

	        lengthData.addedLength = addedLength;
	        return lengthData;
	      };
	    }();

	    function getSegmentsLength(shapeData) {
	      var segmentsLength = segmentsLengthPool.newElement();
	      var closed = shapeData.c;
	      var pathV = shapeData.v;
	      var pathO = shapeData.o;
	      var pathI = shapeData.i;
	      var i;
	      var len = shapeData._length;
	      var lengths = segmentsLength.lengths;
	      var totalLength = 0;

	      for (i = 0; i < len - 1; i += 1) {
	        lengths[i] = getBezierLength(pathV[i], pathV[i + 1], pathO[i], pathI[i + 1]);
	        totalLength += lengths[i].addedLength;
	      }

	      if (closed && len) {
	        lengths[i] = getBezierLength(pathV[i], pathV[0], pathO[i], pathI[0]);
	        totalLength += lengths[i].addedLength;
	      }

	      segmentsLength.totalLength = totalLength;
	      return segmentsLength;
	    }

	    function BezierData(length) {
	      this.segmentLength = 0;
	      this.points = new Array(length);
	    }

	    function PointData(partial, point) {
	      this.partialLength = partial;
	      this.point = point;
	    }

	    var buildBezierData = function () {
	      var storedData = {};
	      return function (pt1, pt2, pt3, pt4) {
	        var bezierName = (pt1[0] + '_' + pt1[1] + '_' + pt2[0] + '_' + pt2[1] + '_' + pt3[0] + '_' + pt3[1] + '_' + pt4[0] + '_' + pt4[1]).replace(/\./g, 'p');

	        if (!storedData[bezierName]) {
	          var curveSegments = getDefaultCurveSegments();
	          var k;
	          var i;
	          var len;
	          var ptCoord;
	          var perc;
	          var addedLength = 0;
	          var ptDistance;
	          var point;
	          var lastPoint = null;

	          if (pt1.length === 2 && (pt1[0] !== pt2[0] || pt1[1] !== pt2[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt1[0] + pt3[0], pt1[1] + pt3[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt2[0] + pt4[0], pt2[1] + pt4[1])) {
	            curveSegments = 2;
	          }

	          var bezierData = new BezierData(curveSegments);
	          len = pt3.length;

	          for (k = 0; k < curveSegments; k += 1) {
	            point = createSizedArray(len);
	            perc = k / (curveSegments - 1);
	            ptDistance = 0;

	            for (i = 0; i < len; i += 1) {
	              ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * (pt1[i] + pt3[i]) + 3 * (1 - perc) * bmPow(perc, 2) * (pt2[i] + pt4[i]) + bmPow(perc, 3) * pt2[i];
	              point[i] = ptCoord;

	              if (lastPoint !== null) {
	                ptDistance += bmPow(point[i] - lastPoint[i], 2);
	              }
	            }

	            ptDistance = bmSqrt(ptDistance);
	            addedLength += ptDistance;
	            bezierData.points[k] = new PointData(ptDistance, point);
	            lastPoint = point;
	          }

	          bezierData.segmentLength = addedLength;
	          storedData[bezierName] = bezierData;
	        }

	        return storedData[bezierName];
	      };
	    }();

	    function getDistancePerc(perc, bezierData) {
	      var percents = bezierData.percents;
	      var lengths = bezierData.lengths;
	      var len = percents.length;
	      var initPos = bmFloor((len - 1) * perc);
	      var lengthPos = perc * bezierData.addedLength;
	      var lPerc = 0;

	      if (initPos === len - 1 || initPos === 0 || lengthPos === lengths[initPos]) {
	        return percents[initPos];
	      }

	      var dir = lengths[initPos] > lengthPos ? -1 : 1;
	      var flag = true;

	      while (flag) {
	        if (lengths[initPos] <= lengthPos && lengths[initPos + 1] > lengthPos) {
	          lPerc = (lengthPos - lengths[initPos]) / (lengths[initPos + 1] - lengths[initPos]);
	          flag = false;
	        } else {
	          initPos += dir;
	        }

	        if (initPos < 0 || initPos >= len - 1) {
	          // FIX for TypedArrays that don't store floating point values with enough accuracy
	          if (initPos === len - 1) {
	            return percents[initPos];
	          }

	          flag = false;
	        }
	      }

	      return percents[initPos] + (percents[initPos + 1] - percents[initPos]) * lPerc;
	    }

	    function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
	      var t1 = getDistancePerc(percent, bezierData);
	      var u1 = 1 - t1;
	      var ptX = math.round((u1 * u1 * u1 * pt1[0] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[0] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[0] + t1 * t1 * t1 * pt2[0]) * 1000) / 1000;
	      var ptY = math.round((u1 * u1 * u1 * pt1[1] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[1] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[1] + t1 * t1 * t1 * pt2[1]) * 1000) / 1000;
	      return [ptX, ptY];
	    }

	    var bezierSegmentPoints = createTypedArray('float32', 8);

	    function getNewSegment(pt1, pt2, pt3, pt4, startPerc, endPerc, bezierData) {
	      if (startPerc < 0) {
	        startPerc = 0;
	      } else if (startPerc > 1) {
	        startPerc = 1;
	      }

	      var t0 = getDistancePerc(startPerc, bezierData);
	      endPerc = endPerc > 1 ? 1 : endPerc;
	      var t1 = getDistancePerc(endPerc, bezierData);
	      var i;
	      var len = pt1.length;
	      var u0 = 1 - t0;
	      var u1 = 1 - t1;
	      var u0u0u0 = u0 * u0 * u0;
	      var t0u0u0_3 = t0 * u0 * u0 * 3; // eslint-disable-line camelcase

	      var t0t0u0_3 = t0 * t0 * u0 * 3; // eslint-disable-line camelcase

	      var t0t0t0 = t0 * t0 * t0; //

	      var u0u0u1 = u0 * u0 * u1;
	      var t0u0u1_3 = t0 * u0 * u1 + u0 * t0 * u1 + u0 * u0 * t1; // eslint-disable-line camelcase

	      var t0t0u1_3 = t0 * t0 * u1 + u0 * t0 * t1 + t0 * u0 * t1; // eslint-disable-line camelcase

	      var t0t0t1 = t0 * t0 * t1; //

	      var u0u1u1 = u0 * u1 * u1;
	      var t0u1u1_3 = t0 * u1 * u1 + u0 * t1 * u1 + u0 * u1 * t1; // eslint-disable-line camelcase

	      var t0t1u1_3 = t0 * t1 * u1 + u0 * t1 * t1 + t0 * u1 * t1; // eslint-disable-line camelcase

	      var t0t1t1 = t0 * t1 * t1; //

	      var u1u1u1 = u1 * u1 * u1;
	      var t1u1u1_3 = t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1; // eslint-disable-line camelcase

	      var t1t1u1_3 = t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1; // eslint-disable-line camelcase

	      var t1t1t1 = t1 * t1 * t1;

	      for (i = 0; i < len; i += 1) {
	        bezierSegmentPoints[i * 4] = math.round((u0u0u0 * pt1[i] + t0u0u0_3 * pt3[i] + t0t0u0_3 * pt4[i] + t0t0t0 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase

	        bezierSegmentPoints[i * 4 + 1] = math.round((u0u0u1 * pt1[i] + t0u0u1_3 * pt3[i] + t0t0u1_3 * pt4[i] + t0t0t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase

	        bezierSegmentPoints[i * 4 + 2] = math.round((u0u1u1 * pt1[i] + t0u1u1_3 * pt3[i] + t0t1u1_3 * pt4[i] + t0t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase

	        bezierSegmentPoints[i * 4 + 3] = math.round((u1u1u1 * pt1[i] + t1u1u1_3 * pt3[i] + t1t1u1_3 * pt4[i] + t1t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
	      }

	      return bezierSegmentPoints;
	    }

	    return {
	      getSegmentsLength: getSegmentsLength,
	      getNewSegment: getNewSegment,
	      getPointInSegment: getPointInSegment,
	      buildBezierData: buildBezierData,
	      pointOnLine2D: pointOnLine2D,
	      pointOnLine3D: pointOnLine3D
	    };
	  }

	  var bez = bezFunction();

	  var initFrame = initialDefaultFrame;
	  var mathAbs = Math.abs;

	  function interpolateValue(frameNum, caching) {
	    var offsetTime = this.offsetTime;
	    var newValue;

	    if (this.propType === 'multidimensional') {
	      newValue = createTypedArray('float32', this.pv.length);
	    }

	    var iterationIndex = caching.lastIndex;
	    var i = iterationIndex;
	    var len = this.keyframes.length - 1;
	    var flag = true;
	    var keyData;
	    var nextKeyData;
	    var keyframeMetadata;

	    while (flag) {
	      keyData = this.keyframes[i];
	      nextKeyData = this.keyframes[i + 1];

	      if (i === len - 1 && frameNum >= nextKeyData.t - offsetTime) {
	        if (keyData.h) {
	          keyData = nextKeyData;
	        }

	        iterationIndex = 0;
	        break;
	      }

	      if (nextKeyData.t - offsetTime > frameNum) {
	        iterationIndex = i;
	        break;
	      }

	      if (i < len - 1) {
	        i += 1;
	      } else {
	        iterationIndex = 0;
	        flag = false;
	      }
	    }

	    keyframeMetadata = this.keyframesMetadata[i] || {};
	    var k;
	    var kLen;
	    var perc;
	    var jLen;
	    var j;
	    var fnc;
	    var nextKeyTime = nextKeyData.t - offsetTime;
	    var keyTime = keyData.t - offsetTime;
	    var endValue;

	    if (keyData.to) {
	      if (!keyframeMetadata.bezierData) {
	        keyframeMetadata.bezierData = bez.buildBezierData(keyData.s, nextKeyData.s || keyData.e, keyData.to, keyData.ti);
	      }

	      var bezierData = keyframeMetadata.bezierData;

	      if (frameNum >= nextKeyTime || frameNum < keyTime) {
	        var ind = frameNum >= nextKeyTime ? bezierData.points.length - 1 : 0;
	        kLen = bezierData.points[ind].point.length;

	        for (k = 0; k < kLen; k += 1) {
	          newValue[k] = bezierData.points[ind].point[k];
	        } // caching._lastKeyframeIndex = -1;

	      } else {
	        if (keyframeMetadata.__fnct) {
	          fnc = keyframeMetadata.__fnct;
	        } else {
	          fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
	          keyframeMetadata.__fnct = fnc;
	        }

	        perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
	        var distanceInLine = bezierData.segmentLength * perc;
	        var segmentPerc;
	        var addedLength = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastAddedLength : 0;
	        j = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastPoint : 0;
	        flag = true;
	        jLen = bezierData.points.length;

	        while (flag) {
	          addedLength += bezierData.points[j].partialLength;

	          if (distanceInLine === 0 || perc === 0 || j === bezierData.points.length - 1) {
	            kLen = bezierData.points[j].point.length;

	            for (k = 0; k < kLen; k += 1) {
	              newValue[k] = bezierData.points[j].point[k];
	            }

	            break;
	          } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j + 1].partialLength) {
	            segmentPerc = (distanceInLine - addedLength) / bezierData.points[j + 1].partialLength;
	            kLen = bezierData.points[j].point.length;

	            for (k = 0; k < kLen; k += 1) {
	              newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j + 1].point[k] - bezierData.points[j].point[k]) * segmentPerc;
	            }

	            break;
	          }

	          if (j < jLen - 1) {
	            j += 1;
	          } else {
	            flag = false;
	          }
	        }

	        caching._lastPoint = j;
	        caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
	        caching._lastKeyframeIndex = i;
	      }
	    } else {
	      var outX;
	      var outY;
	      var inX;
	      var inY;
	      var keyValue;
	      len = keyData.s.length;
	      endValue = nextKeyData.s || keyData.e;

	      if (this.sh && keyData.h !== 1) {
	        if (frameNum >= nextKeyTime) {
	          newValue[0] = endValue[0];
	          newValue[1] = endValue[1];
	          newValue[2] = endValue[2];
	        } else if (frameNum <= keyTime) {
	          newValue[0] = keyData.s[0];
	          newValue[1] = keyData.s[1];
	          newValue[2] = keyData.s[2];
	        } else {
	          var quatStart = createQuaternion(keyData.s);
	          var quatEnd = createQuaternion(endValue);
	          var time = (frameNum - keyTime) / (nextKeyTime - keyTime);
	          quaternionToEuler(newValue, slerp(quatStart, quatEnd, time));
	        }
	      } else {
	        for (i = 0; i < len; i += 1) {
	          if (keyData.h !== 1) {
	            if (frameNum >= nextKeyTime) {
	              perc = 1;
	            } else if (frameNum < keyTime) {
	              perc = 0;
	            } else {
	              if (keyData.o.x.constructor === Array) {
	                if (!keyframeMetadata.__fnct) {
	                  keyframeMetadata.__fnct = [];
	                }

	                if (!keyframeMetadata.__fnct[i]) {
	                  outX = keyData.o.x[i] === undefined ? keyData.o.x[0] : keyData.o.x[i];
	                  outY = keyData.o.y[i] === undefined ? keyData.o.y[0] : keyData.o.y[i];
	                  inX = keyData.i.x[i] === undefined ? keyData.i.x[0] : keyData.i.x[i];
	                  inY = keyData.i.y[i] === undefined ? keyData.i.y[0] : keyData.i.y[i];
	                  fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
	                  keyframeMetadata.__fnct[i] = fnc;
	                } else {
	                  fnc = keyframeMetadata.__fnct[i];
	                }
	              } else if (!keyframeMetadata.__fnct) {
	                outX = keyData.o.x;
	                outY = keyData.o.y;
	                inX = keyData.i.x;
	                inY = keyData.i.y;
	                fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
	                keyData.keyframeMetadata = fnc;
	              } else {
	                fnc = keyframeMetadata.__fnct;
	              }

	              perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
	            }
	          }

	          endValue = nextKeyData.s || keyData.e;
	          keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i] + (endValue[i] - keyData.s[i]) * perc;

	          if (this.propType === 'multidimensional') {
	            newValue[i] = keyValue;
	          } else {
	            newValue = keyValue;
	          }
	        }
	      }
	    }

	    caching.lastIndex = iterationIndex;
	    return newValue;
	  } // based on @Toji's https://github.com/toji/gl-matrix/


	  function slerp(a, b, t) {
	    var out = [];
	    var ax = a[0];
	    var ay = a[1];
	    var az = a[2];
	    var aw = a[3];
	    var bx = b[0];
	    var by = b[1];
	    var bz = b[2];
	    var bw = b[3];
	    var omega;
	    var cosom;
	    var sinom;
	    var scale0;
	    var scale1;
	    cosom = ax * bx + ay * by + az * bz + aw * bw;

	    if (cosom < 0.0) {
	      cosom = -cosom;
	      bx = -bx;
	      by = -by;
	      bz = -bz;
	      bw = -bw;
	    }

	    if (1.0 - cosom > 0.000001) {
	      omega = Math.acos(cosom);
	      sinom = Math.sin(omega);
	      scale0 = Math.sin((1.0 - t) * omega) / sinom;
	      scale1 = Math.sin(t * omega) / sinom;
	    } else {
	      scale0 = 1.0 - t;
	      scale1 = t;
	    }

	    out[0] = scale0 * ax + scale1 * bx;
	    out[1] = scale0 * ay + scale1 * by;
	    out[2] = scale0 * az + scale1 * bz;
	    out[3] = scale0 * aw + scale1 * bw;
	    return out;
	  }

	  function quaternionToEuler(out, quat) {
	    var qx = quat[0];
	    var qy = quat[1];
	    var qz = quat[2];
	    var qw = quat[3];
	    var heading = Math.atan2(2 * qy * qw - 2 * qx * qz, 1 - 2 * qy * qy - 2 * qz * qz);
	    var attitude = Math.asin(2 * qx * qy + 2 * qz * qw);
	    var bank = Math.atan2(2 * qx * qw - 2 * qy * qz, 1 - 2 * qx * qx - 2 * qz * qz);
	    out[0] = heading / degToRads;
	    out[1] = attitude / degToRads;
	    out[2] = bank / degToRads;
	  }

	  function createQuaternion(values) {
	    var heading = values[0] * degToRads;
	    var attitude = values[1] * degToRads;
	    var bank = values[2] * degToRads;
	    var c1 = Math.cos(heading / 2);
	    var c2 = Math.cos(attitude / 2);
	    var c3 = Math.cos(bank / 2);
	    var s1 = Math.sin(heading / 2);
	    var s2 = Math.sin(attitude / 2);
	    var s3 = Math.sin(bank / 2);
	    var w = c1 * c2 * c3 - s1 * s2 * s3;
	    var x = s1 * s2 * c3 + c1 * c2 * s3;
	    var y = s1 * c2 * c3 + c1 * s2 * s3;
	    var z = c1 * s2 * c3 - s1 * c2 * s3;
	    return [x, y, z, w];
	  }

	  function getValueAtCurrentTime() {
	    var frameNum = this.comp.renderedFrame - this.offsetTime;
	    var initTime = this.keyframes[0].t - this.offsetTime;
	    var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;

	    if (!(frameNum === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= endTime && frameNum >= endTime || this._caching.lastFrame < initTime && frameNum < initTime))) {
	      if (this._caching.lastFrame >= frameNum) {
	        this._caching._lastKeyframeIndex = -1;
	        this._caching.lastIndex = 0;
	      }

	      var renderResult = this.interpolateValue(frameNum, this._caching);
	      this.pv = renderResult;
	    }

	    this._caching.lastFrame = frameNum;
	    return this.pv;
	  }

	  function setVValue(val) {
	    var multipliedValue;

	    if (this.propType === 'unidimensional') {
	      multipliedValue = val * this.mult;

	      if (mathAbs(this.v - multipliedValue) > 0.00001) {
	        this.v = multipliedValue;
	        this._mdf = true;
	      }
	    } else {
	      var i = 0;
	      var len = this.v.length;

	      while (i < len) {
	        multipliedValue = val[i] * this.mult;

	        if (mathAbs(this.v[i] - multipliedValue) > 0.00001) {
	          this.v[i] = multipliedValue;
	          this._mdf = true;
	        }

	        i += 1;
	      }
	    }
	  }

	  function processEffectsSequence() {
	    if (this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) {
	      return;
	    }

	    if (this.lock) {
	      this.setVValue(this.pv);
	      return;
	    }

	    this.lock = true;
	    this._mdf = this._isFirstFrame;
	    var i;
	    var len = this.effectsSequence.length;
	    var finalValue = this.kf ? this.pv : this.data.k;

	    for (i = 0; i < len; i += 1) {
	      finalValue = this.effectsSequence[i](finalValue);
	    }

	    this.setVValue(finalValue);
	    this._isFirstFrame = false;
	    this.lock = false;
	    this.frameId = this.elem.globalData.frameId;
	  }

	  function addEffect(effectFunction) {
	    this.effectsSequence.push(effectFunction);
	    this.container.addDynamicProperty(this);
	  }

	  function ValueProperty(elem, data, mult, container) {
	    this.propType = 'unidimensional';
	    this.mult = mult || 1;
	    this.data = data;
	    this.v = mult ? data.k * mult : data.k;
	    this.pv = data.k;
	    this._mdf = false;
	    this.elem = elem;
	    this.container = container;
	    this.comp = elem.comp;
	    this.k = false;
	    this.kf = false;
	    this.vel = 0;
	    this.effectsSequence = [];
	    this._isFirstFrame = true;
	    this.getValue = processEffectsSequence;
	    this.setVValue = setVValue;
	    this.addEffect = addEffect;
	  }

	  function MultiDimensionalProperty(elem, data, mult, container) {
	    this.propType = 'multidimensional';
	    this.mult = mult || 1;
	    this.data = data;
	    this._mdf = false;
	    this.elem = elem;
	    this.container = container;
	    this.comp = elem.comp;
	    this.k = false;
	    this.kf = false;
	    this.frameId = -1;
	    var i;
	    var len = data.k.length;
	    this.v = createTypedArray('float32', len);
	    this.pv = createTypedArray('float32', len);
	    this.vel = createTypedArray('float32', len);

	    for (i = 0; i < len; i += 1) {
	      this.v[i] = data.k[i] * this.mult;
	      this.pv[i] = data.k[i];
	    }

	    this._isFirstFrame = true;
	    this.effectsSequence = [];
	    this.getValue = processEffectsSequence;
	    this.setVValue = setVValue;
	    this.addEffect = addEffect;
	  }

	  function KeyframedValueProperty(elem, data, mult, container) {
	    this.propType = 'unidimensional';
	    this.keyframes = data.k;
	    this.keyframesMetadata = [];
	    this.offsetTime = elem.data.st;
	    this.frameId = -1;
	    this._caching = {
	      lastFrame: initFrame,
	      lastIndex: 0,
	      value: 0,
	      _lastKeyframeIndex: -1
	    };
	    this.k = true;
	    this.kf = true;
	    this.data = data;
	    this.mult = mult || 1;
	    this.elem = elem;
	    this.container = container;
	    this.comp = elem.comp;
	    this.v = initFrame;
	    this.pv = initFrame;
	    this._isFirstFrame = true;
	    this.getValue = processEffectsSequence;
	    this.setVValue = setVValue;
	    this.interpolateValue = interpolateValue;
	    this.effectsSequence = [getValueAtCurrentTime.bind(this)];
	    this.addEffect = addEffect;
	  }

	  function KeyframedMultidimensionalProperty(elem, data, mult, container) {
	    this.propType = 'multidimensional';
	    var i;
	    var len = data.k.length;
	    var s;
	    var e;
	    var to;
	    var ti;

	    for (i = 0; i < len - 1; i += 1) {
	      if (data.k[i].to && data.k[i].s && data.k[i + 1] && data.k[i + 1].s) {
	        s = data.k[i].s;
	        e = data.k[i + 1].s;
	        to = data.k[i].to;
	        ti = data.k[i].ti;

	        if (s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], s[0] + to[0], s[1] + to[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], e[0] + ti[0], e[1] + ti[1]) || s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], s[0] + to[0], s[1] + to[1], s[2] + to[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], e[0] + ti[0], e[1] + ti[1], e[2] + ti[2])) {
	          data.k[i].to = null;
	          data.k[i].ti = null;
	        }

	        if (s[0] === e[0] && s[1] === e[1] && to[0] === 0 && to[1] === 0 && ti[0] === 0 && ti[1] === 0) {
	          if (s.length === 2 || s[2] === e[2] && to[2] === 0 && ti[2] === 0) {
	            data.k[i].to = null;
	            data.k[i].ti = null;
	          }
	        }
	      }
	    }

	    this.effectsSequence = [getValueAtCurrentTime.bind(this)];
	    this.data = data;
	    this.keyframes = data.k;
	    this.keyframesMetadata = [];
	    this.offsetTime = elem.data.st;
	    this.k = true;
	    this.kf = true;
	    this._isFirstFrame = true;
	    this.mult = mult || 1;
	    this.elem = elem;
	    this.container = container;
	    this.comp = elem.comp;
	    this.getValue = processEffectsSequence;
	    this.setVValue = setVValue;
	    this.interpolateValue = interpolateValue;
	    this.frameId = -1;
	    var arrLen = data.k[0].s.length;
	    this.v = createTypedArray('float32', arrLen);
	    this.pv = createTypedArray('float32', arrLen);

	    for (i = 0; i < arrLen; i += 1) {
	      this.v[i] = initFrame;
	      this.pv[i] = initFrame;
	    }

	    this._caching = {
	      lastFrame: initFrame,
	      lastIndex: 0,
	      value: createTypedArray('float32', arrLen)
	    };
	    this.addEffect = addEffect;
	  }

	  var PropertyFactory = function () {
	    function getProp(elem, data, type, mult, container) {
	      if (data.sid) {
	        data = elem.globalData.slotManager.getProp(data);
	      }

	      var p;

	      if (!data.k.length) {
	        p = new ValueProperty(elem, data, mult, container);
	      } else if (typeof data.k[0] === 'number') {
	        p = new MultiDimensionalProperty(elem, data, mult, container);
	      } else {
	        switch (type) {
	          case 0:
	            p = new KeyframedValueProperty(elem, data, mult, container);
	            break;

	          case 1:
	            p = new KeyframedMultidimensionalProperty(elem, data, mult, container);
	            break;
	        }
	      }

	      if (p.effectsSequence.length) {
	        container.addDynamicProperty(p);
	      }

	      return p;
	    }

	    var ob = {
	      getProp: getProp
	    };
	    return ob;
	  }();

	  function DynamicPropertyContainer() {}

	  DynamicPropertyContainer.prototype = {
	    addDynamicProperty: function addDynamicProperty(prop) {
	      if (this.dynamicProperties.indexOf(prop) === -1) {
	        this.dynamicProperties.push(prop);
	        this.container.addDynamicProperty(this);
	        this._isAnimated = true;
	      }
	    },
	    iterateDynamicProperties: function iterateDynamicProperties() {
	      this._mdf = false;
	      var i;
	      var len = this.dynamicProperties.length;

	      for (i = 0; i < len; i += 1) {
	        this.dynamicProperties[i].getValue();

	        if (this.dynamicProperties[i]._mdf) {
	          this._mdf = true;
	        }
	      }
	    },
	    initDynamicPropertyContainer: function initDynamicPropertyContainer(container) {
	      this.container = container;
	      this.dynamicProperties = [];
	      this._mdf = false;
	      this._isAnimated = false;
	    }
	  };

	  var pointPool = function () {
	    function create() {
	      return createTypedArray('float32', 2);
	    }

	    return poolFactory(8, create);
	  }();

	  function ShapePath() {
	    this.c = false;
	    this._length = 0;
	    this._maxLength = 8;
	    this.v = createSizedArray(this._maxLength);
	    this.o = createSizedArray(this._maxLength);
	    this.i = createSizedArray(this._maxLength);
	  }

	  ShapePath.prototype.setPathData = function (closed, len) {
	    this.c = closed;
	    this.setLength(len);
	    var i = 0;

	    while (i < len) {
	      this.v[i] = pointPool.newElement();
	      this.o[i] = pointPool.newElement();
	      this.i[i] = pointPool.newElement();
	      i += 1;
	    }
	  };

	  ShapePath.prototype.setLength = function (len) {
	    while (this._maxLength < len) {
	      this.doubleArrayLength();
	    }

	    this._length = len;
	  };

	  ShapePath.prototype.doubleArrayLength = function () {
	    this.v = this.v.concat(createSizedArray(this._maxLength));
	    this.i = this.i.concat(createSizedArray(this._maxLength));
	    this.o = this.o.concat(createSizedArray(this._maxLength));
	    this._maxLength *= 2;
	  };

	  ShapePath.prototype.setXYAt = function (x, y, type, pos, replace) {
	    var arr;
	    this._length = Math.max(this._length, pos + 1);

	    if (this._length >= this._maxLength) {
	      this.doubleArrayLength();
	    }

	    switch (type) {
	      case 'v':
	        arr = this.v;
	        break;

	      case 'i':
	        arr = this.i;
	        break;

	      case 'o':
	        arr = this.o;
	        break;

	      default:
	        arr = [];
	        break;
	    }

	    if (!arr[pos] || arr[pos] && !replace) {
	      arr[pos] = pointPool.newElement();
	    }

	    arr[pos][0] = x;
	    arr[pos][1] = y;
	  };

	  ShapePath.prototype.setTripleAt = function (vX, vY, oX, oY, iX, iY, pos, replace) {
	    this.setXYAt(vX, vY, 'v', pos, replace);
	    this.setXYAt(oX, oY, 'o', pos, replace);
	    this.setXYAt(iX, iY, 'i', pos, replace);
	  };

	  ShapePath.prototype.reverse = function () {
	    var newPath = new ShapePath();
	    newPath.setPathData(this.c, this._length);
	    var vertices = this.v;
	    var outPoints = this.o;
	    var inPoints = this.i;
	    var init = 0;

	    if (this.c) {
	      newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
	      init = 1;
	    }

	    var cnt = this._length - 1;
	    var len = this._length;
	    var i;

	    for (i = init; i < len; i += 1) {
	      newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
	      cnt -= 1;
	    }

	    return newPath;
	  };

	  ShapePath.prototype.length = function () {
	    return this._length;
	  };

	  var shapePool = function () {
	    function create() {
	      return new ShapePath();
	    }

	    function release(shapePath) {
	      var len = shapePath._length;
	      var i;

	      for (i = 0; i < len; i += 1) {
	        pointPool.release(shapePath.v[i]);
	        pointPool.release(shapePath.i[i]);
	        pointPool.release(shapePath.o[i]);
	        shapePath.v[i] = null;
	        shapePath.i[i] = null;
	        shapePath.o[i] = null;
	      }

	      shapePath._length = 0;
	      shapePath.c = false;
	    }

	    function clone(shape) {
	      var cloned = factory.newElement();
	      var i;
	      var len = shape._length === undefined ? shape.v.length : shape._length;
	      cloned.setLength(len);
	      cloned.c = shape.c;

	      for (i = 0; i < len; i += 1) {
	        cloned.setTripleAt(shape.v[i][0], shape.v[i][1], shape.o[i][0], shape.o[i][1], shape.i[i][0], shape.i[i][1], i);
	      }

	      return cloned;
	    }

	    var factory = poolFactory(4, create, release);
	    factory.clone = clone;
	    return factory;
	  }();

	  function ShapeCollection() {
	    this._length = 0;
	    this._maxLength = 4;
	    this.shapes = createSizedArray(this._maxLength);
	  }

	  ShapeCollection.prototype.addShape = function (shapeData) {
	    if (this._length === this._maxLength) {
	      this.shapes = this.shapes.concat(createSizedArray(this._maxLength));
	      this._maxLength *= 2;
	    }

	    this.shapes[this._length] = shapeData;
	    this._length += 1;
	  };

	  ShapeCollection.prototype.releaseShapes = function () {
	    var i;

	    for (i = 0; i < this._length; i += 1) {
	      shapePool.release(this.shapes[i]);
	    }

	    this._length = 0;
	  };

	  var shapeCollectionPool = function () {
	    var ob = {
	      newShapeCollection: newShapeCollection,
	      release: release
	    };
	    var _length = 0;
	    var _maxLength = 4;
	    var pool = createSizedArray(_maxLength);

	    function newShapeCollection() {
	      var shapeCollection;

	      if (_length) {
	        _length -= 1;
	        shapeCollection = pool[_length];
	      } else {
	        shapeCollection = new ShapeCollection();
	      }

	      return shapeCollection;
	    }

	    function release(shapeCollection) {
	      var i;
	      var len = shapeCollection._length;

	      for (i = 0; i < len; i += 1) {
	        shapePool.release(shapeCollection.shapes[i]);
	      }

	      shapeCollection._length = 0;

	      if (_length === _maxLength) {
	        pool = pooling["double"](pool);
	        _maxLength *= 2;
	      }

	      pool[_length] = shapeCollection;
	      _length += 1;
	    }

	    return ob;
	  }();

	  var ShapePropertyFactory = function () {
	    var initFrame = -999999;

	    function interpolateShape(frameNum, previousValue, caching) {
	      var iterationIndex = caching.lastIndex;
	      var keyPropS;
	      var keyPropE;
	      var isHold;
	      var j;
	      var k;
	      var jLen;
	      var kLen;
	      var perc;
	      var vertexValue;
	      var kf = this.keyframes;

	      if (frameNum < kf[0].t - this.offsetTime) {
	        keyPropS = kf[0].s[0];
	        isHold = true;
	        iterationIndex = 0;
	      } else if (frameNum >= kf[kf.length - 1].t - this.offsetTime) {
	        keyPropS = kf[kf.length - 1].s ? kf[kf.length - 1].s[0] : kf[kf.length - 2].e[0];
	        /* if(kf[kf.length - 1].s){
	                  keyPropS = kf[kf.length - 1].s[0];
	              }else{
	                  keyPropS = kf[kf.length - 2].e[0];
	              } */

	        isHold = true;
	      } else {
	        var i = iterationIndex;
	        var len = kf.length - 1;
	        var flag = true;
	        var keyData;
	        var nextKeyData;
	        var keyframeMetadata;

	        while (flag) {
	          keyData = kf[i];
	          nextKeyData = kf[i + 1];

	          if (nextKeyData.t - this.offsetTime > frameNum) {
	            break;
	          }

	          if (i < len - 1) {
	            i += 1;
	          } else {
	            flag = false;
	          }
	        }

	        keyframeMetadata = this.keyframesMetadata[i] || {};
	        isHold = keyData.h === 1;
	        iterationIndex = i;

	        if (!isHold) {
	          if (frameNum >= nextKeyData.t - this.offsetTime) {
	            perc = 1;
	          } else if (frameNum < keyData.t - this.offsetTime) {
	            perc = 0;
	          } else {
	            var fnc;

	            if (keyframeMetadata.__fnct) {
	              fnc = keyframeMetadata.__fnct;
	            } else {
	              fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y).get;
	              keyframeMetadata.__fnct = fnc;
	            }

	            perc = fnc((frameNum - (keyData.t - this.offsetTime)) / (nextKeyData.t - this.offsetTime - (keyData.t - this.offsetTime)));
	          }

	          keyPropE = nextKeyData.s ? nextKeyData.s[0] : keyData.e[0];
	        }

	        keyPropS = keyData.s[0];
	      }

	      jLen = previousValue._length;
	      kLen = keyPropS.i[0].length;
	      caching.lastIndex = iterationIndex;

	      for (j = 0; j < jLen; j += 1) {
	        for (k = 0; k < kLen; k += 1) {
	          vertexValue = isHold ? keyPropS.i[j][k] : keyPropS.i[j][k] + (keyPropE.i[j][k] - keyPropS.i[j][k]) * perc;
	          previousValue.i[j][k] = vertexValue;
	          vertexValue = isHold ? keyPropS.o[j][k] : keyPropS.o[j][k] + (keyPropE.o[j][k] - keyPropS.o[j][k]) * perc;
	          previousValue.o[j][k] = vertexValue;
	          vertexValue = isHold ? keyPropS.v[j][k] : keyPropS.v[j][k] + (keyPropE.v[j][k] - keyPropS.v[j][k]) * perc;
	          previousValue.v[j][k] = vertexValue;
	        }
	      }
	    }

	    function interpolateShapeCurrentTime() {
	      var frameNum = this.comp.renderedFrame - this.offsetTime;
	      var initTime = this.keyframes[0].t - this.offsetTime;
	      var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
	      var lastFrame = this._caching.lastFrame;

	      if (!(lastFrame !== initFrame && (lastFrame < initTime && frameNum < initTime || lastFrame > endTime && frameNum > endTime))) {
	        /// /
	        this._caching.lastIndex = lastFrame < frameNum ? this._caching.lastIndex : 0;
	        this.interpolateShape(frameNum, this.pv, this._caching); /// /
	      }

	      this._caching.lastFrame = frameNum;
	      return this.pv;
	    }

	    function resetShape() {
	      this.paths = this.localShapeCollection;
	    }

	    function shapesEqual(shape1, shape2) {
	      if (shape1._length !== shape2._length || shape1.c !== shape2.c) {
	        return false;
	      }

	      var i;
	      var len = shape1._length;

	      for (i = 0; i < len; i += 1) {
	        if (shape1.v[i][0] !== shape2.v[i][0] || shape1.v[i][1] !== shape2.v[i][1] || shape1.o[i][0] !== shape2.o[i][0] || shape1.o[i][1] !== shape2.o[i][1] || shape1.i[i][0] !== shape2.i[i][0] || shape1.i[i][1] !== shape2.i[i][1]) {
	          return false;
	        }
	      }

	      return true;
	    }

	    function setVValue(newPath) {
	      if (!shapesEqual(this.v, newPath)) {
	        this.v = shapePool.clone(newPath);
	        this.localShapeCollection.releaseShapes();
	        this.localShapeCollection.addShape(this.v);
	        this._mdf = true;
	        this.paths = this.localShapeCollection;
	      }
	    }

	    function processEffectsSequence() {
	      if (this.elem.globalData.frameId === this.frameId) {
	        return;
	      }

	      if (!this.effectsSequence.length) {
	        this._mdf = false;
	        return;
	      }

	      if (this.lock) {
	        this.setVValue(this.pv);
	        return;
	      }

	      this.lock = true;
	      this._mdf = false;
	      var finalValue;

	      if (this.kf) {
	        finalValue = this.pv;
	      } else if (this.data.ks) {
	        finalValue = this.data.ks.k;
	      } else {
	        finalValue = this.data.pt.k;
	      }

	      var i;
	      var len = this.effectsSequence.length;

	      for (i = 0; i < len; i += 1) {
	        finalValue = this.effectsSequence[i](finalValue);
	      }

	      this.setVValue(finalValue);
	      this.lock = false;
	      this.frameId = this.elem.globalData.frameId;
	    }

	    function ShapeProperty(elem, data, type) {
	      this.propType = 'shape';
	      this.comp = elem.comp;
	      this.container = elem;
	      this.elem = elem;
	      this.data = data;
	      this.k = false;
	      this.kf = false;
	      this._mdf = false;
	      var pathData = type === 3 ? data.pt.k : data.ks.k;
	      this.v = shapePool.clone(pathData);
	      this.pv = shapePool.clone(this.v);
	      this.localShapeCollection = shapeCollectionPool.newShapeCollection();
	      this.paths = this.localShapeCollection;
	      this.paths.addShape(this.v);
	      this.reset = resetShape;
	      this.effectsSequence = [];
	    }

	    function addEffect(effectFunction) {
	      this.effectsSequence.push(effectFunction);
	      this.container.addDynamicProperty(this);
	    }

	    ShapeProperty.prototype.interpolateShape = interpolateShape;
	    ShapeProperty.prototype.getValue = processEffectsSequence;
	    ShapeProperty.prototype.setVValue = setVValue;
	    ShapeProperty.prototype.addEffect = addEffect;

	    function KeyframedShapeProperty(elem, data, type) {
	      this.propType = 'shape';
	      this.comp = elem.comp;
	      this.elem = elem;
	      this.container = elem;
	      this.offsetTime = elem.data.st;
	      this.keyframes = type === 3 ? data.pt.k : data.ks.k;
	      this.keyframesMetadata = [];
	      this.k = true;
	      this.kf = true;
	      var len = this.keyframes[0].s[0].i.length;
	      this.v = shapePool.newElement();
	      this.v.setPathData(this.keyframes[0].s[0].c, len);
	      this.pv = shapePool.clone(this.v);
	      this.localShapeCollection = shapeCollectionPool.newShapeCollection();
	      this.paths = this.localShapeCollection;
	      this.paths.addShape(this.v);
	      this.lastFrame = initFrame;
	      this.reset = resetShape;
	      this._caching = {
	        lastFrame: initFrame,
	        lastIndex: 0
	      };
	      this.effectsSequence = [interpolateShapeCurrentTime.bind(this)];
	    }

	    KeyframedShapeProperty.prototype.getValue = processEffectsSequence;
	    KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
	    KeyframedShapeProperty.prototype.setVValue = setVValue;
	    KeyframedShapeProperty.prototype.addEffect = addEffect;

	    var EllShapeProperty = function () {
	      var cPoint = roundCorner;

	      function EllShapePropertyFactory(elem, data) {
	        this.v = shapePool.newElement();
	        this.v.setPathData(true, 4);
	        this.localShapeCollection = shapeCollectionPool.newShapeCollection();
	        this.paths = this.localShapeCollection;
	        this.localShapeCollection.addShape(this.v);
	        this.d = data.d;
	        this.elem = elem;
	        this.comp = elem.comp;
	        this.frameId = -1;
	        this.initDynamicPropertyContainer(elem);
	        this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
	        this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);

	        if (this.dynamicProperties.length) {
	          this.k = true;
	        } else {
	          this.k = false;
	          this.convertEllToPath();
	        }
	      }

	      EllShapePropertyFactory.prototype = {
	        reset: resetShape,
	        getValue: function getValue() {
	          if (this.elem.globalData.frameId === this.frameId) {
	            return;
	          }

	          this.frameId = this.elem.globalData.frameId;
	          this.iterateDynamicProperties();

	          if (this._mdf) {
	            this.convertEllToPath();
	          }
	        },
	        convertEllToPath: function convertEllToPath() {
	          var p0 = this.p.v[0];
	          var p1 = this.p.v[1];
	          var s0 = this.s.v[0] / 2;
	          var s1 = this.s.v[1] / 2;

	          var _cw = this.d !== 3;

	          var _v = this.v;
	          _v.v[0][0] = p0;
	          _v.v[0][1] = p1 - s1;
	          _v.v[1][0] = _cw ? p0 + s0 : p0 - s0;
	          _v.v[1][1] = p1;
	          _v.v[2][0] = p0;
	          _v.v[2][1] = p1 + s1;
	          _v.v[3][0] = _cw ? p0 - s0 : p0 + s0;
	          _v.v[3][1] = p1;
	          _v.i[0][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
	          _v.i[0][1] = p1 - s1;
	          _v.i[1][0] = _cw ? p0 + s0 : p0 - s0;
	          _v.i[1][1] = p1 - s1 * cPoint;
	          _v.i[2][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
	          _v.i[2][1] = p1 + s1;
	          _v.i[3][0] = _cw ? p0 - s0 : p0 + s0;
	          _v.i[3][1] = p1 + s1 * cPoint;
	          _v.o[0][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
	          _v.o[0][1] = p1 - s1;
	          _v.o[1][0] = _cw ? p0 + s0 : p0 - s0;
	          _v.o[1][1] = p1 + s1 * cPoint;
	          _v.o[2][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
	          _v.o[2][1] = p1 + s1;
	          _v.o[3][0] = _cw ? p0 - s0 : p0 + s0;
	          _v.o[3][1] = p1 - s1 * cPoint;
	        }
	      };
	      extendPrototype([DynamicPropertyContainer], EllShapePropertyFactory);
	      return EllShapePropertyFactory;
	    }();

	    var StarShapeProperty = function () {
	      function StarShapePropertyFactory(elem, data) {
	        this.v = shapePool.newElement();
	        this.v.setPathData(true, 0);
	        this.elem = elem;
	        this.comp = elem.comp;
	        this.data = data;
	        this.frameId = -1;
	        this.d = data.d;
	        this.initDynamicPropertyContainer(elem);

	        if (data.sy === 1) {
	          this.ir = PropertyFactory.getProp(elem, data.ir, 0, 0, this);
	          this.is = PropertyFactory.getProp(elem, data.is, 0, 0.01, this);
	          this.convertToPath = this.convertStarToPath;
	        } else {
	          this.convertToPath = this.convertPolygonToPath;
	        }

	        this.pt = PropertyFactory.getProp(elem, data.pt, 0, 0, this);
	        this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
	        this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this);
	        this.or = PropertyFactory.getProp(elem, data.or, 0, 0, this);
	        this.os = PropertyFactory.getProp(elem, data.os, 0, 0.01, this);
	        this.localShapeCollection = shapeCollectionPool.newShapeCollection();
	        this.localShapeCollection.addShape(this.v);
	        this.paths = this.localShapeCollection;

	        if (this.dynamicProperties.length) {
	          this.k = true;
	        } else {
	          this.k = false;
	          this.convertToPath();
	        }
	      }

	      StarShapePropertyFactory.prototype = {
	        reset: resetShape,
	        getValue: function getValue() {
	          if (this.elem.globalData.frameId === this.frameId) {
	            return;
	          }

	          this.frameId = this.elem.globalData.frameId;
	          this.iterateDynamicProperties();

	          if (this._mdf) {
	            this.convertToPath();
	          }
	        },
	        convertStarToPath: function convertStarToPath() {
	          var numPts = Math.floor(this.pt.v) * 2;
	          var angle = Math.PI * 2 / numPts;
	          /* this.v.v.length = numPts;
	                  this.v.i.length = numPts;
	                  this.v.o.length = numPts; */

	          var longFlag = true;
	          var longRad = this.or.v;
	          var shortRad = this.ir.v;
	          var longRound = this.os.v;
	          var shortRound = this.is.v;
	          var longPerimSegment = 2 * Math.PI * longRad / (numPts * 2);
	          var shortPerimSegment = 2 * Math.PI * shortRad / (numPts * 2);
	          var i;
	          var rad;
	          var roundness;
	          var perimSegment;
	          var currentAng = -Math.PI / 2;
	          currentAng += this.r.v;
	          var dir = this.data.d === 3 ? -1 : 1;
	          this.v._length = 0;

	          for (i = 0; i < numPts; i += 1) {
	            rad = longFlag ? longRad : shortRad;
	            roundness = longFlag ? longRound : shortRound;
	            perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
	            var x = rad * Math.cos(currentAng);
	            var y = rad * Math.sin(currentAng);
	            var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
	            var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
	            x += +this.p.v[0];
	            y += +this.p.v[1];
	            this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
	            /* this.v.v[i] = [x,y];
	                      this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
	                      this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
	                      this.v._length = numPts; */

	            longFlag = !longFlag;
	            currentAng += angle * dir;
	          }
	        },
	        convertPolygonToPath: function convertPolygonToPath() {
	          var numPts = Math.floor(this.pt.v);
	          var angle = Math.PI * 2 / numPts;
	          var rad = this.or.v;
	          var roundness = this.os.v;
	          var perimSegment = 2 * Math.PI * rad / (numPts * 4);
	          var i;
	          var currentAng = -Math.PI * 0.5;
	          var dir = this.data.d === 3 ? -1 : 1;
	          currentAng += this.r.v;
	          this.v._length = 0;

	          for (i = 0; i < numPts; i += 1) {
	            var x = rad * Math.cos(currentAng);
	            var y = rad * Math.sin(currentAng);
	            var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
	            var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
	            x += +this.p.v[0];
	            y += +this.p.v[1];
	            this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
	            currentAng += angle * dir;
	          }

	          this.paths.length = 0;
	          this.paths[0] = this.v;
	        }
	      };
	      extendPrototype([DynamicPropertyContainer], StarShapePropertyFactory);
	      return StarShapePropertyFactory;
	    }();

	    var RectShapeProperty = function () {
	      function RectShapePropertyFactory(elem, data) {
	        this.v = shapePool.newElement();
	        this.v.c = true;
	        this.localShapeCollection = shapeCollectionPool.newShapeCollection();
	        this.localShapeCollection.addShape(this.v);
	        this.paths = this.localShapeCollection;
	        this.elem = elem;
	        this.comp = elem.comp;
	        this.frameId = -1;
	        this.d = data.d;
	        this.initDynamicPropertyContainer(elem);
	        this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
	        this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
	        this.r = PropertyFactory.getProp(elem, data.r, 0, 0, this);

	        if (this.dynamicProperties.length) {
	          this.k = true;
	        } else {
	          this.k = false;
	          this.convertRectToPath();
	        }
	      }

	      RectShapePropertyFactory.prototype = {
	        convertRectToPath: function convertRectToPath() {
	          var p0 = this.p.v[0];
	          var p1 = this.p.v[1];
	          var v0 = this.s.v[0] / 2;
	          var v1 = this.s.v[1] / 2;
	          var round = bmMin(v0, v1, this.r.v);
	          var cPoint = round * (1 - roundCorner);
	          this.v._length = 0;

	          if (this.d === 2 || this.d === 1) {
	            this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, 0, true);
	            this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, p0 + v0, p1 + v1 - round, 1, true);

	            if (round !== 0) {
	              this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, 2, true);
	              this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0 + round, p1 + v1, 3, true);
	              this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, 4, true);
	              this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1 + round, 5, true);
	              this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, 6, true);
	              this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, p0 + v0 - round, p1 - v1, 7, true);
	            } else {
	              this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0, p1 + v1, 2);
	              this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1, 3);
	            }
	          } else {
	            this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, p0 + v0, p1 - v1 + round, 0, true);

	            if (round !== 0) {
	              this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, 1, true);
	              this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0 + round, p1 - v1, 2, true);
	              this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, 3, true);
	              this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1 - round, 4, true);
	              this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, 5, true);
	              this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0 - round, p1 + v1, 6, true);
	              this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, 7, true);
	            } else {
	              this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0, p1 - v1, 1, true);
	              this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1, 2, true);
	              this.v.setTripleAt(p0 + v0, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0, p1 + v1, 3, true);
	            }
	          }
	        },
	        getValue: function getValue() {
	          if (this.elem.globalData.frameId === this.frameId) {
	            return;
	          }

	          this.frameId = this.elem.globalData.frameId;
	          this.iterateDynamicProperties();

	          if (this._mdf) {
	            this.convertRectToPath();
	          }
	        },
	        reset: resetShape
	      };
	      extendPrototype([DynamicPropertyContainer], RectShapePropertyFactory);
	      return RectShapePropertyFactory;
	    }();

	    function getShapeProp(elem, data, type) {
	      var prop;

	      if (type === 3 || type === 4) {
	        var dataProp = type === 3 ? data.pt : data.ks;
	        var keys = dataProp.k;

	        if (keys.length) {
	          prop = new KeyframedShapeProperty(elem, data, type);
	        } else {
	          prop = new ShapeProperty(elem, data, type);
	        }
	      } else if (type === 5) {
	        prop = new RectShapeProperty(elem, data);
	      } else if (type === 6) {
	        prop = new EllShapeProperty(elem, data);
	      } else if (type === 7) {
	        prop = new StarShapeProperty(elem, data);
	      }

	      if (prop.k) {
	        elem.addDynamicProperty(prop);
	      }

	      return prop;
	    }

	    function getConstructorFunction() {
	      return ShapeProperty;
	    }

	    function getKeyframedConstructorFunction() {
	      return KeyframedShapeProperty;
	    }

	    var ob = {};
	    ob.getShapeProp = getShapeProp;
	    ob.getConstructorFunction = getConstructorFunction;
	    ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
	    return ob;
	  }();

	  /*!
	   Transformation Matrix v2.0
	   (c) Epistemex 2014-2015
	   www.epistemex.com
	   By Ken Fyrstenberg
	   Contributions by leeoniya.
	   License: MIT, header required.
	   */

	  /**
	   * 2D transformation matrix object initialized with identity matrix.
	   *
	   * The matrix can synchronize a canvas context by supplying the context
	   * as an argument, or later apply current absolute transform to an
	   * existing context.
	   *
	   * All values are handled as floating point values.
	   *
	   * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
	   * @prop {number} a - scale x
	   * @prop {number} b - shear y
	   * @prop {number} c - shear x
	   * @prop {number} d - scale y
	   * @prop {number} e - translate x
	   * @prop {number} f - translate y
	   * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
	   * @constructor
	   */

	  var Matrix = function () {
	    var _cos = Math.cos;
	    var _sin = Math.sin;
	    var _tan = Math.tan;
	    var _rnd = Math.round;

	    function reset() {
	      this.props[0] = 1;
	      this.props[1] = 0;
	      this.props[2] = 0;
	      this.props[3] = 0;
	      this.props[4] = 0;
	      this.props[5] = 1;
	      this.props[6] = 0;
	      this.props[7] = 0;
	      this.props[8] = 0;
	      this.props[9] = 0;
	      this.props[10] = 1;
	      this.props[11] = 0;
	      this.props[12] = 0;
	      this.props[13] = 0;
	      this.props[14] = 0;
	      this.props[15] = 1;
	      return this;
	    }

	    function rotate(angle) {
	      if (angle === 0) {
	        return this;
	      }

	      var mCos = _cos(angle);

	      var mSin = _sin(angle);

	      return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
	    }

	    function rotateX(angle) {
	      if (angle === 0) {
	        return this;
	      }

	      var mCos = _cos(angle);

	      var mSin = _sin(angle);

	      return this._t(1, 0, 0, 0, 0, mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1);
	    }

	    function rotateY(angle) {
	      if (angle === 0) {
	        return this;
	      }

	      var mCos = _cos(angle);

	      var mSin = _sin(angle);

	      return this._t(mCos, 0, mSin, 0, 0, 1, 0, 0, -mSin, 0, mCos, 0, 0, 0, 0, 1);
	    }

	    function rotateZ(angle) {
	      if (angle === 0) {
	        return this;
	      }

	      var mCos = _cos(angle);

	      var mSin = _sin(angle);

	      return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
	    }

	    function shear(sx, sy) {
	      return this._t(1, sy, sx, 1, 0, 0);
	    }

	    function skew(ax, ay) {
	      return this.shear(_tan(ax), _tan(ay));
	    }

	    function skewFromAxis(ax, angle) {
	      var mCos = _cos(angle);

	      var mSin = _sin(angle);

	      return this._t(mCos, mSin, 0, 0, -mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, _tan(ax), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); // return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
	    }

	    function scale(sx, sy, sz) {
	      if (!sz && sz !== 0) {
	        sz = 1;
	      }

	      if (sx === 1 && sy === 1 && sz === 1) {
	        return this;
	      }

	      return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
	    }

	    function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
	      this.props[0] = a;
	      this.props[1] = b;
	      this.props[2] = c;
	      this.props[3] = d;
	      this.props[4] = e;
	      this.props[5] = f;
	      this.props[6] = g;
	      this.props[7] = h;
	      this.props[8] = i;
	      this.props[9] = j;
	      this.props[10] = k;
	      this.props[11] = l;
	      this.props[12] = m;
	      this.props[13] = n;
	      this.props[14] = o;
	      this.props[15] = p;
	      return this;
	    }

	    function translate(tx, ty, tz) {
	      tz = tz || 0;

	      if (tx !== 0 || ty !== 0 || tz !== 0) {
	        return this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, tx, ty, tz, 1);
	      }

	      return this;
	    }

	    function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
	      var _p = this.props;

	      if (a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0) {
	        // NOTE: commenting this condition because TurboFan deoptimizes code when present
	        // if(m2 !== 0 || n2 !== 0 || o2 !== 0){
	        _p[12] = _p[12] * a2 + _p[15] * m2;
	        _p[13] = _p[13] * f2 + _p[15] * n2;
	        _p[14] = _p[14] * k2 + _p[15] * o2;
	        _p[15] *= p2; // }

	        this._identityCalculated = false;
	        return this;
	      }

	      var a1 = _p[0];
	      var b1 = _p[1];
	      var c1 = _p[2];
	      var d1 = _p[3];
	      var e1 = _p[4];
	      var f1 = _p[5];
	      var g1 = _p[6];
	      var h1 = _p[7];
	      var i1 = _p[8];
	      var j1 = _p[9];
	      var k1 = _p[10];
	      var l1 = _p[11];
	      var m1 = _p[12];
	      var n1 = _p[13];
	      var o1 = _p[14];
	      var p1 = _p[15];
	      /* matrix order (canvas compatible):
	           * ace
	           * bdf
	           * 001
	           */

	      _p[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
	      _p[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2;
	      _p[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2;
	      _p[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2;
	      _p[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2;
	      _p[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2;
	      _p[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2;
	      _p[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2;
	      _p[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2;
	      _p[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2;
	      _p[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2;
	      _p[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2;
	      _p[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2;
	      _p[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2;
	      _p[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2;
	      _p[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2;
	      this._identityCalculated = false;
	      return this;
	    }

	    function multiply(matrix) {
	      var matrixProps = matrix.props;
	      return this.transform(matrixProps[0], matrixProps[1], matrixProps[2], matrixProps[3], matrixProps[4], matrixProps[5], matrixProps[6], matrixProps[7], matrixProps[8], matrixProps[9], matrixProps[10], matrixProps[11], matrixProps[12], matrixProps[13], matrixProps[14], matrixProps[15]);
	    }

	    function isIdentity() {
	      if (!this._identityCalculated) {
	        this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
	        this._identityCalculated = true;
	      }

	      return this._identity;
	    }

	    function equals(matr) {
	      var i = 0;

	      while (i < 16) {
	        if (matr.props[i] !== this.props[i]) {
	          return false;
	        }

	        i += 1;
	      }

	      return true;
	    }

	    function clone(matr) {
	      var i;

	      for (i = 0; i < 16; i += 1) {
	        matr.props[i] = this.props[i];
	      }

	      return matr;
	    }

	    function cloneFromProps(props) {
	      var i;

	      for (i = 0; i < 16; i += 1) {
	        this.props[i] = props[i];
	      }
	    }

	    function applyToPoint(x, y, z) {
	      return {
	        x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
	        y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
	        z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
	      };
	      /* return {
	           x: x * me.a + y * me.c + me.e,
	           y: x * me.b + y * me.d + me.f
	           }; */
	    }

	    function applyToX(x, y, z) {
	      return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
	    }

	    function applyToY(x, y, z) {
	      return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
	    }

	    function applyToZ(x, y, z) {
	      return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
	    }

	    function getInverseMatrix() {
	      var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
	      var a = this.props[5] / determinant;
	      var b = -this.props[1] / determinant;
	      var c = -this.props[4] / determinant;
	      var d = this.props[0] / determinant;
	      var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / determinant;
	      var f = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / determinant;
	      var inverseMatrix = new Matrix();
	      inverseMatrix.props[0] = a;
	      inverseMatrix.props[1] = b;
	      inverseMatrix.props[4] = c;
	      inverseMatrix.props[5] = d;
	      inverseMatrix.props[12] = e;
	      inverseMatrix.props[13] = f;
	      return inverseMatrix;
	    }

	    function inversePoint(pt) {
	      var inverseMatrix = this.getInverseMatrix();
	      return inverseMatrix.applyToPointArray(pt[0], pt[1], pt[2] || 0);
	    }

	    function inversePoints(pts) {
	      var i;
	      var len = pts.length;
	      var retPts = [];

	      for (i = 0; i < len; i += 1) {
	        retPts[i] = inversePoint(pts[i]);
	      }

	      return retPts;
	    }

	    function applyToTriplePoints(pt1, pt2, pt3) {
	      var arr = createTypedArray('float32', 6);

	      if (this.isIdentity()) {
	        arr[0] = pt1[0];
	        arr[1] = pt1[1];
	        arr[2] = pt2[0];
	        arr[3] = pt2[1];
	        arr[4] = pt3[0];
	        arr[5] = pt3[1];
	      } else {
	        var p0 = this.props[0];
	        var p1 = this.props[1];
	        var p4 = this.props[4];
	        var p5 = this.props[5];
	        var p12 = this.props[12];
	        var p13 = this.props[13];
	        arr[0] = pt1[0] * p0 + pt1[1] * p4 + p12;
	        arr[1] = pt1[0] * p1 + pt1[1] * p5 + p13;
	        arr[2] = pt2[0] * p0 + pt2[1] * p4 + p12;
	        arr[3] = pt2[0] * p1 + pt2[1] * p5 + p13;
	        arr[4] = pt3[0] * p0 + pt3[1] * p4 + p12;
	        arr[5] = pt3[0] * p1 + pt3[1] * p5 + p13;
	      }

	      return arr;
	    }

	    function applyToPointArray(x, y, z) {
	      var arr;

	      if (this.isIdentity()) {
	        arr = [x, y, z];
	      } else {
	        arr = [x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12], x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13], x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]];
	      }

	      return arr;
	    }

	    function applyToPointStringified(x, y) {
	      if (this.isIdentity()) {
	        return x + ',' + y;
	      }

	      var _p = this.props;
	      return Math.round((x * _p[0] + y * _p[4] + _p[12]) * 100) / 100 + ',' + Math.round((x * _p[1] + y * _p[5] + _p[13]) * 100) / 100;
	    }

	    function toCSS() {
	      // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.

	      /* if(this.isIdentity()) {
	              return '';
	          } */
	      var i = 0;
	      var props = this.props;
	      var cssValue = 'matrix3d(';
	      var v = 10000;

	      while (i < 16) {
	        cssValue += _rnd(props[i] * v) / v;
	        cssValue += i === 15 ? ')' : ',';
	        i += 1;
	      }

	      return cssValue;
	    }

	    function roundMatrixProperty(val) {
	      var v = 10000;

	      if (val < 0.000001 && val > 0 || val > -0.000001 && val < 0) {
	        return _rnd(val * v) / v;
	      }

	      return val;
	    }

	    function to2dCSS() {
	      // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.

	      /* if(this.isIdentity()) {
	              return '';
	          } */
	      var props = this.props;

	      var _a = roundMatrixProperty(props[0]);

	      var _b = roundMatrixProperty(props[1]);

	      var _c = roundMatrixProperty(props[4]);

	      var _d = roundMatrixProperty(props[5]);

	      var _e = roundMatrixProperty(props[12]);

	      var _f = roundMatrixProperty(props[13]);

	      return 'matrix(' + _a + ',' + _b + ',' + _c + ',' + _d + ',' + _e + ',' + _f + ')';
	    }

	    return function () {
	      this.reset = reset;
	      this.rotate = rotate;
	      this.rotateX = rotateX;
	      this.rotateY = rotateY;
	      this.rotateZ = rotateZ;
	      this.skew = skew;
	      this.skewFromAxis = skewFromAxis;
	      this.shear = shear;
	      this.scale = scale;
	      this.setTransform = setTransform;
	      this.translate = translate;
	      this.transform = transform;
	      this.multiply = multiply;
	      this.applyToPoint = applyToPoint;
	      this.applyToX = applyToX;
	      this.applyToY = applyToY;
	      this.applyToZ = applyToZ;
	      this.applyToPointArray = applyToPointArray;
	      this.applyToTriplePoints = applyToTriplePoints;
	      this.applyToPointStringified = applyToPointStringified;
	      this.toCSS = toCSS;
	      this.to2dCSS = to2dCSS;
	      this.clone = clone;
	      this.cloneFromProps = cloneFromProps;
	      this.equals = equals;
	      this.inversePoints = inversePoints;
	      this.inversePoint = inversePoint;
	      this.getInverseMatrix = getInverseMatrix;
	      this._t = this.transform;
	      this.isIdentity = isIdentity;
	      this._identity = true;
	      this._identityCalculated = false;
	      this.props = createTypedArray('float32', 16);
	      this.reset();
	    };
	  }();

	  function _typeof$3(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$3 = function _typeof(obj) { return typeof obj; }; } else { _typeof$3 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$3(obj); }
	  var lottie = {};

	  function setLocation(href) {
	    setLocationHref(href);
	  }

	  function searchAnimations() {
	    {
	      animationManager.searchAnimations();
	    }
	  }

	  function setSubframeRendering(flag) {
	    setSubframeEnabled(flag);
	  }

	  function setPrefix(prefix) {
	    setIdPrefix(prefix);
	  }

	  function loadAnimation(params) {

	    return animationManager.loadAnimation(params);
	  }

	  function setQuality(value) {
	    if (typeof value === 'string') {
	      switch (value) {
	        case 'high':
	          setDefaultCurveSegments(200);
	          break;

	        default:
	        case 'medium':
	          setDefaultCurveSegments(50);
	          break;

	        case 'low':
	          setDefaultCurveSegments(10);
	          break;
	      }
	    } else if (!isNaN(value) && value > 1) {
	      setDefaultCurveSegments(value);
	    }
	  }

	  function inBrowser() {
	    return typeof navigator !== 'undefined';
	  }

	  function installPlugin(type, plugin) {
	    if (type === 'expressions') {
	      setExpressionsPlugin(plugin);
	    }
	  }

	  function getFactory(name) {
	    switch (name) {
	      case 'propertyFactory':
	        return PropertyFactory;

	      case 'shapePropertyFactory':
	        return ShapePropertyFactory;

	      case 'matrix':
	        return Matrix;

	      default:
	        return null;
	    }
	  }

	  lottie.play = animationManager.play;
	  lottie.pause = animationManager.pause;
	  lottie.setLocationHref = setLocation;
	  lottie.togglePause = animationManager.togglePause;
	  lottie.setSpeed = animationManager.setSpeed;
	  lottie.setDirection = animationManager.setDirection;
	  lottie.stop = animationManager.stop;
	  lottie.searchAnimations = searchAnimations;
	  lottie.registerAnimation = animationManager.registerAnimation;
	  lottie.loadAnimation = loadAnimation;
	  lottie.setSubframeRendering = setSubframeRendering;
	  lottie.resize = animationManager.resize; // lottie.start = start;

	  lottie.goToAndStop = animationManager.goToAndStop;
	  lottie.destroy = animationManager.destroy;
	  lottie.setQuality = setQuality;
	  lottie.inBrowser = inBrowser;
	  lottie.installPlugin = installPlugin;
	  lottie.freeze = animationManager.freeze;
	  lottie.unfreeze = animationManager.unfreeze;
	  lottie.setVolume = animationManager.setVolume;
	  lottie.mute = animationManager.mute;
	  lottie.unmute = animationManager.unmute;
	  lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations;
	  lottie.useWebWorker = setWebWorker;
	  lottie.setIDPrefix = setPrefix;
	  lottie.__getFactory = getFactory;
	  lottie.version = '5.12.2';

	  function checkReady() {
	    if (document.readyState === 'complete') {
	      clearInterval(readyStateCheckInterval);
	      searchAnimations();
	    }
	  }

	  function getQueryVariable(variable) {
	    var vars = queryString.split('&');

	    for (var i = 0; i < vars.length; i += 1) {
	      var pair = vars[i].split('=');

	      if (decodeURIComponent(pair[0]) == variable) {
	        // eslint-disable-line eqeqeq
	        return decodeURIComponent(pair[1]);
	      }
	    }

	    return null;
	  }

	  var queryString = '';

	  {
	    var scripts = document.getElementsByTagName('script');
	    var index = scripts.length - 1;
	    var myScript = scripts[index] || {
	      src: ''
	    };
	    queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, '') : ''; // eslint-disable-line no-useless-escape

	    getQueryVariable('renderer');
	  }

	  var readyStateCheckInterval = setInterval(checkReady, 100); // this adds bodymovin to the window object for backwards compatibility

	  try {
	    if (!(('object' === "undefined" ? "undefined" : _typeof$3(exports)) === 'object' && 'object' !== 'undefined') && !(typeof undefined === 'function' && undefined.amd) // eslint-disable-line no-undef
	    ) {
	      window.bodymovin = lottie;
	    }
	  } catch (err) {//
	  }

	  var ShapeModifiers = function () {
	    var ob = {};
	    var modifiers = {};
	    ob.registerModifier = registerModifier;
	    ob.getModifier = getModifier;

	    function registerModifier(nm, factory) {
	      if (!modifiers[nm]) {
	        modifiers[nm] = factory;
	      }
	    }

	    function getModifier(nm, elem, data) {
	      return new modifiers[nm](elem, data);
	    }

	    return ob;
	  }();

	  function ShapeModifier() {}

	  ShapeModifier.prototype.initModifierProperties = function () {};

	  ShapeModifier.prototype.addShapeToModifier = function () {};

	  ShapeModifier.prototype.addShape = function (data) {
	    if (!this.closed) {
	      // Adding shape to dynamic properties. It covers the case where a shape has no effects applied, to reset it's _mdf state on every tick.
	      data.sh.container.addDynamicProperty(data.sh);
	      var shapeData = {
	        shape: data.sh,
	        data: data,
	        localShapeCollection: shapeCollectionPool.newShapeCollection()
	      };
	      this.shapes.push(shapeData);
	      this.addShapeToModifier(shapeData);

	      if (this._isAnimated) {
	        data.setAsAnimated();
	      }
	    }
	  };

	  ShapeModifier.prototype.init = function (elem, data) {
	    this.shapes = [];
	    this.elem = elem;
	    this.initDynamicPropertyContainer(elem);
	    this.initModifierProperties(elem, data);
	    this.frameId = initialDefaultFrame;
	    this.closed = false;
	    this.k = false;

	    if (this.dynamicProperties.length) {
	      this.k = true;
	    } else {
	      this.getValue(true);
	    }
	  };

	  ShapeModifier.prototype.processKeys = function () {
	    if (this.elem.globalData.frameId === this.frameId) {
	      return;
	    }

	    this.frameId = this.elem.globalData.frameId;
	    this.iterateDynamicProperties();
	  };

	  extendPrototype([DynamicPropertyContainer], ShapeModifier);

	  function TrimModifier() {}

	  extendPrototype([ShapeModifier], TrimModifier);

	  TrimModifier.prototype.initModifierProperties = function (elem, data) {
	    this.s = PropertyFactory.getProp(elem, data.s, 0, 0.01, this);
	    this.e = PropertyFactory.getProp(elem, data.e, 0, 0.01, this);
	    this.o = PropertyFactory.getProp(elem, data.o, 0, 0, this);
	    this.sValue = 0;
	    this.eValue = 0;
	    this.getValue = this.processKeys;
	    this.m = data.m;
	    this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
	  };

	  TrimModifier.prototype.addShapeToModifier = function (shapeData) {
	    shapeData.pathsData = [];
	  };

	  TrimModifier.prototype.calculateShapeEdges = function (s, e, shapeLength, addedLength, totalModifierLength) {
	    var segments = [];

	    if (e <= 1) {
	      segments.push({
	        s: s,
	        e: e
	      });
	    } else if (s >= 1) {
	      segments.push({
	        s: s - 1,
	        e: e - 1
	      });
	    } else {
	      segments.push({
	        s: s,
	        e: 1
	      });
	      segments.push({
	        s: 0,
	        e: e - 1
	      });
	    }

	    var shapeSegments = [];
	    var i;
	    var len = segments.length;
	    var segmentOb;

	    for (i = 0; i < len; i += 1) {
	      segmentOb = segments[i];

	      if (!(segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength)) {
	        var shapeS;
	        var shapeE;

	        if (segmentOb.s * totalModifierLength <= addedLength) {
	          shapeS = 0;
	        } else {
	          shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
	        }

	        if (segmentOb.e * totalModifierLength >= addedLength + shapeLength) {
	          shapeE = 1;
	        } else {
	          shapeE = (segmentOb.e * totalModifierLength - addedLength) / shapeLength;
	        }

	        shapeSegments.push([shapeS, shapeE]);
	      }
	    }

	    if (!shapeSegments.length) {
	      shapeSegments.push([0, 0]);
	    }

	    return shapeSegments;
	  };

	  TrimModifier.prototype.releasePathsData = function (pathsData) {
	    var i;
	    var len = pathsData.length;

	    for (i = 0; i < len; i += 1) {
	      segmentsLengthPool.release(pathsData[i]);
	    }

	    pathsData.length = 0;
	    return pathsData;
	  };

	  TrimModifier.prototype.processShapes = function (_isFirstFrame) {
	    var s;
	    var e;

	    if (this._mdf || _isFirstFrame) {
	      var o = this.o.v % 360 / 360;

	      if (o < 0) {
	        o += 1;
	      }

	      if (this.s.v > 1) {
	        s = 1 + o;
	      } else if (this.s.v < 0) {
	        s = 0 + o;
	      } else {
	        s = this.s.v + o;
	      }

	      if (this.e.v > 1) {
	        e = 1 + o;
	      } else if (this.e.v < 0) {
	        e = 0 + o;
	      } else {
	        e = this.e.v + o;
	      }

	      if (s > e) {
	        var _s = s;
	        s = e;
	        e = _s;
	      }

	      s = Math.round(s * 10000) * 0.0001;
	      e = Math.round(e * 10000) * 0.0001;
	      this.sValue = s;
	      this.eValue = e;
	    } else {
	      s = this.sValue;
	      e = this.eValue;
	    }

	    var shapePaths;
	    var i;
	    var len = this.shapes.length;
	    var j;
	    var jLen;
	    var pathsData;
	    var pathData;
	    var totalShapeLength;
	    var totalModifierLength = 0;

	    if (e === s) {
	      for (i = 0; i < len; i += 1) {
	        this.shapes[i].localShapeCollection.releaseShapes();
	        this.shapes[i].shape._mdf = true;
	        this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;

	        if (this._mdf) {
	          this.shapes[i].pathsData.length = 0;
	        }
	      }
	    } else if (!(e === 1 && s === 0 || e === 0 && s === 1)) {
	      var segments = [];
	      var shapeData;
	      var localShapeCollection;

	      for (i = 0; i < len; i += 1) {
	        shapeData = this.shapes[i]; // if shape hasn't changed and trim properties haven't changed, cached previous path can be used

	        if (!shapeData.shape._mdf && !this._mdf && !_isFirstFrame && this.m !== 2) {
	          shapeData.shape.paths = shapeData.localShapeCollection;
	        } else {
	          shapePaths = shapeData.shape.paths;
	          jLen = shapePaths._length;
	          totalShapeLength = 0;

	          if (!shapeData.shape._mdf && shapeData.pathsData.length) {
	            totalShapeLength = shapeData.totalShapeLength;
	          } else {
	            pathsData = this.releasePathsData(shapeData.pathsData);

	            for (j = 0; j < jLen; j += 1) {
	              pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
	              pathsData.push(pathData);
	              totalShapeLength += pathData.totalLength;
	            }

	            shapeData.totalShapeLength = totalShapeLength;
	            shapeData.pathsData = pathsData;
	          }

	          totalModifierLength += totalShapeLength;
	          shapeData.shape._mdf = true;
	        }
	      }

	      var shapeS = s;
	      var shapeE = e;
	      var addedLength = 0;
	      var edges;

	      for (i = len - 1; i >= 0; i -= 1) {
	        shapeData = this.shapes[i];

	        if (shapeData.shape._mdf) {
	          localShapeCollection = shapeData.localShapeCollection;
	          localShapeCollection.releaseShapes(); // if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group

	          if (this.m === 2 && len > 1) {
	            edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
	            addedLength += shapeData.totalShapeLength;
	          } else {
	            edges = [[shapeS, shapeE]];
	          }

	          jLen = edges.length;

	          for (j = 0; j < jLen; j += 1) {
	            shapeS = edges[j][0];
	            shapeE = edges[j][1];
	            segments.length = 0;

	            if (shapeE <= 1) {
	              segments.push({
	                s: shapeData.totalShapeLength * shapeS,
	                e: shapeData.totalShapeLength * shapeE
	              });
	            } else if (shapeS >= 1) {
	              segments.push({
	                s: shapeData.totalShapeLength * (shapeS - 1),
	                e: shapeData.totalShapeLength * (shapeE - 1)
	              });
	            } else {
	              segments.push({
	                s: shapeData.totalShapeLength * shapeS,
	                e: shapeData.totalShapeLength
	              });
	              segments.push({
	                s: 0,
	                e: shapeData.totalShapeLength * (shapeE - 1)
	              });
	            }

	            var newShapesData = this.addShapes(shapeData, segments[0]);

	            if (segments[0].s !== segments[0].e) {
	              if (segments.length > 1) {
	                var lastShapeInCollection = shapeData.shape.paths.shapes[shapeData.shape.paths._length - 1];

	                if (lastShapeInCollection.c) {
	                  var lastShape = newShapesData.pop();
	                  this.addPaths(newShapesData, localShapeCollection);
	                  newShapesData = this.addShapes(shapeData, segments[1], lastShape);
	                } else {
	                  this.addPaths(newShapesData, localShapeCollection);
	                  newShapesData = this.addShapes(shapeData, segments[1]);
	                }
	              }

	              this.addPaths(newShapesData, localShapeCollection);
	            }
	          }

	          shapeData.shape.paths = localShapeCollection;
	        }
	      }
	    } else if (this._mdf) {
	      for (i = 0; i < len; i += 1) {
	        // Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
	        // Don't remove this even if it's losing cached info.
	        this.shapes[i].pathsData.length = 0;
	        this.shapes[i].shape._mdf = true;
	      }
	    }
	  };

	  TrimModifier.prototype.addPaths = function (newPaths, localShapeCollection) {
	    var i;
	    var len = newPaths.length;

	    for (i = 0; i < len; i += 1) {
	      localShapeCollection.addShape(newPaths[i]);
	    }
	  };

	  TrimModifier.prototype.addSegment = function (pt1, pt2, pt3, pt4, shapePath, pos, newShape) {
	    shapePath.setXYAt(pt2[0], pt2[1], 'o', pos);
	    shapePath.setXYAt(pt3[0], pt3[1], 'i', pos + 1);

	    if (newShape) {
	      shapePath.setXYAt(pt1[0], pt1[1], 'v', pos);
	    }

	    shapePath.setXYAt(pt4[0], pt4[1], 'v', pos + 1);
	  };

	  TrimModifier.prototype.addSegmentFromArray = function (points, shapePath, pos, newShape) {
	    shapePath.setXYAt(points[1], points[5], 'o', pos);
	    shapePath.setXYAt(points[2], points[6], 'i', pos + 1);

	    if (newShape) {
	      shapePath.setXYAt(points[0], points[4], 'v', pos);
	    }

	    shapePath.setXYAt(points[3], points[7], 'v', pos + 1);
	  };

	  TrimModifier.prototype.addShapes = function (shapeData, shapeSegment, shapePath) {
	    var pathsData = shapeData.pathsData;
	    var shapePaths = shapeData.shape.paths.shapes;
	    var i;
	    var len = shapeData.shape.paths._length;
	    var j;
	    var jLen;
	    var addedLength = 0;
	    var currentLengthData;
	    var segmentCount;
	    var lengths;
	    var segment;
	    var shapes = [];
	    var initPos;
	    var newShape = true;

	    if (!shapePath) {
	      shapePath = shapePool.newElement();
	      segmentCount = 0;
	      initPos = 0;
	    } else {
	      segmentCount = shapePath._length;
	      initPos = shapePath._length;
	    }

	    shapes.push(shapePath);

	    for (i = 0; i < len; i += 1) {
	      lengths = pathsData[i].lengths;
	      shapePath.c = shapePaths[i].c;
	      jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;

	      for (j = 1; j < jLen; j += 1) {
	        currentLengthData = lengths[j - 1];

	        if (addedLength + currentLengthData.addedLength < shapeSegment.s) {
	          addedLength += currentLengthData.addedLength;
	          shapePath.c = false;
	        } else if (addedLength > shapeSegment.e) {
	          shapePath.c = false;
	          break;
	        } else {
	          if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength) {
	            this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[j], shapePaths[i].v[j], shapePath, segmentCount, newShape);
	            newShape = false;
	          } else {
	            segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[j], shapePaths[i].o[j - 1], shapePaths[i].i[j], (shapeSegment.s - addedLength) / currentLengthData.addedLength, (shapeSegment.e - addedLength) / currentLengthData.addedLength, lengths[j - 1]);
	            this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);

	            newShape = false;
	            shapePath.c = false;
	          }

	          addedLength += currentLengthData.addedLength;
	          segmentCount += 1;
	        }
	      }

	      if (shapePaths[i].c && lengths.length) {
	        currentLengthData = lengths[j - 1];

	        if (addedLength <= shapeSegment.e) {
	          var segmentLength = lengths[j - 1].addedLength;

	          if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength) {
	            this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[0], shapePaths[i].v[0], shapePath, segmentCount, newShape);
	            newShape = false;
	          } else {
	            segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[0], shapePaths[i].o[j - 1], shapePaths[i].i[0], (shapeSegment.s - addedLength) / segmentLength, (shapeSegment.e - addedLength) / segmentLength, lengths[j - 1]);
	            this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);

	            newShape = false;
	            shapePath.c = false;
	          }
	        } else {
	          shapePath.c = false;
	        }

	        addedLength += currentLengthData.addedLength;
	        segmentCount += 1;
	      }

	      if (shapePath._length) {
	        shapePath.setXYAt(shapePath.v[initPos][0], shapePath.v[initPos][1], 'i', initPos);
	        shapePath.setXYAt(shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1], 'o', shapePath._length - 1);
	      }

	      if (addedLength > shapeSegment.e) {
	        break;
	      }

	      if (i < len - 1) {
	        shapePath = shapePool.newElement();
	        newShape = true;
	        shapes.push(shapePath);
	        segmentCount = 0;
	      }
	    }

	    return shapes;
	  };

	  function PuckerAndBloatModifier() {}

	  extendPrototype([ShapeModifier], PuckerAndBloatModifier);

	  PuckerAndBloatModifier.prototype.initModifierProperties = function (elem, data) {
	    this.getValue = this.processKeys;
	    this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
	    this._isAnimated = !!this.amount.effectsSequence.length;
	  };

	  PuckerAndBloatModifier.prototype.processPath = function (path, amount) {
	    var percent = amount / 100;
	    var centerPoint = [0, 0];
	    var pathLength = path._length;
	    var i = 0;

	    for (i = 0; i < pathLength; i += 1) {
	      centerPoint[0] += path.v[i][0];
	      centerPoint[1] += path.v[i][1];
	    }

	    centerPoint[0] /= pathLength;
	    centerPoint[1] /= pathLength;
	    var clonedPath = shapePool.newElement();
	    clonedPath.c = path.c;
	    var vX;
	    var vY;
	    var oX;
	    var oY;
	    var iX;
	    var iY;

	    for (i = 0; i < pathLength; i += 1) {
	      vX = path.v[i][0] + (centerPoint[0] - path.v[i][0]) * percent;
	      vY = path.v[i][1] + (centerPoint[1] - path.v[i][1]) * percent;
	      oX = path.o[i][0] + (centerPoint[0] - path.o[i][0]) * -percent;
	      oY = path.o[i][1] + (centerPoint[1] - path.o[i][1]) * -percent;
	      iX = path.i[i][0] + (centerPoint[0] - path.i[i][0]) * -percent;
	      iY = path.i[i][1] + (centerPoint[1] - path.i[i][1]) * -percent;
	      clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, i);
	    }

	    return clonedPath;
	  };

	  PuckerAndBloatModifier.prototype.processShapes = function (_isFirstFrame) {
	    var shapePaths;
	    var i;
	    var len = this.shapes.length;
	    var j;
	    var jLen;
	    var amount = this.amount.v;

	    if (amount !== 0) {
	      var shapeData;
	      var localShapeCollection;

	      for (i = 0; i < len; i += 1) {
	        shapeData = this.shapes[i];
	        localShapeCollection = shapeData.localShapeCollection;

	        if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
	          localShapeCollection.releaseShapes();
	          shapeData.shape._mdf = true;
	          shapePaths = shapeData.shape.paths.shapes;
	          jLen = shapeData.shape.paths._length;

	          for (j = 0; j < jLen; j += 1) {
	            localShapeCollection.addShape(this.processPath(shapePaths[j], amount));
	          }
	        }

	        shapeData.shape.paths = shapeData.localShapeCollection;
	      }
	    }

	    if (!this.dynamicProperties.length) {
	      this._mdf = false;
	    }
	  };

	  var TransformPropertyFactory = function () {
	    var defaultVector = [0, 0];

	    function applyToMatrix(mat) {
	      var _mdf = this._mdf;
	      this.iterateDynamicProperties();
	      this._mdf = this._mdf || _mdf;

	      if (this.a) {
	        mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
	      }

	      if (this.s) {
	        mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
	      }

	      if (this.sk) {
	        mat.skewFromAxis(-this.sk.v, this.sa.v);
	      }

	      if (this.r) {
	        mat.rotate(-this.r.v);
	      } else {
	        mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	      }

	      if (this.data.p.s) {
	        if (this.data.p.z) {
	          mat.translate(this.px.v, this.py.v, -this.pz.v);
	        } else {
	          mat.translate(this.px.v, this.py.v, 0);
	        }
	      } else {
	        mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
	      }
	    }

	    function processKeys(forceRender) {
	      if (this.elem.globalData.frameId === this.frameId) {
	        return;
	      }

	      if (this._isDirty) {
	        this.precalculateMatrix();
	        this._isDirty = false;
	      }

	      this.iterateDynamicProperties();

	      if (this._mdf || forceRender) {
	        var frameRate;
	        this.v.cloneFromProps(this.pre.props);

	        if (this.appliedTransformations < 1) {
	          this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
	        }

	        if (this.appliedTransformations < 2) {
	          this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
	        }

	        if (this.sk && this.appliedTransformations < 3) {
	          this.v.skewFromAxis(-this.sk.v, this.sa.v);
	        }

	        if (this.r && this.appliedTransformations < 4) {
	          this.v.rotate(-this.r.v);
	        } else if (!this.r && this.appliedTransformations < 4) {
	          this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	        }

	        if (this.autoOriented) {
	          var v1;
	          var v2;
	          frameRate = this.elem.globalData.frameRate;

	          if (this.p && this.p.keyframes && this.p.getValueAtTime) {
	            if (this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t) {
	              v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / frameRate, 0);
	              v2 = this.p.getValueAtTime(this.p.keyframes[0].t / frameRate, 0);
	            } else if (this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
	              v1 = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / frameRate, 0);
	              v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / frameRate, 0);
	            } else {
	              v1 = this.p.pv;
	              v2 = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / frameRate, this.p.offsetTime);
	            }
	          } else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
	            v1 = [];
	            v2 = [];
	            var px = this.px;
	            var py = this.py;

	            if (px._caching.lastFrame + px.offsetTime <= px.keyframes[0].t) {
	              v1[0] = px.getValueAtTime((px.keyframes[0].t + 0.01) / frameRate, 0);
	              v1[1] = py.getValueAtTime((py.keyframes[0].t + 0.01) / frameRate, 0);
	              v2[0] = px.getValueAtTime(px.keyframes[0].t / frameRate, 0);
	              v2[1] = py.getValueAtTime(py.keyframes[0].t / frameRate, 0);
	            } else if (px._caching.lastFrame + px.offsetTime >= px.keyframes[px.keyframes.length - 1].t) {
	              v1[0] = px.getValueAtTime(px.keyframes[px.keyframes.length - 1].t / frameRate, 0);
	              v1[1] = py.getValueAtTime(py.keyframes[py.keyframes.length - 1].t / frameRate, 0);
	              v2[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t - 0.01) / frameRate, 0);
	              v2[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t - 0.01) / frameRate, 0);
	            } else {
	              v1 = [px.pv, py.pv];
	              v2[0] = px.getValueAtTime((px._caching.lastFrame + px.offsetTime - 0.01) / frameRate, px.offsetTime);
	              v2[1] = py.getValueAtTime((py._caching.lastFrame + py.offsetTime - 0.01) / frameRate, py.offsetTime);
	            }
	          } else {
	            v2 = defaultVector;
	            v1 = v2;
	          }

	          this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
	        }

	        if (this.data.p && this.data.p.s) {
	          if (this.data.p.z) {
	            this.v.translate(this.px.v, this.py.v, -this.pz.v);
	          } else {
	            this.v.translate(this.px.v, this.py.v, 0);
	          }
	        } else {
	          this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
	        }
	      }

	      this.frameId = this.elem.globalData.frameId;
	    }

	    function precalculateMatrix() {
	      this.appliedTransformations = 0;
	      this.pre.reset();

	      if (!this.a.effectsSequence.length) {
	        this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
	        this.appliedTransformations = 1;
	      } else {
	        return;
	      }

	      if (!this.s.effectsSequence.length) {
	        this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
	        this.appliedTransformations = 2;
	      } else {
	        return;
	      }

	      if (this.sk) {
	        if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
	          this.pre.skewFromAxis(-this.sk.v, this.sa.v);
	          this.appliedTransformations = 3;
	        } else {
	          return;
	        }
	      }

	      if (this.r) {
	        if (!this.r.effectsSequence.length) {
	          this.pre.rotate(-this.r.v);
	          this.appliedTransformations = 4;
	        }
	      } else if (!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
	        this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	        this.appliedTransformations = 4;
	      }
	    }

	    function autoOrient() {//
	      // var prevP = this.getValueAtTime();
	    }

	    function addDynamicProperty(prop) {
	      this._addDynamicProperty(prop);

	      this.elem.addDynamicProperty(prop);
	      this._isDirty = true;
	    }

	    function TransformProperty(elem, data, container) {
	      this.elem = elem;
	      this.frameId = -1;
	      this.propType = 'transform';
	      this.data = data;
	      this.v = new Matrix(); // Precalculated matrix with non animated properties

	      this.pre = new Matrix();
	      this.appliedTransformations = 0;
	      this.initDynamicPropertyContainer(container || elem);

	      if (data.p && data.p.s) {
	        this.px = PropertyFactory.getProp(elem, data.p.x, 0, 0, this);
	        this.py = PropertyFactory.getProp(elem, data.p.y, 0, 0, this);

	        if (data.p.z) {
	          this.pz = PropertyFactory.getProp(elem, data.p.z, 0, 0, this);
	        }
	      } else {
	        this.p = PropertyFactory.getProp(elem, data.p || {
	          k: [0, 0, 0]
	        }, 1, 0, this);
	      }

	      if (data.rx) {
	        this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this);
	        this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this);
	        this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this);

	        if (data.or.k[0].ti) {
	          var i;
	          var len = data.or.k.length;

	          for (i = 0; i < len; i += 1) {
	            data.or.k[i].to = null;
	            data.or.k[i].ti = null;
	          }
	        }

	        this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this); // sh Indicates it needs to be capped between -180 and 180

	        this.or.sh = true;
	      } else {
	        this.r = PropertyFactory.getProp(elem, data.r || {
	          k: 0
	        }, 0, degToRads, this);
	      }

	      if (data.sk) {
	        this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this);
	        this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this);
	      }

	      this.a = PropertyFactory.getProp(elem, data.a || {
	        k: [0, 0, 0]
	      }, 1, 0, this);
	      this.s = PropertyFactory.getProp(elem, data.s || {
	        k: [100, 100, 100]
	      }, 1, 0.01, this); // Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.

	      if (data.o) {
	        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, elem);
	      } else {
	        this.o = {
	          _mdf: false,
	          v: 1
	        };
	      }

	      this._isDirty = true;

	      if (!this.dynamicProperties.length) {
	        this.getValue(true);
	      }
	    }

	    TransformProperty.prototype = {
	      applyToMatrix: applyToMatrix,
	      getValue: processKeys,
	      precalculateMatrix: precalculateMatrix,
	      autoOrient: autoOrient
	    };
	    extendPrototype([DynamicPropertyContainer], TransformProperty);
	    TransformProperty.prototype.addDynamicProperty = addDynamicProperty;
	    TransformProperty.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;

	    function getTransformProperty(elem, data, container) {
	      return new TransformProperty(elem, data, container);
	    }

	    return {
	      getTransformProperty: getTransformProperty
	    };
	  }();

	  function RepeaterModifier() {}

	  extendPrototype([ShapeModifier], RepeaterModifier);

	  RepeaterModifier.prototype.initModifierProperties = function (elem, data) {
	    this.getValue = this.processKeys;
	    this.c = PropertyFactory.getProp(elem, data.c, 0, null, this);
	    this.o = PropertyFactory.getProp(elem, data.o, 0, null, this);
	    this.tr = TransformPropertyFactory.getTransformProperty(elem, data.tr, this);
	    this.so = PropertyFactory.getProp(elem, data.tr.so, 0, 0.01, this);
	    this.eo = PropertyFactory.getProp(elem, data.tr.eo, 0, 0.01, this);
	    this.data = data;

	    if (!this.dynamicProperties.length) {
	      this.getValue(true);
	    }

	    this._isAnimated = !!this.dynamicProperties.length;
	    this.pMatrix = new Matrix();
	    this.rMatrix = new Matrix();
	    this.sMatrix = new Matrix();
	    this.tMatrix = new Matrix();
	    this.matrix = new Matrix();
	  };

	  RepeaterModifier.prototype.applyTransforms = function (pMatrix, rMatrix, sMatrix, transform, perc, inv) {
	    var dir = inv ? -1 : 1;
	    var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
	    var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
	    pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
	    rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
	    rMatrix.rotate(-transform.r.v * dir * perc);
	    rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
	    sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
	    sMatrix.scale(inv ? 1 / scaleX : scaleX, inv ? 1 / scaleY : scaleY);
	    sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
	  };

	  RepeaterModifier.prototype.init = function (elem, arr, pos, elemsData) {
	    this.elem = elem;
	    this.arr = arr;
	    this.pos = pos;
	    this.elemsData = elemsData;
	    this._currentCopies = 0;
	    this._elements = [];
	    this._groups = [];
	    this.frameId = -1;
	    this.initDynamicPropertyContainer(elem);
	    this.initModifierProperties(elem, arr[pos]);

	    while (pos > 0) {
	      pos -= 1; // this._elements.unshift(arr.splice(pos,1)[0]);

	      this._elements.unshift(arr[pos]);
	    }

	    if (this.dynamicProperties.length) {
	      this.k = true;
	    } else {
	      this.getValue(true);
	    }
	  };

	  RepeaterModifier.prototype.resetElements = function (elements) {
	    var i;
	    var len = elements.length;

	    for (i = 0; i < len; i += 1) {
	      elements[i]._processed = false;

	      if (elements[i].ty === 'gr') {
	        this.resetElements(elements[i].it);
	      }
	    }
	  };

	  RepeaterModifier.prototype.cloneElements = function (elements) {
	    var newElements = JSON.parse(JSON.stringify(elements));
	    this.resetElements(newElements);
	    return newElements;
	  };

	  RepeaterModifier.prototype.changeGroupRender = function (elements, renderFlag) {
	    var i;
	    var len = elements.length;

	    for (i = 0; i < len; i += 1) {
	      elements[i]._render = renderFlag;

	      if (elements[i].ty === 'gr') {
	        this.changeGroupRender(elements[i].it, renderFlag);
	      }
	    }
	  };

	  RepeaterModifier.prototype.processShapes = function (_isFirstFrame) {
	    var items;
	    var itemsTransform;
	    var i;
	    var dir;
	    var cont;
	    var hasReloaded = false;

	    if (this._mdf || _isFirstFrame) {
	      var copies = Math.ceil(this.c.v);

	      if (this._groups.length < copies) {
	        while (this._groups.length < copies) {
	          var group = {
	            it: this.cloneElements(this._elements),
	            ty: 'gr'
	          };
	          group.it.push({
	            a: {
	              a: 0,
	              ix: 1,
	              k: [0, 0]
	            },
	            nm: 'Transform',
	            o: {
	              a: 0,
	              ix: 7,
	              k: 100
	            },
	            p: {
	              a: 0,
	              ix: 2,
	              k: [0, 0]
	            },
	            r: {
	              a: 1,
	              ix: 6,
	              k: [{
	                s: 0,
	                e: 0,
	                t: 0
	              }, {
	                s: 0,
	                e: 0,
	                t: 1
	              }]
	            },
	            s: {
	              a: 0,
	              ix: 3,
	              k: [100, 100]
	            },
	            sa: {
	              a: 0,
	              ix: 5,
	              k: 0
	            },
	            sk: {
	              a: 0,
	              ix: 4,
	              k: 0
	            },
	            ty: 'tr'
	          });
	          this.arr.splice(0, 0, group);

	          this._groups.splice(0, 0, group);

	          this._currentCopies += 1;
	        }

	        this.elem.reloadShapes();
	        hasReloaded = true;
	      }

	      cont = 0;
	      var renderFlag;

	      for (i = 0; i <= this._groups.length - 1; i += 1) {
	        renderFlag = cont < copies;
	        this._groups[i]._render = renderFlag;
	        this.changeGroupRender(this._groups[i].it, renderFlag);

	        if (!renderFlag) {
	          var elems = this.elemsData[i].it;
	          var transformData = elems[elems.length - 1];

	          if (transformData.transform.op.v !== 0) {
	            transformData.transform.op._mdf = true;
	            transformData.transform.op.v = 0;
	          } else {
	            transformData.transform.op._mdf = false;
	          }
	        }

	        cont += 1;
	      }

	      this._currentCopies = copies; /// /

	      var offset = this.o.v;
	      var offsetModulo = offset % 1;
	      var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
	      var pProps = this.pMatrix.props;
	      var rProps = this.rMatrix.props;
	      var sProps = this.sMatrix.props;
	      this.pMatrix.reset();
	      this.rMatrix.reset();
	      this.sMatrix.reset();
	      this.tMatrix.reset();
	      this.matrix.reset();
	      var iteration = 0;

	      if (offset > 0) {
	        while (iteration < roundOffset) {
	          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
	          iteration += 1;
	        }

	        if (offsetModulo) {
	          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
	          iteration += offsetModulo;
	        }
	      } else if (offset < 0) {
	        while (iteration > roundOffset) {
	          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
	          iteration -= 1;
	        }

	        if (offsetModulo) {
	          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -offsetModulo, true);
	          iteration -= offsetModulo;
	        }
	      }

	      i = this.data.m === 1 ? 0 : this._currentCopies - 1;
	      dir = this.data.m === 1 ? 1 : -1;
	      cont = this._currentCopies;
	      var j;
	      var jLen;

	      while (cont) {
	        items = this.elemsData[i].it;
	        itemsTransform = items[items.length - 1].transform.mProps.v.props;
	        jLen = itemsTransform.length;
	        items[items.length - 1].transform.mProps._mdf = true;
	        items[items.length - 1].transform.op._mdf = true;
	        items[items.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1));

	        if (iteration !== 0) {
	          if (i !== 0 && dir === 1 || i !== this._currentCopies - 1 && dir === -1) {
	            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
	          }

	          this.matrix.transform(rProps[0], rProps[1], rProps[2], rProps[3], rProps[4], rProps[5], rProps[6], rProps[7], rProps[8], rProps[9], rProps[10], rProps[11], rProps[12], rProps[13], rProps[14], rProps[15]);
	          this.matrix.transform(sProps[0], sProps[1], sProps[2], sProps[3], sProps[4], sProps[5], sProps[6], sProps[7], sProps[8], sProps[9], sProps[10], sProps[11], sProps[12], sProps[13], sProps[14], sProps[15]);
	          this.matrix.transform(pProps[0], pProps[1], pProps[2], pProps[3], pProps[4], pProps[5], pProps[6], pProps[7], pProps[8], pProps[9], pProps[10], pProps[11], pProps[12], pProps[13], pProps[14], pProps[15]);

	          for (j = 0; j < jLen; j += 1) {
	            itemsTransform[j] = this.matrix.props[j];
	          }

	          this.matrix.reset();
	        } else {
	          this.matrix.reset();

	          for (j = 0; j < jLen; j += 1) {
	            itemsTransform[j] = this.matrix.props[j];
	          }
	        }

	        iteration += 1;
	        cont -= 1;
	        i += dir;
	      }
	    } else {
	      cont = this._currentCopies;
	      i = 0;
	      dir = 1;

	      while (cont) {
	        items = this.elemsData[i].it;
	        itemsTransform = items[items.length - 1].transform.mProps.v.props;
	        items[items.length - 1].transform.mProps._mdf = false;
	        items[items.length - 1].transform.op._mdf = false;
	        cont -= 1;
	        i += dir;
	      }
	    }

	    return hasReloaded;
	  };

	  RepeaterModifier.prototype.addShape = function () {};

	  function RoundCornersModifier() {}

	  extendPrototype([ShapeModifier], RoundCornersModifier);

	  RoundCornersModifier.prototype.initModifierProperties = function (elem, data) {
	    this.getValue = this.processKeys;
	    this.rd = PropertyFactory.getProp(elem, data.r, 0, null, this);
	    this._isAnimated = !!this.rd.effectsSequence.length;
	  };

	  RoundCornersModifier.prototype.processPath = function (path, round) {
	    var clonedPath = shapePool.newElement();
	    clonedPath.c = path.c;
	    var i;
	    var len = path._length;
	    var currentV;
	    var currentI;
	    var currentO;
	    var closerV;
	    var distance;
	    var newPosPerc;
	    var index = 0;
	    var vX;
	    var vY;
	    var oX;
	    var oY;
	    var iX;
	    var iY;

	    for (i = 0; i < len; i += 1) {
	      currentV = path.v[i];
	      currentO = path.o[i];
	      currentI = path.i[i];

	      if (currentV[0] === currentO[0] && currentV[1] === currentO[1] && currentV[0] === currentI[0] && currentV[1] === currentI[1]) {
	        if ((i === 0 || i === len - 1) && !path.c) {
	          clonedPath.setTripleAt(currentV[0], currentV[1], currentO[0], currentO[1], currentI[0], currentI[1], index);
	          /* clonedPath.v[index] = currentV;
	                  clonedPath.o[index] = currentO;
	                  clonedPath.i[index] = currentI; */

	          index += 1;
	        } else {
	          if (i === 0) {
	            closerV = path.v[len - 1];
	          } else {
	            closerV = path.v[i - 1];
	          }

	          distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
	          newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
	          iX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
	          vX = iX;
	          iY = currentV[1] - (currentV[1] - closerV[1]) * newPosPerc;
	          vY = iY;
	          oX = vX - (vX - currentV[0]) * roundCorner;
	          oY = vY - (vY - currentV[1]) * roundCorner;
	          clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
	          index += 1;

	          if (i === len - 1) {
	            closerV = path.v[0];
	          } else {
	            closerV = path.v[i + 1];
	          }

	          distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
	          newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
	          oX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
	          vX = oX;
	          oY = currentV[1] + (closerV[1] - currentV[1]) * newPosPerc;
	          vY = oY;
	          iX = vX - (vX - currentV[0]) * roundCorner;
	          iY = vY - (vY - currentV[1]) * roundCorner;
	          clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
	          index += 1;
	        }
	      } else {
	        clonedPath.setTripleAt(path.v[i][0], path.v[i][1], path.o[i][0], path.o[i][1], path.i[i][0], path.i[i][1], index);
	        index += 1;
	      }
	    }

	    return clonedPath;
	  };

	  RoundCornersModifier.prototype.processShapes = function (_isFirstFrame) {
	    var shapePaths;
	    var i;
	    var len = this.shapes.length;
	    var j;
	    var jLen;
	    var rd = this.rd.v;

	    if (rd !== 0) {
	      var shapeData;
	      var localShapeCollection;

	      for (i = 0; i < len; i += 1) {
	        shapeData = this.shapes[i];
	        localShapeCollection = shapeData.localShapeCollection;

	        if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
	          localShapeCollection.releaseShapes();
	          shapeData.shape._mdf = true;
	          shapePaths = shapeData.shape.paths.shapes;
	          jLen = shapeData.shape.paths._length;

	          for (j = 0; j < jLen; j += 1) {
	            localShapeCollection.addShape(this.processPath(shapePaths[j], rd));
	          }
	        }

	        shapeData.shape.paths = shapeData.localShapeCollection;
	      }
	    }

	    if (!this.dynamicProperties.length) {
	      this._mdf = false;
	    }
	  };

	  function floatEqual(a, b) {
	    return Math.abs(a - b) * 100000 <= Math.min(Math.abs(a), Math.abs(b));
	  }

	  function floatZero(f) {
	    return Math.abs(f) <= 0.00001;
	  }

	  function lerp(p0, p1, amount) {
	    return p0 * (1 - amount) + p1 * amount;
	  }

	  function lerpPoint(p0, p1, amount) {
	    return [lerp(p0[0], p1[0], amount), lerp(p0[1], p1[1], amount)];
	  }

	  function quadRoots(a, b, c) {
	    // no root
	    if (a === 0) return [];
	    var s = b * b - 4 * a * c; // Complex roots

	    if (s < 0) return [];
	    var singleRoot = -b / (2 * a); // 1 root

	    if (s === 0) return [singleRoot];
	    var delta = Math.sqrt(s) / (2 * a); // 2 roots

	    return [singleRoot - delta, singleRoot + delta];
	  }

	  function polynomialCoefficients(p0, p1, p2, p3) {
	    return [-p0 + 3 * p1 - 3 * p2 + p3, 3 * p0 - 6 * p1 + 3 * p2, -3 * p0 + 3 * p1, p0];
	  }

	  function singlePoint(p) {
	    return new PolynomialBezier(p, p, p, p, false);
	  }

	  function PolynomialBezier(p0, p1, p2, p3, linearize) {
	    if (linearize && pointEqual(p0, p1)) {
	      p1 = lerpPoint(p0, p3, 1 / 3);
	    }

	    if (linearize && pointEqual(p2, p3)) {
	      p2 = lerpPoint(p0, p3, 2 / 3);
	    }

	    var coeffx = polynomialCoefficients(p0[0], p1[0], p2[0], p3[0]);
	    var coeffy = polynomialCoefficients(p0[1], p1[1], p2[1], p3[1]);
	    this.a = [coeffx[0], coeffy[0]];
	    this.b = [coeffx[1], coeffy[1]];
	    this.c = [coeffx[2], coeffy[2]];
	    this.d = [coeffx[3], coeffy[3]];
	    this.points = [p0, p1, p2, p3];
	  }

	  PolynomialBezier.prototype.point = function (t) {
	    return [((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0], ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]];
	  };

	  PolynomialBezier.prototype.derivative = function (t) {
	    return [(3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0], (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]];
	  };

	  PolynomialBezier.prototype.tangentAngle = function (t) {
	    var p = this.derivative(t);
	    return Math.atan2(p[1], p[0]);
	  };

	  PolynomialBezier.prototype.normalAngle = function (t) {
	    var p = this.derivative(t);
	    return Math.atan2(p[0], p[1]);
	  };

	  PolynomialBezier.prototype.inflectionPoints = function () {
	    var denom = this.a[1] * this.b[0] - this.a[0] * this.b[1];
	    if (floatZero(denom)) return [];
	    var tcusp = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / denom;
	    var square = tcusp * tcusp - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / denom;
	    if (square < 0) return [];
	    var root = Math.sqrt(square);

	    if (floatZero(root)) {
	      if (root > 0 && root < 1) return [tcusp];
	      return [];
	    }

	    return [tcusp - root, tcusp + root].filter(function (r) {
	      return r > 0 && r < 1;
	    });
	  };

	  PolynomialBezier.prototype.split = function (t) {
	    if (t <= 0) return [singlePoint(this.points[0]), this];
	    if (t >= 1) return [this, singlePoint(this.points[this.points.length - 1])];
	    var p10 = lerpPoint(this.points[0], this.points[1], t);
	    var p11 = lerpPoint(this.points[1], this.points[2], t);
	    var p12 = lerpPoint(this.points[2], this.points[3], t);
	    var p20 = lerpPoint(p10, p11, t);
	    var p21 = lerpPoint(p11, p12, t);
	    var p3 = lerpPoint(p20, p21, t);
	    return [new PolynomialBezier(this.points[0], p10, p20, p3, true), new PolynomialBezier(p3, p21, p12, this.points[3], true)];
	  };

	  function extrema(bez, comp) {
	    var min = bez.points[0][comp];
	    var max = bez.points[bez.points.length - 1][comp];

	    if (min > max) {
	      var e = max;
	      max = min;
	      min = e;
	    } // Derivative roots to find min/max


	    var f = quadRoots(3 * bez.a[comp], 2 * bez.b[comp], bez.c[comp]);

	    for (var i = 0; i < f.length; i += 1) {
	      if (f[i] > 0 && f[i] < 1) {
	        var val = bez.point(f[i])[comp];
	        if (val < min) min = val;else if (val > max) max = val;
	      }
	    }

	    return {
	      min: min,
	      max: max
	    };
	  }

	  PolynomialBezier.prototype.bounds = function () {
	    return {
	      x: extrema(this, 0),
	      y: extrema(this, 1)
	    };
	  };

	  PolynomialBezier.prototype.boundingBox = function () {
	    var bounds = this.bounds();
	    return {
	      left: bounds.x.min,
	      right: bounds.x.max,
	      top: bounds.y.min,
	      bottom: bounds.y.max,
	      width: bounds.x.max - bounds.x.min,
	      height: bounds.y.max - bounds.y.min,
	      cx: (bounds.x.max + bounds.x.min) / 2,
	      cy: (bounds.y.max + bounds.y.min) / 2
	    };
	  };

	  function intersectData(bez, t1, t2) {
	    var box = bez.boundingBox();
	    return {
	      cx: box.cx,
	      cy: box.cy,
	      width: box.width,
	      height: box.height,
	      bez: bez,
	      t: (t1 + t2) / 2,
	      t1: t1,
	      t2: t2
	    };
	  }

	  function splitData(data) {
	    var split = data.bez.split(0.5);
	    return [intersectData(split[0], data.t1, data.t), intersectData(split[1], data.t, data.t2)];
	  }

	  function boxIntersect(b1, b2) {
	    return Math.abs(b1.cx - b2.cx) * 2 < b1.width + b2.width && Math.abs(b1.cy - b2.cy) * 2 < b1.height + b2.height;
	  }

	  function intersectsImpl(d1, d2, depth, tolerance, intersections, maxRecursion) {
	    if (!boxIntersect(d1, d2)) return;

	    if (depth >= maxRecursion || d1.width <= tolerance && d1.height <= tolerance && d2.width <= tolerance && d2.height <= tolerance) {
	      intersections.push([d1.t, d2.t]);
	      return;
	    }

	    var d1s = splitData(d1);
	    var d2s = splitData(d2);
	    intersectsImpl(d1s[0], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
	    intersectsImpl(d1s[0], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
	    intersectsImpl(d1s[1], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
	    intersectsImpl(d1s[1], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
	  }

	  PolynomialBezier.prototype.intersections = function (other, tolerance, maxRecursion) {
	    if (tolerance === undefined) tolerance = 2;
	    if (maxRecursion === undefined) maxRecursion = 7;
	    var intersections = [];
	    intersectsImpl(intersectData(this, 0, 1), intersectData(other, 0, 1), 0, tolerance, intersections, maxRecursion);
	    return intersections;
	  };

	  PolynomialBezier.shapeSegment = function (shapePath, index) {
	    var nextIndex = (index + 1) % shapePath.length();
	    return new PolynomialBezier(shapePath.v[index], shapePath.o[index], shapePath.i[nextIndex], shapePath.v[nextIndex], true);
	  };

	  PolynomialBezier.shapeSegmentInverted = function (shapePath, index) {
	    var nextIndex = (index + 1) % shapePath.length();
	    return new PolynomialBezier(shapePath.v[nextIndex], shapePath.i[nextIndex], shapePath.o[index], shapePath.v[index], true);
	  };

	  function crossProduct(a, b) {
	    return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
	  }

	  function lineIntersection(start1, end1, start2, end2) {
	    var v1 = [start1[0], start1[1], 1];
	    var v2 = [end1[0], end1[1], 1];
	    var v3 = [start2[0], start2[1], 1];
	    var v4 = [end2[0], end2[1], 1];
	    var r = crossProduct(crossProduct(v1, v2), crossProduct(v3, v4));
	    if (floatZero(r[2])) return null;
	    return [r[0] / r[2], r[1] / r[2]];
	  }

	  function polarOffset(p, angle, length) {
	    return [p[0] + Math.cos(angle) * length, p[1] - Math.sin(angle) * length];
	  }

	  function pointDistance(p1, p2) {
	    return Math.hypot(p1[0] - p2[0], p1[1] - p2[1]);
	  }

	  function pointEqual(p1, p2) {
	    return floatEqual(p1[0], p2[0]) && floatEqual(p1[1], p2[1]);
	  }

	  function ZigZagModifier() {}

	  extendPrototype([ShapeModifier], ZigZagModifier);

	  ZigZagModifier.prototype.initModifierProperties = function (elem, data) {
	    this.getValue = this.processKeys;
	    this.amplitude = PropertyFactory.getProp(elem, data.s, 0, null, this);
	    this.frequency = PropertyFactory.getProp(elem, data.r, 0, null, this);
	    this.pointsType = PropertyFactory.getProp(elem, data.pt, 0, null, this);
	    this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
	  };

	  function setPoint(outputBezier, point, angle, direction, amplitude, outAmplitude, inAmplitude) {
	    var angO = angle - Math.PI / 2;
	    var angI = angle + Math.PI / 2;
	    var px = point[0] + Math.cos(angle) * direction * amplitude;
	    var py = point[1] - Math.sin(angle) * direction * amplitude;
	    outputBezier.setTripleAt(px, py, px + Math.cos(angO) * outAmplitude, py - Math.sin(angO) * outAmplitude, px + Math.cos(angI) * inAmplitude, py - Math.sin(angI) * inAmplitude, outputBezier.length());
	  }

	  function getPerpendicularVector(pt1, pt2) {
	    var vector = [pt2[0] - pt1[0], pt2[1] - pt1[1]];
	    var rot = -Math.PI * 0.5;
	    var rotatedVector = [Math.cos(rot) * vector[0] - Math.sin(rot) * vector[1], Math.sin(rot) * vector[0] + Math.cos(rot) * vector[1]];
	    return rotatedVector;
	  }

	  function getProjectingAngle(path, cur) {
	    var prevIndex = cur === 0 ? path.length() - 1 : cur - 1;
	    var nextIndex = (cur + 1) % path.length();
	    var prevPoint = path.v[prevIndex];
	    var nextPoint = path.v[nextIndex];
	    var pVector = getPerpendicularVector(prevPoint, nextPoint);
	    return Math.atan2(0, 1) - Math.atan2(pVector[1], pVector[0]);
	  }

	  function zigZagCorner(outputBezier, path, cur, amplitude, frequency, pointType, direction) {
	    var angle = getProjectingAngle(path, cur);
	    var point = path.v[cur % path._length];
	    var prevPoint = path.v[cur === 0 ? path._length - 1 : cur - 1];
	    var nextPoint = path.v[(cur + 1) % path._length];
	    var prevDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - prevPoint[0], 2) + Math.pow(point[1] - prevPoint[1], 2)) : 0;
	    var nextDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - nextPoint[0], 2) + Math.pow(point[1] - nextPoint[1], 2)) : 0;
	    setPoint(outputBezier, path.v[cur % path._length], angle, direction, amplitude, nextDist / ((frequency + 1) * 2), prevDist / ((frequency + 1) * 2));
	  }

	  function zigZagSegment(outputBezier, segment, amplitude, frequency, pointType, direction) {
	    for (var i = 0; i < frequency; i += 1) {
	      var t = (i + 1) / (frequency + 1);
	      var dist = pointType === 2 ? Math.sqrt(Math.pow(segment.points[3][0] - segment.points[0][0], 2) + Math.pow(segment.points[3][1] - segment.points[0][1], 2)) : 0;
	      var angle = segment.normalAngle(t);
	      var point = segment.point(t);
	      setPoint(outputBezier, point, angle, direction, amplitude, dist / ((frequency + 1) * 2), dist / ((frequency + 1) * 2));
	      direction = -direction;
	    }

	    return direction;
	  }

	  ZigZagModifier.prototype.processPath = function (path, amplitude, frequency, pointType) {
	    var count = path._length;
	    var clonedPath = shapePool.newElement();
	    clonedPath.c = path.c;

	    if (!path.c) {
	      count -= 1;
	    }

	    if (count === 0) return clonedPath;
	    var direction = -1;
	    var segment = PolynomialBezier.shapeSegment(path, 0);
	    zigZagCorner(clonedPath, path, 0, amplitude, frequency, pointType, direction);

	    for (var i = 0; i < count; i += 1) {
	      direction = zigZagSegment(clonedPath, segment, amplitude, frequency, pointType, -direction);

	      if (i === count - 1 && !path.c) {
	        segment = null;
	      } else {
	        segment = PolynomialBezier.shapeSegment(path, (i + 1) % count);
	      }

	      zigZagCorner(clonedPath, path, i + 1, amplitude, frequency, pointType, direction);
	    }

	    return clonedPath;
	  };

	  ZigZagModifier.prototype.processShapes = function (_isFirstFrame) {
	    var shapePaths;
	    var i;
	    var len = this.shapes.length;
	    var j;
	    var jLen;
	    var amplitude = this.amplitude.v;
	    var frequency = Math.max(0, Math.round(this.frequency.v));
	    var pointType = this.pointsType.v;

	    if (amplitude !== 0) {
	      var shapeData;
	      var localShapeCollection;

	      for (i = 0; i < len; i += 1) {
	        shapeData = this.shapes[i];
	        localShapeCollection = shapeData.localShapeCollection;

	        if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
	          localShapeCollection.releaseShapes();
	          shapeData.shape._mdf = true;
	          shapePaths = shapeData.shape.paths.shapes;
	          jLen = shapeData.shape.paths._length;

	          for (j = 0; j < jLen; j += 1) {
	            localShapeCollection.addShape(this.processPath(shapePaths[j], amplitude, frequency, pointType));
	          }
	        }

	        shapeData.shape.paths = shapeData.localShapeCollection;
	      }
	    }

	    if (!this.dynamicProperties.length) {
	      this._mdf = false;
	    }
	  };

	  function linearOffset(p1, p2, amount) {
	    var angle = Math.atan2(p2[0] - p1[0], p2[1] - p1[1]);
	    return [polarOffset(p1, angle, amount), polarOffset(p2, angle, amount)];
	  }

	  function offsetSegment(segment, amount) {
	    var p0;
	    var p1a;
	    var p1b;
	    var p2b;
	    var p2a;
	    var p3;
	    var e;
	    e = linearOffset(segment.points[0], segment.points[1], amount);
	    p0 = e[0];
	    p1a = e[1];
	    e = linearOffset(segment.points[1], segment.points[2], amount);
	    p1b = e[0];
	    p2b = e[1];
	    e = linearOffset(segment.points[2], segment.points[3], amount);
	    p2a = e[0];
	    p3 = e[1];
	    var p1 = lineIntersection(p0, p1a, p1b, p2b);
	    if (p1 === null) p1 = p1a;
	    var p2 = lineIntersection(p2a, p3, p1b, p2b);
	    if (p2 === null) p2 = p2a;
	    return new PolynomialBezier(p0, p1, p2, p3);
	  }

	  function joinLines(outputBezier, seg1, seg2, lineJoin, miterLimit) {
	    var p0 = seg1.points[3];
	    var p1 = seg2.points[0]; // Bevel

	    if (lineJoin === 3) return p0; // Connected, they don't need a joint

	    if (pointEqual(p0, p1)) return p0; // Round

	    if (lineJoin === 2) {
	      var angleOut = -seg1.tangentAngle(1);
	      var angleIn = -seg2.tangentAngle(0) + Math.PI;
	      var center = lineIntersection(p0, polarOffset(p0, angleOut + Math.PI / 2, 100), p1, polarOffset(p1, angleOut + Math.PI / 2, 100));
	      var radius = center ? pointDistance(center, p0) : pointDistance(p0, p1) / 2;
	      var tan = polarOffset(p0, angleOut, 2 * radius * roundCorner);
	      outputBezier.setXYAt(tan[0], tan[1], 'o', outputBezier.length() - 1);
	      tan = polarOffset(p1, angleIn, 2 * radius * roundCorner);
	      outputBezier.setTripleAt(p1[0], p1[1], p1[0], p1[1], tan[0], tan[1], outputBezier.length());
	      return p1;
	    } // Miter


	    var t0 = pointEqual(p0, seg1.points[2]) ? seg1.points[0] : seg1.points[2];
	    var t1 = pointEqual(p1, seg2.points[1]) ? seg2.points[3] : seg2.points[1];
	    var intersection = lineIntersection(t0, p0, p1, t1);

	    if (intersection && pointDistance(intersection, p0) < miterLimit) {
	      outputBezier.setTripleAt(intersection[0], intersection[1], intersection[0], intersection[1], intersection[0], intersection[1], outputBezier.length());
	      return intersection;
	    }

	    return p0;
	  }

	  function getIntersection(a, b) {
	    var intersect = a.intersections(b);
	    if (intersect.length && floatEqual(intersect[0][0], 1)) intersect.shift();
	    if (intersect.length) return intersect[0];
	    return null;
	  }

	  function pruneSegmentIntersection(a, b) {
	    var outa = a.slice();
	    var outb = b.slice();
	    var intersect = getIntersection(a[a.length - 1], b[0]);

	    if (intersect) {
	      outa[a.length - 1] = a[a.length - 1].split(intersect[0])[0];
	      outb[0] = b[0].split(intersect[1])[1];
	    }

	    if (a.length > 1 && b.length > 1) {
	      intersect = getIntersection(a[0], b[b.length - 1]);

	      if (intersect) {
	        return [[a[0].split(intersect[0])[0]], [b[b.length - 1].split(intersect[1])[1]]];
	      }
	    }

	    return [outa, outb];
	  }

	  function pruneIntersections(segments) {
	    var e;

	    for (var i = 1; i < segments.length; i += 1) {
	      e = pruneSegmentIntersection(segments[i - 1], segments[i]);
	      segments[i - 1] = e[0];
	      segments[i] = e[1];
	    }

	    if (segments.length > 1) {
	      e = pruneSegmentIntersection(segments[segments.length - 1], segments[0]);
	      segments[segments.length - 1] = e[0];
	      segments[0] = e[1];
	    }

	    return segments;
	  }

	  function offsetSegmentSplit(segment, amount) {
	    /*
	      We split each bezier segment into smaller pieces based
	      on inflection points, this ensures the control point
	      polygon is convex.
	        (A cubic bezier can have none, one, or two inflection points)
	    */
	    var flex = segment.inflectionPoints();
	    var left;
	    var right;
	    var split;
	    var mid;

	    if (flex.length === 0) {
	      return [offsetSegment(segment, amount)];
	    }

	    if (flex.length === 1 || floatEqual(flex[1], 1)) {
	      split = segment.split(flex[0]);
	      left = split[0];
	      right = split[1];
	      return [offsetSegment(left, amount), offsetSegment(right, amount)];
	    }

	    split = segment.split(flex[0]);
	    left = split[0];
	    var t = (flex[1] - flex[0]) / (1 - flex[0]);
	    split = split[1].split(t);
	    mid = split[0];
	    right = split[1];
	    return [offsetSegment(left, amount), offsetSegment(mid, amount), offsetSegment(right, amount)];
	  }

	  function OffsetPathModifier() {}

	  extendPrototype([ShapeModifier], OffsetPathModifier);

	  OffsetPathModifier.prototype.initModifierProperties = function (elem, data) {
	    this.getValue = this.processKeys;
	    this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
	    this.miterLimit = PropertyFactory.getProp(elem, data.ml, 0, null, this);
	    this.lineJoin = data.lj;
	    this._isAnimated = this.amount.effectsSequence.length !== 0;
	  };

	  OffsetPathModifier.prototype.processPath = function (inputBezier, amount, lineJoin, miterLimit) {
	    var outputBezier = shapePool.newElement();
	    outputBezier.c = inputBezier.c;
	    var count = inputBezier.length();

	    if (!inputBezier.c) {
	      count -= 1;
	    }

	    var i;
	    var j;
	    var segment;
	    var multiSegments = [];

	    for (i = 0; i < count; i += 1) {
	      segment = PolynomialBezier.shapeSegment(inputBezier, i);
	      multiSegments.push(offsetSegmentSplit(segment, amount));
	    }

	    if (!inputBezier.c) {
	      for (i = count - 1; i >= 0; i -= 1) {
	        segment = PolynomialBezier.shapeSegmentInverted(inputBezier, i);
	        multiSegments.push(offsetSegmentSplit(segment, amount));
	      }
	    }

	    multiSegments = pruneIntersections(multiSegments); // Add bezier segments to the output and apply line joints

	    var lastPoint = null;
	    var lastSeg = null;

	    for (i = 0; i < multiSegments.length; i += 1) {
	      var multiSegment = multiSegments[i];
	      if (lastSeg) lastPoint = joinLines(outputBezier, lastSeg, multiSegment[0], lineJoin, miterLimit);
	      lastSeg = multiSegment[multiSegment.length - 1];

	      for (j = 0; j < multiSegment.length; j += 1) {
	        segment = multiSegment[j];

	        if (lastPoint && pointEqual(segment.points[0], lastPoint)) {
	          outputBezier.setXYAt(segment.points[1][0], segment.points[1][1], 'o', outputBezier.length() - 1);
	        } else {
	          outputBezier.setTripleAt(segment.points[0][0], segment.points[0][1], segment.points[1][0], segment.points[1][1], segment.points[0][0], segment.points[0][1], outputBezier.length());
	        }

	        outputBezier.setTripleAt(segment.points[3][0], segment.points[3][1], segment.points[3][0], segment.points[3][1], segment.points[2][0], segment.points[2][1], outputBezier.length());
	        lastPoint = segment.points[3];
	      }
	    }

	    if (multiSegments.length) joinLines(outputBezier, lastSeg, multiSegments[0][0], lineJoin, miterLimit);
	    return outputBezier;
	  };

	  OffsetPathModifier.prototype.processShapes = function (_isFirstFrame) {
	    var shapePaths;
	    var i;
	    var len = this.shapes.length;
	    var j;
	    var jLen;
	    var amount = this.amount.v;
	    var miterLimit = this.miterLimit.v;
	    var lineJoin = this.lineJoin;

	    if (amount !== 0) {
	      var shapeData;
	      var localShapeCollection;

	      for (i = 0; i < len; i += 1) {
	        shapeData = this.shapes[i];
	        localShapeCollection = shapeData.localShapeCollection;

	        if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
	          localShapeCollection.releaseShapes();
	          shapeData.shape._mdf = true;
	          shapePaths = shapeData.shape.paths.shapes;
	          jLen = shapeData.shape.paths._length;

	          for (j = 0; j < jLen; j += 1) {
	            localShapeCollection.addShape(this.processPath(shapePaths[j], amount, lineJoin, miterLimit));
	          }
	        }

	        shapeData.shape.paths = shapeData.localShapeCollection;
	      }
	    }

	    if (!this.dynamicProperties.length) {
	      this._mdf = false;
	    }
	  };

	  function getFontProperties(fontData) {
	    var styles = fontData.fStyle ? fontData.fStyle.split(' ') : [];
	    var fWeight = 'normal';
	    var fStyle = 'normal';
	    var len = styles.length;
	    var styleName;

	    for (var i = 0; i < len; i += 1) {
	      styleName = styles[i].toLowerCase();

	      switch (styleName) {
	        case 'italic':
	          fStyle = 'italic';
	          break;

	        case 'bold':
	          fWeight = '700';
	          break;

	        case 'black':
	          fWeight = '900';
	          break;

	        case 'medium':
	          fWeight = '500';
	          break;

	        case 'regular':
	        case 'normal':
	          fWeight = '400';
	          break;

	        case 'light':
	        case 'thin':
	          fWeight = '200';
	          break;
	      }
	    }

	    return {
	      style: fStyle,
	      weight: fontData.fWeight || fWeight
	    };
	  }

	  var FontManager = function () {
	    var maxWaitingTime = 5000;
	    var emptyChar = {
	      w: 0,
	      size: 0,
	      shapes: [],
	      data: {
	        shapes: []
	      }
	    };
	    var combinedCharacters = []; // Hindi characters

	    combinedCharacters = combinedCharacters.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
	    var BLACK_FLAG_CODE_POINT = 127988;
	    var CANCEL_TAG_CODE_POINT = 917631;
	    var A_TAG_CODE_POINT = 917601;
	    var Z_TAG_CODE_POINT = 917626;
	    var VARIATION_SELECTOR_16_CODE_POINT = 65039;
	    var ZERO_WIDTH_JOINER_CODE_POINT = 8205;
	    var REGIONAL_CHARACTER_A_CODE_POINT = 127462;
	    var REGIONAL_CHARACTER_Z_CODE_POINT = 127487;
	    var surrogateModifiers = ['d83cdffb', 'd83cdffc', 'd83cdffd', 'd83cdffe', 'd83cdfff'];

	    function trimFontOptions(font) {
	      var familyArray = font.split(',');
	      var i;
	      var len = familyArray.length;
	      var enabledFamilies = [];

	      for (i = 0; i < len; i += 1) {
	        if (familyArray[i] !== 'sans-serif' && familyArray[i] !== 'monospace') {
	          enabledFamilies.push(familyArray[i]);
	        }
	      }

	      return enabledFamilies.join(',');
	    }

	    function setUpNode(font, family) {
	      var parentNode = createTag('span'); // Node is invisible to screen readers.

	      parentNode.setAttribute('aria-hidden', true);
	      parentNode.style.fontFamily = family;
	      var node = createTag('span'); // Characters that vary significantly among different fonts

	      node.innerText = 'giItT1WQy@!-/#'; // Visible - so we can measure it - but not on the screen

	      parentNode.style.position = 'absolute';
	      parentNode.style.left = '-10000px';
	      parentNode.style.top = '-10000px'; // Large font size makes even subtle changes obvious

	      parentNode.style.fontSize = '300px'; // Reset any font properties

	      parentNode.style.fontVariant = 'normal';
	      parentNode.style.fontStyle = 'normal';
	      parentNode.style.fontWeight = 'normal';
	      parentNode.style.letterSpacing = '0';
	      parentNode.appendChild(node);
	      document.body.appendChild(parentNode); // Remember width with no applied web font

	      var width = node.offsetWidth;
	      node.style.fontFamily = trimFontOptions(font) + ', ' + family;
	      return {
	        node: node,
	        w: width,
	        parent: parentNode
	      };
	    }

	    function checkLoadedFonts() {
	      var i;
	      var len = this.fonts.length;
	      var node;
	      var w;
	      var loadedCount = len;

	      for (i = 0; i < len; i += 1) {
	        if (this.fonts[i].loaded) {
	          loadedCount -= 1;
	        } else if (this.fonts[i].fOrigin === 'n' || this.fonts[i].origin === 0) {
	          this.fonts[i].loaded = true;
	        } else {
	          node = this.fonts[i].monoCase.node;
	          w = this.fonts[i].monoCase.w;

	          if (node.offsetWidth !== w) {
	            loadedCount -= 1;
	            this.fonts[i].loaded = true;
	          } else {
	            node = this.fonts[i].sansCase.node;
	            w = this.fonts[i].sansCase.w;

	            if (node.offsetWidth !== w) {
	              loadedCount -= 1;
	              this.fonts[i].loaded = true;
	            }
	          }

	          if (this.fonts[i].loaded) {
	            this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
	            this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
	          }
	        }
	      }

	      if (loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime) {
	        setTimeout(this.checkLoadedFontsBinded, 20);
	      } else {
	        setTimeout(this.setIsLoadedBinded, 10);
	      }
	    }

	    function createHelper(fontData, def) {
	      var engine = document.body && def ? 'svg' : 'canvas';
	      var helper;
	      var fontProps = getFontProperties(fontData);

	      if (engine === 'svg') {
	        var tHelper = createNS('text');
	        tHelper.style.fontSize = '100px'; // tHelper.style.fontFamily = fontData.fFamily;

	        tHelper.setAttribute('font-family', fontData.fFamily);
	        tHelper.setAttribute('font-style', fontProps.style);
	        tHelper.setAttribute('font-weight', fontProps.weight);
	        tHelper.textContent = '1';

	        if (fontData.fClass) {
	          tHelper.style.fontFamily = 'inherit';
	          tHelper.setAttribute('class', fontData.fClass);
	        } else {
	          tHelper.style.fontFamily = fontData.fFamily;
	        }

	        def.appendChild(tHelper);
	        helper = tHelper;
	      } else {
	        var tCanvasHelper = new OffscreenCanvas(500, 500).getContext('2d');
	        tCanvasHelper.font = fontProps.style + ' ' + fontProps.weight + ' 100px ' + fontData.fFamily;
	        helper = tCanvasHelper;
	      }

	      function measure(text) {
	        if (engine === 'svg') {
	          helper.textContent = text;
	          return helper.getComputedTextLength();
	        }

	        return helper.measureText(text).width;
	      }

	      return {
	        measureText: measure
	      };
	    }

	    function addFonts(fontData, defs) {
	      if (!fontData) {
	        this.isLoaded = true;
	        return;
	      }

	      if (this.chars) {
	        this.isLoaded = true;
	        this.fonts = fontData.list;
	        return;
	      }

	      if (!document.body) {
	        this.isLoaded = true;
	        fontData.list.forEach(function (data) {
	          data.helper = createHelper(data);
	          data.cache = {};
	        });
	        this.fonts = fontData.list;
	        return;
	      }

	      var fontArr = fontData.list;
	      var i;
	      var len = fontArr.length;
	      var _pendingFonts = len;

	      for (i = 0; i < len; i += 1) {
	        var shouldLoadFont = true;
	        var loadedSelector;
	        var j;
	        fontArr[i].loaded = false;
	        fontArr[i].monoCase = setUpNode(fontArr[i].fFamily, 'monospace');
	        fontArr[i].sansCase = setUpNode(fontArr[i].fFamily, 'sans-serif');

	        if (!fontArr[i].fPath) {
	          fontArr[i].loaded = true;
	          _pendingFonts -= 1;
	        } else if (fontArr[i].fOrigin === 'p' || fontArr[i].origin === 3) {
	          loadedSelector = document.querySelectorAll('style[f-forigin="p"][f-family="' + fontArr[i].fFamily + '"], style[f-origin="3"][f-family="' + fontArr[i].fFamily + '"]');

	          if (loadedSelector.length > 0) {
	            shouldLoadFont = false;
	          }

	          if (shouldLoadFont) {
	            var s = createTag('style');
	            s.setAttribute('f-forigin', fontArr[i].fOrigin);
	            s.setAttribute('f-origin', fontArr[i].origin);
	            s.setAttribute('f-family', fontArr[i].fFamily);
	            s.type = 'text/css';
	            s.innerText = '@font-face {font-family: ' + fontArr[i].fFamily + "; font-style: normal; src: url('" + fontArr[i].fPath + "');}";
	            defs.appendChild(s);
	          }
	        } else if (fontArr[i].fOrigin === 'g' || fontArr[i].origin === 1) {
	          loadedSelector = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');

	          for (j = 0; j < loadedSelector.length; j += 1) {
	            if (loadedSelector[j].href.indexOf(fontArr[i].fPath) !== -1) {
	              // Font is already loaded
	              shouldLoadFont = false;
	            }
	          }

	          if (shouldLoadFont) {
	            var l = createTag('link');
	            l.setAttribute('f-forigin', fontArr[i].fOrigin);
	            l.setAttribute('f-origin', fontArr[i].origin);
	            l.type = 'text/css';
	            l.rel = 'stylesheet';
	            l.href = fontArr[i].fPath;
	            document.body.appendChild(l);
	          }
	        } else if (fontArr[i].fOrigin === 't' || fontArr[i].origin === 2) {
	          loadedSelector = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');

	          for (j = 0; j < loadedSelector.length; j += 1) {
	            if (fontArr[i].fPath === loadedSelector[j].src) {
	              // Font is already loaded
	              shouldLoadFont = false;
	            }
	          }

	          if (shouldLoadFont) {
	            var sc = createTag('link');
	            sc.setAttribute('f-forigin', fontArr[i].fOrigin);
	            sc.setAttribute('f-origin', fontArr[i].origin);
	            sc.setAttribute('rel', 'stylesheet');
	            sc.setAttribute('href', fontArr[i].fPath);
	            defs.appendChild(sc);
	          }
	        }

	        fontArr[i].helper = createHelper(fontArr[i], defs);
	        fontArr[i].cache = {};
	        this.fonts.push(fontArr[i]);
	      }

	      if (_pendingFonts === 0) {
	        this.isLoaded = true;
	      } else {
	        // On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
	        // Adding this timeout seems to fix it
	        setTimeout(this.checkLoadedFonts.bind(this), 100);
	      }
	    }

	    function addChars(chars) {
	      if (!chars) {
	        return;
	      }

	      if (!this.chars) {
	        this.chars = [];
	      }

	      var i;
	      var len = chars.length;
	      var j;
	      var jLen = this.chars.length;
	      var found;

	      for (i = 0; i < len; i += 1) {
	        j = 0;
	        found = false;

	        while (j < jLen) {
	          if (this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch) {
	            found = true;
	          }

	          j += 1;
	        }

	        if (!found) {
	          this.chars.push(chars[i]);
	          jLen += 1;
	        }
	      }
	    }

	    function getCharData(_char, style, font) {
	      var i = 0;
	      var len = this.chars.length;

	      while (i < len) {
	        if (this.chars[i].ch === _char && this.chars[i].style === style && this.chars[i].fFamily === font) {
	          return this.chars[i];
	        }

	        i += 1;
	      }

	      if ((typeof _char === 'string' && _char.charCodeAt(0) !== 13 || !_char) && console && console.warn // eslint-disable-line no-console
	      && !this._warned) {
	        this._warned = true;
	        console.warn('Missing character from exported characters list: ', _char, style, font); // eslint-disable-line no-console
	      }

	      return emptyChar;
	    }

	    function measureText(_char2, fontName, size) {
	      var fontData = this.getFontByName(fontName); // Using the char instead of char.charCodeAt(0)
	      // to avoid collisions between equal chars

	      var index = _char2;

	      if (!fontData.cache[index]) {
	        var tHelper = fontData.helper;

	        if (_char2 === ' ') {
	          var doubleSize = tHelper.measureText('|' + _char2 + '|');
	          var singleSize = tHelper.measureText('||');
	          fontData.cache[index] = (doubleSize - singleSize) / 100;
	        } else {
	          fontData.cache[index] = tHelper.measureText(_char2) / 100;
	        }
	      }

	      return fontData.cache[index] * size;
	    }

	    function getFontByName(name) {
	      var i = 0;
	      var len = this.fonts.length;

	      while (i < len) {
	        if (this.fonts[i].fName === name) {
	          return this.fonts[i];
	        }

	        i += 1;
	      }

	      return this.fonts[0];
	    }

	    function getCodePoint(string) {
	      var codePoint = 0;
	      var first = string.charCodeAt(0);

	      if (first >= 0xD800 && first <= 0xDBFF) {
	        var second = string.charCodeAt(1);

	        if (second >= 0xDC00 && second <= 0xDFFF) {
	          codePoint = (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
	        }
	      }

	      return codePoint;
	    } // Skin tone modifiers


	    function isModifier(firstCharCode, secondCharCode) {
	      var sum = firstCharCode.toString(16) + secondCharCode.toString(16);
	      return surrogateModifiers.indexOf(sum) !== -1;
	    }

	    function isZeroWidthJoiner(charCode) {
	      return charCode === ZERO_WIDTH_JOINER_CODE_POINT;
	    } // This codepoint may change the appearance of the preceding character.
	    // If that is a symbol, dingbat or emoji, U+FE0F forces it to be rendered
	    // as a colorful image as compared to a monochrome text variant.


	    function isVariationSelector(charCode) {
	      return charCode === VARIATION_SELECTOR_16_CODE_POINT;
	    } // The regional indicator symbols are a set of 26 alphabetic Unicode
	    /// characters (A–Z) intended to be used to encode ISO 3166-1 alpha-2
	    // two-letter country codes in a way that allows optional special treatment.


	    function isRegionalCode(string) {
	      var codePoint = getCodePoint(string);

	      if (codePoint >= REGIONAL_CHARACTER_A_CODE_POINT && codePoint <= REGIONAL_CHARACTER_Z_CODE_POINT) {
	        return true;
	      }

	      return false;
	    } // Some Emoji implementations represent combinations of
	    // two “regional indicator” letters as a single flag symbol.


	    function isFlagEmoji(string) {
	      return isRegionalCode(string.substr(0, 2)) && isRegionalCode(string.substr(2, 2));
	    }

	    function isCombinedCharacter(_char3) {
	      return combinedCharacters.indexOf(_char3) !== -1;
	    } // Regional flags start with a BLACK_FLAG_CODE_POINT
	    // folowed by 5 chars in the TAG range
	    // and end with a CANCEL_TAG_CODE_POINT


	    function isRegionalFlag(text, index) {
	      var codePoint = getCodePoint(text.substr(index, 2));

	      if (codePoint !== BLACK_FLAG_CODE_POINT) {
	        return false;
	      }

	      var count = 0;
	      index += 2;

	      while (count < 5) {
	        codePoint = getCodePoint(text.substr(index, 2));

	        if (codePoint < A_TAG_CODE_POINT || codePoint > Z_TAG_CODE_POINT) {
	          return false;
	        }

	        count += 1;
	        index += 2;
	      }

	      return getCodePoint(text.substr(index, 2)) === CANCEL_TAG_CODE_POINT;
	    }

	    function setIsLoaded() {
	      this.isLoaded = true;
	    }

	    var Font = function Font() {
	      this.fonts = [];
	      this.chars = null;
	      this.typekitLoaded = 0;
	      this.isLoaded = false;
	      this._warned = false;
	      this.initTime = Date.now();
	      this.setIsLoadedBinded = this.setIsLoaded.bind(this);
	      this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
	    };

	    Font.isModifier = isModifier;
	    Font.isZeroWidthJoiner = isZeroWidthJoiner;
	    Font.isFlagEmoji = isFlagEmoji;
	    Font.isRegionalCode = isRegionalCode;
	    Font.isCombinedCharacter = isCombinedCharacter;
	    Font.isRegionalFlag = isRegionalFlag;
	    Font.isVariationSelector = isVariationSelector;
	    Font.BLACK_FLAG_CODE_POINT = BLACK_FLAG_CODE_POINT;
	    var fontPrototype = {
	      addChars: addChars,
	      addFonts: addFonts,
	      getCharData: getCharData,
	      getFontByName: getFontByName,
	      measureText: measureText,
	      checkLoadedFonts: checkLoadedFonts,
	      setIsLoaded: setIsLoaded
	    };
	    Font.prototype = fontPrototype;
	    return Font;
	  }();

	  function SlotManager(animationData) {
	    this.animationData = animationData;
	  }

	  SlotManager.prototype.getProp = function (data) {
	    if (this.animationData.slots && this.animationData.slots[data.sid]) {
	      return Object.assign(data, this.animationData.slots[data.sid].p);
	    }

	    return data;
	  };

	  function slotFactory(animationData) {
	    return new SlotManager(animationData);
	  }

	  function RenderableElement() {}

	  RenderableElement.prototype = {
	    initRenderable: function initRenderable() {
	      // layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
	      this.isInRange = false; // layer's display state

	      this.hidden = false; // If layer's transparency equals 0, it can be hidden

	      this.isTransparent = false; // list of animated components

	      this.renderableComponents = [];
	    },
	    addRenderableComponent: function addRenderableComponent(component) {
	      if (this.renderableComponents.indexOf(component) === -1) {
	        this.renderableComponents.push(component);
	      }
	    },
	    removeRenderableComponent: function removeRenderableComponent(component) {
	      if (this.renderableComponents.indexOf(component) !== -1) {
	        this.renderableComponents.splice(this.renderableComponents.indexOf(component), 1);
	      }
	    },
	    prepareRenderableFrame: function prepareRenderableFrame(num) {
	      this.checkLayerLimits(num);
	    },
	    checkTransparency: function checkTransparency() {
	      if (this.finalTransform.mProp.o.v <= 0) {
	        if (!this.isTransparent && this.globalData.renderConfig.hideOnTransparent) {
	          this.isTransparent = true;
	          this.hide();
	        }
	      } else if (this.isTransparent) {
	        this.isTransparent = false;
	        this.show();
	      }
	    },

	    /**
	       * @function
	       * Initializes frame related properties.
	       *
	       * @param {number} num
	       * current frame number in Layer's time
	       *
	       */
	    checkLayerLimits: function checkLayerLimits(num) {
	      if (this.data.ip - this.data.st <= num && this.data.op - this.data.st > num) {
	        if (this.isInRange !== true) {
	          this.globalData._mdf = true;
	          this._mdf = true;
	          this.isInRange = true;
	          this.show();
	        }
	      } else if (this.isInRange !== false) {
	        this.globalData._mdf = true;
	        this.isInRange = false;
	        this.hide();
	      }
	    },
	    renderRenderable: function renderRenderable() {
	      var i;
	      var len = this.renderableComponents.length;

	      for (i = 0; i < len; i += 1) {
	        this.renderableComponents[i].renderFrame(this._isFirstFrame);
	      }
	      /* this.maskManager.renderFrame(this.finalTransform.mat);
	          this.renderableEffectsManager.renderFrame(this._isFirstFrame); */

	    },
	    sourceRectAtTime: function sourceRectAtTime() {
	      return {
	        top: 0,
	        left: 0,
	        width: 100,
	        height: 100
	      };
	    },
	    getLayerSize: function getLayerSize() {
	      if (this.data.ty === 5) {
	        return {
	          w: this.data.textData.width,
	          h: this.data.textData.height
	        };
	      }

	      return {
	        w: this.data.width,
	        h: this.data.height
	      };
	    }
	  };

	  var getBlendMode = function () {
	    var blendModeEnums = {
	      0: 'source-over',
	      1: 'multiply',
	      2: 'screen',
	      3: 'overlay',
	      4: 'darken',
	      5: 'lighten',
	      6: 'color-dodge',
	      7: 'color-burn',
	      8: 'hard-light',
	      9: 'soft-light',
	      10: 'difference',
	      11: 'exclusion',
	      12: 'hue',
	      13: 'saturation',
	      14: 'color',
	      15: 'luminosity'
	    };
	    return function (mode) {
	      return blendModeEnums[mode] || '';
	    };
	  }();

	  function SliderEffect(data, elem, container) {
	    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
	  }

	  function AngleEffect(data, elem, container) {
	    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
	  }

	  function ColorEffect(data, elem, container) {
	    this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
	  }

	  function PointEffect(data, elem, container) {
	    this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
	  }

	  function LayerIndexEffect(data, elem, container) {
	    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
	  }

	  function MaskIndexEffect(data, elem, container) {
	    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
	  }

	  function CheckboxEffect(data, elem, container) {
	    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
	  }

	  function NoValueEffect() {
	    this.p = {};
	  }

	  function EffectsManager(data, element) {
	    var effects = data.ef || [];
	    this.effectElements = [];
	    var i;
	    var len = effects.length;
	    var effectItem;

	    for (i = 0; i < len; i += 1) {
	      effectItem = new GroupEffect(effects[i], element);
	      this.effectElements.push(effectItem);
	    }
	  }

	  function GroupEffect(data, element) {
	    this.init(data, element);
	  }

	  extendPrototype([DynamicPropertyContainer], GroupEffect);
	  GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;

	  GroupEffect.prototype.init = function (data, element) {
	    this.data = data;
	    this.effectElements = [];
	    this.initDynamicPropertyContainer(element);
	    var i;
	    var len = this.data.ef.length;
	    var eff;
	    var effects = this.data.ef;

	    for (i = 0; i < len; i += 1) {
	      eff = null;

	      switch (effects[i].ty) {
	        case 0:
	          eff = new SliderEffect(effects[i], element, this);
	          break;

	        case 1:
	          eff = new AngleEffect(effects[i], element, this);
	          break;

	        case 2:
	          eff = new ColorEffect(effects[i], element, this);
	          break;

	        case 3:
	          eff = new PointEffect(effects[i], element, this);
	          break;

	        case 4:
	        case 7:
	          eff = new CheckboxEffect(effects[i], element, this);
	          break;

	        case 10:
	          eff = new LayerIndexEffect(effects[i], element, this);
	          break;

	        case 11:
	          eff = new MaskIndexEffect(effects[i], element, this);
	          break;

	        case 5:
	          eff = new EffectsManager(effects[i], element);
	          break;
	        // case 6:

	        default:
	          eff = new NoValueEffect(effects[i]);
	          break;
	      }

	      if (eff) {
	        this.effectElements.push(eff);
	      }
	    }
	  };

	  function BaseElement() {}

	  BaseElement.prototype = {
	    checkMasks: function checkMasks() {
	      if (!this.data.hasMask) {
	        return false;
	      }

	      var i = 0;
	      var len = this.data.masksProperties.length;

	      while (i < len) {
	        if (this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false) {
	          return true;
	        }

	        i += 1;
	      }

	      return false;
	    },
	    initExpressions: function initExpressions() {
	      var expressionsInterfaces = getExpressionInterfaces();

	      if (!expressionsInterfaces) {
	        return;
	      }

	      var LayerExpressionInterface = expressionsInterfaces('layer');
	      var EffectsExpressionInterface = expressionsInterfaces('effects');
	      var ShapeExpressionInterface = expressionsInterfaces('shape');
	      var TextExpressionInterface = expressionsInterfaces('text');
	      var CompExpressionInterface = expressionsInterfaces('comp');
	      this.layerInterface = LayerExpressionInterface(this);

	      if (this.data.hasMask && this.maskManager) {
	        this.layerInterface.registerMaskInterface(this.maskManager);
	      }

	      var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this, this.layerInterface);
	      this.layerInterface.registerEffectsInterface(effectsInterface);

	      if (this.data.ty === 0 || this.data.xt) {
	        this.compInterface = CompExpressionInterface(this);
	      } else if (this.data.ty === 4) {
	        this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData, this.itemsData, this.layerInterface);
	        this.layerInterface.content = this.layerInterface.shapeInterface;
	      } else if (this.data.ty === 5) {
	        this.layerInterface.textInterface = TextExpressionInterface(this);
	        this.layerInterface.text = this.layerInterface.textInterface;
	      }
	    },
	    setBlendMode: function setBlendMode() {
	      var blendModeValue = getBlendMode(this.data.bm);
	      var elem = this.baseElement || this.layerElement;
	      elem.style['mix-blend-mode'] = blendModeValue;
	    },
	    initBaseData: function initBaseData(data, globalData, comp) {
	      this.globalData = globalData;
	      this.comp = comp;
	      this.data = data;
	      this.layerId = createElementID(); // Stretch factor for old animations missing this property.

	      if (!this.data.sr) {
	        this.data.sr = 1;
	      } // effects manager


	      this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
	    },
	    getType: function getType() {
	      return this.type;
	    },
	    sourceRectAtTime: function sourceRectAtTime() {}
	  };

	  /**
	   * @file
	   * Handles element's layer frame update.
	   * Checks layer in point and out point
	   *
	   */
	  function FrameElement() {}

	  FrameElement.prototype = {
	    /**
	       * @function
	       * Initializes frame related properties.
	       *
	       */
	    initFrame: function initFrame() {
	      // set to true when inpoint is rendered
	      this._isFirstFrame = false; // list of animated properties

	      this.dynamicProperties = []; // If layer has been modified in current tick this will be true

	      this._mdf = false;
	    },

	    /**
	       * @function
	       * Calculates all dynamic values
	       *
	       * @param {number} num
	       * current frame number in Layer's time
	       * @param {boolean} isVisible
	       * if layers is currently in range
	       *
	       */
	    prepareProperties: function prepareProperties(num, isVisible) {
	      var i;
	      var len = this.dynamicProperties.length;

	      for (i = 0; i < len; i += 1) {
	        if (isVisible || this._isParent && this.dynamicProperties[i].propType === 'transform') {
	          this.dynamicProperties[i].getValue();

	          if (this.dynamicProperties[i]._mdf) {
	            this.globalData._mdf = true;
	            this._mdf = true;
	          }
	        }
	      }
	    },
	    addDynamicProperty: function addDynamicProperty(prop) {
	      if (this.dynamicProperties.indexOf(prop) === -1) {
	        this.dynamicProperties.push(prop);
	      }
	    }
	  };

	  function FootageElement(data, globalData, comp) {
	    this.initFrame();
	    this.initRenderable();
	    this.assetData = globalData.getAssetData(data.refId);
	    this.footageData = globalData.imageLoader.getAsset(this.assetData);
	    this.initBaseData(data, globalData, comp);
	  }

	  FootageElement.prototype.prepareFrame = function () {};

	  extendPrototype([RenderableElement, BaseElement, FrameElement], FootageElement);

	  FootageElement.prototype.getBaseElement = function () {
	    return null;
	  };

	  FootageElement.prototype.renderFrame = function () {};

	  FootageElement.prototype.destroy = function () {};

	  FootageElement.prototype.initExpressions = function () {
	    var expressionsInterfaces = getExpressionInterfaces();

	    if (!expressionsInterfaces) {
	      return;
	    }

	    var FootageInterface = expressionsInterfaces('footage');
	    this.layerInterface = FootageInterface(this);
	  };

	  FootageElement.prototype.getFootageData = function () {
	    return this.footageData;
	  };

	  function AudioElement(data, globalData, comp) {
	    this.initFrame();
	    this.initRenderable();
	    this.assetData = globalData.getAssetData(data.refId);
	    this.initBaseData(data, globalData, comp);
	    this._isPlaying = false;
	    this._canPlay = false;
	    var assetPath = this.globalData.getAssetsPath(this.assetData);
	    this.audio = this.globalData.audioController.createAudio(assetPath);
	    this._currentTime = 0;
	    this.globalData.audioController.addAudio(this);
	    this._volumeMultiplier = 1;
	    this._volume = 1;
	    this._previousVolume = null;
	    this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
	      _placeholder: true
	    };
	    this.lv = PropertyFactory.getProp(this, data.au && data.au.lv ? data.au.lv : {
	      k: [100]
	    }, 1, 0.01, this);
	  }

	  AudioElement.prototype.prepareFrame = function (num) {
	    this.prepareRenderableFrame(num, true);
	    this.prepareProperties(num, true);

	    if (!this.tm._placeholder) {
	      var timeRemapped = this.tm.v;
	      this._currentTime = timeRemapped;
	    } else {
	      this._currentTime = num / this.data.sr;
	    }

	    this._volume = this.lv.v[0];
	    var totalVolume = this._volume * this._volumeMultiplier;

	    if (this._previousVolume !== totalVolume) {
	      this._previousVolume = totalVolume;
	      this.audio.volume(totalVolume);
	    }
	  };

	  extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement);

	  AudioElement.prototype.renderFrame = function () {
	    if (this.isInRange && this._canPlay) {
	      if (!this._isPlaying) {
	        this.audio.play();
	        this.audio.seek(this._currentTime / this.globalData.frameRate);
	        this._isPlaying = true;
	      } else if (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) {
	        this.audio.seek(this._currentTime / this.globalData.frameRate);
	      }
	    }
	  };

	  AudioElement.prototype.show = function () {// this.audio.play()
	  };

	  AudioElement.prototype.hide = function () {
	    this.audio.pause();
	    this._isPlaying = false;
	  };

	  AudioElement.prototype.pause = function () {
	    this.audio.pause();
	    this._isPlaying = false;
	    this._canPlay = false;
	  };

	  AudioElement.prototype.resume = function () {
	    this._canPlay = true;
	  };

	  AudioElement.prototype.setRate = function (rateValue) {
	    this.audio.rate(rateValue);
	  };

	  AudioElement.prototype.volume = function (volumeValue) {
	    this._volumeMultiplier = volumeValue;
	    this._previousVolume = volumeValue * this._volume;
	    this.audio.volume(this._previousVolume);
	  };

	  AudioElement.prototype.getBaseElement = function () {
	    return null;
	  };

	  AudioElement.prototype.destroy = function () {};

	  AudioElement.prototype.sourceRectAtTime = function () {};

	  AudioElement.prototype.initExpressions = function () {};

	  function BaseRenderer() {}

	  BaseRenderer.prototype.checkLayers = function (num) {
	    var i;
	    var len = this.layers.length;
	    var data;
	    this.completeLayers = true;

	    for (i = len - 1; i >= 0; i -= 1) {
	      if (!this.elements[i]) {
	        data = this.layers[i];

	        if (data.ip - data.st <= num - this.layers[i].st && data.op - data.st > num - this.layers[i].st) {
	          this.buildItem(i);
	        }
	      }

	      this.completeLayers = this.elements[i] ? this.completeLayers : false;
	    }

	    this.checkPendingElements();
	  };

	  BaseRenderer.prototype.createItem = function (layer) {
	    switch (layer.ty) {
	      case 2:
	        return this.createImage(layer);

	      case 0:
	        return this.createComp(layer);

	      case 1:
	        return this.createSolid(layer);

	      case 3:
	        return this.createNull(layer);

	      case 4:
	        return this.createShape(layer);

	      case 5:
	        return this.createText(layer);

	      case 6:
	        return this.createAudio(layer);

	      case 13:
	        return this.createCamera(layer);

	      case 15:
	        return this.createFootage(layer);

	      default:
	        return this.createNull(layer);
	    }
	  };

	  BaseRenderer.prototype.createCamera = function () {
	    throw new Error('You\'re using a 3d camera. Try the html renderer.');
	  };

	  BaseRenderer.prototype.createAudio = function (data) {
	    return new AudioElement(data, this.globalData, this);
	  };

	  BaseRenderer.prototype.createFootage = function (data) {
	    return new FootageElement(data, this.globalData, this);
	  };

	  BaseRenderer.prototype.buildAllItems = function () {
	    var i;
	    var len = this.layers.length;

	    for (i = 0; i < len; i += 1) {
	      this.buildItem(i);
	    }

	    this.checkPendingElements();
	  };

	  BaseRenderer.prototype.includeLayers = function (newLayers) {
	    this.completeLayers = false;
	    var i;
	    var len = newLayers.length;
	    var j;
	    var jLen = this.layers.length;

	    for (i = 0; i < len; i += 1) {
	      j = 0;

	      while (j < jLen) {
	        if (this.layers[j].id === newLayers[i].id) {
	          this.layers[j] = newLayers[i];
	          break;
	        }

	        j += 1;
	      }
	    }
	  };

	  BaseRenderer.prototype.setProjectInterface = function (pInterface) {
	    this.globalData.projectInterface = pInterface;
	  };

	  BaseRenderer.prototype.initItems = function () {
	    if (!this.globalData.progressiveLoad) {
	      this.buildAllItems();
	    }
	  };

	  BaseRenderer.prototype.buildElementParenting = function (element, parentName, hierarchy) {
	    var elements = this.elements;
	    var layers = this.layers;
	    var i = 0;
	    var len = layers.length;

	    while (i < len) {
	      if (layers[i].ind == parentName) {
	        // eslint-disable-line eqeqeq
	        if (!elements[i] || elements[i] === true) {
	          this.buildItem(i);
	          this.addPendingElement(element);
	        } else {
	          hierarchy.push(elements[i]);
	          elements[i].setAsParent();

	          if (layers[i].parent !== undefined) {
	            this.buildElementParenting(element, layers[i].parent, hierarchy);
	          } else {
	            element.setHierarchy(hierarchy);
	          }
	        }
	      }

	      i += 1;
	    }
	  };

	  BaseRenderer.prototype.addPendingElement = function (element) {
	    this.pendingElements.push(element);
	  };

	  BaseRenderer.prototype.searchExtraCompositions = function (assets) {
	    var i;
	    var len = assets.length;

	    for (i = 0; i < len; i += 1) {
	      if (assets[i].xt) {
	        var comp = this.createComp(assets[i]);
	        comp.initExpressions();
	        this.globalData.projectInterface.registerComposition(comp);
	      }
	    }
	  };

	  BaseRenderer.prototype.getElementById = function (ind) {
	    var i;
	    var len = this.elements.length;

	    for (i = 0; i < len; i += 1) {
	      if (this.elements[i].data.ind === ind) {
	        return this.elements[i];
	      }
	    }

	    return null;
	  };

	  BaseRenderer.prototype.getElementByPath = function (path) {
	    var pathValue = path.shift();
	    var element;

	    if (typeof pathValue === 'number') {
	      element = this.elements[pathValue];
	    } else {
	      var i;
	      var len = this.elements.length;

	      for (i = 0; i < len; i += 1) {
	        if (this.elements[i].data.nm === pathValue) {
	          element = this.elements[i];
	          break;
	        }
	      }
	    }

	    if (path.length === 0) {
	      return element;
	    }

	    return element.getElementByPath(path);
	  };

	  BaseRenderer.prototype.setupGlobalData = function (animData, fontsContainer) {
	    this.globalData.fontManager = new FontManager();
	    this.globalData.slotManager = slotFactory(animData);
	    this.globalData.fontManager.addChars(animData.chars);
	    this.globalData.fontManager.addFonts(animData.fonts, fontsContainer);
	    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
	    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
	    this.globalData.imageLoader = this.animationItem.imagePreloader;
	    this.globalData.audioController = this.animationItem.audioController;
	    this.globalData.frameId = 0;
	    this.globalData.frameRate = animData.fr;
	    this.globalData.nm = animData.nm;
	    this.globalData.compSize = {
	      w: animData.w,
	      h: animData.h
	    };
	  };

	  var effectTypes = {
	    TRANSFORM_EFFECT: 'transformEFfect'
	  };

	  function TransformElement() {}

	  TransformElement.prototype = {
	    initTransform: function initTransform() {
	      var mat = new Matrix();
	      this.finalTransform = {
	        mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
	          o: 0
	        },
	        _matMdf: false,
	        _localMatMdf: false,
	        _opMdf: false,
	        mat: mat,
	        localMat: mat,
	        localOpacity: 1
	      };

	      if (this.data.ao) {
	        this.finalTransform.mProp.autoOriented = true;
	      } // TODO: check TYPE 11: Guided elements


	      if (this.data.ty !== 11) ;
	    },
	    renderTransform: function renderTransform() {
	      this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
	      this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;

	      if (this.hierarchy) {
	        var mat;
	        var finalMat = this.finalTransform.mat;
	        var i = 0;
	        var len = this.hierarchy.length; // Checking if any of the transformation matrices in the hierarchy chain has changed.

	        if (!this.finalTransform._matMdf) {
	          while (i < len) {
	            if (this.hierarchy[i].finalTransform.mProp._mdf) {
	              this.finalTransform._matMdf = true;
	              break;
	            }

	            i += 1;
	          }
	        }

	        if (this.finalTransform._matMdf) {
	          mat = this.finalTransform.mProp.v.props;
	          finalMat.cloneFromProps(mat);

	          for (i = 0; i < len; i += 1) {
	            finalMat.multiply(this.hierarchy[i].finalTransform.mProp.v);
	          }
	        }
	      }

	      if (this.finalTransform._matMdf) {
	        this.finalTransform._localMatMdf = this.finalTransform._matMdf;
	      }

	      if (this.finalTransform._opMdf) {
	        this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
	      }
	    },
	    renderLocalTransform: function renderLocalTransform() {
	      if (this.localTransforms) {
	        var i = 0;
	        var len = this.localTransforms.length;
	        this.finalTransform._localMatMdf = this.finalTransform._matMdf;

	        if (!this.finalTransform._localMatMdf || !this.finalTransform._opMdf) {
	          while (i < len) {
	            if (this.localTransforms[i]._mdf) {
	              this.finalTransform._localMatMdf = true;
	            }

	            if (this.localTransforms[i]._opMdf && !this.finalTransform._opMdf) {
	              this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
	              this.finalTransform._opMdf = true;
	            }

	            i += 1;
	          }
	        }

	        if (this.finalTransform._localMatMdf) {
	          var localMat = this.finalTransform.localMat;
	          this.localTransforms[0].matrix.clone(localMat);

	          for (i = 1; i < len; i += 1) {
	            var lmat = this.localTransforms[i].matrix;
	            localMat.multiply(lmat);
	          }

	          localMat.multiply(this.finalTransform.mat);
	        }

	        if (this.finalTransform._opMdf) {
	          var localOp = this.finalTransform.localOpacity;

	          for (i = 0; i < len; i += 1) {
	            localOp *= this.localTransforms[i].opacity * 0.01;
	          }

	          this.finalTransform.localOpacity = localOp;
	        }
	      }
	    },
	    searchEffectTransforms: function searchEffectTransforms() {
	      if (this.renderableEffectsManager) {
	        var transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);

	        if (transformEffects.length) {
	          this.localTransforms = [];
	          this.finalTransform.localMat = new Matrix();
	          var i = 0;
	          var len = transformEffects.length;

	          for (i = 0; i < len; i += 1) {
	            this.localTransforms.push(transformEffects[i]);
	          }
	        }
	      }
	    },
	    globalToLocal: function globalToLocal(pt) {
	      var transforms = [];
	      transforms.push(this.finalTransform);
	      var flag = true;
	      var comp = this.comp;

	      while (flag) {
	        if (comp.finalTransform) {
	          if (comp.data.hasMask) {
	            transforms.splice(0, 0, comp.finalTransform);
	          }

	          comp = comp.comp;
	        } else {
	          flag = false;
	        }
	      }

	      var i;
	      var len = transforms.length;
	      var ptNew;

	      for (i = 0; i < len; i += 1) {
	        ptNew = transforms[i].mat.applyToPointArray(0, 0, 0); // ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);

	        pt = [pt[0] - ptNew[0], pt[1] - ptNew[1], 0];
	      }

	      return pt;
	    },
	    mHelper: new Matrix()
	  };

	  function MaskElement(data, element, globalData) {
	    this.data = data;
	    this.element = element;
	    this.globalData = globalData;
	    this.storedData = [];
	    this.masksProperties = this.data.masksProperties || [];
	    this.maskElement = null;
	    var defs = this.globalData.defs;
	    var i;
	    var len = this.masksProperties ? this.masksProperties.length : 0;
	    this.viewData = createSizedArray(len);
	    this.solidPath = '';
	    var path;
	    var properties = this.masksProperties;
	    var count = 0;
	    var currentMasks = [];
	    var j;
	    var jLen;
	    var layerId = createElementID();
	    var rect;
	    var expansor;
	    var feMorph;
	    var x;
	    var maskType = 'clipPath';
	    var maskRef = 'clip-path';

	    for (i = 0; i < len; i += 1) {
	      if (properties[i].mode !== 'a' && properties[i].mode !== 'n' || properties[i].inv || properties[i].o.k !== 100 || properties[i].o.x) {
	        maskType = 'mask';
	        maskRef = 'mask';
	      }

	      if ((properties[i].mode === 's' || properties[i].mode === 'i') && count === 0) {
	        rect = createNS('rect');
	        rect.setAttribute('fill', '#ffffff');
	        rect.setAttribute('width', this.element.comp.data.w || 0);
	        rect.setAttribute('height', this.element.comp.data.h || 0);
	        currentMasks.push(rect);
	      } else {
	        rect = null;
	      }

	      path = createNS('path');

	      if (properties[i].mode === 'n') {
	        // TODO move this to a factory or to a constructor
	        this.viewData[i] = {
	          op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
	          prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
	          elem: path,
	          lastPath: ''
	        };
	        defs.appendChild(path);
	      } else {
	        count += 1;
	        path.setAttribute('fill', properties[i].mode === 's' ? '#000000' : '#ffffff');
	        path.setAttribute('clip-rule', 'nonzero');
	        var filterID;

	        if (properties[i].x.k !== 0) {
	          maskType = 'mask';
	          maskRef = 'mask';
	          x = PropertyFactory.getProp(this.element, properties[i].x, 0, null, this.element);
	          filterID = createElementID();
	          expansor = createNS('filter');
	          expansor.setAttribute('id', filterID);
	          feMorph = createNS('feMorphology');
	          feMorph.setAttribute('operator', 'erode');
	          feMorph.setAttribute('in', 'SourceGraphic');
	          feMorph.setAttribute('radius', '0');
	          expansor.appendChild(feMorph);
	          defs.appendChild(expansor);
	          path.setAttribute('stroke', properties[i].mode === 's' ? '#000000' : '#ffffff');
	        } else {
	          feMorph = null;
	          x = null;
	        } // TODO move this to a factory or to a constructor


	        this.storedData[i] = {
	          elem: path,
	          x: x,
	          expan: feMorph,
	          lastPath: '',
	          lastOperator: '',
	          filterId: filterID,
	          lastRadius: 0
	        };

	        if (properties[i].mode === 'i') {
	          jLen = currentMasks.length;
	          var g = createNS('g');

	          for (j = 0; j < jLen; j += 1) {
	            g.appendChild(currentMasks[j]);
	          }

	          var mask = createNS('mask');
	          mask.setAttribute('mask-type', 'alpha');
	          mask.setAttribute('id', layerId + '_' + count);
	          mask.appendChild(path);
	          defs.appendChild(mask);
	          g.setAttribute('mask', 'url(' + getLocationHref() + '#' + layerId + '_' + count + ')');
	          currentMasks.length = 0;
	          currentMasks.push(g);
	        } else {
	          currentMasks.push(path);
	        }

	        if (properties[i].inv && !this.solidPath) {
	          this.solidPath = this.createLayerSolidPath();
	        } // TODO move this to a factory or to a constructor


	        this.viewData[i] = {
	          elem: path,
	          lastPath: '',
	          op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
	          prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
	          invRect: rect
	        };

	        if (!this.viewData[i].prop.k) {
	          this.drawPath(properties[i], this.viewData[i].prop.v, this.viewData[i]);
	        }
	      }
	    }

	    this.maskElement = createNS(maskType);
	    len = currentMasks.length;

	    for (i = 0; i < len; i += 1) {
	      this.maskElement.appendChild(currentMasks[i]);
	    }

	    if (count > 0) {
	      this.maskElement.setAttribute('id', layerId);
	      this.element.maskedElement.setAttribute(maskRef, 'url(' + getLocationHref() + '#' + layerId + ')');
	      defs.appendChild(this.maskElement);
	    }

	    if (this.viewData.length) {
	      this.element.addRenderableComponent(this);
	    }
	  }

	  MaskElement.prototype.getMaskProperty = function (pos) {
	    return this.viewData[pos].prop;
	  };

	  MaskElement.prototype.renderFrame = function (isFirstFrame) {
	    var finalMat = this.element.finalTransform.mat;
	    var i;
	    var len = this.masksProperties.length;

	    for (i = 0; i < len; i += 1) {
	      if (this.viewData[i].prop._mdf || isFirstFrame) {
	        this.drawPath(this.masksProperties[i], this.viewData[i].prop.v, this.viewData[i]);
	      }

	      if (this.viewData[i].op._mdf || isFirstFrame) {
	        this.viewData[i].elem.setAttribute('fill-opacity', this.viewData[i].op.v);
	      }

	      if (this.masksProperties[i].mode !== 'n') {
	        if (this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame)) {
	          this.viewData[i].invRect.setAttribute('transform', finalMat.getInverseMatrix().to2dCSS());
	        }

	        if (this.storedData[i].x && (this.storedData[i].x._mdf || isFirstFrame)) {
	          var feMorph = this.storedData[i].expan;

	          if (this.storedData[i].x.v < 0) {
	            if (this.storedData[i].lastOperator !== 'erode') {
	              this.storedData[i].lastOperator = 'erode';
	              this.storedData[i].elem.setAttribute('filter', 'url(' + getLocationHref() + '#' + this.storedData[i].filterId + ')');
	            }

	            feMorph.setAttribute('radius', -this.storedData[i].x.v);
	          } else {
	            if (this.storedData[i].lastOperator !== 'dilate') {
	              this.storedData[i].lastOperator = 'dilate';
	              this.storedData[i].elem.setAttribute('filter', null);
	            }

	            this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v * 2);
	          }
	        }
	      }
	    }
	  };

	  MaskElement.prototype.getMaskelement = function () {
	    return this.maskElement;
	  };

	  MaskElement.prototype.createLayerSolidPath = function () {
	    var path = 'M0,0 ';
	    path += ' h' + this.globalData.compSize.w;
	    path += ' v' + this.globalData.compSize.h;
	    path += ' h-' + this.globalData.compSize.w;
	    path += ' v-' + this.globalData.compSize.h + ' ';
	    return path;
	  };

	  MaskElement.prototype.drawPath = function (pathData, pathNodes, viewData) {
	    var pathString = ' M' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
	    var i;
	    var len;
	    len = pathNodes._length;

	    for (i = 1; i < len; i += 1) {
	      // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
	      pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[i][0] + ',' + pathNodes.i[i][1] + ' ' + pathNodes.v[i][0] + ',' + pathNodes.v[i][1];
	    } // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];


	    if (pathNodes.c && len > 1) {
	      pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[0][0] + ',' + pathNodes.i[0][1] + ' ' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
	    } // pathNodes.__renderedString = pathString;


	    if (viewData.lastPath !== pathString) {
	      var pathShapeValue = '';

	      if (viewData.elem) {
	        if (pathNodes.c) {
	          pathShapeValue = pathData.inv ? this.solidPath + pathString : pathString;
	        }

	        viewData.elem.setAttribute('d', pathShapeValue);
	      }

	      viewData.lastPath = pathString;
	    }
	  };

	  MaskElement.prototype.destroy = function () {
	    this.element = null;
	    this.globalData = null;
	    this.maskElement = null;
	    this.data = null;
	    this.masksProperties = null;
	  };

	  var filtersFactory = function () {
	    var ob = {};
	    ob.createFilter = createFilter;
	    ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;

	    function createFilter(filId, skipCoordinates) {
	      var fil = createNS('filter');
	      fil.setAttribute('id', filId);

	      if (skipCoordinates !== true) {
	        fil.setAttribute('filterUnits', 'objectBoundingBox');
	        fil.setAttribute('x', '0%');
	        fil.setAttribute('y', '0%');
	        fil.setAttribute('width', '100%');
	        fil.setAttribute('height', '100%');
	      }

	      return fil;
	    }

	    function createAlphaToLuminanceFilter() {
	      var feColorMatrix = createNS('feColorMatrix');
	      feColorMatrix.setAttribute('type', 'matrix');
	      feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
	      feColorMatrix.setAttribute('values', '0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');
	      return feColorMatrix;
	    }

	    return ob;
	  }();

	  var featureSupport = function () {
	    var ob = {
	      maskType: true,
	      svgLumaHidden: true,
	      offscreenCanvas: typeof OffscreenCanvas !== 'undefined'
	    };

	    if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) {
	      ob.maskType = false;
	    }

	    if (/firefox/i.test(navigator.userAgent)) {
	      ob.svgLumaHidden = false;
	    }

	    return ob;
	  }();

	  var registeredEffects$1 = {};
	  var idPrefix = 'filter_result_';

	  function SVGEffects(elem) {
	    var i;
	    var source = 'SourceGraphic';
	    var len = elem.data.ef ? elem.data.ef.length : 0;
	    var filId = createElementID();
	    var fil = filtersFactory.createFilter(filId, true);
	    var count = 0;
	    this.filters = [];
	    var filterManager;

	    for (i = 0; i < len; i += 1) {
	      filterManager = null;
	      var type = elem.data.ef[i].ty;

	      if (registeredEffects$1[type]) {
	        var Effect = registeredEffects$1[type].effect;
	        filterManager = new Effect(fil, elem.effectsManager.effectElements[i], elem, idPrefix + count, source);
	        source = idPrefix + count;

	        if (registeredEffects$1[type].countsAsEffect) {
	          count += 1;
	        }
	      }

	      if (filterManager) {
	        this.filters.push(filterManager);
	      }
	    }

	    if (count) {
	      elem.globalData.defs.appendChild(fil);
	      elem.layerElement.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
	    }

	    if (this.filters.length) {
	      elem.addRenderableComponent(this);
	    }
	  }

	  SVGEffects.prototype.renderFrame = function (_isFirstFrame) {
	    var i;
	    var len = this.filters.length;

	    for (i = 0; i < len; i += 1) {
	      this.filters[i].renderFrame(_isFirstFrame);
	    }
	  };

	  SVGEffects.prototype.getEffects = function (type) {
	    var i;
	    var len = this.filters.length;
	    var effects = [];

	    for (i = 0; i < len; i += 1) {
	      if (this.filters[i].type === type) {
	        effects.push(this.filters[i]);
	      }
	    }

	    return effects;
	  };

	  function registerEffect$1(id, effect, countsAsEffect) {
	    registeredEffects$1[id] = {
	      effect: effect,
	      countsAsEffect: countsAsEffect
	    };
	  }

	  function SVGBaseElement() {}

	  SVGBaseElement.prototype = {
	    initRendererElement: function initRendererElement() {
	      this.layerElement = createNS('g');
	    },
	    createContainerElements: function createContainerElements() {
	      this.matteElement = createNS('g');
	      this.transformedElement = this.layerElement;
	      this.maskedElement = this.layerElement;
	      this._sizeChanged = false;
	      var layerElementParent = null; // If this layer acts as a mask for the following layer

	      if (this.data.td) {
	        this.matteMasks = {};
	        var gg = createNS('g');
	        gg.setAttribute('id', this.layerId);
	        gg.appendChild(this.layerElement);
	        layerElementParent = gg;
	        this.globalData.defs.appendChild(gg);
	      } else if (this.data.tt) {
	        this.matteElement.appendChild(this.layerElement);
	        layerElementParent = this.matteElement;
	        this.baseElement = this.matteElement;
	      } else {
	        this.baseElement = this.layerElement;
	      }

	      if (this.data.ln) {
	        this.layerElement.setAttribute('id', this.data.ln);
	      }

	      if (this.data.cl) {
	        this.layerElement.setAttribute('class', this.data.cl);
	      } // Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped


	      if (this.data.ty === 0 && !this.data.hd) {
	        var cp = createNS('clipPath');
	        var pt = createNS('path');
	        pt.setAttribute('d', 'M0,0 L' + this.data.w + ',0 L' + this.data.w + ',' + this.data.h + ' L0,' + this.data.h + 'z');
	        var clipId = createElementID();
	        cp.setAttribute('id', clipId);
	        cp.appendChild(pt);
	        this.globalData.defs.appendChild(cp);

	        if (this.checkMasks()) {
	          var cpGroup = createNS('g');
	          cpGroup.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
	          cpGroup.appendChild(this.layerElement);
	          this.transformedElement = cpGroup;

	          if (layerElementParent) {
	            layerElementParent.appendChild(this.transformedElement);
	          } else {
	            this.baseElement = this.transformedElement;
	          }
	        } else {
	          this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
	        }
	      }

	      if (this.data.bm !== 0) {
	        this.setBlendMode();
	      }
	    },
	    renderElement: function renderElement() {
	      if (this.finalTransform._localMatMdf) {
	        this.transformedElement.setAttribute('transform', this.finalTransform.localMat.to2dCSS());
	      }

	      if (this.finalTransform._opMdf) {
	        this.transformedElement.setAttribute('opacity', this.finalTransform.localOpacity);
	      }
	    },
	    destroyBaseElement: function destroyBaseElement() {
	      this.layerElement = null;
	      this.matteElement = null;
	      this.maskManager.destroy();
	    },
	    getBaseElement: function getBaseElement() {
	      if (this.data.hd) {
	        return null;
	      }

	      return this.baseElement;
	    },
	    createRenderableComponents: function createRenderableComponents() {
	      this.maskManager = new MaskElement(this.data, this, this.globalData);
	      this.renderableEffectsManager = new SVGEffects(this);
	      this.searchEffectTransforms();
	    },
	    getMatte: function getMatte(matteType) {
	      // This should not be a common case. But for backward compatibility, we'll create the matte object.
	      // It solves animations that have two consecutive layers marked as matte masks.
	      // Which is an undefined behavior in AE.
	      if (!this.matteMasks) {
	        this.matteMasks = {};
	      }

	      if (!this.matteMasks[matteType]) {
	        var id = this.layerId + '_' + matteType;
	        var filId;
	        var fil;
	        var useElement;
	        var gg;

	        if (matteType === 1 || matteType === 3) {
	          var masker = createNS('mask');
	          masker.setAttribute('id', id);
	          masker.setAttribute('mask-type', matteType === 3 ? 'luminance' : 'alpha');
	          useElement = createNS('use');
	          useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
	          masker.appendChild(useElement);
	          this.globalData.defs.appendChild(masker);

	          if (!featureSupport.maskType && matteType === 1) {
	            masker.setAttribute('mask-type', 'luminance');
	            filId = createElementID();
	            fil = filtersFactory.createFilter(filId);
	            this.globalData.defs.appendChild(fil);
	            fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
	            gg = createNS('g');
	            gg.appendChild(useElement);
	            masker.appendChild(gg);
	            gg.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
	          }
	        } else if (matteType === 2) {
	          var maskGroup = createNS('mask');
	          maskGroup.setAttribute('id', id);
	          maskGroup.setAttribute('mask-type', 'alpha');
	          var maskGrouper = createNS('g');
	          maskGroup.appendChild(maskGrouper);
	          filId = createElementID();
	          fil = filtersFactory.createFilter(filId); /// /

	          var feCTr = createNS('feComponentTransfer');
	          feCTr.setAttribute('in', 'SourceGraphic');
	          fil.appendChild(feCTr);
	          var feFunc = createNS('feFuncA');
	          feFunc.setAttribute('type', 'table');
	          feFunc.setAttribute('tableValues', '1.0 0.0');
	          feCTr.appendChild(feFunc); /// /

	          this.globalData.defs.appendChild(fil);
	          var alphaRect = createNS('rect');
	          alphaRect.setAttribute('width', this.comp.data.w);
	          alphaRect.setAttribute('height', this.comp.data.h);
	          alphaRect.setAttribute('x', '0');
	          alphaRect.setAttribute('y', '0');
	          alphaRect.setAttribute('fill', '#ffffff');
	          alphaRect.setAttribute('opacity', '0');
	          maskGrouper.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
	          maskGrouper.appendChild(alphaRect);
	          useElement = createNS('use');
	          useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
	          maskGrouper.appendChild(useElement);

	          if (!featureSupport.maskType) {
	            maskGroup.setAttribute('mask-type', 'luminance');
	            fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
	            gg = createNS('g');
	            maskGrouper.appendChild(alphaRect);
	            gg.appendChild(this.layerElement);
	            maskGrouper.appendChild(gg);
	          }

	          this.globalData.defs.appendChild(maskGroup);
	        }

	        this.matteMasks[matteType] = id;
	      }

	      return this.matteMasks[matteType];
	    },
	    setMatte: function setMatte(id) {
	      if (!this.matteElement) {
	        return;
	      }

	      this.matteElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');
	    }
	  };

	  /**
	   * @file
	   * Handles AE's layer parenting property.
	   *
	   */
	  function HierarchyElement() {}

	  HierarchyElement.prototype = {
	    /**
	       * @function
	       * Initializes hierarchy properties
	       *
	       */
	    initHierarchy: function initHierarchy() {
	      // element's parent list
	      this.hierarchy = []; // if element is parent of another layer _isParent will be true

	      this._isParent = false;
	      this.checkParenting();
	    },

	    /**
	       * @function
	       * Sets layer's hierarchy.
	       * @param {array} hierarch
	       * layer's parent list
	       *
	       */
	    setHierarchy: function setHierarchy(hierarchy) {
	      this.hierarchy = hierarchy;
	    },

	    /**
	       * @function
	       * Sets layer as parent.
	       *
	       */
	    setAsParent: function setAsParent() {
	      this._isParent = true;
	    },

	    /**
	       * @function
	       * Searches layer's parenting chain
	       *
	       */
	    checkParenting: function checkParenting() {
	      if (this.data.parent !== undefined) {
	        this.comp.buildElementParenting(this, this.data.parent, []);
	      }
	    }
	  };

	  function RenderableDOMElement() {}

	  (function () {
	    var _prototype = {
	      initElement: function initElement(data, globalData, comp) {
	        this.initFrame();
	        this.initBaseData(data, globalData, comp);
	        this.initTransform(data, globalData, comp);
	        this.initHierarchy();
	        this.initRenderable();
	        this.initRendererElement();
	        this.createContainerElements();
	        this.createRenderableComponents();
	        this.createContent();
	        this.hide();
	      },
	      hide: function hide() {
	        // console.log('HIDE', this);
	        if (!this.hidden && (!this.isInRange || this.isTransparent)) {
	          var elem = this.baseElement || this.layerElement;
	          elem.style.display = 'none';
	          this.hidden = true;
	        }
	      },
	      show: function show() {
	        // console.log('SHOW', this);
	        if (this.isInRange && !this.isTransparent) {
	          if (!this.data.hd) {
	            var elem = this.baseElement || this.layerElement;
	            elem.style.display = 'block';
	          }

	          this.hidden = false;
	          this._isFirstFrame = true;
	        }
	      },
	      renderFrame: function renderFrame() {
	        // If it is exported as hidden (data.hd === true) no need to render
	        // If it is not visible no need to render
	        if (this.data.hd || this.hidden) {
	          return;
	        }

	        this.renderTransform();
	        this.renderRenderable();
	        this.renderLocalTransform();
	        this.renderElement();
	        this.renderInnerContent();

	        if (this._isFirstFrame) {
	          this._isFirstFrame = false;
	        }
	      },
	      renderInnerContent: function renderInnerContent() {},
	      prepareFrame: function prepareFrame(num) {
	        this._mdf = false;
	        this.prepareRenderableFrame(num);
	        this.prepareProperties(num, this.isInRange);
	        this.checkTransparency();
	      },
	      destroy: function destroy() {
	        this.innerElem = null;
	        this.destroyBaseElement();
	      }
	    };
	    extendPrototype([RenderableElement, createProxyFunction(_prototype)], RenderableDOMElement);
	  })();

	  function IImageElement(data, globalData, comp) {
	    this.assetData = globalData.getAssetData(data.refId);

	    if (this.assetData && this.assetData.sid) {
	      this.assetData = globalData.slotManager.getProp(this.assetData);
	    }

	    this.initElement(data, globalData, comp);
	    this.sourceRect = {
	      top: 0,
	      left: 0,
	      width: this.assetData.w,
	      height: this.assetData.h
	    };
	  }

	  extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], IImageElement);

	  IImageElement.prototype.createContent = function () {
	    var assetPath = this.globalData.getAssetsPath(this.assetData);
	    this.innerElem = createNS('image');
	    this.innerElem.setAttribute('width', this.assetData.w + 'px');
	    this.innerElem.setAttribute('height', this.assetData.h + 'px');
	    this.innerElem.setAttribute('preserveAspectRatio', this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio);
	    this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
	    this.layerElement.appendChild(this.innerElem);
	  };

	  IImageElement.prototype.sourceRectAtTime = function () {
	    return this.sourceRect;
	  };

	  function ProcessedElement(element, position) {
	    this.elem = element;
	    this.pos = position;
	  }

	  function IShapeElement() {}

	  IShapeElement.prototype = {
	    addShapeToModifiers: function addShapeToModifiers(data) {
	      var i;
	      var len = this.shapeModifiers.length;

	      for (i = 0; i < len; i += 1) {
	        this.shapeModifiers[i].addShape(data);
	      }
	    },
	    isShapeInAnimatedModifiers: function isShapeInAnimatedModifiers(data) {
	      var i = 0;
	      var len = this.shapeModifiers.length;

	      while (i < len) {
	        if (this.shapeModifiers[i].isAnimatedWithShape(data)) {
	          return true;
	        }
	      }

	      return false;
	    },
	    renderModifiers: function renderModifiers() {
	      if (!this.shapeModifiers.length) {
	        return;
	      }

	      var i;
	      var len = this.shapes.length;

	      for (i = 0; i < len; i += 1) {
	        this.shapes[i].sh.reset();
	      }

	      len = this.shapeModifiers.length;
	      var shouldBreakProcess;

	      for (i = len - 1; i >= 0; i -= 1) {
	        shouldBreakProcess = this.shapeModifiers[i].processShapes(this._isFirstFrame); // workaround to fix cases where a repeater resets the shape so the following processes get called twice
	        // TODO: find a better solution for this

	        if (shouldBreakProcess) {
	          break;
	        }
	      }
	    },
	    searchProcessedElement: function searchProcessedElement(elem) {
	      var elements = this.processedElements;
	      var i = 0;
	      var len = elements.length;

	      while (i < len) {
	        if (elements[i].elem === elem) {
	          return elements[i].pos;
	        }

	        i += 1;
	      }

	      return 0;
	    },
	    addProcessedElement: function addProcessedElement(elem, pos) {
	      var elements = this.processedElements;
	      var i = elements.length;

	      while (i) {
	        i -= 1;

	        if (elements[i].elem === elem) {
	          elements[i].pos = pos;
	          return;
	        }
	      }

	      elements.push(new ProcessedElement(elem, pos));
	    },
	    prepareFrame: function prepareFrame(num) {
	      this.prepareRenderableFrame(num);
	      this.prepareProperties(num, this.isInRange);
	    }
	  };

	  var lineCapEnum = {
	    1: 'butt',
	    2: 'round',
	    3: 'square'
	  };
	  var lineJoinEnum = {
	    1: 'miter',
	    2: 'round',
	    3: 'bevel'
	  };

	  function SVGShapeData(transformers, level, shape) {
	    this.caches = [];
	    this.styles = [];
	    this.transformers = transformers;
	    this.lStr = '';
	    this.sh = shape;
	    this.lvl = level; // TODO find if there are some cases where _isAnimated can be false.
	    // For now, since shapes add up with other shapes. They have to be calculated every time.
	    // One way of finding out is checking if all styles associated to this shape depend only of this shape

	    this._isAnimated = !!shape.k; // TODO: commenting this for now since all shapes are animated

	    var i = 0;
	    var len = transformers.length;

	    while (i < len) {
	      if (transformers[i].mProps.dynamicProperties.length) {
	        this._isAnimated = true;
	        break;
	      }

	      i += 1;
	    }
	  }

	  SVGShapeData.prototype.setAsAnimated = function () {
	    this._isAnimated = true;
	  };

	  function SVGStyleData(data, level) {
	    this.data = data;
	    this.type = data.ty;
	    this.d = '';
	    this.lvl = level;
	    this._mdf = false;
	    this.closed = data.hd === true;
	    this.pElem = createNS('path');
	    this.msElem = null;
	  }

	  SVGStyleData.prototype.reset = function () {
	    this.d = '';
	    this._mdf = false;
	  };

	  function DashProperty(elem, data, renderer, container) {
	    this.elem = elem;
	    this.frameId = -1;
	    this.dataProps = createSizedArray(data.length);
	    this.renderer = renderer;
	    this.k = false;
	    this.dashStr = '';
	    this.dashArray = createTypedArray('float32', data.length ? data.length - 1 : 0);
	    this.dashoffset = createTypedArray('float32', 1);
	    this.initDynamicPropertyContainer(container);
	    var i;
	    var len = data.length || 0;
	    var prop;

	    for (i = 0; i < len; i += 1) {
	      prop = PropertyFactory.getProp(elem, data[i].v, 0, 0, this);
	      this.k = prop.k || this.k;
	      this.dataProps[i] = {
	        n: data[i].n,
	        p: prop
	      };
	    }

	    if (!this.k) {
	      this.getValue(true);
	    }

	    this._isAnimated = this.k;
	  }

	  DashProperty.prototype.getValue = function (forceRender) {
	    if (this.elem.globalData.frameId === this.frameId && !forceRender) {
	      return;
	    }

	    this.frameId = this.elem.globalData.frameId;
	    this.iterateDynamicProperties();
	    this._mdf = this._mdf || forceRender;

	    if (this._mdf) {
	      var i = 0;
	      var len = this.dataProps.length;

	      if (this.renderer === 'svg') {
	        this.dashStr = '';
	      }

	      for (i = 0; i < len; i += 1) {
	        if (this.dataProps[i].n !== 'o') {
	          if (this.renderer === 'svg') {
	            this.dashStr += ' ' + this.dataProps[i].p.v;
	          } else {
	            this.dashArray[i] = this.dataProps[i].p.v;
	          }
	        } else {
	          this.dashoffset[0] = this.dataProps[i].p.v;
	        }
	      }
	    }
	  };

	  extendPrototype([DynamicPropertyContainer], DashProperty);

	  function SVGStrokeStyleData(elem, data, styleOb) {
	    this.initDynamicPropertyContainer(elem);
	    this.getValue = this.iterateDynamicProperties;
	    this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
	    this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
	    this.d = new DashProperty(elem, data.d || {}, 'svg', this);
	    this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
	    this.style = styleOb;
	    this._isAnimated = !!this._isAnimated;
	  }

	  extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData);

	  function SVGFillStyleData(elem, data, styleOb) {
	    this.initDynamicPropertyContainer(elem);
	    this.getValue = this.iterateDynamicProperties;
	    this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
	    this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
	    this.style = styleOb;
	  }

	  extendPrototype([DynamicPropertyContainer], SVGFillStyleData);

	  function SVGNoStyleData(elem, data, styleOb) {
	    this.initDynamicPropertyContainer(elem);
	    this.getValue = this.iterateDynamicProperties;
	    this.style = styleOb;
	  }

	  extendPrototype([DynamicPropertyContainer], SVGNoStyleData);

	  function GradientProperty(elem, data, container) {
	    this.data = data;
	    this.c = createTypedArray('uint8c', data.p * 4);
	    var cLength = data.k.k[0].s ? data.k.k[0].s.length - data.p * 4 : data.k.k.length - data.p * 4;
	    this.o = createTypedArray('float32', cLength);
	    this._cmdf = false;
	    this._omdf = false;
	    this._collapsable = this.checkCollapsable();
	    this._hasOpacity = cLength;
	    this.initDynamicPropertyContainer(container);
	    this.prop = PropertyFactory.getProp(elem, data.k, 1, null, this);
	    this.k = this.prop.k;
	    this.getValue(true);
	  }

	  GradientProperty.prototype.comparePoints = function (values, points) {
	    var i = 0;
	    var len = this.o.length / 2;
	    var diff;

	    while (i < len) {
	      diff = Math.abs(values[i * 4] - values[points * 4 + i * 2]);

	      if (diff > 0.01) {
	        return false;
	      }

	      i += 1;
	    }

	    return true;
	  };

	  GradientProperty.prototype.checkCollapsable = function () {
	    if (this.o.length / 2 !== this.c.length / 4) {
	      return false;
	    }

	    if (this.data.k.k[0].s) {
	      var i = 0;
	      var len = this.data.k.k.length;

	      while (i < len) {
	        if (!this.comparePoints(this.data.k.k[i].s, this.data.p)) {
	          return false;
	        }

	        i += 1;
	      }
	    } else if (!this.comparePoints(this.data.k.k, this.data.p)) {
	      return false;
	    }

	    return true;
	  };

	  GradientProperty.prototype.getValue = function (forceRender) {
	    this.prop.getValue();
	    this._mdf = false;
	    this._cmdf = false;
	    this._omdf = false;

	    if (this.prop._mdf || forceRender) {
	      var i;
	      var len = this.data.p * 4;
	      var mult;
	      var val;

	      for (i = 0; i < len; i += 1) {
	        mult = i % 4 === 0 ? 100 : 255;
	        val = Math.round(this.prop.v[i] * mult);

	        if (this.c[i] !== val) {
	          this.c[i] = val;
	          this._cmdf = !forceRender;
	        }
	      }

	      if (this.o.length) {
	        len = this.prop.v.length;

	        for (i = this.data.p * 4; i < len; i += 1) {
	          mult = i % 2 === 0 ? 100 : 1;
	          val = i % 2 === 0 ? Math.round(this.prop.v[i] * 100) : this.prop.v[i];

	          if (this.o[i - this.data.p * 4] !== val) {
	            this.o[i - this.data.p * 4] = val;
	            this._omdf = !forceRender;
	          }
	        }
	      }

	      this._mdf = !forceRender;
	    }
	  };

	  extendPrototype([DynamicPropertyContainer], GradientProperty);

	  function SVGGradientFillStyleData(elem, data, styleOb) {
	    this.initDynamicPropertyContainer(elem);
	    this.getValue = this.iterateDynamicProperties;
	    this.initGradientData(elem, data, styleOb);
	  }

	  SVGGradientFillStyleData.prototype.initGradientData = function (elem, data, styleOb) {
	    this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
	    this.s = PropertyFactory.getProp(elem, data.s, 1, null, this);
	    this.e = PropertyFactory.getProp(elem, data.e, 1, null, this);
	    this.h = PropertyFactory.getProp(elem, data.h || {
	      k: 0
	    }, 0, 0.01, this);
	    this.a = PropertyFactory.getProp(elem, data.a || {
	      k: 0
	    }, 0, degToRads, this);
	    this.g = new GradientProperty(elem, data.g, this);
	    this.style = styleOb;
	    this.stops = [];
	    this.setGradientData(styleOb.pElem, data);
	    this.setGradientOpacity(data, styleOb);
	    this._isAnimated = !!this._isAnimated;
	  };

	  SVGGradientFillStyleData.prototype.setGradientData = function (pathElement, data) {
	    var gradientId = createElementID();
	    var gfill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
	    gfill.setAttribute('id', gradientId);
	    gfill.setAttribute('spreadMethod', 'pad');
	    gfill.setAttribute('gradientUnits', 'userSpaceOnUse');
	    var stops = [];
	    var stop;
	    var j;
	    var jLen;
	    jLen = data.g.p * 4;

	    for (j = 0; j < jLen; j += 4) {
	      stop = createNS('stop');
	      gfill.appendChild(stop);
	      stops.push(stop);
	    }

	    pathElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + gradientId + ')');
	    this.gf = gfill;
	    this.cst = stops;
	  };

	  SVGGradientFillStyleData.prototype.setGradientOpacity = function (data, styleOb) {
	    if (this.g._hasOpacity && !this.g._collapsable) {
	      var stop;
	      var j;
	      var jLen;
	      var mask = createNS('mask');
	      var maskElement = createNS('path');
	      mask.appendChild(maskElement);
	      var opacityId = createElementID();
	      var maskId = createElementID();
	      mask.setAttribute('id', maskId);
	      var opFill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
	      opFill.setAttribute('id', opacityId);
	      opFill.setAttribute('spreadMethod', 'pad');
	      opFill.setAttribute('gradientUnits', 'userSpaceOnUse');
	      jLen = data.g.k.k[0].s ? data.g.k.k[0].s.length : data.g.k.k.length;
	      var stops = this.stops;

	      for (j = data.g.p * 4; j < jLen; j += 2) {
	        stop = createNS('stop');
	        stop.setAttribute('stop-color', 'rgb(255,255,255)');
	        opFill.appendChild(stop);
	        stops.push(stop);
	      }

	      maskElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + opacityId + ')');

	      if (data.ty === 'gs') {
	        maskElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
	        maskElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);

	        if (data.lj === 1) {
	          maskElement.setAttribute('stroke-miterlimit', data.ml);
	        }
	      }

	      this.of = opFill;
	      this.ms = mask;
	      this.ost = stops;
	      this.maskId = maskId;
	      styleOb.msElem = maskElement;
	    }
	  };

	  extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData);

	  function SVGGradientStrokeStyleData(elem, data, styleOb) {
	    this.initDynamicPropertyContainer(elem);
	    this.getValue = this.iterateDynamicProperties;
	    this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
	    this.d = new DashProperty(elem, data.d || {}, 'svg', this);
	    this.initGradientData(elem, data, styleOb);
	    this._isAnimated = !!this._isAnimated;
	  }

	  extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);

	  function ShapeGroupData() {
	    this.it = [];
	    this.prevViewData = [];
	    this.gr = createNS('g');
	  }

	  function SVGTransformData(mProps, op, container) {
	    this.transform = {
	      mProps: mProps,
	      op: op,
	      container: container
	    };
	    this.elements = [];
	    this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
	  }

	  var buildShapeString = function buildShapeString(pathNodes, length, closed, mat) {
	    if (length === 0) {
	      return '';
	    }

	    var _o = pathNodes.o;
	    var _i = pathNodes.i;
	    var _v = pathNodes.v;
	    var i;
	    var shapeString = ' M' + mat.applyToPointStringified(_v[0][0], _v[0][1]);

	    for (i = 1; i < length; i += 1) {
	      shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[i][0], _i[i][1]) + ' ' + mat.applyToPointStringified(_v[i][0], _v[i][1]);
	    }

	    if (closed && length) {
	      shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[0][0], _i[0][1]) + ' ' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
	      shapeString += 'z';
	    }

	    return shapeString;
	  };

	  var SVGElementsRenderer = function () {
	    var _identityMatrix = new Matrix();

	    var _matrixHelper = new Matrix();

	    var ob = {
	      createRenderFunction: createRenderFunction
	    };

	    function createRenderFunction(data) {
	      switch (data.ty) {
	        case 'fl':
	          return renderFill;

	        case 'gf':
	          return renderGradient;

	        case 'gs':
	          return renderGradientStroke;

	        case 'st':
	          return renderStroke;

	        case 'sh':
	        case 'el':
	        case 'rc':
	        case 'sr':
	          return renderPath;

	        case 'tr':
	          return renderContentTransform;

	        case 'no':
	          return renderNoop;

	        default:
	          return null;
	      }
	    }

	    function renderContentTransform(styleData, itemData, isFirstFrame) {
	      if (isFirstFrame || itemData.transform.op._mdf) {
	        itemData.transform.container.setAttribute('opacity', itemData.transform.op.v);
	      }

	      if (isFirstFrame || itemData.transform.mProps._mdf) {
	        itemData.transform.container.setAttribute('transform', itemData.transform.mProps.v.to2dCSS());
	      }
	    }

	    function renderNoop() {}

	    function renderPath(styleData, itemData, isFirstFrame) {
	      var j;
	      var jLen;
	      var pathStringTransformed;
	      var redraw;
	      var pathNodes;
	      var l;
	      var lLen = itemData.styles.length;
	      var lvl = itemData.lvl;
	      var paths;
	      var mat;
	      var iterations;
	      var k;

	      for (l = 0; l < lLen; l += 1) {
	        redraw = itemData.sh._mdf || isFirstFrame;

	        if (itemData.styles[l].lvl < lvl) {
	          mat = _matrixHelper.reset();
	          iterations = lvl - itemData.styles[l].lvl;
	          k = itemData.transformers.length - 1;

	          while (!redraw && iterations > 0) {
	            redraw = itemData.transformers[k].mProps._mdf || redraw;
	            iterations -= 1;
	            k -= 1;
	          }

	          if (redraw) {
	            iterations = lvl - itemData.styles[l].lvl;
	            k = itemData.transformers.length - 1;

	            while (iterations > 0) {
	              mat.multiply(itemData.transformers[k].mProps.v);
	              iterations -= 1;
	              k -= 1;
	            }
	          }
	        } else {
	          mat = _identityMatrix;
	        }

	        paths = itemData.sh.paths;
	        jLen = paths._length;

	        if (redraw) {
	          pathStringTransformed = '';

	          for (j = 0; j < jLen; j += 1) {
	            pathNodes = paths.shapes[j];

	            if (pathNodes && pathNodes._length) {
	              pathStringTransformed += buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
	            }
	          }

	          itemData.caches[l] = pathStringTransformed;
	        } else {
	          pathStringTransformed = itemData.caches[l];
	        }

	        itemData.styles[l].d += styleData.hd === true ? '' : pathStringTransformed;
	        itemData.styles[l]._mdf = redraw || itemData.styles[l]._mdf;
	      }
	    }

	    function renderFill(styleData, itemData, isFirstFrame) {
	      var styleElem = itemData.style;

	      if (itemData.c._mdf || isFirstFrame) {
	        styleElem.pElem.setAttribute('fill', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
	      }

	      if (itemData.o._mdf || isFirstFrame) {
	        styleElem.pElem.setAttribute('fill-opacity', itemData.o.v);
	      }
	    }

	    function renderGradientStroke(styleData, itemData, isFirstFrame) {
	      renderGradient(styleData, itemData, isFirstFrame);
	      renderStroke(styleData, itemData, isFirstFrame);
	    }

	    function renderGradient(styleData, itemData, isFirstFrame) {
	      var gfill = itemData.gf;
	      var hasOpacity = itemData.g._hasOpacity;
	      var pt1 = itemData.s.v;
	      var pt2 = itemData.e.v;

	      if (itemData.o._mdf || isFirstFrame) {
	        var attr = styleData.ty === 'gf' ? 'fill-opacity' : 'stroke-opacity';
	        itemData.style.pElem.setAttribute(attr, itemData.o.v);
	      }

	      if (itemData.s._mdf || isFirstFrame) {
	        var attr1 = styleData.t === 1 ? 'x1' : 'cx';
	        var attr2 = attr1 === 'x1' ? 'y1' : 'cy';
	        gfill.setAttribute(attr1, pt1[0]);
	        gfill.setAttribute(attr2, pt1[1]);

	        if (hasOpacity && !itemData.g._collapsable) {
	          itemData.of.setAttribute(attr1, pt1[0]);
	          itemData.of.setAttribute(attr2, pt1[1]);
	        }
	      }

	      var stops;
	      var i;
	      var len;
	      var stop;

	      if (itemData.g._cmdf || isFirstFrame) {
	        stops = itemData.cst;
	        var cValues = itemData.g.c;
	        len = stops.length;

	        for (i = 0; i < len; i += 1) {
	          stop = stops[i];
	          stop.setAttribute('offset', cValues[i * 4] + '%');
	          stop.setAttribute('stop-color', 'rgb(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ')');
	        }
	      }

	      if (hasOpacity && (itemData.g._omdf || isFirstFrame)) {
	        var oValues = itemData.g.o;

	        if (itemData.g._collapsable) {
	          stops = itemData.cst;
	        } else {
	          stops = itemData.ost;
	        }

	        len = stops.length;

	        for (i = 0; i < len; i += 1) {
	          stop = stops[i];

	          if (!itemData.g._collapsable) {
	            stop.setAttribute('offset', oValues[i * 2] + '%');
	          }

	          stop.setAttribute('stop-opacity', oValues[i * 2 + 1]);
	        }
	      }

	      if (styleData.t === 1) {
	        if (itemData.e._mdf || isFirstFrame) {
	          gfill.setAttribute('x2', pt2[0]);
	          gfill.setAttribute('y2', pt2[1]);

	          if (hasOpacity && !itemData.g._collapsable) {
	            itemData.of.setAttribute('x2', pt2[0]);
	            itemData.of.setAttribute('y2', pt2[1]);
	          }
	        }
	      } else {
	        var rad;

	        if (itemData.s._mdf || itemData.e._mdf || isFirstFrame) {
	          rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
	          gfill.setAttribute('r', rad);

	          if (hasOpacity && !itemData.g._collapsable) {
	            itemData.of.setAttribute('r', rad);
	          }
	        }

	        if (itemData.e._mdf || itemData.h._mdf || itemData.a._mdf || isFirstFrame) {
	          if (!rad) {
	            rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
	          }

	          var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
	          var percent = itemData.h.v;

	          if (percent >= 1) {
	            percent = 0.99;
	          } else if (percent <= -1) {
	            percent = -0.99;
	          }

	          var dist = rad * percent;
	          var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
	          var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
	          gfill.setAttribute('fx', x);
	          gfill.setAttribute('fy', y);

	          if (hasOpacity && !itemData.g._collapsable) {
	            itemData.of.setAttribute('fx', x);
	            itemData.of.setAttribute('fy', y);
	          }
	        } // gfill.setAttribute('fy','200');

	      }
	    }

	    function renderStroke(styleData, itemData, isFirstFrame) {
	      var styleElem = itemData.style;
	      var d = itemData.d;

	      if (d && (d._mdf || isFirstFrame) && d.dashStr) {
	        styleElem.pElem.setAttribute('stroke-dasharray', d.dashStr);
	        styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset[0]);
	      }

	      if (itemData.c && (itemData.c._mdf || isFirstFrame)) {
	        styleElem.pElem.setAttribute('stroke', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
	      }

	      if (itemData.o._mdf || isFirstFrame) {
	        styleElem.pElem.setAttribute('stroke-opacity', itemData.o.v);
	      }

	      if (itemData.w._mdf || isFirstFrame) {
	        styleElem.pElem.setAttribute('stroke-width', itemData.w.v);

	        if (styleElem.msElem) {
	          styleElem.msElem.setAttribute('stroke-width', itemData.w.v);
	        }
	      }
	    }

	    return ob;
	  }();

	  function SVGShapeElement(data, globalData, comp) {
	    // List of drawable elements
	    this.shapes = []; // Full shape data

	    this.shapesData = data.shapes; // List of styles that will be applied to shapes

	    this.stylesList = []; // List of modifiers that will be applied to shapes

	    this.shapeModifiers = []; // List of items in shape tree

	    this.itemsData = []; // List of items in previous shape tree

	    this.processedElements = []; // List of animated components

	    this.animatedContents = [];
	    this.initElement(data, globalData, comp); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
	    // List of elements that have been created

	    this.prevViewData = []; // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
	  }

	  extendPrototype([BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableDOMElement], SVGShapeElement);

	  SVGShapeElement.prototype.initSecondaryElement = function () {};

	  SVGShapeElement.prototype.identityMatrix = new Matrix();

	  SVGShapeElement.prototype.buildExpressionInterface = function () {};

	  SVGShapeElement.prototype.createContent = function () {
	    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
	    this.filterUniqueShapes();
	  };
	  /*
	  This method searches for multiple shapes that affect a single element and one of them is animated
	  */


	  SVGShapeElement.prototype.filterUniqueShapes = function () {
	    var i;
	    var len = this.shapes.length;
	    var shape;
	    var j;
	    var jLen = this.stylesList.length;
	    var style;
	    var tempShapes = [];
	    var areAnimated = false;

	    for (j = 0; j < jLen; j += 1) {
	      style = this.stylesList[j];
	      areAnimated = false;
	      tempShapes.length = 0;

	      for (i = 0; i < len; i += 1) {
	        shape = this.shapes[i];

	        if (shape.styles.indexOf(style) !== -1) {
	          tempShapes.push(shape);
	          areAnimated = shape._isAnimated || areAnimated;
	        }
	      }

	      if (tempShapes.length > 1 && areAnimated) {
	        this.setShapesAsAnimated(tempShapes);
	      }
	    }
	  };

	  SVGShapeElement.prototype.setShapesAsAnimated = function (shapes) {
	    var i;
	    var len = shapes.length;

	    for (i = 0; i < len; i += 1) {
	      shapes[i].setAsAnimated();
	    }
	  };

	  SVGShapeElement.prototype.createStyleElement = function (data, level) {
	    // TODO: prevent drawing of hidden styles
	    var elementData;
	    var styleOb = new SVGStyleData(data, level);
	    var pathElement = styleOb.pElem;

	    if (data.ty === 'st') {
	      elementData = new SVGStrokeStyleData(this, data, styleOb);
	    } else if (data.ty === 'fl') {
	      elementData = new SVGFillStyleData(this, data, styleOb);
	    } else if (data.ty === 'gf' || data.ty === 'gs') {
	      var GradientConstructor = data.ty === 'gf' ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
	      elementData = new GradientConstructor(this, data, styleOb);
	      this.globalData.defs.appendChild(elementData.gf);

	      if (elementData.maskId) {
	        this.globalData.defs.appendChild(elementData.ms);
	        this.globalData.defs.appendChild(elementData.of);
	        pathElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + elementData.maskId + ')');
	      }
	    } else if (data.ty === 'no') {
	      elementData = new SVGNoStyleData(this, data, styleOb);
	    }

	    if (data.ty === 'st' || data.ty === 'gs') {
	      pathElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
	      pathElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
	      pathElement.setAttribute('fill-opacity', '0');

	      if (data.lj === 1) {
	        pathElement.setAttribute('stroke-miterlimit', data.ml);
	      }
	    }

	    if (data.r === 2) {
	      pathElement.setAttribute('fill-rule', 'evenodd');
	    }

	    if (data.ln) {
	      pathElement.setAttribute('id', data.ln);
	    }

	    if (data.cl) {
	      pathElement.setAttribute('class', data.cl);
	    }

	    if (data.bm) {
	      pathElement.style['mix-blend-mode'] = getBlendMode(data.bm);
	    }

	    this.stylesList.push(styleOb);
	    this.addToAnimatedContents(data, elementData);
	    return elementData;
	  };

	  SVGShapeElement.prototype.createGroupElement = function (data) {
	    var elementData = new ShapeGroupData();

	    if (data.ln) {
	      elementData.gr.setAttribute('id', data.ln);
	    }

	    if (data.cl) {
	      elementData.gr.setAttribute('class', data.cl);
	    }

	    if (data.bm) {
	      elementData.gr.style['mix-blend-mode'] = getBlendMode(data.bm);
	    }

	    return elementData;
	  };

	  SVGShapeElement.prototype.createTransformElement = function (data, container) {
	    var transformProperty = TransformPropertyFactory.getTransformProperty(this, data, this);
	    var elementData = new SVGTransformData(transformProperty, transformProperty.o, container);
	    this.addToAnimatedContents(data, elementData);
	    return elementData;
	  };

	  SVGShapeElement.prototype.createShapeElement = function (data, ownTransformers, level) {
	    var ty = 4;

	    if (data.ty === 'rc') {
	      ty = 5;
	    } else if (data.ty === 'el') {
	      ty = 6;
	    } else if (data.ty === 'sr') {
	      ty = 7;
	    }

	    var shapeProperty = ShapePropertyFactory.getShapeProp(this, data, ty, this);
	    var elementData = new SVGShapeData(ownTransformers, level, shapeProperty);
	    this.shapes.push(elementData);
	    this.addShapeToModifiers(elementData);
	    this.addToAnimatedContents(data, elementData);
	    return elementData;
	  };

	  SVGShapeElement.prototype.addToAnimatedContents = function (data, element) {
	    var i = 0;
	    var len = this.animatedContents.length;

	    while (i < len) {
	      if (this.animatedContents[i].element === element) {
	        return;
	      }

	      i += 1;
	    }

	    this.animatedContents.push({
	      fn: SVGElementsRenderer.createRenderFunction(data),
	      element: element,
	      data: data
	    });
	  };

	  SVGShapeElement.prototype.setElementStyles = function (elementData) {
	    var arr = elementData.styles;
	    var j;
	    var jLen = this.stylesList.length;

	    for (j = 0; j < jLen; j += 1) {
	      if (!this.stylesList[j].closed) {
	        arr.push(this.stylesList[j]);
	      }
	    }
	  };

	  SVGShapeElement.prototype.reloadShapes = function () {
	    this._isFirstFrame = true;
	    var i;
	    var len = this.itemsData.length;

	    for (i = 0; i < len; i += 1) {
	      this.prevViewData[i] = this.itemsData[i];
	    }

	    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
	    this.filterUniqueShapes();
	    len = this.dynamicProperties.length;

	    for (i = 0; i < len; i += 1) {
	      this.dynamicProperties[i].getValue();
	    }

	    this.renderModifiers();
	  };

	  SVGShapeElement.prototype.searchShapes = function (arr, itemsData, prevViewData, container, level, transformers, render) {
	    var ownTransformers = [].concat(transformers);
	    var i;
	    var len = arr.length - 1;
	    var j;
	    var jLen;
	    var ownStyles = [];
	    var ownModifiers = [];
	    var currentTransform;
	    var modifier;
	    var processedPos;

	    for (i = len; i >= 0; i -= 1) {
	      processedPos = this.searchProcessedElement(arr[i]);

	      if (!processedPos) {
	        arr[i]._render = render;
	      } else {
	        itemsData[i] = prevViewData[processedPos - 1];
	      }

	      if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs' || arr[i].ty === 'no') {
	        if (!processedPos) {
	          itemsData[i] = this.createStyleElement(arr[i], level);
	        } else {
	          itemsData[i].style.closed = false;
	        }

	        if (arr[i]._render) {
	          if (itemsData[i].style.pElem.parentNode !== container) {
	            container.appendChild(itemsData[i].style.pElem);
	          }
	        }

	        ownStyles.push(itemsData[i].style);
	      } else if (arr[i].ty === 'gr') {
	        if (!processedPos) {
	          itemsData[i] = this.createGroupElement(arr[i]);
	        } else {
	          jLen = itemsData[i].it.length;

	          for (j = 0; j < jLen; j += 1) {
	            itemsData[i].prevViewData[j] = itemsData[i].it[j];
	          }
	        }

	        this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, itemsData[i].gr, level + 1, ownTransformers, render);

	        if (arr[i]._render) {
	          if (itemsData[i].gr.parentNode !== container) {
	            container.appendChild(itemsData[i].gr);
	          }
	        }
	      } else if (arr[i].ty === 'tr') {
	        if (!processedPos) {
	          itemsData[i] = this.createTransformElement(arr[i], container);
	        }

	        currentTransform = itemsData[i].transform;
	        ownTransformers.push(currentTransform);
	      } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
	        if (!processedPos) {
	          itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level);
	        }

	        this.setElementStyles(itemsData[i]);
	      } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'ms' || arr[i].ty === 'pb' || arr[i].ty === 'zz' || arr[i].ty === 'op') {
	        if (!processedPos) {
	          modifier = ShapeModifiers.getModifier(arr[i].ty);
	          modifier.init(this, arr[i]);
	          itemsData[i] = modifier;
	          this.shapeModifiers.push(modifier);
	        } else {
	          modifier = itemsData[i];
	          modifier.closed = false;
	        }

	        ownModifiers.push(modifier);
	      } else if (arr[i].ty === 'rp') {
	        if (!processedPos) {
	          modifier = ShapeModifiers.getModifier(arr[i].ty);
	          itemsData[i] = modifier;
	          modifier.init(this, arr, i, itemsData);
	          this.shapeModifiers.push(modifier);
	          render = false;
	        } else {
	          modifier = itemsData[i];
	          modifier.closed = true;
	        }

	        ownModifiers.push(modifier);
	      }

	      this.addProcessedElement(arr[i], i + 1);
	    }

	    len = ownStyles.length;

	    for (i = 0; i < len; i += 1) {
	      ownStyles[i].closed = true;
	    }

	    len = ownModifiers.length;

	    for (i = 0; i < len; i += 1) {
	      ownModifiers[i].closed = true;
	    }
	  };

	  SVGShapeElement.prototype.renderInnerContent = function () {
	    this.renderModifiers();
	    var i;
	    var len = this.stylesList.length;

	    for (i = 0; i < len; i += 1) {
	      this.stylesList[i].reset();
	    }

	    this.renderShape();

	    for (i = 0; i < len; i += 1) {
	      if (this.stylesList[i]._mdf || this._isFirstFrame) {
	        if (this.stylesList[i].msElem) {
	          this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d); // Adding M0 0 fixes same mask bug on all browsers

	          this.stylesList[i].d = 'M0 0' + this.stylesList[i].d;
	        }

	        this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d || 'M0 0');
	      }
	    }
	  };

	  SVGShapeElement.prototype.renderShape = function () {
	    var i;
	    var len = this.animatedContents.length;
	    var animatedContent;

	    for (i = 0; i < len; i += 1) {
	      animatedContent = this.animatedContents[i];

	      if ((this._isFirstFrame || animatedContent.element._isAnimated) && animatedContent.data !== true) {
	        animatedContent.fn(animatedContent.data, animatedContent.element, this._isFirstFrame);
	      }
	    }
	  };

	  SVGShapeElement.prototype.destroy = function () {
	    this.destroyBaseElement();
	    this.shapesData = null;
	    this.itemsData = null;
	  };

	  function LetterProps(o, sw, sc, fc, m, p) {
	    this.o = o;
	    this.sw = sw;
	    this.sc = sc;
	    this.fc = fc;
	    this.m = m;
	    this.p = p;
	    this._mdf = {
	      o: true,
	      sw: !!sw,
	      sc: !!sc,
	      fc: !!fc,
	      m: true,
	      p: true
	    };
	  }

	  LetterProps.prototype.update = function (o, sw, sc, fc, m, p) {
	    this._mdf.o = false;
	    this._mdf.sw = false;
	    this._mdf.sc = false;
	    this._mdf.fc = false;
	    this._mdf.m = false;
	    this._mdf.p = false;
	    var updated = false;

	    if (this.o !== o) {
	      this.o = o;
	      this._mdf.o = true;
	      updated = true;
	    }

	    if (this.sw !== sw) {
	      this.sw = sw;
	      this._mdf.sw = true;
	      updated = true;
	    }

	    if (this.sc !== sc) {
	      this.sc = sc;
	      this._mdf.sc = true;
	      updated = true;
	    }

	    if (this.fc !== fc) {
	      this.fc = fc;
	      this._mdf.fc = true;
	      updated = true;
	    }

	    if (this.m !== m) {
	      this.m = m;
	      this._mdf.m = true;
	      updated = true;
	    }

	    if (p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
	      this.p = p;
	      this._mdf.p = true;
	      updated = true;
	    }

	    return updated;
	  };

	  function TextProperty(elem, data) {
	    this._frameId = initialDefaultFrame;
	    this.pv = '';
	    this.v = '';
	    this.kf = false;
	    this._isFirstFrame = true;
	    this._mdf = false;

	    if (data.d && data.d.sid) {
	      data.d = elem.globalData.slotManager.getProp(data.d);
	    }

	    this.data = data;
	    this.elem = elem;
	    this.comp = this.elem.comp;
	    this.keysIndex = 0;
	    this.canResize = false;
	    this.minimumFontSize = 1;
	    this.effectsSequence = [];
	    this.currentData = {
	      ascent: 0,
	      boxWidth: this.defaultBoxWidth,
	      f: '',
	      fStyle: '',
	      fWeight: '',
	      fc: '',
	      j: '',
	      justifyOffset: '',
	      l: [],
	      lh: 0,
	      lineWidths: [],
	      ls: '',
	      of: '',
	      s: '',
	      sc: '',
	      sw: 0,
	      t: 0,
	      tr: 0,
	      sz: 0,
	      ps: null,
	      fillColorAnim: false,
	      strokeColorAnim: false,
	      strokeWidthAnim: false,
	      yOffset: 0,
	      finalSize: 0,
	      finalText: [],
	      finalLineHeight: 0,
	      __complete: false
	    };
	    this.copyData(this.currentData, this.data.d.k[0].s);

	    if (!this.searchProperty()) {
	      this.completeTextData(this.currentData);
	    }
	  }

	  TextProperty.prototype.defaultBoxWidth = [0, 0];

	  TextProperty.prototype.copyData = function (obj, data) {
	    for (var s in data) {
	      if (Object.prototype.hasOwnProperty.call(data, s)) {
	        obj[s] = data[s];
	      }
	    }

	    return obj;
	  };

	  TextProperty.prototype.setCurrentData = function (data) {
	    if (!data.__complete) {
	      this.completeTextData(data);
	    }

	    this.currentData = data;
	    this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
	    this._mdf = true;
	  };

	  TextProperty.prototype.searchProperty = function () {
	    return this.searchKeyframes();
	  };

	  TextProperty.prototype.searchKeyframes = function () {
	    this.kf = this.data.d.k.length > 1;

	    if (this.kf) {
	      this.addEffect(this.getKeyframeValue.bind(this));
	    }

	    return this.kf;
	  };

	  TextProperty.prototype.addEffect = function (effectFunction) {
	    this.effectsSequence.push(effectFunction);
	    this.elem.addDynamicProperty(this);
	  };

	  TextProperty.prototype.getValue = function (_finalValue) {
	    if ((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue) {
	      return;
	    }

	    this.currentData.t = this.data.d.k[this.keysIndex].s.t;
	    var currentValue = this.currentData;
	    var currentIndex = this.keysIndex;

	    if (this.lock) {
	      this.setCurrentData(this.currentData);
	      return;
	    }

	    this.lock = true;
	    this._mdf = false;
	    var i;
	    var len = this.effectsSequence.length;
	    var finalValue = _finalValue || this.data.d.k[this.keysIndex].s;

	    for (i = 0; i < len; i += 1) {
	      // Checking if index changed to prevent creating a new object every time the expression updates.
	      if (currentIndex !== this.keysIndex) {
	        finalValue = this.effectsSequence[i](finalValue, finalValue.t);
	      } else {
	        finalValue = this.effectsSequence[i](this.currentData, finalValue.t);
	      }
	    }

	    if (currentValue !== finalValue) {
	      this.setCurrentData(finalValue);
	    }

	    this.v = this.currentData;
	    this.pv = this.v;
	    this.lock = false;
	    this.frameId = this.elem.globalData.frameId;
	  };

	  TextProperty.prototype.getKeyframeValue = function () {
	    var textKeys = this.data.d.k;
	    var frameNum = this.elem.comp.renderedFrame;
	    var i = 0;
	    var len = textKeys.length;

	    while (i <= len - 1) {
	      if (i === len - 1 || textKeys[i + 1].t > frameNum) {
	        break;
	      }

	      i += 1;
	    }

	    if (this.keysIndex !== i) {
	      this.keysIndex = i;
	    }

	    return this.data.d.k[this.keysIndex].s;
	  };

	  TextProperty.prototype.buildFinalText = function (text) {
	    var charactersArray = [];
	    var i = 0;
	    var len = text.length;
	    var charCode;
	    var secondCharCode;
	    var shouldCombine = false;
	    var shouldCombineNext = false;
	    var currentChars = '';

	    while (i < len) {
	      shouldCombine = shouldCombineNext;
	      shouldCombineNext = false;
	      charCode = text.charCodeAt(i);
	      currentChars = text.charAt(i);

	      if (FontManager.isCombinedCharacter(charCode)) {
	        shouldCombine = true; // It's a potential surrogate pair (this is the High surrogate)
	      } else if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	        if (FontManager.isRegionalFlag(text, i)) {
	          currentChars = text.substr(i, 14);
	        } else {
	          secondCharCode = text.charCodeAt(i + 1); // It's a surrogate pair (this is the Low surrogate)

	          if (secondCharCode >= 0xDC00 && secondCharCode <= 0xDFFF) {
	            if (FontManager.isModifier(charCode, secondCharCode)) {
	              currentChars = text.substr(i, 2);
	              shouldCombine = true;
	            } else if (FontManager.isFlagEmoji(text.substr(i, 4))) {
	              currentChars = text.substr(i, 4);
	            } else {
	              currentChars = text.substr(i, 2);
	            }
	          }
	        }
	      } else if (charCode > 0xDBFF) {
	        secondCharCode = text.charCodeAt(i + 1);

	        if (FontManager.isVariationSelector(charCode)) {
	          shouldCombine = true;
	        }
	      } else if (FontManager.isZeroWidthJoiner(charCode)) {
	        shouldCombine = true;
	        shouldCombineNext = true;
	      }

	      if (shouldCombine) {
	        charactersArray[charactersArray.length - 1] += currentChars;
	        shouldCombine = false;
	      } else {
	        charactersArray.push(currentChars);
	      }

	      i += currentChars.length;
	    }

	    return charactersArray;
	  };

	  TextProperty.prototype.completeTextData = function (documentData) {
	    documentData.__complete = true;
	    var fontManager = this.elem.globalData.fontManager;
	    var data = this.data;
	    var letters = [];
	    var i;
	    var len;
	    var newLineFlag;
	    var index = 0;
	    var val;
	    var anchorGrouping = data.m.g;
	    var currentSize = 0;
	    var currentPos = 0;
	    var currentLine = 0;
	    var lineWidths = [];
	    var lineWidth = 0;
	    var maxLineWidth = 0;
	    var j;
	    var jLen;
	    var fontData = fontManager.getFontByName(documentData.f);
	    var charData;
	    var cLength = 0;
	    var fontProps = getFontProperties(fontData);
	    documentData.fWeight = fontProps.weight;
	    documentData.fStyle = fontProps.style;
	    documentData.finalSize = documentData.s;
	    documentData.finalText = this.buildFinalText(documentData.t);
	    len = documentData.finalText.length;
	    documentData.finalLineHeight = documentData.lh;
	    var trackingOffset = documentData.tr / 1000 * documentData.finalSize;
	    var charCode;

	    if (documentData.sz) {
	      var flag = true;
	      var boxWidth = documentData.sz[0];
	      var boxHeight = documentData.sz[1];
	      var currentHeight;
	      var finalText;

	      while (flag) {
	        finalText = this.buildFinalText(documentData.t);
	        currentHeight = 0;
	        lineWidth = 0;
	        len = finalText.length;
	        trackingOffset = documentData.tr / 1000 * documentData.finalSize;
	        var lastSpaceIndex = -1;

	        for (i = 0; i < len; i += 1) {
	          charCode = finalText[i].charCodeAt(0);
	          newLineFlag = false;

	          if (finalText[i] === ' ') {
	            lastSpaceIndex = i;
	          } else if (charCode === 13 || charCode === 3) {
	            lineWidth = 0;
	            newLineFlag = true;
	            currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
	          }

	          if (fontManager.chars) {
	            charData = fontManager.getCharData(finalText[i], fontData.fStyle, fontData.fFamily);
	            cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
	          } else {
	            // tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
	            cLength = fontManager.measureText(finalText[i], documentData.f, documentData.finalSize);
	          }

	          if (lineWidth + cLength > boxWidth && finalText[i] !== ' ') {
	            if (lastSpaceIndex === -1) {
	              len += 1;
	            } else {
	              i = lastSpaceIndex;
	            }

	            currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
	            finalText.splice(i, lastSpaceIndex === i ? 1 : 0, '\r'); // finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);

	            lastSpaceIndex = -1;
	            lineWidth = 0;
	          } else {
	            lineWidth += cLength;
	            lineWidth += trackingOffset;
	          }
	        }

	        currentHeight += fontData.ascent * documentData.finalSize / 100;

	        if (this.canResize && documentData.finalSize > this.minimumFontSize && boxHeight < currentHeight) {
	          documentData.finalSize -= 1;
	          documentData.finalLineHeight = documentData.finalSize * documentData.lh / documentData.s;
	        } else {
	          documentData.finalText = finalText;
	          len = documentData.finalText.length;
	          flag = false;
	        }
	      }
	    }

	    lineWidth = -trackingOffset;
	    cLength = 0;
	    var uncollapsedSpaces = 0;
	    var currentChar;

	    for (i = 0; i < len; i += 1) {
	      newLineFlag = false;
	      currentChar = documentData.finalText[i];
	      charCode = currentChar.charCodeAt(0);

	      if (charCode === 13 || charCode === 3) {
	        uncollapsedSpaces = 0;
	        lineWidths.push(lineWidth);
	        maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
	        lineWidth = -2 * trackingOffset;
	        val = '';
	        newLineFlag = true;
	        currentLine += 1;
	      } else {
	        val = currentChar;
	      }

	      if (fontManager.chars) {
	        charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
	        cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
	      } else {
	        // var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
	        // tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
	        cLength = fontManager.measureText(val, documentData.f, documentData.finalSize);
	      } //


	      if (currentChar === ' ') {
	        uncollapsedSpaces += cLength + trackingOffset;
	      } else {
	        lineWidth += cLength + trackingOffset + uncollapsedSpaces;
	        uncollapsedSpaces = 0;
	      }

	      letters.push({
	        l: cLength,
	        an: cLength,
	        add: currentSize,
	        n: newLineFlag,
	        anIndexes: [],
	        val: val,
	        line: currentLine,
	        animatorJustifyOffset: 0
	      });

	      if (anchorGrouping == 2) {
	        // eslint-disable-line eqeqeq
	        currentSize += cLength;

	        if (val === '' || val === ' ' || i === len - 1) {
	          if (val === '' || val === ' ') {
	            currentSize -= cLength;
	          }

	          while (currentPos <= i) {
	            letters[currentPos].an = currentSize;
	            letters[currentPos].ind = index;
	            letters[currentPos].extra = cLength;
	            currentPos += 1;
	          }

	          index += 1;
	          currentSize = 0;
	        }
	      } else if (anchorGrouping == 3) {
	        // eslint-disable-line eqeqeq
	        currentSize += cLength;

	        if (val === '' || i === len - 1) {
	          if (val === '') {
	            currentSize -= cLength;
	          }

	          while (currentPos <= i) {
	            letters[currentPos].an = currentSize;
	            letters[currentPos].ind = index;
	            letters[currentPos].extra = cLength;
	            currentPos += 1;
	          }

	          currentSize = 0;
	          index += 1;
	        }
	      } else {
	        letters[index].ind = index;
	        letters[index].extra = 0;
	        index += 1;
	      }
	    }

	    documentData.l = letters;
	    maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
	    lineWidths.push(lineWidth);

	    if (documentData.sz) {
	      documentData.boxWidth = documentData.sz[0];
	      documentData.justifyOffset = 0;
	    } else {
	      documentData.boxWidth = maxLineWidth;

	      switch (documentData.j) {
	        case 1:
	          documentData.justifyOffset = -documentData.boxWidth;
	          break;

	        case 2:
	          documentData.justifyOffset = -documentData.boxWidth / 2;
	          break;

	        default:
	          documentData.justifyOffset = 0;
	      }
	    }

	    documentData.lineWidths = lineWidths;
	    var animators = data.a;
	    var animatorData;
	    var letterData;
	    jLen = animators.length;
	    var based;
	    var ind;
	    var indexes = [];

	    for (j = 0; j < jLen; j += 1) {
	      animatorData = animators[j];

	      if (animatorData.a.sc) {
	        documentData.strokeColorAnim = true;
	      }

	      if (animatorData.a.sw) {
	        documentData.strokeWidthAnim = true;
	      }

	      if (animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb) {
	        documentData.fillColorAnim = true;
	      }

	      ind = 0;
	      based = animatorData.s.b;

	      for (i = 0; i < len; i += 1) {
	        letterData = letters[i];
	        letterData.anIndexes[j] = ind;

	        if (based == 1 && letterData.val !== '' || based == 2 && letterData.val !== '' && letterData.val !== ' ' || based == 3 && (letterData.n || letterData.val == ' ' || i == len - 1) || based == 4 && (letterData.n || i == len - 1)) {
	          // eslint-disable-line eqeqeq
	          if (animatorData.s.rn === 1) {
	            indexes.push(ind);
	          }

	          ind += 1;
	        }
	      }

	      data.a[j].s.totalChars = ind;
	      var currentInd = -1;
	      var newInd;

	      if (animatorData.s.rn === 1) {
	        for (i = 0; i < len; i += 1) {
	          letterData = letters[i];

	          if (currentInd != letterData.anIndexes[j]) {
	            // eslint-disable-line eqeqeq
	            currentInd = letterData.anIndexes[j];
	            newInd = indexes.splice(Math.floor(Math.random() * indexes.length), 1)[0];
	          }

	          letterData.anIndexes[j] = newInd;
	        }
	      }
	    }

	    documentData.yOffset = documentData.finalLineHeight || documentData.finalSize * 1.2;
	    documentData.ls = documentData.ls || 0;
	    documentData.ascent = fontData.ascent * documentData.finalSize / 100;
	  };

	  TextProperty.prototype.updateDocumentData = function (newData, index) {
	    index = index === undefined ? this.keysIndex : index;
	    var dData = this.copyData({}, this.data.d.k[index].s);
	    dData = this.copyData(dData, newData);
	    this.data.d.k[index].s = dData;
	    this.recalculate(index);
	    this.setCurrentData(dData);
	    this.elem.addDynamicProperty(this);
	  };

	  TextProperty.prototype.recalculate = function (index) {
	    var dData = this.data.d.k[index].s;
	    dData.__complete = false;
	    this.keysIndex = 0;
	    this._isFirstFrame = true;
	    this.getValue(dData);
	  };

	  TextProperty.prototype.canResizeFont = function (_canResize) {
	    this.canResize = _canResize;
	    this.recalculate(this.keysIndex);
	    this.elem.addDynamicProperty(this);
	  };

	  TextProperty.prototype.setMinimumFontSize = function (_fontValue) {
	    this.minimumFontSize = Math.floor(_fontValue) || 1;
	    this.recalculate(this.keysIndex);
	    this.elem.addDynamicProperty(this);
	  };

	  var TextSelectorProp = function () {
	    var max = Math.max;
	    var min = Math.min;
	    var floor = Math.floor;

	    function TextSelectorPropFactory(elem, data) {
	      this._currentTextLength = -1;
	      this.k = false;
	      this.data = data;
	      this.elem = elem;
	      this.comp = elem.comp;
	      this.finalS = 0;
	      this.finalE = 0;
	      this.initDynamicPropertyContainer(elem);
	      this.s = PropertyFactory.getProp(elem, data.s || {
	        k: 0
	      }, 0, 0, this);

	      if ('e' in data) {
	        this.e = PropertyFactory.getProp(elem, data.e, 0, 0, this);
	      } else {
	        this.e = {
	          v: 100
	        };
	      }

	      this.o = PropertyFactory.getProp(elem, data.o || {
	        k: 0
	      }, 0, 0, this);
	      this.xe = PropertyFactory.getProp(elem, data.xe || {
	        k: 0
	      }, 0, 0, this);
	      this.ne = PropertyFactory.getProp(elem, data.ne || {
	        k: 0
	      }, 0, 0, this);
	      this.sm = PropertyFactory.getProp(elem, data.sm || {
	        k: 100
	      }, 0, 0, this);
	      this.a = PropertyFactory.getProp(elem, data.a, 0, 0.01, this);

	      if (!this.dynamicProperties.length) {
	        this.getValue();
	      }
	    }

	    TextSelectorPropFactory.prototype = {
	      getMult: function getMult(ind) {
	        if (this._currentTextLength !== this.elem.textProperty.currentData.l.length) {
	          this.getValue();
	        }

	        var x1 = 0;
	        var y1 = 0;
	        var x2 = 1;
	        var y2 = 1;

	        if (this.ne.v > 0) {
	          x1 = this.ne.v / 100.0;
	        } else {
	          y1 = -this.ne.v / 100.0;
	        }

	        if (this.xe.v > 0) {
	          x2 = 1.0 - this.xe.v / 100.0;
	        } else {
	          y2 = 1.0 + this.xe.v / 100.0;
	        }

	        var easer = BezierFactory.getBezierEasing(x1, y1, x2, y2).get;
	        var mult = 0;
	        var s = this.finalS;
	        var e = this.finalE;
	        var type = this.data.sh;

	        if (type === 2) {
	          if (e === s) {
	            mult = ind >= e ? 1 : 0;
	          } else {
	            mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
	          }

	          mult = easer(mult);
	        } else if (type === 3) {
	          if (e === s) {
	            mult = ind >= e ? 0 : 1;
	          } else {
	            mult = 1 - max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
	          }

	          mult = easer(mult);
	        } else if (type === 4) {
	          if (e === s) {
	            mult = 0;
	          } else {
	            mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));

	            if (mult < 0.5) {
	              mult *= 2;
	            } else {
	              mult = 1 - 2 * (mult - 0.5);
	            }
	          }

	          mult = easer(mult);
	        } else if (type === 5) {
	          if (e === s) {
	            mult = 0;
	          } else {
	            var tot = e - s;
	            /* ind += 0.5;
	                      mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind; */

	            ind = min(max(0, ind + 0.5 - s), e - s);
	            var x = -tot / 2 + ind;
	            var a = tot / 2;
	            mult = Math.sqrt(1 - x * x / (a * a));
	          }

	          mult = easer(mult);
	        } else if (type === 6) {
	          if (e === s) {
	            mult = 0;
	          } else {
	            ind = min(max(0, ind + 0.5 - s), e - s);
	            mult = (1 + Math.cos(Math.PI + Math.PI * 2 * ind / (e - s))) / 2; // eslint-disable-line
	          }

	          mult = easer(mult);
	        } else {
	          if (ind >= floor(s)) {
	            if (ind - s < 0) {
	              mult = max(0, min(min(e, 1) - (s - ind), 1));
	            } else {
	              mult = max(0, min(e - ind, 1));
	            }
	          }

	          mult = easer(mult);
	        } // Smoothness implementation.
	        // The smoothness represents a reduced range of the original [0; 1] range.
	        // if smoothness is 25%, the new range will be [0.375; 0.625]
	        // Steps are:
	        // - find the lower value of the new range (threshold)
	        // - if multiplier is smaller than that value, floor it to 0
	        // - if it is larger,
	        //     - subtract the threshold
	        //     - divide it by the smoothness (this will return the range to [0; 1])
	        // Note: If it doesn't work on some scenarios, consider applying it before the easer.


	        if (this.sm.v !== 100) {
	          var smoothness = this.sm.v * 0.01;

	          if (smoothness === 0) {
	            smoothness = 0.00000001;
	          }

	          var threshold = 0.5 - smoothness * 0.5;

	          if (mult < threshold) {
	            mult = 0;
	          } else {
	            mult = (mult - threshold) / smoothness;

	            if (mult > 1) {
	              mult = 1;
	            }
	          }
	        }

	        return mult * this.a.v;
	      },
	      getValue: function getValue(newCharsFlag) {
	        this.iterateDynamicProperties();
	        this._mdf = newCharsFlag || this._mdf;
	        this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;

	        if (newCharsFlag && this.data.r === 2) {
	          this.e.v = this._currentTextLength;
	        }

	        var divisor = this.data.r === 2 ? 1 : 100 / this.data.totalChars;
	        var o = this.o.v / divisor;
	        var s = this.s.v / divisor + o;
	        var e = this.e.v / divisor + o;

	        if (s > e) {
	          var _s = s;
	          s = e;
	          e = _s;
	        }

	        this.finalS = s;
	        this.finalE = e;
	      }
	    };
	    extendPrototype([DynamicPropertyContainer], TextSelectorPropFactory);

	    function getTextSelectorProp(elem, data, arr) {
	      return new TextSelectorPropFactory(elem, data);
	    }

	    return {
	      getTextSelectorProp: getTextSelectorProp
	    };
	  }();

	  function TextAnimatorDataProperty(elem, animatorProps, container) {
	    var defaultData = {
	      propType: false
	    };
	    var getProp = PropertyFactory.getProp;
	    var textAnimatorAnimatables = animatorProps.a;
	    this.a = {
	      r: textAnimatorAnimatables.r ? getProp(elem, textAnimatorAnimatables.r, 0, degToRads, container) : defaultData,
	      rx: textAnimatorAnimatables.rx ? getProp(elem, textAnimatorAnimatables.rx, 0, degToRads, container) : defaultData,
	      ry: textAnimatorAnimatables.ry ? getProp(elem, textAnimatorAnimatables.ry, 0, degToRads, container) : defaultData,
	      sk: textAnimatorAnimatables.sk ? getProp(elem, textAnimatorAnimatables.sk, 0, degToRads, container) : defaultData,
	      sa: textAnimatorAnimatables.sa ? getProp(elem, textAnimatorAnimatables.sa, 0, degToRads, container) : defaultData,
	      s: textAnimatorAnimatables.s ? getProp(elem, textAnimatorAnimatables.s, 1, 0.01, container) : defaultData,
	      a: textAnimatorAnimatables.a ? getProp(elem, textAnimatorAnimatables.a, 1, 0, container) : defaultData,
	      o: textAnimatorAnimatables.o ? getProp(elem, textAnimatorAnimatables.o, 0, 0.01, container) : defaultData,
	      p: textAnimatorAnimatables.p ? getProp(elem, textAnimatorAnimatables.p, 1, 0, container) : defaultData,
	      sw: textAnimatorAnimatables.sw ? getProp(elem, textAnimatorAnimatables.sw, 0, 0, container) : defaultData,
	      sc: textAnimatorAnimatables.sc ? getProp(elem, textAnimatorAnimatables.sc, 1, 0, container) : defaultData,
	      fc: textAnimatorAnimatables.fc ? getProp(elem, textAnimatorAnimatables.fc, 1, 0, container) : defaultData,
	      fh: textAnimatorAnimatables.fh ? getProp(elem, textAnimatorAnimatables.fh, 0, 0, container) : defaultData,
	      fs: textAnimatorAnimatables.fs ? getProp(elem, textAnimatorAnimatables.fs, 0, 0.01, container) : defaultData,
	      fb: textAnimatorAnimatables.fb ? getProp(elem, textAnimatorAnimatables.fb, 0, 0.01, container) : defaultData,
	      t: textAnimatorAnimatables.t ? getProp(elem, textAnimatorAnimatables.t, 0, 0, container) : defaultData
	    };
	    this.s = TextSelectorProp.getTextSelectorProp(elem, animatorProps.s, container);
	    this.s.t = animatorProps.s.t;
	  }

	  function TextAnimatorProperty(textData, renderType, elem) {
	    this._isFirstFrame = true;
	    this._hasMaskedPath = false;
	    this._frameId = -1;
	    this._textData = textData;
	    this._renderType = renderType;
	    this._elem = elem;
	    this._animatorsData = createSizedArray(this._textData.a.length);
	    this._pathData = {};
	    this._moreOptions = {
	      alignment: {}
	    };
	    this.renderedLetters = [];
	    this.lettersChangedFlag = false;
	    this.initDynamicPropertyContainer(elem);
	  }

	  TextAnimatorProperty.prototype.searchProperties = function () {
	    var i;
	    var len = this._textData.a.length;
	    var animatorProps;
	    var getProp = PropertyFactory.getProp;

	    for (i = 0; i < len; i += 1) {
	      animatorProps = this._textData.a[i];
	      this._animatorsData[i] = new TextAnimatorDataProperty(this._elem, animatorProps, this);
	    }

	    if (this._textData.p && 'm' in this._textData.p) {
	      this._pathData = {
	        a: getProp(this._elem, this._textData.p.a, 0, 0, this),
	        f: getProp(this._elem, this._textData.p.f, 0, 0, this),
	        l: getProp(this._elem, this._textData.p.l, 0, 0, this),
	        r: getProp(this._elem, this._textData.p.r, 0, 0, this),
	        p: getProp(this._elem, this._textData.p.p, 0, 0, this),
	        m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
	      };
	      this._hasMaskedPath = true;
	    } else {
	      this._hasMaskedPath = false;
	    }

	    this._moreOptions.alignment = getProp(this._elem, this._textData.m.a, 1, 0, this);
	  };

	  TextAnimatorProperty.prototype.getMeasures = function (documentData, lettersChangedFlag) {
	    this.lettersChangedFlag = lettersChangedFlag;

	    if (!this._mdf && !this._isFirstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m._mdf)) {
	      return;
	    }

	    this._isFirstFrame = false;
	    var alignment = this._moreOptions.alignment.v;
	    var animators = this._animatorsData;
	    var textData = this._textData;
	    var matrixHelper = this.mHelper;
	    var renderType = this._renderType;
	    var renderedLettersCount = this.renderedLetters.length;
	    var xPos;
	    var yPos;
	    var i;
	    var len;
	    var letters = documentData.l;
	    var pathInfo;
	    var currentLength;
	    var currentPoint;
	    var segmentLength;
	    var flag;
	    var pointInd;
	    var segmentInd;
	    var prevPoint;
	    var points;
	    var segments;
	    var partialLength;
	    var totalLength;
	    var perc;
	    var tanAngle;
	    var mask;

	    if (this._hasMaskedPath) {
	      mask = this._pathData.m;

	      if (!this._pathData.n || this._pathData._mdf) {
	        var paths = mask.v;

	        if (this._pathData.r.v) {
	          paths = paths.reverse();
	        } // TODO: release bezier data cached from previous pathInfo: this._pathData.pi


	        pathInfo = {
	          tLength: 0,
	          segments: []
	        };
	        len = paths._length - 1;
	        var bezierData;
	        totalLength = 0;

	        for (i = 0; i < len; i += 1) {
	          bezierData = bez.buildBezierData(paths.v[i], paths.v[i + 1], [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]], [paths.i[i + 1][0] - paths.v[i + 1][0], paths.i[i + 1][1] - paths.v[i + 1][1]]);
	          pathInfo.tLength += bezierData.segmentLength;
	          pathInfo.segments.push(bezierData);
	          totalLength += bezierData.segmentLength;
	        }

	        i = len;

	        if (mask.v.c) {
	          bezierData = bez.buildBezierData(paths.v[i], paths.v[0], [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]], [paths.i[0][0] - paths.v[0][0], paths.i[0][1] - paths.v[0][1]]);
	          pathInfo.tLength += bezierData.segmentLength;
	          pathInfo.segments.push(bezierData);
	          totalLength += bezierData.segmentLength;
	        }

	        this._pathData.pi = pathInfo;
	      }

	      pathInfo = this._pathData.pi;
	      currentLength = this._pathData.f.v;
	      segmentInd = 0;
	      pointInd = 1;
	      segmentLength = 0;
	      flag = true;
	      segments = pathInfo.segments;

	      if (currentLength < 0 && mask.v.c) {
	        if (pathInfo.tLength < Math.abs(currentLength)) {
	          currentLength = -Math.abs(currentLength) % pathInfo.tLength;
	        }

	        segmentInd = segments.length - 1;
	        points = segments[segmentInd].points;
	        pointInd = points.length - 1;

	        while (currentLength < 0) {
	          currentLength += points[pointInd].partialLength;
	          pointInd -= 1;

	          if (pointInd < 0) {
	            segmentInd -= 1;
	            points = segments[segmentInd].points;
	            pointInd = points.length - 1;
	          }
	        }
	      }

	      points = segments[segmentInd].points;
	      prevPoint = points[pointInd - 1];
	      currentPoint = points[pointInd];
	      partialLength = currentPoint.partialLength;
	    }

	    len = letters.length;
	    xPos = 0;
	    yPos = 0;
	    var yOff = documentData.finalSize * 1.2 * 0.714;
	    var firstLine = true;
	    var animatorProps;
	    var animatorSelector;
	    var j;
	    var jLen;
	    var letterValue;
	    jLen = animators.length;
	    var mult;
	    var ind = -1;
	    var offf;
	    var xPathPos;
	    var yPathPos;
	    var initPathPos = currentLength;
	    var initSegmentInd = segmentInd;
	    var initPointInd = pointInd;
	    var currentLine = -1;
	    var elemOpacity;
	    var sc;
	    var sw;
	    var fc;
	    var k;
	    var letterSw;
	    var letterSc;
	    var letterFc;
	    var letterM = '';
	    var letterP = this.defaultPropsArray;
	    var letterO; //

	    if (documentData.j === 2 || documentData.j === 1) {
	      var animatorJustifyOffset = 0;
	      var animatorFirstCharOffset = 0;
	      var justifyOffsetMult = documentData.j === 2 ? -0.5 : -1;
	      var lastIndex = 0;
	      var isNewLine = true;

	      for (i = 0; i < len; i += 1) {
	        if (letters[i].n) {
	          if (animatorJustifyOffset) {
	            animatorJustifyOffset += animatorFirstCharOffset;
	          }

	          while (lastIndex < i) {
	            letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
	            lastIndex += 1;
	          }

	          animatorJustifyOffset = 0;
	          isNewLine = true;
	        } else {
	          for (j = 0; j < jLen; j += 1) {
	            animatorProps = animators[j].a;

	            if (animatorProps.t.propType) {
	              if (isNewLine && documentData.j === 2) {
	                animatorFirstCharOffset += animatorProps.t.v * justifyOffsetMult;
	              }

	              animatorSelector = animators[j].s;
	              mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

	              if (mult.length) {
	                animatorJustifyOffset += animatorProps.t.v * mult[0] * justifyOffsetMult;
	              } else {
	                animatorJustifyOffset += animatorProps.t.v * mult * justifyOffsetMult;
	              }
	            }
	          }

	          isNewLine = false;
	        }
	      }

	      if (animatorJustifyOffset) {
	        animatorJustifyOffset += animatorFirstCharOffset;
	      }

	      while (lastIndex < i) {
	        letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
	        lastIndex += 1;
	      }
	    } //


	    for (i = 0; i < len; i += 1) {
	      matrixHelper.reset();
	      elemOpacity = 1;

	      if (letters[i].n) {
	        xPos = 0;
	        yPos += documentData.yOffset;
	        yPos += firstLine ? 1 : 0;
	        currentLength = initPathPos;
	        firstLine = false;

	        if (this._hasMaskedPath) {
	          segmentInd = initSegmentInd;
	          pointInd = initPointInd;
	          points = segments[segmentInd].points;
	          prevPoint = points[pointInd - 1];
	          currentPoint = points[pointInd];
	          partialLength = currentPoint.partialLength;
	          segmentLength = 0;
	        }

	        letterM = '';
	        letterFc = '';
	        letterSw = '';
	        letterO = '';
	        letterP = this.defaultPropsArray;
	      } else {
	        if (this._hasMaskedPath) {
	          if (currentLine !== letters[i].line) {
	            switch (documentData.j) {
	              case 1:
	                currentLength += totalLength - documentData.lineWidths[letters[i].line];
	                break;

	              case 2:
	                currentLength += (totalLength - documentData.lineWidths[letters[i].line]) / 2;
	                break;
	            }

	            currentLine = letters[i].line;
	          }

	          if (ind !== letters[i].ind) {
	            if (letters[ind]) {
	              currentLength += letters[ind].extra;
	            }

	            currentLength += letters[i].an / 2;
	            ind = letters[i].ind;
	          }

	          currentLength += alignment[0] * letters[i].an * 0.005;
	          var animatorOffset = 0;

	          for (j = 0; j < jLen; j += 1) {
	            animatorProps = animators[j].a;

	            if (animatorProps.p.propType) {
	              animatorSelector = animators[j].s;
	              mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

	              if (mult.length) {
	                animatorOffset += animatorProps.p.v[0] * mult[0];
	              } else {
	                animatorOffset += animatorProps.p.v[0] * mult;
	              }
	            }

	            if (animatorProps.a.propType) {
	              animatorSelector = animators[j].s;
	              mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

	              if (mult.length) {
	                animatorOffset += animatorProps.a.v[0] * mult[0];
	              } else {
	                animatorOffset += animatorProps.a.v[0] * mult;
	              }
	            }
	          }

	          flag = true; // Force alignment only works with a single line for now

	          if (this._pathData.a.v) {
	            currentLength = letters[0].an * 0.5 + (totalLength - this._pathData.f.v - letters[0].an * 0.5 - letters[letters.length - 1].an * 0.5) * ind / (len - 1);
	            currentLength += this._pathData.f.v;
	          }

	          while (flag) {
	            if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
	              perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
	              xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
	              yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
	              matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -(alignment[1] * yOff) * 0.01);
	              flag = false;
	            } else if (points) {
	              segmentLength += currentPoint.partialLength;
	              pointInd += 1;

	              if (pointInd >= points.length) {
	                pointInd = 0;
	                segmentInd += 1;

	                if (!segments[segmentInd]) {
	                  if (mask.v.c) {
	                    pointInd = 0;
	                    segmentInd = 0;
	                    points = segments[segmentInd].points;
	                  } else {
	                    segmentLength -= currentPoint.partialLength;
	                    points = null;
	                  }
	                } else {
	                  points = segments[segmentInd].points;
	                }
	              }

	              if (points) {
	                prevPoint = currentPoint;
	                currentPoint = points[pointInd];
	                partialLength = currentPoint.partialLength;
	              }
	            }
	          }

	          offf = letters[i].an / 2 - letters[i].add;
	          matrixHelper.translate(-offf, 0, 0);
	        } else {
	          offf = letters[i].an / 2 - letters[i].add;
	          matrixHelper.translate(-offf, 0, 0); // Grouping alignment

	          matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -alignment[1] * yOff * 0.01, 0);
	        }

	        for (j = 0; j < jLen; j += 1) {
	          animatorProps = animators[j].a;

	          if (animatorProps.t.propType) {
	            animatorSelector = animators[j].s;
	            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars); // This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"

	            if (xPos !== 0 || documentData.j !== 0) {
	              if (this._hasMaskedPath) {
	                if (mult.length) {
	                  currentLength += animatorProps.t.v * mult[0];
	                } else {
	                  currentLength += animatorProps.t.v * mult;
	                }
	              } else if (mult.length) {
	                xPos += animatorProps.t.v * mult[0];
	              } else {
	                xPos += animatorProps.t.v * mult;
	              }
	            }
	          }
	        }

	        if (documentData.strokeWidthAnim) {
	          sw = documentData.sw || 0;
	        }

	        if (documentData.strokeColorAnim) {
	          if (documentData.sc) {
	            sc = [documentData.sc[0], documentData.sc[1], documentData.sc[2]];
	          } else {
	            sc = [0, 0, 0];
	          }
	        }

	        if (documentData.fillColorAnim && documentData.fc) {
	          fc = [documentData.fc[0], documentData.fc[1], documentData.fc[2]];
	        }

	        for (j = 0; j < jLen; j += 1) {
	          animatorProps = animators[j].a;

	          if (animatorProps.a.propType) {
	            animatorSelector = animators[j].s;
	            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

	            if (mult.length) {
	              matrixHelper.translate(-animatorProps.a.v[0] * mult[0], -animatorProps.a.v[1] * mult[1], animatorProps.a.v[2] * mult[2]);
	            } else {
	              matrixHelper.translate(-animatorProps.a.v[0] * mult, -animatorProps.a.v[1] * mult, animatorProps.a.v[2] * mult);
	            }
	          }
	        }

	        for (j = 0; j < jLen; j += 1) {
	          animatorProps = animators[j].a;

	          if (animatorProps.s.propType) {
	            animatorSelector = animators[j].s;
	            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

	            if (mult.length) {
	              matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult[0], 1 + (animatorProps.s.v[1] - 1) * mult[1], 1);
	            } else {
	              matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult, 1 + (animatorProps.s.v[1] - 1) * mult, 1);
	            }
	          }
	        }

	        for (j = 0; j < jLen; j += 1) {
	          animatorProps = animators[j].a;
	          animatorSelector = animators[j].s;
	          mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

	          if (animatorProps.sk.propType) {
	            if (mult.length) {
	              matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
	            } else {
	              matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
	            }
	          }

	          if (animatorProps.r.propType) {
	            if (mult.length) {
	              matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
	            } else {
	              matrixHelper.rotateZ(-animatorProps.r.v * mult);
	            }
	          }

	          if (animatorProps.ry.propType) {
	            if (mult.length) {
	              matrixHelper.rotateY(animatorProps.ry.v * mult[1]);
	            } else {
	              matrixHelper.rotateY(animatorProps.ry.v * mult);
	            }
	          }

	          if (animatorProps.rx.propType) {
	            if (mult.length) {
	              matrixHelper.rotateX(animatorProps.rx.v * mult[0]);
	            } else {
	              matrixHelper.rotateX(animatorProps.rx.v * mult);
	            }
	          }

	          if (animatorProps.o.propType) {
	            if (mult.length) {
	              elemOpacity += (animatorProps.o.v * mult[0] - elemOpacity) * mult[0];
	            } else {
	              elemOpacity += (animatorProps.o.v * mult - elemOpacity) * mult;
	            }
	          }

	          if (documentData.strokeWidthAnim && animatorProps.sw.propType) {
	            if (mult.length) {
	              sw += animatorProps.sw.v * mult[0];
	            } else {
	              sw += animatorProps.sw.v * mult;
	            }
	          }

	          if (documentData.strokeColorAnim && animatorProps.sc.propType) {
	            for (k = 0; k < 3; k += 1) {
	              if (mult.length) {
	                sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult[0];
	              } else {
	                sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult;
	              }
	            }
	          }

	          if (documentData.fillColorAnim && documentData.fc) {
	            if (animatorProps.fc.propType) {
	              for (k = 0; k < 3; k += 1) {
	                if (mult.length) {
	                  fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult[0];
	                } else {
	                  fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult;
	                }
	              }
	            }

	            if (animatorProps.fh.propType) {
	              if (mult.length) {
	                fc = addHueToRGB(fc, animatorProps.fh.v * mult[0]);
	              } else {
	                fc = addHueToRGB(fc, animatorProps.fh.v * mult);
	              }
	            }

	            if (animatorProps.fs.propType) {
	              if (mult.length) {
	                fc = addSaturationToRGB(fc, animatorProps.fs.v * mult[0]);
	              } else {
	                fc = addSaturationToRGB(fc, animatorProps.fs.v * mult);
	              }
	            }

	            if (animatorProps.fb.propType) {
	              if (mult.length) {
	                fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult[0]);
	              } else {
	                fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult);
	              }
	            }
	          }
	        }

	        for (j = 0; j < jLen; j += 1) {
	          animatorProps = animators[j].a;

	          if (animatorProps.p.propType) {
	            animatorSelector = animators[j].s;
	            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

	            if (this._hasMaskedPath) {
	              if (mult.length) {
	                matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
	              } else {
	                matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
	              }
	            } else if (mult.length) {
	              matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
	            } else {
	              matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
	            }
	          }
	        }

	        if (documentData.strokeWidthAnim) {
	          letterSw = sw < 0 ? 0 : sw;
	        }

	        if (documentData.strokeColorAnim) {
	          letterSc = 'rgb(' + Math.round(sc[0] * 255) + ',' + Math.round(sc[1] * 255) + ',' + Math.round(sc[2] * 255) + ')';
	        }

	        if (documentData.fillColorAnim && documentData.fc) {
	          letterFc = 'rgb(' + Math.round(fc[0] * 255) + ',' + Math.round(fc[1] * 255) + ',' + Math.round(fc[2] * 255) + ')';
	        }

	        if (this._hasMaskedPath) {
	          matrixHelper.translate(0, -documentData.ls);
	          matrixHelper.translate(0, alignment[1] * yOff * 0.01 + yPos, 0);

	          if (this._pathData.p.v) {
	            tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
	            var rot = Math.atan(tanAngle) * 180 / Math.PI;

	            if (currentPoint.point[0] < prevPoint.point[0]) {
	              rot += 180;
	            }

	            matrixHelper.rotate(-rot * Math.PI / 180);
	          }

	          matrixHelper.translate(xPathPos, yPathPos, 0);
	          currentLength -= alignment[0] * letters[i].an * 0.005;

	          if (letters[i + 1] && ind !== letters[i + 1].ind) {
	            currentLength += letters[i].an / 2;
	            currentLength += documentData.tr * 0.001 * documentData.finalSize;
	          }
	        } else {
	          matrixHelper.translate(xPos, yPos, 0);

	          if (documentData.ps) {
	            // matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
	            matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
	          }

	          switch (documentData.j) {
	            case 1:
	              matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]), 0, 0);
	              break;

	            case 2:
	              matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]) / 2, 0, 0);
	              break;
	          }

	          matrixHelper.translate(0, -documentData.ls);
	          matrixHelper.translate(offf, 0, 0);
	          matrixHelper.translate(alignment[0] * letters[i].an * 0.005, alignment[1] * yOff * 0.01, 0);
	          xPos += letters[i].l + documentData.tr * 0.001 * documentData.finalSize;
	        }

	        if (renderType === 'html') {
	          letterM = matrixHelper.toCSS();
	        } else if (renderType === 'svg') {
	          letterM = matrixHelper.to2dCSS();
	        } else {
	          letterP = [matrixHelper.props[0], matrixHelper.props[1], matrixHelper.props[2], matrixHelper.props[3], matrixHelper.props[4], matrixHelper.props[5], matrixHelper.props[6], matrixHelper.props[7], matrixHelper.props[8], matrixHelper.props[9], matrixHelper.props[10], matrixHelper.props[11], matrixHelper.props[12], matrixHelper.props[13], matrixHelper.props[14], matrixHelper.props[15]];
	        }

	        letterO = elemOpacity;
	      }

	      if (renderedLettersCount <= i) {
	        letterValue = new LetterProps(letterO, letterSw, letterSc, letterFc, letterM, letterP);
	        this.renderedLetters.push(letterValue);
	        renderedLettersCount += 1;
	        this.lettersChangedFlag = true;
	      } else {
	        letterValue = this.renderedLetters[i];
	        this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
	      }
	    }
	  };

	  TextAnimatorProperty.prototype.getValue = function () {
	    if (this._elem.globalData.frameId === this._frameId) {
	      return;
	    }

	    this._frameId = this._elem.globalData.frameId;
	    this.iterateDynamicProperties();
	  };

	  TextAnimatorProperty.prototype.mHelper = new Matrix();
	  TextAnimatorProperty.prototype.defaultPropsArray = [];
	  extendPrototype([DynamicPropertyContainer], TextAnimatorProperty);

	  function ITextElement() {}

	  ITextElement.prototype.initElement = function (data, globalData, comp) {
	    this.lettersChangedFlag = true;
	    this.initFrame();
	    this.initBaseData(data, globalData, comp);
	    this.textProperty = new TextProperty(this, data.t, this.dynamicProperties);
	    this.textAnimator = new TextAnimatorProperty(data.t, this.renderType, this);
	    this.initTransform(data, globalData, comp);
	    this.initHierarchy();
	    this.initRenderable();
	    this.initRendererElement();
	    this.createContainerElements();
	    this.createRenderableComponents();
	    this.createContent();
	    this.hide();
	    this.textAnimator.searchProperties(this.dynamicProperties);
	  };

	  ITextElement.prototype.prepareFrame = function (num) {
	    this._mdf = false;
	    this.prepareRenderableFrame(num);
	    this.prepareProperties(num, this.isInRange);
	  };

	  ITextElement.prototype.createPathShape = function (matrixHelper, shapes) {
	    var j;
	    var jLen = shapes.length;
	    var pathNodes;
	    var shapeStr = '';

	    for (j = 0; j < jLen; j += 1) {
	      if (shapes[j].ty === 'sh') {
	        pathNodes = shapes[j].ks.k;
	        shapeStr += buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
	      }
	    }

	    return shapeStr;
	  };

	  ITextElement.prototype.updateDocumentData = function (newData, index) {
	    this.textProperty.updateDocumentData(newData, index);
	  };

	  ITextElement.prototype.canResizeFont = function (_canResize) {
	    this.textProperty.canResizeFont(_canResize);
	  };

	  ITextElement.prototype.setMinimumFontSize = function (_fontSize) {
	    this.textProperty.setMinimumFontSize(_fontSize);
	  };

	  ITextElement.prototype.applyTextPropertiesToMatrix = function (documentData, matrixHelper, lineNumber, xPos, yPos) {
	    if (documentData.ps) {
	      matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
	    }

	    matrixHelper.translate(0, -documentData.ls, 0);

	    switch (documentData.j) {
	      case 1:
	        matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]), 0, 0);
	        break;

	      case 2:
	        matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]) / 2, 0, 0);
	        break;
	    }

	    matrixHelper.translate(xPos, yPos, 0);
	  };

	  ITextElement.prototype.buildColor = function (colorData) {
	    return 'rgb(' + Math.round(colorData[0] * 255) + ',' + Math.round(colorData[1] * 255) + ',' + Math.round(colorData[2] * 255) + ')';
	  };

	  ITextElement.prototype.emptyProp = new LetterProps();

	  ITextElement.prototype.destroy = function () {};

	  ITextElement.prototype.validateText = function () {
	    if (this.textProperty._mdf || this.textProperty._isFirstFrame) {
	      this.buildNewText();
	      this.textProperty._isFirstFrame = false;
	      this.textProperty._mdf = false;
	    }
	  };

	  var emptyShapeData = {
	    shapes: []
	  };

	  function SVGTextLottieElement(data, globalData, comp) {
	    this.textSpans = [];
	    this.renderType = 'svg';
	    this.initElement(data, globalData, comp);
	  }

	  extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], SVGTextLottieElement);

	  SVGTextLottieElement.prototype.createContent = function () {
	    if (this.data.singleShape && !this.globalData.fontManager.chars) {
	      this.textContainer = createNS('text');
	    }
	  };

	  SVGTextLottieElement.prototype.buildTextContents = function (textArray) {
	    var i = 0;
	    var len = textArray.length;
	    var textContents = [];
	    var currentTextContent = '';

	    while (i < len) {
	      if (textArray[i] === String.fromCharCode(13) || textArray[i] === String.fromCharCode(3)) {
	        textContents.push(currentTextContent);
	        currentTextContent = '';
	      } else {
	        currentTextContent += textArray[i];
	      }

	      i += 1;
	    }

	    textContents.push(currentTextContent);
	    return textContents;
	  };

	  SVGTextLottieElement.prototype.buildShapeData = function (data, scale) {
	    // data should probably be cloned to apply scale separately to each instance of a text on different layers
	    // but since text internal content gets only rendered once and then it's never rerendered,
	    // it's probably safe not to clone data and reuse always the same instance even if the object is mutated.
	    // Avoiding cloning is preferred since cloning each character shape data is expensive
	    if (data.shapes && data.shapes.length) {
	      var shape = data.shapes[0];

	      if (shape.it) {
	        var shapeItem = shape.it[shape.it.length - 1];

	        if (shapeItem.s) {
	          shapeItem.s.k[0] = scale;
	          shapeItem.s.k[1] = scale;
	        }
	      }
	    }

	    return data;
	  };

	  SVGTextLottieElement.prototype.buildNewText = function () {
	    this.addDynamicProperty(this);
	    var i;
	    var len;
	    var documentData = this.textProperty.currentData;
	    this.renderedLetters = createSizedArray(documentData ? documentData.l.length : 0);

	    if (documentData.fc) {
	      this.layerElement.setAttribute('fill', this.buildColor(documentData.fc));
	    } else {
	      this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
	    }

	    if (documentData.sc) {
	      this.layerElement.setAttribute('stroke', this.buildColor(documentData.sc));
	      this.layerElement.setAttribute('stroke-width', documentData.sw);
	    }

	    this.layerElement.setAttribute('font-size', documentData.finalSize);
	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);

	    if (fontData.fClass) {
	      this.layerElement.setAttribute('class', fontData.fClass);
	    } else {
	      this.layerElement.setAttribute('font-family', fontData.fFamily);
	      var fWeight = documentData.fWeight;
	      var fStyle = documentData.fStyle;
	      this.layerElement.setAttribute('font-style', fStyle);
	      this.layerElement.setAttribute('font-weight', fWeight);
	    }

	    this.layerElement.setAttribute('aria-label', documentData.t);
	    var letters = documentData.l || [];
	    var usesGlyphs = !!this.globalData.fontManager.chars;
	    len = letters.length;
	    var tSpan;
	    var matrixHelper = this.mHelper;
	    var shapeStr = '';
	    var singleShape = this.data.singleShape;
	    var xPos = 0;
	    var yPos = 0;
	    var firstLine = true;
	    var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;

	    if (singleShape && !usesGlyphs && !documentData.sz) {
	      var tElement = this.textContainer;
	      var justify = 'start';

	      switch (documentData.j) {
	        case 1:
	          justify = 'end';
	          break;

	        case 2:
	          justify = 'middle';
	          break;

	        default:
	          justify = 'start';
	          break;
	      }

	      tElement.setAttribute('text-anchor', justify);
	      tElement.setAttribute('letter-spacing', trackingOffset);
	      var textContent = this.buildTextContents(documentData.finalText);
	      len = textContent.length;
	      yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;

	      for (i = 0; i < len; i += 1) {
	        tSpan = this.textSpans[i].span || createNS('tspan');
	        tSpan.textContent = textContent[i];
	        tSpan.setAttribute('x', 0);
	        tSpan.setAttribute('y', yPos);
	        tSpan.style.display = 'inherit';
	        tElement.appendChild(tSpan);

	        if (!this.textSpans[i]) {
	          this.textSpans[i] = {
	            span: null,
	            glyph: null
	          };
	        }

	        this.textSpans[i].span = tSpan;
	        yPos += documentData.finalLineHeight;
	      }

	      this.layerElement.appendChild(tElement);
	    } else {
	      var cachedSpansLength = this.textSpans.length;
	      var charData;

	      for (i = 0; i < len; i += 1) {
	        if (!this.textSpans[i]) {
	          this.textSpans[i] = {
	            span: null,
	            childSpan: null,
	            glyph: null
	          };
	        }

	        if (!usesGlyphs || !singleShape || i === 0) {
	          tSpan = cachedSpansLength > i ? this.textSpans[i].span : createNS(usesGlyphs ? 'g' : 'text');

	          if (cachedSpansLength <= i) {
	            tSpan.setAttribute('stroke-linecap', 'butt');
	            tSpan.setAttribute('stroke-linejoin', 'round');
	            tSpan.setAttribute('stroke-miterlimit', '4');
	            this.textSpans[i].span = tSpan;

	            if (usesGlyphs) {
	              var childSpan = createNS('g');
	              tSpan.appendChild(childSpan);
	              this.textSpans[i].childSpan = childSpan;
	            }

	            this.textSpans[i].span = tSpan;
	            this.layerElement.appendChild(tSpan);
	          }

	          tSpan.style.display = 'inherit';
	        }

	        matrixHelper.reset();

	        if (singleShape) {
	          if (letters[i].n) {
	            xPos = -trackingOffset;
	            yPos += documentData.yOffset;
	            yPos += firstLine ? 1 : 0;
	            firstLine = false;
	          }

	          this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
	          xPos += letters[i].l || 0; // xPos += letters[i].val === ' ' ? 0 : trackingOffset;

	          xPos += trackingOffset;
	        }

	        if (usesGlyphs) {
	          charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	          var glyphElement; // t === 1 means the character has been replaced with an animated shaped

	          if (charData.t === 1) {
	            glyphElement = new SVGCompElement(charData.data, this.globalData, this);
	          } else {
	            var data = emptyShapeData;

	            if (charData.data && charData.data.shapes) {
	              data = this.buildShapeData(charData.data, documentData.finalSize);
	            }

	            glyphElement = new SVGShapeElement(data, this.globalData, this);
	          }

	          if (this.textSpans[i].glyph) {
	            var glyph = this.textSpans[i].glyph;
	            this.textSpans[i].childSpan.removeChild(glyph.layerElement);
	            glyph.destroy();
	          }

	          this.textSpans[i].glyph = glyphElement;
	          glyphElement._debug = true;
	          glyphElement.prepareFrame(0);
	          glyphElement.renderFrame();
	          this.textSpans[i].childSpan.appendChild(glyphElement.layerElement); // when using animated shapes, the layer will be scaled instead of replacing the internal scale
	          // this might have issues with strokes and might need a different solution

	          if (charData.t === 1) {
	            this.textSpans[i].childSpan.setAttribute('transform', 'scale(' + documentData.finalSize / 100 + ',' + documentData.finalSize / 100 + ')');
	          }
	        } else {
	          if (singleShape) {
	            tSpan.setAttribute('transform', 'translate(' + matrixHelper.props[12] + ',' + matrixHelper.props[13] + ')');
	          }

	          tSpan.textContent = letters[i].val;
	          tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
	        } //

	      }

	      if (singleShape && tSpan) {
	        tSpan.setAttribute('d', shapeStr);
	      }
	    }

	    while (i < this.textSpans.length) {
	      this.textSpans[i].span.style.display = 'none';
	      i += 1;
	    }

	    this._sizeChanged = true;
	  };

	  SVGTextLottieElement.prototype.sourceRectAtTime = function () {
	    this.prepareFrame(this.comp.renderedFrame - this.data.st);
	    this.renderInnerContent();

	    if (this._sizeChanged) {
	      this._sizeChanged = false;
	      var textBox = this.layerElement.getBBox();
	      this.bbox = {
	        top: textBox.y,
	        left: textBox.x,
	        width: textBox.width,
	        height: textBox.height
	      };
	    }

	    return this.bbox;
	  };

	  SVGTextLottieElement.prototype.getValue = function () {
	    var i;
	    var len = this.textSpans.length;
	    var glyphElement;
	    this.renderedFrame = this.comp.renderedFrame;

	    for (i = 0; i < len; i += 1) {
	      glyphElement = this.textSpans[i].glyph;

	      if (glyphElement) {
	        glyphElement.prepareFrame(this.comp.renderedFrame - this.data.st);

	        if (glyphElement._mdf) {
	          this._mdf = true;
	        }
	      }
	    }
	  };

	  SVGTextLottieElement.prototype.renderInnerContent = function () {
	    this.validateText();

	    if (!this.data.singleShape || this._mdf) {
	      this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);

	      if (this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
	        this._sizeChanged = true;
	        var i;
	        var len;
	        var renderedLetters = this.textAnimator.renderedLetters;
	        var letters = this.textProperty.currentData.l;
	        len = letters.length;
	        var renderedLetter;
	        var textSpan;
	        var glyphElement;

	        for (i = 0; i < len; i += 1) {
	          if (!letters[i].n) {
	            renderedLetter = renderedLetters[i];
	            textSpan = this.textSpans[i].span;
	            glyphElement = this.textSpans[i].glyph;

	            if (glyphElement) {
	              glyphElement.renderFrame();
	            }

	            if (renderedLetter._mdf.m) {
	              textSpan.setAttribute('transform', renderedLetter.m);
	            }

	            if (renderedLetter._mdf.o) {
	              textSpan.setAttribute('opacity', renderedLetter.o);
	            }

	            if (renderedLetter._mdf.sw) {
	              textSpan.setAttribute('stroke-width', renderedLetter.sw);
	            }

	            if (renderedLetter._mdf.sc) {
	              textSpan.setAttribute('stroke', renderedLetter.sc);
	            }

	            if (renderedLetter._mdf.fc) {
	              textSpan.setAttribute('fill', renderedLetter.fc);
	            }
	          }
	        }
	      }
	    }
	  };

	  function ISolidElement(data, globalData, comp) {
	    this.initElement(data, globalData, comp);
	  }

	  extendPrototype([IImageElement], ISolidElement);

	  ISolidElement.prototype.createContent = function () {
	    var rect = createNS('rect'); /// /rect.style.width = this.data.sw;
	    /// /rect.style.height = this.data.sh;
	    /// /rect.style.fill = this.data.sc;

	    rect.setAttribute('width', this.data.sw);
	    rect.setAttribute('height', this.data.sh);
	    rect.setAttribute('fill', this.data.sc);
	    this.layerElement.appendChild(rect);
	  };

	  function NullElement(data, globalData, comp) {
	    this.initFrame();
	    this.initBaseData(data, globalData, comp);
	    this.initFrame();
	    this.initTransform(data, globalData, comp);
	    this.initHierarchy();
	  }

	  NullElement.prototype.prepareFrame = function (num) {
	    this.prepareProperties(num, true);
	  };

	  NullElement.prototype.renderFrame = function () {};

	  NullElement.prototype.getBaseElement = function () {
	    return null;
	  };

	  NullElement.prototype.destroy = function () {};

	  NullElement.prototype.sourceRectAtTime = function () {};

	  NullElement.prototype.hide = function () {};

	  extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement], NullElement);

	  function SVGRendererBase() {}

	  extendPrototype([BaseRenderer], SVGRendererBase);

	  SVGRendererBase.prototype.createNull = function (data) {
	    return new NullElement(data, this.globalData, this);
	  };

	  SVGRendererBase.prototype.createShape = function (data) {
	    return new SVGShapeElement(data, this.globalData, this);
	  };

	  SVGRendererBase.prototype.createText = function (data) {
	    return new SVGTextLottieElement(data, this.globalData, this);
	  };

	  SVGRendererBase.prototype.createImage = function (data) {
	    return new IImageElement(data, this.globalData, this);
	  };

	  SVGRendererBase.prototype.createSolid = function (data) {
	    return new ISolidElement(data, this.globalData, this);
	  };

	  SVGRendererBase.prototype.configAnimation = function (animData) {
	    this.svgElement.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
	    this.svgElement.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');

	    if (this.renderConfig.viewBoxSize) {
	      this.svgElement.setAttribute('viewBox', this.renderConfig.viewBoxSize);
	    } else {
	      this.svgElement.setAttribute('viewBox', '0 0 ' + animData.w + ' ' + animData.h);
	    }

	    if (!this.renderConfig.viewBoxOnly) {
	      this.svgElement.setAttribute('width', animData.w);
	      this.svgElement.setAttribute('height', animData.h);
	      this.svgElement.style.width = '100%';
	      this.svgElement.style.height = '100%';
	      this.svgElement.style.transform = 'translate3d(0,0,0)';
	      this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility;
	    }

	    if (this.renderConfig.width) {
	      this.svgElement.setAttribute('width', this.renderConfig.width);
	    }

	    if (this.renderConfig.height) {
	      this.svgElement.setAttribute('height', this.renderConfig.height);
	    }

	    if (this.renderConfig.className) {
	      this.svgElement.setAttribute('class', this.renderConfig.className);
	    }

	    if (this.renderConfig.id) {
	      this.svgElement.setAttribute('id', this.renderConfig.id);
	    }

	    if (this.renderConfig.focusable !== undefined) {
	      this.svgElement.setAttribute('focusable', this.renderConfig.focusable);
	    }

	    this.svgElement.setAttribute('preserveAspectRatio', this.renderConfig.preserveAspectRatio); // this.layerElement.style.transform = 'translate3d(0,0,0)';
	    // this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";

	    this.animationItem.wrapper.appendChild(this.svgElement); // Mask animation

	    var defs = this.globalData.defs;
	    this.setupGlobalData(animData, defs);
	    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
	    this.data = animData;
	    var maskElement = createNS('clipPath');
	    var rect = createNS('rect');
	    rect.setAttribute('width', animData.w);
	    rect.setAttribute('height', animData.h);
	    rect.setAttribute('x', 0);
	    rect.setAttribute('y', 0);
	    var maskId = createElementID();
	    maskElement.setAttribute('id', maskId);
	    maskElement.appendChild(rect);
	    this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + maskId + ')');
	    defs.appendChild(maskElement);
	    this.layers = animData.layers;
	    this.elements = createSizedArray(animData.layers.length);
	  };

	  SVGRendererBase.prototype.destroy = function () {
	    if (this.animationItem.wrapper) {
	      this.animationItem.wrapper.innerText = '';
	    }

	    this.layerElement = null;
	    this.globalData.defs = null;
	    var i;
	    var len = this.layers ? this.layers.length : 0;

	    for (i = 0; i < len; i += 1) {
	      if (this.elements[i] && this.elements[i].destroy) {
	        this.elements[i].destroy();
	      }
	    }

	    this.elements.length = 0;
	    this.destroyed = true;
	    this.animationItem = null;
	  };

	  SVGRendererBase.prototype.updateContainerSize = function () {};

	  SVGRendererBase.prototype.findIndexByInd = function (ind) {
	    var i = 0;
	    var len = this.layers.length;

	    for (i = 0; i < len; i += 1) {
	      if (this.layers[i].ind === ind) {
	        return i;
	      }
	    }

	    return -1;
	  };

	  SVGRendererBase.prototype.buildItem = function (pos) {
	    var elements = this.elements;

	    if (elements[pos] || this.layers[pos].ty === 99) {
	      return;
	    }

	    elements[pos] = true;
	    var element = this.createItem(this.layers[pos]);
	    elements[pos] = element;

	    if (getExpressionsPlugin()) {
	      if (this.layers[pos].ty === 0) {
	        this.globalData.projectInterface.registerComposition(element);
	      }

	      element.initExpressions();
	    }

	    this.appendElementInPos(element, pos);

	    if (this.layers[pos].tt) {
	      var elementIndex = 'tp' in this.layers[pos] ? this.findIndexByInd(this.layers[pos].tp) : pos - 1;

	      if (elementIndex === -1) {
	        return;
	      }

	      if (!this.elements[elementIndex] || this.elements[elementIndex] === true) {
	        this.buildItem(elementIndex);
	        this.addPendingElement(element);
	      } else {
	        var matteElement = elements[elementIndex];
	        var matteMask = matteElement.getMatte(this.layers[pos].tt);
	        element.setMatte(matteMask);
	      }
	    }
	  };

	  SVGRendererBase.prototype.checkPendingElements = function () {
	    while (this.pendingElements.length) {
	      var element = this.pendingElements.pop();
	      element.checkParenting();

	      if (element.data.tt) {
	        var i = 0;
	        var len = this.elements.length;

	        while (i < len) {
	          if (this.elements[i] === element) {
	            var elementIndex = 'tp' in element.data ? this.findIndexByInd(element.data.tp) : i - 1;
	            var matteElement = this.elements[elementIndex];
	            var matteMask = matteElement.getMatte(this.layers[i].tt);
	            element.setMatte(matteMask);
	            break;
	          }

	          i += 1;
	        }
	      }
	    }
	  };

	  SVGRendererBase.prototype.renderFrame = function (num) {
	    if (this.renderedFrame === num || this.destroyed) {
	      return;
	    }

	    if (num === null) {
	      num = this.renderedFrame;
	    } else {
	      this.renderedFrame = num;
	    } // console.log('-------');
	    // console.log('FRAME ',num);


	    this.globalData.frameNum = num;
	    this.globalData.frameId += 1;
	    this.globalData.projectInterface.currentFrame = num;
	    this.globalData._mdf = false;
	    var i;
	    var len = this.layers.length;

	    if (!this.completeLayers) {
	      this.checkLayers(num);
	    }

	    for (i = len - 1; i >= 0; i -= 1) {
	      if (this.completeLayers || this.elements[i]) {
	        this.elements[i].prepareFrame(num - this.layers[i].st);
	      }
	    }

	    if (this.globalData._mdf) {
	      for (i = 0; i < len; i += 1) {
	        if (this.completeLayers || this.elements[i]) {
	          this.elements[i].renderFrame();
	        }
	      }
	    }
	  };

	  SVGRendererBase.prototype.appendElementInPos = function (element, pos) {
	    var newElement = element.getBaseElement();

	    if (!newElement) {
	      return;
	    }

	    var i = 0;
	    var nextElement;

	    while (i < pos) {
	      if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement()) {
	        nextElement = this.elements[i].getBaseElement();
	      }

	      i += 1;
	    }

	    if (nextElement) {
	      this.layerElement.insertBefore(newElement, nextElement);
	    } else {
	      this.layerElement.appendChild(newElement);
	    }
	  };

	  SVGRendererBase.prototype.hide = function () {
	    this.layerElement.style.display = 'none';
	  };

	  SVGRendererBase.prototype.show = function () {
	    this.layerElement.style.display = 'block';
	  };

	  function ICompElement() {}

	  extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement);

	  ICompElement.prototype.initElement = function (data, globalData, comp) {
	    this.initFrame();
	    this.initBaseData(data, globalData, comp);
	    this.initTransform(data, globalData, comp);
	    this.initRenderable();
	    this.initHierarchy();
	    this.initRendererElement();
	    this.createContainerElements();
	    this.createRenderableComponents();

	    if (this.data.xt || !globalData.progressiveLoad) {
	      this.buildAllItems();
	    }

	    this.hide();
	  };
	  /* ICompElement.prototype.hide = function(){
	      if(!this.hidden){
	          this.hideElement();
	          var i,len = this.elements.length;
	          for( i = 0; i < len; i+=1 ){
	              if(this.elements[i]){
	                  this.elements[i].hide();
	              }
	          }
	      }
	  }; */


	  ICompElement.prototype.prepareFrame = function (num) {
	    this._mdf = false;
	    this.prepareRenderableFrame(num);
	    this.prepareProperties(num, this.isInRange);

	    if (!this.isInRange && !this.data.xt) {
	      return;
	    }

	    if (!this.tm._placeholder) {
	      var timeRemapped = this.tm.v;

	      if (timeRemapped === this.data.op) {
	        timeRemapped = this.data.op - 1;
	      }

	      this.renderedFrame = timeRemapped;
	    } else {
	      this.renderedFrame = num / this.data.sr;
	    }

	    var i;
	    var len = this.elements.length;

	    if (!this.completeLayers) {
	      this.checkLayers(this.renderedFrame);
	    } // This iteration needs to be backwards because of how expressions connect between each other


	    for (i = len - 1; i >= 0; i -= 1) {
	      if (this.completeLayers || this.elements[i]) {
	        this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);

	        if (this.elements[i]._mdf) {
	          this._mdf = true;
	        }
	      }
	    }
	  };

	  ICompElement.prototype.renderInnerContent = function () {
	    var i;
	    var len = this.layers.length;

	    for (i = 0; i < len; i += 1) {
	      if (this.completeLayers || this.elements[i]) {
	        this.elements[i].renderFrame();
	      }
	    }
	  };

	  ICompElement.prototype.setElements = function (elems) {
	    this.elements = elems;
	  };

	  ICompElement.prototype.getElements = function () {
	    return this.elements;
	  };

	  ICompElement.prototype.destroyElements = function () {
	    var i;
	    var len = this.layers.length;

	    for (i = 0; i < len; i += 1) {
	      if (this.elements[i]) {
	        this.elements[i].destroy();
	      }
	    }
	  };

	  ICompElement.prototype.destroy = function () {
	    this.destroyElements();
	    this.destroyBaseElement();
	  };

	  function SVGCompElement(data, globalData, comp) {
	    this.layers = data.layers;
	    this.supports3d = true;
	    this.completeLayers = false;
	    this.pendingElements = [];
	    this.elements = this.layers ? createSizedArray(this.layers.length) : [];
	    this.initElement(data, globalData, comp);
	    this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
	      _placeholder: true
	    };
	  }

	  extendPrototype([SVGRendererBase, ICompElement, SVGBaseElement], SVGCompElement);

	  SVGCompElement.prototype.createComp = function (data) {
	    return new SVGCompElement(data, this.globalData, this);
	  };

	  function SVGRenderer(animationItem, config) {
	    this.animationItem = animationItem;
	    this.layers = null;
	    this.renderedFrame = -1;
	    this.svgElement = createNS('svg');
	    var ariaLabel = '';

	    if (config && config.title) {
	      var titleElement = createNS('title');
	      var titleId = createElementID();
	      titleElement.setAttribute('id', titleId);
	      titleElement.textContent = config.title;
	      this.svgElement.appendChild(titleElement);
	      ariaLabel += titleId;
	    }

	    if (config && config.description) {
	      var descElement = createNS('desc');
	      var descId = createElementID();
	      descElement.setAttribute('id', descId);
	      descElement.textContent = config.description;
	      this.svgElement.appendChild(descElement);
	      ariaLabel += ' ' + descId;
	    }

	    if (ariaLabel) {
	      this.svgElement.setAttribute('aria-labelledby', ariaLabel);
	    }

	    var defs = createNS('defs');
	    this.svgElement.appendChild(defs);
	    var maskElement = createNS('g');
	    this.svgElement.appendChild(maskElement);
	    this.layerElement = maskElement;
	    this.renderConfig = {
	      preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
	      imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
	      contentVisibility: config && config.contentVisibility || 'visible',
	      progressiveLoad: config && config.progressiveLoad || false,
	      hideOnTransparent: !(config && config.hideOnTransparent === false),
	      viewBoxOnly: config && config.viewBoxOnly || false,
	      viewBoxSize: config && config.viewBoxSize || false,
	      className: config && config.className || '',
	      id: config && config.id || '',
	      focusable: config && config.focusable,
	      filterSize: {
	        width: config && config.filterSize && config.filterSize.width || '100%',
	        height: config && config.filterSize && config.filterSize.height || '100%',
	        x: config && config.filterSize && config.filterSize.x || '0%',
	        y: config && config.filterSize && config.filterSize.y || '0%'
	      },
	      width: config && config.width,
	      height: config && config.height,
	      runExpressions: !config || config.runExpressions === undefined || config.runExpressions
	    };
	    this.globalData = {
	      _mdf: false,
	      frameNum: -1,
	      defs: defs,
	      renderConfig: this.renderConfig
	    };
	    this.elements = [];
	    this.pendingElements = [];
	    this.destroyed = false;
	    this.rendererType = 'svg';
	  }

	  extendPrototype([SVGRendererBase], SVGRenderer);

	  SVGRenderer.prototype.createComp = function (data) {
	    return new SVGCompElement(data, this.globalData, this);
	  };

	  function ShapeTransformManager() {
	    this.sequences = {};
	    this.sequenceList = [];
	    this.transform_key_count = 0;
	  }

	  ShapeTransformManager.prototype = {
	    addTransformSequence: function addTransformSequence(transforms) {
	      var i;
	      var len = transforms.length;
	      var key = '_';

	      for (i = 0; i < len; i += 1) {
	        key += transforms[i].transform.key + '_';
	      }

	      var sequence = this.sequences[key];

	      if (!sequence) {
	        sequence = {
	          transforms: [].concat(transforms),
	          finalTransform: new Matrix(),
	          _mdf: false
	        };
	        this.sequences[key] = sequence;
	        this.sequenceList.push(sequence);
	      }

	      return sequence;
	    },
	    processSequence: function processSequence(sequence, isFirstFrame) {
	      var i = 0;
	      var len = sequence.transforms.length;
	      var _mdf = isFirstFrame;

	      while (i < len && !isFirstFrame) {
	        if (sequence.transforms[i].transform.mProps._mdf) {
	          _mdf = true;
	          break;
	        }

	        i += 1;
	      }

	      if (_mdf) {
	        sequence.finalTransform.reset();

	        for (i = len - 1; i >= 0; i -= 1) {
	          sequence.finalTransform.multiply(sequence.transforms[i].transform.mProps.v);
	        }
	      }

	      sequence._mdf = _mdf;
	    },
	    processSequences: function processSequences(isFirstFrame) {
	      var i;
	      var len = this.sequenceList.length;

	      for (i = 0; i < len; i += 1) {
	        this.processSequence(this.sequenceList[i], isFirstFrame);
	      }
	    },
	    getNewKey: function getNewKey() {
	      this.transform_key_count += 1;
	      return '_' + this.transform_key_count;
	    }
	  };

	  var lumaLoader = function lumaLoader() {
	    var id = '__lottie_element_luma_buffer';
	    var lumaBuffer = null;
	    var lumaBufferCtx = null;
	    var svg = null; // This alternate solution has a slight delay before the filter is applied, resulting in a flicker on the first frame.
	    // Keeping this here for reference, and in the future, if offscreen canvas supports url filters, this can be used.
	    // For now, neither of them work for offscreen canvas, so canvas workers can't support the luma track matte mask.
	    // Naming it solution 2 to mark the extra comment lines.

	    /*
	    var svgString = [
	      '<svg xmlns="http://www.w3.org/2000/svg">',
	      '<filter id="' + id + '">',
	      '<feColorMatrix type="matrix" color-interpolation-filters="sRGB" values="',
	      '0.3, 0.3, 0.3, 0, 0, ',
	      '0.3, 0.3, 0.3, 0, 0, ',
	      '0.3, 0.3, 0.3, 0, 0, ',
	      '0.3, 0.3, 0.3, 0, 0',
	      '"/>',
	      '</filter>',
	      '</svg>',
	    ].join('');
	    var blob = new Blob([svgString], { type: 'image/svg+xml' });
	    var url = URL.createObjectURL(blob);
	    */

	    function createLumaSvgFilter() {
	      var _svg = createNS('svg');

	      var fil = createNS('filter');
	      var matrix = createNS('feColorMatrix');
	      fil.setAttribute('id', id);
	      matrix.setAttribute('type', 'matrix');
	      matrix.setAttribute('color-interpolation-filters', 'sRGB');
	      matrix.setAttribute('values', '0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0');
	      fil.appendChild(matrix);

	      _svg.appendChild(fil);

	      _svg.setAttribute('id', id + '_svg');

	      if (featureSupport.svgLumaHidden) {
	        _svg.style.display = 'none';
	      }

	      return _svg;
	    }

	    function loadLuma() {
	      if (!lumaBuffer) {
	        svg = createLumaSvgFilter();
	        document.body.appendChild(svg);
	        lumaBuffer = createTag('canvas');
	        lumaBufferCtx = lumaBuffer.getContext('2d'); // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2

	        lumaBufferCtx.filter = 'url(#' + id + ')';
	        lumaBufferCtx.fillStyle = 'rgba(0,0,0,0)';
	        lumaBufferCtx.fillRect(0, 0, 1, 1);
	      }
	    }

	    function getLuma(canvas) {
	      if (!lumaBuffer) {
	        loadLuma();
	      }

	      lumaBuffer.width = canvas.width;
	      lumaBuffer.height = canvas.height; // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2

	      lumaBufferCtx.filter = 'url(#' + id + ')';
	      return lumaBuffer;
	    }

	    return {
	      load: loadLuma,
	      get: getLuma
	    };
	  };

	  function createCanvas(width, height) {
	    if (featureSupport.offscreenCanvas) {
	      return new OffscreenCanvas(width, height);
	    }

	    var canvas = createTag('canvas');
	    canvas.width = width;
	    canvas.height = height;
	    return canvas;
	  }

	  var assetLoader = function () {
	    return {
	      loadLumaCanvas: lumaLoader.load,
	      getLumaCanvas: lumaLoader.get,
	      createCanvas: createCanvas
	    };
	  }();

	  var registeredEffects = {};

	  function CVEffects(elem) {
	    var i;
	    var len = elem.data.ef ? elem.data.ef.length : 0;
	    this.filters = [];
	    var filterManager;

	    for (i = 0; i < len; i += 1) {
	      filterManager = null;
	      var type = elem.data.ef[i].ty;

	      if (registeredEffects[type]) {
	        var Effect = registeredEffects[type].effect;
	        filterManager = new Effect(elem.effectsManager.effectElements[i], elem);
	      }

	      if (filterManager) {
	        this.filters.push(filterManager);
	      }
	    }

	    if (this.filters.length) {
	      elem.addRenderableComponent(this);
	    }
	  }

	  CVEffects.prototype.renderFrame = function (_isFirstFrame) {
	    var i;
	    var len = this.filters.length;

	    for (i = 0; i < len; i += 1) {
	      this.filters[i].renderFrame(_isFirstFrame);
	    }
	  };

	  CVEffects.prototype.getEffects = function (type) {
	    var i;
	    var len = this.filters.length;
	    var effects = [];

	    for (i = 0; i < len; i += 1) {
	      if (this.filters[i].type === type) {
	        effects.push(this.filters[i]);
	      }
	    }

	    return effects;
	  };

	  function registerEffect(id, effect) {
	    registeredEffects[id] = {
	      effect: effect
	    };
	  }

	  function CVMaskElement(data, element) {
	    this.data = data;
	    this.element = element;
	    this.masksProperties = this.data.masksProperties || [];
	    this.viewData = createSizedArray(this.masksProperties.length);
	    var i;
	    var len = this.masksProperties.length;
	    var hasMasks = false;

	    for (i = 0; i < len; i += 1) {
	      if (this.masksProperties[i].mode !== 'n') {
	        hasMasks = true;
	      }

	      this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[i], 3);
	    }

	    this.hasMasks = hasMasks;

	    if (hasMasks) {
	      this.element.addRenderableComponent(this);
	    }
	  }

	  CVMaskElement.prototype.renderFrame = function () {
	    if (!this.hasMasks) {
	      return;
	    }

	    var transform = this.element.finalTransform.mat;
	    var ctx = this.element.canvasContext;
	    var i;
	    var len = this.masksProperties.length;
	    var pt;
	    var pts;
	    var data;
	    ctx.beginPath();

	    for (i = 0; i < len; i += 1) {
	      if (this.masksProperties[i].mode !== 'n') {
	        if (this.masksProperties[i].inv) {
	          ctx.moveTo(0, 0);
	          ctx.lineTo(this.element.globalData.compSize.w, 0);
	          ctx.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h);
	          ctx.lineTo(0, this.element.globalData.compSize.h);
	          ctx.lineTo(0, 0);
	        }

	        data = this.viewData[i].v;
	        pt = transform.applyToPointArray(data.v[0][0], data.v[0][1], 0);
	        ctx.moveTo(pt[0], pt[1]);
	        var j;
	        var jLen = data._length;

	        for (j = 1; j < jLen; j += 1) {
	          pts = transform.applyToTriplePoints(data.o[j - 1], data.i[j], data.v[j]);
	          ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
	        }

	        pts = transform.applyToTriplePoints(data.o[j - 1], data.i[0], data.v[0]);
	        ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
	      }
	    }

	    this.element.globalData.renderer.save(true);
	    ctx.clip();
	  };

	  CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;

	  CVMaskElement.prototype.destroy = function () {
	    this.element = null;
	  };

	  function CVBaseElement() {}

	  var operationsMap = {
	    1: 'source-in',
	    2: 'source-out',
	    3: 'source-in',
	    4: 'source-out'
	  };
	  CVBaseElement.prototype = {
	    createElements: function createElements() {},
	    initRendererElement: function initRendererElement() {},
	    createContainerElements: function createContainerElements() {
	      // If the layer is masked we will use two buffers to store each different states of the drawing
	      // This solution is not ideal for several reason. But unfortunately, because of the recursive
	      // nature of the render tree, it's the only simple way to make sure one inner mask doesn't override an outer mask.
	      // TODO: try to reduce the size of these buffers to the size of the composition contaning the layer
	      // It might be challenging because the layer most likely is transformed in some way
	      if (this.data.tt >= 1) {
	        this.buffers = [];
	        var canvasContext = this.globalData.canvasContext;
	        var bufferCanvas = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
	        this.buffers.push(bufferCanvas);
	        var bufferCanvas2 = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
	        this.buffers.push(bufferCanvas2);

	        if (this.data.tt >= 3 && !document._isProxy) {
	          assetLoader.loadLumaCanvas();
	        }
	      }

	      this.canvasContext = this.globalData.canvasContext;
	      this.transformCanvas = this.globalData.transformCanvas;
	      this.renderableEffectsManager = new CVEffects(this);
	      this.searchEffectTransforms();
	    },
	    createContent: function createContent() {},
	    setBlendMode: function setBlendMode() {
	      var globalData = this.globalData;

	      if (globalData.blendMode !== this.data.bm) {
	        globalData.blendMode = this.data.bm;
	        var blendModeValue = getBlendMode(this.data.bm);
	        globalData.canvasContext.globalCompositeOperation = blendModeValue;
	      }
	    },
	    createRenderableComponents: function createRenderableComponents() {
	      this.maskManager = new CVMaskElement(this.data, this);
	      this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
	    },
	    hideElement: function hideElement() {
	      if (!this.hidden && (!this.isInRange || this.isTransparent)) {
	        this.hidden = true;
	      }
	    },
	    showElement: function showElement() {
	      if (this.isInRange && !this.isTransparent) {
	        this.hidden = false;
	        this._isFirstFrame = true;
	        this.maskManager._isFirstFrame = true;
	      }
	    },
	    clearCanvas: function clearCanvas(canvasContext) {
	      canvasContext.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
	    },
	    prepareLayer: function prepareLayer() {
	      if (this.data.tt >= 1) {
	        var buffer = this.buffers[0];
	        var bufferCtx = buffer.getContext('2d');
	        this.clearCanvas(bufferCtx); // on the first buffer we store the current state of the global drawing

	        bufferCtx.drawImage(this.canvasContext.canvas, 0, 0); // The next four lines are to clear the canvas
	        // TODO: Check if there is a way to clear the canvas without resetting the transform

	        this.currentTransform = this.canvasContext.getTransform();
	        this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
	        this.clearCanvas(this.canvasContext);
	        this.canvasContext.setTransform(this.currentTransform);
	      }
	    },
	    exitLayer: function exitLayer() {
	      if (this.data.tt >= 1) {
	        var buffer = this.buffers[1]; // On the second buffer we store the current state of the global drawing
	        // that only contains the content of this layer
	        // (if it is a composition, it also includes the nested layers)

	        var bufferCtx = buffer.getContext('2d');
	        this.clearCanvas(bufferCtx);
	        bufferCtx.drawImage(this.canvasContext.canvas, 0, 0); // We clear the canvas again

	        this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
	        this.clearCanvas(this.canvasContext);
	        this.canvasContext.setTransform(this.currentTransform); // We draw the mask

	        var mask = this.comp.getElementById('tp' in this.data ? this.data.tp : this.data.ind - 1);
	        mask.renderFrame(true); // We draw the second buffer (that contains the content of this layer)

	        this.canvasContext.setTransform(1, 0, 0, 1, 0, 0); // If the mask is a Luma matte, we need to do two extra painting operations
	        // the _isProxy check is to avoid drawing a fake canvas in workers that will throw an error

	        if (this.data.tt >= 3 && !document._isProxy) {
	          // We copy the painted mask to a buffer that has a color matrix filter applied to it
	          // that applies the rgb values to the alpha channel
	          var lumaBuffer = assetLoader.getLumaCanvas(this.canvasContext.canvas);
	          var lumaBufferCtx = lumaBuffer.getContext('2d');
	          lumaBufferCtx.drawImage(this.canvasContext.canvas, 0, 0);
	          this.clearCanvas(this.canvasContext); // we repaint the context with the mask applied to it

	          this.canvasContext.drawImage(lumaBuffer, 0, 0);
	        }

	        this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt];
	        this.canvasContext.drawImage(buffer, 0, 0); // We finally draw the first buffer (that contains the content of the global drawing)
	        // We use destination-over to draw the global drawing below the current layer

	        this.canvasContext.globalCompositeOperation = 'destination-over';
	        this.canvasContext.drawImage(this.buffers[0], 0, 0);
	        this.canvasContext.setTransform(this.currentTransform); // We reset the globalCompositeOperation to source-over, the standard type of operation

	        this.canvasContext.globalCompositeOperation = 'source-over';
	      }
	    },
	    renderFrame: function renderFrame(forceRender) {
	      if (this.hidden || this.data.hd) {
	        return;
	      }

	      if (this.data.td === 1 && !forceRender) {
	        return;
	      }

	      this.renderTransform();
	      this.renderRenderable();
	      this.renderLocalTransform();
	      this.setBlendMode();
	      var forceRealStack = this.data.ty === 0;
	      this.prepareLayer();
	      this.globalData.renderer.save(forceRealStack);
	      this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props);
	      this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity);
	      this.renderInnerContent();
	      this.globalData.renderer.restore(forceRealStack);
	      this.exitLayer();

	      if (this.maskManager.hasMasks) {
	        this.globalData.renderer.restore(true);
	      }

	      if (this._isFirstFrame) {
	        this._isFirstFrame = false;
	      }
	    },
	    destroy: function destroy() {
	      this.canvasContext = null;
	      this.data = null;
	      this.globalData = null;
	      this.maskManager.destroy();
	    },
	    mHelper: new Matrix()
	  };
	  CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement;
	  CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;

	  function CVShapeData(element, data, styles, transformsManager) {
	    this.styledShapes = [];
	    this.tr = [0, 0, 0, 0, 0, 0];
	    var ty = 4;

	    if (data.ty === 'rc') {
	      ty = 5;
	    } else if (data.ty === 'el') {
	      ty = 6;
	    } else if (data.ty === 'sr') {
	      ty = 7;
	    }

	    this.sh = ShapePropertyFactory.getShapeProp(element, data, ty, element);
	    var i;
	    var len = styles.length;
	    var styledShape;

	    for (i = 0; i < len; i += 1) {
	      if (!styles[i].closed) {
	        styledShape = {
	          transforms: transformsManager.addTransformSequence(styles[i].transforms),
	          trNodes: []
	        };
	        this.styledShapes.push(styledShape);
	        styles[i].elements.push(styledShape);
	      }
	    }
	  }

	  CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;

	  function CVShapeElement(data, globalData, comp) {
	    this.shapes = [];
	    this.shapesData = data.shapes;
	    this.stylesList = [];
	    this.itemsData = [];
	    this.prevViewData = [];
	    this.shapeModifiers = [];
	    this.processedElements = [];
	    this.transformsManager = new ShapeTransformManager();
	    this.initElement(data, globalData, comp);
	  }

	  extendPrototype([BaseElement, TransformElement, CVBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableElement], CVShapeElement);
	  CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement;
	  CVShapeElement.prototype.transformHelper = {
	    opacity: 1,
	    _opMdf: false
	  };
	  CVShapeElement.prototype.dashResetter = [];

	  CVShapeElement.prototype.createContent = function () {
	    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
	  };

	  CVShapeElement.prototype.createStyleElement = function (data, transforms) {
	    var styleElem = {
	      data: data,
	      type: data.ty,
	      preTransforms: this.transformsManager.addTransformSequence(transforms),
	      transforms: [],
	      elements: [],
	      closed: data.hd === true
	    };
	    var elementData = {};

	    if (data.ty === 'fl' || data.ty === 'st') {
	      elementData.c = PropertyFactory.getProp(this, data.c, 1, 255, this);

	      if (!elementData.c.k) {
	        styleElem.co = 'rgb(' + bmFloor(elementData.c.v[0]) + ',' + bmFloor(elementData.c.v[1]) + ',' + bmFloor(elementData.c.v[2]) + ')';
	      }
	    } else if (data.ty === 'gf' || data.ty === 'gs') {
	      elementData.s = PropertyFactory.getProp(this, data.s, 1, null, this);
	      elementData.e = PropertyFactory.getProp(this, data.e, 1, null, this);
	      elementData.h = PropertyFactory.getProp(this, data.h || {
	        k: 0
	      }, 0, 0.01, this);
	      elementData.a = PropertyFactory.getProp(this, data.a || {
	        k: 0
	      }, 0, degToRads, this);
	      elementData.g = new GradientProperty(this, data.g, this);
	    }

	    elementData.o = PropertyFactory.getProp(this, data.o, 0, 0.01, this);

	    if (data.ty === 'st' || data.ty === 'gs') {
	      styleElem.lc = lineCapEnum[data.lc || 2];
	      styleElem.lj = lineJoinEnum[data.lj || 2];

	      if (data.lj == 1) {
	        // eslint-disable-line eqeqeq
	        styleElem.ml = data.ml;
	      }

	      elementData.w = PropertyFactory.getProp(this, data.w, 0, null, this);

	      if (!elementData.w.k) {
	        styleElem.wi = elementData.w.v;
	      }

	      if (data.d) {
	        var d = new DashProperty(this, data.d, 'canvas', this);
	        elementData.d = d;

	        if (!elementData.d.k) {
	          styleElem.da = elementData.d.dashArray;
	          styleElem["do"] = elementData.d.dashoffset[0];
	        }
	      }
	    } else {
	      styleElem.r = data.r === 2 ? 'evenodd' : 'nonzero';
	    }

	    this.stylesList.push(styleElem);
	    elementData.style = styleElem;
	    return elementData;
	  };

	  CVShapeElement.prototype.createGroupElement = function () {
	    var elementData = {
	      it: [],
	      prevViewData: []
	    };
	    return elementData;
	  };

	  CVShapeElement.prototype.createTransformElement = function (data) {
	    var elementData = {
	      transform: {
	        opacity: 1,
	        _opMdf: false,
	        key: this.transformsManager.getNewKey(),
	        op: PropertyFactory.getProp(this, data.o, 0, 0.01, this),
	        mProps: TransformPropertyFactory.getTransformProperty(this, data, this)
	      }
	    };
	    return elementData;
	  };

	  CVShapeElement.prototype.createShapeElement = function (data) {
	    var elementData = new CVShapeData(this, data, this.stylesList, this.transformsManager);
	    this.shapes.push(elementData);
	    this.addShapeToModifiers(elementData);
	    return elementData;
	  };

	  CVShapeElement.prototype.reloadShapes = function () {
	    this._isFirstFrame = true;
	    var i;
	    var len = this.itemsData.length;

	    for (i = 0; i < len; i += 1) {
	      this.prevViewData[i] = this.itemsData[i];
	    }

	    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
	    len = this.dynamicProperties.length;

	    for (i = 0; i < len; i += 1) {
	      this.dynamicProperties[i].getValue();
	    }

	    this.renderModifiers();
	    this.transformsManager.processSequences(this._isFirstFrame);
	  };

	  CVShapeElement.prototype.addTransformToStyleList = function (transform) {
	    var i;
	    var len = this.stylesList.length;

	    for (i = 0; i < len; i += 1) {
	      if (!this.stylesList[i].closed) {
	        this.stylesList[i].transforms.push(transform);
	      }
	    }
	  };

	  CVShapeElement.prototype.removeTransformFromStyleList = function () {
	    var i;
	    var len = this.stylesList.length;

	    for (i = 0; i < len; i += 1) {
	      if (!this.stylesList[i].closed) {
	        this.stylesList[i].transforms.pop();
	      }
	    }
	  };

	  CVShapeElement.prototype.closeStyles = function (styles) {
	    var i;
	    var len = styles.length;

	    for (i = 0; i < len; i += 1) {
	      styles[i].closed = true;
	    }
	  };

	  CVShapeElement.prototype.searchShapes = function (arr, itemsData, prevViewData, shouldRender, transforms) {
	    var i;
	    var len = arr.length - 1;
	    var j;
	    var jLen;
	    var ownStyles = [];
	    var ownModifiers = [];
	    var processedPos;
	    var modifier;
	    var currentTransform;
	    var ownTransforms = [].concat(transforms);

	    for (i = len; i >= 0; i -= 1) {
	      processedPos = this.searchProcessedElement(arr[i]);

	      if (!processedPos) {
	        arr[i]._shouldRender = shouldRender;
	      } else {
	        itemsData[i] = prevViewData[processedPos - 1];
	      }

	      if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs') {
	        if (!processedPos) {
	          itemsData[i] = this.createStyleElement(arr[i], ownTransforms);
	        } else {
	          itemsData[i].style.closed = false;
	        }

	        ownStyles.push(itemsData[i].style);
	      } else if (arr[i].ty === 'gr') {
	        if (!processedPos) {
	          itemsData[i] = this.createGroupElement(arr[i]);
	        } else {
	          jLen = itemsData[i].it.length;

	          for (j = 0; j < jLen; j += 1) {
	            itemsData[i].prevViewData[j] = itemsData[i].it[j];
	          }
	        }

	        this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, shouldRender, ownTransforms);
	      } else if (arr[i].ty === 'tr') {
	        if (!processedPos) {
	          currentTransform = this.createTransformElement(arr[i]);
	          itemsData[i] = currentTransform;
	        }

	        ownTransforms.push(itemsData[i]);
	        this.addTransformToStyleList(itemsData[i]);
	      } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
	        if (!processedPos) {
	          itemsData[i] = this.createShapeElement(arr[i]);
	        }
	      } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'pb' || arr[i].ty === 'zz' || arr[i].ty === 'op') {
	        if (!processedPos) {
	          modifier = ShapeModifiers.getModifier(arr[i].ty);
	          modifier.init(this, arr[i]);
	          itemsData[i] = modifier;
	          this.shapeModifiers.push(modifier);
	        } else {
	          modifier = itemsData[i];
	          modifier.closed = false;
	        }

	        ownModifiers.push(modifier);
	      } else if (arr[i].ty === 'rp') {
	        if (!processedPos) {
	          modifier = ShapeModifiers.getModifier(arr[i].ty);
	          itemsData[i] = modifier;
	          modifier.init(this, arr, i, itemsData);
	          this.shapeModifiers.push(modifier);
	          shouldRender = false;
	        } else {
	          modifier = itemsData[i];
	          modifier.closed = true;
	        }

	        ownModifiers.push(modifier);
	      }

	      this.addProcessedElement(arr[i], i + 1);
	    }

	    this.removeTransformFromStyleList();
	    this.closeStyles(ownStyles);
	    len = ownModifiers.length;

	    for (i = 0; i < len; i += 1) {
	      ownModifiers[i].closed = true;
	    }
	  };

	  CVShapeElement.prototype.renderInnerContent = function () {
	    this.transformHelper.opacity = 1;
	    this.transformHelper._opMdf = false;
	    this.renderModifiers();
	    this.transformsManager.processSequences(this._isFirstFrame);
	    this.renderShape(this.transformHelper, this.shapesData, this.itemsData, true);
	  };

	  CVShapeElement.prototype.renderShapeTransform = function (parentTransform, groupTransform) {
	    if (parentTransform._opMdf || groupTransform.op._mdf || this._isFirstFrame) {
	      groupTransform.opacity = parentTransform.opacity;
	      groupTransform.opacity *= groupTransform.op.v;
	      groupTransform._opMdf = true;
	    }
	  };

	  CVShapeElement.prototype.drawLayer = function () {
	    var i;
	    var len = this.stylesList.length;
	    var j;
	    var jLen;
	    var k;
	    var kLen;
	    var elems;
	    var nodes;
	    var renderer = this.globalData.renderer;
	    var ctx = this.globalData.canvasContext;
	    var type;
	    var currentStyle;

	    for (i = 0; i < len; i += 1) {
	      currentStyle = this.stylesList[i];
	      type = currentStyle.type; // Skipping style when
	      // Stroke width equals 0
	      // style should not be rendered (extra unused repeaters)
	      // current opacity equals 0
	      // global opacity equals 0

	      if (!((type === 'st' || type === 'gs') && currentStyle.wi === 0 || !currentStyle.data._shouldRender || currentStyle.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
	        renderer.save();
	        elems = currentStyle.elements;

	        if (type === 'st' || type === 'gs') {
	          renderer.ctxStrokeStyle(type === 'st' ? currentStyle.co : currentStyle.grd); // ctx.strokeStyle = type === 'st' ? currentStyle.co : currentStyle.grd;

	          renderer.ctxLineWidth(currentStyle.wi); // ctx.lineWidth = currentStyle.wi;

	          renderer.ctxLineCap(currentStyle.lc); // ctx.lineCap = currentStyle.lc;

	          renderer.ctxLineJoin(currentStyle.lj); // ctx.lineJoin = currentStyle.lj;

	          renderer.ctxMiterLimit(currentStyle.ml || 0); // ctx.miterLimit = currentStyle.ml || 0;
	        } else {
	          renderer.ctxFillStyle(type === 'fl' ? currentStyle.co : currentStyle.grd); // ctx.fillStyle = type === 'fl' ? currentStyle.co : currentStyle.grd;
	        }

	        renderer.ctxOpacity(currentStyle.coOp);

	        if (type !== 'st' && type !== 'gs') {
	          ctx.beginPath();
	        }

	        renderer.ctxTransform(currentStyle.preTransforms.finalTransform.props);
	        jLen = elems.length;

	        for (j = 0; j < jLen; j += 1) {
	          if (type === 'st' || type === 'gs') {
	            ctx.beginPath();

	            if (currentStyle.da) {
	              ctx.setLineDash(currentStyle.da);
	              ctx.lineDashOffset = currentStyle["do"];
	            }
	          }

	          nodes = elems[j].trNodes;
	          kLen = nodes.length;

	          for (k = 0; k < kLen; k += 1) {
	            if (nodes[k].t === 'm') {
	              ctx.moveTo(nodes[k].p[0], nodes[k].p[1]);
	            } else if (nodes[k].t === 'c') {
	              ctx.bezierCurveTo(nodes[k].pts[0], nodes[k].pts[1], nodes[k].pts[2], nodes[k].pts[3], nodes[k].pts[4], nodes[k].pts[5]);
	            } else {
	              ctx.closePath();
	            }
	          }

	          if (type === 'st' || type === 'gs') {
	            // ctx.stroke();
	            renderer.ctxStroke();

	            if (currentStyle.da) {
	              ctx.setLineDash(this.dashResetter);
	            }
	          }
	        }

	        if (type !== 'st' && type !== 'gs') {
	          // ctx.fill(currentStyle.r);
	          this.globalData.renderer.ctxFill(currentStyle.r);
	        }

	        renderer.restore();
	      }
	    }
	  };

	  CVShapeElement.prototype.renderShape = function (parentTransform, items, data, isMain) {
	    var i;
	    var len = items.length - 1;
	    var groupTransform;
	    groupTransform = parentTransform;

	    for (i = len; i >= 0; i -= 1) {
	      if (items[i].ty === 'tr') {
	        groupTransform = data[i].transform;
	        this.renderShapeTransform(parentTransform, groupTransform);
	      } else if (items[i].ty === 'sh' || items[i].ty === 'el' || items[i].ty === 'rc' || items[i].ty === 'sr') {
	        this.renderPath(items[i], data[i]);
	      } else if (items[i].ty === 'fl') {
	        this.renderFill(items[i], data[i], groupTransform);
	      } else if (items[i].ty === 'st') {
	        this.renderStroke(items[i], data[i], groupTransform);
	      } else if (items[i].ty === 'gf' || items[i].ty === 'gs') {
	        this.renderGradientFill(items[i], data[i], groupTransform);
	      } else if (items[i].ty === 'gr') {
	        this.renderShape(groupTransform, items[i].it, data[i].it);
	      } else if (items[i].ty === 'tm') ;
	    }

	    if (isMain) {
	      this.drawLayer();
	    }
	  };

	  CVShapeElement.prototype.renderStyledShape = function (styledShape, shape) {
	    if (this._isFirstFrame || shape._mdf || styledShape.transforms._mdf) {
	      var shapeNodes = styledShape.trNodes;
	      var paths = shape.paths;
	      var i;
	      var len;
	      var j;
	      var jLen = paths._length;
	      shapeNodes.length = 0;
	      var groupTransformMat = styledShape.transforms.finalTransform;

	      for (j = 0; j < jLen; j += 1) {
	        var pathNodes = paths.shapes[j];

	        if (pathNodes && pathNodes.v) {
	          len = pathNodes._length;

	          for (i = 1; i < len; i += 1) {
	            if (i === 1) {
	              shapeNodes.push({
	                t: 'm',
	                p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
	              });
	            }

	            shapeNodes.push({
	              t: 'c',
	              pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[i], pathNodes.v[i])
	            });
	          }

	          if (len === 1) {
	            shapeNodes.push({
	              t: 'm',
	              p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
	            });
	          }

	          if (pathNodes.c && len) {
	            shapeNodes.push({
	              t: 'c',
	              pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[0], pathNodes.v[0])
	            });
	            shapeNodes.push({
	              t: 'z'
	            });
	          }
	        }
	      }

	      styledShape.trNodes = shapeNodes;
	    }
	  };

	  CVShapeElement.prototype.renderPath = function (pathData, itemData) {
	    if (pathData.hd !== true && pathData._shouldRender) {
	      var i;
	      var len = itemData.styledShapes.length;

	      for (i = 0; i < len; i += 1) {
	        this.renderStyledShape(itemData.styledShapes[i], itemData.sh);
	      }
	    }
	  };

	  CVShapeElement.prototype.renderFill = function (styleData, itemData, groupTransform) {
	    var styleElem = itemData.style;

	    if (itemData.c._mdf || this._isFirstFrame) {
	      styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
	    }

	    if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) {
	      styleElem.coOp = itemData.o.v * groupTransform.opacity;
	    }
	  };

	  CVShapeElement.prototype.renderGradientFill = function (styleData, itemData, groupTransform) {
	    var styleElem = itemData.style;
	    var grd;

	    if (!styleElem.grd || itemData.g._mdf || itemData.s._mdf || itemData.e._mdf || styleData.t !== 1 && (itemData.h._mdf || itemData.a._mdf)) {
	      var ctx = this.globalData.canvasContext;
	      var pt1 = itemData.s.v;
	      var pt2 = itemData.e.v;

	      if (styleData.t === 1) {
	        grd = ctx.createLinearGradient(pt1[0], pt1[1], pt2[0], pt2[1]);
	      } else {
	        var rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
	        var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
	        var percent = itemData.h.v;

	        if (percent >= 1) {
	          percent = 0.99;
	        } else if (percent <= -1) {
	          percent = -0.99;
	        }

	        var dist = rad * percent;
	        var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
	        var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
	        grd = ctx.createRadialGradient(x, y, 0, pt1[0], pt1[1], rad);
	      }

	      var i;
	      var len = styleData.g.p;
	      var cValues = itemData.g.c;
	      var opacity = 1;

	      for (i = 0; i < len; i += 1) {
	        if (itemData.g._hasOpacity && itemData.g._collapsable) {
	          opacity = itemData.g.o[i * 2 + 1];
	        }

	        grd.addColorStop(cValues[i * 4] / 100, 'rgba(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ',' + opacity + ')');
	      }

	      styleElem.grd = grd;
	    }

	    styleElem.coOp = itemData.o.v * groupTransform.opacity;
	  };

	  CVShapeElement.prototype.renderStroke = function (styleData, itemData, groupTransform) {
	    var styleElem = itemData.style;
	    var d = itemData.d;

	    if (d && (d._mdf || this._isFirstFrame)) {
	      styleElem.da = d.dashArray;
	      styleElem["do"] = d.dashoffset[0];
	    }

	    if (itemData.c._mdf || this._isFirstFrame) {
	      styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
	    }

	    if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) {
	      styleElem.coOp = itemData.o.v * groupTransform.opacity;
	    }

	    if (itemData.w._mdf || this._isFirstFrame) {
	      styleElem.wi = itemData.w.v;
	    }
	  };

	  CVShapeElement.prototype.destroy = function () {
	    this.shapesData = null;
	    this.globalData = null;
	    this.canvasContext = null;
	    this.stylesList.length = 0;
	    this.itemsData.length = 0;
	  };

	  function CVTextElement(data, globalData, comp) {
	    this.textSpans = [];
	    this.yOffset = 0;
	    this.fillColorAnim = false;
	    this.strokeColorAnim = false;
	    this.strokeWidthAnim = false;
	    this.stroke = false;
	    this.fill = false;
	    this.justifyOffset = 0;
	    this.currentRender = null;
	    this.renderType = 'canvas';
	    this.values = {
	      fill: 'rgba(0,0,0,0)',
	      stroke: 'rgba(0,0,0,0)',
	      sWidth: 0,
	      fValue: ''
	    };
	    this.initElement(data, globalData, comp);
	  }

	  extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement, ITextElement], CVTextElement);
	  CVTextElement.prototype.tHelper = createTag('canvas').getContext('2d');

	  CVTextElement.prototype.buildNewText = function () {
	    var documentData = this.textProperty.currentData;
	    this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
	    var hasFill = false;

	    if (documentData.fc) {
	      hasFill = true;
	      this.values.fill = this.buildColor(documentData.fc);
	    } else {
	      this.values.fill = 'rgba(0,0,0,0)';
	    }

	    this.fill = hasFill;
	    var hasStroke = false;

	    if (documentData.sc) {
	      hasStroke = true;
	      this.values.stroke = this.buildColor(documentData.sc);
	      this.values.sWidth = documentData.sw;
	    }

	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
	    var i;
	    var len;
	    var letters = documentData.l;
	    var matrixHelper = this.mHelper;
	    this.stroke = hasStroke;
	    this.values.fValue = documentData.finalSize + 'px ' + this.globalData.fontManager.getFontByName(documentData.f).fFamily;
	    len = documentData.finalText.length; // this.tHelper.font = this.values.fValue;

	    var charData;
	    var shapeData;
	    var k;
	    var kLen;
	    var shapes;
	    var j;
	    var jLen;
	    var pathNodes;
	    var commands;
	    var pathArr;
	    var singleShape = this.data.singleShape;
	    var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
	    var xPos = 0;
	    var yPos = 0;
	    var firstLine = true;
	    var cnt = 0;

	    for (i = 0; i < len; i += 1) {
	      charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	      shapeData = charData && charData.data || {};
	      matrixHelper.reset();

	      if (singleShape && letters[i].n) {
	        xPos = -trackingOffset;
	        yPos += documentData.yOffset;
	        yPos += firstLine ? 1 : 0;
	        firstLine = false;
	      }

	      shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
	      jLen = shapes.length;
	      matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);

	      if (singleShape) {
	        this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
	      }

	      commands = createSizedArray(jLen - 1);
	      var commandsCounter = 0;

	      for (j = 0; j < jLen; j += 1) {
	        if (shapes[j].ty === 'sh') {
	          kLen = shapes[j].ks.k.i.length;
	          pathNodes = shapes[j].ks.k;
	          pathArr = [];

	          for (k = 1; k < kLen; k += 1) {
	            if (k === 1) {
	              pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
	            }

	            pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToY(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToX(pathNodes.v[k][0], pathNodes.v[k][1], 0), matrixHelper.applyToY(pathNodes.v[k][0], pathNodes.v[k][1], 0));
	          }

	          pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToY(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
	          commands[commandsCounter] = pathArr;
	          commandsCounter += 1;
	        }
	      }

	      if (singleShape) {
	        xPos += letters[i].l;
	        xPos += trackingOffset;
	      }

	      if (this.textSpans[cnt]) {
	        this.textSpans[cnt].elem = commands;
	      } else {
	        this.textSpans[cnt] = {
	          elem: commands
	        };
	      }

	      cnt += 1;
	    }
	  };

	  CVTextElement.prototype.renderInnerContent = function () {
	    this.validateText();
	    var ctx = this.canvasContext;
	    ctx.font = this.values.fValue;
	    this.globalData.renderer.ctxLineCap('butt'); // ctx.lineCap = 'butt';

	    this.globalData.renderer.ctxLineJoin('miter'); // ctx.lineJoin = 'miter';

	    this.globalData.renderer.ctxMiterLimit(4); // ctx.miterLimit = 4;

	    if (!this.data.singleShape) {
	      this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
	    }

	    var i;
	    var len;
	    var j;
	    var jLen;
	    var k;
	    var kLen;
	    var renderedLetters = this.textAnimator.renderedLetters;
	    var letters = this.textProperty.currentData.l;
	    len = letters.length;
	    var renderedLetter;
	    var lastFill = null;
	    var lastStroke = null;
	    var lastStrokeW = null;
	    var commands;
	    var pathArr;
	    var renderer = this.globalData.renderer;

	    for (i = 0; i < len; i += 1) {
	      if (!letters[i].n) {
	        renderedLetter = renderedLetters[i];

	        if (renderedLetter) {
	          renderer.save();
	          renderer.ctxTransform(renderedLetter.p);
	          renderer.ctxOpacity(renderedLetter.o);
	        }

	        if (this.fill) {
	          if (renderedLetter && renderedLetter.fc) {
	            if (lastFill !== renderedLetter.fc) {
	              renderer.ctxFillStyle(renderedLetter.fc);
	              lastFill = renderedLetter.fc; // ctx.fillStyle = renderedLetter.fc;
	            }
	          } else if (lastFill !== this.values.fill) {
	            lastFill = this.values.fill;
	            renderer.ctxFillStyle(this.values.fill); // ctx.fillStyle = this.values.fill;
	          }

	          commands = this.textSpans[i].elem;
	          jLen = commands.length;
	          this.globalData.canvasContext.beginPath();

	          for (j = 0; j < jLen; j += 1) {
	            pathArr = commands[j];
	            kLen = pathArr.length;
	            this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);

	            for (k = 2; k < kLen; k += 6) {
	              this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
	            }
	          }

	          this.globalData.canvasContext.closePath();
	          renderer.ctxFill(); // this.globalData.canvasContext.fill();
	          /// ctx.fillText(this.textSpans[i].val,0,0);
	        }

	        if (this.stroke) {
	          if (renderedLetter && renderedLetter.sw) {
	            if (lastStrokeW !== renderedLetter.sw) {
	              lastStrokeW = renderedLetter.sw;
	              renderer.ctxLineWidth(renderedLetter.sw); // ctx.lineWidth = renderedLetter.sw;
	            }
	          } else if (lastStrokeW !== this.values.sWidth) {
	            lastStrokeW = this.values.sWidth;
	            renderer.ctxLineWidth(this.values.sWidth); // ctx.lineWidth = this.values.sWidth;
	          }

	          if (renderedLetter && renderedLetter.sc) {
	            if (lastStroke !== renderedLetter.sc) {
	              lastStroke = renderedLetter.sc;
	              renderer.ctxStrokeStyle(renderedLetter.sc); // ctx.strokeStyle = renderedLetter.sc;
	            }
	          } else if (lastStroke !== this.values.stroke) {
	            lastStroke = this.values.stroke;
	            renderer.ctxStrokeStyle(this.values.stroke); // ctx.strokeStyle = this.values.stroke;
	          }

	          commands = this.textSpans[i].elem;
	          jLen = commands.length;
	          this.globalData.canvasContext.beginPath();

	          for (j = 0; j < jLen; j += 1) {
	            pathArr = commands[j];
	            kLen = pathArr.length;
	            this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);

	            for (k = 2; k < kLen; k += 6) {
	              this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
	            }
	          }

	          this.globalData.canvasContext.closePath();
	          renderer.ctxStroke(); // this.globalData.canvasContext.stroke();
	          /// ctx.strokeText(letters[i].val,0,0);
	        }

	        if (renderedLetter) {
	          this.globalData.renderer.restore();
	        }
	      }
	    }
	  };

	  function CVImageElement(data, globalData, comp) {
	    this.assetData = globalData.getAssetData(data.refId);
	    this.img = globalData.imageLoader.getAsset(this.assetData);
	    this.initElement(data, globalData, comp);
	  }

	  extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement);
	  CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement;
	  CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;

	  CVImageElement.prototype.createContent = function () {
	    if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
	      var canvas = createTag('canvas');
	      canvas.width = this.assetData.w;
	      canvas.height = this.assetData.h;
	      var ctx = canvas.getContext('2d');
	      var imgW = this.img.width;
	      var imgH = this.img.height;
	      var imgRel = imgW / imgH;
	      var canvasRel = this.assetData.w / this.assetData.h;
	      var widthCrop;
	      var heightCrop;
	      var par = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;

	      if (imgRel > canvasRel && par === 'xMidYMid slice' || imgRel < canvasRel && par !== 'xMidYMid slice') {
	        heightCrop = imgH;
	        widthCrop = heightCrop * canvasRel;
	      } else {
	        widthCrop = imgW;
	        heightCrop = widthCrop / canvasRel;
	      }

	      ctx.drawImage(this.img, (imgW - widthCrop) / 2, (imgH - heightCrop) / 2, widthCrop, heightCrop, 0, 0, this.assetData.w, this.assetData.h);
	      this.img = canvas;
	    }
	  };

	  CVImageElement.prototype.renderInnerContent = function () {
	    this.canvasContext.drawImage(this.img, 0, 0);
	  };

	  CVImageElement.prototype.destroy = function () {
	    this.img = null;
	  };

	  function CVSolidElement(data, globalData, comp) {
	    this.initElement(data, globalData, comp);
	  }

	  extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement);
	  CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement;
	  CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;

	  CVSolidElement.prototype.renderInnerContent = function () {
	    // var ctx = this.canvasContext;
	    this.globalData.renderer.ctxFillStyle(this.data.sc); // ctx.fillStyle = this.data.sc;

	    this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh); // ctx.fillRect(0, 0, this.data.sw, this.data.sh);
	    //
	  };

	  function CanvasRendererBase() {}

	  extendPrototype([BaseRenderer], CanvasRendererBase);

	  CanvasRendererBase.prototype.createShape = function (data) {
	    return new CVShapeElement(data, this.globalData, this);
	  };

	  CanvasRendererBase.prototype.createText = function (data) {
	    return new CVTextElement(data, this.globalData, this);
	  };

	  CanvasRendererBase.prototype.createImage = function (data) {
	    return new CVImageElement(data, this.globalData, this);
	  };

	  CanvasRendererBase.prototype.createSolid = function (data) {
	    return new CVSolidElement(data, this.globalData, this);
	  };

	  CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;

	  CanvasRendererBase.prototype.ctxTransform = function (props) {
	    if (props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0) {
	      return;
	    }

	    this.canvasContext.transform(props[0], props[1], props[4], props[5], props[12], props[13]);
	  };

	  CanvasRendererBase.prototype.ctxOpacity = function (op) {
	    this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
	  };

	  CanvasRendererBase.prototype.ctxFillStyle = function (value) {
	    this.canvasContext.fillStyle = value;
	  };

	  CanvasRendererBase.prototype.ctxStrokeStyle = function (value) {
	    this.canvasContext.strokeStyle = value;
	  };

	  CanvasRendererBase.prototype.ctxLineWidth = function (value) {
	    this.canvasContext.lineWidth = value;
	  };

	  CanvasRendererBase.prototype.ctxLineCap = function (value) {
	    this.canvasContext.lineCap = value;
	  };

	  CanvasRendererBase.prototype.ctxLineJoin = function (value) {
	    this.canvasContext.lineJoin = value;
	  };

	  CanvasRendererBase.prototype.ctxMiterLimit = function (value) {
	    this.canvasContext.miterLimit = value;
	  };

	  CanvasRendererBase.prototype.ctxFill = function (rule) {
	    this.canvasContext.fill(rule);
	  };

	  CanvasRendererBase.prototype.ctxFillRect = function (x, y, w, h) {
	    this.canvasContext.fillRect(x, y, w, h);
	  };

	  CanvasRendererBase.prototype.ctxStroke = function () {
	    this.canvasContext.stroke();
	  };

	  CanvasRendererBase.prototype.reset = function () {
	    if (!this.renderConfig.clearCanvas) {
	      this.canvasContext.restore();
	      return;
	    }

	    this.contextData.reset();
	  };

	  CanvasRendererBase.prototype.save = function () {
	    this.canvasContext.save();
	  };

	  CanvasRendererBase.prototype.restore = function (actionFlag) {
	    if (!this.renderConfig.clearCanvas) {
	      this.canvasContext.restore();
	      return;
	    }

	    if (actionFlag) {
	      this.globalData.blendMode = 'source-over';
	    }

	    this.contextData.restore(actionFlag);
	  };

	  CanvasRendererBase.prototype.configAnimation = function (animData) {
	    if (this.animationItem.wrapper) {
	      this.animationItem.container = createTag('canvas');
	      var containerStyle = this.animationItem.container.style;
	      containerStyle.width = '100%';
	      containerStyle.height = '100%';
	      var origin = '0px 0px 0px';
	      containerStyle.transformOrigin = origin;
	      containerStyle.mozTransformOrigin = origin;
	      containerStyle.webkitTransformOrigin = origin;
	      containerStyle['-webkit-transform'] = origin;
	      containerStyle.contentVisibility = this.renderConfig.contentVisibility;
	      this.animationItem.wrapper.appendChild(this.animationItem.container);
	      this.canvasContext = this.animationItem.container.getContext('2d');

	      if (this.renderConfig.className) {
	        this.animationItem.container.setAttribute('class', this.renderConfig.className);
	      }

	      if (this.renderConfig.id) {
	        this.animationItem.container.setAttribute('id', this.renderConfig.id);
	      }
	    } else {
	      this.canvasContext = this.renderConfig.context;
	    }

	    this.contextData.setContext(this.canvasContext);
	    this.data = animData;
	    this.layers = animData.layers;
	    this.transformCanvas = {
	      w: animData.w,
	      h: animData.h,
	      sx: 0,
	      sy: 0,
	      tx: 0,
	      ty: 0
	    };
	    this.setupGlobalData(animData, document.body);
	    this.globalData.canvasContext = this.canvasContext;
	    this.globalData.renderer = this;
	    this.globalData.isDashed = false;
	    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
	    this.globalData.transformCanvas = this.transformCanvas;
	    this.elements = createSizedArray(animData.layers.length);
	    this.updateContainerSize();
	  };

	  CanvasRendererBase.prototype.updateContainerSize = function (width, height) {
	    this.reset();
	    var elementWidth;
	    var elementHeight;

	    if (width) {
	      elementWidth = width;
	      elementHeight = height;
	      this.canvasContext.canvas.width = elementWidth;
	      this.canvasContext.canvas.height = elementHeight;
	    } else {
	      if (this.animationItem.wrapper && this.animationItem.container) {
	        elementWidth = this.animationItem.wrapper.offsetWidth;
	        elementHeight = this.animationItem.wrapper.offsetHeight;
	      } else {
	        elementWidth = this.canvasContext.canvas.width;
	        elementHeight = this.canvasContext.canvas.height;
	      }

	      this.canvasContext.canvas.width = elementWidth * this.renderConfig.dpr;
	      this.canvasContext.canvas.height = elementHeight * this.renderConfig.dpr;
	    }

	    var elementRel;
	    var animationRel;

	    if (this.renderConfig.preserveAspectRatio.indexOf('meet') !== -1 || this.renderConfig.preserveAspectRatio.indexOf('slice') !== -1) {
	      var par = this.renderConfig.preserveAspectRatio.split(' ');
	      var fillType = par[1] || 'meet';
	      var pos = par[0] || 'xMidYMid';
	      var xPos = pos.substr(0, 4);
	      var yPos = pos.substr(4);
	      elementRel = elementWidth / elementHeight;
	      animationRel = this.transformCanvas.w / this.transformCanvas.h;

	      if (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice') {
	        this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
	        this.transformCanvas.sy = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
	      } else {
	        this.transformCanvas.sx = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
	        this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
	      }

	      if (xPos === 'xMid' && (animationRel < elementRel && fillType === 'meet' || animationRel > elementRel && fillType === 'slice')) {
	        this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) / 2 * this.renderConfig.dpr;
	      } else if (xPos === 'xMax' && (animationRel < elementRel && fillType === 'meet' || animationRel > elementRel && fillType === 'slice')) {
	        this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) * this.renderConfig.dpr;
	      } else {
	        this.transformCanvas.tx = 0;
	      }

	      if (yPos === 'YMid' && (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice')) {
	        this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) / 2 * this.renderConfig.dpr;
	      } else if (yPos === 'YMax' && (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice')) {
	        this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) * this.renderConfig.dpr;
	      } else {
	        this.transformCanvas.ty = 0;
	      }
	    } else if (this.renderConfig.preserveAspectRatio === 'none') {
	      this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
	      this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
	      this.transformCanvas.tx = 0;
	      this.transformCanvas.ty = 0;
	    } else {
	      this.transformCanvas.sx = this.renderConfig.dpr;
	      this.transformCanvas.sy = this.renderConfig.dpr;
	      this.transformCanvas.tx = 0;
	      this.transformCanvas.ty = 0;
	    }

	    this.transformCanvas.props = [this.transformCanvas.sx, 0, 0, 0, 0, this.transformCanvas.sy, 0, 0, 0, 0, 1, 0, this.transformCanvas.tx, this.transformCanvas.ty, 0, 1];
	    /* var i, len = this.elements.length;
	      for(i=0;i<len;i+=1){
	          if(this.elements[i] && this.elements[i].data.ty === 0){
	              this.elements[i].resize(this.globalData.transformCanvas);
	          }
	      } */

	    this.ctxTransform(this.transformCanvas.props);
	    this.canvasContext.beginPath();
	    this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
	    this.canvasContext.closePath();
	    this.canvasContext.clip();
	    this.renderFrame(this.renderedFrame, true);
	  };

	  CanvasRendererBase.prototype.destroy = function () {
	    if (this.renderConfig.clearCanvas && this.animationItem.wrapper) {
	      this.animationItem.wrapper.innerText = '';
	    }

	    var i;
	    var len = this.layers ? this.layers.length : 0;

	    for (i = len - 1; i >= 0; i -= 1) {
	      if (this.elements[i] && this.elements[i].destroy) {
	        this.elements[i].destroy();
	      }
	    }

	    this.elements.length = 0;
	    this.globalData.canvasContext = null;
	    this.animationItem.container = null;
	    this.destroyed = true;
	  };

	  CanvasRendererBase.prototype.renderFrame = function (num, forceRender) {
	    if (this.renderedFrame === num && this.renderConfig.clearCanvas === true && !forceRender || this.destroyed || num === -1) {
	      return;
	    }

	    this.renderedFrame = num;
	    this.globalData.frameNum = num - this.animationItem._isFirstFrame;
	    this.globalData.frameId += 1;
	    this.globalData._mdf = !this.renderConfig.clearCanvas || forceRender;
	    this.globalData.projectInterface.currentFrame = num; // console.log('--------');
	    // console.log('NEW: ',num);

	    var i;
	    var len = this.layers.length;

	    if (!this.completeLayers) {
	      this.checkLayers(num);
	    }

	    for (i = len - 1; i >= 0; i -= 1) {
	      if (this.completeLayers || this.elements[i]) {
	        this.elements[i].prepareFrame(num - this.layers[i].st);
	      }
	    }

	    if (this.globalData._mdf) {
	      if (this.renderConfig.clearCanvas === true) {
	        this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
	      } else {
	        this.save();
	      }

	      for (i = len - 1; i >= 0; i -= 1) {
	        if (this.completeLayers || this.elements[i]) {
	          this.elements[i].renderFrame();
	        }
	      }

	      if (this.renderConfig.clearCanvas !== true) {
	        this.restore();
	      }
	    }
	  };

	  CanvasRendererBase.prototype.buildItem = function (pos) {
	    var elements = this.elements;

	    if (elements[pos] || this.layers[pos].ty === 99) {
	      return;
	    }

	    var element = this.createItem(this.layers[pos], this, this.globalData);
	    elements[pos] = element;
	    element.initExpressions();
	    /* if(this.layers[pos].ty === 0){
	          element.resize(this.globalData.transformCanvas);
	      } */
	  };

	  CanvasRendererBase.prototype.checkPendingElements = function () {
	    while (this.pendingElements.length) {
	      var element = this.pendingElements.pop();
	      element.checkParenting();
	    }
	  };

	  CanvasRendererBase.prototype.hide = function () {
	    this.animationItem.container.style.display = 'none';
	  };

	  CanvasRendererBase.prototype.show = function () {
	    this.animationItem.container.style.display = 'block';
	  };

	  function CanvasContext() {
	    this.opacity = -1;
	    this.transform = createTypedArray('float32', 16);
	    this.fillStyle = '';
	    this.strokeStyle = '';
	    this.lineWidth = '';
	    this.lineCap = '';
	    this.lineJoin = '';
	    this.miterLimit = '';
	    this.id = Math.random();
	  }

	  function CVContextData() {
	    this.stack = [];
	    this.cArrPos = 0;
	    this.cTr = new Matrix();
	    var i;
	    var len = 15;

	    for (i = 0; i < len; i += 1) {
	      var canvasContext = new CanvasContext();
	      this.stack[i] = canvasContext;
	    }

	    this._length = len;
	    this.nativeContext = null;
	    this.transformMat = new Matrix();
	    this.currentOpacity = 1; //

	    this.currentFillStyle = '';
	    this.appliedFillStyle = ''; //

	    this.currentStrokeStyle = '';
	    this.appliedStrokeStyle = ''; //

	    this.currentLineWidth = '';
	    this.appliedLineWidth = ''; //

	    this.currentLineCap = '';
	    this.appliedLineCap = ''; //

	    this.currentLineJoin = '';
	    this.appliedLineJoin = ''; //

	    this.appliedMiterLimit = '';
	    this.currentMiterLimit = '';
	  }

	  CVContextData.prototype.duplicate = function () {
	    var newLength = this._length * 2;
	    var i = 0;

	    for (i = this._length; i < newLength; i += 1) {
	      this.stack[i] = new CanvasContext();
	    }

	    this._length = newLength;
	  };

	  CVContextData.prototype.reset = function () {
	    this.cArrPos = 0;
	    this.cTr.reset();
	    this.stack[this.cArrPos].opacity = 1;
	  };

	  CVContextData.prototype.restore = function (forceRestore) {
	    this.cArrPos -= 1;
	    var currentContext = this.stack[this.cArrPos];
	    var transform = currentContext.transform;
	    var i;
	    var arr = this.cTr.props;

	    for (i = 0; i < 16; i += 1) {
	      arr[i] = transform[i];
	    }

	    if (forceRestore) {
	      this.nativeContext.restore();
	      var prevStack = this.stack[this.cArrPos + 1];
	      this.appliedFillStyle = prevStack.fillStyle;
	      this.appliedStrokeStyle = prevStack.strokeStyle;
	      this.appliedLineWidth = prevStack.lineWidth;
	      this.appliedLineCap = prevStack.lineCap;
	      this.appliedLineJoin = prevStack.lineJoin;
	      this.appliedMiterLimit = prevStack.miterLimit;
	    }

	    this.nativeContext.setTransform(transform[0], transform[1], transform[4], transform[5], transform[12], transform[13]);

	    if (forceRestore || currentContext.opacity !== -1 && this.currentOpacity !== currentContext.opacity) {
	      this.nativeContext.globalAlpha = currentContext.opacity;
	      this.currentOpacity = currentContext.opacity;
	    }

	    this.currentFillStyle = currentContext.fillStyle;
	    this.currentStrokeStyle = currentContext.strokeStyle;
	    this.currentLineWidth = currentContext.lineWidth;
	    this.currentLineCap = currentContext.lineCap;
	    this.currentLineJoin = currentContext.lineJoin;
	    this.currentMiterLimit = currentContext.miterLimit;
	  };

	  CVContextData.prototype.save = function (saveOnNativeFlag) {
	    if (saveOnNativeFlag) {
	      this.nativeContext.save();
	    }

	    var props = this.cTr.props;

	    if (this._length <= this.cArrPos) {
	      this.duplicate();
	    }

	    var currentStack = this.stack[this.cArrPos];
	    var i;

	    for (i = 0; i < 16; i += 1) {
	      currentStack.transform[i] = props[i];
	    }

	    this.cArrPos += 1;
	    var newStack = this.stack[this.cArrPos];
	    newStack.opacity = currentStack.opacity;
	    newStack.fillStyle = currentStack.fillStyle;
	    newStack.strokeStyle = currentStack.strokeStyle;
	    newStack.lineWidth = currentStack.lineWidth;
	    newStack.lineCap = currentStack.lineCap;
	    newStack.lineJoin = currentStack.lineJoin;
	    newStack.miterLimit = currentStack.miterLimit;
	  };

	  CVContextData.prototype.setOpacity = function (value) {
	    this.stack[this.cArrPos].opacity = value;
	  };

	  CVContextData.prototype.setContext = function (value) {
	    this.nativeContext = value;
	  };

	  CVContextData.prototype.fillStyle = function (value) {
	    if (this.stack[this.cArrPos].fillStyle !== value) {
	      this.currentFillStyle = value;
	      this.stack[this.cArrPos].fillStyle = value;
	    }
	  };

	  CVContextData.prototype.strokeStyle = function (value) {
	    if (this.stack[this.cArrPos].strokeStyle !== value) {
	      this.currentStrokeStyle = value;
	      this.stack[this.cArrPos].strokeStyle = value;
	    }
	  };

	  CVContextData.prototype.lineWidth = function (value) {
	    if (this.stack[this.cArrPos].lineWidth !== value) {
	      this.currentLineWidth = value;
	      this.stack[this.cArrPos].lineWidth = value;
	    }
	  };

	  CVContextData.prototype.lineCap = function (value) {
	    if (this.stack[this.cArrPos].lineCap !== value) {
	      this.currentLineCap = value;
	      this.stack[this.cArrPos].lineCap = value;
	    }
	  };

	  CVContextData.prototype.lineJoin = function (value) {
	    if (this.stack[this.cArrPos].lineJoin !== value) {
	      this.currentLineJoin = value;
	      this.stack[this.cArrPos].lineJoin = value;
	    }
	  };

	  CVContextData.prototype.miterLimit = function (value) {
	    if (this.stack[this.cArrPos].miterLimit !== value) {
	      this.currentMiterLimit = value;
	      this.stack[this.cArrPos].miterLimit = value;
	    }
	  };

	  CVContextData.prototype.transform = function (props) {
	    this.transformMat.cloneFromProps(props); // Taking the last transform value from the stored stack of transforms

	    var currentTransform = this.cTr; // Applying the last transform value after the new transform to respect the order of transformations

	    this.transformMat.multiply(currentTransform); // Storing the new transformed value in the stored transform

	    currentTransform.cloneFromProps(this.transformMat.props);
	    var trProps = currentTransform.props; // Applying the new transform to the canvas

	    this.nativeContext.setTransform(trProps[0], trProps[1], trProps[4], trProps[5], trProps[12], trProps[13]);
	  };

	  CVContextData.prototype.opacity = function (op) {
	    var currentOpacity = this.stack[this.cArrPos].opacity;
	    currentOpacity *= op < 0 ? 0 : op;

	    if (this.stack[this.cArrPos].opacity !== currentOpacity) {
	      if (this.currentOpacity !== op) {
	        this.nativeContext.globalAlpha = op;
	        this.currentOpacity = op;
	      }

	      this.stack[this.cArrPos].opacity = currentOpacity;
	    }
	  };

	  CVContextData.prototype.fill = function (rule) {
	    if (this.appliedFillStyle !== this.currentFillStyle) {
	      this.appliedFillStyle = this.currentFillStyle;
	      this.nativeContext.fillStyle = this.appliedFillStyle;
	    }

	    this.nativeContext.fill(rule);
	  };

	  CVContextData.prototype.fillRect = function (x, y, w, h) {
	    if (this.appliedFillStyle !== this.currentFillStyle) {
	      this.appliedFillStyle = this.currentFillStyle;
	      this.nativeContext.fillStyle = this.appliedFillStyle;
	    }

	    this.nativeContext.fillRect(x, y, w, h);
	  };

	  CVContextData.prototype.stroke = function () {
	    if (this.appliedStrokeStyle !== this.currentStrokeStyle) {
	      this.appliedStrokeStyle = this.currentStrokeStyle;
	      this.nativeContext.strokeStyle = this.appliedStrokeStyle;
	    }

	    if (this.appliedLineWidth !== this.currentLineWidth) {
	      this.appliedLineWidth = this.currentLineWidth;
	      this.nativeContext.lineWidth = this.appliedLineWidth;
	    }

	    if (this.appliedLineCap !== this.currentLineCap) {
	      this.appliedLineCap = this.currentLineCap;
	      this.nativeContext.lineCap = this.appliedLineCap;
	    }

	    if (this.appliedLineJoin !== this.currentLineJoin) {
	      this.appliedLineJoin = this.currentLineJoin;
	      this.nativeContext.lineJoin = this.appliedLineJoin;
	    }

	    if (this.appliedMiterLimit !== this.currentMiterLimit) {
	      this.appliedMiterLimit = this.currentMiterLimit;
	      this.nativeContext.miterLimit = this.appliedMiterLimit;
	    }

	    this.nativeContext.stroke();
	  };

	  function CVCompElement(data, globalData, comp) {
	    this.completeLayers = false;
	    this.layers = data.layers;
	    this.pendingElements = [];
	    this.elements = createSizedArray(this.layers.length);
	    this.initElement(data, globalData, comp);
	    this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
	      _placeholder: true
	    };
	  }

	  extendPrototype([CanvasRendererBase, ICompElement, CVBaseElement], CVCompElement);

	  CVCompElement.prototype.renderInnerContent = function () {
	    var ctx = this.canvasContext;
	    ctx.beginPath();
	    ctx.moveTo(0, 0);
	    ctx.lineTo(this.data.w, 0);
	    ctx.lineTo(this.data.w, this.data.h);
	    ctx.lineTo(0, this.data.h);
	    ctx.lineTo(0, 0);
	    ctx.clip();
	    var i;
	    var len = this.layers.length;

	    for (i = len - 1; i >= 0; i -= 1) {
	      if (this.completeLayers || this.elements[i]) {
	        this.elements[i].renderFrame();
	      }
	    }
	  };

	  CVCompElement.prototype.destroy = function () {
	    var i;
	    var len = this.layers.length;

	    for (i = len - 1; i >= 0; i -= 1) {
	      if (this.elements[i]) {
	        this.elements[i].destroy();
	      }
	    }

	    this.layers = null;
	    this.elements = null;
	  };

	  CVCompElement.prototype.createComp = function (data) {
	    return new CVCompElement(data, this.globalData, this);
	  };

	  function CanvasRenderer(animationItem, config) {
	    this.animationItem = animationItem;
	    this.renderConfig = {
	      clearCanvas: config && config.clearCanvas !== undefined ? config.clearCanvas : true,
	      context: config && config.context || null,
	      progressiveLoad: config && config.progressiveLoad || false,
	      preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
	      imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
	      contentVisibility: config && config.contentVisibility || 'visible',
	      className: config && config.className || '',
	      id: config && config.id || '',
	      runExpressions: !config || config.runExpressions === undefined || config.runExpressions
	    };
	    this.renderConfig.dpr = config && config.dpr || 1;

	    if (this.animationItem.wrapper) {
	      this.renderConfig.dpr = config && config.dpr || window.devicePixelRatio || 1;
	    }

	    this.renderedFrame = -1;
	    this.globalData = {
	      frameNum: -1,
	      _mdf: false,
	      renderConfig: this.renderConfig,
	      currentGlobalAlpha: -1
	    };
	    this.contextData = new CVContextData();
	    this.elements = [];
	    this.pendingElements = [];
	    this.transformMat = new Matrix();
	    this.completeLayers = false;
	    this.rendererType = 'canvas';

	    if (this.renderConfig.clearCanvas) {
	      this.ctxTransform = this.contextData.transform.bind(this.contextData);
	      this.ctxOpacity = this.contextData.opacity.bind(this.contextData);
	      this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData);
	      this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData);
	      this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData);
	      this.ctxLineCap = this.contextData.lineCap.bind(this.contextData);
	      this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData);
	      this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData);
	      this.ctxFill = this.contextData.fill.bind(this.contextData);
	      this.ctxFillRect = this.contextData.fillRect.bind(this.contextData);
	      this.ctxStroke = this.contextData.stroke.bind(this.contextData);
	      this.save = this.contextData.save.bind(this.contextData);
	    }
	  }

	  extendPrototype([CanvasRendererBase], CanvasRenderer);

	  CanvasRenderer.prototype.createComp = function (data) {
	    return new CVCompElement(data, this.globalData, this);
	  };

	  function HBaseElement() {}

	  HBaseElement.prototype = {
	    checkBlendMode: function checkBlendMode() {},
	    initRendererElement: function initRendererElement() {
	      this.baseElement = createTag(this.data.tg || 'div');

	      if (this.data.hasMask) {
	        this.svgElement = createNS('svg');
	        this.layerElement = createNS('g');
	        this.maskedElement = this.layerElement;
	        this.svgElement.appendChild(this.layerElement);
	        this.baseElement.appendChild(this.svgElement);
	      } else {
	        this.layerElement = this.baseElement;
	      }

	      styleDiv(this.baseElement);
	    },
	    createContainerElements: function createContainerElements() {
	      this.renderableEffectsManager = new CVEffects(this);
	      this.transformedElement = this.baseElement;
	      this.maskedElement = this.layerElement;

	      if (this.data.ln) {
	        this.layerElement.setAttribute('id', this.data.ln);
	      }

	      if (this.data.cl) {
	        this.layerElement.setAttribute('class', this.data.cl);
	      }

	      if (this.data.bm !== 0) {
	        this.setBlendMode();
	      }
	    },
	    renderElement: function renderElement() {
	      var transformedElementStyle = this.transformedElement ? this.transformedElement.style : {};

	      if (this.finalTransform._matMdf) {
	        var matrixValue = this.finalTransform.mat.toCSS();
	        transformedElementStyle.transform = matrixValue;
	        transformedElementStyle.webkitTransform = matrixValue;
	      }

	      if (this.finalTransform._opMdf) {
	        transformedElementStyle.opacity = this.finalTransform.mProp.o.v;
	      }
	    },
	    renderFrame: function renderFrame() {
	      // If it is exported as hidden (data.hd === true) no need to render
	      // If it is not visible no need to render
	      if (this.data.hd || this.hidden) {
	        return;
	      }

	      this.renderTransform();
	      this.renderRenderable();
	      this.renderElement();
	      this.renderInnerContent();

	      if (this._isFirstFrame) {
	        this._isFirstFrame = false;
	      }
	    },
	    destroy: function destroy() {
	      this.layerElement = null;
	      this.transformedElement = null;

	      if (this.matteElement) {
	        this.matteElement = null;
	      }

	      if (this.maskManager) {
	        this.maskManager.destroy();
	        this.maskManager = null;
	      }
	    },
	    createRenderableComponents: function createRenderableComponents() {
	      this.maskManager = new MaskElement(this.data, this, this.globalData);
	    },
	    addEffects: function addEffects() {},
	    setMatte: function setMatte() {}
	  };
	  HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement;
	  HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy;
	  HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting;

	  function HSolidElement(data, globalData, comp) {
	    this.initElement(data, globalData, comp);
	  }

	  extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], HSolidElement);

	  HSolidElement.prototype.createContent = function () {
	    var rect;

	    if (this.data.hasMask) {
	      rect = createNS('rect');
	      rect.setAttribute('width', this.data.sw);
	      rect.setAttribute('height', this.data.sh);
	      rect.setAttribute('fill', this.data.sc);
	      this.svgElement.setAttribute('width', this.data.sw);
	      this.svgElement.setAttribute('height', this.data.sh);
	    } else {
	      rect = createTag('div');
	      rect.style.width = this.data.sw + 'px';
	      rect.style.height = this.data.sh + 'px';
	      rect.style.backgroundColor = this.data.sc;
	    }

	    this.layerElement.appendChild(rect);
	  };

	  function HShapeElement(data, globalData, comp) {
	    // List of drawable elements
	    this.shapes = []; // Full shape data

	    this.shapesData = data.shapes; // List of styles that will be applied to shapes

	    this.stylesList = []; // List of modifiers that will be applied to shapes

	    this.shapeModifiers = []; // List of items in shape tree

	    this.itemsData = []; // List of items in previous shape tree

	    this.processedElements = []; // List of animated components

	    this.animatedContents = [];
	    this.shapesContainer = createNS('g');
	    this.initElement(data, globalData, comp); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
	    // List of elements that have been created

	    this.prevViewData = [];
	    this.currentBBox = {
	      x: 999999,
	      y: -999999,
	      h: 0,
	      w: 0
	    };
	  }

	  extendPrototype([BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement, HierarchyElement, FrameElement, RenderableElement], HShapeElement);
	  HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent;

	  HShapeElement.prototype.createContent = function () {
	    var cont;
	    this.baseElement.style.fontSize = 0;

	    if (this.data.hasMask) {
	      this.layerElement.appendChild(this.shapesContainer);
	      cont = this.svgElement;
	    } else {
	      cont = createNS('svg');
	      var size = this.comp.data ? this.comp.data : this.globalData.compSize;
	      cont.setAttribute('width', size.w);
	      cont.setAttribute('height', size.h);
	      cont.appendChild(this.shapesContainer);
	      this.layerElement.appendChild(cont);
	    }

	    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], true);
	    this.filterUniqueShapes();
	    this.shapeCont = cont;
	  };

	  HShapeElement.prototype.getTransformedPoint = function (transformers, point) {
	    var i;
	    var len = transformers.length;

	    for (i = 0; i < len; i += 1) {
	      point = transformers[i].mProps.v.applyToPointArray(point[0], point[1], 0);
	    }

	    return point;
	  };

	  HShapeElement.prototype.calculateShapeBoundingBox = function (item, boundingBox) {
	    var shape = item.sh.v;
	    var transformers = item.transformers;
	    var i;
	    var len = shape._length;
	    var vPoint;
	    var oPoint;
	    var nextIPoint;
	    var nextVPoint;

	    if (len <= 1) {
	      return;
	    }

	    for (i = 0; i < len - 1; i += 1) {
	      vPoint = this.getTransformedPoint(transformers, shape.v[i]);
	      oPoint = this.getTransformedPoint(transformers, shape.o[i]);
	      nextIPoint = this.getTransformedPoint(transformers, shape.i[i + 1]);
	      nextVPoint = this.getTransformedPoint(transformers, shape.v[i + 1]);
	      this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
	    }

	    if (shape.c) {
	      vPoint = this.getTransformedPoint(transformers, shape.v[i]);
	      oPoint = this.getTransformedPoint(transformers, shape.o[i]);
	      nextIPoint = this.getTransformedPoint(transformers, shape.i[0]);
	      nextVPoint = this.getTransformedPoint(transformers, shape.v[0]);
	      this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
	    }
	  };

	  HShapeElement.prototype.checkBounds = function (vPoint, oPoint, nextIPoint, nextVPoint, boundingBox) {
	    this.getBoundsOfCurve(vPoint, oPoint, nextIPoint, nextVPoint);
	    var bounds = this.shapeBoundingBox;
	    boundingBox.x = bmMin(bounds.left, boundingBox.x);
	    boundingBox.xMax = bmMax(bounds.right, boundingBox.xMax);
	    boundingBox.y = bmMin(bounds.top, boundingBox.y);
	    boundingBox.yMax = bmMax(bounds.bottom, boundingBox.yMax);
	  };

	  HShapeElement.prototype.shapeBoundingBox = {
	    left: 0,
	    right: 0,
	    top: 0,
	    bottom: 0
	  };
	  HShapeElement.prototype.tempBoundingBox = {
	    x: 0,
	    xMax: 0,
	    y: 0,
	    yMax: 0,
	    width: 0,
	    height: 0
	  };

	  HShapeElement.prototype.getBoundsOfCurve = function (p0, p1, p2, p3) {
	    var bounds = [[p0[0], p3[0]], [p0[1], p3[1]]];

	    for (var a, b, c, t, b2ac, t1, t2, i = 0; i < 2; ++i) {
	      // eslint-disable-line no-plusplus
	      b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
	      a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
	      c = 3 * p1[i] - 3 * p0[i];
	      b |= 0; // eslint-disable-line no-bitwise

	      a |= 0; // eslint-disable-line no-bitwise

	      c |= 0; // eslint-disable-line no-bitwise

	      if (a === 0 && b === 0) ; else if (a === 0) {
	        t = -c / b;

	        if (t > 0 && t < 1) {
	          bounds[i].push(this.calculateF(t, p0, p1, p2, p3, i));
	        }
	      } else {
	        b2ac = b * b - 4 * c * a;

	        if (b2ac >= 0) {
	          t1 = (-b + bmSqrt(b2ac)) / (2 * a);
	          if (t1 > 0 && t1 < 1) bounds[i].push(this.calculateF(t1, p0, p1, p2, p3, i));
	          t2 = (-b - bmSqrt(b2ac)) / (2 * a);
	          if (t2 > 0 && t2 < 1) bounds[i].push(this.calculateF(t2, p0, p1, p2, p3, i));
	        }
	      }
	    }

	    this.shapeBoundingBox.left = bmMin.apply(null, bounds[0]);
	    this.shapeBoundingBox.top = bmMin.apply(null, bounds[1]);
	    this.shapeBoundingBox.right = bmMax.apply(null, bounds[0]);
	    this.shapeBoundingBox.bottom = bmMax.apply(null, bounds[1]);
	  };

	  HShapeElement.prototype.calculateF = function (t, p0, p1, p2, p3, i) {
	    return bmPow(1 - t, 3) * p0[i] + 3 * bmPow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * bmPow(t, 2) * p2[i] + bmPow(t, 3) * p3[i];
	  };

	  HShapeElement.prototype.calculateBoundingBox = function (itemsData, boundingBox) {
	    var i;
	    var len = itemsData.length;

	    for (i = 0; i < len; i += 1) {
	      if (itemsData[i] && itemsData[i].sh) {
	        this.calculateShapeBoundingBox(itemsData[i], boundingBox);
	      } else if (itemsData[i] && itemsData[i].it) {
	        this.calculateBoundingBox(itemsData[i].it, boundingBox);
	      } else if (itemsData[i] && itemsData[i].style && itemsData[i].w) {
	        this.expandStrokeBoundingBox(itemsData[i].w, boundingBox);
	      }
	    }
	  };

	  HShapeElement.prototype.expandStrokeBoundingBox = function (widthProperty, boundingBox) {
	    var width = 0;

	    if (widthProperty.keyframes) {
	      for (var i = 0; i < widthProperty.keyframes.length; i += 1) {
	        var kfw = widthProperty.keyframes[i].s;

	        if (kfw > width) {
	          width = kfw;
	        }
	      }

	      width *= widthProperty.mult;
	    } else {
	      width = widthProperty.v * widthProperty.mult;
	    }

	    boundingBox.x -= width;
	    boundingBox.xMax += width;
	    boundingBox.y -= width;
	    boundingBox.yMax += width;
	  };

	  HShapeElement.prototype.currentBoxContains = function (box) {
	    return this.currentBBox.x <= box.x && this.currentBBox.y <= box.y && this.currentBBox.width + this.currentBBox.x >= box.x + box.width && this.currentBBox.height + this.currentBBox.y >= box.y + box.height;
	  };

	  HShapeElement.prototype.renderInnerContent = function () {
	    this._renderShapeFrame();

	    if (!this.hidden && (this._isFirstFrame || this._mdf)) {
	      var tempBoundingBox = this.tempBoundingBox;
	      var max = 999999;
	      tempBoundingBox.x = max;
	      tempBoundingBox.xMax = -max;
	      tempBoundingBox.y = max;
	      tempBoundingBox.yMax = -max;
	      this.calculateBoundingBox(this.itemsData, tempBoundingBox);
	      tempBoundingBox.width = tempBoundingBox.xMax < tempBoundingBox.x ? 0 : tempBoundingBox.xMax - tempBoundingBox.x;
	      tempBoundingBox.height = tempBoundingBox.yMax < tempBoundingBox.y ? 0 : tempBoundingBox.yMax - tempBoundingBox.y; // var tempBoundingBox = this.shapeCont.getBBox();

	      if (this.currentBoxContains(tempBoundingBox)) {
	        return;
	      }

	      var changed = false;

	      if (this.currentBBox.w !== tempBoundingBox.width) {
	        this.currentBBox.w = tempBoundingBox.width;
	        this.shapeCont.setAttribute('width', tempBoundingBox.width);
	        changed = true;
	      }

	      if (this.currentBBox.h !== tempBoundingBox.height) {
	        this.currentBBox.h = tempBoundingBox.height;
	        this.shapeCont.setAttribute('height', tempBoundingBox.height);
	        changed = true;
	      }

	      if (changed || this.currentBBox.x !== tempBoundingBox.x || this.currentBBox.y !== tempBoundingBox.y) {
	        this.currentBBox.w = tempBoundingBox.width;
	        this.currentBBox.h = tempBoundingBox.height;
	        this.currentBBox.x = tempBoundingBox.x;
	        this.currentBBox.y = tempBoundingBox.y;
	        this.shapeCont.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
	        var shapeStyle = this.shapeCont.style;
	        var shapeTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
	        shapeStyle.transform = shapeTransform;
	        shapeStyle.webkitTransform = shapeTransform;
	      }
	    }
	  };

	  function HTextElement(data, globalData, comp) {
	    this.textSpans = [];
	    this.textPaths = [];
	    this.currentBBox = {
	      x: 999999,
	      y: -999999,
	      h: 0,
	      w: 0
	    };
	    this.renderType = 'svg';
	    this.isMasked = false;
	    this.initElement(data, globalData, comp);
	  }

	  extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], HTextElement);

	  HTextElement.prototype.createContent = function () {
	    this.isMasked = this.checkMasks();

	    if (this.isMasked) {
	      this.renderType = 'svg';
	      this.compW = this.comp.data.w;
	      this.compH = this.comp.data.h;
	      this.svgElement.setAttribute('width', this.compW);
	      this.svgElement.setAttribute('height', this.compH);
	      var g = createNS('g');
	      this.maskedElement.appendChild(g);
	      this.innerElem = g;
	    } else {
	      this.renderType = 'html';
	      this.innerElem = this.layerElement;
	    }

	    this.checkParenting();
	  };

	  HTextElement.prototype.buildNewText = function () {
	    var documentData = this.textProperty.currentData;
	    this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
	    var innerElemStyle = this.innerElem.style;
	    var textColor = documentData.fc ? this.buildColor(documentData.fc) : 'rgba(0,0,0,0)';
	    innerElemStyle.fill = textColor;
	    innerElemStyle.color = textColor;

	    if (documentData.sc) {
	      innerElemStyle.stroke = this.buildColor(documentData.sc);
	      innerElemStyle.strokeWidth = documentData.sw + 'px';
	    }

	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);

	    if (!this.globalData.fontManager.chars) {
	      innerElemStyle.fontSize = documentData.finalSize + 'px';
	      innerElemStyle.lineHeight = documentData.finalSize + 'px';

	      if (fontData.fClass) {
	        this.innerElem.className = fontData.fClass;
	      } else {
	        innerElemStyle.fontFamily = fontData.fFamily;
	        var fWeight = documentData.fWeight;
	        var fStyle = documentData.fStyle;
	        innerElemStyle.fontStyle = fStyle;
	        innerElemStyle.fontWeight = fWeight;
	      }
	    }

	    var i;
	    var len;
	    var letters = documentData.l;
	    len = letters.length;
	    var tSpan;
	    var tParent;
	    var tCont;
	    var matrixHelper = this.mHelper;
	    var shapes;
	    var shapeStr = '';
	    var cnt = 0;

	    for (i = 0; i < len; i += 1) {
	      if (this.globalData.fontManager.chars) {
	        if (!this.textPaths[cnt]) {
	          tSpan = createNS('path');
	          tSpan.setAttribute('stroke-linecap', lineCapEnum[1]);
	          tSpan.setAttribute('stroke-linejoin', lineJoinEnum[2]);
	          tSpan.setAttribute('stroke-miterlimit', '4');
	        } else {
	          tSpan = this.textPaths[cnt];
	        }

	        if (!this.isMasked) {
	          if (this.textSpans[cnt]) {
	            tParent = this.textSpans[cnt];
	            tCont = tParent.children[0];
	          } else {
	            tParent = createTag('div');
	            tParent.style.lineHeight = 0;
	            tCont = createNS('svg');
	            tCont.appendChild(tSpan);
	            styleDiv(tParent);
	          }
	        }
	      } else if (!this.isMasked) {
	        if (this.textSpans[cnt]) {
	          tParent = this.textSpans[cnt];
	          tSpan = this.textPaths[cnt];
	        } else {
	          tParent = createTag('span');
	          styleDiv(tParent);
	          tSpan = createTag('span');
	          styleDiv(tSpan);
	          tParent.appendChild(tSpan);
	        }
	      } else {
	        tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : createNS('text');
	      } // tSpan.setAttribute('visibility', 'hidden');


	      if (this.globalData.fontManager.chars) {
	        var charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	        var shapeData;

	        if (charData) {
	          shapeData = charData.data;
	        } else {
	          shapeData = null;
	        }

	        matrixHelper.reset();

	        if (shapeData && shapeData.shapes && shapeData.shapes.length) {
	          shapes = shapeData.shapes[0].it;
	          matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
	          shapeStr = this.createPathShape(matrixHelper, shapes);
	          tSpan.setAttribute('d', shapeStr);
	        }

	        if (!this.isMasked) {
	          this.innerElem.appendChild(tParent);

	          if (shapeData && shapeData.shapes) {
	            // document.body.appendChild is needed to get exact measure of shape
	            document.body.appendChild(tCont);
	            var boundingBox = tCont.getBBox();
	            tCont.setAttribute('width', boundingBox.width + 2);
	            tCont.setAttribute('height', boundingBox.height + 2);
	            tCont.setAttribute('viewBox', boundingBox.x - 1 + ' ' + (boundingBox.y - 1) + ' ' + (boundingBox.width + 2) + ' ' + (boundingBox.height + 2));
	            var tContStyle = tCont.style;
	            var tContTranslation = 'translate(' + (boundingBox.x - 1) + 'px,' + (boundingBox.y - 1) + 'px)';
	            tContStyle.transform = tContTranslation;
	            tContStyle.webkitTransform = tContTranslation;
	            letters[i].yOffset = boundingBox.y - 1;
	          } else {
	            tCont.setAttribute('width', 1);
	            tCont.setAttribute('height', 1);
	          }

	          tParent.appendChild(tCont);
	        } else {
	          this.innerElem.appendChild(tSpan);
	        }
	      } else {
	        tSpan.textContent = letters[i].val;
	        tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');

	        if (!this.isMasked) {
	          this.innerElem.appendChild(tParent); //

	          var tStyle = tSpan.style;
	          var tSpanTranslation = 'translate3d(0,' + -documentData.finalSize / 1.2 + 'px,0)';
	          tStyle.transform = tSpanTranslation;
	          tStyle.webkitTransform = tSpanTranslation;
	        } else {
	          this.innerElem.appendChild(tSpan);
	        }
	      } //


	      if (!this.isMasked) {
	        this.textSpans[cnt] = tParent;
	      } else {
	        this.textSpans[cnt] = tSpan;
	      }

	      this.textSpans[cnt].style.display = 'block';
	      this.textPaths[cnt] = tSpan;
	      cnt += 1;
	    }

	    while (cnt < this.textSpans.length) {
	      this.textSpans[cnt].style.display = 'none';
	      cnt += 1;
	    }
	  };

	  HTextElement.prototype.renderInnerContent = function () {
	    this.validateText();
	    var svgStyle;

	    if (this.data.singleShape) {
	      if (!this._isFirstFrame && !this.lettersChangedFlag) {
	        return;
	      }

	      if (this.isMasked && this.finalTransform._matMdf) {
	        // Todo Benchmark if using this is better than getBBox
	        this.svgElement.setAttribute('viewBox', -this.finalTransform.mProp.p.v[0] + ' ' + -this.finalTransform.mProp.p.v[1] + ' ' + this.compW + ' ' + this.compH);
	        svgStyle = this.svgElement.style;
	        var translation = 'translate(' + -this.finalTransform.mProp.p.v[0] + 'px,' + -this.finalTransform.mProp.p.v[1] + 'px)';
	        svgStyle.transform = translation;
	        svgStyle.webkitTransform = translation;
	      }
	    }

	    this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);

	    if (!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag) {
	      return;
	    }

	    var i;
	    var len;
	    var count = 0;
	    var renderedLetters = this.textAnimator.renderedLetters;
	    var letters = this.textProperty.currentData.l;
	    len = letters.length;
	    var renderedLetter;
	    var textSpan;
	    var textPath;

	    for (i = 0; i < len; i += 1) {
	      if (letters[i].n) {
	        count += 1;
	      } else {
	        textSpan = this.textSpans[i];
	        textPath = this.textPaths[i];
	        renderedLetter = renderedLetters[count];
	        count += 1;

	        if (renderedLetter._mdf.m) {
	          if (!this.isMasked) {
	            textSpan.style.webkitTransform = renderedLetter.m;
	            textSpan.style.transform = renderedLetter.m;
	          } else {
	            textSpan.setAttribute('transform', renderedLetter.m);
	          }
	        } /// /textSpan.setAttribute('opacity',renderedLetter.o);


	        textSpan.style.opacity = renderedLetter.o;

	        if (renderedLetter.sw && renderedLetter._mdf.sw) {
	          textPath.setAttribute('stroke-width', renderedLetter.sw);
	        }

	        if (renderedLetter.sc && renderedLetter._mdf.sc) {
	          textPath.setAttribute('stroke', renderedLetter.sc);
	        }

	        if (renderedLetter.fc && renderedLetter._mdf.fc) {
	          textPath.setAttribute('fill', renderedLetter.fc);
	          textPath.style.color = renderedLetter.fc;
	        }
	      }
	    }

	    if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
	      var boundingBox = this.innerElem.getBBox();

	      if (this.currentBBox.w !== boundingBox.width) {
	        this.currentBBox.w = boundingBox.width;
	        this.svgElement.setAttribute('width', boundingBox.width);
	      }

	      if (this.currentBBox.h !== boundingBox.height) {
	        this.currentBBox.h = boundingBox.height;
	        this.svgElement.setAttribute('height', boundingBox.height);
	      }

	      var margin = 1;

	      if (this.currentBBox.w !== boundingBox.width + margin * 2 || this.currentBBox.h !== boundingBox.height + margin * 2 || this.currentBBox.x !== boundingBox.x - margin || this.currentBBox.y !== boundingBox.y - margin) {
	        this.currentBBox.w = boundingBox.width + margin * 2;
	        this.currentBBox.h = boundingBox.height + margin * 2;
	        this.currentBBox.x = boundingBox.x - margin;
	        this.currentBBox.y = boundingBox.y - margin;
	        this.svgElement.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
	        svgStyle = this.svgElement.style;
	        var svgTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
	        svgStyle.transform = svgTransform;
	        svgStyle.webkitTransform = svgTransform;
	      }
	    }
	  };

	  function HCameraElement(data, globalData, comp) {
	    this.initFrame();
	    this.initBaseData(data, globalData, comp);
	    this.initHierarchy();
	    var getProp = PropertyFactory.getProp;
	    this.pe = getProp(this, data.pe, 0, 0, this);

	    if (data.ks.p.s) {
	      this.px = getProp(this, data.ks.p.x, 1, 0, this);
	      this.py = getProp(this, data.ks.p.y, 1, 0, this);
	      this.pz = getProp(this, data.ks.p.z, 1, 0, this);
	    } else {
	      this.p = getProp(this, data.ks.p, 1, 0, this);
	    }

	    if (data.ks.a) {
	      this.a = getProp(this, data.ks.a, 1, 0, this);
	    }

	    if (data.ks.or.k.length && data.ks.or.k[0].to) {
	      var i;
	      var len = data.ks.or.k.length;

	      for (i = 0; i < len; i += 1) {
	        data.ks.or.k[i].to = null;
	        data.ks.or.k[i].ti = null;
	      }
	    }

	    this.or = getProp(this, data.ks.or, 1, degToRads, this);
	    this.or.sh = true;
	    this.rx = getProp(this, data.ks.rx, 0, degToRads, this);
	    this.ry = getProp(this, data.ks.ry, 0, degToRads, this);
	    this.rz = getProp(this, data.ks.rz, 0, degToRads, this);
	    this.mat = new Matrix();
	    this._prevMat = new Matrix();
	    this._isFirstFrame = true; // TODO: find a better way to make the HCamera element to be compatible with the LayerInterface and TransformInterface.

	    this.finalTransform = {
	      mProp: this
	    };
	  }

	  extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement);

	  HCameraElement.prototype.setup = function () {
	    var i;
	    var len = this.comp.threeDElements.length;
	    var comp;
	    var perspectiveStyle;
	    var containerStyle;

	    for (i = 0; i < len; i += 1) {
	      // [perspectiveElem,container]
	      comp = this.comp.threeDElements[i];

	      if (comp.type === '3d') {
	        perspectiveStyle = comp.perspectiveElem.style;
	        containerStyle = comp.container.style;
	        var perspective = this.pe.v + 'px';
	        var origin = '0px 0px 0px';
	        var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
	        perspectiveStyle.perspective = perspective;
	        perspectiveStyle.webkitPerspective = perspective;
	        containerStyle.transformOrigin = origin;
	        containerStyle.mozTransformOrigin = origin;
	        containerStyle.webkitTransformOrigin = origin;
	        perspectiveStyle.transform = matrix;
	        perspectiveStyle.webkitTransform = matrix;
	      }
	    }
	  };

	  HCameraElement.prototype.createElements = function () {};

	  HCameraElement.prototype.hide = function () {};

	  HCameraElement.prototype.renderFrame = function () {
	    var _mdf = this._isFirstFrame;
	    var i;
	    var len;

	    if (this.hierarchy) {
	      len = this.hierarchy.length;

	      for (i = 0; i < len; i += 1) {
	        _mdf = this.hierarchy[i].finalTransform.mProp._mdf || _mdf;
	      }
	    }

	    if (_mdf || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
	      this.mat.reset();

	      if (this.hierarchy) {
	        len = this.hierarchy.length - 1;

	        for (i = len; i >= 0; i -= 1) {
	          var mTransf = this.hierarchy[i].finalTransform.mProp;
	          this.mat.translate(-mTransf.p.v[0], -mTransf.p.v[1], mTransf.p.v[2]);
	          this.mat.rotateX(-mTransf.or.v[0]).rotateY(-mTransf.or.v[1]).rotateZ(mTransf.or.v[2]);
	          this.mat.rotateX(-mTransf.rx.v).rotateY(-mTransf.ry.v).rotateZ(mTransf.rz.v);
	          this.mat.scale(1 / mTransf.s.v[0], 1 / mTransf.s.v[1], 1 / mTransf.s.v[2]);
	          this.mat.translate(mTransf.a.v[0], mTransf.a.v[1], mTransf.a.v[2]);
	        }
	      }

	      if (this.p) {
	        this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]);
	      } else {
	        this.mat.translate(-this.px.v, -this.py.v, this.pz.v);
	      }

	      if (this.a) {
	        var diffVector;

	        if (this.p) {
	          diffVector = [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]];
	        } else {
	          diffVector = [this.px.v - this.a.v[0], this.py.v - this.a.v[1], this.pz.v - this.a.v[2]];
	        }

	        var mag = Math.sqrt(Math.pow(diffVector[0], 2) + Math.pow(diffVector[1], 2) + Math.pow(diffVector[2], 2)); // var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));

	        var lookDir = [diffVector[0] / mag, diffVector[1] / mag, diffVector[2] / mag];
	        var lookLengthOnXZ = Math.sqrt(lookDir[2] * lookDir[2] + lookDir[0] * lookDir[0]);
	        var mRotationX = Math.atan2(lookDir[1], lookLengthOnXZ);
	        var mRotationY = Math.atan2(lookDir[0], -lookDir[2]);
	        this.mat.rotateY(mRotationY).rotateX(-mRotationX);
	      }

	      this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
	      this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
	      this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0);
	      this.mat.translate(0, 0, this.pe.v);
	      var hasMatrixChanged = !this._prevMat.equals(this.mat);

	      if ((hasMatrixChanged || this.pe._mdf) && this.comp.threeDElements) {
	        len = this.comp.threeDElements.length;
	        var comp;
	        var perspectiveStyle;
	        var containerStyle;

	        for (i = 0; i < len; i += 1) {
	          comp = this.comp.threeDElements[i];

	          if (comp.type === '3d') {
	            if (hasMatrixChanged) {
	              var matValue = this.mat.toCSS();
	              containerStyle = comp.container.style;
	              containerStyle.transform = matValue;
	              containerStyle.webkitTransform = matValue;
	            }

	            if (this.pe._mdf) {
	              perspectiveStyle = comp.perspectiveElem.style;
	              perspectiveStyle.perspective = this.pe.v + 'px';
	              perspectiveStyle.webkitPerspective = this.pe.v + 'px';
	            }
	          }
	        }

	        this.mat.clone(this._prevMat);
	      }
	    }

	    this._isFirstFrame = false;
	  };

	  HCameraElement.prototype.prepareFrame = function (num) {
	    this.prepareProperties(num, true);
	  };

	  HCameraElement.prototype.destroy = function () {};

	  HCameraElement.prototype.getBaseElement = function () {
	    return null;
	  };

	  function HImageElement(data, globalData, comp) {
	    this.assetData = globalData.getAssetData(data.refId);
	    this.initElement(data, globalData, comp);
	  }

	  extendPrototype([BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement, FrameElement, RenderableElement], HImageElement);

	  HImageElement.prototype.createContent = function () {
	    var assetPath = this.globalData.getAssetsPath(this.assetData);
	    var img = new Image();

	    if (this.data.hasMask) {
	      this.imageElem = createNS('image');
	      this.imageElem.setAttribute('width', this.assetData.w + 'px');
	      this.imageElem.setAttribute('height', this.assetData.h + 'px');
	      this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
	      this.layerElement.appendChild(this.imageElem);
	      this.baseElement.setAttribute('width', this.assetData.w);
	      this.baseElement.setAttribute('height', this.assetData.h);
	    } else {
	      this.layerElement.appendChild(img);
	    }

	    img.crossOrigin = 'anonymous';
	    img.src = assetPath;

	    if (this.data.ln) {
	      this.baseElement.setAttribute('id', this.data.ln);
	    }
	  };

	  function HybridRendererBase(animationItem, config) {
	    this.animationItem = animationItem;
	    this.layers = null;
	    this.renderedFrame = -1;
	    this.renderConfig = {
	      className: config && config.className || '',
	      imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
	      hideOnTransparent: !(config && config.hideOnTransparent === false),
	      filterSize: {
	        width: config && config.filterSize && config.filterSize.width || '400%',
	        height: config && config.filterSize && config.filterSize.height || '400%',
	        x: config && config.filterSize && config.filterSize.x || '-100%',
	        y: config && config.filterSize && config.filterSize.y || '-100%'
	      }
	    };
	    this.globalData = {
	      _mdf: false,
	      frameNum: -1,
	      renderConfig: this.renderConfig
	    };
	    this.pendingElements = [];
	    this.elements = [];
	    this.threeDElements = [];
	    this.destroyed = false;
	    this.camera = null;
	    this.supports3d = true;
	    this.rendererType = 'html';
	  }

	  extendPrototype([BaseRenderer], HybridRendererBase);
	  HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem;

	  HybridRendererBase.prototype.checkPendingElements = function () {
	    while (this.pendingElements.length) {
	      var element = this.pendingElements.pop();
	      element.checkParenting();
	    }
	  };

	  HybridRendererBase.prototype.appendElementInPos = function (element, pos) {
	    var newDOMElement = element.getBaseElement();

	    if (!newDOMElement) {
	      return;
	    }

	    var layer = this.layers[pos];

	    if (!layer.ddd || !this.supports3d) {
	      if (this.threeDElements) {
	        this.addTo3dContainer(newDOMElement, pos);
	      } else {
	        var i = 0;
	        var nextDOMElement;
	        var nextLayer;
	        var tmpDOMElement;

	        while (i < pos) {
	          if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement) {
	            nextLayer = this.elements[i];
	            tmpDOMElement = this.layers[i].ddd ? this.getThreeDContainerByPos(i) : nextLayer.getBaseElement();
	            nextDOMElement = tmpDOMElement || nextDOMElement;
	          }

	          i += 1;
	        }

	        if (nextDOMElement) {
	          if (!layer.ddd || !this.supports3d) {
	            this.layerElement.insertBefore(newDOMElement, nextDOMElement);
	          }
	        } else if (!layer.ddd || !this.supports3d) {
	          this.layerElement.appendChild(newDOMElement);
	        }
	      }
	    } else {
	      this.addTo3dContainer(newDOMElement, pos);
	    }
	  };

	  HybridRendererBase.prototype.createShape = function (data) {
	    if (!this.supports3d) {
	      return new SVGShapeElement(data, this.globalData, this);
	    }

	    return new HShapeElement(data, this.globalData, this);
	  };

	  HybridRendererBase.prototype.createText = function (data) {
	    if (!this.supports3d) {
	      return new SVGTextLottieElement(data, this.globalData, this);
	    }

	    return new HTextElement(data, this.globalData, this);
	  };

	  HybridRendererBase.prototype.createCamera = function (data) {
	    this.camera = new HCameraElement(data, this.globalData, this);
	    return this.camera;
	  };

	  HybridRendererBase.prototype.createImage = function (data) {
	    if (!this.supports3d) {
	      return new IImageElement(data, this.globalData, this);
	    }

	    return new HImageElement(data, this.globalData, this);
	  };

	  HybridRendererBase.prototype.createSolid = function (data) {
	    if (!this.supports3d) {
	      return new ISolidElement(data, this.globalData, this);
	    }

	    return new HSolidElement(data, this.globalData, this);
	  };

	  HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;

	  HybridRendererBase.prototype.getThreeDContainerByPos = function (pos) {
	    var i = 0;
	    var len = this.threeDElements.length;

	    while (i < len) {
	      if (this.threeDElements[i].startPos <= pos && this.threeDElements[i].endPos >= pos) {
	        return this.threeDElements[i].perspectiveElem;
	      }

	      i += 1;
	    }

	    return null;
	  };

	  HybridRendererBase.prototype.createThreeDContainer = function (pos, type) {
	    var perspectiveElem = createTag('div');
	    var style;
	    var containerStyle;
	    styleDiv(perspectiveElem);
	    var container = createTag('div');
	    styleDiv(container);

	    if (type === '3d') {
	      style = perspectiveElem.style;
	      style.width = this.globalData.compSize.w + 'px';
	      style.height = this.globalData.compSize.h + 'px';
	      var center = '50% 50%';
	      style.webkitTransformOrigin = center;
	      style.mozTransformOrigin = center;
	      style.transformOrigin = center;
	      containerStyle = container.style;
	      var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
	      containerStyle.transform = matrix;
	      containerStyle.webkitTransform = matrix;
	    }

	    perspectiveElem.appendChild(container); // this.resizerElem.appendChild(perspectiveElem);

	    var threeDContainerData = {
	      container: container,
	      perspectiveElem: perspectiveElem,
	      startPos: pos,
	      endPos: pos,
	      type: type
	    };
	    this.threeDElements.push(threeDContainerData);
	    return threeDContainerData;
	  };

	  HybridRendererBase.prototype.build3dContainers = function () {
	    var i;
	    var len = this.layers.length;
	    var lastThreeDContainerData;
	    var currentContainer = '';

	    for (i = 0; i < len; i += 1) {
	      if (this.layers[i].ddd && this.layers[i].ty !== 3) {
	        if (currentContainer !== '3d') {
	          currentContainer = '3d';
	          lastThreeDContainerData = this.createThreeDContainer(i, '3d');
	        }

	        lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
	      } else {
	        if (currentContainer !== '2d') {
	          currentContainer = '2d';
	          lastThreeDContainerData = this.createThreeDContainer(i, '2d');
	        }

	        lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
	      }
	    }

	    len = this.threeDElements.length;

	    for (i = len - 1; i >= 0; i -= 1) {
	      this.resizerElem.appendChild(this.threeDElements[i].perspectiveElem);
	    }
	  };

	  HybridRendererBase.prototype.addTo3dContainer = function (elem, pos) {
	    var i = 0;
	    var len = this.threeDElements.length;

	    while (i < len) {
	      if (pos <= this.threeDElements[i].endPos) {
	        var j = this.threeDElements[i].startPos;
	        var nextElement;

	        while (j < pos) {
	          if (this.elements[j] && this.elements[j].getBaseElement) {
	            nextElement = this.elements[j].getBaseElement();
	          }

	          j += 1;
	        }

	        if (nextElement) {
	          this.threeDElements[i].container.insertBefore(elem, nextElement);
	        } else {
	          this.threeDElements[i].container.appendChild(elem);
	        }

	        break;
	      }

	      i += 1;
	    }
	  };

	  HybridRendererBase.prototype.configAnimation = function (animData) {
	    var resizerElem = createTag('div');
	    var wrapper = this.animationItem.wrapper;
	    var style = resizerElem.style;
	    style.width = animData.w + 'px';
	    style.height = animData.h + 'px';
	    this.resizerElem = resizerElem;
	    styleDiv(resizerElem);
	    style.transformStyle = 'flat';
	    style.mozTransformStyle = 'flat';
	    style.webkitTransformStyle = 'flat';

	    if (this.renderConfig.className) {
	      resizerElem.setAttribute('class', this.renderConfig.className);
	    }

	    wrapper.appendChild(resizerElem);
	    style.overflow = 'hidden';
	    var svg = createNS('svg');
	    svg.setAttribute('width', '1');
	    svg.setAttribute('height', '1');
	    styleDiv(svg);
	    this.resizerElem.appendChild(svg);
	    var defs = createNS('defs');
	    svg.appendChild(defs);
	    this.data = animData; // Mask animation

	    this.setupGlobalData(animData, svg);
	    this.globalData.defs = defs;
	    this.layers = animData.layers;
	    this.layerElement = this.resizerElem;
	    this.build3dContainers();
	    this.updateContainerSize();
	  };

	  HybridRendererBase.prototype.destroy = function () {
	    if (this.animationItem.wrapper) {
	      this.animationItem.wrapper.innerText = '';
	    }

	    this.animationItem.container = null;
	    this.globalData.defs = null;
	    var i;
	    var len = this.layers ? this.layers.length : 0;

	    for (i = 0; i < len; i += 1) {
	      if (this.elements[i] && this.elements[i].destroy) {
	        this.elements[i].destroy();
	      }
	    }

	    this.elements.length = 0;
	    this.destroyed = true;
	    this.animationItem = null;
	  };

	  HybridRendererBase.prototype.updateContainerSize = function () {
	    var elementWidth = this.animationItem.wrapper.offsetWidth;
	    var elementHeight = this.animationItem.wrapper.offsetHeight;
	    var elementRel = elementWidth / elementHeight;
	    var animationRel = this.globalData.compSize.w / this.globalData.compSize.h;
	    var sx;
	    var sy;
	    var tx;
	    var ty;

	    if (animationRel > elementRel) {
	      sx = elementWidth / this.globalData.compSize.w;
	      sy = elementWidth / this.globalData.compSize.w;
	      tx = 0;
	      ty = (elementHeight - this.globalData.compSize.h * (elementWidth / this.globalData.compSize.w)) / 2;
	    } else {
	      sx = elementHeight / this.globalData.compSize.h;
	      sy = elementHeight / this.globalData.compSize.h;
	      tx = (elementWidth - this.globalData.compSize.w * (elementHeight / this.globalData.compSize.h)) / 2;
	      ty = 0;
	    }

	    var style = this.resizerElem.style;
	    style.webkitTransform = 'matrix3d(' + sx + ',0,0,0,0,' + sy + ',0,0,0,0,1,0,' + tx + ',' + ty + ',0,1)';
	    style.transform = style.webkitTransform;
	  };

	  HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame;

	  HybridRendererBase.prototype.hide = function () {
	    this.resizerElem.style.display = 'none';
	  };

	  HybridRendererBase.prototype.show = function () {
	    this.resizerElem.style.display = 'block';
	  };

	  HybridRendererBase.prototype.initItems = function () {
	    this.buildAllItems();

	    if (this.camera) {
	      this.camera.setup();
	    } else {
	      var cWidth = this.globalData.compSize.w;
	      var cHeight = this.globalData.compSize.h;
	      var i;
	      var len = this.threeDElements.length;

	      for (i = 0; i < len; i += 1) {
	        var style = this.threeDElements[i].perspectiveElem.style;
	        style.webkitPerspective = Math.sqrt(Math.pow(cWidth, 2) + Math.pow(cHeight, 2)) + 'px';
	        style.perspective = style.webkitPerspective;
	      }
	    }
	  };

	  HybridRendererBase.prototype.searchExtraCompositions = function (assets) {
	    var i;
	    var len = assets.length;
	    var floatingContainer = createTag('div');

	    for (i = 0; i < len; i += 1) {
	      if (assets[i].xt) {
	        var comp = this.createComp(assets[i], floatingContainer, this.globalData.comp, null);
	        comp.initExpressions();
	        this.globalData.projectInterface.registerComposition(comp);
	      }
	    }
	  };

	  function HCompElement(data, globalData, comp) {
	    this.layers = data.layers;
	    this.supports3d = !data.hasMask;
	    this.completeLayers = false;
	    this.pendingElements = [];
	    this.elements = this.layers ? createSizedArray(this.layers.length) : [];
	    this.initElement(data, globalData, comp);
	    this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
	      _placeholder: true
	    };
	  }

	  extendPrototype([HybridRendererBase, ICompElement, HBaseElement], HCompElement);
	  HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements;

	  HCompElement.prototype.createContainerElements = function () {
	    this._createBaseContainerElements(); // divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';


	    if (this.data.hasMask) {
	      this.svgElement.setAttribute('width', this.data.w);
	      this.svgElement.setAttribute('height', this.data.h);
	      this.transformedElement = this.baseElement;
	    } else {
	      this.transformedElement = this.layerElement;
	    }
	  };

	  HCompElement.prototype.addTo3dContainer = function (elem, pos) {
	    var j = 0;
	    var nextElement;

	    while (j < pos) {
	      if (this.elements[j] && this.elements[j].getBaseElement) {
	        nextElement = this.elements[j].getBaseElement();
	      }

	      j += 1;
	    }

	    if (nextElement) {
	      this.layerElement.insertBefore(elem, nextElement);
	    } else {
	      this.layerElement.appendChild(elem);
	    }
	  };

	  HCompElement.prototype.createComp = function (data) {
	    if (!this.supports3d) {
	      return new SVGCompElement(data, this.globalData, this);
	    }

	    return new HCompElement(data, this.globalData, this);
	  };

	  function HybridRenderer(animationItem, config) {
	    this.animationItem = animationItem;
	    this.layers = null;
	    this.renderedFrame = -1;
	    this.renderConfig = {
	      className: config && config.className || '',
	      imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
	      hideOnTransparent: !(config && config.hideOnTransparent === false),
	      filterSize: {
	        width: config && config.filterSize && config.filterSize.width || '400%',
	        height: config && config.filterSize && config.filterSize.height || '400%',
	        x: config && config.filterSize && config.filterSize.x || '-100%',
	        y: config && config.filterSize && config.filterSize.y || '-100%'
	      },
	      runExpressions: !config || config.runExpressions === undefined || config.runExpressions
	    };
	    this.globalData = {
	      _mdf: false,
	      frameNum: -1,
	      renderConfig: this.renderConfig
	    };
	    this.pendingElements = [];
	    this.elements = [];
	    this.threeDElements = [];
	    this.destroyed = false;
	    this.camera = null;
	    this.supports3d = true;
	    this.rendererType = 'html';
	  }

	  extendPrototype([HybridRendererBase], HybridRenderer);

	  HybridRenderer.prototype.createComp = function (data) {
	    if (!this.supports3d) {
	      return new SVGCompElement(data, this.globalData, this);
	    }

	    return new HCompElement(data, this.globalData, this);
	  };

	  var CompExpressionInterface = function () {
	    return function (comp) {
	      function _thisLayerFunction(name) {
	        var i = 0;
	        var len = comp.layers.length;

	        while (i < len) {
	          if (comp.layers[i].nm === name || comp.layers[i].ind === name) {
	            return comp.elements[i].layerInterface;
	          }

	          i += 1;
	        }

	        return null; // return {active:false};
	      }

	      Object.defineProperty(_thisLayerFunction, '_name', {
	        value: comp.data.nm
	      });
	      _thisLayerFunction.layer = _thisLayerFunction;
	      _thisLayerFunction.pixelAspect = 1;
	      _thisLayerFunction.height = comp.data.h || comp.globalData.compSize.h;
	      _thisLayerFunction.width = comp.data.w || comp.globalData.compSize.w;
	      _thisLayerFunction.pixelAspect = 1;
	      _thisLayerFunction.frameDuration = 1 / comp.globalData.frameRate;
	      _thisLayerFunction.displayStartTime = 0;
	      _thisLayerFunction.numLayers = comp.layers.length;
	      return _thisLayerFunction;
	    };
	  }();

	  function _typeof$2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$2 = function _typeof(obj) { return typeof obj; }; } else { _typeof$2 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$2(obj); }

	  /* eslint-disable */

	  /*
	   Copyright 2014 David Bau.

	   Permission is hereby granted, free of charge, to any person obtaining
	   a copy of this software and associated documentation files (the
	   "Software"), to deal in the Software without restriction, including
	   without limitation the rights to use, copy, modify, merge, publish,
	   distribute, sublicense, and/or sell copies of the Software, and to
	   permit persons to whom the Software is furnished to do so, subject to
	   the following conditions:

	   The above copyright notice and this permission notice shall be
	   included in all copies or substantial portions of the Software.

	   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	   EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	   MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	   IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	   CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	   TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	   SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

	   */
	  function seedRandom(pool, math) {
	    //
	    // The following constants are related to IEEE 754 limits.
	    //
	    var global = this,
	        width = 256,
	        // each RC4 output is 0 <= x < 256
	    chunks = 6,
	        // at least six RC4 outputs for each double
	    digits = 52,
	        // there are 52 significant digits in a double
	    rngname = 'random',
	        // rngname: name for Math.random and Math.seedrandom
	    startdenom = math.pow(width, chunks),
	        significance = math.pow(2, digits),
	        overflow = significance * 2,
	        mask = width - 1,
	        nodecrypto; // node.js crypto module, initialized at the bottom.
	    //
	    // seedrandom()
	    // This is the seedrandom function described above.
	    //

	    function seedrandom(seed, options, callback) {
	      var key = [];
	      options = options === true ? {
	        entropy: true
	      } : options || {}; // Flatten the seed string or build one from local entropy if needed.

	      var shortseed = mixkey(flatten(options.entropy ? [seed, tostring(pool)] : seed === null ? autoseed() : seed, 3), key); // Use the seed to initialize an ARC4 generator.

	      var arc4 = new ARC4(key); // This function returns a random double in [0, 1) that contains
	      // randomness in every bit of the mantissa of the IEEE 754 value.

	      var prng = function prng() {
	        var n = arc4.g(chunks),
	            // Start with a numerator n < 2 ^ 48
	        d = startdenom,
	            //   and denominator d = 2 ^ 48.
	        x = 0; //   and no 'extra last byte'.

	        while (n < significance) {
	          // Fill up all significant digits by
	          n = (n + x) * width; //   shifting numerator and

	          d *= width; //   denominator and generating a

	          x = arc4.g(1); //   new least-significant-byte.
	        }

	        while (n >= overflow) {
	          // To avoid rounding up, before adding
	          n /= 2; //   last byte, shift everything

	          d /= 2; //   right using integer math until

	          x >>>= 1; //   we have exactly the desired bits.
	        }

	        return (n + x) / d; // Form the number within [0, 1).
	      };

	      prng.int32 = function () {
	        return arc4.g(4) | 0;
	      };

	      prng.quick = function () {
	        return arc4.g(4) / 0x100000000;
	      };

	      prng["double"] = prng; // Mix the randomness into accumulated entropy.

	      mixkey(tostring(arc4.S), pool); // Calling convention: what to return as a function of prng, seed, is_math.

	      return (options.pass || callback || function (prng, seed, is_math_call, state) {
	        if (state) {
	          // Load the arc4 state from the given state if it has an S array.
	          if (state.S) {
	            copy(state, arc4);
	          } // Only provide the .state method if requested via options.state.


	          prng.state = function () {
	            return copy(arc4, {});
	          };
	        } // If called as a method of Math (Math.seedrandom()), mutate
	        // Math.random because that is how seedrandom.js has worked since v1.0.


	        if (is_math_call) {
	          math[rngname] = prng;
	          return seed;
	        } // Otherwise, it is a newer calling convention, so return the
	        // prng directly.
	        else return prng;
	      })(prng, shortseed, 'global' in options ? options.global : this == math, options.state);
	    }

	    math['seed' + rngname] = seedrandom; //
	    // ARC4
	    //
	    // An ARC4 implementation.  The constructor takes a key in the form of
	    // an array of at most (width) integers that should be 0 <= x < (width).
	    //
	    // The g(count) method returns a pseudorandom integer that concatenates
	    // the next (count) outputs from ARC4.  Its return value is a number x
	    // that is in the range 0 <= x < (width ^ count).
	    //

	    function ARC4(key) {
	      var t,
	          keylen = key.length,
	          me = this,
	          i = 0,
	          j = me.i = me.j = 0,
	          s = me.S = []; // The empty key [] is treated as [0].

	      if (!keylen) {
	        key = [keylen++];
	      } // Set up S using the standard key scheduling algorithm.


	      while (i < width) {
	        s[i] = i++;
	      }

	      for (i = 0; i < width; i++) {
	        s[i] = s[j = mask & j + key[i % keylen] + (t = s[i])];
	        s[j] = t;
	      } // The "g" method returns the next (count) outputs as one number.


	      me.g = function (count) {
	        // Using instance members instead of closure state nearly doubles speed.
	        var t,
	            r = 0,
	            i = me.i,
	            j = me.j,
	            s = me.S;

	        while (count--) {
	          t = s[i = mask & i + 1];
	          r = r * width + s[mask & (s[i] = s[j = mask & j + t]) + (s[j] = t)];
	        }

	        me.i = i;
	        me.j = j;
	        return r; // For robust unpredictability, the function call below automatically
	        // discards an initial batch of values.  This is called RC4-drop[256].
	        // See http://google.com/search?q=rsa+fluhrer+response&btnI
	      };
	    } //
	    // copy()
	    // Copies internal state of ARC4 to or from a plain object.
	    //


	    function copy(f, t) {
	      t.i = f.i;
	      t.j = f.j;
	      t.S = f.S.slice();
	      return t;
	    } //
	    // flatten()
	    // Converts an object tree to nested arrays of strings.
	    //


	    function flatten(obj, depth) {
	      var result = [],
	          typ = _typeof$2(obj),
	          prop;

	      if (depth && typ == 'object') {
	        for (prop in obj) {
	          try {
	            result.push(flatten(obj[prop], depth - 1));
	          } catch (e) {}
	        }
	      }

	      return result.length ? result : typ == 'string' ? obj : obj + '\0';
	    } //
	    // mixkey()
	    // Mixes a string seed into a key that is an array of integers, and
	    // returns a shortened string seed that is equivalent to the result key.
	    //


	    function mixkey(seed, key) {
	      var stringseed = seed + '',
	          smear,
	          j = 0;

	      while (j < stringseed.length) {
	        key[mask & j] = mask & (smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++);
	      }

	      return tostring(key);
	    } //
	    // autoseed()
	    // Returns an object for autoseeding, using window.crypto and Node crypto
	    // module if available.
	    //


	    function autoseed() {
	      try {
	        if (nodecrypto) ;

	        var out = new Uint8Array(width);
	        (global.crypto || global.msCrypto).getRandomValues(out);
	        return tostring(out);
	      } catch (e) {
	        var browser = global.navigator,
	            plugins = browser && browser.plugins;
	        return [+new Date(), global, plugins, global.screen, tostring(pool)];
	      }
	    } //
	    // tostring()
	    // Converts an array of charcodes to a string
	    //


	    function tostring(a) {
	      return String.fromCharCode.apply(0, a);
	    } //
	    // When seedrandom.js is loaded, we immediately mix a few bits
	    // from the built-in RNG into the entropy pool.  Because we do
	    // not want to interfere with deterministic PRNG state later,
	    // seedrandom will not call math.random on its own again after
	    // initialization.
	    //


	    mixkey(math.random(), pool); //
	    // Nodejs and AMD support: export the implementation as a module using
	    // either convention.
	    //
	    // End anonymous scope, and pass initial values.
	  }

	  function initialize$2(BMMath) {
	    seedRandom([], BMMath);
	  }

	  var propTypes = {
	    SHAPE: 'shape'
	  };

	  function _typeof$1(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$1 = function _typeof(obj) { return typeof obj; }; } else { _typeof$1 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$1(obj); }

	  var ExpressionManager = function () {

	    var ob = {};
	    var Math = BMMath;
	    var window = null;
	    var document = null;
	    var XMLHttpRequest = null;
	    var fetch = null;
	    var frames = null;
	    var _lottieGlobal = {};
	    initialize$2(BMMath);

	    function resetFrame() {
	      _lottieGlobal = {};
	    }

	    function $bm_isInstanceOfArray(arr) {
	      return arr.constructor === Array || arr.constructor === Float32Array;
	    }

	    function isNumerable(tOfV, v) {
	      return tOfV === 'number' || v instanceof Number || tOfV === 'boolean' || tOfV === 'string';
	    }

	    function $bm_neg(a) {
	      var tOfA = _typeof$1(a);

	      if (tOfA === 'number' || a instanceof Number || tOfA === 'boolean') {
	        return -a;
	      }

	      if ($bm_isInstanceOfArray(a)) {
	        var i;
	        var lenA = a.length;
	        var retArr = [];

	        for (i = 0; i < lenA; i += 1) {
	          retArr[i] = -a[i];
	        }

	        return retArr;
	      }

	      if (a.propType) {
	        return a.v;
	      }

	      return -a;
	    }

	    var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, 'easeIn').get;
	    var easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, 'easeOut').get;
	    var easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, 'easeInOut').get;

	    function sum(a, b) {
	      var tOfA = _typeof$1(a);

	      var tOfB = _typeof$1(b);

	      if (isNumerable(tOfA, a) && isNumerable(tOfB, b) || tOfA === 'string' || tOfB === 'string') {
	        return a + b;
	      }

	      if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
	        a = a.slice(0);
	        a[0] += b;
	        return a;
	      }

	      if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
	        b = b.slice(0);
	        b[0] = a + b[0];
	        return b;
	      }

	      if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
	        var i = 0;
	        var lenA = a.length;
	        var lenB = b.length;
	        var retArr = [];

	        while (i < lenA || i < lenB) {
	          if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) {
	            retArr[i] = a[i] + b[i];
	          } else {
	            retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
	          }

	          i += 1;
	        }

	        return retArr;
	      }

	      return 0;
	    }

	    var add = sum;

	    function sub(a, b) {
	      var tOfA = _typeof$1(a);

	      var tOfB = _typeof$1(b);

	      if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
	        if (tOfA === 'string') {
	          a = parseInt(a, 10);
	        }

	        if (tOfB === 'string') {
	          b = parseInt(b, 10);
	        }

	        return a - b;
	      }

	      if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
	        a = a.slice(0);
	        a[0] -= b;
	        return a;
	      }

	      if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
	        b = b.slice(0);
	        b[0] = a - b[0];
	        return b;
	      }

	      if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
	        var i = 0;
	        var lenA = a.length;
	        var lenB = b.length;
	        var retArr = [];

	        while (i < lenA || i < lenB) {
	          if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) {
	            retArr[i] = a[i] - b[i];
	          } else {
	            retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
	          }

	          i += 1;
	        }

	        return retArr;
	      }

	      return 0;
	    }

	    function mul(a, b) {
	      var tOfA = _typeof$1(a);

	      var tOfB = _typeof$1(b);

	      var arr;

	      if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
	        return a * b;
	      }

	      var i;
	      var len;

	      if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
	        len = a.length;
	        arr = createTypedArray('float32', len);

	        for (i = 0; i < len; i += 1) {
	          arr[i] = a[i] * b;
	        }

	        return arr;
	      }

	      if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
	        len = b.length;
	        arr = createTypedArray('float32', len);

	        for (i = 0; i < len; i += 1) {
	          arr[i] = a * b[i];
	        }

	        return arr;
	      }

	      return 0;
	    }

	    function div(a, b) {
	      var tOfA = _typeof$1(a);

	      var tOfB = _typeof$1(b);

	      var arr;

	      if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
	        return a / b;
	      }

	      var i;
	      var len;

	      if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
	        len = a.length;
	        arr = createTypedArray('float32', len);

	        for (i = 0; i < len; i += 1) {
	          arr[i] = a[i] / b;
	        }

	        return arr;
	      }

	      if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
	        len = b.length;
	        arr = createTypedArray('float32', len);

	        for (i = 0; i < len; i += 1) {
	          arr[i] = a / b[i];
	        }

	        return arr;
	      }

	      return 0;
	    }

	    function mod(a, b) {
	      if (typeof a === 'string') {
	        a = parseInt(a, 10);
	      }

	      if (typeof b === 'string') {
	        b = parseInt(b, 10);
	      }

	      return a % b;
	    }

	    var $bm_sum = sum;
	    var $bm_sub = sub;
	    var $bm_mul = mul;
	    var $bm_div = div;
	    var $bm_mod = mod;

	    function clamp(num, min, max) {
	      if (min > max) {
	        var mm = max;
	        max = min;
	        min = mm;
	      }

	      return Math.min(Math.max(num, min), max);
	    }

	    function radiansToDegrees(val) {
	      return val / degToRads;
	    }

	    var radians_to_degrees = radiansToDegrees;

	    function degreesToRadians(val) {
	      return val * degToRads;
	    }

	    var degrees_to_radians = radiansToDegrees;
	    var helperLengthArray = [0, 0, 0, 0, 0, 0];

	    function length(arr1, arr2) {
	      if (typeof arr1 === 'number' || arr1 instanceof Number) {
	        arr2 = arr2 || 0;
	        return Math.abs(arr1 - arr2);
	      }

	      if (!arr2) {
	        arr2 = helperLengthArray;
	      }

	      var i;
	      var len = Math.min(arr1.length, arr2.length);
	      var addedLength = 0;

	      for (i = 0; i < len; i += 1) {
	        addedLength += Math.pow(arr2[i] - arr1[i], 2);
	      }

	      return Math.sqrt(addedLength);
	    }

	    function normalize(vec) {
	      return div(vec, length(vec));
	    }

	    function rgbToHsl(val) {
	      var r = val[0];
	      var g = val[1];
	      var b = val[2];
	      var max = Math.max(r, g, b);
	      var min = Math.min(r, g, b);
	      var h;
	      var s;
	      var l = (max + min) / 2;

	      if (max === min) {
	        h = 0; // achromatic

	        s = 0; // achromatic
	      } else {
	        var d = max - min;
	        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

	        switch (max) {
	          case r:
	            h = (g - b) / d + (g < b ? 6 : 0);
	            break;

	          case g:
	            h = (b - r) / d + 2;
	            break;

	          case b:
	            h = (r - g) / d + 4;
	            break;
	        }

	        h /= 6;
	      }

	      return [h, s, l, val[3]];
	    }

	    function hue2rgb(p, q, t) {
	      if (t < 0) t += 1;
	      if (t > 1) t -= 1;
	      if (t < 1 / 6) return p + (q - p) * 6 * t;
	      if (t < 1 / 2) return q;
	      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
	      return p;
	    }

	    function hslToRgb(val) {
	      var h = val[0];
	      var s = val[1];
	      var l = val[2];
	      var r;
	      var g;
	      var b;

	      if (s === 0) {
	        r = l; // achromatic

	        b = l; // achromatic

	        g = l; // achromatic
	      } else {
	        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	        var p = 2 * l - q;
	        r = hue2rgb(p, q, h + 1 / 3);
	        g = hue2rgb(p, q, h);
	        b = hue2rgb(p, q, h - 1 / 3);
	      }

	      return [r, g, b, val[3]];
	    }

	    function linear(t, tMin, tMax, value1, value2) {
	      if (value1 === undefined || value2 === undefined) {
	        value1 = tMin;
	        value2 = tMax;
	        tMin = 0;
	        tMax = 1;
	      }

	      if (tMax < tMin) {
	        var _tMin = tMax;
	        tMax = tMin;
	        tMin = _tMin;
	      }

	      if (t <= tMin) {
	        return value1;
	      }

	      if (t >= tMax) {
	        return value2;
	      }

	      var perc = tMax === tMin ? 0 : (t - tMin) / (tMax - tMin);

	      if (!value1.length) {
	        return value1 + (value2 - value1) * perc;
	      }

	      var i;
	      var len = value1.length;
	      var arr = createTypedArray('float32', len);

	      for (i = 0; i < len; i += 1) {
	        arr[i] = value1[i] + (value2[i] - value1[i]) * perc;
	      }

	      return arr;
	    }

	    function random(min, max) {
	      if (max === undefined) {
	        if (min === undefined) {
	          min = 0;
	          max = 1;
	        } else {
	          max = min;
	          min = undefined;
	        }
	      }

	      if (max.length) {
	        var i;
	        var len = max.length;

	        if (!min) {
	          min = createTypedArray('float32', len);
	        }

	        var arr = createTypedArray('float32', len);
	        var rnd = BMMath.random();

	        for (i = 0; i < len; i += 1) {
	          arr[i] = min[i] + rnd * (max[i] - min[i]);
	        }

	        return arr;
	      }

	      if (min === undefined) {
	        min = 0;
	      }

	      var rndm = BMMath.random();
	      return min + rndm * (max - min);
	    }

	    function createPath(points, inTangents, outTangents, closed) {
	      var i;
	      var len = points.length;
	      var path = shapePool.newElement();
	      path.setPathData(!!closed, len);
	      var arrPlaceholder = [0, 0];
	      var inVertexPoint;
	      var outVertexPoint;

	      for (i = 0; i < len; i += 1) {
	        inVertexPoint = inTangents && inTangents[i] ? inTangents[i] : arrPlaceholder;
	        outVertexPoint = outTangents && outTangents[i] ? outTangents[i] : arrPlaceholder;
	        path.setTripleAt(points[i][0], points[i][1], outVertexPoint[0] + points[i][0], outVertexPoint[1] + points[i][1], inVertexPoint[0] + points[i][0], inVertexPoint[1] + points[i][1], i, true);
	      }

	      return path;
	    }

	    function initiateExpression(elem, data, property) {
	      // Bail out if we don't want expressions
	      function noOp(_value) {
	        return _value;
	      }

	      if (!elem.globalData.renderConfig.runExpressions) {
	        return noOp;
	      }

	      var val = data.x;
	      var needsVelocity = /velocity(?![\w\d])/.test(val);

	      var _needsRandom = val.indexOf('random') !== -1;

	      var elemType = elem.data.ty;
	      var transform;
	      var $bm_transform;
	      var content;
	      var effect;
	      var thisProperty = property;
	      thisProperty.valueAtTime = thisProperty.getValueAtTime;
	      Object.defineProperty(thisProperty, 'value', {
	        get: function get() {
	          return thisProperty.v;
	        }
	      });
	      elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate;
	      elem.comp.displayStartTime = 0;
	      var inPoint = elem.data.ip / elem.comp.globalData.frameRate;
	      var outPoint = elem.data.op / elem.comp.globalData.frameRate;
	      var width = elem.data.sw ? elem.data.sw : 0;
	      var height = elem.data.sh ? elem.data.sh : 0;
	      var name = elem.data.nm;
	      var loopIn;
	      var loop_in;
	      var loopOut;
	      var loop_out;
	      var smooth;
	      var toWorld;
	      var fromWorld;
	      var fromComp;
	      var toComp;
	      var fromCompToSurface;
	      var position;
	      var rotation;
	      var anchorPoint;
	      var scale;
	      var thisLayer;
	      var thisComp;
	      var mask;
	      var valueAtTime;
	      var velocityAtTime;
	      var scoped_bm_rt; // val = val.replace(/(\\?"|')((http)(s)?(:\/))?\/.*?(\\?"|')/g, "\"\""); // deter potential network calls

	      var expression_function = eval('[function _expression_function(){' + val + ';scoped_bm_rt=$bm_rt}]')[0]; // eslint-disable-line no-eval

	      var numKeys = property.kf ? data.k.length : 0;
	      var active = !this.data || this.data.hd !== true;

	      var wiggle = function wiggle(freq, amp) {
	        var iWiggle;
	        var j;
	        var lenWiggle = this.pv.length ? this.pv.length : 1;
	        var addedAmps = createTypedArray('float32', lenWiggle);
	        freq = 5;
	        var iterations = Math.floor(time * freq);
	        iWiggle = 0;
	        j = 0;

	        while (iWiggle < iterations) {
	          // var rnd = BMMath.random();
	          for (j = 0; j < lenWiggle; j += 1) {
	            addedAmps[j] += -amp + amp * 2 * BMMath.random(); // addedAmps[j] += -amp + amp*2*rnd;
	          }

	          iWiggle += 1;
	        } // var rnd2 = BMMath.random();


	        var periods = time * freq;
	        var perc = periods - Math.floor(periods);
	        var arr = createTypedArray('float32', lenWiggle);

	        if (lenWiggle > 1) {
	          for (j = 0; j < lenWiggle; j += 1) {
	            arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp * 2 * BMMath.random()) * perc; // arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
	            // arr[i] = this.pv[i] + addedAmp + amp1*perc + amp2*(1-perc);
	          }

	          return arr;
	        }

	        return this.pv + addedAmps[0] + (-amp + amp * 2 * BMMath.random()) * perc;
	      }.bind(this);

	      if (thisProperty.loopIn) {
	        loopIn = thisProperty.loopIn.bind(thisProperty);
	        loop_in = loopIn;
	      }

	      if (thisProperty.loopOut) {
	        loopOut = thisProperty.loopOut.bind(thisProperty);
	        loop_out = loopOut;
	      }

	      if (thisProperty.smooth) {
	        smooth = thisProperty.smooth.bind(thisProperty);
	      }

	      function loopInDuration(type, duration) {
	        return loopIn(type, duration, true);
	      }

	      function loopOutDuration(type, duration) {
	        return loopOut(type, duration, true);
	      }

	      if (this.getValueAtTime) {
	        valueAtTime = this.getValueAtTime.bind(this);
	      }

	      if (this.getVelocityAtTime) {
	        velocityAtTime = this.getVelocityAtTime.bind(this);
	      }

	      var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);

	      function lookAt(elem1, elem2) {
	        var fVec = [elem2[0] - elem1[0], elem2[1] - elem1[1], elem2[2] - elem1[2]];
	        var pitch = Math.atan2(fVec[0], Math.sqrt(fVec[1] * fVec[1] + fVec[2] * fVec[2])) / degToRads;
	        var yaw = -Math.atan2(fVec[1], fVec[2]) / degToRads;
	        return [yaw, pitch, 0];
	      }

	      function easeOut(t, tMin, tMax, val1, val2) {
	        return applyEase(easeOutBez, t, tMin, tMax, val1, val2);
	      }

	      function easeIn(t, tMin, tMax, val1, val2) {
	        return applyEase(easeInBez, t, tMin, tMax, val1, val2);
	      }

	      function ease(t, tMin, tMax, val1, val2) {
	        return applyEase(easeInOutBez, t, tMin, tMax, val1, val2);
	      }

	      function applyEase(fn, t, tMin, tMax, val1, val2) {
	        if (val1 === undefined) {
	          val1 = tMin;
	          val2 = tMax;
	        } else {
	          t = (t - tMin) / (tMax - tMin);
	        }

	        if (t > 1) {
	          t = 1;
	        } else if (t < 0) {
	          t = 0;
	        }

	        var mult = fn(t);

	        if ($bm_isInstanceOfArray(val1)) {
	          var iKey;
	          var lenKey = val1.length;
	          var arr = createTypedArray('float32', lenKey);

	          for (iKey = 0; iKey < lenKey; iKey += 1) {
	            arr[iKey] = (val2[iKey] - val1[iKey]) * mult + val1[iKey];
	          }

	          return arr;
	        }

	        return (val2 - val1) * mult + val1;
	      }

	      function nearestKey(time) {
	        var iKey;
	        var lenKey = data.k.length;
	        var index;
	        var keyTime;

	        if (!data.k.length || typeof data.k[0] === 'number') {
	          index = 0;
	          keyTime = 0;
	        } else {
	          index = -1;
	          time *= elem.comp.globalData.frameRate;

	          if (time < data.k[0].t) {
	            index = 1;
	            keyTime = data.k[0].t;
	          } else {
	            for (iKey = 0; iKey < lenKey - 1; iKey += 1) {
	              if (time === data.k[iKey].t) {
	                index = iKey + 1;
	                keyTime = data.k[iKey].t;
	                break;
	              } else if (time > data.k[iKey].t && time < data.k[iKey + 1].t) {
	                if (time - data.k[iKey].t > data.k[iKey + 1].t - time) {
	                  index = iKey + 2;
	                  keyTime = data.k[iKey + 1].t;
	                } else {
	                  index = iKey + 1;
	                  keyTime = data.k[iKey].t;
	                }

	                break;
	              }
	            }

	            if (index === -1) {
	              index = iKey + 1;
	              keyTime = data.k[iKey].t;
	            }
	          }
	        }

	        var obKey = {};
	        obKey.index = index;
	        obKey.time = keyTime / elem.comp.globalData.frameRate;
	        return obKey;
	      }

	      function key(ind) {
	        var obKey;
	        var iKey;
	        var lenKey;

	        if (!data.k.length || typeof data.k[0] === 'number') {
	          throw new Error('The property has no keyframe at index ' + ind);
	        }

	        ind -= 1;
	        obKey = {
	          time: data.k[ind].t / elem.comp.globalData.frameRate,
	          value: []
	        };
	        var arr = Object.prototype.hasOwnProperty.call(data.k[ind], 's') ? data.k[ind].s : data.k[ind - 1].e;
	        lenKey = arr.length;

	        for (iKey = 0; iKey < lenKey; iKey += 1) {
	          obKey[iKey] = arr[iKey];
	          obKey.value[iKey] = arr[iKey];
	        }

	        return obKey;
	      }

	      function framesToTime(fr, fps) {
	        if (!fps) {
	          fps = elem.comp.globalData.frameRate;
	        }

	        return fr / fps;
	      }

	      function timeToFrames(t, fps) {
	        if (!t && t !== 0) {
	          t = time;
	        }

	        if (!fps) {
	          fps = elem.comp.globalData.frameRate;
	        }

	        return t * fps;
	      }

	      function seedRandom(seed) {
	        BMMath.seedrandom(randSeed + seed);
	      }

	      function sourceRectAtTime() {
	        return elem.sourceRectAtTime();
	      }

	      function substring(init, end) {
	        if (typeof value === 'string') {
	          if (end === undefined) {
	            return value.substring(init);
	          }

	          return value.substring(init, end);
	        }

	        return '';
	      }

	      function substr(init, end) {
	        if (typeof value === 'string') {
	          if (end === undefined) {
	            return value.substr(init);
	          }

	          return value.substr(init, end);
	        }

	        return '';
	      }

	      function posterizeTime(framesPerSecond) {
	        time = framesPerSecond === 0 ? 0 : Math.floor(time * framesPerSecond) / framesPerSecond;
	        value = valueAtTime(time);
	      }

	      var time;
	      var velocity;
	      var value;
	      var text;
	      var textIndex;
	      var textTotal;
	      var selectorValue;
	      var index = elem.data.ind;
	      var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
	      var parent;
	      var randSeed = Math.floor(Math.random() * 1000000);
	      var globalData = elem.globalData;

	      function executeExpression(_value) {
	        // globalData.pushExpression();
	        value = _value;

	        if (this.frameExpressionId === elem.globalData.frameId && this.propType !== 'textSelector') {
	          return value;
	        }

	        if (this.propType === 'textSelector') {
	          textIndex = this.textIndex;
	          textTotal = this.textTotal;
	          selectorValue = this.selectorValue;
	        }

	        if (!thisLayer) {
	          text = elem.layerInterface.text;
	          thisLayer = elem.layerInterface;
	          thisComp = elem.comp.compInterface;
	          toWorld = thisLayer.toWorld.bind(thisLayer);
	          fromWorld = thisLayer.fromWorld.bind(thisLayer);
	          fromComp = thisLayer.fromComp.bind(thisLayer);
	          toComp = thisLayer.toComp.bind(thisLayer);
	          mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null;
	          fromCompToSurface = fromComp;
	        }

	        if (!transform) {
	          transform = elem.layerInterface('ADBE Transform Group');
	          $bm_transform = transform;

	          if (transform) {
	            anchorPoint = transform.anchorPoint;
	            /* position = transform.position;
	                      rotation = transform.rotation;
	                      scale = transform.scale; */
	          }
	        }

	        if (elemType === 4 && !content) {
	          content = thisLayer('ADBE Root Vectors Group');
	        }

	        if (!effect) {
	          effect = thisLayer(4);
	        }

	        hasParent = !!(elem.hierarchy && elem.hierarchy.length);

	        if (hasParent && !parent) {
	          parent = elem.hierarchy[0].layerInterface;
	        }

	        time = this.comp.renderedFrame / this.comp.globalData.frameRate;

	        if (_needsRandom) {
	          seedRandom(randSeed + time);
	        }

	        if (needsVelocity) {
	          velocity = velocityAtTime(time);
	        }

	        expression_function();
	        this.frameExpressionId = elem.globalData.frameId; // TODO: Check if it's possible to return on ShapeInterface the .v value
	        // Changed this to a ternary operation because Rollup failed compiling it correctly

	        scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt;
	        return scoped_bm_rt;
	      } // Bundlers will see these as dead code and unless we reference them


	      executeExpression.__preventDeadCodeRemoval = [$bm_transform, anchorPoint, time, velocity, inPoint, outPoint, width, height, name, loop_in, loop_out, smooth, toComp, fromCompToSurface, toWorld, fromWorld, mask, position, rotation, scale, thisComp, numKeys, active, wiggle, loopInDuration, loopOutDuration, comp, lookAt, easeOut, easeIn, ease, nearestKey, key, text, textIndex, textTotal, selectorValue, framesToTime, timeToFrames, sourceRectAtTime, substring, substr, posterizeTime, index, globalData];
	      return executeExpression;
	    }

	    ob.initiateExpression = initiateExpression;
	    ob.__preventDeadCodeRemoval = [window, document, XMLHttpRequest, fetch, frames, $bm_neg, add, $bm_sum, $bm_sub, $bm_mul, $bm_div, $bm_mod, clamp, radians_to_degrees, degreesToRadians, degrees_to_radians, normalize, rgbToHsl, hslToRgb, linear, random, createPath, _lottieGlobal];
	    ob.resetFrame = resetFrame;
	    return ob;
	  }();

	  var Expressions = function () {
	    var ob = {};
	    ob.initExpressions = initExpressions;
	    ob.resetFrame = ExpressionManager.resetFrame;

	    function initExpressions(animation) {
	      var stackCount = 0;
	      var registers = [];

	      function pushExpression() {
	        stackCount += 1;
	      }

	      function popExpression() {
	        stackCount -= 1;

	        if (stackCount === 0) {
	          releaseInstances();
	        }
	      }

	      function registerExpressionProperty(expression) {
	        if (registers.indexOf(expression) === -1) {
	          registers.push(expression);
	        }
	      }

	      function releaseInstances() {
	        var i;
	        var len = registers.length;

	        for (i = 0; i < len; i += 1) {
	          registers[i].release();
	        }

	        registers.length = 0;
	      }

	      animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
	      animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
	      animation.renderer.globalData.pushExpression = pushExpression;
	      animation.renderer.globalData.popExpression = popExpression;
	      animation.renderer.globalData.registerExpressionProperty = registerExpressionProperty;
	    }

	    return ob;
	  }();

	  var MaskManagerInterface = function () {
	    function MaskInterface(mask, data) {
	      this._mask = mask;
	      this._data = data;
	    }

	    Object.defineProperty(MaskInterface.prototype, 'maskPath', {
	      get: function get() {
	        if (this._mask.prop.k) {
	          this._mask.prop.getValue();
	        }

	        return this._mask.prop;
	      }
	    });
	    Object.defineProperty(MaskInterface.prototype, 'maskOpacity', {
	      get: function get() {
	        if (this._mask.op.k) {
	          this._mask.op.getValue();
	        }

	        return this._mask.op.v * 100;
	      }
	    });

	    var MaskManager = function MaskManager(maskManager) {
	      var _masksInterfaces = createSizedArray(maskManager.viewData.length);

	      var i;
	      var len = maskManager.viewData.length;

	      for (i = 0; i < len; i += 1) {
	        _masksInterfaces[i] = new MaskInterface(maskManager.viewData[i], maskManager.masksProperties[i]);
	      }

	      var maskFunction = function maskFunction(name) {
	        i = 0;

	        while (i < len) {
	          if (maskManager.masksProperties[i].nm === name) {
	            return _masksInterfaces[i];
	          }

	          i += 1;
	        }

	        return null;
	      };

	      return maskFunction;
	    };

	    return MaskManager;
	  }();

	  var ExpressionPropertyInterface = function () {
	    var defaultUnidimensionalValue = {
	      pv: 0,
	      v: 0,
	      mult: 1
	    };
	    var defaultMultidimensionalValue = {
	      pv: [0, 0, 0],
	      v: [0, 0, 0],
	      mult: 1
	    };

	    function completeProperty(expressionValue, property, type) {
	      Object.defineProperty(expressionValue, 'velocity', {
	        get: function get() {
	          return property.getVelocityAtTime(property.comp.currentFrame);
	        }
	      });
	      expressionValue.numKeys = property.keyframes ? property.keyframes.length : 0;

	      expressionValue.key = function (pos) {
	        if (!expressionValue.numKeys) {
	          return 0;
	        }

	        var value = '';

	        if ('s' in property.keyframes[pos - 1]) {
	          value = property.keyframes[pos - 1].s;
	        } else if ('e' in property.keyframes[pos - 2]) {
	          value = property.keyframes[pos - 2].e;
	        } else {
	          value = property.keyframes[pos - 2].s;
	        }

	        var valueProp = type === 'unidimensional' ? new Number(value) : Object.assign({}, value); // eslint-disable-line no-new-wrappers

	        valueProp.time = property.keyframes[pos - 1].t / property.elem.comp.globalData.frameRate;
	        valueProp.value = type === 'unidimensional' ? value[0] : value;
	        return valueProp;
	      };

	      expressionValue.valueAtTime = property.getValueAtTime;
	      expressionValue.speedAtTime = property.getSpeedAtTime;
	      expressionValue.velocityAtTime = property.getVelocityAtTime;
	      expressionValue.propertyGroup = property.propertyGroup;
	    }

	    function UnidimensionalPropertyInterface(property) {
	      if (!property || !('pv' in property)) {
	        property = defaultUnidimensionalValue;
	      }

	      var mult = 1 / property.mult;
	      var val = property.pv * mult;
	      var expressionValue = new Number(val); // eslint-disable-line no-new-wrappers

	      expressionValue.value = val;
	      completeProperty(expressionValue, property, 'unidimensional');
	      return function () {
	        if (property.k) {
	          property.getValue();
	        }

	        val = property.v * mult;

	        if (expressionValue.value !== val) {
	          expressionValue = new Number(val); // eslint-disable-line no-new-wrappers

	          expressionValue.value = val;
	          completeProperty(expressionValue, property, 'unidimensional');
	        }

	        return expressionValue;
	      };
	    }

	    function MultidimensionalPropertyInterface(property) {
	      if (!property || !('pv' in property)) {
	        property = defaultMultidimensionalValue;
	      }

	      var mult = 1 / property.mult;
	      var len = property.data && property.data.l || property.pv.length;
	      var expressionValue = createTypedArray('float32', len);
	      var arrValue = createTypedArray('float32', len);
	      expressionValue.value = arrValue;
	      completeProperty(expressionValue, property, 'multidimensional');
	      return function () {
	        if (property.k) {
	          property.getValue();
	        }

	        for (var i = 0; i < len; i += 1) {
	          arrValue[i] = property.v[i] * mult;
	          expressionValue[i] = arrValue[i];
	        }

	        return expressionValue;
	      };
	    } // TODO: try to avoid using this getter


	    function defaultGetter() {
	      return defaultUnidimensionalValue;
	    }

	    return function (property) {
	      if (!property) {
	        return defaultGetter;
	      }

	      if (property.propType === 'unidimensional') {
	        return UnidimensionalPropertyInterface(property);
	      }

	      return MultidimensionalPropertyInterface(property);
	    };
	  }();

	  var TransformExpressionInterface = function () {
	    return function (transform) {
	      function _thisFunction(name) {
	        switch (name) {
	          case 'scale':
	          case 'Scale':
	          case 'ADBE Scale':
	          case 6:
	            return _thisFunction.scale;

	          case 'rotation':
	          case 'Rotation':
	          case 'ADBE Rotation':
	          case 'ADBE Rotate Z':
	          case 10:
	            return _thisFunction.rotation;

	          case 'ADBE Rotate X':
	            return _thisFunction.xRotation;

	          case 'ADBE Rotate Y':
	            return _thisFunction.yRotation;

	          case 'position':
	          case 'Position':
	          case 'ADBE Position':
	          case 2:
	            return _thisFunction.position;

	          case 'ADBE Position_0':
	            return _thisFunction.xPosition;

	          case 'ADBE Position_1':
	            return _thisFunction.yPosition;

	          case 'ADBE Position_2':
	            return _thisFunction.zPosition;

	          case 'anchorPoint':
	          case 'AnchorPoint':
	          case 'Anchor Point':
	          case 'ADBE AnchorPoint':
	          case 1:
	            return _thisFunction.anchorPoint;

	          case 'opacity':
	          case 'Opacity':
	          case 11:
	            return _thisFunction.opacity;

	          default:
	            return null;
	        }
	      }

	      Object.defineProperty(_thisFunction, 'rotation', {
	        get: ExpressionPropertyInterface(transform.r || transform.rz)
	      });
	      Object.defineProperty(_thisFunction, 'zRotation', {
	        get: ExpressionPropertyInterface(transform.rz || transform.r)
	      });
	      Object.defineProperty(_thisFunction, 'xRotation', {
	        get: ExpressionPropertyInterface(transform.rx)
	      });
	      Object.defineProperty(_thisFunction, 'yRotation', {
	        get: ExpressionPropertyInterface(transform.ry)
	      });
	      Object.defineProperty(_thisFunction, 'scale', {
	        get: ExpressionPropertyInterface(transform.s)
	      });

	      var _px;

	      var _py;

	      var _pz;

	      var _transformFactory;

	      if (transform.p) {
	        _transformFactory = ExpressionPropertyInterface(transform.p);
	      } else {
	        _px = ExpressionPropertyInterface(transform.px);
	        _py = ExpressionPropertyInterface(transform.py);

	        if (transform.pz) {
	          _pz = ExpressionPropertyInterface(transform.pz);
	        }
	      }

	      Object.defineProperty(_thisFunction, 'position', {
	        get: function get() {
	          if (transform.p) {
	            return _transformFactory();
	          }

	          return [_px(), _py(), _pz ? _pz() : 0];
	        }
	      });
	      Object.defineProperty(_thisFunction, 'xPosition', {
	        get: ExpressionPropertyInterface(transform.px)
	      });
	      Object.defineProperty(_thisFunction, 'yPosition', {
	        get: ExpressionPropertyInterface(transform.py)
	      });
	      Object.defineProperty(_thisFunction, 'zPosition', {
	        get: ExpressionPropertyInterface(transform.pz)
	      });
	      Object.defineProperty(_thisFunction, 'anchorPoint', {
	        get: ExpressionPropertyInterface(transform.a)
	      });
	      Object.defineProperty(_thisFunction, 'opacity', {
	        get: ExpressionPropertyInterface(transform.o)
	      });
	      Object.defineProperty(_thisFunction, 'skew', {
	        get: ExpressionPropertyInterface(transform.sk)
	      });
	      Object.defineProperty(_thisFunction, 'skewAxis', {
	        get: ExpressionPropertyInterface(transform.sa)
	      });
	      Object.defineProperty(_thisFunction, 'orientation', {
	        get: ExpressionPropertyInterface(transform.or)
	      });
	      return _thisFunction;
	    };
	  }();

	  var LayerExpressionInterface = function () {
	    function getMatrix(time) {
	      var toWorldMat = new Matrix();

	      if (time !== undefined) {
	        var propMatrix = this._elem.finalTransform.mProp.getValueAtTime(time);

	        propMatrix.clone(toWorldMat);
	      } else {
	        var transformMat = this._elem.finalTransform.mProp;
	        transformMat.applyToMatrix(toWorldMat);
	      }

	      return toWorldMat;
	    }

	    function toWorldVec(arr, time) {
	      var toWorldMat = this.getMatrix(time);
	      toWorldMat.props[12] = 0;
	      toWorldMat.props[13] = 0;
	      toWorldMat.props[14] = 0;
	      return this.applyPoint(toWorldMat, arr);
	    }

	    function toWorld(arr, time) {
	      var toWorldMat = this.getMatrix(time);
	      return this.applyPoint(toWorldMat, arr);
	    }

	    function fromWorldVec(arr, time) {
	      var toWorldMat = this.getMatrix(time);
	      toWorldMat.props[12] = 0;
	      toWorldMat.props[13] = 0;
	      toWorldMat.props[14] = 0;
	      return this.invertPoint(toWorldMat, arr);
	    }

	    function fromWorld(arr, time) {
	      var toWorldMat = this.getMatrix(time);
	      return this.invertPoint(toWorldMat, arr);
	    }

	    function applyPoint(matrix, arr) {
	      if (this._elem.hierarchy && this._elem.hierarchy.length) {
	        var i;
	        var len = this._elem.hierarchy.length;

	        for (i = 0; i < len; i += 1) {
	          this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
	        }
	      }

	      return matrix.applyToPointArray(arr[0], arr[1], arr[2] || 0);
	    }

	    function invertPoint(matrix, arr) {
	      if (this._elem.hierarchy && this._elem.hierarchy.length) {
	        var i;
	        var len = this._elem.hierarchy.length;

	        for (i = 0; i < len; i += 1) {
	          this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
	        }
	      }

	      return matrix.inversePoint(arr);
	    }

	    function fromComp(arr) {
	      var toWorldMat = new Matrix();
	      toWorldMat.reset();

	      this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);

	      if (this._elem.hierarchy && this._elem.hierarchy.length) {
	        var i;
	        var len = this._elem.hierarchy.length;

	        for (i = 0; i < len; i += 1) {
	          this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
	        }

	        return toWorldMat.inversePoint(arr);
	      }

	      return toWorldMat.inversePoint(arr);
	    }

	    function sampleImage() {
	      return [1, 1, 1, 1];
	    }

	    return function (elem) {
	      var transformInterface;

	      function _registerMaskInterface(maskManager) {
	        _thisLayerFunction.mask = new MaskManagerInterface(maskManager, elem);
	      }

	      function _registerEffectsInterface(effects) {
	        _thisLayerFunction.effect = effects;
	      }

	      function _thisLayerFunction(name) {
	        switch (name) {
	          case 'ADBE Root Vectors Group':
	          case 'Contents':
	          case 2:
	            return _thisLayerFunction.shapeInterface;

	          case 1:
	          case 6:
	          case 'Transform':
	          case 'transform':
	          case 'ADBE Transform Group':
	            return transformInterface;

	          case 4:
	          case 'ADBE Effect Parade':
	          case 'effects':
	          case 'Effects':
	            return _thisLayerFunction.effect;

	          case 'ADBE Text Properties':
	            return _thisLayerFunction.textInterface;

	          default:
	            return null;
	        }
	      }

	      _thisLayerFunction.getMatrix = getMatrix;
	      _thisLayerFunction.invertPoint = invertPoint;
	      _thisLayerFunction.applyPoint = applyPoint;
	      _thisLayerFunction.toWorld = toWorld;
	      _thisLayerFunction.toWorldVec = toWorldVec;
	      _thisLayerFunction.fromWorld = fromWorld;
	      _thisLayerFunction.fromWorldVec = fromWorldVec;
	      _thisLayerFunction.toComp = toWorld;
	      _thisLayerFunction.fromComp = fromComp;
	      _thisLayerFunction.sampleImage = sampleImage;
	      _thisLayerFunction.sourceRectAtTime = elem.sourceRectAtTime.bind(elem);
	      _thisLayerFunction._elem = elem;
	      transformInterface = TransformExpressionInterface(elem.finalTransform.mProp);
	      var anchorPointDescriptor = getDescriptor(transformInterface, 'anchorPoint');
	      Object.defineProperties(_thisLayerFunction, {
	        hasParent: {
	          get: function get() {
	            return elem.hierarchy.length;
	          }
	        },
	        parent: {
	          get: function get() {
	            return elem.hierarchy[0].layerInterface;
	          }
	        },
	        rotation: getDescriptor(transformInterface, 'rotation'),
	        scale: getDescriptor(transformInterface, 'scale'),
	        position: getDescriptor(transformInterface, 'position'),
	        opacity: getDescriptor(transformInterface, 'opacity'),
	        anchorPoint: anchorPointDescriptor,
	        anchor_point: anchorPointDescriptor,
	        transform: {
	          get: function get() {
	            return transformInterface;
	          }
	        },
	        active: {
	          get: function get() {
	            return elem.isInRange;
	          }
	        }
	      });
	      _thisLayerFunction.startTime = elem.data.st;
	      _thisLayerFunction.index = elem.data.ind;
	      _thisLayerFunction.source = elem.data.refId;
	      _thisLayerFunction.height = elem.data.ty === 0 ? elem.data.h : 100;
	      _thisLayerFunction.width = elem.data.ty === 0 ? elem.data.w : 100;
	      _thisLayerFunction.inPoint = elem.data.ip / elem.comp.globalData.frameRate;
	      _thisLayerFunction.outPoint = elem.data.op / elem.comp.globalData.frameRate;
	      _thisLayerFunction._name = elem.data.nm;
	      _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
	      _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
	      return _thisLayerFunction;
	    };
	  }();

	  var propertyGroupFactory = function () {
	    return function (interfaceFunction, parentPropertyGroup) {
	      return function (val) {
	        val = val === undefined ? 1 : val;

	        if (val <= 0) {
	          return interfaceFunction;
	        }

	        return parentPropertyGroup(val - 1);
	      };
	    };
	  }();

	  var PropertyInterface = function () {
	    return function (propertyName, propertyGroup) {
	      var interfaceFunction = {
	        _name: propertyName
	      };

	      function _propertyGroup(val) {
	        val = val === undefined ? 1 : val;

	        if (val <= 0) {
	          return interfaceFunction;
	        }

	        return propertyGroup(val - 1);
	      }

	      return _propertyGroup;
	    };
	  }();

	  var EffectsExpressionInterface = function () {
	    var ob = {
	      createEffectsInterface: createEffectsInterface
	    };

	    function createEffectsInterface(elem, propertyGroup) {
	      if (elem.effectsManager) {
	        var effectElements = [];
	        var effectsData = elem.data.ef;
	        var i;
	        var len = elem.effectsManager.effectElements.length;

	        for (i = 0; i < len; i += 1) {
	          effectElements.push(createGroupInterface(effectsData[i], elem.effectsManager.effectElements[i], propertyGroup, elem));
	        }

	        var effects = elem.data.ef || [];

	        var groupInterface = function groupInterface(name) {
	          i = 0;
	          len = effects.length;

	          while (i < len) {
	            if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
	              return effectElements[i];
	            }

	            i += 1;
	          }

	          return null;
	        };

	        Object.defineProperty(groupInterface, 'numProperties', {
	          get: function get() {
	            return effects.length;
	          }
	        });
	        return groupInterface;
	      }

	      return null;
	    }

	    function createGroupInterface(data, elements, propertyGroup, elem) {
	      function groupInterface(name) {
	        var effects = data.ef;
	        var i = 0;
	        var len = effects.length;

	        while (i < len) {
	          if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
	            if (effects[i].ty === 5) {
	              return effectElements[i];
	            }

	            return effectElements[i]();
	          }

	          i += 1;
	        }

	        throw new Error();
	      }

	      var _propertyGroup = propertyGroupFactory(groupInterface, propertyGroup);

	      var effectElements = [];
	      var i;
	      var len = data.ef.length;

	      for (i = 0; i < len; i += 1) {
	        if (data.ef[i].ty === 5) {
	          effectElements.push(createGroupInterface(data.ef[i], elements.effectElements[i], elements.effectElements[i].propertyGroup, elem));
	        } else {
	          effectElements.push(createValueInterface(elements.effectElements[i], data.ef[i].ty, elem, _propertyGroup));
	        }
	      }

	      if (data.mn === 'ADBE Color Control') {
	        Object.defineProperty(groupInterface, 'color', {
	          get: function get() {
	            return effectElements[0]();
	          }
	        });
	      }

	      Object.defineProperties(groupInterface, {
	        numProperties: {
	          get: function get() {
	            return data.np;
	          }
	        },
	        _name: {
	          value: data.nm
	        },
	        propertyGroup: {
	          value: _propertyGroup
	        }
	      });
	      groupInterface.enabled = data.en !== 0;
	      groupInterface.active = groupInterface.enabled;
	      return groupInterface;
	    }

	    function createValueInterface(element, type, elem, propertyGroup) {
	      var expressionProperty = ExpressionPropertyInterface(element.p);

	      function interfaceFunction() {
	        if (type === 10) {
	          return elem.comp.compInterface(element.p.v);
	        }

	        return expressionProperty();
	      }

	      if (element.p.setGroupProperty) {
	        element.p.setGroupProperty(PropertyInterface('', propertyGroup));
	      }

	      return interfaceFunction;
	    }

	    return ob;
	  }();

	  var ShapePathInterface = function () {
	    return function pathInterfaceFactory(shape, view, propertyGroup) {
	      var prop = view.sh;

	      function interfaceFunction(val) {
	        if (val === 'Shape' || val === 'shape' || val === 'Path' || val === 'path' || val === 'ADBE Vector Shape' || val === 2) {
	          return interfaceFunction.path;
	        }

	        return null;
	      }

	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

	      prop.setGroupProperty(PropertyInterface('Path', _propertyGroup));
	      Object.defineProperties(interfaceFunction, {
	        path: {
	          get: function get() {
	            if (prop.k) {
	              prop.getValue();
	            }

	            return prop;
	          }
	        },
	        shape: {
	          get: function get() {
	            if (prop.k) {
	              prop.getValue();
	            }

	            return prop;
	          }
	        },
	        _name: {
	          value: shape.nm
	        },
	        ix: {
	          value: shape.ix
	        },
	        propertyIndex: {
	          value: shape.ix
	        },
	        mn: {
	          value: shape.mn
	        },
	        propertyGroup: {
	          value: propertyGroup
	        }
	      });
	      return interfaceFunction;
	    };
	  }();

	  var ShapeExpressionInterface = function () {
	    function iterateElements(shapes, view, propertyGroup) {
	      var arr = [];
	      var i;
	      var len = shapes ? shapes.length : 0;

	      for (i = 0; i < len; i += 1) {
	        if (shapes[i].ty === 'gr') {
	          arr.push(groupInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'fl') {
	          arr.push(fillInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'st') {
	          arr.push(strokeInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'tm') {
	          arr.push(trimInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'tr') ; else if (shapes[i].ty === 'el') {
	          arr.push(ellipseInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'sr') {
	          arr.push(starInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'sh') {
	          arr.push(ShapePathInterface(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'rc') {
	          arr.push(rectInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'rd') {
	          arr.push(roundedInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'rp') {
	          arr.push(repeaterInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'gf') {
	          arr.push(gradientFillInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else {
	          arr.push(defaultInterfaceFactory(shapes[i], view[i]));
	        }
	      }

	      return arr;
	    }

	    function contentsInterfaceFactory(shape, view, propertyGroup) {
	      var interfaces;

	      var interfaceFunction = function _interfaceFunction(value) {
	        var i = 0;
	        var len = interfaces.length;

	        while (i < len) {
	          if (interfaces[i]._name === value || interfaces[i].mn === value || interfaces[i].propertyIndex === value || interfaces[i].ix === value || interfaces[i].ind === value) {
	            return interfaces[i];
	          }

	          i += 1;
	        }

	        if (typeof value === 'number') {
	          return interfaces[value - 1];
	        }

	        return null;
	      };

	      interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
	      interfaces = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
	      interfaceFunction.numProperties = interfaces.length;
	      var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
	      interfaceFunction.transform = transformInterface;
	      interfaceFunction.propertyIndex = shape.cix;
	      interfaceFunction._name = shape.nm;
	      return interfaceFunction;
	    }

	    function groupInterfaceFactory(shape, view, propertyGroup) {
	      var interfaceFunction = function _interfaceFunction(value) {
	        switch (value) {
	          case 'ADBE Vectors Group':
	          case 'Contents':
	          case 2:
	            return interfaceFunction.content;
	          // Not necessary for now. Keeping them here in case a new case appears
	          // case 'ADBE Vector Transform Group':
	          // case 3:

	          default:
	            return interfaceFunction.transform;
	        }
	      };

	      interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
	      var content = contentsInterfaceFactory(shape, view, interfaceFunction.propertyGroup);
	      var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
	      interfaceFunction.content = content;
	      interfaceFunction.transform = transformInterface;
	      Object.defineProperty(interfaceFunction, '_name', {
	        get: function get() {
	          return shape.nm;
	        }
	      }); // interfaceFunction.content = interfaceFunction;

	      interfaceFunction.numProperties = shape.np;
	      interfaceFunction.propertyIndex = shape.ix;
	      interfaceFunction.nm = shape.nm;
	      interfaceFunction.mn = shape.mn;
	      return interfaceFunction;
	    }

	    function fillInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(val) {
	        if (val === 'Color' || val === 'color') {
	          return interfaceFunction.color;
	        }

	        if (val === 'Opacity' || val === 'opacity') {
	          return interfaceFunction.opacity;
	        }

	        return null;
	      }

	      Object.defineProperties(interfaceFunction, {
	        color: {
	          get: ExpressionPropertyInterface(view.c)
	        },
	        opacity: {
	          get: ExpressionPropertyInterface(view.o)
	        },
	        _name: {
	          value: shape.nm
	        },
	        mn: {
	          value: shape.mn
	        }
	      });
	      view.c.setGroupProperty(PropertyInterface('Color', propertyGroup));
	      view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
	      return interfaceFunction;
	    }

	    function gradientFillInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(val) {
	        if (val === 'Start Point' || val === 'start point') {
	          return interfaceFunction.startPoint;
	        }

	        if (val === 'End Point' || val === 'end point') {
	          return interfaceFunction.endPoint;
	        }

	        if (val === 'Opacity' || val === 'opacity') {
	          return interfaceFunction.opacity;
	        }

	        return null;
	      }

	      Object.defineProperties(interfaceFunction, {
	        startPoint: {
	          get: ExpressionPropertyInterface(view.s)
	        },
	        endPoint: {
	          get: ExpressionPropertyInterface(view.e)
	        },
	        opacity: {
	          get: ExpressionPropertyInterface(view.o)
	        },
	        type: {
	          get: function get() {
	            return 'a';
	          }
	        },
	        _name: {
	          value: shape.nm
	        },
	        mn: {
	          value: shape.mn
	        }
	      });
	      view.s.setGroupProperty(PropertyInterface('Start Point', propertyGroup));
	      view.e.setGroupProperty(PropertyInterface('End Point', propertyGroup));
	      view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
	      return interfaceFunction;
	    }

	    function defaultInterfaceFactory() {
	      function interfaceFunction() {
	        return null;
	      }

	      return interfaceFunction;
	    }

	    function strokeInterfaceFactory(shape, view, propertyGroup) {
	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

	      var _dashPropertyGroup = propertyGroupFactory(dashOb, _propertyGroup);

	      function addPropertyToDashOb(i) {
	        Object.defineProperty(dashOb, shape.d[i].nm, {
	          get: ExpressionPropertyInterface(view.d.dataProps[i].p)
	        });
	      }

	      var i;
	      var len = shape.d ? shape.d.length : 0;
	      var dashOb = {};

	      for (i = 0; i < len; i += 1) {
	        addPropertyToDashOb(i);
	        view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
	      }

	      function interfaceFunction(val) {
	        if (val === 'Color' || val === 'color') {
	          return interfaceFunction.color;
	        }

	        if (val === 'Opacity' || val === 'opacity') {
	          return interfaceFunction.opacity;
	        }

	        if (val === 'Stroke Width' || val === 'stroke width') {
	          return interfaceFunction.strokeWidth;
	        }

	        return null;
	      }

	      Object.defineProperties(interfaceFunction, {
	        color: {
	          get: ExpressionPropertyInterface(view.c)
	        },
	        opacity: {
	          get: ExpressionPropertyInterface(view.o)
	        },
	        strokeWidth: {
	          get: ExpressionPropertyInterface(view.w)
	        },
	        dash: {
	          get: function get() {
	            return dashOb;
	          }
	        },
	        _name: {
	          value: shape.nm
	        },
	        mn: {
	          value: shape.mn
	        }
	      });
	      view.c.setGroupProperty(PropertyInterface('Color', _propertyGroup));
	      view.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
	      view.w.setGroupProperty(PropertyInterface('Stroke Width', _propertyGroup));
	      return interfaceFunction;
	    }

	    function trimInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(val) {
	        if (val === shape.e.ix || val === 'End' || val === 'end') {
	          return interfaceFunction.end;
	        }

	        if (val === shape.s.ix) {
	          return interfaceFunction.start;
	        }

	        if (val === shape.o.ix) {
	          return interfaceFunction.offset;
	        }

	        return null;
	      }

	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

	      interfaceFunction.propertyIndex = shape.ix;
	      view.s.setGroupProperty(PropertyInterface('Start', _propertyGroup));
	      view.e.setGroupProperty(PropertyInterface('End', _propertyGroup));
	      view.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
	      interfaceFunction.propertyIndex = shape.ix;
	      interfaceFunction.propertyGroup = propertyGroup;
	      Object.defineProperties(interfaceFunction, {
	        start: {
	          get: ExpressionPropertyInterface(view.s)
	        },
	        end: {
	          get: ExpressionPropertyInterface(view.e)
	        },
	        offset: {
	          get: ExpressionPropertyInterface(view.o)
	        },
	        _name: {
	          value: shape.nm
	        }
	      });
	      interfaceFunction.mn = shape.mn;
	      return interfaceFunction;
	    }

	    function transformInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(value) {
	        if (shape.a.ix === value || value === 'Anchor Point') {
	          return interfaceFunction.anchorPoint;
	        }

	        if (shape.o.ix === value || value === 'Opacity') {
	          return interfaceFunction.opacity;
	        }

	        if (shape.p.ix === value || value === 'Position') {
	          return interfaceFunction.position;
	        }

	        if (shape.r.ix === value || value === 'Rotation' || value === 'ADBE Vector Rotation') {
	          return interfaceFunction.rotation;
	        }

	        if (shape.s.ix === value || value === 'Scale') {
	          return interfaceFunction.scale;
	        }

	        if (shape.sk && shape.sk.ix === value || value === 'Skew') {
	          return interfaceFunction.skew;
	        }

	        if (shape.sa && shape.sa.ix === value || value === 'Skew Axis') {
	          return interfaceFunction.skewAxis;
	        }

	        return null;
	      }

	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

	      view.transform.mProps.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
	      view.transform.mProps.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
	      view.transform.mProps.a.setGroupProperty(PropertyInterface('Anchor Point', _propertyGroup));
	      view.transform.mProps.s.setGroupProperty(PropertyInterface('Scale', _propertyGroup));
	      view.transform.mProps.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));

	      if (view.transform.mProps.sk) {
	        view.transform.mProps.sk.setGroupProperty(PropertyInterface('Skew', _propertyGroup));
	        view.transform.mProps.sa.setGroupProperty(PropertyInterface('Skew Angle', _propertyGroup));
	      }

	      view.transform.op.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
	      Object.defineProperties(interfaceFunction, {
	        opacity: {
	          get: ExpressionPropertyInterface(view.transform.mProps.o)
	        },
	        position: {
	          get: ExpressionPropertyInterface(view.transform.mProps.p)
	        },
	        anchorPoint: {
	          get: ExpressionPropertyInterface(view.transform.mProps.a)
	        },
	        scale: {
	          get: ExpressionPropertyInterface(view.transform.mProps.s)
	        },
	        rotation: {
	          get: ExpressionPropertyInterface(view.transform.mProps.r)
	        },
	        skew: {
	          get: ExpressionPropertyInterface(view.transform.mProps.sk)
	        },
	        skewAxis: {
	          get: ExpressionPropertyInterface(view.transform.mProps.sa)
	        },
	        _name: {
	          value: shape.nm
	        }
	      });
	      interfaceFunction.ty = 'tr';
	      interfaceFunction.mn = shape.mn;
	      interfaceFunction.propertyGroup = propertyGroup;
	      return interfaceFunction;
	    }

	    function ellipseInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(value) {
	        if (shape.p.ix === value) {
	          return interfaceFunction.position;
	        }

	        if (shape.s.ix === value) {
	          return interfaceFunction.size;
	        }

	        return null;
	      }

	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

	      interfaceFunction.propertyIndex = shape.ix;
	      var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	      prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
	      prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
	      Object.defineProperties(interfaceFunction, {
	        size: {
	          get: ExpressionPropertyInterface(prop.s)
	        },
	        position: {
	          get: ExpressionPropertyInterface(prop.p)
	        },
	        _name: {
	          value: shape.nm
	        }
	      });
	      interfaceFunction.mn = shape.mn;
	      return interfaceFunction;
	    }

	    function starInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(value) {
	        if (shape.p.ix === value) {
	          return interfaceFunction.position;
	        }

	        if (shape.r.ix === value) {
	          return interfaceFunction.rotation;
	        }

	        if (shape.pt.ix === value) {
	          return interfaceFunction.points;
	        }

	        if (shape.or.ix === value || value === 'ADBE Vector Star Outer Radius') {
	          return interfaceFunction.outerRadius;
	        }

	        if (shape.os.ix === value) {
	          return interfaceFunction.outerRoundness;
	        }

	        if (shape.ir && (shape.ir.ix === value || value === 'ADBE Vector Star Inner Radius')) {
	          return interfaceFunction.innerRadius;
	        }

	        if (shape.is && shape.is.ix === value) {
	          return interfaceFunction.innerRoundness;
	        }

	        return null;
	      }

	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

	      var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	      interfaceFunction.propertyIndex = shape.ix;
	      prop.or.setGroupProperty(PropertyInterface('Outer Radius', _propertyGroup));
	      prop.os.setGroupProperty(PropertyInterface('Outer Roundness', _propertyGroup));
	      prop.pt.setGroupProperty(PropertyInterface('Points', _propertyGroup));
	      prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
	      prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));

	      if (shape.ir) {
	        prop.ir.setGroupProperty(PropertyInterface('Inner Radius', _propertyGroup));
	        prop.is.setGroupProperty(PropertyInterface('Inner Roundness', _propertyGroup));
	      }

	      Object.defineProperties(interfaceFunction, {
	        position: {
	          get: ExpressionPropertyInterface(prop.p)
	        },
	        rotation: {
	          get: ExpressionPropertyInterface(prop.r)
	        },
	        points: {
	          get: ExpressionPropertyInterface(prop.pt)
	        },
	        outerRadius: {
	          get: ExpressionPropertyInterface(prop.or)
	        },
	        outerRoundness: {
	          get: ExpressionPropertyInterface(prop.os)
	        },
	        innerRadius: {
	          get: ExpressionPropertyInterface(prop.ir)
	        },
	        innerRoundness: {
	          get: ExpressionPropertyInterface(prop.is)
	        },
	        _name: {
	          value: shape.nm
	        }
	      });
	      interfaceFunction.mn = shape.mn;
	      return interfaceFunction;
	    }

	    function rectInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(value) {
	        if (shape.p.ix === value) {
	          return interfaceFunction.position;
	        }

	        if (shape.r.ix === value) {
	          return interfaceFunction.roundness;
	        }

	        if (shape.s.ix === value || value === 'Size' || value === 'ADBE Vector Rect Size') {
	          return interfaceFunction.size;
	        }

	        return null;
	      }

	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

	      var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	      interfaceFunction.propertyIndex = shape.ix;
	      prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
	      prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
	      prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
	      Object.defineProperties(interfaceFunction, {
	        position: {
	          get: ExpressionPropertyInterface(prop.p)
	        },
	        roundness: {
	          get: ExpressionPropertyInterface(prop.r)
	        },
	        size: {
	          get: ExpressionPropertyInterface(prop.s)
	        },
	        _name: {
	          value: shape.nm
	        }
	      });
	      interfaceFunction.mn = shape.mn;
	      return interfaceFunction;
	    }

	    function roundedInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(value) {
	        if (shape.r.ix === value || value === 'Round Corners 1') {
	          return interfaceFunction.radius;
	        }

	        return null;
	      }

	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

	      var prop = view;
	      interfaceFunction.propertyIndex = shape.ix;
	      prop.rd.setGroupProperty(PropertyInterface('Radius', _propertyGroup));
	      Object.defineProperties(interfaceFunction, {
	        radius: {
	          get: ExpressionPropertyInterface(prop.rd)
	        },
	        _name: {
	          value: shape.nm
	        }
	      });
	      interfaceFunction.mn = shape.mn;
	      return interfaceFunction;
	    }

	    function repeaterInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(value) {
	        if (shape.c.ix === value || value === 'Copies') {
	          return interfaceFunction.copies;
	        }

	        if (shape.o.ix === value || value === 'Offset') {
	          return interfaceFunction.offset;
	        }

	        return null;
	      }

	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

	      var prop = view;
	      interfaceFunction.propertyIndex = shape.ix;
	      prop.c.setGroupProperty(PropertyInterface('Copies', _propertyGroup));
	      prop.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
	      Object.defineProperties(interfaceFunction, {
	        copies: {
	          get: ExpressionPropertyInterface(prop.c)
	        },
	        offset: {
	          get: ExpressionPropertyInterface(prop.o)
	        },
	        _name: {
	          value: shape.nm
	        }
	      });
	      interfaceFunction.mn = shape.mn;
	      return interfaceFunction;
	    }

	    return function (shapes, view, propertyGroup) {
	      var interfaces;

	      function _interfaceFunction(value) {
	        if (typeof value === 'number') {
	          value = value === undefined ? 1 : value;

	          if (value === 0) {
	            return propertyGroup;
	          }

	          return interfaces[value - 1];
	        }

	        var i = 0;
	        var len = interfaces.length;

	        while (i < len) {
	          if (interfaces[i]._name === value) {
	            return interfaces[i];
	          }

	          i += 1;
	        }

	        return null;
	      }

	      function parentGroupWrapper() {
	        return propertyGroup;
	      }

	      _interfaceFunction.propertyGroup = propertyGroupFactory(_interfaceFunction, parentGroupWrapper);
	      interfaces = iterateElements(shapes, view, _interfaceFunction.propertyGroup);
	      _interfaceFunction.numProperties = interfaces.length;
	      _interfaceFunction._name = 'Contents';
	      return _interfaceFunction;
	    };
	  }();

	  var TextExpressionInterface = function () {
	    return function (elem) {
	      var _sourceText;

	      function _thisLayerFunction(name) {
	        switch (name) {
	          case 'ADBE Text Document':
	            return _thisLayerFunction.sourceText;

	          default:
	            return null;
	        }
	      }

	      Object.defineProperty(_thisLayerFunction, 'sourceText', {
	        get: function get() {
	          elem.textProperty.getValue();
	          var stringValue = elem.textProperty.currentData.t;

	          if (!_sourceText || stringValue !== _sourceText.value) {
	            _sourceText = new String(stringValue); // eslint-disable-line no-new-wrappers
	            // If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive

	            _sourceText.value = stringValue || new String(stringValue); // eslint-disable-line no-new-wrappers

	            Object.defineProperty(_sourceText, 'style', {
	              get: function get() {
	                return {
	                  fillColor: elem.textProperty.currentData.fc
	                };
	              }
	            });
	          }

	          return _sourceText;
	        }
	      });
	      return _thisLayerFunction;
	    };
	  }();

	  function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

	  var FootageInterface = function () {
	    var outlineInterfaceFactory = function outlineInterfaceFactory(elem) {
	      var currentPropertyName = '';
	      var currentProperty = elem.getFootageData();

	      function init() {
	        currentPropertyName = '';
	        currentProperty = elem.getFootageData();
	        return searchProperty;
	      }

	      function searchProperty(value) {
	        if (currentProperty[value]) {
	          currentPropertyName = value;
	          currentProperty = currentProperty[value];

	          if (_typeof(currentProperty) === 'object') {
	            return searchProperty;
	          }

	          return currentProperty;
	        }

	        var propertyNameIndex = value.indexOf(currentPropertyName);

	        if (propertyNameIndex !== -1) {
	          var index = parseInt(value.substr(propertyNameIndex + currentPropertyName.length), 10);
	          currentProperty = currentProperty[index];

	          if (_typeof(currentProperty) === 'object') {
	            return searchProperty;
	          }

	          return currentProperty;
	        }

	        return '';
	      }

	      return init;
	    };

	    var dataInterfaceFactory = function dataInterfaceFactory(elem) {
	      function interfaceFunction(value) {
	        if (value === 'Outline') {
	          return interfaceFunction.outlineInterface();
	        }

	        return null;
	      }

	      interfaceFunction._name = 'Outline';
	      interfaceFunction.outlineInterface = outlineInterfaceFactory(elem);
	      return interfaceFunction;
	    };

	    return function (elem) {
	      function _interfaceFunction(value) {
	        if (value === 'Data') {
	          return _interfaceFunction.dataInterface;
	        }

	        return null;
	      }

	      _interfaceFunction._name = 'Data';
	      _interfaceFunction.dataInterface = dataInterfaceFactory(elem);
	      return _interfaceFunction;
	    };
	  }();

	  var interfaces = {
	    layer: LayerExpressionInterface,
	    effects: EffectsExpressionInterface,
	    comp: CompExpressionInterface,
	    shape: ShapeExpressionInterface,
	    text: TextExpressionInterface,
	    footage: FootageInterface
	  };

	  function getInterface(type) {
	    return interfaces[type] || null;
	  }

	  var expressionHelpers = function () {
	    function searchExpressions(elem, data, prop) {
	      if (data.x) {
	        prop.k = true;
	        prop.x = true;
	        prop.initiateExpression = ExpressionManager.initiateExpression;
	        prop.effectsSequence.push(prop.initiateExpression(elem, data, prop).bind(prop));
	      }
	    }

	    function getValueAtTime(frameNum) {
	      frameNum *= this.elem.globalData.frameRate;
	      frameNum -= this.offsetTime;

	      if (frameNum !== this._cachingAtTime.lastFrame) {
	        this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < frameNum ? this._cachingAtTime.lastIndex : 0;
	        this._cachingAtTime.value = this.interpolateValue(frameNum, this._cachingAtTime);
	        this._cachingAtTime.lastFrame = frameNum;
	      }

	      return this._cachingAtTime.value;
	    }

	    function getSpeedAtTime(frameNum) {
	      var delta = -0.01;
	      var v1 = this.getValueAtTime(frameNum);
	      var v2 = this.getValueAtTime(frameNum + delta);
	      var speed = 0;

	      if (v1.length) {
	        var i;

	        for (i = 0; i < v1.length; i += 1) {
	          speed += Math.pow(v2[i] - v1[i], 2);
	        }

	        speed = Math.sqrt(speed) * 100;
	      } else {
	        speed = 0;
	      }

	      return speed;
	    }

	    function getVelocityAtTime(frameNum) {
	      if (this.vel !== undefined) {
	        return this.vel;
	      }

	      var delta = -0.001; // frameNum += this.elem.data.st;

	      var v1 = this.getValueAtTime(frameNum);
	      var v2 = this.getValueAtTime(frameNum + delta);
	      var velocity;

	      if (v1.length) {
	        velocity = createTypedArray('float32', v1.length);
	        var i;

	        for (i = 0; i < v1.length; i += 1) {
	          // removing frameRate
	          // if needed, don't add it here
	          // velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
	          velocity[i] = (v2[i] - v1[i]) / delta;
	        }
	      } else {
	        velocity = (v2 - v1) / delta;
	      }

	      return velocity;
	    }

	    function getStaticValueAtTime() {
	      return this.pv;
	    }

	    function setGroupProperty(propertyGroup) {
	      this.propertyGroup = propertyGroup;
	    }

	    return {
	      searchExpressions: searchExpressions,
	      getSpeedAtTime: getSpeedAtTime,
	      getVelocityAtTime: getVelocityAtTime,
	      getValueAtTime: getValueAtTime,
	      getStaticValueAtTime: getStaticValueAtTime,
	      setGroupProperty: setGroupProperty
	    };
	  }();

	  function addPropertyDecorator() {
	    function loopOut(type, duration, durationFlag) {
	      if (!this.k || !this.keyframes) {
	        return this.pv;
	      }

	      type = type ? type.toLowerCase() : '';
	      var currentFrame = this.comp.renderedFrame;
	      var keyframes = this.keyframes;
	      var lastKeyFrame = keyframes[keyframes.length - 1].t;

	      if (currentFrame <= lastKeyFrame) {
	        return this.pv;
	      }

	      var cycleDuration;
	      var firstKeyFrame;

	      if (!durationFlag) {
	        if (!duration || duration > keyframes.length - 1) {
	          duration = keyframes.length - 1;
	        }

	        firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
	        cycleDuration = lastKeyFrame - firstKeyFrame;
	      } else {
	        if (!duration) {
	          cycleDuration = Math.max(0, lastKeyFrame - this.elem.data.ip);
	        } else {
	          cycleDuration = Math.abs(lastKeyFrame - this.elem.comp.globalData.frameRate * duration);
	        }

	        firstKeyFrame = lastKeyFrame - cycleDuration;
	      }

	      var i;
	      var len;
	      var ret;

	      if (type === 'pingpong') {
	        var iterations = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);

	        if (iterations % 2 !== 0) {
	          return this.getValueAtTime((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
	        }
	      } else if (type === 'offset') {
	        var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	        var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	        var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line

	        var repeats = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);

	        if (this.pv.length) {
	          ret = new Array(initV.length);
	          len = ret.length;

	          for (i = 0; i < len; i += 1) {
	            ret[i] = (endV[i] - initV[i]) * repeats + current[i];
	          }

	          return ret;
	        }

	        return (endV - initV) * repeats + current;
	      } else if (type === 'continue') {
	        var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	        var nextLastValue = this.getValueAtTime((lastKeyFrame - 0.001) / this.comp.globalData.frameRate, 0);

	        if (this.pv.length) {
	          ret = new Array(lastValue.length);
	          len = ret.length;

	          for (i = 0; i < len; i += 1) {
	            ret[i] = lastValue[i] + (lastValue[i] - nextLastValue[i]) * ((currentFrame - lastKeyFrame) / this.comp.globalData.frameRate) / 0.0005; // eslint-disable-line
	          }

	          return ret;
	        }

	        return lastValue + (lastValue - nextLastValue) * ((currentFrame - lastKeyFrame) / 0.001);
	      }

	      return this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
	    }

	    function loopIn(type, duration, durationFlag) {
	      if (!this.k) {
	        return this.pv;
	      }

	      type = type ? type.toLowerCase() : '';
	      var currentFrame = this.comp.renderedFrame;
	      var keyframes = this.keyframes;
	      var firstKeyFrame = keyframes[0].t;

	      if (currentFrame >= firstKeyFrame) {
	        return this.pv;
	      }

	      var cycleDuration;
	      var lastKeyFrame;

	      if (!durationFlag) {
	        if (!duration || duration > keyframes.length - 1) {
	          duration = keyframes.length - 1;
	        }

	        lastKeyFrame = keyframes[duration].t;
	        cycleDuration = lastKeyFrame - firstKeyFrame;
	      } else {
	        if (!duration) {
	          cycleDuration = Math.max(0, this.elem.data.op - firstKeyFrame);
	        } else {
	          cycleDuration = Math.abs(this.elem.comp.globalData.frameRate * duration);
	        }

	        lastKeyFrame = firstKeyFrame + cycleDuration;
	      }

	      var i;
	      var len;
	      var ret;

	      if (type === 'pingpong') {
	        var iterations = Math.floor((firstKeyFrame - currentFrame) / cycleDuration);

	        if (iterations % 2 === 0) {
	          return this.getValueAtTime(((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
	        }
	      } else if (type === 'offset') {
	        var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	        var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	        var current = this.getValueAtTime((cycleDuration - (firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0);
	        var repeats = Math.floor((firstKeyFrame - currentFrame) / cycleDuration) + 1;

	        if (this.pv.length) {
	          ret = new Array(initV.length);
	          len = ret.length;

	          for (i = 0; i < len; i += 1) {
	            ret[i] = current[i] - (endV[i] - initV[i]) * repeats;
	          }

	          return ret;
	        }

	        return current - (endV - initV) * repeats;
	      } else if (type === 'continue') {
	        var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	        var nextFirstValue = this.getValueAtTime((firstKeyFrame + 0.001) / this.comp.globalData.frameRate, 0);

	        if (this.pv.length) {
	          ret = new Array(firstValue.length);
	          len = ret.length;

	          for (i = 0; i < len; i += 1) {
	            ret[i] = firstValue[i] + (firstValue[i] - nextFirstValue[i]) * (firstKeyFrame - currentFrame) / 0.001;
	          }

	          return ret;
	        }

	        return firstValue + (firstValue - nextFirstValue) * (firstKeyFrame - currentFrame) / 0.001;
	      }

	      return this.getValueAtTime((cycleDuration - ((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame)) / this.comp.globalData.frameRate, 0); // eslint-disable-line
	    }

	    function smooth(width, samples) {
	      if (!this.k) {
	        return this.pv;
	      }

	      width = (width || 0.4) * 0.5;
	      samples = Math.floor(samples || 5);

	      if (samples <= 1) {
	        return this.pv;
	      }

	      var currentTime = this.comp.renderedFrame / this.comp.globalData.frameRate;
	      var initFrame = currentTime - width;
	      var endFrame = currentTime + width;
	      var sampleFrequency = samples > 1 ? (endFrame - initFrame) / (samples - 1) : 1;
	      var i = 0;
	      var j = 0;
	      var value;

	      if (this.pv.length) {
	        value = createTypedArray('float32', this.pv.length);
	      } else {
	        value = 0;
	      }

	      var sampleValue;

	      while (i < samples) {
	        sampleValue = this.getValueAtTime(initFrame + i * sampleFrequency);

	        if (this.pv.length) {
	          for (j = 0; j < this.pv.length; j += 1) {
	            value[j] += sampleValue[j];
	          }
	        } else {
	          value += sampleValue;
	        }

	        i += 1;
	      }

	      if (this.pv.length) {
	        for (j = 0; j < this.pv.length; j += 1) {
	          value[j] /= samples;
	        }
	      } else {
	        value /= samples;
	      }

	      return value;
	    }

	    function getTransformValueAtTime(time) {
	      if (!this._transformCachingAtTime) {
	        this._transformCachingAtTime = {
	          v: new Matrix()
	        };
	      } /// /


	      var matrix = this._transformCachingAtTime.v;
	      matrix.cloneFromProps(this.pre.props);

	      if (this.appliedTransformations < 1) {
	        var anchor = this.a.getValueAtTime(time);
	        matrix.translate(-anchor[0] * this.a.mult, -anchor[1] * this.a.mult, anchor[2] * this.a.mult);
	      }

	      if (this.appliedTransformations < 2) {
	        var scale = this.s.getValueAtTime(time);
	        matrix.scale(scale[0] * this.s.mult, scale[1] * this.s.mult, scale[2] * this.s.mult);
	      }

	      if (this.sk && this.appliedTransformations < 3) {
	        var skew = this.sk.getValueAtTime(time);
	        var skewAxis = this.sa.getValueAtTime(time);
	        matrix.skewFromAxis(-skew * this.sk.mult, skewAxis * this.sa.mult);
	      }

	      if (this.r && this.appliedTransformations < 4) {
	        var rotation = this.r.getValueAtTime(time);
	        matrix.rotate(-rotation * this.r.mult);
	      } else if (!this.r && this.appliedTransformations < 4) {
	        var rotationZ = this.rz.getValueAtTime(time);
	        var rotationY = this.ry.getValueAtTime(time);
	        var rotationX = this.rx.getValueAtTime(time);
	        var orientation = this.or.getValueAtTime(time);
	        matrix.rotateZ(-rotationZ * this.rz.mult).rotateY(rotationY * this.ry.mult).rotateX(rotationX * this.rx.mult).rotateZ(-orientation[2] * this.or.mult).rotateY(orientation[1] * this.or.mult).rotateX(orientation[0] * this.or.mult);
	      }

	      if (this.data.p && this.data.p.s) {
	        var positionX = this.px.getValueAtTime(time);
	        var positionY = this.py.getValueAtTime(time);

	        if (this.data.p.z) {
	          var positionZ = this.pz.getValueAtTime(time);
	          matrix.translate(positionX * this.px.mult, positionY * this.py.mult, -positionZ * this.pz.mult);
	        } else {
	          matrix.translate(positionX * this.px.mult, positionY * this.py.mult, 0);
	        }
	      } else {
	        var position = this.p.getValueAtTime(time);
	        matrix.translate(position[0] * this.p.mult, position[1] * this.p.mult, -position[2] * this.p.mult);
	      }

	      return matrix; /// /
	    }

	    function getTransformStaticValueAtTime() {
	      return this.v.clone(new Matrix());
	    }

	    var getTransformProperty = TransformPropertyFactory.getTransformProperty;

	    TransformPropertyFactory.getTransformProperty = function (elem, data, container) {
	      var prop = getTransformProperty(elem, data, container);

	      if (prop.dynamicProperties.length) {
	        prop.getValueAtTime = getTransformValueAtTime.bind(prop);
	      } else {
	        prop.getValueAtTime = getTransformStaticValueAtTime.bind(prop);
	      }

	      prop.setGroupProperty = expressionHelpers.setGroupProperty;
	      return prop;
	    };

	    var propertyGetProp = PropertyFactory.getProp;

	    PropertyFactory.getProp = function (elem, data, type, mult, container) {
	      var prop = propertyGetProp(elem, data, type, mult, container); // prop.getVelocityAtTime = getVelocityAtTime;
	      // prop.loopOut = loopOut;
	      // prop.loopIn = loopIn;

	      if (prop.kf) {
	        prop.getValueAtTime = expressionHelpers.getValueAtTime.bind(prop);
	      } else {
	        prop.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(prop);
	      }

	      prop.setGroupProperty = expressionHelpers.setGroupProperty;
	      prop.loopOut = loopOut;
	      prop.loopIn = loopIn;
	      prop.smooth = smooth;
	      prop.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(prop);
	      prop.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(prop);
	      prop.numKeys = data.a === 1 ? data.k.length : 0;
	      prop.propertyIndex = data.ix;
	      var value = 0;

	      if (type !== 0) {
	        value = createTypedArray('float32', data.a === 1 ? data.k[0].s.length : data.k.length);
	      }

	      prop._cachingAtTime = {
	        lastFrame: initialDefaultFrame,
	        lastIndex: 0,
	        value: value
	      };
	      expressionHelpers.searchExpressions(elem, data, prop);

	      if (prop.k) {
	        container.addDynamicProperty(prop);
	      }

	      return prop;
	    };

	    function getShapeValueAtTime(frameNum) {
	      // For now this caching object is created only when needed instead of creating it when the shape is initialized.
	      if (!this._cachingAtTime) {
	        this._cachingAtTime = {
	          shapeValue: shapePool.clone(this.pv),
	          lastIndex: 0,
	          lastTime: initialDefaultFrame
	        };
	      }

	      frameNum *= this.elem.globalData.frameRate;
	      frameNum -= this.offsetTime;

	      if (frameNum !== this._cachingAtTime.lastTime) {
	        this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < frameNum ? this._caching.lastIndex : 0;
	        this._cachingAtTime.lastTime = frameNum;
	        this.interpolateShape(frameNum, this._cachingAtTime.shapeValue, this._cachingAtTime);
	      }

	      return this._cachingAtTime.shapeValue;
	    }

	    var ShapePropertyConstructorFunction = ShapePropertyFactory.getConstructorFunction();
	    var KeyframedShapePropertyConstructorFunction = ShapePropertyFactory.getKeyframedConstructorFunction();

	    function ShapeExpressions() {}

	    ShapeExpressions.prototype = {
	      vertices: function vertices(prop, time) {
	        if (this.k) {
	          this.getValue();
	        }

	        var shapePath = this.v;

	        if (time !== undefined) {
	          shapePath = this.getValueAtTime(time, 0);
	        }

	        var i;
	        var len = shapePath._length;
	        var vertices = shapePath[prop];
	        var points = shapePath.v;
	        var arr = createSizedArray(len);

	        for (i = 0; i < len; i += 1) {
	          if (prop === 'i' || prop === 'o') {
	            arr[i] = [vertices[i][0] - points[i][0], vertices[i][1] - points[i][1]];
	          } else {
	            arr[i] = [vertices[i][0], vertices[i][1]];
	          }
	        }

	        return arr;
	      },
	      points: function points(time) {
	        return this.vertices('v', time);
	      },
	      inTangents: function inTangents(time) {
	        return this.vertices('i', time);
	      },
	      outTangents: function outTangents(time) {
	        return this.vertices('o', time);
	      },
	      isClosed: function isClosed() {
	        return this.v.c;
	      },
	      pointOnPath: function pointOnPath(perc, time) {
	        var shapePath = this.v;

	        if (time !== undefined) {
	          shapePath = this.getValueAtTime(time, 0);
	        }

	        if (!this._segmentsLength) {
	          this._segmentsLength = bez.getSegmentsLength(shapePath);
	        }

	        var segmentsLength = this._segmentsLength;
	        var lengths = segmentsLength.lengths;
	        var lengthPos = segmentsLength.totalLength * perc;
	        var i = 0;
	        var len = lengths.length;
	        var accumulatedLength = 0;
	        var pt;

	        while (i < len) {
	          if (accumulatedLength + lengths[i].addedLength > lengthPos) {
	            var initIndex = i;
	            var endIndex = shapePath.c && i === len - 1 ? 0 : i + 1;
	            var segmentPerc = (lengthPos - accumulatedLength) / lengths[i].addedLength;
	            pt = bez.getPointInSegment(shapePath.v[initIndex], shapePath.v[endIndex], shapePath.o[initIndex], shapePath.i[endIndex], segmentPerc, lengths[i]);
	            break;
	          } else {
	            accumulatedLength += lengths[i].addedLength;
	          }

	          i += 1;
	        }

	        if (!pt) {
	          pt = shapePath.c ? [shapePath.v[0][0], shapePath.v[0][1]] : [shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1]];
	        }

	        return pt;
	      },
	      vectorOnPath: function vectorOnPath(perc, time, vectorType) {
	        // perc doesn't use triple equality because it can be a Number object as well as a primitive.
	        if (perc == 1) {
	          // eslint-disable-line eqeqeq
	          perc = this.v.c;
	        } else if (perc == 0) {
	          // eslint-disable-line eqeqeq
	          perc = 0.999;
	        }

	        var pt1 = this.pointOnPath(perc, time);
	        var pt2 = this.pointOnPath(perc + 0.001, time);
	        var xLength = pt2[0] - pt1[0];
	        var yLength = pt2[1] - pt1[1];
	        var magnitude = Math.sqrt(Math.pow(xLength, 2) + Math.pow(yLength, 2));

	        if (magnitude === 0) {
	          return [0, 0];
	        }

	        var unitVector = vectorType === 'tangent' ? [xLength / magnitude, yLength / magnitude] : [-yLength / magnitude, xLength / magnitude];
	        return unitVector;
	      },
	      tangentOnPath: function tangentOnPath(perc, time) {
	        return this.vectorOnPath(perc, time, 'tangent');
	      },
	      normalOnPath: function normalOnPath(perc, time) {
	        return this.vectorOnPath(perc, time, 'normal');
	      },
	      setGroupProperty: expressionHelpers.setGroupProperty,
	      getValueAtTime: expressionHelpers.getStaticValueAtTime
	    };
	    extendPrototype([ShapeExpressions], ShapePropertyConstructorFunction);
	    extendPrototype([ShapeExpressions], KeyframedShapePropertyConstructorFunction);
	    KeyframedShapePropertyConstructorFunction.prototype.getValueAtTime = getShapeValueAtTime;
	    KeyframedShapePropertyConstructorFunction.prototype.initiateExpression = ExpressionManager.initiateExpression;
	    var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;

	    ShapePropertyFactory.getShapeProp = function (elem, data, type, arr, trims) {
	      var prop = propertyGetShapeProp(elem, data, type, arr, trims);
	      prop.propertyIndex = data.ix;
	      prop.lock = false;

	      if (type === 3) {
	        expressionHelpers.searchExpressions(elem, data.pt, prop);
	      } else if (type === 4) {
	        expressionHelpers.searchExpressions(elem, data.ks, prop);
	      }

	      if (prop.k) {
	        elem.addDynamicProperty(prop);
	      }

	      return prop;
	    };
	  }

	  function initialize$1() {
	    addPropertyDecorator();
	  }

	  function addDecorator() {
	    function searchExpressions() {
	      if (this.data.d.x) {
	        this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this);
	        this.addEffect(this.getExpressionValue.bind(this));
	        return true;
	      }

	      return null;
	    }

	    TextProperty.prototype.getExpressionValue = function (currentValue, text) {
	      var newValue = this.calculateExpression(text);

	      if (currentValue.t !== newValue) {
	        var newData = {};
	        this.copyData(newData, currentValue);
	        newData.t = newValue.toString();
	        newData.__complete = false;
	        return newData;
	      }

	      return currentValue;
	    };

	    TextProperty.prototype.searchProperty = function () {
	      var isKeyframed = this.searchKeyframes();
	      var hasExpressions = this.searchExpressions();
	      this.kf = isKeyframed || hasExpressions;
	      return this.kf;
	    };

	    TextProperty.prototype.searchExpressions = searchExpressions;
	  }

	  function initialize() {
	    addDecorator();
	  }

	  function SVGComposableEffect() {}

	  SVGComposableEffect.prototype = {
	    createMergeNode: function createMergeNode(resultId, ins) {
	      var feMerge = createNS('feMerge');
	      feMerge.setAttribute('result', resultId);
	      var feMergeNode;
	      var i;

	      for (i = 0; i < ins.length; i += 1) {
	        feMergeNode = createNS('feMergeNode');
	        feMergeNode.setAttribute('in', ins[i]);
	        feMerge.appendChild(feMergeNode);
	        feMerge.appendChild(feMergeNode);
	      }

	      return feMerge;
	    }
	  };

	  var linearFilterValue = '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0';

	  function SVGTintFilter(filter, filterManager, elem, id, source) {
	    this.filterManager = filterManager;
	    var feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type', 'matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
	    feColorMatrix.setAttribute('values', linearFilterValue + ' 1 0');
	    this.linearFilter = feColorMatrix;
	    feColorMatrix.setAttribute('result', id + '_tint_1');
	    filter.appendChild(feColorMatrix);
	    feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type', 'matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
	    feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
	    feColorMatrix.setAttribute('result', id + '_tint_2');
	    filter.appendChild(feColorMatrix);
	    this.matrixFilter = feColorMatrix;
	    var feMerge = this.createMergeNode(id, [source, id + '_tint_1', id + '_tint_2']);
	    filter.appendChild(feMerge);
	  }

	  extendPrototype([SVGComposableEffect], SVGTintFilter);

	  SVGTintFilter.prototype.renderFrame = function (forceRender) {
	    if (forceRender || this.filterManager._mdf) {
	      var colorBlack = this.filterManager.effectElements[0].p.v;
	      var colorWhite = this.filterManager.effectElements[1].p.v;
	      var opacity = this.filterManager.effectElements[2].p.v / 100;
	      this.linearFilter.setAttribute('values', linearFilterValue + ' ' + opacity + ' 0');
	      this.matrixFilter.setAttribute('values', colorWhite[0] - colorBlack[0] + ' 0 0 0 ' + colorBlack[0] + ' ' + (colorWhite[1] - colorBlack[1]) + ' 0 0 0 ' + colorBlack[1] + ' ' + (colorWhite[2] - colorBlack[2]) + ' 0 0 0 ' + colorBlack[2] + ' 0 0 0 1 0');
	    }
	  };

	  function SVGFillFilter(filter, filterManager, elem, id) {
	    this.filterManager = filterManager;
	    var feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type', 'matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
	    feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
	    feColorMatrix.setAttribute('result', id);
	    filter.appendChild(feColorMatrix);
	    this.matrixFilter = feColorMatrix;
	  }

	  SVGFillFilter.prototype.renderFrame = function (forceRender) {
	    if (forceRender || this.filterManager._mdf) {
	      var color = this.filterManager.effectElements[2].p.v;
	      var opacity = this.filterManager.effectElements[6].p.v;
	      this.matrixFilter.setAttribute('values', '0 0 0 0 ' + color[0] + ' 0 0 0 0 ' + color[1] + ' 0 0 0 0 ' + color[2] + ' 0 0 0 ' + opacity + ' 0');
	    }
	  };

	  function SVGStrokeEffect(fil, filterManager, elem) {
	    this.initialized = false;
	    this.filterManager = filterManager;
	    this.elem = elem;
	    this.paths = [];
	  }

	  SVGStrokeEffect.prototype.initialize = function () {
	    var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
	    var path;
	    var groupPath;
	    var i;
	    var len;

	    if (this.filterManager.effectElements[1].p.v === 1) {
	      len = this.elem.maskManager.masksProperties.length;
	      i = 0;
	    } else {
	      i = this.filterManager.effectElements[0].p.v - 1;
	      len = i + 1;
	    }

	    groupPath = createNS('g');
	    groupPath.setAttribute('fill', 'none');
	    groupPath.setAttribute('stroke-linecap', 'round');
	    groupPath.setAttribute('stroke-dashoffset', 1);

	    for (i; i < len; i += 1) {
	      path = createNS('path');
	      groupPath.appendChild(path);
	      this.paths.push({
	        p: path,
	        m: i
	      });
	    }

	    if (this.filterManager.effectElements[10].p.v === 3) {
	      var mask = createNS('mask');
	      var id = createElementID();
	      mask.setAttribute('id', id);
	      mask.setAttribute('mask-type', 'alpha');
	      mask.appendChild(groupPath);
	      this.elem.globalData.defs.appendChild(mask);
	      var g = createNS('g');
	      g.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');

	      while (elemChildren[0]) {
	        g.appendChild(elemChildren[0]);
	      }

	      this.elem.layerElement.appendChild(g);
	      this.masker = mask;
	      groupPath.setAttribute('stroke', '#fff');
	    } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
	      if (this.filterManager.effectElements[10].p.v === 2) {
	        elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;

	        while (elemChildren.length) {
	          this.elem.layerElement.removeChild(elemChildren[0]);
	        }
	      }

	      this.elem.layerElement.appendChild(groupPath);
	      this.elem.layerElement.removeAttribute('mask');
	      groupPath.setAttribute('stroke', '#fff');
	    }

	    this.initialized = true;
	    this.pathMasker = groupPath;
	  };

	  SVGStrokeEffect.prototype.renderFrame = function (forceRender) {
	    if (!this.initialized) {
	      this.initialize();
	    }

	    var i;
	    var len = this.paths.length;
	    var mask;
	    var path;

	    for (i = 0; i < len; i += 1) {
	      if (this.paths[i].m !== -1) {
	        mask = this.elem.maskManager.viewData[this.paths[i].m];
	        path = this.paths[i].p;

	        if (forceRender || this.filterManager._mdf || mask.prop._mdf) {
	          path.setAttribute('d', mask.lastPath);
	        }

	        if (forceRender || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || mask.prop._mdf) {
	          var dasharrayValue;

	          if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
	            var s = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
	            var e = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
	            var l = path.getTotalLength();
	            dasharrayValue = '0 0 0 ' + l * s + ' ';
	            var lineLength = l * (e - s);
	            var segment = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
	            var units = Math.floor(lineLength / segment);
	            var j;

	            for (j = 0; j < units; j += 1) {
	              dasharrayValue += '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + ' ';
	            }

	            dasharrayValue += '0 ' + l * 10 + ' 0 0';
	          } else {
	            dasharrayValue = '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
	          }

	          path.setAttribute('stroke-dasharray', dasharrayValue);
	        }
	      }
	    }

	    if (forceRender || this.filterManager.effectElements[4].p._mdf) {
	      this.pathMasker.setAttribute('stroke-width', this.filterManager.effectElements[4].p.v * 2);
	    }

	    if (forceRender || this.filterManager.effectElements[6].p._mdf) {
	      this.pathMasker.setAttribute('opacity', this.filterManager.effectElements[6].p.v);
	    }

	    if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
	      if (forceRender || this.filterManager.effectElements[3].p._mdf) {
	        var color = this.filterManager.effectElements[3].p.v;
	        this.pathMasker.setAttribute('stroke', 'rgb(' + bmFloor(color[0] * 255) + ',' + bmFloor(color[1] * 255) + ',' + bmFloor(color[2] * 255) + ')');
	      }
	    }
	  };

	  function SVGTritoneFilter(filter, filterManager, elem, id) {
	    this.filterManager = filterManager;
	    var feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type', 'matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
	    feColorMatrix.setAttribute('values', '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
	    filter.appendChild(feColorMatrix);
	    var feComponentTransfer = createNS('feComponentTransfer');
	    feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
	    feComponentTransfer.setAttribute('result', id);
	    this.matrixFilter = feComponentTransfer;
	    var feFuncR = createNS('feFuncR');
	    feFuncR.setAttribute('type', 'table');
	    feComponentTransfer.appendChild(feFuncR);
	    this.feFuncR = feFuncR;
	    var feFuncG = createNS('feFuncG');
	    feFuncG.setAttribute('type', 'table');
	    feComponentTransfer.appendChild(feFuncG);
	    this.feFuncG = feFuncG;
	    var feFuncB = createNS('feFuncB');
	    feFuncB.setAttribute('type', 'table');
	    feComponentTransfer.appendChild(feFuncB);
	    this.feFuncB = feFuncB;
	    filter.appendChild(feComponentTransfer);
	  }

	  SVGTritoneFilter.prototype.renderFrame = function (forceRender) {
	    if (forceRender || this.filterManager._mdf) {
	      var color1 = this.filterManager.effectElements[0].p.v;
	      var color2 = this.filterManager.effectElements[1].p.v;
	      var color3 = this.filterManager.effectElements[2].p.v;
	      var tableR = color3[0] + ' ' + color2[0] + ' ' + color1[0];
	      var tableG = color3[1] + ' ' + color2[1] + ' ' + color1[1];
	      var tableB = color3[2] + ' ' + color2[2] + ' ' + color1[2];
	      this.feFuncR.setAttribute('tableValues', tableR);
	      this.feFuncG.setAttribute('tableValues', tableG);
	      this.feFuncB.setAttribute('tableValues', tableB);
	    }
	  };

	  function SVGProLevelsFilter(filter, filterManager, elem, id) {
	    this.filterManager = filterManager;
	    var effectElements = this.filterManager.effectElements;
	    var feComponentTransfer = createNS('feComponentTransfer'); // Red

	    if (effectElements[10].p.k || effectElements[10].p.v !== 0 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 1 || effectElements[13].p.k || effectElements[13].p.v !== 0 || effectElements[14].p.k || effectElements[14].p.v !== 1) {
	      this.feFuncR = this.createFeFunc('feFuncR', feComponentTransfer);
	    } // Green


	    if (effectElements[17].p.k || effectElements[17].p.v !== 0 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 1 || effectElements[20].p.k || effectElements[20].p.v !== 0 || effectElements[21].p.k || effectElements[21].p.v !== 1) {
	      this.feFuncG = this.createFeFunc('feFuncG', feComponentTransfer);
	    } // Blue


	    if (effectElements[24].p.k || effectElements[24].p.v !== 0 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 1 || effectElements[27].p.k || effectElements[27].p.v !== 0 || effectElements[28].p.k || effectElements[28].p.v !== 1) {
	      this.feFuncB = this.createFeFunc('feFuncB', feComponentTransfer);
	    } // Alpha


	    if (effectElements[31].p.k || effectElements[31].p.v !== 0 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 1 || effectElements[34].p.k || effectElements[34].p.v !== 0 || effectElements[35].p.k || effectElements[35].p.v !== 1) {
	      this.feFuncA = this.createFeFunc('feFuncA', feComponentTransfer);
	    } // RGB


	    if (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) {
	      feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
	      filter.appendChild(feComponentTransfer);
	    }

	    if (effectElements[3].p.k || effectElements[3].p.v !== 0 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 1 || effectElements[6].p.k || effectElements[6].p.v !== 0 || effectElements[7].p.k || effectElements[7].p.v !== 1) {
	      feComponentTransfer = createNS('feComponentTransfer');
	      feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
	      feComponentTransfer.setAttribute('result', id);
	      filter.appendChild(feComponentTransfer);
	      this.feFuncRComposed = this.createFeFunc('feFuncR', feComponentTransfer);
	      this.feFuncGComposed = this.createFeFunc('feFuncG', feComponentTransfer);
	      this.feFuncBComposed = this.createFeFunc('feFuncB', feComponentTransfer);
	    }
	  }

	  SVGProLevelsFilter.prototype.createFeFunc = function (type, feComponentTransfer) {
	    var feFunc = createNS(type);
	    feFunc.setAttribute('type', 'table');
	    feComponentTransfer.appendChild(feFunc);
	    return feFunc;
	  };

	  SVGProLevelsFilter.prototype.getTableValue = function (inputBlack, inputWhite, gamma, outputBlack, outputWhite) {
	    var cnt = 0;
	    var segments = 256;
	    var perc;
	    var min = Math.min(inputBlack, inputWhite);
	    var max = Math.max(inputBlack, inputWhite);
	    var table = Array.call(null, {
	      length: segments
	    });
	    var colorValue;
	    var pos = 0;
	    var outputDelta = outputWhite - outputBlack;
	    var inputDelta = inputWhite - inputBlack;

	    while (cnt <= 256) {
	      perc = cnt / 256;

	      if (perc <= min) {
	        colorValue = inputDelta < 0 ? outputWhite : outputBlack;
	      } else if (perc >= max) {
	        colorValue = inputDelta < 0 ? outputBlack : outputWhite;
	      } else {
	        colorValue = outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma);
	      }

	      table[pos] = colorValue;
	      pos += 1;
	      cnt += 256 / (segments - 1);
	    }

	    return table.join(' ');
	  };

	  SVGProLevelsFilter.prototype.renderFrame = function (forceRender) {
	    if (forceRender || this.filterManager._mdf) {
	      var val;
	      var effectElements = this.filterManager.effectElements;

	      if (this.feFuncRComposed && (forceRender || effectElements[3].p._mdf || effectElements[4].p._mdf || effectElements[5].p._mdf || effectElements[6].p._mdf || effectElements[7].p._mdf)) {
	        val = this.getTableValue(effectElements[3].p.v, effectElements[4].p.v, effectElements[5].p.v, effectElements[6].p.v, effectElements[7].p.v);
	        this.feFuncRComposed.setAttribute('tableValues', val);
	        this.feFuncGComposed.setAttribute('tableValues', val);
	        this.feFuncBComposed.setAttribute('tableValues', val);
	      }

	      if (this.feFuncR && (forceRender || effectElements[10].p._mdf || effectElements[11].p._mdf || effectElements[12].p._mdf || effectElements[13].p._mdf || effectElements[14].p._mdf)) {
	        val = this.getTableValue(effectElements[10].p.v, effectElements[11].p.v, effectElements[12].p.v, effectElements[13].p.v, effectElements[14].p.v);
	        this.feFuncR.setAttribute('tableValues', val);
	      }

	      if (this.feFuncG && (forceRender || effectElements[17].p._mdf || effectElements[18].p._mdf || effectElements[19].p._mdf || effectElements[20].p._mdf || effectElements[21].p._mdf)) {
	        val = this.getTableValue(effectElements[17].p.v, effectElements[18].p.v, effectElements[19].p.v, effectElements[20].p.v, effectElements[21].p.v);
	        this.feFuncG.setAttribute('tableValues', val);
	      }

	      if (this.feFuncB && (forceRender || effectElements[24].p._mdf || effectElements[25].p._mdf || effectElements[26].p._mdf || effectElements[27].p._mdf || effectElements[28].p._mdf)) {
	        val = this.getTableValue(effectElements[24].p.v, effectElements[25].p.v, effectElements[26].p.v, effectElements[27].p.v, effectElements[28].p.v);
	        this.feFuncB.setAttribute('tableValues', val);
	      }

	      if (this.feFuncA && (forceRender || effectElements[31].p._mdf || effectElements[32].p._mdf || effectElements[33].p._mdf || effectElements[34].p._mdf || effectElements[35].p._mdf)) {
	        val = this.getTableValue(effectElements[31].p.v, effectElements[32].p.v, effectElements[33].p.v, effectElements[34].p.v, effectElements[35].p.v);
	        this.feFuncA.setAttribute('tableValues', val);
	      }
	    }
	  };

	  function SVGDropShadowEffect(filter, filterManager, elem, id, source) {
	    var globalFilterSize = filterManager.container.globalData.renderConfig.filterSize;
	    var filterSize = filterManager.data.fs || globalFilterSize;
	    filter.setAttribute('x', filterSize.x || globalFilterSize.x);
	    filter.setAttribute('y', filterSize.y || globalFilterSize.y);
	    filter.setAttribute('width', filterSize.width || globalFilterSize.width);
	    filter.setAttribute('height', filterSize.height || globalFilterSize.height);
	    this.filterManager = filterManager;
	    var feGaussianBlur = createNS('feGaussianBlur');
	    feGaussianBlur.setAttribute('in', 'SourceAlpha');
	    feGaussianBlur.setAttribute('result', id + '_drop_shadow_1');
	    feGaussianBlur.setAttribute('stdDeviation', '0');
	    this.feGaussianBlur = feGaussianBlur;
	    filter.appendChild(feGaussianBlur);
	    var feOffset = createNS('feOffset');
	    feOffset.setAttribute('dx', '25');
	    feOffset.setAttribute('dy', '0');
	    feOffset.setAttribute('in', id + '_drop_shadow_1');
	    feOffset.setAttribute('result', id + '_drop_shadow_2');
	    this.feOffset = feOffset;
	    filter.appendChild(feOffset);
	    var feFlood = createNS('feFlood');
	    feFlood.setAttribute('flood-color', '#00ff00');
	    feFlood.setAttribute('flood-opacity', '1');
	    feFlood.setAttribute('result', id + '_drop_shadow_3');
	    this.feFlood = feFlood;
	    filter.appendChild(feFlood);
	    var feComposite = createNS('feComposite');
	    feComposite.setAttribute('in', id + '_drop_shadow_3');
	    feComposite.setAttribute('in2', id + '_drop_shadow_2');
	    feComposite.setAttribute('operator', 'in');
	    feComposite.setAttribute('result', id + '_drop_shadow_4');
	    filter.appendChild(feComposite);
	    var feMerge = this.createMergeNode(id, [id + '_drop_shadow_4', source]);
	    filter.appendChild(feMerge); //
	  }

	  extendPrototype([SVGComposableEffect], SVGDropShadowEffect);

	  SVGDropShadowEffect.prototype.renderFrame = function (forceRender) {
	    if (forceRender || this.filterManager._mdf) {
	      if (forceRender || this.filterManager.effectElements[4].p._mdf) {
	        this.feGaussianBlur.setAttribute('stdDeviation', this.filterManager.effectElements[4].p.v / 4);
	      }

	      if (forceRender || this.filterManager.effectElements[0].p._mdf) {
	        var col = this.filterManager.effectElements[0].p.v;
	        this.feFlood.setAttribute('flood-color', rgbToHex(Math.round(col[0] * 255), Math.round(col[1] * 255), Math.round(col[2] * 255)));
	      }

	      if (forceRender || this.filterManager.effectElements[1].p._mdf) {
	        this.feFlood.setAttribute('flood-opacity', this.filterManager.effectElements[1].p.v / 255);
	      }

	      if (forceRender || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
	        var distance = this.filterManager.effectElements[3].p.v;
	        var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads;
	        var x = distance * Math.cos(angle);
	        var y = distance * Math.sin(angle);
	        this.feOffset.setAttribute('dx', x);
	        this.feOffset.setAttribute('dy', y);
	      }
	    }
	  };

	  var _svgMatteSymbols = [];

	  function SVGMatte3Effect(filterElem, filterManager, elem) {
	    this.initialized = false;
	    this.filterManager = filterManager;
	    this.filterElem = filterElem;
	    this.elem = elem;
	    elem.matteElement = createNS('g');
	    elem.matteElement.appendChild(elem.layerElement);
	    elem.matteElement.appendChild(elem.transformedElement);
	    elem.baseElement = elem.matteElement;
	  }

	  SVGMatte3Effect.prototype.findSymbol = function (mask) {
	    var i = 0;
	    var len = _svgMatteSymbols.length;

	    while (i < len) {
	      if (_svgMatteSymbols[i] === mask) {
	        return _svgMatteSymbols[i];
	      }

	      i += 1;
	    }

	    return null;
	  };

	  SVGMatte3Effect.prototype.replaceInParent = function (mask, symbolId) {
	    var parentNode = mask.layerElement.parentNode;

	    if (!parentNode) {
	      return;
	    }

	    var children = parentNode.children;
	    var i = 0;
	    var len = children.length;

	    while (i < len) {
	      if (children[i] === mask.layerElement) {
	        break;
	      }

	      i += 1;
	    }

	    var nextChild;

	    if (i <= len - 2) {
	      nextChild = children[i + 1];
	    }

	    var useElem = createNS('use');
	    useElem.setAttribute('href', '#' + symbolId);

	    if (nextChild) {
	      parentNode.insertBefore(useElem, nextChild);
	    } else {
	      parentNode.appendChild(useElem);
	    }
	  };

	  SVGMatte3Effect.prototype.setElementAsMask = function (elem, mask) {
	    if (!this.findSymbol(mask)) {
	      var symbolId = createElementID();
	      var masker = createNS('mask');
	      masker.setAttribute('id', mask.layerId);
	      masker.setAttribute('mask-type', 'alpha');

	      _svgMatteSymbols.push(mask);

	      var defs = elem.globalData.defs;
	      defs.appendChild(masker);
	      var symbol = createNS('symbol');
	      symbol.setAttribute('id', symbolId);
	      this.replaceInParent(mask, symbolId);
	      symbol.appendChild(mask.layerElement);
	      defs.appendChild(symbol);
	      var useElem = createNS('use');
	      useElem.setAttribute('href', '#' + symbolId);
	      masker.appendChild(useElem);
	      mask.data.hd = false;
	      mask.show();
	    }

	    elem.setMatte(mask.layerId);
	  };

	  SVGMatte3Effect.prototype.initialize = function () {
	    var ind = this.filterManager.effectElements[0].p.v;
	    var elements = this.elem.comp.elements;
	    var i = 0;
	    var len = elements.length;

	    while (i < len) {
	      if (elements[i] && elements[i].data.ind === ind) {
	        this.setElementAsMask(this.elem, elements[i]);
	      }

	      i += 1;
	    }

	    this.initialized = true;
	  };

	  SVGMatte3Effect.prototype.renderFrame = function () {
	    if (!this.initialized) {
	      this.initialize();
	    }
	  };

	  function SVGGaussianBlurEffect(filter, filterManager, elem, id) {
	    // Outset the filter region by 100% on all sides to accommodate blur expansion.
	    filter.setAttribute('x', '-100%');
	    filter.setAttribute('y', '-100%');
	    filter.setAttribute('width', '300%');
	    filter.setAttribute('height', '300%');
	    this.filterManager = filterManager;
	    var feGaussianBlur = createNS('feGaussianBlur');
	    feGaussianBlur.setAttribute('result', id);
	    filter.appendChild(feGaussianBlur);
	    this.feGaussianBlur = feGaussianBlur;
	  }

	  SVGGaussianBlurEffect.prototype.renderFrame = function (forceRender) {
	    if (forceRender || this.filterManager._mdf) {
	      // Empirical value, matching AE's blur appearance.
	      var kBlurrinessToSigma = 0.3;
	      var sigma = this.filterManager.effectElements[0].p.v * kBlurrinessToSigma; // Dimensions mapping:
	      //
	      //   1 -> horizontal & vertical
	      //   2 -> horizontal only
	      //   3 -> vertical only
	      //

	      var dimensions = this.filterManager.effectElements[1].p.v;
	      var sigmaX = dimensions == 3 ? 0 : sigma; // eslint-disable-line eqeqeq

	      var sigmaY = dimensions == 2 ? 0 : sigma; // eslint-disable-line eqeqeq

	      this.feGaussianBlur.setAttribute('stdDeviation', sigmaX + ' ' + sigmaY); // Repeat edges mapping:
	      //
	      //   0 -> off -> duplicate
	      //   1 -> on  -> wrap

	      var edgeMode = this.filterManager.effectElements[2].p.v == 1 ? 'wrap' : 'duplicate'; // eslint-disable-line eqeqeq

	      this.feGaussianBlur.setAttribute('edgeMode', edgeMode);
	    }
	  };

	  function TransformEffect() {}

	  TransformEffect.prototype.init = function (effectsManager) {
	    this.effectsManager = effectsManager;
	    this.type = effectTypes.TRANSFORM_EFFECT;
	    this.matrix = new Matrix();
	    this.opacity = -1;
	    this._mdf = false;
	    this._opMdf = false;
	  };

	  TransformEffect.prototype.renderFrame = function (forceFrame) {
	    this._opMdf = false;
	    this._mdf = false;

	    if (forceFrame || this.effectsManager._mdf) {
	      var effectElements = this.effectsManager.effectElements;
	      var anchor = effectElements[0].p.v;
	      var position = effectElements[1].p.v;
	      var isUniformScale = effectElements[2].p.v === 1;
	      var scaleHeight = effectElements[3].p.v;
	      var scaleWidth = isUniformScale ? scaleHeight : effectElements[4].p.v;
	      var skew = effectElements[5].p.v;
	      var skewAxis = effectElements[6].p.v;
	      var rotation = effectElements[7].p.v;
	      this.matrix.reset();
	      this.matrix.translate(-anchor[0], -anchor[1], anchor[2]);
	      this.matrix.scale(scaleWidth * 0.01, scaleHeight * 0.01, 1);
	      this.matrix.rotate(-rotation * degToRads);
	      this.matrix.skewFromAxis(-skew * degToRads, (skewAxis + 90) * degToRads);
	      this.matrix.translate(position[0], position[1], 0);
	      this._mdf = true;

	      if (this.opacity !== effectElements[8].p.v) {
	        this.opacity = effectElements[8].p.v;
	        this._opMdf = true;
	      }
	    }
	  };

	  function SVGTransformEffect(_, filterManager) {
	    this.init(filterManager);
	  }

	  extendPrototype([TransformEffect], SVGTransformEffect);

	  function CVTransformEffect(effectsManager) {
	    this.init(effectsManager);
	  }

	  extendPrototype([TransformEffect], CVTransformEffect);

	  registerRenderer('canvas', CanvasRenderer);
	  registerRenderer('html', HybridRenderer);
	  registerRenderer('svg', SVGRenderer); // Registering shape modifiers

	  ShapeModifiers.registerModifier('tm', TrimModifier);
	  ShapeModifiers.registerModifier('pb', PuckerAndBloatModifier);
	  ShapeModifiers.registerModifier('rp', RepeaterModifier);
	  ShapeModifiers.registerModifier('rd', RoundCornersModifier);
	  ShapeModifiers.registerModifier('zz', ZigZagModifier);
	  ShapeModifiers.registerModifier('op', OffsetPathModifier); // Registering expression plugin

	  setExpressionsPlugin(Expressions);
	  setExpressionInterfaces(getInterface);
	  initialize$1();
	  initialize(); // Registering svg effects

	  registerEffect$1(20, SVGTintFilter, true);
	  registerEffect$1(21, SVGFillFilter, true);
	  registerEffect$1(22, SVGStrokeEffect, false);
	  registerEffect$1(23, SVGTritoneFilter, true);
	  registerEffect$1(24, SVGProLevelsFilter, true);
	  registerEffect$1(25, SVGDropShadowEffect, true);
	  registerEffect$1(28, SVGMatte3Effect, false);
	  registerEffect$1(29, SVGGaussianBlurEffect, true);
	  registerEffect$1(35, SVGTransformEffect, false);
	  registerEffect(35, CVTransformEffect);

	  return lottie;

	})); 
} (lottie$1, lottie$1.exports));

var lottieExports = lottie$1.exports;
var lottie = /*@__PURE__*/getDefaultExportFromCjs(lottieExports);

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var _excluded$1 = ["animationData", "loop", "autoplay", "initialSegment", "onComplete", "onLoopComplete", "onEnterFrame", "onSegmentStart", "onConfigReady", "onDataReady", "onDataFailed", "onLoadedImages", "onDOMLoaded", "onDestroy", "lottieRef", "renderer", "name", "assetsPath", "rendererSettings"];
var useLottie = function useLottie(props, style) {
  var animationData = props.animationData,
    loop = props.loop,
    autoplay = props.autoplay,
    initialSegment = props.initialSegment,
    onComplete = props.onComplete,
    onLoopComplete = props.onLoopComplete,
    onEnterFrame = props.onEnterFrame,
    onSegmentStart = props.onSegmentStart,
    onConfigReady = props.onConfigReady,
    onDataReady = props.onDataReady,
    onDataFailed = props.onDataFailed,
    onLoadedImages = props.onLoadedImages,
    onDOMLoaded = props.onDOMLoaded,
    onDestroy = props.onDestroy;
    props.lottieRef;
    props.renderer;
    props.name;
    props.assetsPath;
    props.rendererSettings;
    var rest = _objectWithoutProperties(props, _excluded$1);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    animationLoaded = _useState2[0],
    setAnimationLoaded = _useState2[1];
  var animationInstanceRef = useRef();
  var animationContainer = useRef(null);
  /*
        ======================================
            INTERACTION METHODS
        ======================================
     */
  /**
   * Play
   */
  var play = function play() {
    var _a;
    (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.play();
  };
  /**
   * Stop
   */
  var stop = function stop() {
    var _a;
    (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.stop();
  };
  /**
   * Pause
   */
  var pause = function pause() {
    var _a;
    (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.pause();
  };
  /**
   * Set animation speed
   * @param speed
   */
  var setSpeed = function setSpeed(speed) {
    var _a;
    (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.setSpeed(speed);
  };
  /**
   * Got to frame and play
   * @param value
   * @param isFrame
   */
  var goToAndPlay = function goToAndPlay(value, isFrame) {
    var _a;
    (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.goToAndPlay(value, isFrame);
  };
  /**
   * Got to frame and stop
   * @param value
   * @param isFrame
   */
  var goToAndStop = function goToAndStop(value, isFrame) {
    var _a;
    (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.goToAndStop(value, isFrame);
  };
  /**
   * Set animation direction
   * @param direction
   */
  var setDirection = function setDirection(direction) {
    var _a;
    (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.setDirection(direction);
  };
  /**
   * Play animation segments
   * @param segments
   * @param forceFlag
   */
  var playSegments = function playSegments(segments, forceFlag) {
    var _a;
    (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.playSegments(segments, forceFlag);
  };
  /**
   * Set sub frames
   * @param useSubFrames
   */
  var setSubframe = function setSubframe(useSubFrames) {
    var _a;
    (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.setSubframe(useSubFrames);
  };
  /**
   * Get animation duration
   * @param inFrames
   */
  var getDuration = function getDuration(inFrames) {
    var _a;
    return (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.getDuration(inFrames);
  };
  /**
   * Destroy animation
   */
  var destroy = function destroy() {
    var _a;
    (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
    // Removing the reference to the animation so separate cleanups are skipped.
    // Without it the internal `lottie-react` instance throws exceptions as it already cleared itself on destroy.
    animationInstanceRef.current = undefined;
  };
  /*
        ======================================
            LOTTIE
        ======================================
     */
  /**
   * Load a new animation, and if it's the case, destroy the previous one
   * @param {Object} forcedConfigs
   */
  var loadAnimation = function loadAnimation() {
    var forcedConfigs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _a;
    // Return if the container ref is null
    if (!animationContainer.current) {
      return;
    }
    // Destroy any previous instance
    (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
    // Build the animation configuration
    var config = _objectSpread2(_objectSpread2(_objectSpread2({}, props), forcedConfigs), {}, {
      container: animationContainer.current
    });
    // Save the animation instance
    animationInstanceRef.current = lottie.loadAnimation(config);
    setAnimationLoaded(!!animationInstanceRef.current);
    // Return a function that will clean up
    return function () {
      var _a;
      (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
      animationInstanceRef.current = undefined;
    };
  };
  /**
   * (Re)Initialize when animation data changed
   */
  useEffect(function () {
    var onUnmount = loadAnimation();
    // Clean up on unmount
    return function () {
      return onUnmount === null || onUnmount === void 0 ? void 0 : onUnmount();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [animationData, loop]);
  // Update the autoplay state
  useEffect(function () {
    if (!animationInstanceRef.current) {
      return;
    }
    animationInstanceRef.current.autoplay = !!autoplay;
  }, [autoplay]);
  // Update the initial segment state
  useEffect(function () {
    if (!animationInstanceRef.current) {
      return;
    }
    // When null should reset to default animation length
    if (!initialSegment) {
      animationInstanceRef.current.resetSegments(true);
      return;
    }
    // If it's not a valid segment, do nothing
    if (!Array.isArray(initialSegment) || !initialSegment.length) {
      return;
    }
    // If the current position it's not in the new segment
    // set the current position to start
    if (animationInstanceRef.current.currentRawFrame < initialSegment[0] || animationInstanceRef.current.currentRawFrame > initialSegment[1]) {
      animationInstanceRef.current.currentRawFrame = initialSegment[0];
    }
    // Update the segment
    animationInstanceRef.current.setSegment(initialSegment[0], initialSegment[1]);
  }, [initialSegment]);
  /*
        ======================================
            EVENTS
        ======================================
     */
  /**
   * Reinitialize listener on change
   */
  useEffect(function () {
    var partialListeners = [{
      name: "complete",
      handler: onComplete
    }, {
      name: "loopComplete",
      handler: onLoopComplete
    }, {
      name: "enterFrame",
      handler: onEnterFrame
    }, {
      name: "segmentStart",
      handler: onSegmentStart
    }, {
      name: "config_ready",
      handler: onConfigReady
    }, {
      name: "data_ready",
      handler: onDataReady
    }, {
      name: "data_failed",
      handler: onDataFailed
    }, {
      name: "loaded_images",
      handler: onLoadedImages
    }, {
      name: "DOMLoaded",
      handler: onDOMLoaded
    }, {
      name: "destroy",
      handler: onDestroy
    }];
    var listeners = partialListeners.filter(function (listener) {
      return listener.handler != null;
    });
    if (!listeners.length) {
      return;
    }
    var deregisterList = listeners.map(
    /**
     * Handle the process of adding an event listener
     * @param {Listener} listener
     * @return {Function} Function that deregister the listener
     */
    function (listener) {
      var _a;
      (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener(listener.name, listener.handler);
      // Return a function to deregister this listener
      return function () {
        var _a;
        (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener(listener.name, listener.handler);
      };
    });
    // Deregister listeners on unmount
    return function () {
      deregisterList.forEach(function (deregister) {
        return deregister();
      });
    };
  }, [onComplete, onLoopComplete, onEnterFrame, onSegmentStart, onConfigReady, onDataReady, onDataFailed, onLoadedImages, onDOMLoaded, onDestroy]);
  /**
   * Build the animation view
   */
  var View = /*#__PURE__*/React__default.createElement("div", _objectSpread2({
    style: style,
    ref: animationContainer
  }, rest));
  return {
    View: View,
    play: play,
    stop: stop,
    pause: pause,
    setSpeed: setSpeed,
    goToAndStop: goToAndStop,
    goToAndPlay: goToAndPlay,
    setDirection: setDirection,
    playSegments: playSegments,
    setSubframe: setSubframe,
    getDuration: getDuration,
    destroy: destroy,
    animationContainerRef: animationContainer,
    animationLoaded: animationLoaded,
    animationItem: animationInstanceRef.current
  };
};

// helpers
function getContainerVisibility(container) {
  var _container$getBoundin = container.getBoundingClientRect(),
    top = _container$getBoundin.top,
    height = _container$getBoundin.height;
  var current = window.innerHeight - top;
  var max = window.innerHeight + height;
  return current / max;
}
function getContainerCursorPosition(container, cursorX, cursorY) {
  var _container$getBoundin2 = container.getBoundingClientRect(),
    top = _container$getBoundin2.top,
    left = _container$getBoundin2.left,
    width = _container$getBoundin2.width,
    height = _container$getBoundin2.height;
  var x = (cursorX - left) / width;
  var y = (cursorY - top) / height;
  return {
    x: x,
    y: y
  };
}
var useInitInteractivity = function useInitInteractivity(_ref) {
  var wrapperRef = _ref.wrapperRef,
    animationItem = _ref.animationItem,
    mode = _ref.mode,
    actions = _ref.actions;
  useEffect(function () {
    var wrapper = wrapperRef.current;
    if (!wrapper || !animationItem || !actions.length) {
      return;
    }
    animationItem.stop();
    var scrollModeHandler = function scrollModeHandler() {
      var assignedSegment = null;
      var scrollHandler = function scrollHandler() {
        var currentPercent = getContainerVisibility(wrapper);
        // Find the first action that satisfies the current position conditions
        var action = actions.find(function (_ref2) {
          var visibility = _ref2.visibility;
          return visibility && currentPercent >= visibility[0] && currentPercent <= visibility[1];
        });
        // Skip if no matching action was found!
        if (!action) {
          return;
        }
        if (action.type === "seek" && action.visibility && action.frames.length === 2) {
          // Seek: Go to a frame based on player scroll position action
          var frameToGo = action.frames[0] + Math.ceil((currentPercent - action.visibility[0]) / (action.visibility[1] - action.visibility[0]) * action.frames[1]);
          //! goToAndStop must be relative to the start of the current segment
          animationItem.goToAndStop(frameToGo - animationItem.firstFrame - 1, true);
        }
        if (action.type === "loop") {
          // Loop: Loop a given frames
          if (assignedSegment === null) {
            // if not playing any segments currently. play those segments and save to state
            animationItem.playSegments(action.frames, true);
            assignedSegment = action.frames;
          } else {
            // if playing any segments currently.
            //check if segments in state are equal to the frames selected by action
            if (assignedSegment !== action.frames) {
              // if they are not equal. new segments are to be loaded
              animationItem.playSegments(action.frames, true);
              assignedSegment = action.frames;
            } else if (animationItem.isPaused) {
              // if they are equal the play method must be called only if lottie is paused
              animationItem.playSegments(action.frames, true);
              assignedSegment = action.frames;
            }
          }
        }
        if (action.type === "play" && animationItem.isPaused) {
          // Play: Reset segments and continue playing full animation from current position
          animationItem.resetSegments(true);
          animationItem.play();
        }
        if (action.type === "stop") {
          // Stop: Stop playback
          animationItem.goToAndStop(action.frames[0] - animationItem.firstFrame - 1, true);
        }
      };
      document.addEventListener("scroll", scrollHandler);
      return function () {
        document.removeEventListener("scroll", scrollHandler);
      };
    };
    var cursorModeHandler = function cursorModeHandler() {
      var handleCursor = function handleCursor(_x, _y) {
        var x = _x;
        var y = _y;
        // Resolve cursor position if cursor is inside container
        if (x !== -1 && y !== -1) {
          // Get container cursor position
          var pos = getContainerCursorPosition(wrapper, x, y);
          // Use the resolved position
          x = pos.x;
          y = pos.y;
        }
        // Find the first action that satisfies the current position conditions
        var action = actions.find(function (_ref3) {
          var position = _ref3.position;
          if (position && Array.isArray(position.x) && Array.isArray(position.y)) {
            return x >= position.x[0] && x <= position.x[1] && y >= position.y[0] && y <= position.y[1];
          }
          if (position && !Number.isNaN(position.x) && !Number.isNaN(position.y)) {
            return x === position.x && y === position.y;
          }
          return false;
        });
        // Skip if no matching action was found!
        if (!action) {
          return;
        }
        // Process action types:
        if (action.type === "seek" && action.position && Array.isArray(action.position.x) && Array.isArray(action.position.y) && action.frames.length === 2) {
          // Seek: Go to a frame based on player scroll position action
          var xPercent = (x - action.position.x[0]) / (action.position.x[1] - action.position.x[0]);
          var yPercent = (y - action.position.y[0]) / (action.position.y[1] - action.position.y[0]);
          animationItem.playSegments(action.frames, true);
          animationItem.goToAndStop(Math.ceil((xPercent + yPercent) / 2 * (action.frames[1] - action.frames[0])), true);
        }
        if (action.type === "loop") {
          animationItem.playSegments(action.frames, true);
        }
        if (action.type === "play") {
          // Play: Reset segments and continue playing full animation from current position
          if (animationItem.isPaused) {
            animationItem.resetSegments(false);
          }
          animationItem.playSegments(action.frames);
        }
        if (action.type === "stop") {
          animationItem.goToAndStop(action.frames[0], true);
        }
      };
      var mouseMoveHandler = function mouseMoveHandler(ev) {
        handleCursor(ev.clientX, ev.clientY);
      };
      var mouseOutHandler = function mouseOutHandler() {
        handleCursor(-1, -1);
      };
      wrapper.addEventListener("mousemove", mouseMoveHandler);
      wrapper.addEventListener("mouseout", mouseOutHandler);
      return function () {
        wrapper.removeEventListener("mousemove", mouseMoveHandler);
        wrapper.removeEventListener("mouseout", mouseOutHandler);
      };
    };
    switch (mode) {
      case "scroll":
        return scrollModeHandler();
      case "cursor":
        return cursorModeHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode, animationItem]);
};
var useLottieInteractivity = function useLottieInteractivity(_ref4) {
  var actions = _ref4.actions,
    mode = _ref4.mode,
    lottieObj = _ref4.lottieObj;
  var animationItem = lottieObj.animationItem,
    View = lottieObj.View,
    animationContainerRef = lottieObj.animationContainerRef;
  useInitInteractivity({
    actions: actions,
    animationItem: animationItem,
    mode: mode,
    wrapperRef: animationContainerRef
  });
  return View;
};

var _excluded = ["style", "interactivity"];
var Lottie = function Lottie(props) {
  var _a, _b, _c;
  var style = props.style,
    interactivity = props.interactivity,
    lottieProps = _objectWithoutProperties(props, _excluded);
  /**
   * Initialize the 'useLottie' hook
   */
  var _useLottie = useLottie(lottieProps, style),
    View = _useLottie.View,
    play = _useLottie.play,
    stop = _useLottie.stop,
    pause = _useLottie.pause,
    setSpeed = _useLottie.setSpeed,
    goToAndStop = _useLottie.goToAndStop,
    goToAndPlay = _useLottie.goToAndPlay,
    setDirection = _useLottie.setDirection,
    playSegments = _useLottie.playSegments,
    setSubframe = _useLottie.setSubframe,
    getDuration = _useLottie.getDuration,
    destroy = _useLottie.destroy,
    animationContainerRef = _useLottie.animationContainerRef,
    animationLoaded = _useLottie.animationLoaded,
    animationItem = _useLottie.animationItem;
  /**
   * Make the hook variables/methods available through the provided 'lottieRef'
   */
  useEffect(function () {
    if (props.lottieRef) {
      props.lottieRef.current = {
        play: play,
        stop: stop,
        pause: pause,
        setSpeed: setSpeed,
        goToAndPlay: goToAndPlay,
        goToAndStop: goToAndStop,
        setDirection: setDirection,
        playSegments: playSegments,
        setSubframe: setSubframe,
        getDuration: getDuration,
        destroy: destroy,
        animationContainerRef: animationContainerRef,
        animationLoaded: animationLoaded,
        animationItem: animationItem
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [(_a = props.lottieRef) === null || _a === void 0 ? void 0 : _a.current]);
  return useLottieInteractivity({
    lottieObj: {
      View: View,
      play: play,
      stop: stop,
      pause: pause,
      setSpeed: setSpeed,
      goToAndStop: goToAndStop,
      goToAndPlay: goToAndPlay,
      setDirection: setDirection,
      playSegments: playSegments,
      setSubframe: setSubframe,
      getDuration: getDuration,
      destroy: destroy,
      animationContainerRef: animationContainerRef,
      animationLoaded: animationLoaded,
      animationItem: animationItem
    },
    actions: (_b = interactivity === null || interactivity === void 0 ? void 0 : interactivity.actions) !== null && _b !== void 0 ? _b : [],
    mode: (_c = interactivity === null || interactivity === void 0 ? void 0 : interactivity.mode) !== null && _c !== void 0 ? _c : "scroll"
  });
};

var v$1 = "4.8.0";
var meta = {
	g: "LottieFiles AE 3.5.7",
	a: "",
	k: "",
	d: "",
	tc: ""
};
var fr$1 = 24;
var ip$1 = 0;
var op$1 = 82;
var w$1 = 56;
var h$1 = 56;
var nm$1 = "icon 3";
var ddd$1 = 0;
var assets$1 = [
	{
		id: "comp_0",
		layers: [
			{
				ddd: 0,
				ind: 1,
				ty: 4,
				nm: "Vector",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							20.604,
							7.718,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							0,
							0,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-0.038,
												-3.496
											],
											[
												-0.038,
												-2.18
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ind: 1,
								ty: "sh",
								ix: 2,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-0.038,
												4.401
											],
											[
												-0.038,
												3.084
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 2",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ind: 2,
								ty: "sh",
								ix: 3,
								ks: {
									a: 0,
									k: {
										i: [
											[
												-0.003,
												-0.287
											],
											[
												0,
												0
											],
											[
												0.56,
												-0.601
											],
											[
												0.792,
												-0.001
											],
											[
												0,
												0
											],
											[
												0.336,
												0.361
											],
											[
												0,
												0.51
											],
											[
												0,
												0
											],
											[
												-0.166,
												0.225
											],
											[
												-0.259,
												0.069
											],
											[
												-0.159,
												0.224
											],
											[
												0,
												0.281
											],
											[
												0.159,
												0.224
											],
											[
												0.253,
												0.074
											],
											[
												0.166,
												0.225
											],
											[
												0.003,
												0.287
											],
											[
												0,
												0
											],
											[
												-0.336,
												0.361
											],
											[
												-0.475,
												0
											],
											[
												0,
												0
											],
											[
												-0.56,
												-0.601
											],
											[
												-0.001,
												-0.851
											],
											[
												0,
												0
											],
											[
												0.166,
												-0.225
											],
											[
												0.259,
												-0.069
											],
											[
												0.159,
												-0.224
											],
											[
												0,
												-0.281
											],
											[
												-0.159,
												-0.224
											],
											[
												-0.253,
												-0.074
											],
											[
												-0.166,
												-0.225
											]
										],
										o: [
											[
												0,
												0
											],
											[
												-0.001,
												0.851
											],
											[
												-0.56,
												0.601
											],
											[
												0,
												0
											],
											[
												-0.475,
												0
											],
											[
												-0.336,
												-0.361
											],
											[
												0,
												0
											],
											[
												0.003,
												-0.287
											],
											[
												0.166,
												-0.225
											],
											[
												0.253,
												-0.074
											],
											[
												0.159,
												-0.224
											],
											[
												0,
												-0.281
											],
											[
												-0.159,
												-0.224
											],
											[
												-0.259,
												-0.069
											],
											[
												-0.166,
												-0.225
											],
											[
												0,
												0
											],
											[
												0,
												-0.51
											],
											[
												0.336,
												-0.361
											],
											[
												0,
												0
											],
											[
												0.792,
												0.001
											],
											[
												0.56,
												0.601
											],
											[
												0,
												0
											],
											[
												-0.003,
												0.287
											],
											[
												-0.166,
												0.225
											],
											[
												-0.253,
												0.074
											],
											[
												-0.159,
												0.224
											],
											[
												0,
												0.281
											],
											[
												0.159,
												0.224
											],
											[
												0.259,
												0.069
											],
											[
												0.166,
												0.225
											]
										],
										v: [
											[
												7.17,
												2.483
											],
											[
												7.17,
												2.566
											],
											[
												6.294,
												4.834
											],
											[
												4.182,
												5.775
											],
											[
												-5.377,
												5.775
											],
											[
												-6.645,
												5.211
											],
											[
												-7.17,
												3.85
											],
											[
												-7.17,
												2.483
											],
											[
												-6.91,
												1.692
											],
											[
												-6.254,
												1.238
											],
											[
												-5.62,
												0.778
											],
											[
												-5.375,
												0
											],
											[
												-5.62,
												-0.778
											],
											[
												-6.254,
												-1.238
											],
											[
												-6.91,
												-1.692
											],
											[
												-7.17,
												-2.483
											],
											[
												-7.17,
												-3.85
											],
											[
												-6.645,
												-5.211
											],
											[
												-5.377,
												-5.775
											],
											[
												4.182,
												-5.775
											],
											[
												6.294,
												-4.834
											],
											[
												7.17,
												-2.566
											],
											[
												7.17,
												-2.483
											],
											[
												6.91,
												-1.692
											],
											[
												6.254,
												-1.238
											],
											[
												5.62,
												-0.778
											],
											[
												5.375,
												0
											],
											[
												5.62,
												0.778
											],
											[
												6.254,
												1.238
											],
											[
												6.91,
												1.692
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 3",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ind: 3,
								ty: "sh",
								ix: 4,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-2.868,
												-3.609
											],
											[
												-2.868,
												-5.053
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 4",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ind: 4,
								ty: "sh",
								ix: 5,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-2.868,
												5.053
											],
											[
												-2.868,
												3.609
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 5",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ind: 5,
								ty: "sh",
								ix: 6,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-2.868,
												2.165
											],
											[
												-2.868,
												-2.165
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 6",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "mm",
								mm: 1,
								nm: "Merge Paths 1",
								mn: "ADBE Vector Filter - Merge",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.847058832645,
										0.262745112181,
										0.223529413342,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 2,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 4,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Vector",
						np: 9,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 720,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 2,
				ty: 4,
				nm: "Vector",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							15.999,
							21.961,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							0,
							0,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.578,
												0.358
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												1.972,
												-1.021
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.59,
												0.337
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-1.114,
												-1.901
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-8.587,
												2.515
											],
											[
												-6.479,
												2.515
											],
											[
												-0.096,
												6.154
											],
											[
												1.74,
												6.2
											],
											[
												13.355,
												-0.993
											],
											[
												13.339,
												-1.02
											],
											[
												7.814,
												-2.542
											],
											[
												2.331,
												0.297
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ind: 1,
								ty: "sh",
								ix: 2,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												2.318,
												1.318
											],
											[
												0,
												0
											],
											[
												0.442,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												2.318,
												1.319
											],
											[
												0,
												0
											],
											[
												-0.334,
												-0.239
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-4.985,
												-0.75
											],
											[
												-3.586,
												-0.75
											],
											[
												-0.425,
												1.048
											],
											[
												1.598,
												-2.405
											],
											[
												-1.833,
												-4.356
											],
											[
												-3.018,
												-4.737
											],
											[
												-8.172,
												-4.737
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 2",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ind: 2,
								ty: "sh",
								ix: 3,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-8.588,
												-6.439
											],
											[
												-13.355,
												-6.439
											],
											[
												-13.355,
												4.967
											],
											[
												-8.588,
												4.967
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 3",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "mm",
								mm: 1,
								nm: "Merge Paths 1",
								mn: "ADBE Vector Filter - Merge",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.847058832645,
										0.262745112181,
										0.223529413342,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 2,
									ix: 5
								},
								lc: 2,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Vector",
						np: 6,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 720,
				st: 0,
				bm: 0
			}
		]
	},
	{
		id: "comp_1",
		layers: [
			{
				ddd: 0,
				ind: 1,
				ty: 4,
				nm: "Vector",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							19.64,
							16.488,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							0,
							0,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							-100,
							-100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												3.707
											],
											[
												0,
												-3.707
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.847058823529,
										0.262745098039,
										0.223529411765,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 2,
									ix: 5
								},
								lc: 1,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: -90,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Vector",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 720,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 2,
				ty: 4,
				nm: "Vector",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							19.64,
							12.709,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							0,
							0,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							-100,
							-100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0,
												3.707
											],
											[
												0,
												-3.707
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.847058823529,
										0.262745098039,
										0.223529411765,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 2,
									ix: 5
								},
								lc: 1,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: -90,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Vector",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 720,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 3,
				ty: 4,
				nm: "Vector",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							20.548,
							24.948,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							0,
							0,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.341,
												-0.348
											],
											[
												0.482,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0.493
											],
											[
												-0.341,
												0.348
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												6.063,
												-1.548
											],
											[
												6.063,
												-0.31
											],
											[
												5.53,
												1.004
											],
											[
												4.244,
												1.548
											],
											[
												-6.063,
												1.548
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.847058823529,
										0.262745098039,
										0.223529411765,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 2,
									ix: 5
								},
								lc: 1,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Vector",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 720,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 4,
				ty: 4,
				nm: "Vector",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							19.639,
							7.612,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							0,
							0,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.341,
												0.348
											],
											[
												-0.482,
												0
											],
											[
												0,
												0
											],
											[
												-0.341,
												-0.348
											],
											[
												0,
												-0.493
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												-0.493
											],
											[
												0.341,
												-0.348
											],
											[
												0,
												0
											],
											[
												0.482,
												0
											],
											[
												0.341,
												0.348
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-6.972,
												4.024
											],
											[
												-6.972,
												-2.167
											],
											[
												-6.439,
												-3.48
											],
											[
												-5.153,
												-4.024
											],
											[
												5.153,
												-4.024
											],
											[
												6.439,
												-3.48
											],
											[
												6.972,
												-2.167
											],
											[
												6.972,
												0.929
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.847058823529,
										0.262745098039,
										0.223529411765,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 2,
									ix: 5
								},
								lc: 1,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Vector",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 720,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 5,
				ty: 4,
				nm: "Vector",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							19.639,
							24.637,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							0,
							0,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0.909,
												0
											],
											[
												-0.909,
												0
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.847058823529,
										0.262745098039,
										0.223529411765,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 2,
									ix: 5
								},
								lc: 1,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Vector",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 720,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 6,
				ty: 4,
				nm: "Vector",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							6.908,
							27.423,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							0,
							0,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0.303,
												0.31
											],
											[
												-0.303,
												-0.31
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.847058823529,
										0.262745098039,
										0.223529411765,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 2,
									ix: 5
								},
								lc: 1,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Vector",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 720,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 7,
				ty: 4,
				nm: "Vector",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							13.273,
							28.042,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							0,
							0,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												4.942,
												0.37
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												-0.493,
												0.589
											],
											[
												-0.635,
												0.619
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												9.7,
												-1.548
											],
											[
												2.425,
												2.167
											],
											[
												0.909,
												3.715
											],
											[
												-6.669,
												-4.024
											],
											[
												-9.7,
												-0.929
											],
											[
												-4.85,
												4.024
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.847058823529,
										0.262745098039,
										0.223529411765,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 2,
									ix: 5
								},
								lc: 1,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Vector",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 720,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 8,
				ty: 4,
				nm: "Vector",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							27.572,
							13.793,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							0,
							0,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												-0.53,
												-0.469
											],
											[
												0,
												0
											],
											[
												-0.294,
												0.344
											],
											[
												0,
												0
											],
											[
												0.028,
												0.34
											],
											[
												0.255,
												0.221
											],
											[
												0,
												0
											],
											[
												0.334,
												-0.02
											],
											[
												0.223,
												-0.255
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0.533,
												0.47
											],
											[
												0,
												0
											],
											[
												0.215,
												-0.262
											],
											[
												-0.028,
												-0.34
											],
											[
												0,
												0
											],
											[
												-0.251,
												-0.226
											],
											[
												-0.334,
												0.02
											],
											[
												0,
												0
											],
											[
												-0.29,
												0.344
											]
										],
										v: [
											[
												-1.277,
												1.42
											],
											[
												-1.174,
												1.511
											],
											[
												0.327,
												1.74
											],
											[
												1.556,
												0.287
											],
											[
												1.847,
												-0.653
											],
											[
												1.405,
												-1.529
											],
											[
												1.301,
												-1.62
											],
											[
												0.388,
												-1.941
											],
											[
												-0.481,
												-1.512
											],
											[
												-1.718,
												-0.058
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.847058823529,
										0.262745098039,
										0.223529411765,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 2,
									ix: 5
								},
								lc: 1,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Vector",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 720,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 9,
				ty: 4,
				nm: "Vector",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							27.574,
							17.586,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							0,
							0,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												-0.53,
												-0.47
											],
											[
												0,
												0
											],
											[
												-0.294,
												0.344
											],
											[
												0,
												0
											],
											[
												0.029,
												0.34
											],
											[
												0.255,
												0.22
											],
											[
												0,
												0
											],
											[
												0.334,
												-0.02
											],
											[
												0.223,
												-0.255
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0.533,
												0.47
											],
											[
												0,
												0
											],
											[
												0.214,
												-0.262
											],
											[
												-0.029,
												-0.34
											],
											[
												0,
												0
											],
											[
												-0.251,
												-0.226
											],
											[
												-0.334,
												0.02
											],
											[
												0,
												0
											],
											[
												-0.29,
												0.344
											]
										],
										v: [
											[
												-1.279,
												1.42
											],
											[
												-1.175,
												1.511
											],
											[
												0.326,
												1.74
											],
											[
												1.559,
												0.286
											],
											[
												1.848,
												-0.654
											],
											[
												1.403,
												-1.529
											],
											[
												1.299,
												-1.621
											],
											[
												0.386,
												-1.941
											],
											[
												-0.482,
												-1.512
											],
											[
												-1.719,
												-0.058
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.847058823529,
										0.262745098039,
										0.223529411765,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 2,
									ix: 5
								},
								lc: 1,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Vector",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 720,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 10,
				ty: 4,
				nm: "Vector",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							11.429,
							19.612,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							0,
							0,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												-0.068,
												0.149
											],
											[
												-0.682,
												1.819
											],
											[
												-0.991,
												3.239
											],
											[
												-0.46,
												-0.657
											],
											[
												0.095,
												-1.037
											],
											[
												0.499,
												-1.534
											],
											[
												1.316,
												-3.84
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0.34,
												-0.746
											],
											[
												0.613,
												-1.627
											],
											[
												0.225,
												-0.738
											],
											[
												0.449,
												0.642
											],
											[
												-0.166,
												1.802
											],
											[
												1.191,
												1.535
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-3.612,
												5.648
											],
											[
												-2.248,
												3.396
											],
											[
												-1.614,
												-1.723
											],
											[
												0.176,
												-7.471
											],
											[
												1.982,
												-7.703
											],
											[
												2.765,
												-5.135
											],
											[
												1.895,
												-0.702
											],
											[
												3.057,
												8.12
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.847058823529,
										0.262745098039,
										0.223529411765,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 2,
									ix: 5
								},
								lc: 1,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Vector",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 720,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 11,
				ty: 4,
				nm: "Vector",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							27.542,
							21.506,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							0,
							0,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												-0.523,
												-0.464
											],
											[
												0,
												0
											],
											[
												-0.285,
												0.338
											],
											[
												0,
												0
											],
											[
												0.028,
												0.334
											],
											[
												0.251,
												0.217
											],
											[
												0,
												0
											],
											[
												0.328,
												-0.02
											],
											[
												0.219,
												-0.25
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0.524,
												0.462
											],
											[
												0,
												0
											],
											[
												0.21,
												-0.258
											],
											[
												-0.028,
												-0.334
											],
											[
												0,
												0
											],
											[
												-0.247,
												-0.222
											],
											[
												-0.328,
												0.02
											],
											[
												0,
												0
											],
											[
												-0.286,
												0.338
											]
										],
										v: [
											[
												-1.255,
												1.395
											],
											[
												-1.152,
												1.485
											],
											[
												0.318,
												1.71
											],
											[
												1.53,
												0.282
											],
											[
												1.814,
												-0.643
											],
											[
												1.379,
												-1.503
											],
											[
												1.276,
												-1.593
											],
											[
												0.379,
												-1.908
											],
											[
												-0.475,
												-1.486
											],
											[
												-1.688,
												-0.057
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.847058823529,
										0.262745098039,
										0.223529411765,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 2,
									ix: 5
								},
								lc: 1,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Vector",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 720,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 12,
				ty: 4,
				nm: "Vector",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							27.413,
							9.953,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							0,
							0,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												-0.522,
												-0.562
											],
											[
												0,
												0
											],
											[
												-0.34,
												0.334
											],
											[
												0,
												0
											],
											[
												0.521,
												0.561
											],
											[
												0,
												0
											],
											[
												0.525,
												-0.508
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0.522,
												0.56
											],
											[
												0,
												0
											],
											[
												0.524,
												-0.508
											],
											[
												0,
												0
											],
											[
												-0.521,
												-0.56
											],
											[
												0,
												0
											],
											[
												-0.341,
												0.334
											]
										],
										v: [
											[
												-1.501,
												1.341
											],
											[
												-1.4,
												1.45
											],
											[
												0.168,
												1.867
											],
											[
												1.619,
												0.474
											],
											[
												1.625,
												-1.472
											],
											[
												1.522,
												-1.581
											],
											[
												-0.38,
												-1.677
											],
											[
												-1.831,
												-0.284
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.847058823529,
										0.262745098039,
										0.223529411765,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 2,
									ix: 5
								},
								lc: 1,
								lj: 2,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Vector",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 720,
				st: 0,
				bm: 0
			},
			{
				ddd: 0,
				ind: 13,
				ty: 4,
				nm: "Vector 38",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 0,
						k: [
							16.75,
							18,
							0
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							0,
							0,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												9.25,
												-10
											],
											[
												9.25,
												-14
											],
											[
												-4.25,
												-14
											],
											[
												-4.25,
												-6.5
											],
											[
												-7.75,
												5.5
											],
											[
												-9.75,
												6.5
											],
											[
												-12.75,
												9
											],
											[
												-8.75,
												14
											],
											[
												-2.75,
												13.5
											],
											[
												4.25,
												10.5
											],
											[
												5.25,
												8.5
											],
											[
												8.25,
												8.5
											],
											[
												12.75,
												4
											],
											[
												12.75,
												-10
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Vector 38",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 720,
				st: 0,
				bm: 0
			}
		]
	}
];
var layers$1 = [
	{
		ddd: 0,
		ind: 1,
		ty: 0,
		nm: "Pre-comp 123",
		refId: "comp_0",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 43,
						s: [
							-30
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 52,
						s: [
							-20
						]
					},
					{
						i: {
							x: [
								0.833
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0
							]
						},
						t: 61,
						s: [
							10
						]
					},
					{
						i: {
							x: [
								0.833
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0
							]
						},
						t: 68,
						s: [
							-5
						]
					},
					{
						i: {
							x: [
								0.833
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0
							]
						},
						t: 75,
						s: [
							0
						]
					},
					{
						t: 81,
						s: [
							-15
						]
					}
				],
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 43,
						s: [
							-23,
							22,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 0.667
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 56,
						s: [
							27,
							22,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0
						},
						t: 75,
						s: [
							27,
							22,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 81,
						s: [
							76,
							22,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					16,
					15.5,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		w: 32,
		h: 31,
		ip: 0,
		op: 720,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 0,
		nm: "hand_phone 11",
		refId: "comp_1",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 0,
						s: [
							30
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 12,
						s: [
							-20
						]
					},
					{
						i: {
							x: [
								0.833
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 18,
						s: [
							15
						]
					},
					{
						i: {
							x: [
								0.833
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0
							]
						},
						t: 25,
						s: [
							-10
						]
					},
					{
						i: {
							x: [
								0.833
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0
							]
						},
						t: 31,
						s: [
							5
						]
					},
					{
						i: {
							x: [
								0.833
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0
							]
						},
						t: 37,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.833
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0
							]
						},
						t: 43,
						s: [
							0
						]
					},
					{
						t: 49,
						s: [
							-15
						]
					}
				],
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 0,
						s: [
							28.136,
							83.814,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 12,
						s: [
							28.136,
							19.073,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 0.667
						},
						o: {
							x: 0.333,
							y: 0.333
						},
						t: 18,
						s: [
							28.136,
							21.814,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 43,
						s: [
							28.136,
							21.814,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 49,
						s: [
							72.136,
							21.814,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					16.5,
					17.5,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		w: 33,
		h: 35,
		ip: 0,
		op: 720,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "bg",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					28,
					33.41,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										4.683,
										-1.244
									],
									[
										3.833,
										-2.175
									],
									[
										5.617,
										-4.743
									],
									[
										-2.337,
										-3.978
									],
									[
										-4.911,
										0
									],
									[
										-7.284,
										0.271
									],
									[
										3.63,
										8.882
									],
									[
										2.379,
										4.05
									]
								],
								o: [
									[
										-4.683,
										1.244
									],
									[
										-4.845,
										2.75
									],
									[
										-5.617,
										4.743
									],
									[
										2.788,
										4.747
									],
									[
										4.911,
										0
									],
									[
										5.985,
										0
									],
									[
										-3.63,
										-8.882
									],
									[
										-2.919,
										-4.97
									]
								],
								v: [
									[
										6.105,
										-12.482
									],
									[
										-8.562,
										-14.479
									],
									[
										-17.532,
										-2.178
									],
									[
										-15.407,
										10.471
									],
									[
										-5.389,
										14.998
									],
									[
										10.372,
										14.495
									],
									[
										18.92,
										5.042
									],
									[
										16.842,
										-7.831
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.996078431373,
								0.909803921569,
								0.901960784314,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "bg",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 720,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "icon",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					28,
					28,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ty: "rc",
						d: 1,
						s: {
							a: 0,
							k: [
								50,
								51
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 4
						},
						nm: "Rectangle Path 1",
						mn: "ADBE Vector Shape - Rect",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "icon",
				np: 1,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 720,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 6,
		ty: 4,
		nm: "Shape Layer 12",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.57
							],
							y: [
								0.838
							]
						},
						o: {
							x: [
								0.211
							],
							y: [
								0
							]
						},
						t: 148,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.701
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.305
							],
							y: [
								29.547
							]
						},
						t: 155,
						s: [
							100
						]
					},
					{
						i: {
							x: [
								0
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 173,
						s: [
							100
						]
					},
					{
						t: 185,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 151,
						s: [
							35.872,
							40.156,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							-8.953,
							0.41,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 164,
						s: [
							41.773,
							7.657,
							0
						],
						to: [
							10.458,
							-0.479,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 185,
						s: [
							53,
							20.281,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					14.5,
					-48.875,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					61.451,
					61.451,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										13.75,
										-55.5
									],
									[
										8.5,
										-44.25
									],
									[
										14.75,
										-42.25
									],
									[
										20.5,
										-47.75
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.847058823529,
								0.262745098039,
								0.223529411765,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 146,
		op: 866,
		st: 146,
		bm: 0
	},
	{
		ddd: 0,
		ind: 7,
		ty: 4,
		nm: "Shape Layer 11",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.57
							],
							y: [
								0.831
							]
						},
						o: {
							x: [
								0.209
							],
							y: [
								0
							]
						},
						t: 148,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.701
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.308
							],
							y: [
								29.432
							]
						},
						t: 155,
						s: [
							100
						]
					},
					{
						i: {
							x: [
								0
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 172,
						s: [
							100
						]
					},
					{
						t: 184,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 153,
						s: [
							44.497,
							35.906,
							0
						],
						to: [
							-5.75,
							-28.667,
							0
						],
						ti: [
							6.151,
							1.706,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 166,
						s: [
							21.688,
							2.928,
							0
						],
						to: [
							-6.151,
							-1.706,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 184,
						s: [
							7.593,
							25.669,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-15.875,
					-49.375,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					61.451,
					61.451,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-20.25,
										-53
									],
									[
										-18,
										-45.75
									],
									[
										-11.5,
										-52.25
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.847058823529,
								0.262745098039,
								0.223529411765,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 146,
		op: 866,
		st: 146,
		bm: 0
	},
	{
		ddd: 0,
		ind: 8,
		ty: 4,
		nm: "Shape Layer 10",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.562
							],
							y: [
								0.861
							]
						},
						o: {
							x: [
								0.19
							],
							y: [
								0
							]
						},
						t: 148,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.842
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.363
							],
							y: [
								29.59
							]
						},
						t: 155,
						s: [
							100
						]
					},
					{
						i: {
							x: [
								0
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 173,
						s: [
							100
						]
					},
					{
						t: 185,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 151,
						s: [
							11.372,
							33.41,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							-6.552,
							-0.016,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 164,
						s: [
							30.362,
							2.5,
							0
						],
						to: [
							14.323,
							0.035,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 185,
						s: [
							49.313,
							23.123,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-0.875,
					-49.875,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					61.451,
					61.451,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-5.25,
										-53.25
									],
									[
										-1.25,
										-46.5
									],
									[
										3.5,
										-48.25
									],
									[
										-0.25,
										-51
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.847058823529,
								0.262745098039,
								0.223529411765,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 146,
		op: 866,
		st: 146,
		bm: 0
	},
	{
		ddd: 0,
		ind: 9,
		ty: 4,
		nm: "Shape Layer 9",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.562
							],
							y: [
								0.867
							]
						},
						o: {
							x: [
								0.192
							],
							y: [
								0
							]
						},
						t: 148,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.843
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.359
							],
							y: [
								29.517
							]
						},
						t: 155,
						s: [
							100
						]
					},
					{
						i: {
							x: [
								0
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 174,
						s: [
							100
						]
					},
					{
						t: 186,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 152,
						s: [
							26.863,
							40.156,
							0
						],
						to: [
							5.21,
							-26.042,
							0
						],
						ti: [
							4.246,
							-0.074,
							0
						]
					},
					{
						i: {
							x: 0.686,
							y: 1
						},
						o: {
							x: 0.301,
							y: 0
						},
						t: 163,
						s: [
							19.635,
							5.396,
							0
						],
						to: [
							-11.996,
							0.208,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 186,
						s: [
							3,
							39.906,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-46.625,
					-30.375,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					61.451,
					61.451,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-49.25,
										-35
									],
									[
										-47.25,
										-25.75
									],
									[
										-44,
										-28.5
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.847058823529,
								0.262745098039,
								0.223529411765,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 146,
		op: 866,
		st: 146,
		bm: 0
	},
	{
		ddd: 0,
		ind: 10,
		ty: 4,
		nm: "Shape Layer 8",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.563
							],
							y: [
								0.847
							]
						},
						o: {
							x: [
								0.186
							],
							y: [
								0
							]
						},
						t: 148,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.842
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.371
							],
							y: [
								29.62
							]
						},
						t: 155,
						s: [
							100
						]
					},
					{
						i: {
							x: [
								0
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 171,
						s: [
							100
						]
					},
					{
						t: 183,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 151,
						s: [
							17.997,
							40.156,
							0
						],
						to: [
							9.938,
							-22.458,
							0
						],
						ti: [
							2.187,
							-0.003,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 161,
						s: [
							8.745,
							15.016,
							0
						],
						to: [
							-5.774,
							0.008,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 183,
						s: [
							4.918,
							39.08,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-38.375,
					-38.5,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					61.451,
					61.451,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-36.5,
										-42.25
									],
									[
										-39.75,
										-39.5
									],
									[
										-40.25,
										-34.75
									],
									[
										-36.5,
										-35.75
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.847058823529,
								0.262745098039,
								0.223529411765,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 146,
		op: 866,
		st: 146,
		bm: 0
	},
	{
		ddd: 0,
		ind: 11,
		ty: 4,
		nm: "Shape Layer 7",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.562
							],
							y: [
								0.861
							]
						},
						o: {
							x: [
								0.19
							],
							y: [
								0
							]
						},
						t: 148,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.842
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.363
							],
							y: [
								29.59
							]
						},
						t: 155,
						s: [
							100
						]
					},
					{
						i: {
							x: [
								0
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 173,
						s: [
							100
						]
					},
					{
						t: 185,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 152,
						s: [
							31.872,
							33.41,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							-15.833,
							-1.738,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 165,
						s: [
							41.437,
							3.581,
							0
						],
						to: [
							8.035,
							0.882,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 185,
						s: [
							49.082,
							25.197,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					31,
					-43.625,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					61.451,
					61.451,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										31.75,
										-49.75
									],
									[
										28.75,
										-43.25
									],
									[
										30.5,
										-37.5
									],
									[
										33.25,
										-42
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.847058823529,
								0.262745098039,
								0.223529411765,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 146,
		op: 866,
		st: 146,
		bm: 0
	},
	{
		ddd: 0,
		ind: 12,
		ty: 4,
		nm: "Shape Layer 6",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.57
							],
							y: [
								0.838
							]
						},
						o: {
							x: [
								0.211
							],
							y: [
								0
							]
						},
						t: 4,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.701
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.305
							],
							y: [
								29.547
							]
						},
						t: 11,
						s: [
							100
						]
					},
					{
						i: {
							x: [
								0
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 29,
						s: [
							100
						]
					},
					{
						t: 41,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 7,
						s: [
							35.872,
							40.156,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							-8.953,
							0.41,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 20,
						s: [
							41.773,
							7.657,
							0
						],
						to: [
							10.458,
							-0.479,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 41,
						s: [
							53,
							20.281,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					14.5,
					-48.875,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					61.451,
					61.451,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										13.75,
										-55.5
									],
									[
										8.5,
										-44.25
									],
									[
										14.75,
										-42.25
									],
									[
										20.5,
										-47.75
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.847058823529,
								0.262745098039,
								0.223529411765,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 2,
		op: 722,
		st: 2,
		bm: 0
	},
	{
		ddd: 0,
		ind: 13,
		ty: 4,
		nm: "Shape Layer 5",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.57
							],
							y: [
								0.831
							]
						},
						o: {
							x: [
								0.209
							],
							y: [
								0
							]
						},
						t: 4,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.701
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.308
							],
							y: [
								29.432
							]
						},
						t: 11,
						s: [
							100
						]
					},
					{
						i: {
							x: [
								0
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 28,
						s: [
							100
						]
					},
					{
						t: 40,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 9,
						s: [
							44.497,
							35.906,
							0
						],
						to: [
							-5.75,
							-28.667,
							0
						],
						ti: [
							6.151,
							1.706,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 22,
						s: [
							21.688,
							2.928,
							0
						],
						to: [
							-6.151,
							-1.706,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 40,
						s: [
							7.593,
							25.669,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-15.875,
					-49.375,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					61.451,
					61.451,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-20.25,
										-53
									],
									[
										-18,
										-45.75
									],
									[
										-11.5,
										-52.25
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.847058823529,
								0.262745098039,
								0.223529411765,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 2,
		op: 722,
		st: 2,
		bm: 0
	},
	{
		ddd: 0,
		ind: 14,
		ty: 4,
		nm: "Shape Layer 4",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.562
							],
							y: [
								0.861
							]
						},
						o: {
							x: [
								0.19
							],
							y: [
								0
							]
						},
						t: 4,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.842
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.363
							],
							y: [
								29.59
							]
						},
						t: 11,
						s: [
							100
						]
					},
					{
						i: {
							x: [
								0
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 29,
						s: [
							100
						]
					},
					{
						t: 41,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 7,
						s: [
							11.372,
							33.41,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							-6.552,
							-0.016,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 20,
						s: [
							30.362,
							2.5,
							0
						],
						to: [
							14.323,
							0.035,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 41,
						s: [
							49.313,
							23.123,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-0.875,
					-49.875,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					61.451,
					61.451,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-5.25,
										-53.25
									],
									[
										-1.25,
										-46.5
									],
									[
										3.5,
										-48.25
									],
									[
										-0.25,
										-51
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.847058823529,
								0.262745098039,
								0.223529411765,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 2,
		op: 722,
		st: 2,
		bm: 0
	},
	{
		ddd: 0,
		ind: 15,
		ty: 4,
		nm: "Shape Layer 3",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.562
							],
							y: [
								0.867
							]
						},
						o: {
							x: [
								0.192
							],
							y: [
								0
							]
						},
						t: 4,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.843
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.359
							],
							y: [
								29.517
							]
						},
						t: 11,
						s: [
							100
						]
					},
					{
						i: {
							x: [
								0
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 30,
						s: [
							100
						]
					},
					{
						t: 42,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 8,
						s: [
							26.863,
							40.156,
							0
						],
						to: [
							5.21,
							-26.042,
							0
						],
						ti: [
							4.246,
							-0.074,
							0
						]
					},
					{
						i: {
							x: 0.686,
							y: 1
						},
						o: {
							x: 0.301,
							y: 0
						},
						t: 19,
						s: [
							19.635,
							5.396,
							0
						],
						to: [
							-11.996,
							0.208,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 42,
						s: [
							3,
							39.906,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-46.625,
					-30.375,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					61.451,
					61.451,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-49.25,
										-35
									],
									[
										-47.25,
										-25.75
									],
									[
										-44,
										-28.5
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.847058823529,
								0.262745098039,
								0.223529411765,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 2,
		op: 722,
		st: 2,
		bm: 0
	},
	{
		ddd: 0,
		ind: 16,
		ty: 4,
		nm: "Shape Layer 1",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.563
							],
							y: [
								0.847
							]
						},
						o: {
							x: [
								0.186
							],
							y: [
								0
							]
						},
						t: 4,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.842
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.371
							],
							y: [
								29.62
							]
						},
						t: 11,
						s: [
							100
						]
					},
					{
						i: {
							x: [
								0
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 27,
						s: [
							100
						]
					},
					{
						t: 39,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 7,
						s: [
							17.997,
							40.156,
							0
						],
						to: [
							9.938,
							-22.458,
							0
						],
						ti: [
							2.187,
							-0.003,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 17,
						s: [
							8.745,
							15.016,
							0
						],
						to: [
							-5.774,
							0.008,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 39,
						s: [
							4.918,
							39.08,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-38.375,
					-38.5,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					61.451,
					61.451,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-36.5,
										-42.25
									],
									[
										-39.75,
										-39.5
									],
									[
										-40.25,
										-34.75
									],
									[
										-36.5,
										-35.75
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.847058823529,
								0.262745098039,
								0.223529411765,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 2,
		op: 722,
		st: 2,
		bm: 0
	},
	{
		ddd: 0,
		ind: 17,
		ty: 4,
		nm: "Shape Layer 2",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.562
							],
							y: [
								0.861
							]
						},
						o: {
							x: [
								0.19
							],
							y: [
								0
							]
						},
						t: 4,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.842
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.363
							],
							y: [
								29.59
							]
						},
						t: 11,
						s: [
							100
						]
					},
					{
						i: {
							x: [
								0
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 29,
						s: [
							100
						]
					},
					{
						t: 41,
						s: [
							0
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 8,
						s: [
							31.872,
							33.41,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							-15.833,
							-1.738,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 21,
						s: [
							41.437,
							3.581,
							0
						],
						to: [
							8.035,
							0.882,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 41,
						s: [
							49.082,
							25.197,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					31,
					-43.625,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					61.451,
					61.451,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										31.75,
										-49.75
									],
									[
										28.75,
										-43.25
									],
									[
										30.5,
										-37.5
									],
									[
										33.25,
										-42
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.847058823529,
								0.262745098039,
								0.223529411765,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 2,
		op: 722,
		st: 2,
		bm: 0
	}
];
var markers$1 = [
];
var offerSentData = {
	v: v$1,
	meta: meta,
	fr: fr$1,
	ip: ip$1,
	op: op$1,
	w: w$1,
	h: h$1,
	nm: nm$1,
	ddd: ddd$1,
	assets: assets$1,
	layers: layers$1,
	markers: markers$1
};

var sortOutlets = function (latLong, outlets, region) {
    if (region === void 0) { region = 'SG'; }
    if (outlets && outlets.length > 0) {
        if (!isEmpty$1(latLong)) {
            var outletsData = outlets.map(function (outlet) {
                return __assign(__assign({}, outlet), { distance: !isEmpty$1(outlet.latLong)
                        ? haversineDistance([latLong.latitude, latLong.longitude], outlet.latLong, region === REGIONS.US)
                        : null });
            });
            outletsData.sort(function (a, b) {
                if (a.distance === undefined || a.distance === null) {
                    return 1;
                }
                if (b.distance === undefined || b.distance === null) {
                    return -1;
                }
                return a.distance - b.distance;
            });
            return outletsData;
        }
        return outlets;
    }
    return [];
};

var baseGetTag$1 = _baseGetTag,
    isArray$3 = isArray_1,
    isObjectLike$1 = isObjectLike_1;

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString$3(value) {
  return typeof value == 'string' ||
    (!isArray$3(value) && isObjectLike$1(value) && baseGetTag$1(value) == stringTag);
}

var isString_1 = isString$3;

var isString$4 = /*@__PURE__*/getDefaultExportFromCjs(isString_1);

var arrayMap$1 = _arrayMap;

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues$1(object, props) {
  return arrayMap$1(props, function(key) {
    return object[key];
  });
}

var _baseValues = baseValues$1;

var baseValues = _baseValues,
    keys = keys_1;

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values$1(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

var values_1 = values$1;

var baseIndexOf = _baseIndexOf,
    isArrayLike$2 = isArrayLike_1,
    isString$2 = isString_1,
    toInteger$2 = toInteger_1,
    values = values_1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike$2(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger$2(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString$2(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

var includes_1 = includes;

var includes$1 = /*@__PURE__*/getDefaultExportFromCjs(includes_1);

var Container$8 = defaultStyled.div(templateObject_1$v || (templateObject_1$v = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n\n  font-family: ", ";\n  color: ", ";\n\n  .search-input {\n    border-radius: 10px !important;\n    margin: 1rem 0;\n  }\n"], ["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n\n  font-family: ", ";\n  color: ", ";\n\n  .search-input {\n    border-radius: 10px !important;\n    margin: 1rem 0;\n  }\n"])), function (_a) {
    var $fontFamily = _a.$fontFamily;
    return $fontFamily;
}, function (_a) {
    var $color = _a.$color;
    return $color;
});
var Title$6 = defaultStyled.div(templateObject_2$p || (templateObject_2$p = __makeTemplateObject(["\n  margin: 1.5rem 0;\n  margin-top: 2rem;\n  font-size: 24px;\n  line-height: 28.8px;\n  text-align: center !important;\n  font-weight: 600;\n"], ["\n  margin: 1.5rem 0;\n  margin-top: 2rem;\n  font-size: 24px;\n  line-height: 28.8px;\n  text-align: center !important;\n  font-weight: 600;\n"])));
var LocationContainer = defaultStyled.div(templateObject_3$f || (templateObject_3$f = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1rem;\n\n  @media (min-width: 768px) {\n    grid-template-columns: 1fr 1fr;\n  }\n"], ["\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1rem;\n\n  @media (min-width: 768px) {\n    grid-template-columns: 1fr 1fr;\n  }\n"])));
var LocationCard = defaultStyled.div(templateObject_4$a || (templateObject_4$a = __makeTemplateObject(["\n  background-color: var(--white);\n  border: 1px solid var(--grey-light);\n  border-radius: 0.5rem;\n  padding: 1rem 1.5rem;\n  cursor: pointer;\n"], ["\n  background-color: var(--white);\n  border: 1px solid var(--grey-light);\n  border-radius: 0.5rem;\n  padding: 1rem 1.5rem;\n  cursor: pointer;\n"])));
var LocationName = defaultStyled.div(templateObject_5$9 || (templateObject_5$9 = __makeTemplateObject(["\n  margin: 0;\n  font-size: 1.25rem;\n  color: var(--grey-dark);\n  font-weight: 600;\n  text-align: left !important;\n  direction: ltr !important;\n"], ["\n  margin: 0;\n  font-size: 1.25rem;\n  color: var(--grey-dark);\n  font-weight: 600;\n  text-align: left !important;\n  direction: ltr !important;\n"])));
var LocationAddress = defaultStyled.p(templateObject_6$7 || (templateObject_6$7 = __makeTemplateObject(["\n  margin: 0.5rem 0;\n  font-size: 1rem;\n  color: var(--grey);\n  text-align: left !important;\n  direction: ltr !important;\n"], ["\n  margin: 0.5rem 0;\n  font-size: 1rem;\n  color: var(--grey);\n  text-align: left !important;\n  direction: ltr !important;\n"])));
var LocationDistance = defaultStyled.p(templateObject_7$4 || (templateObject_7$4 = __makeTemplateObject(["\n  margin: 0;\n  font-size: 0.875rem;\n  color: var(--grey);\n  text-align: left !important;\n  direction: ltr !important;\n"], ["\n  margin: 0;\n  font-size: 0.875rem;\n  color: var(--grey);\n  text-align: left !important;\n  direction: ltr !important;\n"])));
var ModalContainer = defaultStyled.div(templateObject_8$3 || (templateObject_8$3 = __makeTemplateObject(["\n  font-family: ", ";\n  color: ", ";\n\n  .confirm-button span,\n  .cancel-button span {\n    font-family: inherit;\n  }\n"], ["\n  font-family: ", ";\n  color: ", ";\n\n  .confirm-button span,\n  .cancel-button span {\n    font-family: inherit;\n  }\n"])), function (_a) {
    var $fontFamily = _a.$fontFamily;
    return $fontFamily;
}, function (_a) {
    var $color = _a.$color;
    return $color;
});
var filterOutlets = function (outlets, search) {
    if (outlets === void 0) { outlets = []; }
    if (!search)
        return outlets;
    var searchLowerCase = search.toLowerCase();
    return outlets === null || outlets === void 0 ? void 0 : outlets.filter(function (outlet) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        return includes$1((_b = (_a = outlet === null || outlet === void 0 ? void 0 : outlet.name) === null || _a === void 0 ? void 0 : _a.toLowerCase) === null || _b === void 0 ? void 0 : _b.call(_a), searchLowerCase) ||
            includes$1((_d = (_c = outlet === null || outlet === void 0 ? void 0 : outlet.locationName) === null || _c === void 0 ? void 0 : _c.toLowerCase) === null || _d === void 0 ? void 0 : _d.call(_c), searchLowerCase) ||
            includes$1((_f = (_e = outlet === null || outlet === void 0 ? void 0 : outlet.address) === null || _e === void 0 ? void 0 : _e.toLowerCase) === null || _f === void 0 ? void 0 : _f.call(_e), searchLowerCase) ||
            includes$1((_h = (_g = outlet === null || outlet === void 0 ? void 0 : outlet.address2) === null || _g === void 0 ? void 0 : _g.toLowerCase) === null || _h === void 0 ? void 0 : _h.call(_g), searchLowerCase) ||
            includes$1((_k = (_j = outlet === null || outlet === void 0 ? void 0 : outlet.city) === null || _j === void 0 ? void 0 : _j.toLowerCase) === null || _k === void 0 ? void 0 : _k.call(_j), searchLowerCase) ||
            includes$1((_m = (_l = outlet === null || outlet === void 0 ? void 0 : outlet.state) === null || _l === void 0 ? void 0 : _l.toLowerCase) === null || _m === void 0 ? void 0 : _m.call(_l), searchLowerCase);
    });
};
var formatAddress = function (outlet) {
    var formattedAddress = [];
    if (outlet.address) {
        formattedAddress.push(outlet.address);
    }
    if (outlet === null || outlet === void 0 ? void 0 : outlet.address2) {
        formattedAddress.push(outlet === null || outlet === void 0 ? void 0 : outlet.address2);
    }
    if (outlet.city) {
        formattedAddress.push(outlet.city);
    }
    if (outlet.state) {
        formattedAddress.push(outlet.state);
    }
    if (formattedAddress.length) {
        return formattedAddress.join(', ');
    }
    return 'No Address Available';
};
function LocationPage(_a) {
    var configuration = _a.configuration, brand = _a.brand, outlets = _a.outlets, onNext = _a.onNext, isLocationPage = _a.isLocationPage;
    var _b = useContext(RedemptionContext), t = _b.t, form = _b.form, editorMode = _b.editorMode;
    var latLong = (editorMode ? {} : useLocation({ isLocationVisible: true })).latLong;
    var _c = useState(''), search = _c[0], setSearch = _c[1];
    var _d = useState(false), showConfirm = _d[0], setShowConfirm = _d[1];
    var _e = configuration || {}, _f = _e.brandFont, brandFont = _f === void 0 ? 'var(--font-family-regular)' : _f, _g = _e.themeColor, themeColor = _g === void 0 ? 'var(--indian-red)' : _g, _h = _e.showBrandName, showBrandName = _h === void 0 ? true : _h, brandName = _e.brandName, _j = _e.showLogo, showLogo = _j === void 0 ? true : _j;
    var _k = brand || {}, name = _k.name, logoUrl = _k.logoUrl;
    var locations = useMemo(function () {
        var sorted = sortOutlets(latLong, outlets);
        var searched = filterOutlets(sorted, search);
        return searched;
    }, [latLong, search, outlets]);
    var onSelectLocation = function (outletId) {
        if (isLocationPage)
            return;
        form.setFieldsValue({
            outletId: outletId
        });
        setShowConfirm(true);
    };
    var onCloseConfirm = function () {
        setShowConfirm(false);
    };
    return (React__default.createElement(Container$8, { "$fontFamily": brandFont, "$color": themeColor, "data-testid": "location-page" },
        React__default.createElement(OfferLogo, { showBrandName: showBrandName, showLogo: showLogo, logo: logoUrl, brandName: brandName || name }),
        React__default.createElement(Title$6, null, isLocationPage ? t('offer.pages.location.outletTitle') : t('offer.pages.location.title')),
        React__default.createElement(Input, { placeholder: t('offer.pages.location.search'), className: "search-input", onChange: function (e) { return setSearch(e.target.value); } }),
        React__default.createElement(Form.Item, { name: "outletId" },
            React__default.createElement(LocationContainer, null, map$1(locations, function (location) { return (React__default.createElement(LocationCard, { key: location === null || location === void 0 ? void 0 : location.id, onClick: function () { return onSelectLocation(location === null || location === void 0 ? void 0 : location.id); }, className: "location-card" },
                React__default.createElement(LocationName, null, location.name),
                React__default.createElement(LocationAddress, null,
                    React__default.createElement(SvgMapPin$1, null),
                    " ",
                    formatAddress(location)),
                location.distance && !isNaN(location.distance) && (React__default.createElement(LocationDistance, null,
                    React__default.createElement(SvgCornerUpRight, null),
                    " ",
                    location.distance.toFixed(1),
                    " ",
                    brand.region === 'US' ? 'mi' : 'km',
                    ' ',
                    t('offer.pages.location.distance'))))); }))),
        React__default.createElement(Modal, { visible: showConfirm, centered: true, footer: null, onCancel: onCloseConfirm },
            React__default.createElement(ModalContainer, { "$fontFamily": brandFont },
                React__default.createElement(Title$6, null, t('offer.pages.location.confirmTitle')),
                React__default.createElement(Button, { "$disabledHover": true, onClick: function () {
                        var values = form.getFieldsValue(true);
                        onNext === null || onNext === void 0 ? void 0 : onNext(values);
                        onCloseConfirm();
                    }, "$color": themeColor, className: "w-full mt-4 confirm-button" }, t('offer.pages.location.confirmButon')),
                React__default.createElement(Button, { type: "default", onClick: onCloseConfirm, "$color": themeColor, className: "w-full mt-4 cancel-button", "$disabledHover": true }, t('offer.pages.location.cancelButon'))))));
}
var templateObject_1$v, templateObject_2$p, templateObject_3$f, templateObject_4$a, templateObject_5$9, templateObject_6$7, templateObject_7$4, templateObject_8$3;

var Container$7 = defaultStyled.div(templateObject_1$u || (templateObject_1$u = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n\n  font-family: ", ";\n  color: ", ";\n\n  .search-input {\n    border-radius: 10px !important;\n    margin: 1rem 0;\n  }\n  .show-code-btn {\n    text-transform: capitalize;\n  }\n  .voucher-code {\n    padding: 0.5rem;\n    border-top: 1px solid var(--grey-light);\n    border-bottom: 1px solid var(--grey-light);\n\n    .voucher-code-title {\n      text-align: center !important;\n      color: var(--grey-dark);\n      font-size: 16px;\n      line-height: 24px;\n    }\n\n    .voucher-code-main {\n      text-align: center !important;\n      font-size: 24px;\n      font-weight: 700;\n      color: ", ";\n      letter-spacing: 0.2rem;\n    }\n  }\n"], ["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n\n  font-family: ", ";\n  color: ", ";\n\n  .search-input {\n    border-radius: 10px !important;\n    margin: 1rem 0;\n  }\n  .show-code-btn {\n    text-transform: capitalize;\n  }\n  .voucher-code {\n    padding: 0.5rem;\n    border-top: 1px solid var(--grey-light);\n    border-bottom: 1px solid var(--grey-light);\n\n    .voucher-code-title {\n      text-align: center !important;\n      color: var(--grey-dark);\n      font-size: 16px;\n      line-height: 24px;\n    }\n\n    .voucher-code-main {\n      text-align: center !important;\n      font-size: 24px;\n      font-weight: 700;\n      color: ", ";\n      letter-spacing: 0.2rem;\n    }\n  }\n"])), function (_a) {
    var $fontFamily = _a.$fontFamily;
    return $fontFamily;
}, function (_a) {
    var $color = _a.$color;
    return $color;
}, function (_a) {
    var $color = _a.$color;
    return $color;
});
var LottieContainer = defaultStyled.div(templateObject_2$o || (templateObject_2$o = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  width: 100%;\n"], ["\n  display: flex;\n  justify-content: center;\n  width: 100%;\n"])));
var Title$5 = defaultStyled.div(templateObject_3$e || (templateObject_3$e = __makeTemplateObject(["\n  margin: 0.5rem 0 1.5rem;\n  font-size: 24px;\n  line-height: 28.8px;\n  text-align: center !important;\n  font-weight: 600;\n  .main-title {\n    color: ", ";\n    font-weight: 600;\n  }\n  span {\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 28.8px;\n    text-align: center !important;\n    font-family: inherit;\n  }\n"], ["\n  margin: 0.5rem 0 1.5rem;\n  font-size: 24px;\n  line-height: 28.8px;\n  text-align: center !important;\n  font-weight: 600;\n  .main-title {\n    color: ", ";\n    font-weight: 600;\n  }\n  span {\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 28.8px;\n    text-align: center !important;\n    font-family: inherit;\n  }\n"])), function (_a) {
    var $color = _a.$color;
    return $color;
});
var Summary = defaultStyled.div(templateObject_4$9 || (templateObject_4$9 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  font-size: 16px;\n  padding: 1.25rem;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  font-size: 16px;\n  padding: 1.25rem;\n  align-items: center;\n"])));
var SummaryItem = defaultStyled.div(templateObject_5$8 || (templateObject_5$8 = __makeTemplateObject(["\n  display: flex;\n  gap: 0.75rem;\n  align-items: center;\n  color: var(--grey-dark);\n  min-width: 345px;\n  width: fit-content;\n"], ["\n  display: flex;\n  gap: 0.75rem;\n  align-items: center;\n  color: var(--grey-dark);\n  min-width: 345px;\n  width: fit-content;\n"])));
var SummaryValue = defaultStyled.div(templateObject_6$6 || (templateObject_6$6 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 16px;\n"], ["\n  color: ", ";\n  font-size: 16px;\n"])), function (_a) {
    var $color = _a.$color;
    return $color;
});
var ScanCodeTitle = {
    barcode: 'barcode',
    qr: 'QR code'
};
function ConfirmationPage(_a) {
    var _b, _c;
    var voucher = _a.voucher, configuration = _a.configuration, brand = _a.brand, outlets = _a.outlets, voucherInstance = _a.voucherInstance;
    var _d = useContext(RedemptionContext), t = _d.t, language = _d.language; _d.form;
    var _e = useState(false), voucherScanModal = _e[0], setVoucherScanModal = _e[1];
    var _f = useState(false), showCopiedCode = _f[0], setShowCopiedCode = _f[1];
    var _g = configuration || {}, _h = _g.brandFont, brandFont = _h === void 0 ? 'var(--font-family-regular)' : _h, _j = _g.themeColor, themeColor = _j === void 0 ? 'var(--indian-red)' : _j, _k = _g.showBrandName, showBrandName = _k === void 0 ? true : _k, brandName = _g.brandName, _l = _g.showOfferCard, showOfferCard = _l === void 0 ? true : _l, _m = _g.showLogo, showLogo = _m === void 0 ? true : _m;
    var _o = brand || {}, name = _o.name, logoUrl = _o.logoUrl;
    var redemptionDate = useMemo(function () { return moment(); }, []);
    var renderLottieIcon = function () {
        try {
            return React__default.createElement(Lottie, { animationData: offerSentData, loop: true, style: { width: 158 } });
        }
        catch (error) {
            console.error(error);
            return React__default.createElement(React__default.Fragment, null);
        }
    };
    var scanable = useMemo(function () {
        var _a, _b;
        if (!voucherInstance || !((_a = voucherInstance === null || voucherInstance === void 0 ? void 0 : voucherInstance.scanData) === null || _a === void 0 ? void 0 : _a.scanType))
            return null;
        return (React__default.createElement(Button, { "$disabledHover": true, block: true, shape: "round", onClick: function () {
                setVoucherScanModal(true);
            }, "$color": themeColor, className: "show-code-btn mb-4 text-center" },
            t('offer.pages.confirmation.show'),
            " ",
            ScanCodeTitle[(_b = voucherInstance === null || voucherInstance === void 0 ? void 0 : voucherInstance.scanData) === null || _b === void 0 ? void 0 : _b.scanType]));
    }, [t, (_b = voucherInstance === null || voucherInstance === void 0 ? void 0 : voucherInstance.scanData) === null || _b === void 0 ? void 0 : _b.scanType]);
    var titleType = useMemo(function () {
        var _a, _b;
        if (((_a = voucherInstance === null || voucherInstance === void 0 ? void 0 : voucherInstance.scanData) === null || _a === void 0 ? void 0 : _a.scanType) == 'barcode') {
            return 'offer.pages.confirmation.title.barcode';
        }
        if (((_b = voucherInstance === null || voucherInstance === void 0 ? void 0 : voucherInstance.scanData) === null || _b === void 0 ? void 0 : _b.scanType) == 'qr') {
            return 'offer.pages.confirmation.title.qr';
        }
        return 'offer.pages.confirmation.title';
    }, [(_c = voucherInstance === null || voucherInstance === void 0 ? void 0 : voucherInstance.scanData) === null || _c === void 0 ? void 0 : _c.scanType]);
    var copyCode = function () {
        if (voucherInstance === null || voucherInstance === void 0 ? void 0 : voucherInstance.code) {
            copy$1(voucherInstance.code);
            setShowCopiedCode(true);
            setTimeout(function () {
                setShowCopiedCode(false);
            }, 2000);
        }
    };
    return (React__default.createElement(Container$7, { "$fontFamily": brandFont, "$color": themeColor, "data-testid": "confirmation-page" },
        React__default.createElement(OfferLogo, { showBrandName: showBrandName, showLogo: showLogo, logo: logoUrl, brandName: brandName || name, className: "mt-4" }),
        showOfferCard && React__default.createElement(OfferCard, { voucher: voucher, t: t, className: "mt-4", locale: language }),
        React__default.createElement(LottieContainer, null, renderLottieIcon()),
        !((voucherInstance === null || voucherInstance === void 0 ? void 0 : voucherInstance.platformUrl) && voucherInstance.platformUrl !== null) && (React__default.createElement(Title$5, { "$color": themeColor },
            React__default.createElement("span", { className: "main-title block" }, t(titleType)),
            ' ',
            React__default.createElement("span", { className: "sub-title" }, t('offer.pages.confirmation.title2')))),
        scanable,
        (voucherInstance === null || voucherInstance === void 0 ? void 0 : voucherInstance.code) && (React__default.createElement("div", { className: "voucher-code" },
            React__default.createElement("div", { className: "voucher-code-title" }, t('offer.pages.confirmation.couponCode')),
            React__default.createElement("div", { className: "voucher-code-main" },
                voucherInstance.code,
                showCopiedCode ? (React__default.createElement(SvgCheckCircle, { className: "ml-4" })) : (React__default.createElement(SvgCopy, { className: "ml-4 hover:cursor-pointer", onClick: copyCode }))))),
        (voucherInstance === null || voucherInstance === void 0 ? void 0 : voucherInstance.platformUrl) && (React__default.createElement(Button, { block: true, "$disabledHover": true, shape: "round", onClick: function () {
                if (voucherInstance.platformUrl !== null) {
                    window.open(voucherInstance.platformUrl, '_blank');
                }
            }, "$color": themeColor, className: "show-code-btn text-center" }, "Use This Offer")),
        React__default.createElement(Summary, null,
            React__default.createElement(SummaryItem, null,
                React__default.createElement(SvgClock$1, null),
                " ",
                t('offer.pages.confirmation.timeOfRedemption'),
                ":",
                React__default.createElement(SummaryValue, { "$color": themeColor }, redemptionDate === null || redemptionDate === void 0 ? void 0 : redemptionDate.format('h:mm A'))),
            React__default.createElement(SummaryItem, null,
                React__default.createElement(SvgDate, null),
                " ",
                t('offer.pages.confirmation.dateOfRedemption'),
                ":",
                React__default.createElement(SummaryValue, { "$color": themeColor }, redemptionDate === null || redemptionDate === void 0 ? void 0 : redemptionDate.format('MMM D, YYYY'))),
            React__default.createElement(Form.Item, { shouldUpdate: function (prevValues, currentValues) { return prevValues.outletId !== currentValues.outletId; }, className: "mb-0" }, function (_a) {
                var getFieldValue = _a.getFieldValue;
                var outletId = getFieldValue('outletId');
                var outlet = find$1(outlets, { id: outletId });
                if (outlet)
                    return (React__default.createElement(SummaryItem, null,
                        React__default.createElement(SvgMapPin$1, null),
                        React__default.createElement(SummaryValue, { "$color": 'var(--grey-dark)' }, formatAddress(outlet))));
            })),
        (voucherInstance === null || voucherInstance === void 0 ? void 0 : voucherInstance.scanData) && (voucherInstance === null || voucherInstance === void 0 ? void 0 : voucherInstance.code) && (React__default.createElement(QRCodeModal, { title: t(titleType), visible: voucherScanModal, data: voucherInstance.scanData, code: voucherInstance.code, onCancel: function () {
                setVoucherScanModal(false);
            }, color: themeColor }))));
}
var templateObject_1$u, templateObject_2$o, templateObject_3$e, templateObject_4$9, templateObject_5$8, templateObject_6$6;

var Container$6 = defaultStyled.div(templateObject_1$t || (templateObject_1$t = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n  color: ", ";\n  font-family: ", ";\n\n  .instructions-container {\n    width: 100%;\n    margin: 0 auto 1rem;\n    padding: 1rem;\n    background-color: #fff;\n  }\n\n  .steps {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .step {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n  }\n\n  .step-number {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 32px;\n    height: 32px;\n    background-color: ", ";\n    color: #fff;\n    border-radius: 50%;\n    font-size: 18px;\n  }\n\n  .step-content {\n    flex: 1;\n    color: var(--grey-dark);\n  }\n\n  .view-locations {\n    display: block;\n    color: ", ";\n    text-decoration: none;\n    margin-top: 5px;\n  }\n\n  .view-locations:hover {\n    text-decoration: underline;\n  }\n  .vaild-from {\n    text-align: center;\n    margin-top: 1.5rem;\n\n    .vaild-from-title {\n      color: var(--grey-dark);\n    }\n\n    .datetime {\n      font-weight: 700;\n    }\n  }\n"], ["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n  color: ", ";\n  font-family: ", ";\n\n  .instructions-container {\n    width: 100%;\n    margin: 0 auto 1rem;\n    padding: 1rem;\n    background-color: #fff;\n  }\n\n  .steps {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .step {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n  }\n\n  .step-number {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 32px;\n    height: 32px;\n    background-color: ", ";\n    color: #fff;\n    border-radius: 50%;\n    font-size: 18px;\n  }\n\n  .step-content {\n    flex: 1;\n    color: var(--grey-dark);\n  }\n\n  .view-locations {\n    display: block;\n    color: ", ";\n    text-decoration: none;\n    margin-top: 5px;\n  }\n\n  .view-locations:hover {\n    text-decoration: underline;\n  }\n  .vaild-from {\n    text-align: center;\n    margin-top: 1.5rem;\n\n    .vaild-from-title {\n      color: var(--grey-dark);\n    }\n\n    .datetime {\n      font-weight: 700;\n    }\n  }\n"])), function (_a) {
    var $color = _a.$color;
    return $color;
}, function (_a) {
    var $fontFamily = _a.$fontFamily;
    return $fontFamily;
}, function (_a) {
    var $color = _a.$color;
    return $color;
}, function (_a) {
    var $color = _a.$color;
    return $color;
});
var Title$4 = defaultStyled.div(templateObject_2$n || (templateObject_2$n = __makeTemplateObject(["\n  margin: 1.5rem 0;\n  margin-top: 2rem;\n  font-size: 24px;\n  line-height: 28.8px;\n  text-align: center !important;\n  font-weight: 600;\n"], ["\n  margin: 1.5rem 0;\n  margin-top: 2rem;\n  font-size: 24px;\n  line-height: 28.8px;\n  text-align: center !important;\n  font-weight: 600;\n"])));
function InstructionsPage(_a) {
    var _b, _c;
    var voucher = _a.voucher, configuration = _a.configuration, voucherInstance = _a.voucherInstance, brand = _a.brand, isOnline = _a.isOnline, onNext = _a.onNext;
    var _d = useContext(RedemptionContext), t = _d.t, language = _d.language, editorMode = _d.editorMode;
    var _e = configuration || {}, _f = _e.brandFont, brandFont = _f === void 0 ? 'var(--font-family-regular)' : _f, _g = _e.themeColor, themeColor = _g === void 0 ? 'var(--indian-red)' : _g, _h = _e.showBrandName, showBrandName = _h === void 0 ? true : _h, brandName = _e.brandName, _j = _e.showOfferCard, showOfferCard = _j === void 0 ? true : _j, _k = _e.showLogo, showLogo = _k === void 0 ? true : _k;
    var _l = brand || {}, name = _l.name, logoUrl = _l.logoUrl;
    var voucherStartDate = moment(get$2(voucher, 'startDate'));
    var validDate = voucherInstance && voucherInstance.createdAt
        ? (function () {
            var voucherInstanceRedeemableDate = voucher.blackOutHours
                ? moment(voucherInstance.createdAt).add(voucher.blackOutHours, 'hours')
                : moment(voucherInstance.createdAt);
            return voucherInstanceRedeemableDate.isAfter(voucherStartDate)
                ? voucherInstanceRedeemableDate.format(DATETIME_FORMAT)
                : voucherStartDate.format(DATETIME_FORMAT);
        })()
        : voucherStartDate.format(DATETIME_FORMAT);
    var locationPath = "".concat((_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.origin).concat((_c = window === null || window === void 0 ? void 0 : window.location) === null || _c === void 0 ? void 0 : _c.pathname, "/outlets");
    return (React__default.createElement(Container$6, { "$fontFamily": brandFont, "$color": themeColor, "data-testid": "instructions-page" },
        React__default.createElement(OfferLogo, { showBrandName: showBrandName, showLogo: showLogo, logo: logoUrl, brandName: brandName || name }),
        showOfferCard && React__default.createElement(OfferCard, { voucher: voucher, className: "mt-20", t: t, locale: language }),
        React__default.createElement(Title$4, null, t('offer.pages.instructions.title')),
        React__default.createElement("div", { className: "instructions-container" },
            React__default.createElement("div", { className: "steps" },
                React__default.createElement("div", { className: "step" },
                    React__default.createElement("span", { className: "step-number" }, "1"),
                    React__default.createElement("div", { className: "step-content" },
                        isOnline ? t('offer.pages.instructions.step1Online') : t('offer.pages.instructions.step1'),
                        !isOnline && (React__default.createElement("a", { href: editorMode ? '#' : locationPath, className: "view-locations" },
                            t('offer.pages.instructions.viewLocations'),
                            " \u2192")))),
                React__default.createElement("div", { className: "step" },
                    React__default.createElement("span", { className: "step-number" }, "2"),
                    React__default.createElement("div", { className: "step-content" }, isOnline ? t('offer.pages.instructions.step2Online') : t('offer.pages.instructions.step2'))),
                React__default.createElement("div", { className: "step" },
                    React__default.createElement("span", { className: "step-number" }, "3"),
                    React__default.createElement("div", { className: "step-content" }, isOnline ? t('offer.pages.instructions.step3Online') : t('offer.pages.instructions.step3'))))),
        React__default.createElement(Button, { onClick: onNext, "$color": themeColor, "$disabledHover": true, className: "text-center" }, t('offer.pages.instructions.buttonText')),
        validDate && (React__default.createElement("div", { className: "vaild-from text-center" },
            React__default.createElement("div", { className: "vaild-from-title text-center" },
                t('offer.pages.instructions.vaildText'),
                ":"),
            React__default.createElement("div", { className: "datetime text-center" }, validDate)))));
}
var templateObject_1$t, templateObject_2$n;

var Container$5 = defaultStyled.div(templateObject_1$s || (templateObject_1$s = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n\n  font-family: ", ";\n  color: ", ";\n\n  .ant-form-item {\n    .ant-form-item-label,\n    .ant-input-affix-wrapper,\n    label,\n    input {\n      font-family: inherit;\n    }\n  }\n\n  .search-input {\n    border-radius: 10px !important;\n    margin: 1rem 0;\n  }\n  .ant-input-prefix {\n    margin: 0 4px;\n  }\n  .saleamount-input {\n    input {\n      padding-top: 2px;\n    }\n  }\n  .skip-btn span,\n  .ant-input-prefix,\n  .submit-btn span {\n    font-family: inherit;\n  }\n"], ["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n\n  font-family: ", ";\n  color: ", ";\n\n  .ant-form-item {\n    .ant-form-item-label,\n    .ant-input-affix-wrapper,\n    label,\n    input {\n      font-family: inherit;\n    }\n  }\n\n  .search-input {\n    border-radius: 10px !important;\n    margin: 1rem 0;\n  }\n  .ant-input-prefix {\n    margin: 0 4px;\n  }\n  .saleamount-input {\n    input {\n      padding-top: 2px;\n    }\n  }\n  .skip-btn span,\n  .ant-input-prefix,\n  .submit-btn span {\n    font-family: inherit;\n  }\n"])), function (_a) {
    var $fontFamily = _a.$fontFamily;
    return $fontFamily;
}, function (_a) {
    var $color = _a.$color;
    return $color;
});
var Title$3 = defaultStyled.div(templateObject_2$m || (templateObject_2$m = __makeTemplateObject(["\n  margin: 1.5rem 0;\n  margin-top: 2rem;\n  font-size: 24px;\n  line-height: 28.8px;\n  text-align: center !important;\n  word-break: break-word;\n  color: inherit;\n  font-weight: 600;\n\n  p,\n  * {\n    word-break: break-word;\n    font-size: 24px;\n    line-height: 28.8px;\n    font-weight: 600;\n    font-family: inherit;\n    color: inherit;\n    text-align: center !important;\n  }\n"], ["\n  margin: 1.5rem 0;\n  margin-top: 2rem;\n  font-size: 24px;\n  line-height: 28.8px;\n  text-align: center !important;\n  word-break: break-word;\n  color: inherit;\n  font-weight: 600;\n\n  p,\n  * {\n    word-break: break-word;\n    font-size: 24px;\n    line-height: 28.8px;\n    font-weight: 600;\n    font-family: inherit;\n    color: inherit;\n    text-align: center !important;\n  }\n"])));
function OrderAmountPage(_a) {
    var voucher = _a.voucher, configuration = _a.configuration, brand = _a.brand;
    var _b = useContext(RedemptionContext), t = _b.t, translation = _b.translation, form = _b.form, language = _b.language;
    var _c = configuration || {}, _d = _c.brandFont, brandFont = _d === void 0 ? 'var(--font-family-regular)' : _d, _e = _c.themeColor, themeColor = _e === void 0 ? 'var(--indian-red)' : _e, _f = _c.showBrandName, showBrandName = _f === void 0 ? true : _f, brandName = _c.brandName, _g = _c.showLogo, showLogo = _g === void 0 ? true : _g;
    var _h = brand || {}, name = _h.name, logoUrl = _h.logoUrl;
    var voucherCurrency = get$2(voucher, 'voucherData.currency', brand.region && (CURRENCIES === null || CURRENCIES === void 0 ? void 0 : CURRENCIES[brand.region]));
    var showSkipBtn = voucher.withSaleAmount !== 'MANDATORY';
    var requiredSaleAmount = voucher.withSaleAmount === 'MANDATORY';
    return (React__default.createElement(Container$5, { "$fontFamily": brandFont, "$color": themeColor, "data-testid": "order-amount-page" },
        React__default.createElement(OfferLogo, { showBrandName: showBrandName, showLogo: showLogo, logo: logoUrl, brandName: brandName || name }),
        React__default.createElement(OfferCard, { voucher: voucher, className: "mt-20", t: t, locale: language }),
        React__default.createElement(Title$3, { dangerouslySetInnerHTML: { __html: (translation === null || translation === void 0 ? void 0 : translation.offerAlmostThere) || t('offer.pages.orderAmount.title') } }),
        React__default.createElement(Form.Item, { name: "saleAmount", label: t('offer.pages.orderAmount.orderAmountLabel'), rules: [
                {
                    validator: function (_, value, callback) {
                        var _a;
                        if (!value) {
                            if (requiredSaleAmount) {
                                callback(t('offer.pages.orderAmount.orderAmountRequiredMsg'));
                                return;
                            }
                            return callback();
                        }
                        if (value < Number(((_a = voucher === null || voucher === void 0 ? void 0 : voucher.voucherData) === null || _a === void 0 ? void 0 : _a.minOrderValue) || 0)) {
                            callback(t('offer.pages.orderAmount.orderAmountMinMsg') + ' ' + (voucher.voucherData.minOrderValue || 0));
                            return;
                        }
                        return callback();
                    },
                    transform: function (value) {
                        return Number(value);
                    }
                },
            ] },
            React__default.createElement(Input, { type: "number", min: voucher.voucherData.minOrderValue || 0, placeholder: t('offer.pages.orderAmount.orderAmountPlaceholder'), prefix: voucherCurrency, className: "saleamount-input" })),
        React__default.createElement(Form.Item, { shouldUpdate: function (prevValues, currentValues) { return prevValues.saleAmount !== currentValues.saleAmount; } }, function (_a) {
            var _b, _c;
            var getFieldValue = _a.getFieldValue;
            var saleAmount = getFieldValue('saleAmount');
            var disabled = !saleAmount ||
                (((_b = voucher === null || voucher === void 0 ? void 0 : voucher.voucherData) === null || _b === void 0 ? void 0 : _b.minOrderValue) ? saleAmount < Number((_c = voucher === null || voucher === void 0 ? void 0 : voucher.voucherData) === null || _c === void 0 ? void 0 : _c.minOrderValue) : false);
            return (React__default.createElement(Button, { onClick: form.submit, disabled: disabled, className: "w-full mt-2 text-center submit-btn", "$disabledHover": true, "$color": themeColor }, t('offer.pages.orderAmount.buttonText')));
        }),
        showSkipBtn && (React__default.createElement(Button, { "$disabledHover": true, onClick: function () {
                form.setFieldsValue({
                    saleAmount: null
                });
                form.submit();
            }, className: "w-full text-center skip-btn", "$color": themeColor, type: "default" }, t('offer.pages.orderAmount.skipButtonText')))));
}
var templateObject_1$s, templateObject_2$m;

var Container$4 = defaultStyled.div(templateObject_1$r || (templateObject_1$r = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  max-width: 220px;\n  margin: 0 auto;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  max-width: 220px;\n  margin: 0 auto;\n"])));
var CircleInput = defaultStyled(Input$1).attrs({
    inputMode: 'numeric',
    pattern: '[0-9]*'
})(templateObject_2$l || (templateObject_2$l = __makeTemplateObject(["\n  width: 50px;\n  height: 50px;\n  text-align: center;\n  border-radius: 50%;\n  font-size: 24px;\n  padding: 0;\n"], ["\n  width: 50px;\n  height: 50px;\n  text-align: center;\n  border-radius: 50%;\n  font-size: 24px;\n  padding: 0;\n"])));
var PinCodeInput = function (_a) {
    var length = _a.length, onChange = _a.onChange;
    var _b = useState(Array(length).fill('')), values = _b[0], setValues = _b[1];
    var inputsRef = useRef([]);
    var handleInputChange = function (e, index) {
        var _a;
        var value = e.target.value;
        if (/^\d?$/.test(value)) {
            var newValues = __spreadArray([], values, true);
            newValues[index] = value;
            setValues(newValues);
            var combinedValue = newValues.join('');
            onChange(combinedValue, index, value);
            if (value.length >= 1 && index < length - 1) {
                (_a = inputsRef.current[index + 1]) === null || _a === void 0 ? void 0 : _a.focus();
            }
        }
    };
    var handleFocus = function (e) {
        e.target.select();
    };
    var handleKeyDown = function (e, index) {
        var _a;
        if (e.key === 'Backspace' && !values[index] && index > 0) {
            (_a = inputsRef.current[index - 1]) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    useEffect(function () {
        inputsRef.current = inputsRef.current.slice(0, length);
    }, [length]);
    return (React__default.createElement(Container$4, null, values.map(function (_, index) { return (React__default.createElement(CircleInput, { key: index, ref: function (el) { return (inputsRef.current[index] = el); }, maxLength: 1, value: values[index], onFocus: handleFocus, onKeyDown: function (e) { return handleKeyDown(e, index); }, onChange: function (e) { return handleInputChange(e, index); } })); })));
};
var templateObject_1$r, templateObject_2$l;

var Container$3 = defaultStyled.div(templateObject_1$q || (templateObject_1$q = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n\n  font-family: ", ";\n  color: ", ";\n\n  .search-input {\n    border-radius: 10px !important;\n    margin: 1rem 0;\n  }\n"], ["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n\n  font-family: ", ";\n  color: ", ";\n\n  .search-input {\n    border-radius: 10px !important;\n    margin: 1rem 0;\n  }\n"])), function (_a) {
    var $fontFamily = _a.$fontFamily;
    return $fontFamily;
}, function (_a) {
    var $color = _a.$color;
    return $color;
});
var Title$2 = defaultStyled.div(templateObject_2$k || (templateObject_2$k = __makeTemplateObject(["\n  margin: 1.5rem 0;\n  margin-top: 2rem;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 28.8px;\n  text-align: center !important;\n"], ["\n  margin: 1.5rem 0;\n  margin-top: 2rem;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 28.8px;\n  text-align: center !important;\n"])));
function PinCodePage(_a) {
    var voucher = _a.voucher, configuration = _a.configuration, brand = _a.brand, onNext = _a.onNext;
    var _b = useContext(RedemptionContext), t = _b.t, form = _b.form, language = _b.language;
    var _c = configuration || {}, _d = _c.brandFont, brandFont = _d === void 0 ? 'var(--font-family-regular)' : _d, _e = _c.themeColor, themeColor = _e === void 0 ? 'var(--indian-red)' : _e, _f = _c.showBrandName, showBrandName = _f === void 0 ? true : _f, brandName = _c.brandName, _g = _c.showLogo, showLogo = _g === void 0 ? true : _g, _h = _c.showOfferCard, showOfferCard = _h === void 0 ? true : _h;
    var _j = brand || {}, name = _j.name, logoUrl = _j.logoUrl;
    return (React__default.createElement(Container$3, { "$fontFamily": brandFont, "$color": themeColor, "data-testid": "pin-code-page" },
        React__default.createElement(OfferLogo, { showBrandName: showBrandName, showLogo: showLogo, logo: logoUrl, brandName: brandName || name }),
        showOfferCard && React__default.createElement(OfferCard, { voucher: voucher, className: "mt-20", t: t, locale: language }),
        React__default.createElement(Title$2, null, t('offer.pages.pincode.title')),
        React__default.createElement(Form.Item, { name: "pinCode" },
            React__default.createElement(PinCodeInput, { length: 4, onChange: function (pinCode) {
                    form.setFieldsValue({ pinCode: pinCode });
                    if ((pinCode === null || pinCode === void 0 ? void 0 : pinCode.length) === 4) {
                        var values = form.getFieldsValue(true);
                        onNext === null || onNext === void 0 ? void 0 : onNext(values);
                    }
                } }))));
}
var templateObject_1$q, templateObject_2$k;

var Container$2 = defaultStyled(Form)(templateObject_1$p || (templateObject_1$p = __makeTemplateObject(["\n  max-width: 650px;\n  margin: auto;\n  position: relative;\n  padding-bottom: 2rem;\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n  min-height: 100%;\n\n  &.rtl {\n    direction: rtl;\n    text-align: right;\n    * {\n      direction: rtl;\n      text-align: right;\n    }\n  }\n\n  .text-center {\n    text-align: center !important;\n  }\n\n  font-family: ", ";\n  color: ", ";\n"], ["\n  max-width: 650px;\n  margin: auto;\n  position: relative;\n  padding-bottom: 2rem;\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n  min-height: 100%;\n\n  &.rtl {\n    direction: rtl;\n    text-align: right;\n    * {\n      direction: rtl;\n      text-align: right;\n    }\n  }\n\n  .text-center {\n    text-align: center !important;\n  }\n\n  font-family: ", ";\n  color: ", ";\n"])), function (_a) {
    var $fontFamily = _a.$fontFamily;
    return $fontFamily;
}, function (_a) {
    var $color = _a.$color;
    return $color;
});
var ContentContainer = defaultStyled.div(templateObject_2$j || (templateObject_2$j = __makeTemplateObject(["\n  display: ", ";\n  flex-grow: 1;\n"], ["\n  display: ", ";\n  flex-grow: 1;\n"])), function (_a) {
    var visible = _a.visible;
    return (visible ? 'block' : 'none');
});
var RedemptionContext = React__default.createContext(null);
function OfferRedemption(_a) {
    var page = _a.page, voucher = _a.voucher, brand = _a.brand, outlets = _a.outlets, _b = _a.onFinish, onFinish = _b === void 0 ? function (values) {
        console.log(values);
    } : _b, onNext = _a.onNext, onPrev = _a.onPrev, t = _a.t, language = _a.language, onChangeLanguage = _a.onChangeLanguage, _c = _a.editorMode, editorMode = _c === void 0 ? false : _c, voucherInstance = _a.voucherInstance, isLocationPage = _a.isLocationPage;
    var form = Form.useForm()[0];
    var pageConfiguration = useMemo(function () {
        var _a = (voucher === null || voucher === void 0 ? void 0 : voucher.pageConfig) || {}, confirmation = _a.confirmation, instructions = _a.instructions, location = _a.location, orderAmount = _a.orderAmount, pincode = _a.pincode;
        find$1(voucher === null || voucher === void 0 ? void 0 : voucher.pageConfig, function (p) { return p.pageName === page; });
        switch (page) {
            case 'INSTRUCTIONS': {
                return instructions;
            }
            case 'LOCATION': {
                return location;
            }
            case 'PINCODE': {
                return pincode;
            }
            case 'ORDER_AMOUNT': {
                return orderAmount;
            }
            case 'CONFIRMATION': {
                return confirmation;
            }
        }
    }, [voucher === null || voucher === void 0 ? void 0 : voucher.pageConfig, page]);
    var isOnline = Boolean(voucherInstance === null || voucherInstance === void 0 ? void 0 : voucherInstance.platformUrl);
    var content = useMemo(function () {
        return (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(ContentContainer, { visible: page === 'INSTRUCTIONS' },
                React__default.createElement(InstructionsPage, { voucher: voucher, brand: brand, configuration: pageConfiguration, isOnline: isOnline, onNext: onNext, onPrev: onPrev, voucherInstance: voucherInstance })),
            React__default.createElement(ContentContainer, { visible: page === 'LOCATION' },
                React__default.createElement(LocationPage, { voucher: voucher, brand: brand, configuration: pageConfiguration, onNext: onNext, onPrev: onPrev, outlets: outlets, isLocationPage: isLocationPage })),
            React__default.createElement(ContentContainer, { visible: page === 'PINCODE' },
                React__default.createElement(PinCodePage, { voucher: voucher, brand: brand, configuration: pageConfiguration, onNext: onNext, onPrev: onPrev })),
            React__default.createElement(ContentContainer, { visible: page === 'ORDER_AMOUNT' },
                React__default.createElement(OrderAmountPage, { voucher: voucher, brand: brand, configuration: pageConfiguration, onNext: onNext, onPrev: onPrev })),
            React__default.createElement(ContentContainer, { visible: page === 'CONFIRMATION' },
                React__default.createElement(ConfirmationPage, { voucher: voucher, brand: brand, configuration: pageConfiguration, onNext: onNext, onPrev: onPrev, outlets: outlets, voucherInstance: voucherInstance }))));
    }, [voucher, brand, pageConfiguration, outlets, page, onNext, onPrev, voucherInstance, isLocationPage]);
    var translations = useMemo(function () { return voucher === null || voucher === void 0 ? void 0 : voucher.translations; }, [voucher]);
    var translation = useMemo(function () { return find$1(translations, { locale: language }); }, [translations, language]);
    var _d = pageConfiguration || {}, _e = _d.brandFont, brandFont = _e === void 0 ? 'var(--font-family-regular)' : _e, _f = _d.themeColor, themeColor = _f === void 0 ? 'var(--indian-red)' : _f;
    return (React__default.createElement(RedemptionContext.Provider, { value: { form: form, t: t, translation: translation, language: language, editorMode: editorMode } },
        React__default.createElement(Container$2, { form: form, layout: "vertical", onFinish: onFinish, className: language === 'ar-SA' ? 'rtl' : '', "$fontFamily": brandFont, "$color": themeColor },
            content,
            React__default.createElement(LanguageSelect, { translations: translations, language: language, onChangeLanguage: onChangeLanguage }))));
}
var templateObject_1$p, templateObject_2$j;

var SadFace = function (props) { return (React.createElement("svg", __assign({ width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("mask", { id: "mask0_2184_79460", style: { maskType: 'luminance' }, maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "40", height: "40" },
        React.createElement("path", { d: "M0 3.8147e-06H40V40H0V3.8147e-06Z", fill: "white" })),
    React.createElement("g", { mask: "url(#mask0_2184_79460)" },
        React.createElement("path", { d: "M20 1.17188C30.3912 1.17188 38.8281 9.60875 38.8281 20C38.8281 30.3913 30.3912 38.8281 20 38.8281C9.60875 38.8281 1.17188 30.3913 1.17188 20C1.17188 9.60875 9.60875 1.17188 20 1.17188Z", stroke: "#EE1102", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M12.0359 11.9887C12.5002 11.5243 13.1304 11.2632 13.7874 11.2632C14.4452 11.2632 15.0753 11.5243 15.5398 11.9887C17.3774 13.8262 20.0008 16.4498 20.0008 16.4498C20.0008 16.4498 22.6034 13.847 24.4392 12.0113C25.4195 11.0309 27.008 11.0309 27.9877 12.0113C27.9883 12.0119 27.9889 12.0126 27.9895 12.0131C28.9698 12.9929 28.9698 14.5814 27.9895 15.5616C26.1537 17.3973 23.5511 20.0001 23.5511 20.0001C23.5511 20.0001 26.1318 22.5808 27.967 24.4158C28.4433 24.8923 28.7112 25.5387 28.7112 26.2126C28.7112 26.8874 28.4433 27.5338 27.967 28.0101C27.9663 28.0108 27.9663 28.0108 27.9656 28.0115C27.5012 28.4758 26.8712 28.7369 26.2141 28.7369C25.5563 28.7369 24.9262 28.4758 24.4617 28.0115C22.6241 26.1738 20.0008 23.5504 20.0008 23.5504C20.0008 23.5504 17.3981 26.1531 15.5623 27.9888C14.582 28.9692 12.9936 28.9692 12.0138 27.9888C12.0132 27.9888 12.0132 27.9882 12.0126 27.9882C11.0323 27.0079 11.0323 25.4181 12.0126 24.4379C13.849 22.6015 16.4504 20.0001 16.4504 20.0001C16.4504 20.0001 13.8697 17.4194 12.0345 15.5842C11.5582 15.1079 11.2902 14.4614 11.2902 13.7874C11.2902 13.1127 11.5582 12.4663 12.0345 11.99C12.0352 11.9894 12.0352 11.9894 12.0359 11.9887Z", stroke: "#EE1102", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round" })))); };

var StyledTable = defaultStyled(Table)(templateObject_1$o || (templateObject_1$o = __makeTemplateObject(["\n  margin: 10px 0;\n"], ["\n  margin: 10px 0;\n"])));
function format24TimeTo12(timeString) {
    var _a = timeString.split(':'), hourString = _a[0], minute = _a[1];
    var hour = +hourString % 24;
    return (hour % 12 || 12) + ':' + minute + (hour < 12 ? ' am' : ' pm');
}
function structTableData(data) {
    var _a;
    return (_a = data === null || data === void 0 ? void 0 : data.filter(function (d) { return d.isOpen; })) === null || _a === void 0 ? void 0 : _a.map(function (d, i) { return ({
        key: i,
        day: d.day,
        startTime: d.startTime,
        endTime: d.endTime,
        dataList: d.dataList
    }); });
}
var TableColumn = function (t) { return [
    {
        title: t('offer.schedule.day'),
        dataIndex: 'day',
        key: 'day'
    },
    {
        title: t('offer.schedule.startTime'),
        dataIndex: 'startTime',
        key: 'startTime',
        render: function (timeText, data) {
            var _a;
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("div", null, format24TimeTo12(timeText)), (_a = data.dataList) === null || _a === void 0 ? void 0 :
                _a.map(function (d) { return (React__default.createElement("div", { key: d === null || d === void 0 ? void 0 : d.id }, format24TimeTo12(d.startTime))); })));
        }
    },
    {
        title: t('offer.schedule.endTime'),
        dataIndex: 'endTime',
        key: 'endTime',
        render: function (timeText, data) {
            var _a;
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("div", null, format24TimeTo12(timeText)), (_a = data.dataList) === null || _a === void 0 ? void 0 :
                _a.map(function (d) { return (React__default.createElement("div", { key: d === null || d === void 0 ? void 0 : d.id }, format24TimeTo12(d.endTime))); })));
        }
    },
]; };
var VoucherSchedule = function (_a) {
    var schedule = _a.schedule, className = _a.className, t = _a.t;
    return (React__default.createElement("div", { className: className }, schedule && React__default.createElement(StyledTable, { dataSource: structTableData(schedule), columns: TableColumn(t), pagination: false })));
};
var templateObject_1$o;

var Container$1 = defaultStyled.div(templateObject_1$n || (templateObject_1$n = __makeTemplateObject(["\n  max-width: 650px;\n  margin: auto;\n  height: 100%;\n  position: relative;\n  flex-direction: column;\n  display: flex;\n  padding-bottom: 2rem;\n  font-family: ", ";\n  color: ", ";\n"], ["\n  max-width: 650px;\n  margin: auto;\n  height: 100%;\n  position: relative;\n  flex-direction: column;\n  display: flex;\n  padding-bottom: 2rem;\n  font-family: ", ";\n  color: ", ";\n"])), function (_a) {
    var $fontFamily = _a.$fontFamily;
    return $fontFamily;
}, function (_a) {
    var $color = _a.$color;
    return $color;
});
var Content$1 = defaultStyled.div(templateObject_2$i || (templateObject_2$i = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n  padding-top: 2rem;\n  align-items: center;\n  text-align: center;\n  flex-grow: 1;\n\n  font-family: ", ";\n  color: ", ";\n"], ["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n  padding-top: 2rem;\n  align-items: center;\n  text-align: center;\n  flex-grow: 1;\n\n  font-family: ", ";\n  color: ", ";\n"])), function (_a) {
    var $fontFamily = _a.$fontFamily;
    return $fontFamily;
}, function (_a) {
    var $color = _a.$color;
    return $color;
});
var Title$1 = defaultStyled.div(templateObject_3$d || (templateObject_3$d = __makeTemplateObject(["\n  margin: 20px 0;\n  font-family: inherit;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 28px;\n  text-align: center;\n"], ["\n  margin: 20px 0;\n  font-family: inherit;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 28px;\n  text-align: center;\n"])));
var Text = defaultStyled.p(templateObject_4$8 || (templateObject_4$8 = __makeTemplateObject(["\n  color: var(--grey-dark);\n  text-align: center;\n"], ["\n  color: var(--grey-dark);\n  text-align: center;\n"])));
var OfferDetails = defaultStyled.div(templateObject_5$7 || (templateObject_5$7 = __makeTemplateObject(["\n  margin: 20px 0;\n  display: flex;\n  gap: 1rem;\n  justify-content: space-between;\n"], ["\n  margin: 20px 0;\n  display: flex;\n  gap: 1rem;\n  justify-content: space-between;\n"])));
var OfferDetailItem = defaultStyled.div(templateObject_6$5 || (templateObject_6$5 = __makeTemplateObject(["\n  margin: 10px 0;\n  flex-grow: 1;\n  color: var(--grey-dark);\n  font-size: 14px;\n  text-align: center;\n"], ["\n  margin: 10px 0;\n  flex-grow: 1;\n  color: var(--grey-dark);\n  font-size: 14px;\n  text-align: center;\n"])));
var NotRedeemable = function (_a) {
    var voucher = _a.voucher, startDate = _a.startDate, endDate = _a.endDate, brand = _a.brand, schedule = _a.schedule, t = _a.t, language = _a.language, onChangeLanguage = _a.onChangeLanguage;
    var _b = brand || {}, name = _b.name, logoUrl = _b.logoUrl;
    var configuration = ((voucher === null || voucher === void 0 ? void 0 : voucher.pageConfig) || {}).issuance;
    var _c = configuration || {}, _d = _c.brandFont, brandFont = _d === void 0 ? 'var(--font-family-regular)' : _d, _e = _c.themeColor, themeColor = _e === void 0 ? 'var(--indian-red)' : _e;
    var translations = useMemo(function () { return voucher === null || voucher === void 0 ? void 0 : voucher.translations; }, [voucher]);
    return (React__default.createElement(Container$1, { "$fontFamily": brandFont, "$color": themeColor },
        React__default.createElement(Content$1, { "$fontFamily": brandFont, "$color": themeColor },
            React__default.createElement(SadFace, null),
            React__default.createElement(Title$1, null, t('offer.error.notRedeemable.title')),
            React__default.createElement(Text, null, t('offer.error.notRedeemable.schedule')),
            React__default.createElement(OfferDetails, null,
                startDate && (React__default.createElement(OfferDetailItem, null,
                    t('offer.error.notRedeemable.offerStarting'),
                    ": ",
                    React__default.createElement("br", null),
                    React__default.createElement("strong", null, moment(startDate).format(DATETIME_FORMAT)))),
                endDate && (React__default.createElement(OfferDetailItem, null,
                    t('offer.error.notRedeemable.offerEnds'),
                    ": ",
                    React__default.createElement("br", null),
                    React__default.createElement("strong", null, moment(endDate).format(DATETIME_FORMAT))))),
            React__default.createElement(VoucherSchedule, { schedule: schedule, className: "w-full", t: t }),
            React__default.createElement(OfferCard, { voucher: voucher, className: "mt-20 mb-20 w-full", t: t, locale: language }),
            React__default.createElement(OfferLogo, { showBrandName: true, showLogo: true, logo: logoUrl, brandName: name })),
        React__default.createElement(LanguageSelect, { translations: translations, language: language, onChangeLanguage: onChangeLanguage })));
};
var templateObject_1$n, templateObject_2$i, templateObject_3$d, templateObject_4$8, templateObject_5$7, templateObject_6$5;

var Container = defaultStyled.div(templateObject_1$m || (templateObject_1$m = __makeTemplateObject(["\n  max-width: 650px;\n  margin: auto;\n  height: 100%;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 2rem;\n  font-family: ", ";\n  color: ", ";\n"], ["\n  max-width: 650px;\n  margin: auto;\n  height: 100%;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 2rem;\n  font-family: ", ";\n  color: ", ";\n"])), function (_a) {
    var $fontFamily = _a.$fontFamily;
    return $fontFamily;
}, function (_a) {
    var $color = _a.$color;
    return $color;
});
var Content = defaultStyled.div(templateObject_2$h || (templateObject_2$h = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n  padding-top: 2rem;\n  align-items: center;\n  flex-grow: 1;\n"], ["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n  padding-top: 2rem;\n  align-items: center;\n  flex-grow: 1;\n"])));
var Title = defaultStyled.div(templateObject_3$c || (templateObject_3$c = __makeTemplateObject(["\n  margin: 1.5rem 0;\n  margin-top: 1rem;\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 28.8px;\n  text-align: center;\n  word-break: break-all;\n  p {\n    word-break: break-all;\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 28.8px;\n  }\n"], ["\n  margin: 1.5rem 0;\n  margin-top: 1rem;\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 28.8px;\n  text-align: center;\n  word-break: break-all;\n  p {\n    word-break: break-all;\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 28.8px;\n  }\n"])));
defaultStyled.p(templateObject_4$7 || (templateObject_4$7 = __makeTemplateObject(["\n  text-align: center;\n  color: var(--grey-dark);\n  font-weight: 600;\n"], ["\n  text-align: center;\n  color: var(--grey-dark);\n  font-weight: 600;\n"])));
var OfferError = function (_a) {
    var message = _a.message, voucher = _a.voucher, brand = _a.brand, language = _a.language, onChangeLanguage = _a.onChangeLanguage, t = _a.t;
    var _b = brand || {}, name = _b.name, logoUrl = _b.logoUrl;
    var translations = useMemo(function () { return voucher === null || voucher === void 0 ? void 0 : voucher.translations; }, [voucher]);
    var configuration = ((voucher === null || voucher === void 0 ? void 0 : voucher.pageConfig) || {}).issuance;
    var _c = configuration || {}, _d = _c.brandFont, brandFont = _d === void 0 ? 'var(--font-family-regular)' : _d, _e = _c.themeColor, themeColor = _e === void 0 ? 'var(--indian-red)' : _e;
    return (React__default.createElement(Container, { "$fontFamily": brandFont, "$color": themeColor },
        React__default.createElement(Content, { "$fontFamily": brandFont, "$color": themeColor },
            React__default.createElement(SadFace, null),
            React__default.createElement(Title, null, t === null || t === void 0 ? void 0 : t('offer.error.title')),
            React__default.createElement("div", null, message),
            voucher && React__default.createElement(OfferCard, { voucher: voucher, t: t, locale: language, className: "mt-6 w-full" }),
            React__default.createElement(OfferLogo, { showBrandName: true, showLogo: true, logo: logoUrl, brandName: name, className: "mt-6" })),
        React__default.createElement(LanguageSelect, { translations: translations, language: language, onChangeLanguage: onChangeLanguage })));
};
var templateObject_1$m, templateObject_2$h, templateObject_3$c, templateObject_4$7;

var baseClone = _baseClone;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

var cloneDeep_1 = cloneDeep;

var cloneDeep$1 = /*@__PURE__*/getDefaultExportFromCjs(cloneDeep_1);

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */

function arrayReduce$1(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

var _arrayReduce = arrayReduce$1;

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */

function basePropertyOf$1(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

var _basePropertyOf = basePropertyOf$1;

var basePropertyOf = _basePropertyOf;

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter$1 = basePropertyOf(deburredLetters);

var _deburrLetter = deburrLetter$1;

var deburrLetter = _deburrLetter,
    toString$6 = toString_1;

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange$2 = '\\u0300-\\u036f',
    reComboHalfMarksRange$2 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$2 = '\\u20d0-\\u20ff',
    rsComboRange$2 = rsComboMarksRange$2 + reComboHalfMarksRange$2 + rsComboSymbolsRange$2;

/** Used to compose unicode capture groups. */
var rsCombo$2 = '[' + rsComboRange$2 + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo$2, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr$1(string) {
  string = toString$6(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

var deburr_1 = deburr$1;

/** Used to match words composed of alphanumeric characters. */

var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords$1(string) {
  return string.match(reAsciiWord) || [];
}

var _asciiWords = asciiWords$1;

/** Used to detect strings that need a more robust regexp to match words. */

var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord$1(string) {
  return reHasUnicodeWord.test(string);
}

var _hasUnicodeWord = hasUnicodeWord$1;

/** Used to compose unicode character classes. */

var rsAstralRange$1 = '\\ud800-\\udfff',
    rsComboMarksRange$1 = '\\u0300-\\u036f',
    reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$1 = '\\u20d0-\\u20ff',
    rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange$1 = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos$1 = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo$1 = '[' + rsComboRange$1 + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange$1 + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz$1 = '\\ud83c[\\udffb-\\udfff]',
    rsModifier$1 = '(?:' + rsCombo$1 + '|' + rsFitz$1 + ')',
    rsNonAstral$1 = '[^' + rsAstralRange$1 + ']',
    rsRegional$1 = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair$1 = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ$1 = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos$1 + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos$1 + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod$1 = rsModifier$1 + '?',
    rsOptVar$1 = '[' + rsVarRange$1 + ']?',
    rsOptJoin$1 = '(?:' + rsZWJ$1 + '(?:' + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsOptVar$1 + reOptMod$1 + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1,
    rsEmoji = '(?:' + [rsDingbat, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsSeq$1;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords$1(string) {
  return string.match(reUnicodeWord) || [];
}

var _unicodeWords = unicodeWords$1;

var asciiWords = _asciiWords,
    hasUnicodeWord = _hasUnicodeWord,
    toString$5 = toString_1,
    unicodeWords = _unicodeWords;

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words$1(string, pattern, guard) {
  string = toString$5(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

var words_1 = words$1;

var arrayReduce = _arrayReduce,
    deburr = deburr_1,
    words = words_1;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder$2(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

var _createCompounder = createCompounder$2;

var createCompounder$1 = _createCompounder;

/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */
var snakeCase = createCompounder$1(function(result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
});

var snakeCase_1 = snakeCase;

var snakeCase$1 = /*@__PURE__*/getDefaultExportFromCjs(snakeCase_1);

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */

function baseSortBy$1(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

var _baseSortBy = baseSortBy$1;

var isSymbol = isSymbol_1;

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending$1(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

var _compareAscending = compareAscending$1;

var compareAscending = _compareAscending;

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple$1(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

var _compareMultiple = compareMultiple$1;

var arrayMap = _arrayMap,
    baseGet = _baseGet,
    baseIteratee = _baseIteratee,
    baseMap = _baseMap,
    baseSortBy = _baseSortBy,
    baseUnary$1 = _baseUnary,
    compareMultiple = _compareMultiple,
    identity$2 = identity_1,
    isArray$2 = isArray_1;

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy$1(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray$2(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity$2];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary$1(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

var _baseOrderBy = baseOrderBy$1;

var identity$1 = identity_1,
    overRest = _overRest,
    setToString = _setToString;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest$1(func, start) {
  return setToString(overRest(func, start, identity$1), func + '');
}

var _baseRest = baseRest$1;

var eq = eq_1,
    isArrayLike$1 = isArrayLike_1,
    isIndex = _isIndex,
    isObject$2 = isObject_1;

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall$1(value, index, object) {
  if (!isObject$2(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike$1(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

var _isIterateeCall = isIterateeCall$1;

var baseFlatten = _baseFlatten,
    baseOrderBy = _baseOrderBy,
    baseRest = _baseRest,
    isIterateeCall = _isIterateeCall;

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

var sortBy_1 = sortBy;

var sortBy$1 = /*@__PURE__*/getDefaultExportFromCjs(sortBy_1);

var toString$4 = toString_1;

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString$4(prefix) + id;
}

var uniqueId_1 = uniqueId;

var uniqueId$1 = /*@__PURE__*/getDefaultExportFromCjs(uniqueId_1);

var Stepper = function (_a) {
    var steps = _a.steps, activeStep = _a.activeStep, _b = _a.color, color = _b === void 0 ? 'var(--indian-red)' : _b, _c = _a.className, className = _c === void 0 ? '' : _c;
    return (React__default.createElement(StepperWrap, { className: className }, new Array(steps).fill('').map(function (_, index) { return (React__default.createElement(Step, { "$color": color, key: index, "$active": index + 1 <= activeStep })); })));
};
var StepperWrap = defaultStyled.div(templateObject_1$l || (templateObject_1$l = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 0.313rem;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 0.313rem;\n"])));
var Step = defaultStyled.div(templateObject_2$g || (templateObject_2$g = __makeTemplateObject(["\n  height: 0.188rem;\n  background: ", ";\n  width: 100%;\n"], ["\n  height: 0.188rem;\n  background: ", ";\n  width: 100%;\n"])), function (_a) {
    var $active = _a.$active, $color = _a.$color;
    return ($active ? $color : 'var(--disable-grey)');
});
var templateObject_1$l, templateObject_2$g;

var TRACKING_EVENTS = {
    STEP: {
        action: 'CLICK',
        label: 'SURVEY.STEP'
    },
    TYPE_OF_ORDER_SELECT_TYPE: {
        action: 'CLICK',
        label: 'SURVEY.TYPE_OF_ORDER.SELECT_TYPE_OF_ORDER'
    },
    CHOOSE_LOCATION_SELECT_LOCATION: {
        action: 'CLICK',
        label: 'SURVEY.CHOOSE_LOCATION.SELECT_LOCATION'
    },
    CHOOSE_LOCATION_SEARCH: {
        action: 'CLICK',
        label: 'SURVEY.CHOOSE_LOCATION.SEARCH'
    },
    DELIVERY_PLATFORM_SELECT_PLATFORM: {
        action: 'CLICK',
        label: 'SURVEY.DELIVERY_PLATFORM.SELECTPLATFORM'
    },
    RATINGS_SELECT_RATING: {
        action: 'CLICK',
        label: 'SURVEY.RATINGS.SELECT_RATING'
    },
    EXPERIENCE_DETAIL_COMMENT: {
        action: 'CLICK',
        label: 'SURVEY.EXPERIENCE_RATING_DETAIL.COMMENT'
    },
    EXPERIENCE_DETAIL_UPLOAD_FILE: {
        action: 'CLICK',
        label: 'SURVEY.EXPERIENCE_DETAIL.UPLOAD_FILE'
    },
    EXPERIENCE_DETAIL_VISIT_DATE: {
        action: 'CLICK',
        label: 'SURVEY.EXPERIENCE_DETAIL.VISIT_DATE'
    },
    EXPERIENCE_DETAIL_VISIT_TIME: {
        action: 'CLICK',
        label: 'SURVEY.EXPERIENCE_DETAIL.VISIT_TIME'
    },
    EXPERIENCE_DETAIL_ORDER_REFERENCE_NUMBER: {
        action: 'CLICK',
        label: 'SURVEY.EXPERIENCE_DETAIL.ORDER_REFERENCE_NUMBER'
    },
    EXPERIENCE_POSITIVE_CHOOSE_TAG: {
        action: 'CLICK',
        label: 'SURVEY.EXPERIENCE_POSITIVE.CHOOSE_TAG'
    },
    EXPERIENCE_NAGATIVE_CHOOSE_TAG: {
        action: 'CLICK',
        label: 'SURVEY.EXPERIENCE_NAGATIVE.CHOOSE_TAG'
    },
    STAFF_LIST_CHOOSE_STAFF: {
        action: 'CLICK',
        label: 'SURVEY.STAFF_LIST.CHOOSE_STAFF'
    },
    STAFF_RATING_SELECT_STAFF_RATING: {
        action: 'CLICK',
        label: 'SURVEY.STAFF_RATING.SELECT_STAFF_RATING'
    },
    STAFF_RATING_COMMENT: {
        action: 'CLICK',
        label: 'SURVEY.STAFF_RATING.COMMENT'
    },
    PERSONAL_INFORMATION_NAME: {
        action: 'CLICK',
        label: 'SURVEY.PERSONAL_INFORMATION.NAME'
    },
    PERSONAL_INFORMATION_EMAIL: {
        action: 'CLICK',
        label: 'SURVEY.PERSONAL_INFORMATION.EMAIL'
    },
    PERSONAL_INFORMATION_PHONE: {
        action: 'CLICK',
        label: 'SURVEY.PERSONAL_INFORMATION.PHONE'
    },
    PERSONAL_INFORMATION_CONTACT_METHOD: {
        action: 'CLICK',
        label: 'SURVEY.PERSONAL_INFORMATION.CONTACT_METHOD'
    },
    PERSONAL_INFORMATION_TNC: {
        action: 'CLICK',
        label: 'SURVEY.PERSONAL_INFORMATION.TNC'
    },
    PERSONAL_INFORMATION_OPTIN: {
        action: 'CLICK',
        label: 'SURVEY.PERSONAL_INFORMATION.OPTIN'
    },
    PERSONAL_INFORMATION_ATC: {
        action: 'CLICK',
        label: 'SURVEY.PERSONAL_INFORMATION.ATC'
    },
    BOOST_PAGE_BOOST: {
        action: 'CLICK',
        label: 'SURVEY.BOOST_PAGE.BOOST'
    },
    BOOST_PAGE_BOOST_REDIRECT: {
        action: 'CLICK',
        label: 'SURVEY.BOOST_PAGE.BOOST_REDIRECT'
    },
    BOOST_PAGE_BOOST_REDIRECT_NEW_TAB: {
        action: 'CLICK',
        label: 'SURVEY.BOOST_PAGE.BOOST_REDIRECT_NEW_TAB'
    },
    BOOST_PAGE_BOOST_REDIRECT_SAME_TAB: {
        action: 'CLICK',
        label: 'SURVEY.BOOST_PAGE.BOOST_REDIRECT_SAME_TAB'
    },
    BOOST_PAGE_BOOST_REDIRECT_CANCEL: {
        action: 'CLICK',
        label: 'SURVEY.BOOST_PAGE.BOOST_REDIRECT_CANCEL'
    },
    BOOST_PAGE_NO_THANK: {
        action: 'CLICK',
        label: 'SURVEY.BOOST_PAGE.NO_THANK'
    },
    THANK_YOU_SOCIAL_LINK: {
        action: 'CLICK',
        label: 'SURVEY.THANK_YOU.SOCIAL_LINK'
    }
};

var StandardLayout = defaultStyled.div(templateObject_1$k || (templateObject_1$k = __makeTemplateObject(["\n  position: relative;\n  padding: 1.25rem;\n  padding-top: 2.5rem;\n\n  .welcome-logo-wrap {\n    margin-bottom: 0.625rem;\n  }\n\n  ", "\n\n  ", "\n\n  h2, h1, span, div, h5, p, textarea.ant-input, input.ant-input, .ant-picker .ant-picker-input input, .react-tel-input input {\n    font-family: ", " !important;\n  }\n\n  h2,\n  h1 {\n    * {\n      font-size: inherit;\n      line-height: inherit;\n      color: inherit;\n      font-family: inherit;\n      font-weight: inherit;\n    }\n  }\n\n  .page-content {\n    position: relative;\n    min-height: calc(669px - 200px);\n    max-height: 100%;\n\n    ", "\n\n    .location-search {\n      margin-bottom: 1.25rem;\n    }\n\n    .thankyou-page-title {\n      color: ", ";\n    }\n\n    .logo-circle {\n      border: 1px solid ", ";\n    }\n\n    .ant-checkbox-checked .ant-checkbox-inner {\n      background-color: ", ";\n      border-color: ", ";\n    }\n\n    .ant-checkbox-wrapper:hover {\n      .ant-checkbox-inner {\n        border-color: ", ";\n      }\n    }\n\n    .ant-input-affix-wrapper:focus,\n    .ant-input-affix-wrapper-focused,\n    .ant-input:focus,\n    .ant-input-focused {\n      border-color: ", ";\n      box-shadow: 0 0 0 2px\n        ", ";\n    }\n\n    .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {\n      border-color: ", ";\n    }\n\n    .ant-input:hover {\n      border-color: ", ";\n    }\n\n    .ant-picker-focused,\n    .ant-picker:hover {\n      border-color: ", ";\n    }\n\n    .ant-picker-focused {\n      box-shadow: 0 0 0 2px\n        ", ";\n    }\n\n    .select-option {\n      svg > g line,\n      svg > g path {\n        stroke: ", ";\n      }\n\n      :hover {\n        background: ", ";\n      }\n    }\n\n    .survey-voucher-select,\n    .survey-voucher-select-no-hover {\n      svg > path {\n        fill: ", ";\n        opacity: 0.175;\n      }\n      svg > g line,\n      svg > g path {\n        stroke: ", ";\n      }\n      .no-offer-container {\n        svg path {\n          stroke: ", ";\n          opacity: 1 !important;\n        }\n      }\n      .issuance-type {\n        border: 1px solid ", " !important;\n        .issuance-text {\n          color: ", " !important;\n        }\n        /* background: ", " !important; */\n      }\n\n      .info-text-container {\n        font-size: 0.875rem;\n        font-style: normal;\n        font-weight: 700;\n        line-height: 1.05rem;\n        text-transform: capitalize;\n        p {\n          font-size: 0.875rem;\n          font-style: normal;\n          font-weight: 700;\n          line-height: 1.05rem;\n          text-transform: capitalize;\n\n          > *:first-child {\n            color: ", " !important;\n          }\n        }\n      }\n\n      &.active {\n        border: 1px solid ", ";\n      }\n    }\n    .survey-voucher-select:hover {\n      :hover {\n        .no-offer-container {\n          svg path {\n            stroke: white !important;\n          }\n        }\n        svg > path {\n          fill: ", ";\n        }\n        svg > g line,\n        svg > g path {\n          stroke: white !important;\n        }\n        background: ", ";\n        .info-text-container {\n          color: white !important;\n        }\n        .issuance-type {\n          border: 1px solid white !important;\n          .issuance-text {\n            color: white !important;\n          }\n          /* background: ", " !important; */\n        }\n        .info-text-container {\n          p {\n            color: white !important;\n            > *:first-child {\n              color: white !important;\n            }\n          }\n        }\n        .info-text {\n          color: white !important;\n        }\n      }\n    }\n\n    .survey-multi-select > div {\n      border-color: ", ";\n\n      span {\n        svg path {\n          stroke: ", ";\n        }\n      }\n\n      &.active {\n        background: ", ";\n\n        span {\n          svg path {\n            stroke: var(--white);\n          }\n        }\n      }\n    }\n\n    .survey-multi-select-list {\n      > div {\n        > div:first-child span {\n          color: ", ";\n        }\n\n        &.active {\n          > div:first-child {\n            background: ", ";\n\n            span {\n              color: var(--white);\n            }\n          }\n\n          border-color: ", ";\n        }\n\n        :hover {\n          border-color: ", ";\n        }\n      }\n    }\n\n    span p {\n      display: inline;\n      margin-bottom: 0px;\n    }\n\n    .nps-rating.selected {\n      background-color: ", ";\n      border-color: ", ";\n    }\n\n    .survey-upload .ant-upload > span > div > div {\n      background: ", ";\n    }\n\n    .ant-btn-primary {\n      background: ", ";\n      border-color: ", ";\n\n      * {\n        color: var(--white);\n        margin-bottom: 0px;\n      }\n\n      :hover {\n        background: var(--white);\n\n        * {\n          color: ", ";\n        }\n      }\n    }\n\n    .sentiment .tag-actions .tag-icon.active {\n      background: ", ";\n    }\n  }\n\n  .btn-circle {\n    width: 2.5rem;\n    height: 2.5rem;\n    border-radius: 50%;\n    background: ", ";\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 2;\n  }\n\n  .preference-group {\n    .ant-radio-group {\n      .ant-radio-inner {\n        border-color: ", ";\n      }\n      .ant-radio-inner::after {\n        background-color: ", ";\n      }\n    }\n  }\n\n  .theme-bg {\n    background-color: ", ";\n\n    * {\n      color: var(--white);\n    }\n  }\n\n  *.required {\n    text-wrap: pretty;\n  }\n\n  *.required::after {\n    display: inline-block;\n    margin-inline-start: 0.25rem;\n    color: #ff4d4f;\n    font-size: 0.875rem;\n    font-family: inherit;\n    line-height: 1;\n    content: '*';\n  }\n\n  .staff-rating {\n    margin-bottom: 0.938rem;\n  }\n\n  .survey-stepper {\n    margin-bottom: 1.875rem;\n  }\n\n  .survey-stepper-90 {\n    width: 90%;\n    justify-content: center;\n  }\n\n  .survey-stepper-header {\n    display: flex;\n    flex-direction: row;\n    gap: 1.25rem;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 1.875rem;\n  }\n\n  .page-title {\n    margin-bottom: 1.875rem;\n  }\n"], ["\n  position: relative;\n  padding: 1.25rem;\n  padding-top: 2.5rem;\n\n  .welcome-logo-wrap {\n    margin-bottom: 0.625rem;\n  }\n\n  ", "\n\n  ", "\n\n  h2, h1, span, div, h5, p, textarea.ant-input, input.ant-input, .ant-picker .ant-picker-input input, .react-tel-input input {\n    font-family: ", " !important;\n  }\n\n  h2,\n  h1 {\n    * {\n      font-size: inherit;\n      line-height: inherit;\n      color: inherit;\n      font-family: inherit;\n      font-weight: inherit;\n    }\n  }\n\n  .page-content {\n    position: relative;\n    min-height: calc(669px - 200px);\n    max-height: 100%;\n\n    ", "\n\n    .location-search {\n      margin-bottom: 1.25rem;\n    }\n\n    .thankyou-page-title {\n      color: ", ";\n    }\n\n    .logo-circle {\n      border: 1px solid ", ";\n    }\n\n    .ant-checkbox-checked .ant-checkbox-inner {\n      background-color: ", ";\n      border-color: ", ";\n    }\n\n    .ant-checkbox-wrapper:hover {\n      .ant-checkbox-inner {\n        border-color: ", ";\n      }\n    }\n\n    .ant-input-affix-wrapper:focus,\n    .ant-input-affix-wrapper-focused,\n    .ant-input:focus,\n    .ant-input-focused {\n      border-color: ", ";\n      box-shadow: 0 0 0 2px\n        ", ";\n    }\n\n    .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {\n      border-color: ", ";\n    }\n\n    .ant-input:hover {\n      border-color: ", ";\n    }\n\n    .ant-picker-focused,\n    .ant-picker:hover {\n      border-color: ", ";\n    }\n\n    .ant-picker-focused {\n      box-shadow: 0 0 0 2px\n        ", ";\n    }\n\n    .select-option {\n      svg > g line,\n      svg > g path {\n        stroke: ", ";\n      }\n\n      :hover {\n        background: ", ";\n      }\n    }\n\n    .survey-voucher-select,\n    .survey-voucher-select-no-hover {\n      svg > path {\n        fill: ", ";\n        opacity: 0.175;\n      }\n      svg > g line,\n      svg > g path {\n        stroke: ", ";\n      }\n      .no-offer-container {\n        svg path {\n          stroke: ", ";\n          opacity: 1 !important;\n        }\n      }\n      .issuance-type {\n        border: 1px solid ", " !important;\n        .issuance-text {\n          color: ", " !important;\n        }\n        /* background: ", " !important; */\n      }\n\n      .info-text-container {\n        font-size: 0.875rem;\n        font-style: normal;\n        font-weight: 700;\n        line-height: 1.05rem;\n        text-transform: capitalize;\n        p {\n          font-size: 0.875rem;\n          font-style: normal;\n          font-weight: 700;\n          line-height: 1.05rem;\n          text-transform: capitalize;\n\n          > *:first-child {\n            color: ", " !important;\n          }\n        }\n      }\n\n      &.active {\n        border: 1px solid ", ";\n      }\n    }\n    .survey-voucher-select:hover {\n      :hover {\n        .no-offer-container {\n          svg path {\n            stroke: white !important;\n          }\n        }\n        svg > path {\n          fill: ", ";\n        }\n        svg > g line,\n        svg > g path {\n          stroke: white !important;\n        }\n        background: ", ";\n        .info-text-container {\n          color: white !important;\n        }\n        .issuance-type {\n          border: 1px solid white !important;\n          .issuance-text {\n            color: white !important;\n          }\n          /* background: ", " !important; */\n        }\n        .info-text-container {\n          p {\n            color: white !important;\n            > *:first-child {\n              color: white !important;\n            }\n          }\n        }\n        .info-text {\n          color: white !important;\n        }\n      }\n    }\n\n    .survey-multi-select > div {\n      border-color: ", ";\n\n      span {\n        svg path {\n          stroke: ", ";\n        }\n      }\n\n      &.active {\n        background: ", ";\n\n        span {\n          svg path {\n            stroke: var(--white);\n          }\n        }\n      }\n    }\n\n    .survey-multi-select-list {\n      > div {\n        > div:first-child span {\n          color: ", ";\n        }\n\n        &.active {\n          > div:first-child {\n            background: ", ";\n\n            span {\n              color: var(--white);\n            }\n          }\n\n          border-color: ", ";\n        }\n\n        :hover {\n          border-color: ", ";\n        }\n      }\n    }\n\n    span p {\n      display: inline;\n      margin-bottom: 0px;\n    }\n\n    .nps-rating.selected {\n      background-color: ", ";\n      border-color: ", ";\n    }\n\n    .survey-upload .ant-upload > span > div > div {\n      background: ", ";\n    }\n\n    .ant-btn-primary {\n      background: ", ";\n      border-color: ", ";\n\n      * {\n        color: var(--white);\n        margin-bottom: 0px;\n      }\n\n      :hover {\n        background: var(--white);\n\n        * {\n          color: ", ";\n        }\n      }\n    }\n\n    .sentiment .tag-actions .tag-icon.active {\n      background: ", ";\n    }\n  }\n\n  .btn-circle {\n    width: 2.5rem;\n    height: 2.5rem;\n    border-radius: 50%;\n    background: ", ";\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 2;\n  }\n\n  .preference-group {\n    .ant-radio-group {\n      .ant-radio-inner {\n        border-color: ", ";\n      }\n      .ant-radio-inner::after {\n        background-color: ", ";\n      }\n    }\n  }\n\n  .theme-bg {\n    background-color: ", ";\n\n    * {\n      color: var(--white);\n    }\n  }\n\n  *.required {\n    text-wrap: pretty;\n  }\n\n  *.required::after {\n    display: inline-block;\n    margin-inline-start: 0.25rem;\n    color: #ff4d4f;\n    font-size: 0.875rem;\n    font-family: inherit;\n    line-height: 1;\n    content: '*';\n  }\n\n  .staff-rating {\n    margin-bottom: 0.938rem;\n  }\n\n  .survey-stepper {\n    margin-bottom: 1.875rem;\n  }\n\n  .survey-stepper-90 {\n    width: 90%;\n    justify-content: center;\n  }\n\n  .survey-stepper-header {\n    display: flex;\n    flex-direction: row;\n    gap: 1.25rem;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 1.875rem;\n  }\n\n  .page-title {\n    margin-bottom: 1.875rem;\n  }\n"])), function (_a) {
    var $theme = _a.$theme;
    return ($theme === null || $theme === void 0 ? void 0 : $theme.$backgroundImage) &&
        "\n    background: linear-gradient(0deg, rgba(48, 56, 76, ".concat($theme.$backgroundOpacity !== 0 ? ($theme.$backgroundOpacity / 10) * 100 - 10 : 0, "%), rgba(48, 56, 76, ").concat($theme.$backgroundOpacity !== 0 ? ($theme.$backgroundOpacity / 10) * 100 : 0, "%)),\n                url(").concat($theme === null || $theme === void 0 ? void 0 : $theme.$backgroundImage, ");\n     background-repeat: no-repeat;\n     background-size: cover;\n     min-height: 100%;\n     \n     .bg-theme-allowed, .bg-theme-allowed * {\n      color: var(--white) !important;\n\n      svg {\n        path {\n          stroke: var(--white) !important;\n        }\n      }\n     }\n\n     .powered-by-momos {\n        color: var(--white);\n        \n        svg path {\n          fill: var(--white);\n        }\n     }\n\n    ");
}, function (_a) {
    var $theme = _a.$theme;
    return ($theme === null || $theme === void 0 ? void 0 : $theme.$fullHeight) && "height: ".concat($theme.$fullHeight, ";");
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.$fontFamily;
}, function (_a) {
    var $theme = _a.$theme;
    return ($theme === null || $theme === void 0 ? void 0 : $theme.$fullHeight) && "height: ".concat($theme.$fullHeight, ";");
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return ($theme.color ? hexToRgbA($theme.color, 0.2) : 'rgba(216, 67, 57, 0.2)');
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return ($theme.color ? hexToRgbA($theme.color, 0.2) : 'rgba(216, 67, 57, 0.2)');
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return "".concat($theme.color) || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
});
var templateObject_1$k;

var StyledBoxLayout = defaultStyled.div(templateObject_1$j || (templateObject_1$j = __makeTemplateObject(["\n  position: relative;\n  padding: 1.25rem;\n\n  .welcome-logo-wrap {\n    margin-bottom: 0.625rem;\n  }\n\n  ", "\n\n  ", "\n  \n    h2, h1, span, div, h5, p, textarea.ant-input, input.ant-input, .ant-picker .ant-picker-input input, .react-tel-input input {\n    font-family: ", " !important;\n  }\n\n  h2,\n  h1 {\n    * {\n      font-size: inherit;\n      line-height: inherit;\n      color: inherit;\n      font-family: inherit;\n      font-weight: inherit;\n    }\n  }\n\n  .location-search {\n    border-radius: 10px !important;\n    margin-bottom: 0.625rem;\n  }\n\n  .page-body {\n    min-height: calc(41.8125rem - 12.5rem);\n  }\n\n  .page-content {\n    position: relative;\n    background: ", ";\n    padding: ", ";\n    border-radius: 8px;\n\n    .select-options-wrap {\n      margin-bottom: 0px;\n    }\n\n    ", "\n\n    .thankyou-page-title {\n      color: ", ";\n    }\n\n    .logo-circle {\n      border: 1px solid ", ";\n    }\n\n    .ant-checkbox-checked .ant-checkbox-inner {\n      background-color: ", ";\n      border-color: ", ";\n    }\n\n    .ant-input-affix-wrapper:focus,\n    .ant-input-affix-wrapper-focused,\n    .ant-input:focus,\n    .ant-input-focused {\n      border-color: ", ";\n      box-shadow: 0 0 0 2px\n        ", ";\n    }\n\n    .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {\n      border-color: ", ";\n    }\n\n    .ant-input:hover {\n      border-color: ", ";\n    }\n\n    .ant-picker-focused,\n    .ant-picker:hover {\n      border-color: ", ";\n    }\n\n    .ant-picker-focused {\n      box-shadow: 0 0 0 2px\n        ", ";\n    }\n\n    .ant-checkbox-wrapper:hover {\n      .ant-checkbox-inner {\n        border-color: ", ";\n      }\n    }\n\n    .select-option {\n      svg > g line,\n      svg > g path {\n        stroke: ", ";\n      }\n\n      :hover {\n        background: ", ";\n      }\n    }\n\n    .survey-voucher-select,\n    .survey-voucher-select-no-hover {\n      svg > path {\n        fill: ", ";\n        opacity: 0.175;\n      }\n      svg > g line,\n      svg > g path {\n        stroke: ", ";\n      }\n      .no-offer-container {\n        svg path {\n          stroke: ", ";\n          opacity: 1 !important;\n        }\n      }\n\n      .info-text-container {\n        font-size: 0.875rem;\n        font-style: normal;\n        font-weight: 700;\n        line-height: 1.05rem;\n        text-transform: capitalize;\n        p {\n          font-size: 0.875rem;\n          font-style: normal;\n          font-weight: 700;\n          line-height: 1.05rem;\n          text-transform: capitalize;\n\n          > *:first-child {\n            color: ", " !important;\n          }\n        }\n      }\n\n      &.active {\n        border: 1px solid ", ";\n      }\n    }\n    .survey-voucher-select:hover {\n      :hover {\n        .no-offer-container {\n          svg path {\n            stroke: white !important;\n          }\n        }\n        svg > path {\n          fill: ", ";\n        }\n        svg > g line,\n        svg > g path {\n          stroke: white !important;\n        }\n        background: ", ";\n        .info-text-container {\n          color: white !important;\n        }\n        .info-text-container {\n          p {\n            color: white !important;\n            > *:first-child {\n              color: white !important;\n            }\n          }\n        }\n        .info-text {\n          color: white !important;\n        }\n      }\n    }\n\n    .survey-multi-select-list {\n      > div {\n        > div:first-child span {\n          color: ", ";\n        }\n\n        &.active {\n          > div:first-child {\n            background: ", ";\n\n            span {\n              color: var(--white);\n            }\n          }\n\n          border-color: ", ";\n        }\n\n        :hover {\n          border-color: ", ";\n        }\n      }\n    }\n\n    span p {\n      display: inline;\n      margin-bottom: 0px;\n    }\n\n    .nps-rating.selected {\n      background-color: ", ";\n      border-color: ", ";\n    }\n\n    .survey-upload .ant-upload > span > div > div {\n      background: ", ";\n    }\n\n    .ant-btn-primary {\n      background: ", ";\n      border-color: ", ";\n\n      * {\n        color: var(--white);\n        margin-bottom: 0px;\n      }\n\n      :hover {\n        background: var(--white);\n\n        * {\n          color: ", ";\n        }\n      }\n    }\n\n    .sentiment .tag-actions .tag-icon.active {\n      background: ", ";\n    }\n  }\n\n  .btn-circle {\n    width: 2.5rem;\n    height: 2.5rem;\n    border-radius: 50%;\n    background: ", ";\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 2;\n  }\n\n  .preference-group {\n    .ant-radio-group {\n      .ant-radio-inner {\n        border-color: ", ";\n      }\n      .ant-radio-inner::after {\n        background-color: ", ";\n      }\n    }\n  }\n\n  .theme-bg {\n    background-color: ", ";\n\n    * {\n      color: var(--white);\n    }\n  }\n\n  *.required {\n    text-wrap: pretty;\n  }\n\n  *.required::after {\n    display: inline-block;\n    margin-inline-start: 0.25rem;\n    color: #ff4d4f;\n    font-size: 0.875rem;\n    font-family: inherit;\n    line-height: 1;\n    content: '*';\n  }\n\n  .staff-rating {\n    margin-bottom: 0.938rem;\n  }\n\n  .survey-stepper {\n    margin-bottom: 1.875rem;\n  }\n\n  .survey-stepper-90 {\n    width: 90%;\n    justify-content: center;\n  }\n\n  .survey-stepper-header {\n    display: flex;\n    flex-direction: row;\n    gap: 1.25rem;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: ", ";\n  }\n\n  .page-title {\n    margin-bottom: 1.875rem;\n\n    h2 {\n      text-align: center;\n      font-size: 1.375rem;\n      line-height: 1.625rem;\n    }\n  }\n"], ["\n  position: relative;\n  padding: 1.25rem;\n\n  .welcome-logo-wrap {\n    margin-bottom: 0.625rem;\n  }\n\n  ", "\n\n  ", "\n  \n    h2, h1, span, div, h5, p, textarea.ant-input, input.ant-input, .ant-picker .ant-picker-input input, .react-tel-input input {\n    font-family: ", " !important;\n  }\n\n  h2,\n  h1 {\n    * {\n      font-size: inherit;\n      line-height: inherit;\n      color: inherit;\n      font-family: inherit;\n      font-weight: inherit;\n    }\n  }\n\n  .location-search {\n    border-radius: 10px !important;\n    margin-bottom: 0.625rem;\n  }\n\n  .page-body {\n    min-height: calc(41.8125rem - 12.5rem);\n  }\n\n  .page-content {\n    position: relative;\n    background: ", ";\n    padding: ", ";\n    border-radius: 8px;\n\n    .select-options-wrap {\n      margin-bottom: 0px;\n    }\n\n    ", "\n\n    .thankyou-page-title {\n      color: ", ";\n    }\n\n    .logo-circle {\n      border: 1px solid ", ";\n    }\n\n    .ant-checkbox-checked .ant-checkbox-inner {\n      background-color: ", ";\n      border-color: ", ";\n    }\n\n    .ant-input-affix-wrapper:focus,\n    .ant-input-affix-wrapper-focused,\n    .ant-input:focus,\n    .ant-input-focused {\n      border-color: ", ";\n      box-shadow: 0 0 0 2px\n        ", ";\n    }\n\n    .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {\n      border-color: ", ";\n    }\n\n    .ant-input:hover {\n      border-color: ", ";\n    }\n\n    .ant-picker-focused,\n    .ant-picker:hover {\n      border-color: ", ";\n    }\n\n    .ant-picker-focused {\n      box-shadow: 0 0 0 2px\n        ", ";\n    }\n\n    .ant-checkbox-wrapper:hover {\n      .ant-checkbox-inner {\n        border-color: ", ";\n      }\n    }\n\n    .select-option {\n      svg > g line,\n      svg > g path {\n        stroke: ", ";\n      }\n\n      :hover {\n        background: ", ";\n      }\n    }\n\n    .survey-voucher-select,\n    .survey-voucher-select-no-hover {\n      svg > path {\n        fill: ", ";\n        opacity: 0.175;\n      }\n      svg > g line,\n      svg > g path {\n        stroke: ", ";\n      }\n      .no-offer-container {\n        svg path {\n          stroke: ", ";\n          opacity: 1 !important;\n        }\n      }\n\n      .info-text-container {\n        font-size: 0.875rem;\n        font-style: normal;\n        font-weight: 700;\n        line-height: 1.05rem;\n        text-transform: capitalize;\n        p {\n          font-size: 0.875rem;\n          font-style: normal;\n          font-weight: 700;\n          line-height: 1.05rem;\n          text-transform: capitalize;\n\n          > *:first-child {\n            color: ", " !important;\n          }\n        }\n      }\n\n      &.active {\n        border: 1px solid ", ";\n      }\n    }\n    .survey-voucher-select:hover {\n      :hover {\n        .no-offer-container {\n          svg path {\n            stroke: white !important;\n          }\n        }\n        svg > path {\n          fill: ", ";\n        }\n        svg > g line,\n        svg > g path {\n          stroke: white !important;\n        }\n        background: ", ";\n        .info-text-container {\n          color: white !important;\n        }\n        .info-text-container {\n          p {\n            color: white !important;\n            > *:first-child {\n              color: white !important;\n            }\n          }\n        }\n        .info-text {\n          color: white !important;\n        }\n      }\n    }\n\n    .survey-multi-select-list {\n      > div {\n        > div:first-child span {\n          color: ", ";\n        }\n\n        &.active {\n          > div:first-child {\n            background: ", ";\n\n            span {\n              color: var(--white);\n            }\n          }\n\n          border-color: ", ";\n        }\n\n        :hover {\n          border-color: ", ";\n        }\n      }\n    }\n\n    span p {\n      display: inline;\n      margin-bottom: 0px;\n    }\n\n    .nps-rating.selected {\n      background-color: ", ";\n      border-color: ", ";\n    }\n\n    .survey-upload .ant-upload > span > div > div {\n      background: ", ";\n    }\n\n    .ant-btn-primary {\n      background: ", ";\n      border-color: ", ";\n\n      * {\n        color: var(--white);\n        margin-bottom: 0px;\n      }\n\n      :hover {\n        background: var(--white);\n\n        * {\n          color: ", ";\n        }\n      }\n    }\n\n    .sentiment .tag-actions .tag-icon.active {\n      background: ", ";\n    }\n  }\n\n  .btn-circle {\n    width: 2.5rem;\n    height: 2.5rem;\n    border-radius: 50%;\n    background: ", ";\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 2;\n  }\n\n  .preference-group {\n    .ant-radio-group {\n      .ant-radio-inner {\n        border-color: ", ";\n      }\n      .ant-radio-inner::after {\n        background-color: ", ";\n      }\n    }\n  }\n\n  .theme-bg {\n    background-color: ", ";\n\n    * {\n      color: var(--white);\n    }\n  }\n\n  *.required {\n    text-wrap: pretty;\n  }\n\n  *.required::after {\n    display: inline-block;\n    margin-inline-start: 0.25rem;\n    color: #ff4d4f;\n    font-size: 0.875rem;\n    font-family: inherit;\n    line-height: 1;\n    content: '*';\n  }\n\n  .staff-rating {\n    margin-bottom: 0.938rem;\n  }\n\n  .survey-stepper {\n    margin-bottom: 1.875rem;\n  }\n\n  .survey-stepper-90 {\n    width: 90%;\n    justify-content: center;\n  }\n\n  .survey-stepper-header {\n    display: flex;\n    flex-direction: row;\n    gap: 1.25rem;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: ", ";\n  }\n\n  .page-title {\n    margin-bottom: 1.875rem;\n\n    h2 {\n      text-align: center;\n      font-size: 1.375rem;\n      line-height: 1.625rem;\n    }\n  }\n"])), function (_a) {
    var $theme = _a.$theme;
    return ($theme === null || $theme === void 0 ? void 0 : $theme.$backgroundImage) &&
        "\n      background: linear-gradient(0deg, rgba(48, 56, 76, ".concat($theme.$backgroundOpacity !== 0 ? ($theme.$backgroundOpacity / 10) * 100 - 10 : 0, "%), rgba(48, 56, 76, ").concat($theme.$backgroundOpacity !== 0 ? ($theme.$backgroundOpacity / 10) * 100 : 0, "%)),\n                  url(").concat($theme === null || $theme === void 0 ? void 0 : $theme.$backgroundImage, ");\n       background-repeat: no-repeat;\n       background-size: cover;\n       min-height: 100%;\n       \n       .bg-theme-allowed, .bg-theme-allowed * {\n          color: var(--white);\n\n          svg path {\n            stroke: var(--white);\n          }\n       }\n  \n       .powered-by-momos {\n          color: var(--white);\n          \n          svg path {\n            fill: var(--white);\n          }\n       }\n  \n      ");
}, function (_a) {
    var $theme = _a.$theme;
    return ($theme === null || $theme === void 0 ? void 0 : $theme.$fullHeight) && "height: ".concat($theme.$fullHeight, ";");
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.$fontFamily;
}, function (_a) {
    var $ignore = _a.$ignore;
    return ($ignore ? 'unset' : 'var(--white)');
}, function (_a) {
    var $ignore = _a.$ignore;
    return ($ignore ? '0px' : '0.938rem');
}, function (_a) {
    var $theme = _a.$theme;
    return ($theme === null || $theme === void 0 ? void 0 : $theme.$fullHeight) && "height: ".concat($theme.$fullHeight, ";");
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return ($theme.color ? hexToRgbA($theme.color, 0.2) : 'rgba(216, 67, 57, 0.2)');
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return ($theme.color ? hexToRgbA($theme.color, 0.2) : 'rgba(216, 67, 57, 0.2)');
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return "".concat($theme.color) || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $showStepper = _a.$showStepper;
    return ($showStepper ? '1.875rem' : '0.625rem');
});
var BoxLayout = function (_a) {
    var children = _a.children, theme = _a.theme, showStepper = _a.showStepper, currentPageKey = _a.currentPageKey, props = __rest(_a, ["children", "theme", "showStepper", "currentPageKey"]);
    return (React__default.createElement(StyledBoxLayout, __assign({ "$theme": theme, "$showStepper": showStepper, "$ignore": currentPageKey === PAGE_KEYS.WELCOME_PAGE }, props), children));
};
var templateObject_1$j;

var getField = function (page, fieldKey) {
    var field = page.value.find(function (f) { return f.fieldKey == fieldKey; });
    return field;
};
var getFieldValue = function (page, fieldKey) {
    var field = page.value.find(function (f) { return f.fieldKey == fieldKey; });
    return field === null || field === void 0 ? void 0 : field.fieldValue;
};
var getPageVariantFieldValue = function (page, fieldKey, pageVariant) {
    var _a;
    var field = page.value.find(function (f) { return f.fieldKey == fieldKey; });
    var isPageVariantExist = (_a = field.fieldValueConfig) === null || _a === void 0 ? void 0 : _a[pageVariant];
    return isPageVariantExist === null || isPageVariantExist === void 0 ? void 0 : isPageVariantExist.fieldValue;
};
var getFieldRequired = function (page, fieldKey) {
    var field = page.value.find(function (f) { return f.fieldKey == fieldKey; });
    return field === null || field === void 0 ? void 0 : field.showRequired;
};
var getFieldAnswerValue = function (page, fieldKey, selectedFieldKey) {
    var _a, _b;
    var field = page.value.find(function (f) { return f.fieldKey == fieldKey; });
    var selectedValue = (_a = page === null || page === void 0 ? void 0 : page.selectedValue) === null || _a === void 0 ? void 0 : _a[selectedFieldKey];
    if (selectedValue && selectedFieldKey) {
        return (_b = page === null || page === void 0 ? void 0 : page.selectedValue) === null || _b === void 0 ? void 0 : _b[selectedFieldKey];
    }
    return field === null || field === void 0 ? void 0 : field.defaultAnswer;
};
var showField = function (page, fieldKey, ignoreFieldValueCheck) {
    if (ignoreFieldValueCheck === void 0) { ignoreFieldValueCheck = false; }
    var field = page.value.find(function (f) { return f.fieldKey == fieldKey; });
    return Boolean((field === null || field === void 0 ? void 0 : field.show) && (ignoreFieldValueCheck ? true : field === null || field === void 0 ? void 0 : field.fieldValue));
};
var showPageVariantField = function (page, fieldKey, pageVariant, ignoreFieldValueCheck) {
    if (ignoreFieldValueCheck === void 0) { ignoreFieldValueCheck = false; }
    if (ignoreFieldValueCheck) {
        return true;
    }
    var field = page.value.find(function (f) { return f.fieldKey == fieldKey; });
    var isPageVariantExist = field.fieldValueConfig[pageVariant];
    if (isPageVariantExist) {
        return isPageVariantExist === null || isPageVariantExist === void 0 ? void 0 : isPageVariantExist.show;
    }
    return false;
};
var isHiddenField = function (page, fieldKey) {
    var field = page.value.find(function (f) { return f.fieldKey == fieldKey; });
    return Boolean(field === null || field === void 0 ? void 0 : field.isHiddenField);
};
var showQuestionField = function (question, fieldKey, ignoreFieldValueCheck) {
    var _a;
    if (ignoreFieldValueCheck === void 0) { ignoreFieldValueCheck = false; }
    var field = (_a = question === null || question === void 0 ? void 0 : question.value) === null || _a === void 0 ? void 0 : _a.find(function (f) { return f.fieldKey == fieldKey; });
    return Boolean((field === null || field === void 0 ? void 0 : field.show) && (ignoreFieldValueCheck ? true : field === null || field === void 0 ? void 0 : field.fieldValue));
};
var getFieldQuestionValue = function (question, fieldKey) {
    var _a;
    var field = (_a = question === null || question === void 0 ? void 0 : question.value) === null || _a === void 0 ? void 0 : _a.find(function (f) { return f.fieldKey == fieldKey; });
    return field === null || field === void 0 ? void 0 : field.fieldValue;
};
var getFieldQuestionRequired = function (question, fieldKey) {
    var field = question.value.find(function (f) { return f.fieldKey == fieldKey; });
    return field === null || field === void 0 ? void 0 : field.showRequired;
};
var normalizeRating = function (_a) {
    var value = _a.value, type = _a.type;
    if (type === RATING.THUMBS) {
        if (value === -1)
            return '1';
        if (value === 1)
            return '5';
    }
    if (type === RATING.STAR_1_3) {
        if (value === 1)
            return '1';
        if (value === 2)
            return '3';
        if (value === 3)
            return '5';
    }
    if (type === RATING.STAR_1_10) {
        if (Math.floor(value / 2) === 0) {
            return '1';
        }
        return Math.floor(value / 2).toString();
    }
    // default for RATING.STAR_1_5, RATING.EMOJI
    return value === null || value === void 0 ? void 0 : value.toString();
};
var isCurrentRatingIsUnderRange = function (pages, ratingRange, pageKey) {
    var _a, _b;
    var currentPageIndex = pages.find(function (page) { return page.pageKey === pageKey; });
    var ratingValue = ((_a = currentPageIndex === null || currentPageIndex === void 0 ? void 0 : currentPageIndex.selectedValue) === null || _a === void 0 ? void 0 : _a.main) || ((_b = currentPageIndex === null || currentPageIndex === void 0 ? void 0 : currentPageIndex.selectedValue) === null || _b === void 0 ? void 0 : _b.rating) || (currentPageIndex === null || currentPageIndex === void 0 ? void 0 : currentPageIndex.selectedValue);
    if (!ratingValue) {
        return true;
    }
    var scaleType = ratingValue === null || ratingValue === void 0 ? void 0 : ratingValue.type;
    var scaleValue = ratingValue === null || ratingValue === void 0 ? void 0 : ratingValue.value;
    var selectedValue = Number(normalizeRating({ type: scaleType, value: scaleValue }));
    if (selectedValue && ratingRange && Array.isArray(ratingRange) && (ratingRange === null || ratingRange === void 0 ? void 0 : ratingRange.length) === 2) {
        if (ratingRange[0] <= selectedValue && ratingRange[1] >= selectedValue) {
            return true;
        }
    }
    return false;
};
var isServiceTypeMatchingQuestion = function (pages, question) {
    var _a, _b;
    var userSelectedServiceType = (_b = (_a = pages.find(function (page) { return page.pageKey === PAGE_KEYS.TYPE_OF_ORDER; })) === null || _a === void 0 ? void 0 : _a.selectedValue) === null || _b === void 0 ? void 0 : _b.key;
    return doesUserServiceTypeMatchQuestion(userSelectedServiceType, question);
};
var isClient = function () {
    return typeof window !== 'undefined';
};
var scrollToErrorElement = function () {
    if (isClient()) {
        var elements = document.getElementsByClassName('has-field-error')[0];
        elements === null || elements === void 0 ? void 0 : elements.scrollIntoView({
            behavior: 'smooth'
        });
    }
};
var getSelectedOffer = function (pageValues, vouchersData) {
    var resultValue = false;
    var page = lodashExports.find(pageValues, function (page) { return lodashExports.some(page.value, function (value) { return (value === null || value === void 0 ? void 0 : value.type) === 'choose_voucher'; }); });
    if (page) {
        var pageValue = lodashExports.find(page.value, { type: 'choose_voucher' });
        resultValue = (pageValue === null || pageValue === void 0 ? void 0 : pageValue.fieldValue) || false;
        if (resultValue === 'no_offer') {
            resultValue = false;
        }
    }
    if (resultValue) {
        var voucherDataByID = vouchersData === null || vouchersData === void 0 ? void 0 : vouchersData.find(function (eachData) { return eachData.id === resultValue; });
        return voucherDataByID || false;
    }
    return false;
};
var getSelectedOfferForStandardFeedbackSurveyV2 = function (pageValues, vouchersData, multiVoucherIds, editorMode) {
    // In editMode, if we have multiVoucherIds, use the first one
    if (editorMode && (multiVoucherIds === null || multiVoucherIds === void 0 ? void 0 : multiVoucherIds.length)) {
        var voucherId_1 = multiVoucherIds[0];
        if (vouchersData === null || vouchersData === void 0 ? void 0 : vouchersData.length) {
            var voucherDataByID = vouchersData.find(function (eachData) { return eachData.id === voucherId_1; });
            return voucherDataByID || false;
        }
    }
    var chooseOfferPage = lodashExports.find(pageValues, function (page) {
        if (!(page === null || page === void 0 ? void 0 : page.selectedValue))
            return false;
        return Object.values(page.selectedValue).some(function (question) { return question && typeof question === 'object' && question.type === 'choose_voucher'; });
    });
    if (!(chooseOfferPage === null || chooseOfferPage === void 0 ? void 0 : chooseOfferPage.selectedValue)) {
        // If no selection page found and we have a single voucher
        if ((multiVoucherIds === null || multiVoucherIds === void 0 ? void 0 : multiVoucherIds.length) === 1) {
            var voucherDataByID = vouchersData === null || vouchersData === void 0 ? void 0 : vouchersData.find(function (eachData) { return eachData.id === multiVoucherIds[0]; });
            return voucherDataByID || false;
        }
        return false;
    }
    var chooseVoucherQuestion = Object.values(chooseOfferPage.selectedValue).find(function (question) { return question && typeof question === 'object' && question.type === 'choose_voucher'; });
    if (!chooseVoucherQuestion) {
        return false;
    }
    var selectedVoucherId = chooseVoucherQuestion.value;
    if (!selectedVoucherId || selectedVoucherId === 'no_offer') {
        return false;
    }
    if (selectedVoucherId && (vouchersData === null || vouchersData === void 0 ? void 0 : vouchersData.length)) {
        var voucherDataByID = vouchersData.find(function (eachData) { return eachData.id === selectedVoucherId; });
        return voucherDataByID || false;
    }
    return false;
};

var WelcomePageLogoWrap = defaultStyled.div(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  margin-bottom: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  margin-bottom: ", ";\n"])), function (props) { return (props.$showMarginBottom ? '1.25rem' : '0px'); });
var LogoWrap$2 = defaultStyled.div(templateObject_2$f || (templateObject_2$f = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 12.5rem;\n    height: 6.875rem;\n    object-fit: contain;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 12.5rem;\n    height: 6.875rem;\n    object-fit: contain;\n  }\n"])));
var BrandInfo = function (_a) {
    var page = _a.page, pageVariant = _a.pageVariant;
    var showBrandLogoCondition = (pageVariant ? showPageVariantField(page, 'brand_logo', pageVariant) : showField(page, 'brand_logo'));
    var brandLogoFieldValue = (pageVariant ? getPageVariantFieldValue(page, 'brand_logo', pageVariant) : getFieldValue(page, 'brand_logo'));
    var showBrandNameCondition = pageVariant ? showPageVariantField(page, 'brand_name', pageVariant) : showField(page, 'brand_name');
    var brandNameFieldValue = pageVariant ? getPageVariantFieldValue(page, 'brand_name', pageVariant) : getFieldValue(page, 'brand_name');
    var brandLogo = showBrandLogoCondition && brandLogoFieldValue ? brandLogoFieldValue : false;
    var brandName = showBrandNameCondition && brandNameFieldValue ? brandNameFieldValue : false;
    return (React__default.createElement(WelcomePageLogoWrap, { "$showMarginBottom": brandLogo || brandName, className: "page-brand-logo" },
        brandLogo && (React__default.createElement(LogoWrap$2, { className: "welcome-logo-wrap" },
            React__default.createElement("img", { src: brandLogo.mediaUrl, alt: "logo" }))),
        brandName && (React__default.createElement(Text$1.H2, { className: "bg-theme-allowed", semibold: true, dangerouslySetInnerHTML: { __html: brandName || '' } }))));
};
var templateObject_1$i, templateObject_2$f;

var IssuanceTypeEnum;
(function (IssuanceTypeEnum) {
    IssuanceTypeEnum["LUCKY_DRAW"] = "luckyDraw";
    IssuanceTypeEnum["IMMEDIATE"] = "immediate";
})(IssuanceTypeEnum || (IssuanceTypeEnum = {}));

var VoucherCardWrapper$1 = defaultStyled.div(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n  .survey-voucher-select-no-hover,\n  .survey-voucher-select {\n    display: flex;\n    padding: 10px 15px;\n    flex-direction: column;\n    justify-content: flex-end;\n    align-items: flex-start;\n    gap: 8px;\n    align-self: stretch;\n    border-radius: 10px;\n    border: 1px solid var(--Gray-Light-Gray, #eaeaea);\n    background: #fff;\n\n    .no-offer-container {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-direction: row;\n      width: 100%;\n      gap: 8px;\n\n      .no-offer-text {\n        color: var(--Gray-Dark-Slate-Gray, #30384c);\n        font-family: var(--font-family-base);\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 600;\n        margin-bottom: 0px;\n      }\n    }\n    .main-container {\n      display: flex;\n      flex-direction: row;\n      gap: 20px;\n      align-self: stretch;\n    }\n    .content-data {\n      display: flex;\n      flex: 3;\n      flex-direction: column;\n      justify-content: center;\n      gap: 5px;\n\n      .info-container {\n        display: flex;\n        flex-direction: row;\n        justify-content: flex-end;\n\n        .info-card-box {\n          display: flex;\n          padding: 2px 4px;\n          align-items: flex-start;\n          gap: 10px;\n          border-radius: 10px;\n          border: 1px solid var(--gray-light-gray, #eaeaea);\n\n          .info-text {\n            color: var(--grey-semi-light, #a0a0a0);\n            font-family: var(--font-family-base);\n            font-size: 10px;\n            font-style: normal;\n            font-weight: 600;\n            margin-bottom: 0px;\n          }\n        }\n      }\n      .info-text-container {\n        text-align: left;\n\n        p {\n          margin-bottom: 0px;\n        }\n\n        .highlight-content-text {\n          color: var(--Basis-Indianred, #d84339);\n          font-family: var(--font-family-base);\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 700;\n          line-height: 120%; /* 16.8px */\n          text-transform: capitalize;\n        }\n        .main-content-text {\n          color: var(--Dark-Slate-Gray, #30384c);\n          font-family: var(--font-family-base);\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 700;\n          line-height: 120%;\n          text-transform: capitalize;\n        }\n        }\n\n        .subtitle-container {\n          text-align: left;\n          \n          p {\n            font-size: 12px;\n            line-height: 13px;\n            margin-bottom: 0px;\n          }\n          }\n      }\n    }\n    .issuance-container {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      flex: 1;\n      gap: 2;\n    }\n\n    .issuance-type {\n      display: flex;\n      padding: 4px 6px;\n      align-items: flex-start;\n      gap: 10px;\n      border-radius: 10px;\n      justify-content: center;\n\n      .issuance-text {\n        color: var(--Gray-White, #fff);\n        margin-bottom: 0px;\n        font-family: var(--font-family-base);\n        font-size: 10px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 120%;\n      }\n    }\n  \n"], ["\n  .survey-voucher-select-no-hover,\n  .survey-voucher-select {\n    display: flex;\n    padding: 10px 15px;\n    flex-direction: column;\n    justify-content: flex-end;\n    align-items: flex-start;\n    gap: 8px;\n    align-self: stretch;\n    border-radius: 10px;\n    border: 1px solid var(--Gray-Light-Gray, #eaeaea);\n    background: #fff;\n\n    .no-offer-container {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-direction: row;\n      width: 100%;\n      gap: 8px;\n\n      .no-offer-text {\n        color: var(--Gray-Dark-Slate-Gray, #30384c);\n        font-family: var(--font-family-base);\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 600;\n        margin-bottom: 0px;\n      }\n    }\n    .main-container {\n      display: flex;\n      flex-direction: row;\n      gap: 20px;\n      align-self: stretch;\n    }\n    .content-data {\n      display: flex;\n      flex: 3;\n      flex-direction: column;\n      justify-content: center;\n      gap: 5px;\n\n      .info-container {\n        display: flex;\n        flex-direction: row;\n        justify-content: flex-end;\n\n        .info-card-box {\n          display: flex;\n          padding: 2px 4px;\n          align-items: flex-start;\n          gap: 10px;\n          border-radius: 10px;\n          border: 1px solid var(--gray-light-gray, #eaeaea);\n\n          .info-text {\n            color: var(--grey-semi-light, #a0a0a0);\n            font-family: var(--font-family-base);\n            font-size: 10px;\n            font-style: normal;\n            font-weight: 600;\n            margin-bottom: 0px;\n          }\n        }\n      }\n      .info-text-container {\n        text-align: left;\n\n        p {\n          margin-bottom: 0px;\n        }\n\n        .highlight-content-text {\n          color: var(--Basis-Indianred, #d84339);\n          font-family: var(--font-family-base);\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 700;\n          line-height: 120%; /* 16.8px */\n          text-transform: capitalize;\n        }\n        .main-content-text {\n          color: var(--Dark-Slate-Gray, #30384c);\n          font-family: var(--font-family-base);\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 700;\n          line-height: 120%;\n          text-transform: capitalize;\n        }\n        }\n\n        .subtitle-container {\n          text-align: left;\n          \n          p {\n            font-size: 12px;\n            line-height: 13px;\n            margin-bottom: 0px;\n          }\n          }\n      }\n    }\n    .issuance-container {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      flex: 1;\n      gap: 2;\n    }\n\n    .issuance-type {\n      display: flex;\n      padding: 4px 6px;\n      align-items: flex-start;\n      gap: 10px;\n      border-radius: 10px;\n      justify-content: center;\n\n      .issuance-text {\n        color: var(--Gray-White, #fff);\n        margin-bottom: 0px;\n        font-family: var(--font-family-base);\n        font-size: 10px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 120%;\n      }\n    }\n  \n"])));
var getVoucherImage = function (rewardType) {
    switch (rewardType) {
        case REWARD_TYPES.DISCOUNT_AMOUNT: {
            return 'VoucherAmountOffIcon';
        }
        case REWARD_TYPES.PERCENTAGE_OFF: {
            return 'VoucherPercentageOffIcon';
        }
        case REWARD_TYPES.FREE_ITEM: {
            return 'VoucherFreeItemIcon';
        }
        default: {
            return 'VoucherAmountOffIcon';
        }
    }
};
var OfferCardV2 = function (_a) {
    var _b, _c;
    var data = _a.data, selectedValue = _a.selectedValue, voucherId = _a.voucherId, onVoucherSelect = _a.onVoucherSelect, preview = _a.preview, voucherSurveyMetadata = _a.voucherSurveyMetadata;
    var getFormatedSubTitle = function (voucherData) {
        if (voucherData === null || voucherData === void 0 ? void 0 : voucherData.minOrderValue) {
            return "Min order ".concat(voucherData === null || voucherData === void 0 ? void 0 : voucherData.currency, " ").concat(voucherData === null || voucherData === void 0 ? void 0 : voucherData.minOrderValue);
        }
        if (voucherData === null || voucherData === void 0 ? void 0 : voucherData.withPurchaseOf) {
            return "With purchase of ".concat(voucherData === null || voucherData === void 0 ? void 0 : voucherData.withPurchaseOf);
        }
        return "";
    };
    var getFormatedTitle = function (data, rewardType) {
        var _a, _b, _c, _d, _e, _f;
        if (voucherSurveyMetadata === null || voucherSurveyMetadata === void 0 ? void 0 : voucherSurveyMetadata.valueText) {
            return "<p><span>".concat(voucherSurveyMetadata === null || voucherSurveyMetadata === void 0 ? void 0 : voucherSurveyMetadata.valueText, " </span>").concat(voucherSurveyMetadata === null || voucherSurveyMetadata === void 0 ? void 0 : voucherSurveyMetadata.titleText, " </p>");
        }
        if (data) {
            var voucherData_1 = data.voucherData;
            var voucherTitle = '';
            if (REWARD_TYPES.DISCOUNT_AMOUNT === rewardType) {
                voucherTitle = "<p><span>".concat((voucherData_1 === null || voucherData_1 === void 0 ? void 0 : voucherData_1.currency) ? voucherData_1 === null || voucherData_1 === void 0 ? void 0 : voucherData_1.currency : '', " ").concat(voucherData_1 === null || voucherData_1 === void 0 ? void 0 : voucherData_1.amountOff, " Off </span> ");
            }
            else if (REWARD_TYPES.PERCENTAGE_OFF === rewardType) {
                voucherTitle = "<p><span>".concat(voucherData_1 === null || voucherData_1 === void 0 ? void 0 : voucherData_1.percentageOff, "% Off </span> ");
            }
            else if (REWARD_TYPES.FREE_ITEM === rewardType) {
                voucherTitle = "<p><span>Free ".concat(voucherData_1 === null || voucherData_1 === void 0 ? void 0 : voucherData_1.freeItem, " </span>");
            }
            if (voucherTitle === null || voucherTitle === void 0 ? void 0 : voucherTitle.length) {
                if ((voucherData_1 === null || voucherData_1 === void 0 ? void 0 : voucherData_1.brandName) && ((_b = (_a = data === null || data === void 0 ? void 0 : data.platform) === null || _a === void 0 ? void 0 : _a.platform) === null || _b === void 0 ? void 0 : _b.length)) {
                    voucherTitle = "".concat(voucherTitle, " on ").concat((_c = data === null || data === void 0 ? void 0 : data.platform) === null || _c === void 0 ? void 0 : _c.platform, " order at ").concat(voucherData_1 === null || voucherData_1 === void 0 ? void 0 : voucherData_1.brandName);
                }
                else if ((_e = (_d = data === null || data === void 0 ? void 0 : data.platform) === null || _d === void 0 ? void 0 : _d.platform) === null || _e === void 0 ? void 0 : _e.length) {
                    voucherTitle = "".concat(voucherTitle, " on order at ").concat((_f = data === null || data === void 0 ? void 0 : data.platform) === null || _f === void 0 ? void 0 : _f.platform);
                }
                else if (voucherData_1 === null || voucherData_1 === void 0 ? void 0 : voucherData_1.brandName) {
                    voucherTitle = "".concat(voucherTitle, " on order at ").concat(voucherData_1 === null || voucherData_1 === void 0 ? void 0 : voucherData_1.brandName);
                }
                if (voucherTitle === null || voucherTitle === void 0 ? void 0 : voucherTitle.includes('<p>')) {
                    voucherTitle = "".concat(voucherTitle, "</p>");
                }
                return voucherTitle;
            }
            else {
                return (voucherData_1 === null || voucherData_1 === void 0 ? void 0 : voucherData_1.title) || '';
            }
        }
    };
    var handleOnVoucherCardClick = function (voucherId) {
        if (onVoucherSelect && !preview) {
            onVoucherSelect(voucherId);
        }
    };
    if (!data) {
        return React__default.createElement(React__default.Fragment, null);
    }
    var isVoucherLoading = !data ? true : false;
    var voucherData = data === null || data === void 0 ? void 0 : data.voucherData;
    var issuanceType = data === null || data === void 0 ? void 0 : data.issuanceType;
    var titleHtml = getFormatedTitle(data, data === null || data === void 0 ? void 0 : data.rewardType);
    var subTitle = getFormatedSubTitle(voucherData);
    var isVoucherSelected = selectedValue === voucherId;
    var translation = Array.isArray(data.translations) ? data.translations[0] : undefined;
    var translationTitle = ((_b = translation === null || translation === void 0 ? void 0 : translation.offerCard) === null || _b === void 0 ? void 0 : _b.title) || '';
    var translationSubTitle = ((_c = translation === null || translation === void 0 ? void 0 : translation.offerCard) === null || _c === void 0 ? void 0 : _c.subTitle) || '';
    return (React__default.createElement(VoucherCardWrapper$1, null,
        React__default.createElement("div", { className: !preview ? "survey-voucher-select ".concat(!isVoucherSelected ? '' : 'active') : "survey-voucher-select-no-hover", style: { cursor: preview ? 'default' : 'pointer' }, onClick: function () { return handleOnVoucherCardClick(voucherId); } },
            React__default.createElement("div", { className: "main-container" },
                React__default.createElement("div", { className: "issuance-container" },
                    React__default.createElement(Logo, { name: getVoucherImage(data === null || data === void 0 ? void 0 : data.rewardType), size: 80 }),
                    !isVoucherLoading ? (issuanceType === IssuanceTypeEnum.LUCKY_DRAW ? (React__default.createElement("div", { className: "issuance-type" },
                        React__default.createElement("p", { className: "issuance-text" }, 'Lucky Draw'))) : (React__default.createElement(React__default.Fragment, null))) : (React__default.createElement(Skeleton.Input, { active: true }))),
                isVoucherLoading ? (React__default.createElement("div", { className: "content-data" },
                    React__default.createElement(Skeleton.Input, { active: true }))) : (React__default.createElement("div", { className: "content-data" },
                    subTitle && (subTitle === null || subTitle === void 0 ? void 0 : subTitle.length) && !voucherSurveyMetadata ? (React__default.createElement("div", { className: "info-container" },
                        React__default.createElement("div", { className: "info-card-box" },
                            React__default.createElement("p", { className: "info-text" }, subTitle === null || subTitle === void 0 ? void 0 : subTitle.replace(/<\/?[^>]+(>|$)/g, ''))))) : (React__default.createElement(React__default.Fragment, null)),
                    React__default.createElement("div", { className: "info-text-container", dangerouslySetInnerHTML: { __html: voucherSurveyMetadata ? titleHtml : translationTitle || titleHtml } }),
                    (translationSubTitle || (voucherSurveyMetadata === null || voucherSurveyMetadata === void 0 ? void 0 : voucherSurveyMetadata.conditionalText)) && (React__default.createElement("div", { className: "subtitle-container" },
                        React__default.createElement("div", { dangerouslySetInnerHTML: { __html: (voucherSurveyMetadata === null || voucherSurveyMetadata === void 0 ? void 0 : voucherSurveyMetadata.conditionalText) ? "<p>".concat(voucherSurveyMetadata === null || voucherSurveyMetadata === void 0 ? void 0 : voucherSurveyMetadata.conditionalText, "</p>") : translationSubTitle } })))))))));
};
var templateObject_1$h;

var VoucherCardWrapper = defaultStyled.div(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n  .survey-voucher-select {\n    display: flex;\n    padding: 10px 15px;\n    cursor: pointer;\n    flex-direction: column;\n    justify-content: flex-end;\n    align-items: flex-start;\n    gap: 8px;\n    align-self: stretch;\n    border-radius: 10px;\n    border: 1px solid var(--Gray-Light-Gray, #eaeaea);\n    background: #fff;\n\n    .no-offer-container {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-direction: row;\n      width: 100%;\n      gap: 8px;\n\n      .no-offer-text {\n        color: var(--Gray-Dark-Slate-Gray, #30384c);\n        font-family: var(--font-family-base);\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 600;\n        margin-bottom: 0px;\n      }\n    }\n    .main-container {\n      display: flex;\n      flex-direction: row;\n      gap: 20px;\n      align-self: stretch;\n    }\n    .content-data {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      gap: 5px;\n\n      .info-container {\n        display: flex;\n        flex-direction: row;\n        justify-content: flex-end;\n\n        .info-card-box {\n          display: flex;\n          padding: 2px 4px;\n          align-items: flex-start;\n          gap: 10px;\n          border-radius: 10px;\n          border: 1px solid var(--gray-light-gray, #eaeaea);\n\n          .info-text {\n            color: var(--grey-semi-light, #a0a0a0);\n            font-family: var(--font-family-base);\n            font-size: 10px;\n            font-style: normal;\n            font-weight: 600;\n            margin-bottom: 0px;\n          }\n        }\n      }\n      .info-text-container {\n        display: flex;\n        flex-direction: row;\n        justify-content: center;\n        align-items: center;\n\n        .highlight-content-text {\n          color: var(--Basis-Indianred, #d84339);\n          font-family: var(--font-family-base);\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 700;\n          line-height: 120%; /* 16.8px */\n          text-transform: capitalize;\n        }\n        .main-content-text {\n          color: var(--Dark-Slate-Gray, #30384c);\n          font-family: var(--font-family-base);\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 700;\n          line-height: 120%;\n          text-transform: capitalize;\n        }\n      }\n    }\n  }\n"], ["\n  .survey-voucher-select {\n    display: flex;\n    padding: 10px 15px;\n    cursor: pointer;\n    flex-direction: column;\n    justify-content: flex-end;\n    align-items: flex-start;\n    gap: 8px;\n    align-self: stretch;\n    border-radius: 10px;\n    border: 1px solid var(--Gray-Light-Gray, #eaeaea);\n    background: #fff;\n\n    .no-offer-container {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-direction: row;\n      width: 100%;\n      gap: 8px;\n\n      .no-offer-text {\n        color: var(--Gray-Dark-Slate-Gray, #30384c);\n        font-family: var(--font-family-base);\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 600;\n        margin-bottom: 0px;\n      }\n    }\n    .main-container {\n      display: flex;\n      flex-direction: row;\n      gap: 20px;\n      align-self: stretch;\n    }\n    .content-data {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      gap: 5px;\n\n      .info-container {\n        display: flex;\n        flex-direction: row;\n        justify-content: flex-end;\n\n        .info-card-box {\n          display: flex;\n          padding: 2px 4px;\n          align-items: flex-start;\n          gap: 10px;\n          border-radius: 10px;\n          border: 1px solid var(--gray-light-gray, #eaeaea);\n\n          .info-text {\n            color: var(--grey-semi-light, #a0a0a0);\n            font-family: var(--font-family-base);\n            font-size: 10px;\n            font-style: normal;\n            font-weight: 600;\n            margin-bottom: 0px;\n          }\n        }\n      }\n      .info-text-container {\n        display: flex;\n        flex-direction: row;\n        justify-content: center;\n        align-items: center;\n\n        .highlight-content-text {\n          color: var(--Basis-Indianred, #d84339);\n          font-family: var(--font-family-base);\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 700;\n          line-height: 120%; /* 16.8px */\n          text-transform: capitalize;\n        }\n        .main-content-text {\n          color: var(--Dark-Slate-Gray, #30384c);\n          font-family: var(--font-family-base);\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 700;\n          line-height: 120%;\n          text-transform: capitalize;\n        }\n      }\n    }\n  }\n"])));
var VoucherListWrapper = defaultStyled.div(templateObject_2$e || (templateObject_2$e = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n"])));
var VoucherListContainerBox = defaultStyled.div(templateObject_3$b || (templateObject_3$b = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n"])));
var VoucherSelection = function (_a) {
    var _b;
    var voucherData = _a.voucherData, voucherList = _a.voucherList, noOfferPayload = _a.noOfferPayload; _a.showError; _a.errorMessage; var value = _a.value, onChange = _a.onChange, _c = _a.preview, preview = _c === void 0 ? false : _c, voucherIdsMetadata = _a.voucherIdsMetadata;
    var parepareVoucherMap = useCallback(function () {
        var voucherMap = {};
        voucherData.map(function (eachVoucherData) {
            if (eachVoucherData) {
                var voucherId = eachVoucherData.id;
                voucherMap[voucherId] = eachVoucherData;
            }
        });
        return voucherMap;
    }, [voucherData]);
    var onVoucherSelect = function (voucherId) {
        onChange(voucherId);
    };
    var voucherMapData = parepareVoucherMap();
    var voucherOptions = voucherList === null || voucherList === void 0 ? void 0 : voucherList.map(function (eachVoucherData) {
        if (typeof eachVoucherData === 'string') {
            return { id: eachVoucherData, show: true };
        }
        return eachVoucherData;
    }).filter(function (eachVoucherData) {
        return eachVoucherData === null || eachVoucherData === void 0 ? void 0 : eachVoucherData.show;
    });
    return (React__default.createElement(VoucherListWrapper, null,
        React__default.createElement(VoucherListContainerBox, null, (_b = (voucherOptions || [])) === null || _b === void 0 ? void 0 : _b.map(function (eachVoucher) {
            var data = voucherMapData[eachVoucher.id];
            var voucherMetadata = voucherIdsMetadata === null || voucherIdsMetadata === void 0 ? void 0 : voucherIdsMetadata.filter(function (eachIdMetadata) { return (eachIdMetadata === null || eachIdMetadata === void 0 ? void 0 : eachIdMetadata.voucherId) === (eachVoucher === null || eachVoucher === void 0 ? void 0 : eachVoucher.id); });
            return (React__default.createElement(OfferCardV2, { preview: preview, data: data, voucherId: eachVoucher.id, voucherSurveyMetadata: (voucherMetadata === null || voucherMetadata === void 0 ? void 0 : voucherMetadata.length) ? voucherMetadata[0] : undefined, selectedValue: value, onVoucherSelect: onVoucherSelect }));
        })),
        (noOfferPayload === null || noOfferPayload === void 0 ? void 0 : noOfferPayload.show) ? (React__default.createElement(VoucherCardWrapper, null,
            React__default.createElement("div", { className: "survey-voucher-select ".concat(value !== 'no_offer' ? '' : 'active', " "), onClick: function () { return !preview && onVoucherSelect('no_offer'); }, style: { cursor: preview ? 'default' : 'pointer' } },
                React__default.createElement("div", { className: "no-offer-container" },
                    React__default.createElement(Logo, { name: "CrossIcon", size: 20 }),
                    React__default.createElement("p", { className: "info-text-container mb-0" }, noOfferPayload === null || noOfferPayload === void 0 ? void 0 : noOfferPayload.label.replace(/<\/?[^>]+(>|$)/g, '')))))) : (React__default.createElement(React__default.Fragment, null))));
};
var templateObject_1$g, templateObject_2$e, templateObject_3$b;

var WelcomePageWrap = defaultStyled.div(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n  .ant-btn {\n    margin-top: 0.625rem;\n  }\n"], ["\n  .ant-btn {\n    margin-top: 0.625rem;\n  }\n"])));
var WelcomeTitle = defaultStyled.div(templateObject_2$d || (templateObject_2$d = __makeTemplateObject(["\n  margin-bottom: 0.625rem;\n"], ["\n  margin-bottom: 0.625rem;\n"])));
var WelcomeSubTitle = defaultStyled.div(templateObject_3$a || (templateObject_3$a = __makeTemplateObject(["\n  margin-bottom: 0.625rem;\n"], ["\n  margin-bottom: 0.625rem;\n"])));
var OfferCardWrap$1 = defaultStyled.div(templateObject_4$6 || (templateObject_4$6 = __makeTemplateObject(["\n  margin-top: 1.25rem;\n  margin-bottom: 1.25rem;\n"], ["\n  margin-top: 1.25rem;\n  margin-bottom: 1.25rem;\n"])));
var VoucherListWrap = defaultStyled.div(templateObject_5$6 || (templateObject_5$6 = __makeTemplateObject(["\n  margin: 1.25rem 0;\n"], ["\n  margin: 1.25rem 0;\n"])));
var WelcomePage = function (_a) {
    var page = _a.page, onNextPage = _a.onNextPage, _b = _a.vouchersData, vouchersData = _b === void 0 ? [] : _b, surveySetting = _a.surveySetting, voucherIdsMetadata = _a.voucherIdsMetadata;
    var voucherList = getFieldValue(page, 'voucher_list');
    var showVoucherList = showField(page, 'voucher_list');
    // Check if we have valid vouchers to display
    var hasValidVouchers = React__default.useMemo(function () {
        if (!showVoucherList || !(vouchersData === null || vouchersData === void 0 ? void 0 : vouchersData.length) || !(voucherList === null || voucherList === void 0 ? void 0 : voucherList.length)) {
            return false;
        }
        // Check if at least one voucher ID from voucherList exists in vouchersData
        return voucherList.some(function (voucherData) { return vouchersData.some(function (voucher) { return voucher.id === ((voucherData === null || voucherData === void 0 ? void 0 : voucherData.id) || voucherData); }); });
    }, [showVoucherList, vouchersData, voucherList]);
    return (React__default.createElement(WelcomePageWrap, null,
        React__default.createElement("div", { className: "page-content text-center" },
            React__default.createElement(BrandInfo, { page: page }),
            (surveySetting === null || surveySetting === void 0 ? void 0 : surveySetting.template) &&
                ![SURVEY_TEMPLATES.STD_FEEDBACK_SURVEY_V2].includes(surveySetting === null || surveySetting === void 0 ? void 0 : surveySetting.template) &&
                getFieldValue(page, 'voucher_details') && (React__default.createElement(OfferCardWrap$1, null,
                React__default.createElement(OfferCard$1, { voucher: getFieldValue(page, 'voucher_details') }))),
            showField(page, 'title') && (React__default.createElement(WelcomeTitle, null,
                React__default.createElement(Text$1.H1, { className: "bg-theme-allowed", semibold: true, dangerouslySetInnerHTML: { __html: getFieldValue(page, 'title') || '' } }))),
            showField(page, 'sub_title') && (React__default.createElement(WelcomeSubTitle, null,
                React__default.createElement(Text$1.B1, { className: "bg-theme-allowed", semibold: true, dangerouslySetInnerHTML: { __html: getFieldValue(page, 'sub_title') || '' } }))),
            hasValidVouchers && (React__default.createElement(VoucherListWrap, null,
                React__default.createElement(VoucherSelection, { voucherData: vouchersData, voucherIdsMetadata: voucherIdsMetadata, voucherList: voucherList, noOfferPayload: { show: false, label: '' }, value: "", onChange: function () { }, preview: true }))),
            React__default.createElement(Button, { block: true, onClick: function () { return onNextPage(); } },
                React__default.createElement("div", { dangerouslySetInnerHTML: { __html: getFieldValue(page, 'button_title') || '' } })),
            !page.hidePoweredByMomos && React__default.createElement(PoweredByMomos, null))));
};
var templateObject_1$f, templateObject_2$d, templateObject_3$a, templateObject_4$6, templateObject_5$6;

var TypeOfOrderPage = function (_a) {
    var page = _a.page, onNextPage = _a.onNextPage, trackEvent = _a.trackEvent, theme = _a.theme;
    var allowThemeInvert = (theme === null || theme === void 0 ? void 0 : theme.layout) !== 'box';
    var getOrderTypeOptions = function (values, showIcon) {
        if (showIcon === void 0) { showIcon = true; }
        return values
            .filter(function (value) { return value.show; })
            .map(function (value) {
            return {
                key: value.key,
                iconName: showIcon ? value.iconName : undefined,
                customIcon: showIcon && value.customIcon ? true : false,
                customIconData: value.customIconData || null,
                text: value.value
            };
        });
    };
    var showIcon = getField(page, 'order_option_show_icon') ? showField(page, 'order_option_show_icon', true) : true;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(BrandInfo, { page: page }),
        React__default.createElement("div", { className: "page-content" },
            showField(page, 'title') && (React__default.createElement("div", { className: "page-title" },
                React__default.createElement(Text$1.H2, { className: classNames({ 'bg-theme-allowed': allowThemeInvert }), semibold: true, dangerouslySetInnerHTML: { __html: getFieldValue(page, 'title') || '' } }))),
            React__default.createElement(Input.Select, { type: 'logo-text', className: classNames({ 'bg-theme-allowed': allowThemeInvert }), size: 65, options: getOrderTypeOptions(getFieldValue(page, 'order_option'), showIcon), onClick: function (val) {
                    trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.TYPE_OF_ORDER_SELECT_TYPE);
                    onNextPage(val);
                } }))));
};

var createCompounder = _createCompounder;

/**
 * Converts `string`, as space separated words, to lower case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the lower cased string.
 * @example
 *
 * _.lowerCase('--Foo-Bar--');
 * // => 'foo bar'
 *
 * _.lowerCase('fooBar');
 * // => 'foo bar'
 *
 * _.lowerCase('__FOO_BAR__');
 * // => 'foo bar'
 */
var lowerCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + word.toLowerCase();
});

var lowerCase_1 = lowerCase;

var lowerCase$1 = /*@__PURE__*/getDefaultExportFromCjs(lowerCase_1);

var VoucherLocationCard = function (_a) {
    var name = _a.name, address = _a.address, style = _a.style, onClick = _a.onClick, className = _a.className, distance = _a.distance, region = _a.region;
    return (React__default.createElement(LocationCardWrap, { onClick: onClick, style: style, className: className },
        React__default.createElement("div", { className: "location-content" },
            React__default.createElement("div", { className: "location-title-wrap" },
                React__default.createElement("h5", null, name)),
            React__default.createElement("div", { className: "location-info" }, address && (React__default.createElement("div", { className: "location-address-distance-wrap" },
                React__default.createElement("div", { className: "location-meta" },
                    React__default.createElement("div", { className: "icon-wrap" },
                        React__default.createElement(Icon, { name: "MapPin", type: "outline" })),
                    React__default.createElement("p", null, address)),
                distance && !isNaN(distance) && (React__default.createElement("div", { className: "navigation-icon-wrap" },
                    React__default.createElement(Icon, { name: "Navigation" }),
                    React__default.createElement("div", { className: "body-text distance-text" },
                        distance.toFixed(1),
                        " ",
                        region === REGIONS.US ? 'mi' : 'km'))))))),
        React__default.createElement(Icon, { name: "ChevronRight", type: "outline" })));
};
var LocationCardWrap = defaultStyled.div(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n  padding: 15px 20px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: row;\n  transition: all 300ms ease 0s;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  border: 1px solid var(--disable-grey);\n\n  .location-content {\n    flex: 1;\n  }\n\n  .location-title-wrap {\n    h5 {\n      font-family: var(--font-family-bold);\n      font-style: normal;\n      font-weight: 700;\n      font-size: 1rem;\n      line-height: 1.25rem;\n      color: var(--slate-gray-dark);\n    }\n  }\n\n  .location-info {\n    margin-top: 0.938rem;\n\n    .location-address-distance-wrap {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      gap: 0.3125rem;\n    }\n\n    .navigation-icon-wrap {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n\n      svg {\n        margin-right: 0.313rem;\n      }\n    }\n\n    .location-meta {\n      display: flex;\n      flex-direction: row;\n      margin-bottom: 0.938rem;\n      gap: 0.3125rem;\n      flex: 1;\n      align-items: center;\n\n      .outlet-status {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n      }\n\n      .icon-wrap {\n        width: 10%;\n        display: flex;\n\n        & > svg path {\n          stroke: var(--grey-dark);\n        }\n      }\n\n      p {\n        font-family: var(--font-family-medium);\n        font-style: normal;\n        font-weight: 500;\n        font-size: 0.875rem;\n        line-height: 1rem;\n        margin-bottom: 0px;\n      }\n    }\n  }\n\n  .location-action-wrap {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n\n    > button {\n      margin-right: 0.625rem;\n    }\n  }\n"], ["\n  padding: 15px 20px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: row;\n  transition: all 300ms ease 0s;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  border: 1px solid var(--disable-grey);\n\n  .location-content {\n    flex: 1;\n  }\n\n  .location-title-wrap {\n    h5 {\n      font-family: var(--font-family-bold);\n      font-style: normal;\n      font-weight: 700;\n      font-size: 1rem;\n      line-height: 1.25rem;\n      color: var(--slate-gray-dark);\n    }\n  }\n\n  .location-info {\n    margin-top: 0.938rem;\n\n    .location-address-distance-wrap {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      gap: 0.3125rem;\n    }\n\n    .navigation-icon-wrap {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n\n      svg {\n        margin-right: 0.313rem;\n      }\n    }\n\n    .location-meta {\n      display: flex;\n      flex-direction: row;\n      margin-bottom: 0.938rem;\n      gap: 0.3125rem;\n      flex: 1;\n      align-items: center;\n\n      .outlet-status {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n      }\n\n      .icon-wrap {\n        width: 10%;\n        display: flex;\n\n        & > svg path {\n          stroke: var(--grey-dark);\n        }\n      }\n\n      p {\n        font-family: var(--font-family-medium);\n        font-style: normal;\n        font-weight: 500;\n        font-size: 0.875rem;\n        line-height: 1rem;\n        margin-bottom: 0px;\n      }\n    }\n  }\n\n  .location-action-wrap {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n\n    > button {\n      margin-right: 0.625rem;\n    }\n  }\n"])));
var templateObject_1$e;

var ChooseLocationPage = function (_a) {
    var page = _a.page, onNextPage = _a.onNextPage, region = _a.region, editorMode = _a.editorMode, trackEvent = _a.trackEvent, theme = _a.theme;
    var allowThemeInvert = (theme === null || theme === void 0 ? void 0 : theme.layout) !== 'box';
    var latLong = (editorMode ? {} : useLocation({ isLocationVisible: true })).latLong;
    var _b = useState(''), searchKey = _b[0], setSearchKey = _b[1];
    var getLocations = function (values) {
        return values
            .filter(function (value) { return value.show && value.key != 'all'; })
            .map(function (_a) {
            var key = _a.key, value = _a.value, name = _a.name, address = _a.address, thirdPartyLinks = _a.thirdPartyLinks, gmbReviewLink = _a.gmbReviewLink, latLong = _a.latLong, yelpReviewLink = _a.yelpReviewLink;
            return {
                key: key,
                value: value,
                name: name,
                address: address,
                thirdPartyLinks: thirdPartyLinks,
                gmbReviewLink: gmbReviewLink,
                latLong: latLong,
                yelpReviewLink: yelpReviewLink
            };
        });
    };
    var locations = useMemo(function () {
        var locationsData = getLocations(getFieldValue(page, 'location'));
        if (latLong) {
            locationsData = sortOutlets$1(latLong, locationsData, region === REGIONS.US);
        }
        return locationsData === null || locationsData === void 0 ? void 0 : locationsData.filter(function (eachLocation) {
            var _a, _b;
            return ((_a = lowerCase$1(eachLocation === null || eachLocation === void 0 ? void 0 : eachLocation.name)) === null || _a === void 0 ? void 0 : _a.includes(lowerCase$1(searchKey))) ||
                ((_b = lowerCase$1(eachLocation === null || eachLocation === void 0 ? void 0 : eachLocation.address)) === null || _b === void 0 ? void 0 : _b.includes(lowerCase$1(searchKey)));
        });
    }, [page, latLong, searchKey]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(BrandInfo, { page: page }),
        React__default.createElement("div", { className: "page-content" },
            showField(page, 'title') && (React__default.createElement("div", { className: "page-title" },
                React__default.createElement(Text$1.H2, { className: classNames({ 'bg-theme-allowed': allowThemeInvert }), semibold: true, dangerouslySetInnerHTML: { __html: getFieldValue(page, 'title') || '' } }))),
            React__default.createElement(Input, { name: "search", placeholder: "Search location", className: "location-search", allowClear: true, value: searchKey, onChange: function (e) {
                    setSearchKey(e.target.value);
                }, onFocus: function () {
                    trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.CHOOSE_LOCATION_SEARCH);
                }, prefix: React__default.createElement(Icon, { name: "Search", type: "fill" }) }),
            locations.map(function (location) { return (React__default.createElement(VoucherLocationCard, { className: classNames('mb-10', { 'bg-theme-allowed': allowThemeInvert }), name: location.name, address: location.address, onClick: function () {
                    trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.CHOOSE_LOCATION_SELECT_LOCATION);
                    onNextPage(location, {
                        searchKey: searchKey,
                        latLong: latLong,
                        locationsSort: !isEmpty$1(latLong)
                    });
                }, key: location.key, distance: location.distance, region: region })); }))));
};

var DeliveryPlatformPage = function (_a) {
    var page = _a.page, onNextPage = _a.onNextPage, editorMode = _a.editorMode, trackEvent = _a.trackEvent, theme = _a.theme;
    var allowThemeInvert = (theme === null || theme === void 0 ? void 0 : theme.layout) !== 'box';
    var getPlatformOptions = function () {
        // if in editor mode, show delivery-platforms_editor fieldValue
        var platforms = getFieldValue(page, editorMode ? 'delivery_platforms_editor' : 'delivery_platforms');
        platforms = platforms
            .filter(function (value) { return value.show; })
            .map(function (_a) {
            var value = _a.value, iconUrl = _a.iconUrl, rest = __rest(_a, ["value", "iconUrl"]);
            return __assign({ iconName: value, iconUrl: iconUrl }, rest);
        });
        return platforms;
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(BrandInfo, { page: page }),
        React__default.createElement("div", { className: "page-content" },
            showField(page, 'title') && (React__default.createElement("div", { className: "page-title" },
                React__default.createElement(Text$1.H2, { className: classNames({ 'bg-theme-allowed': allowThemeInvert }), semibold: true, dangerouslySetInnerHTML: { __html: getFieldValue(page, 'title') || '' } }))),
            React__default.createElement(Input.Select, { type: 'icon', options: getPlatformOptions(), onClick: function (val) {
                    trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.DELIVERY_PLATFORM_SELECT_PLATFORM);
                    onNextPage(val);
                }, className: classNames({ 'bg-theme-allowed': allowThemeInvert }) }))));
};

var FloatngBtnWrap = defaultStyled.div(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n  position: sticky;\n  bottom: 20px;\n  display: inline-block;\n  justify-content: flex-end;\n  left: 84%;\n\n  @media (max-width: 768px) {\n    position: fixed;\n    width: 3.2rem;\n    height: 3.2rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n"], ["\n  position: sticky;\n  bottom: 20px;\n  display: inline-block;\n  justify-content: flex-end;\n  left: 84%;\n\n  @media (max-width: 768px) {\n    position: fixed;\n    width: 3.2rem;\n    height: 3.2rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n"])));
var FloatingBtn = function (_a) {
    var onClick = _a.onClick;
    return (React__default.createElement(FloatngBtnWrap, { onClick: onClick },
        React__default.createElement("div", { className: "btn-circle" },
            React__default.createElement(Icon, { name: "ChevronRight", type: "outline", color: "white", strokeWidth: 2 }))));
};
var templateObject_1$d;

var PictureSelectionWrap = defaultStyled.div(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n  border-color: ", ";\n  border-radius: 20px;\n  border-style: solid;\n  border-width: thin;\n  display: flex;\n  flex: 1;\n  margin-top: 10px;\n\n  .padding-container {\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    padding: 10px;\n    gap: 10px;\n  }\n  .food-img {\n    border-radius: 20px;\n    height: 100%;\n    width: 100%;\n    object-fit: cover;\n  }\n  .detail-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n  }\n  .option-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 10px;\n  }\n  .option-label {\n    color: var(--gray-dark-slate-gray, #30384c);\n    font-family: var(--font-family-base);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 120%;\n    margin-bottom: 0px;\n  }\n"], ["\n  border-color: ", ";\n  border-radius: 20px;\n  border-style: solid;\n  border-width: thin;\n  display: flex;\n  flex: 1;\n  margin-top: 10px;\n\n  .padding-container {\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    padding: 10px;\n    gap: 10px;\n  }\n  .food-img {\n    border-radius: 20px;\n    height: 100%;\n    width: 100%;\n    object-fit: cover;\n  }\n  .detail-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n  }\n  .option-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 10px;\n  }\n  .option-label {\n    color: var(--gray-dark-slate-gray, #30384c);\n    font-family: var(--font-family-base);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 120%;\n    margin-bottom: 0px;\n  }\n"])), function (props) { var _a; return !(props === null || props === void 0 ? void 0 : props.isSelected) ? "#F3F3F3" : "".concat((_a = props === null || props === void 0 ? void 0 : props.$theme) === null || _a === void 0 ? void 0 : _a.color, ";") || "var(--basis-indianred, #D84339);"; });
var OptionWrap = defaultStyled.div(templateObject_2$c || (templateObject_2$c = __makeTemplateObject(["\ndisplay: flex;\nwidth: 30px;\nheight: 30px;\npadding: 5px 8px;\njustify-content: center;\nalign-items: center;\ngap: 10px;\nborder-radius: 10px;\nbackground: ", " \n.option-text {\n    color: ", " \n    font-family: ", ";\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 120%;\n    margin-bottom : 0px;\n    gap : 10px;\n}\n"], ["\ndisplay: flex;\nwidth: 30px;\nheight: 30px;\npadding: 5px 8px;\njustify-content: center;\nalign-items: center;\ngap: 10px;\nborder-radius: 10px;\nbackground: ", " \n.option-text {\n    color: ", " \n    font-family: ", ";\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 120%;\n    margin-bottom : 0px;\n    gap : 10px;\n}\n"])), function (props) { var _a, _b; return (props === null || props === void 0 ? void 0 : props.isSelected) ? (((_a = props === null || props === void 0 ? void 0 : props.$theme) === null || _a === void 0 ? void 0 : _a.color) ? "".concat((_b = props === null || props === void 0 ? void 0 : props.$theme) === null || _b === void 0 ? void 0 : _b.color, ";") : "var(--indian-red);") : "#f8f5f5;"; }, function (props) { var _a; return (props === null || props === void 0 ? void 0 : props.isSelected) ? "var(--white, #FFF);" : "".concat((_a = props === null || props === void 0 ? void 0 : props.$theme) === null || _a === void 0 ? void 0 : _a.color, ";") || "var(--basis-indianred, #D84339);"; }, function (props) { var _a, _b; return (((_a = props === null || props === void 0 ? void 0 : props.$theme) === null || _a === void 0 ? void 0 : _a.fontFamily) ? (_b = props === null || props === void 0 ? void 0 : props.$theme) === null || _b === void 0 ? void 0 : _b.fontFamily : 'Gloray'); });
var MainWrap = defaultStyled.div(templateObject_3$9 || (templateObject_3$9 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n\n  .selection-container {\n    display: flex;\n    width: 49%;\n    gap: 10px;\n  }\n  .ant-checkbox-checked .ant-checkbox-inner {\n    background-color: ", " !important;\n    border-color: ", " !important;\n  }\n  .ant-checkbox-checked::after {\n    border: ", " !important;\n  }\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n\n  .selection-container {\n    display: flex;\n    width: 49%;\n    gap: 10px;\n  }\n  .ant-checkbox-checked .ant-checkbox-inner {\n    background-color: ", " !important;\n    border-color: ", " !important;\n  }\n  .ant-checkbox-checked::after {\n    border: ", " !important;\n  }\n"])), function (_a) {
    var $theme = _a.$theme;
    return ($theme === null || $theme === void 0 ? void 0 : $theme.color) || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return ($theme === null || $theme === void 0 ? void 0 : $theme.color) || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return ($theme === null || $theme === void 0 ? void 0 : $theme.color) || 'var(--indian-red)';
});
var PictureSelection = function (_a) {
    var options = _a.options, defaultOption = _a.defaultOption, theme = _a.theme, onChange = _a.onChange, value = _a.value;
    var _b = useState(defaultOption || value), selectedOption = _b[0], setSelectedOption = _b[1];
    useEffect(function () {
        var _a;
        if ((_a = value === null || value === void 0 ? void 0 : value.label) === null || _a === void 0 ? void 0 : _a.length) {
            setSelectedOption(value);
        }
    }, [value]);
    var handleOnChange = function (value) {
        setSelectedOption(value);
        onChange(value);
    };
    return (React__default.createElement(MainWrap, { "$theme": theme }, options
        .filter(function (option) { return !(option === null || option === void 0 ? void 0 : option.hide); })
        .map(function (option, index) {
        var image = option.image, value = option.value, label = option.label;
        var isSelected = value === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value);
        return (React__default.createElement("div", { key: option === null || option === void 0 ? void 0 : option.value, className: "selection-container" },
            React__default.createElement(PictureSelectionWrap, { isSelected: isSelected, "$theme": theme, onClick: function () { return handleOnChange(option); } },
                React__default.createElement("div", { className: "padding-container" },
                    React__default.createElement("img", { className: "food-img", src: image }),
                    React__default.createElement("div", { className: "detail-container" },
                        React__default.createElement("div", { className: "option-container" },
                            React__default.createElement(OptionWrap, { isSelected: isSelected, "$theme": theme },
                                React__default.createElement("p", { className: "option-text" }, String.fromCharCode(65 + index))),
                            React__default.createElement("p", { className: "option-label" }, label)),
                        React__default.createElement(Checkbox, { checked: isSelected }))))));
    })));
};
var templateObject_1$c, templateObject_2$c, templateObject_3$9;

var Upload = function (_a) {
    var _b = _a.containerClass, containerClass = _b === void 0 ? '' : _b, _c = _a.btnTitle, btnTitle = _c === void 0 ? 'Upload Pictures' : _c, fileList = _a.fileList, customRequest = _a.customRequest, showLoading = _a.showLoading, setFileList = _a.setFileList; _a.customBtnTitle; var rest = __rest(_a, ["containerClass", "btnTitle", "fileList", "customRequest", "showLoading", "setFileList", "customBtnTitle"]);
    var handleRemove = function (index) {
        if (setFileList && typeof setFileList == 'function') {
            var newFileList = fileList ? __spreadArray([], fileList, true) : [];
            newFileList.splice(index, 1);
            setFileList(newFileList);
        }
    };
    return (React__default.createElement(UploadComponentWrap, { className: containerClass },
        React__default.createElement(Upload$1, __assign({ customRequest: customRequest }, rest),
            React__default.createElement(UploadButtonWrap, null,
                React__default.createElement(UploadIconWrap, null,
                    React__default.createElement(Icon, { name: "ArrowUp" })),
                React__default.createElement(Text$1.B1, { dangerouslySetInnerHTML: { __html: btnTitle } }))),
        showLoading ? (React__default.createElement(Skeleton, { active: true })) : (React__default.createElement(React__default.Fragment, null, (fileList === null || fileList === void 0 ? void 0 : fileList.length) ? (React__default.createElement("div", { className: "mb-20" }, Array.isArray(fileList) &&
            (fileList === null || fileList === void 0 ? void 0 : fileList.map(function (file, index) { return (React__default.createElement("div", { key: index },
                React__default.createElement("div", { className: "upload-media-list" },
                    React__default.createElement("div", { className: "media-info" },
                        React__default.createElement("div", { className: "media-name" }, file.name),
                        file.size && React__default.createElement("div", { className: "media-size" }, bytesToSize(file.size))),
                    React__default.createElement("div", { className: "close-icon-wrap", onClick: function () { return handleRemove(index); } },
                        React__default.createElement(Icon, { name: "Close" }))))); })))) : null))));
};
var UploadComponentWrap = defaultStyled.div(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n  .upload-media-list {\n    display: flex;\n    margin-top: 1.25rem;\n    margin-bottom: 1.25rem;\n\n    .media-image-wrap {\n      margin-right: 0.625rem;\n\n      .media-image {\n        object-fit: cover;\n        border-radius: 40px;\n        width: 3.125rem;\n        height: 2.813rem;\n      }\n    }\n\n    .media-info {\n      margin-right: 0.625rem;\n      flex: 1;\n\n      .media-name {\n        font-family: var(--font-family-medium);\n        font-style: normal;\n        font-weight: 600;\n        font-size: 0.875rem;\n        line-height: 1.063rem;\n        color: #30384c;\n        word-break: break-all;\n      }\n      .media-size {\n        font-family: var(--font-family-medium);\n        font-style: normal;\n        font-weight: 600;\n        font-size: 0.75rem;\n        line-height: 1.25rem;\n        color: #a0a0a0;\n      }\n    }\n\n    .close-icon-wrap {\n      cursor: pointer;\n    }\n  }\n"], ["\n  .upload-media-list {\n    display: flex;\n    margin-top: 1.25rem;\n    margin-bottom: 1.25rem;\n\n    .media-image-wrap {\n      margin-right: 0.625rem;\n\n      .media-image {\n        object-fit: cover;\n        border-radius: 40px;\n        width: 3.125rem;\n        height: 2.813rem;\n      }\n    }\n\n    .media-info {\n      margin-right: 0.625rem;\n      flex: 1;\n\n      .media-name {\n        font-family: var(--font-family-medium);\n        font-style: normal;\n        font-weight: 600;\n        font-size: 0.875rem;\n        line-height: 1.063rem;\n        color: #30384c;\n        word-break: break-all;\n      }\n      .media-size {\n        font-family: var(--font-family-medium);\n        font-style: normal;\n        font-weight: 600;\n        font-size: 0.75rem;\n        line-height: 1.25rem;\n        color: #a0a0a0;\n      }\n    }\n\n    .close-icon-wrap {\n      cursor: pointer;\n    }\n  }\n"])));
var UploadButtonWrap = defaultStyled.div(templateObject_2$b || (templateObject_2$b = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n"], ["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n"])));
var UploadIconWrap = defaultStyled.div(templateObject_3$8 || (templateObject_3$8 = __makeTemplateObject(["\n  background: var(--indian-red);\n  width: 1.875rem;\n  height: 1.875rem;\n  border-radius: 500px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 0.625rem;\n\n  svg path {\n    stroke: var(--white);\n  }\n"], ["\n  background: var(--indian-red);\n  width: 1.875rem;\n  height: 1.875rem;\n  border-radius: 500px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 0.625rem;\n\n  svg path {\n    stroke: var(--white);\n  }\n"])));
var templateObject_1$b, templateObject_2$b, templateObject_3$8;

var ErrorMsg$5 = defaultStyled(Text$1.B2)(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n  color: var(--indian-red);\n"], ["\n  color: var(--indian-red);\n"])));
var FieldWrap$2 = defaultStyled.div(templateObject_2$a || (templateObject_2$a = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 0.938rem;\n\n  > span {\n    margin-bottom: 0.625rem;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 0.938rem;\n\n  > span {\n    margin-bottom: 0.625rem;\n  }\n"])));
var TieredRatingWrapper = defaultStyled.div(templateObject_3$7 || (templateObject_3$7 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.938rem;\n  margin-bottom: 1.875rem;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.938rem;\n  margin-bottom: 1.875rem;\n"])));
var ItemTieredRatingWrapper = defaultStyled.div(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.938rem;\n  margin: 1.25rem 1rem;\n  border-bottom: 1px solid #eaeaea;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.938rem;\n  margin: 1.25rem 1rem;\n  border-bottom: 1px solid #eaeaea;\n"])));
var ChildFieldWrap = defaultStyled.div(templateObject_5$5 || (templateObject_5$5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  border-radius: 10px;\n  background: #f3f3f3;\n  width: 100%;\n  gap: 0.5rem;\n  padding: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  border-radius: 10px;\n  background: #f3f3f3;\n  width: 100%;\n  gap: 0.5rem;\n  padding: ", ";\n"])), function (props) { return (props.$ratingType === RATING.STAR_1_10 ? '1rem 0px 0px 0.625rem' : '0.625rem 1.25rem'); });
var ChildItemFieldWrap = defaultStyled.div(templateObject_6$4 || (templateObject_6$4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: 0.5rem;\n  padding: ", ";\n  border-bottom: 1px solid #eaeaea;\n\n  .label-container {\n    margin-bottom: 1rem;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: 0.5rem;\n  padding: ", ";\n  border-bottom: 1px solid #eaeaea;\n\n  .label-container {\n    margin-bottom: 1rem;\n  }\n"])), function (props) { return (props.$ratingType === RATING.STAR_1_10 ? '1rem 0px 0px 10px' : '1rem 0px'); });
var RatingWrap$2 = defaultStyled.div(templateObject_7$3 || (templateObject_7$3 = __makeTemplateObject(["\n  width: 100%;\n\n  ul {\n    width: 100%;\n  }\n\n  .emoji-container {\n    justify-content: space-around;\n  }\n"], ["\n  width: 100%;\n\n  ul {\n    width: 100%;\n  }\n\n  .emoji-container {\n    justify-content: space-around;\n  }\n"])));
var RenderQuestion = function (_a) {
    var _b, _c;
    var type = _a.type, value = _a.value, label = _a.label, showLabel = _a.showLabel, onChange = _a.onChange, ratingType = _a.ratingType, required = _a.required, showError = _a.showError, errorMessage = _a.errorMessage, dropdownOptions = _a.dropdownOptions, multipleChoiceOptions = _a.multipleChoiceOptions, pictureSelectionOptions = _a.pictureSelectionOptions, theme = _a.theme, showImageUploadLoader = _a.showImageUploadLoader, uploadImage = _a.uploadImage, uploadButtonLabel = _a.uploadButtonLabel, showQuestionLabel = _a.showQuestionLabel, questionCaptions = _a.questionCaptions, vouchersData = _a.vouchersData, voucherList = _a.voucherList, noOfferPayload = _a.noOfferPayload, _d = _a.singleMultipleChoiceListPrefix, singleMultipleChoiceListPrefix = _d === void 0 ? 'numbers' : _d, onTrackEvent = _a.onTrackEvent, voucherIdsMetadata = _a.voucherIdsMetadata;
    var allowThemeInvert = (theme === null || theme === void 0 ? void 0 : theme.layout) !== 'box';
    //classNames({"bg-theme-allowed": allowThemeInvert})
    var renderRating = function () {
        var customCaptions = showQuestionLabel ? questionCaptions : [];
        var handleChange = function (val) {
            onChange(val ? val : null);
        };
        switch (ratingType) {
            case RATING.THUMBS:
                return (React__default.createElement(Input.Rating, { captions: customCaptions, defaultValue: value, type: 'thumbs', onChange: handleChange }));
            case RATING.EMOJI:
                return (React__default.createElement(Input.Rating, { captions: customCaptions, defaultValue: value, type: 'emoji', onChange: handleChange }));
            case RATING.STAR_1_10:
                return React__default.createElement(Input.Rating, { captions: customCaptions, value: value, count: 10, onChange: handleChange });
            case RATING.STAR_1_5:
                return React__default.createElement(Input.Rating, { captions: customCaptions, value: value, count: 5, onChange: handleChange });
            case RATING.STAR_1_3:
                return React__default.createElement(Input.Rating, { captions: customCaptions, value: value, count: 3, onChange: handleChange });
            case RATING.NPS_1_5:
                return React__default.createElement(Input.Rating, { defaultValue: value, type: 'nps', count: 5, onChange: handleChange });
            case RATING.NPS_1_10:
                return React__default.createElement(Input.Rating, { defaultValue: value, type: 'nps', count: 10, onChange: handleChange });
            default:
                return React__default.createElement(Input.Rating, { defaultValue: value, count: 10, onChange: handleChange });
        }
    };
    switch (type) {
        case 'textbox':
            return (React__default.createElement(FieldWrap$2, { className: showError ? 'has-field-error' : '' },
                showLabel && (React__default.createElement(Text$1.B1, { className: classNames({ 'bg-theme-allowed': allowThemeInvert, required: required }), dangerouslySetInnerHTML: { __html: label || '' } })),
                React__default.createElement(Input, { value: value, onChange: function (e) { return onChange(e.target.value); }, onFocus: function () {
                        onTrackEvent === null || onTrackEvent === void 0 ? void 0 : onTrackEvent();
                    }, placeholder: "Your Answer", className: "mb-10" }),
                showError && React__default.createElement(ErrorMsg$5, null, errorMessage)));
        case 'number':
            return (React__default.createElement(FieldWrap$2, { className: showError ? 'has-field-error' : '' },
                showLabel && (React__default.createElement(Text$1.B1, { className: classNames({ 'bg-theme-allowed': allowThemeInvert, required: required }), dangerouslySetInnerHTML: { __html: label || '' } })),
                React__default.createElement(Input, { type: type, value: value, onChange: function (e) { return onChange(e.target.value); }, onFocus: function () {
                        onTrackEvent === null || onTrackEvent === void 0 ? void 0 : onTrackEvent();
                    }, placeholder: "Your Answer", className: "mb-10" }),
                showError && React__default.createElement(ErrorMsg$5, null, errorMessage)));
        case 'textarea':
            return (React__default.createElement(FieldWrap$2, { className: showError ? 'has-field-error' : '' },
                showLabel && (React__default.createElement(Text$1.B1, { className: classNames({ 'bg-theme-allowed': allowThemeInvert, required: required }), dangerouslySetInnerHTML: { __html: label || '' } })),
                React__default.createElement(Input.TextArea, { value: value, onChange: function (e) { return onChange(e.target.value); }, placeholder: "Your Answer", className: "mb-10" }),
                showError && React__default.createElement(ErrorMsg$5, null, errorMessage)));
        case 'datepicker':
            return (React__default.createElement(FieldWrap$2, { className: showError ? 'has-field-error' : '' },
                showLabel && (React__default.createElement(Text$1.B1, { className: classNames({ 'bg-theme-allowed': allowThemeInvert, required: required }), dangerouslySetInnerHTML: { __html: label || '' } })),
                React__default.createElement(Input.Date, { value: value && moment(value, 'YYYY-MM-DD'), onChange: function (date) {
                        onTrackEvent === null || onTrackEvent === void 0 ? void 0 : onTrackEvent();
                        onChange(date === null || date === void 0 ? void 0 : date.format('YYYY-MM-DD'));
                    }, className: "mb-10", format: DATE_FORMAT }),
                showError && React__default.createElement(ErrorMsg$5, null, errorMessage)));
        case 'timepicker':
            return (React__default.createElement(FieldWrap$2, { className: showError ? 'has-field-error' : '' },
                showLabel && (React__default.createElement(Text$1.B1, { className: classNames({ 'bg-theme-allowed': allowThemeInvert, required: required }), dangerouslySetInnerHTML: { __html: label || '' } })),
                React__default.createElement(Input.Time, { value: value && moment(value, 'HH:mm'), className: "mb-10", type: 'modal', onChange: function (time) {
                        onTrackEvent === null || onTrackEvent === void 0 ? void 0 : onTrackEvent();
                        onChange(time.format('HH:mm'));
                    } }),
                showError && React__default.createElement(ErrorMsg$5, null, errorMessage)));
        case 'ratingtype':
            return (React__default.createElement(FieldWrap$2, { className: showError ? 'has-field-error' : '' },
                showLabel && (React__default.createElement(Text$1.B1, { className: classNames({ 'bg-theme-allowed': allowThemeInvert, required: required }), dangerouslySetInnerHTML: { __html: label || '' } })),
                React__default.createElement(RatingWrap$2, { className: "mb-10" }, renderRating()),
                showError && React__default.createElement(ErrorMsg$5, null, errorMessage)));
        case 'dropdown':
            return (React__default.createElement(FieldWrap$2, { className: showError ? 'has-field-error' : '' },
                showLabel && (React__default.createElement(Text$1.B1, { className: classNames({ 'bg-theme-allowed': allowThemeInvert, required: required }), dangerouslySetInnerHTML: { __html: label || '' } })),
                React__default.createElement(Input.Select, { className: "mb-10", type: "dropdown", placeholder: "Select", options: dropdownOptions, value: value, onChange: function (value) {
                        onTrackEvent === null || onTrackEvent === void 0 ? void 0 : onTrackEvent();
                        onChange(value);
                    } }),
                showError && React__default.createElement(ErrorMsg$5, null, errorMessage)));
        case 'picture-selection':
            return (React__default.createElement(FieldWrap$2, { className: showError ? 'has-field-error' : '' },
                showLabel && (React__default.createElement(Text$1.B1, { className: classNames({ 'bg-theme-allowed': allowThemeInvert, required: required }), dangerouslySetInnerHTML: { __html: label || '' } })),
                React__default.createElement(PictureSelection, { className: "mb-10", type: "dropdown", placeholder: "Select", options: pictureSelectionOptions, value: value, onChange: function (value) {
                        onTrackEvent === null || onTrackEvent === void 0 ? void 0 : onTrackEvent();
                        onChange(value);
                    }, theme: theme }),
                showError && React__default.createElement(ErrorMsg$5, null, errorMessage)));
        case 'multiple-choice':
            return (React__default.createElement(FieldWrap$2, { className: showError ? 'has-field-error' : '' },
                showLabel && (React__default.createElement(Text$1.B1, { className: classNames({ 'bg-theme-allowed': allowThemeInvert, required: required }), dangerouslySetInnerHTML: { __html: label || '' } })),
                React__default.createElement(Input.MultiSelect, { className: "survey-multi-select-list", fieldKey: "text", type: "list", options: multipleChoiceOptions, value: value, onChange: function (value) {
                        onTrackEvent === null || onTrackEvent === void 0 ? void 0 : onTrackEvent();
                        onChange(value);
                    }, prefixType: singleMultipleChoiceListPrefix }),
                showError && React__default.createElement(ErrorMsg$5, null, errorMessage)));
        case 'single-choice':
            return (React__default.createElement(FieldWrap$2, { className: showError ? 'has-field-error' : '' },
                showLabel && (React__default.createElement(Text$1.B1, { className: classNames({ 'bg-theme-allowed': allowThemeInvert, required: required }), dangerouslySetInnerHTML: { __html: label || '' } })),
                React__default.createElement(Input.MultiSelect, { className: "survey-multi-select-list", fieldKey: "text", type: "list", options: multipleChoiceOptions, mode: "single", value: value, onChange: function (value) {
                        onTrackEvent === null || onTrackEvent === void 0 ? void 0 : onTrackEvent();
                        onChange(value);
                    }, prefixType: singleMultipleChoiceListPrefix }),
                showError && React__default.createElement(ErrorMsg$5, null, errorMessage)));
        case 'upload':
            return (React__default.createElement(FieldWrap$2, { className: showError ? 'has-field-error' : '' },
                showLabel && (React__default.createElement(Text$1.B1, { className: classNames({ 'bg-theme-allowed': allowThemeInvert, required: required }), dangerouslySetInnerHTML: { __html: label || '' } })),
                React__default.createElement(Upload, { containerClass: "survey-upload mb-10", btnTitle: uploadButtonLabel ? uploadButtonLabel : 'Upload Attachments', showLoading: showImageUploadLoader, fileList: value, customRequest: uploadImage, className: required ? 'required' : '', showUploadList: false, accept: "image/*,video/*,audio/*,.xlsx,.xls,.doc,.docx,.ppt,.pptx,.txt,.pdf", setFileList: function (files) {
                        onTrackEvent === null || onTrackEvent === void 0 ? void 0 : onTrackEvent();
                        onChange(files);
                    } }),
                showError && React__default.createElement(ErrorMsg$5, null, errorMessage)));
        case 'tiered_rating':
            return (React__default.createElement(TieredRatingWrapper, { className: showError ? 'has-field-error' : '' },
                showLabel && (React__default.createElement(Text$1.H3Span, { semibold: true, className: required ? 'required' : '', dangerouslySetInnerHTML: { __html: label || '' } })),
                React__default.createElement(RatingWrap$2, { className: "mb-10" }, renderRating()),
                showError && React__default.createElement(ErrorMsg$5, null, errorMessage)));
        case 'sub_tiered_rating':
            return (React__default.createElement(ChildFieldWrap, { "$ratingType": ratingType, className: showError ? 'has-field-error' : '' },
                showLabel && (React__default.createElement(Text$1.B1, { semibold: true, className: "label-container ".concat(required ? 'required' : ''), dangerouslySetInnerHTML: { __html: label || '' } })),
                React__default.createElement(RatingWrap$2, { className: "mb-0" }, renderRating()),
                showError && React__default.createElement(ErrorMsg$5, null, errorMessage)));
        case 'choose_voucher':
            if (((_b = (vouchersData || [])) === null || _b === void 0 ? void 0 : _b.length) > 0 || (noOfferPayload === null || noOfferPayload === void 0 ? void 0 : noOfferPayload.show)) {
                return (React__default.createElement(FieldWrap$2, { className: showError ? 'has-field-error' : '' },
                    showLabel && (React__default.createElement(Text$1.H2, { style: { textAlign: 'center', fontWeight: 600 }, className: required ? 'mb-20 required' : 'mb-20' }, (_c = (label || '')) === null || _c === void 0 ? void 0 : _c.replace(/<[^>]*>/g, ''))),
                    React__default.createElement(VoucherSelection, { onChange: onChange, value: value, showError: showError, errorMessage: errorMessage, voucherData: vouchersData || [], voucherList: voucherList || [], noOfferPayload: noOfferPayload, voucherIdsMetadata: voucherIdsMetadata }),
                    showError && React__default.createElement(ErrorMsg$5, null, errorMessage)));
            }
            else {
                return React__default.createElement(React__default.Fragment, null);
            }
        case 'item_tiered_rating':
            return (React__default.createElement(ItemTieredRatingWrapper, { className: showError ? 'has-field-error' : '' },
                showLabel && (React__default.createElement(Text$1.B1, { semibold: true, className: required ? 'required' : '', dangerouslySetInnerHTML: { __html: label || '' } })),
                React__default.createElement(RatingWrap$2, { className: "mb-10" }, renderRating()),
                showError && React__default.createElement(ErrorMsg$5, null, errorMessage)));
        case 'item_sub_tiered_rating':
            return (React__default.createElement(ChildItemFieldWrap, { "$ratingType": ratingType, className: showError ? 'item-sub-tiered-rating has-field-error' : 'item-sub-tiered-rating' },
                showLabel && (React__default.createElement(Text$1.B1, { semibold: true, className: "label-container ".concat(required ? 'required' : ''), dangerouslySetInnerHTML: { __html: label || '' } })),
                React__default.createElement(RatingWrap$2, { className: "mb-0" }, renderRating()),
                showError && React__default.createElement(ErrorMsg$5, null, errorMessage)));
        default:
            return null;
    }
};
var templateObject_1$a, templateObject_2$a, templateObject_3$7, templateObject_4$5, templateObject_5$5, templateObject_6$4, templateObject_7$3;

// Constants
var MIN_STORE_ID_DIGITS = 5;
var DynamicTextContainer = defaultStyled.div(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 0.938rem;\n"], ["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 0.938rem;\n"])));
var DynamicTextContent = defaultStyled.div(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject(["\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  padding: 1rem;\n  margin-top: 0.625rem;\n  font-family: inherit;\n  line-height: 1.5;\n  text-align: center;\n"], ["\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  padding: 1rem;\n  margin-top: 0.625rem;\n  font-family: inherit;\n  line-height: 1.5;\n  text-align: center;\n"])));
var SAFE_API_WHITELIST = {
    Math: Math,
    Date: Date,
    String: String,
    Number: Number,
    Boolean: Boolean,
    Object: Object,
    Array: Array,
    // Shadow dangerous globals with safe values
    alert: undefined,
    confirm: undefined,
    prompt: undefined,
    fetch: undefined,
    XMLHttpRequest: undefined,
    document: undefined,
    window: undefined,
    global: undefined,
    localStorage: undefined,
    sessionStorage: undefined,
    eval: undefined,
    Function: undefined,
    setTimeout: undefined,
    setInterval: undefined,
    setImmediate: undefined,
    process: undefined,
    require: undefined
};
// add a fourth param for your whitelist
var evaluateTemplate = function (template, availableVariables) {
    if (availableVariables === void 0) { availableVariables = {}; }
    try {
        // Default context for preview - use the exampleValue from availableVariables
        var context_1 = {};
        Object.entries(availableVariables).forEach(function (_a) {
            var key = _a[0], variable = _a[1];
            if (variable && variable.value !== undefined) {
                context_1[key] = variable.value;
            }
        });
        // Merge with any provided context, but whitelist safe APIs first
        var finalContext_1 = __assign(__assign({}, SAFE_API_WHITELIST), context_1);
        // Check for malformed syntax first
        var errors = [];
        // Check for expressions that start with ${{ but don't close properly at end of string
        if (template.includes('${{') && template.match(/\$\{\{[^}]*$/)) {
            errors.push('Incomplete expression: missing closing braces');
        }
        // If we found syntax errors, return them
        if (errors.length > 0) {
            return { success: false, result: template, errors: errors };
        }
        // Replace simple variables: {{variable}}
        var result = template.replace(/\{\{(\w+)\}\}/g, function (match, variable) {
            return finalContext_1[variable] != null ? finalContext_1[variable] : match;
        });
        // Replace JavaScript expressions: ${{expression}}
        // Manual parsing to handle nested braces properly
        var currentIndex = 0;
        var hasMoreExpressions = true;
        while (hasMoreExpressions) {
            var startIndex = result.indexOf('${{', currentIndex);
            if (startIndex === -1) {
                hasMoreExpressions = false;
                break;
            }
            // Find the matching closing braces
            var braceCount = 0;
            var endIndex = startIndex + 3; // Start after ${{
            while (endIndex < result.length) {
                var char = result[endIndex];
                if (char === '{') {
                    braceCount++;
                }
                else if (char === '}') {
                    if (braceCount === 0) {
                        // Found first closing brace
                        if (endIndex + 1 < result.length && result[endIndex + 1] === '}') {
                            // Found the closing }}
                            endIndex += 2;
                            break;
                        }
                    }
                    else {
                        braceCount--;
                    }
                }
                endIndex++;
            }
            if (endIndex > result.length) {
                // Malformed expression
                throw new Error('Unclosed expression found');
            }
            var expression = result.substring(startIndex + 3, endIndex - 2); // Remove ${{ and }}
            try {
                // Create a safe evaluation context—only SAFE_API_WHITELIST + your variables/overrides
                var func = new (Function.bind.apply(Function, __spreadArray(__spreadArray([void 0], Object.keys(finalContext_1), false), ["return ".concat(expression)], false)))();
                var evaluatedResult = func.apply(void 0, Object.values(finalContext_1));
                result = result.substring(0, startIndex) + evaluatedResult + result.substring(endIndex);
                currentIndex = startIndex + String(evaluatedResult).length;
            }
            catch (error) {
                throw new Error("Error in expression \"".concat(expression, "\": ").concat(error.message));
            }
        }
        return { success: true, result: result, errors: [] };
    }
    catch (error) {
        return { success: false, result: template, errors: [error.message] };
    }
};
// Function to get fresh mapping configuration
var getExpressParamsMapping = function () { return ({
    orderTime: {
        contextVariableKey: 'visitDate',
        fallback: new Date().toISOString()
    },
    storeId: {
        contextVariableKey: 'storeId',
        fallback: '00000'
    }
}); };
// Function to format store ID with leading zeros
var formatStoreId = function (storeId) {
    var storeIdStr = String(storeId);
    // Only pad if less than minimum digits, otherwise return as-is
    return storeIdStr.length < MIN_STORE_ID_DIGITS ? storeIdStr.padStart(MIN_STORE_ID_DIGITS, '0') : storeIdStr;
};
// Function to map expressParams to availableVariables with fallbacks
var mapExpressParamsToVariables = function (expressParams, availableVariables) {
    var paramMapping = getExpressParamsMapping();
    var result = {};
    Object.keys(availableVariables).forEach(function (key) {
        var value = null;
        // 1. Check if any expressParam maps to this variable
        var mappingEntry = Object.entries(paramMapping).find(function (_a) {
            _a[0]; var config = _a[1];
            return config.contextVariableKey === key;
        });
        if (mappingEntry) {
            var paramKey = mappingEntry[0], config = mappingEntry[1];
            if (expressParams[paramKey] !== null && expressParams[paramKey] !== undefined) {
                value = expressParams[paramKey];
                // Special handling for store ID formatting
                if (key === 'storeId') {
                    value = formatStoreId(value);
                }
            }
            else {
                value = config.fallback;
            }
        }
        // 3. Store the result
        if (value !== null && value !== undefined) {
            result[key] = value;
        }
    });
    return result;
};
var RenderDynamicText = function (_a) {
    var _b, _c;
    var question = _a.question, className = _a.className, _d = _a.editorMode, editorMode = _d === void 0 ? false : _d, _e = _a.expressParams, expressParams = _e === void 0 ? {} : _e;
    var label = getFieldQuestionValue(question, 'label');
    var templateDraft = getFieldQuestionValue(question, 'template_draft');
    var availableVariables = (_c = (_b = question.value) === null || _b === void 0 ? void 0 : _b.find(function (field) { return field.fieldKey === 'template_draft'; })) === null || _c === void 0 ? void 0 : _c.availableVariables;
    // Process availableVariables based on mode
    var processedVariables = __assign({}, availableVariables);
    if (editorMode) {
        // Use exampleValue as value for all variables
        Object.keys(processedVariables).forEach(function (key) {
            var _a;
            if (((_a = processedVariables[key]) === null || _a === void 0 ? void 0 : _a.exampleValue) !== undefined) {
                processedVariables[key] = __assign(__assign({}, processedVariables[key]), { value: processedVariables[key].exampleValue });
            }
        });
    }
    else {
        // Non-editor mode: Apply values from expressParams and fallbacks
        var processedParams_1 = mapExpressParamsToVariables(expressParams, processedVariables);
        Object.keys(processedVariables).forEach(function (key) {
            // 4. Apply the value
            if (processedParams_1[key] !== null && processedParams_1[key] !== undefined) {
                processedVariables[key] = __assign(__assign({}, processedVariables[key]), { value: processedParams_1[key] });
            }
        });
    }
    var evaluation = evaluateTemplate(templateDraft || '', processedVariables || {});
    return (React__default.createElement(DynamicTextContainer, { className: className },
        React__default.createElement(Text$1.B1, { semibold: true, dangerouslySetInnerHTML: { __html: label || '' } }),
        React__default.createElement(DynamicTextContent, null, evaluation.success ? (React__default.createElement(Text$1.B1, null, evaluation.result)) : (React__default.createElement("div", null,
            React__default.createElement(Text$1.B1, { style: { color: 'var(--indian-red)' } }, "Error evaluating expression:"),
            evaluation.errors.map(function (error, index) { return (React__default.createElement(Text$1.B2, { key: index, style: { color: 'var(--indian-red)', marginTop: '0.25rem' } }, error)); }))))));
};
var templateObject_1$9, templateObject_2$9;

var RenderElement = function (_a) {
    var type = _a.type, label = _a.label, _b = _a.showElement, showElement = _b === void 0 ? true : _b, className = _a.className, question = _a.question, editorMode = _a.editorMode, expressParams = _a.expressParams;
    if (!showElement) {
        return React__default.createElement(React__default.Fragment, null);
    }
    switch (type) {
        case 'richtext':
            return React__default.createElement(Text$1.B1, { className: className, dangerouslySetInnerHTML: { __html: label || '' } });
        case 'titletext':
            return React__default.createElement(Text$1.H2, { className: className, semibold: true, dangerouslySetInnerHTML: { __html: label || '' } });
        case 'h5text':
            return React__default.createElement(Text$1.H5, { className: className, semibold: true, dangerouslySetInnerHTML: { __html: label || '' } });
        case 'dynamic_text':
            return (React__default.createElement(RenderDynamicText, { question: question, className: className, editorMode: editorMode, expressParams: expressParams }));
        default:
            return null;
    }
};

var axios$3 = {exports: {}};

var bind$2 = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

var bind$1 = bind$2;

// utils is a library of generic helper functions non-specific to axios

var toString$3 = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray$1(val) {
  return toString$3.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString$3.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString$1(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject$1(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString$3.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString$3.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString$3.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString$3.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString$3.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject$1(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach$2(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray$1(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray$1(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach$2(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach$2(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind$1(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

var utils$9 = {
  isArray: isArray$1,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString$1,
  isNumber: isNumber,
  isObject: isObject$1,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach$2,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

var utils$8 = utils$9;

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
var buildURL$1 = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$8.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils$8.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils$8.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils$8.forEach(val, function parseValue(v) {
        if (utils$8.isDate(v)) {
          v = v.toISOString();
        } else if (utils$8.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

var utils$7 = utils$9;

function InterceptorManager$1() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager$1.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager$1.prototype.forEach = function forEach(fn) {
  utils$7.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

var InterceptorManager_1 = InterceptorManager$1;

var utils$6 = utils$9;

var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
  utils$6.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
var enhanceError$1 = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};

var createError;
var hasRequiredCreateError;

function requireCreateError () {
	if (hasRequiredCreateError) return createError;
	hasRequiredCreateError = 1;

	var enhanceError = enhanceError$1;

	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	createError = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};
	return createError;
}

var settle;
var hasRequiredSettle;

function requireSettle () {
	if (hasRequiredSettle) return settle;
	hasRequiredSettle = 1;

	var createError = requireCreateError();

	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	settle = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};
	return settle;
}

var cookies;
var hasRequiredCookies;

function requireCookies () {
	if (hasRequiredCookies) return cookies;
	hasRequiredCookies = 1;

	var utils = utils$9;

	cookies = (
	  utils.isStandardBrowserEnv() ?

	  // Standard browser envs support document.cookie
	    (function standardBrowserEnv() {
	      return {
	        write: function write(name, value, expires, path, domain, secure) {
	          var cookie = [];
	          cookie.push(name + '=' + encodeURIComponent(value));

	          if (utils.isNumber(expires)) {
	            cookie.push('expires=' + new Date(expires).toGMTString());
	          }

	          if (utils.isString(path)) {
	            cookie.push('path=' + path);
	          }

	          if (utils.isString(domain)) {
	            cookie.push('domain=' + domain);
	          }

	          if (secure === true) {
	            cookie.push('secure');
	          }

	          document.cookie = cookie.join('; ');
	        },

	        read: function read(name) {
	          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	          return (match ? decodeURIComponent(match[3]) : null);
	        },

	        remove: function remove(name) {
	          this.write(name, '', Date.now() - 86400000);
	        }
	      };
	    })() :

	  // Non standard browser env (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return {
	        write: function write() {},
	        read: function read() { return null; },
	        remove: function remove() {}
	      };
	    })()
	);
	return cookies;
}

var isAbsoluteURL;
var hasRequiredIsAbsoluteURL;

function requireIsAbsoluteURL () {
	if (hasRequiredIsAbsoluteURL) return isAbsoluteURL;
	hasRequiredIsAbsoluteURL = 1;

	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	isAbsoluteURL = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};
	return isAbsoluteURL;
}

var combineURLs;
var hasRequiredCombineURLs;

function requireCombineURLs () {
	if (hasRequiredCombineURLs) return combineURLs;
	hasRequiredCombineURLs = 1;

	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	combineURLs = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};
	return combineURLs;
}

var buildFullPath;
var hasRequiredBuildFullPath;

function requireBuildFullPath () {
	if (hasRequiredBuildFullPath) return buildFullPath;
	hasRequiredBuildFullPath = 1;

	var isAbsoluteURL = requireIsAbsoluteURL();
	var combineURLs = requireCombineURLs();

	/**
	 * Creates a new URL by combining the baseURL with the requestedURL,
	 * only when the requestedURL is not already an absolute URL.
	 * If the requestURL is absolute, this function returns the requestedURL untouched.
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} requestedURL Absolute or relative URL to combine
	 * @returns {string} The combined full path
	 */
	buildFullPath = function buildFullPath(baseURL, requestedURL) {
	  if (baseURL && !isAbsoluteURL(requestedURL)) {
	    return combineURLs(baseURL, requestedURL);
	  }
	  return requestedURL;
	};
	return buildFullPath;
}

var parseHeaders;
var hasRequiredParseHeaders;

function requireParseHeaders () {
	if (hasRequiredParseHeaders) return parseHeaders;
	hasRequiredParseHeaders = 1;

	var utils = utils$9;

	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];

	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	parseHeaders = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;

	  if (!headers) { return parsed; }

	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));

	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });

	  return parsed;
	};
	return parseHeaders;
}

var isURLSameOrigin;
var hasRequiredIsURLSameOrigin;

function requireIsURLSameOrigin () {
	if (hasRequiredIsURLSameOrigin) return isURLSameOrigin;
	hasRequiredIsURLSameOrigin = 1;

	var utils = utils$9;

	isURLSameOrigin = (
	  utils.isStandardBrowserEnv() ?

	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	    (function standardBrowserEnv() {
	      var msie = /(msie|trident)/i.test(navigator.userAgent);
	      var urlParsingNode = document.createElement('a');
	      var originURL;

	      /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	      function resolveURL(url) {
	        var href = url;

	        if (msie) {
	        // IE needs attribute set twice to normalize properties
	          urlParsingNode.setAttribute('href', href);
	          href = urlParsingNode.href;
	        }

	        urlParsingNode.setAttribute('href', href);

	        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	        return {
	          href: urlParsingNode.href,
	          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	          host: urlParsingNode.host,
	          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	          hostname: urlParsingNode.hostname,
	          port: urlParsingNode.port,
	          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	            urlParsingNode.pathname :
	            '/' + urlParsingNode.pathname
	        };
	      }

	      originURL = resolveURL(window.location.href);

	      /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	      return function isURLSameOrigin(requestURL) {
	        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	        return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	      };
	    })() :

	  // Non standard browser envs (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return function isURLSameOrigin() {
	        return true;
	      };
	    })()
	);
	return isURLSameOrigin;
}

var xhr;
var hasRequiredXhr;

function requireXhr () {
	if (hasRequiredXhr) return xhr;
	hasRequiredXhr = 1;

	var utils = utils$9;
	var settle = requireSettle();
	var cookies = requireCookies();
	var buildURL = buildURL$1;
	var buildFullPath = requireBuildFullPath();
	var parseHeaders = requireParseHeaders();
	var isURLSameOrigin = requireIsURLSameOrigin();
	var createError = requireCreateError();

	xhr = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	    var responseType = config.responseType;

	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }

	    var request = new XMLHttpRequest();

	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }

	    var fullPath = buildFullPath(config.baseURL, config.url);
	    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

	    // Set the request timeout in MS
	    request.timeout = config.timeout;

	    function onloadend() {
	      if (!request) {
	        return;
	      }
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
	        request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };

	      settle(resolve, reject, response);

	      // Clean up request
	      request = null;
	    }

	    if ('onloadend' in request) {
	      // Use onloadend if available
	      request.onloadend = onloadend;
	    } else {
	      // Listen for ready state to emulate onloadend
	      request.onreadystatechange = function handleLoad() {
	        if (!request || request.readyState !== 4) {
	          return;
	        }

	        // The request errored out and we didn't get a response, this will be
	        // handled by onerror instead
	        // With one exception: request that using file: protocol, most browsers
	        // will return status as 0 even though it's a successful request
	        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	          return;
	        }
	        // readystate handler is calling before onerror or ontimeout handlers,
	        // so we should call onloadend on the next 'tick'
	        setTimeout(onloadend);
	      };
	    }

	    // Handle browser request cancellation (as opposed to a manual cancellation)
	    request.onabort = function handleAbort() {
	      if (!request) {
	        return;
	      }

	      reject(createError('Request aborted', config, 'ECONNABORTED', request));

	      // Clean up request
	      request = null;
	    };

	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));

	      // Clean up request
	      request = null;
	    };

	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
	      if (config.timeoutErrorMessage) {
	        timeoutErrorMessage = config.timeoutErrorMessage;
	      }
	      reject(createError(
	        timeoutErrorMessage,
	        config,
	        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
	        request));

	      // Clean up request
	      request = null;
	    };

	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
	        cookies.read(config.xsrfCookieName) :
	        undefined;

	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }

	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }

	    // Add withCredentials to request if needed
	    if (!utils.isUndefined(config.withCredentials)) {
	      request.withCredentials = !!config.withCredentials;
	    }

	    // Add responseType to request if needed
	    if (responseType && responseType !== 'json') {
	      request.responseType = config.responseType;
	    }

	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }

	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }

	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }

	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }

	    if (!requestData) {
	      requestData = null;
	    }

	    // Send the request
	    request.send(requestData);
	  });
	};
	return xhr;
}

var followRedirects = {exports: {}};

var src = {exports: {}};

var browser$1 = {exports: {}};

/**
 * Helpers.
 */

var ms;
var hasRequiredMs;

function requireMs () {
	if (hasRequiredMs) return ms;
	hasRequiredMs = 1;
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var w = d * 7;
	var y = d * 365.25;

	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */

	ms = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isFinite(val)) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};

	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */

	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'weeks':
	    case 'week':
	    case 'w':
	      return n * w;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}

	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */

	function fmtShort(ms) {
	  var msAbs = Math.abs(ms);
	  if (msAbs >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (msAbs >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (msAbs >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (msAbs >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}

	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */

	function fmtLong(ms) {
	  var msAbs = Math.abs(ms);
	  if (msAbs >= d) {
	    return plural(ms, msAbs, d, 'day');
	  }
	  if (msAbs >= h) {
	    return plural(ms, msAbs, h, 'hour');
	  }
	  if (msAbs >= m) {
	    return plural(ms, msAbs, m, 'minute');
	  }
	  if (msAbs >= s) {
	    return plural(ms, msAbs, s, 'second');
	  }
	  return ms + ' ms';
	}

	/**
	 * Pluralization helper.
	 */

	function plural(ms, msAbs, n, name) {
	  var isPlural = msAbs >= n * 1.5;
	  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
	}
	return ms;
}

var common;
var hasRequiredCommon;

function requireCommon () {
	if (hasRequiredCommon) return common;
	hasRequiredCommon = 1;
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 */

	function setup(env) {
		createDebug.debug = createDebug;
		createDebug.default = createDebug;
		createDebug.coerce = coerce;
		createDebug.disable = disable;
		createDebug.enable = enable;
		createDebug.enabled = enabled;
		createDebug.humanize = requireMs();
		createDebug.destroy = destroy;

		Object.keys(env).forEach(key => {
			createDebug[key] = env[key];
		});

		/**
		* The currently active debug mode names, and names to skip.
		*/

		createDebug.names = [];
		createDebug.skips = [];

		/**
		* Map of special "%n" handling functions, for the debug "format" argument.
		*
		* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
		*/
		createDebug.formatters = {};

		/**
		* Selects a color for a debug namespace
		* @param {String} namespace The namespace string for the debug instance to be colored
		* @return {Number|String} An ANSI color code for the given namespace
		* @api private
		*/
		function selectColor(namespace) {
			let hash = 0;

			for (let i = 0; i < namespace.length; i++) {
				hash = ((hash << 5) - hash) + namespace.charCodeAt(i);
				hash |= 0; // Convert to 32bit integer
			}

			return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
		}
		createDebug.selectColor = selectColor;

		/**
		* Create a debugger with the given `namespace`.
		*
		* @param {String} namespace
		* @return {Function}
		* @api public
		*/
		function createDebug(namespace) {
			let prevTime;
			let enableOverride = null;
			let namespacesCache;
			let enabledCache;

			function debug(...args) {
				// Disabled?
				if (!debug.enabled) {
					return;
				}

				const self = debug;

				// Set `diff` timestamp
				const curr = Number(new Date());
				const ms = curr - (prevTime || curr);
				self.diff = ms;
				self.prev = prevTime;
				self.curr = curr;
				prevTime = curr;

				args[0] = createDebug.coerce(args[0]);

				if (typeof args[0] !== 'string') {
					// Anything else let's inspect with %O
					args.unshift('%O');
				}

				// Apply any `formatters` transformations
				let index = 0;
				args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format) => {
					// If we encounter an escaped % then don't increase the array index
					if (match === '%%') {
						return '%';
					}
					index++;
					const formatter = createDebug.formatters[format];
					if (typeof formatter === 'function') {
						const val = args[index];
						match = formatter.call(self, val);

						// Now we need to remove `args[index]` since it's inlined in the `format`
						args.splice(index, 1);
						index--;
					}
					return match;
				});

				// Apply env-specific formatting (colors, etc.)
				createDebug.formatArgs.call(self, args);

				const logFn = self.log || createDebug.log;
				logFn.apply(self, args);
			}

			debug.namespace = namespace;
			debug.useColors = createDebug.useColors();
			debug.color = createDebug.selectColor(namespace);
			debug.extend = extend;
			debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.

			Object.defineProperty(debug, 'enabled', {
				enumerable: true,
				configurable: false,
				get: () => {
					if (enableOverride !== null) {
						return enableOverride;
					}
					if (namespacesCache !== createDebug.namespaces) {
						namespacesCache = createDebug.namespaces;
						enabledCache = createDebug.enabled(namespace);
					}

					return enabledCache;
				},
				set: v => {
					enableOverride = v;
				}
			});

			// Env-specific initialization logic for debug instances
			if (typeof createDebug.init === 'function') {
				createDebug.init(debug);
			}

			return debug;
		}

		function extend(namespace, delimiter) {
			const newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
			newDebug.log = this.log;
			return newDebug;
		}

		/**
		* Enables a debug mode by namespaces. This can include modes
		* separated by a colon and wildcards.
		*
		* @param {String} namespaces
		* @api public
		*/
		function enable(namespaces) {
			createDebug.save(namespaces);
			createDebug.namespaces = namespaces;

			createDebug.names = [];
			createDebug.skips = [];

			let i;
			const split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
			const len = split.length;

			for (i = 0; i < len; i++) {
				if (!split[i]) {
					// ignore empty strings
					continue;
				}

				namespaces = split[i].replace(/\*/g, '.*?');

				if (namespaces[0] === '-') {
					createDebug.skips.push(new RegExp('^' + namespaces.slice(1) + '$'));
				} else {
					createDebug.names.push(new RegExp('^' + namespaces + '$'));
				}
			}
		}

		/**
		* Disable debug output.
		*
		* @return {String} namespaces
		* @api public
		*/
		function disable() {
			const namespaces = [
				...createDebug.names.map(toNamespace),
				...createDebug.skips.map(toNamespace).map(namespace => '-' + namespace)
			].join(',');
			createDebug.enable('');
			return namespaces;
		}

		/**
		* Returns true if the given mode name is enabled, false otherwise.
		*
		* @param {String} name
		* @return {Boolean}
		* @api public
		*/
		function enabled(name) {
			if (name[name.length - 1] === '*') {
				return true;
			}

			let i;
			let len;

			for (i = 0, len = createDebug.skips.length; i < len; i++) {
				if (createDebug.skips[i].test(name)) {
					return false;
				}
			}

			for (i = 0, len = createDebug.names.length; i < len; i++) {
				if (createDebug.names[i].test(name)) {
					return true;
				}
			}

			return false;
		}

		/**
		* Convert regexp to namespace
		*
		* @param {RegExp} regxep
		* @return {String} namespace
		* @api private
		*/
		function toNamespace(regexp) {
			return regexp.toString()
				.substring(2, regexp.toString().length - 2)
				.replace(/\.\*\?$/, '*');
		}

		/**
		* Coerce `val`.
		*
		* @param {Mixed} val
		* @return {Mixed}
		* @api private
		*/
		function coerce(val) {
			if (val instanceof Error) {
				return val.stack || val.message;
			}
			return val;
		}

		/**
		* XXX DO NOT USE. This is a temporary stub function.
		* XXX It WILL be removed in the next major release.
		*/
		function destroy() {
			console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
		}

		createDebug.enable(createDebug.load());

		return createDebug;
	}

	common = setup;
	return common;
}

/* eslint-env browser */

var hasRequiredBrowser;

function requireBrowser () {
	if (hasRequiredBrowser) return browser$1.exports;
	hasRequiredBrowser = 1;
	(function (module, exports) {
		/**
		 * This is the web browser implementation of `debug()`.
		 */

		exports.formatArgs = formatArgs;
		exports.save = save;
		exports.load = load;
		exports.useColors = useColors;
		exports.storage = localstorage();
		exports.destroy = (() => {
			let warned = false;

			return () => {
				if (!warned) {
					warned = true;
					console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
				}
			};
		})();

		/**
		 * Colors.
		 */

		exports.colors = [
			'#0000CC',
			'#0000FF',
			'#0033CC',
			'#0033FF',
			'#0066CC',
			'#0066FF',
			'#0099CC',
			'#0099FF',
			'#00CC00',
			'#00CC33',
			'#00CC66',
			'#00CC99',
			'#00CCCC',
			'#00CCFF',
			'#3300CC',
			'#3300FF',
			'#3333CC',
			'#3333FF',
			'#3366CC',
			'#3366FF',
			'#3399CC',
			'#3399FF',
			'#33CC00',
			'#33CC33',
			'#33CC66',
			'#33CC99',
			'#33CCCC',
			'#33CCFF',
			'#6600CC',
			'#6600FF',
			'#6633CC',
			'#6633FF',
			'#66CC00',
			'#66CC33',
			'#9900CC',
			'#9900FF',
			'#9933CC',
			'#9933FF',
			'#99CC00',
			'#99CC33',
			'#CC0000',
			'#CC0033',
			'#CC0066',
			'#CC0099',
			'#CC00CC',
			'#CC00FF',
			'#CC3300',
			'#CC3333',
			'#CC3366',
			'#CC3399',
			'#CC33CC',
			'#CC33FF',
			'#CC6600',
			'#CC6633',
			'#CC9900',
			'#CC9933',
			'#CCCC00',
			'#CCCC33',
			'#FF0000',
			'#FF0033',
			'#FF0066',
			'#FF0099',
			'#FF00CC',
			'#FF00FF',
			'#FF3300',
			'#FF3333',
			'#FF3366',
			'#FF3399',
			'#FF33CC',
			'#FF33FF',
			'#FF6600',
			'#FF6633',
			'#FF9900',
			'#FF9933',
			'#FFCC00',
			'#FFCC33'
		];

		/**
		 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
		 * and the Firebug extension (any Firefox version) are known
		 * to support "%c" CSS customizations.
		 *
		 * TODO: add a `localStorage` variable to explicitly enable/disable colors
		 */

		// eslint-disable-next-line complexity
		function useColors() {
			// NB: In an Electron preload script, document will be defined but not fully
			// initialized. Since we know we're in Chrome, we'll just detect this case
			// explicitly
			if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
				return true;
			}

			// Internet Explorer and Edge do not support colors.
			if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
				return false;
			}

			let m;

			// Is webkit? http://stackoverflow.com/a/16459606/376773
			// document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
			return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
				// Is firebug? http://stackoverflow.com/a/398120/376773
				(typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
				// Is firefox >= v31?
				// https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
				(typeof navigator !== 'undefined' && navigator.userAgent && (m = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(m[1], 10) >= 31) ||
				// Double check webkit in userAgent just in case we are in a worker
				(typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
		}

		/**
		 * Colorize log arguments if enabled.
		 *
		 * @api public
		 */

		function formatArgs(args) {
			args[0] = (this.useColors ? '%c' : '') +
				this.namespace +
				(this.useColors ? ' %c' : ' ') +
				args[0] +
				(this.useColors ? '%c ' : ' ') +
				'+' + module.exports.humanize(this.diff);

			if (!this.useColors) {
				return;
			}

			const c = 'color: ' + this.color;
			args.splice(1, 0, c, 'color: inherit');

			// The final "%c" is somewhat tricky, because there could be other
			// arguments passed either before or after the %c, so we need to
			// figure out the correct index to insert the CSS into
			let index = 0;
			let lastC = 0;
			args[0].replace(/%[a-zA-Z%]/g, match => {
				if (match === '%%') {
					return;
				}
				index++;
				if (match === '%c') {
					// We only are interested in the *last* %c
					// (the user may have provided their own)
					lastC = index;
				}
			});

			args.splice(lastC, 0, c);
		}

		/**
		 * Invokes `console.debug()` when available.
		 * No-op when `console.debug` is not a "function".
		 * If `console.debug` is not available, falls back
		 * to `console.log`.
		 *
		 * @api public
		 */
		exports.log = console.debug || console.log || (() => {});

		/**
		 * Save `namespaces`.
		 *
		 * @param {String} namespaces
		 * @api private
		 */
		function save(namespaces) {
			try {
				if (namespaces) {
					exports.storage.setItem('debug', namespaces);
				} else {
					exports.storage.removeItem('debug');
				}
			} catch (error) {
				// Swallow
				// XXX (@Qix-) should we be logging these?
			}
		}

		/**
		 * Load `namespaces`.
		 *
		 * @return {String} returns the previously persisted debug modes
		 * @api private
		 */
		function load() {
			let r;
			try {
				r = exports.storage.getItem('debug');
			} catch (error) {
				// Swallow
				// XXX (@Qix-) should we be logging these?
			}

			// If debug isn't set in LS, and we're in Electron, try to load $DEBUG
			if (!r && typeof process !== 'undefined' && 'env' in process) {
				r = process.env.DEBUG;
			}

			return r;
		}

		/**
		 * Localstorage attempts to return the localstorage.
		 *
		 * This is necessary because safari throws
		 * when a user disables cookies/localstorage
		 * and you attempt to access it.
		 *
		 * @return {LocalStorage}
		 * @api private
		 */

		function localstorage() {
			try {
				// TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
				// The Browser also has localStorage in the global context.
				return localStorage;
			} catch (error) {
				// Swallow
				// XXX (@Qix-) should we be logging these?
			}
		}

		module.exports = requireCommon()(exports);

		const {formatters} = module.exports;

		/**
		 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
		 */

		formatters.j = function (v) {
			try {
				return JSON.stringify(v);
			} catch (error) {
				return '[UnexpectedJSONParseError]: ' + error.message;
			}
		}; 
	} (browser$1, browser$1.exports));
	return browser$1.exports;
}

var node = {exports: {}};

var hasFlag;
var hasRequiredHasFlag;

function requireHasFlag () {
	if (hasRequiredHasFlag) return hasFlag;
	hasRequiredHasFlag = 1;
	hasFlag = (flag, argv) => {
		argv = argv || process.argv;
		const prefix = flag.startsWith('-') ? '' : (flag.length === 1 ? '-' : '--');
		const pos = argv.indexOf(prefix + flag);
		const terminatorPos = argv.indexOf('--');
		return pos !== -1 && (terminatorPos === -1 ? true : pos < terminatorPos);
	};
	return hasFlag;
}

var supportsColor_1;
var hasRequiredSupportsColor;

function requireSupportsColor () {
	if (hasRequiredSupportsColor) return supportsColor_1;
	hasRequiredSupportsColor = 1;
	const os = require$$0$2;
	const hasFlag = requireHasFlag();

	const env = process.env;

	let forceColor;
	if (hasFlag('no-color') ||
		hasFlag('no-colors') ||
		hasFlag('color=false')) {
		forceColor = false;
	} else if (hasFlag('color') ||
		hasFlag('colors') ||
		hasFlag('color=true') ||
		hasFlag('color=always')) {
		forceColor = true;
	}
	if ('FORCE_COLOR' in env) {
		forceColor = env.FORCE_COLOR.length === 0 || parseInt(env.FORCE_COLOR, 10) !== 0;
	}

	function translateLevel(level) {
		if (level === 0) {
			return false;
		}

		return {
			level,
			hasBasic: true,
			has256: level >= 2,
			has16m: level >= 3
		};
	}

	function supportsColor(stream) {
		if (forceColor === false) {
			return 0;
		}

		if (hasFlag('color=16m') ||
			hasFlag('color=full') ||
			hasFlag('color=truecolor')) {
			return 3;
		}

		if (hasFlag('color=256')) {
			return 2;
		}

		if (stream && !stream.isTTY && forceColor !== true) {
			return 0;
		}

		const min = forceColor ? 1 : 0;

		if (process.platform === 'win32') {
			// Node.js 7.5.0 is the first version of Node.js to include a patch to
			// libuv that enables 256 color output on Windows. Anything earlier and it
			// won't work. However, here we target Node.js 8 at minimum as it is an LTS
			// release, and Node.js 7 is not. Windows 10 build 10586 is the first Windows
			// release that supports 256 colors. Windows 10 build 14931 is the first release
			// that supports 16m/TrueColor.
			const osRelease = os.release().split('.');
			if (
				Number(process.versions.node.split('.')[0]) >= 8 &&
				Number(osRelease[0]) >= 10 &&
				Number(osRelease[2]) >= 10586
			) {
				return Number(osRelease[2]) >= 14931 ? 3 : 2;
			}

			return 1;
		}

		if ('CI' in env) {
			if (['TRAVIS', 'CIRCLECI', 'APPVEYOR', 'GITLAB_CI'].some(sign => sign in env) || env.CI_NAME === 'codeship') {
				return 1;
			}

			return min;
		}

		if ('TEAMCITY_VERSION' in env) {
			return /^(9\.(0*[1-9]\d*)\.|\d{2,}\.)/.test(env.TEAMCITY_VERSION) ? 1 : 0;
		}

		if (env.COLORTERM === 'truecolor') {
			return 3;
		}

		if ('TERM_PROGRAM' in env) {
			const version = parseInt((env.TERM_PROGRAM_VERSION || '').split('.')[0], 10);

			switch (env.TERM_PROGRAM) {
				case 'iTerm.app':
					return version >= 3 ? 3 : 2;
				case 'Apple_Terminal':
					return 2;
				// No default
			}
		}

		if (/-256(color)?$/i.test(env.TERM)) {
			return 2;
		}

		if (/^screen|^xterm|^vt100|^vt220|^rxvt|color|ansi|cygwin|linux/i.test(env.TERM)) {
			return 1;
		}

		if ('COLORTERM' in env) {
			return 1;
		}

		if (env.TERM === 'dumb') {
			return min;
		}

		return min;
	}

	function getSupportLevel(stream) {
		const level = supportsColor(stream);
		return translateLevel(level);
	}

	supportsColor_1 = {
		supportsColor: getSupportLevel,
		stdout: getSupportLevel(process.stdout),
		stderr: getSupportLevel(process.stderr)
	};
	return supportsColor_1;
}

/**
 * Module dependencies.
 */

var hasRequiredNode;

function requireNode () {
	if (hasRequiredNode) return node.exports;
	hasRequiredNode = 1;
	(function (module, exports) {
		const tty = require$$0$3;
		const util = require$$1;

		/**
		 * This is the Node.js implementation of `debug()`.
		 */

		exports.init = init;
		exports.log = log;
		exports.formatArgs = formatArgs;
		exports.save = save;
		exports.load = load;
		exports.useColors = useColors;
		exports.destroy = util.deprecate(
			() => {},
			'Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.'
		);

		/**
		 * Colors.
		 */

		exports.colors = [6, 2, 3, 4, 5, 1];

		try {
			// Optional dependency (as in, doesn't need to be installed, NOT like optionalDependencies in package.json)
			// eslint-disable-next-line import/no-extraneous-dependencies
			const supportsColor = requireSupportsColor();

			if (supportsColor && (supportsColor.stderr || supportsColor).level >= 2) {
				exports.colors = [
					20,
					21,
					26,
					27,
					32,
					33,
					38,
					39,
					40,
					41,
					42,
					43,
					44,
					45,
					56,
					57,
					62,
					63,
					68,
					69,
					74,
					75,
					76,
					77,
					78,
					79,
					80,
					81,
					92,
					93,
					98,
					99,
					112,
					113,
					128,
					129,
					134,
					135,
					148,
					149,
					160,
					161,
					162,
					163,
					164,
					165,
					166,
					167,
					168,
					169,
					170,
					171,
					172,
					173,
					178,
					179,
					184,
					185,
					196,
					197,
					198,
					199,
					200,
					201,
					202,
					203,
					204,
					205,
					206,
					207,
					208,
					209,
					214,
					215,
					220,
					221
				];
			}
		} catch (error) {
			// Swallow - we only care if `supports-color` is available; it doesn't have to be.
		}

		/**
		 * Build up the default `inspectOpts` object from the environment variables.
		 *
		 *   $ DEBUG_COLORS=no DEBUG_DEPTH=10 DEBUG_SHOW_HIDDEN=enabled node script.js
		 */

		exports.inspectOpts = Object.keys(process.env).filter(key => {
			return /^debug_/i.test(key);
		}).reduce((obj, key) => {
			// Camel-case
			const prop = key
				.substring(6)
				.toLowerCase()
				.replace(/_([a-z])/g, (_, k) => {
					return k.toUpperCase();
				});

			// Coerce string value into JS value
			let val = process.env[key];
			if (/^(yes|on|true|enabled)$/i.test(val)) {
				val = true;
			} else if (/^(no|off|false|disabled)$/i.test(val)) {
				val = false;
			} else if (val === 'null') {
				val = null;
			} else {
				val = Number(val);
			}

			obj[prop] = val;
			return obj;
		}, {});

		/**
		 * Is stdout a TTY? Colored output is enabled when `true`.
		 */

		function useColors() {
			return 'colors' in exports.inspectOpts ?
				Boolean(exports.inspectOpts.colors) :
				tty.isatty(process.stderr.fd);
		}

		/**
		 * Adds ANSI color escape codes if enabled.
		 *
		 * @api public
		 */

		function formatArgs(args) {
			const {namespace: name, useColors} = this;

			if (useColors) {
				const c = this.color;
				const colorCode = '\u001B[3' + (c < 8 ? c : '8;5;' + c);
				const prefix = `  ${colorCode};1m${name} \u001B[0m`;

				args[0] = prefix + args[0].split('\n').join('\n' + prefix);
				args.push(colorCode + 'm+' + module.exports.humanize(this.diff) + '\u001B[0m');
			} else {
				args[0] = getDate() + name + ' ' + args[0];
			}
		}

		function getDate() {
			if (exports.inspectOpts.hideDate) {
				return '';
			}
			return new Date().toISOString() + ' ';
		}

		/**
		 * Invokes `util.formatWithOptions()` with the specified arguments and writes to stderr.
		 */

		function log(...args) {
			return process.stderr.write(util.formatWithOptions(exports.inspectOpts, ...args) + '\n');
		}

		/**
		 * Save `namespaces`.
		 *
		 * @param {String} namespaces
		 * @api private
		 */
		function save(namespaces) {
			if (namespaces) {
				process.env.DEBUG = namespaces;
			} else {
				// If you set a process.env field to null or undefined, it gets cast to the
				// string 'null' or 'undefined'. Just delete instead.
				delete process.env.DEBUG;
			}
		}

		/**
		 * Load `namespaces`.
		 *
		 * @return {String} returns the previously persisted debug modes
		 * @api private
		 */

		function load() {
			return process.env.DEBUG;
		}

		/**
		 * Init logic for `debug` instances.
		 *
		 * Create a new `inspectOpts` object in case `useColors` is set
		 * differently for a particular `debug` instance.
		 */

		function init(debug) {
			debug.inspectOpts = {};

			const keys = Object.keys(exports.inspectOpts);
			for (let i = 0; i < keys.length; i++) {
				debug.inspectOpts[keys[i]] = exports.inspectOpts[keys[i]];
			}
		}

		module.exports = requireCommon()(exports);

		const {formatters} = module.exports;

		/**
		 * Map %o to `util.inspect()`, all on a single line.
		 */

		formatters.o = function (v) {
			this.inspectOpts.colors = this.useColors;
			return util.inspect(v, this.inspectOpts)
				.split('\n')
				.map(str => str.trim())
				.join(' ');
		};

		/**
		 * Map %O to `util.inspect()`, allowing multiple lines if needed.
		 */

		formatters.O = function (v) {
			this.inspectOpts.colors = this.useColors;
			return util.inspect(v, this.inspectOpts);
		}; 
	} (node, node.exports));
	return node.exports;
}

/**
 * Detect Electron renderer / nwjs process, which is node, but we should
 * treat as a browser.
 */

var hasRequiredSrc;

function requireSrc () {
	if (hasRequiredSrc) return src.exports;
	hasRequiredSrc = 1;
	if (typeof process === 'undefined' || process.type === 'renderer' || process.browser === true || process.__nwjs) {
		src.exports = requireBrowser();
	} else {
		src.exports = requireNode();
	}
	return src.exports;
}

var debug_1;
var hasRequiredDebug;

function requireDebug () {
	if (hasRequiredDebug) return debug_1;
	hasRequiredDebug = 1;
	var debug;

	debug_1 = function () {
	  if (!debug) {
	    try {
	      /* eslint global-require: off */
	      debug = requireSrc()("follow-redirects");
	    }
	    catch (error) { /* */ }
	    if (typeof debug !== "function") {
	      debug = function () { /* */ };
	    }
	  }
	  debug.apply(null, arguments);
	};
	return debug_1;
}

var hasRequiredFollowRedirects;

function requireFollowRedirects () {
	if (hasRequiredFollowRedirects) return followRedirects.exports;
	hasRequiredFollowRedirects = 1;
	var url = require$$0$4;
	var URL = url.URL;
	var http = require$$1$1;
	var https = require$$2;
	var Writable = require$$3.Writable;
	var assert = require$$4;
	var debug = requireDebug();

	// Whether to use the native URL object or the legacy url module
	var useNativeURL = false;
	try {
	  assert(new URL());
	}
	catch (error) {
	  useNativeURL = error.code === "ERR_INVALID_URL";
	}

	// URL fields to preserve in copy operations
	var preservedUrlFields = [
	  "auth",
	  "host",
	  "hostname",
	  "href",
	  "path",
	  "pathname",
	  "port",
	  "protocol",
	  "query",
	  "search",
	  "hash",
	];

	// Create handlers that pass events from native requests
	var events = ["abort", "aborted", "connect", "error", "socket", "timeout"];
	var eventHandlers = Object.create(null);
	events.forEach(function (event) {
	  eventHandlers[event] = function (arg1, arg2, arg3) {
	    this._redirectable.emit(event, arg1, arg2, arg3);
	  };
	});

	// Error types with codes
	var InvalidUrlError = createErrorType(
	  "ERR_INVALID_URL",
	  "Invalid URL",
	  TypeError
	);
	var RedirectionError = createErrorType(
	  "ERR_FR_REDIRECTION_FAILURE",
	  "Redirected request failed"
	);
	var TooManyRedirectsError = createErrorType(
	  "ERR_FR_TOO_MANY_REDIRECTS",
	  "Maximum number of redirects exceeded",
	  RedirectionError
	);
	var MaxBodyLengthExceededError = createErrorType(
	  "ERR_FR_MAX_BODY_LENGTH_EXCEEDED",
	  "Request body larger than maxBodyLength limit"
	);
	var WriteAfterEndError = createErrorType(
	  "ERR_STREAM_WRITE_AFTER_END",
	  "write after end"
	);

	// istanbul ignore next
	var destroy = Writable.prototype.destroy || noop;

	// An HTTP(S) request that can be redirected
	function RedirectableRequest(options, responseCallback) {
	  // Initialize the request
	  Writable.call(this);
	  this._sanitizeOptions(options);
	  this._options = options;
	  this._ended = false;
	  this._ending = false;
	  this._redirectCount = 0;
	  this._redirects = [];
	  this._requestBodyLength = 0;
	  this._requestBodyBuffers = [];

	  // Attach a callback if passed
	  if (responseCallback) {
	    this.on("response", responseCallback);
	  }

	  // React to responses of native requests
	  var self = this;
	  this._onNativeResponse = function (response) {
	    try {
	      self._processResponse(response);
	    }
	    catch (cause) {
	      self.emit("error", cause instanceof RedirectionError ?
	        cause : new RedirectionError({ cause: cause }));
	    }
	  };

	  // Perform the first request
	  this._performRequest();
	}
	RedirectableRequest.prototype = Object.create(Writable.prototype);

	RedirectableRequest.prototype.abort = function () {
	  destroyRequest(this._currentRequest);
	  this._currentRequest.abort();
	  this.emit("abort");
	};

	RedirectableRequest.prototype.destroy = function (error) {
	  destroyRequest(this._currentRequest, error);
	  destroy.call(this, error);
	  return this;
	};

	// Writes buffered data to the current native request
	RedirectableRequest.prototype.write = function (data, encoding, callback) {
	  // Writing is not allowed if end has been called
	  if (this._ending) {
	    throw new WriteAfterEndError();
	  }

	  // Validate input and shift parameters if necessary
	  if (!isString(data) && !isBuffer(data)) {
	    throw new TypeError("data should be a string, Buffer or Uint8Array");
	  }
	  if (isFunction(encoding)) {
	    callback = encoding;
	    encoding = null;
	  }

	  // Ignore empty buffers, since writing them doesn't invoke the callback
	  // https://github.com/nodejs/node/issues/22066
	  if (data.length === 0) {
	    if (callback) {
	      callback();
	    }
	    return;
	  }
	  // Only write when we don't exceed the maximum body length
	  if (this._requestBodyLength + data.length <= this._options.maxBodyLength) {
	    this._requestBodyLength += data.length;
	    this._requestBodyBuffers.push({ data: data, encoding: encoding });
	    this._currentRequest.write(data, encoding, callback);
	  }
	  // Error when we exceed the maximum body length
	  else {
	    this.emit("error", new MaxBodyLengthExceededError());
	    this.abort();
	  }
	};

	// Ends the current native request
	RedirectableRequest.prototype.end = function (data, encoding, callback) {
	  // Shift parameters if necessary
	  if (isFunction(data)) {
	    callback = data;
	    data = encoding = null;
	  }
	  else if (isFunction(encoding)) {
	    callback = encoding;
	    encoding = null;
	  }

	  // Write data if needed and end
	  if (!data) {
	    this._ended = this._ending = true;
	    this._currentRequest.end(null, null, callback);
	  }
	  else {
	    var self = this;
	    var currentRequest = this._currentRequest;
	    this.write(data, encoding, function () {
	      self._ended = true;
	      currentRequest.end(null, null, callback);
	    });
	    this._ending = true;
	  }
	};

	// Sets a header value on the current native request
	RedirectableRequest.prototype.setHeader = function (name, value) {
	  this._options.headers[name] = value;
	  this._currentRequest.setHeader(name, value);
	};

	// Clears a header value on the current native request
	RedirectableRequest.prototype.removeHeader = function (name) {
	  delete this._options.headers[name];
	  this._currentRequest.removeHeader(name);
	};

	// Global timeout for all underlying requests
	RedirectableRequest.prototype.setTimeout = function (msecs, callback) {
	  var self = this;

	  // Destroys the socket on timeout
	  function destroyOnTimeout(socket) {
	    socket.setTimeout(msecs);
	    socket.removeListener("timeout", socket.destroy);
	    socket.addListener("timeout", socket.destroy);
	  }

	  // Sets up a timer to trigger a timeout event
	  function startTimer(socket) {
	    if (self._timeout) {
	      clearTimeout(self._timeout);
	    }
	    self._timeout = setTimeout(function () {
	      self.emit("timeout");
	      clearTimer();
	    }, msecs);
	    destroyOnTimeout(socket);
	  }

	  // Stops a timeout from triggering
	  function clearTimer() {
	    // Clear the timeout
	    if (self._timeout) {
	      clearTimeout(self._timeout);
	      self._timeout = null;
	    }

	    // Clean up all attached listeners
	    self.removeListener("abort", clearTimer);
	    self.removeListener("error", clearTimer);
	    self.removeListener("response", clearTimer);
	    self.removeListener("close", clearTimer);
	    if (callback) {
	      self.removeListener("timeout", callback);
	    }
	    if (!self.socket) {
	      self._currentRequest.removeListener("socket", startTimer);
	    }
	  }

	  // Attach callback if passed
	  if (callback) {
	    this.on("timeout", callback);
	  }

	  // Start the timer if or when the socket is opened
	  if (this.socket) {
	    startTimer(this.socket);
	  }
	  else {
	    this._currentRequest.once("socket", startTimer);
	  }

	  // Clean up on events
	  this.on("socket", destroyOnTimeout);
	  this.on("abort", clearTimer);
	  this.on("error", clearTimer);
	  this.on("response", clearTimer);
	  this.on("close", clearTimer);

	  return this;
	};

	// Proxy all other public ClientRequest methods
	[
	  "flushHeaders", "getHeader",
	  "setNoDelay", "setSocketKeepAlive",
	].forEach(function (method) {
	  RedirectableRequest.prototype[method] = function (a, b) {
	    return this._currentRequest[method](a, b);
	  };
	});

	// Proxy all public ClientRequest properties
	["aborted", "connection", "socket"].forEach(function (property) {
	  Object.defineProperty(RedirectableRequest.prototype, property, {
	    get: function () { return this._currentRequest[property]; },
	  });
	});

	RedirectableRequest.prototype._sanitizeOptions = function (options) {
	  // Ensure headers are always present
	  if (!options.headers) {
	    options.headers = {};
	  }

	  // Since http.request treats host as an alias of hostname,
	  // but the url module interprets host as hostname plus port,
	  // eliminate the host property to avoid confusion.
	  if (options.host) {
	    // Use hostname if set, because it has precedence
	    if (!options.hostname) {
	      options.hostname = options.host;
	    }
	    delete options.host;
	  }

	  // Complete the URL object when necessary
	  if (!options.pathname && options.path) {
	    var searchPos = options.path.indexOf("?");
	    if (searchPos < 0) {
	      options.pathname = options.path;
	    }
	    else {
	      options.pathname = options.path.substring(0, searchPos);
	      options.search = options.path.substring(searchPos);
	    }
	  }
	};


	// Executes the next native request (initial or redirect)
	RedirectableRequest.prototype._performRequest = function () {
	  // Load the native protocol
	  var protocol = this._options.protocol;
	  var nativeProtocol = this._options.nativeProtocols[protocol];
	  if (!nativeProtocol) {
	    throw new TypeError("Unsupported protocol " + protocol);
	  }

	  // If specified, use the agent corresponding to the protocol
	  // (HTTP and HTTPS use different types of agents)
	  if (this._options.agents) {
	    var scheme = protocol.slice(0, -1);
	    this._options.agent = this._options.agents[scheme];
	  }

	  // Create the native request and set up its event handlers
	  var request = this._currentRequest =
	        nativeProtocol.request(this._options, this._onNativeResponse);
	  request._redirectable = this;
	  for (var event of events) {
	    request.on(event, eventHandlers[event]);
	  }

	  // RFC7230§5.3.1: When making a request directly to an origin server, […]
	  // a client MUST send only the absolute path […] as the request-target.
	  this._currentUrl = /^\//.test(this._options.path) ?
	    url.format(this._options) :
	    // When making a request to a proxy, […]
	    // a client MUST send the target URI in absolute-form […].
	    this._options.path;

	  // End a redirected request
	  // (The first request must be ended explicitly with RedirectableRequest#end)
	  if (this._isRedirect) {
	    // Write the request entity and end
	    var i = 0;
	    var self = this;
	    var buffers = this._requestBodyBuffers;
	    (function writeNext(error) {
	      // Only write if this request has not been redirected yet
	      /* istanbul ignore else */
	      if (request === self._currentRequest) {
	        // Report any write errors
	        /* istanbul ignore if */
	        if (error) {
	          self.emit("error", error);
	        }
	        // Write the next buffer if there are still left
	        else if (i < buffers.length) {
	          var buffer = buffers[i++];
	          /* istanbul ignore else */
	          if (!request.finished) {
	            request.write(buffer.data, buffer.encoding, writeNext);
	          }
	        }
	        // End the request if `end` has been called on us
	        else if (self._ended) {
	          request.end();
	        }
	      }
	    }());
	  }
	};

	// Processes a response from the current native request
	RedirectableRequest.prototype._processResponse = function (response) {
	  // Store the redirected response
	  var statusCode = response.statusCode;
	  if (this._options.trackRedirects) {
	    this._redirects.push({
	      url: this._currentUrl,
	      headers: response.headers,
	      statusCode: statusCode,
	    });
	  }

	  // RFC7231§6.4: The 3xx (Redirection) class of status code indicates
	  // that further action needs to be taken by the user agent in order to
	  // fulfill the request. If a Location header field is provided,
	  // the user agent MAY automatically redirect its request to the URI
	  // referenced by the Location field value,
	  // even if the specific status code is not understood.

	  // If the response is not a redirect; return it as-is
	  var location = response.headers.location;
	  if (!location || this._options.followRedirects === false ||
	      statusCode < 300 || statusCode >= 400) {
	    response.responseUrl = this._currentUrl;
	    response.redirects = this._redirects;
	    this.emit("response", response);

	    // Clean up
	    this._requestBodyBuffers = [];
	    return;
	  }

	  // The response is a redirect, so abort the current request
	  destroyRequest(this._currentRequest);
	  // Discard the remainder of the response to avoid waiting for data
	  response.destroy();

	  // RFC7231§6.4: A client SHOULD detect and intervene
	  // in cyclical redirections (i.e., "infinite" redirection loops).
	  if (++this._redirectCount > this._options.maxRedirects) {
	    throw new TooManyRedirectsError();
	  }

	  // Store the request headers if applicable
	  var requestHeaders;
	  var beforeRedirect = this._options.beforeRedirect;
	  if (beforeRedirect) {
	    requestHeaders = Object.assign({
	      // The Host header was set by nativeProtocol.request
	      Host: response.req.getHeader("host"),
	    }, this._options.headers);
	  }

	  // RFC7231§6.4: Automatic redirection needs to done with
	  // care for methods not known to be safe, […]
	  // RFC7231§6.4.2–3: For historical reasons, a user agent MAY change
	  // the request method from POST to GET for the subsequent request.
	  var method = this._options.method;
	  if ((statusCode === 301 || statusCode === 302) && this._options.method === "POST" ||
	      // RFC7231§6.4.4: The 303 (See Other) status code indicates that
	      // the server is redirecting the user agent to a different resource […]
	      // A user agent can perform a retrieval request targeting that URI
	      // (a GET or HEAD request if using HTTP) […]
	      (statusCode === 303) && !/^(?:GET|HEAD)$/.test(this._options.method)) {
	    this._options.method = "GET";
	    // Drop a possible entity and headers related to it
	    this._requestBodyBuffers = [];
	    removeMatchingHeaders(/^content-/i, this._options.headers);
	  }

	  // Drop the Host header, as the redirect might lead to a different host
	  var currentHostHeader = removeMatchingHeaders(/^host$/i, this._options.headers);

	  // If the redirect is relative, carry over the host of the last request
	  var currentUrlParts = parseUrl(this._currentUrl);
	  var currentHost = currentHostHeader || currentUrlParts.host;
	  var currentUrl = /^\w+:/.test(location) ? this._currentUrl :
	    url.format(Object.assign(currentUrlParts, { host: currentHost }));

	  // Create the redirected request
	  var redirectUrl = resolveUrl(location, currentUrl);
	  debug("redirecting to", redirectUrl.href);
	  this._isRedirect = true;
	  spreadUrlObject(redirectUrl, this._options);

	  // Drop confidential headers when redirecting to a less secure protocol
	  // or to a different domain that is not a superdomain
	  if (redirectUrl.protocol !== currentUrlParts.protocol &&
	     redirectUrl.protocol !== "https:" ||
	     redirectUrl.host !== currentHost &&
	     !isSubdomain(redirectUrl.host, currentHost)) {
	    removeMatchingHeaders(/^(?:(?:proxy-)?authorization|cookie)$/i, this._options.headers);
	  }

	  // Evaluate the beforeRedirect callback
	  if (isFunction(beforeRedirect)) {
	    var responseDetails = {
	      headers: response.headers,
	      statusCode: statusCode,
	    };
	    var requestDetails = {
	      url: currentUrl,
	      method: method,
	      headers: requestHeaders,
	    };
	    beforeRedirect(this._options, responseDetails, requestDetails);
	    this._sanitizeOptions(this._options);
	  }

	  // Perform the redirected request
	  this._performRequest();
	};

	// Wraps the key/value object of protocols with redirect functionality
	function wrap(protocols) {
	  // Default settings
	  var exports = {
	    maxRedirects: 21,
	    maxBodyLength: 10 * 1024 * 1024,
	  };

	  // Wrap each protocol
	  var nativeProtocols = {};
	  Object.keys(protocols).forEach(function (scheme) {
	    var protocol = scheme + ":";
	    var nativeProtocol = nativeProtocols[protocol] = protocols[scheme];
	    var wrappedProtocol = exports[scheme] = Object.create(nativeProtocol);

	    // Executes a request, following redirects
	    function request(input, options, callback) {
	      // Parse parameters, ensuring that input is an object
	      if (isURL(input)) {
	        input = spreadUrlObject(input);
	      }
	      else if (isString(input)) {
	        input = spreadUrlObject(parseUrl(input));
	      }
	      else {
	        callback = options;
	        options = validateUrl(input);
	        input = { protocol: protocol };
	      }
	      if (isFunction(options)) {
	        callback = options;
	        options = null;
	      }

	      // Set defaults
	      options = Object.assign({
	        maxRedirects: exports.maxRedirects,
	        maxBodyLength: exports.maxBodyLength,
	      }, input, options);
	      options.nativeProtocols = nativeProtocols;
	      if (!isString(options.host) && !isString(options.hostname)) {
	        options.hostname = "::1";
	      }

	      assert.equal(options.protocol, protocol, "protocol mismatch");
	      debug("options", options);
	      return new RedirectableRequest(options, callback);
	    }

	    // Executes a GET request, following redirects
	    function get(input, options, callback) {
	      var wrappedRequest = wrappedProtocol.request(input, options, callback);
	      wrappedRequest.end();
	      return wrappedRequest;
	    }

	    // Expose the properties on the wrapped protocol
	    Object.defineProperties(wrappedProtocol, {
	      request: { value: request, configurable: true, enumerable: true, writable: true },
	      get: { value: get, configurable: true, enumerable: true, writable: true },
	    });
	  });
	  return exports;
	}

	function noop() { /* empty */ }

	function parseUrl(input) {
	  var parsed;
	  /* istanbul ignore else */
	  if (useNativeURL) {
	    parsed = new URL(input);
	  }
	  else {
	    // Ensure the URL is valid and absolute
	    parsed = validateUrl(url.parse(input));
	    if (!isString(parsed.protocol)) {
	      throw new InvalidUrlError({ input });
	    }
	  }
	  return parsed;
	}

	function resolveUrl(relative, base) {
	  /* istanbul ignore next */
	  return useNativeURL ? new URL(relative, base) : parseUrl(url.resolve(base, relative));
	}

	function validateUrl(input) {
	  if (/^\[/.test(input.hostname) && !/^\[[:0-9a-f]+\]$/i.test(input.hostname)) {
	    throw new InvalidUrlError({ input: input.href || input });
	  }
	  if (/^\[/.test(input.host) && !/^\[[:0-9a-f]+\](:\d+)?$/i.test(input.host)) {
	    throw new InvalidUrlError({ input: input.href || input });
	  }
	  return input;
	}

	function spreadUrlObject(urlObject, target) {
	  var spread = target || {};
	  for (var key of preservedUrlFields) {
	    spread[key] = urlObject[key];
	  }

	  // Fix IPv6 hostname
	  if (spread.hostname.startsWith("[")) {
	    spread.hostname = spread.hostname.slice(1, -1);
	  }
	  // Ensure port is a number
	  if (spread.port !== "") {
	    spread.port = Number(spread.port);
	  }
	  // Concatenate path
	  spread.path = spread.search ? spread.pathname + spread.search : spread.pathname;

	  return spread;
	}

	function removeMatchingHeaders(regex, headers) {
	  var lastValue;
	  for (var header in headers) {
	    if (regex.test(header)) {
	      lastValue = headers[header];
	      delete headers[header];
	    }
	  }
	  return (lastValue === null || typeof lastValue === "undefined") ?
	    undefined : String(lastValue).trim();
	}

	function createErrorType(code, message, baseClass) {
	  // Create constructor
	  function CustomError(properties) {
	    Error.captureStackTrace(this, this.constructor);
	    Object.assign(this, properties || {});
	    this.code = code;
	    this.message = this.cause ? message + ": " + this.cause.message : message;
	  }

	  // Attach constructor and set default properties
	  CustomError.prototype = new (baseClass || Error)();
	  Object.defineProperties(CustomError.prototype, {
	    constructor: {
	      value: CustomError,
	      enumerable: false,
	    },
	    name: {
	      value: "Error [" + code + "]",
	      enumerable: false,
	    },
	  });
	  return CustomError;
	}

	function destroyRequest(request, error) {
	  for (var event of events) {
	    request.removeListener(event, eventHandlers[event]);
	  }
	  request.on("error", noop);
	  request.destroy(error);
	}

	function isSubdomain(subdomain, domain) {
	  assert(isString(subdomain) && isString(domain));
	  var dot = subdomain.length - domain.length - 1;
	  return dot > 0 && subdomain[dot] === "." && subdomain.endsWith(domain);
	}

	function isString(value) {
	  return typeof value === "string" || value instanceof String;
	}

	function isFunction(value) {
	  return typeof value === "function";
	}

	function isBuffer(value) {
	  return typeof value === "object" && ("length" in value);
	}

	function isURL(value) {
	  return URL && value instanceof URL;
	}

	// Exports
	followRedirects.exports = wrap({ http: http, https: https });
	followRedirects.exports.wrap = wrap;
	return followRedirects.exports;
}

var name = "axios";
var version = "0.21.4";
var description = "Promise based HTTP client for the browser and node.js";
var main = "index.js";
var scripts = {
	test: "grunt test",
	start: "node ./sandbox/server.js",
	build: "NODE_ENV=production grunt build",
	preversion: "npm test",
	version: "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
	postversion: "git push && git push --tags",
	examples: "node ./examples/server.js",
	coveralls: "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
	fix: "eslint --fix lib/**/*.js"
};
var repository = {
	type: "git",
	url: "https://github.com/axios/axios.git"
};
var keywords = [
	"xhr",
	"http",
	"ajax",
	"promise",
	"node"
];
var author = "Matt Zabriskie";
var license = "MIT";
var bugs = {
	url: "https://github.com/axios/axios/issues"
};
var homepage = "https://axios-http.com";
var devDependencies = {
	coveralls: "^3.0.0",
	"es6-promise": "^4.2.4",
	grunt: "^1.3.0",
	"grunt-banner": "^0.6.0",
	"grunt-cli": "^1.2.0",
	"grunt-contrib-clean": "^1.1.0",
	"grunt-contrib-watch": "^1.0.0",
	"grunt-eslint": "^23.0.0",
	"grunt-karma": "^4.0.0",
	"grunt-mocha-test": "^0.13.3",
	"grunt-ts": "^6.0.0-beta.19",
	"grunt-webpack": "^4.0.2",
	"istanbul-instrumenter-loader": "^1.0.0",
	"jasmine-core": "^2.4.1",
	karma: "^6.3.2",
	"karma-chrome-launcher": "^3.1.0",
	"karma-firefox-launcher": "^2.1.0",
	"karma-jasmine": "^1.1.1",
	"karma-jasmine-ajax": "^0.1.13",
	"karma-safari-launcher": "^1.0.0",
	"karma-sauce-launcher": "^4.3.6",
	"karma-sinon": "^1.0.5",
	"karma-sourcemap-loader": "^0.3.8",
	"karma-webpack": "^4.0.2",
	"load-grunt-tasks": "^3.5.2",
	minimist: "^1.2.0",
	mocha: "^8.2.1",
	sinon: "^4.5.0",
	"terser-webpack-plugin": "^4.2.3",
	typescript: "^4.0.5",
	"url-search-params": "^0.10.0",
	webpack: "^4.44.2",
	"webpack-dev-server": "^3.11.0"
};
var browser = {
	"./lib/adapters/http.js": "./lib/adapters/xhr.js"
};
var jsdelivr = "dist/axios.min.js";
var unpkg = "dist/axios.min.js";
var typings = "./index.d.ts";
var dependencies = {
	"follow-redirects": "^1.14.0"
};
var bundlesize = [
	{
		path: "./dist/axios.min.js",
		threshold: "5kB"
	}
];
var require$$0 = {
	name: name,
	version: version,
	description: description,
	main: main,
	scripts: scripts,
	repository: repository,
	keywords: keywords,
	author: author,
	license: license,
	bugs: bugs,
	homepage: homepage,
	devDependencies: devDependencies,
	browser: browser,
	jsdelivr: jsdelivr,
	unpkg: unpkg,
	typings: typings,
	dependencies: dependencies,
	bundlesize: bundlesize
};

var http_1;
var hasRequiredHttp;

function requireHttp () {
	if (hasRequiredHttp) return http_1;
	hasRequiredHttp = 1;

	var utils = utils$9;
	var settle = requireSettle();
	var buildFullPath = requireBuildFullPath();
	var buildURL = buildURL$1;
	var http = require$$1$1;
	var https = require$$2;
	var httpFollow = requireFollowRedirects().http;
	var httpsFollow = requireFollowRedirects().https;
	var url = require$$0$4;
	var zlib = require$$8;
	var pkg = require$$0;
	var createError = requireCreateError();
	var enhanceError = enhanceError$1;

	var isHttps = /https:?/;

	/**
	 *
	 * @param {http.ClientRequestArgs} options
	 * @param {AxiosProxyConfig} proxy
	 * @param {string} location
	 */
	function setProxy(options, proxy, location) {
	  options.hostname = proxy.host;
	  options.host = proxy.host;
	  options.port = proxy.port;
	  options.path = location;

	  // Basic proxy authorization
	  if (proxy.auth) {
	    var base64 = Buffer.from(proxy.auth.username + ':' + proxy.auth.password, 'utf8').toString('base64');
	    options.headers['Proxy-Authorization'] = 'Basic ' + base64;
	  }

	  // If a proxy is used, any redirects must also pass through the proxy
	  options.beforeRedirect = function beforeRedirect(redirection) {
	    redirection.headers.host = redirection.host;
	    setProxy(redirection, proxy, redirection.href);
	  };
	}

	/*eslint consistent-return:0*/
	http_1 = function httpAdapter(config) {
	  return new Promise(function dispatchHttpRequest(resolvePromise, rejectPromise) {
	    var resolve = function resolve(value) {
	      resolvePromise(value);
	    };
	    var reject = function reject(value) {
	      rejectPromise(value);
	    };
	    var data = config.data;
	    var headers = config.headers;

	    // Set User-Agent (required by some servers)
	    // See https://github.com/axios/axios/issues/69
	    if ('User-Agent' in headers || 'user-agent' in headers) {
	      // User-Agent is specified; handle case where no UA header is desired
	      if (!headers['User-Agent'] && !headers['user-agent']) {
	        delete headers['User-Agent'];
	        delete headers['user-agent'];
	      }
	      // Otherwise, use specified value
	    } else {
	      // Only set header if it hasn't been set in config
	      headers['User-Agent'] = 'axios/' + pkg.version;
	    }

	    if (data && !utils.isStream(data)) {
	      if (Buffer.isBuffer(data)) ; else if (utils.isArrayBuffer(data)) {
	        data = Buffer.from(new Uint8Array(data));
	      } else if (utils.isString(data)) {
	        data = Buffer.from(data, 'utf-8');
	      } else {
	        return reject(createError(
	          'Data after transformation must be a string, an ArrayBuffer, a Buffer, or a Stream',
	          config
	        ));
	      }

	      // Add Content-Length header if data exists
	      headers['Content-Length'] = data.length;
	    }

	    // HTTP basic authentication
	    var auth = undefined;
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      auth = username + ':' + password;
	    }

	    // Parse url
	    var fullPath = buildFullPath(config.baseURL, config.url);
	    var parsed = url.parse(fullPath);
	    var protocol = parsed.protocol || 'http:';

	    if (!auth && parsed.auth) {
	      var urlAuth = parsed.auth.split(':');
	      var urlUsername = urlAuth[0] || '';
	      var urlPassword = urlAuth[1] || '';
	      auth = urlUsername + ':' + urlPassword;
	    }

	    if (auth) {
	      delete headers.Authorization;
	    }

	    var isHttpsRequest = isHttps.test(protocol);
	    var agent = isHttpsRequest ? config.httpsAgent : config.httpAgent;

	    var options = {
	      path: buildURL(parsed.path, config.params, config.paramsSerializer).replace(/^\?/, ''),
	      method: config.method.toUpperCase(),
	      headers: headers,
	      agent: agent,
	      agents: { http: config.httpAgent, https: config.httpsAgent },
	      auth: auth
	    };

	    if (config.socketPath) {
	      options.socketPath = config.socketPath;
	    } else {
	      options.hostname = parsed.hostname;
	      options.port = parsed.port;
	    }

	    var proxy = config.proxy;
	    if (!proxy && proxy !== false) {
	      var proxyEnv = protocol.slice(0, -1) + '_proxy';
	      var proxyUrl = process.env[proxyEnv] || process.env[proxyEnv.toUpperCase()];
	      if (proxyUrl) {
	        var parsedProxyUrl = url.parse(proxyUrl);
	        var noProxyEnv = process.env.no_proxy || process.env.NO_PROXY;
	        var shouldProxy = true;

	        if (noProxyEnv) {
	          var noProxy = noProxyEnv.split(',').map(function trim(s) {
	            return s.trim();
	          });

	          shouldProxy = !noProxy.some(function proxyMatch(proxyElement) {
	            if (!proxyElement) {
	              return false;
	            }
	            if (proxyElement === '*') {
	              return true;
	            }
	            if (proxyElement[0] === '.' &&
	                parsed.hostname.substr(parsed.hostname.length - proxyElement.length) === proxyElement) {
	              return true;
	            }

	            return parsed.hostname === proxyElement;
	          });
	        }

	        if (shouldProxy) {
	          proxy = {
	            host: parsedProxyUrl.hostname,
	            port: parsedProxyUrl.port,
	            protocol: parsedProxyUrl.protocol
	          };

	          if (parsedProxyUrl.auth) {
	            var proxyUrlAuth = parsedProxyUrl.auth.split(':');
	            proxy.auth = {
	              username: proxyUrlAuth[0],
	              password: proxyUrlAuth[1]
	            };
	          }
	        }
	      }
	    }

	    if (proxy) {
	      options.headers.host = parsed.hostname + (parsed.port ? ':' + parsed.port : '');
	      setProxy(options, proxy, protocol + '//' + parsed.hostname + (parsed.port ? ':' + parsed.port : '') + options.path);
	    }

	    var transport;
	    var isHttpsProxy = isHttpsRequest && (proxy ? isHttps.test(proxy.protocol) : true);
	    if (config.transport) {
	      transport = config.transport;
	    } else if (config.maxRedirects === 0) {
	      transport = isHttpsProxy ? https : http;
	    } else {
	      if (config.maxRedirects) {
	        options.maxRedirects = config.maxRedirects;
	      }
	      transport = isHttpsProxy ? httpsFollow : httpFollow;
	    }

	    if (config.maxBodyLength > -1) {
	      options.maxBodyLength = config.maxBodyLength;
	    }

	    // Create the request
	    var req = transport.request(options, function handleResponse(res) {
	      if (req.aborted) return;

	      // uncompress the response body transparently if required
	      var stream = res;

	      // return the last request in case of redirects
	      var lastRequest = res.req || req;


	      // if no content, is HEAD request or decompress disabled we should not decompress
	      if (res.statusCode !== 204 && lastRequest.method !== 'HEAD' && config.decompress !== false) {
	        switch (res.headers['content-encoding']) {
	        /*eslint default-case:0*/
	        case 'gzip':
	        case 'compress':
	        case 'deflate':
	        // add the unzipper to the body stream processing pipeline
	          stream = stream.pipe(zlib.createUnzip());

	          // remove the content-encoding in order to not confuse downstream operations
	          delete res.headers['content-encoding'];
	          break;
	        }
	      }

	      var response = {
	        status: res.statusCode,
	        statusText: res.statusMessage,
	        headers: res.headers,
	        config: config,
	        request: lastRequest
	      };

	      if (config.responseType === 'stream') {
	        response.data = stream;
	        settle(resolve, reject, response);
	      } else {
	        var responseBuffer = [];
	        var totalResponseBytes = 0;
	        stream.on('data', function handleStreamData(chunk) {
	          responseBuffer.push(chunk);
	          totalResponseBytes += chunk.length;

	          // make sure the content length is not over the maxContentLength if specified
	          if (config.maxContentLength > -1 && totalResponseBytes > config.maxContentLength) {
	            stream.destroy();
	            reject(createError('maxContentLength size of ' + config.maxContentLength + ' exceeded',
	              config, null, lastRequest));
	          }
	        });

	        stream.on('error', function handleStreamError(err) {
	          if (req.aborted) return;
	          reject(enhanceError(err, config, null, lastRequest));
	        });

	        stream.on('end', function handleStreamEnd() {
	          var responseData = Buffer.concat(responseBuffer);
	          if (config.responseType !== 'arraybuffer') {
	            responseData = responseData.toString(config.responseEncoding);
	            if (!config.responseEncoding || config.responseEncoding === 'utf8') {
	              responseData = utils.stripBOM(responseData);
	            }
	          }

	          response.data = responseData;
	          settle(resolve, reject, response);
	        });
	      }
	    });

	    // Handle errors
	    req.on('error', function handleRequestError(err) {
	      if (req.aborted && err.code !== 'ERR_FR_TOO_MANY_REDIRECTS') return;
	      reject(enhanceError(err, config, null, req));
	    });

	    // Handle request timeout
	    if (config.timeout) {
	      // This is forcing a int timeout to avoid problems if the `req` interface doesn't handle other types.
	      var timeout = parseInt(config.timeout, 10);

	      if (isNaN(timeout)) {
	        reject(createError(
	          'error trying to parse `config.timeout` to int',
	          config,
	          'ERR_PARSE_TIMEOUT',
	          req
	        ));

	        return;
	      }

	      // Sometime, the response will be very slow, and does not respond, the connect event will be block by event loop system.
	      // And timer callback will be fired, and abort() will be invoked before connection, then get "socket hang up" and code ECONNRESET.
	      // At this time, if we have a large number of request, nodejs will hang up some socket on background. and the number will up and up.
	      // And then these socket which be hang up will devoring CPU little by little.
	      // ClientRequest.setTimeout will be fired on the specify milliseconds, and can make sure that abort() will be fired after connect.
	      req.setTimeout(timeout, function handleRequestTimeout() {
	        req.abort();
	        reject(createError(
	          'timeout of ' + timeout + 'ms exceeded',
	          config,
	          config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
	          req
	        ));
	      });
	    }

	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (req.aborted) return;

	        req.abort();
	        reject(cancel);
	      });
	    }

	    // Send the request
	    if (utils.isStream(data)) {
	      data.on('error', function handleStreamError(err) {
	        reject(enhanceError(err, config, null, req));
	      }).pipe(req);
	    } else {
	      req.end(data);
	    }
	  });
	};
	return http_1;
}

var utils$5 = utils$9;
var normalizeHeaderName = normalizeHeaderName$1;
var enhanceError = enhanceError$1;

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils$5.isUndefined(headers) && utils$5.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = requireXhr();
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = requireHttp();
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils$5.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$5.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults$3 = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils$5.isFormData(data) ||
      utils$5.isArrayBuffer(data) ||
      utils$5.isBuffer(data) ||
      utils$5.isStream(data) ||
      utils$5.isFile(data) ||
      utils$5.isBlob(data)
    ) {
      return data;
    }
    if (utils$5.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$5.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils$5.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils$5.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults$3.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils$5.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults$3.headers[method] = {};
});

utils$5.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults$3.headers[method] = utils$5.merge(DEFAULT_CONTENT_TYPE);
});

var defaults_1 = defaults$3;

var utils$4 = utils$9;
var defaults$2 = defaults_1;

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
var transformData$1 = function transformData(data, headers, fns) {
  var context = this || defaults$2;
  /*eslint no-param-reassign:0*/
  utils$4.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};

var isCancel$1;
var hasRequiredIsCancel;

function requireIsCancel () {
	if (hasRequiredIsCancel) return isCancel$1;
	hasRequiredIsCancel = 1;

	isCancel$1 = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};
	return isCancel$1;
}

var utils$3 = utils$9;
var transformData = transformData$1;
var isCancel = requireIsCancel();
var defaults$1 = defaults_1;

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
var dispatchRequest$1 = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils$3.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils$3.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults$1.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

var utils$2 = utils$9;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
var mergeConfig$2 = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils$2.isPlainObject(target) && utils$2.isPlainObject(source)) {
      return utils$2.merge(target, source);
    } else if (utils$2.isPlainObject(source)) {
      return utils$2.merge({}, source);
    } else if (utils$2.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$2.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils$2.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils$2.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils$2.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils$2.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils$2.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils$2.forEach(otherKeys, mergeDeepProperties);

  return config;
};

var pkg = require$$0;

var validators$1 = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators$1[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators$1.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

var validator$1 = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators$1
};

var utils$1 = utils$9;
var buildURL = buildURL$1;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var validator = validator$1;

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios$1.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig$1(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios$1.prototype.getUri = function getUri(config) {
  config = mergeConfig$1(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils$1.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios$1.prototype[method] = function(url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils$1.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios$1.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig$1(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

var Axios_1 = Axios$1;

var Cancel_1;
var hasRequiredCancel;

function requireCancel () {
	if (hasRequiredCancel) return Cancel_1;
	hasRequiredCancel = 1;

	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}

	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};

	Cancel.prototype.__CANCEL__ = true;

	Cancel_1 = Cancel;
	return Cancel_1;
}

var CancelToken_1;
var hasRequiredCancelToken;

function requireCancelToken () {
	if (hasRequiredCancelToken) return CancelToken_1;
	hasRequiredCancelToken = 1;

	var Cancel = requireCancel();

	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }

	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });

	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }

	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}

	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};

	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};

	CancelToken_1 = CancelToken;
	return CancelToken_1;
}

var spread;
var hasRequiredSpread;

function requireSpread () {
	if (hasRequiredSpread) return spread;
	hasRequiredSpread = 1;

	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	spread = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};
	return spread;
}

var isAxiosError;
var hasRequiredIsAxiosError;

function requireIsAxiosError () {
	if (hasRequiredIsAxiosError) return isAxiosError;
	hasRequiredIsAxiosError = 1;

	/**
	 * Determines whether the payload is an error thrown by Axios
	 *
	 * @param {*} payload The value to test
	 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
	 */
	isAxiosError = function isAxiosError(payload) {
	  return (typeof payload === 'object') && (payload.isAxiosError === true);
	};
	return isAxiosError;
}

var utils = utils$9;
var bind = bind$2;
var Axios = Axios_1;
var mergeConfig = mergeConfig$2;
var defaults = defaults_1;

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios$2 = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios$2.Axios = Axios;

// Factory for creating new instances
axios$2.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios$2.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios$2.Cancel = requireCancel();
axios$2.CancelToken = requireCancelToken();
axios$2.isCancel = requireIsCancel();

// Expose all/spread
axios$2.all = function all(promises) {
  return Promise.all(promises);
};
axios$2.spread = requireSpread();

// Expose isAxiosError
axios$2.isAxiosError = requireIsAxiosError();

axios$3.exports = axios$2;

// Allow use of default import syntax in TypeScript
axios$3.exports.default = axios$2;

var axiosExports = axios$3.exports;

var axios = axiosExports;

var axios$1 = /*@__PURE__*/getDefaultExportFromCjs(axios);

var ItemListContext = createContext(undefined);
var useItemList = function () {
    var context = useContext(ItemListContext);
    if (context === undefined) {
        throw new Error('useItemList must be used within an ItemListProvider');
    }
    return context;
};
var ItemListProvider = function (_a) {
    var children = _a.children, _b = _a.initialItemList, initialItemList = _b === void 0 ? [] : _b;
    var _c = useState(new Set(initialItemList)), globalItemList = _c[0], setGlobalItemList = _c[1];
    var addToItemList = function (items) {
        setGlobalItemList(function (prev) {
            var newSet = new Set(prev);
            items.forEach(function (item) { return newSet.add(item); });
            return newSet;
        });
    };
    var removeFromItemList = function (items) {
        setGlobalItemList(function (prev) {
            var newSet = new Set(prev);
            items.forEach(function (item) { return newSet["delete"](item); });
            return newSet;
        });
    };
    var resetItemList = function (originalItems) {
        setGlobalItemList(new Set(originalItems));
    };
    var getItemListAsArray = function () {
        return Array.from(globalItemList);
    };
    var value = {
        globalItemList: globalItemList,
        setGlobalItemList: setGlobalItemList,
        addToItemList: addToItemList,
        removeFromItemList: removeFromItemList,
        resetItemList: resetItemList,
        getItemListAsArray: getItemListAsArray
    };
    return (React__default.createElement(ItemListContext.Provider, { value: value }, children));
};

var ChildQuestionMainWrapper = defaultStyled.div(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.625rem;\n  width: 100%;\n  margin-bottom: 1.25rem;\n\n  ", "\n\n  .child-element {\n    width: 100%;\n  }\n\n  p {\n    margin-bottom: 0px;\n  }\n"], ["\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.625rem;\n  width: 100%;\n  margin-bottom: 1.25rem;\n\n  ", "\n\n  .child-element {\n    width: 100%;\n  }\n\n  p {\n    margin-bottom: 0px;\n  }\n"])), function (_a) {
    var $itemLevel = _a.$itemLevel;
    return $itemLevel &&
        "\n      padding-left: 1rem;\n      padding-right: 1rem;\n\n      .item-sub-tiered-rating:last-child {\n        border-bottom: none;\n      }\n  ";
});
var ItemWrap = defaultStyled.div(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n  padding: 0.75rem 0.625rem;\n  background: var(--indian-red);\n  width: 100%;\n  border-radius: 10px;\n\n  .item-count {\n    margin-bottom: 0.625rem;\n  }\n"], ["\n  padding: 0.75rem 0.625rem;\n  background: var(--indian-red);\n  width: 100%;\n  border-radius: 10px;\n\n  .item-count {\n    margin-bottom: 0.625rem;\n  }\n"])));
var QuestionBlockWrap = defaultStyled.div(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject(["\n  margin-bottom: ", ";\n\n  ", "\n"], ["\n  margin-bottom: ", ";\n\n  ", "\n"])), function (_a) {
    var $margin = _a.$margin;
    return $margin;
}, function (_a) {
    var $itemLevel = _a.$itemLevel;
    return $itemLevel &&
        "\n      border-radius: 10px;\n      border-left: 1px solid #eaeaea;\n      border-right: 1px solid #eaeaea;\n      border-bottom: 1px solid #eaeaea;\n  ";
});
var getChildRatingQuestion = function (originQuestionId, page, editorMode, visibleQuestionsRecord) {
    var _a, _b;
    if (!originQuestionId)
        return [];
    return (((_b = (_a = page === null || page === void 0 ? void 0 : page.questions) === null || _a === void 0 ? void 0 : _a.filter(function (eachQuestion) { return (eachQuestion === null || eachQuestion === void 0 ? void 0 : eachQuestion.parentQuestionId) === originQuestionId; })) === null || _b === void 0 ? void 0 : _b.filter(function (question) {
        if (!editorMode &&
            visibleQuestionsRecord &&
            lodashExports.has(visibleQuestionsRecord, question === null || question === void 0 ? void 0 : question.originQuestionId) &&
            !visibleQuestionsRecord[question.originQuestionId]) {
            return false;
        }
        return true;
    })) || []);
};
var uploadImage = function (_a) {
    var uploadRequest = _a.uploadRequest, options = _a.options, question = _a.question, setImageUploadLoader = _a.setImageUploadLoader, onChangeHandler = _a.onChangeHandler;
    return __awaiter(void 0, void 0, void 0, function () {
        var onSuccess, onError, file, fmData, config, result, newFileObj, err_1;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!(uploadRequest === null || uploadRequest === void 0 ? void 0 : uploadRequest.url)) return [3 /*break*/, 4];
                    setImageUploadLoader(true);
                    onSuccess = options.onSuccess, onError = options.onError, file = options.file;
                    fmData = new FormData();
                    config = {
                        headers: { 'content-type': 'multipart/form-data', 'req-scope': 'MH-CP' }
                    };
                    fmData.append('media', file);
                    fmData.append('type', 'survey');
                    fmData.append('surveyId', uploadRequest.surveyId);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios$1.post(uploadRequest.url, fmData, config)];
                case 2:
                    result = _c.sent();
                    newFileObj = __assign(__assign({}, result === null || result === void 0 ? void 0 : result.data), { name: file.name, size: file.size, thumbUrl: (_b = result === null || result === void 0 ? void 0 : result.data) === null || _b === void 0 ? void 0 : _b.mediaUrl });
                    onChangeHandler(question, [newFileObj]);
                    onSuccess('Ok');
                    setImageUploadLoader(false);
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _c.sent();
                    onError({ err: err_1 });
                    setImageUploadLoader(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
};
var getVisibleQuestions = function (page, editorMode, visibleQuestionsRecord, pages, surveySetting, ratingSelected, globalItemListArr) {
    var _a, _b;
    var visibleQuestions = ((_a = page === null || page === void 0 ? void 0 : page.questions) === null || _a === void 0 ? void 0 : _a.filter(function (question) {
        if (!editorMode &&
            surveySetting &&
            (lodashExports.isEqual(surveySetting === null || surveySetting === void 0 ? void 0 : surveySetting.template, SURVEY_TEMPLATES.FEW_CLICK_FEEDBACK_SURVEY) ||
                lodashExports.isEqual(surveySetting === null || surveySetting === void 0 ? void 0 : surveySetting.template, SURVEY_TEMPLATES.STD_FEEDBACK_SURVEY)) &&
            pages) {
            var ratingDependency = showQuestionField(question, 'rating_dependency', true);
            var showOnPositiveRating = showQuestionField(question, 'show_question_if_rating', true) ||
                getFieldQuestionValue(question, 'show_question_if_rating');
            if (ratingDependency) {
                if (showOnPositiveRating && !isCurrentRatingIsUnderRange(pages, surveySetting.positiveRating, 'ratings')) {
                    return false;
                }
                else if (!showOnPositiveRating &&
                    !isCurrentRatingIsUnderRange(pages, surveySetting.negativeRating, 'ratings')) {
                    return false;
                }
                else if (!ratingSelected) {
                    return false;
                }
            }
            var serviceTypeDependency = showQuestionField(question, 'service_type_dependency', true);
            if (serviceTypeDependency && !isServiceTypeMatchingQuestion(pages, question))
                return false;
        }
        if (!editorMode &&
            visibleQuestionsRecord &&
            lodashExports.has(visibleQuestionsRecord, question === null || question === void 0 ? void 0 : question.originQuestionId) &&
            !visibleQuestionsRecord[question.originQuestionId]) {
            return false;
        }
        return true;
    })) || [];
    var isItemPage = ((_b = page.questions) === null || _b === void 0 ? void 0 : _b.some(function (q) { return q.questionType === 'item_tiered_rating'; })) || false;
    console.log("visibleQuestions Before: ", visibleQuestions);
    if (isItemPage && pages) {
        // We can't use hooks here since this is not a React component
        // Instead, we should pass the itemList as a prop from the parent component
        globalItemListArr = globalItemListArr ? globalItemListArr : [];
        console.log("globalItemListArr: ", globalItemListArr);
        // Get all previous pages up to current page
        var currentPageIndex = pages.findIndex(function (p) { return p.pageKey === page.pageKey; });
        var previousPages = pages.slice(0, currentPageIndex + 1);
        // Find all questions with v1QuestionConfigString 'item_list' from previous pages
        var itemListQuestions = previousPages.reduce(function (acc, page) {
            var _a;
            var itemListQs = ((_a = page.questions) === null || _a === void 0 ? void 0 : _a.filter(function (q) { return q.v1QuestionConfigString === 'item_list'; })) || [];
            return __spreadArray(__spreadArray([], acc, true), itemListQs, true);
        }, []);
        console.log("itemListQuestions: ", itemListQuestions);
        // fetch all the itemQuestions from pages array and get the selectedValue from itemListQuestions.id
        // Get selected values for item list questions
        var itemListSelectedValues = itemListQuestions.reduce(function (acc, question) {
            var _a, _b;
            if (question.questionType !== 'multiple-choice') {
                return acc;
            }
            var questionId = question.id;
            // Find the page containing this question
            var containingPage = pages.find(function (p) { var _a; return (_a = p.questions) === null || _a === void 0 ? void 0 : _a.some(function (q) { return q.id === questionId; }); });
            // Get selected value if it exists
            if ((_a = containingPage === null || containingPage === void 0 ? void 0 : containingPage.selectedValue) === null || _a === void 0 ? void 0 : _a[questionId]) {
                return __spreadArray(__spreadArray([], acc, true), [(_b = containingPage.selectedValue[questionId]) === null || _b === void 0 ? void 0 : _b.value], false);
            }
            return acc;
        }, []);
        console.log("itemListSelectedValues: ", itemListSelectedValues);
        // Merge with global item list, removing duplicates
        globalItemListArr = globalItemListArr.concat(itemListSelectedValues);
        var finalItemList_1 = lodashExports.flatMap(globalItemListArr);
        console.log("finalItemList: ", finalItemList_1);
        //loop over page.questions
        // if item_tiered_rating append itemName from finalItemList
        // remove questions which are item_tiered_rating and no itemName
        // Map through questions and add itemName for item_tiered_rating questions
        var int_1 = 0;
        var updatedQuestions = visibleQuestions === null || visibleQuestions === void 0 ? void 0 : visibleQuestions.map(function (question) {
            if (question.questionType === 'item_tiered_rating') {
                // Find matching item from finalItemList
                var matchingItem = finalItemList_1[int_1];
                int_1++;
                if (matchingItem) {
                    return __assign(__assign({}, question), { itemName: matchingItem });
                }
            }
            return question;
        });
        // Filter out item_tiered_rating questions that don't have an itemName
        var filteredQuestions = updatedQuestions === null || updatedQuestions === void 0 ? void 0 : updatedQuestions.filter(function (question) {
            if (question.questionType === 'item_tiered_rating') {
                return question.itemName;
            }
            return true;
        });
        // Update the page questions
        visibleQuestions = filteredQuestions || [];
        // Filter out item_sub_tiered_rating questions whose parent is not in visibleQuestions
        visibleQuestions = visibleQuestions.filter(function (question) {
            if (question.questionType === 'item_sub_tiered_rating') {
                // Keep only if parent question exists in visibleQuestions
                return visibleQuestions.some(function (q) { return q.originQuestionId === question.parentQuestionId; });
            }
            return true;
        });
    }
    console.log("visibleQuestions After: ", visibleQuestions);
    return groupChildQuestionsWithParent(visibleQuestions);
};
var renderElement = function (question, index, isSkipAbleElement, canAutoJumpToNextPage, page, pages, surveySetting, editorMode, theme, showError, questionsValue, invalidQuestions, ratingSelected, onChangeHandler, trackEvent, visibleQuestionsRecord, uploadImageOptions, voucherData, expressParams, voucherIdsMetadata) {
    var _a, _b, _c;
    var questionLabel = getFieldQuestionValue(question, 'label');
    var showQuestionLabel = showQuestionField(question, 'input_list_caption', true);
    var questionCaptions = getFieldQuestionValue(question, 'input_list_caption');
    var childQuestions = getChildRatingQuestion(question.originQuestionId, page, editorMode, visibleQuestionsRecord);
    var childQuestionMainTitle = getFieldQuestionValue(question, 'child_question_label');
    var showChildQuestionMainTitle = showQuestionField(question, 'child_question_label', false);
    var isNonQuestionType = (question === null || question === void 0 ? void 0 : question.isNonQuestionType) || false;
    var uploadButtonLabel = getFieldQuestionValue(question, 'upload_btn_label');
    var voucherList = getFieldQuestionValue(question, 'voucher_list');
    var noOfferPayload = {
        show: showQuestionField(question, 'no_offer_label', true),
        label: getFieldQuestionValue(question, 'no_offer_label')
    };
    if (isNonQuestionType) {
        return (React__default.createElement(RenderElement, { type: question.questionType, showElement: showQuestionField(question, 'label'), label: questionLabel, key: "".concat(question.id, "-").concat(index), question: question, editorMode: editorMode, expressParams: expressParams }));
    }
    var renderChildQuestion = function () {
        return childQuestions === null || childQuestions === void 0 ? void 0 : childQuestions.map(function (childQuestion, childIndex) {
            var _a;
            return renderElement(childQuestion, childIndex + 1, lodashExports.isEqual(childQuestion === null || childQuestion === void 0 ? void 0 : childQuestion.originQuestionId, (_a = lodashExports.last(getVisibleQuestions(page, editorMode, visibleQuestionsRecord, pages))) === null || _a === void 0 ? void 0 : _a.originQuestionId), canAutoJumpToNextPage, page, pages, surveySetting, editorMode, theme, showError, questionsValue, invalidQuestions, ratingSelected, onChangeHandler, trackEvent, visibleQuestionsRecord, uploadImageOptions, voucherData, expressParams, voucherIdsMetadata);
        });
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(RenderQuestion, { onChange: function (value) {
                onChangeHandler(question, value, isSkipAbleElement && canAutoJumpToNextPage);
            }, onTrackEvent: function () {
                trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent({
                    action: 'CLICK',
                    label: "SURVEY.CUSTOM_PAGE.".concat(lodashExports.snakeCase(questionLabel || question.questionType).toUpperCase())
                });
            }, type: question.questionType, value: (_a = questionsValue === null || questionsValue === void 0 ? void 0 : questionsValue[question.id]) === null || _a === void 0 ? void 0 : _a.value, label: questionLabel, showLabel: showQuestionField(question, 'label'), ratingType: getFieldQuestionValue(question, 'rating_type'), required: getFieldQuestionRequired(question, 'required'), showError: showError && invalidQuestions[question.id], dropdownOptions: ((_b = getFieldQuestionValue(question, 'options')) === null || _b === void 0 ? void 0 : _b.map(function (option) { return ({
                value: option,
                label: option
            }); })) || [], multipleChoiceOptions: ((_c = getFieldQuestionValue(question, 'options')) === null || _c === void 0 ? void 0 : _c.map(function (option) { return ({
                text: option,
                iconName: ''
            }); })) || [], pictureSelectionOptions: getFieldQuestionValue(question, 'options'), showImageUploadLoader: !!(uploadImageOptions === null || uploadImageOptions === void 0 ? void 0 : uploadImageOptions.showImageUploadLoader), uploadImage: function (options) {
                return uploadImageOptions
                    ? uploadImage({
                        uploadRequest: uploadImageOptions === null || uploadImageOptions === void 0 ? void 0 : uploadImageOptions.uploadRequest,
                        options: options,
                        question: question,
                        setImageUploadLoader: uploadImageOptions === null || uploadImageOptions === void 0 ? void 0 : uploadImageOptions.setImageUploadLoader,
                        onChangeHandler: uploadImageOptions === null || uploadImageOptions === void 0 ? void 0 : uploadImageOptions.onChangeHandler
                    })
                    : null;
            }, theme: theme, errorMessage: 'this field is required', uploadButtonLabel: uploadButtonLabel, key: "".concat(question.id, "-").concat(index), showQuestionLabel: showQuestionLabel || false, questionCaptions: questionCaptions || [], voucherList: voucherList, vouchersData: voucherData, noOfferPayload: noOfferPayload, singleMultipleChoiceListPrefix: getFieldQuestionValue(question, 'single_multiple_choice_prefix'), voucherIdsMetadata: voucherIdsMetadata }),
        (childQuestions === null || childQuestions === void 0 ? void 0 : childQuestions.length) ? (React__default.createElement(ChildQuestionMainWrapper, { "$itemLevel": lodashExports.isEqual(question.questionType, QUESTION_TYPE_KEYS.ITEM_TIERED_RATING) },
            showChildQuestionMainTitle ? (React__default.createElement(RenderElement, { type: 'h5text', label: childQuestionMainTitle, key: "sub-title-".concat(index), className: "mb-0", editorMode: editorMode, expressParams: expressParams })) : null,
            renderChildQuestion())) : (React__default.createElement(React__default.Fragment, null))));
};
var renderCustomQuestion = function (_a) {
    var page = _a.page, pages = _a.pages, surveySetting = _a.surveySetting, editorMode = _a.editorMode, theme = _a.theme, showError = _a.showError, questionsValue = _a.questionsValue, invalidQuestions = _a.invalidQuestions, _b = _a.ratingSelected, ratingSelected = _b === void 0 ? true : _b, onChangeHandler = _a.onChangeHandler, trackEvent = _a.trackEvent, visibleQuestionsRecord = _a.visibleQuestionsRecord, uploadImageOptions = _a.uploadImageOptions, vouchersData = _a.vouchersData, expressParams = _a.expressParams; _a.globalSelectedFactMap; var voucherIdsMetadata = _a.voucherIdsMetadata;
    // Use global itemList context
    var getItemListAsArray = useItemList().getItemListAsArray;
    var globalItemListArr = getItemListAsArray();
    var visibleQuestions = getVisibleQuestions(page, editorMode, visibleQuestionsRecord, pages, surveySetting, ratingSelected, globalItemListArr);
    var _c = computeCanGoToNextPage(__spreadArray([], visibleQuestions, true)), lastQuestion = _c.lastQuestion, canGoToNextPage = _c.canGoToNextPage;
    var excludedChildVisibleQuestions = visibleQuestions.filter(function (eachQuestion) { return !(eachQuestion === null || eachQuestion === void 0 ? void 0 : eachQuestion.parentQuestionId); });
    var canAutoJumpToNextPage = !lodashExports.isEmpty(page === null || page === void 0 ? void 0 : page.selectedValue) || showError ? false : canGoToNextPage;
    console.log("canAutoJumpToNextPage: ", canAutoJumpToNextPage);
    // For item pages with no visible questions, trigger auto-jump
    // const isItemPage = page.questions?.some(q => q.questionType === 'item_tiered_rating') || false;
    // if (isItemPage && isEmpty(visibleQuestions) && canAutoJumpToNextPage) {
    //     if(canAutoJumpToNextPage) {
    //       canAutoJumpToNextPage = !canAutoJumpToNextPage;
    //     }
    // }
    return {
        renderedCustomVisibleQuestions: excludedChildVisibleQuestions === null || excludedChildVisibleQuestions === void 0 ? void 0 : excludedChildVisibleQuestions.map(function (question, index) {
            return (React__default.createElement(QuestionBlockWrap, { "data-testId": "".concat(index, "-").concat(question.id), key: "".concat(question.id, "-").concat(index), "$itemLevel": lodashExports.isEqual(question.questionType, QUESTION_TYPE_KEYS.ITEM_TIERED_RATING), "data-question-type": question.questionType, "$margin": lodashExports.isEqual(excludedChildVisibleQuestions.length - 1, index) ? '0px' : '1.875rem' },
                question.itemName && (React__default.createElement(ItemWrap, { className: 'theme-bg' },
                    React__default.createElement("div", { className: "item-count" },
                        React__default.createElement(Text$1.B2, { semibold: true }, "".concat(index + 1, "/").concat(excludedChildVisibleQuestions.length))),
                    React__default.createElement(Text$1.H3, null, question.itemName))),
                renderElement(question, index, lodashExports.isEqual(question === null || question === void 0 ? void 0 : question.originQuestionId, lastQuestion === null || lastQuestion === void 0 ? void 0 : lastQuestion.originQuestionId), canAutoJumpToNextPage, page, pages, surveySetting, editorMode, theme, showError, questionsValue, invalidQuestions, ratingSelected, onChangeHandler, trackEvent, visibleQuestionsRecord, uploadImageOptions, vouchersData, expressParams, voucherIdsMetadata)));
        }),
        customVisibleQuestions: visibleQuestions,
        canShowNextButton: !canAutoJumpToNextPage
    };
};
var templateObject_1$8, templateObject_2$8, templateObject_3$6;

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */

function isNil(value) {
  return value == null;
}

var isNil_1 = isNil;

var isNil$1 = /*@__PURE__*/getDefaultExportFromCjs(isNil_1);

/** Used for built-in method references. */

var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas$1(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

var _baseHas = baseHas$1;

var baseHas = _baseHas,
    hasPath = _hasPath;

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

var has_1 = has;

var has$1 = /*@__PURE__*/getDefaultExportFromCjs(has_1);

var RatingWrap$1 = defaultStyled.div(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  text-align: center;\n  margin-bottom: 1.25rem;\n\n  ul {\n    width: ", ";\n  }\n\n  .emoji-container {\n    text-align: center;\n    justify-content: center;\n  }\n"], ["\n  text-align: center;\n  margin-bottom: 1.25rem;\n\n  ul {\n    width: ", ";\n  }\n\n  .emoji-container {\n    text-align: center;\n    justify-content: center;\n  }\n"])), function (_a) {
    var $containerWidth = _a.$containerWidth;
    return $containerWidth;
});
var ErrorMsg$4 = defaultStyled(Text$1.B2)(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n  color: var(--indian-red);\n"], ["\n  color: var(--indian-red);\n"])));
var RatingsPage = function (_a) {
    var page = _a.page, onNextPage = _a.onNextPage, trackEvent = _a.trackEvent, pages = _a.pages, surveySetting = _a.surveySetting, editorMode = _a.editorMode, theme = _a.theme, visibleQuestionsMap = _a.visibleQuestionsMap, allQuestionsRulesFromEngine = _a.allQuestionsRulesFromEngine, selectedValueFactMap = _a.selectedValueFactMap, uploadRequest = _a.uploadRequest, expressParams = _a.expressParams;
    var allowThemeInvert = (theme === null || theme === void 0 ? void 0 : theme.layout) !== 'box';
    var _b = useState(visibleQuestionsMap || {}), visibleQuestionsRecord = _b[0], setVisibleQuestionsRecord = _b[1];
    var _c = useState(selectedValueFactMap), selectedFactMap = _c[0], setSelectedFactMap = _c[1];
    var _d = useState(false), selected = _d[0], setSelected = _d[1];
    var _e = useState(null), selectedRating = _e[0], setSelectedRating = _e[1];
    var _f = useState({}), questionsValue = _f[0], setQuestionsValue = _f[1];
    var _g = useState({}), invalidQuestions = _g[0], setInvalidQuestions = _g[1];
    var _h = useState(false), canSubmitPage = _h[0], setCanSubmitPage = _h[1];
    var _j = useState(false), showError = _j[0], setShowError = _j[1];
    var _k = useState(false), showImageUploadLoader = _k[0], setImageUploadLoader = _k[1];
    useEffect(function () {
        setVisibleQuestionsRecord(__assign(__assign({}, visibleQuestionsRecord), visibleQuestionsMap));
    }, [visibleQuestionsMap]);
    useEffect(function () {
        setSelectedFactMap(selectedValueFactMap);
    }, [selectedValueFactMap]);
    useEffect(function () {
        var _a, _b, _c, _d;
        if (page === null || page === void 0 ? void 0 : page.selectedValue) {
            var questionsVal_1 = {};
            Object.keys(page === null || page === void 0 ? void 0 : page.selectedValue).map(function (eachQuestionKey) {
                var _a;
                var _b;
                questionsVal_1 = __assign(__assign({}, questionsVal_1), (_a = {}, _a[eachQuestionKey] = (_b = page === null || page === void 0 ? void 0 : page.selectedValue) === null || _b === void 0 ? void 0 : _b[eachQuestionKey], _a));
            });
            setQuestionsValue(questionsVal_1);
            if (surveySetting.template === SURVEY_TEMPLATES.STD_FEEDBACK_SURVEY_V2) {
                setSelectedRating((page === null || page === void 0 ? void 0 : page.selectedValue.value) || ((_b = (_a = page === null || page === void 0 ? void 0 : page.selectedValue) === null || _a === void 0 ? void 0 : _a.rating) === null || _b === void 0 ? void 0 : _b.value));
            }
            else {
                setSelectedRating((_d = (_c = page === null || page === void 0 ? void 0 : page.selectedValue) === null || _c === void 0 ? void 0 : _c.rating) === null || _d === void 0 ? void 0 : _d.value);
            }
        }
    }, [page]);
    useEffect(function () {
        scrollToErrorElement();
    }, [showError]);
    var onChangeHandler = function (question, value, canSubmitPageStatus) {
        var _a, _b, _c, _d, _e, _f;
        if (canSubmitPageStatus === void 0) { canSubmitPageStatus = false; }
        var isChoiceType = includes$1(['multiple-choice', 'picture-selection', 'upload'], question.questionType);
        var isValueEmpty = isChoiceType ? lodashExports.isEmpty(value) : isNil$1(value);
        // Check if the value is empty
        if (isValueEmpty) {
            // Retrieve the required status of the question
            var isQuestionRequired = getFieldQuestionRequired(question, 'required');
            // If the question is required and the value is empty, mark it as invalid
            if (isQuestionRequired) {
                setInvalidQuestions(__assign(__assign({}, invalidQuestions), (_a = {}, _a[question.id] = true, _a)));
            }
        }
        else {
            // If the value is not empty, mark the question as valid
            setInvalidQuestions(__assign(__assign({}, invalidQuestions), (_b = {}, _b[question.id] = false, _b)));
        }
        var questionType = EXTRACT_DETAILED_QUESTION_TYPE.includes(question.questionType)
            ? getFieldQuestionValue(question, 'rating_type')
            : question.questionType;
        if (!editorMode && surveySetting.template === SURVEY_TEMPLATES.STD_FEEDBACK_SURVEY_V2) {
            var selectedValue = value;
            var factKey = (question === null || question === void 0 ? void 0 : question.originQuestionId) + '_value';
            if (question.questionType === 'picture-selection') {
                selectedValue = value.value;
            }
            var updatedSelectedFactMap_1 = __assign(__assign({}, selectedFactMap), (_c = {}, _c[factKey] = selectedValue, _c));
            getQuestionsVisibleStatus({
                page: page,
                factMap: updatedSelectedFactMap_1,
                allQuestionsRulesFromEngine: allQuestionsRulesFromEngine
            }).then(function (updatedVisibleQuestionsRecord) {
                setVisibleQuestionsRecord(updatedVisibleQuestionsRecord);
                setSelectedFactMap(updatedSelectedFactMap_1);
                if (!canSubmitPageStatus) {
                    var updatedVisibleQuestions = getVisibleQuestions(page, editorMode, updatedVisibleQuestionsRecord);
                    var _a = computeCanGoToNextPage(__spreadArray([], updatedVisibleQuestions, true)), lastQuestion = _a.lastQuestion, canGoToNextPage = _a.canGoToNextPage;
                    var canAutoJumpToNextPage = !lodashExports.isEmpty(page === null || page === void 0 ? void 0 : page.selectedValue) || showError ? false : canGoToNextPage;
                    if (lodashExports.isEqual(surveySetting.template, SURVEY_TEMPLATES.STD_FEEDBACK_SURVEY_V2) &&
                        canAutoJumpToNextPage &&
                        lastQuestion &&
                        has$1(questionsValue, lastQuestion === null || lastQuestion === void 0 ? void 0 : lastQuestion.originQuestionId)) {
                        setCanSubmitPage(!canSubmitPageStatus);
                    }
                }
                setCanSubmitPage(canSubmitPageStatus);
            });
            if (question.id === question.originQuestionId) {
                setQuestionsValue(__assign(__assign({}, questionsValue), (_d = {}, _d[question.id] = {
                    value: value,
                    questionType: questionType,
                    isMasterQuestion: question.isMasterQuestion
                }, _d)));
            }
            else {
                setQuestionsValue(__assign(__assign({}, questionsValue), (_e = {}, _e[question.id] = {
                    value: value,
                    questionType: questionType,
                    isMasterQuestion: question.isMasterQuestion
                }, _e[question.originQuestionId] = {
                    value: value,
                    questionType: questionType,
                    isMasterQuestion: question.isMasterQuestion,
                    questionIdType: 'origin-question-id',
                    generatedQuestionId: question.id
                }, _e)));
            }
        }
        else {
            setQuestionsValue(__assign(__assign({}, questionsValue), (_f = {}, _f[question.id] = {
                value: value,
                questionType: questionType,
                isMasterQuestion: question.isMasterQuestion
            }, _f)));
        }
    };
    var renderRating = function (ratingType, captions) {
        var _a;
        var handleOnChange = function (value) {
            var _a;
            var _b;
            trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.RATINGS_SELECT_RATING);
            setInvalidQuestions(__assign(__assign({}, invalidQuestions), { mainRating: !value }));
            if (surveySetting.template === SURVEY_TEMPLATES.FEW_CLICK_FEEDBACK_SURVEY) {
                if (value != ((_b = questionsValue === null || questionsValue === void 0 ? void 0 : questionsValue.main) === null || _b === void 0 ? void 0 : _b.value)) {
                    setInvalidQuestions({});
                    setShowError(false);
                    setQuestionsValue({});
                }
                setSelected(true);
                setSelectedRating(value);
                setQuestionsValue(__assign(__assign({}, questionsValue), { main: { value: value, type: ratingType || RATING.STAR_1_10 } }));
                page.selectedValue = __assign(__assign({}, questionsValue), { main: { value: value, type: ratingType || RATING.STAR_1_10 } });
            }
            else if (surveySetting.template === SURVEY_TEMPLATES.STD_FEEDBACK_SURVEY_V2) {
                setSelected(true);
                setSelectedRating(value);
                if (!editorMode && surveySetting.template === SURVEY_TEMPLATES.STD_FEEDBACK_SURVEY_V2) {
                    var selectedValue = value;
                    var factKey = 'rating_value';
                    var updatedSelectedFactMap_2 = __assign(__assign({}, selectedFactMap), (_a = {}, _a[factKey] = selectedValue, _a));
                    getQuestionsVisibleStatus({
                        page: page,
                        factMap: updatedSelectedFactMap_2,
                        allQuestionsRulesFromEngine: allQuestionsRulesFromEngine
                    }).then(function (result) {
                        var hasQuestionToShow = Object.values(omit$1(result, 'rating')).some(function (isVisible) { return !!isVisible; });
                        if (!hasQuestionToShow && value) {
                            setTimeout(function () {
                                onNextPage({ rating: { value: value, type: ratingType || RATING.STAR_1_10 } }, updatedSelectedFactMap_2);
                            }, 500);
                        }
                        setVisibleQuestionsRecord(result);
                        setSelectedFactMap(updatedSelectedFactMap_2);
                    });
                }
                setQuestionsValue(__assign(__assign({}, questionsValue), { rating: { value: value, type: ratingType || RATING.STAR_1_10 } }));
            }
            else {
                // for std template
                if (!selected) {
                    setSelectedRating(value);
                    if (value) {
                        setSelected(true);
                        setTimeout(function () {
                            onNextPage({ value: value, type: ratingType || RATING.STAR_1_10 });
                        }, 500);
                    }
                }
            }
        };
        var RATING_COMPONENT = (_a = {},
            _a[RATING.THUMBS] = 'thumbs',
            _a[RATING.EMOJI] = 'emoji',
            _a[RATING.STAR_1_10] = 10,
            _a[RATING.STAR_1_5] = 5,
            _a[RATING.STAR_1_3] = 3,
            _a);
        return (React__default.createElement(Input.Rating, { type: RATING_COMPONENT[ratingType] || 10, onChange: function (val) {
                handleOnChange(val ? val : null);
            }, value: selectedRating, captions: captions }));
    };
    var handleSubmitPage = function () {
        var questionsValue_ = __assign({}, questionsValue);
        if (showError) {
            scrollToErrorElement();
        }
        // Initialize an object to keep track of invalid form fields
        var inValidFormFields = {};
        // Initialize a flag to track the overall validity of the form
        var validForm = true;
        var visibleQuestions = getVisibleQuestions(page, editorMode, visibleQuestionsRecord);
        // Iterate through each question on the page
        visibleQuestions.forEach(function (question) {
            var _a;
            var _b, _c;
            // Check if the question has a rating dependency
            var ratingDependency = showQuestionField(question, 'rating_dependency', true);
            var serviceTypeDependency = showQuestionField(question, 'service_type_dependency', true);
            // Check if the question should be shown based on positive rating
            var showOnPositiveRating = showQuestionField(question, 'show_question_if_rating', true) ||
                getFieldQuestionValue(question, 'show_question_if_rating');
            // Flag to determine if the question is visible
            var questionVisible = true;
            if (ratingDependency || serviceTypeDependency) {
                // Determine the rating range based on whether it should be shown on positive rating or not
                var ratingRange = showOnPositiveRating ? surveySetting.positiveRating : surveySetting.negativeRating;
                // Check if the current rating is under the specified range and the service type matches the question
                if (ratingDependency && serviceTypeDependency) {
                    questionVisible =
                        isCurrentRatingIsUnderRange(pages, ratingRange, 'ratings') &&
                            isServiceTypeMatchingQuestion(pages, question);
                }
                else if (ratingDependency) {
                    questionVisible = isCurrentRatingIsUnderRange(pages, ratingRange, 'ratings');
                }
                else if (serviceTypeDependency) {
                    questionVisible = isServiceTypeMatchingQuestion(pages, question);
                }
            }
            if (!questionVisible && !lodashExports.isEmpty(questionsValue_)) {
                delete questionsValue_[question.id];
            }
            if (question.questionType === 'upload' && ((_c = (_b = questionsValue[question.id]) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.length)) {
                questionsValue_[question.id] = __assign(__assign({}, questionsValue[question.id]), { value: JSON.stringify(questionsValue[question.id].value[0]) });
            }
            var isChoiceType = includes$1(['multiple-choice', 'single-choice', 'upload'], question.questionType);
            var questionValue = get$2(questionsValue, "[".concat(question.id, "].value"), null);
            var isValueEmpty = isChoiceType ? lodashExports.isEmpty(questionValue) : isNil$1(questionValue);
            // Check if the question is visible, required, and its value is empty
            if (questionVisible && getFieldQuestionRequired(question, 'required') && isValueEmpty) {
                // Mark the question as invalid in the inValidFormFields object
                inValidFormFields = __assign(__assign({}, inValidFormFields), (_a = {}, _a[question.id] = true, _a));
                // Set the validForm flag to false since an invalid question was found
                validForm = false;
            }
        });
        if (!selectedRating) {
            inValidFormFields['mainRating'] = true;
            validForm = false;
        }
        // Update the invalidQuestions state with the inValidFormFields object
        setInvalidQuestions(inValidFormFields);
        // If the form is not valid, show an error and return
        if (!validForm) {
            setShowError(true);
            return;
        }
        // Hide the error since the form is valid
        setShowError(false);
        if (surveySetting.template === SURVEY_TEMPLATES.STD_FEEDBACK_SURVEY_V2) {
            // Call the onNextPage function and pass the questionsValue as the argument
            onNextPage(questionsValue_, selectedFactMap);
        }
        else {
            onNextPage(questionsValue_);
        }
    };
    var _l = useMemo(function () {
        return renderCustomQuestion({
            page: page,
            pages: pages,
            editorMode: editorMode,
            surveySetting: surveySetting,
            theme: theme,
            onChangeHandler: onChangeHandler,
            questionsValue: questionsValue,
            invalidQuestions: invalidQuestions,
            showError: showError,
            trackEvent: trackEvent,
            ratingSelected: selectedRating ? true : false,
            visibleQuestionsRecord: visibleQuestionsRecord,
            uploadImageOptions: uploadRequest
                ? {
                    uploadRequest: uploadRequest,
                    setImageUploadLoader: setImageUploadLoader,
                    onChangeHandler: onChangeHandler,
                    showImageUploadLoader: showImageUploadLoader
                }
                : null,
            expressParams: expressParams
        });
    }, [
        selectedRating,
        questionsValue,
        invalidQuestions,
        showError,
        visibleQuestionsRecord,
        selectedFactMap,
        showImageUploadLoader,
        expressParams,
    ]), renderedCustomVisibleQuestions = _l.renderedCustomVisibleQuestions, _m = _l.customVisibleQuestions, customVisibleQuestions = _m === void 0 ? [] : _m, canShowNextButton = _l.canShowNextButton;
    useEffect(function () {
        if (canSubmitPage && !showError) {
            var _a = computeCanGoToNextPage(customVisibleQuestions), lastQuestion = _a.lastQuestion, canGoToNextPage = _a.canGoToNextPage;
            var canAutoJumpToNextPage = !lodashExports.isEmpty(page === null || page === void 0 ? void 0 : page.selectedValue) || showError ? false : canGoToNextPage;
            if (lodashExports.isEqual(surveySetting.template, SURVEY_TEMPLATES.STD_FEEDBACK_SURVEY_V2) &&
                canAutoJumpToNextPage &&
                lastQuestion &&
                has$1(questionsValue, lastQuestion === null || lastQuestion === void 0 ? void 0 : lastQuestion.originQuestionId)) {
                setTimeout(function () {
                    handleSubmitPage();
                }, 500);
            }
        }
    }, [canSubmitPage, surveySetting, customVisibleQuestions, questionsValue]);
    useEffect(function () {
        if (selectedRating) {
            if (lodashExports.isEqual(surveySetting.template, SURVEY_TEMPLATES.FEW_CLICK_FEEDBACK_SURVEY) &&
                lodashExports.isEmpty(customVisibleQuestions)) {
                setTimeout(function () {
                    onNextPage({ value: selectedRating, type: getFieldValue(page, 'rating_type') || RATING.STAR_1_10 });
                }, 500);
            }
        }
    }, [selectedRating, customVisibleQuestions, surveySetting]);
    var renderFloatingButton = function () {
        if (lodashExports.isEqual(surveySetting.template, SURVEY_TEMPLATES.STD_FEEDBACK_SURVEY_V2)) {
            return canShowNextButton && selectedRating ? React__default.createElement(FloatingBtn, { onClick: handleSubmitPage }) : null;
        }
        return selectedRating && !lodashExports.isEmpty(customVisibleQuestions) ? React__default.createElement(FloatingBtn, { onClick: handleSubmitPage }) : null;
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(BrandInfo, { page: page }),
        React__default.createElement("div", { className: "page-body" },
            React__default.createElement("div", { className: "page-content" },
                showField(page, 'title') && (React__default.createElement("div", { className: "page-title" },
                    React__default.createElement(Text$1.H2, { className: classNames({ 'bg-theme-allowed': allowThemeInvert }), semibold: true, dangerouslySetInnerHTML: { __html: getFieldValue(page, 'title') || '' } }))),
                React__default.createElement(RatingWrap$1, { "$containerWidth": surveySetting.template === SURVEY_TEMPLATES.FEW_CLICK_FEEDBACK_SURVEY ? '100%' : '100%' },
                    renderRating(getFieldValue(page, 'rating_type'), showField(page, 'input_list_caption') ? getFieldValue(page, 'input_list_caption') : []),
                    showError && invalidQuestions['mainRating'] ? React__default.createElement(ErrorMsg$4, null, "this field is required") : null),
                [SURVEY_TEMPLATES.FEW_CLICK_FEEDBACK_SURVEY, SURVEY_TEMPLATES.STD_FEEDBACK_SURVEY_V2].includes(surveySetting.template) && React__default.createElement(React__default.Fragment, null, !lodashExports.isEmpty(customVisibleQuestions) ? renderedCustomVisibleQuestions : null))),
        renderFloatingButton()));
};
var templateObject_1$7, templateObject_2$7;

var CustomPage = function (_a) {
    var page = _a.page, pages = _a.pages, editorMode = _a.editorMode, onNextPage = _a.onNextPage, surveySetting = _a.surveySetting, theme = _a.theme, trackEvent = _a.trackEvent, uploadRequest = _a.uploadRequest, visibleQuestionsMap = _a.visibleQuestionsMap, allQuestionsRulesFromEngine = _a.allQuestionsRulesFromEngine, selectedValueFactMap = _a.selectedValueFactMap, vouchersData = _a.vouchersData, expressParams = _a.expressParams, voucherIdsMetadata = _a.voucherIdsMetadata;
    var allowThemeInvert = (theme === null || theme === void 0 ? void 0 : theme.layout) !== 'box';
    var _b = useState(visibleQuestionsMap), visibleQuestionsRecord = _b[0], setVisibleQuestionsRecord = _b[1];
    var _c = useState(selectedValueFactMap), selectedFactMap = _c[0], setSelectedFactMap = _c[1];
    var _d = useState({}), questionsValue = _d[0], setQuestionsValue = _d[1];
    var _e = useState({}), invalidQuestions = _e[0], setInvalidQuestions = _e[1];
    var _f = useState(false), showError = _f[0], setShowError = _f[1];
    var _g = useState(false), showImageUploadLoader = _g[0], setImageUploadLoader = _g[1];
    var _h = useState(false), canSubmitPage = _h[0], setCanSubmitPage = _h[1];
    // Use global itemList context
    var getItemListAsArray = useItemList().getItemListAsArray;
    var globalItemListArr = getItemListAsArray();
    var onChangeHandler = function (question, value, canSubmitPageStatus) {
        var _a, _b, _c, _d, _e, _f;
        if (canSubmitPageStatus === void 0) { canSubmitPageStatus = false; }
        var isChoiceType = lodashExports.includes(['multiple-choice', 'picture-selection', 'upload'], question.questionType);
        var isValueEmpty = isChoiceType ? lodashExports.isEmpty(value) : isNil$1(value);
        // Check if the value is empty
        if (isValueEmpty) {
            // Retrieve the required status of the question
            var isQuestionRequired = getFieldQuestionRequired(question, 'required');
            // If the question is required and the value is empty, mark it as invalid
            if (isQuestionRequired) {
                setInvalidQuestions(__assign(__assign({}, invalidQuestions), (_a = {}, _a[question.id] = true, _a)));
            }
        }
        else {
            // If the value is not empty, mark the question as valid
            setInvalidQuestions(__assign(__assign({}, invalidQuestions), (_b = {}, _b[question.id] = false, _b)));
        }
        var questionType = EXTRACT_DETAILED_QUESTION_TYPE.includes(question.questionType)
            ? getFieldQuestionValue(question, 'rating_type')
            : question.questionType;
        if (!editorMode && surveySetting.template === SURVEY_TEMPLATES.STD_FEEDBACK_SURVEY_V2) {
            var selectedValue = value;
            var factKey = (question === null || question === void 0 ? void 0 : question.originQuestionId) + '_value';
            if (question.questionType === 'picture-selection') {
                selectedValue = value.value;
            }
            var updatedSelectedFactMap_1 = __assign(__assign({}, selectedFactMap), (_c = {}, _c[factKey] = selectedValue, _c));
            getQuestionsVisibleStatus({
                page: page,
                factMap: updatedSelectedFactMap_1,
                allQuestionsRulesFromEngine: allQuestionsRulesFromEngine
            }).then(function (updatedVisibleQuestionsRecord) {
                setVisibleQuestionsRecord(updatedVisibleQuestionsRecord);
                setSelectedFactMap(updatedSelectedFactMap_1);
                if (!canSubmitPageStatus) {
                    var updatedVisibleQuestions = getVisibleQuestions(page, editorMode, updatedVisibleQuestionsRecord);
                    var _a = computeCanGoToNextPage(__spreadArray([], updatedVisibleQuestions, true)), lastQuestion = _a.lastQuestion, canGoToNextPage = _a.canGoToNextPage;
                    var canAutoJumpToNextPage = !lodashExports.isEmpty(page === null || page === void 0 ? void 0 : page.selectedValue) || showError ? false : canGoToNextPage;
                    if (lodashExports.isEqual(surveySetting.template, SURVEY_TEMPLATES.STD_FEEDBACK_SURVEY_V2) &&
                        canAutoJumpToNextPage &&
                        lastQuestion &&
                        has$1(questionsValue, lastQuestion === null || lastQuestion === void 0 ? void 0 : lastQuestion.originQuestionId)) {
                        setCanSubmitPage(!canSubmitPageStatus);
                    }
                }
                setCanSubmitPage(canSubmitPageStatus);
            });
            if (question.id === question.originQuestionId) {
                setQuestionsValue(__assign(__assign({}, questionsValue), (_d = {}, _d[question.id] = {
                    value: value,
                    questionType: questionType,
                    isMasterQuestion: question.isMasterQuestion,
                    itemName: question.itemName
                }, _d)));
            }
            else {
                setQuestionsValue(__assign(__assign({}, questionsValue), (_e = {}, _e[question.id] = {
                    value: value,
                    questionType: questionType,
                    isMasterQuestion: question.isMasterQuestion,
                    itemName: question.itemName
                }, _e[question.originQuestionId] = {
                    value: value,
                    questionType: questionType,
                    isMasterQuestion: question.isMasterQuestion,
                    questionIdType: 'origin-question-id',
                    generatedQuestionId: question.id,
                    itemName: question.itemName
                }, _e)));
            }
        }
        else {
            setQuestionsValue(__assign(__assign({}, questionsValue), (_f = {}, _f[question.id] = {
                value: value,
                questionType: questionType,
                isMasterQuestion: question.isMasterQuestion
            }, _f)));
        }
    };
    var handleSubmitPage = function () {
        var questionsValue_ = __assign({}, questionsValue);
        if (showError) {
            scrollToErrorElement();
        }
        // Initialize an object to keep track of invalid form fields
        var inValidFormFields = {};
        // Initialize a flag to track the overall validity of the form
        var validForm = true;
        var visibleQuestions = getVisibleQuestions(page, editorMode, visibleQuestionsRecord, pages, undefined, undefined, globalItemListArr);
        // Iterate through each question on the page
        visibleQuestions === null || visibleQuestions === void 0 ? void 0 : visibleQuestions.forEach(function (question) {
            var _a;
            var _b, _c, _d;
            // Check if the question has a rating dependency
            var ratingDependency = showQuestionField(question, 'rating_dependency', true);
            var serviceTypeDependency = showQuestionField(question, 'service_type_dependency', true);
            // Check if the question should be shown based on positive rating
            var showOnPositiveRating = showQuestionField(question, 'show_question_if_rating', true) ||
                getFieldQuestionValue(question, 'show_question_if_rating');
            // Flag to determine if the question is visible
            var questionVisible = true;
            if (ratingDependency || serviceTypeDependency) {
                // Determine the rating range based on whether it should be shown on positive rating or not
                var ratingRange = showOnPositiveRating ? surveySetting.positiveRating : surveySetting.negativeRating;
                // Check if the current rating is under the specified range and the service type matches the question
                if (ratingDependency && serviceTypeDependency) {
                    questionVisible =
                        isCurrentRatingIsUnderRange(pages, ratingRange, 'ratings') &&
                            isServiceTypeMatchingQuestion(pages, question);
                }
                else if (ratingDependency) {
                    questionVisible = isCurrentRatingIsUnderRange(pages, ratingRange, 'ratings');
                }
                else if (serviceTypeDependency) {
                    questionVisible = isServiceTypeMatchingQuestion(pages, question);
                }
            }
            if (!questionVisible && !lodashExports.isEmpty(questionsValue_)) {
                delete questionsValue_[question.id];
            }
            if (question.questionType === 'upload' && ((_c = (_b = questionsValue[question.id]) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.length)) {
                questionsValue_[question.id] = __assign(__assign({}, questionsValue[question.id]), { value: JSON.stringify(questionsValue[question.id].value[0]) });
            }
            var isChoiceType = lodashExports.includes(['multiple-choice', 'upload'], question.questionType);
            var questionValue = get$2(questionsValue, "[".concat(question.id, "].value"), null);
            var isValueEmpty = isChoiceType ? lodashExports.isEmpty(questionValue) : isNil$1(questionValue);
            var isVoucherSelectType = (question === null || question === void 0 ? void 0 : question.questionType) === 'choose_voucher';
            if (isVoucherSelectType) {
                var voucherNoOfferPayload = (_d = question === null || question === void 0 ? void 0 : question.value) === null || _d === void 0 ? void 0 : _d.find(function (eachValue) { return (eachValue === null || eachValue === void 0 ? void 0 : eachValue.fieldKey) === 'no_offer_label'; });
                isValueEmpty = isVoucherSelectType
                    ? (vouchersData === null || vouchersData === void 0 ? void 0 : vouchersData.length) || (voucherNoOfferPayload === null || voucherNoOfferPayload === void 0 ? void 0 : voucherNoOfferPayload.show)
                        ? isValueEmpty
                        : false
                    : isValueEmpty;
            }
            // Check if the question is visible, required, and its value is empty
            if (questionVisible && getFieldQuestionRequired(question, 'required') && isValueEmpty) {
                // Mark the question as invalid in the inValidFormFields object
                inValidFormFields = __assign(__assign({}, inValidFormFields), (_a = {}, _a[question.id] = true, _a));
                console.log("inValidFormFields: ", inValidFormFields);
                // Set the validForm flag to false since an invalid question was found
                validForm = false;
            }
        });
        // Update the invalidQuestions state with the inValidFormFields object
        setInvalidQuestions(inValidFormFields);
        console.log("validForm: ", validForm);
        // If the form is not valid, show an error and return
        if (!validForm) {
            setShowError(true);
            return;
        }
        // Hide the error since the form is valid
        setShowError(false);
        // Call the onNextPage function and pass the questionsValue as the argument
        onNextPage(questionsValue_, selectedFactMap);
    };
    useEffect(function () {
        scrollToErrorElement();
    }, [showError]);
    var _j = useMemo(function () {
        return renderCustomQuestion({
            page: page,
            pages: pages,
            editorMode: editorMode,
            surveySetting: surveySetting,
            theme: theme,
            onChangeHandler: onChangeHandler,
            questionsValue: questionsValue,
            invalidQuestions: invalidQuestions,
            showError: showError,
            trackEvent: trackEvent,
            ratingSelected: lodashExports.isEqual(surveySetting.template, SURVEY_TEMPLATES.STD_FEEDBACK_SURVEY_V2)
                ? (selectedFactMap === null || selectedFactMap === void 0 ? void 0 : selectedFactMap.rating_value)
                    ? true
                    : false
                : true,
            visibleQuestionsRecord: visibleQuestionsRecord,
            uploadImageOptions: uploadRequest
                ? {
                    uploadRequest: uploadRequest,
                    setImageUploadLoader: setImageUploadLoader,
                    onChangeHandler: onChangeHandler,
                    showImageUploadLoader: showImageUploadLoader
                }
                : null,
            vouchersData: vouchersData,
            expressParams: expressParams,
            voucherIdsMetadata: voucherIdsMetadata
        });
    }, [
        selectedFactMap === null || selectedFactMap === void 0 ? void 0 : selectedFactMap.rating_value,
        questionsValue,
        invalidQuestions,
        showError,
        visibleQuestionsRecord,
        selectedFactMap,
        vouchersData,
        showImageUploadLoader,
        expressParams,
    ]), renderedCustomVisibleQuestions = _j.renderedCustomVisibleQuestions, _k = _j.customVisibleQuestions, customVisibleQuestions = _k === void 0 ? [] : _k, canShowNextButton = _j.canShowNextButton;
    useEffect(function () {
        if (page === null || page === void 0 ? void 0 : page.selectedValue) {
            var questionsVal_1 = {};
            Object.keys(page === null || page === void 0 ? void 0 : page.selectedValue).map(function (eachQuestionKey) {
                var _a;
                var _b;
                questionsVal_1 = __assign(__assign({}, questionsVal_1), (_a = {}, _a[eachQuestionKey] = (_b = page === null || page === void 0 ? void 0 : page.selectedValue) === null || _b === void 0 ? void 0 : _b[eachQuestionKey], _a));
            });
            setQuestionsValue(questionsVal_1);
        }
    }, [page]);
    var lastComputedValuesRef = useRef({
        lastQuestion: null,
        canAutoJumpToNextPage: false
    });
    useEffect(function () {
        var _a;
        //code for new item 
        var isItemPage = ((_a = page.questions) === null || _a === void 0 ? void 0 : _a.some(function (q) { return q.questionType === 'item_tiered_rating'; })) || false;
        if (isItemPage && lodashExports.isEmpty(customVisibleQuestions)) {
            console.log("skipping page");
            handleSubmitPage();
        }
        if (canSubmitPage && !showError) {
            var _b = computeCanGoToNextPage(customVisibleQuestions), lastQuestion = _b.lastQuestion, canGoToNextPage = _b.canGoToNextPage;
            var canAutoJumpToNextPage = !lodashExports.isEmpty(page === null || page === void 0 ? void 0 : page.selectedValue) || showError ? false : canGoToNextPage;
            // Update the ref to store the latest computation
            lastComputedValuesRef.current = {
                lastQuestion: lastQuestion,
                canAutoJumpToNextPage: canAutoJumpToNextPage
            };
            setTimeout(function () {
                var _a = lastComputedValuesRef.current, lastQuestion = _a.lastQuestion, canAutoJumpToNextPage = _a.canAutoJumpToNextPage;
                if (lodashExports.isEqual(surveySetting.template, SURVEY_TEMPLATES.STD_FEEDBACK_SURVEY_V2) &&
                    canAutoJumpToNextPage &&
                    lastQuestion &&
                    has$1(questionsValue, lastQuestion === null || lastQuestion === void 0 ? void 0 : lastQuestion.originQuestionId)) {
                    handleSubmitPage();
                }
            }, 500);
        }
    }, [canSubmitPage, surveySetting, customVisibleQuestions, questionsValue]);
    var renderFloatingButton = function () {
        if (lodashExports.isEqual(surveySetting.template, SURVEY_TEMPLATES.STD_FEEDBACK_SURVEY_V2)) {
            return canShowNextButton ? React__default.createElement(FloatingBtn, { onClick: handleSubmitPage }) : null;
        }
        return React__default.createElement(FloatingBtn, { onClick: handleSubmitPage });
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: "page-title" },
            React__default.createElement(BrandInfo, { page: page }),
            showField(page, 'title') && (React__default.createElement(Text$1.H2, { className: classNames({ 'bg-theme-allowed': allowThemeInvert }), semibold: true, dangerouslySetInnerHTML: { __html: getFieldValue(page, 'title') || '' } }))),
        React__default.createElement("div", { className: "page-body" },
            React__default.createElement("div", { className: "page-content" }, !lodashExports.isEmpty(customVisibleQuestions) ? renderedCustomVisibleQuestions : null)),
        renderFloatingButton()));
};
var CustomPage$1 = memo(CustomPage);

var ThankYouPageWrap = defaultStyled.div(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  .send-mail-logo {\n    margin-top: 1.25rem;\n  }\n  .social-icons {\n    margin-top: 0.625rem;\n  }\n"], ["\n  .send-mail-logo {\n    margin-top: 1.25rem;\n  }\n  .social-icons {\n    margin-top: 0.625rem;\n  }\n"])));
var FollowBox = defaultStyled.div(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 1.875rem;\n\n  .social-icons {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.625rem;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 1.875rem;\n\n  .social-icons {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.625rem;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n  }\n"])));
var ThankYouPageDes = defaultStyled.div(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n  border-bottom: ", ";\n  padding-bottom: ", ";\n\n  .thankyou-page-title {\n    margin-bottom: 1.25rem;\n    text-align: center;\n\n    &.has-logo {\n      margin-top: 1.875rem;\n    }\n  }\n"], ["\n  border-bottom: ", ";\n  padding-bottom: ", ";\n\n  .thankyou-page-title {\n    margin-bottom: 1.25rem;\n    text-align: center;\n\n    &.has-logo {\n      margin-top: 1.875rem;\n    }\n  }\n"])), function (_a) {
    var $showBorder = _a.$showBorder;
    return ($showBorder ? '1px solid var(--grey-light)' : 'none');
}, function (_a) {
    var $showBorder = _a.$showBorder;
    return ($showBorder ? '1.875rem' : '0px');
});
var Border = defaultStyled.div(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject(["\n  border-bottom: 1px solid var(--grey-light);\n  margin: 1.875rem 0;\n"], ["\n  border-bottom: 1px solid var(--grey-light);\n  margin: 1.875rem 0;\n"])));
var LogoCircle = defaultStyled.div(templateObject_5$4 || (templateObject_5$4 = __makeTemplateObject(["\n  width: 3.125rem;\n  height: 3.125rem;\n  border-radius: 50%;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  width: 3.125rem;\n  height: 3.125rem;\n  border-radius: 50%;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var ThankYouPage = function (_a) {
    var _b, _c;
    var page = _a.page, trackEvent = _a.trackEvent, theme = _a.theme, pages = _a.pages, surveySetting = _a.surveySetting, editorMode = _a.editorMode, visibleQuestionsMap = _a.visibleQuestionsMap; _a.allQuestionsRulesFromEngine; var selectedValueFactMap = _a.selectedValueFactMap, expressParams = _a.expressParams;
    var allowThemeInvert = (theme === null || theme === void 0 ? void 0 : theme.layout) !== 'box';
    var followText = getFieldValue(page, 'follow_us').replace('{brand_name}', '');
    var socialLinks = getFieldValue(page, 'social_links');
    var onClickSocialLink = function (url) {
        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.THANK_YOU_SOCIAL_LINK);
        if (url)
            window.open(url, '_blank');
    };
    // Dummy handler for custom questions (no actual form interaction needed)
    var onChangeHandler = function () {
        // No-op since these are display-only questions
    };
    // Use renderCustomQuestion with useMemo like in RatingPage
    var _d = useMemo(function () {
        return renderCustomQuestion({
            page: page,
            pages: pages || [],
            surveySetting: surveySetting,
            editorMode: editorMode,
            theme: theme,
            showError: false,
            questionsValue: {},
            invalidQuestions: {},
            ratingSelected: lodashExports.isEqual(surveySetting.template, SURVEY_TEMPLATES.STD_FEEDBACK_SURVEY_V2)
                ? (selectedValueFactMap === null || selectedValueFactMap === void 0 ? void 0 : selectedValueFactMap.rating_value)
                    ? true
                    : false
                : true,
            onChangeHandler: onChangeHandler,
            trackEvent: trackEvent,
            visibleQuestionsRecord: visibleQuestionsMap,
            uploadImageOptions: null,
            vouchersData: [],
            expressParams: expressParams
        });
    }, [page, pages, surveySetting, editorMode, theme, visibleQuestionsMap, trackEvent, expressParams]), renderedCustomVisibleQuestions = _d.renderedCustomVisibleQuestions, _e = _d.customVisibleQuestions, customVisibleQuestions = _e === void 0 ? [] : _e;
    console.log(selectedValueFactMap, 'selectedValueFactMap');
    console.log(visibleQuestionsMap, 'visibleQuestionsMap');
    return (React__default.createElement(ThankYouPageWrap, null,
        React__default.createElement(BrandInfo, { page: page }),
        React__default.createElement("div", { className: "page-content" },
            React__default.createElement(ThankYouPageDes, null, showField(page, 'title') && (React__default.createElement(Text$1.H2, { dangerouslySetInnerHTML: { __html: getFieldValue(page, 'title') || '' }, semibold: true, className: "thankyou-page-title ".concat(showField(page, 'brand_logo') ? 'has-logo' : '') }))),
            !isEmpty$1(customVisibleQuestions) && (React__default.createElement("div", { className: "custom-questions-section", style: { marginTop: '1.875rem' } }, renderedCustomVisibleQuestions)),
            !isEmpty$1(socialLinks) && React__default.createElement(Border, null),
            !isEmpty$1(socialLinks) && (React__default.createElement(FollowBox, null,
                showField(page, 'follow_us') && (React__default.createElement(Text$1.B1, { className: classNames({ 'bg-theme-allowed': allowThemeInvert }), dangerouslySetInnerHTML: { __html: followText } })),
                React__default.createElement("div", { className: "social-icons" }, socialLinks
                    .filter(function (link) { return link.show; })
                    .map(function (link) { return (React__default.createElement(LogoCircle, { className: "logo-circle", onClick: function () { return onClickSocialLink(link.url); } },
                    React__default.createElement("img", { src: link.logo, alt: link.label }))); })))),
            showField(page, 'upload_gif') && ((_b = getFieldValue(page, 'upload_gif')) === null || _b === void 0 ? void 0 : _b.mediaUrl) && (React__default.createElement("div", { className: "send-mail-logo" },
                React__default.createElement(Image$1, { src: (_c = getFieldValue(page, 'upload_gif')) === null || _c === void 0 ? void 0 : _c.mediaUrl })))),
        !page.hidePoweredByMomos && React__default.createElement(PoweredByMomos, null)));
};
var templateObject_1$6, templateObject_2$6, templateObject_3$5, templateObject_4$4, templateObject_5$4;

var toString$2 = toString_1;

/**
 * Replaces matches for `pattern` in `string` with `replacement`.
 *
 * **Note:** This method is based on
 * [`String#replace`](https://mdn.io/String/replace).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to modify.
 * @param {RegExp|string} pattern The pattern to replace.
 * @param {Function|string} replacement The match replacement.
 * @returns {string} Returns the modified string.
 * @example
 *
 * _.replace('Hi Fred', 'Fred', 'Barney');
 * // => 'Hi Barney'
 */
function replace() {
  var args = arguments,
      string = toString$2(args[0]);

  return args.length < 3 ? string : string.replace(args[1], args[2]);
}

var replace_1 = replace;

var replace$1 = /*@__PURE__*/getDefaultExportFromCjs(replace_1);

var baseProperty = _baseProperty;

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize$1 = baseProperty('length');

var _asciiSize = asciiSize$1;

/** Used to compose unicode character classes. */

var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize$1(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    ++result;
  }
  return result;
}

var _unicodeSize = unicodeSize$1;

var asciiSize = _asciiSize,
    hasUnicode$1 = _hasUnicode,
    unicodeSize = _unicodeSize;

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize$2(string) {
  return hasUnicode$1(string)
    ? unicodeSize(string)
    : asciiSize(string);
}

var _stringSize = stringSize$2;

var baseKeys = _baseKeys,
    getTag = _getTag,
    isArrayLike = isArrayLike_1,
    isString = isString_1,
    stringSize$1 = _stringSize;

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */
function size(collection) {
  if (collection == null) {
    return 0;
  }
  if (isArrayLike(collection)) {
    return isString(collection) ? stringSize$1(collection) : collection.length;
  }
  var tag = getTag(collection);
  if (tag == mapTag || tag == setTag) {
    return collection.size;
  }
  return baseKeys(collection).length;
}

var size_1 = size;

var size$1 = /*@__PURE__*/getDefaultExportFromCjs(size_1);

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */

function baseClamp$1(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

var _baseClamp = baseClamp$1;

var baseClamp = _baseClamp,
    baseToString$1 = _baseToString,
    toInteger$1 = toInteger_1,
    toString$1 = toString_1;

/**
 * Checks if `string` starts with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=0] The position to search from.
 * @returns {boolean} Returns `true` if `string` starts with `target`,
 *  else `false`.
 * @example
 *
 * _.startsWith('abc', 'a');
 * // => true
 *
 * _.startsWith('abc', 'b');
 * // => false
 *
 * _.startsWith('abc', 'b', 1);
 * // => true
 */
function startsWith(string, target, position) {
  string = toString$1(string);
  position = position == null
    ? 0
    : baseClamp(toInteger$1(position), 0, string.length);

  target = baseToString$1(target);
  return string.slice(position, position + target.length) == target;
}

var startsWith_1 = startsWith;

var startsWith$1 = /*@__PURE__*/getDefaultExportFromCjs(startsWith_1);

var _paddingUsPhoneNumber = function (phoneNumber) {
    phoneNumber = phoneNumber.replace(/[^0-9]/g, '');
    if (!phoneNumber)
        return '';
    if (phoneNumber.length === 10) {
        return "1".concat(phoneNumber);
    }
    else if (startsWith$1(phoneNumber, '1') && size$1(phoneNumber) === 11) {
        return "".concat(phoneNumber);
    }
    else if (size$1(phoneNumber) > 10) {
        return !startsWith$1(phoneNumber, '1') ? "1".concat(phoneNumber.slice(0, 10)) : "".concat(phoneNumber.slice(0, 11));
    }
    return !startsWith$1(phoneNumber, '1') ? "1".concat(phoneNumber) : phoneNumber;
};

var PersonalInfoPageWrap = defaultStyled.div(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  .ant-btn {\n    margin-top: 1.25rem;\n  }\n"], ["\n  .ant-btn {\n    margin-top: 1.25rem;\n  }\n"])));
var FieldWrap$1 = defaultStyled.div(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 15px;\n\n  > span {\n    margin-bottom: 0.625rem;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 15px;\n\n  > span {\n    margin-bottom: 0.625rem;\n  }\n"])));
var CaptionText = defaultStyled.div(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n  margin-top: 1.875rem;\n  margin-bottom: 1.25rem;\n  text-align: center;\n"], ["\n  margin-top: 1.875rem;\n  margin-bottom: 1.25rem;\n  text-align: center;\n"])));
var ErrorMsg$3 = defaultStyled(Text$1.B2)(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n  color: var(--indian-red);\n"], ["\n  color: var(--indian-red);\n"])));
var SubmitWrap = defaultStyled.div(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject([""], [""])));
var OfferCardWrap = defaultStyled.div(templateObject_6$3 || (templateObject_6$3 = __makeTemplateObject(["\n  margin-top: 1.25rem;\n  margin-bottom: 1.25rem;\n\n  .offer-title {\n    display: inline-block;\n    margin-bottom: 10px;\n  }\n"], ["\n  margin-top: 1.25rem;\n  margin-bottom: 1.25rem;\n\n  .offer-title {\n    display: inline-block;\n    margin-bottom: 10px;\n  }\n"])));
var ContactPreference = defaultStyled.div(templateObject_7$2 || (templateObject_7$2 = __makeTemplateObject(["\n  margin-top: 0.625rem;\n  margin-bottom: 0.625rem;\n\n  label > span {\n    font-size: 0.75rem;\n    line-height: 0.875rem;\n  }\n"], ["\n  margin-top: 0.625rem;\n  margin-bottom: 0.625rem;\n\n  label > span {\n    font-size: 0.75rem;\n    line-height: 0.875rem;\n  }\n"])));
var TermConditionWrap = defaultStyled.div(templateObject_8$2 || (templateObject_8$2 = __makeTemplateObject(["\n  .ant-checkbox-wrapper {\n    display: flex;\n  }\n  .first-checkbox {\n    span p {\n      margin: 0;\n      display: inline;\n    }\n  }\n"], ["\n  .ant-checkbox-wrapper {\n    display: flex;\n  }\n  .first-checkbox {\n    span p {\n      margin: 0;\n      display: inline;\n    }\n  }\n"])));
var PersonalInformationPage = function (_a) {
    var _b, _c, _d;
    var page = _a.page, onNextPage = _a.onNextPage, surveySetting = _a.surveySetting, brandRegion = _a.brandRegion, trackEvent = _a.trackEvent, vouchersData = _a.vouchersData, multiVoucherIds = _a.multiVoucherIds, pages = _a.pages, theme = _a.theme, editorMode = _a.editorMode;
    var allowThemeInvert = (theme === null || theme === void 0 ? void 0 : theme.layout) !== 'box';
    var _e = useState({}), questionsValue = _e[0], setQuestionsValue = _e[1];
    var _f = useState({
        name: false,
        email: false,
        phone_no: false
    }), invalidQuestions = _f[0], setInvalidQuestions = _f[1];
    var _g = useState(null), countyCode = _g[0], setCountryCode = _g[1];
    var _h = useState(false), showError = _h[0], setShowError = _h[1];
    var _j = useState(false), showNameEmail = _j[0], setShowNameEmail = _j[1];
    // Function to set the validity of a question
    var setQuestionValidity = function (fieldKey, isValid) {
        var _a;
        setInvalidQuestions(__assign(__assign({}, invalidQuestions), (_a = {}, _a[fieldKey] = !isValid, _a)));
    };
    var defaultName = useMemo(function () { return getFieldAnswerValue(page, 'name', 'name') || ''; }, []);
    var defaultEmail = useMemo(function () { return getFieldAnswerValue(page, 'email', 'email') || ''; }, []);
    var defaultPhoneno = useMemo(function () {
        return lowerCase$1(brandRegion) == 'us'
            ? _paddingUsPhoneNumber(getFieldAnswerValue(page, 'phone_no', 'phone_no') || '')
            : getFieldAnswerValue(page, 'phone_no', 'phone_no') || '';
    }, []);
    // set default values for express survey
    useEffect(function () {
        if (defaultEmail === null || defaultEmail === void 0 ? void 0 : defaultEmail.length) {
            var isEmailValid = !!validateEmail(defaultEmail);
            if (!isEmailValid) {
                setQuestionValidity('email', isEmailValid);
                setShowError(true);
            }
        }
        setQuestionsValue(__assign(__assign({}, questionsValue), { name: defaultName, email: defaultEmail, phone_no: defaultPhoneno }));
    }, [page]);
    var onChangeHandler = function (fieldKey, value) {
        var _a, _b, _c, _d, _e;
        // Handle different cases based on the fieldKey
        switch (fieldKey) {
            // For 'name', 'email', and 'phone_no' fields
            case 'name':
                setQuestionValidity(fieldKey, value === null || value === void 0 ? void 0 : value.length);
                setQuestionsValue(__assign(__assign({}, questionsValue), (_a = {}, _a[fieldKey] = value, _a)));
                break;
            case 'email':
                setQuestionValidity(fieldKey, !!validateEmail(value));
                setQuestionsValue(__assign(__assign({}, questionsValue), (_b = {}, _b[fieldKey] = value, _b)));
                break;
            case 'phone_no':
                // Set the validity of the question
                var isQuestionRequired = getFieldQuestionRequired(page, 'phone_no');
                if (isQuestionRequired) {
                    setQuestionValidity(fieldKey, value);
                }
                // Update the value of the question in the questionsValue state
                setQuestionsValue(__assign(__assign({}, questionsValue), (_c = {}, _c[fieldKey] = value, _c)));
                break;
            case 'contactMethod':
                setQuestionsValue(__assign(__assign({}, questionsValue), (_d = {}, _d[fieldKey] = value, _d)));
                break;
            default:
                var question = page.value.find(function (o) { return o.fieldKey === fieldKey; });
                if (question) {
                    if (!value) {
                        var isQuestionRequired_1 = question.showRequired;
                        if (isQuestionRequired_1) {
                            // If the question is required and the value is not empty, mark it as valid
                            setQuestionValidity(question.fieldKey, false);
                        }
                    }
                    else {
                        // If the value is empty, mark the question as invalid
                        setQuestionValidity(question.fieldKey, true);
                    }
                    // Update the value of the question in the questionsValue state
                    setQuestionsValue(__assign(__assign({}, questionsValue), (_e = {}, _e[question.fieldKey] = value, _e)));
                }
                break;
        }
    };
    var handleSubmitPage = function () {
        var _a;
        var inValidFormFields = {};
        var validForm = true;
        Object.keys(invalidQuestions).map(function (eachKey) {
            if (invalidQuestions[eachKey]) {
                validForm = false;
                setShowError(true);
            }
        });
        if (!validForm) {
            return;
        }
        // Function to mark a question as invalid in the inValidFormFields object
        var markQuestionAsInvalid = function (fieldKey) {
            var _a;
            return __assign(__assign({}, inValidFormFields), (_a = {}, _a[fieldKey] = true, _a));
        };
        // Check for required fields in the page.value array
        (_a = page.value) === null || _a === void 0 ? void 0 : _a.forEach(function (question) {
            if (question.showRequired && question.show && !questionsValue[question.fieldKey]) {
                // Mark the question as invalid
                inValidFormFields = markQuestionAsInvalid(question.fieldKey);
                // Set the validForm flag to false since an invalid question was found
                validForm = false;
            }
        });
        // Check for 'name', 'email', and 'phone_no' fields individually
        var requiredFields = (surveySetting === null || surveySetting === void 0 ? void 0 : surveySetting.smsEnabled) ? ['name'] : ['name', 'email'];
        requiredFields.forEach(function (fieldKey) {
            if (!questionsValue[fieldKey] && showField(page, fieldKey)) {
                // Mark the question as invalid
                inValidFormFields = markQuestionAsInvalid(fieldKey);
                // Set the validForm flag to false since an invalid question was found
                validForm = false;
            }
        });
        // Set the invalidQuestions state with the updated inValidFormFields object
        setInvalidQuestions(inValidFormFields);
        // Check if 'name', 'email', or 'phone_no' fields are required individually
        var nameRequired = !questionsValue['name'];
        var emailRequired = (surveySetting === null || surveySetting === void 0 ? void 0 : surveySetting.smsEnabled)
            ? !questionsValue['email'] && showField(page, 'email') && getFieldQuestionRequired(page, 'email')
            : !questionsValue['email'];
        var phoneRequired = (!questionsValue['phone_no'] || questionsValue['phone_no'] === countyCode) &&
            showField(page, 'phone_no') &&
            getFieldQuestionRequired(page, 'phone_no');
        if (nameRequired || emailRequired || phoneRequired) {
            validForm = false;
            // Mark the required fields as invalid
            inValidFormFields = __assign(__assign({}, inValidFormFields), { name: nameRequired, email: emailRequired, phone_no: phoneRequired });
            // Update the invalidQuestions state with the additional invalid fields
            setInvalidQuestions(inValidFormFields);
        }
        // Show error if the form is not valid
        setShowError(!validForm);
        if (!validForm) {
            return;
        }
        // Hide the error since the form is valid
        setShowError(false);
        // Call the onNextPage function and pass the questionsValue as the argument
        onNextPage({
            name: questionsValue['name'],
            email: questionsValue['email'],
            // If countyCode and phone no. is same then don't send the phone number
            phoneNumber: questionsValue['phone_no'] === countyCode ? '' : questionsValue['phone_no'],
            checkedTC: questionsValue['terms_and_conditions'],
            checkedContactMe: questionsValue['agree_to_contact'],
            contactMethod: questionsValue['contactMethod'] || getFieldValue(page, 'method_contact_preferences'),
            checkedOptin: questionsValue['optin']
        });
    };
    useEffect(function () {
        if ((surveySetting === null || surveySetting === void 0 ? void 0 : surveySetting.template) &&
            ![SURVEY_TEMPLATES.FEW_CLICK_FEEDBACK_SURVEY, SURVEY_TEMPLATES.STD_FEEDBACK_SURVEY_V2].includes(surveySetting === null || surveySetting === void 0 ? void 0 : surveySetting.template)) {
            setShowNameEmail(true);
        }
        else {
            var isQuestionRequired = getFieldQuestionRequired(page, 'phone_no');
            var isPhoneFieldVisible = showField(page, 'phone_no');
            if (isQuestionRequired && isPhoneFieldVisible) {
                if (defaultEmail && defaultName && !defaultPhoneno) {
                    setShowNameEmail(false);
                }
                else {
                    setShowNameEmail(true);
                }
            }
            else {
                setShowNameEmail(true);
            }
        }
    }, []);
    // Check the conditions for terms and conditions checkbox
    var tncUnchecked = showField(page, 'terms_and_conditions') &&
        getFieldRequired(page, 'terms_and_conditions') &&
        !questionsValue['terms_and_conditions'];
    // Check the conditions for agree to contact checkbox
    var agreeUnchecked = showField(page, 'agree_to_contact') &&
        getFieldRequired(page, 'agree_to_contact') &&
        !questionsValue['agree_to_contact'];
    var getSelectedOfferByTemplate = function (pageValues) {
        return (surveySetting === null || surveySetting === void 0 ? void 0 : surveySetting.template) && ![SURVEY_TEMPLATES.STD_FEEDBACK_SURVEY_V2].includes(surveySetting === null || surveySetting === void 0 ? void 0 : surveySetting.template)
            ? getSelectedOffer(pageValues, vouchersData)
            : getSelectedOfferForStandardFeedbackSurveyV2(pageValues, vouchersData, multiVoucherIds, editorMode);
    };
    var selectedOffer = getSelectedOfferByTemplate(pages);
    return (React__default.createElement(PersonalInfoPageWrap, null,
        React__default.createElement(BrandInfo, { page: page }),
        (surveySetting === null || surveySetting === void 0 ? void 0 : surveySetting.template) &&
            [SURVEY_TEMPLATES.FEW_CLICK_FEEDBACK_SURVEY, SURVEY_TEMPLATES.STD_FEEDBACK_SURVEY_V2].includes(surveySetting === null || surveySetting === void 0 ? void 0 : surveySetting.template) &&
            showField(page, 'caption') && (React__default.createElement("div", { className: "page-title" },
            React__default.createElement(Text$1.H2, { className: "bg-theme-allowed", semibold: true, dangerouslySetInnerHTML: { __html: getFieldValue(page, 'caption') || '' } }))),
        React__default.createElement("div", { className: "page-content" },
            (surveySetting === null || surveySetting === void 0 ? void 0 : surveySetting.template) &&
                ![SURVEY_TEMPLATES.STD_FEEDBACK_SURVEY_V2].includes(surveySetting === null || surveySetting === void 0 ? void 0 : surveySetting.template) &&
                getFieldValue(page, 'voucher_details') && (React__default.createElement(OfferCardWrap, null, selectedOffer ? (React__default.createElement(OfferCardV2, { preview: true, data: [selectedOffer] })) : (React__default.createElement(OfferCard$1, { voucher: getFieldValue(page, 'voucher_details') })))),
            (surveySetting === null || surveySetting === void 0 ? void 0 : surveySetting.template) &&
                ![SURVEY_TEMPLATES.FEW_CLICK_FEEDBACK_SURVEY, SURVEY_TEMPLATES.STD_FEEDBACK_SURVEY_V2].includes(surveySetting === null || surveySetting === void 0 ? void 0 : surveySetting.template) &&
                showField(page, 'caption') && (React__default.createElement(CaptionText, null,
                React__default.createElement(Text$1.B1, { dangerouslySetInnerHTML: { __html: getFieldValue(page, 'caption') || '' } }))),
            showField(page, 'show_selected_offer') && selectedOffer && (React__default.createElement(OfferCardWrap, null,
                React__default.createElement(Text$1.B1, { className: "bg-theme-allowed offer-title", semibold: true, dangerouslySetInnerHTML: { __html: getFieldValue(page, 'show_selected_offer') || '' } }),
                React__default.createElement(OfferCardV2, { preview: true, data: selectedOffer, voucherId: selectedOffer.id }))),
            (surveySetting === null || surveySetting === void 0 ? void 0 : surveySetting.template) &&
                [SURVEY_TEMPLATES.FEW_CLICK_FEEDBACK_SURVEY, SURVEY_TEMPLATES.STD_FEEDBACK_SURVEY_V2].includes(surveySetting === null || surveySetting === void 0 ? void 0 : surveySetting.template) &&
                showField(page, 'phone_no') && (React__default.createElement(FieldWrap$1, { onClick: function () { return setShowNameEmail(true); } },
                React__default.createElement(Text$1.B1, { className: classNames({
                        required: getFieldRequired(page, 'phone_no'),
                        'bg-theme-allowed': allowThemeInvert
                    }), dangerouslySetInnerHTML: { __html: getFieldValue(page, 'phone_no') || '' } }),
                React__default.createElement(Input.Phone
                //name="phone_no"
                , { 
                    //name="phone_no"
                    country: PHONE_COUNTRY_CODE_MAPPING[brandRegion] || lowerCase$1(brandRegion) || 'sg', placeholder: "Phone Number", countryCodeEditable: false, inputClass: "mb-10", value: questionsValue['phone_no'], onChange: function (phone, dialCode) {
                        setCountryCode(dialCode.dialCode);
                        onChangeHandler('phone_no', phone);
                    }, onFocus: function () {
                        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.PERSONAL_INFORMATION_PHONE);
                    } }),
                showError && invalidQuestions['phone_no'] && React__default.createElement(ErrorMsg$3, null, "This field is required"))),
            showNameEmail && (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(FieldWrap$1, null,
                    React__default.createElement(Text$1.B1, { className: classNames('required', { 'bg-theme-allowed': allowThemeInvert }), dangerouslySetInnerHTML: { __html: getFieldValue(page, 'name') || '' } }),
                    React__default.createElement(Input, { name: "name", placeholder: "Name", className: "mb-10", value: questionsValue['name'], onChange: function (e) {
                            onChangeHandler('name', e.target.value);
                        }, onFocus: function () {
                            trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.PERSONAL_INFORMATION_NAME);
                        } }),
                    showError && invalidQuestions['name'] && React__default.createElement(ErrorMsg$3, null, "This field is required")),
                (surveySetting === null || surveySetting === void 0 ? void 0 : surveySetting.smsEnabled) ? (React__default.createElement(React__default.Fragment, null, showField(page, 'email') || ((_b = getField(page, 'email')) === null || _b === void 0 ? void 0 : _b.show) === undefined ? (React__default.createElement(FieldWrap$1, null,
                    React__default.createElement(Text$1.B1, { className: classNames({
                            required: getFieldRequired(page, 'email') || ((_c = getField(page, 'email')) === null || _c === void 0 ? void 0 : _c.showRequired) === undefined,
                            'bg-theme-allowed': allowThemeInvert
                        }), dangerouslySetInnerHTML: { __html: getFieldValue(page, 'email') || '' } }),
                    React__default.createElement(Input, { name: "email", placeholder: "Email", className: "mb-10", value: questionsValue['email'], onChange: function (e) {
                            onChangeHandler('email', e.target.value);
                        }, onFocus: function () {
                            trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.PERSONAL_INFORMATION_EMAIL);
                        } }),
                    showError && invalidQuestions['email'] && React__default.createElement(ErrorMsg$3, null, "This field is invalid"))) : null)) : (React__default.createElement(FieldWrap$1, null,
                    React__default.createElement(Text$1.B1, { className: classNames('required', { 'bg-theme-allowed': allowThemeInvert }), dangerouslySetInnerHTML: { __html: getFieldValue(page, 'email') || '' } }),
                    React__default.createElement(Input, { name: "email", placeholder: "Email", className: "mb-10", value: questionsValue['email'], onChange: function (e) {
                            onChangeHandler('email', e.target.value);
                        }, onFocus: function () {
                            trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.PERSONAL_INFORMATION_EMAIL);
                        } }),
                    showError && invalidQuestions['email'] && React__default.createElement(ErrorMsg$3, null, "This field is invalid"))),
                (surveySetting === null || surveySetting === void 0 ? void 0 : surveySetting.template) &&
                    ![SURVEY_TEMPLATES.FEW_CLICK_FEEDBACK_SURVEY, SURVEY_TEMPLATES.STD_FEEDBACK_SURVEY_V2].includes(surveySetting === null || surveySetting === void 0 ? void 0 : surveySetting.template) &&
                    showField(page, 'phone_no') && (React__default.createElement(FieldWrap$1, null,
                    React__default.createElement(Text$1.B1, { className: classNames({
                            required: getFieldRequired(page, 'phone_no'),
                            'bg-theme-allowed': allowThemeInvert
                        }), dangerouslySetInnerHTML: { __html: getFieldValue(page, 'phone_no') || '' } }),
                    React__default.createElement(Input.Phone
                    //name="phone_no"
                    , { 
                        //name="phone_no"
                        country: PHONE_COUNTRY_CODE_MAPPING[brandRegion] || lowerCase$1(brandRegion) || 'sg', placeholder: "Phone Number", countryCodeEditable: false, inputClass: "mb-10", value: questionsValue['phone_no'], onChange: function (phone, dialCode) {
                            setCountryCode(dialCode.dialCode);
                            onChangeHandler('phone_no', phone);
                        }, onFocus: function () {
                            trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.PERSONAL_INFORMATION_PHONE);
                        } }),
                    showError && invalidQuestions['phone_no'] && React__default.createElement(ErrorMsg$3, null, "This field is required"))))),
            (surveySetting === null || surveySetting === void 0 ? void 0 : surveySetting.smsEnabled) &&
                showField(page, 'method_contact_preferences') &&
                questionsValue['phone_no'] &&
                ((_d = questionsValue['phone_no']) === null || _d === void 0 ? void 0 : _d.length) > ((countyCode === null || countyCode === void 0 ? void 0 : countyCode.length) || 2) &&
                questionsValue['email'] ? (React__default.createElement(ContactPreference, { className: "preference-group" },
                React__default.createElement(Text$1.B2, { className: classNames({ 'bg-theme-allowed': allowThemeInvert }) }, "How would you like to be contacted?"),
                React__default.createElement(Radio.Group, { value: questionsValue['contactMethod'], onChange: function (e) {
                        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.PERSONAL_INFORMATION_CONTACT_METHOD);
                        onChangeHandler('contactMethod', e.target.value);
                    }, defaultValue: getFieldValue(page, 'method_contact_preferences') || 'EMAIL' },
                    React__default.createElement(Radio, { value: 'EMAIL', className: classNames({ 'bg-theme-allowed': allowThemeInvert }) }, "Email"),
                    React__default.createElement(Radio, { value: 'SMS', className: classNames({ 'bg-theme-allowed': allowThemeInvert }) }, "Text Message")))) : null,
            React__default.createElement(SubmitWrap, null,
                React__default.createElement(TermConditionWrap, { className: "terms-group" },
                    React__default.createElement("div", { className: "first-checkbox" },
                        React__default.createElement(Checkbox, { checked: questionsValue['terms_and_conditions'], onChange: function (e) {
                                trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.PERSONAL_INFORMATION_TNC);
                                onChangeHandler('terms_and_conditions', e.target.checked);
                            } },
                            React__default.createElement(Text$1.B2, { className: classNames({
                                    'bg-theme-allowed': allowThemeInvert,
                                    required: getFieldRequired(page, 'terms_and_conditions')
                                }), dangerouslySetInnerHTML: {
                                    __html: replace$1(getFieldValue(page, 'terms_and_conditions') || '', "traget'_blank'", "target='_blank'")
                                } })),
                        showError && invalidQuestions['terms_and_conditions'] && React__default.createElement(ErrorMsg$3, null, "This field is required")),
                    showField(page, 'agree_to_contact') && (React__default.createElement("div", { className: "second-checkbox" },
                        React__default.createElement(Checkbox, { checked: questionsValue['agree_to_contact'], onChange: function (e) {
                                trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.PERSONAL_INFORMATION_ATC);
                                onChangeHandler('agree_to_contact', e.target.checked);
                            } },
                            React__default.createElement(Text$1.B2, { className: classNames({
                                    'bg-theme-allowed': allowThemeInvert,
                                    required: getFieldRequired(page, 'agree_to_contact')
                                }) }, getFieldValue(page, 'agree_to_contact'))),
                        showError && invalidQuestions['agree_to_contact'] && React__default.createElement(ErrorMsg$3, null, "This field is required"))),
                    showField(page, 'optin') && (React__default.createElement("div", { className: "first-checkbox mt-2" },
                        React__default.createElement(Checkbox, { checked: questionsValue['optin'], onChange: function (e) {
                                trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.PERSONAL_INFORMATION_OPTIN);
                                onChangeHandler('optin', e.target.checked);
                            } },
                            React__default.createElement(Text$1.B2, { className: classNames({
                                    'bg-theme-allowed': allowThemeInvert,
                                    required: getFieldRequired(page, 'optin')
                                }), dangerouslySetInnerHTML: {
                                    __html: getFieldValue(page, 'optin') || ''
                                } }))))),
                React__default.createElement(Button, { block: true, className: "btn mb-10", onClick: handleSubmitPage, disabled: tncUnchecked || agreeUnchecked },
                    React__default.createElement("div", { dangerouslySetInnerHTML: { __html: getFieldValue(page, 'button_text') || '' } }))))));
};
var templateObject_1$5, templateObject_2$5, templateObject_3$4, templateObject_4$3, templateObject_5$3, templateObject_6$3, templateObject_7$2, templateObject_8$2;

var v = "5.6.3";
var fr = 30;
var ip = 0;
var op = 51;
var w = 240;
var h = 240;
var nm = "loading";
var ddd = 0;
var assets = [
	{
		id: "comp_0",
		layers: [
			{
				ddd: 0,
				ind: 1,
				ty: 4,
				nm: "Shape Layer 1",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.667,
									y: 1
								},
								o: {
									x: 0.345,
									y: 0
								},
								t: 10,
								s: [
									120,
									120,
									0
								],
								to: [
									0,
									-4.917,
									0
								],
								ti: [
									0,
									-2.417,
									0
								]
							},
							{
								i: {
									x: 0.385,
									y: 1
								},
								o: {
									x: 0.333,
									y: 0
								},
								t: 20,
								s: [
									120,
									90.5,
									0
								],
								to: [
									0,
									2.417,
									0
								],
								ti: [
									0,
									-3.833,
									0
								]
							},
							{
								i: {
									x: 0.44,
									y: 1
								},
								o: {
									x: 0.594,
									y: 0
								},
								t: 30,
								s: [
									120,
									134.5,
									0
								],
								to: [
									0,
									3.833,
									0
								],
								ti: [
									0,
									2.417,
									0
								]
							},
							{
								i: {
									x: 0.44,
									y: 1
								},
								o: {
									x: 0.167,
									y: 0
								},
								t: 40,
								s: [
									120,
									113.5,
									0
								],
								to: [
									0,
									-2.417,
									0
								],
								ti: [
									0,
									-1.083,
									0
								]
							},
							{
								t: 50,
								s: [
									120,
									120,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							0,
							0,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								d: 1,
								ty: "el",
								s: {
									a: 0,
									k: [
										30,
										30
									],
									ix: 2
								},
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 3
								},
								nm: "Ellipse Path 1",
								mn: "ADBE Vector Shape - Ellipse",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.286274988511,
										0.427451010311,
										0.815685975318,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 4,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										0.8980392156862745,
										0,
										0.23137254901960785,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Ellipse 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					}
				],
				ip: 0,
				op: 61,
				st: 0,
				bm: 0
			}
		]
	}
];
var layers = [
	{
		ddd: 0,
		ind: 1,
		ty: 0,
		nm: "dot",
		refId: "comp_0",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					159.5,
					120,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					120,
					120,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		w: 240,
		h: 240,
		ip: 0,
		op: 61,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 0,
		nm: "dot",
		refId: "comp_0",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					120,
					120,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					120,
					120,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		w: 240,
		h: 240,
		ip: -5,
		op: 56,
		st: -5,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 0,
		nm: "dot",
		refId: "comp_0",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					79.5,
					120,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					120,
					120,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		w: 240,
		h: 240,
		ip: -10,
		op: 51,
		st: -10,
		bm: 0
	}
];
var markers = [
];
var boostSurveyLoading = {
	v: v,
	fr: fr,
	ip: ip,
	op: op,
	w: w,
	h: h,
	nm: nm,
	ddd: ddd,
	assets: assets,
	layers: layers,
	markers: markers
};

var baseGetTag = _baseGetTag,
    isObjectLike = isObjectLike_1;

/** `Object#toString` result references. */
var regexpTag = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp$1(value) {
  return isObjectLike(value) && baseGetTag(value) == regexpTag;
}

var _baseIsRegExp = baseIsRegExp$1;

var baseIsRegExp = _baseIsRegExp,
    baseUnary = _baseUnary,
    nodeUtil = _nodeUtilExports;

/* Node.js helper references. */
var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp$1 = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

var isRegExp_1 = isRegExp$1;

var baseToString = _baseToString,
    castSlice = _castSlice,
    hasUnicode = _hasUnicode,
    isObject = isObject_1,
    isRegExp = isRegExp_1,
    stringSize = _stringSize,
    stringToArray = _stringToArray,
    toInteger = toInteger_1,
    toString = toString_1;

/** Used as default options for `_.truncate`. */
var DEFAULT_TRUNC_LENGTH = 30,
    DEFAULT_TRUNC_OMISSION = '...';

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Truncates `string` if it's longer than the given maximum string length.
 * The last characters of the truncated string are replaced with the omission
 * string which defaults to "...".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to truncate.
 * @param {Object} [options={}] The options object.
 * @param {number} [options.length=30] The maximum string length.
 * @param {string} [options.omission='...'] The string to indicate text is omitted.
 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
 * @returns {string} Returns the truncated string.
 * @example
 *
 * _.truncate('hi-diddly-ho there, neighborino');
 * // => 'hi-diddly-ho there, neighbo...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': ' '
 * });
 * // => 'hi-diddly-ho there,...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': /,? +/
 * });
 * // => 'hi-diddly-ho there...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'omission': ' [...]'
 * });
 * // => 'hi-diddly-ho there, neig [...]'
 */
function truncate(string, options) {
  var length = DEFAULT_TRUNC_LENGTH,
      omission = DEFAULT_TRUNC_OMISSION;

  if (isObject(options)) {
    var separator = 'separator' in options ? options.separator : separator;
    length = 'length' in options ? toInteger(options.length) : length;
    omission = 'omission' in options ? baseToString(options.omission) : omission;
  }
  string = toString(string);

  var strLength = string.length;
  if (hasUnicode(string)) {
    var strSymbols = stringToArray(string);
    strLength = strSymbols.length;
  }
  if (length >= strLength) {
    return string;
  }
  var end = length - stringSize(omission);
  if (end < 1) {
    return omission;
  }
  var result = strSymbols
    ? castSlice(strSymbols, 0, end).join('')
    : string.slice(0, end);

  if (separator === undefined) {
    return result + omission;
  }
  if (strSymbols) {
    end += (result.length - end);
  }
  if (isRegExp(separator)) {
    if (string.slice(end).search(separator)) {
      var match,
          substring = result;

      if (!separator.global) {
        separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
      }
      separator.lastIndex = 0;
      while ((match = separator.exec(substring))) {
        var newEnd = match.index;
      }
      result = result.slice(0, newEnd === undefined ? end : newEnd);
    }
  } else if (string.indexOf(baseToString(separator), end) != end) {
    var index = result.lastIndexOf(separator);
    if (index > -1) {
      result = result.slice(0, index);
    }
  }
  return result + omission;
}

var truncate_1 = truncate;

var truncate$1 = /*@__PURE__*/getDefaultExportFromCjs(truncate_1);

var BoostRedirect$1 = defaultStyled.div(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  padding: 0.625rem;\n  width: 100%;\n  justify-content: flex-end;\n  strong {\n    padding-left: 0.125rem;\n    color: ", ";\n  }\n\n  svg path {\n    fill: ", ";\n  }\n\n  .redirect-anchor {\n    color: rgba(55, 53, 47, 0.65);\n    text-decoration: underline;\n    caret-color: rgb(55, 53, 47);\n    cursor: pointer;\n  }\n\n  .counter-dot span {\n    animation-name: blink;\n    animation-duration: 2.4s;\n    animation-iteration-count: infinite;\n    animation-fill-mode: both;\n    color: ", ";\n  }\n\n  .counter-dot span:nth-child(2) {\n    animation-delay: 0.2s;\n  }\n\n  .counter-dot span:nth-child(3) {\n    animation-delay: 0.4s;\n  }\n\n  @keyframes blink {\n    0% {\n      opacity: 0.2;\n    }\n    20% {\n      opacity: 1;\n    }\n    100% {\n      opacity: 0.2;\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  padding: 0.625rem;\n  width: 100%;\n  justify-content: flex-end;\n  strong {\n    padding-left: 0.125rem;\n    color: ", ";\n  }\n\n  svg path {\n    fill: ", ";\n  }\n\n  .redirect-anchor {\n    color: rgba(55, 53, 47, 0.65);\n    text-decoration: underline;\n    caret-color: rgb(55, 53, 47);\n    cursor: pointer;\n  }\n\n  .counter-dot span {\n    animation-name: blink;\n    animation-duration: 2.4s;\n    animation-iteration-count: infinite;\n    animation-fill-mode: both;\n    color: ", ";\n  }\n\n  .counter-dot span:nth-child(2) {\n    animation-delay: 0.2s;\n  }\n\n  .counter-dot span:nth-child(3) {\n    animation-delay: 0.4s;\n  }\n\n  @keyframes blink {\n    0% {\n      opacity: 0.2;\n    }\n    20% {\n      opacity: 1;\n    }\n    100% {\n      opacity: 0.2;\n    }\n  }\n"])), function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
});
var ThankYouTextWrap$1 = defaultStyled.div(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  margin-top: 1.25rem;\n\n  cursor: pointer;\n  text-align: center;\n\n  span {\n    color: #a0a0a0;\n  }\n"], ["\n  margin-top: 1.25rem;\n\n  cursor: pointer;\n  text-align: center;\n\n  span {\n    color: #a0a0a0;\n  }\n"])));
var BoostReviewBox$1 = defaultStyled.div(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n  .boost-review-header {\n    line-height: 120%;\n    display: flex;\n    margin-top: 1.875rem;\n  }\n\n  .boost-review-header {\n    .clipboard-text {\n      padding-left: 0.625rem;\n      color: var(--slate-gray-dark);\n    }\n    .review-clipboard-text {\n      color: var(--slate-gray-dark);\n      font-family: var(--font-family-medium) !important;\n      font-size: 0.875rem;\n      font-weight: 500;\n      line-height: 1.125rem;\n      padding: 0 0.625rem;\n    }\n  }\n\n  .boost-review-text {\n    font-style: italic;\n    padding: 0 1.563rem;\n    margin-top: 0.625rem;\n    max-height: 150px;\n    overflow-y: scroll;\n  }\n"], ["\n  .boost-review-header {\n    line-height: 120%;\n    display: flex;\n    margin-top: 1.875rem;\n  }\n\n  .boost-review-header {\n    .clipboard-text {\n      padding-left: 0.625rem;\n      color: var(--slate-gray-dark);\n    }\n    .review-clipboard-text {\n      color: var(--slate-gray-dark);\n      font-family: var(--font-family-medium) !important;\n      font-size: 0.875rem;\n      font-weight: 500;\n      line-height: 1.125rem;\n      padding: 0 0.625rem;\n    }\n  }\n\n  .boost-review-text {\n    font-style: italic;\n    padding: 0 1.563rem;\n    margin-top: 0.625rem;\n    max-height: 150px;\n    overflow-y: scroll;\n  }\n"])));
var BoostPageWrap$1 = defaultStyled.div(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n  height: 100%;\n  .ant-btn {\n    margin-top: 1.875rem;\n  }\n\n  .boost-page-logo {\n    margin-top: 1.875rem;\n  }\n"], ["\n  height: 100%;\n  .ant-btn {\n    margin-top: 1.875rem;\n  }\n\n  .boost-page-logo {\n    margin-top: 1.875rem;\n  }\n"])));
var BoostPageTitile$1 = defaultStyled.div(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n  text-align: center;\n  padding-bottom: 1.25rem;\n  padding-left: 1.563rem;\n  padding-right: 1.563rem;\n  border-bottom: 1px solid var(--grey-light);\n"], ["\n  text-align: center;\n  padding-bottom: 1.25rem;\n  padding-left: 1.563rem;\n  padding-right: 1.563rem;\n  border-bottom: 1px solid var(--grey-light);\n"])));
var BoostTitle$1 = defaultStyled.div(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject(["\n  width: 70%;\n  text-align: center;\n  margin: 0 auto;\n  margin-top: 1.25rem;\n\n  h2::first-line {\n    color: ", ";\n  }\n"], ["\n  width: 70%;\n  text-align: center;\n  margin: 0 auto;\n  margin-top: 1.25rem;\n\n  h2::first-line {\n    color: ", ";\n  }\n"])), function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
});
var FeedbackUserReviewInfoWrap$1 = defaultStyled.div(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n  flex-direction: column;\n  .review-platform-icon {\n    transform: scale(0.75);\n    position: absolute;\n    right: 12px;\n    background: var(--white);\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    padding: 0.313rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n"], ["\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n  flex-direction: column;\n  .review-platform-icon {\n    transform: scale(0.75);\n    position: absolute;\n    right: 12px;\n    background: var(--white);\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    padding: 0.313rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n"])));
var FeedbackUserInfoWrap$1 = defaultStyled.div(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: flex-start;\n  border: 1px solid var(--disable-grey);\n  padding: 0.625rem;\n  margin: 0.625rem 0rem;\n  border-radius: 0.625rem;\n\n  .boost-review-message {\n    font-family: var(--font-family-medium) !important;\n    font-size: 0.875rem;\n    font-weight: 500;\n    line-height: 1.05rem;\n    margin-top: 0.625rem;\n    max-height: 135px;\n    color: #30384c;\n    white-space: normal;\n    text-overflow: ellipsis;\n    word-break: break-word;\n    width: 99%;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n  }\n\n  .feedback-user-name {\n    font-family: var(--font-family-medium) !important;\n    font-size: 0.875rem;\n    font-weight: 700;\n    line-height: 1.05rem;\n    text-align: left;\n    margin-bottom: 0.125rem;\n    color: #30384c;\n  }\n\n  .time {\n    font-family: var(--font-family-regular) !important;\n    font-size: 0.75rem;\n    font-weight: 500;\n    line-height: 11.05rem\n    text-align: left;\n    color: var(--grey-semi-light);\n    margin-bottom: 0.125rem;\n  }\n"], ["\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: flex-start;\n  border: 1px solid var(--disable-grey);\n  padding: 0.625rem;\n  margin: 0.625rem 0rem;\n  border-radius: 0.625rem;\n\n  .boost-review-message {\n    font-family: var(--font-family-medium) !important;\n    font-size: 0.875rem;\n    font-weight: 500;\n    line-height: 1.05rem;\n    margin-top: 0.625rem;\n    max-height: 135px;\n    color: #30384c;\n    white-space: normal;\n    text-overflow: ellipsis;\n    word-break: break-word;\n    width: 99%;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n  }\n\n  .feedback-user-name {\n    font-family: var(--font-family-medium) !important;\n    font-size: 0.875rem;\n    font-weight: 700;\n    line-height: 1.05rem;\n    text-align: left;\n    margin-bottom: 0.125rem;\n    color: #30384c;\n  }\n\n  .time {\n    font-family: var(--font-family-regular) !important;\n    font-size: 0.75rem;\n    font-weight: 500;\n    line-height: 11.05rem\n    text-align: left;\n    color: var(--grey-semi-light);\n    margin-bottom: 0.125rem;\n  }\n"])));
var StyledIcon$1 = defaultStyled.span(templateObject_9$1 || (templateObject_9$1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  svg {\n    width: ", ";\n    height: ", ";\n  }\n"], ["\n  width: ", ";\n  height: ", ";\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  svg {\n    width: ", ";\n    height: ", ";\n  }\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? 16 : _b;
    return "".concat(size, "px");
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? 16 : _b;
    return "".concat(size, "px");
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? 16 : _b;
    return "".concat(size, "px");
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? 16 : _b;
    return "".concat(size, "px");
});
var FeedbackUserRating$1 = defaultStyled.div(templateObject_10$1 || (templateObject_10$1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  margin-right: 5px;\n  height: 16px;\n"], ["\n  display: flex;\n  align-items: center;\n  margin-right: 5px;\n  height: 16px;\n"])));
var BoostPageCancelWrap$1 = defaultStyled.div(templateObject_11$1 || (templateObject_11$1 = __makeTemplateObject(["\n  margin-top: 10px;\n  cursor: pointer;\n  text-align: center;\n\n  span {\n    color: #a0a0a0;\n  }\n"], ["\n  margin-top: 10px;\n  cursor: pointer;\n  text-align: center;\n\n  span {\n    color: #a0a0a0;\n  }\n"])));
var LogoWrap$1 = defaultStyled.div(templateObject_12$1 || (templateObject_12$1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    height: 110px;\n    object-fit: contain;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    height: 110px;\n    object-fit: contain;\n  }\n"])));
var BoostPage = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var page = _a.page, pages = _a.pages, theme = _a.theme, onNextPage = _a.onNextPage, editorMode = _a.editorMode, surveySetting = _a.surveySetting, handleAssistedReview = _a.handleAssistedReview, trackEvent = _a.trackEvent, surveySubmitted = _a.surveySubmitted;
    var allowThemeInvert = (theme === null || theme === void 0 ? void 0 : theme.layout) !== 'box';
    var _l = useState(false), showCancelState = _l[0], setShowCancelState = _l[1];
    var _m = useState((getFieldValue(page, 'auto_redirect') || false)), showRedirect = _m[0], setShowRedirect = _m[1];
    var _o = useState((getFieldValue(page, 'auto_redirect_counter') || 5)), counter = _o[0], setCounter = _o[1];
    var reviewText = editorMode
        ? "Great place! Love coming here. I've been here 3 times this month already. I mainly come here for the service as the people are super nice and are always there to help. Definitely going to come here more often. You have a new loyal customer! Special shoutout to Jerry who really took care of us."
        : getFieldValue(page, 'review_text');
    var reviewerName = editorMode
        ? 'Grant Oliveria'
        : (_c = (_b = pages.find(function (page) { return page.pageKey === PAGE_KEYS.PERSONAL_INFORMATION; })) === null || _b === void 0 ? void 0 : _b.selectedValue) === null || _c === void 0 ? void 0 : _c.name;
    var ratingPage = pages.find(function (page) { return page.pageKey === PAGE_KEYS.RATINGS; });
    var starRating = editorMode
        ? 5
        : ((_e = (_d = ratingPage === null || ratingPage === void 0 ? void 0 : ratingPage.selectedValue) === null || _d === void 0 ? void 0 : _d.main) === null || _e === void 0 ? void 0 : _e.value) ||
            ((_g = (_f = ratingPage === null || ratingPage === void 0 ? void 0 : ratingPage.selectedValue) === null || _f === void 0 ? void 0 : _f.rating) === null || _g === void 0 ? void 0 : _g.value) ||
            ((_h = ratingPage === null || ratingPage === void 0 ? void 0 : ratingPage.selectedValue) === null || _h === void 0 ? void 0 : _h.value);
    useEffect(function () {
        if (!get$2(surveySetting, 'reviewBoosting', true)) {
            console.log("Going on to the next page now.... ".concat(get$2(surveySetting, 'reviewBoosting', true), " "));
            onNextPage();
        }
    }, []);
    useEffect(function () {
        var newCounter = (getFieldValue(page, 'auto_redirect_counter') || 5);
        var newShowRedirectValue = (getFieldValue(page, 'auto_redirect') || false);
        if (showRedirect !== newShowRedirectValue) {
            setShowRedirect(newShowRedirectValue);
        }
        if (counter !== newCounter) {
            setCounter(newCounter);
        }
    }, [page]);
    var onBoostReviewClick = function () {
        if (!editorMode && isClient() && navigator) {
            handleAssistedReview && handleAssistedReview('GOOGLE');
            if (reviewText && typeof reviewText === 'string')
                copy$1(reviewText || '');
            window === null || window === void 0 ? void 0 : window.open(page.selectedLocationReviewLink, '_blank');
        }
        onNextPage();
    };
    var onBoostReviewClickV1 = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 4, , 5]);
                    if (!(!editorMode && isClient() && navigator)) return [3 /*break*/, 3];
                    _a = handleAssistedReview;
                    if (!_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, handleAssistedReview('GOOGLE')];
                case 1:
                    _a = (_b.sent());
                    _b.label = 2;
                case 2:
                    response = window === null || window === void 0 ? void 0 : window.open(page.selectedLocationReviewLink, '_blank');
                    if (response !== null) {
                        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.BOOST_PAGE_BOOST_REDIRECT_NEW_TAB);
                    }
                    else if (response === null && (page === null || page === void 0 ? void 0 : page.selectedLocationReviewLink)) {
                        window.location.href = page === null || page === void 0 ? void 0 : page.selectedLocationReviewLink;
                        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.BOOST_PAGE_BOOST_REDIRECT_SAME_TAB);
                    }
                    _b.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    _b.sent();
                    console.error('An error occured while redirecting to the link');
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (!editorMode && showRedirect) {
            var interval_1 = setInterval(function () {
                counter > 0 && setCounter(function (prevCounter) { return prevCounter - 1; });
            }, 1000);
            return function () { return clearInterval(interval_1); };
        }
    }, []);
    useEffect(function () {
        if (!showCancelState && showRedirect && counter === 0 && surveySubmitted) {
            trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.BOOST_PAGE_BOOST);
            trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.BOOST_PAGE_BOOST_REDIRECT);
            onBoostReviewClickV1();
        }
    }, [counter, surveySubmitted]);
    var renderLottieLoader = function () {
        try {
            return React__default.createElement(Lottie, { animationData: boostSurveyLoading, loop: true, style: { color: theme === null || theme === void 0 ? void 0 : theme.color, height: 65 } });
        }
        catch (error) {
            console.error(error);
            return React__default.createElement(React__default.Fragment, null);
        }
    };
    var BoostActionButtons = (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Button, { block: true, className: "btn", onClick: function () {
                trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.BOOST_PAGE_BOOST);
                onBoostReviewClick();
            } },
            React__default.createElement("div", { dangerouslySetInnerHTML: { __html: getFieldValue(page, 'button_text') || 'Post on Google' } })),
        React__default.createElement(ThankYouTextWrap$1, { onClick: function () {
                trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.BOOST_PAGE_NO_THANK);
                onNextPage();
            } },
            React__default.createElement(Text$1.B1, { className: classNames('text-center', { 'bg-theme-allowed': allowThemeInvert }) }, "No, thank you"))));
    var BoostButtonRenderer = (React__default.createElement(React__default.Fragment, null,
        isString$4(reviewText) && !isEmpty$1(reviewText) && (React__default.createElement(BoostReviewBox$1, null,
            showField(page, 'copy_clipboard') && (React__default.createElement("div", { className: classNames('boost-review-header', { 'bg-theme-allowed': allowThemeInvert }) },
                React__default.createElement(Icon, { name: "CommentQuote", type: "outline", size: 15 }),
                React__default.createElement(Text$1.B1, { className: classNames('clipboard-text', { 'bg-theme-allowed': allowThemeInvert }), dangerouslySetInnerHTML: { __html: getFieldValue(page, 'copy_clipboard') || '' } }))),
            showField(page, 'review_text', true) && (React__default.createElement("div", { className: "boost-review-text" },
                React__default.createElement(Text$1.B1, null,
                    "\"",
                    truncate$1(reviewText, {
                        length: 125,
                        omission: '...'
                    }),
                    "\""))))),
        BoostActionButtons));
    var BoostRedirectRenderer = (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(BoostReviewBox$1, null, showField(page, 'copy_clipboard') && (React__default.createElement("div", { className: "boost-review-header" },
            React__default.createElement(Text$1.B1, { className: classNames('review-clipboard-text', { 'bg-theme-allowed': allowThemeInvert }), dangerouslySetInnerHTML: { __html: getFieldValue(page, 'copy_clipboard') || '' } })))),
        React__default.createElement(FeedbackUserInfoWrap$1, null,
            React__default.createElement(FeedbackUserReviewInfoWrap$1, null,
                React__default.createElement("div", { className: "review-platform-icon" },
                    React__default.createElement(StyledIcon$1, { size: 24 },
                        React__default.createElement(Icon, { name: "Google", type: "partners" }))),
                React__default.createElement("div", { className: classNames('feedback-user-name', { 'bg-theme-allowed': allowThemeInvert }) }, reviewerName),
                React__default.createElement("div", { className: classNames('time', { 'bg-theme-allowed': allowThemeInvert }) }, "".concat((_j = moment()) === null || _j === void 0 ? void 0 : _j.format('DD MMMM YYYY'))),
                starRating && (React__default.createElement(FeedbackUserRating$1, null,
                    React__default.createElement(Input.Rating, { type: 'boost', count: 5, value: starRating }))),
                showField(page, 'review_text', true) && (React__default.createElement("div", { className: classNames('boost-review-message', { 'bg-theme-allowed': allowThemeInvert }) }, reviewText)))),
        React__default.createElement(BoostRedirect$1, { "$theme": theme },
            !showCancelState && counter > 0 && (React__default.createElement(React__default.Fragment, null,
                renderLottieLoader(),
                React__default.createElement(Text$1.H4, { semibold: true, className: classNames('text-center', { 'bg-theme-allowed': allowThemeInvert }), dangerouslySetInnerHTML: {
                        __html: "".concat((_k = getFieldValue(page, 'auto_redirect_text')) === null || _k === void 0 ? void 0 : _k.replace('{{counter}}', "<strong class=\"counter-dot\">".concat(counter >= 0 ? counter : 0))) || "Redirect to Google, please wait ".concat(counter >= 0 ? counter : 0)
                    } }))),
            (counter <= 0 || showCancelState) && BoostActionButtons,
            !showCancelState && counter > 0 && (React__default.createElement(BoostPageCancelWrap$1, { onClick: function () {
                    setShowCancelState(true);
                    trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.BOOST_PAGE_BOOST_REDIRECT_CANCEL);
                } },
                React__default.createElement(Text$1.B2, { className: classNames('text-center', { 'bg-theme-allowed': allowThemeInvert }) }, "Cancel"))))));
    return get$2(surveySetting, 'reviewBoosting', true) ? (React__default.createElement(BoostPageWrap$1, null,
        React__default.createElement("div", { className: "page-content" },
            React__default.createElement(BrandInfo, { page: page }),
            showField(page, 'header_text') && (React__default.createElement(BoostPageTitile$1, null,
                React__default.createElement(Text$1.H5, { semibold: true, className: classNames('text-center', { 'bg-theme-allowed': allowThemeInvert }), dangerouslySetInnerHTML: { __html: getFieldValue(page, 'header_text') || '' } }))),
            React__default.createElement(LogoWrap$1, { className: classNames('boost-page-logo', { 'bg-theme-allowed': allowThemeInvert }) },
                React__default.createElement(Logo, { name: 'Google', type: "bubble-original-color", size: 50 })),
            showField(page, 'main_title') && (React__default.createElement(BoostTitle$1, { "$theme": theme },
                React__default.createElement(Text$1.H2, { semibold: true, className: classNames('text-center', { 'bg-theme-allowed': allowThemeInvert }), dangerouslySetInnerHTML: { __html: getFieldValue(page, 'main_title') || '' } }))),
            showRedirect ? BoostRedirectRenderer : BoostButtonRenderer))) : (React__default.createElement(React__default.Fragment, null));
};
var templateObject_1$4, templateObject_2$4, templateObject_3$3, templateObject_4$2, templateObject_5$2, templateObject_6$2, templateObject_7$1, templateObject_8$1, templateObject_9$1, templateObject_10$1, templateObject_11$1, templateObject_12$1;

var CaptionTextWrap$1 = defaultStyled.div(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  margin-bottom: 1.25rem;\n"], ["\n  margin-bottom: 1.25rem;\n"])));
var MultiSelectWrap$1 = defaultStyled.div(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  margin-bottom: 0.625rem;\n"], ["\n  margin-bottom: 0.625rem;\n"])));
var ErrorMsg$2 = defaultStyled(Text$1.B2)(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n  color: var(--indian-red);\n"], ["\n  color: var(--indian-red);\n"])));
var ExperiencePositivePage = function (_a) {
    var _b;
    var page = _a.page, onNextPage = _a.onNextPage, editorMode = _a.editorMode, trackEvent = _a.trackEvent;
    var _c = useState([]), selectedTags = _c[0], setSelectedTags = _c[1];
    var _d = useState(false), showError = _d[0], setShowError = _d[1];
    var getExperienceTagsOptions = function () {
        var _a, _b;
        var tagsToShow = [];
        var isDependentOnOrderType = showField(page, 'dependent_order_type', true);
        if (!isDependentOnOrderType) {
            tagsToShow = getFieldValue(page, 'tags');
        }
        else {
            // if not editorMode, to show dependent_order_type tags, check which type_of_order was selected and show tags accordingly
            if (!editorMode) {
                if (page.selectedOrderType == ORDER_TYPE.DINE_IN)
                    tagsToShow = getFieldValue(page, 'tags_dine_in');
                else if (page.selectedOrderType == ORDER_TYPE.DELIVERY)
                    tagsToShow = getFieldValue(page, 'tags_delivery');
                else if (page.selectedOrderType == ORDER_TYPE.TAKE_AWAY)
                    tagsToShow = getFieldValue(page, 'tags_take_away');
                else
                    tagsToShow = getFieldValue(page, page.selectedOrderType || '') || []; // for custom service-types
            }
            else {
                var tagsDineIn = isHiddenField(page, 'tags_dine_in') ? [] : getFieldValue(page, 'tags_dine_in');
                var tagsDelivery = isHiddenField(page, 'tags_delivery')
                    ? []
                    : getFieldValue(page, 'tags_delivery');
                var tagsTakeAway = isHiddenField(page, 'tags_take_away')
                    ? []
                    : getFieldValue(page, 'tags_take_away');
                var customTags = (_b = (_a = page.value) === null || _a === void 0 ? void 0 : _a.find(function (f) { return f.fieldType === 'tags' && !f.isHiddenField; })) === null || _b === void 0 ? void 0 : _b.fieldValue;
                tagsToShow =
                    tagsDineIn.length > 0
                        ? tagsDineIn
                        : tagsDelivery.length > 0
                            ? tagsDelivery
                            : tagsTakeAway.length > 0
                                ? tagsTakeAway
                                : customTags || [];
            }
        }
        return tagsToShow.map(function (value) {
            return {
                text: value,
                iconName: ''
            };
        });
    };
    var handleSubmitPage = function () {
        if (getFieldRequired(page, 'required') && selectedTags.length === 0) {
            setShowError(true);
            return;
        }
        setShowError(false);
        onNextPage(selectedTags);
    };
    useEffect(function () {
        if (selectedTags.length) {
            setShowError(false);
        }
    }, [selectedTags]);
    useEffect(function () {
        var _a;
        if ((_a = page === null || page === void 0 ? void 0 : page.selectedValue) === null || _a === void 0 ? void 0 : _a.length) {
            setSelectedTags(page === null || page === void 0 ? void 0 : page.selectedValue);
        }
    }, [(_b = page === null || page === void 0 ? void 0 : page.selectedValue) === null || _b === void 0 ? void 0 : _b.length]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(BrandInfo, { page: page }),
        showField(page, 'title') && (React__default.createElement("div", { className: "page-title" },
            React__default.createElement(Text$1.H2, { semibold: true, dangerouslySetInnerHTML: { __html: getFieldValue(page, 'title') || '' } }))),
        React__default.createElement("div", { className: "page-content" },
            showField(page, 'caption') && (React__default.createElement(CaptionTextWrap$1, null,
                React__default.createElement(Text$1.B1, { dangerouslySetInnerHTML: { __html: getFieldValue(page, 'caption') || '' }, className: getFieldRequired(page, 'required') ? 'required' : '' }))),
            React__default.createElement(MultiSelectWrap$1, null,
                React__default.createElement(Input.MultiSelect, { options: getExperienceTagsOptions(), fieldKey: "text", className: "survey-multi-select", value: selectedTags, onChange: function (value) {
                        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.EXPERIENCE_POSITIVE_CHOOSE_TAG);
                        setSelectedTags(value);
                    } })),
            showError && React__default.createElement(ErrorMsg$2, null, "This field is required")),
        React__default.createElement(FloatingBtn, { onClick: handleSubmitPage })));
};
var templateObject_1$3, templateObject_2$3, templateObject_3$2;

var baseIsEqual = _baseIsEqual;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

var isEqual_1 = isEqual;

var isEqual$1 = /*@__PURE__*/getDefaultExportFromCjs(isEqual_1);

var FieldWrap = defaultStyled.div(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 0.938rem;\n\n  > span {\n    margin-bottom: 0.625rem;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 0.938rem;\n\n  > span {\n    margin-bottom: 0.625rem;\n  }\n"])));
var ErrorMsg$1 = defaultStyled(Text$1.B2)(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n  color: var(--indian-red);\n"], ["\n  color: var(--indian-red);\n"])));
var ExperienceDetailsPage = function (_a) {
    var page = _a.page, pages = _a.pages, onNextPage = _a.onNextPage, uploadRequest = _a.uploadRequest, editorMode = _a.editorMode, trackEvent = _a.trackEvent, surveySetting = _a.surveySetting, visibleQuestionsMap = _a.visibleQuestionsMap, allQuestionsRulesFromEngine = _a.allQuestionsRulesFromEngine, selectedValueFactMap = _a.selectedValueFactMap;
    var _b = useState(visibleQuestionsMap || {}), visibleQuestionsRecord = _b[0], setVisibleQuestionsRecord = _b[1];
    var _c = useState(selectedValueFactMap), selectedFactMap = _c[0], setSelectedFactMap = _c[1];
    var _d = useState(false), showLoading = _d[0], setShowLoading = _d[1];
    var _e = useState({}), questionsValue = _e[0], setQuestionsValue = _e[1];
    var _f = useState({}), invalidQuestions = _f[0], setInvalidQuestions = _f[1];
    var _g = useState(false), showError = _g[0], setShowError = _g[1];
    var isSurveyFeedbackSurveyV2Enabled = isEqual$1(surveySetting.template, SURVEY_TEMPLATES.STD_FEEDBACK_SURVEY_V2);
    useEffect(function () {
        setVisibleQuestionsRecord(__assign(__assign({}, visibleQuestionsMap), visibleQuestionsRecord));
    }, [visibleQuestionsMap]);
    useEffect(function () {
        setSelectedFactMap(selectedValueFactMap);
    }, [selectedValueFactMap]);
    // set default values for express survey
    useEffect(function () {
        var defaultComment = getFieldAnswerValue(page, 'title', 'comment') || '';
        var defaultOrderReferenceNumber = getFieldAnswerValue(page, 'order_reference_number', 'orderReferenceNumber') || '';
        var defaultOrderDate = getFieldAnswerValue(page, 'visit_date', 'orderDate')
            ? moment(getFieldAnswerValue(page, 'visit_date', 'orderDate'))
            : undefined;
        var defaultOrderTime = getFieldAnswerValue(page, 'visit_time', 'orderTime')
            ? moment(getFieldAnswerValue(page, 'visit_time', 'orderTime'))
            : undefined;
        setQuestionsValue(__assign(__assign({}, questionsValue), { comment: defaultComment, order_reference_number: defaultOrderReferenceNumber, visit_date: defaultOrderDate, visit_time: defaultOrderTime }));
    }, [page]);
    useEffect(function () {
        scrollToErrorElement();
    }, [showError]);
    var shouldRenderMainCommentField = function () {
        var mainCommentVisible = true;
        try {
            if (editorMode) {
                return mainCommentVisible;
            }
            var ratingDependency = showQuestionField(page, 'rating_dependency', true);
            var serviceTypeDependency = showQuestionField(page, 'service_type_dependency', true);
            var showOnPositiveRating = showQuestionField(page, 'show_question_if_rating', true) ||
                getFieldQuestionValue(page, 'show_question_if_rating');
            // Determine the rating range based on whether it should be shown on positive rating or not
            var ratingRange = showOnPositiveRating ? surveySetting.positiveRating : surveySetting.negativeRating;
            // Check if the current rating is under the specified range and the service type matches the question
            if (ratingDependency && serviceTypeDependency) {
                mainCommentVisible =
                    isCurrentRatingIsUnderRange(pages, ratingRange, 'ratings') && isServiceTypeMatchingQuestion(pages, page);
            }
            else if (ratingDependency) {
                mainCommentVisible = isCurrentRatingIsUnderRange(pages, ratingRange, 'ratings');
            }
            else if (serviceTypeDependency) {
                mainCommentVisible = isServiceTypeMatchingQuestion(pages, page);
            }
            return mainCommentVisible;
        }
        catch (error) {
            console.error('An error occured while rendering the main comment field');
            return mainCommentVisible;
        }
    };
    var canShowCommentField = useMemo(function () {
        return isSurveyFeedbackSurveyV2Enabled
            ? (!editorMode &&
                visibleQuestionsRecord &&
                has$1(visibleQuestionsRecord, 'comment') &&
                !visibleQuestionsRecord['comment']
                ? false
                : true) && shouldRenderMainCommentField()
            : shouldRenderMainCommentField();
    }, [isSurveyFeedbackSurveyV2Enabled, editorMode, visibleQuestionsRecord]);
    var uploadImage = function (options) { return __awaiter(void 0, void 0, void 0, function () {
        var onSuccess, onError, file, fmData, config, result, newFileObj, updatedFilesList, err_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(uploadRequest === null || uploadRequest === void 0 ? void 0 : uploadRequest.url)) return [3 /*break*/, 4];
                    setShowLoading(true);
                    onSuccess = options.onSuccess, onError = options.onError, file = options.file;
                    fmData = new FormData();
                    config = {
                        headers: { 'content-type': 'multipart/form-data', 'req-scope': 'MH-CP' }
                    };
                    fmData.append('media', file);
                    fmData.append('type', 'survey');
                    fmData.append('surveyId', uploadRequest.surveyId);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios$1.post(uploadRequest.url, fmData, config)];
                case 2:
                    result = _b.sent();
                    newFileObj = __assign(__assign({}, result === null || result === void 0 ? void 0 : result.data), { name: file.name, size: file.size, thumbUrl: (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.mediaUrl });
                    updatedFilesList = questionsValue['pictures']
                        ? __spreadArray(__spreadArray([], questionsValue['pictures'], true), [newFileObj], false) : [newFileObj];
                    onChangeHandler('pictures', updatedFilesList);
                    onSuccess('Ok');
                    setShowLoading(false);
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _b.sent();
                    onError({ err: err_1 });
                    setShowLoading(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onChangeHandler = function (fieldKey, value) {
        var _a, _b, _c, _d;
        if (fieldKey === 'comment') {
            var question = page.value.find(function (o) { return o.fieldKey === 'caption'; });
            if (question) {
                var isValueEmpty = !value;
                var isQuestionRequired = question.showRequired;
                // Update the validity of the question
                setInvalidQuestions(__assign(__assign({}, invalidQuestions), { comment: isQuestionRequired && isValueEmpty }));
                if (!editorMode && surveySetting.template === SURVEY_TEMPLATES.STD_FEEDBACK_SURVEY_V2) {
                    var selectedValue = value;
                    var factKey = 'comment' + '_value';
                    var updatedSelectedFactMap_1 = __assign(__assign({}, selectedFactMap), (_a = {}, _a[factKey] = selectedValue, _a));
                    getQuestionsVisibleStatus({
                        page: page,
                        factMap: updatedSelectedFactMap_1,
                        allQuestionsRulesFromEngine: allQuestionsRulesFromEngine
                    }).then(function (result) {
                        setVisibleQuestionsRecord(result);
                        setSelectedFactMap(updatedSelectedFactMap_1);
                    });
                }
                // Update the value of the question in the questionsValue state
                setQuestionsValue(__assign(__assign({}, questionsValue), { comment: value }));
            }
        }
        else {
            var question = page.value.find(function (o) { return o.fieldKey === fieldKey; });
            if (question) {
                var isValueEmpty = !value;
                var isQuestionRequired = question.showRequired;
                // Update the validity of the question
                setInvalidQuestions(__assign(__assign({}, invalidQuestions), (_b = {}, _b[question.fieldKey] = isQuestionRequired && isValueEmpty, _b)));
                if (!editorMode && surveySetting.template === SURVEY_TEMPLATES.STD_FEEDBACK_SURVEY_V2) {
                    var selectedValue = value;
                    var factKey = (question === null || question === void 0 ? void 0 : question.fieldKey) + '_value';
                    var updatedSelectedFactMap_2 = __assign(__assign({}, selectedFactMap), (_c = {}, _c[factKey] = selectedValue, _c));
                    getQuestionsVisibleStatus({
                        page: page,
                        factMap: updatedSelectedFactMap_2,
                        allQuestionsRulesFromEngine: allQuestionsRulesFromEngine
                    }).then(function (result) {
                        setVisibleQuestionsRecord(result);
                        setSelectedFactMap(updatedSelectedFactMap_2);
                    });
                }
                // Update the value of the question in the questionsValue state
                setQuestionsValue(__assign(__assign({}, questionsValue), (_d = {}, _d[question.fieldKey] = value, _d)));
            }
        }
    };
    var handleSubmitPage = function () {
        if (showError) {
            scrollToErrorElement();
        }
        // Flag to determine if the main comment is visible
        var mainCommentVisible = true;
        var inValidFormFields = {};
        var validForm = true;
        // Function to mark a question as invalid in the inValidFormFields object
        var markQuestionAsInvalid = function (fieldKey) {
            var _a;
            return __assign(__assign({}, inValidFormFields), (_a = {}, _a[fieldKey] = true, _a));
        };
        // Iterate through each question on the page
        page.value.forEach(function (question) {
            if (question.fieldKey === 'caption') {
                var isRequiredField = shouldRenderMainCommentField()
                    ? (question === null || question === void 0 ? void 0 : question.showRequired) === null || (question === null || question === void 0 ? void 0 : question.showRequired) === undefined
                        ? true
                        : question === null || question === void 0 ? void 0 : question.showRequired
                    : false;
                // Check if the question is required and its value is empty
                if (isRequiredField && !questionsValue['comment']) {
                    var isElementVisible = !editorMode &&
                        visibleQuestionsRecord &&
                        has$1(visibleQuestionsRecord, 'comment') &&
                        !visibleQuestionsRecord['comment']
                        ? false
                        : true;
                    if (isElementVisible) {
                        // Mark the question as invalid
                        inValidFormFields = markQuestionAsInvalid('comment');
                        // Set the validForm flag to false since an invalid question was found
                        validForm = false;
                    }
                }
            }
            else {
                // Check if the question is required and its value is empty
                if (question.show && question.showRequired && !questionsValue[question.fieldKey]) {
                    var isElementVisible = !editorMode &&
                        visibleQuestionsRecord &&
                        has$1(visibleQuestionsRecord, question.fieldKey) &&
                        !visibleQuestionsRecord[question.fieldKey]
                        ? false
                        : true;
                    if (isElementVisible) {
                        // Mark the question as invalid
                        inValidFormFields = markQuestionAsInvalid(question.fieldKey);
                        // Set the validForm flag to false since an invalid question was found
                        validForm = false;
                    }
                }
            }
        });
        // Update the invalidQuestions state with the inValidFormFields object
        setInvalidQuestions(inValidFormFields);
        // Show error if the form is not valid
        setShowError(!validForm);
        if (!validForm) {
            return;
        }
        // Hide the error since the form is valid
        setShowError(false);
        try {
            // Check if the question has a rating dependency
            var ratingDependency = showQuestionField(page, 'rating_dependency', true);
            var serviceTypeDependency = showQuestionField(page, 'service_type_dependency', true);
            // Check if the question should be shown based on positive rating
            var showOnPositiveRating = showQuestionField(page, 'show_question_if_rating', true) ||
                getFieldQuestionValue(page, 'show_question_if_rating');
            if (ratingDependency || serviceTypeDependency) {
                // Determine the rating range based on whether it should be shown on positive rating or not
                var ratingRange = showOnPositiveRating ? surveySetting === null || surveySetting === void 0 ? void 0 : surveySetting.positiveRating : surveySetting === null || surveySetting === void 0 ? void 0 : surveySetting.negativeRating;
                // Check if the current rating is under the specified range and the service type matches the question
                if (isSurveyFeedbackSurveyV2Enabled) {
                    mainCommentVisible =
                        !editorMode &&
                            visibleQuestionsRecord &&
                            has$1(visibleQuestionsRecord, 'comment') &&
                            !visibleQuestionsRecord['comment']
                            ? false
                            : true;
                }
                if (ratingDependency && serviceTypeDependency) {
                    mainCommentVisible =
                        isCurrentRatingIsUnderRange(pages, ratingRange, 'ratings') && isServiceTypeMatchingQuestion(pages, page);
                }
                else if (ratingDependency) {
                    mainCommentVisible = isCurrentRatingIsUnderRange(pages, ratingRange, 'ratings');
                }
                else if (serviceTypeDependency) {
                    mainCommentVisible = isServiceTypeMatchingQuestion(pages, page);
                }
            }
        }
        catch (error) {
            console.error('An error occured while checking depended questions');
        }
        if (!mainCommentVisible && !isEmpty$1(questionsValue)) {
            delete questionsValue['comment'];
        }
        // Call the onNextPage function and pass the questionsValue as the argument
        onNextPage({
            comment: questionsValue['comment'],
            orderDate: questionsValue['visit_date'],
            orderTime: questionsValue['visit_time'],
            orderReferenceNumber: questionsValue['order_reference_number'],
            pictures: questionsValue['pictures']
        }, selectedFactMap);
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(BrandInfo, { page: page }),
        showField(page, 'title') && (React__default.createElement("div", { className: "page-title" },
            React__default.createElement(Text$1.H2, { semibold: true, dangerouslySetInnerHTML: { __html: getFieldValue(page, 'title') || '' } }))),
        React__default.createElement("div", { className: "page-content" },
            canShowCommentField && (React__default.createElement(FieldWrap, { className: showError ? 'has-field-error' : '' },
                showField(page, 'caption') && (React__default.createElement(Text$1.B1, { dangerouslySetInnerHTML: { __html: getFieldValue(page, 'caption') || ' ' }, className: getFieldRequired(page, 'caption') ? 'required' : '' })),
                React__default.createElement(Input.TextArea, { className: "mb-10", placeholder: "Enter comment", value: questionsValue['comment'], onChange: function (e) {
                        onChangeHandler('comment', e.target.value);
                    }, onFocus: function () {
                        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.EXPERIENCE_DETAIL_COMMENT);
                    } }),
                showError && invalidQuestions['comment'] && React__default.createElement(ErrorMsg$1, null, "This field is required"))),
            (isSurveyFeedbackSurveyV2Enabled
                ? !editorMode &&
                    visibleQuestionsRecord &&
                    has$1(visibleQuestionsRecord, 'pictures') &&
                    !visibleQuestionsRecord['pictures']
                    ? false
                    : true
                : showField(page, 'pictures')) && (React__default.createElement(FieldWrap, { className: showError ? 'has-field-error' : '' },
                React__default.createElement(Upload, { containerClass: "survey-upload mb-10", btnTitle: "Upload Pictures", showLoading: showLoading, fileList: questionsValue['pictures'], customRequest: uploadImage, className: getFieldRequired(page, 'pictures') ? 'required' : '', disabled: editorMode, showUploadList: false, accept: "image/*,video/*,audio/*,.xlsx,.xls,.doc,.docx,.ppt,.pptx,.txt,.pdf", setFileList: function (files) {
                        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.EXPERIENCE_DETAIL_UPLOAD_FILE);
                        onChangeHandler('pictures', files);
                    } }),
                showError && invalidQuestions['pictures'] && React__default.createElement(ErrorMsg$1, null, "This field is required"))),
            (isSurveyFeedbackSurveyV2Enabled
                ? !editorMode &&
                    visibleQuestionsRecord &&
                    has$1(visibleQuestionsRecord, 'visit_date') &&
                    !visibleQuestionsRecord['visit_date']
                    ? false
                    : true
                : showField(page, 'visit_date')) && (React__default.createElement(FieldWrap, { className: showError ? 'has-field-error' : '' },
                React__default.createElement(Text$1.B1, { dangerouslySetInnerHTML: { __html: getFieldValue(page, 'visit_date') || '' }, className: getFieldRequired(page, 'visit_date') ? 'required' : '' }),
                React__default.createElement(Input.Date, { className: "mb-10", value: questionsValue['visit_date'], onChange: function (val) {
                        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.EXPERIENCE_DETAIL_VISIT_DATE);
                        onChangeHandler('visit_date', val);
                    }, format: DATE_FORMAT }),
                showError && invalidQuestions['visit_date'] && React__default.createElement(ErrorMsg$1, null, "This field is required"))),
            (isSurveyFeedbackSurveyV2Enabled
                ? !editorMode &&
                    visibleQuestionsRecord &&
                    has$1(visibleQuestionsRecord, 'visit_time') &&
                    !visibleQuestionsRecord['visit_time']
                    ? false
                    : true
                : showField(page, 'visit_time')) && (React__default.createElement(FieldWrap, { className: showError ? 'has-field-error' : '' },
                React__default.createElement(Text$1.B1, { dangerouslySetInnerHTML: { __html: getFieldValue(page, 'visit_time') || '' }, className: getFieldRequired(page, 'visit_time') ? 'required' : '' }),
                React__default.createElement(Input.Time, { type: 'modal', placeholder: "Select Time", value: questionsValue['visit_time'], className: "mb-10", onChange: function (val) {
                        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.EXPERIENCE_DETAIL_VISIT_TIME);
                        onChangeHandler('visit_time', val);
                    } }),
                showError && invalidQuestions['visit_time'] && React__default.createElement(ErrorMsg$1, null, "This field is required"))),
            (isSurveyFeedbackSurveyV2Enabled
                ? !editorMode &&
                    visibleQuestionsRecord &&
                    has$1(visibleQuestionsRecord, 'order_reference_number') &&
                    !visibleQuestionsRecord['order_reference_number']
                    ? false
                    : true
                : showField(page, 'order_reference_number')) && (React__default.createElement(FieldWrap, { className: showError ? 'has-field-error' : '' },
                React__default.createElement(Text$1.B1, { dangerouslySetInnerHTML: { __html: getFieldValue(page, 'order_reference_number') || '' }, className: getFieldRequired(page, 'order_reference_number') ? 'required' : '' }),
                React__default.createElement(Input, { value: questionsValue['order_reference_number'], onChange: function (e) {
                        onChangeHandler('order_reference_number', e.target.value);
                    }, onFocus: function () {
                        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.EXPERIENCE_DETAIL_ORDER_REFERENCE_NUMBER);
                    }, className: "mb-10" }),
                showError && invalidQuestions['order_reference_number'] && React__default.createElement(ErrorMsg$1, null, "This field is required")))),
        React__default.createElement(FloatingBtn, { onClick: handleSubmitPage })));
};
var templateObject_1$2, templateObject_2$2;

var useQuestionsVisible = function (props) {
    var page = props.page, pages = props.pages, globalSelectedFactMap = props.globalSelectedFactMap;
    var _a = useState(function () {
        return generateQuestionsMapUntilCurrentPage({ pages: pages, page: page, globalSelectedFactMap: globalSelectedFactMap });
    }), selectedValueFactMap = _a[0], setSelectedValueFactMap = _a[1];
    // Update selectedValuesMap when page or pages change
    useEffect(function () {
        var updatedSelectedValuesMap = generateQuestionsMapUntilCurrentPage({
            pages: pages,
            page: page,
            globalSelectedFactMap: globalSelectedFactMap
        });
        setSelectedValueFactMap(__assign(__assign({}, selectedValueFactMap), updatedSelectedValuesMap));
    }, [page, pages, globalSelectedFactMap]);
    return {
        selectedValueFactMap: selectedValueFactMap,
        setSelectedValueFactMap: setSelectedValueFactMap
    };
};

var IconStack = defaultStyled.div(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  /* margin-top: 1.875rem; */\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  /* margin-top: 1.875rem; */\n"])));
var IconCircle = defaultStyled.div(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background-color: #ffffff;\n  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.06), 0px 0px 0px 1px rgba(0, 0, 0, 0.04);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: ", "px;\n  z-index: ", ";\n  .partner-icon-box {\n    width: 35px;\n    height: 35px;\n  }\n"], ["\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background-color: #ffffff;\n  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.06), 0px 0px 0px 1px rgba(0, 0, 0, 0.04);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: ", "px;\n  z-index: ", ";\n  .partner-icon-box {\n    width: 35px;\n    height: 35px;\n  }\n"])), function (_a) {
    var index = _a.index;
    return -4 * index;
}, function (_a) {
    var total = _a.total, index = _a.index;
    return total - index;
});
var StyledButton = defaultStyled.button(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  display: flex;\n  align-items: stretch;\n  width: 100%;\n  min-height: 50px;\n  border-radius: 10px;\n  overflow: hidden;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  background-color: ", ";\n  transition: opacity 0.2s ease-in-out;\n\n  &:hover {\n    opacity: 0.9;\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n"], ["\n  display: flex;\n  align-items: stretch;\n  width: 100%;\n  min-height: 50px;\n  border-radius: 10px;\n  overflow: hidden;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  background-color: ", ";\n  transition: opacity 0.2s ease-in-out;\n\n  &:hover {\n    opacity: 0.9;\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n"])), function (_a) {
    var color = _a.color;
    return color;
});
var IconArea = defaultStyled.div(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 50px;\n  padding: 5px;\n  border: 1px solid  ", ";;\n    background-color: white;\n    border-radius: 10px 0px 0px 10px;\n"], ["\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 50px;\n  padding: 5px;\n  border: 1px solid  ", ";;\n    background-color: white;\n    border-radius: 10px 0px 0px 10px;\n"])), function (_a) {
    var color = _a.color;
    return color;
});
var TextArea = defaultStyled.div(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n  flex-grow: 1; \n  display: flex;\n  align-items: center;\n  justify-content: center; \n  padding: 10px 20px;\n  color: #ffffff;\n  font-size: 16px;\n  font-weight: 500;\n  background-color:  ", ";\n  text-align: center;\n"], ["\n  flex-grow: 1; \n  display: flex;\n  align-items: center;\n  justify-content: center; \n  padding: 10px 20px;\n  color: #ffffff;\n  font-size: 16px;\n  font-weight: 500;\n  background-color:  ", ";\n  text-align: center;\n"])), function (_a) {
    var color = _a.color;
    return color;
});
var BoostRedirect = defaultStyled.div(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  padding: 0.625rem;\n  width: 100%;\n  justify-content: flex-end;#0E68E\n  strong {\n    padding-left: 0.125rem;\n    color: ", ";\n  }\n\n\n  .redirect-anchor {\n    color: rgba(55, 53, 47, 0.65);\n    text-decoration: underline;\n    caret-color: rgb(55, 53, 47);\n    cursor: pointer;\n  }\n\n  .counter-dot span {\n    animation-name: blink;\n    animation-duration: 2.4s;\n    animation-iteration-count: infinite;\n    animation-fill-mode: both;\n    color: ", ";\n  }\n\n  .counter-dot span:nth-child(2) {\n    animation-delay: 0.2s;\n  }\n\n  .counter-dot span:nth-child(3) {\n    animation-delay: 0.4s;\n  }\n\n  @keyframes blink {\n    0% {\n      opacity: 0.2;\n    }\n    20% {\n      opacity: 1;\n    }\n    100% {\n      opacity: 0.2;\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  padding: 0.625rem;\n  width: 100%;\n  justify-content: flex-end;#0E68E\n  strong {\n    padding-left: 0.125rem;\n    color: ", ";\n  }\n\n\n  .redirect-anchor {\n    color: rgba(55, 53, 47, 0.65);\n    text-decoration: underline;\n    caret-color: rgb(55, 53, 47);\n    cursor: pointer;\n  }\n\n  .counter-dot span {\n    animation-name: blink;\n    animation-duration: 2.4s;\n    animation-iteration-count: infinite;\n    animation-fill-mode: both;\n    color: ", ";\n  }\n\n  .counter-dot span:nth-child(2) {\n    animation-delay: 0.2s;\n  }\n\n  .counter-dot span:nth-child(3) {\n    animation-delay: 0.4s;\n  }\n\n  @keyframes blink {\n    0% {\n      opacity: 0.2;\n    }\n    20% {\n      opacity: 1;\n    }\n    100% {\n      opacity: 0.2;\n    }\n  }\n"])), function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
}, function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
});
var ThankYouTextWrap = defaultStyled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  margin-top: 1.25rem;\n\n  cursor: pointer;\n  text-align: center;\n\n  span {\n    color: #a0a0a0;\n  }\n"], ["\n  margin-top: 1.25rem;\n\n  cursor: pointer;\n  text-align: center;\n\n  span {\n    color: #a0a0a0;\n  }\n"])));
var BoostReviewBox = defaultStyled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  .boost-review-header {\n    line-height: 120%;\n    display: flex;\n    margin-top: 1.875rem;\n  }\n\n  .boost-review-header {\n    .clipboard-text {\n      padding-left: 0.625rem;\n      color: var(--slate-gray-dark);\n    }\n    .review-clipboard-text {\n      color: var(--slate-gray-dark);\n      font-family: var(--font-family-medium) !important;\n      font-size: 0.875rem;\n      font-weight: 500;\n      line-height: 1.125rem;\n      padding: 0 0.625rem;\n    }\n  }\n\n  .boost-review-text {\n    margin-bottom: 1.625rem;\n    font-style: italic;\n    padding: 0px 1.563rem;\n    margin-top: 0.625rem;\n    max-height: 150px;\n    overflow-y: scroll;\n  }\n"], ["\n  .boost-review-header {\n    line-height: 120%;\n    display: flex;\n    margin-top: 1.875rem;\n  }\n\n  .boost-review-header {\n    .clipboard-text {\n      padding-left: 0.625rem;\n      color: var(--slate-gray-dark);\n    }\n    .review-clipboard-text {\n      color: var(--slate-gray-dark);\n      font-family: var(--font-family-medium) !important;\n      font-size: 0.875rem;\n      font-weight: 500;\n      line-height: 1.125rem;\n      padding: 0 0.625rem;\n    }\n  }\n\n  .boost-review-text {\n    margin-bottom: 1.625rem;\n    font-style: italic;\n    padding: 0px 1.563rem;\n    margin-top: 0.625rem;\n    max-height: 150px;\n    overflow-y: scroll;\n  }\n"])));
var BoostPageWrap = defaultStyled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  height: 100%;\n  .ant-btn {\n    margin-top: 1.875rem;\n  }\n\n  .boost-page-logo {\n    margin-top: 1.875rem;\n  }\n"], ["\n  height: 100%;\n  .ant-btn {\n    margin-top: 1.875rem;\n  }\n\n  .boost-page-logo {\n    margin-top: 1.875rem;\n  }\n"])));
var BoostPageTitile = defaultStyled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  text-align: center;\n  padding-bottom: 1.25rem;\n  padding-left: 1.563rem;\n  padding-right: 1.563rem;\n  border-bottom: 1px solid var(--grey-light);\n"], ["\n  text-align: center;\n  padding-bottom: 1.25rem;\n  padding-left: 1.563rem;\n  padding-right: 1.563rem;\n  border-bottom: 1px solid var(--grey-light);\n"])));
var BoostTitle = defaultStyled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  width: 70%;\n  text-align: center;\n  margin: 0 auto;\n  margin-top: 1.25rem;\n  margin-bottom: 1.25rem;\n\n  h2::first-line {\n    color: ", ";\n  }\n"], ["\n  width: 70%;\n  text-align: center;\n  margin: 0 auto;\n  margin-top: 1.25rem;\n  margin-bottom: 1.25rem;\n\n  h2::first-line {\n    color: ", ";\n  }\n"])), function (_a) {
    var $theme = _a.$theme;
    return $theme.color || 'var(--indian-red)';
});
var FeedbackUserReviewInfoWrap = defaultStyled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n  flex-direction: column;\n  .review-platform-icon {\n    transform: scale(0.75);\n    position: absolute;\n    right: 12px;\n    background: var(--white);\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    padding: 0.313rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n"], ["\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n  flex-direction: column;\n  .review-platform-icon {\n    transform: scale(0.75);\n    position: absolute;\n    right: 12px;\n    background: var(--white);\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    padding: 0.313rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n"])));
var FeedbackUserInfoWrap = defaultStyled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: flex-start;\n  border: 1px solid var(--disable-grey);\n  padding: 0.625rem;\n  margin: 0.625rem 0rem;\n  border-radius: 0.625rem;\n\n  .boost-review-message {\n    font-family: var(--font-family-medium) !important;\n    font-size: 0.875rem;\n    font-weight: 500;\n    line-height: 1.05rem;\n    margin-top: 0.625rem;\n    max-height: 135px;\n    color: #30384c;\n    white-space: normal;\n    text-overflow: ellipsis;\n    word-break: break-word;\n    width: 99%;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n  }\n\n  .feedback-user-name {\n    font-family: var(--font-family-medium) !important;\n    font-size: 0.875rem;\n    font-weight: 700;\n    line-height: 1.05rem;\n    text-align: left;\n    margin-bottom: 0.125rem;\n    color: #30384c;\n  }\n\n  .time {\n    font-family: var(--font-family-regular) !important;\n    font-size: 0.75rem;\n    font-weight: 500;\n    text-align: left;\n    color: var(--grey-semi-light);\n    margin-bottom: 0.125rem;\n  }\n"], ["\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: flex-start;\n  border: 1px solid var(--disable-grey);\n  padding: 0.625rem;\n  margin: 0.625rem 0rem;\n  border-radius: 0.625rem;\n\n  .boost-review-message {\n    font-family: var(--font-family-medium) !important;\n    font-size: 0.875rem;\n    font-weight: 500;\n    line-height: 1.05rem;\n    margin-top: 0.625rem;\n    max-height: 135px;\n    color: #30384c;\n    white-space: normal;\n    text-overflow: ellipsis;\n    word-break: break-word;\n    width: 99%;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n  }\n\n  .feedback-user-name {\n    font-family: var(--font-family-medium) !important;\n    font-size: 0.875rem;\n    font-weight: 700;\n    line-height: 1.05rem;\n    text-align: left;\n    margin-bottom: 0.125rem;\n    color: #30384c;\n  }\n\n  .time {\n    font-family: var(--font-family-regular) !important;\n    font-size: 0.75rem;\n    font-weight: 500;\n    text-align: left;\n    color: var(--grey-semi-light);\n    margin-bottom: 0.125rem;\n  }\n"])));
var StyledIcon = defaultStyled.span(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  svg {\n    width: ", ";\n    height: ", ";\n  }\n"], ["\n  width: ", ";\n  height: ", ";\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  svg {\n    width: ", ";\n    height: ", ";\n  }\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? 16 : _b;
    return "".concat(size, "px");
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? 16 : _b;
    return "".concat(size, "px");
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? 16 : _b;
    return "".concat(size, "px");
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? 16 : _b;
    return "".concat(size, "px");
});
var FeedbackUserRating = defaultStyled.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  margin-right: 5px;\n  height: 16px;\n"], ["\n  display: flex;\n  align-items: center;\n  margin-right: 5px;\n  height: 16px;\n"])));
var BoostPageCancelWrap = defaultStyled.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  margin-top: 10px;\n  cursor: pointer;\n  text-align: center;\n\n  span {\n    color: #a0a0a0;\n  }\n"], ["\n  margin-top: 10px;\n  cursor: pointer;\n  text-align: center;\n\n  span {\n    color: #a0a0a0;\n  }\n"])));
var LogoWrap = defaultStyled.div(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    height: 110px;\n    object-fit: contain;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    height: 110px;\n    object-fit: contain;\n  }\n"])));
var BoostPageV2 = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var page = _a.page, pages = _a.pages, theme = _a.theme, onNextPage = _a.onNextPage, editorMode = _a.editorMode, surveySetting = _a.surveySetting, handleAssistedReview = _a.handleAssistedReview, trackEvent = _a.trackEvent, surveySubmitted = _a.surveySubmitted;
    var pageVariant = page.pageVariant;
    var allowThemeInvert = (theme === null || theme === void 0 ? void 0 : theme.layout) !== 'box';
    var _q = useState(false), showCancelState = _q[0], setShowCancelState = _q[1];
    var _r = useState((getPageVariantFieldValue(page, 'auto_redirect', pageVariant) || false)), showRedirect = _r[0], setShowRedirect = _r[1];
    var _s = useState((getPageVariantFieldValue(page, 'auto_redirect_counter', pageVariant) || 5)), counter = _s[0], setCounter = _s[1];
    var reviewText = editorMode
        ? "Great place! Love coming here. I've been here 3 times this month already. I mainly come here for the service as the people are super nice and are always there to help. Definitely going to come here more often. You have a new loyal customer! Special shoutout to Jerry who really took care of us."
        : getPageVariantFieldValue(page, 'review_text', pageVariant);
    var reviewerName = editorMode
        ? 'Grant Oliveria'
        : (_c = (_b = pages.find(function (page) { return page.pageKey === PAGE_KEYS.PERSONAL_INFORMATION; })) === null || _b === void 0 ? void 0 : _b.selectedValue) === null || _c === void 0 ? void 0 : _c.name;
    var ratingPage = pages.find(function (page) { return page.pageKey === PAGE_KEYS.RATINGS; });
    var showHeaderText = showPageVariantField(page, 'header_text', pageVariant);
    var showMainTitle = showPageVariantField(page, 'main_title', pageVariant);
    var showCopyClipboard = showPageVariantField(page, 'copy_clipboard', pageVariant);
    var showReviewText = showPageVariantField(page, 'review_text', pageVariant);
    var boostPageV2PageVariantConfig = BOOST_PAGE_V2_CONFIG === null || BOOST_PAGE_V2_CONFIG === void 0 ? void 0 : BOOST_PAGE_V2_CONFIG[pageVariant];
    var autoRedirectText = getPageVariantFieldValue(page, 'auto_redirect_text', pageVariant);
    var starRating = editorMode
        ? 5
        : ((_e = (_d = ratingPage === null || ratingPage === void 0 ? void 0 : ratingPage.selectedValue) === null || _d === void 0 ? void 0 : _d.main) === null || _e === void 0 ? void 0 : _e.value) ||
            ((_g = (_f = ratingPage === null || ratingPage === void 0 ? void 0 : ratingPage.selectedValue) === null || _f === void 0 ? void 0 : _f.rating) === null || _g === void 0 ? void 0 : _g.value) ||
            ((_h = ratingPage === null || ratingPage === void 0 ? void 0 : ratingPage.selectedValue) === null || _h === void 0 ? void 0 : _h.value);
    useEffect(function () {
        if (!get$2(surveySetting, 'reviewBoosting', true)) {
            console.log("Going on to the next page now.... ".concat(get$2(surveySetting, 'reviewBoosting', true), " "));
            onNextPage();
        }
    }, []);
    useEffect(function () {
        var newCounter = (getPageVariantFieldValue(page, 'auto_redirect_counter', pageVariant) || 5);
        var newShowRedirectValue = (getPageVariantFieldValue(page, 'auto_redirect', pageVariant) || false);
        if (showRedirect !== newShowRedirectValue) {
            setShowRedirect(newShowRedirectValue);
        }
        if (counter !== newCounter) {
            setCounter(newCounter);
        }
    }, [page]);
    var onBoostReviewClick = function (redirectionUrl, platform) {
        if (!editorMode && isClient() && navigator) {
            handleAssistedReview && handleAssistedReview(platform);
            if (reviewText && typeof reviewText === 'string')
                copy$1(reviewText || '');
            window === null || window === void 0 ? void 0 : window.open(redirectionUrl, '_blank');
        }
        onNextPage();
    };
    var onBoostReviewClickV1 = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, key, pageLink, response;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 4, , 5]);
                    if (!(!editorMode && isClient() && navigator)) return [3 /*break*/, 3];
                    _a = handleAssistedReview;
                    if (!_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, handleAssistedReview(boostPageV2PageVariantConfig === null || boostPageV2PageVariantConfig === void 0 ? void 0 : boostPageV2PageVariantConfig.variationPlaformKey)];
                case 1:
                    _a = (_d.sent());
                    _d.label = 2;
                case 2:
                    key = (_c = (_b = boostPageV2PageVariantConfig.redirectionUrlKey) === null || _b === void 0 ? void 0 : _b.button_text) === null || _c === void 0 ? void 0 : _c.fieldKey;
                    pageLink = page === null || page === void 0 ? void 0 : page[key];
                    console.log("AUTO REDIRECT LINK : ", pageLink);
                    response = window === null || window === void 0 ? void 0 : window.open(pageLink, '_blank');
                    if (response !== null) {
                        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.BOOST_PAGE_BOOST_REDIRECT_NEW_TAB);
                    }
                    else if (response === null && pageLink) {
                        window.location.href = pageLink;
                        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.BOOST_PAGE_BOOST_REDIRECT_SAME_TAB);
                    }
                    _d.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    _d.sent();
                    console.error('An error occured while redirecting to the link');
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (!editorMode && showRedirect) {
            var interval_1 = setInterval(function () {
                counter > 0 && setCounter(function (prevCounter) { return prevCounter - 1; });
            }, 1000);
            return function () { return clearInterval(interval_1); };
        }
    }, []);
    useEffect(function () {
        if (!showCancelState && showRedirect && counter === 0 && surveySubmitted) {
            trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.BOOST_PAGE_BOOST);
            trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.BOOST_PAGE_BOOST_REDIRECT);
            onBoostReviewClickV1();
        }
    }, [counter, surveySubmitted]);
    var renderLottieLoader = function () {
        try {
            return React__default.createElement(Lottie, { animationData: boostSurveyLoading, loop: true, style: { color: theme === null || theme === void 0 ? void 0 : theme.color, height: 65 } });
        }
        catch (error) {
            console.error(error);
            return React__default.createElement(React__default.Fragment, null);
        }
    };
    var BoostActionButtons = (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: 10 } }, (_j = boostPageV2PageVariantConfig === null || boostPageV2PageVariantConfig === void 0 ? void 0 : boostPageV2PageVariantConfig.buttonKey) === null || _j === void 0 ? void 0 : _j.map(function (eachButton) {
            var buttonConfig = (boostPageV2PageVariantConfig).redirectionUrlKey[eachButton];
            var redirectionUrl = page[buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.fieldKey];
            return (React__default.createElement(StyledButton, { color: buttonConfig.color, onClick: function () {
                    trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.BOOST_PAGE_BOOST);
                    onBoostReviewClick(redirectionUrl, buttonConfig.variationPlaformKey);
                } },
                React__default.createElement(IconArea, { color: buttonConfig.color },
                    React__default.createElement(Icon, { name: buttonConfig.icon, type: "partners" })),
                React__default.createElement(TextArea, { color: buttonConfig.color }, getPageVariantFieldValue(page, eachButton, pageVariant))));
        })),
        React__default.createElement(ThankYouTextWrap, { onClick: function () {
                trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.BOOST_PAGE_NO_THANK);
                onNextPage();
            } },
            React__default.createElement(Text$1.B1, { className: classNames('text-center', { 'bg-theme-allowed': allowThemeInvert }) }, "No, thank you"))));
    var BoostButtonRenderer = (React__default.createElement(React__default.Fragment, null,
        isString$4(reviewText) && !isEmpty$1(reviewText) && (React__default.createElement(BoostReviewBox, null,
            showCopyClipboard && (React__default.createElement("div", { className: classNames('boost-review-header', { 'bg-theme-allowed': allowThemeInvert }) },
                React__default.createElement(Icon, { name: "CommentQuote", type: "outline", size: 15 }),
                React__default.createElement(Text$1.B1, { className: classNames('clipboard-text', { 'bg-theme-allowed': allowThemeInvert }), dangerouslySetInnerHTML: { __html: getPageVariantFieldValue(page, 'copy_clipboard', pageVariant) || '' } }))),
            showReviewText && (React__default.createElement("div", { className: "boost-review-text" },
                React__default.createElement(Text$1.B1, null,
                    "\"",
                    truncate$1(reviewText, {
                        length: 125,
                        omission: '...'
                    }),
                    "\""))))),
        BoostActionButtons));
    var BoostRedirectRenderer = (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(BoostReviewBox, null, showCopyClipboard && (React__default.createElement("div", { className: "boost-review-header" },
            React__default.createElement(Text$1.B1, { className: classNames('review-clipboard-text', { 'bg-theme-allowed': allowThemeInvert }), dangerouslySetInnerHTML: { __html: getPageVariantFieldValue(page, 'copy_clipboard', pageVariant) || '' } })))),
        React__default.createElement(FeedbackUserInfoWrap, null,
            React__default.createElement(FeedbackUserReviewInfoWrap, null,
                ((_k = boostPageV2PageVariantConfig === null || boostPageV2PageVariantConfig === void 0 ? void 0 : boostPageV2PageVariantConfig.icon) === null || _k === void 0 ? void 0 : _k.length) === 1 ? React__default.createElement("div", { className: "review-platform-icon" },
                    React__default.createElement(StyledIcon, { size: 24 },
                        React__default.createElement(Icon, { name: boostPageV2PageVariantConfig === null || boostPageV2PageVariantConfig === void 0 ? void 0 : boostPageV2PageVariantConfig.icon[0], type: "partners" }))) : React__default.createElement(React__default.Fragment, null),
                React__default.createElement("div", { className: classNames('feedback-user-name', { 'bg-theme-allowed': allowThemeInvert }) }, reviewerName),
                React__default.createElement("div", { className: classNames('time', { 'bg-theme-allowed': allowThemeInvert }) }, "".concat((_l = moment()) === null || _l === void 0 ? void 0 : _l.format('DD MMMM YYYY'))),
                starRating && (React__default.createElement(FeedbackUserRating, null,
                    React__default.createElement(Input.Rating, { type: 'boost', count: 5, value: starRating }))),
                showReviewText && (React__default.createElement("div", { className: classNames('boost-review-message', { 'bg-theme-allowed': allowThemeInvert }) }, reviewText)))),
        React__default.createElement(BoostRedirect, { "$theme": theme },
            !showCancelState && counter > 0 && (React__default.createElement(React__default.Fragment, null,
                renderLottieLoader(),
                React__default.createElement(Text$1.H4, { semibold: true, className: classNames('text-center', { 'bg-theme-allowed': allowThemeInvert }), dangerouslySetInnerHTML: {
                        __html: "".concat(autoRedirectText && (autoRedirectText === null || autoRedirectText === void 0 ? void 0 : autoRedirectText.replace('{{counter}}', "<strong class=\"counter-dot\">".concat(counter >= 0 ? counter : 0)))) || "Redirect to ".concat(boostPageV2PageVariantConfig === null || boostPageV2PageVariantConfig === void 0 ? void 0 : boostPageV2PageVariantConfig.platformName, ", please wait ").concat(counter >= 0 ? counter : 0)
                    } }))),
            (counter <= 0 || showCancelState) && BoostActionButtons,
            !showCancelState && counter > 0 && (React__default.createElement(BoostPageCancelWrap, { onClick: function () {
                    setShowCancelState(true);
                    trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.BOOST_PAGE_BOOST_REDIRECT_CANCEL);
                } },
                React__default.createElement(Text$1.B2, { className: classNames('text-center', { 'bg-theme-allowed': allowThemeInvert }) }, "Cancel"))))));
    return get$2(surveySetting, 'reviewBoosting', true) ? (React__default.createElement(BoostPageWrap, null,
        React__default.createElement("div", { className: "page-content" },
            React__default.createElement(BrandInfo, { page: page, pageVariant: pageVariant }),
            showHeaderText && (React__default.createElement(BoostPageTitile, null,
                React__default.createElement(Text$1.H5, { semibold: true, className: classNames('text-center', { 'bg-theme-allowed': allowThemeInvert }), dangerouslySetInnerHTML: { __html: getPageVariantFieldValue(page, 'header_text', pageVariant) || '' } }))),
            ((_m = boostPageV2PageVariantConfig === null || boostPageV2PageVariantConfig === void 0 ? void 0 : boostPageV2PageVariantConfig.icon) === null || _m === void 0 ? void 0 : _m.length) > 1 ?
                React__default.createElement(IconStack, { className: classNames('boost-page-logo') }, (_o = boostPageV2PageVariantConfig === null || boostPageV2PageVariantConfig === void 0 ? void 0 : boostPageV2PageVariantConfig.icon) === null || _o === void 0 ? void 0 : _o.map(function (eachIcon, index) {
                    var _a;
                    var total = (_a = boostPageV2PageVariantConfig === null || boostPageV2PageVariantConfig === void 0 ? void 0 : boostPageV2PageVariantConfig.icon) === null || _a === void 0 ? void 0 : _a.length;
                    return (React__default.createElement(IconCircle, { key: index, index: index, total: total },
                        React__default.createElement(Icon, { className: 'partner-icon-box', name: eachIcon, type: "partners" })));
                })) : React__default.createElement(LogoWrap, { className: classNames('boost-page-logo', { 'bg-theme-allowed': allowThemeInvert }) }, (_p = boostPageV2PageVariantConfig === null || boostPageV2PageVariantConfig === void 0 ? void 0 : boostPageV2PageVariantConfig.icon) === null || _p === void 0 ? void 0 : _p.map(function (eachIcon) {
                return React__default.createElement(Logo, { name: eachIcon, type: "bubble-original-color", size: 50 });
            })),
            showMainTitle && (React__default.createElement(BoostTitle, { "$theme": theme },
                React__default.createElement(Text$1.H2, { semibold: true, className: classNames('text-center', { 'bg-theme-allowed': allowThemeInvert }), dangerouslySetInnerHTML: { __html: getPageVariantFieldValue(page, 'main_title', pageVariant) || '' } }))),
            showRedirect ? BoostRedirectRenderer : BoostButtonRenderer))) : (React__default.createElement(React__default.Fragment, null));
};
var templateObject_1$1, templateObject_2$1, templateObject_3$1, templateObject_4$1, templateObject_5$1, templateObject_6$1, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;

var CaptionTextWrap = defaultStyled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 1.25rem;\n"], ["\n  margin-bottom: 1.25rem;\n"])));
var StaffProfileWrap = defaultStyled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 0.938rem;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 0.938rem;\n"])));
var MultiSelectWrap = defaultStyled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-bottom: 0.625rem;\n"], ["\n  margin-bottom: 0.625rem;\n"])));
var ErrorMsg = defaultStyled(Text$1.B2)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: var(--indian-red);\n"], ["\n  color: var(--indian-red);\n"])));
var ScreenLoader = defaultStyled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.6);\n"], ["\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.6);\n"])));
var RatingWrap = defaultStyled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  text-align: center;\n  margin-bottom: 1.25rem;\n\n  ul {\n    width: 100%;\n  }\n\n  .emoji-container {\n    text-align: center;\n    justify-content: center;\n  }\n"], ["\n  text-align: center;\n  margin-bottom: 1.25rem;\n\n  ul {\n    width: 100%;\n  }\n\n  .emoji-container {\n    text-align: center;\n    justify-content: center;\n  }\n"])));
var renderPage = function (page, onNextPage, surveySetting, pages, editorMode, uploadPicturesRequest, region, theme, brandRegion, handleAssistedReview, trackEvent, visibleQuestionsMap, allQuestionsRulesFromEngine, selectedValueFactMap, setSelectedValueFactMap, vouchersData, multiVoucherIds, surveySubmitted, expressParams, voucherIdsMetadata) {
    switch (page.pageKey) {
        case PAGE_KEYS.WELCOME_PAGE:
            return (React__default.createElement(WelcomePage, { surveySetting: surveySetting, voucherIdsMetadata: voucherIdsMetadata, page: page, onNextPage: onNextPage, vouchersData: vouchersData }));
        case PAGE_KEYS.TYPE_OF_ORDER:
            return (React__default.createElement(TypeOfOrderPage, { page: page, onNextPage: function (val) {
                    var _a;
                    return onNextPage(val, __assign(__assign({}, selectedValueFactMap), (_a = {}, _a['serviceType_value'] = val === null || val === void 0 ? void 0 : val.key, _a)));
                }, trackEvent: trackEvent, theme: theme }));
        case PAGE_KEYS.CHOOSE_LOCATION:
            return (React__default.createElement(ChooseLocationPage, { editorMode: editorMode, page: page, onNextPage: function (val, metaData) {
                    var _a;
                    return onNextPage(val, __assign(__assign({}, selectedValueFactMap), (_a = {}, _a['location_value'] = val === null || val === void 0 ? void 0 : val.value, _a)), metaData);
                }, region: region, trackEvent: trackEvent, theme: theme }));
        case PAGE_KEYS.DELIVERY_PLATFORM:
            return (React__default.createElement(DeliveryPlatformPage, { page: page, onNextPage: function (val) {
                    var _a;
                    return onNextPage(val, __assign(__assign({}, selectedValueFactMap), (_a = {}, _a['deliveryPlatform_value'] = val === null || val === void 0 ? void 0 : val.key, _a)));
                }, editorMode: editorMode, trackEvent: trackEvent, theme: theme }));
        case PAGE_KEYS.RATINGS:
            return (React__default.createElement(RatingsPage, { page: page, onNextPage: onNextPage, trackEvent: trackEvent, surveySetting: surveySetting, pages: pages, editorMode: editorMode, theme: theme, visibleQuestionsMap: visibleQuestionsMap, allQuestionsRulesFromEngine: allQuestionsRulesFromEngine, selectedValueFactMap: selectedValueFactMap, uploadRequest: uploadPicturesRequest, expressParams: expressParams }));
        case PAGE_KEYS.EXPERIENCE_DETAILS:
            return (React__default.createElement(ExperienceDetailsPage, { page: page, pages: pages, uploadRequest: uploadPicturesRequest, onNextPage: onNextPage, editorMode: editorMode, trackEvent: trackEvent, surveySetting: surveySetting, visibleQuestionsMap: visibleQuestionsMap, allQuestionsRulesFromEngine: allQuestionsRulesFromEngine, selectedValueFactMap: selectedValueFactMap }));
        case PAGE_KEYS.EXPERIENCE_POSITIVE:
            return (React__default.createElement(ExperiencePositivePage, { page: page, onNextPage: function (val) { return onNextPage(val, selectedValueFactMap); }, editorMode: editorMode, trackEvent: trackEvent }));
        case PAGE_KEYS.EXPERIENCE_NEGATIVE:
            return (React__default.createElement(ExperienceNegativePage, { page: page, onNextPage: function (val) { return onNextPage(val, selectedValueFactMap); }, editorMode: editorMode, trackEvent: trackEvent }));
        case PAGE_KEYS.STAFF_LIST:
            return (React__default.createElement(StaffListPage, { page: page, onNextPage: function (val) { return onNextPage(val, selectedValueFactMap); }, editorMode: editorMode, trackEvent: trackEvent }));
        case PAGE_KEYS.STAFF_RATING:
            return (React__default.createElement(StaffRatingPage, { page: page, onNextPage: function (val) { return onNextPage(val, selectedValueFactMap); }, trackEvent: trackEvent }));
        case PAGE_KEYS.PERSONAL_INFORMATION:
            return (React__default.createElement(PersonalInformationPage, { page: page, onNextPage: function (val) { return onNextPage(val, selectedValueFactMap); }, surveySetting: surveySetting, brandRegion: brandRegion, trackEvent: trackEvent, vouchersData: vouchersData, multiVoucherIds: multiVoucherIds, pages: pages, theme: theme, editorMode: editorMode }));
        case PAGE_KEYS.BOOST_PAGE:
            return (React__default.createElement(BoostPage, { page: page, pages: pages, theme: theme, surveySetting: surveySetting, onNextPage: function (val) { return onNextPage(val, selectedValueFactMap); }, editorMode: editorMode, handleAssistedReview: handleAssistedReview, trackEvent: trackEvent, surveySubmitted: surveySubmitted }));
        case PAGE_KEYS.BOOST_PAGE_V2:
            return (React__default.createElement(BoostPageV2, { page: page, pages: pages, theme: theme, surveySetting: surveySetting, onNextPage: function (val) { return onNextPage(val, selectedValueFactMap); }, editorMode: editorMode, handleAssistedReview: handleAssistedReview, trackEvent: trackEvent, surveySubmitted: surveySubmitted }));
        case PAGE_KEYS.THANK_YOU:
            return (React__default.createElement(ThankYouPage, { theme: theme, page: page, trackEvent: trackEvent, pages: pages, surveySetting: surveySetting, editorMode: editorMode, visibleQuestionsMap: visibleQuestionsMap, allQuestionsRulesFromEngine: allQuestionsRulesFromEngine, selectedValueFactMap: selectedValueFactMap, expressParams: expressParams }));
        default:
            return (React__default.createElement(CustomPage$1, { surveySetting: surveySetting, pages: pages, page: page, onNextPage: onNextPage, editorMode: editorMode, key: uniqueId$1(), theme: theme, trackEvent: trackEvent, uploadRequest: uploadPicturesRequest, visibleQuestionsMap: visibleQuestionsMap, allQuestionsRulesFromEngine: allQuestionsRulesFromEngine, selectedValueFactMap: selectedValueFactMap, vouchersData: vouchersData, expressParams: expressParams, voucherIdsMetadata: voucherIdsMetadata }));
    }
};
var SurveyPage = function (_a) {
    var _b, _c;
    var page = _a.page, onNextPage = _a.onNextPage, _d = _a.theme, theme = _d === void 0 ? { color: 'var(--indian-red)', fontFamily: 'inherit' } : _d, editorMode = _a.editorMode, initialPageKey = _a.initialPageKey, stepperProps = _a.stepperProps, surveySetting = _a.surveySetting, pages = _a.pages, uploadPicturesRequest = _a.uploadPicturesRequest, loading = _a.loading, region = _a.region, onBackPage = _a.onBackPage, handleAssistedReview = _a.handleAssistedReview, brandRegion = _a.brandRegion, trackEvent = _a.trackEvent, allQuestionsRulesFromEngine = _a.allQuestionsRulesFromEngine, visibleQuestionsMap = _a.visibleQuestionsMap, globalSelectedFactMap = _a.globalSelectedFactMap, vouchersData = _a.vouchersData, multiVoucherIds = _a.multiVoucherIds, voucherIdsMetadata = _a.voucherIdsMetadata, surveySubmitted = _a.surveySubmitted, expressParams = _a.expressParams;
    var bgImageValue = ((_b = getFieldValue(page, 'bg_image')) === null || _b === void 0 ? void 0 : _b.mediaUrl)
        ? (_c = getFieldValue(page, 'bg_image')) === null || _c === void 0 ? void 0 : _c.mediaUrl
        : getFieldValue(page, 'bg_image');
    var bgImageShow = showField(page, 'bg_image');
    var bgImageOpacity = getFieldValue(page, 'bg_color_opacity');
    var ignoreLayout = page.pageKey === PAGE_KEYS.WELCOME_PAGE ? true : false;
    var _e = useQuestionsVisible({
        page: page,
        pages: pages,
        globalSelectedFactMap: globalSelectedFactMap
    }), selectedValueFactMap = _e.selectedValueFactMap, setSelectedValueFactMap = _e.setSelectedValueFactMap;
    var handleOnBack = function () {
        var _a;
        var pageName = (_a = snakeCase$1((page === null || page === void 0 ? void 0 : page.pageName) || (page === null || page === void 0 ? void 0 : page.pageKey))) === null || _a === void 0 ? void 0 : _a.toUpperCase();
        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent({
            action: 'CLICK',
            label: "SURVEY.".concat(pageName, ".BACK")
        });
        if (onBackPage) {
            onBackPage();
        }
    };
    var backlistStepperPages = __spreadArray([PAGE_KEYS.THANK_YOU], BOOST_PAGE_KEYS, true);
    var fullHeightPages = BOOST_PAGE_KEYS;
    var renderSurveyData = (React__default.createElement(React__default.Fragment, null,
        !backlistStepperPages.includes(page === null || page === void 0 ? void 0 : page.pageKey) ? ((page === null || page === void 0 ? void 0 : page.pageKey) === initialPageKey ? (stepperProps &&
            surveySetting.showProgressBar && (React__default.createElement(Stepper, __assign({ color: theme === null || theme === void 0 ? void 0 : theme.color }, stepperProps, { className: "bg-theme-allowed survey-stepper" })))) : (React__default.createElement("div", { className: "survey-stepper-header" },
            React__default.createElement("div", { onClick: handleOnBack, className: "bg-theme-allowed" },
                React__default.createElement(Icon, { strokeWidth: 2, type: "outline", name: "ChevronLeft", size: 20 })),
            stepperProps && surveySetting.showProgressBar ? (React__default.createElement(Stepper, __assign({ color: theme === null || theme === void 0 ? void 0 : theme.color }, stepperProps, { className: "bg-theme-allowed survey-stepper-90" }))) : (React__default.createElement("div", { className: "flex-1" }))))) : (React__default.createElement(React__default.Fragment, null)),
        renderPage(page, onNextPage, surveySetting, pages, editorMode, uploadPicturesRequest, region, theme, brandRegion, handleAssistedReview, trackEvent, visibleQuestionsMap, allQuestionsRulesFromEngine, selectedValueFactMap, setSelectedValueFactMap, vouchersData, multiVoucherIds, surveySubmitted, expressParams, voucherIdsMetadata),
        loading && (React__default.createElement(ScreenLoader, null,
            React__default.createElement(Spin, null)))));
    return (React__default.createElement("div", { className: "hero-container" },
        React__default.createElement(MobileView, { backgroundColor: (theme === null || theme === void 0 ? void 0 : theme.bgColor) && !ignoreLayout ? theme === null || theme === void 0 ? void 0 : theme.bgColor : '#FFFFFF', outerBgColor: "#F3F3F3", loading: false }, surveySetting.template === SURVEY_TEMPLATES.FEW_CLICK_FEEDBACK_SURVEY || theme.layout === 'box' ? (React__default.createElement(BoxLayout, { theme: {
                $backgroundImage: bgImageShow && bgImageValue ? bgImageValue : '',
                color: theme === null || theme === void 0 ? void 0 : theme.color,
                $fontFamily: theme === null || theme === void 0 ? void 0 : theme.fontFamily,
                $backgroundOpacity: bgImageOpacity === undefined ? 8 : bgImageOpacity,
                $fullHeight: fullHeightPages.includes(page === null || page === void 0 ? void 0 : page.pageKey) ? '100%' : undefined
            }, currentPageKey: page.pageKey, showStepper: surveySetting.showProgressBar, "data-testId": "survey-container", className: classNames({ 'has-custom-bg-image': bgImageShow && bgImageValue }) }, renderSurveyData)) : (React__default.createElement(StandardLayout, { "$theme": {
                $backgroundImage: bgImageShow && bgImageValue ? bgImageValue : '',
                color: theme === null || theme === void 0 ? void 0 : theme.color,
                $bgColor: theme === null || theme === void 0 ? void 0 : theme.bgColor,
                $fontFamily: theme === null || theme === void 0 ? void 0 : theme.fontFamily,
                $backgroundOpacity: bgImageOpacity === undefined ? 8 : bgImageOpacity,
                $fullHeight: fullHeightPages.includes(page === null || page === void 0 ? void 0 : page.pageKey) ? '100%' : undefined
            }, "$showStepper": surveySetting.showProgressBar, "data-testId": "survey-container", className: classNames({ 'has-custom-bg-image': bgImageShow && bgImageValue }) }, renderSurveyData)))));
};
var ExperienceNegativePage = function (_a) {
    var _b;
    var page = _a.page, onNextPage = _a.onNextPage, editorMode = _a.editorMode, trackEvent = _a.trackEvent;
    var _c = useState([]), selectedTags = _c[0], setSelectedTags = _c[1];
    var _d = useState(false), showError = _d[0], setShowError = _d[1];
    useEffect(function () {
        var _a;
        if ((_a = page === null || page === void 0 ? void 0 : page.selectedValue) === null || _a === void 0 ? void 0 : _a.length) {
            setSelectedTags(page === null || page === void 0 ? void 0 : page.selectedValue);
        }
    }, [(_b = page === null || page === void 0 ? void 0 : page.selectedValue) === null || _b === void 0 ? void 0 : _b.length]);
    var getExperienceTagsOptions = function () {
        var tagsToShow = [];
        var isDependentOnOrderType = showField(page, 'dependent_order_type', true);
        if (!isDependentOnOrderType) {
            tagsToShow = getFieldValue(page, 'tags');
        }
        else {
            // if not editorMode, to show dependent_order_type tags, check which type_of_order was selected and show tags accordingly
            if (!editorMode) {
                if (page.selectedOrderType == ORDER_TYPE.DINE_IN)
                    tagsToShow = getFieldValue(page, 'tags_dine_in');
                if (page.selectedOrderType == ORDER_TYPE.DELIVERY)
                    tagsToShow = getFieldValue(page, 'tags_delivery');
                if (page.selectedOrderType == ORDER_TYPE.TAKE_AWAY)
                    tagsToShow = getFieldValue(page, 'tags_take_away');
            }
            else {
                var tagsDineIn = isHiddenField(page, 'tags_dine_in') ? [] : getFieldValue(page, 'tags_dine_in');
                var tagsDelivery = isHiddenField(page, 'tags_delivery')
                    ? []
                    : getFieldValue(page, 'tags_delivery');
                var tagsTakeAway = isHiddenField(page, 'tags_take_away')
                    ? []
                    : getFieldValue(page, 'tags_take_away');
                tagsToShow = tagsDineIn.length > 0 ? tagsDineIn : tagsDelivery.length > 0 ? tagsDelivery : tagsTakeAway;
            }
        }
        return tagsToShow.map(function (value) {
            return {
                text: value,
                iconName: ''
            };
        });
    };
    var handleSubmitPage = function () {
        if (getFieldRequired(page, 'required') && selectedTags.length === 0) {
            setShowError(true);
            return;
        }
        setShowError(false);
        onNextPage(selectedTags);
    };
    useEffect(function () {
        if (selectedTags.length) {
            setShowError(false);
        }
    }, [selectedTags]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(BrandInfo, { page: page }),
        showField(page, 'title') && (React__default.createElement("div", { className: "page-title" },
            React__default.createElement(Text$1.H2, { semibold: true, dangerouslySetInnerHTML: { __html: getFieldValue(page, 'title') || '' } }))),
        React__default.createElement("div", { className: "page-content" },
            showField(page, 'caption') && (React__default.createElement(CaptionTextWrap, null,
                React__default.createElement(Text$1.B1, { dangerouslySetInnerHTML: { __html: getFieldValue(page, 'caption') || '' }, className: getFieldRequired(page, 'required') ? 'required' : '' }))),
            React__default.createElement(MultiSelectWrap, null,
                React__default.createElement(Input.MultiSelect, { options: getExperienceTagsOptions(), fieldKey: "text", className: "survey-multi-select", onChange: function (value) {
                        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.EXPERIENCE_NAGATIVE_CHOOSE_TAG);
                        setSelectedTags(value);
                    }, value: selectedTags })),
            showError && React__default.createElement(ErrorMsg, null, "This field is required")),
        React__default.createElement(FloatingBtn, { onClick: handleSubmitPage })));
};
var StaffListPage = function (_a) {
    var page = _a.page, onNextPage = _a.onNextPage, editorMode = _a.editorMode, trackEvent = _a.trackEvent;
    var getStaffOptions = function (values, showProfilePic) {
        return sortBy$1(values, ['value']).map(function (_a) {
            var key = _a.key, value = _a.value, src = _a.src;
            return {
                key: key,
                name: value,
                src: showProfilePic ? src : null
            };
        });
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(BrandInfo, { page: page }),
        showField(page, 'title') && (React__default.createElement("div", { className: "page-title" },
            React__default.createElement(Text$1.H2, { semibold: true, dangerouslySetInnerHTML: { __html: getFieldValue(page, 'title') || '' } }))),
        React__default.createElement("div", { className: "page-body" },
            React__default.createElement("div", { className: "page-content" },
                React__default.createElement(Input.Select, { type: 'profile', options: getStaffOptions(getFieldValue(page, editorMode ? 'staff_list_editor' : 'staff_list') || [], showField(page, 'show_staff_pictures', true)), onClick: function (option) {
                        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.STAFF_LIST_CHOOSE_STAFF);
                        onNextPage(option);
                    } }))),
        !getFieldRequired(page, 'required') && React__default.createElement(FloatingBtn, { onClick: function () { return onNextPage(null); } })));
};
var StaffRatingPage = function (_a) {
    var page = _a.page, onNextPage = _a.onNextPage, trackEvent = _a.trackEvent;
    var _b = useState(''), comment = _b[0], setComment = _b[1];
    var _c = useState(null), rating = _c[0], setRating = _c[1];
    var _d = useState(false), showErrorComment = _d[0], setShowErrorComment = _d[1];
    var _e = useState(false), showErrorRating = _e[0], setShowErrorRating = _e[1];
    var selectedStaff = page.selectedStaff || { key: '', name: 'staff', src: '' };
    useEffect(function () {
        var _a, _b, _c, _d;
        if ((_a = page === null || page === void 0 ? void 0 : page.selectedValue) === null || _a === void 0 ? void 0 : _a.comment) {
            setComment((_b = page === null || page === void 0 ? void 0 : page.selectedValue) === null || _b === void 0 ? void 0 : _b.comment);
        }
        if ((_c = page === null || page === void 0 ? void 0 : page.selectedValue) === null || _c === void 0 ? void 0 : _c.rating) {
            setRating((_d = page === null || page === void 0 ? void 0 : page.selectedValue) === null || _d === void 0 ? void 0 : _d.rating);
        }
    }, [page]);
    var handleSubmitPage = function () {
        if (getFieldRequired(page, 'required')) {
            if (!rating) {
                setShowErrorRating(true);
                return;
            }
            if (!comment) {
                setShowErrorComment(true);
                return;
            }
        }
        setShowErrorComment(false);
        setShowErrorRating(false);
        onNextPage({ staffId: selectedStaff.key, comment: comment, rating: rating, type: ratingType });
    };
    var renderRating = function (ratingType) {
        var handleOnChange = function (value) {
            // onNextPage({ value, type: ratingType || RATING.STAR_1_10 });
            setShowErrorRating(false);
            setRating(value);
            trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.STAFF_RATING_SELECT_STAFF_RATING);
        };
        switch (ratingType) {
            case RATING.THUMBS:
                return React__default.createElement(Input.Rating, { type: 'thumbs', value: rating, onChange: handleOnChange });
            case RATING.EMOJI:
                return React__default.createElement(Input.Rating, { type: 'emoji', value: rating, onChange: handleOnChange });
            case RATING.STAR_1_10:
                return React__default.createElement(Input.Rating, { count: 10, value: rating, onChange: handleOnChange });
            case RATING.STAR_1_5:
                return React__default.createElement(Input.Rating, { count: 5, value: rating, onChange: handleOnChange });
            case RATING.STAR_1_3:
                return React__default.createElement(Input.Rating, { count: 3, value: rating, onChange: handleOnChange });
            default:
                return React__default.createElement(Input.Rating, { count: 10, value: rating, onChange: handleOnChange });
        }
    };
    var onCommentChange = function (comment) {
        if (comment)
            setShowErrorComment(false);
        setComment(comment);
    };
    var pageTitle = getFieldValue(page, 'title').replace('{staff_name}', selectedStaff === null || selectedStaff === void 0 ? void 0 : selectedStaff.name);
    var ratingType = getFieldValue(page, 'rating_type') || RATING.STAR_1_10;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(BrandInfo, { page: page }),
        showField(page, 'title') && (React__default.createElement("div", { className: "page-title" },
            React__default.createElement(Text$1.H2, { semibold: true, dangerouslySetInnerHTML: { __html: pageTitle } }))),
        React__default.createElement("div", { className: "page-body" },
            React__default.createElement("div", { className: "page-content" }, selectedStaff && (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(StaffProfileWrap, null,
                    React__default.createElement(ProfileImage, { src: selectedStaff.src || '', name: selectedStaff.name })),
                React__default.createElement(RatingWrap, { className: "staff-rating" }, renderRating(ratingType)),
                showErrorRating && React__default.createElement(ErrorMsg, null, "This field is required"),
                React__default.createElement("div", { className: "mb-10" },
                    React__default.createElement(Text$1.B1, null, "Tell us more about your experience with ".concat(selectedStaff.name))),
                React__default.createElement(Input.TextArea, { placeholder: "Comment", value: comment, onChange: function (e) {
                        onCommentChange(e.target.value);
                    }, onFocus: function () {
                        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(TRACKING_EVENTS.STAFF_RATING_COMMENT);
                    } }),
                showErrorComment && React__default.createElement(ErrorMsg, null, "This field is required"))))),
        React__default.createElement(FloatingBtn, { onClick: function () { return handleSubmitPage(); } })));
};
var MemoizedSurveyPage = memo(SurveyPage);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

var identity = identity_1;

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction$1(value) {
  return typeof value == 'function' ? value : identity;
}

var _castFunction = castFunction$1;

var arrayEach = _arrayEach,
    baseEach = _baseEach,
    castFunction = _castFunction,
    isArray = isArray_1;

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

var forEach_1 = forEach;

var forEach$1 = /*@__PURE__*/getDefaultExportFromCjs(forEach_1);

var findNextNonSkippablePageKey = function (pages, currentPageKey) {
    var currentPageIndex = pages.findIndex(function (page) { return page.pageKey === currentPageKey; });
    var nextPageIndex = pages.findIndex(function (page, index) { return index >= currentPageIndex + 1 && !page.skipPage && !page.ignorePage; });
    return nextPageIndex !== -1 ? pages[nextPageIndex].pageKey : null;
};
var SurveyViewer = function (_a) {
    var surveyPages = _a.pages, initialPageKey = _a.initialPageKey, setInitialPageKey = _a.setInitialPageKey, currentPageKey = _a.currentPageKey, setCurrentPageKey = _a.setCurrentPageKey, theme = _a.theme, submitSurvey = _a.submitSurvey, editorMode = _a.editorMode, surveySettings = _a.surveySettings, uploadPicturesRequest = _a.uploadPicturesRequest, loading = _a.loading, expressParams = _a.expressParams, region = _a.region, handleAssistedReview = _a.handleAssistedReview, brandId = _a.brandId, brandRegion = _a.brandRegion, trackEvent = _a.trackEvent, surveyData = _a.surveyData, vouchersData = _a.vouchersData, multiVoucherIds = _a.multiVoucherIds, voucherIdsMetadata = _a.voucherIdsMetadata, itemList = _a.itemList;
    var isSurveyFeedbackSurveyV2Enabled = isEqual$1(surveySettings.template, SURVEY_TEMPLATES.STD_FEEDBACK_SURVEY_V2);
    var pages = useMemo(function () {
        // check if we can pass some flag to use new condition for OR
        if (isSurveyFeedbackSurveyV2Enabled) {
            return reformatQuestionsWithFullConditions(cloneDeep$1(surveyPages), itemList);
        }
        else {
            return surveyPages;
        }
    }, [surveyPages]);
    var _b = useState([]), pageDataStack = _b[0], setPageStackData = _b[1];
    var _c = useState(false), surveySubmitted = _c[0], setSurveySubmitted = _c[1];
    var _d = useState(isSurveyFeedbackSurveyV2Enabled ? getInitialQuestionsVisibleStatus({ pages: pages }) : {}), globalQuestionsVisibleMap = _d[0], setGlobalQuestionsVisibleMap = _d[1];
    var _e = useState(isSurveyFeedbackSurveyV2Enabled ? getInitialSelectedFactMap({ pages: pages, itemList: itemList }) : {}), globalSelectedFactMap = _e[0], setGlobalSelectedFactMap = _e[1];
    var allQuestionsRulesFromEngine = useMemo(function () {
        if (isSurveyFeedbackSurveyV2Enabled) {
            return generateConditionalRulesEngine({ pages: pages });
        }
        return {};
    }, [pages, surveySettings]);
    var availablePages = useMemo(function () { return pages === null || pages === void 0 ? void 0 : pages.filter(function (page) { return !(page === null || page === void 0 ? void 0 : page.skipPage); }); }, [pages]);
    var handleTrackEvent = function (data) {
        try {
            var currentPageNumber = availablePages === null || availablePages === void 0 ? void 0 : availablePages.findIndex(function (page) { return page.pageKey === currentPageKey; });
            var value = {
                totalPage: availablePages === null || availablePages === void 0 ? void 0 : availablePages.length,
                page: currentPageNumber + 1,
                surveyId: surveyData === null || surveyData === void 0 ? void 0 : surveyData.id,
                revisionId: surveyData === null || surveyData === void 0 ? void 0 : surveyData.revisionId
            };
            trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(__assign(__assign({}, data), { value: JSON.stringify(value) }));
        }
        catch (err) {
            console.log(err);
        }
    };
    var getReviewTextValue = function () {
        var page = _.find(pages, function (p) { return _.includes(BOOST_PAGE_KEYS, p.pageKey); });
        if (!page)
            return null;
        var reviewTextField = _.find(page.value, function (o) { return o.fieldKey === 'review_text'; });
        if (!reviewTextField)
            return null;
        var config = reviewTextField.fieldValueConfig;
        var hasConfig = _.isPlainObject(config) && !_.isEmpty(config);
        if (hasConfig) {
            return _.get(config, page.pageVariant).fieldValue;
        }
        else {
            return reviewTextField === null || reviewTextField === void 0 ? void 0 : reviewTextField.fieldValue;
        }
    };
    var setReviewTextValue = function (reviewText) {
        var boostPage = _.find(pages, function (p) { return _.includes(BOOST_PAGE_KEYS, p.pageKey); });
        if (!boostPage)
            return;
        var reviewTextField = _.find(boostPage.value, function (field) { return field.fieldKey === 'review_text'; });
        if (!reviewTextField)
            return;
        if (_.isPlainObject(reviewTextField.fieldValueConfig) && !_.isEmpty(reviewTextField.fieldValueConfig)) {
            _.forEach(reviewTextField.fieldValueConfig, function (config) {
                config.fieldValue = reviewText;
            });
        }
        else {
            reviewTextField.fieldValue = reviewText;
        }
    };
    //Tracking STEP event
    useEffect(function () {
        var _a;
        if (!currentPageKey)
            return;
        try {
            var trackingPage = availablePages.find(function (page) { return page.pageKey === currentPageKey; });
            handleTrackEvent === null || handleTrackEvent === void 0 ? void 0 : handleTrackEvent({
                action: 'CLICK',
                label: "SURVEY.STEP.".concat((_a = snakeCase$1((trackingPage === null || trackingPage === void 0 ? void 0 : trackingPage.pageName) || currentPageKey)) === null || _a === void 0 ? void 0 : _a.toUpperCase())
            });
        }
        catch (err) {
            console.log(err);
        }
    }, [currentPageKey]);
    // handle express params
    useEffect(function () {
        var _a;
        var _b, _c, _d;
        // 1. orderType
        if (expressParams === null || expressParams === void 0 ? void 0 : expressParams.orderType) {
            var orderTypePage = pages.find(function (page) { return page.pageKey === PAGE_KEYS.TYPE_OF_ORDER; });
            orderTypePage.selectedValue = {
                key: expressParams.orderType
            };
            orderTypePage.skipPage = true;
            onSelectOrderType();
        }
        // 2. selectedPlatform
        if (expressParams === null || expressParams === void 0 ? void 0 : expressParams.selectedPlatform) {
            var deliveryPlatformPage = pages.find(function (page) { return page.pageKey === PAGE_KEYS.DELIVERY_PLATFORM; });
            deliveryPlatformPage.selectedValue = {
                label: expressParams.selectedPlatform
            };
            deliveryPlatformPage.skipPage = true;
        }
        // 3. outletId
        if (expressParams === null || expressParams === void 0 ? void 0 : expressParams.outletId) {
            var locationPage = pages.find(function (page) { return page.pageKey === PAGE_KEYS.CHOOSE_LOCATION; });
            var locationFound = (_b = locationPage === null || locationPage === void 0 ? void 0 : locationPage.value.find(function (field) { return field.fieldKey === 'location'; })) === null || _b === void 0 ? void 0 : _b.fieldValue.find(function (option) { return option.show && option.key == expressParams.outletId; });
            if (locationFound) {
                locationPage.selectedValue = locationFound;
                locationPage.skipPage = true;
                onSelectLocation(locationFound);
            }
        }
        // 4. star rating
        if (expressParams === null || expressParams === void 0 ? void 0 : expressParams.rating) {
            var ratingPage_1 = pages.find(function (page) { return page.pageKey === PAGE_KEYS.RATINGS; });
            if (ratingPage_1) {
                var ratingType = (_c = ratingPage_1.value) === null || _c === void 0 ? void 0 : _c.find(function (eachValue) { return (eachValue === null || eachValue === void 0 ? void 0 : eachValue.fieldKey) === 'rating_type'; });
                if ((ratingType === null || ratingType === void 0 ? void 0 : ratingType.fieldValue) === '1_5') {
                    if (isSurveyFeedbackSurveyV2Enabled) {
                        ratingPage_1.selectedValue = {
                            rating: {
                                type: ratingType === null || ratingType === void 0 ? void 0 : ratingType.fieldValue,
                                value: expressParams === null || expressParams === void 0 ? void 0 : expressParams.rating
                            }
                        };
                        var factKey = 'rating_value';
                        var updatedSelectedFactMap_1 = __assign(__assign({}, globalSelectedFactMap), (_a = {}, _a[factKey] = expressParams === null || expressParams === void 0 ? void 0 : expressParams.rating, _a));
                        getQuestionsVisibleStatus({
                            page: ratingPage_1,
                            factMap: updatedSelectedFactMap_1,
                            allQuestionsRulesFromEngine: allQuestionsRulesFromEngine
                        }).then(function (result) {
                            var hasQuestionToShow = Object.values(omit$1(result, 'rating')).some(function (isVisible) { return !!isVisible; });
                            if (!hasQuestionToShow) {
                                ratingPage_1.skipPage = true;
                                handleRatingPageLogic();
                            }
                            setGlobalQuestionsVisibleMap(__assign(__assign({}, globalQuestionsVisibleMap), result));
                            setGlobalSelectedFactMap(updatedSelectedFactMap_1);
                        });
                    }
                    else {
                        ratingPage_1.selectedValue = {
                            type: ratingType === null || ratingType === void 0 ? void 0 : ratingType.fieldValue,
                            value: expressParams === null || expressParams === void 0 ? void 0 : expressParams.rating
                        };
                        handleRatingPageLogic();
                        ratingPage_1.skipPage = true;
                    }
                }
            }
        }
        if ((expressParams === null || expressParams === void 0 ? void 0 : expressParams.lat) && (expressParams === null || expressParams === void 0 ? void 0 : expressParams.long)) {
            // handle express survey lat & long
            var lat_1 = expressParams.lat, long_1 = expressParams.long;
            // let pagesCopy: Page[] = [...pages];
            var locationPageIndex = pages.findIndex(function (page) { return page.pageKey === PAGE_KEYS.CHOOSE_LOCATION; });
            if (locationPageIndex !== -1) {
                var locationValuesIndex = (_d = pages[locationPageIndex]) === null || _d === void 0 ? void 0 : _d.value.findIndex(function (field) { return field.fieldKey === 'location'; });
                if (locationValuesIndex !== -1) {
                    var locationValues = pages[locationPageIndex].value[locationValuesIndex].fieldValue;
                    var filteredValues = locationValues.filter(function (outlet) {
                        var _a;
                        if (outlet.key === 'all') {
                            return false;
                        }
                        if ((_a = outlet.latLong) === null || _a === void 0 ? void 0 : _a.length) {
                            var distance = haversineDistance([lat_1, long_1], outlet.latLong);
                            return distance <= 0.3;
                        }
                        return false;
                    });
                    // check if filtered value contains only one option other than all, if yes skip location page
                    if (filteredValues.length === 1) {
                        pages[locationPageIndex].selectedValue = filteredValues[0];
                        pages[locationPageIndex].skipPage = true;
                        onSelectLocation(filteredValues[0]);
                    }
                    if (filteredValues.length > 1) {
                        pages[locationPageIndex].value[locationValuesIndex].fieldValue = filteredValues;
                    }
                }
            }
            // setPages && setPages(pagesCopy);
        }
        // 4. EXPERIENCE_DETAILS: reviewText, orderDate, orderTime, orderId
        var reviewPage = pages.find(function (page) { return page.pageKey === PAGE_KEYS.EXPERIENCE_DETAILS; });
        if (reviewPage && !isEmpty$1(reviewPage.value)) {
            var fieldsToUpdate = {
                title: expressParams === null || expressParams === void 0 ? void 0 : expressParams.reviewText,
                visit_date: expressParams === null || expressParams === void 0 ? void 0 : expressParams.orderDate,
                visit_time: expressParams === null || expressParams === void 0 ? void 0 : expressParams.orderTime,
                order_reference_number: expressParams === null || expressParams === void 0 ? void 0 : expressParams.orderId
            };
            forEach$1(fieldsToUpdate, function (value, key) {
                if (value) {
                    var field = find$1(reviewPage.value, { fieldKey: key });
                    if (field) {
                        field.defaultAnswer = value;
                    }
                }
            });
        }
        // 5. PERSONAL_INFORMATION: name, email
        var personalInformationPage = pages.find(function (page) { return page.pageKey === PAGE_KEYS.PERSONAL_INFORMATION; });
        if (personalInformationPage) {
            if (expressParams === null || expressParams === void 0 ? void 0 : expressParams.name)
                personalInformationPage.value.find(function (field) { return field.fieldKey === 'name'; }).defaultAnswer = expressParams.name;
            if (expressParams === null || expressParams === void 0 ? void 0 : expressParams.email)
                personalInformationPage.value.find(function (field) { return field.fieldKey === 'email'; }).defaultAnswer = expressParams.email;
            if ((expressParams === null || expressParams === void 0 ? void 0 : expressParams.phoneNumber) || (expressParams === null || expressParams === void 0 ? void 0 : expressParams.phone))
                personalInformationPage.value.find(function (field) { return field.fieldKey === 'phone_no'; }).defaultAnswer =
                    expressParams.phoneNumber || (expressParams === null || expressParams === void 0 ? void 0 : expressParams.phone);
        }
        // setPages && setPages(cloneDeep(pages));
    }, [expressParams]);
    useEffect(function () {
        var findNonSkippablePageKey = function (pages, currentPageKey) {
            var currentPageIndex = pages.findIndex(function (page) { return !page.skipPage; });
            return currentPageIndex !== -1 ? pages[currentPageIndex].pageKey : currentPageKey;
        };
        var shouldSkipWelcomePage = findNonSkippablePageKey(pages, PAGE_KEYS.WELCOME_PAGE) !== PAGE_KEYS.WELCOME_PAGE;
        if (shouldSkipWelcomePage) {
            if (!initialPageKey) {
                handlePageLogic();
                var nextPageKey = findNextNonSkippablePageKey(pages, PAGE_KEYS.WELCOME_PAGE) || currentPageKey;
                setInitialPageKey && setInitialPageKey(nextPageKey);
                setCurrentPageKey(nextPageKey);
            }
        }
        else {
            setInitialPageKey && setInitialPageKey(PAGE_KEYS.WELCOME_PAGE);
        }
    }, [initialPageKey]);
    var findNextNonSkippablePageKeyBasedOnConditions = function (pages, currentPageKey, selectedFactMap, allQuestionsRulesFromEngine) { return __awaiter(void 0, void 0, void 0, function () {
        var currentPageIndex, globalVisibleQuestionsMap, lastVisitedPageIndex, i, page, hasVisibleQuestion, visibleQuestionList, chooseOfferQuestion, noOfferPayload, offerList, pageKeyToShow, surveyData_1, nextPageKey, reviewText, response, nextPageIndex;
        var _a;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        return __generator(this, function (_o) {
            switch (_o.label) {
                case 0:
                    currentPageIndex = pages.findIndex(function (page) { return page.pageKey === currentPageKey; });
                    return [4 /*yield*/, getQuestionsVisibleStatusForAllPages({
                            pages: pages,
                            factMap: __assign(__assign({}, globalSelectedFactMap), selectedFactMap),
                            allQuestionsRulesFromEngine: allQuestionsRulesFromEngine
                        })];
                case 1:
                    globalVisibleQuestionsMap = _o.sent();
                    setGlobalQuestionsVisibleMap(globalVisibleQuestionsMap);
                    setGlobalSelectedFactMap(__assign(__assign({}, globalSelectedFactMap), selectedFactMap));
                    lastVisitedPageIndex = currentPageIndex;
                    // Find the next non-skippable page with at least one visible question
                    for (i = currentPageIndex + 1; i < pages.length; i++) {
                        page = pages[i];
                        if (!page.skipPage && !page.ignorePage) {
                            if (STATIC_SURVEY_PAGES.includes(page.pageKey)) {
                                if (BOOST_PAGE_KEYS.includes(page.pageKey)) {
                                    lastVisitedPageIndex = i;
                                    break;
                                }
                                return [2 /*return*/, page.pageKey];
                            }
                        }
                        if (!page.skipPage &&
                            !page.ignorePage &&
                            ((page === null || page === void 0 ? void 0 : page.isCustomPage) || STATIC_PAGE_KEYS_WITH_CUSTOM_QUESTIONS.includes(page === null || page === void 0 ? void 0 : page.pageKey))) {
                            hasVisibleQuestion = isEmpty$1(page === null || page === void 0 ? void 0 : page.questions)
                                ? (page === null || page === void 0 ? void 0 : page.isCustomPage)
                                    ? false
                                    : true
                                : (_b = page === null || page === void 0 ? void 0 : page.questions) === null || _b === void 0 ? void 0 : _b.some(function (question) {
                                    if (!editorMode &&
                                        globalVisibleQuestionsMap &&
                                        has$1(globalVisibleQuestionsMap, question === null || question === void 0 ? void 0 : question.originQuestionId) &&
                                        !globalVisibleQuestionsMap[question.originQuestionId]) {
                                        return false;
                                    }
                                    return true;
                                });
                            if ((page === null || page === void 0 ? void 0 : page.isCustomPage) && !editorMode) {
                                visibleQuestionList = _.filter(page === null || page === void 0 ? void 0 : page.questions, function (q) {
                                    var originId = q === null || q === void 0 ? void 0 : q.originQuestionId;
                                    return !(globalVisibleQuestionsMap && _.has(globalVisibleQuestionsMap, originId) && !globalVisibleQuestionsMap[originId]);
                                });
                                if ((visibleQuestionList === null || visibleQuestionList === void 0 ? void 0 : visibleQuestionList.length) === 1 && isEqual$1((_c = visibleQuestionList[0]) === null || _c === void 0 ? void 0 : _c.questionType, QUESTION_TYPE_KEYS.CHOOSE_VOUCHER)) {
                                    chooseOfferQuestion = visibleQuestionList[0];
                                    noOfferPayload = (_d = chooseOfferQuestion.value) === null || _d === void 0 ? void 0 : _d.find(function (field) { return field.fieldKey === 'no_offer_label'; });
                                    offerList = (_e = chooseOfferQuestion.value) === null || _e === void 0 ? void 0 : _e.find(function (field) { return field.fieldKey === 'voucher_list'; });
                                    offerList = (_f = offerList === null || offerList === void 0 ? void 0 : offerList.fieldValue) === null || _f === void 0 ? void 0 : _f.filter(function (eachOfferList) {
                                        return eachOfferList === null || eachOfferList === void 0 ? void 0 : eachOfferList.show;
                                    });
                                    if ((offerList === null || offerList === void 0 ? void 0 : offerList.length) === 1 && !(noOfferPayload === null || noOfferPayload === void 0 ? void 0 : noOfferPayload.show)) {
                                        page.selectedValue = (_a = {},
                                            _a[chooseOfferQuestion.originQuestionId] = {
                                                questionType: 'choose_voucher',
                                                value: offerList[0]
                                            },
                                            _a);
                                        hasVisibleQuestion = false;
                                    }
                                }
                            }
                            if (hasVisibleQuestion) {
                                return [2 /*return*/, page.pageKey];
                            }
                            lastVisitedPageIndex = i;
                        }
                    }
                    pageKeyToShow = pages[lastVisitedPageIndex].pageKey;
                    if (!(isEqual$1((_g = pages[lastVisitedPageIndex]) === null || _g === void 0 ? void 0 : _g.pageKey, PAGE_KEYS.PERSONAL_INFORMATION) ||
                        BOOST_PAGE_KEYS.includes((_h = pages[lastVisitedPageIndex]) === null || _h === void 0 ? void 0 : _h.pageKey))) return [3 /*break*/, 6];
                    surveyData_1 = pages.map(function (page) { return cleanUpSurveyDetailsForSubmission(page, globalQuestionsVisibleMap); });
                    nextPageKey = isEqual$1((_j = pages[lastVisitedPageIndex]) === null || _j === void 0 ? void 0 : _j.pageKey, PAGE_KEYS.BOOST_PAGE)
                        ? PAGE_KEYS.BOOST_PAGE
                        : isEqual$1((_k = pages[lastVisitedPageIndex]) === null || _k === void 0 ? void 0 : _k.pageKey, PAGE_KEYS.BOOST_PAGE_V2)
                            ? PAGE_KEYS.BOOST_PAGE_V2
                            : findNextNonSkippablePageKey(pages, (_l = pages[lastVisitedPageIndex]) === null || _l === void 0 ? void 0 : _l.pageKey) ||
                                ((_m = pages[lastVisitedPageIndex]) === null || _m === void 0 ? void 0 : _m.pageKey);
                    try {
                        if (BOOST_PAGE_KEYS.includes(nextPageKey)) {
                            reviewText = getReviewTextValue();
                            if (reviewText && typeof reviewText === 'string')
                                copy$1(reviewText || '');
                        }
                    }
                    catch (error) {
                        console.error('An error occured while copying review text into clipboard');
                    }
                    if (!submitSurvey) return [3 /*break*/, 5];
                    _o.label = 2;
                case 2:
                    _o.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, submitSurvey(surveyData_1, {
                            boostdisplayed: BOOST_PAGE_KEYS.includes(nextPageKey)
                        })];
                case 3:
                    response = _o.sent();
                    if (response) {
                        setSurveySubmitted(true);
                        return [2 /*return*/, nextPageKey];
                    }
                    return [3 /*break*/, 5];
                case 4:
                    _o.sent();
                    console.error('An error occured while submitting the survey');
                    return [3 /*break*/, 5];
                case 5: return [3 /*break*/, 7];
                case 6:
                    nextPageIndex = pages.findIndex(function (page, index) { return index >= lastVisitedPageIndex + 1 && !page.skipPage && !page.ignorePage; });
                    pageKeyToShow = nextPageIndex !== -1 ? pages[nextPageIndex].pageKey : null;
                    return [2 /*return*/, pageKeyToShow];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var setCurrentPageStateInState = function () {
        var pageStackData = __spreadArray([], pageDataStack, true);
        pageStackData.push({ data: cloneDeep$1(pages), key: currentPageKey });
        setPageStackData(pageStackData);
    };
    var goToNextPage = function (val, selectedFactMap, metaData) { return __awaiter(void 0, void 0, void 0, function () {
        var page, nextPageKey, nextPageKeyBasedOnConditions;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    page = pages.find(function (p) { return p.pageKey == currentPageKey; });
                    page.selectedValue = val;
                    page.metaData = metaData;
                    setCurrentPageStateInState();
                    handlePageLogic();
                    if (!(currentPageKey !== PAGE_KEYS.PERSONAL_INFORMATION)) return [3 /*break*/, 3];
                    nextPageKey = findNextNonSkippablePageKey(pages, currentPageKey) || currentPageKey;
                    if (!(!__spreadArray([PAGE_KEYS.WELCOME_PAGE], BOOST_PAGE_KEYS, true).includes(currentPageKey) && isSurveyFeedbackSurveyV2Enabled)) return [3 /*break*/, 2];
                    return [4 /*yield*/, findNextNonSkippablePageKeyBasedOnConditions(pages, currentPageKey, selectedFactMap || {}, allQuestionsRulesFromEngine)];
                case 1:
                    nextPageKeyBasedOnConditions = _a.sent();
                    nextPageKey = nextPageKeyBasedOnConditions || currentPageKey;
                    _a.label = 2;
                case 2:
                    setCurrentPageKey(nextPageKey);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onSelectOrderType = function () {
        var _a;
        // if order type is not delivery, skip delivery platform page
        var orderTypePage = pages.find(function (page) { return page.pageKey === PAGE_KEYS.TYPE_OF_ORDER; });
        var selectedOrderType = (_a = orderTypePage === null || orderTypePage === void 0 ? void 0 : orderTypePage.selectedValue) === null || _a === void 0 ? void 0 : _a.key;
        var isOrderTypeDelivery = selectedOrderType === ORDER_TYPE.DELIVERY;
        var deliveryPlatformPage = pages.find(function (page) { return page.pageKey === PAGE_KEYS.DELIVERY_PLATFORM; });
        if (!isOrderTypeDelivery) {
            if (deliveryPlatformPage) {
                deliveryPlatformPage.ignorePage = true;
                deliveryPlatformPage.selectedValue = undefined;
            }
        }
        else {
            deliveryPlatformPage.ignorePage = deliveryPlatformPage === null || deliveryPlatformPage === void 0 ? void 0 : deliveryPlatformPage.skipPage;
        }
        // add selected order type to these pages: EXPERIENCE_POSITIVE, EXPERIENCE_NEGATIVE, EXPERIENCE_DETAILS
        pages.find(function (page) { return page.pageKey === PAGE_KEYS.EXPERIENCE_POSITIVE; }).selectedOrderType = selectedOrderType;
        pages.find(function (page) { return page.pageKey === PAGE_KEYS.EXPERIENCE_NEGATIVE; }).selectedOrderType = selectedOrderType;
        pages.find(function (page) { return page.pageKey === PAGE_KEYS.EXPERIENCE_DETAILS; }).selectedOrderType = selectedOrderType;
        handleLocationPage(isOrderTypeDelivery);
    };
    var handleLocationPage = function (isOrderTypeDelivery) {
        var _a;
        var locationPage = pages.find(function (page) { return page.pageKey === PAGE_KEYS.CHOOSE_LOCATION; });
        var locationOptions = (_a = locationPage === null || locationPage === void 0 ? void 0 : locationPage.value.find(function (field) { return field.fieldKey === 'location'; })) === null || _a === void 0 ? void 0 : _a.fieldValue.filter(function (option) { return option.show && option.key != 'all'; });
        // if there is only single option to select for location, no need to show the page - autoselect and goto next page
        if ((locationOptions === null || locationOptions === void 0 ? void 0 : locationOptions.length) === 1) {
            locationPage.selectedValue = locationOptions[0];
            locationPage.skipPage = true;
            onSelectLocation(locationOptions[0]);
        }
        else {
            //  // if there are more than 1 location then handle delivery platform page
            if (isOrderTypeDelivery) {
                handleDeliveryType(locationPage === null || locationPage === void 0 ? void 0 : locationPage.selectedValue);
            }
        }
    };
    var onSelectLocation = function (selectedLocation) {
        var _a, _b, _c, _d, _e;
        // logic: if order type is delivery and when location is selected, get delivery-platforms for that selected location
        // selected-location can be found in the delivery-platform page (ie. delivery-platforms_editor fieldValue)
        var isOrderTypeDelivery = ((_b = (_a = pages.find(function (page) { return page.pageKey === PAGE_KEYS.TYPE_OF_ORDER; })) === null || _a === void 0 ? void 0 : _a.selectedValue) === null || _b === void 0 ? void 0 : _b.key) === ORDER_TYPE.DELIVERY;
        if (isOrderTypeDelivery) {
            handleDeliveryType(selectedLocation);
        }
        // also, populate staff_list field with staff from selected location
        var staffListPage = pages.find(function (page) { return page.pageKey === PAGE_KEYS.STAFF_LIST; });
        var outletStaffList = (_c = staffListPage === null || staffListPage === void 0 ? void 0 : staffListPage.value.find(function (field) { return field.fieldKey === 'outlet_staff_list'; })) === null || _c === void 0 ? void 0 : _c.fieldValue;
        var staffListField = staffListPage === null || staffListPage === void 0 ? void 0 : staffListPage.value.find(function (field) { return field.fieldKey === 'staff_list'; });
        if (outletStaffList && staffListField) {
            var selectedLocationStaffs = (_d = outletStaffList[selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.key]) === null || _d === void 0 ? void 0 : _d.map(function (staff) {
                var _a, _b;
                return {
                    key: staff.id,
                    value: staff.name,
                    src: (_b = (_a = staff.media) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.url
                };
            });
            staffListField.fieldValue = selectedLocationStaffs;
            var staffRatingPage = pages.find(function (page) { return page.pageKey === PAGE_KEYS.STAFF_RATING; });
            if (!selectedLocationStaffs || (selectedLocationStaffs === null || selectedLocationStaffs === void 0 ? void 0 : selectedLocationStaffs.length) == 0) {
                staffListPage.skipPage = true;
                staffRatingPage.skipPage = true;
            }
            else {
                staffListPage.skipPage = false;
                staffRatingPage.skipPage = false;
            }
        }
        // if selectedLocation doesn't contain Google link, skip Boost page
        var boostPage = pages.find(function (page) { return page.pageKey === PAGE_KEYS.BOOST_PAGE; });
        var boostPageV2 = pages.find(function (page) { return page.pageKey === PAGE_KEYS.BOOST_PAGE_V2; });
        if (boostPage) {
            if (!(selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.gmbReviewLink)) {
                // hard code logic for Rosa Brothers Milk Company account to change boosted review links
                if (brandId === 'b786494b-bcdb-4947-b7fd-146280a5e184') {
                    boostPage.selectedLocationReviewLink =
                        'https://search.google.com/local/writereview?placeid=ChIJiUTdQkIrlYARURmv0to0Z50';
                }
                else {
                    boostPage.skipPage = true;
                }
            }
            else {
                boostPage.skipPage = false;
                boostPage.selectedLocationReviewLink = selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.gmbReviewLink;
            }
        }
        if (boostPageV2) {
            var config_1 = {
                skip: true,
                selectedLocationReviewGMBLink: null,
                selectedLocationReviewYelpLink: null,
                pageVariant: null
            };
            var boostPlatformsField = (_e = boostPageV2.value) === null || _e === void 0 ? void 0 : _e.find(function (f) { return (f === null || f === void 0 ? void 0 : f.fieldKey) === 'boost_platforms' && !isEmpty$1(f === null || f === void 0 ? void 0 : f.fieldValue); });
            if (boostPlatformsField) {
                var platforms = lodashExports.get(boostPlatformsField, 'fieldValue', []);
                var hasGMB = !!lodashExports.get(selectedLocation, 'gmbReviewLink');
                var hasYelp = !!lodashExports.get(selectedLocation, 'yelpReviewLink');
                var setConfig = function (variant, gmb, yelp) {
                    config_1 = {
                        skip: false,
                        selectedLocationReviewGMBLink: gmb,
                        selectedLocationReviewYelpLink: yelp,
                        pageVariant: variant
                    };
                };
                if (platforms.length > 1) {
                    if (hasGMB && hasYelp)
                        setConfig('all', selectedLocation.gmbReviewLink, selectedLocation.yelpReviewLink);
                    else if (hasGMB)
                        setConfig('google', selectedLocation.gmbReviewLink, null);
                    else if (hasYelp)
                        setConfig('yelp', null, selectedLocation.yelpReviewLink);
                }
                else if (platforms.length === 1) {
                    var platform = platforms[0];
                    if (platform === 'google' && hasGMB)
                        setConfig('google', selectedLocation.gmbReviewLink, null);
                    else if (platform === 'yelp' && hasYelp)
                        setConfig('yelp', null, selectedLocation.yelpReviewLink);
                }
            }
            // Assign config to boostPageV2
            boostPageV2.skipPage = config_1.skip;
            boostPageV2.selectedLocationReviewLink = config_1.selectedLocationReviewGMBLink;
            boostPageV2.selectedLocationReviewYelpLink = config_1.selectedLocationReviewYelpLink;
            boostPageV2.pageVariant = config_1.pageVariant;
        }
    };
    var handleDeliveryType = function (selectedLocation) {
        var _a, _b, _c;
        var deliveryPlatformPage = pages.find(function (page) { return page.pageKey === PAGE_KEYS.DELIVERY_PLATFORM; });
        var deliveryPlatformsEditorField = (_a = deliveryPlatformPage === null || deliveryPlatformPage === void 0 ? void 0 : deliveryPlatformPage.value.find(function (page) { return page.fieldKey === 'delivery_platforms_editor'; })) === null || _a === void 0 ? void 0 : _a.fieldValue.filter(function (field) { return field.show; }).map(function (field) { return field.value; });
        var deliveryPlatformsField = deliveryPlatformPage === null || deliveryPlatformPage === void 0 ? void 0 : deliveryPlatformPage.value.find(function (page) { return page.fieldKey === 'delivery_platforms'; });
        if (deliveryPlatformsField) {
            var selectedLocationDeliveryPlatforms = (_c = (_b = selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.thirdPartyLinks) === null || _b === void 0 ? void 0 : _b.filter(function (link) {
                return link.type === THIRD_PARTY_LINK_TYPE.FOOD_DELIVERY && deliveryPlatformsEditorField.includes(link.category);
            })) === null || _c === void 0 ? void 0 : _c.map(function (link) {
                return {
                    key: link.id,
                    label: link.category,
                    value: link.category,
                    iconUrl: link.logo,
                    show: true,
                    showTextbox: false
                };
            });
            deliveryPlatformsField.fieldValue = __spreadArray(__spreadArray([], (selectedLocationDeliveryPlatforms || []), true), [
                {
                    key: 'other',
                    label: 'Other',
                    value: 'Other',
                    iconUrl: '',
                    iconName: 'Other',
                    show: deliveryPlatformsEditorField.includes('Other'),
                    showTextbox: true
                },
            ], false);
        }
        // if there is only single option to select for delivery platform, no need to show the page - autoselect and goto next page
        var deliveryPlatformOptions = deliveryPlatformsField === null || deliveryPlatformsField === void 0 ? void 0 : deliveryPlatformsField.fieldValue.filter(function (option) { return option.show; });
        // if there is no delivery platform, skip delivery platform page
        if (!(deliveryPlatformOptions === null || deliveryPlatformOptions === void 0 ? void 0 : deliveryPlatformOptions.length)) {
            deliveryPlatformPage.selectedValue = { label: 'N/A', value: 'N/A' };
            deliveryPlatformPage.ignorePage = true;
        }
        else if ((deliveryPlatformOptions === null || deliveryPlatformOptions === void 0 ? void 0 : deliveryPlatformOptions.length) === 1) {
            deliveryPlatformPage.selectedValue = deliveryPlatformOptions[0];
            deliveryPlatformPage.ignorePage = true;
        }
        else {
            deliveryPlatformPage.ignorePage = deliveryPlatformPage === null || deliveryPlatformPage === void 0 ? void 0 : deliveryPlatformPage.skipPage;
        }
    };
    var handleRatingPageLogic = function () {
        var _a, _b, _c, _d, _e;
        var selectedPageRating = (_a = pages.find(function (page) { return page.pageKey === PAGE_KEYS.RATINGS; })) === null || _a === void 0 ? void 0 : _a.selectedValue;
        var ratingValue = selectedPageRating;
        if (surveySettings.template === SURVEY_TEMPLATES.FEW_CLICK_FEEDBACK_SURVEY) {
            ratingValue = selectedPageRating.main || selectedPageRating;
        }
        else if (isSurveyFeedbackSurveyV2Enabled) {
            ratingValue = selectedPageRating.rating || selectedPageRating;
        }
        var isPositiveRating = isCurrentRatingIsUnderRange$1(ratingValue, surveySettings.positiveRating);
        var isNegativeRating = isCurrentRatingIsUnderRange$1(ratingValue, surveySettings.negativeRating);
        var userSelectedServiceType = (_c = (_b = pages.find(function (page) { return page.pageKey === PAGE_KEYS.TYPE_OF_ORDER; })) === null || _b === void 0 ? void 0 : _b.selectedValue) === null || _c === void 0 ? void 0 : _c.key;
        var boostPage = pages.find(function (page) { return BOOST_PAGE_KEYS.includes(page.pageKey); });
        if ([SURVEY_TEMPLATES.FEW_CLICK_FEEDBACK_SURVEY, SURVEY_TEMPLATES.STD_FEEDBACK_SURVEY_V2].includes(surveySettings.template)) {
            var customQuestionsValues_1 = omit$1(selectedPageRating, ['main', 'rating']);
            var fieldToUpdate = keys$8(customQuestionsValues_1).find(function (key) {
                return customQuestionsValues_1[key].isMasterQuestion;
            });
            if (fieldToUpdate && boostPage) {
                setReviewTextValue(customQuestionsValues_1[fieldToUpdate].value);
            }
        }
        if (boostPage) {
            if (boostPage.selectedLocationReviewYelpLink) {
                var yelpRatingParameter = ratingValue.value > 5 ? 5 : ratingValue.value;
                boostPage.selectedLocationReviewYelpLink = "".concat(boostPage.selectedLocationReviewYelpLink, "?rating=").concat(yelpRatingParameter);
            }
            // if not a positive rating, skip boostpage
            if (!isPositiveRating) {
                boostPage.ignorePage = true;
            }
            else {
                // if positive rating and location has gmbReviewLink then show boost page
                var locationPage = pages.find(function (page) { return page.pageKey === PAGE_KEYS.CHOOSE_LOCATION; });
                if ((_d = locationPage === null || locationPage === void 0 ? void 0 : locationPage.selectedValue) === null || _d === void 0 ? void 0 : _d.gmbReviewLink) {
                    boostPage.ignorePage = boostPage.skipPage || false;
                }
            }
        }
        if (surveySettings.template !== SURVEY_TEMPLATES.STD_FEEDBACK_SURVEY_V2) {
            // Based the service type and rating, we need to also handle for experience details page
            var experienceDetailsPage_1 = pages.find(function (page) { return page.pageKey === PAGE_KEYS.EXPERIENCE_DETAILS; });
            if (experienceDetailsPage_1 && !(experienceDetailsPage_1 === null || experienceDetailsPage_1 === void 0 ? void 0 : experienceDetailsPage_1.skipPage)) {
                var shouldRenderMainCommentField = function () {
                    var mainCommentVisible = true;
                    try {
                        if (editorMode) {
                            return mainCommentVisible;
                        }
                        var hasRatingDependency = showQuestionField$1(experienceDetailsPage_1, 'rating_dependency');
                        var hasServiceTypeDependency = showQuestionField$1(experienceDetailsPage_1, 'service_type_dependency');
                        // Determine the rating range based on whether it should be shown on positive rating or not
                        // Check if the current rating is under the specified range and the service type matches the question
                        if (hasRatingDependency && hasServiceTypeDependency) {
                            var hasRatingMatch = doesUserRatingMatchQuestion(experienceDetailsPage_1, isPositiveRating, isNegativeRating);
                            var hasServiceTypeMatch = doesUserServiceTypeMatchQuestion(userSelectedServiceType, experienceDetailsPage_1);
                            mainCommentVisible = hasRatingMatch && hasServiceTypeMatch;
                        }
                        else if (hasRatingDependency) {
                            mainCommentVisible = doesUserRatingMatchQuestion(experienceDetailsPage_1, isPositiveRating, isNegativeRating);
                        }
                        else if (hasServiceTypeDependency) {
                            mainCommentVisible = doesUserServiceTypeMatchQuestion(userSelectedServiceType, experienceDetailsPage_1);
                        }
                        return mainCommentVisible;
                    }
                    catch (error) {
                        console.error('An error occured while rendering the main comment field');
                        return mainCommentVisible;
                    }
                };
                var hasQuestionToShow = [
                    shouldRenderMainCommentField(),
                    showField$1(experienceDetailsPage_1, 'pictures'),
                    showField$1(experienceDetailsPage_1, 'visit_date'),
                    showField$1(experienceDetailsPage_1, 'visit_time'),
                    showField$1(experienceDetailsPage_1, 'order_reference_number'),
                ].some(function (ele) { return ele === true; });
                experienceDetailsPage_1.ignorePage = !hasQuestionToShow;
            }
            // when ratings selected, manage custom page skip logic -
            // if serviceType selected is one of the service_dependency question, don't skip page
            // if rating is positive, skip page if positive questions or neutral questions are not present
            var customPages = pages.filter(function (page) { return page.isCustomPage; });
            for (var _i = 0, customPages_1 = customPages; _i < customPages_1.length; _i++) {
                var customPage = customPages_1[_i];
                if (!customPage.skipPage) {
                    var hasQuestionToShow = (_e = customPage.questions) === null || _e === void 0 ? void 0 : _e.some(function (question) {
                        var hasRatingDependency = showQuestionField$1(question, 'rating_dependency');
                        var hasServiceTypeDependency = showQuestionField$1(question, 'service_type_dependency');
                        if (hasRatingDependency && hasServiceTypeDependency) {
                            var hasRatingMatch = doesUserRatingMatchQuestion(question, isPositiveRating, isNegativeRating);
                            var hasServiceTypeMatch = doesUserServiceTypeMatchQuestion(userSelectedServiceType, question);
                            return hasRatingMatch && hasServiceTypeMatch;
                        }
                        else if (hasRatingDependency) {
                            return doesUserRatingMatchQuestion(question, isPositiveRating, isNegativeRating);
                        }
                        else if (hasServiceTypeDependency) {
                            return doesUserServiceTypeMatchQuestion(userSelectedServiceType, question);
                        }
                        return true;
                    });
                    if (!hasQuestionToShow) {
                        customPage.selectedValue = undefined;
                    }
                    customPage.ignorePage = !hasQuestionToShow;
                }
            }
        }
    };
    var handleSingleVoucherCase = function (pages, vouchersData, multiVoucherIds) {
        var _a;
        var _b, _c, _d, _e, _f;
        var chooseOfferPage = pages.find(function (page) {
            var _a;
            var hasChooseVoucherQuestion = (_a = page.questions) === null || _a === void 0 ? void 0 : _a.some(function (question) { return question.questionType === 'choose_voucher'; });
            return hasChooseVoucherQuestion;
        });
        // If multiple voucher Id metadata is null then use the old logic
        var validateMultiVoucher = (_b = (voucherIdsMetadata || [])) === null || _b === void 0 ? void 0 : _b.filter(function (eachVoucherMetadata) {
            return !lodashExports.isNull(eachVoucherMetadata);
        });
        if (chooseOfferPage && (multiVoucherIds === null || multiVoucherIds === void 0 ? void 0 : multiVoucherIds.length) === 1 && !(validateMultiVoucher === null || validateMultiVoucher === void 0 ? void 0 : validateMultiVoucher.length)) {
            // Check if "no offer" option is not present or hidden
            var noOfferPayload = (_e = (_d = (_c = chooseOfferPage.questions) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.value) === null || _e === void 0 ? void 0 : _e.find(function (field) { return field.fieldKey === 'no_offer_label'; });
            if (!(noOfferPayload === null || noOfferPayload === void 0 ? void 0 : noOfferPayload.show)) {
                // Pre-select the single voucher
                var voucherId = multiVoucherIds[0];
                var chooseVoucherQuestion = (_f = chooseOfferPage.questions) === null || _f === void 0 ? void 0 : _f.find(function (question) { return question.questionType === 'choose_voucher'; });
                if (chooseVoucherQuestion) {
                    chooseOfferPage.selectedValue = (_a = {},
                        _a[chooseVoucherQuestion.originQuestionId] = {
                            questionType: 'choose_voucher',
                            value: voucherId
                        },
                        _a);
                    chooseOfferPage.skipPage = true;
                }
            }
        }
    };
    var handlePageLogic = function () {
        var _a;
        var index = pages.findIndex(function (page) { return page.pageKey === currentPageKey; });
        // Handle single voucher case when on welcome page
        if (pages[index].pageKey === PAGE_KEYS.WELCOME_PAGE || initialPageKey !== PAGE_KEYS.WELCOME_PAGE) {
            if (vouchersData && multiVoucherIds) {
                handleSingleVoucherCase(pages, vouchersData, multiVoucherIds);
            }
            // if there is only single option to select for order type, no need to show the page - autoselect and goto next page
            var orderTypePage = pages.find(function (page) { return page.pageKey === PAGE_KEYS.TYPE_OF_ORDER; });
            var orderTypeOptions = (_a = orderTypePage === null || orderTypePage === void 0 ? void 0 : orderTypePage.value.find(function (field) { return field.fieldKey === 'order_option'; })) === null || _a === void 0 ? void 0 : _a.fieldValue.filter(function (option) { return option.show; });
            if ((orderTypeOptions === null || orderTypeOptions === void 0 ? void 0 : orderTypeOptions.length) === 1) {
                orderTypePage.selectedValue = orderTypeOptions[0];
                orderTypePage.skipPage = true;
                onSelectOrderType();
            }
        }
        if (pages[index].pageKey == PAGE_KEYS.TYPE_OF_ORDER) {
            onSelectOrderType();
        }
        if (pages[index].pageKey == PAGE_KEYS.CHOOSE_LOCATION) {
            onSelectLocation(pages[index].selectedValue);
        }
        if (pages[index].pageKey == PAGE_KEYS.STAFF_LIST) {
            var staffRatingPage = pages.find(function (page) { return page.pageKey === PAGE_KEYS.STAFF_RATING; });
            if (pages[index].selectedValue) {
                staffRatingPage.skipPage = false;
            }
            else {
                staffRatingPage.skipPage = true;
            }
            staffRatingPage.selectedStaff = pages[index].selectedValue;
        }
        if (pages[index].pageKey == PAGE_KEYS.RATINGS) {
            handleRatingPageLogic();
        }
        if (pages[index].pageKey == PAGE_KEYS.EXPERIENCE_DETAILS) {
            // set the review text to boost page
            var experienceDetailsPage = pages.find(function (page) { return page.pageKey === PAGE_KEYS.EXPERIENCE_DETAILS; });
            var mainCommentField = experienceDetailsPage === null || experienceDetailsPage === void 0 ? void 0 : experienceDetailsPage.value.find(function (o) { return o.fieldKey === 'mainCommentField'; });
            if ((mainCommentField && mainCommentField.show) || mainCommentField === undefined) {
                var reviewText = pages[index].selectedValue.comment;
                var boostPage = pages.find(function (page) { return BOOST_PAGE_KEYS.includes(page.pageKey); });
                if (boostPage && !boostPage.skipPage) {
                    setReviewTextValue(reviewText);
                }
            }
        }
        // TODO: Add whitlist check here
        if (pages[index].isCustomPage) {
            var customQuestionsValues_2 = pages[index].selectedValue;
            var fieldToUpdate = keys$8(customQuestionsValues_2).find(function (key) {
                return customQuestionsValues_2[key].isMasterQuestion;
            });
            var boostPage = pages.find(function (page) { return BOOST_PAGE_KEYS.includes(page.pageKey); });
            if (fieldToUpdate && boostPage) {
                setReviewTextValue(customQuestionsValues_2[fieldToUpdate].value);
            }
        }
        // submit survey
        if (pages[index].pageKey == PAGE_KEYS.PERSONAL_INFORMATION) {
            var surveyData_2 = isSurveyFeedbackSurveyV2Enabled
                ? pages.map(function (page) { return cleanUpSurveyDetailsForSubmission(page, globalQuestionsVisibleMap); })
                : pages.map(function (page) {
                    return {
                        pageKey: page.pageKey,
                        isCustomPage: page.isCustomPage,
                        value: page.selectedValue,
                        isCustomQuestionAllowed: page.isCustomQuestionAllowed
                    };
                });
            var nextPageKey_1 = findNextNonSkippablePageKey(pages, currentPageKey) || currentPageKey;
            // Trying to copy the review_text into the user clipboard
            try {
                if (BOOST_PAGE_KEYS.includes(nextPageKey_1)) {
                    var reviewText = getReviewTextValue();
                    if (reviewText && typeof reviewText === 'string')
                        copy$1(reviewText || '');
                }
            }
            catch (error) {
                console.error('An error occured while copying review text into clipboard');
            }
            submitSurvey &&
                submitSurvey(surveyData_2, {
                    boostdisplayed: nextPageKey_1 === PAGE_KEYS.BOOST_PAGE || nextPageKey_1 === PAGE_KEYS.BOOST_PAGE_V2
                })
                    .then(function (success) {
                    if (success) {
                        setSurveySubmitted(true);
                        setCurrentPageKey(nextPageKey_1);
                    }
                })["catch"](function (err) {
                    console.error(err);
                });
        }
    };
    var getStepperProps = function () {
        var _a, _b, _c;
        var nonCountedPages = __spreadArray(__spreadArray([], BOOST_PAGE_KEYS, true), [PAGE_KEYS.THANK_YOU], false);
        if ((expressParams === null || expressParams === void 0 ? void 0 : expressParams.orderType) && !isEmpty$1(expressParams === null || expressParams === void 0 ? void 0 : expressParams.orderType)) {
            nonCountedPages.push(PAGE_KEYS.TYPE_OF_ORDER);
        }
        if ((expressParams === null || expressParams === void 0 ? void 0 : expressParams.selectedPlatform) && !isEmpty$1(expressParams === null || expressParams === void 0 ? void 0 : expressParams.selectedPlatform)) {
            nonCountedPages === null || nonCountedPages === void 0 ? void 0 : nonCountedPages.push(PAGE_KEYS.DELIVERY_PLATFORM);
        }
        var locationPageData = pages === null || pages === void 0 ? void 0 : pages.filter(function (eachPage) { return eachPage.pageKey === PAGE_KEYS.CHOOSE_LOCATION; });
        if (!isEmpty$1(locationPageData)) {
            var locationField = (_b = (_a = locationPageData[0]) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.filter(function (eachField) { return eachField.fieldKey === 'location'; });
            if (!isEmpty$1(locationField)) {
                var locationData = (_c = locationField[0]) === null || _c === void 0 ? void 0 : _c.fieldValue;
                var locationCount = ((locationData === null || locationData === void 0 ? void 0 : locationData.filter(function (eachLocation) { return (eachLocation === null || eachLocation === void 0 ? void 0 : eachLocation.key) !== 'all'; })) || []).length;
                if (locationCount === 1) {
                    nonCountedPages.push(PAGE_KEYS.CHOOSE_LOCATION);
                }
            }
        }
        var totalNonSkippablePages = pages.filter(function (page) { return !page.skipPage && !nonCountedPages.includes(page.pageKey); });
        var currentPageIndex = totalNonSkippablePages
            .filter(function (page) { return !nonCountedPages.includes(page.pageKey); })
            .findIndex(function (page) { return page.pageKey === currentPageKey; });
        return {
            activeStep: currentPageIndex,
            steps: totalNonSkippablePages === null || totalNonSkippablePages === void 0 ? void 0 : totalNonSkippablePages.length
        };
    };
    var handleOnBack = function () {
        var _a;
        if (pageDataStack === null || pageDataStack === void 0 ? void 0 : pageDataStack.length) {
            var lastPage = pageDataStack.pop();
            var backPageKey_1 = lastPage === null || lastPage === void 0 ? void 0 : lastPage.key;
            // Check if the back page is an item page
            var backPage = pages.find(function (p) { return p.pageKey === backPageKey_1; });
            var isItemPage = ((_a = backPage === null || backPage === void 0 ? void 0 : backPage.questions) === null || _a === void 0 ? void 0 : _a.some(function (q) { return q.questionType === 'item_tiered_rating'; })) || false;
            if (isItemPage && backPage) {
                // Get visible questions for the back page
                var visibleQuestions = getVisibleQuestions(backPage, editorMode, globalQuestionsVisibleMap, pages, surveySettings, undefined, itemList);
                // If there are no visible questions, call handleOnBack again
                if (!visibleQuestions || visibleQuestions.length === 0) {
                    handleOnBack();
                    return;
                }
            }
            setCurrentPageKey(backPageKey_1);
        }
    };
    useEffect(function () {
        surveyScrollHandler();
    }, [currentPageKey]);
    if (initialPageKey === null || initialPageKey === undefined) {
        return React__default.createElement(Spin, null);
    }
    return (React__default.createElement(ItemListProvider, { initialItemList: itemList || [] },
        React__default.createElement(MemoizedSurveyPage, { page: pages.find(function (p) { return p.pageKey == currentPageKey; }) || pages[0], pages: pages, onNextPage: !editorMode ? goToNextPage : function () { }, onBackPage: handleOnBack, initialPageKey: initialPageKey, theme: theme, editorMode: editorMode, stepperProps: getStepperProps(), surveySetting: surveySettings, uploadPicturesRequest: uploadPicturesRequest, loading: loading, region: region, handleAssistedReview: handleAssistedReview, brandRegion: brandRegion, trackEvent: handleTrackEvent, allQuestionsRulesFromEngine: allQuestionsRulesFromEngine, visibleQuestionsMap: globalQuestionsVisibleMap, globalSelectedFactMap: globalSelectedFactMap, vouchersData: vouchersData, multiVoucherIds: multiVoucherIds, surveySubmitted: surveySubmitted, expressParams: expressParams, voucherIdsMetadata: voucherIdsMetadata })));
};

export { Button, Drawer, FormViewer, INQUIRYFORM_QUESTION_TYPE, Icon, Input, LocationModal, MobileView, MomosDatePicker, MomosModal, NotRedeemable, OfferCard$1 as OfferCard, OfferCard as OfferCardV2, OfferError, OfferIssuance, OfferRedemption, OptionArea, Select$1 as Select, StandardLayout, SurveyViewer, Switch, Text$1 as Text, ThankYouModalContent, Upload, WelcomePage, addScrollAnimation, selectAll };
//# sourceMappingURL=index.js.map
